// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./shepherd.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./mermaid.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/la-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/la-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/la-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/la-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/la-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/la-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/la-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/la-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/la-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/la-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/la-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/la-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/la-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/la-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/la-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/remixicon.eot?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/remixicon.woff2?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/remixicon.woff?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/remixicon.ttf?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/remixicon.svg?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28248.5, 177.5, 151.5%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%230ab39c%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f06548%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f06548%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--vz-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28217.8, 90, 43.2%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../fonts/hkgrotesk-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../fonts/hkgrotesk-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../fonts/hkgrotesk-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../fonts/hkgrotesk-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../fonts/hkgrotesk-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../fonts/hkgrotesk-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../fonts/hkgrotesk-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../fonts/hkgrotesk-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../fonts/hkgrotesk-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../images/sidebar/img-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/sidebar/img-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/sidebar/img-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/sidebar/img-4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23adb5bd%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../images/modal-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 xmlns:svgjs=%27http://svgjs.com/svgjs%27 width=%271440%27 height=%27560%27 preserveAspectRatio=%27none%27 viewBox=%270 0 1440 560%27%3e%3cg mask=%27url%28%26quot%3b%23SvgjsMask1016%26quot%3b%29%27 fill=%27none%27%3e%3crect width=%271440%27 height=%27560%27 x=%270%27 y=%270%27 fill=%27rgba%2864%2c 81%2c 137%2c 1%29%27%3e%3c/rect%3e%3cpath d=%27M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704%27 fill=%27%2333416e%27%3e%3c/path%3e%3cpath d=%27M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672%27 fill=%27%234d61a4%27%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id=%27SvgjsMask1016%27%3e%3crect width=%271440%27 height=%27560%27 fill=%27white%27%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ced4da%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ced4da%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../images/flags/us.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../images/kuzelogo.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/cover-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/nft/marketplace.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../images/chat-bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../images/file.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../images/landing/bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("../images/new.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Inter:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=6.5.95" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.4.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\f01c9";
}

.mdi-abacus::before {
  content: "\\f16e0";
}

.mdi-abjad-arabic::before {
  content: "\\f1328";
}

.mdi-abjad-hebrew::before {
  content: "\\f1329";
}

.mdi-abugida-devanagari::before {
  content: "\\f132a";
}

.mdi-abugida-thai::before {
  content: "\\f132b";
}

.mdi-access-point::before {
  content: "\\f0003";
}

.mdi-access-point-check::before {
  content: "\\f1538";
}

.mdi-access-point-minus::before {
  content: "\\f1539";
}

.mdi-access-point-network::before {
  content: "\\f0002";
}

.mdi-access-point-network-off::before {
  content: "\\f0be1";
}

.mdi-access-point-off::before {
  content: "\\f1511";
}

.mdi-access-point-plus::before {
  content: "\\f153a";
}

.mdi-access-point-remove::before {
  content: "\\f153b";
}

.mdi-account::before {
  content: "\\f0004";
}

.mdi-account-alert::before {
  content: "\\f0005";
}

.mdi-account-alert-outline::before {
  content: "\\f0b50";
}

.mdi-account-arrow-down::before {
  content: "\\f1868";
}

.mdi-account-arrow-down-outline::before {
  content: "\\f1869";
}

.mdi-account-arrow-left::before {
  content: "\\f0b51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\f0b52";
}

.mdi-account-arrow-right::before {
  content: "\\f0b53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\f0b54";
}

.mdi-account-arrow-up::before {
  content: "\\f1867";
}

.mdi-account-arrow-up-outline::before {
  content: "\\f186a";
}

.mdi-account-box::before {
  content: "\\f0006";
}

.mdi-account-box-multiple::before {
  content: "\\f0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\f100a";
}

.mdi-account-box-outline::before {
  content: "\\f0007";
}

.mdi-account-cancel::before {
  content: "\\f12df";
}

.mdi-account-cancel-outline::before {
  content: "\\f12e0";
}

.mdi-account-cash::before {
  content: "\\f1097";
}

.mdi-account-cash-outline::before {
  content: "\\f1098";
}

.mdi-account-check::before {
  content: "\\f0008";
}

.mdi-account-check-outline::before {
  content: "\\f0be2";
}

.mdi-account-child::before {
  content: "\\f0a89";
}

.mdi-account-child-circle::before {
  content: "\\f0a8a";
}

.mdi-account-child-outline::before {
  content: "\\f10c8";
}

.mdi-account-circle::before {
  content: "\\f0009";
}

.mdi-account-circle-outline::before {
  content: "\\f0b55";
}

.mdi-account-clock::before {
  content: "\\f0b56";
}

.mdi-account-clock-outline::before {
  content: "\\f0b57";
}

.mdi-account-cog::before {
  content: "\\f1370";
}

.mdi-account-cog-outline::before {
  content: "\\f1371";
}

.mdi-account-convert::before {
  content: "\\f000a";
}

.mdi-account-convert-outline::before {
  content: "\\f1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\f0e9b";
}

.mdi-account-cowboy-hat-outline::before {
  content: "\\f17f3";
}

.mdi-account-details::before {
  content: "\\f0631";
}

.mdi-account-details-outline::before {
  content: "\\f1372";
}

.mdi-account-edit::before {
  content: "\\f06bc";
}

.mdi-account-edit-outline::before {
  content: "\\f0ffb";
}

.mdi-account-eye::before {
  content: "\\f0420";
}

.mdi-account-eye-outline::before {
  content: "\\f127b";
}

.mdi-account-filter::before {
  content: "\\f0936";
}

.mdi-account-filter-outline::before {
  content: "\\f0f9d";
}

.mdi-account-group::before {
  content: "\\f0849";
}

.mdi-account-group-outline::before {
  content: "\\f0b58";
}

.mdi-account-hard-hat::before {
  content: "\\f05b5";
}

.mdi-account-heart::before {
  content: "\\f0899";
}

.mdi-account-heart-outline::before {
  content: "\\f0be3";
}

.mdi-account-injury::before {
  content: "\\f1815";
}

.mdi-account-injury-outline::before {
  content: "\\f1816";
}

.mdi-account-key::before {
  content: "\\f000b";
}

.mdi-account-key-outline::before {
  content: "\\f0be4";
}

.mdi-account-lock::before {
  content: "\\f115e";
}

.mdi-account-lock-open::before {
  content: "\\f1960";
}

.mdi-account-lock-open-outline::before {
  content: "\\f1961";
}

.mdi-account-lock-outline::before {
  content: "\\f115f";
}

.mdi-account-minus::before {
  content: "\\f000d";
}

.mdi-account-minus-outline::before {
  content: "\\f0aec";
}

.mdi-account-multiple::before {
  content: "\\f000e";
}

.mdi-account-multiple-check::before {
  content: "\\f08c5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\f11fe";
}

.mdi-account-multiple-minus::before {
  content: "\\f05d3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\f0be5";
}

.mdi-account-multiple-outline::before {
  content: "\\f000f";
}

.mdi-account-multiple-plus::before {
  content: "\\f0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\f0800";
}

.mdi-account-multiple-remove::before {
  content: "\\f120a";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\f120b";
}

.mdi-account-music::before {
  content: "\\f0803";
}

.mdi-account-music-outline::before {
  content: "\\f0ce9";
}

.mdi-account-network::before {
  content: "\\f0011";
}

.mdi-account-network-outline::before {
  content: "\\f0be6";
}

.mdi-account-off::before {
  content: "\\f0012";
}

.mdi-account-off-outline::before {
  content: "\\f0be7";
}

.mdi-account-outline::before {
  content: "\\f0013";
}

.mdi-account-plus::before {
  content: "\\f0014";
}

.mdi-account-plus-outline::before {
  content: "\\f0801";
}

.mdi-account-question::before {
  content: "\\f0b59";
}

.mdi-account-question-outline::before {
  content: "\\f0b5a";
}

.mdi-account-reactivate::before {
  content: "\\f152b";
}

.mdi-account-reactivate-outline::before {
  content: "\\f152c";
}

.mdi-account-remove::before {
  content: "\\f0015";
}

.mdi-account-remove-outline::before {
  content: "\\f0aed";
}

.mdi-account-search::before {
  content: "\\f0016";
}

.mdi-account-search-outline::before {
  content: "\\f0935";
}

.mdi-account-settings::before {
  content: "\\f0630";
}

.mdi-account-settings-outline::before {
  content: "\\f10c9";
}

.mdi-account-star::before {
  content: "\\f0017";
}

.mdi-account-star-outline::before {
  content: "\\f0be8";
}

.mdi-account-supervisor::before {
  content: "\\f0a8b";
}

.mdi-account-supervisor-circle::before {
  content: "\\f0a8c";
}

.mdi-account-supervisor-circle-outline::before {
  content: "\\f14ec";
}

.mdi-account-supervisor-outline::before {
  content: "\\f112d";
}

.mdi-account-switch::before {
  content: "\\f0019";
}

.mdi-account-switch-outline::before {
  content: "\\f04cb";
}

.mdi-account-sync::before {
  content: "\\f191b";
}

.mdi-account-sync-outline::before {
  content: "\\f191c";
}

.mdi-account-tie::before {
  content: "\\f0ce3";
}

.mdi-account-tie-hat::before {
  content: "\\f1898";
}

.mdi-account-tie-hat-outline::before {
  content: "\\f1899";
}

.mdi-account-tie-outline::before {
  content: "\\f10ca";
}

.mdi-account-tie-voice::before {
  content: "\\f1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\f130a";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\f130b";
}

.mdi-account-tie-voice-outline::before {
  content: "\\f1309";
}

.mdi-account-voice::before {
  content: "\\f05cb";
}

.mdi-account-voice-off::before {
  content: "\\f0ed4";
}

.mdi-account-wrench::before {
  content: "\\f189a";
}

.mdi-account-wrench-outline::before {
  content: "\\f189b";
}

.mdi-adjust::before {
  content: "\\f001a";
}

.mdi-advertisements::before {
  content: "\\f192a";
}

.mdi-advertisements-off::before {
  content: "\\f192b";
}

.mdi-air-conditioner::before {
  content: "\\f001b";
}

.mdi-air-filter::before {
  content: "\\f0d43";
}

.mdi-air-horn::before {
  content: "\\f0dac";
}

.mdi-air-humidifier::before {
  content: "\\f1099";
}

.mdi-air-humidifier-off::before {
  content: "\\f1466";
}

.mdi-air-purifier::before {
  content: "\\f0d44";
}

.mdi-airbag::before {
  content: "\\f0be9";
}

.mdi-airballoon::before {
  content: "\\f001c";
}

.mdi-airballoon-outline::before {
  content: "\\f100b";
}

.mdi-airplane::before {
  content: "\\f001d";
}

.mdi-airplane-alert::before {
  content: "\\f187a";
}

.mdi-airplane-check::before {
  content: "\\f187b";
}

.mdi-airplane-clock::before {
  content: "\\f187c";
}

.mdi-airplane-cog::before {
  content: "\\f187d";
}

.mdi-airplane-edit::before {
  content: "\\f187e";
}

.mdi-airplane-landing::before {
  content: "\\f05d4";
}

.mdi-airplane-marker::before {
  content: "\\f187f";
}

.mdi-airplane-minus::before {
  content: "\\f1880";
}

.mdi-airplane-off::before {
  content: "\\f001e";
}

.mdi-airplane-plus::before {
  content: "\\f1881";
}

.mdi-airplane-remove::before {
  content: "\\f1882";
}

.mdi-airplane-search::before {
  content: "\\f1883";
}

.mdi-airplane-settings::before {
  content: "\\f1884";
}

.mdi-airplane-takeoff::before {
  content: "\\f05d5";
}

.mdi-airport::before {
  content: "\\f084b";
}

.mdi-alarm::before {
  content: "\\f0020";
}

.mdi-alarm-bell::before {
  content: "\\f078e";
}

.mdi-alarm-check::before {
  content: "\\f0021";
}

.mdi-alarm-light::before {
  content: "\\f078f";
}

.mdi-alarm-light-off::before {
  content: "\\f171e";
}

.mdi-alarm-light-off-outline::before {
  content: "\\f171f";
}

.mdi-alarm-light-outline::before {
  content: "\\f0bea";
}

.mdi-alarm-multiple::before {
  content: "\\f0022";
}

.mdi-alarm-note::before {
  content: "\\f0e71";
}

.mdi-alarm-note-off::before {
  content: "\\f0e72";
}

.mdi-alarm-off::before {
  content: "\\f0023";
}

.mdi-alarm-panel::before {
  content: "\\f15c4";
}

.mdi-alarm-panel-outline::before {
  content: "\\f15c5";
}

.mdi-alarm-plus::before {
  content: "\\f0024";
}

.mdi-alarm-snooze::before {
  content: "\\f068e";
}

.mdi-album::before {
  content: "\\f0025";
}

.mdi-alert::before {
  content: "\\f0026";
}

.mdi-alert-box::before {
  content: "\\f0027";
}

.mdi-alert-box-outline::before {
  content: "\\f0ce4";
}

.mdi-alert-circle::before {
  content: "\\f0028";
}

.mdi-alert-circle-check::before {
  content: "\\f11ed";
}

.mdi-alert-circle-check-outline::before {
  content: "\\f11ee";
}

.mdi-alert-circle-outline::before {
  content: "\\f05d6";
}

.mdi-alert-decagram::before {
  content: "\\f06bd";
}

.mdi-alert-decagram-outline::before {
  content: "\\f0ce5";
}

.mdi-alert-minus::before {
  content: "\\f14bb";
}

.mdi-alert-minus-outline::before {
  content: "\\f14be";
}

.mdi-alert-octagon::before {
  content: "\\f0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\f0ce6";
}

.mdi-alert-octagram::before {
  content: "\\f0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\f0ce7";
}

.mdi-alert-outline::before {
  content: "\\f002a";
}

.mdi-alert-plus::before {
  content: "\\f14ba";
}

.mdi-alert-plus-outline::before {
  content: "\\f14bd";
}

.mdi-alert-remove::before {
  content: "\\f14bc";
}

.mdi-alert-remove-outline::before {
  content: "\\f14bf";
}

.mdi-alert-rhombus::before {
  content: "\\f11ce";
}

.mdi-alert-rhombus-outline::before {
  content: "\\f11cf";
}

.mdi-alien::before {
  content: "\\f089a";
}

.mdi-alien-outline::before {
  content: "\\f10cb";
}

.mdi-align-horizontal-center::before {
  content: "\\f11c3";
}

.mdi-align-horizontal-distribute::before {
  content: "\\f1962";
}

.mdi-align-horizontal-left::before {
  content: "\\f11c2";
}

.mdi-align-horizontal-right::before {
  content: "\\f11c4";
}

.mdi-align-vertical-bottom::before {
  content: "\\f11c5";
}

.mdi-align-vertical-center::before {
  content: "\\f11c6";
}

.mdi-align-vertical-distribute::before {
  content: "\\f1963";
}

.mdi-align-vertical-top::before {
  content: "\\f11c7";
}

.mdi-all-inclusive::before {
  content: "\\f06be";
}

.mdi-all-inclusive-box::before {
  content: "\\f188d";
}

.mdi-all-inclusive-box-outline::before {
  content: "\\f188e";
}

.mdi-allergy::before {
  content: "\\f1258";
}

.mdi-alpha::before {
  content: "\\f002b";
}

.mdi-alpha-a::before {
  content: "\\f0aee";
}

.mdi-alpha-a-box::before {
  content: "\\f0b08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\f0beb";
}

.mdi-alpha-a-circle::before {
  content: "\\f0bec";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\f0bed";
}

.mdi-alpha-b::before {
  content: "\\f0aef";
}

.mdi-alpha-b-box::before {
  content: "\\f0b09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\f0bee";
}

.mdi-alpha-b-circle::before {
  content: "\\f0bef";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\f0bf0";
}

.mdi-alpha-c::before {
  content: "\\f0af0";
}

.mdi-alpha-c-box::before {
  content: "\\f0b0a";
}

.mdi-alpha-c-box-outline::before {
  content: "\\f0bf1";
}

.mdi-alpha-c-circle::before {
  content: "\\f0bf2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\f0bf3";
}

.mdi-alpha-d::before {
  content: "\\f0af1";
}

.mdi-alpha-d-box::before {
  content: "\\f0b0b";
}

.mdi-alpha-d-box-outline::before {
  content: "\\f0bf4";
}

.mdi-alpha-d-circle::before {
  content: "\\f0bf5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\f0bf6";
}

.mdi-alpha-e::before {
  content: "\\f0af2";
}

.mdi-alpha-e-box::before {
  content: "\\f0b0c";
}

.mdi-alpha-e-box-outline::before {
  content: "\\f0bf7";
}

.mdi-alpha-e-circle::before {
  content: "\\f0bf8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\f0bf9";
}

.mdi-alpha-f::before {
  content: "\\f0af3";
}

.mdi-alpha-f-box::before {
  content: "\\f0b0d";
}

.mdi-alpha-f-box-outline::before {
  content: "\\f0bfa";
}

.mdi-alpha-f-circle::before {
  content: "\\f0bfb";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\f0bfc";
}

.mdi-alpha-g::before {
  content: "\\f0af4";
}

.mdi-alpha-g-box::before {
  content: "\\f0b0e";
}

.mdi-alpha-g-box-outline::before {
  content: "\\f0bfd";
}

.mdi-alpha-g-circle::before {
  content: "\\f0bfe";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\f0bff";
}

.mdi-alpha-h::before {
  content: "\\f0af5";
}

.mdi-alpha-h-box::before {
  content: "\\f0b0f";
}

.mdi-alpha-h-box-outline::before {
  content: "\\f0c00";
}

.mdi-alpha-h-circle::before {
  content: "\\f0c01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\f0c02";
}

.mdi-alpha-i::before {
  content: "\\f0af6";
}

.mdi-alpha-i-box::before {
  content: "\\f0b10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\f0c03";
}

.mdi-alpha-i-circle::before {
  content: "\\f0c04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\f0c05";
}

.mdi-alpha-j::before {
  content: "\\f0af7";
}

.mdi-alpha-j-box::before {
  content: "\\f0b11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\f0c06";
}

.mdi-alpha-j-circle::before {
  content: "\\f0c07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\f0c08";
}

.mdi-alpha-k::before {
  content: "\\f0af8";
}

.mdi-alpha-k-box::before {
  content: "\\f0b12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\f0c09";
}

.mdi-alpha-k-circle::before {
  content: "\\f0c0a";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\f0c0b";
}

.mdi-alpha-l::before {
  content: "\\f0af9";
}

.mdi-alpha-l-box::before {
  content: "\\f0b13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\f0c0c";
}

.mdi-alpha-l-circle::before {
  content: "\\f0c0d";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\f0c0e";
}

.mdi-alpha-m::before {
  content: "\\f0afa";
}

.mdi-alpha-m-box::before {
  content: "\\f0b14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\f0c0f";
}

.mdi-alpha-m-circle::before {
  content: "\\f0c10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\f0c11";
}

.mdi-alpha-n::before {
  content: "\\f0afb";
}

.mdi-alpha-n-box::before {
  content: "\\f0b15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\f0c12";
}

.mdi-alpha-n-circle::before {
  content: "\\f0c13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\f0c14";
}

.mdi-alpha-o::before {
  content: "\\f0afc";
}

.mdi-alpha-o-box::before {
  content: "\\f0b16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\f0c15";
}

.mdi-alpha-o-circle::before {
  content: "\\f0c16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\f0c17";
}

.mdi-alpha-p::before {
  content: "\\f0afd";
}

.mdi-alpha-p-box::before {
  content: "\\f0b17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\f0c18";
}

.mdi-alpha-p-circle::before {
  content: "\\f0c19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\f0c1a";
}

.mdi-alpha-q::before {
  content: "\\f0afe";
}

.mdi-alpha-q-box::before {
  content: "\\f0b18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\f0c1b";
}

.mdi-alpha-q-circle::before {
  content: "\\f0c1c";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\f0c1d";
}

.mdi-alpha-r::before {
  content: "\\f0aff";
}

.mdi-alpha-r-box::before {
  content: "\\f0b19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\f0c1e";
}

.mdi-alpha-r-circle::before {
  content: "\\f0c1f";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\f0c20";
}

.mdi-alpha-s::before {
  content: "\\f0b00";
}

.mdi-alpha-s-box::before {
  content: "\\f0b1a";
}

.mdi-alpha-s-box-outline::before {
  content: "\\f0c21";
}

.mdi-alpha-s-circle::before {
  content: "\\f0c22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\f0c23";
}

.mdi-alpha-t::before {
  content: "\\f0b01";
}

.mdi-alpha-t-box::before {
  content: "\\f0b1b";
}

.mdi-alpha-t-box-outline::before {
  content: "\\f0c24";
}

.mdi-alpha-t-circle::before {
  content: "\\f0c25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\f0c26";
}

.mdi-alpha-u::before {
  content: "\\f0b02";
}

.mdi-alpha-u-box::before {
  content: "\\f0b1c";
}

.mdi-alpha-u-box-outline::before {
  content: "\\f0c27";
}

.mdi-alpha-u-circle::before {
  content: "\\f0c28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\f0c29";
}

.mdi-alpha-v::before {
  content: "\\f0b03";
}

.mdi-alpha-v-box::before {
  content: "\\f0b1d";
}

.mdi-alpha-v-box-outline::before {
  content: "\\f0c2a";
}

.mdi-alpha-v-circle::before {
  content: "\\f0c2b";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\f0c2c";
}

.mdi-alpha-w::before {
  content: "\\f0b04";
}

.mdi-alpha-w-box::before {
  content: "\\f0b1e";
}

.mdi-alpha-w-box-outline::before {
  content: "\\f0c2d";
}

.mdi-alpha-w-circle::before {
  content: "\\f0c2e";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\f0c2f";
}

.mdi-alpha-x::before {
  content: "\\f0b05";
}

.mdi-alpha-x-box::before {
  content: "\\f0b1f";
}

.mdi-alpha-x-box-outline::before {
  content: "\\f0c30";
}

.mdi-alpha-x-circle::before {
  content: "\\f0c31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\f0c32";
}

.mdi-alpha-y::before {
  content: "\\f0b06";
}

.mdi-alpha-y-box::before {
  content: "\\f0b20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\f0c33";
}

.mdi-alpha-y-circle::before {
  content: "\\f0c34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\f0c35";
}

.mdi-alpha-z::before {
  content: "\\f0b07";
}

.mdi-alpha-z-box::before {
  content: "\\f0b21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\f0c36";
}

.mdi-alpha-z-circle::before {
  content: "\\f0c37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\f0c38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\f132c";
}

.mdi-alphabet-cyrillic::before {
  content: "\\f132d";
}

.mdi-alphabet-greek::before {
  content: "\\f132e";
}

.mdi-alphabet-latin::before {
  content: "\\f132f";
}

.mdi-alphabet-piqad::before {
  content: "\\f1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\f1337";
}

.mdi-alphabetical::before {
  content: "\\f002c";
}

.mdi-alphabetical-off::before {
  content: "\\f100c";
}

.mdi-alphabetical-variant::before {
  content: "\\f100d";
}

.mdi-alphabetical-variant-off::before {
  content: "\\f100e";
}

.mdi-altimeter::before {
  content: "\\f05d7";
}

.mdi-ambulance::before {
  content: "\\f002f";
}

.mdi-ammunition::before {
  content: "\\f0ce8";
}

.mdi-ampersand::before {
  content: "\\f0a8d";
}

.mdi-amplifier::before {
  content: "\\f0030";
}

.mdi-amplifier-off::before {
  content: "\\f11b5";
}

.mdi-anchor::before {
  content: "\\f0031";
}

.mdi-android::before {
  content: "\\f0032";
}

.mdi-android-messages::before {
  content: "\\f0d45";
}

.mdi-android-studio::before {
  content: "\\f0034";
}

.mdi-angle-acute::before {
  content: "\\f0937";
}

.mdi-angle-obtuse::before {
  content: "\\f0938";
}

.mdi-angle-right::before {
  content: "\\f0939";
}

.mdi-angular::before {
  content: "\\f06b2";
}

.mdi-angularjs::before {
  content: "\\f06bf";
}

.mdi-animation::before {
  content: "\\f05d8";
}

.mdi-animation-outline::before {
  content: "\\f0a8f";
}

.mdi-animation-play::before {
  content: "\\f093a";
}

.mdi-animation-play-outline::before {
  content: "\\f0a90";
}

.mdi-ansible::before {
  content: "\\f109a";
}

.mdi-antenna::before {
  content: "\\f1119";
}

.mdi-anvil::before {
  content: "\\f089b";
}

.mdi-apache-kafka::before {
  content: "\\f100f";
}

.mdi-api::before {
  content: "\\f109b";
}

.mdi-api-off::before {
  content: "\\f1257";
}

.mdi-apple::before {
  content: "\\f0035";
}

.mdi-apple-finder::before {
  content: "\\f0036";
}

.mdi-apple-icloud::before {
  content: "\\f0038";
}

.mdi-apple-ios::before {
  content: "\\f0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\f0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\f0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\f0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\f0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\f0636";
}

.mdi-apple-safari::before {
  content: "\\f0039";
}

.mdi-application::before {
  content: "\\f08c6";
}

.mdi-application-array::before {
  content: "\\f10f5";
}

.mdi-application-array-outline::before {
  content: "\\f10f6";
}

.mdi-application-braces::before {
  content: "\\f10f7";
}

.mdi-application-braces-outline::before {
  content: "\\f10f8";
}

.mdi-application-brackets::before {
  content: "\\f0c8b";
}

.mdi-application-brackets-outline::before {
  content: "\\f0c8c";
}

.mdi-application-cog::before {
  content: "\\f0675";
}

.mdi-application-cog-outline::before {
  content: "\\f1577";
}

.mdi-application-edit::before {
  content: "\\f00ae";
}

.mdi-application-edit-outline::before {
  content: "\\f0619";
}

.mdi-application-export::before {
  content: "\\f0dad";
}

.mdi-application-import::before {
  content: "\\f0dae";
}

.mdi-application-outline::before {
  content: "\\f0614";
}

.mdi-application-parentheses::before {
  content: "\\f10f9";
}

.mdi-application-parentheses-outline::before {
  content: "\\f10fa";
}

.mdi-application-settings::before {
  content: "\\f0b60";
}

.mdi-application-settings-outline::before {
  content: "\\f1555";
}

.mdi-application-variable::before {
  content: "\\f10fb";
}

.mdi-application-variable-outline::before {
  content: "\\f10fc";
}

.mdi-approximately-equal::before {
  content: "\\f0f9e";
}

.mdi-approximately-equal-box::before {
  content: "\\f0f9f";
}

.mdi-apps::before {
  content: "\\f003b";
}

.mdi-apps-box::before {
  content: "\\f0d46";
}

.mdi-arch::before {
  content: "\\f08c7";
}

.mdi-archive::before {
  content: "\\f003c";
}

.mdi-archive-alert::before {
  content: "\\f14fd";
}

.mdi-archive-alert-outline::before {
  content: "\\f14fe";
}

.mdi-archive-arrow-down::before {
  content: "\\f1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\f125a";
}

.mdi-archive-arrow-up::before {
  content: "\\f125b";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\f125c";
}

.mdi-archive-cancel::before {
  content: "\\f174b";
}

.mdi-archive-cancel-outline::before {
  content: "\\f174c";
}

.mdi-archive-check::before {
  content: "\\f174d";
}

.mdi-archive-check-outline::before {
  content: "\\f174e";
}

.mdi-archive-clock::before {
  content: "\\f174f";
}

.mdi-archive-clock-outline::before {
  content: "\\f1750";
}

.mdi-archive-cog::before {
  content: "\\f1751";
}

.mdi-archive-cog-outline::before {
  content: "\\f1752";
}

.mdi-archive-edit::before {
  content: "\\f1753";
}

.mdi-archive-edit-outline::before {
  content: "\\f1754";
}

.mdi-archive-eye::before {
  content: "\\f1755";
}

.mdi-archive-eye-outline::before {
  content: "\\f1756";
}

.mdi-archive-lock::before {
  content: "\\f1757";
}

.mdi-archive-lock-open::before {
  content: "\\f1758";
}

.mdi-archive-lock-open-outline::before {
  content: "\\f1759";
}

.mdi-archive-lock-outline::before {
  content: "\\f175a";
}

.mdi-archive-marker::before {
  content: "\\f175b";
}

.mdi-archive-marker-outline::before {
  content: "\\f175c";
}

.mdi-archive-minus::before {
  content: "\\f175d";
}

.mdi-archive-minus-outline::before {
  content: "\\f175e";
}

.mdi-archive-music::before {
  content: "\\f175f";
}

.mdi-archive-music-outline::before {
  content: "\\f1760";
}

.mdi-archive-off::before {
  content: "\\f1761";
}

.mdi-archive-off-outline::before {
  content: "\\f1762";
}

.mdi-archive-outline::before {
  content: "\\f120e";
}

.mdi-archive-plus::before {
  content: "\\f1763";
}

.mdi-archive-plus-outline::before {
  content: "\\f1764";
}

.mdi-archive-refresh::before {
  content: "\\f1765";
}

.mdi-archive-refresh-outline::before {
  content: "\\f1766";
}

.mdi-archive-remove::before {
  content: "\\f1767";
}

.mdi-archive-remove-outline::before {
  content: "\\f1768";
}

.mdi-archive-search::before {
  content: "\\f1769";
}

.mdi-archive-search-outline::before {
  content: "\\f176a";
}

.mdi-archive-settings::before {
  content: "\\f176b";
}

.mdi-archive-settings-outline::before {
  content: "\\f176c";
}

.mdi-archive-star::before {
  content: "\\f176d";
}

.mdi-archive-star-outline::before {
  content: "\\f176e";
}

.mdi-archive-sync::before {
  content: "\\f176f";
}

.mdi-archive-sync-outline::before {
  content: "\\f1770";
}

.mdi-arm-flex::before {
  content: "\\f0fd7";
}

.mdi-arm-flex-outline::before {
  content: "\\f0fd6";
}

.mdi-arrange-bring-forward::before {
  content: "\\f003d";
}

.mdi-arrange-bring-to-front::before {
  content: "\\f003e";
}

.mdi-arrange-send-backward::before {
  content: "\\f003f";
}

.mdi-arrange-send-to-back::before {
  content: "\\f0040";
}

.mdi-arrow-all::before {
  content: "\\f0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\f0042";
}

.mdi-arrow-bottom-left-bold-box::before {
  content: "\\f1964";
}

.mdi-arrow-bottom-left-bold-box-outline::before {
  content: "\\f1965";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\f09b7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\f09b8";
}

.mdi-arrow-bottom-left-thin::before {
  content: "\\f19b6";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\f1596";
}

.mdi-arrow-bottom-right::before {
  content: "\\f0043";
}

.mdi-arrow-bottom-right-bold-box::before {
  content: "\\f1966";
}

.mdi-arrow-bottom-right-bold-box-outline::before {
  content: "\\f1967";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\f09b9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\f09ba";
}

.mdi-arrow-bottom-right-thin::before {
  content: "\\f19b7";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\f1595";
}

.mdi-arrow-collapse::before {
  content: "\\f0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\f0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\f0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\f084c";
}

.mdi-arrow-collapse-left::before {
  content: "\\f0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\f0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\f0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\f084d";
}

.mdi-arrow-decision::before {
  content: "\\f09bb";
}

.mdi-arrow-decision-auto::before {
  content: "\\f09bc";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\f09bd";
}

.mdi-arrow-decision-outline::before {
  content: "\\f09be";
}

.mdi-arrow-down::before {
  content: "\\f0045";
}

.mdi-arrow-down-bold::before {
  content: "\\f072e";
}

.mdi-arrow-down-bold-box::before {
  content: "\\f072f";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\f0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\f0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\f0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\f0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\f09bf";
}

.mdi-arrow-down-box::before {
  content: "\\f06c0";
}

.mdi-arrow-down-circle::before {
  content: "\\f0cdb";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\f0cdc";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\f004a";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\f004b";
}

.mdi-arrow-down-left::before {
  content: "\\f17a1";
}

.mdi-arrow-down-left-bold::before {
  content: "\\f17a2";
}

.mdi-arrow-down-right::before {
  content: "\\f17a3";
}

.mdi-arrow-down-right-bold::before {
  content: "\\f17a4";
}

.mdi-arrow-down-thick::before {
  content: "\\f0046";
}

.mdi-arrow-down-thin::before {
  content: "\\f19b3";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\f1599";
}

.mdi-arrow-expand::before {
  content: "\\f0616";
}

.mdi-arrow-expand-all::before {
  content: "\\f004c";
}

.mdi-arrow-expand-down::before {
  content: "\\f0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\f084e";
}

.mdi-arrow-expand-left::before {
  content: "\\f0797";
}

.mdi-arrow-expand-right::before {
  content: "\\f0798";
}

.mdi-arrow-expand-up::before {
  content: "\\f0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\f084f";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\f115b";
}

.mdi-arrow-left::before {
  content: "\\f004d";
}

.mdi-arrow-left-bold::before {
  content: "\\f0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\f0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\f0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\f004f";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\f0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\f0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\f09c0";
}

.mdi-arrow-left-bottom::before {
  content: "\\f17a5";
}

.mdi-arrow-left-bottom-bold::before {
  content: "\\f17a6";
}

.mdi-arrow-left-box::before {
  content: "\\f06c1";
}

.mdi-arrow-left-circle::before {
  content: "\\f0cdd";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\f0cde";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\f0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\f0053";
}

.mdi-arrow-left-right::before {
  content: "\\f0e73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\f0e74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\f09c1";
}

.mdi-arrow-left-thick::before {
  content: "\\f004e";
}

.mdi-arrow-left-thin::before {
  content: "\\f19b1";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\f159a";
}

.mdi-arrow-left-top::before {
  content: "\\f17a7";
}

.mdi-arrow-left-top-bold::before {
  content: "\\f17a8";
}

.mdi-arrow-projectile::before {
  content: "\\f1840";
}

.mdi-arrow-projectile-multiple::before {
  content: "\\f183f";
}

.mdi-arrow-right::before {
  content: "\\f0054";
}

.mdi-arrow-right-bold::before {
  content: "\\f0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\f0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\f0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\f0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\f0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\f0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\f09c2";
}

.mdi-arrow-right-bottom::before {
  content: "\\f17a9";
}

.mdi-arrow-right-bottom-bold::before {
  content: "\\f17aa";
}

.mdi-arrow-right-box::before {
  content: "\\f06c2";
}

.mdi-arrow-right-circle::before {
  content: "\\f0cdf";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\f0ce0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\f0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\f005a";
}

.mdi-arrow-right-thick::before {
  content: "\\f0055";
}

.mdi-arrow-right-thin::before {
  content: "\\f19b0";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\f1598";
}

.mdi-arrow-right-top::before {
  content: "\\f17ab";
}

.mdi-arrow-right-top-bold::before {
  content: "\\f17ac";
}

.mdi-arrow-split-horizontal::before {
  content: "\\f093b";
}

.mdi-arrow-split-vertical::before {
  content: "\\f093c";
}

.mdi-arrow-top-left::before {
  content: "\\f005b";
}

.mdi-arrow-top-left-bold-box::before {
  content: "\\f1968";
}

.mdi-arrow-top-left-bold-box-outline::before {
  content: "\\f1969";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\f09c3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\f0e75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\f0e76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\f09c4";
}

.mdi-arrow-top-left-thin::before {
  content: "\\f19b5";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\f1593";
}

.mdi-arrow-top-right::before {
  content: "\\f005c";
}

.mdi-arrow-top-right-bold-box::before {
  content: "\\f196a";
}

.mdi-arrow-top-right-bold-box-outline::before {
  content: "\\f196b";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\f09c5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\f0e77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\f0e78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\f09c6";
}

.mdi-arrow-top-right-thin::before {
  content: "\\f19b4";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\f1594";
}

.mdi-arrow-u-down-left::before {
  content: "\\f17ad";
}

.mdi-arrow-u-down-left-bold::before {
  content: "\\f17ae";
}

.mdi-arrow-u-down-right::before {
  content: "\\f17af";
}

.mdi-arrow-u-down-right-bold::before {
  content: "\\f17b0";
}

.mdi-arrow-u-left-bottom::before {
  content: "\\f17b1";
}

.mdi-arrow-u-left-bottom-bold::before {
  content: "\\f17b2";
}

.mdi-arrow-u-left-top::before {
  content: "\\f17b3";
}

.mdi-arrow-u-left-top-bold::before {
  content: "\\f17b4";
}

.mdi-arrow-u-right-bottom::before {
  content: "\\f17b5";
}

.mdi-arrow-u-right-bottom-bold::before {
  content: "\\f17b6";
}

.mdi-arrow-u-right-top::before {
  content: "\\f17b7";
}

.mdi-arrow-u-right-top-bold::before {
  content: "\\f17b8";
}

.mdi-arrow-u-up-left::before {
  content: "\\f17b9";
}

.mdi-arrow-u-up-left-bold::before {
  content: "\\f17ba";
}

.mdi-arrow-u-up-right::before {
  content: "\\f17bb";
}

.mdi-arrow-u-up-right-bold::before {
  content: "\\f17bc";
}

.mdi-arrow-up::before {
  content: "\\f005d";
}

.mdi-arrow-up-bold::before {
  content: "\\f0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\f0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\f0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\f005f";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\f0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\f0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\f09c7";
}

.mdi-arrow-up-box::before {
  content: "\\f06c3";
}

.mdi-arrow-up-circle::before {
  content: "\\f0ce1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\f0ce2";
}

.mdi-arrow-up-down::before {
  content: "\\f0e79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\f0e7a";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\f09c8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\f0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\f0063";
}

.mdi-arrow-up-left::before {
  content: "\\f17bd";
}

.mdi-arrow-up-left-bold::before {
  content: "\\f17be";
}

.mdi-arrow-up-right::before {
  content: "\\f17bf";
}

.mdi-arrow-up-right-bold::before {
  content: "\\f17c0";
}

.mdi-arrow-up-thick::before {
  content: "\\f005e";
}

.mdi-arrow-up-thin::before {
  content: "\\f19b2";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\f1597";
}

.mdi-arrow-vertical-lock::before {
  content: "\\f115c";
}

.mdi-artstation::before {
  content: "\\f0b5b";
}

.mdi-aspect-ratio::before {
  content: "\\f0a24";
}

.mdi-assistant::before {
  content: "\\f0064";
}

.mdi-asterisk::before {
  content: "\\f06c4";
}

.mdi-at::before {
  content: "\\f0065";
}

.mdi-atlassian::before {
  content: "\\f0804";
}

.mdi-atm::before {
  content: "\\f0d47";
}

.mdi-atom::before {
  content: "\\f0768";
}

.mdi-atom-variant::before {
  content: "\\f0e7b";
}

.mdi-attachment::before {
  content: "\\f0066";
}

.mdi-audio-input-rca::before {
  content: "\\f186b";
}

.mdi-audio-input-stereo-minijack::before {
  content: "\\f186c";
}

.mdi-audio-input-xlr::before {
  content: "\\f186d";
}

.mdi-audio-video::before {
  content: "\\f093d";
}

.mdi-audio-video-off::before {
  content: "\\f11b6";
}

.mdi-augmented-reality::before {
  content: "\\f0850";
}

.mdi-auto-download::before {
  content: "\\f137e";
}

.mdi-auto-fix::before {
  content: "\\f0068";
}

.mdi-auto-upload::before {
  content: "\\f0069";
}

.mdi-autorenew::before {
  content: "\\f006a";
}

.mdi-av-timer::before {
  content: "\\f006b";
}

.mdi-aws::before {
  content: "\\f0e0f";
}

.mdi-axe::before {
  content: "\\f08c8";
}

.mdi-axe-battle::before {
  content: "\\f1842";
}

.mdi-axis::before {
  content: "\\f0d48";
}

.mdi-axis-arrow::before {
  content: "\\f0d49";
}

.mdi-axis-arrow-info::before {
  content: "\\f140e";
}

.mdi-axis-arrow-lock::before {
  content: "\\f0d4a";
}

.mdi-axis-lock::before {
  content: "\\f0d4b";
}

.mdi-axis-x-arrow::before {
  content: "\\f0d4c";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\f0d4d";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\f0d4e";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\f0d4f";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\f0d50";
}

.mdi-axis-y-arrow::before {
  content: "\\f0d51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\f0d52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\f0d53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\f0d54";
}

.mdi-axis-z-arrow::before {
  content: "\\f0d55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\f0d56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\f0d57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\f0d58";
}

.mdi-babel::before {
  content: "\\f0a25";
}

.mdi-baby::before {
  content: "\\f006c";
}

.mdi-baby-bottle::before {
  content: "\\f0f39";
}

.mdi-baby-bottle-outline::before {
  content: "\\f0f3a";
}

.mdi-baby-buggy::before {
  content: "\\f13e0";
}

.mdi-baby-carriage::before {
  content: "\\f068f";
}

.mdi-baby-carriage-off::before {
  content: "\\f0fa0";
}

.mdi-baby-face::before {
  content: "\\f0e7c";
}

.mdi-baby-face-outline::before {
  content: "\\f0e7d";
}

.mdi-backburger::before {
  content: "\\f006d";
}

.mdi-backspace::before {
  content: "\\f006e";
}

.mdi-backspace-outline::before {
  content: "\\f0b5c";
}

.mdi-backspace-reverse::before {
  content: "\\f0e7e";
}

.mdi-backspace-reverse-outline::before {
  content: "\\f0e7f";
}

.mdi-backup-restore::before {
  content: "\\f006f";
}

.mdi-bacteria::before {
  content: "\\f0ed5";
}

.mdi-bacteria-outline::before {
  content: "\\f0ed6";
}

.mdi-badge-account::before {
  content: "\\f0da7";
}

.mdi-badge-account-alert::before {
  content: "\\f0da8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\f0da9";
}

.mdi-badge-account-horizontal::before {
  content: "\\f0e0d";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\f0e0e";
}

.mdi-badge-account-outline::before {
  content: "\\f0daa";
}

.mdi-badminton::before {
  content: "\\f0851";
}

.mdi-bag-carry-on::before {
  content: "\\f0f3b";
}

.mdi-bag-carry-on-check::before {
  content: "\\f0d65";
}

.mdi-bag-carry-on-off::before {
  content: "\\f0f3c";
}

.mdi-bag-checked::before {
  content: "\\f0f3d";
}

.mdi-bag-personal::before {
  content: "\\f0e10";
}

.mdi-bag-personal-off::before {
  content: "\\f0e11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\f0e12";
}

.mdi-bag-personal-outline::before {
  content: "\\f0e13";
}

.mdi-bag-suitcase::before {
  content: "\\f158b";
}

.mdi-bag-suitcase-off::before {
  content: "\\f158d";
}

.mdi-bag-suitcase-off-outline::before {
  content: "\\f158e";
}

.mdi-bag-suitcase-outline::before {
  content: "\\f158c";
}

.mdi-baguette::before {
  content: "\\f0f3e";
}

.mdi-balcony::before {
  content: "\\f1817";
}

.mdi-balloon::before {
  content: "\\f0a26";
}

.mdi-ballot::before {
  content: "\\f09c9";
}

.mdi-ballot-outline::before {
  content: "\\f09ca";
}

.mdi-ballot-recount::before {
  content: "\\f0c39";
}

.mdi-ballot-recount-outline::before {
  content: "\\f0c3a";
}

.mdi-bandage::before {
  content: "\\f0daf";
}

.mdi-bank::before {
  content: "\\f0070";
}

.mdi-bank-check::before {
  content: "\\f1655";
}

.mdi-bank-minus::before {
  content: "\\f0db0";
}

.mdi-bank-off::before {
  content: "\\f1656";
}

.mdi-bank-off-outline::before {
  content: "\\f1657";
}

.mdi-bank-outline::before {
  content: "\\f0e80";
}

.mdi-bank-plus::before {
  content: "\\f0db1";
}

.mdi-bank-remove::before {
  content: "\\f0db2";
}

.mdi-bank-transfer::before {
  content: "\\f0a27";
}

.mdi-bank-transfer-in::before {
  content: "\\f0a28";
}

.mdi-bank-transfer-out::before {
  content: "\\f0a29";
}

.mdi-barcode::before {
  content: "\\f0071";
}

.mdi-barcode-off::before {
  content: "\\f1236";
}

.mdi-barcode-scan::before {
  content: "\\f0072";
}

.mdi-barley::before {
  content: "\\f0073";
}

.mdi-barley-off::before {
  content: "\\f0b5d";
}

.mdi-barn::before {
  content: "\\f0b5e";
}

.mdi-barrel::before {
  content: "\\f0074";
}

.mdi-baseball::before {
  content: "\\f0852";
}

.mdi-baseball-bat::before {
  content: "\\f0853";
}

.mdi-baseball-diamond::before {
  content: "\\f15ec";
}

.mdi-baseball-diamond-outline::before {
  content: "\\f15ed";
}

.mdi-bash::before {
  content: "\\f1183";
}

.mdi-basket::before {
  content: "\\f0076";
}

.mdi-basket-check::before {
  content: "\\f18e5";
}

.mdi-basket-check-outline::before {
  content: "\\f18e6";
}

.mdi-basket-fill::before {
  content: "\\f0077";
}

.mdi-basket-minus::before {
  content: "\\f1523";
}

.mdi-basket-minus-outline::before {
  content: "\\f1524";
}

.mdi-basket-off::before {
  content: "\\f1525";
}

.mdi-basket-off-outline::before {
  content: "\\f1526";
}

.mdi-basket-outline::before {
  content: "\\f1181";
}

.mdi-basket-plus::before {
  content: "\\f1527";
}

.mdi-basket-plus-outline::before {
  content: "\\f1528";
}

.mdi-basket-remove::before {
  content: "\\f1529";
}

.mdi-basket-remove-outline::before {
  content: "\\f152a";
}

.mdi-basket-unfill::before {
  content: "\\f0078";
}

.mdi-basketball::before {
  content: "\\f0806";
}

.mdi-basketball-hoop::before {
  content: "\\f0c3b";
}

.mdi-basketball-hoop-outline::before {
  content: "\\f0c3c";
}

.mdi-bat::before {
  content: "\\f0b5f";
}

.mdi-bathtub::before {
  content: "\\f1818";
}

.mdi-bathtub-outline::before {
  content: "\\f1819";
}

.mdi-battery::before {
  content: "\\f0079";
}

.mdi-battery-10::before {
  content: "\\f007a";
}

.mdi-battery-10-bluetooth::before {
  content: "\\f093e";
}

.mdi-battery-20::before {
  content: "\\f007b";
}

.mdi-battery-20-bluetooth::before {
  content: "\\f093f";
}

.mdi-battery-30::before {
  content: "\\f007c";
}

.mdi-battery-30-bluetooth::before {
  content: "\\f0940";
}

.mdi-battery-40::before {
  content: "\\f007d";
}

.mdi-battery-40-bluetooth::before {
  content: "\\f0941";
}

.mdi-battery-50::before {
  content: "\\f007e";
}

.mdi-battery-50-bluetooth::before {
  content: "\\f0942";
}

.mdi-battery-60::before {
  content: "\\f007f";
}

.mdi-battery-60-bluetooth::before {
  content: "\\f0943";
}

.mdi-battery-70::before {
  content: "\\f0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\f0944";
}

.mdi-battery-80::before {
  content: "\\f0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\f0945";
}

.mdi-battery-90::before {
  content: "\\f0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\f0946";
}

.mdi-battery-alert::before {
  content: "\\f0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\f0947";
}

.mdi-battery-alert-variant::before {
  content: "\\f10cc";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\f10cd";
}

.mdi-battery-arrow-down::before {
  content: "\\f17de";
}

.mdi-battery-arrow-down-outline::before {
  content: "\\f17df";
}

.mdi-battery-arrow-up::before {
  content: "\\f17e0";
}

.mdi-battery-arrow-up-outline::before {
  content: "\\f17e1";
}

.mdi-battery-bluetooth::before {
  content: "\\f0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\f0949";
}

.mdi-battery-charging::before {
  content: "\\f0084";
}

.mdi-battery-charging-10::before {
  content: "\\f089c";
}

.mdi-battery-charging-100::before {
  content: "\\f0085";
}

.mdi-battery-charging-20::before {
  content: "\\f0086";
}

.mdi-battery-charging-30::before {
  content: "\\f0087";
}

.mdi-battery-charging-40::before {
  content: "\\f0088";
}

.mdi-battery-charging-50::before {
  content: "\\f089d";
}

.mdi-battery-charging-60::before {
  content: "\\f0089";
}

.mdi-battery-charging-70::before {
  content: "\\f089e";
}

.mdi-battery-charging-80::before {
  content: "\\f008a";
}

.mdi-battery-charging-90::before {
  content: "\\f008b";
}

.mdi-battery-charging-high::before {
  content: "\\f12a6";
}

.mdi-battery-charging-low::before {
  content: "\\f12a4";
}

.mdi-battery-charging-medium::before {
  content: "\\f12a5";
}

.mdi-battery-charging-outline::before {
  content: "\\f089f";
}

.mdi-battery-charging-wireless::before {
  content: "\\f0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\f0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\f0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\f080a";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\f080b";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\f080c";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\f080d";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\f080e";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\f080f";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\f0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\f0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\f0812";
}

.mdi-battery-check::before {
  content: "\\f17e2";
}

.mdi-battery-check-outline::before {
  content: "\\f17e3";
}

.mdi-battery-heart::before {
  content: "\\f120f";
}

.mdi-battery-heart-outline::before {
  content: "\\f1210";
}

.mdi-battery-heart-variant::before {
  content: "\\f1211";
}

.mdi-battery-high::before {
  content: "\\f12a3";
}

.mdi-battery-lock::before {
  content: "\\f179c";
}

.mdi-battery-lock-open::before {
  content: "\\f179d";
}

.mdi-battery-low::before {
  content: "\\f12a1";
}

.mdi-battery-medium::before {
  content: "\\f12a2";
}

.mdi-battery-minus::before {
  content: "\\f17e4";
}

.mdi-battery-minus-outline::before {
  content: "\\f17e5";
}

.mdi-battery-minus-variant::before {
  content: "\\f008c";
}

.mdi-battery-negative::before {
  content: "\\f008d";
}

.mdi-battery-off::before {
  content: "\\f125d";
}

.mdi-battery-off-outline::before {
  content: "\\f125e";
}

.mdi-battery-outline::before {
  content: "\\f008e";
}

.mdi-battery-plus::before {
  content: "\\f17e6";
}

.mdi-battery-plus-outline::before {
  content: "\\f17e7";
}

.mdi-battery-plus-variant::before {
  content: "\\f008f";
}

.mdi-battery-positive::before {
  content: "\\f0090";
}

.mdi-battery-remove::before {
  content: "\\f17e8";
}

.mdi-battery-remove-outline::before {
  content: "\\f17e9";
}

.mdi-battery-sync::before {
  content: "\\f1834";
}

.mdi-battery-sync-outline::before {
  content: "\\f1835";
}

.mdi-battery-unknown::before {
  content: "\\f0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\f094a";
}

.mdi-beach::before {
  content: "\\f0092";
}

.mdi-beaker::before {
  content: "\\f0cea";
}

.mdi-beaker-alert::before {
  content: "\\f1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\f122a";
}

.mdi-beaker-check::before {
  content: "\\f122b";
}

.mdi-beaker-check-outline::before {
  content: "\\f122c";
}

.mdi-beaker-minus::before {
  content: "\\f122d";
}

.mdi-beaker-minus-outline::before {
  content: "\\f122e";
}

.mdi-beaker-outline::before {
  content: "\\f0690";
}

.mdi-beaker-plus::before {
  content: "\\f122f";
}

.mdi-beaker-plus-outline::before {
  content: "\\f1230";
}

.mdi-beaker-question::before {
  content: "\\f1231";
}

.mdi-beaker-question-outline::before {
  content: "\\f1232";
}

.mdi-beaker-remove::before {
  content: "\\f1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\f1234";
}

.mdi-bed::before {
  content: "\\f02e3";
}

.mdi-bed-double::before {
  content: "\\f0fd4";
}

.mdi-bed-double-outline::before {
  content: "\\f0fd3";
}

.mdi-bed-empty::before {
  content: "\\f08a0";
}

.mdi-bed-king::before {
  content: "\\f0fd2";
}

.mdi-bed-king-outline::before {
  content: "\\f0fd1";
}

.mdi-bed-outline::before {
  content: "\\f0099";
}

.mdi-bed-queen::before {
  content: "\\f0fd0";
}

.mdi-bed-queen-outline::before {
  content: "\\f0fdb";
}

.mdi-bed-single::before {
  content: "\\f106d";
}

.mdi-bed-single-outline::before {
  content: "\\f106e";
}

.mdi-bee::before {
  content: "\\f0fa1";
}

.mdi-bee-flower::before {
  content: "\\f0fa2";
}

.mdi-beehive-off-outline::before {
  content: "\\f13ed";
}

.mdi-beehive-outline::before {
  content: "\\f10ce";
}

.mdi-beekeeper::before {
  content: "\\f14e2";
}

.mdi-beer::before {
  content: "\\f0098";
}

.mdi-beer-outline::before {
  content: "\\f130c";
}

.mdi-bell::before {
  content: "\\f009a";
}

.mdi-bell-alert::before {
  content: "\\f0d59";
}

.mdi-bell-alert-outline::before {
  content: "\\f0e81";
}

.mdi-bell-badge::before {
  content: "\\f116b";
}

.mdi-bell-badge-outline::before {
  content: "\\f0178";
}

.mdi-bell-cancel::before {
  content: "\\f13e7";
}

.mdi-bell-cancel-outline::before {
  content: "\\f13e8";
}

.mdi-bell-check::before {
  content: "\\f11e5";
}

.mdi-bell-check-outline::before {
  content: "\\f11e6";
}

.mdi-bell-circle::before {
  content: "\\f0d5a";
}

.mdi-bell-circle-outline::before {
  content: "\\f0d5b";
}

.mdi-bell-minus::before {
  content: "\\f13e9";
}

.mdi-bell-minus-outline::before {
  content: "\\f13ea";
}

.mdi-bell-off::before {
  content: "\\f009b";
}

.mdi-bell-off-outline::before {
  content: "\\f0a91";
}

.mdi-bell-outline::before {
  content: "\\f009c";
}

.mdi-bell-plus::before {
  content: "\\f009d";
}

.mdi-bell-plus-outline::before {
  content: "\\f0a92";
}

.mdi-bell-remove::before {
  content: "\\f13eb";
}

.mdi-bell-remove-outline::before {
  content: "\\f13ec";
}

.mdi-bell-ring::before {
  content: "\\f009e";
}

.mdi-bell-ring-outline::before {
  content: "\\f009f";
}

.mdi-bell-sleep::before {
  content: "\\f00a0";
}

.mdi-bell-sleep-outline::before {
  content: "\\f0a93";
}

.mdi-beta::before {
  content: "\\f00a1";
}

.mdi-betamax::before {
  content: "\\f09cb";
}

.mdi-biathlon::before {
  content: "\\f0e14";
}

.mdi-bicycle::before {
  content: "\\f109c";
}

.mdi-bicycle-basket::before {
  content: "\\f1235";
}

.mdi-bicycle-cargo::before {
  content: "\\f189c";
}

.mdi-bicycle-electric::before {
  content: "\\f15b4";
}

.mdi-bicycle-penny-farthing::before {
  content: "\\f15e9";
}

.mdi-bike::before {
  content: "\\f00a3";
}

.mdi-bike-fast::before {
  content: "\\f111f";
}

.mdi-billboard::before {
  content: "\\f1010";
}

.mdi-billiards::before {
  content: "\\f0b61";
}

.mdi-billiards-rack::before {
  content: "\\f0b62";
}

.mdi-binoculars::before {
  content: "\\f00a5";
}

.mdi-bio::before {
  content: "\\f00a6";
}

.mdi-biohazard::before {
  content: "\\f00a7";
}

.mdi-bird::before {
  content: "\\f15c6";
}

.mdi-bitbucket::before {
  content: "\\f00a8";
}

.mdi-bitcoin::before {
  content: "\\f0813";
}

.mdi-black-mesa::before {
  content: "\\f00a9";
}

.mdi-blender::before {
  content: "\\f0ceb";
}

.mdi-blender-outline::before {
  content: "\\f181a";
}

.mdi-blender-software::before {
  content: "\\f00ab";
}

.mdi-blinds::before {
  content: "\\f00ac";
}

.mdi-blinds-open::before {
  content: "\\f1011";
}

.mdi-block-helper::before {
  content: "\\f00ad";
}

.mdi-blood-bag::before {
  content: "\\f0cec";
}

.mdi-bluetooth::before {
  content: "\\f00af";
}

.mdi-bluetooth-audio::before {
  content: "\\f00b0";
}

.mdi-bluetooth-connect::before {
  content: "\\f00b1";
}

.mdi-bluetooth-off::before {
  content: "\\f00b2";
}

.mdi-bluetooth-settings::before {
  content: "\\f00b3";
}

.mdi-bluetooth-transfer::before {
  content: "\\f00b4";
}

.mdi-blur::before {
  content: "\\f00b5";
}

.mdi-blur-linear::before {
  content: "\\f00b6";
}

.mdi-blur-off::before {
  content: "\\f00b7";
}

.mdi-blur-radial::before {
  content: "\\f00b8";
}

.mdi-bolt::before {
  content: "\\f0db3";
}

.mdi-bomb::before {
  content: "\\f0691";
}

.mdi-bomb-off::before {
  content: "\\f06c5";
}

.mdi-bone::before {
  content: "\\f00b9";
}

.mdi-book::before {
  content: "\\f00ba";
}

.mdi-book-account::before {
  content: "\\f13ad";
}

.mdi-book-account-outline::before {
  content: "\\f13ae";
}

.mdi-book-alert::before {
  content: "\\f167c";
}

.mdi-book-alert-outline::before {
  content: "\\f167d";
}

.mdi-book-alphabet::before {
  content: "\\f061d";
}

.mdi-book-arrow-down::before {
  content: "\\f167e";
}

.mdi-book-arrow-down-outline::before {
  content: "\\f167f";
}

.mdi-book-arrow-left::before {
  content: "\\f1680";
}

.mdi-book-arrow-left-outline::before {
  content: "\\f1681";
}

.mdi-book-arrow-right::before {
  content: "\\f1682";
}

.mdi-book-arrow-right-outline::before {
  content: "\\f1683";
}

.mdi-book-arrow-up::before {
  content: "\\f1684";
}

.mdi-book-arrow-up-outline::before {
  content: "\\f1685";
}

.mdi-book-cancel::before {
  content: "\\f1686";
}

.mdi-book-cancel-outline::before {
  content: "\\f1687";
}

.mdi-book-check::before {
  content: "\\f14f3";
}

.mdi-book-check-outline::before {
  content: "\\f14f4";
}

.mdi-book-clock::before {
  content: "\\f1688";
}

.mdi-book-clock-outline::before {
  content: "\\f1689";
}

.mdi-book-cog::before {
  content: "\\f168a";
}

.mdi-book-cog-outline::before {
  content: "\\f168b";
}

.mdi-book-cross::before {
  content: "\\f00a2";
}

.mdi-book-edit::before {
  content: "\\f168c";
}

.mdi-book-edit-outline::before {
  content: "\\f168d";
}

.mdi-book-education::before {
  content: "\\f16c9";
}

.mdi-book-education-outline::before {
  content: "\\f16ca";
}

.mdi-book-information-variant::before {
  content: "\\f106f";
}

.mdi-book-lock::before {
  content: "\\f079a";
}

.mdi-book-lock-open::before {
  content: "\\f079b";
}

.mdi-book-lock-open-outline::before {
  content: "\\f168e";
}

.mdi-book-lock-outline::before {
  content: "\\f168f";
}

.mdi-book-marker::before {
  content: "\\f1690";
}

.mdi-book-marker-outline::before {
  content: "\\f1691";
}

.mdi-book-minus::before {
  content: "\\f05d9";
}

.mdi-book-minus-multiple::before {
  content: "\\f0a94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\f090b";
}

.mdi-book-minus-outline::before {
  content: "\\f1692";
}

.mdi-book-multiple::before {
  content: "\\f00bb";
}

.mdi-book-multiple-outline::before {
  content: "\\f0436";
}

.mdi-book-music::before {
  content: "\\f0067";
}

.mdi-book-music-outline::before {
  content: "\\f1693";
}

.mdi-book-off::before {
  content: "\\f1694";
}

.mdi-book-off-outline::before {
  content: "\\f1695";
}

.mdi-book-open::before {
  content: "\\f00bd";
}

.mdi-book-open-blank-variant::before {
  content: "\\f00be";
}

.mdi-book-open-outline::before {
  content: "\\f0b63";
}

.mdi-book-open-page-variant::before {
  content: "\\f05da";
}

.mdi-book-open-page-variant-outline::before {
  content: "\\f15d6";
}

.mdi-book-open-variant::before {
  content: "\\f14f7";
}

.mdi-book-outline::before {
  content: "\\f0b64";
}

.mdi-book-play::before {
  content: "\\f0e82";
}

.mdi-book-play-outline::before {
  content: "\\f0e83";
}

.mdi-book-plus::before {
  content: "\\f05db";
}

.mdi-book-plus-multiple::before {
  content: "\\f0a95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\f0ade";
}

.mdi-book-plus-outline::before {
  content: "\\f1696";
}

.mdi-book-refresh::before {
  content: "\\f1697";
}

.mdi-book-refresh-outline::before {
  content: "\\f1698";
}

.mdi-book-remove::before {
  content: "\\f0a97";
}

.mdi-book-remove-multiple::before {
  content: "\\f0a96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\f04ca";
}

.mdi-book-remove-outline::before {
  content: "\\f1699";
}

.mdi-book-search::before {
  content: "\\f0e84";
}

.mdi-book-search-outline::before {
  content: "\\f0e85";
}

.mdi-book-settings::before {
  content: "\\f169a";
}

.mdi-book-settings-outline::before {
  content: "\\f169b";
}

.mdi-book-sync::before {
  content: "\\f169c";
}

.mdi-book-sync-outline::before {
  content: "\\f16c8";
}

.mdi-book-variant::before {
  content: "\\f00bf";
}

.mdi-book-variant-multiple::before {
  content: "\\f00bc";
}

.mdi-bookmark::before {
  content: "\\f00c0";
}

.mdi-bookmark-box-multiple::before {
  content: "\\f196c";
}

.mdi-bookmark-box-multiple-outline::before {
  content: "\\f196d";
}

.mdi-bookmark-check::before {
  content: "\\f00c1";
}

.mdi-bookmark-check-outline::before {
  content: "\\f137b";
}

.mdi-bookmark-minus::before {
  content: "\\f09cc";
}

.mdi-bookmark-minus-outline::before {
  content: "\\f09cd";
}

.mdi-bookmark-multiple::before {
  content: "\\f0e15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\f0e16";
}

.mdi-bookmark-music::before {
  content: "\\f00c2";
}

.mdi-bookmark-music-outline::before {
  content: "\\f1379";
}

.mdi-bookmark-off::before {
  content: "\\f09ce";
}

.mdi-bookmark-off-outline::before {
  content: "\\f09cf";
}

.mdi-bookmark-outline::before {
  content: "\\f00c3";
}

.mdi-bookmark-plus::before {
  content: "\\f00c5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\f00c4";
}

.mdi-bookmark-remove::before {
  content: "\\f00c6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\f137a";
}

.mdi-bookshelf::before {
  content: "\\f125f";
}

.mdi-boom-gate::before {
  content: "\\f0e86";
}

.mdi-boom-gate-alert::before {
  content: "\\f0e87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\f0e88";
}

.mdi-boom-gate-arrow-down::before {
  content: "\\f0e89";
}

.mdi-boom-gate-arrow-down-outline::before {
  content: "\\f0e8a";
}

.mdi-boom-gate-arrow-up::before {
  content: "\\f0e8c";
}

.mdi-boom-gate-arrow-up-outline::before {
  content: "\\f0e8d";
}

.mdi-boom-gate-outline::before {
  content: "\\f0e8b";
}

.mdi-boom-gate-up::before {
  content: "\\f17f9";
}

.mdi-boom-gate-up-outline::before {
  content: "\\f17fa";
}

.mdi-boombox::before {
  content: "\\f05dc";
}

.mdi-boomerang::before {
  content: "\\f10cf";
}

.mdi-bootstrap::before {
  content: "\\f06c6";
}

.mdi-border-all::before {
  content: "\\f00c7";
}

.mdi-border-all-variant::before {
  content: "\\f08a1";
}

.mdi-border-bottom::before {
  content: "\\f00c8";
}

.mdi-border-bottom-variant::before {
  content: "\\f08a2";
}

.mdi-border-color::before {
  content: "\\f00c9";
}

.mdi-border-horizontal::before {
  content: "\\f00ca";
}

.mdi-border-inside::before {
  content: "\\f00cb";
}

.mdi-border-left::before {
  content: "\\f00cc";
}

.mdi-border-left-variant::before {
  content: "\\f08a3";
}

.mdi-border-none::before {
  content: "\\f00cd";
}

.mdi-border-none-variant::before {
  content: "\\f08a4";
}

.mdi-border-outside::before {
  content: "\\f00ce";
}

.mdi-border-right::before {
  content: "\\f00cf";
}

.mdi-border-right-variant::before {
  content: "\\f08a5";
}

.mdi-border-style::before {
  content: "\\f00d0";
}

.mdi-border-top::before {
  content: "\\f00d1";
}

.mdi-border-top-variant::before {
  content: "\\f08a6";
}

.mdi-border-vertical::before {
  content: "\\f00d2";
}

.mdi-bottle-soda::before {
  content: "\\f1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\f1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\f1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\f1072";
}

.mdi-bottle-tonic::before {
  content: "\\f112e";
}

.mdi-bottle-tonic-outline::before {
  content: "\\f112f";
}

.mdi-bottle-tonic-plus::before {
  content: "\\f1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\f1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\f1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\f1133";
}

.mdi-bottle-wine::before {
  content: "\\f0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\f1310";
}

.mdi-bow-arrow::before {
  content: "\\f1841";
}

.mdi-bow-tie::before {
  content: "\\f0678";
}

.mdi-bowl::before {
  content: "\\f028e";
}

.mdi-bowl-mix::before {
  content: "\\f0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\f02e4";
}

.mdi-bowl-outline::before {
  content: "\\f02a9";
}

.mdi-bowling::before {
  content: "\\f00d3";
}

.mdi-box::before {
  content: "\\f00d4";
}

.mdi-box-cutter::before {
  content: "\\f00d5";
}

.mdi-box-cutter-off::before {
  content: "\\f0b4a";
}

.mdi-box-shadow::before {
  content: "\\f0637";
}

.mdi-boxing-glove::before {
  content: "\\f0b65";
}

.mdi-braille::before {
  content: "\\f09d0";
}

.mdi-brain::before {
  content: "\\f09d1";
}

.mdi-bread-slice::before {
  content: "\\f0cee";
}

.mdi-bread-slice-outline::before {
  content: "\\f0cef";
}

.mdi-bridge::before {
  content: "\\f0618";
}

.mdi-briefcase::before {
  content: "\\f00d6";
}

.mdi-briefcase-account::before {
  content: "\\f0cf0";
}

.mdi-briefcase-account-outline::before {
  content: "\\f0cf1";
}

.mdi-briefcase-check::before {
  content: "\\f00d7";
}

.mdi-briefcase-check-outline::before {
  content: "\\f131e";
}

.mdi-briefcase-clock::before {
  content: "\\f10d0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\f10d1";
}

.mdi-briefcase-download::before {
  content: "\\f00d8";
}

.mdi-briefcase-download-outline::before {
  content: "\\f0c3d";
}

.mdi-briefcase-edit::before {
  content: "\\f0a98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\f0c3e";
}

.mdi-briefcase-eye::before {
  content: "\\f17d9";
}

.mdi-briefcase-eye-outline::before {
  content: "\\f17da";
}

.mdi-briefcase-minus::before {
  content: "\\f0a2a";
}

.mdi-briefcase-minus-outline::before {
  content: "\\f0c3f";
}

.mdi-briefcase-off::before {
  content: "\\f1658";
}

.mdi-briefcase-off-outline::before {
  content: "\\f1659";
}

.mdi-briefcase-outline::before {
  content: "\\f0814";
}

.mdi-briefcase-plus::before {
  content: "\\f0a2b";
}

.mdi-briefcase-plus-outline::before {
  content: "\\f0c40";
}

.mdi-briefcase-remove::before {
  content: "\\f0a2c";
}

.mdi-briefcase-remove-outline::before {
  content: "\\f0c41";
}

.mdi-briefcase-search::before {
  content: "\\f0a2d";
}

.mdi-briefcase-search-outline::before {
  content: "\\f0c42";
}

.mdi-briefcase-upload::before {
  content: "\\f00d9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\f0c43";
}

.mdi-briefcase-variant::before {
  content: "\\f1494";
}

.mdi-briefcase-variant-off::before {
  content: "\\f165a";
}

.mdi-briefcase-variant-off-outline::before {
  content: "\\f165b";
}

.mdi-briefcase-variant-outline::before {
  content: "\\f1495";
}

.mdi-brightness-1::before {
  content: "\\f00da";
}

.mdi-brightness-2::before {
  content: "\\f00db";
}

.mdi-brightness-3::before {
  content: "\\f00dc";
}

.mdi-brightness-4::before {
  content: "\\f00dd";
}

.mdi-brightness-5::before {
  content: "\\f00de";
}

.mdi-brightness-6::before {
  content: "\\f00df";
}

.mdi-brightness-7::before {
  content: "\\f00e0";
}

.mdi-brightness-auto::before {
  content: "\\f00e1";
}

.mdi-brightness-percent::before {
  content: "\\f0cf2";
}

.mdi-broadcast::before {
  content: "\\f1720";
}

.mdi-broadcast-off::before {
  content: "\\f1721";
}

.mdi-broom::before {
  content: "\\f00e2";
}

.mdi-brush::before {
  content: "\\f00e3";
}

.mdi-brush-off::before {
  content: "\\f1771";
}

.mdi-brush-variant::before {
  content: "\\f1813";
}

.mdi-bucket::before {
  content: "\\f1415";
}

.mdi-bucket-outline::before {
  content: "\\f1416";
}

.mdi-buffet::before {
  content: "\\f0578";
}

.mdi-bug::before {
  content: "\\f00e4";
}

.mdi-bug-check::before {
  content: "\\f0a2e";
}

.mdi-bug-check-outline::before {
  content: "\\f0a2f";
}

.mdi-bug-outline::before {
  content: "\\f0a30";
}

.mdi-bugle::before {
  content: "\\f0db4";
}

.mdi-bulldozer::before {
  content: "\\f0b22";
}

.mdi-bullet::before {
  content: "\\f0cf3";
}

.mdi-bulletin-board::before {
  content: "\\f00e5";
}

.mdi-bullhorn::before {
  content: "\\f00e6";
}

.mdi-bullhorn-outline::before {
  content: "\\f0b23";
}

.mdi-bullhorn-variant::before {
  content: "\\f196e";
}

.mdi-bullhorn-variant-outline::before {
  content: "\\f196f";
}

.mdi-bullseye::before {
  content: "\\f05dd";
}

.mdi-bullseye-arrow::before {
  content: "\\f08c9";
}

.mdi-bulma::before {
  content: "\\f12e7";
}

.mdi-bunk-bed::before {
  content: "\\f1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\f0097";
}

.mdi-bus::before {
  content: "\\f00e7";
}

.mdi-bus-alert::before {
  content: "\\f0a99";
}

.mdi-bus-articulated-end::before {
  content: "\\f079c";
}

.mdi-bus-articulated-front::before {
  content: "\\f079d";
}

.mdi-bus-clock::before {
  content: "\\f08ca";
}

.mdi-bus-double-decker::before {
  content: "\\f079e";
}

.mdi-bus-electric::before {
  content: "\\f191d";
}

.mdi-bus-marker::before {
  content: "\\f1212";
}

.mdi-bus-multiple::before {
  content: "\\f0f3f";
}

.mdi-bus-school::before {
  content: "\\f079f";
}

.mdi-bus-side::before {
  content: "\\f07a0";
}

.mdi-bus-stop::before {
  content: "\\f1012";
}

.mdi-bus-stop-covered::before {
  content: "\\f1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\f1014";
}

.mdi-butterfly::before {
  content: "\\f1589";
}

.mdi-butterfly-outline::before {
  content: "\\f158a";
}

.mdi-cabin-a-frame::before {
  content: "\\f188c";
}

.mdi-cable-data::before {
  content: "\\f1394";
}

.mdi-cached::before {
  content: "\\f00e8";
}

.mdi-cactus::before {
  content: "\\f0db5";
}

.mdi-cake::before {
  content: "\\f00e9";
}

.mdi-cake-layered::before {
  content: "\\f00ea";
}

.mdi-cake-variant::before {
  content: "\\f00eb";
}

.mdi-cake-variant-outline::before {
  content: "\\f17f0";
}

.mdi-calculator::before {
  content: "\\f00ec";
}

.mdi-calculator-variant::before {
  content: "\\f0a9a";
}

.mdi-calculator-variant-outline::before {
  content: "\\f15a6";
}

.mdi-calendar::before {
  content: "\\f00ed";
}

.mdi-calendar-account::before {
  content: "\\f0ed7";
}

.mdi-calendar-account-outline::before {
  content: "\\f0ed8";
}

.mdi-calendar-alert::before {
  content: "\\f0a31";
}

.mdi-calendar-arrow-left::before {
  content: "\\f1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\f1135";
}

.mdi-calendar-blank::before {
  content: "\\f00ee";
}

.mdi-calendar-blank-multiple::before {
  content: "\\f1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\f0b66";
}

.mdi-calendar-check::before {
  content: "\\f00ef";
}

.mdi-calendar-check-outline::before {
  content: "\\f0c44";
}

.mdi-calendar-clock::before {
  content: "\\f00f0";
}

.mdi-calendar-clock-outline::before {
  content: "\\f16e1";
}

.mdi-calendar-collapse-horizontal::before {
  content: "\\f189d";
}

.mdi-calendar-cursor::before {
  content: "\\f157b";
}

.mdi-calendar-edit::before {
  content: "\\f08a7";
}

.mdi-calendar-end::before {
  content: "\\f166c";
}

.mdi-calendar-expand-horizontal::before {
  content: "\\f189e";
}

.mdi-calendar-export::before {
  content: "\\f0b24";
}

.mdi-calendar-heart::before {
  content: "\\f09d2";
}

.mdi-calendar-import::before {
  content: "\\f0b25";
}

.mdi-calendar-lock::before {
  content: "\\f1641";
}

.mdi-calendar-lock-outline::before {
  content: "\\f1642";
}

.mdi-calendar-minus::before {
  content: "\\f0d5c";
}

.mdi-calendar-month::before {
  content: "\\f0e17";
}

.mdi-calendar-month-outline::before {
  content: "\\f0e18";
}

.mdi-calendar-multiple::before {
  content: "\\f00f1";
}

.mdi-calendar-multiple-check::before {
  content: "\\f00f2";
}

.mdi-calendar-multiselect::before {
  content: "\\f0a32";
}

.mdi-calendar-outline::before {
  content: "\\f0b67";
}

.mdi-calendar-plus::before {
  content: "\\f00f3";
}

.mdi-calendar-question::before {
  content: "\\f0692";
}

.mdi-calendar-range::before {
  content: "\\f0679";
}

.mdi-calendar-range-outline::before {
  content: "\\f0b68";
}

.mdi-calendar-refresh::before {
  content: "\\f01e1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\f0203";
}

.mdi-calendar-remove::before {
  content: "\\f00f4";
}

.mdi-calendar-remove-outline::before {
  content: "\\f0c45";
}

.mdi-calendar-search::before {
  content: "\\f094c";
}

.mdi-calendar-star::before {
  content: "\\f09d3";
}

.mdi-calendar-start::before {
  content: "\\f166d";
}

.mdi-calendar-sync::before {
  content: "\\f0e8e";
}

.mdi-calendar-sync-outline::before {
  content: "\\f0e8f";
}

.mdi-calendar-text::before {
  content: "\\f00f5";
}

.mdi-calendar-text-outline::before {
  content: "\\f0c46";
}

.mdi-calendar-today::before {
  content: "\\f00f6";
}

.mdi-calendar-week::before {
  content: "\\f0a33";
}

.mdi-calendar-week-begin::before {
  content: "\\f0a34";
}

.mdi-calendar-weekend::before {
  content: "\\f0ed9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\f0eda";
}

.mdi-call-made::before {
  content: "\\f00f7";
}

.mdi-call-merge::before {
  content: "\\f00f8";
}

.mdi-call-missed::before {
  content: "\\f00f9";
}

.mdi-call-received::before {
  content: "\\f00fa";
}

.mdi-call-split::before {
  content: "\\f00fb";
}

.mdi-camcorder::before {
  content: "\\f00fc";
}

.mdi-camcorder-off::before {
  content: "\\f00ff";
}

.mdi-camera::before {
  content: "\\f0100";
}

.mdi-camera-account::before {
  content: "\\f08cb";
}

.mdi-camera-burst::before {
  content: "\\f0693";
}

.mdi-camera-control::before {
  content: "\\f0b69";
}

.mdi-camera-document::before {
  content: "\\f1871";
}

.mdi-camera-document-off::before {
  content: "\\f1872";
}

.mdi-camera-enhance::before {
  content: "\\f0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\f0b6a";
}

.mdi-camera-flip::before {
  content: "\\f15d9";
}

.mdi-camera-flip-outline::before {
  content: "\\f15da";
}

.mdi-camera-front::before {
  content: "\\f0102";
}

.mdi-camera-front-variant::before {
  content: "\\f0103";
}

.mdi-camera-gopro::before {
  content: "\\f07a1";
}

.mdi-camera-image::before {
  content: "\\f08cc";
}

.mdi-camera-iris::before {
  content: "\\f0104";
}

.mdi-camera-marker::before {
  content: "\\f19a7";
}

.mdi-camera-marker-outline::before {
  content: "\\f19a8";
}

.mdi-camera-metering-center::before {
  content: "\\f07a2";
}

.mdi-camera-metering-matrix::before {
  content: "\\f07a3";
}

.mdi-camera-metering-partial::before {
  content: "\\f07a4";
}

.mdi-camera-metering-spot::before {
  content: "\\f07a5";
}

.mdi-camera-off::before {
  content: "\\f05df";
}

.mdi-camera-off-outline::before {
  content: "\\f19bf";
}

.mdi-camera-outline::before {
  content: "\\f0d5d";
}

.mdi-camera-party-mode::before {
  content: "\\f0105";
}

.mdi-camera-plus::before {
  content: "\\f0edb";
}

.mdi-camera-plus-outline::before {
  content: "\\f0edc";
}

.mdi-camera-rear::before {
  content: "\\f0106";
}

.mdi-camera-rear-variant::before {
  content: "\\f0107";
}

.mdi-camera-retake::before {
  content: "\\f0e19";
}

.mdi-camera-retake-outline::before {
  content: "\\f0e1a";
}

.mdi-camera-switch::before {
  content: "\\f0108";
}

.mdi-camera-switch-outline::before {
  content: "\\f084a";
}

.mdi-camera-timer::before {
  content: "\\f0109";
}

.mdi-camera-wireless::before {
  content: "\\f0db6";
}

.mdi-camera-wireless-outline::before {
  content: "\\f0db7";
}

.mdi-campfire::before {
  content: "\\f0edd";
}

.mdi-cancel::before {
  content: "\\f073a";
}

.mdi-candelabra::before {
  content: "\\f17d2";
}

.mdi-candelabra-fire::before {
  content: "\\f17d3";
}

.mdi-candle::before {
  content: "\\f05e2";
}

.mdi-candy::before {
  content: "\\f1970";
}

.mdi-candy-off::before {
  content: "\\f1971";
}

.mdi-candy-off-outline::before {
  content: "\\f1972";
}

.mdi-candy-outline::before {
  content: "\\f1973";
}

.mdi-candycane::before {
  content: "\\f010a";
}

.mdi-cannabis::before {
  content: "\\f07a6";
}

.mdi-cannabis-off::before {
  content: "\\f166e";
}

.mdi-caps-lock::before {
  content: "\\f0a9b";
}

.mdi-car::before {
  content: "\\f010b";
}

.mdi-car-2-plus::before {
  content: "\\f1015";
}

.mdi-car-3-plus::before {
  content: "\\f1016";
}

.mdi-car-arrow-left::before {
  content: "\\f13b2";
}

.mdi-car-arrow-right::before {
  content: "\\f13b3";
}

.mdi-car-back::before {
  content: "\\f0e1b";
}

.mdi-car-battery::before {
  content: "\\f010c";
}

.mdi-car-brake-abs::before {
  content: "\\f0c47";
}

.mdi-car-brake-alert::before {
  content: "\\f0c48";
}

.mdi-car-brake-fluid-level::before {
  content: "\\f1909";
}

.mdi-car-brake-hold::before {
  content: "\\f0d5e";
}

.mdi-car-brake-low-pressure::before {
  content: "\\f190a";
}

.mdi-car-brake-parking::before {
  content: "\\f0d5f";
}

.mdi-car-brake-retarder::before {
  content: "\\f1017";
}

.mdi-car-brake-temperature::before {
  content: "\\f190b";
}

.mdi-car-brake-worn-linings::before {
  content: "\\f190c";
}

.mdi-car-child-seat::before {
  content: "\\f0fa3";
}

.mdi-car-clock::before {
  content: "\\f1974";
}

.mdi-car-clutch::before {
  content: "\\f1018";
}

.mdi-car-cog::before {
  content: "\\f13cc";
}

.mdi-car-connected::before {
  content: "\\f010d";
}

.mdi-car-convertible::before {
  content: "\\f07a7";
}

.mdi-car-coolant-level::before {
  content: "\\f1019";
}

.mdi-car-cruise-control::before {
  content: "\\f0d60";
}

.mdi-car-defrost-front::before {
  content: "\\f0d61";
}

.mdi-car-defrost-rear::before {
  content: "\\f0d62";
}

.mdi-car-door::before {
  content: "\\f0b6b";
}

.mdi-car-door-lock::before {
  content: "\\f109d";
}

.mdi-car-electric::before {
  content: "\\f0b6c";
}

.mdi-car-electric-outline::before {
  content: "\\f15b5";
}

.mdi-car-emergency::before {
  content: "\\f160f";
}

.mdi-car-esp::before {
  content: "\\f0c49";
}

.mdi-car-estate::before {
  content: "\\f07a8";
}

.mdi-car-hatchback::before {
  content: "\\f07a9";
}

.mdi-car-info::before {
  content: "\\f11be";
}

.mdi-car-key::before {
  content: "\\f0b6d";
}

.mdi-car-lifted-pickup::before {
  content: "\\f152d";
}

.mdi-car-light-alert::before {
  content: "\\f190d";
}

.mdi-car-light-dimmed::before {
  content: "\\f0c4a";
}

.mdi-car-light-fog::before {
  content: "\\f0c4b";
}

.mdi-car-light-high::before {
  content: "\\f0c4c";
}

.mdi-car-limousine::before {
  content: "\\f08cd";
}

.mdi-car-multiple::before {
  content: "\\f0b6e";
}

.mdi-car-off::before {
  content: "\\f0e1c";
}

.mdi-car-outline::before {
  content: "\\f14ed";
}

.mdi-car-parking-lights::before {
  content: "\\f0d63";
}

.mdi-car-pickup::before {
  content: "\\f07aa";
}

.mdi-car-seat::before {
  content: "\\f0fa4";
}

.mdi-car-seat-cooler::before {
  content: "\\f0fa5";
}

.mdi-car-seat-heater::before {
  content: "\\f0fa6";
}

.mdi-car-select::before {
  content: "\\f1879";
}

.mdi-car-settings::before {
  content: "\\f13cd";
}

.mdi-car-shift-pattern::before {
  content: "\\f0f40";
}

.mdi-car-side::before {
  content: "\\f07ab";
}

.mdi-car-speed-limiter::before {
  content: "\\f190e";
}

.mdi-car-sports::before {
  content: "\\f07ac";
}

.mdi-car-tire-alert::before {
  content: "\\f0c4d";
}

.mdi-car-traction-control::before {
  content: "\\f0d64";
}

.mdi-car-turbocharger::before {
  content: "\\f101a";
}

.mdi-car-wash::before {
  content: "\\f010e";
}

.mdi-car-windshield::before {
  content: "\\f101b";
}

.mdi-car-windshield-outline::before {
  content: "\\f101c";
}

.mdi-car-wireless::before {
  content: "\\f1878";
}

.mdi-car-wrench::before {
  content: "\\f1814";
}

.mdi-carabiner::before {
  content: "\\f14c0";
}

.mdi-caravan::before {
  content: "\\f07ad";
}

.mdi-card::before {
  content: "\\f0b6f";
}

.mdi-card-account-details::before {
  content: "\\f05d2";
}

.mdi-card-account-details-outline::before {
  content: "\\f0dab";
}

.mdi-card-account-details-star::before {
  content: "\\f02a3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\f06db";
}

.mdi-card-account-mail::before {
  content: "\\f018e";
}

.mdi-card-account-mail-outline::before {
  content: "\\f0e98";
}

.mdi-card-account-phone::before {
  content: "\\f0e99";
}

.mdi-card-account-phone-outline::before {
  content: "\\f0e9a";
}

.mdi-card-bulleted::before {
  content: "\\f0b70";
}

.mdi-card-bulleted-off::before {
  content: "\\f0b71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\f0b72";
}

.mdi-card-bulleted-outline::before {
  content: "\\f0b73";
}

.mdi-card-bulleted-settings::before {
  content: "\\f0b74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\f0b75";
}

.mdi-card-minus::before {
  content: "\\f1600";
}

.mdi-card-minus-outline::before {
  content: "\\f1601";
}

.mdi-card-multiple::before {
  content: "\\f17f1";
}

.mdi-card-multiple-outline::before {
  content: "\\f17f2";
}

.mdi-card-off::before {
  content: "\\f1602";
}

.mdi-card-off-outline::before {
  content: "\\f1603";
}

.mdi-card-outline::before {
  content: "\\f0b76";
}

.mdi-card-plus::before {
  content: "\\f11ff";
}

.mdi-card-plus-outline::before {
  content: "\\f1200";
}

.mdi-card-remove::before {
  content: "\\f1604";
}

.mdi-card-remove-outline::before {
  content: "\\f1605";
}

.mdi-card-search::before {
  content: "\\f1074";
}

.mdi-card-search-outline::before {
  content: "\\f1075";
}

.mdi-card-text::before {
  content: "\\f0b77";
}

.mdi-card-text-outline::before {
  content: "\\f0b78";
}

.mdi-cards::before {
  content: "\\f0638";
}

.mdi-cards-club::before {
  content: "\\f08ce";
}

.mdi-cards-club-outline::before {
  content: "\\f189f";
}

.mdi-cards-diamond::before {
  content: "\\f08cf";
}

.mdi-cards-diamond-outline::before {
  content: "\\f101d";
}

.mdi-cards-heart::before {
  content: "\\f08d0";
}

.mdi-cards-heart-outline::before {
  content: "\\f18a0";
}

.mdi-cards-outline::before {
  content: "\\f0639";
}

.mdi-cards-playing::before {
  content: "\\f18a1";
}

.mdi-cards-playing-club::before {
  content: "\\f18a2";
}

.mdi-cards-playing-club-multiple::before {
  content: "\\f18a3";
}

.mdi-cards-playing-club-multiple-outline::before {
  content: "\\f18a4";
}

.mdi-cards-playing-club-outline::before {
  content: "\\f18a5";
}

.mdi-cards-playing-diamond::before {
  content: "\\f18a6";
}

.mdi-cards-playing-diamond-multiple::before {
  content: "\\f18a7";
}

.mdi-cards-playing-diamond-multiple-outline::before {
  content: "\\f18a8";
}

.mdi-cards-playing-diamond-outline::before {
  content: "\\f18a9";
}

.mdi-cards-playing-heart::before {
  content: "\\f18aa";
}

.mdi-cards-playing-heart-multiple::before {
  content: "\\f18ab";
}

.mdi-cards-playing-heart-multiple-outline::before {
  content: "\\f18ac";
}

.mdi-cards-playing-heart-outline::before {
  content: "\\f18ad";
}

.mdi-cards-playing-outline::before {
  content: "\\f063a";
}

.mdi-cards-playing-spade::before {
  content: "\\f18ae";
}

.mdi-cards-playing-spade-multiple::before {
  content: "\\f18af";
}

.mdi-cards-playing-spade-multiple-outline::before {
  content: "\\f18b0";
}

.mdi-cards-playing-spade-outline::before {
  content: "\\f18b1";
}

.mdi-cards-spade::before {
  content: "\\f08d1";
}

.mdi-cards-spade-outline::before {
  content: "\\f18b2";
}

.mdi-cards-variant::before {
  content: "\\f06c7";
}

.mdi-carrot::before {
  content: "\\f010f";
}

.mdi-cart::before {
  content: "\\f0110";
}

.mdi-cart-arrow-down::before {
  content: "\\f0d66";
}

.mdi-cart-arrow-right::before {
  content: "\\f0c4e";
}

.mdi-cart-arrow-up::before {
  content: "\\f0d67";
}

.mdi-cart-check::before {
  content: "\\f15ea";
}

.mdi-cart-heart::before {
  content: "\\f18e0";
}

.mdi-cart-minus::before {
  content: "\\f0d68";
}

.mdi-cart-off::before {
  content: "\\f066b";
}

.mdi-cart-outline::before {
  content: "\\f0111";
}

.mdi-cart-plus::before {
  content: "\\f0112";
}

.mdi-cart-remove::before {
  content: "\\f0d69";
}

.mdi-cart-variant::before {
  content: "\\f15eb";
}

.mdi-case-sensitive-alt::before {
  content: "\\f0113";
}

.mdi-cash::before {
  content: "\\f0114";
}

.mdi-cash-100::before {
  content: "\\f0115";
}

.mdi-cash-check::before {
  content: "\\f14ee";
}

.mdi-cash-fast::before {
  content: "\\f185c";
}

.mdi-cash-lock::before {
  content: "\\f14ea";
}

.mdi-cash-lock-open::before {
  content: "\\f14eb";
}

.mdi-cash-marker::before {
  content: "\\f0db8";
}

.mdi-cash-minus::before {
  content: "\\f1260";
}

.mdi-cash-multiple::before {
  content: "\\f0116";
}

.mdi-cash-plus::before {
  content: "\\f1261";
}

.mdi-cash-refund::before {
  content: "\\f0a9c";
}

.mdi-cash-register::before {
  content: "\\f0cf4";
}

.mdi-cash-remove::before {
  content: "\\f1262";
}

.mdi-cassette::before {
  content: "\\f09d4";
}

.mdi-cast::before {
  content: "\\f0118";
}

.mdi-cast-audio::before {
  content: "\\f101e";
}

.mdi-cast-audio-variant::before {
  content: "\\f1749";
}

.mdi-cast-connected::before {
  content: "\\f0119";
}

.mdi-cast-education::before {
  content: "\\f0e1d";
}

.mdi-cast-off::before {
  content: "\\f078a";
}

.mdi-cast-variant::before {
  content: "\\f001f";
}

.mdi-castle::before {
  content: "\\f011a";
}

.mdi-cat::before {
  content: "\\f011b";
}

.mdi-cctv::before {
  content: "\\f07ae";
}

.mdi-cctv-off::before {
  content: "\\f185f";
}

.mdi-ceiling-fan::before {
  content: "\\f1797";
}

.mdi-ceiling-fan-light::before {
  content: "\\f1798";
}

.mdi-ceiling-light::before {
  content: "\\f0769";
}

.mdi-ceiling-light-multiple::before {
  content: "\\f18dd";
}

.mdi-ceiling-light-multiple-outline::before {
  content: "\\f18de";
}

.mdi-ceiling-light-outline::before {
  content: "\\f17c7";
}

.mdi-cellphone::before {
  content: "\\f011c";
}

.mdi-cellphone-arrow-down::before {
  content: "\\f09d5";
}

.mdi-cellphone-basic::before {
  content: "\\f011e";
}

.mdi-cellphone-charging::before {
  content: "\\f1397";
}

.mdi-cellphone-check::before {
  content: "\\f17fd";
}

.mdi-cellphone-cog::before {
  content: "\\f0951";
}

.mdi-cellphone-dock::before {
  content: "\\f011f";
}

.mdi-cellphone-information::before {
  content: "\\f0f41";
}

.mdi-cellphone-key::before {
  content: "\\f094e";
}

.mdi-cellphone-link::before {
  content: "\\f0121";
}

.mdi-cellphone-link-off::before {
  content: "\\f0122";
}

.mdi-cellphone-lock::before {
  content: "\\f094f";
}

.mdi-cellphone-marker::before {
  content: "\\f183a";
}

.mdi-cellphone-message::before {
  content: "\\f08d3";
}

.mdi-cellphone-message-off::before {
  content: "\\f10d2";
}

.mdi-cellphone-nfc::before {
  content: "\\f0e90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\f12d8";
}

.mdi-cellphone-off::before {
  content: "\\f0950";
}

.mdi-cellphone-play::before {
  content: "\\f101f";
}

.mdi-cellphone-remove::before {
  content: "\\f094d";
}

.mdi-cellphone-screenshot::before {
  content: "\\f0a35";
}

.mdi-cellphone-settings::before {
  content: "\\f0123";
}

.mdi-cellphone-sound::before {
  content: "\\f0952";
}

.mdi-cellphone-text::before {
  content: "\\f08d2";
}

.mdi-cellphone-wireless::before {
  content: "\\f0815";
}

.mdi-centos::before {
  content: "\\f111a";
}

.mdi-certificate::before {
  content: "\\f0124";
}

.mdi-certificate-outline::before {
  content: "\\f1188";
}

.mdi-chair-rolling::before {
  content: "\\f0f48";
}

.mdi-chair-school::before {
  content: "\\f0125";
}

.mdi-chandelier::before {
  content: "\\f1793";
}

.mdi-charity::before {
  content: "\\f0c4f";
}

.mdi-chart-arc::before {
  content: "\\f0126";
}

.mdi-chart-areaspline::before {
  content: "\\f0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\f0e91";
}

.mdi-chart-bar::before {
  content: "\\f0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\f076a";
}

.mdi-chart-bell-curve::before {
  content: "\\f0c50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\f0fa7";
}

.mdi-chart-box::before {
  content: "\\f154d";
}

.mdi-chart-box-outline::before {
  content: "\\f154e";
}

.mdi-chart-box-plus-outline::before {
  content: "\\f154f";
}

.mdi-chart-bubble::before {
  content: "\\f05e3";
}

.mdi-chart-donut::before {
  content: "\\f07af";
}

.mdi-chart-donut-variant::before {
  content: "\\f07b0";
}

.mdi-chart-gantt::before {
  content: "\\f066c";
}

.mdi-chart-histogram::before {
  content: "\\f0129";
}

.mdi-chart-line::before {
  content: "\\f012a";
}

.mdi-chart-line-stacked::before {
  content: "\\f076b";
}

.mdi-chart-line-variant::before {
  content: "\\f07b1";
}

.mdi-chart-multiline::before {
  content: "\\f08d4";
}

.mdi-chart-multiple::before {
  content: "\\f1213";
}

.mdi-chart-pie::before {
  content: "\\f012b";
}

.mdi-chart-ppf::before {
  content: "\\f1380";
}

.mdi-chart-sankey::before {
  content: "\\f11df";
}

.mdi-chart-sankey-variant::before {
  content: "\\f11e0";
}

.mdi-chart-scatter-plot::before {
  content: "\\f0e92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\f066d";
}

.mdi-chart-timeline::before {
  content: "\\f066e";
}

.mdi-chart-timeline-variant::before {
  content: "\\f0e93";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\f15b6";
}

.mdi-chart-tree::before {
  content: "\\f0e94";
}

.mdi-chart-waterfall::before {
  content: "\\f1918";
}

.mdi-chat::before {
  content: "\\f0b79";
}

.mdi-chat-alert::before {
  content: "\\f0b7a";
}

.mdi-chat-alert-outline::before {
  content: "\\f12c9";
}

.mdi-chat-minus::before {
  content: "\\f1410";
}

.mdi-chat-minus-outline::before {
  content: "\\f1413";
}

.mdi-chat-outline::before {
  content: "\\f0ede";
}

.mdi-chat-plus::before {
  content: "\\f140f";
}

.mdi-chat-plus-outline::before {
  content: "\\f1412";
}

.mdi-chat-processing::before {
  content: "\\f0b7b";
}

.mdi-chat-processing-outline::before {
  content: "\\f12ca";
}

.mdi-chat-question::before {
  content: "\\f1738";
}

.mdi-chat-question-outline::before {
  content: "\\f1739";
}

.mdi-chat-remove::before {
  content: "\\f1411";
}

.mdi-chat-remove-outline::before {
  content: "\\f1414";
}

.mdi-chat-sleep::before {
  content: "\\f12d1";
}

.mdi-chat-sleep-outline::before {
  content: "\\f12d2";
}

.mdi-check::before {
  content: "\\f012c";
}

.mdi-check-all::before {
  content: "\\f012d";
}

.mdi-check-bold::before {
  content: "\\f0e1e";
}

.mdi-check-circle::before {
  content: "\\f05e0";
}

.mdi-check-circle-outline::before {
  content: "\\f05e1";
}

.mdi-check-decagram::before {
  content: "\\f0791";
}

.mdi-check-decagram-outline::before {
  content: "\\f1740";
}

.mdi-check-network::before {
  content: "\\f0c53";
}

.mdi-check-network-outline::before {
  content: "\\f0c54";
}

.mdi-check-outline::before {
  content: "\\f0855";
}

.mdi-check-underline::before {
  content: "\\f0e1f";
}

.mdi-check-underline-circle::before {
  content: "\\f0e20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\f0e21";
}

.mdi-checkbook::before {
  content: "\\f0a9d";
}

.mdi-checkbox-blank::before {
  content: "\\f012e";
}

.mdi-checkbox-blank-badge::before {
  content: "\\f1176";
}

.mdi-checkbox-blank-badge-outline::before {
  content: "\\f0117";
}

.mdi-checkbox-blank-circle::before {
  content: "\\f012f";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\f0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\f12ec";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\f12ed";
}

.mdi-checkbox-blank-outline::before {
  content: "\\f0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\f0856";
}

.mdi-checkbox-marked::before {
  content: "\\f0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\f0133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\f0134";
}

.mdi-checkbox-marked-circle-plus-outline::before {
  content: "\\f1927";
}

.mdi-checkbox-marked-outline::before {
  content: "\\f0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\f0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\f063b";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\f063c";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\f0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\f0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\f063d";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\f063e";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\f0139";
}

.mdi-checkbox-multiple-outline::before {
  content: "\\f0c51";
}

.mdi-checkbox-outline::before {
  content: "\\f0c52";
}

.mdi-checkerboard::before {
  content: "\\f013a";
}

.mdi-checkerboard-minus::before {
  content: "\\f1202";
}

.mdi-checkerboard-plus::before {
  content: "\\f1201";
}

.mdi-checkerboard-remove::before {
  content: "\\f1203";
}

.mdi-cheese::before {
  content: "\\f12b9";
}

.mdi-cheese-off::before {
  content: "\\f13ee";
}

.mdi-chef-hat::before {
  content: "\\f0b7c";
}

.mdi-chemical-weapon::before {
  content: "\\f013b";
}

.mdi-chess-bishop::before {
  content: "\\f085c";
}

.mdi-chess-king::before {
  content: "\\f0857";
}

.mdi-chess-knight::before {
  content: "\\f0858";
}

.mdi-chess-pawn::before {
  content: "\\f0859";
}

.mdi-chess-queen::before {
  content: "\\f085a";
}

.mdi-chess-rook::before {
  content: "\\f085b";
}

.mdi-chevron-double-down::before {
  content: "\\f013c";
}

.mdi-chevron-double-left::before {
  content: "\\f013d";
}

.mdi-chevron-double-right::before {
  content: "\\f013e";
}

.mdi-chevron-double-up::before {
  content: "\\f013f";
}

.mdi-chevron-down::before {
  content: "\\f0140";
}

.mdi-chevron-down-box::before {
  content: "\\f09d6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\f09d7";
}

.mdi-chevron-down-circle::before {
  content: "\\f0b26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\f0b27";
}

.mdi-chevron-left::before {
  content: "\\f0141";
}

.mdi-chevron-left-box::before {
  content: "\\f09d8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\f09d9";
}

.mdi-chevron-left-circle::before {
  content: "\\f0b28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\f0b29";
}

.mdi-chevron-right::before {
  content: "\\f0142";
}

.mdi-chevron-right-box::before {
  content: "\\f09da";
}

.mdi-chevron-right-box-outline::before {
  content: "\\f09db";
}

.mdi-chevron-right-circle::before {
  content: "\\f0b2a";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\f0b2b";
}

.mdi-chevron-triple-down::before {
  content: "\\f0db9";
}

.mdi-chevron-triple-left::before {
  content: "\\f0dba";
}

.mdi-chevron-triple-right::before {
  content: "\\f0dbb";
}

.mdi-chevron-triple-up::before {
  content: "\\f0dbc";
}

.mdi-chevron-up::before {
  content: "\\f0143";
}

.mdi-chevron-up-box::before {
  content: "\\f09dc";
}

.mdi-chevron-up-box-outline::before {
  content: "\\f09dd";
}

.mdi-chevron-up-circle::before {
  content: "\\f0b2c";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\f0b2d";
}

.mdi-chili-alert::before {
  content: "\\f17ea";
}

.mdi-chili-alert-outline::before {
  content: "\\f17eb";
}

.mdi-chili-hot::before {
  content: "\\f07b2";
}

.mdi-chili-hot-outline::before {
  content: "\\f17ec";
}

.mdi-chili-medium::before {
  content: "\\f07b3";
}

.mdi-chili-medium-outline::before {
  content: "\\f17ed";
}

.mdi-chili-mild::before {
  content: "\\f07b4";
}

.mdi-chili-mild-outline::before {
  content: "\\f17ee";
}

.mdi-chili-off::before {
  content: "\\f1467";
}

.mdi-chili-off-outline::before {
  content: "\\f17ef";
}

.mdi-chip::before {
  content: "\\f061a";
}

.mdi-church::before {
  content: "\\f0144";
}

.mdi-cigar::before {
  content: "\\f1189";
}

.mdi-cigar-off::before {
  content: "\\f141b";
}

.mdi-circle::before {
  content: "\\f0765";
}

.mdi-circle-box::before {
  content: "\\f15dc";
}

.mdi-circle-box-outline::before {
  content: "\\f15dd";
}

.mdi-circle-double::before {
  content: "\\f0e95";
}

.mdi-circle-edit-outline::before {
  content: "\\f08d5";
}

.mdi-circle-expand::before {
  content: "\\f0e96";
}

.mdi-circle-half::before {
  content: "\\f1395";
}

.mdi-circle-half-full::before {
  content: "\\f1396";
}

.mdi-circle-medium::before {
  content: "\\f09de";
}

.mdi-circle-multiple::before {
  content: "\\f0b38";
}

.mdi-circle-multiple-outline::before {
  content: "\\f0695";
}

.mdi-circle-off-outline::before {
  content: "\\f10d3";
}

.mdi-circle-opacity::before {
  content: "\\f1853";
}

.mdi-circle-outline::before {
  content: "\\f0766";
}

.mdi-circle-slice-1::before {
  content: "\\f0a9e";
}

.mdi-circle-slice-2::before {
  content: "\\f0a9f";
}

.mdi-circle-slice-3::before {
  content: "\\f0aa0";
}

.mdi-circle-slice-4::before {
  content: "\\f0aa1";
}

.mdi-circle-slice-5::before {
  content: "\\f0aa2";
}

.mdi-circle-slice-6::before {
  content: "\\f0aa3";
}

.mdi-circle-slice-7::before {
  content: "\\f0aa4";
}

.mdi-circle-slice-8::before {
  content: "\\f0aa5";
}

.mdi-circle-small::before {
  content: "\\f09df";
}

.mdi-circular-saw::before {
  content: "\\f0e22";
}

.mdi-city::before {
  content: "\\f0146";
}

.mdi-city-variant::before {
  content: "\\f0a36";
}

.mdi-city-variant-outline::before {
  content: "\\f0a37";
}

.mdi-clipboard::before {
  content: "\\f0147";
}

.mdi-clipboard-account::before {
  content: "\\f0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\f0c55";
}

.mdi-clipboard-alert::before {
  content: "\\f0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\f0cf7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\f014a";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\f0c56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\f014b";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\f0cf8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\f0cf9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\f0cfa";
}

.mdi-clipboard-arrow-up::before {
  content: "\\f0c57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\f0c58";
}

.mdi-clipboard-check::before {
  content: "\\f014e";
}

.mdi-clipboard-check-multiple::before {
  content: "\\f1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\f1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\f08a8";
}

.mdi-clipboard-clock::before {
  content: "\\f16e2";
}

.mdi-clipboard-clock-outline::before {
  content: "\\f16e3";
}

.mdi-clipboard-edit::before {
  content: "\\f14e5";
}

.mdi-clipboard-edit-outline::before {
  content: "\\f14e6";
}

.mdi-clipboard-file::before {
  content: "\\f1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\f1266";
}

.mdi-clipboard-flow::before {
  content: "\\f06c8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\f1117";
}

.mdi-clipboard-list::before {
  content: "\\f10d4";
}

.mdi-clipboard-list-outline::before {
  content: "\\f10d5";
}

.mdi-clipboard-minus::before {
  content: "\\f1618";
}

.mdi-clipboard-minus-outline::before {
  content: "\\f1619";
}

.mdi-clipboard-multiple::before {
  content: "\\f1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\f1268";
}

.mdi-clipboard-off::before {
  content: "\\f161a";
}

.mdi-clipboard-off-outline::before {
  content: "\\f161b";
}

.mdi-clipboard-outline::before {
  content: "\\f014c";
}

.mdi-clipboard-play::before {
  content: "\\f0c59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\f1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\f126a";
}

.mdi-clipboard-play-outline::before {
  content: "\\f0c5a";
}

.mdi-clipboard-plus::before {
  content: "\\f0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\f131f";
}

.mdi-clipboard-pulse::before {
  content: "\\f085d";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\f085e";
}

.mdi-clipboard-remove::before {
  content: "\\f161c";
}

.mdi-clipboard-remove-outline::before {
  content: "\\f161d";
}

.mdi-clipboard-search::before {
  content: "\\f161e";
}

.mdi-clipboard-search-outline::before {
  content: "\\f161f";
}

.mdi-clipboard-text::before {
  content: "\\f014d";
}

.mdi-clipboard-text-clock::before {
  content: "\\f18f9";
}

.mdi-clipboard-text-clock-outline::before {
  content: "\\f18fa";
}

.mdi-clipboard-text-multiple::before {
  content: "\\f126b";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\f126c";
}

.mdi-clipboard-text-off::before {
  content: "\\f1620";
}

.mdi-clipboard-text-off-outline::before {
  content: "\\f1621";
}

.mdi-clipboard-text-outline::before {
  content: "\\f0a38";
}

.mdi-clipboard-text-play::before {
  content: "\\f0c5b";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\f0c5c";
}

.mdi-clipboard-text-search::before {
  content: "\\f1622";
}

.mdi-clipboard-text-search-outline::before {
  content: "\\f1623";
}

.mdi-clippy::before {
  content: "\\f014f";
}

.mdi-clock::before {
  content: "\\f0954";
}

.mdi-clock-alert::before {
  content: "\\f0955";
}

.mdi-clock-alert-outline::before {
  content: "\\f05ce";
}

.mdi-clock-check::before {
  content: "\\f0fa8";
}

.mdi-clock-check-outline::before {
  content: "\\f0fa9";
}

.mdi-clock-digital::before {
  content: "\\f0e97";
}

.mdi-clock-edit::before {
  content: "\\f19ba";
}

.mdi-clock-edit-outline::before {
  content: "\\f19bb";
}

.mdi-clock-end::before {
  content: "\\f0151";
}

.mdi-clock-fast::before {
  content: "\\f0152";
}

.mdi-clock-in::before {
  content: "\\f0153";
}

.mdi-clock-minus::before {
  content: "\\f1863";
}

.mdi-clock-minus-outline::before {
  content: "\\f1864";
}

.mdi-clock-out::before {
  content: "\\f0154";
}

.mdi-clock-outline::before {
  content: "\\f0150";
}

.mdi-clock-plus::before {
  content: "\\f1861";
}

.mdi-clock-plus-outline::before {
  content: "\\f1862";
}

.mdi-clock-remove::before {
  content: "\\f1865";
}

.mdi-clock-remove-outline::before {
  content: "\\f1866";
}

.mdi-clock-start::before {
  content: "\\f0155";
}

.mdi-clock-time-eight::before {
  content: "\\f1446";
}

.mdi-clock-time-eight-outline::before {
  content: "\\f1452";
}

.mdi-clock-time-eleven::before {
  content: "\\f1449";
}

.mdi-clock-time-eleven-outline::before {
  content: "\\f1455";
}

.mdi-clock-time-five::before {
  content: "\\f1443";
}

.mdi-clock-time-five-outline::before {
  content: "\\f144f";
}

.mdi-clock-time-four::before {
  content: "\\f1442";
}

.mdi-clock-time-four-outline::before {
  content: "\\f144e";
}

.mdi-clock-time-nine::before {
  content: "\\f1447";
}

.mdi-clock-time-nine-outline::before {
  content: "\\f1453";
}

.mdi-clock-time-one::before {
  content: "\\f143f";
}

.mdi-clock-time-one-outline::before {
  content: "\\f144b";
}

.mdi-clock-time-seven::before {
  content: "\\f1445";
}

.mdi-clock-time-seven-outline::before {
  content: "\\f1451";
}

.mdi-clock-time-six::before {
  content: "\\f1444";
}

.mdi-clock-time-six-outline::before {
  content: "\\f1450";
}

.mdi-clock-time-ten::before {
  content: "\\f1448";
}

.mdi-clock-time-ten-outline::before {
  content: "\\f1454";
}

.mdi-clock-time-three::before {
  content: "\\f1441";
}

.mdi-clock-time-three-outline::before {
  content: "\\f144d";
}

.mdi-clock-time-twelve::before {
  content: "\\f144a";
}

.mdi-clock-time-twelve-outline::before {
  content: "\\f1456";
}

.mdi-clock-time-two::before {
  content: "\\f1440";
}

.mdi-clock-time-two-outline::before {
  content: "\\f144c";
}

.mdi-close::before {
  content: "\\f0156";
}

.mdi-close-box::before {
  content: "\\f0157";
}

.mdi-close-box-multiple::before {
  content: "\\f0c5d";
}

.mdi-close-box-multiple-outline::before {
  content: "\\f0c5e";
}

.mdi-close-box-outline::before {
  content: "\\f0158";
}

.mdi-close-circle::before {
  content: "\\f0159";
}

.mdi-close-circle-multiple::before {
  content: "\\f062a";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\f0883";
}

.mdi-close-circle-outline::before {
  content: "\\f015a";
}

.mdi-close-network::before {
  content: "\\f015b";
}

.mdi-close-network-outline::before {
  content: "\\f0c5f";
}

.mdi-close-octagon::before {
  content: "\\f015c";
}

.mdi-close-octagon-outline::before {
  content: "\\f015d";
}

.mdi-close-outline::before {
  content: "\\f06c9";
}

.mdi-close-thick::before {
  content: "\\f1398";
}

.mdi-closed-caption::before {
  content: "\\f015e";
}

.mdi-closed-caption-outline::before {
  content: "\\f0dbd";
}

.mdi-cloud::before {
  content: "\\f015f";
}

.mdi-cloud-alert::before {
  content: "\\f09e0";
}

.mdi-cloud-braces::before {
  content: "\\f07b5";
}

.mdi-cloud-check::before {
  content: "\\f0160";
}

.mdi-cloud-check-outline::before {
  content: "\\f12cc";
}

.mdi-cloud-circle::before {
  content: "\\f0161";
}

.mdi-cloud-download::before {
  content: "\\f0162";
}

.mdi-cloud-download-outline::before {
  content: "\\f0b7d";
}

.mdi-cloud-lock::before {
  content: "\\f11f1";
}

.mdi-cloud-lock-outline::before {
  content: "\\f11f2";
}

.mdi-cloud-off-outline::before {
  content: "\\f0164";
}

.mdi-cloud-outline::before {
  content: "\\f0163";
}

.mdi-cloud-print::before {
  content: "\\f0165";
}

.mdi-cloud-print-outline::before {
  content: "\\f0166";
}

.mdi-cloud-question::before {
  content: "\\f0a39";
}

.mdi-cloud-refresh::before {
  content: "\\f052a";
}

.mdi-cloud-search::before {
  content: "\\f0956";
}

.mdi-cloud-search-outline::before {
  content: "\\f0957";
}

.mdi-cloud-sync::before {
  content: "\\f063f";
}

.mdi-cloud-sync-outline::before {
  content: "\\f12d6";
}

.mdi-cloud-tags::before {
  content: "\\f07b6";
}

.mdi-cloud-upload::before {
  content: "\\f0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\f0b7e";
}

.mdi-clover::before {
  content: "\\f0816";
}

.mdi-coach-lamp::before {
  content: "\\f1020";
}

.mdi-coat-rack::before {
  content: "\\f109e";
}

.mdi-code-array::before {
  content: "\\f0168";
}

.mdi-code-braces::before {
  content: "\\f0169";
}

.mdi-code-braces-box::before {
  content: "\\f10d6";
}

.mdi-code-brackets::before {
  content: "\\f016a";
}

.mdi-code-equal::before {
  content: "\\f016b";
}

.mdi-code-greater-than::before {
  content: "\\f016c";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\f016d";
}

.mdi-code-json::before {
  content: "\\f0626";
}

.mdi-code-less-than::before {
  content: "\\f016e";
}

.mdi-code-less-than-or-equal::before {
  content: "\\f016f";
}

.mdi-code-not-equal::before {
  content: "\\f0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\f0171";
}

.mdi-code-parentheses::before {
  content: "\\f0172";
}

.mdi-code-parentheses-box::before {
  content: "\\f10d7";
}

.mdi-code-string::before {
  content: "\\f0173";
}

.mdi-code-tags::before {
  content: "\\f0174";
}

.mdi-code-tags-check::before {
  content: "\\f0694";
}

.mdi-codepen::before {
  content: "\\f0175";
}

.mdi-coffee::before {
  content: "\\f0176";
}

.mdi-coffee-maker::before {
  content: "\\f109f";
}

.mdi-coffee-maker-check::before {
  content: "\\f1931";
}

.mdi-coffee-maker-check-outline::before {
  content: "\\f1932";
}

.mdi-coffee-maker-outline::before {
  content: "\\f181b";
}

.mdi-coffee-off::before {
  content: "\\f0faa";
}

.mdi-coffee-off-outline::before {
  content: "\\f0fab";
}

.mdi-coffee-outline::before {
  content: "\\f06ca";
}

.mdi-coffee-to-go::before {
  content: "\\f0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\f130e";
}

.mdi-coffin::before {
  content: "\\f0b7f";
}

.mdi-cog::before {
  content: "\\f0493";
}

.mdi-cog-box::before {
  content: "\\f0494";
}

.mdi-cog-clockwise::before {
  content: "\\f11dd";
}

.mdi-cog-counterclockwise::before {
  content: "\\f11de";
}

.mdi-cog-off::before {
  content: "\\f13ce";
}

.mdi-cog-off-outline::before {
  content: "\\f13cf";
}

.mdi-cog-outline::before {
  content: "\\f08bb";
}

.mdi-cog-pause::before {
  content: "\\f1933";
}

.mdi-cog-pause-outline::before {
  content: "\\f1934";
}

.mdi-cog-play::before {
  content: "\\f1935";
}

.mdi-cog-play-outline::before {
  content: "\\f1936";
}

.mdi-cog-refresh::before {
  content: "\\f145e";
}

.mdi-cog-refresh-outline::before {
  content: "\\f145f";
}

.mdi-cog-stop::before {
  content: "\\f1937";
}

.mdi-cog-stop-outline::before {
  content: "\\f1938";
}

.mdi-cog-sync::before {
  content: "\\f1460";
}

.mdi-cog-sync-outline::before {
  content: "\\f1461";
}

.mdi-cog-transfer::before {
  content: "\\f105b";
}

.mdi-cog-transfer-outline::before {
  content: "\\f105c";
}

.mdi-cogs::before {
  content: "\\f08d6";
}

.mdi-collage::before {
  content: "\\f0640";
}

.mdi-collapse-all::before {
  content: "\\f0aa6";
}

.mdi-collapse-all-outline::before {
  content: "\\f0aa7";
}

.mdi-color-helper::before {
  content: "\\f0179";
}

.mdi-comma::before {
  content: "\\f0e23";
}

.mdi-comma-box::before {
  content: "\\f0e2b";
}

.mdi-comma-box-outline::before {
  content: "\\f0e24";
}

.mdi-comma-circle::before {
  content: "\\f0e25";
}

.mdi-comma-circle-outline::before {
  content: "\\f0e26";
}

.mdi-comment::before {
  content: "\\f017a";
}

.mdi-comment-account::before {
  content: "\\f017b";
}

.mdi-comment-account-outline::before {
  content: "\\f017c";
}

.mdi-comment-alert::before {
  content: "\\f017d";
}

.mdi-comment-alert-outline::before {
  content: "\\f017e";
}

.mdi-comment-arrow-left::before {
  content: "\\f09e1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\f09e2";
}

.mdi-comment-arrow-right::before {
  content: "\\f09e3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\f09e4";
}

.mdi-comment-bookmark::before {
  content: "\\f15ae";
}

.mdi-comment-bookmark-outline::before {
  content: "\\f15af";
}

.mdi-comment-check::before {
  content: "\\f017f";
}

.mdi-comment-check-outline::before {
  content: "\\f0180";
}

.mdi-comment-edit::before {
  content: "\\f11bf";
}

.mdi-comment-edit-outline::before {
  content: "\\f12c4";
}

.mdi-comment-eye::before {
  content: "\\f0a3a";
}

.mdi-comment-eye-outline::before {
  content: "\\f0a3b";
}

.mdi-comment-flash::before {
  content: "\\f15b0";
}

.mdi-comment-flash-outline::before {
  content: "\\f15b1";
}

.mdi-comment-minus::before {
  content: "\\f15df";
}

.mdi-comment-minus-outline::before {
  content: "\\f15e0";
}

.mdi-comment-multiple::before {
  content: "\\f085f";
}

.mdi-comment-multiple-outline::before {
  content: "\\f0181";
}

.mdi-comment-off::before {
  content: "\\f15e1";
}

.mdi-comment-off-outline::before {
  content: "\\f15e2";
}

.mdi-comment-outline::before {
  content: "\\f0182";
}

.mdi-comment-plus::before {
  content: "\\f09e5";
}

.mdi-comment-plus-outline::before {
  content: "\\f0183";
}

.mdi-comment-processing::before {
  content: "\\f0184";
}

.mdi-comment-processing-outline::before {
  content: "\\f0185";
}

.mdi-comment-question::before {
  content: "\\f0817";
}

.mdi-comment-question-outline::before {
  content: "\\f0186";
}

.mdi-comment-quote::before {
  content: "\\f1021";
}

.mdi-comment-quote-outline::before {
  content: "\\f1022";
}

.mdi-comment-remove::before {
  content: "\\f05de";
}

.mdi-comment-remove-outline::before {
  content: "\\f0187";
}

.mdi-comment-search::before {
  content: "\\f0a3c";
}

.mdi-comment-search-outline::before {
  content: "\\f0a3d";
}

.mdi-comment-text::before {
  content: "\\f0188";
}

.mdi-comment-text-multiple::before {
  content: "\\f0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\f0861";
}

.mdi-comment-text-outline::before {
  content: "\\f0189";
}

.mdi-compare::before {
  content: "\\f018a";
}

.mdi-compare-horizontal::before {
  content: "\\f1492";
}

.mdi-compare-remove::before {
  content: "\\f18b3";
}

.mdi-compare-vertical::before {
  content: "\\f1493";
}

.mdi-compass::before {
  content: "\\f018b";
}

.mdi-compass-off::before {
  content: "\\f0b80";
}

.mdi-compass-off-outline::before {
  content: "\\f0b81";
}

.mdi-compass-outline::before {
  content: "\\f018c";
}

.mdi-compass-rose::before {
  content: "\\f1382";
}

.mdi-cone::before {
  content: "\\f194c";
}

.mdi-cone-off::before {
  content: "\\f194d";
}

.mdi-connection::before {
  content: "\\f1616";
}

.mdi-console::before {
  content: "\\f018d";
}

.mdi-console-line::before {
  content: "\\f07b7";
}

.mdi-console-network::before {
  content: "\\f08a9";
}

.mdi-console-network-outline::before {
  content: "\\f0c60";
}

.mdi-consolidate::before {
  content: "\\f10d8";
}

.mdi-contactless-payment::before {
  content: "\\f0d6a";
}

.mdi-contactless-payment-circle::before {
  content: "\\f0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\f0408";
}

.mdi-contacts::before {
  content: "\\f06cb";
}

.mdi-contacts-outline::before {
  content: "\\f05b8";
}

.mdi-contain::before {
  content: "\\f0a3e";
}

.mdi-contain-end::before {
  content: "\\f0a3f";
}

.mdi-contain-start::before {
  content: "\\f0a40";
}

.mdi-content-copy::before {
  content: "\\f018f";
}

.mdi-content-cut::before {
  content: "\\f0190";
}

.mdi-content-duplicate::before {
  content: "\\f0191";
}

.mdi-content-paste::before {
  content: "\\f0192";
}

.mdi-content-save::before {
  content: "\\f0193";
}

.mdi-content-save-alert::before {
  content: "\\f0f42";
}

.mdi-content-save-alert-outline::before {
  content: "\\f0f43";
}

.mdi-content-save-all::before {
  content: "\\f0194";
}

.mdi-content-save-all-outline::before {
  content: "\\f0f44";
}

.mdi-content-save-check::before {
  content: "\\f18ea";
}

.mdi-content-save-check-outline::before {
  content: "\\f18eb";
}

.mdi-content-save-cog::before {
  content: "\\f145b";
}

.mdi-content-save-cog-outline::before {
  content: "\\f145c";
}

.mdi-content-save-edit::before {
  content: "\\f0cfb";
}

.mdi-content-save-edit-outline::before {
  content: "\\f0cfc";
}

.mdi-content-save-move::before {
  content: "\\f0e27";
}

.mdi-content-save-move-outline::before {
  content: "\\f0e28";
}

.mdi-content-save-off::before {
  content: "\\f1643";
}

.mdi-content-save-off-outline::before {
  content: "\\f1644";
}

.mdi-content-save-outline::before {
  content: "\\f0818";
}

.mdi-content-save-settings::before {
  content: "\\f061b";
}

.mdi-content-save-settings-outline::before {
  content: "\\f0b2e";
}

.mdi-contrast::before {
  content: "\\f0195";
}

.mdi-contrast-box::before {
  content: "\\f0196";
}

.mdi-contrast-circle::before {
  content: "\\f0197";
}

.mdi-controller-classic::before {
  content: "\\f0b82";
}

.mdi-controller-classic-outline::before {
  content: "\\f0b83";
}

.mdi-cookie::before {
  content: "\\f0198";
}

.mdi-cookie-alert::before {
  content: "\\f16d0";
}

.mdi-cookie-alert-outline::before {
  content: "\\f16d1";
}

.mdi-cookie-check::before {
  content: "\\f16d2";
}

.mdi-cookie-check-outline::before {
  content: "\\f16d3";
}

.mdi-cookie-clock::before {
  content: "\\f16e4";
}

.mdi-cookie-clock-outline::before {
  content: "\\f16e5";
}

.mdi-cookie-cog::before {
  content: "\\f16d4";
}

.mdi-cookie-cog-outline::before {
  content: "\\f16d5";
}

.mdi-cookie-edit::before {
  content: "\\f16e6";
}

.mdi-cookie-edit-outline::before {
  content: "\\f16e7";
}

.mdi-cookie-lock::before {
  content: "\\f16e8";
}

.mdi-cookie-lock-outline::before {
  content: "\\f16e9";
}

.mdi-cookie-minus::before {
  content: "\\f16da";
}

.mdi-cookie-minus-outline::before {
  content: "\\f16db";
}

.mdi-cookie-off::before {
  content: "\\f16ea";
}

.mdi-cookie-off-outline::before {
  content: "\\f16eb";
}

.mdi-cookie-outline::before {
  content: "\\f16de";
}

.mdi-cookie-plus::before {
  content: "\\f16d6";
}

.mdi-cookie-plus-outline::before {
  content: "\\f16d7";
}

.mdi-cookie-refresh::before {
  content: "\\f16ec";
}

.mdi-cookie-refresh-outline::before {
  content: "\\f16ed";
}

.mdi-cookie-remove::before {
  content: "\\f16d8";
}

.mdi-cookie-remove-outline::before {
  content: "\\f16d9";
}

.mdi-cookie-settings::before {
  content: "\\f16dc";
}

.mdi-cookie-settings-outline::before {
  content: "\\f16dd";
}

.mdi-coolant-temperature::before {
  content: "\\f03c8";
}

.mdi-copyleft::before {
  content: "\\f1939";
}

.mdi-copyright::before {
  content: "\\f05e6";
}

.mdi-cordova::before {
  content: "\\f0958";
}

.mdi-corn::before {
  content: "\\f07b8";
}

.mdi-corn-off::before {
  content: "\\f13ef";
}

.mdi-cosine-wave::before {
  content: "\\f1479";
}

.mdi-counter::before {
  content: "\\f0199";
}

.mdi-countertop::before {
  content: "\\f181c";
}

.mdi-countertop-outline::before {
  content: "\\f181d";
}

.mdi-cow::before {
  content: "\\f019a";
}

.mdi-cow-off::before {
  content: "\\f18fc";
}

.mdi-cpu-32-bit::before {
  content: "\\f0edf";
}

.mdi-cpu-64-bit::before {
  content: "\\f0ee0";
}

.mdi-cradle::before {
  content: "\\f198b";
}

.mdi-cradle-outline::before {
  content: "\\f1991";
}

.mdi-crane::before {
  content: "\\f0862";
}

.mdi-creation::before {
  content: "\\f0674";
}

.mdi-creative-commons::before {
  content: "\\f0d6b";
}

.mdi-credit-card::before {
  content: "\\f0fef";
}

.mdi-credit-card-check::before {
  content: "\\f13d0";
}

.mdi-credit-card-check-outline::before {
  content: "\\f13d1";
}

.mdi-credit-card-chip::before {
  content: "\\f190f";
}

.mdi-credit-card-chip-outline::before {
  content: "\\f1910";
}

.mdi-credit-card-clock::before {
  content: "\\f0ee1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\f0ee2";
}

.mdi-credit-card-edit::before {
  content: "\\f17d7";
}

.mdi-credit-card-edit-outline::before {
  content: "\\f17d8";
}

.mdi-credit-card-fast::before {
  content: "\\f1911";
}

.mdi-credit-card-fast-outline::before {
  content: "\\f1912";
}

.mdi-credit-card-lock::before {
  content: "\\f18e7";
}

.mdi-credit-card-lock-outline::before {
  content: "\\f18e8";
}

.mdi-credit-card-marker::before {
  content: "\\f06a8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\f0dbe";
}

.mdi-credit-card-minus::before {
  content: "\\f0fac";
}

.mdi-credit-card-minus-outline::before {
  content: "\\f0fad";
}

.mdi-credit-card-multiple::before {
  content: "\\f0ff0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\f019c";
}

.mdi-credit-card-off::before {
  content: "\\f0ff1";
}

.mdi-credit-card-off-outline::before {
  content: "\\f05e4";
}

.mdi-credit-card-outline::before {
  content: "\\f019b";
}

.mdi-credit-card-plus::before {
  content: "\\f0ff2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\f0676";
}

.mdi-credit-card-refresh::before {
  content: "\\f1645";
}

.mdi-credit-card-refresh-outline::before {
  content: "\\f1646";
}

.mdi-credit-card-refund::before {
  content: "\\f0ff3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\f0aa8";
}

.mdi-credit-card-remove::before {
  content: "\\f0fae";
}

.mdi-credit-card-remove-outline::before {
  content: "\\f0faf";
}

.mdi-credit-card-scan::before {
  content: "\\f0ff4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\f019d";
}

.mdi-credit-card-search::before {
  content: "\\f1647";
}

.mdi-credit-card-search-outline::before {
  content: "\\f1648";
}

.mdi-credit-card-settings::before {
  content: "\\f0ff5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\f08d7";
}

.mdi-credit-card-sync::before {
  content: "\\f1649";
}

.mdi-credit-card-sync-outline::before {
  content: "\\f164a";
}

.mdi-credit-card-wireless::before {
  content: "\\f0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\f057a";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\f057b";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\f0d6c";
}

.mdi-cricket::before {
  content: "\\f0d6d";
}

.mdi-crop::before {
  content: "\\f019e";
}

.mdi-crop-free::before {
  content: "\\f019f";
}

.mdi-crop-landscape::before {
  content: "\\f01a0";
}

.mdi-crop-portrait::before {
  content: "\\f01a1";
}

.mdi-crop-rotate::before {
  content: "\\f0696";
}

.mdi-crop-square::before {
  content: "\\f01a2";
}

.mdi-cross::before {
  content: "\\f0953";
}

.mdi-cross-bolnisi::before {
  content: "\\f0ced";
}

.mdi-cross-celtic::before {
  content: "\\f0cf5";
}

.mdi-cross-outline::before {
  content: "\\f0cf6";
}

.mdi-crosshairs::before {
  content: "\\f01a3";
}

.mdi-crosshairs-gps::before {
  content: "\\f01a4";
}

.mdi-crosshairs-off::before {
  content: "\\f0f45";
}

.mdi-crosshairs-question::before {
  content: "\\f1136";
}

.mdi-crowd::before {
  content: "\\f1975";
}

.mdi-crown::before {
  content: "\\f01a5";
}

.mdi-crown-circle::before {
  content: "\\f17dc";
}

.mdi-crown-circle-outline::before {
  content: "\\f17dd";
}

.mdi-crown-outline::before {
  content: "\\f11d0";
}

.mdi-cryengine::before {
  content: "\\f0959";
}

.mdi-crystal-ball::before {
  content: "\\f0b2f";
}

.mdi-cube::before {
  content: "\\f01a6";
}

.mdi-cube-off::before {
  content: "\\f141c";
}

.mdi-cube-off-outline::before {
  content: "\\f141d";
}

.mdi-cube-outline::before {
  content: "\\f01a7";
}

.mdi-cube-scan::before {
  content: "\\f0b84";
}

.mdi-cube-send::before {
  content: "\\f01a8";
}

.mdi-cube-unfolded::before {
  content: "\\f01a9";
}

.mdi-cup::before {
  content: "\\f01aa";
}

.mdi-cup-off::before {
  content: "\\f05e5";
}

.mdi-cup-off-outline::before {
  content: "\\f137d";
}

.mdi-cup-outline::before {
  content: "\\f130f";
}

.mdi-cup-water::before {
  content: "\\f01ab";
}

.mdi-cupboard::before {
  content: "\\f0f46";
}

.mdi-cupboard-outline::before {
  content: "\\f0f47";
}

.mdi-cupcake::before {
  content: "\\f095a";
}

.mdi-curling::before {
  content: "\\f0863";
}

.mdi-currency-bdt::before {
  content: "\\f0864";
}

.mdi-currency-brl::before {
  content: "\\f0b85";
}

.mdi-currency-btc::before {
  content: "\\f01ac";
}

.mdi-currency-cny::before {
  content: "\\f07ba";
}

.mdi-currency-eth::before {
  content: "\\f07bb";
}

.mdi-currency-eur::before {
  content: "\\f01ad";
}

.mdi-currency-eur-off::before {
  content: "\\f1315";
}

.mdi-currency-gbp::before {
  content: "\\f01ae";
}

.mdi-currency-ils::before {
  content: "\\f0c61";
}

.mdi-currency-inr::before {
  content: "\\f01af";
}

.mdi-currency-jpy::before {
  content: "\\f07bc";
}

.mdi-currency-krw::before {
  content: "\\f07bd";
}

.mdi-currency-kzt::before {
  content: "\\f0865";
}

.mdi-currency-mnt::before {
  content: "\\f1512";
}

.mdi-currency-ngn::before {
  content: "\\f01b0";
}

.mdi-currency-php::before {
  content: "\\f09e6";
}

.mdi-currency-rial::before {
  content: "\\f0e9c";
}

.mdi-currency-rub::before {
  content: "\\f01b1";
}

.mdi-currency-rupee::before {
  content: "\\f1976";
}

.mdi-currency-sign::before {
  content: "\\f07be";
}

.mdi-currency-try::before {
  content: "\\f01b2";
}

.mdi-currency-twd::before {
  content: "\\f07bf";
}

.mdi-currency-usd::before {
  content: "\\f01c1";
}

.mdi-currency-usd-off::before {
  content: "\\f067a";
}

.mdi-current-ac::before {
  content: "\\f1480";
}

.mdi-current-dc::before {
  content: "\\f095c";
}

.mdi-cursor-default::before {
  content: "\\f01c0";
}

.mdi-cursor-default-click::before {
  content: "\\f0cfd";
}

.mdi-cursor-default-click-outline::before {
  content: "\\f0cfe";
}

.mdi-cursor-default-gesture::before {
  content: "\\f1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\f1128";
}

.mdi-cursor-default-outline::before {
  content: "\\f01bf";
}

.mdi-cursor-move::before {
  content: "\\f01be";
}

.mdi-cursor-pointer::before {
  content: "\\f01bd";
}

.mdi-cursor-text::before {
  content: "\\f05e7";
}

.mdi-curtains::before {
  content: "\\f1846";
}

.mdi-curtains-closed::before {
  content: "\\f1847";
}

.mdi-cylinder::before {
  content: "\\f194e";
}

.mdi-cylinder-off::before {
  content: "\\f194f";
}

.mdi-dance-ballroom::before {
  content: "\\f15fb";
}

.mdi-dance-pole::before {
  content: "\\f1578";
}

.mdi-data-matrix::before {
  content: "\\f153c";
}

.mdi-data-matrix-edit::before {
  content: "\\f153d";
}

.mdi-data-matrix-minus::before {
  content: "\\f153e";
}

.mdi-data-matrix-plus::before {
  content: "\\f153f";
}

.mdi-data-matrix-remove::before {
  content: "\\f1540";
}

.mdi-data-matrix-scan::before {
  content: "\\f1541";
}

.mdi-database::before {
  content: "\\f01bc";
}

.mdi-database-alert::before {
  content: "\\f163a";
}

.mdi-database-alert-outline::before {
  content: "\\f1624";
}

.mdi-database-arrow-down::before {
  content: "\\f163b";
}

.mdi-database-arrow-down-outline::before {
  content: "\\f1625";
}

.mdi-database-arrow-left::before {
  content: "\\f163c";
}

.mdi-database-arrow-left-outline::before {
  content: "\\f1626";
}

.mdi-database-arrow-right::before {
  content: "\\f163d";
}

.mdi-database-arrow-right-outline::before {
  content: "\\f1627";
}

.mdi-database-arrow-up::before {
  content: "\\f163e";
}

.mdi-database-arrow-up-outline::before {
  content: "\\f1628";
}

.mdi-database-check::before {
  content: "\\f0aa9";
}

.mdi-database-check-outline::before {
  content: "\\f1629";
}

.mdi-database-clock::before {
  content: "\\f163f";
}

.mdi-database-clock-outline::before {
  content: "\\f162a";
}

.mdi-database-cog::before {
  content: "\\f164b";
}

.mdi-database-cog-outline::before {
  content: "\\f164c";
}

.mdi-database-edit::before {
  content: "\\f0b86";
}

.mdi-database-edit-outline::before {
  content: "\\f162b";
}

.mdi-database-export::before {
  content: "\\f095e";
}

.mdi-database-export-outline::before {
  content: "\\f162c";
}

.mdi-database-eye::before {
  content: "\\f191f";
}

.mdi-database-eye-off::before {
  content: "\\f1920";
}

.mdi-database-eye-off-outline::before {
  content: "\\f1921";
}

.mdi-database-eye-outline::before {
  content: "\\f1922";
}

.mdi-database-import::before {
  content: "\\f095d";
}

.mdi-database-import-outline::before {
  content: "\\f162d";
}

.mdi-database-lock::before {
  content: "\\f0aaa";
}

.mdi-database-lock-outline::before {
  content: "\\f162e";
}

.mdi-database-marker::before {
  content: "\\f12f6";
}

.mdi-database-marker-outline::before {
  content: "\\f162f";
}

.mdi-database-minus::before {
  content: "\\f01bb";
}

.mdi-database-minus-outline::before {
  content: "\\f1630";
}

.mdi-database-off::before {
  content: "\\f1640";
}

.mdi-database-off-outline::before {
  content: "\\f1631";
}

.mdi-database-outline::before {
  content: "\\f1632";
}

.mdi-database-plus::before {
  content: "\\f01ba";
}

.mdi-database-plus-outline::before {
  content: "\\f1633";
}

.mdi-database-refresh::before {
  content: "\\f05c2";
}

.mdi-database-refresh-outline::before {
  content: "\\f1634";
}

.mdi-database-remove::before {
  content: "\\f0d00";
}

.mdi-database-remove-outline::before {
  content: "\\f1635";
}

.mdi-database-search::before {
  content: "\\f0866";
}

.mdi-database-search-outline::before {
  content: "\\f1636";
}

.mdi-database-settings::before {
  content: "\\f0d01";
}

.mdi-database-settings-outline::before {
  content: "\\f1637";
}

.mdi-database-sync::before {
  content: "\\f0cff";
}

.mdi-database-sync-outline::before {
  content: "\\f1638";
}

.mdi-death-star::before {
  content: "\\f08d8";
}

.mdi-death-star-variant::before {
  content: "\\f08d9";
}

.mdi-deathly-hallows::before {
  content: "\\f0b87";
}

.mdi-debian::before {
  content: "\\f08da";
}

.mdi-debug-step-into::before {
  content: "\\f01b9";
}

.mdi-debug-step-out::before {
  content: "\\f01b8";
}

.mdi-debug-step-over::before {
  content: "\\f01b7";
}

.mdi-decagram::before {
  content: "\\f076c";
}

.mdi-decagram-outline::before {
  content: "\\f076d";
}

.mdi-decimal::before {
  content: "\\f10a1";
}

.mdi-decimal-comma::before {
  content: "\\f10a2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\f10a3";
}

.mdi-decimal-comma-increase::before {
  content: "\\f10a4";
}

.mdi-decimal-decrease::before {
  content: "\\f01b6";
}

.mdi-decimal-increase::before {
  content: "\\f01b5";
}

.mdi-delete::before {
  content: "\\f01b4";
}

.mdi-delete-alert::before {
  content: "\\f10a5";
}

.mdi-delete-alert-outline::before {
  content: "\\f10a6";
}

.mdi-delete-circle::before {
  content: "\\f0683";
}

.mdi-delete-circle-outline::before {
  content: "\\f0b88";
}

.mdi-delete-clock::before {
  content: "\\f1556";
}

.mdi-delete-clock-outline::before {
  content: "\\f1557";
}

.mdi-delete-empty::before {
  content: "\\f06cc";
}

.mdi-delete-empty-outline::before {
  content: "\\f0e9d";
}

.mdi-delete-forever::before {
  content: "\\f05e8";
}

.mdi-delete-forever-outline::before {
  content: "\\f0b89";
}

.mdi-delete-off::before {
  content: "\\f10a7";
}

.mdi-delete-off-outline::before {
  content: "\\f10a8";
}

.mdi-delete-outline::before {
  content: "\\f09e7";
}

.mdi-delete-restore::before {
  content: "\\f0819";
}

.mdi-delete-sweep::before {
  content: "\\f05e9";
}

.mdi-delete-sweep-outline::before {
  content: "\\f0c62";
}

.mdi-delete-variant::before {
  content: "\\f01b3";
}

.mdi-delta::before {
  content: "\\f01c2";
}

.mdi-desk::before {
  content: "\\f1239";
}

.mdi-desk-lamp::before {
  content: "\\f095f";
}

.mdi-deskphone::before {
  content: "\\f01c3";
}

.mdi-desktop-classic::before {
  content: "\\f07c0";
}

.mdi-desktop-mac::before {
  content: "\\f01c4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\f09e8";
}

.mdi-desktop-tower::before {
  content: "\\f01c5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\f0aab";
}

.mdi-details::before {
  content: "\\f01c6";
}

.mdi-dev-to::before {
  content: "\\f0d6e";
}

.mdi-developer-board::before {
  content: "\\f0697";
}

.mdi-deviantart::before {
  content: "\\f01c7";
}

.mdi-devices::before {
  content: "\\f0fb0";
}

.mdi-dharmachakra::before {
  content: "\\f094b";
}

.mdi-diabetes::before {
  content: "\\f1126";
}

.mdi-dialpad::before {
  content: "\\f061c";
}

.mdi-diameter::before {
  content: "\\f0c63";
}

.mdi-diameter-outline::before {
  content: "\\f0c64";
}

.mdi-diameter-variant::before {
  content: "\\f0c65";
}

.mdi-diamond::before {
  content: "\\f0b8a";
}

.mdi-diamond-outline::before {
  content: "\\f0b8b";
}

.mdi-diamond-stone::before {
  content: "\\f01c8";
}

.mdi-dice-1::before {
  content: "\\f01ca";
}

.mdi-dice-1-outline::before {
  content: "\\f114a";
}

.mdi-dice-2::before {
  content: "\\f01cb";
}

.mdi-dice-2-outline::before {
  content: "\\f114b";
}

.mdi-dice-3::before {
  content: "\\f01cc";
}

.mdi-dice-3-outline::before {
  content: "\\f114c";
}

.mdi-dice-4::before {
  content: "\\f01cd";
}

.mdi-dice-4-outline::before {
  content: "\\f114d";
}

.mdi-dice-5::before {
  content: "\\f01ce";
}

.mdi-dice-5-outline::before {
  content: "\\f114e";
}

.mdi-dice-6::before {
  content: "\\f01cf";
}

.mdi-dice-6-outline::before {
  content: "\\f114f";
}

.mdi-dice-d10::before {
  content: "\\f1153";
}

.mdi-dice-d10-outline::before {
  content: "\\f076f";
}

.mdi-dice-d12::before {
  content: "\\f1154";
}

.mdi-dice-d12-outline::before {
  content: "\\f0867";
}

.mdi-dice-d20::before {
  content: "\\f1155";
}

.mdi-dice-d20-outline::before {
  content: "\\f05ea";
}

.mdi-dice-d4::before {
  content: "\\f1150";
}

.mdi-dice-d4-outline::before {
  content: "\\f05eb";
}

.mdi-dice-d6::before {
  content: "\\f1151";
}

.mdi-dice-d6-outline::before {
  content: "\\f05ed";
}

.mdi-dice-d8::before {
  content: "\\f1152";
}

.mdi-dice-d8-outline::before {
  content: "\\f05ec";
}

.mdi-dice-multiple::before {
  content: "\\f076e";
}

.mdi-dice-multiple-outline::before {
  content: "\\f1156";
}

.mdi-digital-ocean::before {
  content: "\\f1237";
}

.mdi-dip-switch::before {
  content: "\\f07c1";
}

.mdi-directions::before {
  content: "\\f01d0";
}

.mdi-directions-fork::before {
  content: "\\f0641";
}

.mdi-disc::before {
  content: "\\f05ee";
}

.mdi-disc-alert::before {
  content: "\\f01d1";
}

.mdi-disc-player::before {
  content: "\\f0960";
}

.mdi-discord::before {
  content: "\\f066f";
}

.mdi-dishwasher::before {
  content: "\\f0aac";
}

.mdi-dishwasher-alert::before {
  content: "\\f11b8";
}

.mdi-dishwasher-off::before {
  content: "\\f11b9";
}

.mdi-disqus::before {
  content: "\\f01d2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\f11c9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\f11c8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\f11ca";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\f11cb";
}

.mdi-distribute-vertical-center::before {
  content: "\\f11cc";
}

.mdi-distribute-vertical-top::before {
  content: "\\f11cd";
}

.mdi-diversify::before {
  content: "\\f1877";
}

.mdi-diving::before {
  content: "\\f1977";
}

.mdi-diving-flippers::before {
  content: "\\f0dbf";
}

.mdi-diving-helmet::before {
  content: "\\f0dc0";
}

.mdi-diving-scuba::before {
  content: "\\f0dc1";
}

.mdi-diving-scuba-flag::before {
  content: "\\f0dc2";
}

.mdi-diving-scuba-tank::before {
  content: "\\f0dc3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\f0dc4";
}

.mdi-diving-snorkel::before {
  content: "\\f0dc5";
}

.mdi-division::before {
  content: "\\f01d4";
}

.mdi-division-box::before {
  content: "\\f01d5";
}

.mdi-dlna::before {
  content: "\\f0a41";
}

.mdi-dna::before {
  content: "\\f0684";
}

.mdi-dns::before {
  content: "\\f01d6";
}

.mdi-dns-outline::before {
  content: "\\f0b8c";
}

.mdi-dock-bottom::before {
  content: "\\f10a9";
}

.mdi-dock-left::before {
  content: "\\f10aa";
}

.mdi-dock-right::before {
  content: "\\f10ab";
}

.mdi-dock-top::before {
  content: "\\f1513";
}

.mdi-dock-window::before {
  content: "\\f10ac";
}

.mdi-docker::before {
  content: "\\f0868";
}

.mdi-doctor::before {
  content: "\\f0a42";
}

.mdi-dog::before {
  content: "\\f0a43";
}

.mdi-dog-service::before {
  content: "\\f0aad";
}

.mdi-dog-side::before {
  content: "\\f0a44";
}

.mdi-dog-side-off::before {
  content: "\\f16ee";
}

.mdi-dolby::before {
  content: "\\f06b3";
}

.mdi-dolly::before {
  content: "\\f0e9e";
}

.mdi-dolphin::before {
  content: "\\f18b4";
}

.mdi-domain::before {
  content: "\\f01d7";
}

.mdi-domain-off::before {
  content: "\\f0d6f";
}

.mdi-domain-plus::before {
  content: "\\f10ad";
}

.mdi-domain-remove::before {
  content: "\\f10ae";
}

.mdi-dome-light::before {
  content: "\\f141e";
}

.mdi-domino-mask::before {
  content: "\\f1023";
}

.mdi-donkey::before {
  content: "\\f07c2";
}

.mdi-door::before {
  content: "\\f081a";
}

.mdi-door-closed::before {
  content: "\\f081b";
}

.mdi-door-closed-lock::before {
  content: "\\f10af";
}

.mdi-door-open::before {
  content: "\\f081c";
}

.mdi-door-sliding::before {
  content: "\\f181e";
}

.mdi-door-sliding-lock::before {
  content: "\\f181f";
}

.mdi-door-sliding-open::before {
  content: "\\f1820";
}

.mdi-doorbell::before {
  content: "\\f12e6";
}

.mdi-doorbell-video::before {
  content: "\\f0869";
}

.mdi-dot-net::before {
  content: "\\f0aae";
}

.mdi-dots-circle::before {
  content: "\\f1978";
}

.mdi-dots-grid::before {
  content: "\\f15fc";
}

.mdi-dots-hexagon::before {
  content: "\\f15ff";
}

.mdi-dots-horizontal::before {
  content: "\\f01d8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\f07c3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\f0b8d";
}

.mdi-dots-square::before {
  content: "\\f15fd";
}

.mdi-dots-triangle::before {
  content: "\\f15fe";
}

.mdi-dots-vertical::before {
  content: "\\f01d9";
}

.mdi-dots-vertical-circle::before {
  content: "\\f07c4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\f0b8e";
}

.mdi-download::before {
  content: "\\f01da";
}

.mdi-download-box::before {
  content: "\\f1462";
}

.mdi-download-box-outline::before {
  content: "\\f1463";
}

.mdi-download-circle::before {
  content: "\\f1464";
}

.mdi-download-circle-outline::before {
  content: "\\f1465";
}

.mdi-download-lock::before {
  content: "\\f1320";
}

.mdi-download-lock-outline::before {
  content: "\\f1321";
}

.mdi-download-multiple::before {
  content: "\\f09e9";
}

.mdi-download-network::before {
  content: "\\f06f4";
}

.mdi-download-network-outline::before {
  content: "\\f0c66";
}

.mdi-download-off::before {
  content: "\\f10b0";
}

.mdi-download-off-outline::before {
  content: "\\f10b1";
}

.mdi-download-outline::before {
  content: "\\f0b8f";
}

.mdi-drag::before {
  content: "\\f01db";
}

.mdi-drag-horizontal::before {
  content: "\\f01dc";
}

.mdi-drag-horizontal-variant::before {
  content: "\\f12f0";
}

.mdi-drag-variant::before {
  content: "\\f0b90";
}

.mdi-drag-vertical::before {
  content: "\\f01dd";
}

.mdi-drag-vertical-variant::before {
  content: "\\f12f1";
}

.mdi-drama-masks::before {
  content: "\\f0d02";
}

.mdi-draw::before {
  content: "\\f0f49";
}

.mdi-draw-pen::before {
  content: "\\f19b9";
}

.mdi-drawing::before {
  content: "\\f01de";
}

.mdi-drawing-box::before {
  content: "\\f01df";
}

.mdi-dresser::before {
  content: "\\f0f4a";
}

.mdi-dresser-outline::before {
  content: "\\f0f4b";
}

.mdi-drone::before {
  content: "\\f01e2";
}

.mdi-dropbox::before {
  content: "\\f01e3";
}

.mdi-drupal::before {
  content: "\\f01e4";
}

.mdi-duck::before {
  content: "\\f01e5";
}

.mdi-dumbbell::before {
  content: "\\f01e6";
}

.mdi-dump-truck::before {
  content: "\\f0c67";
}

.mdi-ear-hearing::before {
  content: "\\f07c5";
}

.mdi-ear-hearing-off::before {
  content: "\\f0a45";
}

.mdi-earbuds::before {
  content: "\\f184f";
}

.mdi-earbuds-off::before {
  content: "\\f1850";
}

.mdi-earbuds-off-outline::before {
  content: "\\f1851";
}

.mdi-earbuds-outline::before {
  content: "\\f1852";
}

.mdi-earth::before {
  content: "\\f01e7";
}

.mdi-earth-arrow-right::before {
  content: "\\f1311";
}

.mdi-earth-box::before {
  content: "\\f06cd";
}

.mdi-earth-box-minus::before {
  content: "\\f1407";
}

.mdi-earth-box-off::before {
  content: "\\f06ce";
}

.mdi-earth-box-plus::before {
  content: "\\f1406";
}

.mdi-earth-box-remove::before {
  content: "\\f1408";
}

.mdi-earth-minus::before {
  content: "\\f1404";
}

.mdi-earth-off::before {
  content: "\\f01e8";
}

.mdi-earth-plus::before {
  content: "\\f1403";
}

.mdi-earth-remove::before {
  content: "\\f1405";
}

.mdi-egg::before {
  content: "\\f0aaf";
}

.mdi-egg-easter::before {
  content: "\\f0ab0";
}

.mdi-egg-fried::before {
  content: "\\f184a";
}

.mdi-egg-off::before {
  content: "\\f13f0";
}

.mdi-egg-off-outline::before {
  content: "\\f13f1";
}

.mdi-egg-outline::before {
  content: "\\f13f2";
}

.mdi-eiffel-tower::before {
  content: "\\f156b";
}

.mdi-eight-track::before {
  content: "\\f09ea";
}

.mdi-eject::before {
  content: "\\f01ea";
}

.mdi-eject-outline::before {
  content: "\\f0b91";
}

.mdi-electric-switch::before {
  content: "\\f0e9f";
}

.mdi-electric-switch-closed::before {
  content: "\\f10d9";
}

.mdi-electron-framework::before {
  content: "\\f1024";
}

.mdi-elephant::before {
  content: "\\f07c6";
}

.mdi-elevation-decline::before {
  content: "\\f01eb";
}

.mdi-elevation-rise::before {
  content: "\\f01ec";
}

.mdi-elevator::before {
  content: "\\f01ed";
}

.mdi-elevator-down::before {
  content: "\\f12c2";
}

.mdi-elevator-passenger::before {
  content: "\\f1381";
}

.mdi-elevator-passenger-off::before {
  content: "\\f1979";
}

.mdi-elevator-passenger-off-outline::before {
  content: "\\f197a";
}

.mdi-elevator-passenger-outline::before {
  content: "\\f197b";
}

.mdi-elevator-up::before {
  content: "\\f12c1";
}

.mdi-ellipse::before {
  content: "\\f0ea0";
}

.mdi-ellipse-outline::before {
  content: "\\f0ea1";
}

.mdi-email::before {
  content: "\\f01ee";
}

.mdi-email-alert::before {
  content: "\\f06cf";
}

.mdi-email-alert-outline::before {
  content: "\\f0d42";
}

.mdi-email-box::before {
  content: "\\f0d03";
}

.mdi-email-check::before {
  content: "\\f0ab1";
}

.mdi-email-check-outline::before {
  content: "\\f0ab2";
}

.mdi-email-edit::before {
  content: "\\f0ee3";
}

.mdi-email-edit-outline::before {
  content: "\\f0ee4";
}

.mdi-email-fast::before {
  content: "\\f186f";
}

.mdi-email-fast-outline::before {
  content: "\\f1870";
}

.mdi-email-lock::before {
  content: "\\f01f1";
}

.mdi-email-mark-as-unread::before {
  content: "\\f0b92";
}

.mdi-email-minus::before {
  content: "\\f0ee5";
}

.mdi-email-minus-outline::before {
  content: "\\f0ee6";
}

.mdi-email-multiple::before {
  content: "\\f0ee7";
}

.mdi-email-multiple-outline::before {
  content: "\\f0ee8";
}

.mdi-email-newsletter::before {
  content: "\\f0fb1";
}

.mdi-email-off::before {
  content: "\\f13e3";
}

.mdi-email-off-outline::before {
  content: "\\f13e4";
}

.mdi-email-open::before {
  content: "\\f01ef";
}

.mdi-email-open-multiple::before {
  content: "\\f0ee9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\f0eea";
}

.mdi-email-open-outline::before {
  content: "\\f05ef";
}

.mdi-email-outline::before {
  content: "\\f01f0";
}

.mdi-email-plus::before {
  content: "\\f09eb";
}

.mdi-email-plus-outline::before {
  content: "\\f09ec";
}

.mdi-email-receive::before {
  content: "\\f10da";
}

.mdi-email-receive-outline::before {
  content: "\\f10db";
}

.mdi-email-remove::before {
  content: "\\f1661";
}

.mdi-email-remove-outline::before {
  content: "\\f1662";
}

.mdi-email-seal::before {
  content: "\\f195b";
}

.mdi-email-seal-outline::before {
  content: "\\f195c";
}

.mdi-email-search::before {
  content: "\\f0961";
}

.mdi-email-search-outline::before {
  content: "\\f0962";
}

.mdi-email-send::before {
  content: "\\f10dc";
}

.mdi-email-send-outline::before {
  content: "\\f10dd";
}

.mdi-email-sync::before {
  content: "\\f12c7";
}

.mdi-email-sync-outline::before {
  content: "\\f12c8";
}

.mdi-email-variant::before {
  content: "\\f05f0";
}

.mdi-ember::before {
  content: "\\f0b30";
}

.mdi-emby::before {
  content: "\\f06b4";
}

.mdi-emoticon::before {
  content: "\\f0c68";
}

.mdi-emoticon-angry::before {
  content: "\\f0c69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\f0c6a";
}

.mdi-emoticon-confused::before {
  content: "\\f10de";
}

.mdi-emoticon-confused-outline::before {
  content: "\\f10df";
}

.mdi-emoticon-cool::before {
  content: "\\f0c6b";
}

.mdi-emoticon-cool-outline::before {
  content: "\\f01f3";
}

.mdi-emoticon-cry::before {
  content: "\\f0c6c";
}

.mdi-emoticon-cry-outline::before {
  content: "\\f0c6d";
}

.mdi-emoticon-dead::before {
  content: "\\f0c6e";
}

.mdi-emoticon-dead-outline::before {
  content: "\\f069b";
}

.mdi-emoticon-devil::before {
  content: "\\f0c6f";
}

.mdi-emoticon-devil-outline::before {
  content: "\\f01f4";
}

.mdi-emoticon-excited::before {
  content: "\\f0c70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\f069c";
}

.mdi-emoticon-frown::before {
  content: "\\f0f4c";
}

.mdi-emoticon-frown-outline::before {
  content: "\\f0f4d";
}

.mdi-emoticon-happy::before {
  content: "\\f0c71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\f01f5";
}

.mdi-emoticon-kiss::before {
  content: "\\f0c72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\f0c73";
}

.mdi-emoticon-lol::before {
  content: "\\f1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\f1215";
}

.mdi-emoticon-neutral::before {
  content: "\\f0c74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\f01f6";
}

.mdi-emoticon-outline::before {
  content: "\\f01f2";
}

.mdi-emoticon-poop::before {
  content: "\\f01f7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\f0c75";
}

.mdi-emoticon-sad::before {
  content: "\\f0c76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\f01f8";
}

.mdi-emoticon-sick::before {
  content: "\\f157c";
}

.mdi-emoticon-sick-outline::before {
  content: "\\f157d";
}

.mdi-emoticon-tongue::before {
  content: "\\f01f9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\f0c77";
}

.mdi-emoticon-wink::before {
  content: "\\f0c78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\f0c79";
}

.mdi-engine::before {
  content: "\\f01fa";
}

.mdi-engine-off::before {
  content: "\\f0a46";
}

.mdi-engine-off-outline::before {
  content: "\\f0a47";
}

.mdi-engine-outline::before {
  content: "\\f01fb";
}

.mdi-epsilon::before {
  content: "\\f10e0";
}

.mdi-equal::before {
  content: "\\f01fc";
}

.mdi-equal-box::before {
  content: "\\f01fd";
}

.mdi-equalizer::before {
  content: "\\f0ea2";
}

.mdi-equalizer-outline::before {
  content: "\\f0ea3";
}

.mdi-eraser::before {
  content: "\\f01fe";
}

.mdi-eraser-variant::before {
  content: "\\f0642";
}

.mdi-escalator::before {
  content: "\\f01ff";
}

.mdi-escalator-box::before {
  content: "\\f1399";
}

.mdi-escalator-down::before {
  content: "\\f12c0";
}

.mdi-escalator-up::before {
  content: "\\f12bf";
}

.mdi-eslint::before {
  content: "\\f0c7a";
}

.mdi-et::before {
  content: "\\f0ab3";
}

.mdi-ethereum::before {
  content: "\\f086a";
}

.mdi-ethernet::before {
  content: "\\f0200";
}

.mdi-ethernet-cable::before {
  content: "\\f0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\f0202";
}

.mdi-ev-plug-ccs1::before {
  content: "\\f1519";
}

.mdi-ev-plug-ccs2::before {
  content: "\\f151a";
}

.mdi-ev-plug-chademo::before {
  content: "\\f151b";
}

.mdi-ev-plug-tesla::before {
  content: "\\f151c";
}

.mdi-ev-plug-type1::before {
  content: "\\f151d";
}

.mdi-ev-plug-type2::before {
  content: "\\f151e";
}

.mdi-ev-station::before {
  content: "\\f05f1";
}

.mdi-evernote::before {
  content: "\\f0204";
}

.mdi-excavator::before {
  content: "\\f1025";
}

.mdi-exclamation::before {
  content: "\\f0205";
}

.mdi-exclamation-thick::before {
  content: "\\f1238";
}

.mdi-exit-run::before {
  content: "\\f0a48";
}

.mdi-exit-to-app::before {
  content: "\\f0206";
}

.mdi-expand-all::before {
  content: "\\f0ab4";
}

.mdi-expand-all-outline::before {
  content: "\\f0ab5";
}

.mdi-expansion-card::before {
  content: "\\f08ae";
}

.mdi-expansion-card-variant::before {
  content: "\\f0fb2";
}

.mdi-exponent::before {
  content: "\\f0963";
}

.mdi-exponent-box::before {
  content: "\\f0964";
}

.mdi-export::before {
  content: "\\f0207";
}

.mdi-export-variant::before {
  content: "\\f0b93";
}

.mdi-eye::before {
  content: "\\f0208";
}

.mdi-eye-arrow-left::before {
  content: "\\f18fd";
}

.mdi-eye-arrow-left-outline::before {
  content: "\\f18fe";
}

.mdi-eye-arrow-right::before {
  content: "\\f18ff";
}

.mdi-eye-arrow-right-outline::before {
  content: "\\f1900";
}

.mdi-eye-check::before {
  content: "\\f0d04";
}

.mdi-eye-check-outline::before {
  content: "\\f0d05";
}

.mdi-eye-circle::before {
  content: "\\f0b94";
}

.mdi-eye-circle-outline::before {
  content: "\\f0b95";
}

.mdi-eye-minus::before {
  content: "\\f1026";
}

.mdi-eye-minus-outline::before {
  content: "\\f1027";
}

.mdi-eye-off::before {
  content: "\\f0209";
}

.mdi-eye-off-outline::before {
  content: "\\f06d1";
}

.mdi-eye-outline::before {
  content: "\\f06d0";
}

.mdi-eye-plus::before {
  content: "\\f086b";
}

.mdi-eye-plus-outline::before {
  content: "\\f086c";
}

.mdi-eye-refresh::before {
  content: "\\f197c";
}

.mdi-eye-refresh-outline::before {
  content: "\\f197d";
}

.mdi-eye-remove::before {
  content: "\\f15e3";
}

.mdi-eye-remove-outline::before {
  content: "\\f15e4";
}

.mdi-eye-settings::before {
  content: "\\f086d";
}

.mdi-eye-settings-outline::before {
  content: "\\f086e";
}

.mdi-eyedropper::before {
  content: "\\f020a";
}

.mdi-eyedropper-minus::before {
  content: "\\f13dd";
}

.mdi-eyedropper-off::before {
  content: "\\f13df";
}

.mdi-eyedropper-plus::before {
  content: "\\f13dc";
}

.mdi-eyedropper-remove::before {
  content: "\\f13de";
}

.mdi-eyedropper-variant::before {
  content: "\\f020b";
}

.mdi-face-agent::before {
  content: "\\f0d70";
}

.mdi-face-man::before {
  content: "\\f0643";
}

.mdi-face-man-outline::before {
  content: "\\f0b96";
}

.mdi-face-man-profile::before {
  content: "\\f0644";
}

.mdi-face-man-shimmer::before {
  content: "\\f15cc";
}

.mdi-face-man-shimmer-outline::before {
  content: "\\f15cd";
}

.mdi-face-mask::before {
  content: "\\f1586";
}

.mdi-face-mask-outline::before {
  content: "\\f1587";
}

.mdi-face-recognition::before {
  content: "\\f0c7b";
}

.mdi-face-woman::before {
  content: "\\f1077";
}

.mdi-face-woman-outline::before {
  content: "\\f1078";
}

.mdi-face-woman-profile::before {
  content: "\\f1076";
}

.mdi-face-woman-shimmer::before {
  content: "\\f15ce";
}

.mdi-face-woman-shimmer-outline::before {
  content: "\\f15cf";
}

.mdi-facebook::before {
  content: "\\f020c";
}

.mdi-facebook-gaming::before {
  content: "\\f07dd";
}

.mdi-facebook-messenger::before {
  content: "\\f020e";
}

.mdi-facebook-workplace::before {
  content: "\\f0b31";
}

.mdi-factory::before {
  content: "\\f020f";
}

.mdi-family-tree::before {
  content: "\\f160e";
}

.mdi-fan::before {
  content: "\\f0210";
}

.mdi-fan-alert::before {
  content: "\\f146c";
}

.mdi-fan-auto::before {
  content: "\\f171d";
}

.mdi-fan-chevron-down::before {
  content: "\\f146d";
}

.mdi-fan-chevron-up::before {
  content: "\\f146e";
}

.mdi-fan-minus::before {
  content: "\\f1470";
}

.mdi-fan-off::before {
  content: "\\f081d";
}

.mdi-fan-plus::before {
  content: "\\f146f";
}

.mdi-fan-remove::before {
  content: "\\f1471";
}

.mdi-fan-speed-1::before {
  content: "\\f1472";
}

.mdi-fan-speed-2::before {
  content: "\\f1473";
}

.mdi-fan-speed-3::before {
  content: "\\f1474";
}

.mdi-fast-forward::before {
  content: "\\f0211";
}

.mdi-fast-forward-10::before {
  content: "\\f0d71";
}

.mdi-fast-forward-15::before {
  content: "\\f193a";
}

.mdi-fast-forward-30::before {
  content: "\\f0d06";
}

.mdi-fast-forward-5::before {
  content: "\\f11f8";
}

.mdi-fast-forward-60::before {
  content: "\\f160b";
}

.mdi-fast-forward-outline::before {
  content: "\\f06d2";
}

.mdi-fax::before {
  content: "\\f0212";
}

.mdi-feather::before {
  content: "\\f06d3";
}

.mdi-feature-search::before {
  content: "\\f0a49";
}

.mdi-feature-search-outline::before {
  content: "\\f0a4a";
}

.mdi-fedora::before {
  content: "\\f08db";
}

.mdi-fence::before {
  content: "\\f179a";
}

.mdi-fence-electric::before {
  content: "\\f17f6";
}

.mdi-fencing::before {
  content: "\\f14c1";
}

.mdi-ferris-wheel::before {
  content: "\\f0ea4";
}

.mdi-ferry::before {
  content: "\\f0213";
}

.mdi-file::before {
  content: "\\f0214";
}

.mdi-file-account::before {
  content: "\\f073b";
}

.mdi-file-account-outline::before {
  content: "\\f1028";
}

.mdi-file-alert::before {
  content: "\\f0a4b";
}

.mdi-file-alert-outline::before {
  content: "\\f0a4c";
}

.mdi-file-cabinet::before {
  content: "\\f0ab6";
}

.mdi-file-cad::before {
  content: "\\f0eeb";
}

.mdi-file-cad-box::before {
  content: "\\f0eec";
}

.mdi-file-cancel::before {
  content: "\\f0dc6";
}

.mdi-file-cancel-outline::before {
  content: "\\f0dc7";
}

.mdi-file-certificate::before {
  content: "\\f1186";
}

.mdi-file-certificate-outline::before {
  content: "\\f1187";
}

.mdi-file-chart::before {
  content: "\\f0215";
}

.mdi-file-chart-outline::before {
  content: "\\f1029";
}

.mdi-file-check::before {
  content: "\\f0216";
}

.mdi-file-check-outline::before {
  content: "\\f0e29";
}

.mdi-file-clock::before {
  content: "\\f12e1";
}

.mdi-file-clock-outline::before {
  content: "\\f12e2";
}

.mdi-file-cloud::before {
  content: "\\f0217";
}

.mdi-file-cloud-outline::before {
  content: "\\f102a";
}

.mdi-file-code::before {
  content: "\\f022e";
}

.mdi-file-code-outline::before {
  content: "\\f102b";
}

.mdi-file-cog::before {
  content: "\\f107b";
}

.mdi-file-cog-outline::before {
  content: "\\f107c";
}

.mdi-file-compare::before {
  content: "\\f08aa";
}

.mdi-file-delimited::before {
  content: "\\f0218";
}

.mdi-file-delimited-outline::before {
  content: "\\f0ea5";
}

.mdi-file-document::before {
  content: "\\f0219";
}

.mdi-file-document-edit::before {
  content: "\\f0dc8";
}

.mdi-file-document-edit-outline::before {
  content: "\\f0dc9";
}

.mdi-file-document-multiple::before {
  content: "\\f1517";
}

.mdi-file-document-multiple-outline::before {
  content: "\\f1518";
}

.mdi-file-document-outline::before {
  content: "\\f09ee";
}

.mdi-file-download::before {
  content: "\\f0965";
}

.mdi-file-download-outline::before {
  content: "\\f0966";
}

.mdi-file-edit::before {
  content: "\\f11e7";
}

.mdi-file-edit-outline::before {
  content: "\\f11e8";
}

.mdi-file-excel::before {
  content: "\\f021b";
}

.mdi-file-excel-box::before {
  content: "\\f021c";
}

.mdi-file-excel-box-outline::before {
  content: "\\f102c";
}

.mdi-file-excel-outline::before {
  content: "\\f102d";
}

.mdi-file-export::before {
  content: "\\f021d";
}

.mdi-file-export-outline::before {
  content: "\\f102e";
}

.mdi-file-eye::before {
  content: "\\f0dca";
}

.mdi-file-eye-outline::before {
  content: "\\f0dcb";
}

.mdi-file-find::before {
  content: "\\f021e";
}

.mdi-file-find-outline::before {
  content: "\\f0b97";
}

.mdi-file-gif-box::before {
  content: "\\f0d78";
}

.mdi-file-hidden::before {
  content: "\\f0613";
}

.mdi-file-image::before {
  content: "\\f021f";
}

.mdi-file-image-marker::before {
  content: "\\f1772";
}

.mdi-file-image-marker-outline::before {
  content: "\\f1773";
}

.mdi-file-image-minus::before {
  content: "\\f193b";
}

.mdi-file-image-minus-outline::before {
  content: "\\f193c";
}

.mdi-file-image-outline::before {
  content: "\\f0eb0";
}

.mdi-file-image-plus::before {
  content: "\\f193d";
}

.mdi-file-image-plus-outline::before {
  content: "\\f193e";
}

.mdi-file-image-remove::before {
  content: "\\f193f";
}

.mdi-file-image-remove-outline::before {
  content: "\\f1940";
}

.mdi-file-import::before {
  content: "\\f0220";
}

.mdi-file-import-outline::before {
  content: "\\f102f";
}

.mdi-file-jpg-box::before {
  content: "\\f0225";
}

.mdi-file-key::before {
  content: "\\f1184";
}

.mdi-file-key-outline::before {
  content: "\\f1185";
}

.mdi-file-link::before {
  content: "\\f1177";
}

.mdi-file-link-outline::before {
  content: "\\f1178";
}

.mdi-file-lock::before {
  content: "\\f0221";
}

.mdi-file-lock-outline::before {
  content: "\\f1030";
}

.mdi-file-marker::before {
  content: "\\f1774";
}

.mdi-file-marker-outline::before {
  content: "\\f1775";
}

.mdi-file-move::before {
  content: "\\f0ab9";
}

.mdi-file-move-outline::before {
  content: "\\f1031";
}

.mdi-file-multiple::before {
  content: "\\f0222";
}

.mdi-file-multiple-outline::before {
  content: "\\f1032";
}

.mdi-file-music::before {
  content: "\\f0223";
}

.mdi-file-music-outline::before {
  content: "\\f0e2a";
}

.mdi-file-outline::before {
  content: "\\f0224";
}

.mdi-file-pdf-box::before {
  content: "\\f0226";
}

.mdi-file-percent::before {
  content: "\\f081e";
}

.mdi-file-percent-outline::before {
  content: "\\f1033";
}

.mdi-file-phone::before {
  content: "\\f1179";
}

.mdi-file-phone-outline::before {
  content: "\\f117a";
}

.mdi-file-plus::before {
  content: "\\f0752";
}

.mdi-file-plus-outline::before {
  content: "\\f0eed";
}

.mdi-file-png-box::before {
  content: "\\f0e2d";
}

.mdi-file-powerpoint::before {
  content: "\\f0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\f0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\f1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\f1035";
}

.mdi-file-presentation-box::before {
  content: "\\f0229";
}

.mdi-file-question::before {
  content: "\\f086f";
}

.mdi-file-question-outline::before {
  content: "\\f1036";
}

.mdi-file-refresh::before {
  content: "\\f0918";
}

.mdi-file-refresh-outline::before {
  content: "\\f0541";
}

.mdi-file-remove::before {
  content: "\\f0b98";
}

.mdi-file-remove-outline::before {
  content: "\\f1037";
}

.mdi-file-replace::before {
  content: "\\f0b32";
}

.mdi-file-replace-outline::before {
  content: "\\f0b33";
}

.mdi-file-restore::before {
  content: "\\f0670";
}

.mdi-file-restore-outline::before {
  content: "\\f1038";
}

.mdi-file-search::before {
  content: "\\f0c7c";
}

.mdi-file-search-outline::before {
  content: "\\f0c7d";
}

.mdi-file-send::before {
  content: "\\f022a";
}

.mdi-file-send-outline::before {
  content: "\\f1039";
}

.mdi-file-settings::before {
  content: "\\f1079";
}

.mdi-file-settings-outline::before {
  content: "\\f107a";
}

.mdi-file-sign::before {
  content: "\\f19c3";
}

.mdi-file-star::before {
  content: "\\f103a";
}

.mdi-file-star-outline::before {
  content: "\\f103b";
}

.mdi-file-swap::before {
  content: "\\f0fb4";
}

.mdi-file-swap-outline::before {
  content: "\\f0fb5";
}

.mdi-file-sync::before {
  content: "\\f1216";
}

.mdi-file-sync-outline::before {
  content: "\\f1217";
}

.mdi-file-table::before {
  content: "\\f0c7e";
}

.mdi-file-table-box::before {
  content: "\\f10e1";
}

.mdi-file-table-box-multiple::before {
  content: "\\f10e2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\f10e3";
}

.mdi-file-table-box-outline::before {
  content: "\\f10e4";
}

.mdi-file-table-outline::before {
  content: "\\f0c7f";
}

.mdi-file-tree::before {
  content: "\\f0645";
}

.mdi-file-tree-outline::before {
  content: "\\f13d2";
}

.mdi-file-undo::before {
  content: "\\f08dc";
}

.mdi-file-undo-outline::before {
  content: "\\f103c";
}

.mdi-file-upload::before {
  content: "\\f0a4d";
}

.mdi-file-upload-outline::before {
  content: "\\f0a4e";
}

.mdi-file-video::before {
  content: "\\f022b";
}

.mdi-file-video-outline::before {
  content: "\\f0e2c";
}

.mdi-file-word::before {
  content: "\\f022c";
}

.mdi-file-word-box::before {
  content: "\\f022d";
}

.mdi-file-word-box-outline::before {
  content: "\\f103d";
}

.mdi-file-word-outline::before {
  content: "\\f103e";
}

.mdi-film::before {
  content: "\\f022f";
}

.mdi-filmstrip::before {
  content: "\\f0230";
}

.mdi-filmstrip-box::before {
  content: "\\f0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\f0d18";
}

.mdi-filmstrip-off::before {
  content: "\\f0231";
}

.mdi-filter::before {
  content: "\\f0232";
}

.mdi-filter-check::before {
  content: "\\f18ec";
}

.mdi-filter-check-outline::before {
  content: "\\f18ed";
}

.mdi-filter-menu::before {
  content: "\\f10e5";
}

.mdi-filter-menu-outline::before {
  content: "\\f10e6";
}

.mdi-filter-minus::before {
  content: "\\f0eee";
}

.mdi-filter-minus-outline::before {
  content: "\\f0eef";
}

.mdi-filter-off::before {
  content: "\\f14ef";
}

.mdi-filter-off-outline::before {
  content: "\\f14f0";
}

.mdi-filter-outline::before {
  content: "\\f0233";
}

.mdi-filter-plus::before {
  content: "\\f0ef0";
}

.mdi-filter-plus-outline::before {
  content: "\\f0ef1";
}

.mdi-filter-remove::before {
  content: "\\f0234";
}

.mdi-filter-remove-outline::before {
  content: "\\f0235";
}

.mdi-filter-variant::before {
  content: "\\f0236";
}

.mdi-filter-variant-minus::before {
  content: "\\f1112";
}

.mdi-filter-variant-plus::before {
  content: "\\f1113";
}

.mdi-filter-variant-remove::before {
  content: "\\f103f";
}

.mdi-finance::before {
  content: "\\f081f";
}

.mdi-find-replace::before {
  content: "\\f06d4";
}

.mdi-fingerprint::before {
  content: "\\f0237";
}

.mdi-fingerprint-off::before {
  content: "\\f0eb1";
}

.mdi-fire::before {
  content: "\\f0238";
}

.mdi-fire-alert::before {
  content: "\\f15d7";
}

.mdi-fire-circle::before {
  content: "\\f1807";
}

.mdi-fire-extinguisher::before {
  content: "\\f0ef2";
}

.mdi-fire-hydrant::before {
  content: "\\f1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\f1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\f1139";
}

.mdi-fire-off::before {
  content: "\\f1722";
}

.mdi-fire-truck::before {
  content: "\\f08ab";
}

.mdi-firebase::before {
  content: "\\f0967";
}

.mdi-firefox::before {
  content: "\\f0239";
}

.mdi-fireplace::before {
  content: "\\f0e2e";
}

.mdi-fireplace-off::before {
  content: "\\f0e2f";
}

.mdi-firewire::before {
  content: "\\f05be";
}

.mdi-firework::before {
  content: "\\f0e30";
}

.mdi-firework-off::before {
  content: "\\f1723";
}

.mdi-fish::before {
  content: "\\f023a";
}

.mdi-fish-off::before {
  content: "\\f13f3";
}

.mdi-fishbowl::before {
  content: "\\f0ef3";
}

.mdi-fishbowl-outline::before {
  content: "\\f0ef4";
}

.mdi-fit-to-page::before {
  content: "\\f0ef5";
}

.mdi-fit-to-page-outline::before {
  content: "\\f0ef6";
}

.mdi-fit-to-screen::before {
  content: "\\f18f4";
}

.mdi-fit-to-screen-outline::before {
  content: "\\f18f5";
}

.mdi-flag::before {
  content: "\\f023b";
}

.mdi-flag-checkered::before {
  content: "\\f023c";
}

.mdi-flag-minus::before {
  content: "\\f0b99";
}

.mdi-flag-minus-outline::before {
  content: "\\f10b2";
}

.mdi-flag-off::before {
  content: "\\f18ee";
}

.mdi-flag-off-outline::before {
  content: "\\f18ef";
}

.mdi-flag-outline::before {
  content: "\\f023d";
}

.mdi-flag-plus::before {
  content: "\\f0b9a";
}

.mdi-flag-plus-outline::before {
  content: "\\f10b3";
}

.mdi-flag-remove::before {
  content: "\\f0b9b";
}

.mdi-flag-remove-outline::before {
  content: "\\f10b4";
}

.mdi-flag-triangle::before {
  content: "\\f023f";
}

.mdi-flag-variant::before {
  content: "\\f0240";
}

.mdi-flag-variant-outline::before {
  content: "\\f023e";
}

.mdi-flare::before {
  content: "\\f0d72";
}

.mdi-flash::before {
  content: "\\f0241";
}

.mdi-flash-alert::before {
  content: "\\f0ef7";
}

.mdi-flash-alert-outline::before {
  content: "\\f0ef8";
}

.mdi-flash-auto::before {
  content: "\\f0242";
}

.mdi-flash-off::before {
  content: "\\f0243";
}

.mdi-flash-outline::before {
  content: "\\f06d5";
}

.mdi-flash-red-eye::before {
  content: "\\f067b";
}

.mdi-flashlight::before {
  content: "\\f0244";
}

.mdi-flashlight-off::before {
  content: "\\f0245";
}

.mdi-flask::before {
  content: "\\f0093";
}

.mdi-flask-empty::before {
  content: "\\f0094";
}

.mdi-flask-empty-minus::before {
  content: "\\f123a";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\f123b";
}

.mdi-flask-empty-off::before {
  content: "\\f13f4";
}

.mdi-flask-empty-off-outline::before {
  content: "\\f13f5";
}

.mdi-flask-empty-outline::before {
  content: "\\f0095";
}

.mdi-flask-empty-plus::before {
  content: "\\f123c";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\f123d";
}

.mdi-flask-empty-remove::before {
  content: "\\f123e";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\f123f";
}

.mdi-flask-minus::before {
  content: "\\f1240";
}

.mdi-flask-minus-outline::before {
  content: "\\f1241";
}

.mdi-flask-off::before {
  content: "\\f13f6";
}

.mdi-flask-off-outline::before {
  content: "\\f13f7";
}

.mdi-flask-outline::before {
  content: "\\f0096";
}

.mdi-flask-plus::before {
  content: "\\f1242";
}

.mdi-flask-plus-outline::before {
  content: "\\f1243";
}

.mdi-flask-remove::before {
  content: "\\f1244";
}

.mdi-flask-remove-outline::before {
  content: "\\f1245";
}

.mdi-flask-round-bottom::before {
  content: "\\f124b";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\f124c";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\f124d";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\f124e";
}

.mdi-fleur-de-lis::before {
  content: "\\f1303";
}

.mdi-flip-horizontal::before {
  content: "\\f10e7";
}

.mdi-flip-to-back::before {
  content: "\\f0247";
}

.mdi-flip-to-front::before {
  content: "\\f0248";
}

.mdi-flip-vertical::before {
  content: "\\f10e8";
}

.mdi-floor-lamp::before {
  content: "\\f08dd";
}

.mdi-floor-lamp-dual::before {
  content: "\\f1040";
}

.mdi-floor-lamp-dual-outline::before {
  content: "\\f17ce";
}

.mdi-floor-lamp-outline::before {
  content: "\\f17c8";
}

.mdi-floor-lamp-torchiere::before {
  content: "\\f1747";
}

.mdi-floor-lamp-torchiere-outline::before {
  content: "\\f17d6";
}

.mdi-floor-lamp-torchiere-variant::before {
  content: "\\f1041";
}

.mdi-floor-lamp-torchiere-variant-outline::before {
  content: "\\f17cf";
}

.mdi-floor-plan::before {
  content: "\\f0821";
}

.mdi-floppy::before {
  content: "\\f0249";
}

.mdi-floppy-variant::before {
  content: "\\f09ef";
}

.mdi-flower::before {
  content: "\\f024a";
}

.mdi-flower-outline::before {
  content: "\\f09f0";
}

.mdi-flower-pollen::before {
  content: "\\f1885";
}

.mdi-flower-pollen-outline::before {
  content: "\\f1886";
}

.mdi-flower-poppy::before {
  content: "\\f0d08";
}

.mdi-flower-tulip::before {
  content: "\\f09f1";
}

.mdi-flower-tulip-outline::before {
  content: "\\f09f2";
}

.mdi-focus-auto::before {
  content: "\\f0f4e";
}

.mdi-focus-field::before {
  content: "\\f0f4f";
}

.mdi-focus-field-horizontal::before {
  content: "\\f0f50";
}

.mdi-focus-field-vertical::before {
  content: "\\f0f51";
}

.mdi-folder::before {
  content: "\\f024b";
}

.mdi-folder-account::before {
  content: "\\f024c";
}

.mdi-folder-account-outline::before {
  content: "\\f0b9c";
}

.mdi-folder-alert::before {
  content: "\\f0dcc";
}

.mdi-folder-alert-outline::before {
  content: "\\f0dcd";
}

.mdi-folder-check::before {
  content: "\\f197e";
}

.mdi-folder-check-outline::before {
  content: "\\f197f";
}

.mdi-folder-clock::before {
  content: "\\f0aba";
}

.mdi-folder-clock-outline::before {
  content: "\\f0abb";
}

.mdi-folder-cog::before {
  content: "\\f107f";
}

.mdi-folder-cog-outline::before {
  content: "\\f1080";
}

.mdi-folder-download::before {
  content: "\\f024d";
}

.mdi-folder-download-outline::before {
  content: "\\f10e9";
}

.mdi-folder-edit::before {
  content: "\\f08de";
}

.mdi-folder-edit-outline::before {
  content: "\\f0dce";
}

.mdi-folder-eye::before {
  content: "\\f178a";
}

.mdi-folder-eye-outline::before {
  content: "\\f178b";
}

.mdi-folder-google-drive::before {
  content: "\\f024e";
}

.mdi-folder-heart::before {
  content: "\\f10ea";
}

.mdi-folder-heart-outline::before {
  content: "\\f10eb";
}

.mdi-folder-hidden::before {
  content: "\\f179e";
}

.mdi-folder-home::before {
  content: "\\f10b5";
}

.mdi-folder-home-outline::before {
  content: "\\f10b6";
}

.mdi-folder-image::before {
  content: "\\f024f";
}

.mdi-folder-information::before {
  content: "\\f10b7";
}

.mdi-folder-information-outline::before {
  content: "\\f10b8";
}

.mdi-folder-key::before {
  content: "\\f08ac";
}

.mdi-folder-key-network::before {
  content: "\\f08ad";
}

.mdi-folder-key-network-outline::before {
  content: "\\f0c80";
}

.mdi-folder-key-outline::before {
  content: "\\f10ec";
}

.mdi-folder-lock::before {
  content: "\\f0250";
}

.mdi-folder-lock-open::before {
  content: "\\f0251";
}

.mdi-folder-marker::before {
  content: "\\f126d";
}

.mdi-folder-marker-outline::before {
  content: "\\f126e";
}

.mdi-folder-move::before {
  content: "\\f0252";
}

.mdi-folder-move-outline::before {
  content: "\\f1246";
}

.mdi-folder-multiple::before {
  content: "\\f0253";
}

.mdi-folder-multiple-image::before {
  content: "\\f0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\f0255";
}

.mdi-folder-multiple-plus::before {
  content: "\\f147e";
}

.mdi-folder-multiple-plus-outline::before {
  content: "\\f147f";
}

.mdi-folder-music::before {
  content: "\\f1359";
}

.mdi-folder-music-outline::before {
  content: "\\f135a";
}

.mdi-folder-network::before {
  content: "\\f0870";
}

.mdi-folder-network-outline::before {
  content: "\\f0c81";
}

.mdi-folder-open::before {
  content: "\\f0770";
}

.mdi-folder-open-outline::before {
  content: "\\f0dcf";
}

.mdi-folder-outline::before {
  content: "\\f0256";
}

.mdi-folder-plus::before {
  content: "\\f0257";
}

.mdi-folder-plus-outline::before {
  content: "\\f0b9d";
}

.mdi-folder-pound::before {
  content: "\\f0d09";
}

.mdi-folder-pound-outline::before {
  content: "\\f0d0a";
}

.mdi-folder-refresh::before {
  content: "\\f0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\f0542";
}

.mdi-folder-remove::before {
  content: "\\f0258";
}

.mdi-folder-remove-outline::before {
  content: "\\f0b9e";
}

.mdi-folder-search::before {
  content: "\\f0968";
}

.mdi-folder-search-outline::before {
  content: "\\f0969";
}

.mdi-folder-settings::before {
  content: "\\f107d";
}

.mdi-folder-settings-outline::before {
  content: "\\f107e";
}

.mdi-folder-star::before {
  content: "\\f069d";
}

.mdi-folder-star-multiple::before {
  content: "\\f13d3";
}

.mdi-folder-star-multiple-outline::before {
  content: "\\f13d4";
}

.mdi-folder-star-outline::before {
  content: "\\f0b9f";
}

.mdi-folder-swap::before {
  content: "\\f0fb6";
}

.mdi-folder-swap-outline::before {
  content: "\\f0fb7";
}

.mdi-folder-sync::before {
  content: "\\f0d0b";
}

.mdi-folder-sync-outline::before {
  content: "\\f0d0c";
}

.mdi-folder-table::before {
  content: "\\f12e3";
}

.mdi-folder-table-outline::before {
  content: "\\f12e4";
}

.mdi-folder-text::before {
  content: "\\f0c82";
}

.mdi-folder-text-outline::before {
  content: "\\f0c83";
}

.mdi-folder-upload::before {
  content: "\\f0259";
}

.mdi-folder-upload-outline::before {
  content: "\\f10ed";
}

.mdi-folder-zip::before {
  content: "\\f06eb";
}

.mdi-folder-zip-outline::before {
  content: "\\f07b9";
}

.mdi-font-awesome::before {
  content: "\\f003a";
}

.mdi-food::before {
  content: "\\f025a";
}

.mdi-food-apple::before {
  content: "\\f025b";
}

.mdi-food-apple-outline::before {
  content: "\\f0c84";
}

.mdi-food-croissant::before {
  content: "\\f07c8";
}

.mdi-food-drumstick::before {
  content: "\\f141f";
}

.mdi-food-drumstick-off::before {
  content: "\\f1468";
}

.mdi-food-drumstick-off-outline::before {
  content: "\\f1469";
}

.mdi-food-drumstick-outline::before {
  content: "\\f1420";
}

.mdi-food-fork-drink::before {
  content: "\\f05f2";
}

.mdi-food-halal::before {
  content: "\\f1572";
}

.mdi-food-hot-dog::before {
  content: "\\f184b";
}

.mdi-food-kosher::before {
  content: "\\f1573";
}

.mdi-food-off::before {
  content: "\\f05f3";
}

.mdi-food-off-outline::before {
  content: "\\f1915";
}

.mdi-food-outline::before {
  content: "\\f1916";
}

.mdi-food-steak::before {
  content: "\\f146a";
}

.mdi-food-steak-off::before {
  content: "\\f146b";
}

.mdi-food-takeout-box::before {
  content: "\\f1836";
}

.mdi-food-takeout-box-outline::before {
  content: "\\f1837";
}

.mdi-food-turkey::before {
  content: "\\f171c";
}

.mdi-food-variant::before {
  content: "\\f025c";
}

.mdi-food-variant-off::before {
  content: "\\f13e5";
}

.mdi-foot-print::before {
  content: "\\f0f52";
}

.mdi-football::before {
  content: "\\f025d";
}

.mdi-football-australian::before {
  content: "\\f025e";
}

.mdi-football-helmet::before {
  content: "\\f025f";
}

.mdi-forest::before {
  content: "\\f1897";
}

.mdi-forklift::before {
  content: "\\f07c9";
}

.mdi-form-dropdown::before {
  content: "\\f1400";
}

.mdi-form-select::before {
  content: "\\f1401";
}

.mdi-form-textarea::before {
  content: "\\f1095";
}

.mdi-form-textbox::before {
  content: "\\f060e";
}

.mdi-form-textbox-lock::before {
  content: "\\f135d";
}

.mdi-form-textbox-password::before {
  content: "\\f07f5";
}

.mdi-format-align-bottom::before {
  content: "\\f0753";
}

.mdi-format-align-center::before {
  content: "\\f0260";
}

.mdi-format-align-justify::before {
  content: "\\f0261";
}

.mdi-format-align-left::before {
  content: "\\f0262";
}

.mdi-format-align-middle::before {
  content: "\\f0754";
}

.mdi-format-align-right::before {
  content: "\\f0263";
}

.mdi-format-align-top::before {
  content: "\\f0755";
}

.mdi-format-annotation-minus::before {
  content: "\\f0abc";
}

.mdi-format-annotation-plus::before {
  content: "\\f0646";
}

.mdi-format-bold::before {
  content: "\\f0264";
}

.mdi-format-clear::before {
  content: "\\f0265";
}

.mdi-format-color-fill::before {
  content: "\\f0266";
}

.mdi-format-color-highlight::before {
  content: "\\f0e31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\f1313";
}

.mdi-format-color-text::before {
  content: "\\f069e";
}

.mdi-format-columns::before {
  content: "\\f08df";
}

.mdi-format-float-center::before {
  content: "\\f0267";
}

.mdi-format-float-left::before {
  content: "\\f0268";
}

.mdi-format-float-none::before {
  content: "\\f0269";
}

.mdi-format-float-right::before {
  content: "\\f026a";
}

.mdi-format-font::before {
  content: "\\f06d6";
}

.mdi-format-font-size-decrease::before {
  content: "\\f09f3";
}

.mdi-format-font-size-increase::before {
  content: "\\f09f4";
}

.mdi-format-header-1::before {
  content: "\\f026b";
}

.mdi-format-header-2::before {
  content: "\\f026c";
}

.mdi-format-header-3::before {
  content: "\\f026d";
}

.mdi-format-header-4::before {
  content: "\\f026e";
}

.mdi-format-header-5::before {
  content: "\\f026f";
}

.mdi-format-header-6::before {
  content: "\\f0270";
}

.mdi-format-header-decrease::before {
  content: "\\f0271";
}

.mdi-format-header-equal::before {
  content: "\\f0272";
}

.mdi-format-header-increase::before {
  content: "\\f0273";
}

.mdi-format-header-pound::before {
  content: "\\f0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\f061e";
}

.mdi-format-horizontal-align-left::before {
  content: "\\f061f";
}

.mdi-format-horizontal-align-right::before {
  content: "\\f0620";
}

.mdi-format-indent-decrease::before {
  content: "\\f0275";
}

.mdi-format-indent-increase::before {
  content: "\\f0276";
}

.mdi-format-italic::before {
  content: "\\f0277";
}

.mdi-format-letter-case::before {
  content: "\\f0b34";
}

.mdi-format-letter-case-lower::before {
  content: "\\f0b35";
}

.mdi-format-letter-case-upper::before {
  content: "\\f0b36";
}

.mdi-format-letter-ends-with::before {
  content: "\\f0fb8";
}

.mdi-format-letter-matches::before {
  content: "\\f0fb9";
}

.mdi-format-letter-spacing::before {
  content: "\\f1956";
}

.mdi-format-letter-starts-with::before {
  content: "\\f0fba";
}

.mdi-format-line-spacing::before {
  content: "\\f0278";
}

.mdi-format-line-style::before {
  content: "\\f05c8";
}

.mdi-format-line-weight::before {
  content: "\\f05c9";
}

.mdi-format-list-bulleted::before {
  content: "\\f0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\f0dd0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\f0eb2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\f027a";
}

.mdi-format-list-checkbox::before {
  content: "\\f096a";
}

.mdi-format-list-checks::before {
  content: "\\f0756";
}

.mdi-format-list-group::before {
  content: "\\f1860";
}

.mdi-format-list-numbered::before {
  content: "\\f027b";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\f0d0d";
}

.mdi-format-list-text::before {
  content: "\\f126f";
}

.mdi-format-overline::before {
  content: "\\f0eb3";
}

.mdi-format-page-break::before {
  content: "\\f06d7";
}

.mdi-format-page-split::before {
  content: "\\f1917";
}

.mdi-format-paint::before {
  content: "\\f027c";
}

.mdi-format-paragraph::before {
  content: "\\f027d";
}

.mdi-format-pilcrow::before {
  content: "\\f06d8";
}

.mdi-format-quote-close::before {
  content: "\\f027e";
}

.mdi-format-quote-close-outline::before {
  content: "\\f11a8";
}

.mdi-format-quote-open::before {
  content: "\\f0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\f11a7";
}

.mdi-format-rotate-90::before {
  content: "\\f06aa";
}

.mdi-format-section::before {
  content: "\\f069f";
}

.mdi-format-size::before {
  content: "\\f027f";
}

.mdi-format-strikethrough::before {
  content: "\\f0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\f0281";
}

.mdi-format-subscript::before {
  content: "\\f0282";
}

.mdi-format-superscript::before {
  content: "\\f0283";
}

.mdi-format-text::before {
  content: "\\f0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\f0fbb";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\f0fbc";
}

.mdi-format-text-rotation-down::before {
  content: "\\f0d73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\f0fbd";
}

.mdi-format-text-rotation-none::before {
  content: "\\f0d74";
}

.mdi-format-text-rotation-up::before {
  content: "\\f0fbe";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\f0fbf";
}

.mdi-format-text-variant::before {
  content: "\\f0e32";
}

.mdi-format-text-variant-outline::before {
  content: "\\f150f";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\f0d0e";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\f0d0f";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\f0d10";
}

.mdi-format-textbox::before {
  content: "\\f0d11";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\f0285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\f0286";
}

.mdi-format-title::before {
  content: "\\f05f4";
}

.mdi-format-underline::before {
  content: "\\f0287";
}

.mdi-format-underline-wavy::before {
  content: "\\f18e9";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\f0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\f0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\f0623";
}

.mdi-format-wrap-inline::before {
  content: "\\f0288";
}

.mdi-format-wrap-square::before {
  content: "\\f0289";
}

.mdi-format-wrap-tight::before {
  content: "\\f028a";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\f028b";
}

.mdi-forum::before {
  content: "\\f028c";
}

.mdi-forum-outline::before {
  content: "\\f0822";
}

.mdi-forward::before {
  content: "\\f028d";
}

.mdi-forwardburger::before {
  content: "\\f0d75";
}

.mdi-fountain::before {
  content: "\\f096b";
}

.mdi-fountain-pen::before {
  content: "\\f0d12";
}

.mdi-fountain-pen-tip::before {
  content: "\\f0d13";
}

.mdi-fraction-one-half::before {
  content: "\\f1992";
}

.mdi-freebsd::before {
  content: "\\f08e0";
}

.mdi-french-fries::before {
  content: "\\f1957";
}

.mdi-frequently-asked-questions::before {
  content: "\\f0eb4";
}

.mdi-fridge::before {
  content: "\\f0290";
}

.mdi-fridge-alert::before {
  content: "\\f11b1";
}

.mdi-fridge-alert-outline::before {
  content: "\\f11b2";
}

.mdi-fridge-bottom::before {
  content: "\\f0292";
}

.mdi-fridge-industrial::before {
  content: "\\f15ee";
}

.mdi-fridge-industrial-alert::before {
  content: "\\f15ef";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "\\f15f0";
}

.mdi-fridge-industrial-off::before {
  content: "\\f15f1";
}

.mdi-fridge-industrial-off-outline::before {
  content: "\\f15f2";
}

.mdi-fridge-industrial-outline::before {
  content: "\\f15f3";
}

.mdi-fridge-off::before {
  content: "\\f11af";
}

.mdi-fridge-off-outline::before {
  content: "\\f11b0";
}

.mdi-fridge-outline::before {
  content: "\\f028f";
}

.mdi-fridge-top::before {
  content: "\\f0291";
}

.mdi-fridge-variant::before {
  content: "\\f15f4";
}

.mdi-fridge-variant-alert::before {
  content: "\\f15f5";
}

.mdi-fridge-variant-alert-outline::before {
  content: "\\f15f6";
}

.mdi-fridge-variant-off::before {
  content: "\\f15f7";
}

.mdi-fridge-variant-off-outline::before {
  content: "\\f15f8";
}

.mdi-fridge-variant-outline::before {
  content: "\\f15f9";
}

.mdi-fruit-cherries::before {
  content: "\\f1042";
}

.mdi-fruit-cherries-off::before {
  content: "\\f13f8";
}

.mdi-fruit-citrus::before {
  content: "\\f1043";
}

.mdi-fruit-citrus-off::before {
  content: "\\f13f9";
}

.mdi-fruit-grapes::before {
  content: "\\f1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\f1045";
}

.mdi-fruit-pineapple::before {
  content: "\\f1046";
}

.mdi-fruit-watermelon::before {
  content: "\\f1047";
}

.mdi-fuel::before {
  content: "\\f07ca";
}

.mdi-fuel-cell::before {
  content: "\\f18b5";
}

.mdi-fullscreen::before {
  content: "\\f0293";
}

.mdi-fullscreen-exit::before {
  content: "\\f0294";
}

.mdi-function::before {
  content: "\\f0295";
}

.mdi-function-variant::before {
  content: "\\f0871";
}

.mdi-furigana-horizontal::before {
  content: "\\f1081";
}

.mdi-furigana-vertical::before {
  content: "\\f1082";
}

.mdi-fuse::before {
  content: "\\f0c85";
}

.mdi-fuse-alert::before {
  content: "\\f142d";
}

.mdi-fuse-blade::before {
  content: "\\f0c86";
}

.mdi-fuse-off::before {
  content: "\\f142c";
}

.mdi-gamepad::before {
  content: "\\f0296";
}

.mdi-gamepad-circle::before {
  content: "\\f0e33";
}

.mdi-gamepad-circle-down::before {
  content: "\\f0e34";
}

.mdi-gamepad-circle-left::before {
  content: "\\f0e35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\f0e36";
}

.mdi-gamepad-circle-right::before {
  content: "\\f0e37";
}

.mdi-gamepad-circle-up::before {
  content: "\\f0e38";
}

.mdi-gamepad-down::before {
  content: "\\f0e39";
}

.mdi-gamepad-left::before {
  content: "\\f0e3a";
}

.mdi-gamepad-outline::before {
  content: "\\f1919";
}

.mdi-gamepad-right::before {
  content: "\\f0e3b";
}

.mdi-gamepad-round::before {
  content: "\\f0e3c";
}

.mdi-gamepad-round-down::before {
  content: "\\f0e3d";
}

.mdi-gamepad-round-left::before {
  content: "\\f0e3e";
}

.mdi-gamepad-round-outline::before {
  content: "\\f0e3f";
}

.mdi-gamepad-round-right::before {
  content: "\\f0e40";
}

.mdi-gamepad-round-up::before {
  content: "\\f0e41";
}

.mdi-gamepad-square::before {
  content: "\\f0eb5";
}

.mdi-gamepad-square-outline::before {
  content: "\\f0eb6";
}

.mdi-gamepad-up::before {
  content: "\\f0e42";
}

.mdi-gamepad-variant::before {
  content: "\\f0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\f0eb7";
}

.mdi-gamma::before {
  content: "\\f10ee";
}

.mdi-gantry-crane::before {
  content: "\\f0dd1";
}

.mdi-garage::before {
  content: "\\f06d9";
}

.mdi-garage-alert::before {
  content: "\\f0872";
}

.mdi-garage-alert-variant::before {
  content: "\\f12d5";
}

.mdi-garage-lock::before {
  content: "\\f17fb";
}

.mdi-garage-open::before {
  content: "\\f06da";
}

.mdi-garage-open-variant::before {
  content: "\\f12d4";
}

.mdi-garage-variant::before {
  content: "\\f12d3";
}

.mdi-garage-variant-lock::before {
  content: "\\f17fc";
}

.mdi-gas-cylinder::before {
  content: "\\f0647";
}

.mdi-gas-station::before {
  content: "\\f0298";
}

.mdi-gas-station-off::before {
  content: "\\f1409";
}

.mdi-gas-station-off-outline::before {
  content: "\\f140a";
}

.mdi-gas-station-outline::before {
  content: "\\f0eb8";
}

.mdi-gate::before {
  content: "\\f0299";
}

.mdi-gate-alert::before {
  content: "\\f17f8";
}

.mdi-gate-and::before {
  content: "\\f08e1";
}

.mdi-gate-arrow-left::before {
  content: "\\f17f7";
}

.mdi-gate-arrow-right::before {
  content: "\\f1169";
}

.mdi-gate-nand::before {
  content: "\\f08e2";
}

.mdi-gate-nor::before {
  content: "\\f08e3";
}

.mdi-gate-not::before {
  content: "\\f08e4";
}

.mdi-gate-open::before {
  content: "\\f116a";
}

.mdi-gate-or::before {
  content: "\\f08e5";
}

.mdi-gate-xnor::before {
  content: "\\f08e6";
}

.mdi-gate-xor::before {
  content: "\\f08e7";
}

.mdi-gatsby::before {
  content: "\\f0e43";
}

.mdi-gauge::before {
  content: "\\f029a";
}

.mdi-gauge-empty::before {
  content: "\\f0873";
}

.mdi-gauge-full::before {
  content: "\\f0874";
}

.mdi-gauge-low::before {
  content: "\\f0875";
}

.mdi-gavel::before {
  content: "\\f029b";
}

.mdi-gender-female::before {
  content: "\\f029c";
}

.mdi-gender-male::before {
  content: "\\f029d";
}

.mdi-gender-male-female::before {
  content: "\\f029e";
}

.mdi-gender-male-female-variant::before {
  content: "\\f113f";
}

.mdi-gender-non-binary::before {
  content: "\\f1140";
}

.mdi-gender-transgender::before {
  content: "\\f029f";
}

.mdi-gentoo::before {
  content: "\\f08e8";
}

.mdi-gesture::before {
  content: "\\f07cb";
}

.mdi-gesture-double-tap::before {
  content: "\\f073c";
}

.mdi-gesture-pinch::before {
  content: "\\f0abd";
}

.mdi-gesture-spread::before {
  content: "\\f0abe";
}

.mdi-gesture-swipe::before {
  content: "\\f0d76";
}

.mdi-gesture-swipe-down::before {
  content: "\\f073d";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\f0abf";
}

.mdi-gesture-swipe-left::before {
  content: "\\f073e";
}

.mdi-gesture-swipe-right::before {
  content: "\\f073f";
}

.mdi-gesture-swipe-up::before {
  content: "\\f0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\f0ac0";
}

.mdi-gesture-tap::before {
  content: "\\f0741";
}

.mdi-gesture-tap-box::before {
  content: "\\f12a9";
}

.mdi-gesture-tap-button::before {
  content: "\\f12a8";
}

.mdi-gesture-tap-hold::before {
  content: "\\f0d77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\f0742";
}

.mdi-gesture-two-tap::before {
  content: "\\f0743";
}

.mdi-ghost::before {
  content: "\\f02a0";
}

.mdi-ghost-off::before {
  content: "\\f09f5";
}

.mdi-ghost-off-outline::before {
  content: "\\f165c";
}

.mdi-ghost-outline::before {
  content: "\\f165d";
}

.mdi-gift::before {
  content: "\\f0e44";
}

.mdi-gift-off::before {
  content: "\\f16ef";
}

.mdi-gift-off-outline::before {
  content: "\\f16f0";
}

.mdi-gift-open::before {
  content: "\\f16f1";
}

.mdi-gift-open-outline::before {
  content: "\\f16f2";
}

.mdi-gift-outline::before {
  content: "\\f02a1";
}

.mdi-git::before {
  content: "\\f02a2";
}

.mdi-github::before {
  content: "\\f02a4";
}

.mdi-gitlab::before {
  content: "\\f0ba0";
}

.mdi-glass-cocktail::before {
  content: "\\f0356";
}

.mdi-glass-cocktail-off::before {
  content: "\\f15e6";
}

.mdi-glass-flute::before {
  content: "\\f02a5";
}

.mdi-glass-fragile::before {
  content: "\\f1873";
}

.mdi-glass-mug::before {
  content: "\\f02a6";
}

.mdi-glass-mug-off::before {
  content: "\\f15e7";
}

.mdi-glass-mug-variant::before {
  content: "\\f1116";
}

.mdi-glass-mug-variant-off::before {
  content: "\\f15e8";
}

.mdi-glass-pint-outline::before {
  content: "\\f130d";
}

.mdi-glass-stange::before {
  content: "\\f02a7";
}

.mdi-glass-tulip::before {
  content: "\\f02a8";
}

.mdi-glass-wine::before {
  content: "\\f0876";
}

.mdi-glasses::before {
  content: "\\f02aa";
}

.mdi-globe-light::before {
  content: "\\f12d7";
}

.mdi-globe-model::before {
  content: "\\f08e9";
}

.mdi-gmail::before {
  content: "\\f02ab";
}

.mdi-gnome::before {
  content: "\\f02ac";
}

.mdi-go-kart::before {
  content: "\\f0d79";
}

.mdi-go-kart-track::before {
  content: "\\f0d7a";
}

.mdi-gog::before {
  content: "\\f0ba1";
}

.mdi-gold::before {
  content: "\\f124f";
}

.mdi-golf::before {
  content: "\\f0823";
}

.mdi-golf-cart::before {
  content: "\\f11a4";
}

.mdi-golf-tee::before {
  content: "\\f1083";
}

.mdi-gondola::before {
  content: "\\f0686";
}

.mdi-goodreads::before {
  content: "\\f0d7b";
}

.mdi-google::before {
  content: "\\f02ad";
}

.mdi-google-ads::before {
  content: "\\f0c87";
}

.mdi-google-analytics::before {
  content: "\\f07cc";
}

.mdi-google-assistant::before {
  content: "\\f07cd";
}

.mdi-google-cardboard::before {
  content: "\\f02ae";
}

.mdi-google-chrome::before {
  content: "\\f02af";
}

.mdi-google-circles::before {
  content: "\\f02b0";
}

.mdi-google-circles-communities::before {
  content: "\\f02b1";
}

.mdi-google-circles-extended::before {
  content: "\\f02b2";
}

.mdi-google-circles-group::before {
  content: "\\f02b3";
}

.mdi-google-classroom::before {
  content: "\\f02c0";
}

.mdi-google-cloud::before {
  content: "\\f11f6";
}

.mdi-google-controller::before {
  content: "\\f02b4";
}

.mdi-google-controller-off::before {
  content: "\\f02b5";
}

.mdi-google-downasaur::before {
  content: "\\f1362";
}

.mdi-google-drive::before {
  content: "\\f02b6";
}

.mdi-google-earth::before {
  content: "\\f02b7";
}

.mdi-google-fit::before {
  content: "\\f096c";
}

.mdi-google-glass::before {
  content: "\\f02b8";
}

.mdi-google-hangouts::before {
  content: "\\f02c9";
}

.mdi-google-home::before {
  content: "\\f0824";
}

.mdi-google-keep::before {
  content: "\\f06dc";
}

.mdi-google-lens::before {
  content: "\\f09f6";
}

.mdi-google-maps::before {
  content: "\\f05f5";
}

.mdi-google-my-business::before {
  content: "\\f1048";
}

.mdi-google-nearby::before {
  content: "\\f02b9";
}

.mdi-google-play::before {
  content: "\\f02bc";
}

.mdi-google-plus::before {
  content: "\\f02bd";
}

.mdi-google-podcast::before {
  content: "\\f0eb9";
}

.mdi-google-spreadsheet::before {
  content: "\\f09f7";
}

.mdi-google-street-view::before {
  content: "\\f0c88";
}

.mdi-google-translate::before {
  content: "\\f02bf";
}

.mdi-gradient-horizontal::before {
  content: "\\f174a";
}

.mdi-gradient-vertical::before {
  content: "\\f06a0";
}

.mdi-grain::before {
  content: "\\f0d7c";
}

.mdi-graph::before {
  content: "\\f1049";
}

.mdi-graph-outline::before {
  content: "\\f104a";
}

.mdi-graphql::before {
  content: "\\f0877";
}

.mdi-grass::before {
  content: "\\f1510";
}

.mdi-grave-stone::before {
  content: "\\f0ba2";
}

.mdi-grease-pencil::before {
  content: "\\f0648";
}

.mdi-greater-than::before {
  content: "\\f096d";
}

.mdi-greater-than-or-equal::before {
  content: "\\f096e";
}

.mdi-greenhouse::before {
  content: "\\f002d";
}

.mdi-grid::before {
  content: "\\f02c1";
}

.mdi-grid-large::before {
  content: "\\f0758";
}

.mdi-grid-off::before {
  content: "\\f02c2";
}

.mdi-grill::before {
  content: "\\f0e45";
}

.mdi-grill-outline::before {
  content: "\\f118a";
}

.mdi-group::before {
  content: "\\f02c3";
}

.mdi-guitar-acoustic::before {
  content: "\\f0771";
}

.mdi-guitar-electric::before {
  content: "\\f02c4";
}

.mdi-guitar-pick::before {
  content: "\\f02c5";
}

.mdi-guitar-pick-outline::before {
  content: "\\f02c6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\f0825";
}

.mdi-hail::before {
  content: "\\f0ac1";
}

.mdi-hair-dryer::before {
  content: "\\f10ef";
}

.mdi-hair-dryer-outline::before {
  content: "\\f10f0";
}

.mdi-halloween::before {
  content: "\\f0ba3";
}

.mdi-hamburger::before {
  content: "\\f0685";
}

.mdi-hamburger-check::before {
  content: "\\f1776";
}

.mdi-hamburger-minus::before {
  content: "\\f1777";
}

.mdi-hamburger-off::before {
  content: "\\f1778";
}

.mdi-hamburger-plus::before {
  content: "\\f1779";
}

.mdi-hamburger-remove::before {
  content: "\\f177a";
}

.mdi-hammer::before {
  content: "\\f08ea";
}

.mdi-hammer-screwdriver::before {
  content: "\\f1322";
}

.mdi-hammer-sickle::before {
  content: "\\f1887";
}

.mdi-hammer-wrench::before {
  content: "\\f1323";
}

.mdi-hand-back-left::before {
  content: "\\f0e46";
}

.mdi-hand-back-left-off::before {
  content: "\\f1830";
}

.mdi-hand-back-left-off-outline::before {
  content: "\\f1832";
}

.mdi-hand-back-left-outline::before {
  content: "\\f182c";
}

.mdi-hand-back-right::before {
  content: "\\f0e47";
}

.mdi-hand-back-right-off::before {
  content: "\\f1831";
}

.mdi-hand-back-right-off-outline::before {
  content: "\\f1833";
}

.mdi-hand-back-right-outline::before {
  content: "\\f182d";
}

.mdi-hand-clap::before {
  content: "\\f194b";
}

.mdi-hand-coin::before {
  content: "\\f188f";
}

.mdi-hand-coin-outline::before {
  content: "\\f1890";
}

.mdi-hand-extended::before {
  content: "\\f18b6";
}

.mdi-hand-extended-outline::before {
  content: "\\f18b7";
}

.mdi-hand-front-left::before {
  content: "\\f182b";
}

.mdi-hand-front-left-outline::before {
  content: "\\f182e";
}

.mdi-hand-front-right::before {
  content: "\\f0a4f";
}

.mdi-hand-front-right-outline::before {
  content: "\\f182f";
}

.mdi-hand-heart::before {
  content: "\\f10f1";
}

.mdi-hand-heart-outline::before {
  content: "\\f157e";
}

.mdi-hand-okay::before {
  content: "\\f0a50";
}

.mdi-hand-peace::before {
  content: "\\f0a51";
}

.mdi-hand-peace-variant::before {
  content: "\\f0a52";
}

.mdi-hand-pointing-down::before {
  content: "\\f0a53";
}

.mdi-hand-pointing-left::before {
  content: "\\f0a54";
}

.mdi-hand-pointing-right::before {
  content: "\\f02c7";
}

.mdi-hand-pointing-up::before {
  content: "\\f0a55";
}

.mdi-hand-saw::before {
  content: "\\f0e48";
}

.mdi-hand-wash::before {
  content: "\\f157f";
}

.mdi-hand-wash-outline::before {
  content: "\\f1580";
}

.mdi-hand-water::before {
  content: "\\f139f";
}

.mdi-hand-wave::before {
  content: "\\f1821";
}

.mdi-hand-wave-outline::before {
  content: "\\f1822";
}

.mdi-handball::before {
  content: "\\f0f53";
}

.mdi-handcuffs::before {
  content: "\\f113e";
}

.mdi-hands-pray::before {
  content: "\\f0579";
}

.mdi-handshake::before {
  content: "\\f1218";
}

.mdi-handshake-outline::before {
  content: "\\f15a1";
}

.mdi-hanger::before {
  content: "\\f02c8";
}

.mdi-hard-hat::before {
  content: "\\f096f";
}

.mdi-harddisk::before {
  content: "\\f02ca";
}

.mdi-harddisk-plus::before {
  content: "\\f104b";
}

.mdi-harddisk-remove::before {
  content: "\\f104c";
}

.mdi-hat-fedora::before {
  content: "\\f0ba4";
}

.mdi-hazard-lights::before {
  content: "\\f0c89";
}

.mdi-hdr::before {
  content: "\\f0d7d";
}

.mdi-hdr-off::before {
  content: "\\f0d7e";
}

.mdi-head::before {
  content: "\\f135e";
}

.mdi-head-alert::before {
  content: "\\f1338";
}

.mdi-head-alert-outline::before {
  content: "\\f1339";
}

.mdi-head-check::before {
  content: "\\f133a";
}

.mdi-head-check-outline::before {
  content: "\\f133b";
}

.mdi-head-cog::before {
  content: "\\f133c";
}

.mdi-head-cog-outline::before {
  content: "\\f133d";
}

.mdi-head-dots-horizontal::before {
  content: "\\f133e";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\f133f";
}

.mdi-head-flash::before {
  content: "\\f1340";
}

.mdi-head-flash-outline::before {
  content: "\\f1341";
}

.mdi-head-heart::before {
  content: "\\f1342";
}

.mdi-head-heart-outline::before {
  content: "\\f1343";
}

.mdi-head-lightbulb::before {
  content: "\\f1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\f1345";
}

.mdi-head-minus::before {
  content: "\\f1346";
}

.mdi-head-minus-outline::before {
  content: "\\f1347";
}

.mdi-head-outline::before {
  content: "\\f135f";
}

.mdi-head-plus::before {
  content: "\\f1348";
}

.mdi-head-plus-outline::before {
  content: "\\f1349";
}

.mdi-head-question::before {
  content: "\\f134a";
}

.mdi-head-question-outline::before {
  content: "\\f134b";
}

.mdi-head-remove::before {
  content: "\\f134c";
}

.mdi-head-remove-outline::before {
  content: "\\f134d";
}

.mdi-head-snowflake::before {
  content: "\\f134e";
}

.mdi-head-snowflake-outline::before {
  content: "\\f134f";
}

.mdi-head-sync::before {
  content: "\\f1350";
}

.mdi-head-sync-outline::before {
  content: "\\f1351";
}

.mdi-headphones::before {
  content: "\\f02cb";
}

.mdi-headphones-bluetooth::before {
  content: "\\f0970";
}

.mdi-headphones-box::before {
  content: "\\f02cc";
}

.mdi-headphones-off::before {
  content: "\\f07ce";
}

.mdi-headphones-settings::before {
  content: "\\f02cd";
}

.mdi-headset::before {
  content: "\\f02ce";
}

.mdi-headset-dock::before {
  content: "\\f02cf";
}

.mdi-headset-off::before {
  content: "\\f02d0";
}

.mdi-heart::before {
  content: "\\f02d1";
}

.mdi-heart-box::before {
  content: "\\f02d2";
}

.mdi-heart-box-outline::before {
  content: "\\f02d3";
}

.mdi-heart-broken::before {
  content: "\\f02d4";
}

.mdi-heart-broken-outline::before {
  content: "\\f0d14";
}

.mdi-heart-circle::before {
  content: "\\f0971";
}

.mdi-heart-circle-outline::before {
  content: "\\f0972";
}

.mdi-heart-cog::before {
  content: "\\f1663";
}

.mdi-heart-cog-outline::before {
  content: "\\f1664";
}

.mdi-heart-flash::before {
  content: "\\f0ef9";
}

.mdi-heart-half::before {
  content: "\\f06df";
}

.mdi-heart-half-full::before {
  content: "\\f06de";
}

.mdi-heart-half-outline::before {
  content: "\\f06e0";
}

.mdi-heart-minus::before {
  content: "\\f142f";
}

.mdi-heart-minus-outline::before {
  content: "\\f1432";
}

.mdi-heart-multiple::before {
  content: "\\f0a56";
}

.mdi-heart-multiple-outline::before {
  content: "\\f0a57";
}

.mdi-heart-off::before {
  content: "\\f0759";
}

.mdi-heart-off-outline::before {
  content: "\\f1434";
}

.mdi-heart-outline::before {
  content: "\\f02d5";
}

.mdi-heart-plus::before {
  content: "\\f142e";
}

.mdi-heart-plus-outline::before {
  content: "\\f1431";
}

.mdi-heart-pulse::before {
  content: "\\f05f6";
}

.mdi-heart-remove::before {
  content: "\\f1430";
}

.mdi-heart-remove-outline::before {
  content: "\\f1433";
}

.mdi-heart-settings::before {
  content: "\\f1665";
}

.mdi-heart-settings-outline::before {
  content: "\\f1666";
}

.mdi-helicopter::before {
  content: "\\f0ac2";
}

.mdi-help::before {
  content: "\\f02d6";
}

.mdi-help-box::before {
  content: "\\f078b";
}

.mdi-help-circle::before {
  content: "\\f02d7";
}

.mdi-help-circle-outline::before {
  content: "\\f0625";
}

.mdi-help-network::before {
  content: "\\f06f5";
}

.mdi-help-network-outline::before {
  content: "\\f0c8a";
}

.mdi-help-rhombus::before {
  content: "\\f0ba5";
}

.mdi-help-rhombus-outline::before {
  content: "\\f0ba6";
}

.mdi-hexadecimal::before {
  content: "\\f12a7";
}

.mdi-hexagon::before {
  content: "\\f02d8";
}

.mdi-hexagon-multiple::before {
  content: "\\f06e1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\f10f2";
}

.mdi-hexagon-outline::before {
  content: "\\f02d9";
}

.mdi-hexagon-slice-1::before {
  content: "\\f0ac3";
}

.mdi-hexagon-slice-2::before {
  content: "\\f0ac4";
}

.mdi-hexagon-slice-3::before {
  content: "\\f0ac5";
}

.mdi-hexagon-slice-4::before {
  content: "\\f0ac6";
}

.mdi-hexagon-slice-5::before {
  content: "\\f0ac7";
}

.mdi-hexagon-slice-6::before {
  content: "\\f0ac8";
}

.mdi-hexagram::before {
  content: "\\f0ac9";
}

.mdi-hexagram-outline::before {
  content: "\\f0aca";
}

.mdi-high-definition::before {
  content: "\\f07cf";
}

.mdi-high-definition-box::before {
  content: "\\f0878";
}

.mdi-highway::before {
  content: "\\f05f7";
}

.mdi-hiking::before {
  content: "\\f0d7f";
}

.mdi-history::before {
  content: "\\f02da";
}

.mdi-hockey-puck::before {
  content: "\\f0879";
}

.mdi-hockey-sticks::before {
  content: "\\f087a";
}

.mdi-hololens::before {
  content: "\\f02db";
}

.mdi-home::before {
  content: "\\f02dc";
}

.mdi-home-account::before {
  content: "\\f0826";
}

.mdi-home-alert::before {
  content: "\\f087b";
}

.mdi-home-alert-outline::before {
  content: "\\f15d0";
}

.mdi-home-analytics::before {
  content: "\\f0eba";
}

.mdi-home-assistant::before {
  content: "\\f07d0";
}

.mdi-home-automation::before {
  content: "\\f07d1";
}

.mdi-home-battery::before {
  content: "\\f1901";
}

.mdi-home-battery-outline::before {
  content: "\\f1902";
}

.mdi-home-circle::before {
  content: "\\f07d2";
}

.mdi-home-circle-outline::before {
  content: "\\f104d";
}

.mdi-home-city::before {
  content: "\\f0d15";
}

.mdi-home-city-outline::before {
  content: "\\f0d16";
}

.mdi-home-edit::before {
  content: "\\f1159";
}

.mdi-home-edit-outline::before {
  content: "\\f115a";
}

.mdi-home-export-outline::before {
  content: "\\f0f9b";
}

.mdi-home-flood::before {
  content: "\\f0efa";
}

.mdi-home-floor-0::before {
  content: "\\f0dd2";
}

.mdi-home-floor-1::before {
  content: "\\f0d80";
}

.mdi-home-floor-2::before {
  content: "\\f0d81";
}

.mdi-home-floor-3::before {
  content: "\\f0d82";
}

.mdi-home-floor-a::before {
  content: "\\f0d83";
}

.mdi-home-floor-b::before {
  content: "\\f0d84";
}

.mdi-home-floor-g::before {
  content: "\\f0d85";
}

.mdi-home-floor-l::before {
  content: "\\f0d86";
}

.mdi-home-floor-negative-1::before {
  content: "\\f0dd3";
}

.mdi-home-group::before {
  content: "\\f0dd4";
}

.mdi-home-group-minus::before {
  content: "\\f19c1";
}

.mdi-home-group-plus::before {
  content: "\\f19c0";
}

.mdi-home-group-remove::before {
  content: "\\f19c2";
}

.mdi-home-heart::before {
  content: "\\f0827";
}

.mdi-home-import-outline::before {
  content: "\\f0f9c";
}

.mdi-home-lightbulb::before {
  content: "\\f1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\f1252";
}

.mdi-home-lightning-bolt::before {
  content: "\\f1903";
}

.mdi-home-lightning-bolt-outline::before {
  content: "\\f1904";
}

.mdi-home-lock::before {
  content: "\\f08eb";
}

.mdi-home-lock-open::before {
  content: "\\f08ec";
}

.mdi-home-map-marker::before {
  content: "\\f05f8";
}

.mdi-home-minus::before {
  content: "\\f0974";
}

.mdi-home-minus-outline::before {
  content: "\\f13d5";
}

.mdi-home-modern::before {
  content: "\\f02dd";
}

.mdi-home-outline::before {
  content: "\\f06a1";
}

.mdi-home-plus::before {
  content: "\\f0975";
}

.mdi-home-plus-outline::before {
  content: "\\f13d6";
}

.mdi-home-remove::before {
  content: "\\f1247";
}

.mdi-home-remove-outline::before {
  content: "\\f13d7";
}

.mdi-home-roof::before {
  content: "\\f112b";
}

.mdi-home-search::before {
  content: "\\f13b0";
}

.mdi-home-search-outline::before {
  content: "\\f13b1";
}

.mdi-home-switch::before {
  content: "\\f1794";
}

.mdi-home-switch-outline::before {
  content: "\\f1795";
}

.mdi-home-thermometer::before {
  content: "\\f0f54";
}

.mdi-home-thermometer-outline::before {
  content: "\\f0f55";
}

.mdi-home-variant::before {
  content: "\\f02de";
}

.mdi-home-variant-outline::before {
  content: "\\f0ba7";
}

.mdi-hook::before {
  content: "\\f06e2";
}

.mdi-hook-off::before {
  content: "\\f06e3";
}

.mdi-hoop-house::before {
  content: "\\f0e56";
}

.mdi-hops::before {
  content: "\\f02df";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\f10f3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\f10f4";
}

.mdi-horse::before {
  content: "\\f15bf";
}

.mdi-horse-human::before {
  content: "\\f15c0";
}

.mdi-horse-variant::before {
  content: "\\f15c1";
}

.mdi-horse-variant-fast::before {
  content: "\\f186e";
}

.mdi-horseshoe::before {
  content: "\\f0a58";
}

.mdi-hospital::before {
  content: "\\f0ff6";
}

.mdi-hospital-box::before {
  content: "\\f02e0";
}

.mdi-hospital-box-outline::before {
  content: "\\f0ff7";
}

.mdi-hospital-building::before {
  content: "\\f02e1";
}

.mdi-hospital-marker::before {
  content: "\\f02e2";
}

.mdi-hot-tub::before {
  content: "\\f0828";
}

.mdi-hours-24::before {
  content: "\\f1478";
}

.mdi-hubspot::before {
  content: "\\f0d17";
}

.mdi-hulu::before {
  content: "\\f0829";
}

.mdi-human::before {
  content: "\\f02e6";
}

.mdi-human-baby-changing-table::before {
  content: "\\f138b";
}

.mdi-human-cane::before {
  content: "\\f1581";
}

.mdi-human-capacity-decrease::before {
  content: "\\f159b";
}

.mdi-human-capacity-increase::before {
  content: "\\f159c";
}

.mdi-human-child::before {
  content: "\\f02e7";
}

.mdi-human-dolly::before {
  content: "\\f1980";
}

.mdi-human-edit::before {
  content: "\\f14e8";
}

.mdi-human-female::before {
  content: "\\f0649";
}

.mdi-human-female-boy::before {
  content: "\\f0a59";
}

.mdi-human-female-dance::before {
  content: "\\f15c9";
}

.mdi-human-female-female::before {
  content: "\\f0a5a";
}

.mdi-human-female-girl::before {
  content: "\\f0a5b";
}

.mdi-human-greeting::before {
  content: "\\f17c4";
}

.mdi-human-greeting-proximity::before {
  content: "\\f159d";
}

.mdi-human-greeting-variant::before {
  content: "\\f064a";
}

.mdi-human-handsdown::before {
  content: "\\f064b";
}

.mdi-human-handsup::before {
  content: "\\f064c";
}

.mdi-human-male::before {
  content: "\\f064d";
}

.mdi-human-male-board::before {
  content: "\\f0890";
}

.mdi-human-male-board-poll::before {
  content: "\\f0846";
}

.mdi-human-male-boy::before {
  content: "\\f0a5c";
}

.mdi-human-male-child::before {
  content: "\\f138c";
}

.mdi-human-male-female::before {
  content: "\\f02e8";
}

.mdi-human-male-female-child::before {
  content: "\\f1823";
}

.mdi-human-male-girl::before {
  content: "\\f0a5d";
}

.mdi-human-male-height::before {
  content: "\\f0efb";
}

.mdi-human-male-height-variant::before {
  content: "\\f0efc";
}

.mdi-human-male-male::before {
  content: "\\f0a5e";
}

.mdi-human-non-binary::before {
  content: "\\f1848";
}

.mdi-human-pregnant::before {
  content: "\\f05cf";
}

.mdi-human-queue::before {
  content: "\\f1571";
}

.mdi-human-scooter::before {
  content: "\\f11e9";
}

.mdi-human-wheelchair::before {
  content: "\\f138d";
}

.mdi-human-white-cane::before {
  content: "\\f1981";
}

.mdi-humble-bundle::before {
  content: "\\f0744";
}

.mdi-hvac::before {
  content: "\\f1352";
}

.mdi-hvac-off::before {
  content: "\\f159e";
}

.mdi-hydraulic-oil-level::before {
  content: "\\f1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\f1325";
}

.mdi-hydro-power::before {
  content: "\\f12e5";
}

.mdi-hydrogen-station::before {
  content: "\\f1894";
}

.mdi-ice-cream::before {
  content: "\\f082a";
}

.mdi-ice-cream-off::before {
  content: "\\f0e52";
}

.mdi-ice-pop::before {
  content: "\\f0efd";
}

.mdi-id-card::before {
  content: "\\f0fc0";
}

.mdi-identifier::before {
  content: "\\f0efe";
}

.mdi-ideogram-cjk::before {
  content: "\\f1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\f1332";
}

.mdi-image::before {
  content: "\\f02e9";
}

.mdi-image-album::before {
  content: "\\f02ea";
}

.mdi-image-area::before {
  content: "\\f02eb";
}

.mdi-image-area-close::before {
  content: "\\f02ec";
}

.mdi-image-auto-adjust::before {
  content: "\\f0fc1";
}

.mdi-image-broken::before {
  content: "\\f02ed";
}

.mdi-image-broken-variant::before {
  content: "\\f02ee";
}

.mdi-image-edit::before {
  content: "\\f11e3";
}

.mdi-image-edit-outline::before {
  content: "\\f11e4";
}

.mdi-image-filter-black-white::before {
  content: "\\f02f0";
}

.mdi-image-filter-center-focus::before {
  content: "\\f02f1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\f0eff";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\f0f00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\f02f2";
}

.mdi-image-filter-drama::before {
  content: "\\f02f3";
}

.mdi-image-filter-frames::before {
  content: "\\f02f4";
}

.mdi-image-filter-hdr::before {
  content: "\\f02f5";
}

.mdi-image-filter-none::before {
  content: "\\f02f6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\f02f7";
}

.mdi-image-filter-vintage::before {
  content: "\\f02f8";
}

.mdi-image-frame::before {
  content: "\\f0e49";
}

.mdi-image-marker::before {
  content: "\\f177b";
}

.mdi-image-marker-outline::before {
  content: "\\f177c";
}

.mdi-image-minus::before {
  content: "\\f1419";
}

.mdi-image-move::before {
  content: "\\f09f8";
}

.mdi-image-multiple::before {
  content: "\\f02f9";
}

.mdi-image-multiple-outline::before {
  content: "\\f02ef";
}

.mdi-image-off::before {
  content: "\\f082b";
}

.mdi-image-off-outline::before {
  content: "\\f11d1";
}

.mdi-image-outline::before {
  content: "\\f0976";
}

.mdi-image-plus::before {
  content: "\\f087c";
}

.mdi-image-remove::before {
  content: "\\f1418";
}

.mdi-image-search::before {
  content: "\\f0977";
}

.mdi-image-search-outline::before {
  content: "\\f0978";
}

.mdi-image-size-select-actual::before {
  content: "\\f0c8d";
}

.mdi-image-size-select-large::before {
  content: "\\f0c8e";
}

.mdi-image-size-select-small::before {
  content: "\\f0c8f";
}

.mdi-image-text::before {
  content: "\\f160d";
}

.mdi-import::before {
  content: "\\f02fa";
}

.mdi-inbox::before {
  content: "\\f0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\f02fb";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\f1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\f03d1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\f1271";
}

.mdi-inbox-full::before {
  content: "\\f1272";
}

.mdi-inbox-full-outline::before {
  content: "\\f1273";
}

.mdi-inbox-multiple::before {
  content: "\\f08b0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\f0ba8";
}

.mdi-inbox-outline::before {
  content: "\\f1274";
}

.mdi-inbox-remove::before {
  content: "\\f159f";
}

.mdi-inbox-remove-outline::before {
  content: "\\f15a0";
}

.mdi-incognito::before {
  content: "\\f05f9";
}

.mdi-incognito-circle::before {
  content: "\\f1421";
}

.mdi-incognito-circle-off::before {
  content: "\\f1422";
}

.mdi-incognito-off::before {
  content: "\\f0075";
}

.mdi-induction::before {
  content: "\\f184c";
}

.mdi-infinity::before {
  content: "\\f06e4";
}

.mdi-information::before {
  content: "\\f02fc";
}

.mdi-information-off::before {
  content: "\\f178c";
}

.mdi-information-off-outline::before {
  content: "\\f178d";
}

.mdi-information-outline::before {
  content: "\\f02fd";
}

.mdi-information-variant::before {
  content: "\\f064e";
}

.mdi-instagram::before {
  content: "\\f02fe";
}

.mdi-instrument-triangle::before {
  content: "\\f104e";
}

.mdi-integrated-circuit-chip::before {
  content: "\\f1913";
}

.mdi-invert-colors::before {
  content: "\\f0301";
}

.mdi-invert-colors-off::before {
  content: "\\f0e4a";
}

.mdi-iobroker::before {
  content: "\\f12e8";
}

.mdi-ip::before {
  content: "\\f0a5f";
}

.mdi-ip-network::before {
  content: "\\f0a60";
}

.mdi-ip-network-outline::before {
  content: "\\f0c90";
}

.mdi-ip-outline::before {
  content: "\\f1982";
}

.mdi-ipod::before {
  content: "\\f0c91";
}

.mdi-iron::before {
  content: "\\f1824";
}

.mdi-iron-board::before {
  content: "\\f1838";
}

.mdi-iron-outline::before {
  content: "\\f1825";
}

.mdi-island::before {
  content: "\\f104f";
}

.mdi-iv-bag::before {
  content: "\\f10b9";
}

.mdi-jabber::before {
  content: "\\f0dd5";
}

.mdi-jeepney::before {
  content: "\\f0302";
}

.mdi-jellyfish::before {
  content: "\\f0f01";
}

.mdi-jellyfish-outline::before {
  content: "\\f0f02";
}

.mdi-jira::before {
  content: "\\f0303";
}

.mdi-jquery::before {
  content: "\\f087d";
}

.mdi-jsfiddle::before {
  content: "\\f0304";
}

.mdi-jump-rope::before {
  content: "\\f12ff";
}

.mdi-kabaddi::before {
  content: "\\f0d87";
}

.mdi-kangaroo::before {
  content: "\\f1558";
}

.mdi-karate::before {
  content: "\\f082c";
}

.mdi-kayaking::before {
  content: "\\f08af";
}

.mdi-keg::before {
  content: "\\f0305";
}

.mdi-kettle::before {
  content: "\\f05fa";
}

.mdi-kettle-alert::before {
  content: "\\f1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\f1318";
}

.mdi-kettle-off::before {
  content: "\\f131b";
}

.mdi-kettle-off-outline::before {
  content: "\\f131c";
}

.mdi-kettle-outline::before {
  content: "\\f0f56";
}

.mdi-kettle-pour-over::before {
  content: "\\f173c";
}

.mdi-kettle-steam::before {
  content: "\\f1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\f131a";
}

.mdi-kettlebell::before {
  content: "\\f1300";
}

.mdi-key::before {
  content: "\\f0306";
}

.mdi-key-alert::before {
  content: "\\f1983";
}

.mdi-key-alert-outline::before {
  content: "\\f1984";
}

.mdi-key-arrow-right::before {
  content: "\\f1312";
}

.mdi-key-chain::before {
  content: "\\f1574";
}

.mdi-key-chain-variant::before {
  content: "\\f1575";
}

.mdi-key-change::before {
  content: "\\f0307";
}

.mdi-key-link::before {
  content: "\\f119f";
}

.mdi-key-minus::before {
  content: "\\f0308";
}

.mdi-key-outline::before {
  content: "\\f0dd6";
}

.mdi-key-plus::before {
  content: "\\f0309";
}

.mdi-key-remove::before {
  content: "\\f030a";
}

.mdi-key-star::before {
  content: "\\f119e";
}

.mdi-key-variant::before {
  content: "\\f030b";
}

.mdi-key-wireless::before {
  content: "\\f0fc2";
}

.mdi-keyboard::before {
  content: "\\f030c";
}

.mdi-keyboard-backspace::before {
  content: "\\f030d";
}

.mdi-keyboard-caps::before {
  content: "\\f030e";
}

.mdi-keyboard-close::before {
  content: "\\f030f";
}

.mdi-keyboard-esc::before {
  content: "\\f12b7";
}

.mdi-keyboard-f1::before {
  content: "\\f12ab";
}

.mdi-keyboard-f10::before {
  content: "\\f12b4";
}

.mdi-keyboard-f11::before {
  content: "\\f12b5";
}

.mdi-keyboard-f12::before {
  content: "\\f12b6";
}

.mdi-keyboard-f2::before {
  content: "\\f12ac";
}

.mdi-keyboard-f3::before {
  content: "\\f12ad";
}

.mdi-keyboard-f4::before {
  content: "\\f12ae";
}

.mdi-keyboard-f5::before {
  content: "\\f12af";
}

.mdi-keyboard-f6::before {
  content: "\\f12b0";
}

.mdi-keyboard-f7::before {
  content: "\\f12b1";
}

.mdi-keyboard-f8::before {
  content: "\\f12b2";
}

.mdi-keyboard-f9::before {
  content: "\\f12b3";
}

.mdi-keyboard-off::before {
  content: "\\f0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\f0e4b";
}

.mdi-keyboard-outline::before {
  content: "\\f097b";
}

.mdi-keyboard-return::before {
  content: "\\f0311";
}

.mdi-keyboard-settings::before {
  content: "\\f09f9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\f09fa";
}

.mdi-keyboard-space::before {
  content: "\\f1050";
}

.mdi-keyboard-tab::before {
  content: "\\f0312";
}

.mdi-keyboard-tab-reverse::before {
  content: "\\f0325";
}

.mdi-keyboard-variant::before {
  content: "\\f0313";
}

.mdi-khanda::before {
  content: "\\f10fd";
}

.mdi-kickstarter::before {
  content: "\\f0745";
}

.mdi-kite::before {
  content: "\\f1985";
}

.mdi-kite-outline::before {
  content: "\\f1986";
}

.mdi-kitesurfing::before {
  content: "\\f1744";
}

.mdi-klingon::before {
  content: "\\f135b";
}

.mdi-knife::before {
  content: "\\f09fb";
}

.mdi-knife-military::before {
  content: "\\f09fc";
}

.mdi-koala::before {
  content: "\\f173f";
}

.mdi-kodi::before {
  content: "\\f0314";
}

.mdi-kubernetes::before {
  content: "\\f10fe";
}

.mdi-label::before {
  content: "\\f0315";
}

.mdi-label-multiple::before {
  content: "\\f1375";
}

.mdi-label-multiple-outline::before {
  content: "\\f1376";
}

.mdi-label-off::before {
  content: "\\f0acb";
}

.mdi-label-off-outline::before {
  content: "\\f0acc";
}

.mdi-label-outline::before {
  content: "\\f0316";
}

.mdi-label-percent::before {
  content: "\\f12ea";
}

.mdi-label-percent-outline::before {
  content: "\\f12eb";
}

.mdi-label-variant::before {
  content: "\\f0acd";
}

.mdi-label-variant-outline::before {
  content: "\\f0ace";
}

.mdi-ladder::before {
  content: "\\f15a2";
}

.mdi-ladybug::before {
  content: "\\f082d";
}

.mdi-lambda::before {
  content: "\\f0627";
}

.mdi-lamp::before {
  content: "\\f06b5";
}

.mdi-lamp-outline::before {
  content: "\\f17d0";
}

.mdi-lamps::before {
  content: "\\f1576";
}

.mdi-lamps-outline::before {
  content: "\\f17d1";
}

.mdi-lan::before {
  content: "\\f0317";
}

.mdi-lan-check::before {
  content: "\\f12aa";
}

.mdi-lan-connect::before {
  content: "\\f0318";
}

.mdi-lan-disconnect::before {
  content: "\\f0319";
}

.mdi-lan-pending::before {
  content: "\\f031a";
}

.mdi-language-c::before {
  content: "\\f0671";
}

.mdi-language-cpp::before {
  content: "\\f0672";
}

.mdi-language-csharp::before {
  content: "\\f031b";
}

.mdi-language-css3::before {
  content: "\\f031c";
}

.mdi-language-fortran::before {
  content: "\\f121a";
}

.mdi-language-go::before {
  content: "\\f07d3";
}

.mdi-language-haskell::before {
  content: "\\f0c92";
}

.mdi-language-html5::before {
  content: "\\f031d";
}

.mdi-language-java::before {
  content: "\\f0b37";
}

.mdi-language-javascript::before {
  content: "\\f031e";
}

.mdi-language-kotlin::before {
  content: "\\f1219";
}

.mdi-language-lua::before {
  content: "\\f08b1";
}

.mdi-language-markdown::before {
  content: "\\f0354";
}

.mdi-language-markdown-outline::before {
  content: "\\f0f5b";
}

.mdi-language-php::before {
  content: "\\f031f";
}

.mdi-language-python::before {
  content: "\\f0320";
}

.mdi-language-r::before {
  content: "\\f07d4";
}

.mdi-language-ruby::before {
  content: "\\f0d2d";
}

.mdi-language-ruby-on-rails::before {
  content: "\\f0acf";
}

.mdi-language-rust::before {
  content: "\\f1617";
}

.mdi-language-swift::before {
  content: "\\f06e5";
}

.mdi-language-typescript::before {
  content: "\\f06e6";
}

.mdi-language-xaml::before {
  content: "\\f0673";
}

.mdi-laptop::before {
  content: "\\f0322";
}

.mdi-laptop-off::before {
  content: "\\f06e7";
}

.mdi-laravel::before {
  content: "\\f0ad0";
}

.mdi-laser-pointer::before {
  content: "\\f1484";
}

.mdi-lasso::before {
  content: "\\f0f03";
}

.mdi-lastpass::before {
  content: "\\f0446";
}

.mdi-latitude::before {
  content: "\\f0f57";
}

.mdi-launch::before {
  content: "\\f0327";
}

.mdi-lava-lamp::before {
  content: "\\f07d5";
}

.mdi-layers::before {
  content: "\\f0328";
}

.mdi-layers-edit::before {
  content: "\\f1892";
}

.mdi-layers-minus::before {
  content: "\\f0e4c";
}

.mdi-layers-off::before {
  content: "\\f0329";
}

.mdi-layers-off-outline::before {
  content: "\\f09fd";
}

.mdi-layers-outline::before {
  content: "\\f09fe";
}

.mdi-layers-plus::before {
  content: "\\f0e4d";
}

.mdi-layers-remove::before {
  content: "\\f0e4e";
}

.mdi-layers-search::before {
  content: "\\f1206";
}

.mdi-layers-search-outline::before {
  content: "\\f1207";
}

.mdi-layers-triple::before {
  content: "\\f0f58";
}

.mdi-layers-triple-outline::before {
  content: "\\f0f59";
}

.mdi-lead-pencil::before {
  content: "\\f064f";
}

.mdi-leaf::before {
  content: "\\f032a";
}

.mdi-leaf-circle::before {
  content: "\\f1905";
}

.mdi-leaf-circle-outline::before {
  content: "\\f1906";
}

.mdi-leaf-maple::before {
  content: "\\f0c93";
}

.mdi-leaf-maple-off::before {
  content: "\\f12da";
}

.mdi-leaf-off::before {
  content: "\\f12d9";
}

.mdi-leak::before {
  content: "\\f0dd7";
}

.mdi-leak-off::before {
  content: "\\f0dd8";
}

.mdi-led-off::before {
  content: "\\f032b";
}

.mdi-led-on::before {
  content: "\\f032c";
}

.mdi-led-outline::before {
  content: "\\f032d";
}

.mdi-led-strip::before {
  content: "\\f07d6";
}

.mdi-led-strip-variant::before {
  content: "\\f1051";
}

.mdi-led-variant-off::before {
  content: "\\f032e";
}

.mdi-led-variant-on::before {
  content: "\\f032f";
}

.mdi-led-variant-outline::before {
  content: "\\f0330";
}

.mdi-leek::before {
  content: "\\f117d";
}

.mdi-less-than::before {
  content: "\\f097c";
}

.mdi-less-than-or-equal::before {
  content: "\\f097d";
}

.mdi-library::before {
  content: "\\f0331";
}

.mdi-library-shelves::before {
  content: "\\f0ba9";
}

.mdi-license::before {
  content: "\\f0fc3";
}

.mdi-lifebuoy::before {
  content: "\\f087e";
}

.mdi-light-flood-down::before {
  content: "\\f1987";
}

.mdi-light-flood-up::before {
  content: "\\f1988";
}

.mdi-light-recessed::before {
  content: "\\f179b";
}

.mdi-light-switch::before {
  content: "\\f097e";
}

.mdi-lightbulb::before {
  content: "\\f0335";
}

.mdi-lightbulb-auto::before {
  content: "\\f1800";
}

.mdi-lightbulb-auto-outline::before {
  content: "\\f1801";
}

.mdi-lightbulb-cfl::before {
  content: "\\f1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\f1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\f1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\f12c3";
}

.mdi-lightbulb-fluorescent-tube::before {
  content: "\\f1804";
}

.mdi-lightbulb-fluorescent-tube-outline::before {
  content: "\\f1805";
}

.mdi-lightbulb-group::before {
  content: "\\f1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\f12cd";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\f12ce";
}

.mdi-lightbulb-group-outline::before {
  content: "\\f1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\f1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\f12cf";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\f12d0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\f1256";
}

.mdi-lightbulb-off::before {
  content: "\\f0e4f";
}

.mdi-lightbulb-off-outline::before {
  content: "\\f0e50";
}

.mdi-lightbulb-on::before {
  content: "\\f06e8";
}

.mdi-lightbulb-on-outline::before {
  content: "\\f06e9";
}

.mdi-lightbulb-outline::before {
  content: "\\f0336";
}

.mdi-lightbulb-spot::before {
  content: "\\f17f4";
}

.mdi-lightbulb-spot-off::before {
  content: "\\f17f5";
}

.mdi-lightbulb-variant::before {
  content: "\\f1802";
}

.mdi-lightbulb-variant-outline::before {
  content: "\\f1803";
}

.mdi-lighthouse::before {
  content: "\\f09ff";
}

.mdi-lighthouse-on::before {
  content: "\\f0a00";
}

.mdi-lightning-bolt::before {
  content: "\\f140b";
}

.mdi-lightning-bolt-circle::before {
  content: "\\f0820";
}

.mdi-lightning-bolt-outline::before {
  content: "\\f140c";
}

.mdi-line-scan::before {
  content: "\\f0624";
}

.mdi-lingerie::before {
  content: "\\f1476";
}

.mdi-link::before {
  content: "\\f0337";
}

.mdi-link-box::before {
  content: "\\f0d1a";
}

.mdi-link-box-outline::before {
  content: "\\f0d1b";
}

.mdi-link-box-variant::before {
  content: "\\f0d1c";
}

.mdi-link-box-variant-outline::before {
  content: "\\f0d1d";
}

.mdi-link-lock::before {
  content: "\\f10ba";
}

.mdi-link-off::before {
  content: "\\f0338";
}

.mdi-link-plus::before {
  content: "\\f0c94";
}

.mdi-link-variant::before {
  content: "\\f0339";
}

.mdi-link-variant-minus::before {
  content: "\\f10ff";
}

.mdi-link-variant-off::before {
  content: "\\f033a";
}

.mdi-link-variant-plus::before {
  content: "\\f1100";
}

.mdi-link-variant-remove::before {
  content: "\\f1101";
}

.mdi-linkedin::before {
  content: "\\f033b";
}

.mdi-linux::before {
  content: "\\f033d";
}

.mdi-linux-mint::before {
  content: "\\f08ed";
}

.mdi-lipstick::before {
  content: "\\f13b5";
}

.mdi-liquid-spot::before {
  content: "\\f1826";
}

.mdi-liquor::before {
  content: "\\f191e";
}

.mdi-list-status::before {
  content: "\\f15ab";
}

.mdi-litecoin::before {
  content: "\\f0a61";
}

.mdi-loading::before {
  content: "\\f0772";
}

.mdi-location-enter::before {
  content: "\\f0fc4";
}

.mdi-location-exit::before {
  content: "\\f0fc5";
}

.mdi-lock::before {
  content: "\\f033e";
}

.mdi-lock-alert::before {
  content: "\\f08ee";
}

.mdi-lock-alert-outline::before {
  content: "\\f15d1";
}

.mdi-lock-check::before {
  content: "\\f139a";
}

.mdi-lock-check-outline::before {
  content: "\\f16a8";
}

.mdi-lock-clock::before {
  content: "\\f097f";
}

.mdi-lock-minus::before {
  content: "\\f16a9";
}

.mdi-lock-minus-outline::before {
  content: "\\f16aa";
}

.mdi-lock-off::before {
  content: "\\f1671";
}

.mdi-lock-off-outline::before {
  content: "\\f1672";
}

.mdi-lock-open::before {
  content: "\\f033f";
}

.mdi-lock-open-alert::before {
  content: "\\f139b";
}

.mdi-lock-open-alert-outline::before {
  content: "\\f15d2";
}

.mdi-lock-open-check::before {
  content: "\\f139c";
}

.mdi-lock-open-check-outline::before {
  content: "\\f16ab";
}

.mdi-lock-open-minus::before {
  content: "\\f16ac";
}

.mdi-lock-open-minus-outline::before {
  content: "\\f16ad";
}

.mdi-lock-open-outline::before {
  content: "\\f0340";
}

.mdi-lock-open-plus::before {
  content: "\\f16ae";
}

.mdi-lock-open-plus-outline::before {
  content: "\\f16af";
}

.mdi-lock-open-remove::before {
  content: "\\f16b0";
}

.mdi-lock-open-remove-outline::before {
  content: "\\f16b1";
}

.mdi-lock-open-variant::before {
  content: "\\f0fc6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\f0fc7";
}

.mdi-lock-outline::before {
  content: "\\f0341";
}

.mdi-lock-pattern::before {
  content: "\\f06ea";
}

.mdi-lock-plus::before {
  content: "\\f05fb";
}

.mdi-lock-plus-outline::before {
  content: "\\f16b2";
}

.mdi-lock-question::before {
  content: "\\f08ef";
}

.mdi-lock-remove::before {
  content: "\\f16b3";
}

.mdi-lock-remove-outline::before {
  content: "\\f16b4";
}

.mdi-lock-reset::before {
  content: "\\f0773";
}

.mdi-lock-smart::before {
  content: "\\f08b2";
}

.mdi-locker::before {
  content: "\\f07d7";
}

.mdi-locker-multiple::before {
  content: "\\f07d8";
}

.mdi-login::before {
  content: "\\f0342";
}

.mdi-login-variant::before {
  content: "\\f05fc";
}

.mdi-logout::before {
  content: "\\f0343";
}

.mdi-logout-variant::before {
  content: "\\f05fd";
}

.mdi-longitude::before {
  content: "\\f0f5a";
}

.mdi-looks::before {
  content: "\\f0344";
}

.mdi-lotion::before {
  content: "\\f1582";
}

.mdi-lotion-outline::before {
  content: "\\f1583";
}

.mdi-lotion-plus::before {
  content: "\\f1584";
}

.mdi-lotion-plus-outline::before {
  content: "\\f1585";
}

.mdi-loupe::before {
  content: "\\f0345";
}

.mdi-lumx::before {
  content: "\\f0346";
}

.mdi-lungs::before {
  content: "\\f1084";
}

.mdi-mace::before {
  content: "\\f1843";
}

.mdi-magazine-pistol::before {
  content: "\\f0324";
}

.mdi-magazine-rifle::before {
  content: "\\f0323";
}

.mdi-magic-staff::before {
  content: "\\f1844";
}

.mdi-magnet::before {
  content: "\\f0347";
}

.mdi-magnet-on::before {
  content: "\\f0348";
}

.mdi-magnify::before {
  content: "\\f0349";
}

.mdi-magnify-close::before {
  content: "\\f0980";
}

.mdi-magnify-expand::before {
  content: "\\f1874";
}

.mdi-magnify-minus::before {
  content: "\\f034a";
}

.mdi-magnify-minus-cursor::before {
  content: "\\f0a62";
}

.mdi-magnify-minus-outline::before {
  content: "\\f06ec";
}

.mdi-magnify-plus::before {
  content: "\\f034b";
}

.mdi-magnify-plus-cursor::before {
  content: "\\f0a63";
}

.mdi-magnify-plus-outline::before {
  content: "\\f06ed";
}

.mdi-magnify-remove-cursor::before {
  content: "\\f120c";
}

.mdi-magnify-remove-outline::before {
  content: "\\f120d";
}

.mdi-magnify-scan::before {
  content: "\\f1276";
}

.mdi-mail::before {
  content: "\\f0ebb";
}

.mdi-mailbox::before {
  content: "\\f06ee";
}

.mdi-mailbox-open::before {
  content: "\\f0d88";
}

.mdi-mailbox-open-outline::before {
  content: "\\f0d89";
}

.mdi-mailbox-open-up::before {
  content: "\\f0d8a";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\f0d8b";
}

.mdi-mailbox-outline::before {
  content: "\\f0d8c";
}

.mdi-mailbox-up::before {
  content: "\\f0d8d";
}

.mdi-mailbox-up-outline::before {
  content: "\\f0d8e";
}

.mdi-manjaro::before {
  content: "\\f160a";
}

.mdi-map::before {
  content: "\\f034d";
}

.mdi-map-check::before {
  content: "\\f0ebc";
}

.mdi-map-check-outline::before {
  content: "\\f0ebd";
}

.mdi-map-clock::before {
  content: "\\f0d1e";
}

.mdi-map-clock-outline::before {
  content: "\\f0d1f";
}

.mdi-map-legend::before {
  content: "\\f0a01";
}

.mdi-map-marker::before {
  content: "\\f034e";
}

.mdi-map-marker-account::before {
  content: "\\f18e3";
}

.mdi-map-marker-account-outline::before {
  content: "\\f18e4";
}

.mdi-map-marker-alert::before {
  content: "\\f0f05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\f0f06";
}

.mdi-map-marker-check::before {
  content: "\\f0c95";
}

.mdi-map-marker-check-outline::before {
  content: "\\f12fb";
}

.mdi-map-marker-circle::before {
  content: "\\f034f";
}

.mdi-map-marker-distance::before {
  content: "\\f08f0";
}

.mdi-map-marker-down::before {
  content: "\\f1102";
}

.mdi-map-marker-left::before {
  content: "\\f12db";
}

.mdi-map-marker-left-outline::before {
  content: "\\f12dd";
}

.mdi-map-marker-minus::before {
  content: "\\f0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\f12f9";
}

.mdi-map-marker-multiple::before {
  content: "\\f0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\f1277";
}

.mdi-map-marker-off::before {
  content: "\\f0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\f12fd";
}

.mdi-map-marker-outline::before {
  content: "\\f07d9";
}

.mdi-map-marker-path::before {
  content: "\\f0d20";
}

.mdi-map-marker-plus::before {
  content: "\\f0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\f12f8";
}

.mdi-map-marker-question::before {
  content: "\\f0f07";
}

.mdi-map-marker-question-outline::before {
  content: "\\f0f08";
}

.mdi-map-marker-radius::before {
  content: "\\f0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\f12fc";
}

.mdi-map-marker-remove::before {
  content: "\\f0f09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\f12fa";
}

.mdi-map-marker-remove-variant::before {
  content: "\\f0f0a";
}

.mdi-map-marker-right::before {
  content: "\\f12dc";
}

.mdi-map-marker-right-outline::before {
  content: "\\f12de";
}

.mdi-map-marker-star::before {
  content: "\\f1608";
}

.mdi-map-marker-star-outline::before {
  content: "\\f1609";
}

.mdi-map-marker-up::before {
  content: "\\f1103";
}

.mdi-map-minus::before {
  content: "\\f0981";
}

.mdi-map-outline::before {
  content: "\\f0982";
}

.mdi-map-plus::before {
  content: "\\f0983";
}

.mdi-map-search::before {
  content: "\\f0984";
}

.mdi-map-search-outline::before {
  content: "\\f0985";
}

.mdi-mapbox::before {
  content: "\\f0baa";
}

.mdi-margin::before {
  content: "\\f0353";
}

.mdi-marker::before {
  content: "\\f0652";
}

.mdi-marker-cancel::before {
  content: "\\f0dd9";
}

.mdi-marker-check::before {
  content: "\\f0355";
}

.mdi-mastodon::before {
  content: "\\f0ad1";
}

.mdi-material-design::before {
  content: "\\f0986";
}

.mdi-material-ui::before {
  content: "\\f0357";
}

.mdi-math-compass::before {
  content: "\\f0358";
}

.mdi-math-cos::before {
  content: "\\f0c96";
}

.mdi-math-integral::before {
  content: "\\f0fc8";
}

.mdi-math-integral-box::before {
  content: "\\f0fc9";
}

.mdi-math-log::before {
  content: "\\f1085";
}

.mdi-math-norm::before {
  content: "\\f0fca";
}

.mdi-math-norm-box::before {
  content: "\\f0fcb";
}

.mdi-math-sin::before {
  content: "\\f0c97";
}

.mdi-math-tan::before {
  content: "\\f0c98";
}

.mdi-matrix::before {
  content: "\\f0628";
}

.mdi-medal::before {
  content: "\\f0987";
}

.mdi-medal-outline::before {
  content: "\\f1326";
}

.mdi-medical-bag::before {
  content: "\\f06ef";
}

.mdi-meditation::before {
  content: "\\f117b";
}

.mdi-memory::before {
  content: "\\f035b";
}

.mdi-menorah::before {
  content: "\\f17d4";
}

.mdi-menorah-fire::before {
  content: "\\f17d5";
}

.mdi-menu::before {
  content: "\\f035c";
}

.mdi-menu-down::before {
  content: "\\f035d";
}

.mdi-menu-down-outline::before {
  content: "\\f06b6";
}

.mdi-menu-left::before {
  content: "\\f035e";
}

.mdi-menu-left-outline::before {
  content: "\\f0a02";
}

.mdi-menu-open::before {
  content: "\\f0bab";
}

.mdi-menu-right::before {
  content: "\\f035f";
}

.mdi-menu-right-outline::before {
  content: "\\f0a03";
}

.mdi-menu-swap::before {
  content: "\\f0a64";
}

.mdi-menu-swap-outline::before {
  content: "\\f0a65";
}

.mdi-menu-up::before {
  content: "\\f0360";
}

.mdi-menu-up-outline::before {
  content: "\\f06b7";
}

.mdi-merge::before {
  content: "\\f0f5c";
}

.mdi-message::before {
  content: "\\f0361";
}

.mdi-message-alert::before {
  content: "\\f0362";
}

.mdi-message-alert-outline::before {
  content: "\\f0a04";
}

.mdi-message-arrow-left::before {
  content: "\\f12f2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\f12f3";
}

.mdi-message-arrow-right::before {
  content: "\\f12f4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\f12f5";
}

.mdi-message-badge::before {
  content: "\\f1941";
}

.mdi-message-badge-outline::before {
  content: "\\f1942";
}

.mdi-message-bookmark::before {
  content: "\\f15ac";
}

.mdi-message-bookmark-outline::before {
  content: "\\f15ad";
}

.mdi-message-bulleted::before {
  content: "\\f06a2";
}

.mdi-message-bulleted-off::before {
  content: "\\f06a3";
}

.mdi-message-cog::before {
  content: "\\f06f1";
}

.mdi-message-cog-outline::before {
  content: "\\f1172";
}

.mdi-message-draw::before {
  content: "\\f0363";
}

.mdi-message-flash::before {
  content: "\\f15a9";
}

.mdi-message-flash-outline::before {
  content: "\\f15aa";
}

.mdi-message-image::before {
  content: "\\f0364";
}

.mdi-message-image-outline::before {
  content: "\\f116c";
}

.mdi-message-lock::before {
  content: "\\f0fcc";
}

.mdi-message-lock-outline::before {
  content: "\\f116d";
}

.mdi-message-minus::before {
  content: "\\f116e";
}

.mdi-message-minus-outline::before {
  content: "\\f116f";
}

.mdi-message-off::before {
  content: "\\f164d";
}

.mdi-message-off-outline::before {
  content: "\\f164e";
}

.mdi-message-outline::before {
  content: "\\f0365";
}

.mdi-message-plus::before {
  content: "\\f0653";
}

.mdi-message-plus-outline::before {
  content: "\\f10bb";
}

.mdi-message-processing::before {
  content: "\\f0366";
}

.mdi-message-processing-outline::before {
  content: "\\f1170";
}

.mdi-message-question::before {
  content: "\\f173a";
}

.mdi-message-question-outline::before {
  content: "\\f173b";
}

.mdi-message-reply::before {
  content: "\\f0367";
}

.mdi-message-reply-outline::before {
  content: "\\f173d";
}

.mdi-message-reply-text::before {
  content: "\\f0368";
}

.mdi-message-reply-text-outline::before {
  content: "\\f173e";
}

.mdi-message-settings::before {
  content: "\\f06f0";
}

.mdi-message-settings-outline::before {
  content: "\\f1171";
}

.mdi-message-star::before {
  content: "\\f069a";
}

.mdi-message-star-outline::before {
  content: "\\f1250";
}

.mdi-message-text::before {
  content: "\\f0369";
}

.mdi-message-text-clock::before {
  content: "\\f1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\f1174";
}

.mdi-message-text-lock::before {
  content: "\\f0fcd";
}

.mdi-message-text-lock-outline::before {
  content: "\\f1175";
}

.mdi-message-text-outline::before {
  content: "\\f036a";
}

.mdi-message-video::before {
  content: "\\f036b";
}

.mdi-meteor::before {
  content: "\\f0629";
}

.mdi-metronome::before {
  content: "\\f07da";
}

.mdi-metronome-tick::before {
  content: "\\f07db";
}

.mdi-micro-sd::before {
  content: "\\f07dc";
}

.mdi-microphone::before {
  content: "\\f036c";
}

.mdi-microphone-minus::before {
  content: "\\f08b3";
}

.mdi-microphone-off::before {
  content: "\\f036d";
}

.mdi-microphone-outline::before {
  content: "\\f036e";
}

.mdi-microphone-plus::before {
  content: "\\f08b4";
}

.mdi-microphone-question::before {
  content: "\\f1989";
}

.mdi-microphone-question-outline::before {
  content: "\\f198a";
}

.mdi-microphone-settings::before {
  content: "\\f036f";
}

.mdi-microphone-variant::before {
  content: "\\f0370";
}

.mdi-microphone-variant-off::before {
  content: "\\f0371";
}

.mdi-microscope::before {
  content: "\\f0654";
}

.mdi-microsoft::before {
  content: "\\f0372";
}

.mdi-microsoft-access::before {
  content: "\\f138e";
}

.mdi-microsoft-azure::before {
  content: "\\f0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\f0fd5";
}

.mdi-microsoft-bing::before {
  content: "\\f00a4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\f0988";
}

.mdi-microsoft-edge::before {
  content: "\\f01e9";
}

.mdi-microsoft-excel::before {
  content: "\\f138f";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\f0300";
}

.mdi-microsoft-office::before {
  content: "\\f03c6";
}

.mdi-microsoft-onedrive::before {
  content: "\\f03ca";
}

.mdi-microsoft-onenote::before {
  content: "\\f0747";
}

.mdi-microsoft-outlook::before {
  content: "\\f0d22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\f1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\f1391";
}

.mdi-microsoft-teams::before {
  content: "\\f02bb";
}

.mdi-microsoft-visual-studio::before {
  content: "\\f0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\f0a1e";
}

.mdi-microsoft-windows::before {
  content: "\\f05b3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\f0a21";
}

.mdi-microsoft-word::before {
  content: "\\f1392";
}

.mdi-microsoft-xbox::before {
  content: "\\f05b9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\f05ba";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\f074b";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\f0a22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\f074c";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\f074d";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\f074e";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\f074f";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\f0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\f0e6f";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\f05bb";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\f0e70";
}

.mdi-microwave::before {
  content: "\\f0c99";
}

.mdi-microwave-off::before {
  content: "\\f1423";
}

.mdi-middleware::before {
  content: "\\f0f5d";
}

.mdi-middleware-outline::before {
  content: "\\f0f5e";
}

.mdi-midi::before {
  content: "\\f08f1";
}

.mdi-midi-port::before {
  content: "\\f08f2";
}

.mdi-mine::before {
  content: "\\f0dda";
}

.mdi-minecraft::before {
  content: "\\f0373";
}

.mdi-mini-sd::before {
  content: "\\f0a05";
}

.mdi-minidisc::before {
  content: "\\f0a06";
}

.mdi-minus::before {
  content: "\\f0374";
}

.mdi-minus-box::before {
  content: "\\f0375";
}

.mdi-minus-box-multiple::before {
  content: "\\f1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\f1142";
}

.mdi-minus-box-outline::before {
  content: "\\f06f2";
}

.mdi-minus-circle::before {
  content: "\\f0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\f035a";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\f0ad3";
}

.mdi-minus-circle-off::before {
  content: "\\f1459";
}

.mdi-minus-circle-off-outline::before {
  content: "\\f145a";
}

.mdi-minus-circle-outline::before {
  content: "\\f0377";
}

.mdi-minus-network::before {
  content: "\\f0378";
}

.mdi-minus-network-outline::before {
  content: "\\f0c9a";
}

.mdi-minus-thick::before {
  content: "\\f1639";
}

.mdi-mirror::before {
  content: "\\f11fd";
}

.mdi-mirror-rectangle::before {
  content: "\\f179f";
}

.mdi-mirror-variant::before {
  content: "\\f17a0";
}

.mdi-mixed-martial-arts::before {
  content: "\\f0d8f";
}

.mdi-mixed-reality::before {
  content: "\\f087f";
}

.mdi-molecule::before {
  content: "\\f0bac";
}

.mdi-molecule-co::before {
  content: "\\f12fe";
}

.mdi-molecule-co2::before {
  content: "\\f07e4";
}

.mdi-monitor::before {
  content: "\\f0379";
}

.mdi-monitor-cellphone::before {
  content: "\\f0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\f098a";
}

.mdi-monitor-dashboard::before {
  content: "\\f0a07";
}

.mdi-monitor-edit::before {
  content: "\\f12c6";
}

.mdi-monitor-eye::before {
  content: "\\f13b4";
}

.mdi-monitor-lock::before {
  content: "\\f0ddb";
}

.mdi-monitor-multiple::before {
  content: "\\f037a";
}

.mdi-monitor-off::before {
  content: "\\f0d90";
}

.mdi-monitor-screenshot::before {
  content: "\\f0e51";
}

.mdi-monitor-share::before {
  content: "\\f1483";
}

.mdi-monitor-shimmer::before {
  content: "\\f1104";
}

.mdi-monitor-small::before {
  content: "\\f1876";
}

.mdi-monitor-speaker::before {
  content: "\\f0f5f";
}

.mdi-monitor-speaker-off::before {
  content: "\\f0f60";
}

.mdi-monitor-star::before {
  content: "\\f0ddc";
}

.mdi-moon-first-quarter::before {
  content: "\\f0f61";
}

.mdi-moon-full::before {
  content: "\\f0f62";
}

.mdi-moon-last-quarter::before {
  content: "\\f0f63";
}

.mdi-moon-new::before {
  content: "\\f0f64";
}

.mdi-moon-waning-crescent::before {
  content: "\\f0f65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\f0f66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\f0f67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\f0f68";
}

.mdi-moped::before {
  content: "\\f1086";
}

.mdi-moped-electric::before {
  content: "\\f15b7";
}

.mdi-moped-electric-outline::before {
  content: "\\f15b8";
}

.mdi-moped-outline::before {
  content: "\\f15b9";
}

.mdi-more::before {
  content: "\\f037b";
}

.mdi-mortar-pestle::before {
  content: "\\f1748";
}

.mdi-mortar-pestle-plus::before {
  content: "\\f03f1";
}

.mdi-mosque::before {
  content: "\\f1827";
}

.mdi-mother-heart::before {
  content: "\\f1314";
}

.mdi-mother-nurse::before {
  content: "\\f0d21";
}

.mdi-motion::before {
  content: "\\f15b2";
}

.mdi-motion-outline::before {
  content: "\\f15b3";
}

.mdi-motion-pause::before {
  content: "\\f1590";
}

.mdi-motion-pause-outline::before {
  content: "\\f1592";
}

.mdi-motion-play::before {
  content: "\\f158f";
}

.mdi-motion-play-outline::before {
  content: "\\f1591";
}

.mdi-motion-sensor::before {
  content: "\\f0d91";
}

.mdi-motion-sensor-off::before {
  content: "\\f1435";
}

.mdi-motorbike::before {
  content: "\\f037c";
}

.mdi-motorbike-electric::before {
  content: "\\f15ba";
}

.mdi-mouse::before {
  content: "\\f037d";
}

.mdi-mouse-bluetooth::before {
  content: "\\f098b";
}

.mdi-mouse-move-down::before {
  content: "\\f1550";
}

.mdi-mouse-move-up::before {
  content: "\\f1551";
}

.mdi-mouse-move-vertical::before {
  content: "\\f1552";
}

.mdi-mouse-off::before {
  content: "\\f037e";
}

.mdi-mouse-variant::before {
  content: "\\f037f";
}

.mdi-mouse-variant-off::before {
  content: "\\f0380";
}

.mdi-move-resize::before {
  content: "\\f0655";
}

.mdi-move-resize-variant::before {
  content: "\\f0656";
}

.mdi-movie::before {
  content: "\\f0381";
}

.mdi-movie-check::before {
  content: "\\f16f3";
}

.mdi-movie-check-outline::before {
  content: "\\f16f4";
}

.mdi-movie-cog::before {
  content: "\\f16f5";
}

.mdi-movie-cog-outline::before {
  content: "\\f16f6";
}

.mdi-movie-edit::before {
  content: "\\f1122";
}

.mdi-movie-edit-outline::before {
  content: "\\f1123";
}

.mdi-movie-filter::before {
  content: "\\f1124";
}

.mdi-movie-filter-outline::before {
  content: "\\f1125";
}

.mdi-movie-minus::before {
  content: "\\f16f7";
}

.mdi-movie-minus-outline::before {
  content: "\\f16f8";
}

.mdi-movie-off::before {
  content: "\\f16f9";
}

.mdi-movie-off-outline::before {
  content: "\\f16fa";
}

.mdi-movie-open::before {
  content: "\\f0fce";
}

.mdi-movie-open-check::before {
  content: "\\f16fb";
}

.mdi-movie-open-check-outline::before {
  content: "\\f16fc";
}

.mdi-movie-open-cog::before {
  content: "\\f16fd";
}

.mdi-movie-open-cog-outline::before {
  content: "\\f16fe";
}

.mdi-movie-open-edit::before {
  content: "\\f16ff";
}

.mdi-movie-open-edit-outline::before {
  content: "\\f1700";
}

.mdi-movie-open-minus::before {
  content: "\\f1701";
}

.mdi-movie-open-minus-outline::before {
  content: "\\f1702";
}

.mdi-movie-open-off::before {
  content: "\\f1703";
}

.mdi-movie-open-off-outline::before {
  content: "\\f1704";
}

.mdi-movie-open-outline::before {
  content: "\\f0fcf";
}

.mdi-movie-open-play::before {
  content: "\\f1705";
}

.mdi-movie-open-play-outline::before {
  content: "\\f1706";
}

.mdi-movie-open-plus::before {
  content: "\\f1707";
}

.mdi-movie-open-plus-outline::before {
  content: "\\f1708";
}

.mdi-movie-open-remove::before {
  content: "\\f1709";
}

.mdi-movie-open-remove-outline::before {
  content: "\\f170a";
}

.mdi-movie-open-settings::before {
  content: "\\f170b";
}

.mdi-movie-open-settings-outline::before {
  content: "\\f170c";
}

.mdi-movie-open-star::before {
  content: "\\f170d";
}

.mdi-movie-open-star-outline::before {
  content: "\\f170e";
}

.mdi-movie-outline::before {
  content: "\\f0ddd";
}

.mdi-movie-play::before {
  content: "\\f170f";
}

.mdi-movie-play-outline::before {
  content: "\\f1710";
}

.mdi-movie-plus::before {
  content: "\\f1711";
}

.mdi-movie-plus-outline::before {
  content: "\\f1712";
}

.mdi-movie-remove::before {
  content: "\\f1713";
}

.mdi-movie-remove-outline::before {
  content: "\\f1714";
}

.mdi-movie-roll::before {
  content: "\\f07de";
}

.mdi-movie-search::before {
  content: "\\f11d2";
}

.mdi-movie-search-outline::before {
  content: "\\f11d3";
}

.mdi-movie-settings::before {
  content: "\\f1715";
}

.mdi-movie-settings-outline::before {
  content: "\\f1716";
}

.mdi-movie-star::before {
  content: "\\f1717";
}

.mdi-movie-star-outline::before {
  content: "\\f1718";
}

.mdi-mower::before {
  content: "\\f166f";
}

.mdi-mower-bag::before {
  content: "\\f1670";
}

.mdi-muffin::before {
  content: "\\f098c";
}

.mdi-multicast::before {
  content: "\\f1893";
}

.mdi-multiplication::before {
  content: "\\f0382";
}

.mdi-multiplication-box::before {
  content: "\\f0383";
}

.mdi-mushroom::before {
  content: "\\f07df";
}

.mdi-mushroom-off::before {
  content: "\\f13fa";
}

.mdi-mushroom-off-outline::before {
  content: "\\f13fb";
}

.mdi-mushroom-outline::before {
  content: "\\f07e0";
}

.mdi-music::before {
  content: "\\f075a";
}

.mdi-music-accidental-double-flat::before {
  content: "\\f0f69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\f0f6a";
}

.mdi-music-accidental-flat::before {
  content: "\\f0f6b";
}

.mdi-music-accidental-natural::before {
  content: "\\f0f6c";
}

.mdi-music-accidental-sharp::before {
  content: "\\f0f6d";
}

.mdi-music-box::before {
  content: "\\f0384";
}

.mdi-music-box-multiple::before {
  content: "\\f0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\f0f04";
}

.mdi-music-box-outline::before {
  content: "\\f0385";
}

.mdi-music-circle::before {
  content: "\\f0386";
}

.mdi-music-circle-outline::before {
  content: "\\f0ad4";
}

.mdi-music-clef-alto::before {
  content: "\\f0f6e";
}

.mdi-music-clef-bass::before {
  content: "\\f0f6f";
}

.mdi-music-clef-treble::before {
  content: "\\f0f70";
}

.mdi-music-note::before {
  content: "\\f0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\f05fe";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\f05ff";
}

.mdi-music-note-eighth::before {
  content: "\\f0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\f0f71";
}

.mdi-music-note-half::before {
  content: "\\f0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\f0f72";
}

.mdi-music-note-off::before {
  content: "\\f038a";
}

.mdi-music-note-off-outline::before {
  content: "\\f0f73";
}

.mdi-music-note-outline::before {
  content: "\\f0f74";
}

.mdi-music-note-plus::before {
  content: "\\f0dde";
}

.mdi-music-note-quarter::before {
  content: "\\f038b";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\f0f75";
}

.mdi-music-note-sixteenth::before {
  content: "\\f038c";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\f0f76";
}

.mdi-music-note-whole::before {
  content: "\\f038d";
}

.mdi-music-note-whole-dotted::before {
  content: "\\f0f77";
}

.mdi-music-off::before {
  content: "\\f075b";
}

.mdi-music-rest-eighth::before {
  content: "\\f0f78";
}

.mdi-music-rest-half::before {
  content: "\\f0f79";
}

.mdi-music-rest-quarter::before {
  content: "\\f0f7a";
}

.mdi-music-rest-sixteenth::before {
  content: "\\f0f7b";
}

.mdi-music-rest-whole::before {
  content: "\\f0f7c";
}

.mdi-mustache::before {
  content: "\\f15de";
}

.mdi-nail::before {
  content: "\\f0ddf";
}

.mdi-nas::before {
  content: "\\f08f3";
}

.mdi-nativescript::before {
  content: "\\f0880";
}

.mdi-nature::before {
  content: "\\f038e";
}

.mdi-nature-people::before {
  content: "\\f038f";
}

.mdi-navigation::before {
  content: "\\f0390";
}

.mdi-navigation-outline::before {
  content: "\\f1607";
}

.mdi-navigation-variant::before {
  content: "\\f18f0";
}

.mdi-navigation-variant-outline::before {
  content: "\\f18f1";
}

.mdi-near-me::before {
  content: "\\f05cd";
}

.mdi-necklace::before {
  content: "\\f0f0b";
}

.mdi-needle::before {
  content: "\\f0391";
}

.mdi-netflix::before {
  content: "\\f0746";
}

.mdi-network::before {
  content: "\\f06f3";
}

.mdi-network-off::before {
  content: "\\f0c9b";
}

.mdi-network-off-outline::before {
  content: "\\f0c9c";
}

.mdi-network-outline::before {
  content: "\\f0c9d";
}

.mdi-network-strength-1::before {
  content: "\\f08f4";
}

.mdi-network-strength-1-alert::before {
  content: "\\f08f5";
}

.mdi-network-strength-2::before {
  content: "\\f08f6";
}

.mdi-network-strength-2-alert::before {
  content: "\\f08f7";
}

.mdi-network-strength-3::before {
  content: "\\f08f8";
}

.mdi-network-strength-3-alert::before {
  content: "\\f08f9";
}

.mdi-network-strength-4::before {
  content: "\\f08fa";
}

.mdi-network-strength-4-alert::before {
  content: "\\f08fb";
}

.mdi-network-strength-4-cog::before {
  content: "\\f191a";
}

.mdi-network-strength-off::before {
  content: "\\f08fc";
}

.mdi-network-strength-off-outline::before {
  content: "\\f08fd";
}

.mdi-network-strength-outline::before {
  content: "\\f08fe";
}

.mdi-new-box::before {
  content: "\\f0394";
}

.mdi-newspaper::before {
  content: "\\f0395";
}

.mdi-newspaper-check::before {
  content: "\\f1943";
}

.mdi-newspaper-minus::before {
  content: "\\f0f0c";
}

.mdi-newspaper-plus::before {
  content: "\\f0f0d";
}

.mdi-newspaper-remove::before {
  content: "\\f1944";
}

.mdi-newspaper-variant::before {
  content: "\\f1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\f1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\f1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\f1004";
}

.mdi-nfc::before {
  content: "\\f0396";
}

.mdi-nfc-search-variant::before {
  content: "\\f0e53";
}

.mdi-nfc-tap::before {
  content: "\\f0397";
}

.mdi-nfc-variant::before {
  content: "\\f0398";
}

.mdi-nfc-variant-off::before {
  content: "\\f0e54";
}

.mdi-ninja::before {
  content: "\\f0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\f1393";
}

.mdi-nintendo-switch::before {
  content: "\\f07e1";
}

.mdi-nintendo-wii::before {
  content: "\\f05ab";
}

.mdi-nintendo-wiiu::before {
  content: "\\f072d";
}

.mdi-nix::before {
  content: "\\f1105";
}

.mdi-nodejs::before {
  content: "\\f0399";
}

.mdi-noodles::before {
  content: "\\f117e";
}

.mdi-not-equal::before {
  content: "\\f098d";
}

.mdi-not-equal-variant::before {
  content: "\\f098e";
}

.mdi-note::before {
  content: "\\f039a";
}

.mdi-note-alert::before {
  content: "\\f177d";
}

.mdi-note-alert-outline::before {
  content: "\\f177e";
}

.mdi-note-check::before {
  content: "\\f177f";
}

.mdi-note-check-outline::before {
  content: "\\f1780";
}

.mdi-note-edit::before {
  content: "\\f1781";
}

.mdi-note-edit-outline::before {
  content: "\\f1782";
}

.mdi-note-minus::before {
  content: "\\f164f";
}

.mdi-note-minus-outline::before {
  content: "\\f1650";
}

.mdi-note-multiple::before {
  content: "\\f06b8";
}

.mdi-note-multiple-outline::before {
  content: "\\f06b9";
}

.mdi-note-off::before {
  content: "\\f1783";
}

.mdi-note-off-outline::before {
  content: "\\f1784";
}

.mdi-note-outline::before {
  content: "\\f039b";
}

.mdi-note-plus::before {
  content: "\\f039c";
}

.mdi-note-plus-outline::before {
  content: "\\f039d";
}

.mdi-note-remove::before {
  content: "\\f1651";
}

.mdi-note-remove-outline::before {
  content: "\\f1652";
}

.mdi-note-search::before {
  content: "\\f1653";
}

.mdi-note-search-outline::before {
  content: "\\f1654";
}

.mdi-note-text::before {
  content: "\\f039e";
}

.mdi-note-text-outline::before {
  content: "\\f11d7";
}

.mdi-notebook::before {
  content: "\\f082e";
}

.mdi-notebook-check::before {
  content: "\\f14f5";
}

.mdi-notebook-check-outline::before {
  content: "\\f14f6";
}

.mdi-notebook-edit::before {
  content: "\\f14e7";
}

.mdi-notebook-edit-outline::before {
  content: "\\f14e9";
}

.mdi-notebook-minus::before {
  content: "\\f1610";
}

.mdi-notebook-minus-outline::before {
  content: "\\f1611";
}

.mdi-notebook-multiple::before {
  content: "\\f0e55";
}

.mdi-notebook-outline::before {
  content: "\\f0ebf";
}

.mdi-notebook-plus::before {
  content: "\\f1612";
}

.mdi-notebook-plus-outline::before {
  content: "\\f1613";
}

.mdi-notebook-remove::before {
  content: "\\f1614";
}

.mdi-notebook-remove-outline::before {
  content: "\\f1615";
}

.mdi-notification-clear-all::before {
  content: "\\f039f";
}

.mdi-npm::before {
  content: "\\f06f7";
}

.mdi-nuke::before {
  content: "\\f06a4";
}

.mdi-null::before {
  content: "\\f07e2";
}

.mdi-numeric::before {
  content: "\\f03a0";
}

.mdi-numeric-0::before {
  content: "\\f0b39";
}

.mdi-numeric-0-box::before {
  content: "\\f03a1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\f0f0e";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\f03a2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\f03a3";
}

.mdi-numeric-0-circle::before {
  content: "\\f0c9e";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\f0c9f";
}

.mdi-numeric-1::before {
  content: "\\f0b3a";
}

.mdi-numeric-1-box::before {
  content: "\\f03a4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\f0f0f";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\f03a5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\f03a6";
}

.mdi-numeric-1-circle::before {
  content: "\\f0ca0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\f0ca1";
}

.mdi-numeric-10::before {
  content: "\\f0fe9";
}

.mdi-numeric-10-box::before {
  content: "\\f0f7d";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\f0fea";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\f0feb";
}

.mdi-numeric-10-box-outline::before {
  content: "\\f0f7e";
}

.mdi-numeric-10-circle::before {
  content: "\\f0fec";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\f0fed";
}

.mdi-numeric-2::before {
  content: "\\f0b3b";
}

.mdi-numeric-2-box::before {
  content: "\\f03a7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\f0f10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\f03a8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\f03a9";
}

.mdi-numeric-2-circle::before {
  content: "\\f0ca2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\f0ca3";
}

.mdi-numeric-3::before {
  content: "\\f0b3c";
}

.mdi-numeric-3-box::before {
  content: "\\f03aa";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\f0f11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\f03ab";
}

.mdi-numeric-3-box-outline::before {
  content: "\\f03ac";
}

.mdi-numeric-3-circle::before {
  content: "\\f0ca4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\f0ca5";
}

.mdi-numeric-4::before {
  content: "\\f0b3d";
}

.mdi-numeric-4-box::before {
  content: "\\f03ad";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\f0f12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\f03b2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\f03ae";
}

.mdi-numeric-4-circle::before {
  content: "\\f0ca6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\f0ca7";
}

.mdi-numeric-5::before {
  content: "\\f0b3e";
}

.mdi-numeric-5-box::before {
  content: "\\f03b1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\f0f13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\f03af";
}

.mdi-numeric-5-box-outline::before {
  content: "\\f03b0";
}

.mdi-numeric-5-circle::before {
  content: "\\f0ca8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\f0ca9";
}

.mdi-numeric-6::before {
  content: "\\f0b3f";
}

.mdi-numeric-6-box::before {
  content: "\\f03b3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\f0f14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\f03b4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\f03b5";
}

.mdi-numeric-6-circle::before {
  content: "\\f0caa";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\f0cab";
}

.mdi-numeric-7::before {
  content: "\\f0b40";
}

.mdi-numeric-7-box::before {
  content: "\\f03b6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\f0f15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\f03b7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\f03b8";
}

.mdi-numeric-7-circle::before {
  content: "\\f0cac";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\f0cad";
}

.mdi-numeric-8::before {
  content: "\\f0b41";
}

.mdi-numeric-8-box::before {
  content: "\\f03b9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\f0f16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\f03ba";
}

.mdi-numeric-8-box-outline::before {
  content: "\\f03bb";
}

.mdi-numeric-8-circle::before {
  content: "\\f0cae";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\f0caf";
}

.mdi-numeric-9::before {
  content: "\\f0b42";
}

.mdi-numeric-9-box::before {
  content: "\\f03bc";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\f0f17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\f03bd";
}

.mdi-numeric-9-box-outline::before {
  content: "\\f03be";
}

.mdi-numeric-9-circle::before {
  content: "\\f0cb0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\f0cb1";
}

.mdi-numeric-9-plus::before {
  content: "\\f0fee";
}

.mdi-numeric-9-plus-box::before {
  content: "\\f03bf";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\f0f18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\f03c0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\f03c1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\f0cb2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\f0cb3";
}

.mdi-numeric-negative-1::before {
  content: "\\f1052";
}

.mdi-numeric-positive-1::before {
  content: "\\f15cb";
}

.mdi-nut::before {
  content: "\\f06f8";
}

.mdi-nutrition::before {
  content: "\\f03c2";
}

.mdi-nuxt::before {
  content: "\\f1106";
}

.mdi-oar::before {
  content: "\\f067c";
}

.mdi-ocarina::before {
  content: "\\f0de0";
}

.mdi-oci::before {
  content: "\\f12e9";
}

.mdi-ocr::before {
  content: "\\f113a";
}

.mdi-octagon::before {
  content: "\\f03c3";
}

.mdi-octagon-outline::before {
  content: "\\f03c4";
}

.mdi-octagram::before {
  content: "\\f06f9";
}

.mdi-octagram-outline::before {
  content: "\\f0775";
}

.mdi-octahedron::before {
  content: "\\f1950";
}

.mdi-octahedron-off::before {
  content: "\\f1951";
}

.mdi-odnoklassniki::before {
  content: "\\f03c5";
}

.mdi-offer::before {
  content: "\\f121b";
}

.mdi-office-building::before {
  content: "\\f0991";
}

.mdi-office-building-cog::before {
  content: "\\f1949";
}

.mdi-office-building-cog-outline::before {
  content: "\\f194a";
}

.mdi-office-building-marker::before {
  content: "\\f1520";
}

.mdi-office-building-marker-outline::before {
  content: "\\f1521";
}

.mdi-office-building-outline::before {
  content: "\\f151f";
}

.mdi-oil::before {
  content: "\\f03c7";
}

.mdi-oil-lamp::before {
  content: "\\f0f19";
}

.mdi-oil-level::before {
  content: "\\f1053";
}

.mdi-oil-temperature::before {
  content: "\\f0ff8";
}

.mdi-om::before {
  content: "\\f0973";
}

.mdi-omega::before {
  content: "\\f03c9";
}

.mdi-one-up::before {
  content: "\\f0bad";
}

.mdi-onepassword::before {
  content: "\\f0881";
}

.mdi-opacity::before {
  content: "\\f05cc";
}

.mdi-open-in-app::before {
  content: "\\f03cb";
}

.mdi-open-in-new::before {
  content: "\\f03cc";
}

.mdi-open-source-initiative::before {
  content: "\\f0bae";
}

.mdi-openid::before {
  content: "\\f03cd";
}

.mdi-opera::before {
  content: "\\f03ce";
}

.mdi-orbit::before {
  content: "\\f0018";
}

.mdi-orbit-variant::before {
  content: "\\f15db";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\f020d";
}

.mdi-order-alphabetical-descending::before {
  content: "\\f0d07";
}

.mdi-order-bool-ascending::before {
  content: "\\f02be";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\f098f";
}

.mdi-order-bool-descending::before {
  content: "\\f1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\f0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\f0545";
}

.mdi-order-numeric-descending::before {
  content: "\\f0546";
}

.mdi-origin::before {
  content: "\\f0b43";
}

.mdi-ornament::before {
  content: "\\f03cf";
}

.mdi-ornament-variant::before {
  content: "\\f03d0";
}

.mdi-outdoor-lamp::before {
  content: "\\f1054";
}

.mdi-overscan::before {
  content: "\\f1005";
}

.mdi-owl::before {
  content: "\\f03d2";
}

.mdi-pac-man::before {
  content: "\\f0baf";
}

.mdi-package::before {
  content: "\\f03d3";
}

.mdi-package-down::before {
  content: "\\f03d4";
}

.mdi-package-up::before {
  content: "\\f03d5";
}

.mdi-package-variant::before {
  content: "\\f03d6";
}

.mdi-package-variant-closed::before {
  content: "\\f03d7";
}

.mdi-page-first::before {
  content: "\\f0600";
}

.mdi-page-last::before {
  content: "\\f0601";
}

.mdi-page-layout-body::before {
  content: "\\f06fa";
}

.mdi-page-layout-footer::before {
  content: "\\f06fb";
}

.mdi-page-layout-header::before {
  content: "\\f06fc";
}

.mdi-page-layout-header-footer::before {
  content: "\\f0f7f";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\f06fd";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\f06fe";
}

.mdi-page-next::before {
  content: "\\f0bb0";
}

.mdi-page-next-outline::before {
  content: "\\f0bb1";
}

.mdi-page-previous::before {
  content: "\\f0bb2";
}

.mdi-page-previous-outline::before {
  content: "\\f0bb3";
}

.mdi-pail::before {
  content: "\\f1417";
}

.mdi-pail-minus::before {
  content: "\\f1437";
}

.mdi-pail-minus-outline::before {
  content: "\\f143c";
}

.mdi-pail-off::before {
  content: "\\f1439";
}

.mdi-pail-off-outline::before {
  content: "\\f143e";
}

.mdi-pail-outline::before {
  content: "\\f143a";
}

.mdi-pail-plus::before {
  content: "\\f1436";
}

.mdi-pail-plus-outline::before {
  content: "\\f143b";
}

.mdi-pail-remove::before {
  content: "\\f1438";
}

.mdi-pail-remove-outline::before {
  content: "\\f143d";
}

.mdi-palette::before {
  content: "\\f03d8";
}

.mdi-palette-advanced::before {
  content: "\\f03d9";
}

.mdi-palette-outline::before {
  content: "\\f0e0c";
}

.mdi-palette-swatch::before {
  content: "\\f08b5";
}

.mdi-palette-swatch-outline::before {
  content: "\\f135c";
}

.mdi-palette-swatch-variant::before {
  content: "\\f195a";
}

.mdi-palm-tree::before {
  content: "\\f1055";
}

.mdi-pan::before {
  content: "\\f0bb4";
}

.mdi-pan-bottom-left::before {
  content: "\\f0bb5";
}

.mdi-pan-bottom-right::before {
  content: "\\f0bb6";
}

.mdi-pan-down::before {
  content: "\\f0bb7";
}

.mdi-pan-horizontal::before {
  content: "\\f0bb8";
}

.mdi-pan-left::before {
  content: "\\f0bb9";
}

.mdi-pan-right::before {
  content: "\\f0bba";
}

.mdi-pan-top-left::before {
  content: "\\f0bbb";
}

.mdi-pan-top-right::before {
  content: "\\f0bbc";
}

.mdi-pan-up::before {
  content: "\\f0bbd";
}

.mdi-pan-vertical::before {
  content: "\\f0bbe";
}

.mdi-panda::before {
  content: "\\f03da";
}

.mdi-pandora::before {
  content: "\\f03db";
}

.mdi-panorama::before {
  content: "\\f03dc";
}

.mdi-panorama-fisheye::before {
  content: "\\f03dd";
}

.mdi-panorama-horizontal::before {
  content: "\\f1928";
}

.mdi-panorama-horizontal-outline::before {
  content: "\\f03de";
}

.mdi-panorama-outline::before {
  content: "\\f198c";
}

.mdi-panorama-sphere::before {
  content: "\\f198d";
}

.mdi-panorama-sphere-outline::before {
  content: "\\f198e";
}

.mdi-panorama-variant::before {
  content: "\\f198f";
}

.mdi-panorama-variant-outline::before {
  content: "\\f1990";
}

.mdi-panorama-vertical::before {
  content: "\\f1929";
}

.mdi-panorama-vertical-outline::before {
  content: "\\f03df";
}

.mdi-panorama-wide-angle::before {
  content: "\\f195f";
}

.mdi-panorama-wide-angle-outline::before {
  content: "\\f03e0";
}

.mdi-paper-cut-vertical::before {
  content: "\\f03e1";
}

.mdi-paper-roll::before {
  content: "\\f1157";
}

.mdi-paper-roll-outline::before {
  content: "\\f1158";
}

.mdi-paperclip::before {
  content: "\\f03e2";
}

.mdi-parachute::before {
  content: "\\f0cb4";
}

.mdi-parachute-outline::before {
  content: "\\f0cb5";
}

.mdi-paragliding::before {
  content: "\\f1745";
}

.mdi-parking::before {
  content: "\\f03e3";
}

.mdi-party-popper::before {
  content: "\\f1056";
}

.mdi-passport::before {
  content: "\\f07e3";
}

.mdi-passport-biometric::before {
  content: "\\f0de1";
}

.mdi-pasta::before {
  content: "\\f1160";
}

.mdi-patio-heater::before {
  content: "\\f0f80";
}

.mdi-patreon::before {
  content: "\\f0882";
}

.mdi-pause::before {
  content: "\\f03e4";
}

.mdi-pause-circle::before {
  content: "\\f03e5";
}

.mdi-pause-circle-outline::before {
  content: "\\f03e6";
}

.mdi-pause-octagon::before {
  content: "\\f03e7";
}

.mdi-pause-octagon-outline::before {
  content: "\\f03e8";
}

.mdi-paw::before {
  content: "\\f03e9";
}

.mdi-paw-off::before {
  content: "\\f0657";
}

.mdi-paw-off-outline::before {
  content: "\\f1676";
}

.mdi-paw-outline::before {
  content: "\\f1675";
}

.mdi-peace::before {
  content: "\\f0884";
}

.mdi-peanut::before {
  content: "\\f0ffc";
}

.mdi-peanut-off::before {
  content: "\\f0ffd";
}

.mdi-peanut-off-outline::before {
  content: "\\f0fff";
}

.mdi-peanut-outline::before {
  content: "\\f0ffe";
}

.mdi-pen::before {
  content: "\\f03ea";
}

.mdi-pen-lock::before {
  content: "\\f0de2";
}

.mdi-pen-minus::before {
  content: "\\f0de3";
}

.mdi-pen-off::before {
  content: "\\f0de4";
}

.mdi-pen-plus::before {
  content: "\\f0de5";
}

.mdi-pen-remove::before {
  content: "\\f0de6";
}

.mdi-pencil::before {
  content: "\\f03eb";
}

.mdi-pencil-box::before {
  content: "\\f03ec";
}

.mdi-pencil-box-multiple::before {
  content: "\\f1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\f1145";
}

.mdi-pencil-box-outline::before {
  content: "\\f03ed";
}

.mdi-pencil-circle::before {
  content: "\\f06ff";
}

.mdi-pencil-circle-outline::before {
  content: "\\f0776";
}

.mdi-pencil-lock::before {
  content: "\\f03ee";
}

.mdi-pencil-lock-outline::before {
  content: "\\f0de7";
}

.mdi-pencil-minus::before {
  content: "\\f0de8";
}

.mdi-pencil-minus-outline::before {
  content: "\\f0de9";
}

.mdi-pencil-off::before {
  content: "\\f03ef";
}

.mdi-pencil-off-outline::before {
  content: "\\f0dea";
}

.mdi-pencil-outline::before {
  content: "\\f0cb6";
}

.mdi-pencil-plus::before {
  content: "\\f0deb";
}

.mdi-pencil-plus-outline::before {
  content: "\\f0dec";
}

.mdi-pencil-remove::before {
  content: "\\f0ded";
}

.mdi-pencil-remove-outline::before {
  content: "\\f0dee";
}

.mdi-pencil-ruler::before {
  content: "\\f1353";
}

.mdi-penguin::before {
  content: "\\f0ec0";
}

.mdi-pentagon::before {
  content: "\\f0701";
}

.mdi-pentagon-outline::before {
  content: "\\f0700";
}

.mdi-pentagram::before {
  content: "\\f1667";
}

.mdi-percent::before {
  content: "\\f03f0";
}

.mdi-percent-outline::before {
  content: "\\f1278";
}

.mdi-periodic-table::before {
  content: "\\f08b6";
}

.mdi-perspective-less::before {
  content: "\\f0d23";
}

.mdi-perspective-more::before {
  content: "\\f0d24";
}

.mdi-ph::before {
  content: "\\f17c5";
}

.mdi-phone::before {
  content: "\\f03f2";
}

.mdi-phone-alert::before {
  content: "\\f0f1a";
}

.mdi-phone-alert-outline::before {
  content: "\\f118e";
}

.mdi-phone-bluetooth::before {
  content: "\\f03f3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\f118f";
}

.mdi-phone-cancel::before {
  content: "\\f10bc";
}

.mdi-phone-cancel-outline::before {
  content: "\\f1190";
}

.mdi-phone-check::before {
  content: "\\f11a9";
}

.mdi-phone-check-outline::before {
  content: "\\f11aa";
}

.mdi-phone-classic::before {
  content: "\\f0602";
}

.mdi-phone-classic-off::before {
  content: "\\f1279";
}

.mdi-phone-dial::before {
  content: "\\f1559";
}

.mdi-phone-dial-outline::before {
  content: "\\f155a";
}

.mdi-phone-forward::before {
  content: "\\f03f4";
}

.mdi-phone-forward-outline::before {
  content: "\\f1191";
}

.mdi-phone-hangup::before {
  content: "\\f03f5";
}

.mdi-phone-hangup-outline::before {
  content: "\\f1192";
}

.mdi-phone-in-talk::before {
  content: "\\f03f6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\f1182";
}

.mdi-phone-incoming::before {
  content: "\\f03f7";
}

.mdi-phone-incoming-outline::before {
  content: "\\f1193";
}

.mdi-phone-lock::before {
  content: "\\f03f8";
}

.mdi-phone-lock-outline::before {
  content: "\\f1194";
}

.mdi-phone-log::before {
  content: "\\f03f9";
}

.mdi-phone-log-outline::before {
  content: "\\f1195";
}

.mdi-phone-message::before {
  content: "\\f1196";
}

.mdi-phone-message-outline::before {
  content: "\\f1197";
}

.mdi-phone-minus::before {
  content: "\\f0658";
}

.mdi-phone-minus-outline::before {
  content: "\\f1198";
}

.mdi-phone-missed::before {
  content: "\\f03fa";
}

.mdi-phone-missed-outline::before {
  content: "\\f11a5";
}

.mdi-phone-off::before {
  content: "\\f0def";
}

.mdi-phone-off-outline::before {
  content: "\\f11a6";
}

.mdi-phone-outgoing::before {
  content: "\\f03fb";
}

.mdi-phone-outgoing-outline::before {
  content: "\\f1199";
}

.mdi-phone-outline::before {
  content: "\\f0df0";
}

.mdi-phone-paused::before {
  content: "\\f03fc";
}

.mdi-phone-paused-outline::before {
  content: "\\f119a";
}

.mdi-phone-plus::before {
  content: "\\f0659";
}

.mdi-phone-plus-outline::before {
  content: "\\f119b";
}

.mdi-phone-refresh::before {
  content: "\\f1993";
}

.mdi-phone-refresh-outline::before {
  content: "\\f1994";
}

.mdi-phone-remove::before {
  content: "\\f152f";
}

.mdi-phone-remove-outline::before {
  content: "\\f1530";
}

.mdi-phone-return::before {
  content: "\\f082f";
}

.mdi-phone-return-outline::before {
  content: "\\f119c";
}

.mdi-phone-ring::before {
  content: "\\f11ab";
}

.mdi-phone-ring-outline::before {
  content: "\\f11ac";
}

.mdi-phone-rotate-landscape::before {
  content: "\\f0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\f0886";
}

.mdi-phone-settings::before {
  content: "\\f03fd";
}

.mdi-phone-settings-outline::before {
  content: "\\f119d";
}

.mdi-phone-sync::before {
  content: "\\f1995";
}

.mdi-phone-sync-outline::before {
  content: "\\f1996";
}

.mdi-phone-voip::before {
  content: "\\f03fe";
}

.mdi-pi::before {
  content: "\\f03ff";
}

.mdi-pi-box::before {
  content: "\\f0400";
}

.mdi-pi-hole::before {
  content: "\\f0df1";
}

.mdi-piano::before {
  content: "\\f067d";
}

.mdi-piano-off::before {
  content: "\\f0698";
}

.mdi-pickaxe::before {
  content: "\\f08b7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\f0e57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\f0e58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\f0e59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\f0e5a";
}

.mdi-pier::before {
  content: "\\f0887";
}

.mdi-pier-crane::before {
  content: "\\f0888";
}

.mdi-pig::before {
  content: "\\f0401";
}

.mdi-pig-variant::before {
  content: "\\f1006";
}

.mdi-pig-variant-outline::before {
  content: "\\f1678";
}

.mdi-piggy-bank::before {
  content: "\\f1007";
}

.mdi-piggy-bank-outline::before {
  content: "\\f1679";
}

.mdi-pill::before {
  content: "\\f0402";
}

.mdi-pillar::before {
  content: "\\f0702";
}

.mdi-pin::before {
  content: "\\f0403";
}

.mdi-pin-off::before {
  content: "\\f0404";
}

.mdi-pin-off-outline::before {
  content: "\\f0930";
}

.mdi-pin-outline::before {
  content: "\\f0931";
}

.mdi-pine-tree::before {
  content: "\\f0405";
}

.mdi-pine-tree-box::before {
  content: "\\f0406";
}

.mdi-pine-tree-fire::before {
  content: "\\f141a";
}

.mdi-pinterest::before {
  content: "\\f0407";
}

.mdi-pinwheel::before {
  content: "\\f0ad5";
}

.mdi-pinwheel-outline::before {
  content: "\\f0ad6";
}

.mdi-pipe::before {
  content: "\\f07e5";
}

.mdi-pipe-disconnected::before {
  content: "\\f07e6";
}

.mdi-pipe-leak::before {
  content: "\\f0889";
}

.mdi-pipe-valve::before {
  content: "\\f184d";
}

.mdi-pipe-wrench::before {
  content: "\\f1354";
}

.mdi-pirate::before {
  content: "\\f0a08";
}

.mdi-pistol::before {
  content: "\\f0703";
}

.mdi-piston::before {
  content: "\\f088a";
}

.mdi-pitchfork::before {
  content: "\\f1553";
}

.mdi-pizza::before {
  content: "\\f0409";
}

.mdi-play::before {
  content: "\\f040a";
}

.mdi-play-box::before {
  content: "\\f127a";
}

.mdi-play-box-multiple::before {
  content: "\\f0d19";
}

.mdi-play-box-multiple-outline::before {
  content: "\\f13e6";
}

.mdi-play-box-outline::before {
  content: "\\f040b";
}

.mdi-play-circle::before {
  content: "\\f040c";
}

.mdi-play-circle-outline::before {
  content: "\\f040d";
}

.mdi-play-network::before {
  content: "\\f088b";
}

.mdi-play-network-outline::before {
  content: "\\f0cb7";
}

.mdi-play-outline::before {
  content: "\\f0f1b";
}

.mdi-play-pause::before {
  content: "\\f040e";
}

.mdi-play-protected-content::before {
  content: "\\f040f";
}

.mdi-play-speed::before {
  content: "\\f08ff";
}

.mdi-playlist-check::before {
  content: "\\f05c7";
}

.mdi-playlist-edit::before {
  content: "\\f0900";
}

.mdi-playlist-minus::before {
  content: "\\f0410";
}

.mdi-playlist-music::before {
  content: "\\f0cb8";
}

.mdi-playlist-music-outline::before {
  content: "\\f0cb9";
}

.mdi-playlist-play::before {
  content: "\\f0411";
}

.mdi-playlist-plus::before {
  content: "\\f0412";
}

.mdi-playlist-remove::before {
  content: "\\f0413";
}

.mdi-playlist-star::before {
  content: "\\f0df2";
}

.mdi-plex::before {
  content: "\\f06ba";
}

.mdi-pliers::before {
  content: "\\f19a4";
}

.mdi-plus::before {
  content: "\\f0415";
}

.mdi-plus-box::before {
  content: "\\f0416";
}

.mdi-plus-box-multiple::before {
  content: "\\f0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\f1143";
}

.mdi-plus-box-outline::before {
  content: "\\f0704";
}

.mdi-plus-circle::before {
  content: "\\f0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\f034c";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\f0418";
}

.mdi-plus-circle-outline::before {
  content: "\\f0419";
}

.mdi-plus-minus::before {
  content: "\\f0992";
}

.mdi-plus-minus-box::before {
  content: "\\f0993";
}

.mdi-plus-minus-variant::before {
  content: "\\f14c9";
}

.mdi-plus-network::before {
  content: "\\f041a";
}

.mdi-plus-network-outline::before {
  content: "\\f0cba";
}

.mdi-plus-outline::before {
  content: "\\f0705";
}

.mdi-plus-thick::before {
  content: "\\f11ec";
}

.mdi-podcast::before {
  content: "\\f0994";
}

.mdi-podium::before {
  content: "\\f0d25";
}

.mdi-podium-bronze::before {
  content: "\\f0d26";
}

.mdi-podium-gold::before {
  content: "\\f0d27";
}

.mdi-podium-silver::before {
  content: "\\f0d28";
}

.mdi-point-of-sale::before {
  content: "\\f0d92";
}

.mdi-pokeball::before {
  content: "\\f041d";
}

.mdi-pokemon-go::before {
  content: "\\f0a09";
}

.mdi-poker-chip::before {
  content: "\\f0830";
}

.mdi-polaroid::before {
  content: "\\f041e";
}

.mdi-police-badge::before {
  content: "\\f1167";
}

.mdi-police-badge-outline::before {
  content: "\\f1168";
}

.mdi-police-station::before {
  content: "\\f1839";
}

.mdi-poll::before {
  content: "\\f041f";
}

.mdi-polo::before {
  content: "\\f14c3";
}

.mdi-polymer::before {
  content: "\\f0421";
}

.mdi-pool::before {
  content: "\\f0606";
}

.mdi-popcorn::before {
  content: "\\f0422";
}

.mdi-post::before {
  content: "\\f1008";
}

.mdi-post-outline::before {
  content: "\\f1009";
}

.mdi-postage-stamp::before {
  content: "\\f0cbb";
}

.mdi-pot::before {
  content: "\\f02e5";
}

.mdi-pot-mix::before {
  content: "\\f065b";
}

.mdi-pot-mix-outline::before {
  content: "\\f0677";
}

.mdi-pot-outline::before {
  content: "\\f02ff";
}

.mdi-pot-steam::before {
  content: "\\f065a";
}

.mdi-pot-steam-outline::before {
  content: "\\f0326";
}

.mdi-pound::before {
  content: "\\f0423";
}

.mdi-pound-box::before {
  content: "\\f0424";
}

.mdi-pound-box-outline::before {
  content: "\\f117f";
}

.mdi-power::before {
  content: "\\f0425";
}

.mdi-power-cycle::before {
  content: "\\f0901";
}

.mdi-power-off::before {
  content: "\\f0902";
}

.mdi-power-on::before {
  content: "\\f0903";
}

.mdi-power-plug::before {
  content: "\\f06a5";
}

.mdi-power-plug-off::before {
  content: "\\f06a6";
}

.mdi-power-plug-off-outline::before {
  content: "\\f1424";
}

.mdi-power-plug-outline::before {
  content: "\\f1425";
}

.mdi-power-settings::before {
  content: "\\f0426";
}

.mdi-power-sleep::before {
  content: "\\f0904";
}

.mdi-power-socket::before {
  content: "\\f0427";
}

.mdi-power-socket-au::before {
  content: "\\f0905";
}

.mdi-power-socket-ch::before {
  content: "\\f0fb3";
}

.mdi-power-socket-de::before {
  content: "\\f1107";
}

.mdi-power-socket-eu::before {
  content: "\\f07e7";
}

.mdi-power-socket-fr::before {
  content: "\\f1108";
}

.mdi-power-socket-it::before {
  content: "\\f14ff";
}

.mdi-power-socket-jp::before {
  content: "\\f1109";
}

.mdi-power-socket-uk::before {
  content: "\\f07e8";
}

.mdi-power-socket-us::before {
  content: "\\f07e9";
}

.mdi-power-standby::before {
  content: "\\f0906";
}

.mdi-powershell::before {
  content: "\\f0a0a";
}

.mdi-prescription::before {
  content: "\\f0706";
}

.mdi-presentation::before {
  content: "\\f0428";
}

.mdi-presentation-play::before {
  content: "\\f0429";
}

.mdi-pretzel::before {
  content: "\\f1562";
}

.mdi-printer::before {
  content: "\\f042a";
}

.mdi-printer-3d::before {
  content: "\\f042b";
}

.mdi-printer-3d-nozzle::before {
  content: "\\f0e5b";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\f11c0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\f11c1";
}

.mdi-printer-3d-nozzle-heat::before {
  content: "\\f18b8";
}

.mdi-printer-3d-nozzle-heat-outline::before {
  content: "\\f18b9";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\f0e5c";
}

.mdi-printer-alert::before {
  content: "\\f042c";
}

.mdi-printer-check::before {
  content: "\\f1146";
}

.mdi-printer-eye::before {
  content: "\\f1458";
}

.mdi-printer-off::before {
  content: "\\f0e5d";
}

.mdi-printer-off-outline::before {
  content: "\\f1785";
}

.mdi-printer-outline::before {
  content: "\\f1786";
}

.mdi-printer-pos::before {
  content: "\\f1057";
}

.mdi-printer-search::before {
  content: "\\f1457";
}

.mdi-printer-settings::before {
  content: "\\f0707";
}

.mdi-printer-wireless::before {
  content: "\\f0a0b";
}

.mdi-priority-high::before {
  content: "\\f0603";
}

.mdi-priority-low::before {
  content: "\\f0604";
}

.mdi-professional-hexagon::before {
  content: "\\f042d";
}

.mdi-progress-alert::before {
  content: "\\f0cbc";
}

.mdi-progress-check::before {
  content: "\\f0995";
}

.mdi-progress-clock::before {
  content: "\\f0996";
}

.mdi-progress-close::before {
  content: "\\f110a";
}

.mdi-progress-download::before {
  content: "\\f0997";
}

.mdi-progress-pencil::before {
  content: "\\f1787";
}

.mdi-progress-question::before {
  content: "\\f1522";
}

.mdi-progress-star::before {
  content: "\\f1788";
}

.mdi-progress-upload::before {
  content: "\\f0998";
}

.mdi-progress-wrench::before {
  content: "\\f0cbd";
}

.mdi-projector::before {
  content: "\\f042e";
}

.mdi-projector-screen::before {
  content: "\\f042f";
}

.mdi-projector-screen-off::before {
  content: "\\f180d";
}

.mdi-projector-screen-off-outline::before {
  content: "\\f180e";
}

.mdi-projector-screen-outline::before {
  content: "\\f1724";
}

.mdi-projector-screen-variant::before {
  content: "\\f180f";
}

.mdi-projector-screen-variant-off::before {
  content: "\\f1810";
}

.mdi-projector-screen-variant-off-outline::before {
  content: "\\f1811";
}

.mdi-projector-screen-variant-outline::before {
  content: "\\f1812";
}

.mdi-propane-tank::before {
  content: "\\f1357";
}

.mdi-propane-tank-outline::before {
  content: "\\f1358";
}

.mdi-protocol::before {
  content: "\\f0fd8";
}

.mdi-publish::before {
  content: "\\f06a7";
}

.mdi-publish-off::before {
  content: "\\f1945";
}

.mdi-pulse::before {
  content: "\\f0430";
}

.mdi-pump::before {
  content: "\\f1402";
}

.mdi-pumpkin::before {
  content: "\\f0bbf";
}

.mdi-purse::before {
  content: "\\f0f1c";
}

.mdi-purse-outline::before {
  content: "\\f0f1d";
}

.mdi-puzzle::before {
  content: "\\f0431";
}

.mdi-puzzle-check::before {
  content: "\\f1426";
}

.mdi-puzzle-check-outline::before {
  content: "\\f1427";
}

.mdi-puzzle-edit::before {
  content: "\\f14d3";
}

.mdi-puzzle-edit-outline::before {
  content: "\\f14d9";
}

.mdi-puzzle-heart::before {
  content: "\\f14d4";
}

.mdi-puzzle-heart-outline::before {
  content: "\\f14da";
}

.mdi-puzzle-minus::before {
  content: "\\f14d1";
}

.mdi-puzzle-minus-outline::before {
  content: "\\f14d7";
}

.mdi-puzzle-outline::before {
  content: "\\f0a66";
}

.mdi-puzzle-plus::before {
  content: "\\f14d0";
}

.mdi-puzzle-plus-outline::before {
  content: "\\f14d6";
}

.mdi-puzzle-remove::before {
  content: "\\f14d2";
}

.mdi-puzzle-remove-outline::before {
  content: "\\f14d8";
}

.mdi-puzzle-star::before {
  content: "\\f14d5";
}

.mdi-puzzle-star-outline::before {
  content: "\\f14db";
}

.mdi-pyramid::before {
  content: "\\f1952";
}

.mdi-pyramid-off::before {
  content: "\\f1953";
}

.mdi-qi::before {
  content: "\\f0999";
}

.mdi-qqchat::before {
  content: "\\f0605";
}

.mdi-qrcode::before {
  content: "\\f0432";
}

.mdi-qrcode-edit::before {
  content: "\\f08b8";
}

.mdi-qrcode-minus::before {
  content: "\\f118c";
}

.mdi-qrcode-plus::before {
  content: "\\f118b";
}

.mdi-qrcode-remove::before {
  content: "\\f118d";
}

.mdi-qrcode-scan::before {
  content: "\\f0433";
}

.mdi-quadcopter::before {
  content: "\\f0434";
}

.mdi-quality-high::before {
  content: "\\f0435";
}

.mdi-quality-low::before {
  content: "\\f0a0c";
}

.mdi-quality-medium::before {
  content: "\\f0a0d";
}

.mdi-quora::before {
  content: "\\f0d29";
}

.mdi-rabbit::before {
  content: "\\f0907";
}

.mdi-racing-helmet::before {
  content: "\\f0d93";
}

.mdi-racquetball::before {
  content: "\\f0d94";
}

.mdi-radar::before {
  content: "\\f0437";
}

.mdi-radiator::before {
  content: "\\f0438";
}

.mdi-radiator-disabled::before {
  content: "\\f0ad7";
}

.mdi-radiator-off::before {
  content: "\\f0ad8";
}

.mdi-radio::before {
  content: "\\f0439";
}

.mdi-radio-am::before {
  content: "\\f0cbe";
}

.mdi-radio-fm::before {
  content: "\\f0cbf";
}

.mdi-radio-handheld::before {
  content: "\\f043a";
}

.mdi-radio-off::before {
  content: "\\f121c";
}

.mdi-radio-tower::before {
  content: "\\f043b";
}

.mdi-radioactive::before {
  content: "\\f043c";
}

.mdi-radioactive-circle::before {
  content: "\\f185d";
}

.mdi-radioactive-circle-outline::before {
  content: "\\f185e";
}

.mdi-radioactive-off::before {
  content: "\\f0ec1";
}

.mdi-radiobox-blank::before {
  content: "\\f043d";
}

.mdi-radiobox-marked::before {
  content: "\\f043e";
}

.mdi-radiology-box::before {
  content: "\\f14c5";
}

.mdi-radiology-box-outline::before {
  content: "\\f14c6";
}

.mdi-radius::before {
  content: "\\f0cc0";
}

.mdi-radius-outline::before {
  content: "\\f0cc1";
}

.mdi-railroad-light::before {
  content: "\\f0f1e";
}

.mdi-rake::before {
  content: "\\f1544";
}

.mdi-raspberry-pi::before {
  content: "\\f043f";
}

.mdi-ray-end::before {
  content: "\\f0440";
}

.mdi-ray-end-arrow::before {
  content: "\\f0441";
}

.mdi-ray-start::before {
  content: "\\f0442";
}

.mdi-ray-start-arrow::before {
  content: "\\f0443";
}

.mdi-ray-start-end::before {
  content: "\\f0444";
}

.mdi-ray-start-vertex-end::before {
  content: "\\f15d8";
}

.mdi-ray-vertex::before {
  content: "\\f0445";
}

.mdi-razor-double-edge::before {
  content: "\\f1997";
}

.mdi-razor-single-edge::before {
  content: "\\f1998";
}

.mdi-react::before {
  content: "\\f0708";
}

.mdi-read::before {
  content: "\\f0447";
}

.mdi-receipt::before {
  content: "\\f0449";
}

.mdi-record::before {
  content: "\\f044a";
}

.mdi-record-circle::before {
  content: "\\f0ec2";
}

.mdi-record-circle-outline::before {
  content: "\\f0ec3";
}

.mdi-record-player::before {
  content: "\\f099a";
}

.mdi-record-rec::before {
  content: "\\f044b";
}

.mdi-rectangle::before {
  content: "\\f0e5e";
}

.mdi-rectangle-outline::before {
  content: "\\f0e5f";
}

.mdi-recycle::before {
  content: "\\f044c";
}

.mdi-recycle-variant::before {
  content: "\\f139d";
}

.mdi-reddit::before {
  content: "\\f044d";
}

.mdi-redhat::before {
  content: "\\f111b";
}

.mdi-redo::before {
  content: "\\f044e";
}

.mdi-redo-variant::before {
  content: "\\f044f";
}

.mdi-reflect-horizontal::before {
  content: "\\f0a0e";
}

.mdi-reflect-vertical::before {
  content: "\\f0a0f";
}

.mdi-refresh::before {
  content: "\\f0450";
}

.mdi-refresh-auto::before {
  content: "\\f18f2";
}

.mdi-refresh-circle::before {
  content: "\\f1377";
}

.mdi-regex::before {
  content: "\\f0451";
}

.mdi-registered-trademark::before {
  content: "\\f0a67";
}

.mdi-reiterate::before {
  content: "\\f1588";
}

.mdi-relation-many-to-many::before {
  content: "\\f1496";
}

.mdi-relation-many-to-one::before {
  content: "\\f1497";
}

.mdi-relation-many-to-one-or-many::before {
  content: "\\f1498";
}

.mdi-relation-many-to-only-one::before {
  content: "\\f1499";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "\\f149a";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "\\f149b";
}

.mdi-relation-one-or-many-to-many::before {
  content: "\\f149c";
}

.mdi-relation-one-or-many-to-one::before {
  content: "\\f149d";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\f149e";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\f149f";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\f14a0";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\f14a1";
}

.mdi-relation-one-to-many::before {
  content: "\\f14a2";
}

.mdi-relation-one-to-one::before {
  content: "\\f14a3";
}

.mdi-relation-one-to-one-or-many::before {
  content: "\\f14a4";
}

.mdi-relation-one-to-only-one::before {
  content: "\\f14a5";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "\\f14a6";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "\\f14a7";
}

.mdi-relation-only-one-to-many::before {
  content: "\\f14a8";
}

.mdi-relation-only-one-to-one::before {
  content: "\\f14a9";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\f14aa";
}

.mdi-relation-only-one-to-only-one::before {
  content: "\\f14ab";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\f14ac";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\f14ad";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "\\f14ae";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "\\f14af";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\f14b0";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\f14b1";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\f14b2";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\f14b3";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "\\f14b4";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "\\f14b5";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\f14b6";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\f14b7";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\f14b8";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\f14b9";
}

.mdi-relative-scale::before {
  content: "\\f0452";
}

.mdi-reload::before {
  content: "\\f0453";
}

.mdi-reload-alert::before {
  content: "\\f110b";
}

.mdi-reminder::before {
  content: "\\f088c";
}

.mdi-remote::before {
  content: "\\f0454";
}

.mdi-remote-desktop::before {
  content: "\\f08b9";
}

.mdi-remote-off::before {
  content: "\\f0ec4";
}

.mdi-remote-tv::before {
  content: "\\f0ec5";
}

.mdi-remote-tv-off::before {
  content: "\\f0ec6";
}

.mdi-rename-box::before {
  content: "\\f0455";
}

.mdi-reorder-horizontal::before {
  content: "\\f0688";
}

.mdi-reorder-vertical::before {
  content: "\\f0689";
}

.mdi-repeat::before {
  content: "\\f0456";
}

.mdi-repeat-off::before {
  content: "\\f0457";
}

.mdi-repeat-once::before {
  content: "\\f0458";
}

.mdi-repeat-variant::before {
  content: "\\f0547";
}

.mdi-replay::before {
  content: "\\f0459";
}

.mdi-reply::before {
  content: "\\f045a";
}

.mdi-reply-all::before {
  content: "\\f045b";
}

.mdi-reply-all-outline::before {
  content: "\\f0f1f";
}

.mdi-reply-circle::before {
  content: "\\f11ae";
}

.mdi-reply-outline::before {
  content: "\\f0f20";
}

.mdi-reproduction::before {
  content: "\\f045c";
}

.mdi-resistor::before {
  content: "\\f0b44";
}

.mdi-resistor-nodes::before {
  content: "\\f0b45";
}

.mdi-resize::before {
  content: "\\f0a68";
}

.mdi-resize-bottom-right::before {
  content: "\\f045d";
}

.mdi-responsive::before {
  content: "\\f045e";
}

.mdi-restart::before {
  content: "\\f0709";
}

.mdi-restart-alert::before {
  content: "\\f110c";
}

.mdi-restart-off::before {
  content: "\\f0d95";
}

.mdi-restore::before {
  content: "\\f099b";
}

.mdi-restore-alert::before {
  content: "\\f110d";
}

.mdi-rewind::before {
  content: "\\f045f";
}

.mdi-rewind-10::before {
  content: "\\f0d2a";
}

.mdi-rewind-15::before {
  content: "\\f1946";
}

.mdi-rewind-30::before {
  content: "\\f0d96";
}

.mdi-rewind-5::before {
  content: "\\f11f9";
}

.mdi-rewind-60::before {
  content: "\\f160c";
}

.mdi-rewind-outline::before {
  content: "\\f070a";
}

.mdi-rhombus::before {
  content: "\\f070b";
}

.mdi-rhombus-medium::before {
  content: "\\f0a10";
}

.mdi-rhombus-medium-outline::before {
  content: "\\f14dc";
}

.mdi-rhombus-outline::before {
  content: "\\f070c";
}

.mdi-rhombus-split::before {
  content: "\\f0a11";
}

.mdi-rhombus-split-outline::before {
  content: "\\f14dd";
}

.mdi-ribbon::before {
  content: "\\f0460";
}

.mdi-rice::before {
  content: "\\f07ea";
}

.mdi-rickshaw::before {
  content: "\\f15bb";
}

.mdi-rickshaw-electric::before {
  content: "\\f15bc";
}

.mdi-ring::before {
  content: "\\f07eb";
}

.mdi-rivet::before {
  content: "\\f0e60";
}

.mdi-road::before {
  content: "\\f0461";
}

.mdi-road-variant::before {
  content: "\\f0462";
}

.mdi-robber::before {
  content: "\\f1058";
}

.mdi-robot::before {
  content: "\\f06a9";
}

.mdi-robot-angry::before {
  content: "\\f169d";
}

.mdi-robot-angry-outline::before {
  content: "\\f169e";
}

.mdi-robot-confused::before {
  content: "\\f169f";
}

.mdi-robot-confused-outline::before {
  content: "\\f16a0";
}

.mdi-robot-dead::before {
  content: "\\f16a1";
}

.mdi-robot-dead-outline::before {
  content: "\\f16a2";
}

.mdi-robot-excited::before {
  content: "\\f16a3";
}

.mdi-robot-excited-outline::before {
  content: "\\f16a4";
}

.mdi-robot-happy::before {
  content: "\\f1719";
}

.mdi-robot-happy-outline::before {
  content: "\\f171a";
}

.mdi-robot-industrial::before {
  content: "\\f0b46";
}

.mdi-robot-love::before {
  content: "\\f16a5";
}

.mdi-robot-love-outline::before {
  content: "\\f16a6";
}

.mdi-robot-mower::before {
  content: "\\f11f7";
}

.mdi-robot-mower-outline::before {
  content: "\\f11f3";
}

.mdi-robot-off::before {
  content: "\\f16a7";
}

.mdi-robot-off-outline::before {
  content: "\\f167b";
}

.mdi-robot-outline::before {
  content: "\\f167a";
}

.mdi-robot-vacuum::before {
  content: "\\f070d";
}

.mdi-robot-vacuum-variant::before {
  content: "\\f0908";
}

.mdi-rocket::before {
  content: "\\f0463";
}

.mdi-rocket-launch::before {
  content: "\\f14de";
}

.mdi-rocket-launch-outline::before {
  content: "\\f14df";
}

.mdi-rocket-outline::before {
  content: "\\f13af";
}

.mdi-rodent::before {
  content: "\\f1327";
}

.mdi-roller-skate::before {
  content: "\\f0d2b";
}

.mdi-roller-skate-off::before {
  content: "\\f0145";
}

.mdi-rollerblade::before {
  content: "\\f0d2c";
}

.mdi-rollerblade-off::before {
  content: "\\f002e";
}

.mdi-rollupjs::before {
  content: "\\f0bc0";
}

.mdi-roman-numeral-1::before {
  content: "\\f1088";
}

.mdi-roman-numeral-10::before {
  content: "\\f1091";
}

.mdi-roman-numeral-2::before {
  content: "\\f1089";
}

.mdi-roman-numeral-3::before {
  content: "\\f108a";
}

.mdi-roman-numeral-4::before {
  content: "\\f108b";
}

.mdi-roman-numeral-5::before {
  content: "\\f108c";
}

.mdi-roman-numeral-6::before {
  content: "\\f108d";
}

.mdi-roman-numeral-7::before {
  content: "\\f108e";
}

.mdi-roman-numeral-8::before {
  content: "\\f108f";
}

.mdi-roman-numeral-9::before {
  content: "\\f1090";
}

.mdi-room-service::before {
  content: "\\f088d";
}

.mdi-room-service-outline::before {
  content: "\\f0d97";
}

.mdi-rotate-360::before {
  content: "\\f1999";
}

.mdi-rotate-3d::before {
  content: "\\f0ec7";
}

.mdi-rotate-3d-variant::before {
  content: "\\f0464";
}

.mdi-rotate-left::before {
  content: "\\f0465";
}

.mdi-rotate-left-variant::before {
  content: "\\f0466";
}

.mdi-rotate-orbit::before {
  content: "\\f0d98";
}

.mdi-rotate-right::before {
  content: "\\f0467";
}

.mdi-rotate-right-variant::before {
  content: "\\f0468";
}

.mdi-rounded-corner::before {
  content: "\\f0607";
}

.mdi-router::before {
  content: "\\f11e2";
}

.mdi-router-network::before {
  content: "\\f1087";
}

.mdi-router-wireless::before {
  content: "\\f0469";
}

.mdi-router-wireless-off::before {
  content: "\\f15a3";
}

.mdi-router-wireless-settings::before {
  content: "\\f0a69";
}

.mdi-routes::before {
  content: "\\f046a";
}

.mdi-routes-clock::before {
  content: "\\f1059";
}

.mdi-rowing::before {
  content: "\\f0608";
}

.mdi-rss::before {
  content: "\\f046b";
}

.mdi-rss-box::before {
  content: "\\f046c";
}

.mdi-rss-off::before {
  content: "\\f0f21";
}

.mdi-rug::before {
  content: "\\f1475";
}

.mdi-rugby::before {
  content: "\\f0d99";
}

.mdi-ruler::before {
  content: "\\f046d";
}

.mdi-ruler-square::before {
  content: "\\f0cc2";
}

.mdi-ruler-square-compass::before {
  content: "\\f0ebe";
}

.mdi-run::before {
  content: "\\f070e";
}

.mdi-run-fast::before {
  content: "\\f046e";
}

.mdi-rv-truck::before {
  content: "\\f11d4";
}

.mdi-sack::before {
  content: "\\f0d2e";
}

.mdi-sack-percent::before {
  content: "\\f0d2f";
}

.mdi-safe::before {
  content: "\\f0a6a";
}

.mdi-safe-square::before {
  content: "\\f127c";
}

.mdi-safe-square-outline::before {
  content: "\\f127d";
}

.mdi-safety-goggles::before {
  content: "\\f0d30";
}

.mdi-sail-boat::before {
  content: "\\f0ec8";
}

.mdi-sale::before {
  content: "\\f046f";
}

.mdi-salesforce::before {
  content: "\\f088e";
}

.mdi-sass::before {
  content: "\\f07ec";
}

.mdi-satellite::before {
  content: "\\f0470";
}

.mdi-satellite-uplink::before {
  content: "\\f0909";
}

.mdi-satellite-variant::before {
  content: "\\f0471";
}

.mdi-sausage::before {
  content: "\\f08ba";
}

.mdi-sausage-off::before {
  content: "\\f1789";
}

.mdi-saw-blade::before {
  content: "\\f0e61";
}

.mdi-sawtooth-wave::before {
  content: "\\f147a";
}

.mdi-saxophone::before {
  content: "\\f0609";
}

.mdi-scale::before {
  content: "\\f0472";
}

.mdi-scale-balance::before {
  content: "\\f05d1";
}

.mdi-scale-bathroom::before {
  content: "\\f0473";
}

.mdi-scale-off::before {
  content: "\\f105a";
}

.mdi-scale-unbalanced::before {
  content: "\\f19b8";
}

.mdi-scan-helper::before {
  content: "\\f13d8";
}

.mdi-scanner::before {
  content: "\\f06ab";
}

.mdi-scanner-off::before {
  content: "\\f090a";
}

.mdi-scatter-plot::before {
  content: "\\f0ec9";
}

.mdi-scatter-plot-outline::before {
  content: "\\f0eca";
}

.mdi-scent::before {
  content: "\\f1958";
}

.mdi-scent-off::before {
  content: "\\f1959";
}

.mdi-school::before {
  content: "\\f0474";
}

.mdi-school-outline::before {
  content: "\\f1180";
}

.mdi-scissors-cutting::before {
  content: "\\f0a6b";
}

.mdi-scooter::before {
  content: "\\f15bd";
}

.mdi-scooter-electric::before {
  content: "\\f15be";
}

.mdi-scoreboard::before {
  content: "\\f127e";
}

.mdi-scoreboard-outline::before {
  content: "\\f127f";
}

.mdi-screen-rotation::before {
  content: "\\f0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\f0478";
}

.mdi-screw-flat-top::before {
  content: "\\f0df3";
}

.mdi-screw-lag::before {
  content: "\\f0df4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\f0df5";
}

.mdi-screw-machine-round-top::before {
  content: "\\f0df6";
}

.mdi-screw-round-top::before {
  content: "\\f0df7";
}

.mdi-screwdriver::before {
  content: "\\f0476";
}

.mdi-script::before {
  content: "\\f0bc1";
}

.mdi-script-outline::before {
  content: "\\f0477";
}

.mdi-script-text::before {
  content: "\\f0bc2";
}

.mdi-script-text-key::before {
  content: "\\f1725";
}

.mdi-script-text-key-outline::before {
  content: "\\f1726";
}

.mdi-script-text-outline::before {
  content: "\\f0bc3";
}

.mdi-script-text-play::before {
  content: "\\f1727";
}

.mdi-script-text-play-outline::before {
  content: "\\f1728";
}

.mdi-sd::before {
  content: "\\f0479";
}

.mdi-seal::before {
  content: "\\f047a";
}

.mdi-seal-variant::before {
  content: "\\f0fd9";
}

.mdi-search-web::before {
  content: "\\f070f";
}

.mdi-seat::before {
  content: "\\f0cc3";
}

.mdi-seat-flat::before {
  content: "\\f047b";
}

.mdi-seat-flat-angled::before {
  content: "\\f047c";
}

.mdi-seat-individual-suite::before {
  content: "\\f047d";
}

.mdi-seat-legroom-extra::before {
  content: "\\f047e";
}

.mdi-seat-legroom-normal::before {
  content: "\\f047f";
}

.mdi-seat-legroom-reduced::before {
  content: "\\f0480";
}

.mdi-seat-outline::before {
  content: "\\f0cc4";
}

.mdi-seat-passenger::before {
  content: "\\f1249";
}

.mdi-seat-recline-extra::before {
  content: "\\f0481";
}

.mdi-seat-recline-normal::before {
  content: "\\f0482";
}

.mdi-seatbelt::before {
  content: "\\f0cc5";
}

.mdi-security::before {
  content: "\\f0483";
}

.mdi-security-network::before {
  content: "\\f0484";
}

.mdi-seed::before {
  content: "\\f0e62";
}

.mdi-seed-off::before {
  content: "\\f13fd";
}

.mdi-seed-off-outline::before {
  content: "\\f13fe";
}

.mdi-seed-outline::before {
  content: "\\f0e63";
}

.mdi-seesaw::before {
  content: "\\f15a4";
}

.mdi-segment::before {
  content: "\\f0ecb";
}

.mdi-select::before {
  content: "\\f0485";
}

.mdi-select-all::before {
  content: "\\f0486";
}

.mdi-select-color::before {
  content: "\\f0d31";
}

.mdi-select-compare::before {
  content: "\\f0ad9";
}

.mdi-select-drag::before {
  content: "\\f0a6c";
}

.mdi-select-group::before {
  content: "\\f0f82";
}

.mdi-select-inverse::before {
  content: "\\f0487";
}

.mdi-select-marker::before {
  content: "\\f1280";
}

.mdi-select-multiple::before {
  content: "\\f1281";
}

.mdi-select-multiple-marker::before {
  content: "\\f1282";
}

.mdi-select-off::before {
  content: "\\f0488";
}

.mdi-select-place::before {
  content: "\\f0fda";
}

.mdi-select-remove::before {
  content: "\\f17c1";
}

.mdi-select-search::before {
  content: "\\f1204";
}

.mdi-selection::before {
  content: "\\f0489";
}

.mdi-selection-drag::before {
  content: "\\f0a6d";
}

.mdi-selection-ellipse::before {
  content: "\\f0d32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\f0f22";
}

.mdi-selection-ellipse-remove::before {
  content: "\\f17c2";
}

.mdi-selection-marker::before {
  content: "\\f1283";
}

.mdi-selection-multiple::before {
  content: "\\f1285";
}

.mdi-selection-multiple-marker::before {
  content: "\\f1284";
}

.mdi-selection-off::before {
  content: "\\f0777";
}

.mdi-selection-remove::before {
  content: "\\f17c3";
}

.mdi-selection-search::before {
  content: "\\f1205";
}

.mdi-semantic-web::before {
  content: "\\f1316";
}

.mdi-send::before {
  content: "\\f048a";
}

.mdi-send-check::before {
  content: "\\f1161";
}

.mdi-send-check-outline::before {
  content: "\\f1162";
}

.mdi-send-circle::before {
  content: "\\f0df8";
}

.mdi-send-circle-outline::before {
  content: "\\f0df9";
}

.mdi-send-clock::before {
  content: "\\f1163";
}

.mdi-send-clock-outline::before {
  content: "\\f1164";
}

.mdi-send-lock::before {
  content: "\\f07ed";
}

.mdi-send-lock-outline::before {
  content: "\\f1166";
}

.mdi-send-outline::before {
  content: "\\f1165";
}

.mdi-serial-port::before {
  content: "\\f065c";
}

.mdi-server::before {
  content: "\\f048b";
}

.mdi-server-minus::before {
  content: "\\f048c";
}

.mdi-server-network::before {
  content: "\\f048d";
}

.mdi-server-network-off::before {
  content: "\\f048e";
}

.mdi-server-off::before {
  content: "\\f048f";
}

.mdi-server-plus::before {
  content: "\\f0490";
}

.mdi-server-remove::before {
  content: "\\f0491";
}

.mdi-server-security::before {
  content: "\\f0492";
}

.mdi-set-all::before {
  content: "\\f0778";
}

.mdi-set-center::before {
  content: "\\f0779";
}

.mdi-set-center-right::before {
  content: "\\f077a";
}

.mdi-set-left::before {
  content: "\\f077b";
}

.mdi-set-left-center::before {
  content: "\\f077c";
}

.mdi-set-left-right::before {
  content: "\\f077d";
}

.mdi-set-merge::before {
  content: "\\f14e0";
}

.mdi-set-none::before {
  content: "\\f077e";
}

.mdi-set-right::before {
  content: "\\f077f";
}

.mdi-set-split::before {
  content: "\\f14e1";
}

.mdi-set-square::before {
  content: "\\f145d";
}

.mdi-set-top-box::before {
  content: "\\f099f";
}

.mdi-settings-helper::before {
  content: "\\f0a6e";
}

.mdi-shaker::before {
  content: "\\f110e";
}

.mdi-shaker-outline::before {
  content: "\\f110f";
}

.mdi-shape::before {
  content: "\\f0831";
}

.mdi-shape-circle-plus::before {
  content: "\\f065d";
}

.mdi-shape-outline::before {
  content: "\\f0832";
}

.mdi-shape-oval-plus::before {
  content: "\\f11fa";
}

.mdi-shape-plus::before {
  content: "\\f0495";
}

.mdi-shape-polygon-plus::before {
  content: "\\f065e";
}

.mdi-shape-rectangle-plus::before {
  content: "\\f065f";
}

.mdi-shape-square-plus::before {
  content: "\\f0660";
}

.mdi-shape-square-rounded-plus::before {
  content: "\\f14fa";
}

.mdi-share::before {
  content: "\\f0496";
}

.mdi-share-all::before {
  content: "\\f11f4";
}

.mdi-share-all-outline::before {
  content: "\\f11f5";
}

.mdi-share-circle::before {
  content: "\\f11ad";
}

.mdi-share-off::before {
  content: "\\f0f23";
}

.mdi-share-off-outline::before {
  content: "\\f0f24";
}

.mdi-share-outline::before {
  content: "\\f0932";
}

.mdi-share-variant::before {
  content: "\\f0497";
}

.mdi-share-variant-outline::before {
  content: "\\f1514";
}

.mdi-shark::before {
  content: "\\f18ba";
}

.mdi-shark-fin::before {
  content: "\\f1673";
}

.mdi-shark-fin-outline::before {
  content: "\\f1674";
}

.mdi-shark-off::before {
  content: "\\f18bb";
}

.mdi-sheep::before {
  content: "\\f0cc6";
}

.mdi-shield::before {
  content: "\\f0498";
}

.mdi-shield-account::before {
  content: "\\f088f";
}

.mdi-shield-account-outline::before {
  content: "\\f0a12";
}

.mdi-shield-account-variant::before {
  content: "\\f15a7";
}

.mdi-shield-account-variant-outline::before {
  content: "\\f15a8";
}

.mdi-shield-airplane::before {
  content: "\\f06bb";
}

.mdi-shield-airplane-outline::before {
  content: "\\f0cc7";
}

.mdi-shield-alert::before {
  content: "\\f0ecc";
}

.mdi-shield-alert-outline::before {
  content: "\\f0ecd";
}

.mdi-shield-bug::before {
  content: "\\f13da";
}

.mdi-shield-bug-outline::before {
  content: "\\f13db";
}

.mdi-shield-car::before {
  content: "\\f0f83";
}

.mdi-shield-check::before {
  content: "\\f0565";
}

.mdi-shield-check-outline::before {
  content: "\\f0cc8";
}

.mdi-shield-cross::before {
  content: "\\f0cc9";
}

.mdi-shield-cross-outline::before {
  content: "\\f0cca";
}

.mdi-shield-crown::before {
  content: "\\f18bc";
}

.mdi-shield-crown-outline::before {
  content: "\\f18bd";
}

.mdi-shield-edit::before {
  content: "\\f11a0";
}

.mdi-shield-edit-outline::before {
  content: "\\f11a1";
}

.mdi-shield-half::before {
  content: "\\f1360";
}

.mdi-shield-half-full::before {
  content: "\\f0780";
}

.mdi-shield-home::before {
  content: "\\f068a";
}

.mdi-shield-home-outline::before {
  content: "\\f0ccb";
}

.mdi-shield-key::before {
  content: "\\f0bc4";
}

.mdi-shield-key-outline::before {
  content: "\\f0bc5";
}

.mdi-shield-link-variant::before {
  content: "\\f0d33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\f0d34";
}

.mdi-shield-lock::before {
  content: "\\f099d";
}

.mdi-shield-lock-open::before {
  content: "\\f199a";
}

.mdi-shield-lock-open-outline::before {
  content: "\\f199b";
}

.mdi-shield-lock-outline::before {
  content: "\\f0ccc";
}

.mdi-shield-moon::before {
  content: "\\f1828";
}

.mdi-shield-moon-outline::before {
  content: "\\f1829";
}

.mdi-shield-off::before {
  content: "\\f099e";
}

.mdi-shield-off-outline::before {
  content: "\\f099c";
}

.mdi-shield-outline::before {
  content: "\\f0499";
}

.mdi-shield-plus::before {
  content: "\\f0ada";
}

.mdi-shield-plus-outline::before {
  content: "\\f0adb";
}

.mdi-shield-refresh::before {
  content: "\\f00aa";
}

.mdi-shield-refresh-outline::before {
  content: "\\f01e0";
}

.mdi-shield-remove::before {
  content: "\\f0adc";
}

.mdi-shield-remove-outline::before {
  content: "\\f0add";
}

.mdi-shield-search::before {
  content: "\\f0d9a";
}

.mdi-shield-star::before {
  content: "\\f113b";
}

.mdi-shield-star-outline::before {
  content: "\\f113c";
}

.mdi-shield-sun::before {
  content: "\\f105d";
}

.mdi-shield-sun-outline::before {
  content: "\\f105e";
}

.mdi-shield-sword::before {
  content: "\\f18be";
}

.mdi-shield-sword-outline::before {
  content: "\\f18bf";
}

.mdi-shield-sync::before {
  content: "\\f11a2";
}

.mdi-shield-sync-outline::before {
  content: "\\f11a3";
}

.mdi-shimmer::before {
  content: "\\f1545";
}

.mdi-ship-wheel::before {
  content: "\\f0833";
}

.mdi-shipping-pallet::before {
  content: "\\f184e";
}

.mdi-shoe-ballet::before {
  content: "\\f15ca";
}

.mdi-shoe-cleat::before {
  content: "\\f15c7";
}

.mdi-shoe-formal::before {
  content: "\\f0b47";
}

.mdi-shoe-heel::before {
  content: "\\f0b48";
}

.mdi-shoe-print::before {
  content: "\\f0dfa";
}

.mdi-shoe-sneaker::before {
  content: "\\f15c8";
}

.mdi-shopping::before {
  content: "\\f049a";
}

.mdi-shopping-music::before {
  content: "\\f049b";
}

.mdi-shopping-outline::before {
  content: "\\f11d5";
}

.mdi-shopping-search::before {
  content: "\\f0f84";
}

.mdi-shore::before {
  content: "\\f14f9";
}

.mdi-shovel::before {
  content: "\\f0710";
}

.mdi-shovel-off::before {
  content: "\\f0711";
}

.mdi-shower::before {
  content: "\\f09a0";
}

.mdi-shower-head::before {
  content: "\\f09a1";
}

.mdi-shredder::before {
  content: "\\f049c";
}

.mdi-shuffle::before {
  content: "\\f049d";
}

.mdi-shuffle-disabled::before {
  content: "\\f049e";
}

.mdi-shuffle-variant::before {
  content: "\\f049f";
}

.mdi-shuriken::before {
  content: "\\f137f";
}

.mdi-sickle::before {
  content: "\\f18c0";
}

.mdi-sigma::before {
  content: "\\f04a0";
}

.mdi-sigma-lower::before {
  content: "\\f062b";
}

.mdi-sign-caution::before {
  content: "\\f04a1";
}

.mdi-sign-direction::before {
  content: "\\f0781";
}

.mdi-sign-direction-minus::before {
  content: "\\f1000";
}

.mdi-sign-direction-plus::before {
  content: "\\f0fdc";
}

.mdi-sign-direction-remove::before {
  content: "\\f0fdd";
}

.mdi-sign-pole::before {
  content: "\\f14f8";
}

.mdi-sign-real-estate::before {
  content: "\\f1118";
}

.mdi-sign-text::before {
  content: "\\f0782";
}

.mdi-signal::before {
  content: "\\f04a2";
}

.mdi-signal-2g::before {
  content: "\\f0712";
}

.mdi-signal-3g::before {
  content: "\\f0713";
}

.mdi-signal-4g::before {
  content: "\\f0714";
}

.mdi-signal-5g::before {
  content: "\\f0a6f";
}

.mdi-signal-cellular-1::before {
  content: "\\f08bc";
}

.mdi-signal-cellular-2::before {
  content: "\\f08bd";
}

.mdi-signal-cellular-3::before {
  content: "\\f08be";
}

.mdi-signal-cellular-outline::before {
  content: "\\f08bf";
}

.mdi-signal-distance-variant::before {
  content: "\\f0e64";
}

.mdi-signal-hspa::before {
  content: "\\f0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\f0716";
}

.mdi-signal-off::before {
  content: "\\f0783";
}

.mdi-signal-variant::before {
  content: "\\f060a";
}

.mdi-signature::before {
  content: "\\f0dfb";
}

.mdi-signature-freehand::before {
  content: "\\f0dfc";
}

.mdi-signature-image::before {
  content: "\\f0dfd";
}

.mdi-signature-text::before {
  content: "\\f0dfe";
}

.mdi-silo::before {
  content: "\\f0b49";
}

.mdi-silverware::before {
  content: "\\f04a3";
}

.mdi-silverware-clean::before {
  content: "\\f0fde";
}

.mdi-silverware-fork::before {
  content: "\\f04a4";
}

.mdi-silverware-fork-knife::before {
  content: "\\f0a70";
}

.mdi-silverware-spoon::before {
  content: "\\f04a5";
}

.mdi-silverware-variant::before {
  content: "\\f04a6";
}

.mdi-sim::before {
  content: "\\f04a7";
}

.mdi-sim-alert::before {
  content: "\\f04a8";
}

.mdi-sim-alert-outline::before {
  content: "\\f15d3";
}

.mdi-sim-off::before {
  content: "\\f04a9";
}

.mdi-sim-off-outline::before {
  content: "\\f15d4";
}

.mdi-sim-outline::before {
  content: "\\f15d5";
}

.mdi-simple-icons::before {
  content: "\\f131d";
}

.mdi-sina-weibo::before {
  content: "\\f0adf";
}

.mdi-sine-wave::before {
  content: "\\f095b";
}

.mdi-sitemap::before {
  content: "\\f04aa";
}

.mdi-sitemap-outline::before {
  content: "\\f199c";
}

.mdi-size-l::before {
  content: "\\f13a6";
}

.mdi-size-m::before {
  content: "\\f13a5";
}

.mdi-size-s::before {
  content: "\\f13a4";
}

.mdi-size-xl::before {
  content: "\\f13a7";
}

.mdi-size-xs::before {
  content: "\\f13a3";
}

.mdi-size-xxl::before {
  content: "\\f13a8";
}

.mdi-size-xxs::before {
  content: "\\f13a2";
}

.mdi-size-xxxl::before {
  content: "\\f13a9";
}

.mdi-skate::before {
  content: "\\f0d35";
}

.mdi-skate-off::before {
  content: "\\f0699";
}

.mdi-skateboard::before {
  content: "\\f14c2";
}

.mdi-skateboarding::before {
  content: "\\f0501";
}

.mdi-skew-less::before {
  content: "\\f0d36";
}

.mdi-skew-more::before {
  content: "\\f0d37";
}

.mdi-ski::before {
  content: "\\f1304";
}

.mdi-ski-cross-country::before {
  content: "\\f1305";
}

.mdi-ski-water::before {
  content: "\\f1306";
}

.mdi-skip-backward::before {
  content: "\\f04ab";
}

.mdi-skip-backward-outline::before {
  content: "\\f0f25";
}

.mdi-skip-forward::before {
  content: "\\f04ac";
}

.mdi-skip-forward-outline::before {
  content: "\\f0f26";
}

.mdi-skip-next::before {
  content: "\\f04ad";
}

.mdi-skip-next-circle::before {
  content: "\\f0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\f0662";
}

.mdi-skip-next-outline::before {
  content: "\\f0f27";
}

.mdi-skip-previous::before {
  content: "\\f04ae";
}

.mdi-skip-previous-circle::before {
  content: "\\f0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\f0664";
}

.mdi-skip-previous-outline::before {
  content: "\\f0f28";
}

.mdi-skull::before {
  content: "\\f068c";
}

.mdi-skull-crossbones::before {
  content: "\\f0bc6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\f0bc7";
}

.mdi-skull-outline::before {
  content: "\\f0bc8";
}

.mdi-skull-scan::before {
  content: "\\f14c7";
}

.mdi-skull-scan-outline::before {
  content: "\\f14c8";
}

.mdi-skype::before {
  content: "\\f04af";
}

.mdi-skype-business::before {
  content: "\\f04b0";
}

.mdi-slack::before {
  content: "\\f04b1";
}

.mdi-slash-forward::before {
  content: "\\f0fdf";
}

.mdi-slash-forward-box::before {
  content: "\\f0fe0";
}

.mdi-sledding::before {
  content: "\\f041b";
}

.mdi-sleep::before {
  content: "\\f04b2";
}

.mdi-sleep-off::before {
  content: "\\f04b3";
}

.mdi-slide::before {
  content: "\\f15a5";
}

.mdi-slope-downhill::before {
  content: "\\f0dff";
}

.mdi-slope-uphill::before {
  content: "\\f0e00";
}

.mdi-slot-machine::before {
  content: "\\f1114";
}

.mdi-slot-machine-outline::before {
  content: "\\f1115";
}

.mdi-smart-card::before {
  content: "\\f10bd";
}

.mdi-smart-card-off::before {
  content: "\\f18f7";
}

.mdi-smart-card-off-outline::before {
  content: "\\f18f8";
}

.mdi-smart-card-outline::before {
  content: "\\f10be";
}

.mdi-smart-card-reader::before {
  content: "\\f10bf";
}

.mdi-smart-card-reader-outline::before {
  content: "\\f10c0";
}

.mdi-smog::before {
  content: "\\f0a71";
}

.mdi-smoke::before {
  content: "\\f1799";
}

.mdi-smoke-detector::before {
  content: "\\f0392";
}

.mdi-smoke-detector-alert::before {
  content: "\\f192e";
}

.mdi-smoke-detector-alert-outline::before {
  content: "\\f192f";
}

.mdi-smoke-detector-off::before {
  content: "\\f1809";
}

.mdi-smoke-detector-off-outline::before {
  content: "\\f180a";
}

.mdi-smoke-detector-outline::before {
  content: "\\f1808";
}

.mdi-smoke-detector-variant::before {
  content: "\\f180b";
}

.mdi-smoke-detector-variant-alert::before {
  content: "\\f1930";
}

.mdi-smoke-detector-variant-off::before {
  content: "\\f180c";
}

.mdi-smoking::before {
  content: "\\f04b4";
}

.mdi-smoking-off::before {
  content: "\\f04b5";
}

.mdi-smoking-pipe::before {
  content: "\\f140d";
}

.mdi-smoking-pipe-off::before {
  content: "\\f1428";
}

.mdi-snail::before {
  content: "\\f1677";
}

.mdi-snake::before {
  content: "\\f150e";
}

.mdi-snapchat::before {
  content: "\\f04b6";
}

.mdi-snowboard::before {
  content: "\\f1307";
}

.mdi-snowflake::before {
  content: "\\f0717";
}

.mdi-snowflake-alert::before {
  content: "\\f0f29";
}

.mdi-snowflake-melt::before {
  content: "\\f12cb";
}

.mdi-snowflake-off::before {
  content: "\\f14e3";
}

.mdi-snowflake-variant::before {
  content: "\\f0f2a";
}

.mdi-snowman::before {
  content: "\\f04b7";
}

.mdi-snowmobile::before {
  content: "\\f06dd";
}

.mdi-soccer::before {
  content: "\\f04b8";
}

.mdi-soccer-field::before {
  content: "\\f0834";
}

.mdi-social-distance-2-meters::before {
  content: "\\f1579";
}

.mdi-social-distance-6-feet::before {
  content: "\\f157a";
}

.mdi-sofa::before {
  content: "\\f04b9";
}

.mdi-sofa-outline::before {
  content: "\\f156d";
}

.mdi-sofa-single::before {
  content: "\\f156e";
}

.mdi-sofa-single-outline::before {
  content: "\\f156f";
}

.mdi-solar-panel::before {
  content: "\\f0d9b";
}

.mdi-solar-panel-large::before {
  content: "\\f0d9c";
}

.mdi-solar-power::before {
  content: "\\f0a72";
}

.mdi-soldering-iron::before {
  content: "\\f1092";
}

.mdi-solid::before {
  content: "\\f068d";
}

.mdi-sony-playstation::before {
  content: "\\f0414";
}

.mdi-sort::before {
  content: "\\f04ba";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\f05bd";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\f1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\f05bf";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\f1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\f04bb";
}

.mdi-sort-ascending::before {
  content: "\\f04bc";
}

.mdi-sort-bool-ascending::before {
  content: "\\f1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\f1386";
}

.mdi-sort-bool-descending::before {
  content: "\\f1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\f1388";
}

.mdi-sort-calendar-ascending::before {
  content: "\\f1547";
}

.mdi-sort-calendar-descending::before {
  content: "\\f1548";
}

.mdi-sort-clock-ascending::before {
  content: "\\f1549";
}

.mdi-sort-clock-ascending-outline::before {
  content: "\\f154a";
}

.mdi-sort-clock-descending::before {
  content: "\\f154b";
}

.mdi-sort-clock-descending-outline::before {
  content: "\\f154c";
}

.mdi-sort-descending::before {
  content: "\\f04bd";
}

.mdi-sort-numeric-ascending::before {
  content: "\\f1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\f090d";
}

.mdi-sort-numeric-descending::before {
  content: "\\f138a";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\f0ad2";
}

.mdi-sort-numeric-variant::before {
  content: "\\f04be";
}

.mdi-sort-reverse-variant::before {
  content: "\\f033c";
}

.mdi-sort-variant::before {
  content: "\\f04bf";
}

.mdi-sort-variant-lock::before {
  content: "\\f0ccd";
}

.mdi-sort-variant-lock-open::before {
  content: "\\f0cce";
}

.mdi-sort-variant-remove::before {
  content: "\\f1147";
}

.mdi-soundbar::before {
  content: "\\f17db";
}

.mdi-soundcloud::before {
  content: "\\f04c0";
}

.mdi-source-branch::before {
  content: "\\f062c";
}

.mdi-source-branch-check::before {
  content: "\\f14cf";
}

.mdi-source-branch-minus::before {
  content: "\\f14cb";
}

.mdi-source-branch-plus::before {
  content: "\\f14ca";
}

.mdi-source-branch-refresh::before {
  content: "\\f14cd";
}

.mdi-source-branch-remove::before {
  content: "\\f14cc";
}

.mdi-source-branch-sync::before {
  content: "\\f14ce";
}

.mdi-source-commit::before {
  content: "\\f0718";
}

.mdi-source-commit-end::before {
  content: "\\f0719";
}

.mdi-source-commit-end-local::before {
  content: "\\f071a";
}

.mdi-source-commit-local::before {
  content: "\\f071b";
}

.mdi-source-commit-next-local::before {
  content: "\\f071c";
}

.mdi-source-commit-start::before {
  content: "\\f071d";
}

.mdi-source-commit-start-next-local::before {
  content: "\\f071e";
}

.mdi-source-fork::before {
  content: "\\f04c1";
}

.mdi-source-merge::before {
  content: "\\f062d";
}

.mdi-source-pull::before {
  content: "\\f04c2";
}

.mdi-source-repository::before {
  content: "\\f0ccf";
}

.mdi-source-repository-multiple::before {
  content: "\\f0cd0";
}

.mdi-soy-sauce::before {
  content: "\\f07ee";
}

.mdi-soy-sauce-off::before {
  content: "\\f13fc";
}

.mdi-spa::before {
  content: "\\f0cd1";
}

.mdi-spa-outline::before {
  content: "\\f0cd2";
}

.mdi-space-invaders::before {
  content: "\\f0bc9";
}

.mdi-space-station::before {
  content: "\\f1383";
}

.mdi-spade::before {
  content: "\\f0e65";
}

.mdi-speaker::before {
  content: "\\f04c3";
}

.mdi-speaker-bluetooth::before {
  content: "\\f09a2";
}

.mdi-speaker-multiple::before {
  content: "\\f0d38";
}

.mdi-speaker-off::before {
  content: "\\f04c4";
}

.mdi-speaker-wireless::before {
  content: "\\f071f";
}

.mdi-spear::before {
  content: "\\f1845";
}

.mdi-speedometer::before {
  content: "\\f04c5";
}

.mdi-speedometer-medium::before {
  content: "\\f0f85";
}

.mdi-speedometer-slow::before {
  content: "\\f0f86";
}

.mdi-spellcheck::before {
  content: "\\f04c6";
}

.mdi-sphere::before {
  content: "\\f1954";
}

.mdi-sphere-off::before {
  content: "\\f1955";
}

.mdi-spider::before {
  content: "\\f11ea";
}

.mdi-spider-thread::before {
  content: "\\f11eb";
}

.mdi-spider-web::before {
  content: "\\f0bca";
}

.mdi-spirit-level::before {
  content: "\\f14f1";
}

.mdi-spoon-sugar::before {
  content: "\\f1429";
}

.mdi-spotify::before {
  content: "\\f04c7";
}

.mdi-spotlight::before {
  content: "\\f04c8";
}

.mdi-spotlight-beam::before {
  content: "\\f04c9";
}

.mdi-spray::before {
  content: "\\f0665";
}

.mdi-spray-bottle::before {
  content: "\\f0ae0";
}

.mdi-sprinkler::before {
  content: "\\f105f";
}

.mdi-sprinkler-fire::before {
  content: "\\f199d";
}

.mdi-sprinkler-variant::before {
  content: "\\f1060";
}

.mdi-sprout::before {
  content: "\\f0e66";
}

.mdi-sprout-outline::before {
  content: "\\f0e67";
}

.mdi-square::before {
  content: "\\f0764";
}

.mdi-square-circle::before {
  content: "\\f1500";
}

.mdi-square-edit-outline::before {
  content: "\\f090c";
}

.mdi-square-medium::before {
  content: "\\f0a13";
}

.mdi-square-medium-outline::before {
  content: "\\f0a14";
}

.mdi-square-off::before {
  content: "\\f12ee";
}

.mdi-square-off-outline::before {
  content: "\\f12ef";
}

.mdi-square-opacity::before {
  content: "\\f1854";
}

.mdi-square-outline::before {
  content: "\\f0763";
}

.mdi-square-root::before {
  content: "\\f0784";
}

.mdi-square-root-box::before {
  content: "\\f09a3";
}

.mdi-square-rounded::before {
  content: "\\f14fb";
}

.mdi-square-rounded-outline::before {
  content: "\\f14fc";
}

.mdi-square-small::before {
  content: "\\f0a15";
}

.mdi-square-wave::before {
  content: "\\f147b";
}

.mdi-squeegee::before {
  content: "\\f0ae1";
}

.mdi-ssh::before {
  content: "\\f08c0";
}

.mdi-stack-exchange::before {
  content: "\\f060b";
}

.mdi-stack-overflow::before {
  content: "\\f04cc";
}

.mdi-stackpath::before {
  content: "\\f0359";
}

.mdi-stadium::before {
  content: "\\f0ff9";
}

.mdi-stadium-variant::before {
  content: "\\f0720";
}

.mdi-stairs::before {
  content: "\\f04cd";
}

.mdi-stairs-box::before {
  content: "\\f139e";
}

.mdi-stairs-down::before {
  content: "\\f12be";
}

.mdi-stairs-up::before {
  content: "\\f12bd";
}

.mdi-stamper::before {
  content: "\\f0d39";
}

.mdi-standard-definition::before {
  content: "\\f07ef";
}

.mdi-star::before {
  content: "\\f04ce";
}

.mdi-star-box::before {
  content: "\\f0a73";
}

.mdi-star-box-multiple::before {
  content: "\\f1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\f1287";
}

.mdi-star-box-outline::before {
  content: "\\f0a74";
}

.mdi-star-check::before {
  content: "\\f1566";
}

.mdi-star-check-outline::before {
  content: "\\f156a";
}

.mdi-star-circle::before {
  content: "\\f04cf";
}

.mdi-star-circle-outline::before {
  content: "\\f09a4";
}

.mdi-star-cog::before {
  content: "\\f1668";
}

.mdi-star-cog-outline::before {
  content: "\\f1669";
}

.mdi-star-crescent::before {
  content: "\\f0979";
}

.mdi-star-david::before {
  content: "\\f097a";
}

.mdi-star-face::before {
  content: "\\f09a5";
}

.mdi-star-four-points::before {
  content: "\\f0ae2";
}

.mdi-star-four-points-outline::before {
  content: "\\f0ae3";
}

.mdi-star-half::before {
  content: "\\f0246";
}

.mdi-star-half-full::before {
  content: "\\f04d0";
}

.mdi-star-minus::before {
  content: "\\f1564";
}

.mdi-star-minus-outline::before {
  content: "\\f1568";
}

.mdi-star-off::before {
  content: "\\f04d1";
}

.mdi-star-off-outline::before {
  content: "\\f155b";
}

.mdi-star-outline::before {
  content: "\\f04d2";
}

.mdi-star-plus::before {
  content: "\\f1563";
}

.mdi-star-plus-outline::before {
  content: "\\f1567";
}

.mdi-star-remove::before {
  content: "\\f1565";
}

.mdi-star-remove-outline::before {
  content: "\\f1569";
}

.mdi-star-settings::before {
  content: "\\f166a";
}

.mdi-star-settings-outline::before {
  content: "\\f166b";
}

.mdi-star-shooting::before {
  content: "\\f1741";
}

.mdi-star-shooting-outline::before {
  content: "\\f1742";
}

.mdi-star-three-points::before {
  content: "\\f0ae4";
}

.mdi-star-three-points-outline::before {
  content: "\\f0ae5";
}

.mdi-state-machine::before {
  content: "\\f11ef";
}

.mdi-steam::before {
  content: "\\f04d3";
}

.mdi-steering::before {
  content: "\\f04d4";
}

.mdi-steering-off::before {
  content: "\\f090e";
}

.mdi-step-backward::before {
  content: "\\f04d5";
}

.mdi-step-backward-2::before {
  content: "\\f04d6";
}

.mdi-step-forward::before {
  content: "\\f04d7";
}

.mdi-step-forward-2::before {
  content: "\\f04d8";
}

.mdi-stethoscope::before {
  content: "\\f04d9";
}

.mdi-sticker::before {
  content: "\\f1364";
}

.mdi-sticker-alert::before {
  content: "\\f1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\f1366";
}

.mdi-sticker-check::before {
  content: "\\f1367";
}

.mdi-sticker-check-outline::before {
  content: "\\f1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\f05d0";
}

.mdi-sticker-emoji::before {
  content: "\\f0785";
}

.mdi-sticker-minus::before {
  content: "\\f1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\f136a";
}

.mdi-sticker-outline::before {
  content: "\\f136b";
}

.mdi-sticker-plus::before {
  content: "\\f136c";
}

.mdi-sticker-plus-outline::before {
  content: "\\f136d";
}

.mdi-sticker-remove::before {
  content: "\\f136e";
}

.mdi-sticker-remove-outline::before {
  content: "\\f136f";
}

.mdi-sticker-text::before {
  content: "\\f178e";
}

.mdi-sticker-text-outline::before {
  content: "\\f178f";
}

.mdi-stocking::before {
  content: "\\f04da";
}

.mdi-stomach::before {
  content: "\\f1093";
}

.mdi-stool::before {
  content: "\\f195d";
}

.mdi-stool-outline::before {
  content: "\\f195e";
}

.mdi-stop::before {
  content: "\\f04db";
}

.mdi-stop-circle::before {
  content: "\\f0666";
}

.mdi-stop-circle-outline::before {
  content: "\\f0667";
}

.mdi-store::before {
  content: "\\f04dc";
}

.mdi-store-24-hour::before {
  content: "\\f04dd";
}

.mdi-store-alert::before {
  content: "\\f18c1";
}

.mdi-store-alert-outline::before {
  content: "\\f18c2";
}

.mdi-store-check::before {
  content: "\\f18c3";
}

.mdi-store-check-outline::before {
  content: "\\f18c4";
}

.mdi-store-clock::before {
  content: "\\f18c5";
}

.mdi-store-clock-outline::before {
  content: "\\f18c6";
}

.mdi-store-cog::before {
  content: "\\f18c7";
}

.mdi-store-cog-outline::before {
  content: "\\f18c8";
}

.mdi-store-edit::before {
  content: "\\f18c9";
}

.mdi-store-edit-outline::before {
  content: "\\f18ca";
}

.mdi-store-marker::before {
  content: "\\f18cb";
}

.mdi-store-marker-outline::before {
  content: "\\f18cc";
}

.mdi-store-minus::before {
  content: "\\f165e";
}

.mdi-store-minus-outline::before {
  content: "\\f18cd";
}

.mdi-store-off::before {
  content: "\\f18ce";
}

.mdi-store-off-outline::before {
  content: "\\f18cf";
}

.mdi-store-outline::before {
  content: "\\f1361";
}

.mdi-store-plus::before {
  content: "\\f165f";
}

.mdi-store-plus-outline::before {
  content: "\\f18d0";
}

.mdi-store-remove::before {
  content: "\\f1660";
}

.mdi-store-remove-outline::before {
  content: "\\f18d1";
}

.mdi-store-search::before {
  content: "\\f18d2";
}

.mdi-store-search-outline::before {
  content: "\\f18d3";
}

.mdi-store-settings::before {
  content: "\\f18d4";
}

.mdi-store-settings-outline::before {
  content: "\\f18d5";
}

.mdi-storefront::before {
  content: "\\f07c7";
}

.mdi-storefront-outline::before {
  content: "\\f10c1";
}

.mdi-stove::before {
  content: "\\f04de";
}

.mdi-strategy::before {
  content: "\\f11d6";
}

.mdi-stretch-to-page::before {
  content: "\\f0f2b";
}

.mdi-stretch-to-page-outline::before {
  content: "\\f0f2c";
}

.mdi-string-lights::before {
  content: "\\f12ba";
}

.mdi-string-lights-off::before {
  content: "\\f12bb";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\f060c";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\f060d";
}

.mdi-submarine::before {
  content: "\\f156c";
}

.mdi-subtitles::before {
  content: "\\f0a16";
}

.mdi-subtitles-outline::before {
  content: "\\f0a17";
}

.mdi-subway::before {
  content: "\\f06ac";
}

.mdi-subway-alert-variant::before {
  content: "\\f0d9d";
}

.mdi-subway-variant::before {
  content: "\\f04df";
}

.mdi-summit::before {
  content: "\\f0786";
}

.mdi-sun-compass::before {
  content: "\\f19a5";
}

.mdi-sun-snowflake::before {
  content: "\\f1796";
}

.mdi-sun-thermometer::before {
  content: "\\f18d6";
}

.mdi-sun-thermometer-outline::before {
  content: "\\f18d7";
}

.mdi-sun-wireless::before {
  content: "\\f17fe";
}

.mdi-sun-wireless-outline::before {
  content: "\\f17ff";
}

.mdi-sunglasses::before {
  content: "\\f04e0";
}

.mdi-surfing::before {
  content: "\\f1746";
}

.mdi-surround-sound::before {
  content: "\\f05c5";
}

.mdi-surround-sound-2-0::before {
  content: "\\f07f0";
}

.mdi-surround-sound-2-1::before {
  content: "\\f1729";
}

.mdi-surround-sound-3-1::before {
  content: "\\f07f1";
}

.mdi-surround-sound-5-1::before {
  content: "\\f07f2";
}

.mdi-surround-sound-5-1-2::before {
  content: "\\f172a";
}

.mdi-surround-sound-7-1::before {
  content: "\\f07f3";
}

.mdi-svg::before {
  content: "\\f0721";
}

.mdi-swap-horizontal::before {
  content: "\\f04e1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\f0bcd";
}

.mdi-swap-horizontal-circle::before {
  content: "\\f0fe1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\f0fe2";
}

.mdi-swap-horizontal-variant::before {
  content: "\\f08c1";
}

.mdi-swap-vertical::before {
  content: "\\f04e2";
}

.mdi-swap-vertical-bold::before {
  content: "\\f0bce";
}

.mdi-swap-vertical-circle::before {
  content: "\\f0fe3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\f0fe4";
}

.mdi-swap-vertical-variant::before {
  content: "\\f08c2";
}

.mdi-swim::before {
  content: "\\f04e3";
}

.mdi-switch::before {
  content: "\\f04e4";
}

.mdi-sword::before {
  content: "\\f04e5";
}

.mdi-sword-cross::before {
  content: "\\f0787";
}

.mdi-syllabary-hangul::before {
  content: "\\f1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\f1334";
}

.mdi-syllabary-katakana::before {
  content: "\\f1335";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\f1336";
}

.mdi-symbol::before {
  content: "\\f1501";
}

.mdi-symfony::before {
  content: "\\f0ae6";
}

.mdi-sync::before {
  content: "\\f04e6";
}

.mdi-sync-alert::before {
  content: "\\f04e7";
}

.mdi-sync-circle::before {
  content: "\\f1378";
}

.mdi-sync-off::before {
  content: "\\f04e8";
}

.mdi-tab::before {
  content: "\\f04e9";
}

.mdi-tab-minus::before {
  content: "\\f0b4b";
}

.mdi-tab-plus::before {
  content: "\\f075c";
}

.mdi-tab-remove::before {
  content: "\\f0b4c";
}

.mdi-tab-search::before {
  content: "\\f199e";
}

.mdi-tab-unselected::before {
  content: "\\f04ea";
}

.mdi-table::before {
  content: "\\f04eb";
}

.mdi-table-account::before {
  content: "\\f13b9";
}

.mdi-table-alert::before {
  content: "\\f13ba";
}

.mdi-table-arrow-down::before {
  content: "\\f13bb";
}

.mdi-table-arrow-left::before {
  content: "\\f13bc";
}

.mdi-table-arrow-right::before {
  content: "\\f13bd";
}

.mdi-table-arrow-up::before {
  content: "\\f13be";
}

.mdi-table-border::before {
  content: "\\f0a18";
}

.mdi-table-cancel::before {
  content: "\\f13bf";
}

.mdi-table-chair::before {
  content: "\\f1061";
}

.mdi-table-check::before {
  content: "\\f13c0";
}

.mdi-table-clock::before {
  content: "\\f13c1";
}

.mdi-table-cog::before {
  content: "\\f13c2";
}

.mdi-table-column::before {
  content: "\\f0835";
}

.mdi-table-column-plus-after::before {
  content: "\\f04ec";
}

.mdi-table-column-plus-before::before {
  content: "\\f04ed";
}

.mdi-table-column-remove::before {
  content: "\\f04ee";
}

.mdi-table-column-width::before {
  content: "\\f04ef";
}

.mdi-table-edit::before {
  content: "\\f04f0";
}

.mdi-table-eye::before {
  content: "\\f1094";
}

.mdi-table-eye-off::before {
  content: "\\f13c3";
}

.mdi-table-furniture::before {
  content: "\\f05bc";
}

.mdi-table-headers-eye::before {
  content: "\\f121d";
}

.mdi-table-headers-eye-off::before {
  content: "\\f121e";
}

.mdi-table-heart::before {
  content: "\\f13c4";
}

.mdi-table-key::before {
  content: "\\f13c5";
}

.mdi-table-large::before {
  content: "\\f04f1";
}

.mdi-table-large-plus::before {
  content: "\\f0f87";
}

.mdi-table-large-remove::before {
  content: "\\f0f88";
}

.mdi-table-lock::before {
  content: "\\f13c6";
}

.mdi-table-merge-cells::before {
  content: "\\f09a6";
}

.mdi-table-minus::before {
  content: "\\f13c7";
}

.mdi-table-multiple::before {
  content: "\\f13c8";
}

.mdi-table-network::before {
  content: "\\f13c9";
}

.mdi-table-of-contents::before {
  content: "\\f0836";
}

.mdi-table-off::before {
  content: "\\f13ca";
}

.mdi-table-picnic::before {
  content: "\\f1743";
}

.mdi-table-pivot::before {
  content: "\\f183c";
}

.mdi-table-plus::before {
  content: "\\f0a75";
}

.mdi-table-refresh::before {
  content: "\\f13a0";
}

.mdi-table-remove::before {
  content: "\\f0a76";
}

.mdi-table-row::before {
  content: "\\f0837";
}

.mdi-table-row-height::before {
  content: "\\f04f2";
}

.mdi-table-row-plus-after::before {
  content: "\\f04f3";
}

.mdi-table-row-plus-before::before {
  content: "\\f04f4";
}

.mdi-table-row-remove::before {
  content: "\\f04f5";
}

.mdi-table-search::before {
  content: "\\f090f";
}

.mdi-table-settings::before {
  content: "\\f0838";
}

.mdi-table-split-cell::before {
  content: "\\f142a";
}

.mdi-table-star::before {
  content: "\\f13cb";
}

.mdi-table-sync::before {
  content: "\\f13a1";
}

.mdi-table-tennis::before {
  content: "\\f0e68";
}

.mdi-tablet::before {
  content: "\\f04f6";
}

.mdi-tablet-android::before {
  content: "\\f04f7";
}

.mdi-tablet-cellphone::before {
  content: "\\f09a7";
}

.mdi-tablet-dashboard::before {
  content: "\\f0ece";
}

.mdi-taco::before {
  content: "\\f0762";
}

.mdi-tag::before {
  content: "\\f04f9";
}

.mdi-tag-arrow-down::before {
  content: "\\f172b";
}

.mdi-tag-arrow-down-outline::before {
  content: "\\f172c";
}

.mdi-tag-arrow-left::before {
  content: "\\f172d";
}

.mdi-tag-arrow-left-outline::before {
  content: "\\f172e";
}

.mdi-tag-arrow-right::before {
  content: "\\f172f";
}

.mdi-tag-arrow-right-outline::before {
  content: "\\f1730";
}

.mdi-tag-arrow-up::before {
  content: "\\f1731";
}

.mdi-tag-arrow-up-outline::before {
  content: "\\f1732";
}

.mdi-tag-faces::before {
  content: "\\f04fa";
}

.mdi-tag-heart::before {
  content: "\\f068b";
}

.mdi-tag-heart-outline::before {
  content: "\\f0bcf";
}

.mdi-tag-minus::before {
  content: "\\f0910";
}

.mdi-tag-minus-outline::before {
  content: "\\f121f";
}

.mdi-tag-multiple::before {
  content: "\\f04fb";
}

.mdi-tag-multiple-outline::before {
  content: "\\f12f7";
}

.mdi-tag-off::before {
  content: "\\f1220";
}

.mdi-tag-off-outline::before {
  content: "\\f1221";
}

.mdi-tag-outline::before {
  content: "\\f04fc";
}

.mdi-tag-plus::before {
  content: "\\f0722";
}

.mdi-tag-plus-outline::before {
  content: "\\f1222";
}

.mdi-tag-remove::before {
  content: "\\f0723";
}

.mdi-tag-remove-outline::before {
  content: "\\f1223";
}

.mdi-tag-search::before {
  content: "\\f1907";
}

.mdi-tag-search-outline::before {
  content: "\\f1908";
}

.mdi-tag-text::before {
  content: "\\f1224";
}

.mdi-tag-text-outline::before {
  content: "\\f04fd";
}

.mdi-tailwind::before {
  content: "\\f13ff";
}

.mdi-tangram::before {
  content: "\\f04f8";
}

.mdi-tank::before {
  content: "\\f0d3a";
}

.mdi-tanker-truck::before {
  content: "\\f0fe5";
}

.mdi-tape-drive::before {
  content: "\\f16df";
}

.mdi-tape-measure::before {
  content: "\\f0b4d";
}

.mdi-target::before {
  content: "\\f04fe";
}

.mdi-target-account::before {
  content: "\\f0bd0";
}

.mdi-target-variant::before {
  content: "\\f0a77";
}

.mdi-taxi::before {
  content: "\\f04ff";
}

.mdi-tea::before {
  content: "\\f0d9e";
}

.mdi-tea-outline::before {
  content: "\\f0d9f";
}

.mdi-teamviewer::before {
  content: "\\f0500";
}

.mdi-teddy-bear::before {
  content: "\\f18fb";
}

.mdi-telescope::before {
  content: "\\f0b4e";
}

.mdi-television::before {
  content: "\\f0502";
}

.mdi-television-ambient-light::before {
  content: "\\f1356";
}

.mdi-television-box::before {
  content: "\\f0839";
}

.mdi-television-classic::before {
  content: "\\f07f4";
}

.mdi-television-classic-off::before {
  content: "\\f083a";
}

.mdi-television-guide::before {
  content: "\\f0503";
}

.mdi-television-off::before {
  content: "\\f083b";
}

.mdi-television-pause::before {
  content: "\\f0f89";
}

.mdi-television-play::before {
  content: "\\f0ecf";
}

.mdi-television-shimmer::before {
  content: "\\f1110";
}

.mdi-television-stop::before {
  content: "\\f0f8a";
}

.mdi-temperature-celsius::before {
  content: "\\f0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\f0505";
}

.mdi-temperature-kelvin::before {
  content: "\\f0506";
}

.mdi-tennis::before {
  content: "\\f0da0";
}

.mdi-tennis-ball::before {
  content: "\\f0507";
}

.mdi-tent::before {
  content: "\\f0508";
}

.mdi-terraform::before {
  content: "\\f1062";
}

.mdi-terrain::before {
  content: "\\f0509";
}

.mdi-test-tube::before {
  content: "\\f0668";
}

.mdi-test-tube-empty::before {
  content: "\\f0911";
}

.mdi-test-tube-off::before {
  content: "\\f0912";
}

.mdi-text::before {
  content: "\\f09a8";
}

.mdi-text-account::before {
  content: "\\f1570";
}

.mdi-text-box::before {
  content: "\\f021a";
}

.mdi-text-box-check::before {
  content: "\\f0ea6";
}

.mdi-text-box-check-outline::before {
  content: "\\f0ea7";
}

.mdi-text-box-minus::before {
  content: "\\f0ea8";
}

.mdi-text-box-minus-outline::before {
  content: "\\f0ea9";
}

.mdi-text-box-multiple::before {
  content: "\\f0ab7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\f0ab8";
}

.mdi-text-box-outline::before {
  content: "\\f09ed";
}

.mdi-text-box-plus::before {
  content: "\\f0eaa";
}

.mdi-text-box-plus-outline::before {
  content: "\\f0eab";
}

.mdi-text-box-remove::before {
  content: "\\f0eac";
}

.mdi-text-box-remove-outline::before {
  content: "\\f0ead";
}

.mdi-text-box-search::before {
  content: "\\f0eae";
}

.mdi-text-box-search-outline::before {
  content: "\\f0eaf";
}

.mdi-text-long::before {
  content: "\\f09aa";
}

.mdi-text-recognition::before {
  content: "\\f113d";
}

.mdi-text-search::before {
  content: "\\f13b8";
}

.mdi-text-shadow::before {
  content: "\\f0669";
}

.mdi-text-short::before {
  content: "\\f09a9";
}

.mdi-text-to-speech::before {
  content: "\\f050a";
}

.mdi-text-to-speech-off::before {
  content: "\\f050b";
}

.mdi-texture::before {
  content: "\\f050c";
}

.mdi-texture-box::before {
  content: "\\f0fe6";
}

.mdi-theater::before {
  content: "\\f050d";
}

.mdi-theme-light-dark::before {
  content: "\\f050e";
}

.mdi-thermometer::before {
  content: "\\f050f";
}

.mdi-thermometer-alert::before {
  content: "\\f0e01";
}

.mdi-thermometer-bluetooth::before {
  content: "\\f1895";
}

.mdi-thermometer-chevron-down::before {
  content: "\\f0e02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\f0e03";
}

.mdi-thermometer-high::before {
  content: "\\f10c2";
}

.mdi-thermometer-lines::before {
  content: "\\f0510";
}

.mdi-thermometer-low::before {
  content: "\\f10c3";
}

.mdi-thermometer-minus::before {
  content: "\\f0e04";
}

.mdi-thermometer-off::before {
  content: "\\f1531";
}

.mdi-thermometer-plus::before {
  content: "\\f0e05";
}

.mdi-thermostat::before {
  content: "\\f0393";
}

.mdi-thermostat-box::before {
  content: "\\f0891";
}

.mdi-thought-bubble::before {
  content: "\\f07f6";
}

.mdi-thought-bubble-outline::before {
  content: "\\f07f7";
}

.mdi-thumb-down::before {
  content: "\\f0511";
}

.mdi-thumb-down-outline::before {
  content: "\\f0512";
}

.mdi-thumb-up::before {
  content: "\\f0513";
}

.mdi-thumb-up-outline::before {
  content: "\\f0514";
}

.mdi-thumbs-up-down::before {
  content: "\\f0515";
}

.mdi-thumbs-up-down-outline::before {
  content: "\\f1914";
}

.mdi-ticket::before {
  content: "\\f0516";
}

.mdi-ticket-account::before {
  content: "\\f0517";
}

.mdi-ticket-confirmation::before {
  content: "\\f0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\f13aa";
}

.mdi-ticket-outline::before {
  content: "\\f0913";
}

.mdi-ticket-percent::before {
  content: "\\f0724";
}

.mdi-ticket-percent-outline::before {
  content: "\\f142b";
}

.mdi-tie::before {
  content: "\\f0519";
}

.mdi-tilde::before {
  content: "\\f0725";
}

.mdi-tilde-off::before {
  content: "\\f18f3";
}

.mdi-timelapse::before {
  content: "\\f051a";
}

.mdi-timeline::before {
  content: "\\f0bd1";
}

.mdi-timeline-alert::before {
  content: "\\f0f95";
}

.mdi-timeline-alert-outline::before {
  content: "\\f0f98";
}

.mdi-timeline-check::before {
  content: "\\f1532";
}

.mdi-timeline-check-outline::before {
  content: "\\f1533";
}

.mdi-timeline-clock::before {
  content: "\\f11fb";
}

.mdi-timeline-clock-outline::before {
  content: "\\f11fc";
}

.mdi-timeline-help::before {
  content: "\\f0f99";
}

.mdi-timeline-help-outline::before {
  content: "\\f0f9a";
}

.mdi-timeline-minus::before {
  content: "\\f1534";
}

.mdi-timeline-minus-outline::before {
  content: "\\f1535";
}

.mdi-timeline-outline::before {
  content: "\\f0bd2";
}

.mdi-timeline-plus::before {
  content: "\\f0f96";
}

.mdi-timeline-plus-outline::before {
  content: "\\f0f97";
}

.mdi-timeline-remove::before {
  content: "\\f1536";
}

.mdi-timeline-remove-outline::before {
  content: "\\f1537";
}

.mdi-timeline-text::before {
  content: "\\f0bd3";
}

.mdi-timeline-text-outline::before {
  content: "\\f0bd4";
}

.mdi-timer::before {
  content: "\\f13ab";
}

.mdi-timer-10::before {
  content: "\\f051c";
}

.mdi-timer-3::before {
  content: "\\f051d";
}

.mdi-timer-cog::before {
  content: "\\f1925";
}

.mdi-timer-cog-outline::before {
  content: "\\f1926";
}

.mdi-timer-off::before {
  content: "\\f13ac";
}

.mdi-timer-off-outline::before {
  content: "\\f051e";
}

.mdi-timer-outline::before {
  content: "\\f051b";
}

.mdi-timer-sand::before {
  content: "\\f051f";
}

.mdi-timer-sand-complete::before {
  content: "\\f199f";
}

.mdi-timer-sand-empty::before {
  content: "\\f06ad";
}

.mdi-timer-sand-full::before {
  content: "\\f078c";
}

.mdi-timer-sand-paused::before {
  content: "\\f19a0";
}

.mdi-timer-settings::before {
  content: "\\f1923";
}

.mdi-timer-settings-outline::before {
  content: "\\f1924";
}

.mdi-timetable::before {
  content: "\\f0520";
}

.mdi-tire::before {
  content: "\\f1896";
}

.mdi-toaster::before {
  content: "\\f1063";
}

.mdi-toaster-off::before {
  content: "\\f11b7";
}

.mdi-toaster-oven::before {
  content: "\\f0cd3";
}

.mdi-toggle-switch::before {
  content: "\\f0521";
}

.mdi-toggle-switch-off::before {
  content: "\\f0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\f0a19";
}

.mdi-toggle-switch-outline::before {
  content: "\\f0a1a";
}

.mdi-toilet::before {
  content: "\\f09ab";
}

.mdi-toolbox::before {
  content: "\\f09ac";
}

.mdi-toolbox-outline::before {
  content: "\\f09ad";
}

.mdi-tools::before {
  content: "\\f1064";
}

.mdi-tooltip::before {
  content: "\\f0523";
}

.mdi-tooltip-account::before {
  content: "\\f000c";
}

.mdi-tooltip-cellphone::before {
  content: "\\f183b";
}

.mdi-tooltip-check::before {
  content: "\\f155c";
}

.mdi-tooltip-check-outline::before {
  content: "\\f155d";
}

.mdi-tooltip-edit::before {
  content: "\\f0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\f12c5";
}

.mdi-tooltip-image::before {
  content: "\\f0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\f0bd5";
}

.mdi-tooltip-minus::before {
  content: "\\f155e";
}

.mdi-tooltip-minus-outline::before {
  content: "\\f155f";
}

.mdi-tooltip-outline::before {
  content: "\\f0526";
}

.mdi-tooltip-plus::before {
  content: "\\f0bd6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\f0527";
}

.mdi-tooltip-remove::before {
  content: "\\f1560";
}

.mdi-tooltip-remove-outline::before {
  content: "\\f1561";
}

.mdi-tooltip-text::before {
  content: "\\f0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\f0bd7";
}

.mdi-tooth::before {
  content: "\\f08c3";
}

.mdi-tooth-outline::before {
  content: "\\f0529";
}

.mdi-toothbrush::before {
  content: "\\f1129";
}

.mdi-toothbrush-electric::before {
  content: "\\f112c";
}

.mdi-toothbrush-paste::before {
  content: "\\f112a";
}

.mdi-torch::before {
  content: "\\f1606";
}

.mdi-tortoise::before {
  content: "\\f0d3b";
}

.mdi-toslink::before {
  content: "\\f12b8";
}

.mdi-tournament::before {
  content: "\\f09ae";
}

.mdi-tow-truck::before {
  content: "\\f083c";
}

.mdi-tower-beach::before {
  content: "\\f0681";
}

.mdi-tower-fire::before {
  content: "\\f0682";
}

.mdi-town-hall::before {
  content: "\\f1875";
}

.mdi-toy-brick::before {
  content: "\\f1288";
}

.mdi-toy-brick-marker::before {
  content: "\\f1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\f128a";
}

.mdi-toy-brick-minus::before {
  content: "\\f128b";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\f128c";
}

.mdi-toy-brick-outline::before {
  content: "\\f128d";
}

.mdi-toy-brick-plus::before {
  content: "\\f128e";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\f128f";
}

.mdi-toy-brick-remove::before {
  content: "\\f1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\f1291";
}

.mdi-toy-brick-search::before {
  content: "\\f1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\f1293";
}

.mdi-track-light::before {
  content: "\\f0914";
}

.mdi-trackpad::before {
  content: "\\f07f8";
}

.mdi-trackpad-lock::before {
  content: "\\f0933";
}

.mdi-tractor::before {
  content: "\\f0892";
}

.mdi-tractor-variant::before {
  content: "\\f14c4";
}

.mdi-trademark::before {
  content: "\\f0a78";
}

.mdi-traffic-cone::before {
  content: "\\f137c";
}

.mdi-traffic-light::before {
  content: "\\f052b";
}

.mdi-traffic-light-outline::before {
  content: "\\f182a";
}

.mdi-train::before {
  content: "\\f052c";
}

.mdi-train-car::before {
  content: "\\f0bd8";
}

.mdi-train-car-passenger::before {
  content: "\\f1733";
}

.mdi-train-car-passenger-door::before {
  content: "\\f1734";
}

.mdi-train-car-passenger-door-open::before {
  content: "\\f1735";
}

.mdi-train-car-passenger-variant::before {
  content: "\\f1736";
}

.mdi-train-variant::before {
  content: "\\f08c4";
}

.mdi-tram::before {
  content: "\\f052d";
}

.mdi-tram-side::before {
  content: "\\f0fe7";
}

.mdi-transcribe::before {
  content: "\\f052e";
}

.mdi-transcribe-close::before {
  content: "\\f052f";
}

.mdi-transfer::before {
  content: "\\f1065";
}

.mdi-transfer-down::before {
  content: "\\f0da1";
}

.mdi-transfer-left::before {
  content: "\\f0da2";
}

.mdi-transfer-right::before {
  content: "\\f0530";
}

.mdi-transfer-up::before {
  content: "\\f0da3";
}

.mdi-transit-connection::before {
  content: "\\f0d3c";
}

.mdi-transit-connection-horizontal::before {
  content: "\\f1546";
}

.mdi-transit-connection-variant::before {
  content: "\\f0d3d";
}

.mdi-transit-detour::before {
  content: "\\f0f8b";
}

.mdi-transit-skip::before {
  content: "\\f1515";
}

.mdi-transit-transfer::before {
  content: "\\f06ae";
}

.mdi-transition::before {
  content: "\\f0915";
}

.mdi-transition-masked::before {
  content: "\\f0916";
}

.mdi-translate::before {
  content: "\\f05ca";
}

.mdi-translate-off::before {
  content: "\\f0e06";
}

.mdi-transmission-tower::before {
  content: "\\f0d3e";
}

.mdi-transmission-tower-export::before {
  content: "\\f192c";
}

.mdi-transmission-tower-import::before {
  content: "\\f192d";
}

.mdi-trash-can::before {
  content: "\\f0a79";
}

.mdi-trash-can-outline::before {
  content: "\\f0a7a";
}

.mdi-tray::before {
  content: "\\f1294";
}

.mdi-tray-alert::before {
  content: "\\f1295";
}

.mdi-tray-arrow-down::before {
  content: "\\f0120";
}

.mdi-tray-arrow-up::before {
  content: "\\f011d";
}

.mdi-tray-full::before {
  content: "\\f1296";
}

.mdi-tray-minus::before {
  content: "\\f1297";
}

.mdi-tray-plus::before {
  content: "\\f1298";
}

.mdi-tray-remove::before {
  content: "\\f1299";
}

.mdi-treasure-chest::before {
  content: "\\f0726";
}

.mdi-tree::before {
  content: "\\f0531";
}

.mdi-tree-outline::before {
  content: "\\f0e69";
}

.mdi-trello::before {
  content: "\\f0532";
}

.mdi-trending-down::before {
  content: "\\f0533";
}

.mdi-trending-neutral::before {
  content: "\\f0534";
}

.mdi-trending-up::before {
  content: "\\f0535";
}

.mdi-triangle::before {
  content: "\\f0536";
}

.mdi-triangle-outline::before {
  content: "\\f0537";
}

.mdi-triangle-wave::before {
  content: "\\f147c";
}

.mdi-triforce::before {
  content: "\\f0bd9";
}

.mdi-trophy::before {
  content: "\\f0538";
}

.mdi-trophy-award::before {
  content: "\\f0539";
}

.mdi-trophy-broken::before {
  content: "\\f0da4";
}

.mdi-trophy-outline::before {
  content: "\\f053a";
}

.mdi-trophy-variant::before {
  content: "\\f053b";
}

.mdi-trophy-variant-outline::before {
  content: "\\f053c";
}

.mdi-truck::before {
  content: "\\f053d";
}

.mdi-truck-cargo-container::before {
  content: "\\f18d8";
}

.mdi-truck-check::before {
  content: "\\f0cd4";
}

.mdi-truck-check-outline::before {
  content: "\\f129a";
}

.mdi-truck-delivery::before {
  content: "\\f053e";
}

.mdi-truck-delivery-outline::before {
  content: "\\f129b";
}

.mdi-truck-fast::before {
  content: "\\f0788";
}

.mdi-truck-fast-outline::before {
  content: "\\f129c";
}

.mdi-truck-flatbed::before {
  content: "\\f1891";
}

.mdi-truck-minus::before {
  content: "\\f19ae";
}

.mdi-truck-minus-outline::before {
  content: "\\f19bd";
}

.mdi-truck-outline::before {
  content: "\\f129d";
}

.mdi-truck-plus::before {
  content: "\\f19ad";
}

.mdi-truck-plus-outline::before {
  content: "\\f19bc";
}

.mdi-truck-remove::before {
  content: "\\f19af";
}

.mdi-truck-remove-outline::before {
  content: "\\f19be";
}

.mdi-truck-snowflake::before {
  content: "\\f19a6";
}

.mdi-truck-trailer::before {
  content: "\\f0727";
}

.mdi-trumpet::before {
  content: "\\f1096";
}

.mdi-tshirt-crew::before {
  content: "\\f0a7b";
}

.mdi-tshirt-crew-outline::before {
  content: "\\f053f";
}

.mdi-tshirt-v::before {
  content: "\\f0a7c";
}

.mdi-tshirt-v-outline::before {
  content: "\\f0540";
}

.mdi-tumble-dryer::before {
  content: "\\f0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\f11ba";
}

.mdi-tumble-dryer-off::before {
  content: "\\f11bb";
}

.mdi-tune::before {
  content: "\\f062e";
}

.mdi-tune-variant::before {
  content: "\\f1542";
}

.mdi-tune-vertical::before {
  content: "\\f066a";
}

.mdi-tune-vertical-variant::before {
  content: "\\f1543";
}

.mdi-tunnel::before {
  content: "\\f183d";
}

.mdi-tunnel-outline::before {
  content: "\\f183e";
}

.mdi-turkey::before {
  content: "\\f171b";
}

.mdi-turnstile::before {
  content: "\\f0cd5";
}

.mdi-turnstile-outline::before {
  content: "\\f0cd6";
}

.mdi-turtle::before {
  content: "\\f0cd7";
}

.mdi-twitch::before {
  content: "\\f0543";
}

.mdi-twitter::before {
  content: "\\f0544";
}

.mdi-two-factor-authentication::before {
  content: "\\f09af";
}

.mdi-typewriter::before {
  content: "\\f0f2d";
}

.mdi-ubisoft::before {
  content: "\\f0bda";
}

.mdi-ubuntu::before {
  content: "\\f0548";
}

.mdi-ufo::before {
  content: "\\f10c4";
}

.mdi-ufo-outline::before {
  content: "\\f10c5";
}

.mdi-ultra-high-definition::before {
  content: "\\f07f9";
}

.mdi-umbraco::before {
  content: "\\f0549";
}

.mdi-umbrella::before {
  content: "\\f054a";
}

.mdi-umbrella-beach::before {
  content: "\\f188a";
}

.mdi-umbrella-beach-outline::before {
  content: "\\f188b";
}

.mdi-umbrella-closed::before {
  content: "\\f09b0";
}

.mdi-umbrella-closed-outline::before {
  content: "\\f13e2";
}

.mdi-umbrella-closed-variant::before {
  content: "\\f13e1";
}

.mdi-umbrella-outline::before {
  content: "\\f054b";
}

.mdi-undo::before {
  content: "\\f054c";
}

.mdi-undo-variant::before {
  content: "\\f054d";
}

.mdi-unfold-less-horizontal::before {
  content: "\\f054e";
}

.mdi-unfold-less-vertical::before {
  content: "\\f0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\f054f";
}

.mdi-unfold-more-vertical::before {
  content: "\\f0761";
}

.mdi-ungroup::before {
  content: "\\f0550";
}

.mdi-unicode::before {
  content: "\\f0ed0";
}

.mdi-unicorn::before {
  content: "\\f15c2";
}

.mdi-unicorn-variant::before {
  content: "\\f15c3";
}

.mdi-unicycle::before {
  content: "\\f15e5";
}

.mdi-unity::before {
  content: "\\f06af";
}

.mdi-unreal::before {
  content: "\\f09b1";
}

.mdi-update::before {
  content: "\\f06b0";
}

.mdi-upload::before {
  content: "\\f0552";
}

.mdi-upload-lock::before {
  content: "\\f1373";
}

.mdi-upload-lock-outline::before {
  content: "\\f1374";
}

.mdi-upload-multiple::before {
  content: "\\f083d";
}

.mdi-upload-network::before {
  content: "\\f06f6";
}

.mdi-upload-network-outline::before {
  content: "\\f0cd8";
}

.mdi-upload-off::before {
  content: "\\f10c6";
}

.mdi-upload-off-outline::before {
  content: "\\f10c7";
}

.mdi-upload-outline::before {
  content: "\\f0e07";
}

.mdi-usb::before {
  content: "\\f0553";
}

.mdi-usb-flash-drive::before {
  content: "\\f129e";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\f129f";
}

.mdi-usb-port::before {
  content: "\\f11f0";
}

.mdi-vacuum::before {
  content: "\\f19a1";
}

.mdi-vacuum-outline::before {
  content: "\\f19a2";
}

.mdi-valve::before {
  content: "\\f1066";
}

.mdi-valve-closed::before {
  content: "\\f1067";
}

.mdi-valve-open::before {
  content: "\\f1068";
}

.mdi-van-passenger::before {
  content: "\\f07fa";
}

.mdi-van-utility::before {
  content: "\\f07fb";
}

.mdi-vanish::before {
  content: "\\f07fc";
}

.mdi-vanish-quarter::before {
  content: "\\f1554";
}

.mdi-vanity-light::before {
  content: "\\f11e1";
}

.mdi-variable::before {
  content: "\\f0ae7";
}

.mdi-variable-box::before {
  content: "\\f1111";
}

.mdi-vector-arrange-above::before {
  content: "\\f0554";
}

.mdi-vector-arrange-below::before {
  content: "\\f0555";
}

.mdi-vector-bezier::before {
  content: "\\f0ae8";
}

.mdi-vector-circle::before {
  content: "\\f0556";
}

.mdi-vector-circle-variant::before {
  content: "\\f0557";
}

.mdi-vector-combine::before {
  content: "\\f0558";
}

.mdi-vector-curve::before {
  content: "\\f0559";
}

.mdi-vector-difference::before {
  content: "\\f055a";
}

.mdi-vector-difference-ab::before {
  content: "\\f055b";
}

.mdi-vector-difference-ba::before {
  content: "\\f055c";
}

.mdi-vector-ellipse::before {
  content: "\\f0893";
}

.mdi-vector-intersection::before {
  content: "\\f055d";
}

.mdi-vector-line::before {
  content: "\\f055e";
}

.mdi-vector-link::before {
  content: "\\f0fe8";
}

.mdi-vector-point::before {
  content: "\\f055f";
}

.mdi-vector-polygon::before {
  content: "\\f0560";
}

.mdi-vector-polygon-variant::before {
  content: "\\f1856";
}

.mdi-vector-polyline::before {
  content: "\\f0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\f1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\f1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\f1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\f1228";
}

.mdi-vector-radius::before {
  content: "\\f074a";
}

.mdi-vector-rectangle::before {
  content: "\\f05c6";
}

.mdi-vector-selection::before {
  content: "\\f0562";
}

.mdi-vector-square::before {
  content: "\\f0001";
}

.mdi-vector-square-close::before {
  content: "\\f1857";
}

.mdi-vector-square-edit::before {
  content: "\\f18d9";
}

.mdi-vector-square-minus::before {
  content: "\\f18da";
}

.mdi-vector-square-open::before {
  content: "\\f1858";
}

.mdi-vector-square-plus::before {
  content: "\\f18db";
}

.mdi-vector-square-remove::before {
  content: "\\f18dc";
}

.mdi-vector-triangle::before {
  content: "\\f0563";
}

.mdi-vector-union::before {
  content: "\\f0564";
}

.mdi-vhs::before {
  content: "\\f0a1b";
}

.mdi-vibrate::before {
  content: "\\f0566";
}

.mdi-vibrate-off::before {
  content: "\\f0cd9";
}

.mdi-video::before {
  content: "\\f0567";
}

.mdi-video-3d::before {
  content: "\\f07fd";
}

.mdi-video-3d-off::before {
  content: "\\f13d9";
}

.mdi-video-3d-variant::before {
  content: "\\f0ed1";
}

.mdi-video-4k-box::before {
  content: "\\f083e";
}

.mdi-video-account::before {
  content: "\\f0919";
}

.mdi-video-box::before {
  content: "\\f00fd";
}

.mdi-video-box-off::before {
  content: "\\f00fe";
}

.mdi-video-check::before {
  content: "\\f1069";
}

.mdi-video-check-outline::before {
  content: "\\f106a";
}

.mdi-video-high-definition::before {
  content: "\\f152e";
}

.mdi-video-image::before {
  content: "\\f091a";
}

.mdi-video-input-antenna::before {
  content: "\\f083f";
}

.mdi-video-input-component::before {
  content: "\\f0840";
}

.mdi-video-input-hdmi::before {
  content: "\\f0841";
}

.mdi-video-input-scart::before {
  content: "\\f0f8c";
}

.mdi-video-input-svideo::before {
  content: "\\f0842";
}

.mdi-video-marker::before {
  content: "\\f19a9";
}

.mdi-video-marker-outline::before {
  content: "\\f19aa";
}

.mdi-video-minus::before {
  content: "\\f09b2";
}

.mdi-video-minus-outline::before {
  content: "\\f02ba";
}

.mdi-video-off::before {
  content: "\\f0568";
}

.mdi-video-off-outline::before {
  content: "\\f0bdb";
}

.mdi-video-outline::before {
  content: "\\f0bdc";
}

.mdi-video-plus::before {
  content: "\\f09b3";
}

.mdi-video-plus-outline::before {
  content: "\\f01d3";
}

.mdi-video-stabilization::before {
  content: "\\f091b";
}

.mdi-video-switch::before {
  content: "\\f0569";
}

.mdi-video-switch-outline::before {
  content: "\\f0790";
}

.mdi-video-vintage::before {
  content: "\\f0a1c";
}

.mdi-video-wireless::before {
  content: "\\f0ed2";
}

.mdi-video-wireless-outline::before {
  content: "\\f0ed3";
}

.mdi-view-agenda::before {
  content: "\\f056a";
}

.mdi-view-agenda-outline::before {
  content: "\\f11d8";
}

.mdi-view-array::before {
  content: "\\f056b";
}

.mdi-view-array-outline::before {
  content: "\\f1485";
}

.mdi-view-carousel::before {
  content: "\\f056c";
}

.mdi-view-carousel-outline::before {
  content: "\\f1486";
}

.mdi-view-column::before {
  content: "\\f056d";
}

.mdi-view-column-outline::before {
  content: "\\f1487";
}

.mdi-view-comfy::before {
  content: "\\f0e6a";
}

.mdi-view-comfy-outline::before {
  content: "\\f1488";
}

.mdi-view-compact::before {
  content: "\\f0e6b";
}

.mdi-view-compact-outline::before {
  content: "\\f0e6c";
}

.mdi-view-dashboard::before {
  content: "\\f056e";
}

.mdi-view-dashboard-edit::before {
  content: "\\f1947";
}

.mdi-view-dashboard-edit-outline::before {
  content: "\\f1948";
}

.mdi-view-dashboard-outline::before {
  content: "\\f0a1d";
}

.mdi-view-dashboard-variant::before {
  content: "\\f0843";
}

.mdi-view-dashboard-variant-outline::before {
  content: "\\f1489";
}

.mdi-view-day::before {
  content: "\\f056f";
}

.mdi-view-day-outline::before {
  content: "\\f148a";
}

.mdi-view-gallery::before {
  content: "\\f1888";
}

.mdi-view-gallery-outline::before {
  content: "\\f1889";
}

.mdi-view-grid::before {
  content: "\\f0570";
}

.mdi-view-grid-outline::before {
  content: "\\f11d9";
}

.mdi-view-grid-plus::before {
  content: "\\f0f8d";
}

.mdi-view-grid-plus-outline::before {
  content: "\\f11da";
}

.mdi-view-headline::before {
  content: "\\f0571";
}

.mdi-view-list::before {
  content: "\\f0572";
}

.mdi-view-list-outline::before {
  content: "\\f148b";
}

.mdi-view-module::before {
  content: "\\f0573";
}

.mdi-view-module-outline::before {
  content: "\\f148c";
}

.mdi-view-parallel::before {
  content: "\\f0728";
}

.mdi-view-parallel-outline::before {
  content: "\\f148d";
}

.mdi-view-quilt::before {
  content: "\\f0574";
}

.mdi-view-quilt-outline::before {
  content: "\\f148e";
}

.mdi-view-sequential::before {
  content: "\\f0729";
}

.mdi-view-sequential-outline::before {
  content: "\\f148f";
}

.mdi-view-split-horizontal::before {
  content: "\\f0bcb";
}

.mdi-view-split-vertical::before {
  content: "\\f0bcc";
}

.mdi-view-stream::before {
  content: "\\f0575";
}

.mdi-view-stream-outline::before {
  content: "\\f1490";
}

.mdi-view-week::before {
  content: "\\f0576";
}

.mdi-view-week-outline::before {
  content: "\\f1491";
}

.mdi-vimeo::before {
  content: "\\f0577";
}

.mdi-violin::before {
  content: "\\f060f";
}

.mdi-virtual-reality::before {
  content: "\\f0894";
}

.mdi-virus::before {
  content: "\\f13b6";
}

.mdi-virus-off::before {
  content: "\\f18e1";
}

.mdi-virus-off-outline::before {
  content: "\\f18e2";
}

.mdi-virus-outline::before {
  content: "\\f13b7";
}

.mdi-vlc::before {
  content: "\\f057c";
}

.mdi-voicemail::before {
  content: "\\f057d";
}

.mdi-volleyball::before {
  content: "\\f09b4";
}

.mdi-volume-high::before {
  content: "\\f057e";
}

.mdi-volume-low::before {
  content: "\\f057f";
}

.mdi-volume-medium::before {
  content: "\\f0580";
}

.mdi-volume-minus::before {
  content: "\\f075e";
}

.mdi-volume-mute::before {
  content: "\\f075f";
}

.mdi-volume-off::before {
  content: "\\f0581";
}

.mdi-volume-plus::before {
  content: "\\f075d";
}

.mdi-volume-source::before {
  content: "\\f1120";
}

.mdi-volume-variant-off::before {
  content: "\\f0e08";
}

.mdi-volume-vibrate::before {
  content: "\\f1121";
}

.mdi-vote::before {
  content: "\\f0a1f";
}

.mdi-vote-outline::before {
  content: "\\f0a20";
}

.mdi-vpn::before {
  content: "\\f0582";
}

.mdi-vuejs::before {
  content: "\\f0844";
}

.mdi-vuetify::before {
  content: "\\f0e6d";
}

.mdi-walk::before {
  content: "\\f0583";
}

.mdi-wall::before {
  content: "\\f07fe";
}

.mdi-wall-sconce::before {
  content: "\\f091c";
}

.mdi-wall-sconce-flat::before {
  content: "\\f091d";
}

.mdi-wall-sconce-flat-outline::before {
  content: "\\f17c9";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\f041c";
}

.mdi-wall-sconce-flat-variant-outline::before {
  content: "\\f17ca";
}

.mdi-wall-sconce-outline::before {
  content: "\\f17cb";
}

.mdi-wall-sconce-round::before {
  content: "\\f0748";
}

.mdi-wall-sconce-round-outline::before {
  content: "\\f17cc";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\f091e";
}

.mdi-wall-sconce-round-variant-outline::before {
  content: "\\f17cd";
}

.mdi-wallet::before {
  content: "\\f0584";
}

.mdi-wallet-giftcard::before {
  content: "\\f0585";
}

.mdi-wallet-membership::before {
  content: "\\f0586";
}

.mdi-wallet-outline::before {
  content: "\\f0bdd";
}

.mdi-wallet-plus::before {
  content: "\\f0f8e";
}

.mdi-wallet-plus-outline::before {
  content: "\\f0f8f";
}

.mdi-wallet-travel::before {
  content: "\\f0587";
}

.mdi-wallpaper::before {
  content: "\\f0e09";
}

.mdi-wan::before {
  content: "\\f0588";
}

.mdi-wardrobe::before {
  content: "\\f0f90";
}

.mdi-wardrobe-outline::before {
  content: "\\f0f91";
}

.mdi-warehouse::before {
  content: "\\f0f81";
}

.mdi-washing-machine::before {
  content: "\\f072a";
}

.mdi-washing-machine-alert::before {
  content: "\\f11bc";
}

.mdi-washing-machine-off::before {
  content: "\\f11bd";
}

.mdi-watch::before {
  content: "\\f0589";
}

.mdi-watch-export::before {
  content: "\\f058a";
}

.mdi-watch-export-variant::before {
  content: "\\f0895";
}

.mdi-watch-import::before {
  content: "\\f058b";
}

.mdi-watch-import-variant::before {
  content: "\\f0896";
}

.mdi-watch-variant::before {
  content: "\\f0897";
}

.mdi-watch-vibrate::before {
  content: "\\f06b1";
}

.mdi-watch-vibrate-off::before {
  content: "\\f0cda";
}

.mdi-water::before {
  content: "\\f058c";
}

.mdi-water-alert::before {
  content: "\\f1502";
}

.mdi-water-alert-outline::before {
  content: "\\f1503";
}

.mdi-water-boiler::before {
  content: "\\f0f92";
}

.mdi-water-boiler-alert::before {
  content: "\\f11b3";
}

.mdi-water-boiler-off::before {
  content: "\\f11b4";
}

.mdi-water-check::before {
  content: "\\f1504";
}

.mdi-water-check-outline::before {
  content: "\\f1505";
}

.mdi-water-circle::before {
  content: "\\f1806";
}

.mdi-water-minus::before {
  content: "\\f1506";
}

.mdi-water-minus-outline::before {
  content: "\\f1507";
}

.mdi-water-off::before {
  content: "\\f058d";
}

.mdi-water-off-outline::before {
  content: "\\f1508";
}

.mdi-water-opacity::before {
  content: "\\f1855";
}

.mdi-water-outline::before {
  content: "\\f0e0a";
}

.mdi-water-percent::before {
  content: "\\f058e";
}

.mdi-water-percent-alert::before {
  content: "\\f1509";
}

.mdi-water-plus::before {
  content: "\\f150a";
}

.mdi-water-plus-outline::before {
  content: "\\f150b";
}

.mdi-water-polo::before {
  content: "\\f12a0";
}

.mdi-water-pump::before {
  content: "\\f058f";
}

.mdi-water-pump-off::before {
  content: "\\f0f93";
}

.mdi-water-remove::before {
  content: "\\f150c";
}

.mdi-water-remove-outline::before {
  content: "\\f150d";
}

.mdi-water-sync::before {
  content: "\\f17c6";
}

.mdi-water-well::before {
  content: "\\f106b";
}

.mdi-water-well-outline::before {
  content: "\\f106c";
}

.mdi-waterfall::before {
  content: "\\f1849";
}

.mdi-watering-can::before {
  content: "\\f1481";
}

.mdi-watering-can-outline::before {
  content: "\\f1482";
}

.mdi-watermark::before {
  content: "\\f0612";
}

.mdi-wave::before {
  content: "\\f0f2e";
}

.mdi-waveform::before {
  content: "\\f147d";
}

.mdi-waves::before {
  content: "\\f078d";
}

.mdi-waves-arrow-left::before {
  content: "\\f1859";
}

.mdi-waves-arrow-right::before {
  content: "\\f185a";
}

.mdi-waves-arrow-up::before {
  content: "\\f185b";
}

.mdi-waze::before {
  content: "\\f0bde";
}

.mdi-weather-cloudy::before {
  content: "\\f0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\f0f2f";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\f0e6e";
}

.mdi-weather-cloudy-clock::before {
  content: "\\f18f6";
}

.mdi-weather-fog::before {
  content: "\\f0591";
}

.mdi-weather-hail::before {
  content: "\\f0592";
}

.mdi-weather-hazy::before {
  content: "\\f0f30";
}

.mdi-weather-hurricane::before {
  content: "\\f0898";
}

.mdi-weather-lightning::before {
  content: "\\f0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\f067e";
}

.mdi-weather-night::before {
  content: "\\f0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\f0f31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\f0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\f0f32";
}

.mdi-weather-partly-rainy::before {
  content: "\\f0f33";
}

.mdi-weather-partly-snowy::before {
  content: "\\f0f34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\f0f35";
}

.mdi-weather-pouring::before {
  content: "\\f0596";
}

.mdi-weather-rainy::before {
  content: "\\f0597";
}

.mdi-weather-snowy::before {
  content: "\\f0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\f0f36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\f067f";
}

.mdi-weather-sunny::before {
  content: "\\f0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\f0f37";
}

.mdi-weather-sunny-off::before {
  content: "\\f14e4";
}

.mdi-weather-sunset::before {
  content: "\\f059a";
}

.mdi-weather-sunset-down::before {
  content: "\\f059b";
}

.mdi-weather-sunset-up::before {
  content: "\\f059c";
}

.mdi-weather-tornado::before {
  content: "\\f0f38";
}

.mdi-weather-windy::before {
  content: "\\f059d";
}

.mdi-weather-windy-variant::before {
  content: "\\f059e";
}

.mdi-web::before {
  content: "\\f059f";
}

.mdi-web-box::before {
  content: "\\f0f94";
}

.mdi-web-cancel::before {
  content: "\\f1790";
}

.mdi-web-check::before {
  content: "\\f0789";
}

.mdi-web-clock::before {
  content: "\\f124a";
}

.mdi-web-minus::before {
  content: "\\f10a0";
}

.mdi-web-off::before {
  content: "\\f0a8e";
}

.mdi-web-plus::before {
  content: "\\f0033";
}

.mdi-web-refresh::before {
  content: "\\f1791";
}

.mdi-web-remove::before {
  content: "\\f0551";
}

.mdi-web-sync::before {
  content: "\\f1792";
}

.mdi-webcam::before {
  content: "\\f05a0";
}

.mdi-webcam-off::before {
  content: "\\f1737";
}

.mdi-webhook::before {
  content: "\\f062f";
}

.mdi-webpack::before {
  content: "\\f072b";
}

.mdi-webrtc::before {
  content: "\\f1248";
}

.mdi-wechat::before {
  content: "\\f0611";
}

.mdi-weight::before {
  content: "\\f05a1";
}

.mdi-weight-gram::before {
  content: "\\f0d3f";
}

.mdi-weight-kilogram::before {
  content: "\\f05a2";
}

.mdi-weight-lifter::before {
  content: "\\f115d";
}

.mdi-weight-pound::before {
  content: "\\f09b5";
}

.mdi-whatsapp::before {
  content: "\\f05a3";
}

.mdi-wheel-barrow::before {
  content: "\\f14f2";
}

.mdi-wheelchair-accessibility::before {
  content: "\\f05a4";
}

.mdi-whistle::before {
  content: "\\f09b6";
}

.mdi-whistle-outline::before {
  content: "\\f12bc";
}

.mdi-white-balance-auto::before {
  content: "\\f05a5";
}

.mdi-white-balance-incandescent::before {
  content: "\\f05a6";
}

.mdi-white-balance-iridescent::before {
  content: "\\f05a7";
}

.mdi-white-balance-sunny::before {
  content: "\\f05a8";
}

.mdi-widgets::before {
  content: "\\f072c";
}

.mdi-widgets-outline::before {
  content: "\\f1355";
}

.mdi-wifi::before {
  content: "\\f05a9";
}

.mdi-wifi-alert::before {
  content: "\\f16b5";
}

.mdi-wifi-arrow-down::before {
  content: "\\f16b6";
}

.mdi-wifi-arrow-left::before {
  content: "\\f16b7";
}

.mdi-wifi-arrow-left-right::before {
  content: "\\f16b8";
}

.mdi-wifi-arrow-right::before {
  content: "\\f16b9";
}

.mdi-wifi-arrow-up::before {
  content: "\\f16ba";
}

.mdi-wifi-arrow-up-down::before {
  content: "\\f16bb";
}

.mdi-wifi-cancel::before {
  content: "\\f16bc";
}

.mdi-wifi-check::before {
  content: "\\f16bd";
}

.mdi-wifi-cog::before {
  content: "\\f16be";
}

.mdi-wifi-lock::before {
  content: "\\f16bf";
}

.mdi-wifi-lock-open::before {
  content: "\\f16c0";
}

.mdi-wifi-marker::before {
  content: "\\f16c1";
}

.mdi-wifi-minus::before {
  content: "\\f16c2";
}

.mdi-wifi-off::before {
  content: "\\f05aa";
}

.mdi-wifi-plus::before {
  content: "\\f16c3";
}

.mdi-wifi-refresh::before {
  content: "\\f16c4";
}

.mdi-wifi-remove::before {
  content: "\\f16c5";
}

.mdi-wifi-settings::before {
  content: "\\f16c6";
}

.mdi-wifi-star::before {
  content: "\\f0e0b";
}

.mdi-wifi-strength-1::before {
  content: "\\f091f";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\f0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\f0921";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "\\f16cb";
}

.mdi-wifi-strength-2::before {
  content: "\\f0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\f0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\f0924";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "\\f16cc";
}

.mdi-wifi-strength-3::before {
  content: "\\f0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\f0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\f0927";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "\\f16cd";
}

.mdi-wifi-strength-4::before {
  content: "\\f0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\f0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\f092a";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "\\f16ce";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\f092b";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\f16cf";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\f092c";
}

.mdi-wifi-strength-off::before {
  content: "\\f092d";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\f092e";
}

.mdi-wifi-strength-outline::before {
  content: "\\f092f";
}

.mdi-wifi-sync::before {
  content: "\\f16c7";
}

.mdi-wikipedia::before {
  content: "\\f05ac";
}

.mdi-wind-turbine::before {
  content: "\\f0da5";
}

.mdi-wind-turbine-alert::before {
  content: "\\f19ab";
}

.mdi-wind-turbine-check::before {
  content: "\\f19ac";
}

.mdi-window-close::before {
  content: "\\f05ad";
}

.mdi-window-closed::before {
  content: "\\f05ae";
}

.mdi-window-closed-variant::before {
  content: "\\f11db";
}

.mdi-window-maximize::before {
  content: "\\f05af";
}

.mdi-window-minimize::before {
  content: "\\f05b0";
}

.mdi-window-open::before {
  content: "\\f05b1";
}

.mdi-window-open-variant::before {
  content: "\\f11dc";
}

.mdi-window-restore::before {
  content: "\\f05b2";
}

.mdi-window-shutter::before {
  content: "\\f111c";
}

.mdi-window-shutter-alert::before {
  content: "\\f111d";
}

.mdi-window-shutter-open::before {
  content: "\\f111e";
}

.mdi-windsock::before {
  content: "\\f15fa";
}

.mdi-wiper::before {
  content: "\\f0ae9";
}

.mdi-wiper-wash::before {
  content: "\\f0da6";
}

.mdi-wiper-wash-alert::before {
  content: "\\f18df";
}

.mdi-wizard-hat::before {
  content: "\\f1477";
}

.mdi-wordpress::before {
  content: "\\f05b4";
}

.mdi-wrap::before {
  content: "\\f05b6";
}

.mdi-wrap-disabled::before {
  content: "\\f0bdf";
}

.mdi-wrench::before {
  content: "\\f05b7";
}

.mdi-wrench-clock::before {
  content: "\\f19a3";
}

.mdi-wrench-outline::before {
  content: "\\f0be0";
}

.mdi-xamarin::before {
  content: "\\f0845";
}

.mdi-xml::before {
  content: "\\f05c0";
}

.mdi-xmpp::before {
  content: "\\f07ff";
}

.mdi-yahoo::before {
  content: "\\f0b4f";
}

.mdi-yeast::before {
  content: "\\f05c1";
}

.mdi-yin-yang::before {
  content: "\\f0680";
}

.mdi-yoga::before {
  content: "\\f117c";
}

.mdi-youtube::before {
  content: "\\f05c3";
}

.mdi-youtube-gaming::before {
  content: "\\f0848";
}

.mdi-youtube-studio::before {
  content: "\\f0847";
}

.mdi-youtube-subscription::before {
  content: "\\f0d40";
}

.mdi-youtube-tv::before {
  content: "\\f0448";
}

.mdi-yurt::before {
  content: "\\f1516";
}

.mdi-z-wave::before {
  content: "\\f0aea";
}

.mdi-zend::before {
  content: "\\f0aeb";
}

.mdi-zigbee::before {
  content: "\\f0d41";
}

.mdi-zip-box::before {
  content: "\\f05c4";
}

.mdi-zip-box-outline::before {
  content: "\\f0ffa";
}

.mdi-zip-disk::before {
  content: "\\f0a23";
}

.mdi-zodiac-aquarius::before {
  content: "\\f0a7d";
}

.mdi-zodiac-aries::before {
  content: "\\f0a7e";
}

.mdi-zodiac-cancer::before {
  content: "\\f0a7f";
}

.mdi-zodiac-capricorn::before {
  content: "\\f0a80";
}

.mdi-zodiac-gemini::before {
  content: "\\f0a81";
}

.mdi-zodiac-leo::before {
  content: "\\f0a82";
}

.mdi-zodiac-libra::before {
  content: "\\f0a83";
}

.mdi-zodiac-pisces::before {
  content: "\\f0a84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\f0a85";
}

.mdi-zodiac-scorpio::before {
  content: "\\f0a86";
}

.mdi-zodiac-taurus::before {
  content: "\\f0a87";
}

.mdi-zodiac-virgo::before {
  content: "\\f0a88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

@font-face {
  font-family: "boxicons";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
}
.bx {
  font-family: "boxicons" !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none;
}

.bx-ul > li {
  position: relative;
}

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center;
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(359deg);
  }
}
@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  90% {
    transform: scale(1.5);
    opacity: 0;
  }
}
@keyframes flashing {
  0% {
    opacity: 1;
  }
  45% {
    opacity: 0;
  }
  90% {
    opacity: 1;
  }
}
@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(20px);
    opacity: 0;
  }
}
@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);
  }
  40%, 60%, 80% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.bx-spin {
  animation: spin 2s linear infinite;
}

.bx-spin-hover:hover {
  animation: spin 2s linear infinite;
}

.bx-tada {
  animation: tada 1.5s ease infinite;
}

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite;
}

.bx-flashing {
  animation: flashing 1.5s infinite linear;
}

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear;
}

.bx-burst {
  animation: burst 1.5s infinite linear;
}

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear;
}

.bx-fade-up {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-down {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-left {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-right {
  animation: fade-right 1.5s infinite linear;
}

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear;
}

.bx-xs {
  font-size: 1rem !important;
}

.bx-sm {
  font-size: 1.55rem !important;
}

.bx-md {
  font-size: 2.25rem !important;
}

.bx-lg {
  font-size: 3rem !important;
}

.bx-fw {
  font-size: 1.2857142857em;
  line-height: 0.8em;
  width: 1.2857142857em;
  height: 0.8em;
  margin-top: -0.2em !important;
  vertical-align: middle;
}

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important;
}

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important;
}

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
}

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
}

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
}

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.bx-border {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25em;
}

.bx-border-circle {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

.bxl-meta:before {
  content: "\\ef27";
}

.bx-lemon:before {
  content: "\\ef28";
}

.bxs-lemon:before {
  content: "\\ef29";
}

.bx-cricket-ball:before {
  content: "\\ef0c";
}

.bx-baguette:before {
  content: "\\ef0d";
}

.bx-bowl-hot:before {
  content: "\\ef0e";
}

.bx-bowl-rice:before {
  content: "\\ef0f";
}

.bx-cable-car:before {
  content: "\\ef10";
}

.bx-candles:before {
  content: "\\ef11";
}

.bx-circle-half:before {
  content: "\\ef12";
}

.bx-circle-quarter:before {
  content: "\\ef13";
}

.bx-circle-three-quarter:before {
  content: "\\ef14";
}

.bx-cross:before {
  content: "\\ef15";
}

.bx-fork:before {
  content: "\\ef16";
}

.bx-knife:before {
  content: "\\ef17";
}

.bx-money-withdraw:before {
  content: "\\ef18";
}

.bx-popsicle:before {
  content: "\\ef19";
}

.bx-scatter-chart:before {
  content: "\\ef1a";
}

.bxs-baguette:before {
  content: "\\ef1b";
}

.bxs-bowl-hot:before {
  content: "\\ef1c";
}

.bxs-bowl-rice:before {
  content: "\\ef1d";
}

.bxs-cable-car:before {
  content: "\\ef1e";
}

.bxs-circle-half:before {
  content: "\\ef1f";
}

.bxs-circle-quarter:before {
  content: "\\ef20";
}

.bxs-circle-three-quarter:before {
  content: "\\ef21";
}

.bxs-cricket-ball:before {
  content: "\\ef22";
}

.bxs-invader:before {
  content: "\\ef23";
}

.bx-male-female:before {
  content: "\\ef24";
}

.bxs-popsicle:before {
  content: "\\ef25";
}

.bxs-tree-alt:before {
  content: "\\ef26";
}

.bxl-venmo:before {
  content: "\\e900";
}

.bxl-upwork:before {
  content: "\\e901";
}

.bxl-netlify:before {
  content: "\\e902";
}

.bxl-java:before {
  content: "\\e903";
}

.bxl-heroku:before {
  content: "\\e904";
}

.bxl-go-lang:before {
  content: "\\e905";
}

.bxl-gmail:before {
  content: "\\e906";
}

.bxl-flask:before {
  content: "\\e907";
}

.bxl-99designs:before {
  content: "\\e908";
}

.bxl-500px:before {
  content: "\\e909";
}

.bxl-adobe:before {
  content: "\\e90a";
}

.bxl-airbnb:before {
  content: "\\e90b";
}

.bxl-algolia:before {
  content: "\\e90c";
}

.bxl-amazon:before {
  content: "\\e90d";
}

.bxl-android:before {
  content: "\\e90e";
}

.bxl-angular:before {
  content: "\\e90f";
}

.bxl-apple:before {
  content: "\\e910";
}

.bxl-audible:before {
  content: "\\e911";
}

.bxl-aws:before {
  content: "\\e912";
}

.bxl-baidu:before {
  content: "\\e913";
}

.bxl-behance:before {
  content: "\\e914";
}

.bxl-bing:before {
  content: "\\e915";
}

.bxl-bitcoin:before {
  content: "\\e916";
}

.bxl-blender:before {
  content: "\\e917";
}

.bxl-blogger:before {
  content: "\\e918";
}

.bxl-bootstrap:before {
  content: "\\e919";
}

.bxl-chrome:before {
  content: "\\e91a";
}

.bxl-codepen:before {
  content: "\\e91b";
}

.bxl-c-plus-plus:before {
  content: "\\e91c";
}

.bxl-creative-commons:before {
  content: "\\e91d";
}

.bxl-css3:before {
  content: "\\e91e";
}

.bxl-dailymotion:before {
  content: "\\e91f";
}

.bxl-deviantart:before {
  content: "\\e920";
}

.bxl-dev-to:before {
  content: "\\e921";
}

.bxl-digg:before {
  content: "\\e922";
}

.bxl-digitalocean:before {
  content: "\\e923";
}

.bxl-discord:before {
  content: "\\e924";
}

.bxl-discord-alt:before {
  content: "\\e925";
}

.bxl-discourse:before {
  content: "\\e926";
}

.bxl-django:before {
  content: "\\e927";
}

.bxl-docker:before {
  content: "\\e928";
}

.bxl-dribbble:before {
  content: "\\e929";
}

.bxl-dropbox:before {
  content: "\\e92a";
}

.bxl-drupal:before {
  content: "\\e92b";
}

.bxl-ebay:before {
  content: "\\e92c";
}

.bxl-edge:before {
  content: "\\e92d";
}

.bxl-etsy:before {
  content: "\\e92e";
}

.bxl-facebook:before {
  content: "\\e92f";
}

.bxl-facebook-circle:before {
  content: "\\e930";
}

.bxl-facebook-square:before {
  content: "\\e931";
}

.bxl-figma:before {
  content: "\\e932";
}

.bxl-firebase:before {
  content: "\\e933";
}

.bxl-firefox:before {
  content: "\\e934";
}

.bxl-flickr:before {
  content: "\\e935";
}

.bxl-flickr-square:before {
  content: "\\e936";
}

.bxl-flutter:before {
  content: "\\e937";
}

.bxl-foursquare:before {
  content: "\\e938";
}

.bxl-git:before {
  content: "\\e939";
}

.bxl-github:before {
  content: "\\e93a";
}

.bxl-gitlab:before {
  content: "\\e93b";
}

.bxl-google:before {
  content: "\\e93c";
}

.bxl-google-cloud:before {
  content: "\\e93d";
}

.bxl-google-plus:before {
  content: "\\e93e";
}

.bxl-google-plus-circle:before {
  content: "\\e93f";
}

.bxl-html5:before {
  content: "\\e940";
}

.bxl-imdb:before {
  content: "\\e941";
}

.bxl-instagram:before {
  content: "\\e942";
}

.bxl-instagram-alt:before {
  content: "\\e943";
}

.bxl-internet-explorer:before {
  content: "\\e944";
}

.bxl-invision:before {
  content: "\\e945";
}

.bxl-javascript:before {
  content: "\\e946";
}

.bxl-joomla:before {
  content: "\\e947";
}

.bxl-jquery:before {
  content: "\\e948";
}

.bxl-jsfiddle:before {
  content: "\\e949";
}

.bxl-kickstarter:before {
  content: "\\e94a";
}

.bxl-kubernetes:before {
  content: "\\e94b";
}

.bxl-less:before {
  content: "\\e94c";
}

.bxl-linkedin:before {
  content: "\\e94d";
}

.bxl-linkedin-square:before {
  content: "\\e94e";
}

.bxl-magento:before {
  content: "\\e94f";
}

.bxl-mailchimp:before {
  content: "\\e950";
}

.bxl-markdown:before {
  content: "\\e951";
}

.bxl-mastercard:before {
  content: "\\e952";
}

.bxl-mastodon:before {
  content: "\\e953";
}

.bxl-medium:before {
  content: "\\e954";
}

.bxl-medium-old:before {
  content: "\\e955";
}

.bxl-medium-square:before {
  content: "\\e956";
}

.bxl-messenger:before {
  content: "\\e957";
}

.bxl-microsoft:before {
  content: "\\e958";
}

.bxl-microsoft-teams:before {
  content: "\\e959";
}

.bxl-nodejs:before {
  content: "\\e95a";
}

.bxl-ok-ru:before {
  content: "\\e95b";
}

.bxl-opera:before {
  content: "\\e95c";
}

.bxl-patreon:before {
  content: "\\e95d";
}

.bxl-paypal:before {
  content: "\\e95e";
}

.bxl-periscope:before {
  content: "\\e95f";
}

.bxl-php:before {
  content: "\\e960";
}

.bxl-pinterest:before {
  content: "\\e961";
}

.bxl-pinterest-alt:before {
  content: "\\e962";
}

.bxl-play-store:before {
  content: "\\e963";
}

.bxl-pocket:before {
  content: "\\e964";
}

.bxl-product-hunt:before {
  content: "\\e965";
}

.bxl-python:before {
  content: "\\e966";
}

.bxl-quora:before {
  content: "\\e967";
}

.bxl-react:before {
  content: "\\e968";
}

.bxl-redbubble:before {
  content: "\\e969";
}

.bxl-reddit:before {
  content: "\\e96a";
}

.bxl-redux:before {
  content: "\\e96b";
}

.bxl-sass:before {
  content: "\\e96c";
}

.bxl-shopify:before {
  content: "\\e96d";
}

.bxl-sketch:before {
  content: "\\e96e";
}

.bxl-skype:before {
  content: "\\e96f";
}

.bxl-slack:before {
  content: "\\e970";
}

.bxl-slack-old:before {
  content: "\\e971";
}

.bxl-snapchat:before {
  content: "\\e972";
}

.bxl-soundcloud:before {
  content: "\\e973";
}

.bxl-spotify:before {
  content: "\\e974";
}

.bxl-spring-boot:before {
  content: "\\e975";
}

.bxl-squarespace:before {
  content: "\\e976";
}

.bxl-stack-overflow:before {
  content: "\\e977";
}

.bxl-steam:before {
  content: "\\e978";
}

.bxl-stripe:before {
  content: "\\e979";
}

.bxl-tailwind-css:before {
  content: "\\e97a";
}

.bxl-telegram:before {
  content: "\\e97b";
}

.bxl-tiktok:before {
  content: "\\e97c";
}

.bxl-trello:before {
  content: "\\e97d";
}

.bxl-trip-advisor:before {
  content: "\\e97e";
}

.bxl-tumblr:before {
  content: "\\e97f";
}

.bxl-tux:before {
  content: "\\e980";
}

.bxl-twitch:before {
  content: "\\e981";
}

.bxl-twitter:before {
  content: "\\e982";
}

.bxl-unity:before {
  content: "\\e983";
}

.bxl-unsplash:before {
  content: "\\e984";
}

.bxl-vimeo:before {
  content: "\\e985";
}

.bxl-visa:before {
  content: "\\e986";
}

.bxl-visual-studio:before {
  content: "\\e987";
}

.bxl-vk:before {
  content: "\\e988";
}

.bxl-vuejs:before {
  content: "\\e989";
}

.bxl-whatsapp:before {
  content: "\\e98a";
}

.bxl-whatsapp-square:before {
  content: "\\e98b";
}

.bxl-wikipedia:before {
  content: "\\e98c";
}

.bxl-windows:before {
  content: "\\e98d";
}

.bxl-wix:before {
  content: "\\e98e";
}

.bxl-wordpress:before {
  content: "\\e98f";
}

.bxl-yahoo:before {
  content: "\\e990";
}

.bxl-yelp:before {
  content: "\\e991";
}

.bxl-youtube:before {
  content: "\\e992";
}

.bxl-zoom:before {
  content: "\\e993";
}

.bx-collapse-alt:before {
  content: "\\e994";
}

.bx-collapse-horizontal:before {
  content: "\\e995";
}

.bx-collapse-vertical:before {
  content: "\\e996";
}

.bx-expand-horizontal:before {
  content: "\\e997";
}

.bx-expand-vertical:before {
  content: "\\e998";
}

.bx-injection:before {
  content: "\\e999";
}

.bx-leaf:before {
  content: "\\e99a";
}

.bx-math:before {
  content: "\\e99b";
}

.bx-party:before {
  content: "\\e99c";
}

.bx-abacus:before {
  content: "\\e99d";
}

.bx-accessibility:before {
  content: "\\e99e";
}

.bx-add-to-queue:before {
  content: "\\e99f";
}

.bx-adjust:before {
  content: "\\e9a0";
}

.bx-alarm:before {
  content: "\\e9a1";
}

.bx-alarm-add:before {
  content: "\\e9a2";
}

.bx-alarm-exclamation:before {
  content: "\\e9a3";
}

.bx-alarm-off:before {
  content: "\\e9a4";
}

.bx-alarm-snooze:before {
  content: "\\e9a5";
}

.bx-album:before {
  content: "\\e9a6";
}

.bx-align-justify:before {
  content: "\\e9a7";
}

.bx-align-left:before {
  content: "\\e9a8";
}

.bx-align-middle:before {
  content: "\\e9a9";
}

.bx-align-right:before {
  content: "\\e9aa";
}

.bx-analyse:before {
  content: "\\e9ab";
}

.bx-anchor:before {
  content: "\\e9ac";
}

.bx-angry:before {
  content: "\\e9ad";
}

.bx-aperture:before {
  content: "\\e9ae";
}

.bx-arch:before {
  content: "\\e9af";
}

.bx-archive:before {
  content: "\\e9b0";
}

.bx-archive-in:before {
  content: "\\e9b1";
}

.bx-archive-out:before {
  content: "\\e9b2";
}

.bx-area:before {
  content: "\\e9b3";
}

.bx-arrow-back:before {
  content: "\\e9b4";
}

.bx-arrow-from-bottom:before {
  content: "\\e9b5";
}

.bx-arrow-from-left:before {
  content: "\\e9b6";
}

.bx-arrow-from-right:before {
  content: "\\e9b7";
}

.bx-arrow-from-top:before {
  content: "\\e9b8";
}

.bx-arrow-to-bottom:before {
  content: "\\e9b9";
}

.bx-arrow-to-left:before {
  content: "\\e9ba";
}

.bx-arrow-to-right:before {
  content: "\\e9bb";
}

.bx-arrow-to-top:before {
  content: "\\e9bc";
}

.bx-at:before {
  content: "\\e9bd";
}

.bx-atom:before {
  content: "\\e9be";
}

.bx-award:before {
  content: "\\e9bf";
}

.bx-badge:before {
  content: "\\e9c0";
}

.bx-badge-check:before {
  content: "\\e9c1";
}

.bx-ball:before {
  content: "\\e9c2";
}

.bx-band-aid:before {
  content: "\\e9c3";
}

.bx-bar-chart:before {
  content: "\\e9c4";
}

.bx-bar-chart-alt:before {
  content: "\\e9c5";
}

.bx-bar-chart-alt-2:before {
  content: "\\e9c6";
}

.bx-bar-chart-square:before {
  content: "\\e9c7";
}

.bx-barcode:before {
  content: "\\e9c8";
}

.bx-barcode-reader:before {
  content: "\\e9c9";
}

.bx-baseball:before {
  content: "\\e9ca";
}

.bx-basket:before {
  content: "\\e9cb";
}

.bx-basketball:before {
  content: "\\e9cc";
}

.bx-bath:before {
  content: "\\e9cd";
}

.bx-battery:before {
  content: "\\e9ce";
}

.bx-bed:before {
  content: "\\e9cf";
}

.bx-been-here:before {
  content: "\\e9d0";
}

.bx-beer:before {
  content: "\\e9d1";
}

.bx-bell:before {
  content: "\\e9d2";
}

.bx-bell-minus:before {
  content: "\\e9d3";
}

.bx-bell-off:before {
  content: "\\e9d4";
}

.bx-bell-plus:before {
  content: "\\e9d5";
}

.bx-bible:before {
  content: "\\e9d6";
}

.bx-bitcoin:before {
  content: "\\e9d7";
}

.bx-blanket:before {
  content: "\\e9d8";
}

.bx-block:before {
  content: "\\e9d9";
}

.bx-bluetooth:before {
  content: "\\e9da";
}

.bx-body:before {
  content: "\\e9db";
}

.bx-bold:before {
  content: "\\e9dc";
}

.bx-bolt-circle:before {
  content: "\\e9dd";
}

.bx-bomb:before {
  content: "\\e9de";
}

.bx-bone:before {
  content: "\\e9df";
}

.bx-bong:before {
  content: "\\e9e0";
}

.bx-book:before {
  content: "\\e9e1";
}

.bx-book-add:before {
  content: "\\e9e2";
}

.bx-book-alt:before {
  content: "\\e9e3";
}

.bx-book-bookmark:before {
  content: "\\e9e4";
}

.bx-book-content:before {
  content: "\\e9e5";
}

.bx-book-heart:before {
  content: "\\e9e6";
}

.bx-bookmark:before {
  content: "\\e9e7";
}

.bx-bookmark-alt:before {
  content: "\\e9e8";
}

.bx-bookmark-alt-minus:before {
  content: "\\e9e9";
}

.bx-bookmark-alt-plus:before {
  content: "\\e9ea";
}

.bx-bookmark-heart:before {
  content: "\\e9eb";
}

.bx-bookmark-minus:before {
  content: "\\e9ec";
}

.bx-bookmark-plus:before {
  content: "\\e9ed";
}

.bx-bookmarks:before {
  content: "\\e9ee";
}

.bx-book-open:before {
  content: "\\e9ef";
}

.bx-book-reader:before {
  content: "\\e9f0";
}

.bx-border-all:before {
  content: "\\e9f1";
}

.bx-border-bottom:before {
  content: "\\e9f2";
}

.bx-border-inner:before {
  content: "\\e9f3";
}

.bx-border-left:before {
  content: "\\e9f4";
}

.bx-border-none:before {
  content: "\\e9f5";
}

.bx-border-outer:before {
  content: "\\e9f6";
}

.bx-border-radius:before {
  content: "\\e9f7";
}

.bx-border-right:before {
  content: "\\e9f8";
}

.bx-border-top:before {
  content: "\\e9f9";
}

.bx-bot:before {
  content: "\\e9fa";
}

.bx-bowling-ball:before {
  content: "\\e9fb";
}

.bx-box:before {
  content: "\\e9fc";
}

.bx-bracket:before {
  content: "\\e9fd";
}

.bx-braille:before {
  content: "\\e9fe";
}

.bx-brain:before {
  content: "\\e9ff";
}

.bx-briefcase:before {
  content: "\\ea00";
}

.bx-briefcase-alt:before {
  content: "\\ea01";
}

.bx-briefcase-alt-2:before {
  content: "\\ea02";
}

.bx-brightness:before {
  content: "\\ea03";
}

.bx-brightness-half:before {
  content: "\\ea04";
}

.bx-broadcast:before {
  content: "\\ea05";
}

.bx-brush:before {
  content: "\\ea06";
}

.bx-brush-alt:before {
  content: "\\ea07";
}

.bx-bug:before {
  content: "\\ea08";
}

.bx-bug-alt:before {
  content: "\\ea09";
}

.bx-building:before {
  content: "\\ea0a";
}

.bx-building-house:before {
  content: "\\ea0b";
}

.bx-buildings:before {
  content: "\\ea0c";
}

.bx-bulb:before {
  content: "\\ea0d";
}

.bx-bullseye:before {
  content: "\\ea0e";
}

.bx-buoy:before {
  content: "\\ea0f";
}

.bx-bus:before {
  content: "\\ea10";
}

.bx-bus-school:before {
  content: "\\ea11";
}

.bx-cabinet:before {
  content: "\\ea12";
}

.bx-cake:before {
  content: "\\ea13";
}

.bx-calculator:before {
  content: "\\ea14";
}

.bx-calendar:before {
  content: "\\ea15";
}

.bx-calendar-alt:before {
  content: "\\ea16";
}

.bx-calendar-check:before {
  content: "\\ea17";
}

.bx-calendar-edit:before {
  content: "\\ea18";
}

.bx-calendar-event:before {
  content: "\\ea19";
}

.bx-calendar-exclamation:before {
  content: "\\ea1a";
}

.bx-calendar-heart:before {
  content: "\\ea1b";
}

.bx-calendar-minus:before {
  content: "\\ea1c";
}

.bx-calendar-plus:before {
  content: "\\ea1d";
}

.bx-calendar-star:before {
  content: "\\ea1e";
}

.bx-calendar-week:before {
  content: "\\ea1f";
}

.bx-calendar-x:before {
  content: "\\ea20";
}

.bx-camera:before {
  content: "\\ea21";
}

.bx-camera-home:before {
  content: "\\ea22";
}

.bx-camera-movie:before {
  content: "\\ea23";
}

.bx-camera-off:before {
  content: "\\ea24";
}

.bx-capsule:before {
  content: "\\ea25";
}

.bx-captions:before {
  content: "\\ea26";
}

.bx-car:before {
  content: "\\ea27";
}

.bx-card:before {
  content: "\\ea28";
}

.bx-caret-down:before {
  content: "\\ea29";
}

.bx-caret-down-circle:before {
  content: "\\ea2a";
}

.bx-caret-down-square:before {
  content: "\\ea2b";
}

.bx-caret-left:before {
  content: "\\ea2c";
}

.bx-caret-left-circle:before {
  content: "\\ea2d";
}

.bx-caret-left-square:before {
  content: "\\ea2e";
}

.bx-caret-right:before {
  content: "\\ea2f";
}

.bx-caret-right-circle:before {
  content: "\\ea30";
}

.bx-caret-right-square:before {
  content: "\\ea31";
}

.bx-caret-up:before {
  content: "\\ea32";
}

.bx-caret-up-circle:before {
  content: "\\ea33";
}

.bx-caret-up-square:before {
  content: "\\ea34";
}

.bx-carousel:before {
  content: "\\ea35";
}

.bx-cart:before {
  content: "\\ea36";
}

.bx-cart-alt:before {
  content: "\\ea37";
}

.bx-cast:before {
  content: "\\ea38";
}

.bx-category:before {
  content: "\\ea39";
}

.bx-category-alt:before {
  content: "\\ea3a";
}

.bx-cctv:before {
  content: "\\ea3b";
}

.bx-certification:before {
  content: "\\ea3c";
}

.bx-chair:before {
  content: "\\ea3d";
}

.bx-chalkboard:before {
  content: "\\ea3e";
}

.bx-chart:before {
  content: "\\ea3f";
}

.bx-chat:before {
  content: "\\ea40";
}

.bx-check:before {
  content: "\\ea41";
}

.bx-checkbox:before {
  content: "\\ea42";
}

.bx-checkbox-checked:before {
  content: "\\ea43";
}

.bx-checkbox-minus:before {
  content: "\\ea44";
}

.bx-checkbox-square:before {
  content: "\\ea45";
}

.bx-check-circle:before {
  content: "\\ea46";
}

.bx-check-double:before {
  content: "\\ea47";
}

.bx-check-shield:before {
  content: "\\ea48";
}

.bx-check-square:before {
  content: "\\ea49";
}

.bx-chevron-down:before {
  content: "\\ea4a";
}

.bx-chevron-down-circle:before {
  content: "\\ea4b";
}

.bx-chevron-down-square:before {
  content: "\\ea4c";
}

.bx-chevron-left:before {
  content: "\\ea4d";
}

.bx-chevron-left-circle:before {
  content: "\\ea4e";
}

.bx-chevron-left-square:before {
  content: "\\ea4f";
}

.bx-chevron-right:before {
  content: "\\ea50";
}

.bx-chevron-right-circle:before {
  content: "\\ea51";
}

.bx-chevron-right-square:before {
  content: "\\ea52";
}

.bx-chevrons-down:before {
  content: "\\ea53";
}

.bx-chevrons-left:before {
  content: "\\ea54";
}

.bx-chevrons-right:before {
  content: "\\ea55";
}

.bx-chevrons-up:before {
  content: "\\ea56";
}

.bx-chevron-up:before {
  content: "\\ea57";
}

.bx-chevron-up-circle:before {
  content: "\\ea58";
}

.bx-chevron-up-square:before {
  content: "\\ea59";
}

.bx-chip:before {
  content: "\\ea5a";
}

.bx-church:before {
  content: "\\ea5b";
}

.bx-circle:before {
  content: "\\ea5c";
}

.bx-clinic:before {
  content: "\\ea5d";
}

.bx-clipboard:before {
  content: "\\ea5e";
}

.bx-closet:before {
  content: "\\ea5f";
}

.bx-cloud:before {
  content: "\\ea60";
}

.bx-cloud-download:before {
  content: "\\ea61";
}

.bx-cloud-drizzle:before {
  content: "\\ea62";
}

.bx-cloud-lightning:before {
  content: "\\ea63";
}

.bx-cloud-light-rain:before {
  content: "\\ea64";
}

.bx-cloud-rain:before {
  content: "\\ea65";
}

.bx-cloud-snow:before {
  content: "\\ea66";
}

.bx-cloud-upload:before {
  content: "\\ea67";
}

.bx-code:before {
  content: "\\ea68";
}

.bx-code-alt:before {
  content: "\\ea69";
}

.bx-code-block:before {
  content: "\\ea6a";
}

.bx-code-curly:before {
  content: "\\ea6b";
}

.bx-coffee:before {
  content: "\\ea6c";
}

.bx-coffee-togo:before {
  content: "\\ea6d";
}

.bx-cog:before {
  content: "\\ea6e";
}

.bx-coin:before {
  content: "\\ea6f";
}

.bx-coin-stack:before {
  content: "\\ea70";
}

.bx-collapse:before {
  content: "\\ea71";
}

.bx-collection:before {
  content: "\\ea72";
}

.bx-color-fill:before {
  content: "\\ea73";
}

.bx-columns:before {
  content: "\\ea74";
}

.bx-command:before {
  content: "\\ea75";
}

.bx-comment:before {
  content: "\\ea76";
}

.bx-comment-add:before {
  content: "\\ea77";
}

.bx-comment-check:before {
  content: "\\ea78";
}

.bx-comment-detail:before {
  content: "\\ea79";
}

.bx-comment-dots:before {
  content: "\\ea7a";
}

.bx-comment-edit:before {
  content: "\\ea7b";
}

.bx-comment-error:before {
  content: "\\ea7c";
}

.bx-comment-minus:before {
  content: "\\ea7d";
}

.bx-comment-x:before {
  content: "\\ea7e";
}

.bx-compass:before {
  content: "\\ea7f";
}

.bx-confused:before {
  content: "\\ea80";
}

.bx-conversation:before {
  content: "\\ea81";
}

.bx-cookie:before {
  content: "\\ea82";
}

.bx-cool:before {
  content: "\\ea83";
}

.bx-copy:before {
  content: "\\ea84";
}

.bx-copy-alt:before {
  content: "\\ea85";
}

.bx-copyright:before {
  content: "\\ea86";
}

.bx-credit-card:before {
  content: "\\ea87";
}

.bx-credit-card-alt:before {
  content: "\\ea88";
}

.bx-credit-card-front:before {
  content: "\\ea89";
}

.bx-crop:before {
  content: "\\ea8a";
}

.bx-crosshair:before {
  content: "\\ea8b";
}

.bx-crown:before {
  content: "\\ea8c";
}

.bx-cube:before {
  content: "\\ea8d";
}

.bx-cube-alt:before {
  content: "\\ea8e";
}

.bx-cuboid:before {
  content: "\\ea8f";
}

.bx-current-location:before {
  content: "\\ea90";
}

.bx-customize:before {
  content: "\\ea91";
}

.bx-cut:before {
  content: "\\ea92";
}

.bx-cycling:before {
  content: "\\ea93";
}

.bx-cylinder:before {
  content: "\\ea94";
}

.bx-data:before {
  content: "\\ea95";
}

.bx-desktop:before {
  content: "\\ea96";
}

.bx-detail:before {
  content: "\\ea97";
}

.bx-devices:before {
  content: "\\ea98";
}

.bx-dialpad:before {
  content: "\\ea99";
}

.bx-dialpad-alt:before {
  content: "\\ea9a";
}

.bx-diamond:before {
  content: "\\ea9b";
}

.bx-dice-1:before {
  content: "\\ea9c";
}

.bx-dice-2:before {
  content: "\\ea9d";
}

.bx-dice-3:before {
  content: "\\ea9e";
}

.bx-dice-4:before {
  content: "\\ea9f";
}

.bx-dice-5:before {
  content: "\\eaa0";
}

.bx-dice-6:before {
  content: "\\eaa1";
}

.bx-directions:before {
  content: "\\eaa2";
}

.bx-disc:before {
  content: "\\eaa3";
}

.bx-dish:before {
  content: "\\eaa4";
}

.bx-dislike:before {
  content: "\\eaa5";
}

.bx-dizzy:before {
  content: "\\eaa6";
}

.bx-dna:before {
  content: "\\eaa7";
}

.bx-dock-bottom:before {
  content: "\\eaa8";
}

.bx-dock-left:before {
  content: "\\eaa9";
}

.bx-dock-right:before {
  content: "\\eaaa";
}

.bx-dock-top:before {
  content: "\\eaab";
}

.bx-dollar:before {
  content: "\\eaac";
}

.bx-dollar-circle:before {
  content: "\\eaad";
}

.bx-donate-blood:before {
  content: "\\eaae";
}

.bx-donate-heart:before {
  content: "\\eaaf";
}

.bx-door-open:before {
  content: "\\eab0";
}

.bx-dots-horizontal:before {
  content: "\\eab1";
}

.bx-dots-horizontal-rounded:before {
  content: "\\eab2";
}

.bx-dots-vertical:before {
  content: "\\eab3";
}

.bx-dots-vertical-rounded:before {
  content: "\\eab4";
}

.bx-doughnut-chart:before {
  content: "\\eab5";
}

.bx-down-arrow:before {
  content: "\\eab6";
}

.bx-down-arrow-alt:before {
  content: "\\eab7";
}

.bx-down-arrow-circle:before {
  content: "\\eab8";
}

.bx-download:before {
  content: "\\eab9";
}

.bx-downvote:before {
  content: "\\eaba";
}

.bx-drink:before {
  content: "\\eabb";
}

.bx-droplet:before {
  content: "\\eabc";
}

.bx-dumbbell:before {
  content: "\\eabd";
}

.bx-duplicate:before {
  content: "\\eabe";
}

.bx-edit:before {
  content: "\\eabf";
}

.bx-edit-alt:before {
  content: "\\eac0";
}

.bx-envelope:before {
  content: "\\eac1";
}

.bx-envelope-open:before {
  content: "\\eac2";
}

.bx-equalizer:before {
  content: "\\eac3";
}

.bx-eraser:before {
  content: "\\eac4";
}

.bx-error:before {
  content: "\\eac5";
}

.bx-error-alt:before {
  content: "\\eac6";
}

.bx-error-circle:before {
  content: "\\eac7";
}

.bx-euro:before {
  content: "\\eac8";
}

.bx-exclude:before {
  content: "\\eac9";
}

.bx-exit:before {
  content: "\\eaca";
}

.bx-exit-fullscreen:before {
  content: "\\eacb";
}

.bx-expand:before {
  content: "\\eacc";
}

.bx-expand-alt:before {
  content: "\\eacd";
}

.bx-export:before {
  content: "\\eace";
}

.bx-extension:before {
  content: "\\eacf";
}

.bx-face:before {
  content: "\\ead0";
}

.bx-fast-forward:before {
  content: "\\ead1";
}

.bx-fast-forward-circle:before {
  content: "\\ead2";
}

.bx-female:before {
  content: "\\ead3";
}

.bx-female-sign:before {
  content: "\\ead4";
}

.bx-file:before {
  content: "\\ead5";
}

.bx-file-blank:before {
  content: "\\ead6";
}

.bx-file-find:before {
  content: "\\ead7";
}

.bx-film:before {
  content: "\\ead8";
}

.bx-filter:before {
  content: "\\ead9";
}

.bx-filter-alt:before {
  content: "\\eada";
}

.bx-fingerprint:before {
  content: "\\eadb";
}

.bx-first-aid:before {
  content: "\\eadc";
}

.bx-first-page:before {
  content: "\\eadd";
}

.bx-flag:before {
  content: "\\eade";
}

.bx-folder:before {
  content: "\\eadf";
}

.bx-folder-minus:before {
  content: "\\eae0";
}

.bx-folder-open:before {
  content: "\\eae1";
}

.bx-folder-plus:before {
  content: "\\eae2";
}

.bx-font:before {
  content: "\\eae3";
}

.bx-font-color:before {
  content: "\\eae4";
}

.bx-font-family:before {
  content: "\\eae5";
}

.bx-font-size:before {
  content: "\\eae6";
}

.bx-food-menu:before {
  content: "\\eae7";
}

.bx-food-tag:before {
  content: "\\eae8";
}

.bx-football:before {
  content: "\\eae9";
}

.bx-fridge:before {
  content: "\\eaea";
}

.bx-fullscreen:before {
  content: "\\eaeb";
}

.bx-game:before {
  content: "\\eaec";
}

.bx-gas-pump:before {
  content: "\\eaed";
}

.bx-ghost:before {
  content: "\\eaee";
}

.bx-gift:before {
  content: "\\eaef";
}

.bx-git-branch:before {
  content: "\\eaf0";
}

.bx-git-commit:before {
  content: "\\eaf1";
}

.bx-git-compare:before {
  content: "\\eaf2";
}

.bx-git-merge:before {
  content: "\\eaf3";
}

.bx-git-pull-request:before {
  content: "\\eaf4";
}

.bx-git-repo-forked:before {
  content: "\\eaf5";
}

.bx-glasses:before {
  content: "\\eaf6";
}

.bx-glasses-alt:before {
  content: "\\eaf7";
}

.bx-globe:before {
  content: "\\eaf8";
}

.bx-globe-alt:before {
  content: "\\eaf9";
}

.bx-grid:before {
  content: "\\eafa";
}

.bx-grid-alt:before {
  content: "\\eafb";
}

.bx-grid-horizontal:before {
  content: "\\eafc";
}

.bx-grid-small:before {
  content: "\\eafd";
}

.bx-grid-vertical:before {
  content: "\\eafe";
}

.bx-group:before {
  content: "\\eaff";
}

.bx-handicap:before {
  content: "\\eb00";
}

.bx-happy:before {
  content: "\\eb01";
}

.bx-happy-alt:before {
  content: "\\eb02";
}

.bx-happy-beaming:before {
  content: "\\eb03";
}

.bx-happy-heart-eyes:before {
  content: "\\eb04";
}

.bx-hash:before {
  content: "\\eb05";
}

.bx-hdd:before {
  content: "\\eb06";
}

.bx-heading:before {
  content: "\\eb07";
}

.bx-headphone:before {
  content: "\\eb08";
}

.bx-health:before {
  content: "\\eb09";
}

.bx-heart:before {
  content: "\\eb0a";
}

.bx-heart-circle:before {
  content: "\\eb0b";
}

.bx-heart-square:before {
  content: "\\eb0c";
}

.bx-help-circle:before {
  content: "\\eb0d";
}

.bx-hide:before {
  content: "\\eb0e";
}

.bx-highlight:before {
  content: "\\eb0f";
}

.bx-history:before {
  content: "\\eb10";
}

.bx-hive:before {
  content: "\\eb11";
}

.bx-home:before {
  content: "\\eb12";
}

.bx-home-alt:before {
  content: "\\eb13";
}

.bx-home-circle:before {
  content: "\\eb14";
}

.bx-home-heart:before {
  content: "\\eb15";
}

.bx-home-smile:before {
  content: "\\eb16";
}

.bx-horizontal-center:before {
  content: "\\eb17";
}

.bx-hotel:before {
  content: "\\eb18";
}

.bx-hourglass:before {
  content: "\\eb19";
}

.bx-id-card:before {
  content: "\\eb1a";
}

.bx-image:before {
  content: "\\eb1b";
}

.bx-image-add:before {
  content: "\\eb1c";
}

.bx-image-alt:before {
  content: "\\eb1d";
}

.bx-images:before {
  content: "\\eb1e";
}

.bx-import:before {
  content: "\\eb1f";
}

.bx-infinite:before {
  content: "\\eb20";
}

.bx-info-circle:before {
  content: "\\eb21";
}

.bx-info-square:before {
  content: "\\eb22";
}

.bx-intersect:before {
  content: "\\eb23";
}

.bx-italic:before {
  content: "\\eb24";
}

.bx-joystick:before {
  content: "\\eb25";
}

.bx-joystick-alt:before {
  content: "\\eb26";
}

.bx-joystick-button:before {
  content: "\\eb27";
}

.bx-key:before {
  content: "\\eb28";
}

.bx-label:before {
  content: "\\eb29";
}

.bx-landscape:before {
  content: "\\eb2a";
}

.bx-laptop:before {
  content: "\\eb2b";
}

.bx-last-page:before {
  content: "\\eb2c";
}

.bx-laugh:before {
  content: "\\eb2d";
}

.bx-layer:before {
  content: "\\eb2e";
}

.bx-layer-minus:before {
  content: "\\eb2f";
}

.bx-layer-plus:before {
  content: "\\eb30";
}

.bx-layout:before {
  content: "\\eb31";
}

.bx-left-arrow:before {
  content: "\\eb32";
}

.bx-left-arrow-alt:before {
  content: "\\eb33";
}

.bx-left-arrow-circle:before {
  content: "\\eb34";
}

.bx-left-down-arrow-circle:before {
  content: "\\eb35";
}

.bx-left-indent:before {
  content: "\\eb36";
}

.bx-left-top-arrow-circle:before {
  content: "\\eb37";
}

.bx-library:before {
  content: "\\eb38";
}

.bx-like:before {
  content: "\\eb39";
}

.bx-line-chart:before {
  content: "\\eb3a";
}

.bx-line-chart-down:before {
  content: "\\eb3b";
}

.bx-link:before {
  content: "\\eb3c";
}

.bx-link-alt:before {
  content: "\\eb3d";
}

.bx-link-external:before {
  content: "\\eb3e";
}

.bx-lira:before {
  content: "\\eb3f";
}

.bx-list-check:before {
  content: "\\eb40";
}

.bx-list-minus:before {
  content: "\\eb41";
}

.bx-list-ol:before {
  content: "\\eb42";
}

.bx-list-plus:before {
  content: "\\eb43";
}

.bx-list-ul:before {
  content: "\\eb44";
}

.bx-loader:before {
  content: "\\eb45";
}

.bx-loader-alt:before {
  content: "\\eb46";
}

.bx-loader-circle:before {
  content: "\\eb47";
}

.bx-location-plus:before {
  content: "\\eb48";
}

.bx-lock:before {
  content: "\\eb49";
}

.bx-lock-alt:before {
  content: "\\eb4a";
}

.bx-lock-open:before {
  content: "\\eb4b";
}

.bx-lock-open-alt:before {
  content: "\\eb4c";
}

.bx-log-in:before {
  content: "\\eb4d";
}

.bx-log-in-circle:before {
  content: "\\eb4e";
}

.bx-log-out:before {
  content: "\\eb4f";
}

.bx-log-out-circle:before {
  content: "\\eb50";
}

.bx-low-vision:before {
  content: "\\eb51";
}

.bx-magnet:before {
  content: "\\eb52";
}

.bx-mail-send:before {
  content: "\\eb53";
}

.bx-male:before {
  content: "\\eb54";
}

.bx-male-sign:before {
  content: "\\eb55";
}

.bx-map:before {
  content: "\\eb56";
}

.bx-map-alt:before {
  content: "\\eb57";
}

.bx-map-pin:before {
  content: "\\eb58";
}

.bx-mask:before {
  content: "\\eb59";
}

.bx-medal:before {
  content: "\\eb5a";
}

.bx-meh:before {
  content: "\\eb5b";
}

.bx-meh-alt:before {
  content: "\\eb5c";
}

.bx-meh-blank:before {
  content: "\\eb5d";
}

.bx-memory-card:before {
  content: "\\eb5e";
}

.bx-menu:before {
  content: "\\eb5f";
}

.bx-menu-alt-left:before {
  content: "\\eb60";
}

.bx-menu-alt-right:before {
  content: "\\eb61";
}

.bx-merge:before {
  content: "\\eb62";
}

.bx-message:before {
  content: "\\eb63";
}

.bx-message-add:before {
  content: "\\eb64";
}

.bx-message-alt:before {
  content: "\\eb65";
}

.bx-message-alt-add:before {
  content: "\\eb66";
}

.bx-message-alt-check:before {
  content: "\\eb67";
}

.bx-message-alt-detail:before {
  content: "\\eb68";
}

.bx-message-alt-dots:before {
  content: "\\eb69";
}

.bx-message-alt-edit:before {
  content: "\\eb6a";
}

.bx-message-alt-error:before {
  content: "\\eb6b";
}

.bx-message-alt-minus:before {
  content: "\\eb6c";
}

.bx-message-alt-x:before {
  content: "\\eb6d";
}

.bx-message-check:before {
  content: "\\eb6e";
}

.bx-message-detail:before {
  content: "\\eb6f";
}

.bx-message-dots:before {
  content: "\\eb70";
}

.bx-message-edit:before {
  content: "\\eb71";
}

.bx-message-error:before {
  content: "\\eb72";
}

.bx-message-minus:before {
  content: "\\eb73";
}

.bx-message-rounded:before {
  content: "\\eb74";
}

.bx-message-rounded-add:before {
  content: "\\eb75";
}

.bx-message-rounded-check:before {
  content: "\\eb76";
}

.bx-message-rounded-detail:before {
  content: "\\eb77";
}

.bx-message-rounded-dots:before {
  content: "\\eb78";
}

.bx-message-rounded-edit:before {
  content: "\\eb79";
}

.bx-message-rounded-error:before {
  content: "\\eb7a";
}

.bx-message-rounded-minus:before {
  content: "\\eb7b";
}

.bx-message-rounded-x:before {
  content: "\\eb7c";
}

.bx-message-square:before {
  content: "\\eb7d";
}

.bx-message-square-add:before {
  content: "\\eb7e";
}

.bx-message-square-check:before {
  content: "\\eb7f";
}

.bx-message-square-detail:before {
  content: "\\eb80";
}

.bx-message-square-dots:before {
  content: "\\eb81";
}

.bx-message-square-edit:before {
  content: "\\eb82";
}

.bx-message-square-error:before {
  content: "\\eb83";
}

.bx-message-square-minus:before {
  content: "\\eb84";
}

.bx-message-square-x:before {
  content: "\\eb85";
}

.bx-message-x:before {
  content: "\\eb86";
}

.bx-meteor:before {
  content: "\\eb87";
}

.bx-microchip:before {
  content: "\\eb88";
}

.bx-microphone:before {
  content: "\\eb89";
}

.bx-microphone-off:before {
  content: "\\eb8a";
}

.bx-minus:before {
  content: "\\eb8b";
}

.bx-minus-back:before {
  content: "\\eb8c";
}

.bx-minus-circle:before {
  content: "\\eb8d";
}

.bx-minus-front:before {
  content: "\\eb8e";
}

.bx-mobile:before {
  content: "\\eb8f";
}

.bx-mobile-alt:before {
  content: "\\eb90";
}

.bx-mobile-landscape:before {
  content: "\\eb91";
}

.bx-mobile-vibration:before {
  content: "\\eb92";
}

.bx-money:before {
  content: "\\eb93";
}

.bx-moon:before {
  content: "\\eb94";
}

.bx-mouse:before {
  content: "\\eb95";
}

.bx-mouse-alt:before {
  content: "\\eb96";
}

.bx-move:before {
  content: "\\eb97";
}

.bx-move-horizontal:before {
  content: "\\eb98";
}

.bx-move-vertical:before {
  content: "\\eb99";
}

.bx-movie:before {
  content: "\\eb9a";
}

.bx-movie-play:before {
  content: "\\eb9b";
}

.bx-music:before {
  content: "\\eb9c";
}

.bx-navigation:before {
  content: "\\eb9d";
}

.bx-network-chart:before {
  content: "\\eb9e";
}

.bx-news:before {
  content: "\\eb9f";
}

.bx-no-entry:before {
  content: "\\eba0";
}

.bx-note:before {
  content: "\\eba1";
}

.bx-notepad:before {
  content: "\\eba2";
}

.bx-notification:before {
  content: "\\eba3";
}

.bx-notification-off:before {
  content: "\\eba4";
}

.bx-outline:before {
  content: "\\eba5";
}

.bx-package:before {
  content: "\\eba6";
}

.bx-paint:before {
  content: "\\eba7";
}

.bx-paint-roll:before {
  content: "\\eba8";
}

.bx-palette:before {
  content: "\\eba9";
}

.bx-paperclip:before {
  content: "\\ebaa";
}

.bx-paper-plane:before {
  content: "\\ebab";
}

.bx-paragraph:before {
  content: "\\ebac";
}

.bx-paste:before {
  content: "\\ebad";
}

.bx-pause:before {
  content: "\\ebae";
}

.bx-pause-circle:before {
  content: "\\ebaf";
}

.bx-pen:before {
  content: "\\ebb0";
}

.bx-pencil:before {
  content: "\\ebb1";
}

.bx-phone:before {
  content: "\\ebb2";
}

.bx-phone-call:before {
  content: "\\ebb3";
}

.bx-phone-incoming:before {
  content: "\\ebb4";
}

.bx-phone-off:before {
  content: "\\ebb5";
}

.bx-phone-outgoing:before {
  content: "\\ebb6";
}

.bx-photo-album:before {
  content: "\\ebb7";
}

.bx-pie-chart:before {
  content: "\\ebb8";
}

.bx-pie-chart-alt:before {
  content: "\\ebb9";
}

.bx-pie-chart-alt-2:before {
  content: "\\ebba";
}

.bx-pin:before {
  content: "\\ebbb";
}

.bx-planet:before {
  content: "\\ebbc";
}

.bx-play:before {
  content: "\\ebbd";
}

.bx-play-circle:before {
  content: "\\ebbe";
}

.bx-plug:before {
  content: "\\ebbf";
}

.bx-plus:before {
  content: "\\ebc0";
}

.bx-plus-circle:before {
  content: "\\ebc1";
}

.bx-plus-medical:before {
  content: "\\ebc2";
}

.bx-podcast:before {
  content: "\\ebc3";
}

.bx-pointer:before {
  content: "\\ebc4";
}

.bx-poll:before {
  content: "\\ebc5";
}

.bx-polygon:before {
  content: "\\ebc6";
}

.bx-pound:before {
  content: "\\ebc7";
}

.bx-power-off:before {
  content: "\\ebc8";
}

.bx-printer:before {
  content: "\\ebc9";
}

.bx-pulse:before {
  content: "\\ebca";
}

.bx-purchase-tag:before {
  content: "\\ebcb";
}

.bx-purchase-tag-alt:before {
  content: "\\ebcc";
}

.bx-pyramid:before {
  content: "\\ebcd";
}

.bx-qr:before {
  content: "\\ebce";
}

.bx-qr-scan:before {
  content: "\\ebcf";
}

.bx-question-mark:before {
  content: "\\ebd0";
}

.bx-radar:before {
  content: "\\ebd1";
}

.bx-radio:before {
  content: "\\ebd2";
}

.bx-radio-circle:before {
  content: "\\ebd3";
}

.bx-radio-circle-marked:before {
  content: "\\ebd4";
}

.bx-receipt:before {
  content: "\\ebd5";
}

.bx-rectangle:before {
  content: "\\ebd6";
}

.bx-recycle:before {
  content: "\\ebd7";
}

.bx-redo:before {
  content: "\\ebd8";
}

.bx-refresh:before {
  content: "\\ebd9";
}

.bx-registered:before {
  content: "\\ebda";
}

.bx-rename:before {
  content: "\\ebdb";
}

.bx-repeat:before {
  content: "\\ebdc";
}

.bx-reply:before {
  content: "\\ebdd";
}

.bx-reply-all:before {
  content: "\\ebde";
}

.bx-repost:before {
  content: "\\ebdf";
}

.bx-reset:before {
  content: "\\ebe0";
}

.bx-restaurant:before {
  content: "\\ebe1";
}

.bx-revision:before {
  content: "\\ebe2";
}

.bx-rewind:before {
  content: "\\ebe3";
}

.bx-rewind-circle:before {
  content: "\\ebe4";
}

.bx-right-arrow:before {
  content: "\\ebe5";
}

.bx-right-arrow-alt:before {
  content: "\\ebe6";
}

.bx-right-arrow-circle:before {
  content: "\\ebe7";
}

.bx-right-down-arrow-circle:before {
  content: "\\ebe8";
}

.bx-right-indent:before {
  content: "\\ebe9";
}

.bx-right-top-arrow-circle:before {
  content: "\\ebea";
}

.bx-rocket:before {
  content: "\\ebeb";
}

.bx-rotate-left:before {
  content: "\\ebec";
}

.bx-rotate-right:before {
  content: "\\ebed";
}

.bx-rss:before {
  content: "\\ebee";
}

.bx-ruble:before {
  content: "\\ebef";
}

.bx-ruler:before {
  content: "\\ebf0";
}

.bx-run:before {
  content: "\\ebf1";
}

.bx-rupee:before {
  content: "\\ebf2";
}

.bx-sad:before {
  content: "\\ebf3";
}

.bx-save:before {
  content: "\\ebf4";
}

.bx-scan:before {
  content: "\\ebf5";
}

.bx-screenshot:before {
  content: "\\ebf6";
}

.bx-search:before {
  content: "\\ebf7";
}

.bx-search-alt:before {
  content: "\\ebf8";
}

.bx-search-alt-2:before {
  content: "\\ebf9";
}

.bx-selection:before {
  content: "\\ebfa";
}

.bx-select-multiple:before {
  content: "\\ebfb";
}

.bx-send:before {
  content: "\\ebfc";
}

.bx-server:before {
  content: "\\ebfd";
}

.bx-shape-circle:before {
  content: "\\ebfe";
}

.bx-shape-polygon:before {
  content: "\\ebff";
}

.bx-shape-square:before {
  content: "\\ec00";
}

.bx-shape-triangle:before {
  content: "\\ec01";
}

.bx-share:before {
  content: "\\ec02";
}

.bx-share-alt:before {
  content: "\\ec03";
}

.bx-shekel:before {
  content: "\\ec04";
}

.bx-shield:before {
  content: "\\ec05";
}

.bx-shield-alt:before {
  content: "\\ec06";
}

.bx-shield-alt-2:before {
  content: "\\ec07";
}

.bx-shield-quarter:before {
  content: "\\ec08";
}

.bx-shield-x:before {
  content: "\\ec09";
}

.bx-shocked:before {
  content: "\\ec0a";
}

.bx-shopping-bag:before {
  content: "\\ec0b";
}

.bx-show:before {
  content: "\\ec0c";
}

.bx-show-alt:before {
  content: "\\ec0d";
}

.bx-shuffle:before {
  content: "\\ec0e";
}

.bx-sidebar:before {
  content: "\\ec0f";
}

.bx-sitemap:before {
  content: "\\ec10";
}

.bx-skip-next:before {
  content: "\\ec11";
}

.bx-skip-next-circle:before {
  content: "\\ec12";
}

.bx-skip-previous:before {
  content: "\\ec13";
}

.bx-skip-previous-circle:before {
  content: "\\ec14";
}

.bx-sleepy:before {
  content: "\\ec15";
}

.bx-slider:before {
  content: "\\ec16";
}

.bx-slider-alt:before {
  content: "\\ec17";
}

.bx-slideshow:before {
  content: "\\ec18";
}

.bx-smile:before {
  content: "\\ec19";
}

.bx-sort:before {
  content: "\\ec1a";
}

.bx-sort-alt-2:before {
  content: "\\ec1b";
}

.bx-sort-a-z:before {
  content: "\\ec1c";
}

.bx-sort-down:before {
  content: "\\ec1d";
}

.bx-sort-up:before {
  content: "\\ec1e";
}

.bx-sort-z-a:before {
  content: "\\ec1f";
}

.bx-spa:before {
  content: "\\ec20";
}

.bx-space-bar:before {
  content: "\\ec21";
}

.bx-speaker:before {
  content: "\\ec22";
}

.bx-spray-can:before {
  content: "\\ec23";
}

.bx-spreadsheet:before {
  content: "\\ec24";
}

.bx-square:before {
  content: "\\ec25";
}

.bx-square-rounded:before {
  content: "\\ec26";
}

.bx-star:before {
  content: "\\ec27";
}

.bx-station:before {
  content: "\\ec28";
}

.bx-stats:before {
  content: "\\ec29";
}

.bx-sticker:before {
  content: "\\ec2a";
}

.bx-stop:before {
  content: "\\ec2b";
}

.bx-stop-circle:before {
  content: "\\ec2c";
}

.bx-stopwatch:before {
  content: "\\ec2d";
}

.bx-store:before {
  content: "\\ec2e";
}

.bx-store-alt:before {
  content: "\\ec2f";
}

.bx-street-view:before {
  content: "\\ec30";
}

.bx-strikethrough:before {
  content: "\\ec31";
}

.bx-subdirectory-left:before {
  content: "\\ec32";
}

.bx-subdirectory-right:before {
  content: "\\ec33";
}

.bx-sun:before {
  content: "\\ec34";
}

.bx-support:before {
  content: "\\ec35";
}

.bx-swim:before {
  content: "\\ec36";
}

.bx-sync:before {
  content: "\\ec37";
}

.bx-tab:before {
  content: "\\ec38";
}

.bx-table:before {
  content: "\\ec39";
}

.bx-tachometer:before {
  content: "\\ec3a";
}

.bx-tag:before {
  content: "\\ec3b";
}

.bx-tag-alt:before {
  content: "\\ec3c";
}

.bx-target-lock:before {
  content: "\\ec3d";
}

.bx-task:before {
  content: "\\ec3e";
}

.bx-task-x:before {
  content: "\\ec3f";
}

.bx-taxi:before {
  content: "\\ec40";
}

.bx-tennis-ball:before {
  content: "\\ec41";
}

.bx-terminal:before {
  content: "\\ec42";
}

.bx-test-tube:before {
  content: "\\ec43";
}

.bx-text:before {
  content: "\\ec44";
}

.bx-time:before {
  content: "\\ec45";
}

.bx-time-five:before {
  content: "\\ec46";
}

.bx-timer:before {
  content: "\\ec47";
}

.bx-tired:before {
  content: "\\ec48";
}

.bx-toggle-left:before {
  content: "\\ec49";
}

.bx-toggle-right:before {
  content: "\\ec4a";
}

.bx-tone:before {
  content: "\\ec4b";
}

.bx-traffic-cone:before {
  content: "\\ec4c";
}

.bx-train:before {
  content: "\\ec4d";
}

.bx-transfer:before {
  content: "\\ec4e";
}

.bx-transfer-alt:before {
  content: "\\ec4f";
}

.bx-trash:before {
  content: "\\ec50";
}

.bx-trash-alt:before {
  content: "\\ec51";
}

.bx-trending-down:before {
  content: "\\ec52";
}

.bx-trending-up:before {
  content: "\\ec53";
}

.bx-trim:before {
  content: "\\ec54";
}

.bx-trip:before {
  content: "\\ec55";
}

.bx-trophy:before {
  content: "\\ec56";
}

.bx-tv:before {
  content: "\\ec57";
}

.bx-underline:before {
  content: "\\ec58";
}

.bx-undo:before {
  content: "\\ec59";
}

.bx-unite:before {
  content: "\\ec5a";
}

.bx-unlink:before {
  content: "\\ec5b";
}

.bx-up-arrow:before {
  content: "\\ec5c";
}

.bx-up-arrow-alt:before {
  content: "\\ec5d";
}

.bx-up-arrow-circle:before {
  content: "\\ec5e";
}

.bx-upload:before {
  content: "\\ec5f";
}

.bx-upside-down:before {
  content: "\\ec60";
}

.bx-upvote:before {
  content: "\\ec61";
}

.bx-usb:before {
  content: "\\ec62";
}

.bx-user:before {
  content: "\\ec63";
}

.bx-user-check:before {
  content: "\\ec64";
}

.bx-user-circle:before {
  content: "\\ec65";
}

.bx-user-minus:before {
  content: "\\ec66";
}

.bx-user-pin:before {
  content: "\\ec67";
}

.bx-user-plus:before {
  content: "\\ec68";
}

.bx-user-voice:before {
  content: "\\ec69";
}

.bx-user-x:before {
  content: "\\ec6a";
}

.bx-vector:before {
  content: "\\ec6b";
}

.bx-vertical-center:before {
  content: "\\ec6c";
}

.bx-vial:before {
  content: "\\ec6d";
}

.bx-video:before {
  content: "\\ec6e";
}

.bx-video-off:before {
  content: "\\ec6f";
}

.bx-video-plus:before {
  content: "\\ec70";
}

.bx-video-recording:before {
  content: "\\ec71";
}

.bx-voicemail:before {
  content: "\\ec72";
}

.bx-volume:before {
  content: "\\ec73";
}

.bx-volume-full:before {
  content: "\\ec74";
}

.bx-volume-low:before {
  content: "\\ec75";
}

.bx-volume-mute:before {
  content: "\\ec76";
}

.bx-walk:before {
  content: "\\ec77";
}

.bx-wallet:before {
  content: "\\ec78";
}

.bx-wallet-alt:before {
  content: "\\ec79";
}

.bx-water:before {
  content: "\\ec7a";
}

.bx-webcam:before {
  content: "\\ec7b";
}

.bx-wifi:before {
  content: "\\ec7c";
}

.bx-wifi-0:before {
  content: "\\ec7d";
}

.bx-wifi-1:before {
  content: "\\ec7e";
}

.bx-wifi-2:before {
  content: "\\ec7f";
}

.bx-wifi-off:before {
  content: "\\ec80";
}

.bx-wind:before {
  content: "\\ec81";
}

.bx-window:before {
  content: "\\ec82";
}

.bx-window-alt:before {
  content: "\\ec83";
}

.bx-window-close:before {
  content: "\\ec84";
}

.bx-window-open:before {
  content: "\\ec85";
}

.bx-windows:before {
  content: "\\ec86";
}

.bx-wine:before {
  content: "\\ec87";
}

.bx-wink-smile:before {
  content: "\\ec88";
}

.bx-wink-tongue:before {
  content: "\\ec89";
}

.bx-won:before {
  content: "\\ec8a";
}

.bx-world:before {
  content: "\\ec8b";
}

.bx-wrench:before {
  content: "\\ec8c";
}

.bx-x:before {
  content: "\\ec8d";
}

.bx-x-circle:before {
  content: "\\ec8e";
}

.bx-yen:before {
  content: "\\ec8f";
}

.bx-zoom-in:before {
  content: "\\ec90";
}

.bx-zoom-out:before {
  content: "\\ec91";
}

.bxs-party:before {
  content: "\\ec92";
}

.bxs-hot:before {
  content: "\\ec93";
}

.bxs-droplet:before {
  content: "\\ec94";
}

.bxs-cat:before {
  content: "\\ec95";
}

.bxs-dog:before {
  content: "\\ec96";
}

.bxs-injection:before {
  content: "\\ec97";
}

.bxs-leaf:before {
  content: "\\ec98";
}

.bxs-add-to-queue:before {
  content: "\\ec99";
}

.bxs-adjust:before {
  content: "\\ec9a";
}

.bxs-adjust-alt:before {
  content: "\\ec9b";
}

.bxs-alarm:before {
  content: "\\ec9c";
}

.bxs-alarm-add:before {
  content: "\\ec9d";
}

.bxs-alarm-exclamation:before {
  content: "\\ec9e";
}

.bxs-alarm-off:before {
  content: "\\ec9f";
}

.bxs-alarm-snooze:before {
  content: "\\eca0";
}

.bxs-album:before {
  content: "\\eca1";
}

.bxs-ambulance:before {
  content: "\\eca2";
}

.bxs-analyse:before {
  content: "\\eca3";
}

.bxs-angry:before {
  content: "\\eca4";
}

.bxs-arch:before {
  content: "\\eca5";
}

.bxs-archive:before {
  content: "\\eca6";
}

.bxs-archive-in:before {
  content: "\\eca7";
}

.bxs-archive-out:before {
  content: "\\eca8";
}

.bxs-area:before {
  content: "\\eca9";
}

.bxs-arrow-from-bottom:before {
  content: "\\ecaa";
}

.bxs-arrow-from-left:before {
  content: "\\ecab";
}

.bxs-arrow-from-right:before {
  content: "\\ecac";
}

.bxs-arrow-from-top:before {
  content: "\\ecad";
}

.bxs-arrow-to-bottom:before {
  content: "\\ecae";
}

.bxs-arrow-to-left:before {
  content: "\\ecaf";
}

.bxs-arrow-to-right:before {
  content: "\\ecb0";
}

.bxs-arrow-to-top:before {
  content: "\\ecb1";
}

.bxs-award:before {
  content: "\\ecb2";
}

.bxs-baby-carriage:before {
  content: "\\ecb3";
}

.bxs-backpack:before {
  content: "\\ecb4";
}

.bxs-badge:before {
  content: "\\ecb5";
}

.bxs-badge-check:before {
  content: "\\ecb6";
}

.bxs-badge-dollar:before {
  content: "\\ecb7";
}

.bxs-ball:before {
  content: "\\ecb8";
}

.bxs-band-aid:before {
  content: "\\ecb9";
}

.bxs-bank:before {
  content: "\\ecba";
}

.bxs-bar-chart-alt-2:before {
  content: "\\ecbb";
}

.bxs-bar-chart-square:before {
  content: "\\ecbc";
}

.bxs-barcode:before {
  content: "\\ecbd";
}

.bxs-baseball:before {
  content: "\\ecbe";
}

.bxs-basket:before {
  content: "\\ecbf";
}

.bxs-basketball:before {
  content: "\\ecc0";
}

.bxs-bath:before {
  content: "\\ecc1";
}

.bxs-battery:before {
  content: "\\ecc2";
}

.bxs-battery-charging:before {
  content: "\\ecc3";
}

.bxs-battery-full:before {
  content: "\\ecc4";
}

.bxs-battery-low:before {
  content: "\\ecc5";
}

.bxs-bed:before {
  content: "\\ecc6";
}

.bxs-been-here:before {
  content: "\\ecc7";
}

.bxs-beer:before {
  content: "\\ecc8";
}

.bxs-bell:before {
  content: "\\ecc9";
}

.bxs-bell-minus:before {
  content: "\\ecca";
}

.bxs-bell-off:before {
  content: "\\eccb";
}

.bxs-bell-plus:before {
  content: "\\eccc";
}

.bxs-bell-ring:before {
  content: "\\eccd";
}

.bxs-bible:before {
  content: "\\ecce";
}

.bxs-binoculars:before {
  content: "\\eccf";
}

.bxs-blanket:before {
  content: "\\ecd0";
}

.bxs-bolt:before {
  content: "\\ecd1";
}

.bxs-bolt-circle:before {
  content: "\\ecd2";
}

.bxs-bomb:before {
  content: "\\ecd3";
}

.bxs-bone:before {
  content: "\\ecd4";
}

.bxs-bong:before {
  content: "\\ecd5";
}

.bxs-book:before {
  content: "\\ecd6";
}

.bxs-book-add:before {
  content: "\\ecd7";
}

.bxs-book-alt:before {
  content: "\\ecd8";
}

.bxs-book-bookmark:before {
  content: "\\ecd9";
}

.bxs-book-content:before {
  content: "\\ecda";
}

.bxs-book-heart:before {
  content: "\\ecdb";
}

.bxs-bookmark:before {
  content: "\\ecdc";
}

.bxs-bookmark-alt:before {
  content: "\\ecdd";
}

.bxs-bookmark-alt-minus:before {
  content: "\\ecde";
}

.bxs-bookmark-alt-plus:before {
  content: "\\ecdf";
}

.bxs-bookmark-heart:before {
  content: "\\ece0";
}

.bxs-bookmark-minus:before {
  content: "\\ece1";
}

.bxs-bookmark-plus:before {
  content: "\\ece2";
}

.bxs-bookmarks:before {
  content: "\\ece3";
}

.bxs-bookmark-star:before {
  content: "\\ece4";
}

.bxs-book-open:before {
  content: "\\ece5";
}

.bxs-book-reader:before {
  content: "\\ece6";
}

.bxs-bot:before {
  content: "\\ece7";
}

.bxs-bowling-ball:before {
  content: "\\ece8";
}

.bxs-box:before {
  content: "\\ece9";
}

.bxs-brain:before {
  content: "\\ecea";
}

.bxs-briefcase:before {
  content: "\\eceb";
}

.bxs-briefcase-alt:before {
  content: "\\ecec";
}

.bxs-briefcase-alt-2:before {
  content: "\\eced";
}

.bxs-brightness:before {
  content: "\\ecee";
}

.bxs-brightness-half:before {
  content: "\\ecef";
}

.bxs-brush:before {
  content: "\\ecf0";
}

.bxs-brush-alt:before {
  content: "\\ecf1";
}

.bxs-bug:before {
  content: "\\ecf2";
}

.bxs-bug-alt:before {
  content: "\\ecf3";
}

.bxs-building:before {
  content: "\\ecf4";
}

.bxs-building-house:before {
  content: "\\ecf5";
}

.bxs-buildings:before {
  content: "\\ecf6";
}

.bxs-bulb:before {
  content: "\\ecf7";
}

.bxs-bullseye:before {
  content: "\\ecf8";
}

.bxs-buoy:before {
  content: "\\ecf9";
}

.bxs-bus:before {
  content: "\\ecfa";
}

.bxs-business:before {
  content: "\\ecfb";
}

.bxs-bus-school:before {
  content: "\\ecfc";
}

.bxs-cabinet:before {
  content: "\\ecfd";
}

.bxs-cake:before {
  content: "\\ecfe";
}

.bxs-calculator:before {
  content: "\\ecff";
}

.bxs-calendar:before {
  content: "\\ed00";
}

.bxs-calendar-alt:before {
  content: "\\ed01";
}

.bxs-calendar-check:before {
  content: "\\ed02";
}

.bxs-calendar-edit:before {
  content: "\\ed03";
}

.bxs-calendar-event:before {
  content: "\\ed04";
}

.bxs-calendar-exclamation:before {
  content: "\\ed05";
}

.bxs-calendar-heart:before {
  content: "\\ed06";
}

.bxs-calendar-minus:before {
  content: "\\ed07";
}

.bxs-calendar-plus:before {
  content: "\\ed08";
}

.bxs-calendar-star:before {
  content: "\\ed09";
}

.bxs-calendar-week:before {
  content: "\\ed0a";
}

.bxs-calendar-x:before {
  content: "\\ed0b";
}

.bxs-camera:before {
  content: "\\ed0c";
}

.bxs-camera-home:before {
  content: "\\ed0d";
}

.bxs-camera-movie:before {
  content: "\\ed0e";
}

.bxs-camera-off:before {
  content: "\\ed0f";
}

.bxs-camera-plus:before {
  content: "\\ed10";
}

.bxs-capsule:before {
  content: "\\ed11";
}

.bxs-captions:before {
  content: "\\ed12";
}

.bxs-car:before {
  content: "\\ed13";
}

.bxs-car-battery:before {
  content: "\\ed14";
}

.bxs-car-crash:before {
  content: "\\ed15";
}

.bxs-card:before {
  content: "\\ed16";
}

.bxs-caret-down-circle:before {
  content: "\\ed17";
}

.bxs-caret-down-square:before {
  content: "\\ed18";
}

.bxs-caret-left-circle:before {
  content: "\\ed19";
}

.bxs-caret-left-square:before {
  content: "\\ed1a";
}

.bxs-caret-right-circle:before {
  content: "\\ed1b";
}

.bxs-caret-right-square:before {
  content: "\\ed1c";
}

.bxs-caret-up-circle:before {
  content: "\\ed1d";
}

.bxs-caret-up-square:before {
  content: "\\ed1e";
}

.bxs-car-garage:before {
  content: "\\ed1f";
}

.bxs-car-mechanic:before {
  content: "\\ed20";
}

.bxs-carousel:before {
  content: "\\ed21";
}

.bxs-cart:before {
  content: "\\ed22";
}

.bxs-cart-add:before {
  content: "\\ed23";
}

.bxs-cart-alt:before {
  content: "\\ed24";
}

.bxs-cart-download:before {
  content: "\\ed25";
}

.bxs-car-wash:before {
  content: "\\ed26";
}

.bxs-category:before {
  content: "\\ed27";
}

.bxs-category-alt:before {
  content: "\\ed28";
}

.bxs-cctv:before {
  content: "\\ed29";
}

.bxs-certification:before {
  content: "\\ed2a";
}

.bxs-chalkboard:before {
  content: "\\ed2b";
}

.bxs-chart:before {
  content: "\\ed2c";
}

.bxs-chat:before {
  content: "\\ed2d";
}

.bxs-checkbox:before {
  content: "\\ed2e";
}

.bxs-checkbox-checked:before {
  content: "\\ed2f";
}

.bxs-checkbox-minus:before {
  content: "\\ed30";
}

.bxs-check-circle:before {
  content: "\\ed31";
}

.bxs-check-shield:before {
  content: "\\ed32";
}

.bxs-check-square:before {
  content: "\\ed33";
}

.bxs-chess:before {
  content: "\\ed34";
}

.bxs-chevron-down:before {
  content: "\\ed35";
}

.bxs-chevron-down-circle:before {
  content: "\\ed36";
}

.bxs-chevron-down-square:before {
  content: "\\ed37";
}

.bxs-chevron-left:before {
  content: "\\ed38";
}

.bxs-chevron-left-circle:before {
  content: "\\ed39";
}

.bxs-chevron-left-square:before {
  content: "\\ed3a";
}

.bxs-chevron-right:before {
  content: "\\ed3b";
}

.bxs-chevron-right-circle:before {
  content: "\\ed3c";
}

.bxs-chevron-right-square:before {
  content: "\\ed3d";
}

.bxs-chevrons-down:before {
  content: "\\ed3e";
}

.bxs-chevrons-left:before {
  content: "\\ed3f";
}

.bxs-chevrons-right:before {
  content: "\\ed40";
}

.bxs-chevrons-up:before {
  content: "\\ed41";
}

.bxs-chevron-up:before {
  content: "\\ed42";
}

.bxs-chevron-up-circle:before {
  content: "\\ed43";
}

.bxs-chevron-up-square:before {
  content: "\\ed44";
}

.bxs-chip:before {
  content: "\\ed45";
}

.bxs-church:before {
  content: "\\ed46";
}

.bxs-circle:before {
  content: "\\ed47";
}

.bxs-city:before {
  content: "\\ed48";
}

.bxs-clinic:before {
  content: "\\ed49";
}

.bxs-cloud:before {
  content: "\\ed4a";
}

.bxs-cloud-download:before {
  content: "\\ed4b";
}

.bxs-cloud-lightning:before {
  content: "\\ed4c";
}

.bxs-cloud-rain:before {
  content: "\\ed4d";
}

.bxs-cloud-upload:before {
  content: "\\ed4e";
}

.bxs-coffee:before {
  content: "\\ed4f";
}

.bxs-coffee-alt:before {
  content: "\\ed50";
}

.bxs-coffee-togo:before {
  content: "\\ed51";
}

.bxs-cog:before {
  content: "\\ed52";
}

.bxs-coin:before {
  content: "\\ed53";
}

.bxs-coin-stack:before {
  content: "\\ed54";
}

.bxs-collection:before {
  content: "\\ed55";
}

.bxs-color-fill:before {
  content: "\\ed56";
}

.bxs-comment:before {
  content: "\\ed57";
}

.bxs-comment-add:before {
  content: "\\ed58";
}

.bxs-comment-check:before {
  content: "\\ed59";
}

.bxs-comment-detail:before {
  content: "\\ed5a";
}

.bxs-comment-dots:before {
  content: "\\ed5b";
}

.bxs-comment-edit:before {
  content: "\\ed5c";
}

.bxs-comment-error:before {
  content: "\\ed5d";
}

.bxs-comment-minus:before {
  content: "\\ed5e";
}

.bxs-comment-x:before {
  content: "\\ed5f";
}

.bxs-compass:before {
  content: "\\ed60";
}

.bxs-component:before {
  content: "\\ed61";
}

.bxs-confused:before {
  content: "\\ed62";
}

.bxs-contact:before {
  content: "\\ed63";
}

.bxs-conversation:before {
  content: "\\ed64";
}

.bxs-cookie:before {
  content: "\\ed65";
}

.bxs-cool:before {
  content: "\\ed66";
}

.bxs-copy:before {
  content: "\\ed67";
}

.bxs-copy-alt:before {
  content: "\\ed68";
}

.bxs-copyright:before {
  content: "\\ed69";
}

.bxs-coupon:before {
  content: "\\ed6a";
}

.bxs-credit-card:before {
  content: "\\ed6b";
}

.bxs-credit-card-alt:before {
  content: "\\ed6c";
}

.bxs-credit-card-front:before {
  content: "\\ed6d";
}

.bxs-crop:before {
  content: "\\ed6e";
}

.bxs-crown:before {
  content: "\\ed6f";
}

.bxs-cube:before {
  content: "\\ed70";
}

.bxs-cube-alt:before {
  content: "\\ed71";
}

.bxs-cuboid:before {
  content: "\\ed72";
}

.bxs-customize:before {
  content: "\\ed73";
}

.bxs-cylinder:before {
  content: "\\ed74";
}

.bxs-dashboard:before {
  content: "\\ed75";
}

.bxs-data:before {
  content: "\\ed76";
}

.bxs-detail:before {
  content: "\\ed77";
}

.bxs-devices:before {
  content: "\\ed78";
}

.bxs-diamond:before {
  content: "\\ed79";
}

.bxs-dice-1:before {
  content: "\\ed7a";
}

.bxs-dice-2:before {
  content: "\\ed7b";
}

.bxs-dice-3:before {
  content: "\\ed7c";
}

.bxs-dice-4:before {
  content: "\\ed7d";
}

.bxs-dice-5:before {
  content: "\\ed7e";
}

.bxs-dice-6:before {
  content: "\\ed7f";
}

.bxs-direction-left:before {
  content: "\\ed80";
}

.bxs-direction-right:before {
  content: "\\ed81";
}

.bxs-directions:before {
  content: "\\ed82";
}

.bxs-disc:before {
  content: "\\ed83";
}

.bxs-discount:before {
  content: "\\ed84";
}

.bxs-dish:before {
  content: "\\ed85";
}

.bxs-dislike:before {
  content: "\\ed86";
}

.bxs-dizzy:before {
  content: "\\ed87";
}

.bxs-dock-bottom:before {
  content: "\\ed88";
}

.bxs-dock-left:before {
  content: "\\ed89";
}

.bxs-dock-right:before {
  content: "\\ed8a";
}

.bxs-dock-top:before {
  content: "\\ed8b";
}

.bxs-dollar-circle:before {
  content: "\\ed8c";
}

.bxs-donate-blood:before {
  content: "\\ed8d";
}

.bxs-donate-heart:before {
  content: "\\ed8e";
}

.bxs-door-open:before {
  content: "\\ed8f";
}

.bxs-doughnut-chart:before {
  content: "\\ed90";
}

.bxs-down-arrow:before {
  content: "\\ed91";
}

.bxs-down-arrow-alt:before {
  content: "\\ed92";
}

.bxs-down-arrow-circle:before {
  content: "\\ed93";
}

.bxs-down-arrow-square:before {
  content: "\\ed94";
}

.bxs-download:before {
  content: "\\ed95";
}

.bxs-downvote:before {
  content: "\\ed96";
}

.bxs-drink:before {
  content: "\\ed97";
}

.bxs-droplet-half:before {
  content: "\\ed98";
}

.bxs-dryer:before {
  content: "\\ed99";
}

.bxs-duplicate:before {
  content: "\\ed9a";
}

.bxs-edit:before {
  content: "\\ed9b";
}

.bxs-edit-alt:before {
  content: "\\ed9c";
}

.bxs-edit-location:before {
  content: "\\ed9d";
}

.bxs-eject:before {
  content: "\\ed9e";
}

.bxs-envelope:before {
  content: "\\ed9f";
}

.bxs-envelope-open:before {
  content: "\\eda0";
}

.bxs-eraser:before {
  content: "\\eda1";
}

.bxs-error:before {
  content: "\\eda2";
}

.bxs-error-alt:before {
  content: "\\eda3";
}

.bxs-error-circle:before {
  content: "\\eda4";
}

.bxs-ev-station:before {
  content: "\\eda5";
}

.bxs-exit:before {
  content: "\\eda6";
}

.bxs-extension:before {
  content: "\\eda7";
}

.bxs-eyedropper:before {
  content: "\\eda8";
}

.bxs-face:before {
  content: "\\eda9";
}

.bxs-face-mask:before {
  content: "\\edaa";
}

.bxs-factory:before {
  content: "\\edab";
}

.bxs-fast-forward-circle:before {
  content: "\\edac";
}

.bxs-file:before {
  content: "\\edad";
}

.bxs-file-archive:before {
  content: "\\edae";
}

.bxs-file-blank:before {
  content: "\\edaf";
}

.bxs-file-css:before {
  content: "\\edb0";
}

.bxs-file-doc:before {
  content: "\\edb1";
}

.bxs-file-export:before {
  content: "\\edb2";
}

.bxs-file-find:before {
  content: "\\edb3";
}

.bxs-file-gif:before {
  content: "\\edb4";
}

.bxs-file-html:before {
  content: "\\edb5";
}

.bxs-file-image:before {
  content: "\\edb6";
}

.bxs-file-import:before {
  content: "\\edb7";
}

.bxs-file-jpg:before {
  content: "\\edb8";
}

.bxs-file-js:before {
  content: "\\edb9";
}

.bxs-file-json:before {
  content: "\\edba";
}

.bxs-file-md:before {
  content: "\\edbb";
}

.bxs-file-pdf:before {
  content: "\\edbc";
}

.bxs-file-plus:before {
  content: "\\edbd";
}

.bxs-file-png:before {
  content: "\\edbe";
}

.bxs-file-txt:before {
  content: "\\edbf";
}

.bxs-film:before {
  content: "\\edc0";
}

.bxs-filter-alt:before {
  content: "\\edc1";
}

.bxs-first-aid:before {
  content: "\\edc2";
}

.bxs-flag:before {
  content: "\\edc3";
}

.bxs-flag-alt:before {
  content: "\\edc4";
}

.bxs-flag-checkered:before {
  content: "\\edc5";
}

.bxs-flame:before {
  content: "\\edc6";
}

.bxs-flask:before {
  content: "\\edc7";
}

.bxs-florist:before {
  content: "\\edc8";
}

.bxs-folder:before {
  content: "\\edc9";
}

.bxs-folder-minus:before {
  content: "\\edca";
}

.bxs-folder-open:before {
  content: "\\edcb";
}

.bxs-folder-plus:before {
  content: "\\edcc";
}

.bxs-food-menu:before {
  content: "\\edcd";
}

.bxs-fridge:before {
  content: "\\edce";
}

.bxs-game:before {
  content: "\\edcf";
}

.bxs-gas-pump:before {
  content: "\\edd0";
}

.bxs-ghost:before {
  content: "\\edd1";
}

.bxs-gift:before {
  content: "\\edd2";
}

.bxs-graduation:before {
  content: "\\edd3";
}

.bxs-grid:before {
  content: "\\edd4";
}

.bxs-grid-alt:before {
  content: "\\edd5";
}

.bxs-group:before {
  content: "\\edd6";
}

.bxs-guitar-amp:before {
  content: "\\edd7";
}

.bxs-hand:before {
  content: "\\edd8";
}

.bxs-hand-down:before {
  content: "\\edd9";
}

.bxs-hand-left:before {
  content: "\\edda";
}

.bxs-hand-right:before {
  content: "\\eddb";
}

.bxs-hand-up:before {
  content: "\\eddc";
}

.bxs-happy:before {
  content: "\\eddd";
}

.bxs-happy-alt:before {
  content: "\\edde";
}

.bxs-happy-beaming:before {
  content: "\\eddf";
}

.bxs-happy-heart-eyes:before {
  content: "\\ede0";
}

.bxs-hdd:before {
  content: "\\ede1";
}

.bxs-heart:before {
  content: "\\ede2";
}

.bxs-heart-circle:before {
  content: "\\ede3";
}

.bxs-heart-square:before {
  content: "\\ede4";
}

.bxs-help-circle:before {
  content: "\\ede5";
}

.bxs-hide:before {
  content: "\\ede6";
}

.bxs-home:before {
  content: "\\ede7";
}

.bxs-home-circle:before {
  content: "\\ede8";
}

.bxs-home-heart:before {
  content: "\\ede9";
}

.bxs-home-smile:before {
  content: "\\edea";
}

.bxs-hotel:before {
  content: "\\edeb";
}

.bxs-hourglass:before {
  content: "\\edec";
}

.bxs-hourglass-bottom:before {
  content: "\\eded";
}

.bxs-hourglass-top:before {
  content: "\\edee";
}

.bxs-id-card:before {
  content: "\\edef";
}

.bxs-image:before {
  content: "\\edf0";
}

.bxs-image-add:before {
  content: "\\edf1";
}

.bxs-image-alt:before {
  content: "\\edf2";
}

.bxs-inbox:before {
  content: "\\edf3";
}

.bxs-info-circle:before {
  content: "\\edf4";
}

.bxs-info-square:before {
  content: "\\edf5";
}

.bxs-institution:before {
  content: "\\edf6";
}

.bxs-joystick:before {
  content: "\\edf7";
}

.bxs-joystick-alt:before {
  content: "\\edf8";
}

.bxs-joystick-button:before {
  content: "\\edf9";
}

.bxs-key:before {
  content: "\\edfa";
}

.bxs-keyboard:before {
  content: "\\edfb";
}

.bxs-label:before {
  content: "\\edfc";
}

.bxs-landmark:before {
  content: "\\edfd";
}

.bxs-landscape:before {
  content: "\\edfe";
}

.bxs-laugh:before {
  content: "\\edff";
}

.bxs-layer:before {
  content: "\\ee00";
}

.bxs-layer-minus:before {
  content: "\\ee01";
}

.bxs-layer-plus:before {
  content: "\\ee02";
}

.bxs-layout:before {
  content: "\\ee03";
}

.bxs-left-arrow:before {
  content: "\\ee04";
}

.bxs-left-arrow-alt:before {
  content: "\\ee05";
}

.bxs-left-arrow-circle:before {
  content: "\\ee06";
}

.bxs-left-arrow-square:before {
  content: "\\ee07";
}

.bxs-left-down-arrow-circle:before {
  content: "\\ee08";
}

.bxs-left-top-arrow-circle:before {
  content: "\\ee09";
}

.bxs-like:before {
  content: "\\ee0a";
}

.bxs-location-plus:before {
  content: "\\ee0b";
}

.bxs-lock:before {
  content: "\\ee0c";
}

.bxs-lock-alt:before {
  content: "\\ee0d";
}

.bxs-lock-open:before {
  content: "\\ee0e";
}

.bxs-lock-open-alt:before {
  content: "\\ee0f";
}

.bxs-log-in:before {
  content: "\\ee10";
}

.bxs-log-in-circle:before {
  content: "\\ee11";
}

.bxs-log-out:before {
  content: "\\ee12";
}

.bxs-log-out-circle:before {
  content: "\\ee13";
}

.bxs-low-vision:before {
  content: "\\ee14";
}

.bxs-magic-wand:before {
  content: "\\ee15";
}

.bxs-magnet:before {
  content: "\\ee16";
}

.bxs-map:before {
  content: "\\ee17";
}

.bxs-map-alt:before {
  content: "\\ee18";
}

.bxs-map-pin:before {
  content: "\\ee19";
}

.bxs-mask:before {
  content: "\\ee1a";
}

.bxs-medal:before {
  content: "\\ee1b";
}

.bxs-megaphone:before {
  content: "\\ee1c";
}

.bxs-meh:before {
  content: "\\ee1d";
}

.bxs-meh-alt:before {
  content: "\\ee1e";
}

.bxs-meh-blank:before {
  content: "\\ee1f";
}

.bxs-memory-card:before {
  content: "\\ee20";
}

.bxs-message:before {
  content: "\\ee21";
}

.bxs-message-add:before {
  content: "\\ee22";
}

.bxs-message-alt:before {
  content: "\\ee23";
}

.bxs-message-alt-add:before {
  content: "\\ee24";
}

.bxs-message-alt-check:before {
  content: "\\ee25";
}

.bxs-message-alt-detail:before {
  content: "\\ee26";
}

.bxs-message-alt-dots:before {
  content: "\\ee27";
}

.bxs-message-alt-edit:before {
  content: "\\ee28";
}

.bxs-message-alt-error:before {
  content: "\\ee29";
}

.bxs-message-alt-minus:before {
  content: "\\ee2a";
}

.bxs-message-alt-x:before {
  content: "\\ee2b";
}

.bxs-message-check:before {
  content: "\\ee2c";
}

.bxs-message-detail:before {
  content: "\\ee2d";
}

.bxs-message-dots:before {
  content: "\\ee2e";
}

.bxs-message-edit:before {
  content: "\\ee2f";
}

.bxs-message-error:before {
  content: "\\ee30";
}

.bxs-message-minus:before {
  content: "\\ee31";
}

.bxs-message-rounded:before {
  content: "\\ee32";
}

.bxs-message-rounded-add:before {
  content: "\\ee33";
}

.bxs-message-rounded-check:before {
  content: "\\ee34";
}

.bxs-message-rounded-detail:before {
  content: "\\ee35";
}

.bxs-message-rounded-dots:before {
  content: "\\ee36";
}

.bxs-message-rounded-edit:before {
  content: "\\ee37";
}

.bxs-message-rounded-error:before {
  content: "\\ee38";
}

.bxs-message-rounded-minus:before {
  content: "\\ee39";
}

.bxs-message-rounded-x:before {
  content: "\\ee3a";
}

.bxs-message-square:before {
  content: "\\ee3b";
}

.bxs-message-square-add:before {
  content: "\\ee3c";
}

.bxs-message-square-check:before {
  content: "\\ee3d";
}

.bxs-message-square-detail:before {
  content: "\\ee3e";
}

.bxs-message-square-dots:before {
  content: "\\ee3f";
}

.bxs-message-square-edit:before {
  content: "\\ee40";
}

.bxs-message-square-error:before {
  content: "\\ee41";
}

.bxs-message-square-minus:before {
  content: "\\ee42";
}

.bxs-message-square-x:before {
  content: "\\ee43";
}

.bxs-message-x:before {
  content: "\\ee44";
}

.bxs-meteor:before {
  content: "\\ee45";
}

.bxs-microchip:before {
  content: "\\ee46";
}

.bxs-microphone:before {
  content: "\\ee47";
}

.bxs-microphone-alt:before {
  content: "\\ee48";
}

.bxs-microphone-off:before {
  content: "\\ee49";
}

.bxs-minus-circle:before {
  content: "\\ee4a";
}

.bxs-minus-square:before {
  content: "\\ee4b";
}

.bxs-mobile:before {
  content: "\\ee4c";
}

.bxs-mobile-vibration:before {
  content: "\\ee4d";
}

.bxs-moon:before {
  content: "\\ee4e";
}

.bxs-mouse:before {
  content: "\\ee4f";
}

.bxs-mouse-alt:before {
  content: "\\ee50";
}

.bxs-movie:before {
  content: "\\ee51";
}

.bxs-movie-play:before {
  content: "\\ee52";
}

.bxs-music:before {
  content: "\\ee53";
}

.bxs-navigation:before {
  content: "\\ee54";
}

.bxs-network-chart:before {
  content: "\\ee55";
}

.bxs-news:before {
  content: "\\ee56";
}

.bxs-no-entry:before {
  content: "\\ee57";
}

.bxs-note:before {
  content: "\\ee58";
}

.bxs-notepad:before {
  content: "\\ee59";
}

.bxs-notification:before {
  content: "\\ee5a";
}

.bxs-notification-off:before {
  content: "\\ee5b";
}

.bxs-offer:before {
  content: "\\ee5c";
}

.bxs-package:before {
  content: "\\ee5d";
}

.bxs-paint:before {
  content: "\\ee5e";
}

.bxs-paint-roll:before {
  content: "\\ee5f";
}

.bxs-palette:before {
  content: "\\ee60";
}

.bxs-paper-plane:before {
  content: "\\ee61";
}

.bxs-parking:before {
  content: "\\ee62";
}

.bxs-paste:before {
  content: "\\ee63";
}

.bxs-pen:before {
  content: "\\ee64";
}

.bxs-pencil:before {
  content: "\\ee65";
}

.bxs-phone:before {
  content: "\\ee66";
}

.bxs-phone-call:before {
  content: "\\ee67";
}

.bxs-phone-incoming:before {
  content: "\\ee68";
}

.bxs-phone-off:before {
  content: "\\ee69";
}

.bxs-phone-outgoing:before {
  content: "\\ee6a";
}

.bxs-photo-album:before {
  content: "\\ee6b";
}

.bxs-piano:before {
  content: "\\ee6c";
}

.bxs-pie-chart:before {
  content: "\\ee6d";
}

.bxs-pie-chart-alt:before {
  content: "\\ee6e";
}

.bxs-pie-chart-alt-2:before {
  content: "\\ee6f";
}

.bxs-pin:before {
  content: "\\ee70";
}

.bxs-pizza:before {
  content: "\\ee71";
}

.bxs-plane:before {
  content: "\\ee72";
}

.bxs-plane-alt:before {
  content: "\\ee73";
}

.bxs-plane-land:before {
  content: "\\ee74";
}

.bxs-planet:before {
  content: "\\ee75";
}

.bxs-plane-take-off:before {
  content: "\\ee76";
}

.bxs-playlist:before {
  content: "\\ee77";
}

.bxs-plug:before {
  content: "\\ee78";
}

.bxs-plus-circle:before {
  content: "\\ee79";
}

.bxs-plus-square:before {
  content: "\\ee7a";
}

.bxs-pointer:before {
  content: "\\ee7b";
}

.bxs-polygon:before {
  content: "\\ee7c";
}

.bxs-printer:before {
  content: "\\ee7d";
}

.bxs-purchase-tag:before {
  content: "\\ee7e";
}

.bxs-purchase-tag-alt:before {
  content: "\\ee7f";
}

.bxs-pyramid:before {
  content: "\\ee80";
}

.bxs-quote-alt-left:before {
  content: "\\ee81";
}

.bxs-quote-alt-right:before {
  content: "\\ee82";
}

.bxs-quote-left:before {
  content: "\\ee83";
}

.bxs-quote-right:before {
  content: "\\ee84";
}

.bxs-quote-single-left:before {
  content: "\\ee85";
}

.bxs-quote-single-right:before {
  content: "\\ee86";
}

.bxs-radiation:before {
  content: "\\ee87";
}

.bxs-radio:before {
  content: "\\ee88";
}

.bxs-receipt:before {
  content: "\\ee89";
}

.bxs-rectangle:before {
  content: "\\ee8a";
}

.bxs-registered:before {
  content: "\\ee8b";
}

.bxs-rename:before {
  content: "\\ee8c";
}

.bxs-report:before {
  content: "\\ee8d";
}

.bxs-rewind-circle:before {
  content: "\\ee8e";
}

.bxs-right-arrow:before {
  content: "\\ee8f";
}

.bxs-right-arrow-alt:before {
  content: "\\ee90";
}

.bxs-right-arrow-circle:before {
  content: "\\ee91";
}

.bxs-right-arrow-square:before {
  content: "\\ee92";
}

.bxs-right-down-arrow-circle:before {
  content: "\\ee93";
}

.bxs-right-top-arrow-circle:before {
  content: "\\ee94";
}

.bxs-rocket:before {
  content: "\\ee95";
}

.bxs-ruler:before {
  content: "\\ee96";
}

.bxs-sad:before {
  content: "\\ee97";
}

.bxs-save:before {
  content: "\\ee98";
}

.bxs-school:before {
  content: "\\ee99";
}

.bxs-search:before {
  content: "\\ee9a";
}

.bxs-search-alt-2:before {
  content: "\\ee9b";
}

.bxs-select-multiple:before {
  content: "\\ee9c";
}

.bxs-send:before {
  content: "\\ee9d";
}

.bxs-server:before {
  content: "\\ee9e";
}

.bxs-shapes:before {
  content: "\\ee9f";
}

.bxs-share:before {
  content: "\\eea0";
}

.bxs-share-alt:before {
  content: "\\eea1";
}

.bxs-shield:before {
  content: "\\eea2";
}

.bxs-shield-alt-2:before {
  content: "\\eea3";
}

.bxs-shield-x:before {
  content: "\\eea4";
}

.bxs-ship:before {
  content: "\\eea5";
}

.bxs-shocked:before {
  content: "\\eea6";
}

.bxs-shopping-bag:before {
  content: "\\eea7";
}

.bxs-shopping-bag-alt:before {
  content: "\\eea8";
}

.bxs-shopping-bags:before {
  content: "\\eea9";
}

.bxs-show:before {
  content: "\\eeaa";
}

.bxs-skip-next-circle:before {
  content: "\\eeab";
}

.bxs-skip-previous-circle:before {
  content: "\\eeac";
}

.bxs-skull:before {
  content: "\\eead";
}

.bxs-sleepy:before {
  content: "\\eeae";
}

.bxs-slideshow:before {
  content: "\\eeaf";
}

.bxs-smile:before {
  content: "\\eeb0";
}

.bxs-sort-alt:before {
  content: "\\eeb1";
}

.bxs-spa:before {
  content: "\\eeb2";
}

.bxs-speaker:before {
  content: "\\eeb3";
}

.bxs-spray-can:before {
  content: "\\eeb4";
}

.bxs-spreadsheet:before {
  content: "\\eeb5";
}

.bxs-square:before {
  content: "\\eeb6";
}

.bxs-square-rounded:before {
  content: "\\eeb7";
}

.bxs-star:before {
  content: "\\eeb8";
}

.bxs-star-half:before {
  content: "\\eeb9";
}

.bxs-sticker:before {
  content: "\\eeba";
}

.bxs-stopwatch:before {
  content: "\\eebb";
}

.bxs-store:before {
  content: "\\eebc";
}

.bxs-store-alt:before {
  content: "\\eebd";
}

.bxs-sun:before {
  content: "\\eebe";
}

.bxs-tachometer:before {
  content: "\\eebf";
}

.bxs-tag:before {
  content: "\\eec0";
}

.bxs-tag-alt:before {
  content: "\\eec1";
}

.bxs-tag-x:before {
  content: "\\eec2";
}

.bxs-taxi:before {
  content: "\\eec3";
}

.bxs-tennis-ball:before {
  content: "\\eec4";
}

.bxs-terminal:before {
  content: "\\eec5";
}

.bxs-thermometer:before {
  content: "\\eec6";
}

.bxs-time:before {
  content: "\\eec7";
}

.bxs-time-five:before {
  content: "\\eec8";
}

.bxs-timer:before {
  content: "\\eec9";
}

.bxs-tired:before {
  content: "\\eeca";
}

.bxs-toggle-left:before {
  content: "\\eecb";
}

.bxs-toggle-right:before {
  content: "\\eecc";
}

.bxs-tone:before {
  content: "\\eecd";
}

.bxs-torch:before {
  content: "\\eece";
}

.bxs-to-top:before {
  content: "\\eecf";
}

.bxs-traffic:before {
  content: "\\eed0";
}

.bxs-traffic-barrier:before {
  content: "\\eed1";
}

.bxs-traffic-cone:before {
  content: "\\eed2";
}

.bxs-train:before {
  content: "\\eed3";
}

.bxs-trash:before {
  content: "\\eed4";
}

.bxs-trash-alt:before {
  content: "\\eed5";
}

.bxs-tree:before {
  content: "\\eed6";
}

.bxs-trophy:before {
  content: "\\eed7";
}

.bxs-truck:before {
  content: "\\eed8";
}

.bxs-t-shirt:before {
  content: "\\eed9";
}

.bxs-tv:before {
  content: "\\eeda";
}

.bxs-up-arrow:before {
  content: "\\eedb";
}

.bxs-up-arrow-alt:before {
  content: "\\eedc";
}

.bxs-up-arrow-circle:before {
  content: "\\eedd";
}

.bxs-up-arrow-square:before {
  content: "\\eede";
}

.bxs-upside-down:before {
  content: "\\eedf";
}

.bxs-upvote:before {
  content: "\\eee0";
}

.bxs-user:before {
  content: "\\eee1";
}

.bxs-user-account:before {
  content: "\\eee2";
}

.bxs-user-badge:before {
  content: "\\eee3";
}

.bxs-user-check:before {
  content: "\\eee4";
}

.bxs-user-circle:before {
  content: "\\eee5";
}

.bxs-user-detail:before {
  content: "\\eee6";
}

.bxs-user-minus:before {
  content: "\\eee7";
}

.bxs-user-pin:before {
  content: "\\eee8";
}

.bxs-user-plus:before {
  content: "\\eee9";
}

.bxs-user-rectangle:before {
  content: "\\eeea";
}

.bxs-user-voice:before {
  content: "\\eeeb";
}

.bxs-user-x:before {
  content: "\\eeec";
}

.bxs-vector:before {
  content: "\\eeed";
}

.bxs-vial:before {
  content: "\\eeee";
}

.bxs-video:before {
  content: "\\eeef";
}

.bxs-video-off:before {
  content: "\\eef0";
}

.bxs-video-plus:before {
  content: "\\eef1";
}

.bxs-video-recording:before {
  content: "\\eef2";
}

.bxs-videos:before {
  content: "\\eef3";
}

.bxs-virus:before {
  content: "\\eef4";
}

.bxs-virus-block:before {
  content: "\\eef5";
}

.bxs-volume:before {
  content: "\\eef6";
}

.bxs-volume-full:before {
  content: "\\eef7";
}

.bxs-volume-low:before {
  content: "\\eef8";
}

.bxs-volume-mute:before {
  content: "\\eef9";
}

.bxs-wallet:before {
  content: "\\eefa";
}

.bxs-wallet-alt:before {
  content: "\\eefb";
}

.bxs-washer:before {
  content: "\\eefc";
}

.bxs-watch:before {
  content: "\\eefd";
}

.bxs-watch-alt:before {
  content: "\\eefe";
}

.bxs-webcam:before {
  content: "\\eeff";
}

.bxs-widget:before {
  content: "\\ef00";
}

.bxs-window-alt:before {
  content: "\\ef01";
}

.bxs-wine:before {
  content: "\\ef02";
}

.bxs-wink-smile:before {
  content: "\\ef03";
}

.bxs-wink-tongue:before {
  content: "\\ef04";
}

.bxs-wrench:before {
  content: "\\ef05";
}

.bxs-x-circle:before {
  content: "\\ef06";
}

.bxs-x-square:before {
  content: "\\ef07";
}

.bxs-yin-yang:before {
  content: "\\ef08";
}

.bxs-zap:before {
  content: "\\ef09";
}

.bxs-zoom-in:before {
  content: "\\ef0a";
}

.bxs-zoom-out:before {
  content: "\\ef0b";
}

.la,
.las,
.lar,
.lal,
.lad,
.lab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.la-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.la-xs {
  font-size: 0.75em;
}

.la-sm {
  font-size: 0.875em;
}

.la-1x {
  font-size: 1em;
}

.la-2x {
  font-size: 2em;
}

.la-3x {
  font-size: 3em;
}

.la-4x {
  font-size: 4em;
}

.la-5x {
  font-size: 5em;
}

.la-6x {
  font-size: 6em;
}

.la-7x {
  font-size: 7em;
}

.la-8x {
  font-size: 8em;
}

.la-9x {
  font-size: 9em;
}

.la-10x {
  font-size: 10em;
}

.la-fw {
  text-align: center;
  width: 1.25em;
}

.la-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.la-ul > li {
  position: relative;
}

.la-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.la-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.la-pull-left {
  float: left;
}

.la-pull-right {
  float: right;
}

.la.la-pull-left,
.las.la-pull-left,
.lar.la-pull-left,
.lal.la-pull-left,
.lab.la-pull-left {
  margin-right: 0.3em;
}

.la.la-pull-right,
.las.la-pull-right,
.lar.la-pull-right,
.lal.la-pull-right,
.lab.la-pull-right {
  margin-left: 0.3em;
}

.la-spin {
  animation: la-spin 2s infinite linear;
}

.la-pulse {
  animation: la-spin 1s infinite steps(8);
}
@keyframes la-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.la-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.la-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.la-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.la-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

.la-flip-both, .la-flip-horizontal.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1);
}

:root .la-rotate-90,
:root .la-rotate-180,
:root .la-rotate-270,
:root .la-flip-horizontal,
:root .la-flip-vertical,
:root .la-flip-both {
  filter: none;
}

.la-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.la-stack-1x,
.la-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.la-stack-1x {
  line-height: inherit;
}

.la-stack-2x {
  font-size: 2em;
}

.la-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.la-500px:before {
  content: "\\f26e";
}

.la-accessible-icon:before {
  content: "\\f368";
}

.la-accusoft:before {
  content: "\\f369";
}

.la-acquisitions-incorporated:before {
  content: "\\f6af";
}

.la-ad:before {
  content: "\\f641";
}

.la-address-book:before {
  content: "\\f2b9";
}

.la-address-card:before {
  content: "\\f2bb";
}

.la-adjust:before {
  content: "\\f042";
}

.la-adn:before {
  content: "\\f170";
}

.la-adobe:before {
  content: "\\f778";
}

.la-adversal:before {
  content: "\\f36a";
}

.la-affiliatetheme:before {
  content: "\\f36b";
}

.la-air-freshener:before {
  content: "\\f5d0";
}

.la-airbnb:before {
  content: "\\f834";
}

.la-algolia:before {
  content: "\\f36c";
}

.la-align-center:before {
  content: "\\f037";
}

.la-align-justify:before {
  content: "\\f039";
}

.la-align-left:before {
  content: "\\f036";
}

.la-align-right:before {
  content: "\\f038";
}

.la-alipay:before {
  content: "\\f642";
}

.la-allergies:before {
  content: "\\f461";
}

.la-amazon:before {
  content: "\\f270";
}

.la-amazon-pay:before {
  content: "\\f42c";
}

.la-ambulance:before {
  content: "\\f0f9";
}

.la-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.la-amilia:before {
  content: "\\f36d";
}

.la-anchor:before {
  content: "\\f13d";
}

.la-android:before {
  content: "\\f17b";
}

.la-angellist:before {
  content: "\\f209";
}

.la-angle-double-down:before {
  content: "\\f103";
}

.la-angle-double-left:before {
  content: "\\f100";
}

.la-angle-double-right:before {
  content: "\\f101";
}

.la-angle-double-up:before {
  content: "\\f102";
}

.la-angle-down:before {
  content: "\\f107";
}

.la-angle-left:before {
  content: "\\f104";
}

.la-angle-right:before {
  content: "\\f105";
}

.la-angle-up:before {
  content: "\\f106";
}

.la-angry:before {
  content: "\\f556";
}

.la-angrycreative:before {
  content: "\\f36e";
}

.la-angular:before {
  content: "\\f420";
}

.la-ankh:before {
  content: "\\f644";
}

.la-app-store:before {
  content: "\\f36f";
}

.la-app-store-ios:before {
  content: "\\f370";
}

.la-apper:before {
  content: "\\f371";
}

.la-apple:before {
  content: "\\f179";
}

.la-apple-alt:before {
  content: "\\f5d1";
}

.la-apple-pay:before {
  content: "\\f415";
}

.la-archive:before {
  content: "\\f187";
}

.la-archway:before {
  content: "\\f557";
}

.la-arrow-alt-circle-down:before {
  content: "\\f358";
}

.la-arrow-alt-circle-left:before {
  content: "\\f359";
}

.la-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.la-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.la-arrow-circle-down:before {
  content: "\\f0ab";
}

.la-arrow-circle-left:before {
  content: "\\f0a8";
}

.la-arrow-circle-right:before {
  content: "\\f0a9";
}

.la-arrow-circle-up:before {
  content: "\\f0aa";
}

.la-arrow-down:before {
  content: "\\f063";
}

.la-arrow-left:before {
  content: "\\f060";
}

.la-arrow-right:before {
  content: "\\f061";
}

.la-arrow-up:before {
  content: "\\f062";
}

.la-arrows-alt:before {
  content: "\\f0b2";
}

.la-arrows-alt-h:before {
  content: "\\f337";
}

.la-arrows-alt-v:before {
  content: "\\f338";
}

.la-artstation:before {
  content: "\\f77a";
}

.la-assistive-listening-systems:before {
  content: "\\f2a2";
}

.la-asterisk:before {
  content: "\\f069";
}

.la-asymmetrik:before {
  content: "\\f372";
}

.la-at:before {
  content: "\\f1fa";
}

.la-atlas:before {
  content: "\\f558";
}

.la-atlassian:before {
  content: "\\f77b";
}

.la-atom:before {
  content: "\\f5d2";
}

.la-audible:before {
  content: "\\f373";
}

.la-audio-description:before {
  content: "\\f29e";
}

.la-autoprefixer:before {
  content: "\\f41c";
}

.la-avianex:before {
  content: "\\f374";
}

.la-aviato:before {
  content: "\\f421";
}

.la-award:before {
  content: "\\f559";
}

.la-aws:before {
  content: "\\f375";
}

.la-baby:before {
  content: "\\f77c";
}

.la-baby-carriage:before {
  content: "\\f77d";
}

.la-backspace:before {
  content: "\\f55a";
}

.la-backward:before {
  content: "\\f04a";
}

.la-bacon:before {
  content: "\\f7e5";
}

.la-balance-scale:before {
  content: "\\f24e";
}

.la-balance-scale-left:before {
  content: "\\f515";
}

.la-balance-scale-right:before {
  content: "\\f516";
}

.la-ban:before {
  content: "\\f05e";
}

.la-band-aid:before {
  content: "\\f462";
}

.la-bandcamp:before {
  content: "\\f2d5";
}

.la-barcode:before {
  content: "\\f02a";
}

.la-bars:before {
  content: "\\f0c9";
}

.la-baseball-ball:before {
  content: "\\f433";
}

.la-basketball-ball:before {
  content: "\\f434";
}

.la-bath:before {
  content: "\\f2cd";
}

.la-battery-empty:before {
  content: "\\f244";
}

.la-battery-full:before {
  content: "\\f240";
}

.la-battery-half:before {
  content: "\\f242";
}

.la-battery-quarter:before {
  content: "\\f243";
}

.la-battery-three-quarters:before {
  content: "\\f241";
}

.la-battle-net:before {
  content: "\\f835";
}

.la-bed:before {
  content: "\\f236";
}

.la-beer:before {
  content: "\\f0fc";
}

.la-behance:before {
  content: "\\f1b4";
}

.la-behance-square:before {
  content: "\\f1b5";
}

.la-bell:before {
  content: "\\f0f3";
}

.la-bell-slash:before {
  content: "\\f1f6";
}

.la-bezier-curve:before {
  content: "\\f55b";
}

.la-bible:before {
  content: "\\f647";
}

.la-bicycle:before {
  content: "\\f206";
}

.la-biking:before {
  content: "\\f84a";
}

.la-bimobject:before {
  content: "\\f378";
}

.la-binoculars:before {
  content: "\\f1e5";
}

.la-biohazard:before {
  content: "\\f780";
}

.la-birthday-cake:before {
  content: "\\f1fd";
}

.la-bitbucket:before {
  content: "\\f171";
}

.la-bitcoin:before {
  content: "\\f379";
}

.la-bity:before {
  content: "\\f37a";
}

.la-black-tie:before {
  content: "\\f27e";
}

.la-blackberry:before {
  content: "\\f37b";
}

.la-blender:before {
  content: "\\f517";
}

.la-blender-phone:before {
  content: "\\f6b6";
}

.la-blind:before {
  content: "\\f29d";
}

.la-blog:before {
  content: "\\f781";
}

.la-blogger:before {
  content: "\\f37c";
}

.la-blogger-b:before {
  content: "\\f37d";
}

.la-bluetooth:before {
  content: "\\f293";
}

.la-bluetooth-b:before {
  content: "\\f294";
}

.la-bold:before {
  content: "\\f032";
}

.la-bolt:before {
  content: "\\f0e7";
}

.la-bomb:before {
  content: "\\f1e2";
}

.la-bone:before {
  content: "\\f5d7";
}

.la-bong:before {
  content: "\\f55c";
}

.la-book:before {
  content: "\\f02d";
}

.la-book-dead:before {
  content: "\\f6b7";
}

.la-book-medical:before {
  content: "\\f7e6";
}

.la-book-open:before {
  content: "\\f518";
}

.la-book-reader:before {
  content: "\\f5da";
}

.la-bookmark:before {
  content: "\\f02e";
}

.la-bootstrap:before {
  content: "\\f836";
}

.la-border-all:before {
  content: "\\f84c";
}

.la-border-none:before {
  content: "\\f850";
}

.la-border-style:before {
  content: "\\f853";
}

.la-bowling-ball:before {
  content: "\\f436";
}

.la-box:before {
  content: "\\f466";
}

.la-box-open:before {
  content: "\\f49e";
}

.la-boxes:before {
  content: "\\f468";
}

.la-braille:before {
  content: "\\f2a1";
}

.la-brain:before {
  content: "\\f5dc";
}

.la-bread-slice:before {
  content: "\\f7ec";
}

.la-briefcase:before {
  content: "\\f0b1";
}

.la-briefcase-medical:before {
  content: "\\f469";
}

.la-broadcast-tower:before {
  content: "\\f519";
}

.la-broom:before {
  content: "\\f51a";
}

.la-brush:before {
  content: "\\f55d";
}

.la-btc:before {
  content: "\\f15a";
}

.la-buffer:before {
  content: "\\f837";
}

.la-bug:before {
  content: "\\f188";
}

.la-building:before {
  content: "\\f1ad";
}

.la-bullhorn:before {
  content: "\\f0a1";
}

.la-bullseye:before {
  content: "\\f140";
}

.la-burn:before {
  content: "\\f46a";
}

.la-buromobelexperte:before {
  content: "\\f37f";
}

.la-bus:before {
  content: "\\f207";
}

.la-bus-alt:before {
  content: "\\f55e";
}

.la-business-time:before {
  content: "\\f64a";
}

.la-buy-n-large:before {
  content: "\\f8a6";
}

.la-buysellads:before {
  content: "\\f20d";
}

.la-calculator:before {
  content: "\\f1ec";
}

.la-calendar:before {
  content: "\\f133";
}

.la-calendar-alt:before {
  content: "\\f073";
}

.la-calendar-check:before {
  content: "\\f274";
}

.la-calendar-day:before {
  content: "\\f783";
}

.la-calendar-minus:before {
  content: "\\f272";
}

.la-calendar-plus:before {
  content: "\\f271";
}

.la-calendar-times:before {
  content: "\\f273";
}

.la-calendar-week:before {
  content: "\\f784";
}

.la-camera:before {
  content: "\\f030";
}

.la-camera-retro:before {
  content: "\\f083";
}

.la-campground:before {
  content: "\\f6bb";
}

.la-canadian-maple-leaf:before {
  content: "\\f785";
}

.la-candy-cane:before {
  content: "\\f786";
}

.la-cannabis:before {
  content: "\\f55f";
}

.la-capsules:before {
  content: "\\f46b";
}

.la-car:before {
  content: "\\f1b9";
}

.la-car-alt:before {
  content: "\\f5de";
}

.la-car-battery:before {
  content: "\\f5df";
}

.la-car-crash:before {
  content: "\\f5e1";
}

.la-car-side:before {
  content: "\\f5e4";
}

.la-caret-down:before {
  content: "\\f0d7";
}

.la-caret-left:before {
  content: "\\f0d9";
}

.la-caret-right:before {
  content: "\\f0da";
}

.la-caret-square-down:before {
  content: "\\f150";
}

.la-caret-square-left:before {
  content: "\\f191";
}

.la-caret-square-right:before {
  content: "\\f152";
}

.la-caret-square-up:before {
  content: "\\f151";
}

.la-caret-up:before {
  content: "\\f0d8";
}

.la-carrot:before {
  content: "\\f787";
}

.la-cart-arrow-down:before {
  content: "\\f218";
}

.la-cart-plus:before {
  content: "\\f217";
}

.la-cash-register:before {
  content: "\\f788";
}

.la-cat:before {
  content: "\\f6be";
}

.la-cc-amazon-pay:before {
  content: "\\f42d";
}

.la-cc-amex:before {
  content: "\\f1f3";
}

.la-cc-apple-pay:before {
  content: "\\f416";
}

.la-cc-diners-club:before {
  content: "\\f24c";
}

.la-cc-discover:before {
  content: "\\f1f2";
}

.la-cc-jcb:before {
  content: "\\f24b";
}

.la-cc-mastercard:before {
  content: "\\f1f1";
}

.la-cc-paypal:before {
  content: "\\f1f4";
}

.la-cc-stripe:before {
  content: "\\f1f5";
}

.la-cc-visa:before {
  content: "\\f1f0";
}

.la-centercode:before {
  content: "\\f380";
}

.la-centos:before {
  content: "\\f789";
}

.la-certificate:before {
  content: "\\f0a3";
}

.la-chair:before {
  content: "\\f6c0";
}

.la-chalkboard:before {
  content: "\\f51b";
}

.la-chalkboard-teacher:before {
  content: "\\f51c";
}

.la-charging-station:before {
  content: "\\f5e7";
}

.la-chart-area:before {
  content: "\\f1fe";
}

.la-chart-bar:before {
  content: "\\f080";
}

.la-chart-line:before {
  content: "\\f201";
}

.la-chart-pie:before {
  content: "\\f200";
}

.la-check:before {
  content: "\\f00c";
}

.la-check-circle:before {
  content: "\\f058";
}

.la-check-double:before {
  content: "\\f560";
}

.la-check-square:before {
  content: "\\f14a";
}

.la-cheese:before {
  content: "\\f7ef";
}

.la-chess:before {
  content: "\\f439";
}

.la-chess-bishop:before {
  content: "\\f43a";
}

.la-chess-board:before {
  content: "\\f43c";
}

.la-chess-king:before {
  content: "\\f43f";
}

.la-chess-knight:before {
  content: "\\f441";
}

.la-chess-pawn:before {
  content: "\\f443";
}

.la-chess-queen:before {
  content: "\\f445";
}

.la-chess-rook:before {
  content: "\\f447";
}

.la-chevron-circle-down:before {
  content: "\\f13a";
}

.la-chevron-circle-left:before {
  content: "\\f137";
}

.la-chevron-circle-right:before {
  content: "\\f138";
}

.la-chevron-circle-up:before {
  content: "\\f139";
}

.la-chevron-down:before {
  content: "\\f078";
}

.la-chevron-left:before {
  content: "\\f053";
}

.la-chevron-right:before {
  content: "\\f054";
}

.la-chevron-up:before {
  content: "\\f077";
}

.la-child:before {
  content: "\\f1ae";
}

.la-chrome:before {
  content: "\\f268";
}

.la-chromecast:before {
  content: "\\f838";
}

.la-church:before {
  content: "\\f51d";
}

.la-circle:before {
  content: "\\f111";
}

.la-circle-notch:before {
  content: "\\f1ce";
}

.la-city:before {
  content: "\\f64f";
}

.la-clinic-medical:before {
  content: "\\f7f2";
}

.la-clipboard:before {
  content: "\\f328";
}

.la-clipboard-check:before {
  content: "\\f46c";
}

.la-clipboard-list:before {
  content: "\\f46d";
}

.la-clock:before {
  content: "\\f017";
}

.la-clone:before {
  content: "\\f24d";
}

.la-closed-captioning:before {
  content: "\\f20a";
}

.la-cloud:before {
  content: "\\f0c2";
}

.la-cloud-download-alt:before {
  content: "\\f381";
}

.la-cloud-meatball:before {
  content: "\\f73b";
}

.la-cloud-moon:before {
  content: "\\f6c3";
}

.la-cloud-moon-rain:before {
  content: "\\f73c";
}

.la-cloud-rain:before {
  content: "\\f73d";
}

.la-cloud-showers-heavy:before {
  content: "\\f740";
}

.la-cloud-sun:before {
  content: "\\f6c4";
}

.la-cloud-sun-rain:before {
  content: "\\f743";
}

.la-cloud-upload-alt:before {
  content: "\\f382";
}

.la-cloudscale:before {
  content: "\\f383";
}

.la-cloudsmith:before {
  content: "\\f384";
}

.la-cloudversify:before {
  content: "\\f385";
}

.la-cocktail:before {
  content: "\\f561";
}

.la-code:before {
  content: "\\f121";
}

.la-code-branch:before {
  content: "\\f126";
}

.la-codepen:before {
  content: "\\f1cb";
}

.la-codiepie:before {
  content: "\\f284";
}

.la-coffee:before {
  content: "\\f0f4";
}

.la-cog:before {
  content: "\\f013";
}

.la-cogs:before {
  content: "\\f085";
}

.la-coins:before {
  content: "\\f51e";
}

.la-columns:before {
  content: "\\f0db";
}

.la-comment:before {
  content: "\\f075";
}

.la-comment-alt:before {
  content: "\\f27a";
}

.la-comment-dollar:before {
  content: "\\f651";
}

.la-comment-dots:before {
  content: "\\f4ad";
}

.la-comment-medical:before {
  content: "\\f7f5";
}

.la-comment-slash:before {
  content: "\\f4b3";
}

.la-comments:before {
  content: "\\f086";
}

.la-comments-dollar:before {
  content: "\\f653";
}

.la-compact-disc:before {
  content: "\\f51f";
}

.la-compass:before {
  content: "\\f14e";
}

.la-compress:before {
  content: "\\f066";
}

.la-compress-arrows-alt:before {
  content: "\\f78c";
}

.la-concierge-bell:before {
  content: "\\f562";
}

.la-confluence:before {
  content: "\\f78d";
}

.la-connectdevelop:before {
  content: "\\f20e";
}

.la-contao:before {
  content: "\\f26d";
}

.la-cookie:before {
  content: "\\f563";
}

.la-cookie-bite:before {
  content: "\\f564";
}

.la-copy:before {
  content: "\\f0c5";
}

.la-copyright:before {
  content: "\\f1f9";
}

.la-cotton-bureau:before {
  content: "\\f89e";
}

.la-couch:before {
  content: "\\f4b8";
}

.la-cpanel:before {
  content: "\\f388";
}

.la-creative-commons:before {
  content: "\\f25e";
}

.la-creative-commons-by:before {
  content: "\\f4e7";
}

.la-creative-commons-nc:before {
  content: "\\f4e8";
}

.la-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.la-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.la-creative-commons-nd:before {
  content: "\\f4eb";
}

.la-creative-commons-pd:before {
  content: "\\f4ec";
}

.la-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.la-creative-commons-remix:before {
  content: "\\f4ee";
}

.la-creative-commons-sa:before {
  content: "\\f4ef";
}

.la-creative-commons-sampling:before {
  content: "\\f4f0";
}

.la-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.la-creative-commons-share:before {
  content: "\\f4f2";
}

.la-creative-commons-zero:before {
  content: "\\f4f3";
}

.la-credit-card:before {
  content: "\\f09d";
}

.la-critical-role:before {
  content: "\\f6c9";
}

.la-crop:before {
  content: "\\f125";
}

.la-crop-alt:before {
  content: "\\f565";
}

.la-cross:before {
  content: "\\f654";
}

.la-crosshairs:before {
  content: "\\f05b";
}

.la-crow:before {
  content: "\\f520";
}

.la-crown:before {
  content: "\\f521";
}

.la-crutch:before {
  content: "\\f7f7";
}

.la-css3:before {
  content: "\\f13c";
}

.la-css3-alt:before {
  content: "\\f38b";
}

.la-cube:before {
  content: "\\f1b2";
}

.la-cubes:before {
  content: "\\f1b3";
}

.la-cut:before {
  content: "\\f0c4";
}

.la-cuttlefish:before {
  content: "\\f38c";
}

.la-d-and-d:before {
  content: "\\f38d";
}

.la-d-and-d-beyond:before {
  content: "\\f6ca";
}

.la-dashcube:before {
  content: "\\f210";
}

.la-database:before {
  content: "\\f1c0";
}

.la-deaf:before {
  content: "\\f2a4";
}

.la-delicious:before {
  content: "\\f1a5";
}

.la-democrat:before {
  content: "\\f747";
}

.la-deploydog:before {
  content: "\\f38e";
}

.la-deskpro:before {
  content: "\\f38f";
}

.la-desktop:before {
  content: "\\f108";
}

.la-dev:before {
  content: "\\f6cc";
}

.la-deviantart:before {
  content: "\\f1bd";
}

.la-dharmachakra:before {
  content: "\\f655";
}

.la-dhl:before {
  content: "\\f790";
}

.la-diagnoses:before {
  content: "\\f470";
}

.la-diaspora:before {
  content: "\\f791";
}

.la-dice:before {
  content: "\\f522";
}

.la-dice-d20:before {
  content: "\\f6cf";
}

.la-dice-d6:before {
  content: "\\f6d1";
}

.la-dice-five:before {
  content: "\\f523";
}

.la-dice-four:before {
  content: "\\f524";
}

.la-dice-one:before {
  content: "\\f525";
}

.la-dice-six:before {
  content: "\\f526";
}

.la-dice-three:before {
  content: "\\f527";
}

.la-dice-two:before {
  content: "\\f528";
}

.la-digg:before {
  content: "\\f1a6";
}

.la-digital-ocean:before {
  content: "\\f391";
}

.la-digital-tachograph:before {
  content: "\\f566";
}

.la-directions:before {
  content: "\\f5eb";
}

.la-discord:before {
  content: "\\f392";
}

.la-discourse:before {
  content: "\\f393";
}

.la-divide:before {
  content: "\\f529";
}

.la-dizzy:before {
  content: "\\f567";
}

.la-dna:before {
  content: "\\f471";
}

.la-dochub:before {
  content: "\\f394";
}

.la-docker:before {
  content: "\\f395";
}

.la-dog:before {
  content: "\\f6d3";
}

.la-dollar-sign:before {
  content: "\\f155";
}

.la-dolly:before {
  content: "\\f472";
}

.la-dolly-flatbed:before {
  content: "\\f474";
}

.la-donate:before {
  content: "\\f4b9";
}

.la-door-closed:before {
  content: "\\f52a";
}

.la-door-open:before {
  content: "\\f52b";
}

.la-dot-circle:before {
  content: "\\f192";
}

.la-dove:before {
  content: "\\f4ba";
}

.la-download:before {
  content: "\\f019";
}

.la-draft2digital:before {
  content: "\\f396";
}

.la-drafting-compass:before {
  content: "\\f568";
}

.la-dragon:before {
  content: "\\f6d5";
}

.la-draw-polygon:before {
  content: "\\f5ee";
}

.la-dribbble:before {
  content: "\\f17d";
}

.la-dribbble-square:before {
  content: "\\f397";
}

.la-dropbox:before {
  content: "\\f16b";
}

.la-drum:before {
  content: "\\f569";
}

.la-drum-steelpan:before {
  content: "\\f56a";
}

.la-drumstick-bite:before {
  content: "\\f6d7";
}

.la-drupal:before {
  content: "\\f1a9";
}

.la-dumbbell:before {
  content: "\\f44b";
}

.la-dumpster:before {
  content: "\\f793";
}

.la-dumpster-fire:before {
  content: "\\f794";
}

.la-dungeon:before {
  content: "\\f6d9";
}

.la-dyalog:before {
  content: "\\f399";
}

.la-earlybirds:before {
  content: "\\f39a";
}

.la-ebay:before {
  content: "\\f4f4";
}

.la-edge:before {
  content: "\\f282";
}

.la-edit:before {
  content: "\\f044";
}

.la-egg:before {
  content: "\\f7fb";
}

.la-eject:before {
  content: "\\f052";
}

.la-elementor:before {
  content: "\\f430";
}

.la-ellipsis-h:before {
  content: "\\f141";
}

.la-ellipsis-v:before {
  content: "\\f142";
}

.la-ello:before {
  content: "\\f5f1";
}

.la-ember:before {
  content: "\\f423";
}

.la-empire:before {
  content: "\\f1d1";
}

.la-envelope:before {
  content: "\\f0e0";
}

.la-envelope-open:before {
  content: "\\f2b6";
}

.la-envelope-open-text:before {
  content: "\\f658";
}

.la-envelope-square:before {
  content: "\\f199";
}

.la-envira:before {
  content: "\\f299";
}

.la-equals:before {
  content: "\\f52c";
}

.la-eraser:before {
  content: "\\f12d";
}

.la-erlang:before {
  content: "\\f39d";
}

.la-ethereum:before {
  content: "\\f42e";
}

.la-ethernet:before {
  content: "\\f796";
}

.la-etsy:before {
  content: "\\f2d7";
}

.la-euro-sign:before {
  content: "\\f153";
}

.la-evernote:before {
  content: "\\f839";
}

.la-exchange-alt:before {
  content: "\\f362";
}

.la-exclamation:before {
  content: "\\f12a";
}

.la-exclamation-circle:before {
  content: "\\f06a";
}

.la-exclamation-triangle:before {
  content: "\\f071";
}

.la-expand:before {
  content: "\\f065";
}

.la-expand-arrows-alt:before {
  content: "\\f31e";
}

.la-expeditedssl:before {
  content: "\\f23e";
}

.la-external-link-alt:before {
  content: "\\f35d";
}

.la-external-link-square-alt:before {
  content: "\\f360";
}

.la-eye:before {
  content: "\\f06e";
}

.la-eye-dropper:before {
  content: "\\f1fb";
}

.la-eye-slash:before {
  content: "\\f070";
}

.la-facebook:before {
  content: "\\f09a";
}

.la-facebook-f:before {
  content: "\\f39e";
}

.la-facebook-messenger:before {
  content: "\\f39f";
}

.la-facebook-square:before {
  content: "\\f082";
}

.la-fan:before {
  content: "\\f863";
}

.la-fantasy-flight-games:before {
  content: "\\f6dc";
}

.la-fast-backward:before {
  content: "\\f049";
}

.la-fast-forward:before {
  content: "\\f050";
}

.la-fax:before {
  content: "\\f1ac";
}

.la-feather:before {
  content: "\\f52d";
}

.la-feather-alt:before {
  content: "\\f56b";
}

.la-fedex:before {
  content: "\\f797";
}

.la-fedora:before {
  content: "\\f798";
}

.la-female:before {
  content: "\\f182";
}

.la-fighter-jet:before {
  content: "\\f0fb";
}

.la-figma:before {
  content: "\\f799";
}

.la-file:before {
  content: "\\f15b";
}

.la-file-alt:before {
  content: "\\f15c";
}

.la-file-archive:before {
  content: "\\f1c6";
}

.la-file-audio:before {
  content: "\\f1c7";
}

.la-file-code:before {
  content: "\\f1c9";
}

.la-file-contract:before {
  content: "\\f56c";
}

.la-file-csv:before {
  content: "\\f6dd";
}

.la-file-download:before {
  content: "\\f56d";
}

.la-file-excel:before {
  content: "\\f1c3";
}

.la-file-export:before {
  content: "\\f56e";
}

.la-file-image:before {
  content: "\\f1c5";
}

.la-file-import:before {
  content: "\\f56f";
}

.la-file-invoice:before {
  content: "\\f570";
}

.la-file-invoice-dollar:before {
  content: "\\f571";
}

.la-file-medical:before {
  content: "\\f477";
}

.la-file-medical-alt:before {
  content: "\\f478";
}

.la-file-pdf:before {
  content: "\\f1c1";
}

.la-file-powerpoint:before {
  content: "\\f1c4";
}

.la-file-prescription:before {
  content: "\\f572";
}

.la-file-signature:before {
  content: "\\f573";
}

.la-file-upload:before {
  content: "\\f574";
}

.la-file-video:before {
  content: "\\f1c8";
}

.la-file-word:before {
  content: "\\f1c2";
}

.la-fill:before {
  content: "\\f575";
}

.la-fill-drip:before {
  content: "\\f576";
}

.la-film:before {
  content: "\\f008";
}

.la-filter:before {
  content: "\\f0b0";
}

.la-fingerprint:before {
  content: "\\f577";
}

.la-fire:before {
  content: "\\f06d";
}

.la-fire-alt:before {
  content: "\\f7e4";
}

.la-fire-extinguisher:before {
  content: "\\f134";
}

.la-firefox:before {
  content: "\\f269";
}

.la-first-aid:before {
  content: "\\f479";
}

.la-first-order:before {
  content: "\\f2b0";
}

.la-first-order-alt:before {
  content: "\\f50a";
}

.la-firstdraft:before {
  content: "\\f3a1";
}

.la-fish:before {
  content: "\\f578";
}

.la-fist-raised:before {
  content: "\\f6de";
}

.la-flag:before {
  content: "\\f024";
}

.la-flag-checkered:before {
  content: "\\f11e";
}

.la-flag-usa:before {
  content: "\\f74d";
}

.la-flask:before {
  content: "\\f0c3";
}

.la-flickr:before {
  content: "\\f16e";
}

.la-flipboard:before {
  content: "\\f44d";
}

.la-flushed:before {
  content: "\\f579";
}

.la-fly:before {
  content: "\\f417";
}

.la-folder:before {
  content: "\\f07b";
}

.la-folder-minus:before {
  content: "\\f65d";
}

.la-folder-open:before {
  content: "\\f07c";
}

.la-folder-plus:before {
  content: "\\f65e";
}

.la-font:before {
  content: "\\f031";
}

.la-font-awesome:before {
  content: "\\f2b4";
}

.la-font-awesome-alt:before {
  content: "\\f35c";
}

.la-font-awesome-flag:before {
  content: "\\f425";
}

.la-font-awesome-logo-full:before {
  content: "\\f4e6";
}

.la-fonticons:before {
  content: "\\f280";
}

.la-fonticons-fi:before {
  content: "\\f3a2";
}

.la-football-ball:before {
  content: "\\f44e";
}

.la-fort-awesome:before {
  content: "\\f286";
}

.la-fort-awesome-alt:before {
  content: "\\f3a3";
}

.la-forumbee:before {
  content: "\\f211";
}

.la-forward:before {
  content: "\\f04e";
}

.la-foursquare:before {
  content: "\\f180";
}

.la-free-code-camp:before {
  content: "\\f2c5";
}

.la-freebsd:before {
  content: "\\f3a4";
}

.la-frog:before {
  content: "\\f52e";
}

.la-frown:before {
  content: "\\f119";
}

.la-frown-open:before {
  content: "\\f57a";
}

.la-fulcrum:before {
  content: "\\f50b";
}

.la-funnel-dollar:before {
  content: "\\f662";
}

.la-futbol:before {
  content: "\\f1e3";
}

.la-galactic-republic:before {
  content: "\\f50c";
}

.la-galactic-senate:before {
  content: "\\f50d";
}

.la-gamepad:before {
  content: "\\f11b";
}

.la-gas-pump:before {
  content: "\\f52f";
}

.la-gavel:before {
  content: "\\f0e3";
}

.la-gem:before {
  content: "\\f3a5";
}

.la-genderless:before {
  content: "\\f22d";
}

.la-get-pocket:before {
  content: "\\f265";
}

.la-gg:before {
  content: "\\f260";
}

.la-gg-circle:before {
  content: "\\f261";
}

.la-ghost:before {
  content: "\\f6e2";
}

.la-gift:before {
  content: "\\f06b";
}

.la-gifts:before {
  content: "\\f79c";
}

.la-git:before {
  content: "\\f1d3";
}

.la-git-alt:before {
  content: "\\f841";
}

.la-git-square:before {
  content: "\\f1d2";
}

.la-github:before {
  content: "\\f09b";
}

.la-github-alt:before {
  content: "\\f113";
}

.la-github-square:before {
  content: "\\f092";
}

.la-gitkraken:before {
  content: "\\f3a6";
}

.la-gitlab:before {
  content: "\\f296";
}

.la-gitter:before {
  content: "\\f426";
}

.la-glass-cheers:before {
  content: "\\f79f";
}

.la-glass-martini:before {
  content: "\\f000";
}

.la-glass-martini-alt:before {
  content: "\\f57b";
}

.la-glass-whiskey:before {
  content: "\\f7a0";
}

.la-glasses:before {
  content: "\\f530";
}

.la-glide:before {
  content: "\\f2a5";
}

.la-glide-g:before {
  content: "\\f2a6";
}

.la-globe:before {
  content: "\\f0ac";
}

.la-globe-africa:before {
  content: "\\f57c";
}

.la-globe-americas:before {
  content: "\\f57d";
}

.la-globe-asia:before {
  content: "\\f57e";
}

.la-globe-europe:before {
  content: "\\f7a2";
}

.la-gofore:before {
  content: "\\f3a7";
}

.la-golf-ball:before {
  content: "\\f450";
}

.la-goodreads:before {
  content: "\\f3a8";
}

.la-goodreads-g:before {
  content: "\\f3a9";
}

.la-google:before {
  content: "\\f1a0";
}

.la-google-drive:before {
  content: "\\f3aa";
}

.la-google-play:before {
  content: "\\f3ab";
}

.la-google-plus:before {
  content: "\\f2b3";
}

.la-google-plus-g:before {
  content: "\\f0d5";
}

.la-google-plus-square:before {
  content: "\\f0d4";
}

.la-google-wallet:before {
  content: "\\f1ee";
}

.la-gopuram:before {
  content: "\\f664";
}

.la-graduation-cap:before {
  content: "\\f19d";
}

.la-gratipay:before {
  content: "\\f184";
}

.la-grav:before {
  content: "\\f2d6";
}

.la-greater-than:before {
  content: "\\f531";
}

.la-greater-than-equal:before {
  content: "\\f532";
}

.la-grimace:before {
  content: "\\f57f";
}

.la-grin:before {
  content: "\\f580";
}

.la-grin-alt:before {
  content: "\\f581";
}

.la-grin-beam:before {
  content: "\\f582";
}

.la-grin-beam-sweat:before {
  content: "\\f583";
}

.la-grin-hearts:before {
  content: "\\f584";
}

.la-grin-squint:before {
  content: "\\f585";
}

.la-grin-squint-tears:before {
  content: "\\f586";
}

.la-grin-stars:before {
  content: "\\f587";
}

.la-grin-tears:before {
  content: "\\f588";
}

.la-grin-tongue:before {
  content: "\\f589";
}

.la-grin-tongue-squint:before {
  content: "\\f58a";
}

.la-grin-tongue-wink:before {
  content: "\\f58b";
}

.la-grin-wink:before {
  content: "\\f58c";
}

.la-grip-horizontal:before {
  content: "\\f58d";
}

.la-grip-lines:before {
  content: "\\f7a4";
}

.la-grip-lines-vertical:before {
  content: "\\f7a5";
}

.la-grip-vertical:before {
  content: "\\f58e";
}

.la-gripfire:before {
  content: "\\f3ac";
}

.la-grunt:before {
  content: "\\f3ad";
}

.la-guitar:before {
  content: "\\f7a6";
}

.la-gulp:before {
  content: "\\f3ae";
}

.la-h-square:before {
  content: "\\f0fd";
}

.la-hacker-news:before {
  content: "\\f1d4";
}

.la-hacker-news-square:before {
  content: "\\f3af";
}

.la-hackerrank:before {
  content: "\\f5f7";
}

.la-hamburger:before {
  content: "\\f805";
}

.la-hammer:before {
  content: "\\f6e3";
}

.la-hamsa:before {
  content: "\\f665";
}

.la-hand-holding:before {
  content: "\\f4bd";
}

.la-hand-holding-heart:before {
  content: "\\f4be";
}

.la-hand-holding-usd:before {
  content: "\\f4c0";
}

.la-hand-lizard:before {
  content: "\\f258";
}

.la-hand-middle-finger:before {
  content: "\\f806";
}

.la-hand-paper:before {
  content: "\\f256";
}

.la-hand-peace:before {
  content: "\\f25b";
}

.la-hand-point-down:before {
  content: "\\f0a7";
}

.la-hand-point-left:before {
  content: "\\f0a5";
}

.la-hand-point-right:before {
  content: "\\f0a4";
}

.la-hand-point-up:before {
  content: "\\f0a6";
}

.la-hand-pointer:before {
  content: "\\f25a";
}

.la-hand-rock:before {
  content: "\\f255";
}

.la-hand-scissors:before {
  content: "\\f257";
}

.la-hand-spock:before {
  content: "\\f259";
}

.la-hands:before {
  content: "\\f4c2";
}

.la-hands-helping:before {
  content: "\\f4c4";
}

.la-handshake:before {
  content: "\\f2b5";
}

.la-hanukiah:before {
  content: "\\f6e6";
}

.la-hard-hat:before {
  content: "\\f807";
}

.la-hashtag:before {
  content: "\\f292";
}

.la-hat-cowboy:before {
  content: "\\f8c0";
}

.la-hat-cowboy-side:before {
  content: "\\f8c1";
}

.la-hat-wizard:before {
  content: "\\f6e8";
}

.la-haykal:before {
  content: "\\f666";
}

.la-hdd:before {
  content: "\\f0a0";
}

.la-heading:before {
  content: "\\f1dc";
}

.la-headphones:before {
  content: "\\f025";
}

.la-headphones-alt:before {
  content: "\\f58f";
}

.la-headset:before {
  content: "\\f590";
}

.la-heart:before {
  content: "\\f004";
}

.la-heart-broken:before {
  content: "\\f7a9";
}

.la-heartbeat:before {
  content: "\\f21e";
}

.la-helicopter:before {
  content: "\\f533";
}

.la-highlighter:before {
  content: "\\f591";
}

.la-hiking:before {
  content: "\\f6ec";
}

.la-hippo:before {
  content: "\\f6ed";
}

.la-hips:before {
  content: "\\f452";
}

.la-hire-a-helper:before {
  content: "\\f3b0";
}

.la-history:before {
  content: "\\f1da";
}

.la-hockey-puck:before {
  content: "\\f453";
}

.la-holly-berry:before {
  content: "\\f7aa";
}

.la-home:before {
  content: "\\f015";
}

.la-hooli:before {
  content: "\\f427";
}

.la-hornbill:before {
  content: "\\f592";
}

.la-horse:before {
  content: "\\f6f0";
}

.la-horse-head:before {
  content: "\\f7ab";
}

.la-hospital:before {
  content: "\\f0f8";
}

.la-hospital-alt:before {
  content: "\\f47d";
}

.la-hospital-symbol:before {
  content: "\\f47e";
}

.la-hot-tub:before {
  content: "\\f593";
}

.la-hotdog:before {
  content: "\\f80f";
}

.la-hotel:before {
  content: "\\f594";
}

.la-hotjar:before {
  content: "\\f3b1";
}

.la-hourglass:before {
  content: "\\f254";
}

.la-hourglass-end:before {
  content: "\\f253";
}

.la-hourglass-half:before {
  content: "\\f252";
}

.la-hourglass-start:before {
  content: "\\f251";
}

.la-house-damage:before {
  content: "\\f6f1";
}

.la-houzz:before {
  content: "\\f27c";
}

.la-hryvnia:before {
  content: "\\f6f2";
}

.la-html5:before {
  content: "\\f13b";
}

.la-hubspot:before {
  content: "\\f3b2";
}

.la-i-cursor:before {
  content: "\\f246";
}

.la-ice-cream:before {
  content: "\\f810";
}

.la-icicles:before {
  content: "\\f7ad";
}

.la-icons:before {
  content: "\\f86d";
}

.la-id-badge:before {
  content: "\\f2c1";
}

.la-id-card:before {
  content: "\\f2c2";
}

.la-id-card-alt:before {
  content: "\\f47f";
}

.la-igloo:before {
  content: "\\f7ae";
}

.la-image:before {
  content: "\\f03e";
}

.la-images:before {
  content: "\\f302";
}

.la-imdb:before {
  content: "\\f2d8";
}

.la-inbox:before {
  content: "\\f01c";
}

.la-indent:before {
  content: "\\f03c";
}

.la-industry:before {
  content: "\\f275";
}

.la-infinity:before {
  content: "\\f534";
}

.la-info:before {
  content: "\\f129";
}

.la-info-circle:before {
  content: "\\f05a";
}

.la-instagram:before {
  content: "\\f16d";
}

.la-intercom:before {
  content: "\\f7af";
}

.la-internet-explorer:before {
  content: "\\f26b";
}

.la-invision:before {
  content: "\\f7b0";
}

.la-ioxhost:before {
  content: "\\f208";
}

.la-italic:before {
  content: "\\f033";
}

.la-itch-io:before {
  content: "\\f83a";
}

.la-itunes:before {
  content: "\\f3b4";
}

.la-itunes-note:before {
  content: "\\f3b5";
}

.la-java:before {
  content: "\\f4e4";
}

.la-jedi:before {
  content: "\\f669";
}

.la-jedi-order:before {
  content: "\\f50e";
}

.la-jenkins:before {
  content: "\\f3b6";
}

.la-jira:before {
  content: "\\f7b1";
}

.la-joget:before {
  content: "\\f3b7";
}

.la-joint:before {
  content: "\\f595";
}

.la-joomla:before {
  content: "\\f1aa";
}

.la-journal-whills:before {
  content: "\\f66a";
}

.la-js:before {
  content: "\\f3b8";
}

.la-js-square:before {
  content: "\\f3b9";
}

.la-jsfiddle:before {
  content: "\\f1cc";
}

.la-kaaba:before {
  content: "\\f66b";
}

.la-kaggle:before {
  content: "\\f5fa";
}

.la-key:before {
  content: "\\f084";
}

.la-keybase:before {
  content: "\\f4f5";
}

.la-keyboard:before {
  content: "\\f11c";
}

.la-keycdn:before {
  content: "\\f3ba";
}

.la-khanda:before {
  content: "\\f66d";
}

.la-kickstarter:before {
  content: "\\f3bb";
}

.la-kickstarter-k:before {
  content: "\\f3bc";
}

.la-kiss:before {
  content: "\\f596";
}

.la-kiss-beam:before {
  content: "\\f597";
}

.la-kiss-wink-heart:before {
  content: "\\f598";
}

.la-kiwi-bird:before {
  content: "\\f535";
}

.la-korvue:before {
  content: "\\f42f";
}

.la-landmark:before {
  content: "\\f66f";
}

.la-language:before {
  content: "\\f1ab";
}

.la-laptop:before {
  content: "\\f109";
}

.la-laptop-code:before {
  content: "\\f5fc";
}

.la-laptop-medical:before {
  content: "\\f812";
}

.la-laravel:before {
  content: "\\f3bd";
}

.la-lastfm:before {
  content: "\\f202";
}

.la-lastfm-square:before {
  content: "\\f203";
}

.la-laugh:before {
  content: "\\f599";
}

.la-laugh-beam:before {
  content: "\\f59a";
}

.la-laugh-squint:before {
  content: "\\f59b";
}

.la-laugh-wink:before {
  content: "\\f59c";
}

.la-layer-group:before {
  content: "\\f5fd";
}

.la-leaf:before {
  content: "\\f06c";
}

.la-leanpub:before {
  content: "\\f212";
}

.la-lemon:before {
  content: "\\f094";
}

.la-less:before {
  content: "\\f41d";
}

.la-less-than:before {
  content: "\\f536";
}

.la-less-than-equal:before {
  content: "\\f537";
}

.la-level-down-alt:before {
  content: "\\f3be";
}

.la-level-up-alt:before {
  content: "\\f3bf";
}

.la-life-ring:before {
  content: "\\f1cd";
}

.la-lightbulb:before {
  content: "\\f0eb";
}

.la-line:before {
  content: "\\f3c0";
}

.la-link:before {
  content: "\\f0c1";
}

.la-linkedin:before {
  content: "\\f08c";
}

.la-linkedin-in:before {
  content: "\\f0e1";
}

.la-linode:before {
  content: "\\f2b8";
}

.la-linux:before {
  content: "\\f17c";
}

.la-lira-sign:before {
  content: "\\f195";
}

.la-list:before {
  content: "\\f03a";
}

.la-list-alt:before {
  content: "\\f022";
}

.la-list-ol:before {
  content: "\\f0cb";
}

.la-list-ul:before {
  content: "\\f0ca";
}

.la-location-arrow:before {
  content: "\\f124";
}

.la-lock:before {
  content: "\\f023";
}

.la-lock-open:before {
  content: "\\f3c1";
}

.la-long-arrow-alt-down:before {
  content: "\\f309";
}

.la-long-arrow-alt-left:before {
  content: "\\f30a";
}

.la-long-arrow-alt-right:before {
  content: "\\f30b";
}

.la-long-arrow-alt-up:before {
  content: "\\f30c";
}

.la-low-vision:before {
  content: "\\f2a8";
}

.la-luggage-cart:before {
  content: "\\f59d";
}

.la-lyft:before {
  content: "\\f3c3";
}

.la-magento:before {
  content: "\\f3c4";
}

.la-magic:before {
  content: "\\f0d0";
}

.la-magnet:before {
  content: "\\f076";
}

.la-mail-bulk:before {
  content: "\\f674";
}

.la-mailchimp:before {
  content: "\\f59e";
}

.la-male:before {
  content: "\\f183";
}

.la-mandalorian:before {
  content: "\\f50f";
}

.la-map:before {
  content: "\\f279";
}

.la-map-marked:before {
  content: "\\f59f";
}

.la-map-marked-alt:before {
  content: "\\f5a0";
}

.la-map-marker:before {
  content: "\\f041";
}

.la-map-marker-alt:before {
  content: "\\f3c5";
}

.la-map-pin:before {
  content: "\\f276";
}

.la-map-signs:before {
  content: "\\f277";
}

.la-markdown:before {
  content: "\\f60f";
}

.la-marker:before {
  content: "\\f5a1";
}

.la-mars:before {
  content: "\\f222";
}

.la-mars-double:before {
  content: "\\f227";
}

.la-mars-stroke:before {
  content: "\\f229";
}

.la-mars-stroke-h:before {
  content: "\\f22b";
}

.la-mars-stroke-v:before {
  content: "\\f22a";
}

.la-mask:before {
  content: "\\f6fa";
}

.la-mastodon:before {
  content: "\\f4f6";
}

.la-maxcdn:before {
  content: "\\f136";
}

.la-mdb:before {
  content: "\\f8ca";
}

.la-medal:before {
  content: "\\f5a2";
}

.la-medapps:before {
  content: "\\f3c6";
}

.la-medium:before {
  content: "\\f23a";
}

.la-medium-m:before {
  content: "\\f3c7";
}

.la-medkit:before {
  content: "\\f0fa";
}

.la-medrt:before {
  content: "\\f3c8";
}

.la-meetup:before {
  content: "\\f2e0";
}

.la-megaport:before {
  content: "\\f5a3";
}

.la-meh:before {
  content: "\\f11a";
}

.la-meh-blank:before {
  content: "\\f5a4";
}

.la-meh-rolling-eyes:before {
  content: "\\f5a5";
}

.la-memory:before {
  content: "\\f538";
}

.la-mendeley:before {
  content: "\\f7b3";
}

.la-menorah:before {
  content: "\\f676";
}

.la-mercury:before {
  content: "\\f223";
}

.la-meteor:before {
  content: "\\f753";
}

.la-microchip:before {
  content: "\\f2db";
}

.la-microphone:before {
  content: "\\f130";
}

.la-microphone-alt:before {
  content: "\\f3c9";
}

.la-microphone-alt-slash:before {
  content: "\\f539";
}

.la-microphone-slash:before {
  content: "\\f131";
}

.la-microscope:before {
  content: "\\f610";
}

.la-microsoft:before {
  content: "\\f3ca";
}

.la-minus:before {
  content: "\\f068";
}

.la-minus-circle:before {
  content: "\\f056";
}

.la-minus-square:before {
  content: "\\f146";
}

.la-mitten:before {
  content: "\\f7b5";
}

.la-mix:before {
  content: "\\f3cb";
}

.la-mixcloud:before {
  content: "\\f289";
}

.la-mizuni:before {
  content: "\\f3cc";
}

.la-mobile:before {
  content: "\\f10b";
}

.la-mobile-alt:before {
  content: "\\f3cd";
}

.la-modx:before {
  content: "\\f285";
}

.la-monero:before {
  content: "\\f3d0";
}

.la-money-bill:before {
  content: "\\f0d6";
}

.la-money-bill-alt:before {
  content: "\\f3d1";
}

.la-money-bill-wave:before {
  content: "\\f53a";
}

.la-money-bill-wave-alt:before {
  content: "\\f53b";
}

.la-money-check:before {
  content: "\\f53c";
}

.la-money-check-alt:before {
  content: "\\f53d";
}

.la-monument:before {
  content: "\\f5a6";
}

.la-moon:before {
  content: "\\f186";
}

.la-mortar-pestle:before {
  content: "\\f5a7";
}

.la-mosque:before {
  content: "\\f678";
}

.la-motorcycle:before {
  content: "\\f21c";
}

.la-mountain:before {
  content: "\\f6fc";
}

.la-mouse:before {
  content: "\\f8cc";
}

.la-mouse-pointer:before {
  content: "\\f245";
}

.la-mug-hot:before {
  content: "\\f7b6";
}

.la-music:before {
  content: "\\f001";
}

.la-napster:before {
  content: "\\f3d2";
}

.la-neos:before {
  content: "\\f612";
}

.la-network-wired:before {
  content: "\\f6ff";
}

.la-neuter:before {
  content: "\\f22c";
}

.la-newspaper:before {
  content: "\\f1ea";
}

.la-nimblr:before {
  content: "\\f5a8";
}

.la-node:before {
  content: "\\f419";
}

.la-node-js:before {
  content: "\\f3d3";
}

.la-not-equal:before {
  content: "\\f53e";
}

.la-notes-medical:before {
  content: "\\f481";
}

.la-npm:before {
  content: "\\f3d4";
}

.la-ns8:before {
  content: "\\f3d5";
}

.la-nutritionix:before {
  content: "\\f3d6";
}

.la-object-group:before {
  content: "\\f247";
}

.la-object-ungroup:before {
  content: "\\f248";
}

.la-odnoklassniki:before {
  content: "\\f263";
}

.la-odnoklassniki-square:before {
  content: "\\f264";
}

.la-oil-can:before {
  content: "\\f613";
}

.la-old-republic:before {
  content: "\\f510";
}

.la-om:before {
  content: "\\f679";
}

.la-opencart:before {
  content: "\\f23d";
}

.la-openid:before {
  content: "\\f19b";
}

.la-opera:before {
  content: "\\f26a";
}

.la-optin-monster:before {
  content: "\\f23c";
}

.la-orcid:before {
  content: "\\f8d2";
}

.la-osi:before {
  content: "\\f41a";
}

.la-otter:before {
  content: "\\f700";
}

.la-outdent:before {
  content: "\\f03b";
}

.la-page4:before {
  content: "\\f3d7";
}

.la-pagelines:before {
  content: "\\f18c";
}

.la-pager:before {
  content: "\\f815";
}

.la-paint-brush:before {
  content: "\\f1fc";
}

.la-paint-roller:before {
  content: "\\f5aa";
}

.la-palette:before {
  content: "\\f53f";
}

.la-palfed:before {
  content: "\\f3d8";
}

.la-pallet:before {
  content: "\\f482";
}

.la-paper-plane:before {
  content: "\\f1d8";
}

.la-paperclip:before {
  content: "\\f0c6";
}

.la-parachute-box:before {
  content: "\\f4cd";
}

.la-paragraph:before {
  content: "\\f1dd";
}

.la-parking:before {
  content: "\\f540";
}

.la-passport:before {
  content: "\\f5ab";
}

.la-pastafarianism:before {
  content: "\\f67b";
}

.la-paste:before {
  content: "\\f0ea";
}

.la-patreon:before {
  content: "\\f3d9";
}

.la-pause:before {
  content: "\\f04c";
}

.la-pause-circle:before {
  content: "\\f28b";
}

.la-paw:before {
  content: "\\f1b0";
}

.la-paypal:before {
  content: "\\f1ed";
}

.la-peace:before {
  content: "\\f67c";
}

.la-pen:before {
  content: "\\f304";
}

.la-pen-alt:before {
  content: "\\f305";
}

.la-pen-fancy:before {
  content: "\\f5ac";
}

.la-pen-nib:before {
  content: "\\f5ad";
}

.la-pen-square:before {
  content: "\\f14b";
}

.la-pencil-alt:before {
  content: "\\f303";
}

.la-pencil-ruler:before {
  content: "\\f5ae";
}

.la-penny-arcade:before {
  content: "\\f704";
}

.la-people-carry:before {
  content: "\\f4ce";
}

.la-pepper-hot:before {
  content: "\\f816";
}

.la-percent:before {
  content: "\\f295";
}

.la-percentage:before {
  content: "\\f541";
}

.la-periscope:before {
  content: "\\f3da";
}

.la-person-booth:before {
  content: "\\f756";
}

.la-phabricator:before {
  content: "\\f3db";
}

.la-phoenix-framework:before {
  content: "\\f3dc";
}

.la-phoenix-squadron:before {
  content: "\\f511";
}

.la-phone:before {
  content: "\\f095";
}

.la-phone-alt:before {
  content: "\\f879";
}

.la-phone-slash:before {
  content: "\\f3dd";
}

.la-phone-square:before {
  content: "\\f098";
}

.la-phone-square-alt:before {
  content: "\\f87b";
}

.la-phone-volume:before {
  content: "\\f2a0";
}

.la-photo-video:before {
  content: "\\f87c";
}

.la-php:before {
  content: "\\f457";
}

.la-pied-piper:before {
  content: "\\f2ae";
}

.la-pied-piper-alt:before {
  content: "\\f1a8";
}

.la-pied-piper-hat:before {
  content: "\\f4e5";
}

.la-pied-piper-pp:before {
  content: "\\f1a7";
}

.la-piggy-bank:before {
  content: "\\f4d3";
}

.la-pills:before {
  content: "\\f484";
}

.la-pinterest:before {
  content: "\\f0d2";
}

.la-pinterest-p:before {
  content: "\\f231";
}

.la-pinterest-square:before {
  content: "\\f0d3";
}

.la-pizza-slice:before {
  content: "\\f818";
}

.la-place-of-worship:before {
  content: "\\f67f";
}

.la-plane:before {
  content: "\\f072";
}

.la-plane-arrival:before {
  content: "\\f5af";
}

.la-plane-departure:before {
  content: "\\f5b0";
}

.la-play:before {
  content: "\\f04b";
}

.la-play-circle:before {
  content: "\\f144";
}

.la-playstation:before {
  content: "\\f3df";
}

.la-plug:before {
  content: "\\f1e6";
}

.la-plus:before {
  content: "\\f067";
}

.la-plus-circle:before {
  content: "\\f055";
}

.la-plus-square:before {
  content: "\\f0fe";
}

.la-podcast:before {
  content: "\\f2ce";
}

.la-poll:before {
  content: "\\f681";
}

.la-poll-h:before {
  content: "\\f682";
}

.la-poo:before {
  content: "\\f2fe";
}

.la-poo-storm:before {
  content: "\\f75a";
}

.la-poop:before {
  content: "\\f619";
}

.la-portrait:before {
  content: "\\f3e0";
}

.la-pound-sign:before {
  content: "\\f154";
}

.la-power-off:before {
  content: "\\f011";
}

.la-pray:before {
  content: "\\f683";
}

.la-praying-hands:before {
  content: "\\f684";
}

.la-prescription:before {
  content: "\\f5b1";
}

.la-prescription-bottle:before {
  content: "\\f485";
}

.la-prescription-bottle-alt:before {
  content: "\\f486";
}

.la-print:before {
  content: "\\f02f";
}

.la-procedures:before {
  content: "\\f487";
}

.la-product-hunt:before {
  content: "\\f288";
}

.la-project-diagram:before {
  content: "\\f542";
}

.la-pushed:before {
  content: "\\f3e1";
}

.la-puzzle-piece:before {
  content: "\\f12e";
}

.la-python:before {
  content: "\\f3e2";
}

.la-qq:before {
  content: "\\f1d6";
}

.la-qrcode:before {
  content: "\\f029";
}

.la-question:before {
  content: "\\f128";
}

.la-question-circle:before {
  content: "\\f059";
}

.la-quidditch:before {
  content: "\\f458";
}

.la-quinscape:before {
  content: "\\f459";
}

.la-quora:before {
  content: "\\f2c4";
}

.la-quote-left:before {
  content: "\\f10d";
}

.la-quote-right:before {
  content: "\\f10e";
}

.la-quran:before {
  content: "\\f687";
}

.la-r-project:before {
  content: "\\f4f7";
}

.la-radiation:before {
  content: "\\f7b9";
}

.la-radiation-alt:before {
  content: "\\f7ba";
}

.la-rainbow:before {
  content: "\\f75b";
}

.la-random:before {
  content: "\\f074";
}

.la-raspberry-pi:before {
  content: "\\f7bb";
}

.la-ravelry:before {
  content: "\\f2d9";
}

.la-react:before {
  content: "\\f41b";
}

.la-reacteurope:before {
  content: "\\f75d";
}

.la-readme:before {
  content: "\\f4d5";
}

.la-rebel:before {
  content: "\\f1d0";
}

.la-receipt:before {
  content: "\\f543";
}

.la-record-vinyl:before {
  content: "\\f8d9";
}

.la-recycle:before {
  content: "\\f1b8";
}

.la-red-river:before {
  content: "\\f3e3";
}

.la-reddit:before {
  content: "\\f1a1";
}

.la-reddit-alien:before {
  content: "\\f281";
}

.la-reddit-square:before {
  content: "\\f1a2";
}

.la-redhat:before {
  content: "\\f7bc";
}

.la-redo:before {
  content: "\\f01e";
}

.la-redo-alt:before {
  content: "\\f2f9";
}

.la-registered:before {
  content: "\\f25d";
}

.la-remove-format:before {
  content: "\\f87d";
}

.la-renren:before {
  content: "\\f18b";
}

.la-reply:before {
  content: "\\f3e5";
}

.la-reply-all:before {
  content: "\\f122";
}

.la-replyd:before {
  content: "\\f3e6";
}

.la-republican:before {
  content: "\\f75e";
}

.la-researchgate:before {
  content: "\\f4f8";
}

.la-resolving:before {
  content: "\\f3e7";
}

.la-restroom:before {
  content: "\\f7bd";
}

.la-retweet:before {
  content: "\\f079";
}

.la-rev:before {
  content: "\\f5b2";
}

.la-ribbon:before {
  content: "\\f4d6";
}

.la-ring:before {
  content: "\\f70b";
}

.la-road:before {
  content: "\\f018";
}

.la-robot:before {
  content: "\\f544";
}

.la-rocket:before {
  content: "\\f135";
}

.la-rocketchat:before {
  content: "\\f3e8";
}

.la-rockrms:before {
  content: "\\f3e9";
}

.la-route:before {
  content: "\\f4d7";
}

.la-rss:before {
  content: "\\f09e";
}

.la-rss-square:before {
  content: "\\f143";
}

.la-ruble-sign:before {
  content: "\\f158";
}

.la-ruler:before {
  content: "\\f545";
}

.la-ruler-combined:before {
  content: "\\f546";
}

.la-ruler-horizontal:before {
  content: "\\f547";
}

.la-ruler-vertical:before {
  content: "\\f548";
}

.la-running:before {
  content: "\\f70c";
}

.la-rupee-sign:before {
  content: "\\f156";
}

.la-sad-cry:before {
  content: "\\f5b3";
}

.la-sad-tear:before {
  content: "\\f5b4";
}

.la-safari:before {
  content: "\\f267";
}

.la-salesforce:before {
  content: "\\f83b";
}

.la-sass:before {
  content: "\\f41e";
}

.la-satellite:before {
  content: "\\f7bf";
}

.la-satellite-dish:before {
  content: "\\f7c0";
}

.la-save:before {
  content: "\\f0c7";
}

.la-schlix:before {
  content: "\\f3ea";
}

.la-school:before {
  content: "\\f549";
}

.la-screwdriver:before {
  content: "\\f54a";
}

.la-scribd:before {
  content: "\\f28a";
}

.la-scroll:before {
  content: "\\f70e";
}

.la-sd-card:before {
  content: "\\f7c2";
}

.la-search:before {
  content: "\\f002";
}

.la-search-dollar:before {
  content: "\\f688";
}

.la-search-location:before {
  content: "\\f689";
}

.la-search-minus:before {
  content: "\\f010";
}

.la-search-plus:before {
  content: "\\f00e";
}

.la-searchengin:before {
  content: "\\f3eb";
}

.la-seedling:before {
  content: "\\f4d8";
}

.la-sellcast:before {
  content: "\\f2da";
}

.la-sellsy:before {
  content: "\\f213";
}

.la-server:before {
  content: "\\f233";
}

.la-servicestack:before {
  content: "\\f3ec";
}

.la-shapes:before {
  content: "\\f61f";
}

.la-share:before {
  content: "\\f064";
}

.la-share-alt:before {
  content: "\\f1e0";
}

.la-share-alt-square:before {
  content: "\\f1e1";
}

.la-share-square:before {
  content: "\\f14d";
}

.la-shekel-sign:before {
  content: "\\f20b";
}

.la-shield-alt:before {
  content: "\\f3ed";
}

.la-ship:before {
  content: "\\f21a";
}

.la-shipping-fast:before {
  content: "\\f48b";
}

.la-shirtsinbulk:before {
  content: "\\f214";
}

.la-shoe-prints:before {
  content: "\\f54b";
}

.la-shopping-bag:before {
  content: "\\f290";
}

.la-shopping-basket:before {
  content: "\\f291";
}

.la-shopping-cart:before {
  content: "\\f07a";
}

.la-shopware:before {
  content: "\\f5b5";
}

.la-shower:before {
  content: "\\f2cc";
}

.la-shuttle-van:before {
  content: "\\f5b6";
}

.la-sign:before {
  content: "\\f4d9";
}

.la-sign-in-alt:before {
  content: "\\f2f6";
}

.la-sign-language:before {
  content: "\\f2a7";
}

.la-sign-out-alt:before {
  content: "\\f2f5";
}

.la-signal:before {
  content: "\\f012";
}

.la-signature:before {
  content: "\\f5b7";
}

.la-sim-card:before {
  content: "\\f7c4";
}

.la-simplybuilt:before {
  content: "\\f215";
}

.la-sistrix:before {
  content: "\\f3ee";
}

.la-sitemap:before {
  content: "\\f0e8";
}

.la-sith:before {
  content: "\\f512";
}

.la-skating:before {
  content: "\\f7c5";
}

.la-sketch:before {
  content: "\\f7c6";
}

.la-skiing:before {
  content: "\\f7c9";
}

.la-skiing-nordic:before {
  content: "\\f7ca";
}

.la-skull:before {
  content: "\\f54c";
}

.la-skull-crossbones:before {
  content: "\\f714";
}

.la-skyatlas:before {
  content: "\\f216";
}

.la-skype:before {
  content: "\\f17e";
}

.la-slack:before {
  content: "\\f198";
}

.la-slack-hash:before {
  content: "\\f3ef";
}

.la-slash:before {
  content: "\\f715";
}

.la-sleigh:before {
  content: "\\f7cc";
}

.la-sliders-h:before {
  content: "\\f1de";
}

.la-slideshare:before {
  content: "\\f1e7";
}

.la-smile:before {
  content: "\\f118";
}

.la-smile-beam:before {
  content: "\\f5b8";
}

.la-smile-wink:before {
  content: "\\f4da";
}

.la-smog:before {
  content: "\\f75f";
}

.la-smoking:before {
  content: "\\f48d";
}

.la-smoking-ban:before {
  content: "\\f54d";
}

.la-sms:before {
  content: "\\f7cd";
}

.la-snapchat:before {
  content: "\\f2ab";
}

.la-snapchat-ghost:before {
  content: "\\f2ac";
}

.la-snapchat-square:before {
  content: "\\f2ad";
}

.la-snowboarding:before {
  content: "\\f7ce";
}

.la-snowflake:before {
  content: "\\f2dc";
}

.la-snowman:before {
  content: "\\f7d0";
}

.la-snowplow:before {
  content: "\\f7d2";
}

.la-socks:before {
  content: "\\f696";
}

.la-solar-panel:before {
  content: "\\f5ba";
}

.la-sort:before {
  content: "\\f0dc";
}

.la-sort-alpha-down:before {
  content: "\\f15d";
}

.la-sort-alpha-down-alt:before {
  content: "\\f881";
}

.la-sort-alpha-up:before {
  content: "\\f15e";
}

.la-sort-alpha-up-alt:before {
  content: "\\f882";
}

.la-sort-amount-down:before {
  content: "\\f160";
}

.la-sort-amount-down-alt:before {
  content: "\\f884";
}

.la-sort-amount-up:before {
  content: "\\f161";
}

.la-sort-amount-up-alt:before {
  content: "\\f885";
}

.la-sort-down:before {
  content: "\\f0dd";
}

.la-sort-numeric-down:before {
  content: "\\f162";
}

.la-sort-numeric-down-alt:before {
  content: "\\f886";
}

.la-sort-numeric-up:before {
  content: "\\f163";
}

.la-sort-numeric-up-alt:before {
  content: "\\f887";
}

.la-sort-up:before {
  content: "\\f0de";
}

.la-soundcloud:before {
  content: "\\f1be";
}

.la-sourcetree:before {
  content: "\\f7d3";
}

.la-spa:before {
  content: "\\f5bb";
}

.la-space-shuttle:before {
  content: "\\f197";
}

.la-speakap:before {
  content: "\\f3f3";
}

.la-speaker-deck:before {
  content: "\\f83c";
}

.la-spell-check:before {
  content: "\\f891";
}

.la-spider:before {
  content: "\\f717";
}

.la-spinner:before {
  content: "\\f110";
}

.la-splotch:before {
  content: "\\f5bc";
}

.la-spotify:before {
  content: "\\f1bc";
}

.la-spray-can:before {
  content: "\\f5bd";
}

.la-square:before {
  content: "\\f0c8";
}

.la-square-full:before {
  content: "\\f45c";
}

.la-square-root-alt:before {
  content: "\\f698";
}

.la-squarespace:before {
  content: "\\f5be";
}

.la-stack-exchange:before {
  content: "\\f18d";
}

.la-stack-overflow:before {
  content: "\\f16c";
}

.la-stackpath:before {
  content: "\\f842";
}

.la-stamp:before {
  content: "\\f5bf";
}

.la-star:before {
  content: "\\f005";
}

.la-star-and-crescent:before {
  content: "\\f699";
}

.la-star-half:before {
  content: "\\f089";
}

.la-star-half-alt:before {
  content: "\\f5c0";
}

.la-star-of-david:before {
  content: "\\f69a";
}

.la-star-of-life:before {
  content: "\\f621";
}

.la-staylinked:before {
  content: "\\f3f5";
}

.la-steam:before {
  content: "\\f1b6";
}

.la-steam-square:before {
  content: "\\f1b7";
}

.la-steam-symbol:before {
  content: "\\f3f6";
}

.la-step-backward:before {
  content: "\\f048";
}

.la-step-forward:before {
  content: "\\f051";
}

.la-stethoscope:before {
  content: "\\f0f1";
}

.la-sticker-mule:before {
  content: "\\f3f7";
}

.la-sticky-note:before {
  content: "\\f249";
}

.la-stop:before {
  content: "\\f04d";
}

.la-stop-circle:before {
  content: "\\f28d";
}

.la-stopwatch:before {
  content: "\\f2f2";
}

.la-store:before {
  content: "\\f54e";
}

.la-store-alt:before {
  content: "\\f54f";
}

.la-strava:before {
  content: "\\f428";
}

.la-stream:before {
  content: "\\f550";
}

.la-street-view:before {
  content: "\\f21d";
}

.la-strikethrough:before {
  content: "\\f0cc";
}

.la-stripe:before {
  content: "\\f429";
}

.la-stripe-s:before {
  content: "\\f42a";
}

.la-stroopwafel:before {
  content: "\\f551";
}

.la-studiovinari:before {
  content: "\\f3f8";
}

.la-stumbleupon:before {
  content: "\\f1a4";
}

.la-stumbleupon-circle:before {
  content: "\\f1a3";
}

.la-subscript:before {
  content: "\\f12c";
}

.la-subway:before {
  content: "\\f239";
}

.la-suitcase:before {
  content: "\\f0f2";
}

.la-suitcase-rolling:before {
  content: "\\f5c1";
}

.la-sun:before {
  content: "\\f185";
}

.la-superpowers:before {
  content: "\\f2dd";
}

.la-superscript:before {
  content: "\\f12b";
}

.la-supple:before {
  content: "\\f3f9";
}

.la-surprise:before {
  content: "\\f5c2";
}

.la-suse:before {
  content: "\\f7d6";
}

.la-swatchbook:before {
  content: "\\f5c3";
}

.la-swift:before {
  content: "\\f8e1";
}

.la-swimmer:before {
  content: "\\f5c4";
}

.la-swimming-pool:before {
  content: "\\f5c5";
}

.la-symfony:before {
  content: "\\f83d";
}

.la-synagogue:before {
  content: "\\f69b";
}

.la-sync:before {
  content: "\\f021";
}

.la-sync-alt:before {
  content: "\\f2f1";
}

.la-syringe:before {
  content: "\\f48e";
}

.la-table:before {
  content: "\\f0ce";
}

.la-table-tennis:before {
  content: "\\f45d";
}

.la-tablet:before {
  content: "\\f10a";
}

.la-tablet-alt:before {
  content: "\\f3fa";
}

.la-tablets:before {
  content: "\\f490";
}

.la-tachometer-alt:before {
  content: "\\f3fd";
}

.la-tag:before {
  content: "\\f02b";
}

.la-tags:before {
  content: "\\f02c";
}

.la-tape:before {
  content: "\\f4db";
}

.la-tasks:before {
  content: "\\f0ae";
}

.la-taxi:before {
  content: "\\f1ba";
}

.la-teamspeak:before {
  content: "\\f4f9";
}

.la-teeth:before {
  content: "\\f62e";
}

.la-teeth-open:before {
  content: "\\f62f";
}

.la-telegram:before {
  content: "\\f2c6";
}

.la-telegram-plane:before {
  content: "\\f3fe";
}

.la-temperature-high:before {
  content: "\\f769";
}

.la-temperature-low:before {
  content: "\\f76b";
}

.la-tencent-weibo:before {
  content: "\\f1d5";
}

.la-tenge:before {
  content: "\\f7d7";
}

.la-terminal:before {
  content: "\\f120";
}

.la-text-height:before {
  content: "\\f034";
}

.la-text-width:before {
  content: "\\f035";
}

.la-th:before {
  content: "\\f00a";
}

.la-th-large:before {
  content: "\\f009";
}

.la-th-list:before {
  content: "\\f00b";
}

.la-the-red-yeti:before {
  content: "\\f69d";
}

.la-theater-masks:before {
  content: "\\f630";
}

.la-themeco:before {
  content: "\\f5c6";
}

.la-themeisle:before {
  content: "\\f2b2";
}

.la-thermometer:before {
  content: "\\f491";
}

.la-thermometer-empty:before {
  content: "\\f2cb";
}

.la-thermometer-full:before {
  content: "\\f2c7";
}

.la-thermometer-half:before {
  content: "\\f2c9";
}

.la-thermometer-quarter:before {
  content: "\\f2ca";
}

.la-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.la-think-peaks:before {
  content: "\\f731";
}

.la-thumbs-down:before {
  content: "\\f165";
}

.la-thumbs-up:before {
  content: "\\f164";
}

.la-thumbtack:before {
  content: "\\f08d";
}

.la-ticket-alt:before {
  content: "\\f3ff";
}

.la-times:before {
  content: "\\f00d";
}

.la-times-circle:before {
  content: "\\f057";
}

.la-tint:before {
  content: "\\f043";
}

.la-tint-slash:before {
  content: "\\f5c7";
}

.la-tired:before {
  content: "\\f5c8";
}

.la-toggle-off:before {
  content: "\\f204";
}

.la-toggle-on:before {
  content: "\\f205";
}

.la-toilet:before {
  content: "\\f7d8";
}

.la-toilet-paper:before {
  content: "\\f71e";
}

.la-toolbox:before {
  content: "\\f552";
}

.la-tools:before {
  content: "\\f7d9";
}

.la-tooth:before {
  content: "\\f5c9";
}

.la-torah:before {
  content: "\\f6a0";
}

.la-torii-gate:before {
  content: "\\f6a1";
}

.la-tractor:before {
  content: "\\f722";
}

.la-trade-federation:before {
  content: "\\f513";
}

.la-trademark:before {
  content: "\\f25c";
}

.la-traffic-light:before {
  content: "\\f637";
}

.la-train:before {
  content: "\\f238";
}

.la-tram:before {
  content: "\\f7da";
}

.la-transgender:before {
  content: "\\f224";
}

.la-transgender-alt:before {
  content: "\\f225";
}

.la-trash:before {
  content: "\\f1f8";
}

.la-trash-alt:before {
  content: "\\f2ed";
}

.la-trash-restore:before {
  content: "\\f829";
}

.la-trash-restore-alt:before {
  content: "\\f82a";
}

.la-tree:before {
  content: "\\f1bb";
}

.la-trello:before {
  content: "\\f181";
}

.la-tripadvisor:before {
  content: "\\f262";
}

.la-trophy:before {
  content: "\\f091";
}

.la-truck:before {
  content: "\\f0d1";
}

.la-truck-loading:before {
  content: "\\f4de";
}

.la-truck-monster:before {
  content: "\\f63b";
}

.la-truck-moving:before {
  content: "\\f4df";
}

.la-truck-pickup:before {
  content: "\\f63c";
}

.la-tshirt:before {
  content: "\\f553";
}

.la-tty:before {
  content: "\\f1e4";
}

.la-tumblr:before {
  content: "\\f173";
}

.la-tumblr-square:before {
  content: "\\f174";
}

.la-tv:before {
  content: "\\f26c";
}

.la-twitch:before {
  content: "\\f1e8";
}

.la-twitter:before {
  content: "\\f099";
}

.la-twitter-square:before {
  content: "\\f081";
}

.la-typo3:before {
  content: "\\f42b";
}

.la-uber:before {
  content: "\\f402";
}

.la-ubuntu:before {
  content: "\\f7df";
}

.la-uikit:before {
  content: "\\f403";
}

.la-umbraco:before {
  content: "\\f8e8";
}

.la-umbrella:before {
  content: "\\f0e9";
}

.la-umbrella-beach:before {
  content: "\\f5ca";
}

.la-underline:before {
  content: "\\f0cd";
}

.la-undo:before {
  content: "\\f0e2";
}

.la-undo-alt:before {
  content: "\\f2ea";
}

.la-uniregistry:before {
  content: "\\f404";
}

.la-universal-access:before {
  content: "\\f29a";
}

.la-university:before {
  content: "\\f19c";
}

.la-unlink:before {
  content: "\\f127";
}

.la-unlock:before {
  content: "\\f09c";
}

.la-unlock-alt:before {
  content: "\\f13e";
}

.la-untappd:before {
  content: "\\f405";
}

.la-upload:before {
  content: "\\f093";
}

.la-ups:before {
  content: "\\f7e0";
}

.la-usb:before {
  content: "\\f287";
}

.la-user:before {
  content: "\\f007";
}

.la-user-alt:before {
  content: "\\f406";
}

.la-user-alt-slash:before {
  content: "\\f4fa";
}

.la-user-astronaut:before {
  content: "\\f4fb";
}

.la-user-check:before {
  content: "\\f4fc";
}

.la-user-circle:before {
  content: "\\f2bd";
}

.la-user-clock:before {
  content: "\\f4fd";
}

.la-user-cog:before {
  content: "\\f4fe";
}

.la-user-edit:before {
  content: "\\f4ff";
}

.la-user-friends:before {
  content: "\\f500";
}

.la-user-graduate:before {
  content: "\\f501";
}

.la-user-injured:before {
  content: "\\f728";
}

.la-user-lock:before {
  content: "\\f502";
}

.la-user-md:before {
  content: "\\f0f0";
}

.la-user-minus:before {
  content: "\\f503";
}

.la-user-ninja:before {
  content: "\\f504";
}

.la-user-nurse:before {
  content: "\\f82f";
}

.la-user-plus:before {
  content: "\\f234";
}

.la-user-secret:before {
  content: "\\f21b";
}

.la-user-shield:before {
  content: "\\f505";
}

.la-user-slash:before {
  content: "\\f506";
}

.la-user-tag:before {
  content: "\\f507";
}

.la-user-tie:before {
  content: "\\f508";
}

.la-user-times:before {
  content: "\\f235";
}

.la-users:before {
  content: "\\f0c0";
}

.la-users-cog:before {
  content: "\\f509";
}

.la-usps:before {
  content: "\\f7e1";
}

.la-ussunnah:before {
  content: "\\f407";
}

.la-utensil-spoon:before {
  content: "\\f2e5";
}

.la-utensils:before {
  content: "\\f2e7";
}

.la-vaadin:before {
  content: "\\f408";
}

.la-vector-square:before {
  content: "\\f5cb";
}

.la-venus:before {
  content: "\\f221";
}

.la-venus-double:before {
  content: "\\f226";
}

.la-venus-mars:before {
  content: "\\f228";
}

.la-viacoin:before {
  content: "\\f237";
}

.la-viadeo:before {
  content: "\\f2a9";
}

.la-viadeo-square:before {
  content: "\\f2aa";
}

.la-vial:before {
  content: "\\f492";
}

.la-vials:before {
  content: "\\f493";
}

.la-viber:before {
  content: "\\f409";
}

.la-video:before {
  content: "\\f03d";
}

.la-video-slash:before {
  content: "\\f4e2";
}

.la-vihara:before {
  content: "\\f6a7";
}

.la-vimeo:before {
  content: "\\f40a";
}

.la-vimeo-square:before {
  content: "\\f194";
}

.la-vimeo-v:before {
  content: "\\f27d";
}

.la-vine:before {
  content: "\\f1ca";
}

.la-vk:before {
  content: "\\f189";
}

.la-vnv:before {
  content: "\\f40b";
}

.la-voicemail:before {
  content: "\\f897";
}

.la-volleyball-ball:before {
  content: "\\f45f";
}

.la-volume-down:before {
  content: "\\f027";
}

.la-volume-mute:before {
  content: "\\f6a9";
}

.la-volume-off:before {
  content: "\\f026";
}

.la-volume-up:before {
  content: "\\f028";
}

.la-vote-yea:before {
  content: "\\f772";
}

.la-vr-cardboard:before {
  content: "\\f729";
}

.la-vuejs:before {
  content: "\\f41f";
}

.la-walking:before {
  content: "\\f554";
}

.la-wallet:before {
  content: "\\f555";
}

.la-warehouse:before {
  content: "\\f494";
}

.la-water:before {
  content: "\\f773";
}

.la-wave-square:before {
  content: "\\f83e";
}

.la-waze:before {
  content: "\\f83f";
}

.la-weebly:before {
  content: "\\f5cc";
}

.la-weibo:before {
  content: "\\f18a";
}

.la-weight:before {
  content: "\\f496";
}

.la-weight-hanging:before {
  content: "\\f5cd";
}

.la-weixin:before {
  content: "\\f1d7";
}

.la-whatsapp:before {
  content: "\\f232";
}

.la-whatsapp-square:before {
  content: "\\f40c";
}

.la-wheelchair:before {
  content: "\\f193";
}

.la-whmcs:before {
  content: "\\f40d";
}

.la-wifi:before {
  content: "\\f1eb";
}

.la-wikipedia-w:before {
  content: "\\f266";
}

.la-wind:before {
  content: "\\f72e";
}

.la-window-close:before {
  content: "\\f410";
}

.la-window-maximize:before {
  content: "\\f2d0";
}

.la-window-minimize:before {
  content: "\\f2d1";
}

.la-window-restore:before {
  content: "\\f2d2";
}

.la-windows:before {
  content: "\\f17a";
}

.la-wine-bottle:before {
  content: "\\f72f";
}

.la-wine-glass:before {
  content: "\\f4e3";
}

.la-wine-glass-alt:before {
  content: "\\f5ce";
}

.la-wix:before {
  content: "\\f5cf";
}

.la-wizards-of-the-coast:before {
  content: "\\f730";
}

.la-wolf-pack-battalion:before {
  content: "\\f514";
}

.la-won-sign:before {
  content: "\\f159";
}

.la-wordpress:before {
  content: "\\f19a";
}

.la-wordpress-simple:before {
  content: "\\f411";
}

.la-wpbeginner:before {
  content: "\\f297";
}

.la-wpexplorer:before {
  content: "\\f2de";
}

.la-wpforms:before {
  content: "\\f298";
}

.la-wpressr:before {
  content: "\\f3e4";
}

.la-wrench:before {
  content: "\\f0ad";
}

.la-x-ray:before {
  content: "\\f497";
}

.la-xbox:before {
  content: "\\f412";
}

.la-xing:before {
  content: "\\f168";
}

.la-xing-square:before {
  content: "\\f169";
}

.la-y-combinator:before {
  content: "\\f23b";
}

.la-yahoo:before {
  content: "\\f19e";
}

.la-yammer:before {
  content: "\\f840";
}

.la-yandex:before {
  content: "\\f413";
}

.la-yandex-international:before {
  content: "\\f414";
}

.la-yarn:before {
  content: "\\f7e3";
}

.la-yelp:before {
  content: "\\f1e9";
}

.la-yen-sign:before {
  content: "\\f157";
}

.la-yin-yang:before {
  content: "\\f6ad";
}

.la-yoast:before {
  content: "\\f2b1";
}

.la-youtube:before {
  content: "\\f167";
}

.la-youtube-square:before {
  content: "\\f431";
}

.la-zhihu:before {
  content: "\\f63f";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Line Awesome Brands";
  font-style: normal;
  font-weight: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
}
.lab {
  font-family: "Line Awesome Brands";
}

@font-face {
  font-family: "Line Awesome Free";
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg");
}
.lar {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

@font-face {
  font-family: "Line Awesome Free";
  font-style: normal;
  font-weight: 900;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg");
}
.la,
.las {
  font-family: "Line Awesome Free";
  font-weight: 900;
}

.la.la-glass:before {
  content: "\\f000";
}

.la.la-meetup {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-star-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-o:before {
  content: "\\f005";
}

.la.la-remove:before {
  content: "\\f00d";
}

.la.la-close:before {
  content: "\\f00d";
}

.la.la-gear:before {
  content: "\\f013";
}

.la.la-trash-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-trash-o:before {
  content: "\\f2ed";
}

.la.la-file-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-o:before {
  content: "\\f15b";
}

.la.la-clock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-clock-o:before {
  content: "\\f017";
}

.la.la-arrow-circle-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-down:before {
  content: "\\f358";
}

.la.la-arrow-circle-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-up:before {
  content: "\\f35b";
}

.la.la-play-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-play-circle-o:before {
  content: "\\f144";
}

.la.la-repeat:before {
  content: "\\f01e";
}

.la.la-rotate-right:before {
  content: "\\f01e";
}

.la.la-refresh:before {
  content: "\\f021";
}

.la.la-list-alt {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-dedent:before {
  content: "\\f03b";
}

.la.la-video-camera:before {
  content: "\\f03d";
}

.la.la-picture-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-picture-o:before {
  content: "\\f03e";
}

.la.la-photo {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-photo:before {
  content: "\\f03e";
}

.la.la-image {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-image:before {
  content: "\\f03e";
}

.la.la-pencil:before {
  content: "\\f303";
}

.la.la-map-marker:before {
  content: "\\f3c5";
}

.la.la-pencil-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-pencil-square-o:before {
  content: "\\f044";
}

.la.la-share-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-share-square-o:before {
  content: "\\f14d";
}

.la.la-check-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-check-square-o:before {
  content: "\\f14a";
}

.la.la-arrows:before {
  content: "\\f0b2";
}

.la.la-times-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-circle-o:before {
  content: "\\f057";
}

.la.la-check-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-check-circle-o:before {
  content: "\\f058";
}

.la.la-mail-forward:before {
  content: "\\f064";
}

.la.la-eye {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-eye-slash {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-warning:before {
  content: "\\f071";
}

.la.la-calendar:before {
  content: "\\f073";
}

.la.la-arrows-v:before {
  content: "\\f338";
}

.la.la-arrows-h:before {
  content: "\\f337";
}

.la.la-bar-chart {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bar-chart:before {
  content: "\\f080";
}

.la.la-bar-chart-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bar-chart-o:before {
  content: "\\f080";
}

.la.la-twitter-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gears:before {
  content: "\\f085";
}

.la.la-thumbs-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-thumbs-o-up:before {
  content: "\\f164";
}

.la.la-thumbs-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-thumbs-o-down:before {
  content: "\\f165";
}

.la.la-heart-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-heart-o:before {
  content: "\\f004";
}

.la.la-sign-out:before {
  content: "\\f2f5";
}

.la.la-linkedin-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linkedin-square:before {
  content: "\\f08c";
}

.la.la-thumb-tack:before {
  content: "\\f08d";
}

.la.la-external-link:before {
  content: "\\f35d";
}

.la.la-sign-in:before {
  content: "\\f2f6";
}

.la.la-github-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-lemon-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-lemon-o:before {
  content: "\\f094";
}

.la.la-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-square-o:before {
  content: "\\f0c8";
}

.la.la-bookmark-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bookmark-o:before {
  content: "\\f02e";
}

.la.la-twitter {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook:before {
  content: "\\f39e";
}

.la.la-facebook-f {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-f:before {
  content: "\\f39e";
}

.la.la-github {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-credit-card {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-feed:before {
  content: "\\f09e";
}

.la.la-hdd-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hdd-o:before {
  content: "\\f0a0";
}

.la.la-hand-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-right:before {
  content: "\\f0a4";
}

.la.la-hand-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-left:before {
  content: "\\f0a5";
}

.la.la-hand-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-up:before {
  content: "\\f0a6";
}

.la.la-hand-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-down:before {
  content: "\\f0a7";
}

.la.la-arrows-alt:before {
  content: "\\f31e";
}

.la.la-group:before {
  content: "\\f0c0";
}

.la.la-chain:before {
  content: "\\f0c1";
}

.la.la-scissors:before {
  content: "\\f0c4";
}

.la.la-files-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-files-o:before {
  content: "\\f0c5";
}

.la.la-floppy-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-floppy-o:before {
  content: "\\f0c7";
}

.la.la-navicon:before {
  content: "\\f0c9";
}

.la.la-reorder:before {
  content: "\\f0c9";
}

.la.la-pinterest {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pinterest-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus:before {
  content: "\\f0d5";
}

.la.la-money {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-money:before {
  content: "\\f3d1";
}

.la.la-unsorted:before {
  content: "\\f0dc";
}

.la.la-sort-desc:before {
  content: "\\f0dd";
}

.la.la-sort-asc:before {
  content: "\\f0de";
}

.la.la-linkedin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linkedin:before {
  content: "\\f0e1";
}

.la.la-rotate-left:before {
  content: "\\f0e2";
}

.la.la-legal:before {
  content: "\\f0e3";
}

.la.la-tachometer:before {
  content: "\\f3fd";
}

.la.la-dashboard:before {
  content: "\\f3fd";
}

.la.la-comment-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-comment-o:before {
  content: "\\f075";
}

.la.la-comments-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-comments-o:before {
  content: "\\f086";
}

.la.la-flash:before {
  content: "\\f0e7";
}

.la.la-clipboard {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paste {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paste:before {
  content: "\\f328";
}

.la.la-lightbulb-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-lightbulb-o:before {
  content: "\\f0eb";
}

.la.la-exchange:before {
  content: "\\f362";
}

.la.la-cloud-download:before {
  content: "\\f381";
}

.la.la-cloud-upload:before {
  content: "\\f382";
}

.la.la-bell-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bell-o:before {
  content: "\\f0f3";
}

.la.la-cutlery:before {
  content: "\\f2e7";
}

.la.la-file-text-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-text-o:before {
  content: "\\f15c";
}

.la.la-building-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-building-o:before {
  content: "\\f1ad";
}

.la.la-hospital-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hospital-o:before {
  content: "\\f0f8";
}

.la.la-tablet:before {
  content: "\\f3fa";
}

.la.la-mobile:before {
  content: "\\f3cd";
}

.la.la-mobile-phone:before {
  content: "\\f3cd";
}

.la.la-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-circle-o:before {
  content: "\\f111";
}

.la.la-mail-reply:before {
  content: "\\f3e5";
}

.la.la-github-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-folder-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-folder-o:before {
  content: "\\f07b";
}

.la.la-folder-open-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-folder-open-o:before {
  content: "\\f07c";
}

.la.la-smile-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-smile-o:before {
  content: "\\f118";
}

.la.la-frown-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-frown-o:before {
  content: "\\f119";
}

.la.la-meh-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-meh-o:before {
  content: "\\f11a";
}

.la.la-keyboard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-keyboard-o:before {
  content: "\\f11c";
}

.la.la-flag-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-flag-o:before {
  content: "\\f024";
}

.la.la-mail-reply-all:before {
  content: "\\f122";
}

.la.la-star-half-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-o:before {
  content: "\\f089";
}

.la.la-star-half-empty {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-empty:before {
  content: "\\f089";
}

.la.la-star-half-full {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-full:before {
  content: "\\f089";
}

.la.la-code-fork:before {
  content: "\\f126";
}

.la.la-chain-broken:before {
  content: "\\f127";
}

.la.la-shield:before {
  content: "\\f3ed";
}

.la.la-calendar-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-o:before {
  content: "\\f133";
}

.la.la-maxcdn {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-html5 {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-css3 {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ticket:before {
  content: "\\f3ff";
}

.la.la-minus-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-minus-square-o:before {
  content: "\\f146";
}

.la.la-level-up:before {
  content: "\\f3bf";
}

.la.la-level-down:before {
  content: "\\f3be";
}

.la.la-pencil-square:before {
  content: "\\f14b";
}

.la.la-external-link-square:before {
  content: "\\f360";
}

.la.la-compass {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-down:before {
  content: "\\f150";
}

.la.la-toggle-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-down:before {
  content: "\\f150";
}

.la.la-caret-square-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-up:before {
  content: "\\f151";
}

.la.la-toggle-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-up:before {
  content: "\\f151";
}

.la.la-caret-square-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-right:before {
  content: "\\f152";
}

.la.la-toggle-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-right:before {
  content: "\\f152";
}

.la.la-eur:before {
  content: "\\f153";
}

.la.la-euro:before {
  content: "\\f153";
}

.la.la-gbp:before {
  content: "\\f154";
}

.la.la-usd:before {
  content: "\\f155";
}

.la.la-dollar:before {
  content: "\\f155";
}

.la.la-inr:before {
  content: "\\f156";
}

.la.la-rupee:before {
  content: "\\f156";
}

.la.la-jpy:before {
  content: "\\f157";
}

.la.la-cny:before {
  content: "\\f157";
}

.la.la-rmb:before {
  content: "\\f157";
}

.la.la-yen:before {
  content: "\\f157";
}

.la.la-rub:before {
  content: "\\f158";
}

.la.la-ruble:before {
  content: "\\f158";
}

.la.la-rouble:before {
  content: "\\f158";
}

.la.la-krw:before {
  content: "\\f159";
}

.la.la-won:before {
  content: "\\f159";
}

.la.la-btc {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitcoin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitcoin:before {
  content: "\\f15a";
}

.la.la-file-text:before {
  content: "\\f15c";
}

.la.la-sort-alpha-asc:before {
  content: "\\f15d";
}

.la.la-sort-alpha-desc:before {
  content: "\\f881";
}

.la.la-sort-amount-asc:before {
  content: "\\f160";
}

.la.la-sort-amount-desc:before {
  content: "\\f884";
}

.la.la-sort-numeric-asc:before {
  content: "\\f162";
}

.la.la-sort-numeric-desc:before {
  content: "\\f886";
}

.la.la-youtube-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-xing {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-xing-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube-play {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube-play:before {
  content: "\\f167";
}

.la.la-dropbox {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stack-overflow {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-instagram {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-flickr {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-adn {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket-square:before {
  content: "\\f171";
}

.la.la-tumblr {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-tumblr-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-long-arrow-down:before {
  content: "\\f309";
}

.la.la-long-arrow-up:before {
  content: "\\f30c";
}

.la.la-long-arrow-left:before {
  content: "\\f30a";
}

.la.la-long-arrow-right:before {
  content: "\\f30b";
}

.la.la-apple {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-windows {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-android {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linux {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-dribbble {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-skype {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-foursquare {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-trello {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gratipay {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gittip {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gittip:before {
  content: "\\f184";
}

.la.la-sun-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sun-o:before {
  content: "\\f185";
}

.la.la-moon-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-moon-o:before {
  content: "\\f186";
}

.la.la-vk {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-weibo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-renren {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pagelines {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stack-exchange {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-arrow-circle-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-right:before {
  content: "\\f35a";
}

.la.la-arrow-circle-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-left:before {
  content: "\\f359";
}

.la.la-caret-square-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-left:before {
  content: "\\f191";
}

.la.la-toggle-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-left:before {
  content: "\\f191";
}

.la.la-dot-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-dot-circle-o:before {
  content: "\\f192";
}

.la.la-vimeo-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-try:before {
  content: "\\f195";
}

.la.la-turkish-lira:before {
  content: "\\f195";
}

.la.la-plus-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-plus-square-o:before {
  content: "\\f0fe";
}

.la.la-slack {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wordpress {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-openid {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-institution:before {
  content: "\\f19c";
}

.la.la-bank:before {
  content: "\\f19c";
}

.la.la-mortar-board:before {
  content: "\\f19d";
}

.la.la-yahoo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stumbleupon-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stumbleupon {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-delicious {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-digg {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper-pp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-drupal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-joomla {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-spoon:before {
  content: "\\f2e5";
}

.la.la-behance {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-behance-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-steam {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-steam-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-automobile:before {
  content: "\\f1b9";
}

.la.la-cab:before {
  content: "\\f1ba";
}

.la.la-envelope-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-envelope-o:before {
  content: "\\f0e0";
}

.la.la-deviantart {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-soundcloud {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-file-pdf-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-pdf-o:before {
  content: "\\f1c1";
}

.la.la-file-word-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-word-o:before {
  content: "\\f1c2";
}

.la.la-file-excel-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-excel-o:before {
  content: "\\f1c3";
}

.la.la-file-powerpoint-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-powerpoint-o:before {
  content: "\\f1c4";
}

.la.la-file-image-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-image-o:before {
  content: "\\f1c5";
}

.la.la-file-photo-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-photo-o:before {
  content: "\\f1c5";
}

.la.la-file-picture-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-picture-o:before {
  content: "\\f1c5";
}

.la.la-file-archive-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-archive-o:before {
  content: "\\f1c6";
}

.la.la-file-zip-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-zip-o:before {
  content: "\\f1c6";
}

.la.la-file-audio-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-audio-o:before {
  content: "\\f1c7";
}

.la.la-file-sound-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-sound-o:before {
  content: "\\f1c7";
}

.la.la-file-video-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-video-o:before {
  content: "\\f1c8";
}

.la.la-file-movie-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-movie-o:before {
  content: "\\f1c8";
}

.la.la-file-code-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-code-o:before {
  content: "\\f1c9";
}

.la.la-vine {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-codepen {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-jsfiddle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-life-ring {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-bouy {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-bouy:before {
  content: "\\f1cd";
}

.la.la-life-buoy {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-buoy:before {
  content: "\\f1cd";
}

.la.la-life-saver {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-saver:before {
  content: "\\f1cd";
}

.la.la-support {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-support:before {
  content: "\\f1cd";
}

.la.la-circle-o-notch:before {
  content: "\\f1ce";
}

.la.la-rebel {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ra {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ra:before {
  content: "\\f1d0";
}

.la.la-resistance {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-resistance:before {
  content: "\\f1d0";
}

.la.la-empire {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ge {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ge:before {
  content: "\\f1d1";
}

.la.la-git-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-git {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-hacker-news {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator-square:before {
  content: "\\f1d4";
}

.la.la-yc-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc-square:before {
  content: "\\f1d4";
}

.la.la-tencent-weibo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-qq {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-weixin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wechat {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wechat:before {
  content: "\\f1d7";
}

.la.la-send:before {
  content: "\\f1d8";
}

.la.la-paper-plane-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paper-plane-o:before {
  content: "\\f1d8";
}

.la.la-send-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-send-o:before {
  content: "\\f1d8";
}

.la.la-circle-thin {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-circle-thin:before {
  content: "\\f111";
}

.la.la-header:before {
  content: "\\f1dc";
}

.la.la-sliders:before {
  content: "\\f1de";
}

.la.la-futbol-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-futbol-o:before {
  content: "\\f1e3";
}

.la.la-soccer-ball-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-soccer-ball-o:before {
  content: "\\f1e3";
}

.la.la-slideshare {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-twitch {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yelp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-newspaper-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-newspaper-o:before {
  content: "\\f1ea";
}

.la.la-paypal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-wallet {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-visa {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-mastercard {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-discover {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-amex {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-paypal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-stripe {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bell-slash-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bell-slash-o:before {
  content: "\\f1f6";
}

.la.la-trash:before {
  content: "\\f2ed";
}

.la.la-copyright {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-eyedropper:before {
  content: "\\f1fb";
}

.la.la-area-chart:before {
  content: "\\f1fe";
}

.la.la-pie-chart:before {
  content: "\\f200";
}

.la.la-line-chart:before {
  content: "\\f201";
}

.la.la-lastfm {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-lastfm-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ioxhost {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-angellist {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-cc:before {
  content: "\\f20a";
}

.la.la-ils:before {
  content: "\\f20b";
}

.la.la-shekel:before {
  content: "\\f20b";
}

.la.la-sheqel:before {
  content: "\\f20b";
}

.la.la-meanpath {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-meanpath:before {
  content: "\\f2b4";
}

.la.la-buysellads {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-connectdevelop {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-dashcube {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-forumbee {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-leanpub {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-sellsy {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-shirtsinbulk {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-simplybuilt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-skyatlas {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-diamond {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-diamond:before {
  content: "\\f3a5";
}

.la.la-intersex:before {
  content: "\\f224";
}

.la.la-facebook-official {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-official:before {
  content: "\\f09a";
}

.la.la-pinterest-p {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-whatsapp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-hotel:before {
  content: "\\f236";
}

.la.la-viacoin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-medium {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc:before {
  content: "\\f23b";
}

.la.la-optin-monster {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-opencart {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-expeditedssl {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-battery-4:before {
  content: "\\f240";
}

.la.la-battery:before {
  content: "\\f240";
}

.la.la-battery-3:before {
  content: "\\f241";
}

.la.la-battery-2:before {
  content: "\\f242";
}

.la.la-battery-1:before {
  content: "\\f243";
}

.la.la-battery-0:before {
  content: "\\f244";
}

.la.la-object-group {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-object-ungroup {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sticky-note-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sticky-note-o:before {
  content: "\\f249";
}

.la.la-cc-jcb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-diners-club {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-clone {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hourglass-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hourglass-o:before {
  content: "\\f254";
}

.la.la-hourglass-1:before {
  content: "\\f251";
}

.la.la-hourglass-2:before {
  content: "\\f252";
}

.la.la-hourglass-3:before {
  content: "\\f253";
}

.la.la-hand-rock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-rock-o:before {
  content: "\\f255";
}

.la.la-hand-grab-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-grab-o:before {
  content: "\\f255";
}

.la.la-hand-paper-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-paper-o:before {
  content: "\\f256";
}

.la.la-hand-stop-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-stop-o:before {
  content: "\\f256";
}

.la.la-hand-scissors-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-scissors-o:before {
  content: "\\f257";
}

.la.la-hand-lizard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-lizard-o:before {
  content: "\\f258";
}

.la.la-hand-spock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-spock-o:before {
  content: "\\f259";
}

.la.la-hand-pointer-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-pointer-o:before {
  content: "\\f25a";
}

.la.la-hand-peace-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-peace-o:before {
  content: "\\f25b";
}

.la.la-registered {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-creative-commons {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gg {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gg-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-tripadvisor {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-odnoklassniki {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-odnoklassniki-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-get-pocket {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wikipedia-w {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-safari {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-chrome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-firefox {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-opera {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-internet-explorer {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-television:before {
  content: "\\f26c";
}

.la.la-contao {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-500px {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-amazon {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-calendar-plus-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-plus-o:before {
  content: "\\f271";
}

.la.la-calendar-minus-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-minus-o:before {
  content: "\\f272";
}

.la.la-calendar-times-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-times-o:before {
  content: "\\f273";
}

.la.la-calendar-check-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-check-o:before {
  content: "\\f274";
}

.la.la-map-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-map-o:before {
  content: "\\f279";
}

.la.la-commenting:before {
  content: "\\f4ad";
}

.la.la-commenting-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-commenting-o:before {
  content: "\\f4ad";
}

.la.la-houzz {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-vimeo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-vimeo:before {
  content: "\\f27d";
}

.la.la-black-tie {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fonticons {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit-alien {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-edge {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-credit-card-alt:before {
  content: "\\f09d";
}

.la.la-codiepie {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-modx {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fort-awesome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-usb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-product-hunt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-mixcloud {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-scribd {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pause-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-pause-circle-o:before {
  content: "\\f28b";
}

.la.la-stop-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-stop-circle-o:before {
  content: "\\f28d";
}

.la.la-bluetooth {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bluetooth-b {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gitlab {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpbeginner {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpforms {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-envira {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wheelchair-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wheelchair-alt:before {
  content: "\\f368";
}

.la.la-question-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-question-circle-o:before {
  content: "\\f059";
}

.la.la-volume-control-phone:before {
  content: "\\f2a0";
}

.la.la-asl-interpreting:before {
  content: "\\f2a3";
}

.la.la-deafness:before {
  content: "\\f2a4";
}

.la.la-hard-of-hearing:before {
  content: "\\f2a4";
}

.la.la-glide {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-glide-g {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-signing:before {
  content: "\\f2a7";
}

.la.la-viadeo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-viadeo-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat-ghost {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-first-order {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yoast {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-themeisle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-official {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-official:before {
  content: "\\f2b3";
}

.la.la-google-plus-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-circle:before {
  content: "\\f2b3";
}

.la.la-font-awesome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fa {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fa:before {
  content: "\\f2b4";
}

.la.la-handshake-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-handshake-o:before {
  content: "\\f2b5";
}

.la.la-envelope-open-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-envelope-open-o:before {
  content: "\\f2b6";
}

.la.la-linode {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-address-book-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-address-book-o:before {
  content: "\\f2b9";
}

.la.la-vcard:before {
  content: "\\f2bb";
}

.la.la-address-card-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-address-card-o:before {
  content: "\\f2bb";
}

.la.la-vcard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-vcard-o:before {
  content: "\\f2bb";
}

.la.la-user-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-user-circle-o:before {
  content: "\\f2bd";
}

.la.la-user-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-user-o:before {
  content: "\\f007";
}

.la.la-id-badge {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-drivers-license:before {
  content: "\\f2c2";
}

.la.la-id-card-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-id-card-o:before {
  content: "\\f2c2";
}

.la.la-drivers-license-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-drivers-license-o:before {
  content: "\\f2c2";
}

.la.la-quora {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-free-code-camp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-telegram {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-thermometer-4:before {
  content: "\\f2c7";
}

.la.la-thermometer:before {
  content: "\\f2c7";
}

.la.la-thermometer-3:before {
  content: "\\f2c8";
}

.la.la-thermometer-2:before {
  content: "\\f2c9";
}

.la.la-thermometer-1:before {
  content: "\\f2ca";
}

.la.la-thermometer-0:before {
  content: "\\f2cb";
}

.la.la-bathtub:before {
  content: "\\f2cd";
}

.la.la-s15:before {
  content: "\\f2cd";
}

.la.la-window-maximize {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-window-restore {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-rectangle:before {
  content: "\\f410";
}

.la.la-window-close-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-window-close-o:before {
  content: "\\f410";
}

.la.la-times-rectangle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-rectangle-o:before {
  content: "\\f410";
}

.la.la-bandcamp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-grav {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-etsy {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-imdb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ravelry {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-eercast {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-eercast:before {
  content: "\\f2da";
}

.la.la-snowflake-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-snowflake-o:before {
  content: "\\f2dc";
}

.la.la-superpowers {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpexplorer {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-spotify {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

/*
* Remix Icon v2.5.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-05-23
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}); /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg"); /* iOS 4.1- */
  font-display: swap;
}
[class^=ri-], [class*=" ri-"] {
  font-family: "remixicon" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -0.075em;
}

.ri-xxs {
  font-size: 0.5em;
}

.ri-xs {
  font-size: 0.75em;
}

.ri-sm {
  font-size: 0.875em;
}

.ri-1x {
  font-size: 1em;
}

.ri-2x {
  font-size: 2em;
}

.ri-3x {
  font-size: 3em;
}

.ri-4x {
  font-size: 4em;
}

.ri-5x {
  font-size: 5em;
}

.ri-6x {
  font-size: 6em;
}

.ri-7x {
  font-size: 7em;
}

.ri-8x {
  font-size: 8em;
}

.ri-9x {
  font-size: 9em;
}

.ri-10x {
  font-size: 10em;
}

.ri-fw {
  text-align: center;
  width: 1.25em;
}

.ri-24-hours-fill:before {
  content: "\\ea01";
}

.ri-24-hours-line:before {
  content: "\\ea02";
}

.ri-4k-fill:before {
  content: "\\ea03";
}

.ri-4k-line:before {
  content: "\\ea04";
}

.ri-a-b:before {
  content: "\\ea05";
}

.ri-account-box-fill:before {
  content: "\\ea06";
}

.ri-account-box-line:before {
  content: "\\ea07";
}

.ri-account-circle-fill:before {
  content: "\\ea08";
}

.ri-account-circle-line:before {
  content: "\\ea09";
}

.ri-account-pin-box-fill:before {
  content: "\\ea0a";
}

.ri-account-pin-box-line:before {
  content: "\\ea0b";
}

.ri-account-pin-circle-fill:before {
  content: "\\ea0c";
}

.ri-account-pin-circle-line:before {
  content: "\\ea0d";
}

.ri-add-box-fill:before {
  content: "\\ea0e";
}

.ri-add-box-line:before {
  content: "\\ea0f";
}

.ri-add-circle-fill:before {
  content: "\\ea10";
}

.ri-add-circle-line:before {
  content: "\\ea11";
}

.ri-add-fill:before {
  content: "\\ea12";
}

.ri-add-line:before {
  content: "\\ea13";
}

.ri-admin-fill:before {
  content: "\\ea14";
}

.ri-admin-line:before {
  content: "\\ea15";
}

.ri-advertisement-fill:before {
  content: "\\ea16";
}

.ri-advertisement-line:before {
  content: "\\ea17";
}

.ri-airplay-fill:before {
  content: "\\ea18";
}

.ri-airplay-line:before {
  content: "\\ea19";
}

.ri-alarm-fill:before {
  content: "\\ea1a";
}

.ri-alarm-line:before {
  content: "\\ea1b";
}

.ri-alarm-warning-fill:before {
  content: "\\ea1c";
}

.ri-alarm-warning-line:before {
  content: "\\ea1d";
}

.ri-album-fill:before {
  content: "\\ea1e";
}

.ri-album-line:before {
  content: "\\ea1f";
}

.ri-alert-fill:before {
  content: "\\ea20";
}

.ri-alert-line:before {
  content: "\\ea21";
}

.ri-aliens-fill:before {
  content: "\\ea22";
}

.ri-aliens-line:before {
  content: "\\ea23";
}

.ri-align-bottom:before {
  content: "\\ea24";
}

.ri-align-center:before {
  content: "\\ea25";
}

.ri-align-justify:before {
  content: "\\ea26";
}

.ri-align-left:before {
  content: "\\ea27";
}

.ri-align-right:before {
  content: "\\ea28";
}

.ri-align-top:before {
  content: "\\ea29";
}

.ri-align-vertically:before {
  content: "\\ea2a";
}

.ri-alipay-fill:before {
  content: "\\ea2b";
}

.ri-alipay-line:before {
  content: "\\ea2c";
}

.ri-amazon-fill:before {
  content: "\\ea2d";
}

.ri-amazon-line:before {
  content: "\\ea2e";
}

.ri-anchor-fill:before {
  content: "\\ea2f";
}

.ri-anchor-line:before {
  content: "\\ea30";
}

.ri-ancient-gate-fill:before {
  content: "\\ea31";
}

.ri-ancient-gate-line:before {
  content: "\\ea32";
}

.ri-ancient-pavilion-fill:before {
  content: "\\ea33";
}

.ri-ancient-pavilion-line:before {
  content: "\\ea34";
}

.ri-android-fill:before {
  content: "\\ea35";
}

.ri-android-line:before {
  content: "\\ea36";
}

.ri-angularjs-fill:before {
  content: "\\ea37";
}

.ri-angularjs-line:before {
  content: "\\ea38";
}

.ri-anticlockwise-2-fill:before {
  content: "\\ea39";
}

.ri-anticlockwise-2-line:before {
  content: "\\ea3a";
}

.ri-anticlockwise-fill:before {
  content: "\\ea3b";
}

.ri-anticlockwise-line:before {
  content: "\\ea3c";
}

.ri-app-store-fill:before {
  content: "\\ea3d";
}

.ri-app-store-line:before {
  content: "\\ea3e";
}

.ri-apple-fill:before {
  content: "\\ea3f";
}

.ri-apple-line:before {
  content: "\\ea40";
}

.ri-apps-2-fill:before {
  content: "\\ea41";
}

.ri-apps-2-line:before {
  content: "\\ea42";
}

.ri-apps-fill:before {
  content: "\\ea43";
}

.ri-apps-line:before {
  content: "\\ea44";
}

.ri-archive-drawer-fill:before {
  content: "\\ea45";
}

.ri-archive-drawer-line:before {
  content: "\\ea46";
}

.ri-archive-fill:before {
  content: "\\ea47";
}

.ri-archive-line:before {
  content: "\\ea48";
}

.ri-arrow-down-circle-fill:before {
  content: "\\ea49";
}

.ri-arrow-down-circle-line:before {
  content: "\\ea4a";
}

.ri-arrow-down-fill:before {
  content: "\\ea4b";
}

.ri-arrow-down-line:before {
  content: "\\ea4c";
}

.ri-arrow-down-s-fill:before {
  content: "\\ea4d";
}

.ri-arrow-down-s-line:before {
  content: "\\ea4e";
}

.ri-arrow-drop-down-fill:before {
  content: "\\ea4f";
}

.ri-arrow-drop-down-line:before {
  content: "\\ea50";
}

.ri-arrow-drop-left-fill:before {
  content: "\\ea51";
}

.ri-arrow-drop-left-line:before {
  content: "\\ea52";
}

.ri-arrow-drop-right-fill:before {
  content: "\\ea53";
}

.ri-arrow-drop-right-line:before {
  content: "\\ea54";
}

.ri-arrow-drop-up-fill:before {
  content: "\\ea55";
}

.ri-arrow-drop-up-line:before {
  content: "\\ea56";
}

.ri-arrow-go-back-fill:before {
  content: "\\ea57";
}

.ri-arrow-go-back-line:before {
  content: "\\ea58";
}

.ri-arrow-go-forward-fill:before {
  content: "\\ea59";
}

.ri-arrow-go-forward-line:before {
  content: "\\ea5a";
}

.ri-arrow-left-circle-fill:before {
  content: "\\ea5b";
}

.ri-arrow-left-circle-line:before {
  content: "\\ea5c";
}

.ri-arrow-left-down-fill:before {
  content: "\\ea5d";
}

.ri-arrow-left-down-line:before {
  content: "\\ea5e";
}

.ri-arrow-left-fill:before {
  content: "\\ea5f";
}

.ri-arrow-left-line:before {
  content: "\\ea60";
}

.ri-arrow-left-right-fill:before {
  content: "\\ea61";
}

.ri-arrow-left-right-line:before {
  content: "\\ea62";
}

.ri-arrow-left-s-fill:before {
  content: "\\ea63";
}

.ri-arrow-left-s-line:before {
  content: "\\ea64";
}

.ri-arrow-left-up-fill:before {
  content: "\\ea65";
}

.ri-arrow-left-up-line:before {
  content: "\\ea66";
}

.ri-arrow-right-circle-fill:before {
  content: "\\ea67";
}

.ri-arrow-right-circle-line:before {
  content: "\\ea68";
}

.ri-arrow-right-down-fill:before {
  content: "\\ea69";
}

.ri-arrow-right-down-line:before {
  content: "\\ea6a";
}

.ri-arrow-right-fill:before {
  content: "\\ea6b";
}

.ri-arrow-right-line:before {
  content: "\\ea6c";
}

.ri-arrow-right-s-fill:before {
  content: "\\ea6d";
}

.ri-arrow-right-s-line:before {
  content: "\\ea6e";
}

.ri-arrow-right-up-fill:before {
  content: "\\ea6f";
}

.ri-arrow-right-up-line:before {
  content: "\\ea70";
}

.ri-arrow-up-circle-fill:before {
  content: "\\ea71";
}

.ri-arrow-up-circle-line:before {
  content: "\\ea72";
}

.ri-arrow-up-down-fill:before {
  content: "\\ea73";
}

.ri-arrow-up-down-line:before {
  content: "\\ea74";
}

.ri-arrow-up-fill:before {
  content: "\\ea75";
}

.ri-arrow-up-line:before {
  content: "\\ea76";
}

.ri-arrow-up-s-fill:before {
  content: "\\ea77";
}

.ri-arrow-up-s-line:before {
  content: "\\ea78";
}

.ri-artboard-2-fill:before {
  content: "\\ea79";
}

.ri-artboard-2-line:before {
  content: "\\ea7a";
}

.ri-artboard-fill:before {
  content: "\\ea7b";
}

.ri-artboard-line:before {
  content: "\\ea7c";
}

.ri-article-fill:before {
  content: "\\ea7d";
}

.ri-article-line:before {
  content: "\\ea7e";
}

.ri-aspect-ratio-fill:before {
  content: "\\ea7f";
}

.ri-aspect-ratio-line:before {
  content: "\\ea80";
}

.ri-asterisk:before {
  content: "\\ea81";
}

.ri-at-fill:before {
  content: "\\ea82";
}

.ri-at-line:before {
  content: "\\ea83";
}

.ri-attachment-2:before {
  content: "\\ea84";
}

.ri-attachment-fill:before {
  content: "\\ea85";
}

.ri-attachment-line:before {
  content: "\\ea86";
}

.ri-auction-fill:before {
  content: "\\ea87";
}

.ri-auction-line:before {
  content: "\\ea88";
}

.ri-award-fill:before {
  content: "\\ea89";
}

.ri-award-line:before {
  content: "\\ea8a";
}

.ri-baidu-fill:before {
  content: "\\ea8b";
}

.ri-baidu-line:before {
  content: "\\ea8c";
}

.ri-ball-pen-fill:before {
  content: "\\ea8d";
}

.ri-ball-pen-line:before {
  content: "\\ea8e";
}

.ri-bank-card-2-fill:before {
  content: "\\ea8f";
}

.ri-bank-card-2-line:before {
  content: "\\ea90";
}

.ri-bank-card-fill:before {
  content: "\\ea91";
}

.ri-bank-card-line:before {
  content: "\\ea92";
}

.ri-bank-fill:before {
  content: "\\ea93";
}

.ri-bank-line:before {
  content: "\\ea94";
}

.ri-bar-chart-2-fill:before {
  content: "\\ea95";
}

.ri-bar-chart-2-line:before {
  content: "\\ea96";
}

.ri-bar-chart-box-fill:before {
  content: "\\ea97";
}

.ri-bar-chart-box-line:before {
  content: "\\ea98";
}

.ri-bar-chart-fill:before {
  content: "\\ea99";
}

.ri-bar-chart-grouped-fill:before {
  content: "\\ea9a";
}

.ri-bar-chart-grouped-line:before {
  content: "\\ea9b";
}

.ri-bar-chart-horizontal-fill:before {
  content: "\\ea9c";
}

.ri-bar-chart-horizontal-line:before {
  content: "\\ea9d";
}

.ri-bar-chart-line:before {
  content: "\\ea9e";
}

.ri-barcode-box-fill:before {
  content: "\\ea9f";
}

.ri-barcode-box-line:before {
  content: "\\eaa0";
}

.ri-barcode-fill:before {
  content: "\\eaa1";
}

.ri-barcode-line:before {
  content: "\\eaa2";
}

.ri-barricade-fill:before {
  content: "\\eaa3";
}

.ri-barricade-line:before {
  content: "\\eaa4";
}

.ri-base-station-fill:before {
  content: "\\eaa5";
}

.ri-base-station-line:before {
  content: "\\eaa6";
}

.ri-basketball-fill:before {
  content: "\\eaa7";
}

.ri-basketball-line:before {
  content: "\\eaa8";
}

.ri-battery-2-charge-fill:before {
  content: "\\eaa9";
}

.ri-battery-2-charge-line:before {
  content: "\\eaaa";
}

.ri-battery-2-fill:before {
  content: "\\eaab";
}

.ri-battery-2-line:before {
  content: "\\eaac";
}

.ri-battery-charge-fill:before {
  content: "\\eaad";
}

.ri-battery-charge-line:before {
  content: "\\eaae";
}

.ri-battery-fill:before {
  content: "\\eaaf";
}

.ri-battery-line:before {
  content: "\\eab0";
}

.ri-battery-low-fill:before {
  content: "\\eab1";
}

.ri-battery-low-line:before {
  content: "\\eab2";
}

.ri-battery-saver-fill:before {
  content: "\\eab3";
}

.ri-battery-saver-line:before {
  content: "\\eab4";
}

.ri-battery-share-fill:before {
  content: "\\eab5";
}

.ri-battery-share-line:before {
  content: "\\eab6";
}

.ri-bear-smile-fill:before {
  content: "\\eab7";
}

.ri-bear-smile-line:before {
  content: "\\eab8";
}

.ri-behance-fill:before {
  content: "\\eab9";
}

.ri-behance-line:before {
  content: "\\eaba";
}

.ri-bell-fill:before {
  content: "\\eabb";
}

.ri-bell-line:before {
  content: "\\eabc";
}

.ri-bike-fill:before {
  content: "\\eabd";
}

.ri-bike-line:before {
  content: "\\eabe";
}

.ri-bilibili-fill:before {
  content: "\\eabf";
}

.ri-bilibili-line:before {
  content: "\\eac0";
}

.ri-bill-fill:before {
  content: "\\eac1";
}

.ri-bill-line:before {
  content: "\\eac2";
}

.ri-billiards-fill:before {
  content: "\\eac3";
}

.ri-billiards-line:before {
  content: "\\eac4";
}

.ri-bit-coin-fill:before {
  content: "\\eac5";
}

.ri-bit-coin-line:before {
  content: "\\eac6";
}

.ri-blaze-fill:before {
  content: "\\eac7";
}

.ri-blaze-line:before {
  content: "\\eac8";
}

.ri-bluetooth-connect-fill:before {
  content: "\\eac9";
}

.ri-bluetooth-connect-line:before {
  content: "\\eaca";
}

.ri-bluetooth-fill:before {
  content: "\\eacb";
}

.ri-bluetooth-line:before {
  content: "\\eacc";
}

.ri-blur-off-fill:before {
  content: "\\eacd";
}

.ri-blur-off-line:before {
  content: "\\eace";
}

.ri-body-scan-fill:before {
  content: "\\eacf";
}

.ri-body-scan-line:before {
  content: "\\ead0";
}

.ri-bold:before {
  content: "\\ead1";
}

.ri-book-2-fill:before {
  content: "\\ead2";
}

.ri-book-2-line:before {
  content: "\\ead3";
}

.ri-book-3-fill:before {
  content: "\\ead4";
}

.ri-book-3-line:before {
  content: "\\ead5";
}

.ri-book-fill:before {
  content: "\\ead6";
}

.ri-book-line:before {
  content: "\\ead7";
}

.ri-book-mark-fill:before {
  content: "\\ead8";
}

.ri-book-mark-line:before {
  content: "\\ead9";
}

.ri-book-open-fill:before {
  content: "\\eada";
}

.ri-book-open-line:before {
  content: "\\eadb";
}

.ri-book-read-fill:before {
  content: "\\eadc";
}

.ri-book-read-line:before {
  content: "\\eadd";
}

.ri-booklet-fill:before {
  content: "\\eade";
}

.ri-booklet-line:before {
  content: "\\eadf";
}

.ri-bookmark-2-fill:before {
  content: "\\eae0";
}

.ri-bookmark-2-line:before {
  content: "\\eae1";
}

.ri-bookmark-3-fill:before {
  content: "\\eae2";
}

.ri-bookmark-3-line:before {
  content: "\\eae3";
}

.ri-bookmark-fill:before {
  content: "\\eae4";
}

.ri-bookmark-line:before {
  content: "\\eae5";
}

.ri-boxing-fill:before {
  content: "\\eae6";
}

.ri-boxing-line:before {
  content: "\\eae7";
}

.ri-braces-fill:before {
  content: "\\eae8";
}

.ri-braces-line:before {
  content: "\\eae9";
}

.ri-brackets-fill:before {
  content: "\\eaea";
}

.ri-brackets-line:before {
  content: "\\eaeb";
}

.ri-briefcase-2-fill:before {
  content: "\\eaec";
}

.ri-briefcase-2-line:before {
  content: "\\eaed";
}

.ri-briefcase-3-fill:before {
  content: "\\eaee";
}

.ri-briefcase-3-line:before {
  content: "\\eaef";
}

.ri-briefcase-4-fill:before {
  content: "\\eaf0";
}

.ri-briefcase-4-line:before {
  content: "\\eaf1";
}

.ri-briefcase-5-fill:before {
  content: "\\eaf2";
}

.ri-briefcase-5-line:before {
  content: "\\eaf3";
}

.ri-briefcase-fill:before {
  content: "\\eaf4";
}

.ri-briefcase-line:before {
  content: "\\eaf5";
}

.ri-bring-forward:before {
  content: "\\eaf6";
}

.ri-bring-to-front:before {
  content: "\\eaf7";
}

.ri-broadcast-fill:before {
  content: "\\eaf8";
}

.ri-broadcast-line:before {
  content: "\\eaf9";
}

.ri-brush-2-fill:before {
  content: "\\eafa";
}

.ri-brush-2-line:before {
  content: "\\eafb";
}

.ri-brush-3-fill:before {
  content: "\\eafc";
}

.ri-brush-3-line:before {
  content: "\\eafd";
}

.ri-brush-4-fill:before {
  content: "\\eafe";
}

.ri-brush-4-line:before {
  content: "\\eaff";
}

.ri-brush-fill:before {
  content: "\\eb00";
}

.ri-brush-line:before {
  content: "\\eb01";
}

.ri-bubble-chart-fill:before {
  content: "\\eb02";
}

.ri-bubble-chart-line:before {
  content: "\\eb03";
}

.ri-bug-2-fill:before {
  content: "\\eb04";
}

.ri-bug-2-line:before {
  content: "\\eb05";
}

.ri-bug-fill:before {
  content: "\\eb06";
}

.ri-bug-line:before {
  content: "\\eb07";
}

.ri-building-2-fill:before {
  content: "\\eb08";
}

.ri-building-2-line:before {
  content: "\\eb09";
}

.ri-building-3-fill:before {
  content: "\\eb0a";
}

.ri-building-3-line:before {
  content: "\\eb0b";
}

.ri-building-4-fill:before {
  content: "\\eb0c";
}

.ri-building-4-line:before {
  content: "\\eb0d";
}

.ri-building-fill:before {
  content: "\\eb0e";
}

.ri-building-line:before {
  content: "\\eb0f";
}

.ri-bus-2-fill:before {
  content: "\\eb10";
}

.ri-bus-2-line:before {
  content: "\\eb11";
}

.ri-bus-fill:before {
  content: "\\eb12";
}

.ri-bus-line:before {
  content: "\\eb13";
}

.ri-bus-wifi-fill:before {
  content: "\\eb14";
}

.ri-bus-wifi-line:before {
  content: "\\eb15";
}

.ri-cactus-fill:before {
  content: "\\eb16";
}

.ri-cactus-line:before {
  content: "\\eb17";
}

.ri-cake-2-fill:before {
  content: "\\eb18";
}

.ri-cake-2-line:before {
  content: "\\eb19";
}

.ri-cake-3-fill:before {
  content: "\\eb1a";
}

.ri-cake-3-line:before {
  content: "\\eb1b";
}

.ri-cake-fill:before {
  content: "\\eb1c";
}

.ri-cake-line:before {
  content: "\\eb1d";
}

.ri-calculator-fill:before {
  content: "\\eb1e";
}

.ri-calculator-line:before {
  content: "\\eb1f";
}

.ri-calendar-2-fill:before {
  content: "\\eb20";
}

.ri-calendar-2-line:before {
  content: "\\eb21";
}

.ri-calendar-check-fill:before {
  content: "\\eb22";
}

.ri-calendar-check-line:before {
  content: "\\eb23";
}

.ri-calendar-event-fill:before {
  content: "\\eb24";
}

.ri-calendar-event-line:before {
  content: "\\eb25";
}

.ri-calendar-fill:before {
  content: "\\eb26";
}

.ri-calendar-line:before {
  content: "\\eb27";
}

.ri-calendar-todo-fill:before {
  content: "\\eb28";
}

.ri-calendar-todo-line:before {
  content: "\\eb29";
}

.ri-camera-2-fill:before {
  content: "\\eb2a";
}

.ri-camera-2-line:before {
  content: "\\eb2b";
}

.ri-camera-3-fill:before {
  content: "\\eb2c";
}

.ri-camera-3-line:before {
  content: "\\eb2d";
}

.ri-camera-fill:before {
  content: "\\eb2e";
}

.ri-camera-lens-fill:before {
  content: "\\eb2f";
}

.ri-camera-lens-line:before {
  content: "\\eb30";
}

.ri-camera-line:before {
  content: "\\eb31";
}

.ri-camera-off-fill:before {
  content: "\\eb32";
}

.ri-camera-off-line:before {
  content: "\\eb33";
}

.ri-camera-switch-fill:before {
  content: "\\eb34";
}

.ri-camera-switch-line:before {
  content: "\\eb35";
}

.ri-capsule-fill:before {
  content: "\\eb36";
}

.ri-capsule-line:before {
  content: "\\eb37";
}

.ri-car-fill:before {
  content: "\\eb38";
}

.ri-car-line:before {
  content: "\\eb39";
}

.ri-car-washing-fill:before {
  content: "\\eb3a";
}

.ri-car-washing-line:before {
  content: "\\eb3b";
}

.ri-caravan-fill:before {
  content: "\\eb3c";
}

.ri-caravan-line:before {
  content: "\\eb3d";
}

.ri-cast-fill:before {
  content: "\\eb3e";
}

.ri-cast-line:before {
  content: "\\eb3f";
}

.ri-cellphone-fill:before {
  content: "\\eb40";
}

.ri-cellphone-line:before {
  content: "\\eb41";
}

.ri-celsius-fill:before {
  content: "\\eb42";
}

.ri-celsius-line:before {
  content: "\\eb43";
}

.ri-centos-fill:before {
  content: "\\eb44";
}

.ri-centos-line:before {
  content: "\\eb45";
}

.ri-character-recognition-fill:before {
  content: "\\eb46";
}

.ri-character-recognition-line:before {
  content: "\\eb47";
}

.ri-charging-pile-2-fill:before {
  content: "\\eb48";
}

.ri-charging-pile-2-line:before {
  content: "\\eb49";
}

.ri-charging-pile-fill:before {
  content: "\\eb4a";
}

.ri-charging-pile-line:before {
  content: "\\eb4b";
}

.ri-chat-1-fill:before {
  content: "\\eb4c";
}

.ri-chat-1-line:before {
  content: "\\eb4d";
}

.ri-chat-2-fill:before {
  content: "\\eb4e";
}

.ri-chat-2-line:before {
  content: "\\eb4f";
}

.ri-chat-3-fill:before {
  content: "\\eb50";
}

.ri-chat-3-line:before {
  content: "\\eb51";
}

.ri-chat-4-fill:before {
  content: "\\eb52";
}

.ri-chat-4-line:before {
  content: "\\eb53";
}

.ri-chat-check-fill:before {
  content: "\\eb54";
}

.ri-chat-check-line:before {
  content: "\\eb55";
}

.ri-chat-delete-fill:before {
  content: "\\eb56";
}

.ri-chat-delete-line:before {
  content: "\\eb57";
}

.ri-chat-download-fill:before {
  content: "\\eb58";
}

.ri-chat-download-line:before {
  content: "\\eb59";
}

.ri-chat-follow-up-fill:before {
  content: "\\eb5a";
}

.ri-chat-follow-up-line:before {
  content: "\\eb5b";
}

.ri-chat-forward-fill:before {
  content: "\\eb5c";
}

.ri-chat-forward-line:before {
  content: "\\eb5d";
}

.ri-chat-heart-fill:before {
  content: "\\eb5e";
}

.ri-chat-heart-line:before {
  content: "\\eb5f";
}

.ri-chat-history-fill:before {
  content: "\\eb60";
}

.ri-chat-history-line:before {
  content: "\\eb61";
}

.ri-chat-new-fill:before {
  content: "\\eb62";
}

.ri-chat-new-line:before {
  content: "\\eb63";
}

.ri-chat-off-fill:before {
  content: "\\eb64";
}

.ri-chat-off-line:before {
  content: "\\eb65";
}

.ri-chat-poll-fill:before {
  content: "\\eb66";
}

.ri-chat-poll-line:before {
  content: "\\eb67";
}

.ri-chat-private-fill:before {
  content: "\\eb68";
}

.ri-chat-private-line:before {
  content: "\\eb69";
}

.ri-chat-quote-fill:before {
  content: "\\eb6a";
}

.ri-chat-quote-line:before {
  content: "\\eb6b";
}

.ri-chat-settings-fill:before {
  content: "\\eb6c";
}

.ri-chat-settings-line:before {
  content: "\\eb6d";
}

.ri-chat-smile-2-fill:before {
  content: "\\eb6e";
}

.ri-chat-smile-2-line:before {
  content: "\\eb6f";
}

.ri-chat-smile-3-fill:before {
  content: "\\eb70";
}

.ri-chat-smile-3-line:before {
  content: "\\eb71";
}

.ri-chat-smile-fill:before {
  content: "\\eb72";
}

.ri-chat-smile-line:before {
  content: "\\eb73";
}

.ri-chat-upload-fill:before {
  content: "\\eb74";
}

.ri-chat-upload-line:before {
  content: "\\eb75";
}

.ri-chat-voice-fill:before {
  content: "\\eb76";
}

.ri-chat-voice-line:before {
  content: "\\eb77";
}

.ri-check-double-fill:before {
  content: "\\eb78";
}

.ri-check-double-line:before {
  content: "\\eb79";
}

.ri-check-fill:before {
  content: "\\eb7a";
}

.ri-check-line:before {
  content: "\\eb7b";
}

.ri-checkbox-blank-circle-fill:before {
  content: "\\eb7c";
}

.ri-checkbox-blank-circle-line:before {
  content: "\\eb7d";
}

.ri-checkbox-blank-fill:before {
  content: "\\eb7e";
}

.ri-checkbox-blank-line:before {
  content: "\\eb7f";
}

.ri-checkbox-circle-fill:before {
  content: "\\eb80";
}

.ri-checkbox-circle-line:before {
  content: "\\eb81";
}

.ri-checkbox-fill:before {
  content: "\\eb82";
}

.ri-checkbox-indeterminate-fill:before {
  content: "\\eb83";
}

.ri-checkbox-indeterminate-line:before {
  content: "\\eb84";
}

.ri-checkbox-line:before {
  content: "\\eb85";
}

.ri-checkbox-multiple-blank-fill:before {
  content: "\\eb86";
}

.ri-checkbox-multiple-blank-line:before {
  content: "\\eb87";
}

.ri-checkbox-multiple-fill:before {
  content: "\\eb88";
}

.ri-checkbox-multiple-line:before {
  content: "\\eb89";
}

.ri-china-railway-fill:before {
  content: "\\eb8a";
}

.ri-china-railway-line:before {
  content: "\\eb8b";
}

.ri-chrome-fill:before {
  content: "\\eb8c";
}

.ri-chrome-line:before {
  content: "\\eb8d";
}

.ri-clapperboard-fill:before {
  content: "\\eb8e";
}

.ri-clapperboard-line:before {
  content: "\\eb8f";
}

.ri-clipboard-fill:before {
  content: "\\eb90";
}

.ri-clipboard-line:before {
  content: "\\eb91";
}

.ri-clockwise-2-fill:before {
  content: "\\eb92";
}

.ri-clockwise-2-line:before {
  content: "\\eb93";
}

.ri-clockwise-fill:before {
  content: "\\eb94";
}

.ri-clockwise-line:before {
  content: "\\eb95";
}

.ri-close-circle-fill:before {
  content: "\\eb96";
}

.ri-close-circle-line:before {
  content: "\\eb97";
}

.ri-close-fill:before {
  content: "\\eb98";
}

.ri-close-line:before {
  content: "\\eb99";
}

.ri-closed-captioning-fill:before {
  content: "\\eb9a";
}

.ri-closed-captioning-line:before {
  content: "\\eb9b";
}

.ri-cloud-fill:before {
  content: "\\eb9c";
}

.ri-cloud-line:before {
  content: "\\eb9d";
}

.ri-cloud-off-fill:before {
  content: "\\eb9e";
}

.ri-cloud-off-line:before {
  content: "\\eb9f";
}

.ri-cloud-windy-fill:before {
  content: "\\eba0";
}

.ri-cloud-windy-line:before {
  content: "\\eba1";
}

.ri-cloudy-2-fill:before {
  content: "\\eba2";
}

.ri-cloudy-2-line:before {
  content: "\\eba3";
}

.ri-cloudy-fill:before {
  content: "\\eba4";
}

.ri-cloudy-line:before {
  content: "\\eba5";
}

.ri-code-box-fill:before {
  content: "\\eba6";
}

.ri-code-box-line:before {
  content: "\\eba7";
}

.ri-code-fill:before {
  content: "\\eba8";
}

.ri-code-line:before {
  content: "\\eba9";
}

.ri-code-s-fill:before {
  content: "\\ebaa";
}

.ri-code-s-line:before {
  content: "\\ebab";
}

.ri-code-s-slash-fill:before {
  content: "\\ebac";
}

.ri-code-s-slash-line:before {
  content: "\\ebad";
}

.ri-code-view:before {
  content: "\\ebae";
}

.ri-codepen-fill:before {
  content: "\\ebaf";
}

.ri-codepen-line:before {
  content: "\\ebb0";
}

.ri-coin-fill:before {
  content: "\\ebb1";
}

.ri-coin-line:before {
  content: "\\ebb2";
}

.ri-coins-fill:before {
  content: "\\ebb3";
}

.ri-coins-line:before {
  content: "\\ebb4";
}

.ri-collage-fill:before {
  content: "\\ebb5";
}

.ri-collage-line:before {
  content: "\\ebb6";
}

.ri-command-fill:before {
  content: "\\ebb7";
}

.ri-command-line:before {
  content: "\\ebb8";
}

.ri-community-fill:before {
  content: "\\ebb9";
}

.ri-community-line:before {
  content: "\\ebba";
}

.ri-compass-2-fill:before {
  content: "\\ebbb";
}

.ri-compass-2-line:before {
  content: "\\ebbc";
}

.ri-compass-3-fill:before {
  content: "\\ebbd";
}

.ri-compass-3-line:before {
  content: "\\ebbe";
}

.ri-compass-4-fill:before {
  content: "\\ebbf";
}

.ri-compass-4-line:before {
  content: "\\ebc0";
}

.ri-compass-discover-fill:before {
  content: "\\ebc1";
}

.ri-compass-discover-line:before {
  content: "\\ebc2";
}

.ri-compass-fill:before {
  content: "\\ebc3";
}

.ri-compass-line:before {
  content: "\\ebc4";
}

.ri-compasses-2-fill:before {
  content: "\\ebc5";
}

.ri-compasses-2-line:before {
  content: "\\ebc6";
}

.ri-compasses-fill:before {
  content: "\\ebc7";
}

.ri-compasses-line:before {
  content: "\\ebc8";
}

.ri-computer-fill:before {
  content: "\\ebc9";
}

.ri-computer-line:before {
  content: "\\ebca";
}

.ri-contacts-book-2-fill:before {
  content: "\\ebcb";
}

.ri-contacts-book-2-line:before {
  content: "\\ebcc";
}

.ri-contacts-book-fill:before {
  content: "\\ebcd";
}

.ri-contacts-book-line:before {
  content: "\\ebce";
}

.ri-contacts-book-upload-fill:before {
  content: "\\ebcf";
}

.ri-contacts-book-upload-line:before {
  content: "\\ebd0";
}

.ri-contacts-fill:before {
  content: "\\ebd1";
}

.ri-contacts-line:before {
  content: "\\ebd2";
}

.ri-contrast-2-fill:before {
  content: "\\ebd3";
}

.ri-contrast-2-line:before {
  content: "\\ebd4";
}

.ri-contrast-drop-2-fill:before {
  content: "\\ebd5";
}

.ri-contrast-drop-2-line:before {
  content: "\\ebd6";
}

.ri-contrast-drop-fill:before {
  content: "\\ebd7";
}

.ri-contrast-drop-line:before {
  content: "\\ebd8";
}

.ri-contrast-fill:before {
  content: "\\ebd9";
}

.ri-contrast-line:before {
  content: "\\ebda";
}

.ri-copper-coin-fill:before {
  content: "\\ebdb";
}

.ri-copper-coin-line:before {
  content: "\\ebdc";
}

.ri-copper-diamond-fill:before {
  content: "\\ebdd";
}

.ri-copper-diamond-line:before {
  content: "\\ebde";
}

.ri-copyleft-fill:before {
  content: "\\ebdf";
}

.ri-copyleft-line:before {
  content: "\\ebe0";
}

.ri-copyright-fill:before {
  content: "\\ebe1";
}

.ri-copyright-line:before {
  content: "\\ebe2";
}

.ri-coreos-fill:before {
  content: "\\ebe3";
}

.ri-coreos-line:before {
  content: "\\ebe4";
}

.ri-coupon-2-fill:before {
  content: "\\ebe5";
}

.ri-coupon-2-line:before {
  content: "\\ebe6";
}

.ri-coupon-3-fill:before {
  content: "\\ebe7";
}

.ri-coupon-3-line:before {
  content: "\\ebe8";
}

.ri-coupon-4-fill:before {
  content: "\\ebe9";
}

.ri-coupon-4-line:before {
  content: "\\ebea";
}

.ri-coupon-5-fill:before {
  content: "\\ebeb";
}

.ri-coupon-5-line:before {
  content: "\\ebec";
}

.ri-coupon-fill:before {
  content: "\\ebed";
}

.ri-coupon-line:before {
  content: "\\ebee";
}

.ri-cpu-fill:before {
  content: "\\ebef";
}

.ri-cpu-line:before {
  content: "\\ebf0";
}

.ri-creative-commons-by-fill:before {
  content: "\\ebf1";
}

.ri-creative-commons-by-line:before {
  content: "\\ebf2";
}

.ri-creative-commons-fill:before {
  content: "\\ebf3";
}

.ri-creative-commons-line:before {
  content: "\\ebf4";
}

.ri-creative-commons-nc-fill:before {
  content: "\\ebf5";
}

.ri-creative-commons-nc-line:before {
  content: "\\ebf6";
}

.ri-creative-commons-nd-fill:before {
  content: "\\ebf7";
}

.ri-creative-commons-nd-line:before {
  content: "\\ebf8";
}

.ri-creative-commons-sa-fill:before {
  content: "\\ebf9";
}

.ri-creative-commons-sa-line:before {
  content: "\\ebfa";
}

.ri-creative-commons-zero-fill:before {
  content: "\\ebfb";
}

.ri-creative-commons-zero-line:before {
  content: "\\ebfc";
}

.ri-criminal-fill:before {
  content: "\\ebfd";
}

.ri-criminal-line:before {
  content: "\\ebfe";
}

.ri-crop-2-fill:before {
  content: "\\ebff";
}

.ri-crop-2-line:before {
  content: "\\ec00";
}

.ri-crop-fill:before {
  content: "\\ec01";
}

.ri-crop-line:before {
  content: "\\ec02";
}

.ri-css3-fill:before {
  content: "\\ec03";
}

.ri-css3-line:before {
  content: "\\ec04";
}

.ri-cup-fill:before {
  content: "\\ec05";
}

.ri-cup-line:before {
  content: "\\ec06";
}

.ri-currency-fill:before {
  content: "\\ec07";
}

.ri-currency-line:before {
  content: "\\ec08";
}

.ri-cursor-fill:before {
  content: "\\ec09";
}

.ri-cursor-line:before {
  content: "\\ec0a";
}

.ri-customer-service-2-fill:before {
  content: "\\ec0b";
}

.ri-customer-service-2-line:before {
  content: "\\ec0c";
}

.ri-customer-service-fill:before {
  content: "\\ec0d";
}

.ri-customer-service-line:before {
  content: "\\ec0e";
}

.ri-dashboard-2-fill:before {
  content: "\\ec0f";
}

.ri-dashboard-2-line:before {
  content: "\\ec10";
}

.ri-dashboard-3-fill:before {
  content: "\\ec11";
}

.ri-dashboard-3-line:before {
  content: "\\ec12";
}

.ri-dashboard-fill:before {
  content: "\\ec13";
}

.ri-dashboard-line:before {
  content: "\\ec14";
}

.ri-database-2-fill:before {
  content: "\\ec15";
}

.ri-database-2-line:before {
  content: "\\ec16";
}

.ri-database-fill:before {
  content: "\\ec17";
}

.ri-database-line:before {
  content: "\\ec18";
}

.ri-delete-back-2-fill:before {
  content: "\\ec19";
}

.ri-delete-back-2-line:before {
  content: "\\ec1a";
}

.ri-delete-back-fill:before {
  content: "\\ec1b";
}

.ri-delete-back-line:before {
  content: "\\ec1c";
}

.ri-delete-bin-2-fill:before {
  content: "\\ec1d";
}

.ri-delete-bin-2-line:before {
  content: "\\ec1e";
}

.ri-delete-bin-3-fill:before {
  content: "\\ec1f";
}

.ri-delete-bin-3-line:before {
  content: "\\ec20";
}

.ri-delete-bin-4-fill:before {
  content: "\\ec21";
}

.ri-delete-bin-4-line:before {
  content: "\\ec22";
}

.ri-delete-bin-5-fill:before {
  content: "\\ec23";
}

.ri-delete-bin-5-line:before {
  content: "\\ec24";
}

.ri-delete-bin-6-fill:before {
  content: "\\ec25";
}

.ri-delete-bin-6-line:before {
  content: "\\ec26";
}

.ri-delete-bin-7-fill:before {
  content: "\\ec27";
}

.ri-delete-bin-7-line:before {
  content: "\\ec28";
}

.ri-delete-bin-fill:before {
  content: "\\ec29";
}

.ri-delete-bin-line:before {
  content: "\\ec2a";
}

.ri-delete-column:before {
  content: "\\ec2b";
}

.ri-delete-row:before {
  content: "\\ec2c";
}

.ri-device-fill:before {
  content: "\\ec2d";
}

.ri-device-line:before {
  content: "\\ec2e";
}

.ri-device-recover-fill:before {
  content: "\\ec2f";
}

.ri-device-recover-line:before {
  content: "\\ec30";
}

.ri-dingding-fill:before {
  content: "\\ec31";
}

.ri-dingding-line:before {
  content: "\\ec32";
}

.ri-direction-fill:before {
  content: "\\ec33";
}

.ri-direction-line:before {
  content: "\\ec34";
}

.ri-disc-fill:before {
  content: "\\ec35";
}

.ri-disc-line:before {
  content: "\\ec36";
}

.ri-discord-fill:before {
  content: "\\ec37";
}

.ri-discord-line:before {
  content: "\\ec38";
}

.ri-discuss-fill:before {
  content: "\\ec39";
}

.ri-discuss-line:before {
  content: "\\ec3a";
}

.ri-dislike-fill:before {
  content: "\\ec3b";
}

.ri-dislike-line:before {
  content: "\\ec3c";
}

.ri-disqus-fill:before {
  content: "\\ec3d";
}

.ri-disqus-line:before {
  content: "\\ec3e";
}

.ri-divide-fill:before {
  content: "\\ec3f";
}

.ri-divide-line:before {
  content: "\\ec40";
}

.ri-donut-chart-fill:before {
  content: "\\ec41";
}

.ri-donut-chart-line:before {
  content: "\\ec42";
}

.ri-door-closed-fill:before {
  content: "\\ec43";
}

.ri-door-closed-line:before {
  content: "\\ec44";
}

.ri-door-fill:before {
  content: "\\ec45";
}

.ri-door-line:before {
  content: "\\ec46";
}

.ri-door-lock-box-fill:before {
  content: "\\ec47";
}

.ri-door-lock-box-line:before {
  content: "\\ec48";
}

.ri-door-lock-fill:before {
  content: "\\ec49";
}

.ri-door-lock-line:before {
  content: "\\ec4a";
}

.ri-door-open-fill:before {
  content: "\\ec4b";
}

.ri-door-open-line:before {
  content: "\\ec4c";
}

.ri-dossier-fill:before {
  content: "\\ec4d";
}

.ri-dossier-line:before {
  content: "\\ec4e";
}

.ri-douban-fill:before {
  content: "\\ec4f";
}

.ri-douban-line:before {
  content: "\\ec50";
}

.ri-double-quotes-l:before {
  content: "\\ec51";
}

.ri-double-quotes-r:before {
  content: "\\ec52";
}

.ri-download-2-fill:before {
  content: "\\ec53";
}

.ri-download-2-line:before {
  content: "\\ec54";
}

.ri-download-cloud-2-fill:before {
  content: "\\ec55";
}

.ri-download-cloud-2-line:before {
  content: "\\ec56";
}

.ri-download-cloud-fill:before {
  content: "\\ec57";
}

.ri-download-cloud-line:before {
  content: "\\ec58";
}

.ri-download-fill:before {
  content: "\\ec59";
}

.ri-download-line:before {
  content: "\\ec5a";
}

.ri-draft-fill:before {
  content: "\\ec5b";
}

.ri-draft-line:before {
  content: "\\ec5c";
}

.ri-drag-drop-fill:before {
  content: "\\ec5d";
}

.ri-drag-drop-line:before {
  content: "\\ec5e";
}

.ri-drag-move-2-fill:before {
  content: "\\ec5f";
}

.ri-drag-move-2-line:before {
  content: "\\ec60";
}

.ri-drag-move-fill:before {
  content: "\\ec61";
}

.ri-drag-move-line:before {
  content: "\\ec62";
}

.ri-dribbble-fill:before {
  content: "\\ec63";
}

.ri-dribbble-line:before {
  content: "\\ec64";
}

.ri-drive-fill:before {
  content: "\\ec65";
}

.ri-drive-line:before {
  content: "\\ec66";
}

.ri-drizzle-fill:before {
  content: "\\ec67";
}

.ri-drizzle-line:before {
  content: "\\ec68";
}

.ri-drop-fill:before {
  content: "\\ec69";
}

.ri-drop-line:before {
  content: "\\ec6a";
}

.ri-dropbox-fill:before {
  content: "\\ec6b";
}

.ri-dropbox-line:before {
  content: "\\ec6c";
}

.ri-dual-sim-1-fill:before {
  content: "\\ec6d";
}

.ri-dual-sim-1-line:before {
  content: "\\ec6e";
}

.ri-dual-sim-2-fill:before {
  content: "\\ec6f";
}

.ri-dual-sim-2-line:before {
  content: "\\ec70";
}

.ri-dv-fill:before {
  content: "\\ec71";
}

.ri-dv-line:before {
  content: "\\ec72";
}

.ri-dvd-fill:before {
  content: "\\ec73";
}

.ri-dvd-line:before {
  content: "\\ec74";
}

.ri-e-bike-2-fill:before {
  content: "\\ec75";
}

.ri-e-bike-2-line:before {
  content: "\\ec76";
}

.ri-e-bike-fill:before {
  content: "\\ec77";
}

.ri-e-bike-line:before {
  content: "\\ec78";
}

.ri-earth-fill:before {
  content: "\\ec79";
}

.ri-earth-line:before {
  content: "\\ec7a";
}

.ri-earthquake-fill:before {
  content: "\\ec7b";
}

.ri-earthquake-line:before {
  content: "\\ec7c";
}

.ri-edge-fill:before {
  content: "\\ec7d";
}

.ri-edge-line:before {
  content: "\\ec7e";
}

.ri-edit-2-fill:before {
  content: "\\ec7f";
}

.ri-edit-2-line:before {
  content: "\\ec80";
}

.ri-edit-box-fill:before {
  content: "\\ec81";
}

.ri-edit-box-line:before {
  content: "\\ec82";
}

.ri-edit-circle-fill:before {
  content: "\\ec83";
}

.ri-edit-circle-line:before {
  content: "\\ec84";
}

.ri-edit-fill:before {
  content: "\\ec85";
}

.ri-edit-line:before {
  content: "\\ec86";
}

.ri-eject-fill:before {
  content: "\\ec87";
}

.ri-eject-line:before {
  content: "\\ec88";
}

.ri-emotion-2-fill:before {
  content: "\\ec89";
}

.ri-emotion-2-line:before {
  content: "\\ec8a";
}

.ri-emotion-fill:before {
  content: "\\ec8b";
}

.ri-emotion-happy-fill:before {
  content: "\\ec8c";
}

.ri-emotion-happy-line:before {
  content: "\\ec8d";
}

.ri-emotion-laugh-fill:before {
  content: "\\ec8e";
}

.ri-emotion-laugh-line:before {
  content: "\\ec8f";
}

.ri-emotion-line:before {
  content: "\\ec90";
}

.ri-emotion-normal-fill:before {
  content: "\\ec91";
}

.ri-emotion-normal-line:before {
  content: "\\ec92";
}

.ri-emotion-sad-fill:before {
  content: "\\ec93";
}

.ri-emotion-sad-line:before {
  content: "\\ec94";
}

.ri-emotion-unhappy-fill:before {
  content: "\\ec95";
}

.ri-emotion-unhappy-line:before {
  content: "\\ec96";
}

.ri-empathize-fill:before {
  content: "\\ec97";
}

.ri-empathize-line:before {
  content: "\\ec98";
}

.ri-emphasis-cn:before {
  content: "\\ec99";
}

.ri-emphasis:before {
  content: "\\ec9a";
}

.ri-english-input:before {
  content: "\\ec9b";
}

.ri-equalizer-fill:before {
  content: "\\ec9c";
}

.ri-equalizer-line:before {
  content: "\\ec9d";
}

.ri-eraser-fill:before {
  content: "\\ec9e";
}

.ri-eraser-line:before {
  content: "\\ec9f";
}

.ri-error-warning-fill:before {
  content: "\\eca0";
}

.ri-error-warning-line:before {
  content: "\\eca1";
}

.ri-evernote-fill:before {
  content: "\\eca2";
}

.ri-evernote-line:before {
  content: "\\eca3";
}

.ri-exchange-box-fill:before {
  content: "\\eca4";
}

.ri-exchange-box-line:before {
  content: "\\eca5";
}

.ri-exchange-cny-fill:before {
  content: "\\eca6";
}

.ri-exchange-cny-line:before {
  content: "\\eca7";
}

.ri-exchange-dollar-fill:before {
  content: "\\eca8";
}

.ri-exchange-dollar-line:before {
  content: "\\eca9";
}

.ri-exchange-fill:before {
  content: "\\ecaa";
}

.ri-exchange-funds-fill:before {
  content: "\\ecab";
}

.ri-exchange-funds-line:before {
  content: "\\ecac";
}

.ri-exchange-line:before {
  content: "\\ecad";
}

.ri-external-link-fill:before {
  content: "\\ecae";
}

.ri-external-link-line:before {
  content: "\\ecaf";
}

.ri-eye-2-fill:before {
  content: "\\ecb0";
}

.ri-eye-2-line:before {
  content: "\\ecb1";
}

.ri-eye-close-fill:before {
  content: "\\ecb2";
}

.ri-eye-close-line:before {
  content: "\\ecb3";
}

.ri-eye-fill:before {
  content: "\\ecb4";
}

.ri-eye-line:before {
  content: "\\ecb5";
}

.ri-eye-off-fill:before {
  content: "\\ecb6";
}

.ri-eye-off-line:before {
  content: "\\ecb7";
}

.ri-facebook-box-fill:before {
  content: "\\ecb8";
}

.ri-facebook-box-line:before {
  content: "\\ecb9";
}

.ri-facebook-circle-fill:before {
  content: "\\ecba";
}

.ri-facebook-circle-line:before {
  content: "\\ecbb";
}

.ri-facebook-fill:before {
  content: "\\ecbc";
}

.ri-facebook-line:before {
  content: "\\ecbd";
}

.ri-fahrenheit-fill:before {
  content: "\\ecbe";
}

.ri-fahrenheit-line:before {
  content: "\\ecbf";
}

.ri-feedback-fill:before {
  content: "\\ecc0";
}

.ri-feedback-line:before {
  content: "\\ecc1";
}

.ri-file-2-fill:before {
  content: "\\ecc2";
}

.ri-file-2-line:before {
  content: "\\ecc3";
}

.ri-file-3-fill:before {
  content: "\\ecc4";
}

.ri-file-3-line:before {
  content: "\\ecc5";
}

.ri-file-4-fill:before {
  content: "\\ecc6";
}

.ri-file-4-line:before {
  content: "\\ecc7";
}

.ri-file-add-fill:before {
  content: "\\ecc8";
}

.ri-file-add-line:before {
  content: "\\ecc9";
}

.ri-file-chart-2-fill:before {
  content: "\\ecca";
}

.ri-file-chart-2-line:before {
  content: "\\eccb";
}

.ri-file-chart-fill:before {
  content: "\\eccc";
}

.ri-file-chart-line:before {
  content: "\\eccd";
}

.ri-file-cloud-fill:before {
  content: "\\ecce";
}

.ri-file-cloud-line:before {
  content: "\\eccf";
}

.ri-file-code-fill:before {
  content: "\\ecd0";
}

.ri-file-code-line:before {
  content: "\\ecd1";
}

.ri-file-copy-2-fill:before {
  content: "\\ecd2";
}

.ri-file-copy-2-line:before {
  content: "\\ecd3";
}

.ri-file-copy-fill:before {
  content: "\\ecd4";
}

.ri-file-copy-line:before {
  content: "\\ecd5";
}

.ri-file-damage-fill:before {
  content: "\\ecd6";
}

.ri-file-damage-line:before {
  content: "\\ecd7";
}

.ri-file-download-fill:before {
  content: "\\ecd8";
}

.ri-file-download-line:before {
  content: "\\ecd9";
}

.ri-file-edit-fill:before {
  content: "\\ecda";
}

.ri-file-edit-line:before {
  content: "\\ecdb";
}

.ri-file-excel-2-fill:before {
  content: "\\ecdc";
}

.ri-file-excel-2-line:before {
  content: "\\ecdd";
}

.ri-file-excel-fill:before {
  content: "\\ecde";
}

.ri-file-excel-line:before {
  content: "\\ecdf";
}

.ri-file-fill:before {
  content: "\\ece0";
}

.ri-file-forbid-fill:before {
  content: "\\ece1";
}

.ri-file-forbid-line:before {
  content: "\\ece2";
}

.ri-file-gif-fill:before {
  content: "\\ece3";
}

.ri-file-gif-line:before {
  content: "\\ece4";
}

.ri-file-history-fill:before {
  content: "\\ece5";
}

.ri-file-history-line:before {
  content: "\\ece6";
}

.ri-file-hwp-fill:before {
  content: "\\ece7";
}

.ri-file-hwp-line:before {
  content: "\\ece8";
}

.ri-file-info-fill:before {
  content: "\\ece9";
}

.ri-file-info-line:before {
  content: "\\ecea";
}

.ri-file-line:before {
  content: "\\eceb";
}

.ri-file-list-2-fill:before {
  content: "\\ecec";
}

.ri-file-list-2-line:before {
  content: "\\eced";
}

.ri-file-list-3-fill:before {
  content: "\\ecee";
}

.ri-file-list-3-line:before {
  content: "\\ecef";
}

.ri-file-list-fill:before {
  content: "\\ecf0";
}

.ri-file-list-line:before {
  content: "\\ecf1";
}

.ri-file-lock-fill:before {
  content: "\\ecf2";
}

.ri-file-lock-line:before {
  content: "\\ecf3";
}

.ri-file-mark-fill:before {
  content: "\\ecf4";
}

.ri-file-mark-line:before {
  content: "\\ecf5";
}

.ri-file-music-fill:before {
  content: "\\ecf6";
}

.ri-file-music-line:before {
  content: "\\ecf7";
}

.ri-file-paper-2-fill:before {
  content: "\\ecf8";
}

.ri-file-paper-2-line:before {
  content: "\\ecf9";
}

.ri-file-paper-fill:before {
  content: "\\ecfa";
}

.ri-file-paper-line:before {
  content: "\\ecfb";
}

.ri-file-pdf-fill:before {
  content: "\\ecfc";
}

.ri-file-pdf-line:before {
  content: "\\ecfd";
}

.ri-file-ppt-2-fill:before {
  content: "\\ecfe";
}

.ri-file-ppt-2-line:before {
  content: "\\ecff";
}

.ri-file-ppt-fill:before {
  content: "\\ed00";
}

.ri-file-ppt-line:before {
  content: "\\ed01";
}

.ri-file-reduce-fill:before {
  content: "\\ed02";
}

.ri-file-reduce-line:before {
  content: "\\ed03";
}

.ri-file-search-fill:before {
  content: "\\ed04";
}

.ri-file-search-line:before {
  content: "\\ed05";
}

.ri-file-settings-fill:before {
  content: "\\ed06";
}

.ri-file-settings-line:before {
  content: "\\ed07";
}

.ri-file-shield-2-fill:before {
  content: "\\ed08";
}

.ri-file-shield-2-line:before {
  content: "\\ed09";
}

.ri-file-shield-fill:before {
  content: "\\ed0a";
}

.ri-file-shield-line:before {
  content: "\\ed0b";
}

.ri-file-shred-fill:before {
  content: "\\ed0c";
}

.ri-file-shred-line:before {
  content: "\\ed0d";
}

.ri-file-text-fill:before {
  content: "\\ed0e";
}

.ri-file-text-line:before {
  content: "\\ed0f";
}

.ri-file-transfer-fill:before {
  content: "\\ed10";
}

.ri-file-transfer-line:before {
  content: "\\ed11";
}

.ri-file-unknow-fill:before {
  content: "\\ed12";
}

.ri-file-unknow-line:before {
  content: "\\ed13";
}

.ri-file-upload-fill:before {
  content: "\\ed14";
}

.ri-file-upload-line:before {
  content: "\\ed15";
}

.ri-file-user-fill:before {
  content: "\\ed16";
}

.ri-file-user-line:before {
  content: "\\ed17";
}

.ri-file-warning-fill:before {
  content: "\\ed18";
}

.ri-file-warning-line:before {
  content: "\\ed19";
}

.ri-file-word-2-fill:before {
  content: "\\ed1a";
}

.ri-file-word-2-line:before {
  content: "\\ed1b";
}

.ri-file-word-fill:before {
  content: "\\ed1c";
}

.ri-file-word-line:before {
  content: "\\ed1d";
}

.ri-file-zip-fill:before {
  content: "\\ed1e";
}

.ri-file-zip-line:before {
  content: "\\ed1f";
}

.ri-film-fill:before {
  content: "\\ed20";
}

.ri-film-line:before {
  content: "\\ed21";
}

.ri-filter-2-fill:before {
  content: "\\ed22";
}

.ri-filter-2-line:before {
  content: "\\ed23";
}

.ri-filter-3-fill:before {
  content: "\\ed24";
}

.ri-filter-3-line:before {
  content: "\\ed25";
}

.ri-filter-fill:before {
  content: "\\ed26";
}

.ri-filter-line:before {
  content: "\\ed27";
}

.ri-filter-off-fill:before {
  content: "\\ed28";
}

.ri-filter-off-line:before {
  content: "\\ed29";
}

.ri-find-replace-fill:before {
  content: "\\ed2a";
}

.ri-find-replace-line:before {
  content: "\\ed2b";
}

.ri-finder-fill:before {
  content: "\\ed2c";
}

.ri-finder-line:before {
  content: "\\ed2d";
}

.ri-fingerprint-2-fill:before {
  content: "\\ed2e";
}

.ri-fingerprint-2-line:before {
  content: "\\ed2f";
}

.ri-fingerprint-fill:before {
  content: "\\ed30";
}

.ri-fingerprint-line:before {
  content: "\\ed31";
}

.ri-fire-fill:before {
  content: "\\ed32";
}

.ri-fire-line:before {
  content: "\\ed33";
}

.ri-firefox-fill:before {
  content: "\\ed34";
}

.ri-firefox-line:before {
  content: "\\ed35";
}

.ri-first-aid-kit-fill:before {
  content: "\\ed36";
}

.ri-first-aid-kit-line:before {
  content: "\\ed37";
}

.ri-flag-2-fill:before {
  content: "\\ed38";
}

.ri-flag-2-line:before {
  content: "\\ed39";
}

.ri-flag-fill:before {
  content: "\\ed3a";
}

.ri-flag-line:before {
  content: "\\ed3b";
}

.ri-flashlight-fill:before {
  content: "\\ed3c";
}

.ri-flashlight-line:before {
  content: "\\ed3d";
}

.ri-flask-fill:before {
  content: "\\ed3e";
}

.ri-flask-line:before {
  content: "\\ed3f";
}

.ri-flight-land-fill:before {
  content: "\\ed40";
}

.ri-flight-land-line:before {
  content: "\\ed41";
}

.ri-flight-takeoff-fill:before {
  content: "\\ed42";
}

.ri-flight-takeoff-line:before {
  content: "\\ed43";
}

.ri-flood-fill:before {
  content: "\\ed44";
}

.ri-flood-line:before {
  content: "\\ed45";
}

.ri-flow-chart:before {
  content: "\\ed46";
}

.ri-flutter-fill:before {
  content: "\\ed47";
}

.ri-flutter-line:before {
  content: "\\ed48";
}

.ri-focus-2-fill:before {
  content: "\\ed49";
}

.ri-focus-2-line:before {
  content: "\\ed4a";
}

.ri-focus-3-fill:before {
  content: "\\ed4b";
}

.ri-focus-3-line:before {
  content: "\\ed4c";
}

.ri-focus-fill:before {
  content: "\\ed4d";
}

.ri-focus-line:before {
  content: "\\ed4e";
}

.ri-foggy-fill:before {
  content: "\\ed4f";
}

.ri-foggy-line:before {
  content: "\\ed50";
}

.ri-folder-2-fill:before {
  content: "\\ed51";
}

.ri-folder-2-line:before {
  content: "\\ed52";
}

.ri-folder-3-fill:before {
  content: "\\ed53";
}

.ri-folder-3-line:before {
  content: "\\ed54";
}

.ri-folder-4-fill:before {
  content: "\\ed55";
}

.ri-folder-4-line:before {
  content: "\\ed56";
}

.ri-folder-5-fill:before {
  content: "\\ed57";
}

.ri-folder-5-line:before {
  content: "\\ed58";
}

.ri-folder-add-fill:before {
  content: "\\ed59";
}

.ri-folder-add-line:before {
  content: "\\ed5a";
}

.ri-folder-chart-2-fill:before {
  content: "\\ed5b";
}

.ri-folder-chart-2-line:before {
  content: "\\ed5c";
}

.ri-folder-chart-fill:before {
  content: "\\ed5d";
}

.ri-folder-chart-line:before {
  content: "\\ed5e";
}

.ri-folder-download-fill:before {
  content: "\\ed5f";
}

.ri-folder-download-line:before {
  content: "\\ed60";
}

.ri-folder-fill:before {
  content: "\\ed61";
}

.ri-folder-forbid-fill:before {
  content: "\\ed62";
}

.ri-folder-forbid-line:before {
  content: "\\ed63";
}

.ri-folder-history-fill:before {
  content: "\\ed64";
}

.ri-folder-history-line:before {
  content: "\\ed65";
}

.ri-folder-info-fill:before {
  content: "\\ed66";
}

.ri-folder-info-line:before {
  content: "\\ed67";
}

.ri-folder-keyhole-fill:before {
  content: "\\ed68";
}

.ri-folder-keyhole-line:before {
  content: "\\ed69";
}

.ri-folder-line:before {
  content: "\\ed6a";
}

.ri-folder-lock-fill:before {
  content: "\\ed6b";
}

.ri-folder-lock-line:before {
  content: "\\ed6c";
}

.ri-folder-music-fill:before {
  content: "\\ed6d";
}

.ri-folder-music-line:before {
  content: "\\ed6e";
}

.ri-folder-open-fill:before {
  content: "\\ed6f";
}

.ri-folder-open-line:before {
  content: "\\ed70";
}

.ri-folder-received-fill:before {
  content: "\\ed71";
}

.ri-folder-received-line:before {
  content: "\\ed72";
}

.ri-folder-reduce-fill:before {
  content: "\\ed73";
}

.ri-folder-reduce-line:before {
  content: "\\ed74";
}

.ri-folder-settings-fill:before {
  content: "\\ed75";
}

.ri-folder-settings-line:before {
  content: "\\ed76";
}

.ri-folder-shared-fill:before {
  content: "\\ed77";
}

.ri-folder-shared-line:before {
  content: "\\ed78";
}

.ri-folder-shield-2-fill:before {
  content: "\\ed79";
}

.ri-folder-shield-2-line:before {
  content: "\\ed7a";
}

.ri-folder-shield-fill:before {
  content: "\\ed7b";
}

.ri-folder-shield-line:before {
  content: "\\ed7c";
}

.ri-folder-transfer-fill:before {
  content: "\\ed7d";
}

.ri-folder-transfer-line:before {
  content: "\\ed7e";
}

.ri-folder-unknow-fill:before {
  content: "\\ed7f";
}

.ri-folder-unknow-line:before {
  content: "\\ed80";
}

.ri-folder-upload-fill:before {
  content: "\\ed81";
}

.ri-folder-upload-line:before {
  content: "\\ed82";
}

.ri-folder-user-fill:before {
  content: "\\ed83";
}

.ri-folder-user-line:before {
  content: "\\ed84";
}

.ri-folder-warning-fill:before {
  content: "\\ed85";
}

.ri-folder-warning-line:before {
  content: "\\ed86";
}

.ri-folder-zip-fill:before {
  content: "\\ed87";
}

.ri-folder-zip-line:before {
  content: "\\ed88";
}

.ri-folders-fill:before {
  content: "\\ed89";
}

.ri-folders-line:before {
  content: "\\ed8a";
}

.ri-font-color:before {
  content: "\\ed8b";
}

.ri-font-size-2:before {
  content: "\\ed8c";
}

.ri-font-size:before {
  content: "\\ed8d";
}

.ri-football-fill:before {
  content: "\\ed8e";
}

.ri-football-line:before {
  content: "\\ed8f";
}

.ri-footprint-fill:before {
  content: "\\ed90";
}

.ri-footprint-line:before {
  content: "\\ed91";
}

.ri-forbid-2-fill:before {
  content: "\\ed92";
}

.ri-forbid-2-line:before {
  content: "\\ed93";
}

.ri-forbid-fill:before {
  content: "\\ed94";
}

.ri-forbid-line:before {
  content: "\\ed95";
}

.ri-format-clear:before {
  content: "\\ed96";
}

.ri-fridge-fill:before {
  content: "\\ed97";
}

.ri-fridge-line:before {
  content: "\\ed98";
}

.ri-fullscreen-exit-fill:before {
  content: "\\ed99";
}

.ri-fullscreen-exit-line:before {
  content: "\\ed9a";
}

.ri-fullscreen-fill:before {
  content: "\\ed9b";
}

.ri-fullscreen-line:before {
  content: "\\ed9c";
}

.ri-function-fill:before {
  content: "\\ed9d";
}

.ri-function-line:before {
  content: "\\ed9e";
}

.ri-functions:before {
  content: "\\ed9f";
}

.ri-funds-box-fill:before {
  content: "\\eda0";
}

.ri-funds-box-line:before {
  content: "\\eda1";
}

.ri-funds-fill:before {
  content: "\\eda2";
}

.ri-funds-line:before {
  content: "\\eda3";
}

.ri-gallery-fill:before {
  content: "\\eda4";
}

.ri-gallery-line:before {
  content: "\\eda5";
}

.ri-gallery-upload-fill:before {
  content: "\\eda6";
}

.ri-gallery-upload-line:before {
  content: "\\eda7";
}

.ri-game-fill:before {
  content: "\\eda8";
}

.ri-game-line:before {
  content: "\\eda9";
}

.ri-gamepad-fill:before {
  content: "\\edaa";
}

.ri-gamepad-line:before {
  content: "\\edab";
}

.ri-gas-station-fill:before {
  content: "\\edac";
}

.ri-gas-station-line:before {
  content: "\\edad";
}

.ri-gatsby-fill:before {
  content: "\\edae";
}

.ri-gatsby-line:before {
  content: "\\edaf";
}

.ri-genderless-fill:before {
  content: "\\edb0";
}

.ri-genderless-line:before {
  content: "\\edb1";
}

.ri-ghost-2-fill:before {
  content: "\\edb2";
}

.ri-ghost-2-line:before {
  content: "\\edb3";
}

.ri-ghost-fill:before {
  content: "\\edb4";
}

.ri-ghost-line:before {
  content: "\\edb5";
}

.ri-ghost-smile-fill:before {
  content: "\\edb6";
}

.ri-ghost-smile-line:before {
  content: "\\edb7";
}

.ri-gift-2-fill:before {
  content: "\\edb8";
}

.ri-gift-2-line:before {
  content: "\\edb9";
}

.ri-gift-fill:before {
  content: "\\edba";
}

.ri-gift-line:before {
  content: "\\edbb";
}

.ri-git-branch-fill:before {
  content: "\\edbc";
}

.ri-git-branch-line:before {
  content: "\\edbd";
}

.ri-git-commit-fill:before {
  content: "\\edbe";
}

.ri-git-commit-line:before {
  content: "\\edbf";
}

.ri-git-merge-fill:before {
  content: "\\edc0";
}

.ri-git-merge-line:before {
  content: "\\edc1";
}

.ri-git-pull-request-fill:before {
  content: "\\edc2";
}

.ri-git-pull-request-line:before {
  content: "\\edc3";
}

.ri-git-repository-commits-fill:before {
  content: "\\edc4";
}

.ri-git-repository-commits-line:before {
  content: "\\edc5";
}

.ri-git-repository-fill:before {
  content: "\\edc6";
}

.ri-git-repository-line:before {
  content: "\\edc7";
}

.ri-git-repository-private-fill:before {
  content: "\\edc8";
}

.ri-git-repository-private-line:before {
  content: "\\edc9";
}

.ri-github-fill:before {
  content: "\\edca";
}

.ri-github-line:before {
  content: "\\edcb";
}

.ri-gitlab-fill:before {
  content: "\\edcc";
}

.ri-gitlab-line:before {
  content: "\\edcd";
}

.ri-global-fill:before {
  content: "\\edce";
}

.ri-global-line:before {
  content: "\\edcf";
}

.ri-globe-fill:before {
  content: "\\edd0";
}

.ri-globe-line:before {
  content: "\\edd1";
}

.ri-goblet-fill:before {
  content: "\\edd2";
}

.ri-goblet-line:before {
  content: "\\edd3";
}

.ri-google-fill:before {
  content: "\\edd4";
}

.ri-google-line:before {
  content: "\\edd5";
}

.ri-google-play-fill:before {
  content: "\\edd6";
}

.ri-google-play-line:before {
  content: "\\edd7";
}

.ri-government-fill:before {
  content: "\\edd8";
}

.ri-government-line:before {
  content: "\\edd9";
}

.ri-gps-fill:before {
  content: "\\edda";
}

.ri-gps-line:before {
  content: "\\eddb";
}

.ri-gradienter-fill:before {
  content: "\\eddc";
}

.ri-gradienter-line:before {
  content: "\\eddd";
}

.ri-grid-fill:before {
  content: "\\edde";
}

.ri-grid-line:before {
  content: "\\eddf";
}

.ri-group-2-fill:before {
  content: "\\ede0";
}

.ri-group-2-line:before {
  content: "\\ede1";
}

.ri-group-fill:before {
  content: "\\ede2";
}

.ri-group-line:before {
  content: "\\ede3";
}

.ri-guide-fill:before {
  content: "\\ede4";
}

.ri-guide-line:before {
  content: "\\ede5";
}

.ri-h-1:before {
  content: "\\ede6";
}

.ri-h-2:before {
  content: "\\ede7";
}

.ri-h-3:before {
  content: "\\ede8";
}

.ri-h-4:before {
  content: "\\ede9";
}

.ri-h-5:before {
  content: "\\edea";
}

.ri-h-6:before {
  content: "\\edeb";
}

.ri-hail-fill:before {
  content: "\\edec";
}

.ri-hail-line:before {
  content: "\\eded";
}

.ri-hammer-fill:before {
  content: "\\edee";
}

.ri-hammer-line:before {
  content: "\\edef";
}

.ri-hand-coin-fill:before {
  content: "\\edf0";
}

.ri-hand-coin-line:before {
  content: "\\edf1";
}

.ri-hand-heart-fill:before {
  content: "\\edf2";
}

.ri-hand-heart-line:before {
  content: "\\edf3";
}

.ri-hand-sanitizer-fill:before {
  content: "\\edf4";
}

.ri-hand-sanitizer-line:before {
  content: "\\edf5";
}

.ri-handbag-fill:before {
  content: "\\edf6";
}

.ri-handbag-line:before {
  content: "\\edf7";
}

.ri-hard-drive-2-fill:before {
  content: "\\edf8";
}

.ri-hard-drive-2-line:before {
  content: "\\edf9";
}

.ri-hard-drive-fill:before {
  content: "\\edfa";
}

.ri-hard-drive-line:before {
  content: "\\edfb";
}

.ri-hashtag:before {
  content: "\\edfc";
}

.ri-haze-2-fill:before {
  content: "\\edfd";
}

.ri-haze-2-line:before {
  content: "\\edfe";
}

.ri-haze-fill:before {
  content: "\\edff";
}

.ri-haze-line:before {
  content: "\\ee00";
}

.ri-hd-fill:before {
  content: "\\ee01";
}

.ri-hd-line:before {
  content: "\\ee02";
}

.ri-heading:before {
  content: "\\ee03";
}

.ri-headphone-fill:before {
  content: "\\ee04";
}

.ri-headphone-line:before {
  content: "\\ee05";
}

.ri-health-book-fill:before {
  content: "\\ee06";
}

.ri-health-book-line:before {
  content: "\\ee07";
}

.ri-heart-2-fill:before {
  content: "\\ee08";
}

.ri-heart-2-line:before {
  content: "\\ee09";
}

.ri-heart-3-fill:before {
  content: "\\ee0a";
}

.ri-heart-3-line:before {
  content: "\\ee0b";
}

.ri-heart-add-fill:before {
  content: "\\ee0c";
}

.ri-heart-add-line:before {
  content: "\\ee0d";
}

.ri-heart-fill:before {
  content: "\\ee0e";
}

.ri-heart-line:before {
  content: "\\ee0f";
}

.ri-heart-pulse-fill:before {
  content: "\\ee10";
}

.ri-heart-pulse-line:before {
  content: "\\ee11";
}

.ri-hearts-fill:before {
  content: "\\ee12";
}

.ri-hearts-line:before {
  content: "\\ee13";
}

.ri-heavy-showers-fill:before {
  content: "\\ee14";
}

.ri-heavy-showers-line:before {
  content: "\\ee15";
}

.ri-history-fill:before {
  content: "\\ee16";
}

.ri-history-line:before {
  content: "\\ee17";
}

.ri-home-2-fill:before {
  content: "\\ee18";
}

.ri-home-2-line:before {
  content: "\\ee19";
}

.ri-home-3-fill:before {
  content: "\\ee1a";
}

.ri-home-3-line:before {
  content: "\\ee1b";
}

.ri-home-4-fill:before {
  content: "\\ee1c";
}

.ri-home-4-line:before {
  content: "\\ee1d";
}

.ri-home-5-fill:before {
  content: "\\ee1e";
}

.ri-home-5-line:before {
  content: "\\ee1f";
}

.ri-home-6-fill:before {
  content: "\\ee20";
}

.ri-home-6-line:before {
  content: "\\ee21";
}

.ri-home-7-fill:before {
  content: "\\ee22";
}

.ri-home-7-line:before {
  content: "\\ee23";
}

.ri-home-8-fill:before {
  content: "\\ee24";
}

.ri-home-8-line:before {
  content: "\\ee25";
}

.ri-home-fill:before {
  content: "\\ee26";
}

.ri-home-gear-fill:before {
  content: "\\ee27";
}

.ri-home-gear-line:before {
  content: "\\ee28";
}

.ri-home-heart-fill:before {
  content: "\\ee29";
}

.ri-home-heart-line:before {
  content: "\\ee2a";
}

.ri-home-line:before {
  content: "\\ee2b";
}

.ri-home-smile-2-fill:before {
  content: "\\ee2c";
}

.ri-home-smile-2-line:before {
  content: "\\ee2d";
}

.ri-home-smile-fill:before {
  content: "\\ee2e";
}

.ri-home-smile-line:before {
  content: "\\ee2f";
}

.ri-home-wifi-fill:before {
  content: "\\ee30";
}

.ri-home-wifi-line:before {
  content: "\\ee31";
}

.ri-honor-of-kings-fill:before {
  content: "\\ee32";
}

.ri-honor-of-kings-line:before {
  content: "\\ee33";
}

.ri-honour-fill:before {
  content: "\\ee34";
}

.ri-honour-line:before {
  content: "\\ee35";
}

.ri-hospital-fill:before {
  content: "\\ee36";
}

.ri-hospital-line:before {
  content: "\\ee37";
}

.ri-hotel-bed-fill:before {
  content: "\\ee38";
}

.ri-hotel-bed-line:before {
  content: "\\ee39";
}

.ri-hotel-fill:before {
  content: "\\ee3a";
}

.ri-hotel-line:before {
  content: "\\ee3b";
}

.ri-hotspot-fill:before {
  content: "\\ee3c";
}

.ri-hotspot-line:before {
  content: "\\ee3d";
}

.ri-hq-fill:before {
  content: "\\ee3e";
}

.ri-hq-line:before {
  content: "\\ee3f";
}

.ri-html5-fill:before {
  content: "\\ee40";
}

.ri-html5-line:before {
  content: "\\ee41";
}

.ri-ie-fill:before {
  content: "\\ee42";
}

.ri-ie-line:before {
  content: "\\ee43";
}

.ri-image-2-fill:before {
  content: "\\ee44";
}

.ri-image-2-line:before {
  content: "\\ee45";
}

.ri-image-add-fill:before {
  content: "\\ee46";
}

.ri-image-add-line:before {
  content: "\\ee47";
}

.ri-image-edit-fill:before {
  content: "\\ee48";
}

.ri-image-edit-line:before {
  content: "\\ee49";
}

.ri-image-fill:before {
  content: "\\ee4a";
}

.ri-image-line:before {
  content: "\\ee4b";
}

.ri-inbox-archive-fill:before {
  content: "\\ee4c";
}

.ri-inbox-archive-line:before {
  content: "\\ee4d";
}

.ri-inbox-fill:before {
  content: "\\ee4e";
}

.ri-inbox-line:before {
  content: "\\ee4f";
}

.ri-inbox-unarchive-fill:before {
  content: "\\ee50";
}

.ri-inbox-unarchive-line:before {
  content: "\\ee51";
}

.ri-increase-decrease-fill:before {
  content: "\\ee52";
}

.ri-increase-decrease-line:before {
  content: "\\ee53";
}

.ri-indent-decrease:before {
  content: "\\ee54";
}

.ri-indent-increase:before {
  content: "\\ee55";
}

.ri-indeterminate-circle-fill:before {
  content: "\\ee56";
}

.ri-indeterminate-circle-line:before {
  content: "\\ee57";
}

.ri-information-fill:before {
  content: "\\ee58";
}

.ri-information-line:before {
  content: "\\ee59";
}

.ri-infrared-thermometer-fill:before {
  content: "\\ee5a";
}

.ri-infrared-thermometer-line:before {
  content: "\\ee5b";
}

.ri-ink-bottle-fill:before {
  content: "\\ee5c";
}

.ri-ink-bottle-line:before {
  content: "\\ee5d";
}

.ri-input-cursor-move:before {
  content: "\\ee5e";
}

.ri-input-method-fill:before {
  content: "\\ee5f";
}

.ri-input-method-line:before {
  content: "\\ee60";
}

.ri-insert-column-left:before {
  content: "\\ee61";
}

.ri-insert-column-right:before {
  content: "\\ee62";
}

.ri-insert-row-bottom:before {
  content: "\\ee63";
}

.ri-insert-row-top:before {
  content: "\\ee64";
}

.ri-instagram-fill:before {
  content: "\\ee65";
}

.ri-instagram-line:before {
  content: "\\ee66";
}

.ri-install-fill:before {
  content: "\\ee67";
}

.ri-install-line:before {
  content: "\\ee68";
}

.ri-invision-fill:before {
  content: "\\ee69";
}

.ri-invision-line:before {
  content: "\\ee6a";
}

.ri-italic:before {
  content: "\\ee6b";
}

.ri-kakao-talk-fill:before {
  content: "\\ee6c";
}

.ri-kakao-talk-line:before {
  content: "\\ee6d";
}

.ri-key-2-fill:before {
  content: "\\ee6e";
}

.ri-key-2-line:before {
  content: "\\ee6f";
}

.ri-key-fill:before {
  content: "\\ee70";
}

.ri-key-line:before {
  content: "\\ee71";
}

.ri-keyboard-box-fill:before {
  content: "\\ee72";
}

.ri-keyboard-box-line:before {
  content: "\\ee73";
}

.ri-keyboard-fill:before {
  content: "\\ee74";
}

.ri-keyboard-line:before {
  content: "\\ee75";
}

.ri-keynote-fill:before {
  content: "\\ee76";
}

.ri-keynote-line:before {
  content: "\\ee77";
}

.ri-knife-blood-fill:before {
  content: "\\ee78";
}

.ri-knife-blood-line:before {
  content: "\\ee79";
}

.ri-knife-fill:before {
  content: "\\ee7a";
}

.ri-knife-line:before {
  content: "\\ee7b";
}

.ri-landscape-fill:before {
  content: "\\ee7c";
}

.ri-landscape-line:before {
  content: "\\ee7d";
}

.ri-layout-2-fill:before {
  content: "\\ee7e";
}

.ri-layout-2-line:before {
  content: "\\ee7f";
}

.ri-layout-3-fill:before {
  content: "\\ee80";
}

.ri-layout-3-line:before {
  content: "\\ee81";
}

.ri-layout-4-fill:before {
  content: "\\ee82";
}

.ri-layout-4-line:before {
  content: "\\ee83";
}

.ri-layout-5-fill:before {
  content: "\\ee84";
}

.ri-layout-5-line:before {
  content: "\\ee85";
}

.ri-layout-6-fill:before {
  content: "\\ee86";
}

.ri-layout-6-line:before {
  content: "\\ee87";
}

.ri-layout-bottom-2-fill:before {
  content: "\\ee88";
}

.ri-layout-bottom-2-line:before {
  content: "\\ee89";
}

.ri-layout-bottom-fill:before {
  content: "\\ee8a";
}

.ri-layout-bottom-line:before {
  content: "\\ee8b";
}

.ri-layout-column-fill:before {
  content: "\\ee8c";
}

.ri-layout-column-line:before {
  content: "\\ee8d";
}

.ri-layout-fill:before {
  content: "\\ee8e";
}

.ri-layout-grid-fill:before {
  content: "\\ee8f";
}

.ri-layout-grid-line:before {
  content: "\\ee90";
}

.ri-layout-left-2-fill:before {
  content: "\\ee91";
}

.ri-layout-left-2-line:before {
  content: "\\ee92";
}

.ri-layout-left-fill:before {
  content: "\\ee93";
}

.ri-layout-left-line:before {
  content: "\\ee94";
}

.ri-layout-line:before {
  content: "\\ee95";
}

.ri-layout-masonry-fill:before {
  content: "\\ee96";
}

.ri-layout-masonry-line:before {
  content: "\\ee97";
}

.ri-layout-right-2-fill:before {
  content: "\\ee98";
}

.ri-layout-right-2-line:before {
  content: "\\ee99";
}

.ri-layout-right-fill:before {
  content: "\\ee9a";
}

.ri-layout-right-line:before {
  content: "\\ee9b";
}

.ri-layout-row-fill:before {
  content: "\\ee9c";
}

.ri-layout-row-line:before {
  content: "\\ee9d";
}

.ri-layout-top-2-fill:before {
  content: "\\ee9e";
}

.ri-layout-top-2-line:before {
  content: "\\ee9f";
}

.ri-layout-top-fill:before {
  content: "\\eea0";
}

.ri-layout-top-line:before {
  content: "\\eea1";
}

.ri-leaf-fill:before {
  content: "\\eea2";
}

.ri-leaf-line:before {
  content: "\\eea3";
}

.ri-lifebuoy-fill:before {
  content: "\\eea4";
}

.ri-lifebuoy-line:before {
  content: "\\eea5";
}

.ri-lightbulb-fill:before {
  content: "\\eea6";
}

.ri-lightbulb-flash-fill:before {
  content: "\\eea7";
}

.ri-lightbulb-flash-line:before {
  content: "\\eea8";
}

.ri-lightbulb-line:before {
  content: "\\eea9";
}

.ri-line-chart-fill:before {
  content: "\\eeaa";
}

.ri-line-chart-line:before {
  content: "\\eeab";
}

.ri-line-fill:before {
  content: "\\eeac";
}

.ri-line-height:before {
  content: "\\eead";
}

.ri-line-line:before {
  content: "\\eeae";
}

.ri-link-m:before {
  content: "\\eeaf";
}

.ri-link-unlink-m:before {
  content: "\\eeb0";
}

.ri-link-unlink:before {
  content: "\\eeb1";
}

.ri-link:before {
  content: "\\eeb2";
}

.ri-linkedin-box-fill:before {
  content: "\\eeb3";
}

.ri-linkedin-box-line:before {
  content: "\\eeb4";
}

.ri-linkedin-fill:before {
  content: "\\eeb5";
}

.ri-linkedin-line:before {
  content: "\\eeb6";
}

.ri-links-fill:before {
  content: "\\eeb7";
}

.ri-links-line:before {
  content: "\\eeb8";
}

.ri-list-check-2:before {
  content: "\\eeb9";
}

.ri-list-check:before {
  content: "\\eeba";
}

.ri-list-ordered:before {
  content: "\\eebb";
}

.ri-list-settings-fill:before {
  content: "\\eebc";
}

.ri-list-settings-line:before {
  content: "\\eebd";
}

.ri-list-unordered:before {
  content: "\\eebe";
}

.ri-live-fill:before {
  content: "\\eebf";
}

.ri-live-line:before {
  content: "\\eec0";
}

.ri-loader-2-fill:before {
  content: "\\eec1";
}

.ri-loader-2-line:before {
  content: "\\eec2";
}

.ri-loader-3-fill:before {
  content: "\\eec3";
}

.ri-loader-3-line:before {
  content: "\\eec4";
}

.ri-loader-4-fill:before {
  content: "\\eec5";
}

.ri-loader-4-line:before {
  content: "\\eec6";
}

.ri-loader-5-fill:before {
  content: "\\eec7";
}

.ri-loader-5-line:before {
  content: "\\eec8";
}

.ri-loader-fill:before {
  content: "\\eec9";
}

.ri-loader-line:before {
  content: "\\eeca";
}

.ri-lock-2-fill:before {
  content: "\\eecb";
}

.ri-lock-2-line:before {
  content: "\\eecc";
}

.ri-lock-fill:before {
  content: "\\eecd";
}

.ri-lock-line:before {
  content: "\\eece";
}

.ri-lock-password-fill:before {
  content: "\\eecf";
}

.ri-lock-password-line:before {
  content: "\\eed0";
}

.ri-lock-unlock-fill:before {
  content: "\\eed1";
}

.ri-lock-unlock-line:before {
  content: "\\eed2";
}

.ri-login-box-fill:before {
  content: "\\eed3";
}

.ri-login-box-line:before {
  content: "\\eed4";
}

.ri-login-circle-fill:before {
  content: "\\eed5";
}

.ri-login-circle-line:before {
  content: "\\eed6";
}

.ri-logout-box-fill:before {
  content: "\\eed7";
}

.ri-logout-box-line:before {
  content: "\\eed8";
}

.ri-logout-box-r-fill:before {
  content: "\\eed9";
}

.ri-logout-box-r-line:before {
  content: "\\eeda";
}

.ri-logout-circle-fill:before {
  content: "\\eedb";
}

.ri-logout-circle-line:before {
  content: "\\eedc";
}

.ri-logout-circle-r-fill:before {
  content: "\\eedd";
}

.ri-logout-circle-r-line:before {
  content: "\\eede";
}

.ri-luggage-cart-fill:before {
  content: "\\eedf";
}

.ri-luggage-cart-line:before {
  content: "\\eee0";
}

.ri-luggage-deposit-fill:before {
  content: "\\eee1";
}

.ri-luggage-deposit-line:before {
  content: "\\eee2";
}

.ri-lungs-fill:before {
  content: "\\eee3";
}

.ri-lungs-line:before {
  content: "\\eee4";
}

.ri-mac-fill:before {
  content: "\\eee5";
}

.ri-mac-line:before {
  content: "\\eee6";
}

.ri-macbook-fill:before {
  content: "\\eee7";
}

.ri-macbook-line:before {
  content: "\\eee8";
}

.ri-magic-fill:before {
  content: "\\eee9";
}

.ri-magic-line:before {
  content: "\\eeea";
}

.ri-mail-add-fill:before {
  content: "\\eeeb";
}

.ri-mail-add-line:before {
  content: "\\eeec";
}

.ri-mail-check-fill:before {
  content: "\\eeed";
}

.ri-mail-check-line:before {
  content: "\\eeee";
}

.ri-mail-close-fill:before {
  content: "\\eeef";
}

.ri-mail-close-line:before {
  content: "\\eef0";
}

.ri-mail-download-fill:before {
  content: "\\eef1";
}

.ri-mail-download-line:before {
  content: "\\eef2";
}

.ri-mail-fill:before {
  content: "\\eef3";
}

.ri-mail-forbid-fill:before {
  content: "\\eef4";
}

.ri-mail-forbid-line:before {
  content: "\\eef5";
}

.ri-mail-line:before {
  content: "\\eef6";
}

.ri-mail-lock-fill:before {
  content: "\\eef7";
}

.ri-mail-lock-line:before {
  content: "\\eef8";
}

.ri-mail-open-fill:before {
  content: "\\eef9";
}

.ri-mail-open-line:before {
  content: "\\eefa";
}

.ri-mail-send-fill:before {
  content: "\\eefb";
}

.ri-mail-send-line:before {
  content: "\\eefc";
}

.ri-mail-settings-fill:before {
  content: "\\eefd";
}

.ri-mail-settings-line:before {
  content: "\\eefe";
}

.ri-mail-star-fill:before {
  content: "\\eeff";
}

.ri-mail-star-line:before {
  content: "\\ef00";
}

.ri-mail-unread-fill:before {
  content: "\\ef01";
}

.ri-mail-unread-line:before {
  content: "\\ef02";
}

.ri-mail-volume-fill:before {
  content: "\\ef03";
}

.ri-mail-volume-line:before {
  content: "\\ef04";
}

.ri-map-2-fill:before {
  content: "\\ef05";
}

.ri-map-2-line:before {
  content: "\\ef06";
}

.ri-map-fill:before {
  content: "\\ef07";
}

.ri-map-line:before {
  content: "\\ef08";
}

.ri-map-pin-2-fill:before {
  content: "\\ef09";
}

.ri-map-pin-2-line:before {
  content: "\\ef0a";
}

.ri-map-pin-3-fill:before {
  content: "\\ef0b";
}

.ri-map-pin-3-line:before {
  content: "\\ef0c";
}

.ri-map-pin-4-fill:before {
  content: "\\ef0d";
}

.ri-map-pin-4-line:before {
  content: "\\ef0e";
}

.ri-map-pin-5-fill:before {
  content: "\\ef0f";
}

.ri-map-pin-5-line:before {
  content: "\\ef10";
}

.ri-map-pin-add-fill:before {
  content: "\\ef11";
}

.ri-map-pin-add-line:before {
  content: "\\ef12";
}

.ri-map-pin-fill:before {
  content: "\\ef13";
}

.ri-map-pin-line:before {
  content: "\\ef14";
}

.ri-map-pin-range-fill:before {
  content: "\\ef15";
}

.ri-map-pin-range-line:before {
  content: "\\ef16";
}

.ri-map-pin-time-fill:before {
  content: "\\ef17";
}

.ri-map-pin-time-line:before {
  content: "\\ef18";
}

.ri-map-pin-user-fill:before {
  content: "\\ef19";
}

.ri-map-pin-user-line:before {
  content: "\\ef1a";
}

.ri-mark-pen-fill:before {
  content: "\\ef1b";
}

.ri-mark-pen-line:before {
  content: "\\ef1c";
}

.ri-markdown-fill:before {
  content: "\\ef1d";
}

.ri-markdown-line:before {
  content: "\\ef1e";
}

.ri-markup-fill:before {
  content: "\\ef1f";
}

.ri-markup-line:before {
  content: "\\ef20";
}

.ri-mastercard-fill:before {
  content: "\\ef21";
}

.ri-mastercard-line:before {
  content: "\\ef22";
}

.ri-mastodon-fill:before {
  content: "\\ef23";
}

.ri-mastodon-line:before {
  content: "\\ef24";
}

.ri-medal-2-fill:before {
  content: "\\ef25";
}

.ri-medal-2-line:before {
  content: "\\ef26";
}

.ri-medal-fill:before {
  content: "\\ef27";
}

.ri-medal-line:before {
  content: "\\ef28";
}

.ri-medicine-bottle-fill:before {
  content: "\\ef29";
}

.ri-medicine-bottle-line:before {
  content: "\\ef2a";
}

.ri-medium-fill:before {
  content: "\\ef2b";
}

.ri-medium-line:before {
  content: "\\ef2c";
}

.ri-men-fill:before {
  content: "\\ef2d";
}

.ri-men-line:before {
  content: "\\ef2e";
}

.ri-mental-health-fill:before {
  content: "\\ef2f";
}

.ri-mental-health-line:before {
  content: "\\ef30";
}

.ri-menu-2-fill:before {
  content: "\\ef31";
}

.ri-menu-2-line:before {
  content: "\\ef32";
}

.ri-menu-3-fill:before {
  content: "\\ef33";
}

.ri-menu-3-line:before {
  content: "\\ef34";
}

.ri-menu-4-fill:before {
  content: "\\ef35";
}

.ri-menu-4-line:before {
  content: "\\ef36";
}

.ri-menu-5-fill:before {
  content: "\\ef37";
}

.ri-menu-5-line:before {
  content: "\\ef38";
}

.ri-menu-add-fill:before {
  content: "\\ef39";
}

.ri-menu-add-line:before {
  content: "\\ef3a";
}

.ri-menu-fill:before {
  content: "\\ef3b";
}

.ri-menu-fold-fill:before {
  content: "\\ef3c";
}

.ri-menu-fold-line:before {
  content: "\\ef3d";
}

.ri-menu-line:before {
  content: "\\ef3e";
}

.ri-menu-unfold-fill:before {
  content: "\\ef3f";
}

.ri-menu-unfold-line:before {
  content: "\\ef40";
}

.ri-merge-cells-horizontal:before {
  content: "\\ef41";
}

.ri-merge-cells-vertical:before {
  content: "\\ef42";
}

.ri-message-2-fill:before {
  content: "\\ef43";
}

.ri-message-2-line:before {
  content: "\\ef44";
}

.ri-message-3-fill:before {
  content: "\\ef45";
}

.ri-message-3-line:before {
  content: "\\ef46";
}

.ri-message-fill:before {
  content: "\\ef47";
}

.ri-message-line:before {
  content: "\\ef48";
}

.ri-messenger-fill:before {
  content: "\\ef49";
}

.ri-messenger-line:before {
  content: "\\ef4a";
}

.ri-meteor-fill:before {
  content: "\\ef4b";
}

.ri-meteor-line:before {
  content: "\\ef4c";
}

.ri-mic-2-fill:before {
  content: "\\ef4d";
}

.ri-mic-2-line:before {
  content: "\\ef4e";
}

.ri-mic-fill:before {
  content: "\\ef4f";
}

.ri-mic-line:before {
  content: "\\ef50";
}

.ri-mic-off-fill:before {
  content: "\\ef51";
}

.ri-mic-off-line:before {
  content: "\\ef52";
}

.ri-mickey-fill:before {
  content: "\\ef53";
}

.ri-mickey-line:before {
  content: "\\ef54";
}

.ri-microscope-fill:before {
  content: "\\ef55";
}

.ri-microscope-line:before {
  content: "\\ef56";
}

.ri-microsoft-fill:before {
  content: "\\ef57";
}

.ri-microsoft-line:before {
  content: "\\ef58";
}

.ri-mind-map:before {
  content: "\\ef59";
}

.ri-mini-program-fill:before {
  content: "\\ef5a";
}

.ri-mini-program-line:before {
  content: "\\ef5b";
}

.ri-mist-fill:before {
  content: "\\ef5c";
}

.ri-mist-line:before {
  content: "\\ef5d";
}

.ri-money-cny-box-fill:before {
  content: "\\ef5e";
}

.ri-money-cny-box-line:before {
  content: "\\ef5f";
}

.ri-money-cny-circle-fill:before {
  content: "\\ef60";
}

.ri-money-cny-circle-line:before {
  content: "\\ef61";
}

.ri-money-dollar-box-fill:before {
  content: "\\ef62";
}

.ri-money-dollar-box-line:before {
  content: "\\ef63";
}

.ri-money-dollar-circle-fill:before {
  content: "\\ef64";
}

.ri-money-dollar-circle-line:before {
  content: "\\ef65";
}

.ri-money-euro-box-fill:before {
  content: "\\ef66";
}

.ri-money-euro-box-line:before {
  content: "\\ef67";
}

.ri-money-euro-circle-fill:before {
  content: "\\ef68";
}

.ri-money-euro-circle-line:before {
  content: "\\ef69";
}

.ri-money-pound-box-fill:before {
  content: "\\ef6a";
}

.ri-money-pound-box-line:before {
  content: "\\ef6b";
}

.ri-money-pound-circle-fill:before {
  content: "\\ef6c";
}

.ri-money-pound-circle-line:before {
  content: "\\ef6d";
}

.ri-moon-clear-fill:before {
  content: "\\ef6e";
}

.ri-moon-clear-line:before {
  content: "\\ef6f";
}

.ri-moon-cloudy-fill:before {
  content: "\\ef70";
}

.ri-moon-cloudy-line:before {
  content: "\\ef71";
}

.ri-moon-fill:before {
  content: "\\ef72";
}

.ri-moon-foggy-fill:before {
  content: "\\ef73";
}

.ri-moon-foggy-line:before {
  content: "\\ef74";
}

.ri-moon-line:before {
  content: "\\ef75";
}

.ri-more-2-fill:before {
  content: "\\ef76";
}

.ri-more-2-line:before {
  content: "\\ef77";
}

.ri-more-fill:before {
  content: "\\ef78";
}

.ri-more-line:before {
  content: "\\ef79";
}

.ri-motorbike-fill:before {
  content: "\\ef7a";
}

.ri-motorbike-line:before {
  content: "\\ef7b";
}

.ri-mouse-fill:before {
  content: "\\ef7c";
}

.ri-mouse-line:before {
  content: "\\ef7d";
}

.ri-movie-2-fill:before {
  content: "\\ef7e";
}

.ri-movie-2-line:before {
  content: "\\ef7f";
}

.ri-movie-fill:before {
  content: "\\ef80";
}

.ri-movie-line:before {
  content: "\\ef81";
}

.ri-music-2-fill:before {
  content: "\\ef82";
}

.ri-music-2-line:before {
  content: "\\ef83";
}

.ri-music-fill:before {
  content: "\\ef84";
}

.ri-music-line:before {
  content: "\\ef85";
}

.ri-mv-fill:before {
  content: "\\ef86";
}

.ri-mv-line:before {
  content: "\\ef87";
}

.ri-navigation-fill:before {
  content: "\\ef88";
}

.ri-navigation-line:before {
  content: "\\ef89";
}

.ri-netease-cloud-music-fill:before {
  content: "\\ef8a";
}

.ri-netease-cloud-music-line:before {
  content: "\\ef8b";
}

.ri-netflix-fill:before {
  content: "\\ef8c";
}

.ri-netflix-line:before {
  content: "\\ef8d";
}

.ri-newspaper-fill:before {
  content: "\\ef8e";
}

.ri-newspaper-line:before {
  content: "\\ef8f";
}

.ri-node-tree:before {
  content: "\\ef90";
}

.ri-notification-2-fill:before {
  content: "\\ef91";
}

.ri-notification-2-line:before {
  content: "\\ef92";
}

.ri-notification-3-fill:before {
  content: "\\ef93";
}

.ri-notification-3-line:before {
  content: "\\ef94";
}

.ri-notification-4-fill:before {
  content: "\\ef95";
}

.ri-notification-4-line:before {
  content: "\\ef96";
}

.ri-notification-badge-fill:before {
  content: "\\ef97";
}

.ri-notification-badge-line:before {
  content: "\\ef98";
}

.ri-notification-fill:before {
  content: "\\ef99";
}

.ri-notification-line:before {
  content: "\\ef9a";
}

.ri-notification-off-fill:before {
  content: "\\ef9b";
}

.ri-notification-off-line:before {
  content: "\\ef9c";
}

.ri-npmjs-fill:before {
  content: "\\ef9d";
}

.ri-npmjs-line:before {
  content: "\\ef9e";
}

.ri-number-0:before {
  content: "\\ef9f";
}

.ri-number-1:before {
  content: "\\efa0";
}

.ri-number-2:before {
  content: "\\efa1";
}

.ri-number-3:before {
  content: "\\efa2";
}

.ri-number-4:before {
  content: "\\efa3";
}

.ri-number-5:before {
  content: "\\efa4";
}

.ri-number-6:before {
  content: "\\efa5";
}

.ri-number-7:before {
  content: "\\efa6";
}

.ri-number-8:before {
  content: "\\efa7";
}

.ri-number-9:before {
  content: "\\efa8";
}

.ri-numbers-fill:before {
  content: "\\efa9";
}

.ri-numbers-line:before {
  content: "\\efaa";
}

.ri-nurse-fill:before {
  content: "\\efab";
}

.ri-nurse-line:before {
  content: "\\efac";
}

.ri-oil-fill:before {
  content: "\\efad";
}

.ri-oil-line:before {
  content: "\\efae";
}

.ri-omega:before {
  content: "\\efaf";
}

.ri-open-arm-fill:before {
  content: "\\efb0";
}

.ri-open-arm-line:before {
  content: "\\efb1";
}

.ri-open-source-fill:before {
  content: "\\efb2";
}

.ri-open-source-line:before {
  content: "\\efb3";
}

.ri-opera-fill:before {
  content: "\\efb4";
}

.ri-opera-line:before {
  content: "\\efb5";
}

.ri-order-play-fill:before {
  content: "\\efb6";
}

.ri-order-play-line:before {
  content: "\\efb7";
}

.ri-organization-chart:before {
  content: "\\efb8";
}

.ri-outlet-2-fill:before {
  content: "\\efb9";
}

.ri-outlet-2-line:before {
  content: "\\efba";
}

.ri-outlet-fill:before {
  content: "\\efbb";
}

.ri-outlet-line:before {
  content: "\\efbc";
}

.ri-page-separator:before {
  content: "\\efbd";
}

.ri-pages-fill:before {
  content: "\\efbe";
}

.ri-pages-line:before {
  content: "\\efbf";
}

.ri-paint-brush-fill:before {
  content: "\\efc0";
}

.ri-paint-brush-line:before {
  content: "\\efc1";
}

.ri-paint-fill:before {
  content: "\\efc2";
}

.ri-paint-line:before {
  content: "\\efc3";
}

.ri-palette-fill:before {
  content: "\\efc4";
}

.ri-palette-line:before {
  content: "\\efc5";
}

.ri-pantone-fill:before {
  content: "\\efc6";
}

.ri-pantone-line:before {
  content: "\\efc7";
}

.ri-paragraph:before {
  content: "\\efc8";
}

.ri-parent-fill:before {
  content: "\\efc9";
}

.ri-parent-line:before {
  content: "\\efca";
}

.ri-parentheses-fill:before {
  content: "\\efcb";
}

.ri-parentheses-line:before {
  content: "\\efcc";
}

.ri-parking-box-fill:before {
  content: "\\efcd";
}

.ri-parking-box-line:before {
  content: "\\efce";
}

.ri-parking-fill:before {
  content: "\\efcf";
}

.ri-parking-line:before {
  content: "\\efd0";
}

.ri-passport-fill:before {
  content: "\\efd1";
}

.ri-passport-line:before {
  content: "\\efd2";
}

.ri-patreon-fill:before {
  content: "\\efd3";
}

.ri-patreon-line:before {
  content: "\\efd4";
}

.ri-pause-circle-fill:before {
  content: "\\efd5";
}

.ri-pause-circle-line:before {
  content: "\\efd6";
}

.ri-pause-fill:before {
  content: "\\efd7";
}

.ri-pause-line:before {
  content: "\\efd8";
}

.ri-pause-mini-fill:before {
  content: "\\efd9";
}

.ri-pause-mini-line:before {
  content: "\\efda";
}

.ri-paypal-fill:before {
  content: "\\efdb";
}

.ri-paypal-line:before {
  content: "\\efdc";
}

.ri-pen-nib-fill:before {
  content: "\\efdd";
}

.ri-pen-nib-line:before {
  content: "\\efde";
}

.ri-pencil-fill:before {
  content: "\\efdf";
}

.ri-pencil-line:before {
  content: "\\efe0";
}

.ri-pencil-ruler-2-fill:before {
  content: "\\efe1";
}

.ri-pencil-ruler-2-line:before {
  content: "\\efe2";
}

.ri-pencil-ruler-fill:before {
  content: "\\efe3";
}

.ri-pencil-ruler-line:before {
  content: "\\efe4";
}

.ri-percent-fill:before {
  content: "\\efe5";
}

.ri-percent-line:before {
  content: "\\efe6";
}

.ri-phone-camera-fill:before {
  content: "\\efe7";
}

.ri-phone-camera-line:before {
  content: "\\efe8";
}

.ri-phone-fill:before {
  content: "\\efe9";
}

.ri-phone-find-fill:before {
  content: "\\efea";
}

.ri-phone-find-line:before {
  content: "\\efeb";
}

.ri-phone-line:before {
  content: "\\efec";
}

.ri-phone-lock-fill:before {
  content: "\\efed";
}

.ri-phone-lock-line:before {
  content: "\\efee";
}

.ri-picture-in-picture-2-fill:before {
  content: "\\efef";
}

.ri-picture-in-picture-2-line:before {
  content: "\\eff0";
}

.ri-picture-in-picture-exit-fill:before {
  content: "\\eff1";
}

.ri-picture-in-picture-exit-line:before {
  content: "\\eff2";
}

.ri-picture-in-picture-fill:before {
  content: "\\eff3";
}

.ri-picture-in-picture-line:before {
  content: "\\eff4";
}

.ri-pie-chart-2-fill:before {
  content: "\\eff5";
}

.ri-pie-chart-2-line:before {
  content: "\\eff6";
}

.ri-pie-chart-box-fill:before {
  content: "\\eff7";
}

.ri-pie-chart-box-line:before {
  content: "\\eff8";
}

.ri-pie-chart-fill:before {
  content: "\\eff9";
}

.ri-pie-chart-line:before {
  content: "\\effa";
}

.ri-pin-distance-fill:before {
  content: "\\effb";
}

.ri-pin-distance-line:before {
  content: "\\effc";
}

.ri-ping-pong-fill:before {
  content: "\\effd";
}

.ri-ping-pong-line:before {
  content: "\\effe";
}

.ri-pinterest-fill:before {
  content: "\\efff";
}

.ri-pinterest-line:before {
  content: "\\f000";
}

.ri-pinyin-input:before {
  content: "\\f001";
}

.ri-pixelfed-fill:before {
  content: "\\f002";
}

.ri-pixelfed-line:before {
  content: "\\f003";
}

.ri-plane-fill:before {
  content: "\\f004";
}

.ri-plane-line:before {
  content: "\\f005";
}

.ri-plant-fill:before {
  content: "\\f006";
}

.ri-plant-line:before {
  content: "\\f007";
}

.ri-play-circle-fill:before {
  content: "\\f008";
}

.ri-play-circle-line:before {
  content: "\\f009";
}

.ri-play-fill:before {
  content: "\\f00a";
}

.ri-play-line:before {
  content: "\\f00b";
}

.ri-play-list-2-fill:before {
  content: "\\f00c";
}

.ri-play-list-2-line:before {
  content: "\\f00d";
}

.ri-play-list-add-fill:before {
  content: "\\f00e";
}

.ri-play-list-add-line:before {
  content: "\\f00f";
}

.ri-play-list-fill:before {
  content: "\\f010";
}

.ri-play-list-line:before {
  content: "\\f011";
}

.ri-play-mini-fill:before {
  content: "\\f012";
}

.ri-play-mini-line:before {
  content: "\\f013";
}

.ri-playstation-fill:before {
  content: "\\f014";
}

.ri-playstation-line:before {
  content: "\\f015";
}

.ri-plug-2-fill:before {
  content: "\\f016";
}

.ri-plug-2-line:before {
  content: "\\f017";
}

.ri-plug-fill:before {
  content: "\\f018";
}

.ri-plug-line:before {
  content: "\\f019";
}

.ri-polaroid-2-fill:before {
  content: "\\f01a";
}

.ri-polaroid-2-line:before {
  content: "\\f01b";
}

.ri-polaroid-fill:before {
  content: "\\f01c";
}

.ri-polaroid-line:before {
  content: "\\f01d";
}

.ri-police-car-fill:before {
  content: "\\f01e";
}

.ri-police-car-line:before {
  content: "\\f01f";
}

.ri-price-tag-2-fill:before {
  content: "\\f020";
}

.ri-price-tag-2-line:before {
  content: "\\f021";
}

.ri-price-tag-3-fill:before {
  content: "\\f022";
}

.ri-price-tag-3-line:before {
  content: "\\f023";
}

.ri-price-tag-fill:before {
  content: "\\f024";
}

.ri-price-tag-line:before {
  content: "\\f025";
}

.ri-printer-cloud-fill:before {
  content: "\\f026";
}

.ri-printer-cloud-line:before {
  content: "\\f027";
}

.ri-printer-fill:before {
  content: "\\f028";
}

.ri-printer-line:before {
  content: "\\f029";
}

.ri-product-hunt-fill:before {
  content: "\\f02a";
}

.ri-product-hunt-line:before {
  content: "\\f02b";
}

.ri-profile-fill:before {
  content: "\\f02c";
}

.ri-profile-line:before {
  content: "\\f02d";
}

.ri-projector-2-fill:before {
  content: "\\f02e";
}

.ri-projector-2-line:before {
  content: "\\f02f";
}

.ri-projector-fill:before {
  content: "\\f030";
}

.ri-projector-line:before {
  content: "\\f031";
}

.ri-psychotherapy-fill:before {
  content: "\\f032";
}

.ri-psychotherapy-line:before {
  content: "\\f033";
}

.ri-pulse-fill:before {
  content: "\\f034";
}

.ri-pulse-line:before {
  content: "\\f035";
}

.ri-pushpin-2-fill:before {
  content: "\\f036";
}

.ri-pushpin-2-line:before {
  content: "\\f037";
}

.ri-pushpin-fill:before {
  content: "\\f038";
}

.ri-pushpin-line:before {
  content: "\\f039";
}

.ri-qq-fill:before {
  content: "\\f03a";
}

.ri-qq-line:before {
  content: "\\f03b";
}

.ri-qr-code-fill:before {
  content: "\\f03c";
}

.ri-qr-code-line:before {
  content: "\\f03d";
}

.ri-qr-scan-2-fill:before {
  content: "\\f03e";
}

.ri-qr-scan-2-line:before {
  content: "\\f03f";
}

.ri-qr-scan-fill:before {
  content: "\\f040";
}

.ri-qr-scan-line:before {
  content: "\\f041";
}

.ri-question-answer-fill:before {
  content: "\\f042";
}

.ri-question-answer-line:before {
  content: "\\f043";
}

.ri-question-fill:before {
  content: "\\f044";
}

.ri-question-line:before {
  content: "\\f045";
}

.ri-question-mark:before {
  content: "\\f046";
}

.ri-questionnaire-fill:before {
  content: "\\f047";
}

.ri-questionnaire-line:before {
  content: "\\f048";
}

.ri-quill-pen-fill:before {
  content: "\\f049";
}

.ri-quill-pen-line:before {
  content: "\\f04a";
}

.ri-radar-fill:before {
  content: "\\f04b";
}

.ri-radar-line:before {
  content: "\\f04c";
}

.ri-radio-2-fill:before {
  content: "\\f04d";
}

.ri-radio-2-line:before {
  content: "\\f04e";
}

.ri-radio-button-fill:before {
  content: "\\f04f";
}

.ri-radio-button-line:before {
  content: "\\f050";
}

.ri-radio-fill:before {
  content: "\\f051";
}

.ri-radio-line:before {
  content: "\\f052";
}

.ri-rainbow-fill:before {
  content: "\\f053";
}

.ri-rainbow-line:before {
  content: "\\f054";
}

.ri-rainy-fill:before {
  content: "\\f055";
}

.ri-rainy-line:before {
  content: "\\f056";
}

.ri-reactjs-fill:before {
  content: "\\f057";
}

.ri-reactjs-line:before {
  content: "\\f058";
}

.ri-record-circle-fill:before {
  content: "\\f059";
}

.ri-record-circle-line:before {
  content: "\\f05a";
}

.ri-record-mail-fill:before {
  content: "\\f05b";
}

.ri-record-mail-line:before {
  content: "\\f05c";
}

.ri-recycle-fill:before {
  content: "\\f05d";
}

.ri-recycle-line:before {
  content: "\\f05e";
}

.ri-red-packet-fill:before {
  content: "\\f05f";
}

.ri-red-packet-line:before {
  content: "\\f060";
}

.ri-reddit-fill:before {
  content: "\\f061";
}

.ri-reddit-line:before {
  content: "\\f062";
}

.ri-refresh-fill:before {
  content: "\\f063";
}

.ri-refresh-line:before {
  content: "\\f064";
}

.ri-refund-2-fill:before {
  content: "\\f065";
}

.ri-refund-2-line:before {
  content: "\\f066";
}

.ri-refund-fill:before {
  content: "\\f067";
}

.ri-refund-line:before {
  content: "\\f068";
}

.ri-registered-fill:before {
  content: "\\f069";
}

.ri-registered-line:before {
  content: "\\f06a";
}

.ri-remixicon-fill:before {
  content: "\\f06b";
}

.ri-remixicon-line:before {
  content: "\\f06c";
}

.ri-remote-control-2-fill:before {
  content: "\\f06d";
}

.ri-remote-control-2-line:before {
  content: "\\f06e";
}

.ri-remote-control-fill:before {
  content: "\\f06f";
}

.ri-remote-control-line:before {
  content: "\\f070";
}

.ri-repeat-2-fill:before {
  content: "\\f071";
}

.ri-repeat-2-line:before {
  content: "\\f072";
}

.ri-repeat-fill:before {
  content: "\\f073";
}

.ri-repeat-line:before {
  content: "\\f074";
}

.ri-repeat-one-fill:before {
  content: "\\f075";
}

.ri-repeat-one-line:before {
  content: "\\f076";
}

.ri-reply-all-fill:before {
  content: "\\f077";
}

.ri-reply-all-line:before {
  content: "\\f078";
}

.ri-reply-fill:before {
  content: "\\f079";
}

.ri-reply-line:before {
  content: "\\f07a";
}

.ri-reserved-fill:before {
  content: "\\f07b";
}

.ri-reserved-line:before {
  content: "\\f07c";
}

.ri-rest-time-fill:before {
  content: "\\f07d";
}

.ri-rest-time-line:before {
  content: "\\f07e";
}

.ri-restart-fill:before {
  content: "\\f07f";
}

.ri-restart-line:before {
  content: "\\f080";
}

.ri-restaurant-2-fill:before {
  content: "\\f081";
}

.ri-restaurant-2-line:before {
  content: "\\f082";
}

.ri-restaurant-fill:before {
  content: "\\f083";
}

.ri-restaurant-line:before {
  content: "\\f084";
}

.ri-rewind-fill:before {
  content: "\\f085";
}

.ri-rewind-line:before {
  content: "\\f086";
}

.ri-rewind-mini-fill:before {
  content: "\\f087";
}

.ri-rewind-mini-line:before {
  content: "\\f088";
}

.ri-rhythm-fill:before {
  content: "\\f089";
}

.ri-rhythm-line:before {
  content: "\\f08a";
}

.ri-riding-fill:before {
  content: "\\f08b";
}

.ri-riding-line:before {
  content: "\\f08c";
}

.ri-road-map-fill:before {
  content: "\\f08d";
}

.ri-road-map-line:before {
  content: "\\f08e";
}

.ri-roadster-fill:before {
  content: "\\f08f";
}

.ri-roadster-line:before {
  content: "\\f090";
}

.ri-robot-fill:before {
  content: "\\f091";
}

.ri-robot-line:before {
  content: "\\f092";
}

.ri-rocket-2-fill:before {
  content: "\\f093";
}

.ri-rocket-2-line:before {
  content: "\\f094";
}

.ri-rocket-fill:before {
  content: "\\f095";
}

.ri-rocket-line:before {
  content: "\\f096";
}

.ri-rotate-lock-fill:before {
  content: "\\f097";
}

.ri-rotate-lock-line:before {
  content: "\\f098";
}

.ri-rounded-corner:before {
  content: "\\f099";
}

.ri-route-fill:before {
  content: "\\f09a";
}

.ri-route-line:before {
  content: "\\f09b";
}

.ri-router-fill:before {
  content: "\\f09c";
}

.ri-router-line:before {
  content: "\\f09d";
}

.ri-rss-fill:before {
  content: "\\f09e";
}

.ri-rss-line:before {
  content: "\\f09f";
}

.ri-ruler-2-fill:before {
  content: "\\f0a0";
}

.ri-ruler-2-line:before {
  content: "\\f0a1";
}

.ri-ruler-fill:before {
  content: "\\f0a2";
}

.ri-ruler-line:before {
  content: "\\f0a3";
}

.ri-run-fill:before {
  content: "\\f0a4";
}

.ri-run-line:before {
  content: "\\f0a5";
}

.ri-safari-fill:before {
  content: "\\f0a6";
}

.ri-safari-line:before {
  content: "\\f0a7";
}

.ri-safe-2-fill:before {
  content: "\\f0a8";
}

.ri-safe-2-line:before {
  content: "\\f0a9";
}

.ri-safe-fill:before {
  content: "\\f0aa";
}

.ri-safe-line:before {
  content: "\\f0ab";
}

.ri-sailboat-fill:before {
  content: "\\f0ac";
}

.ri-sailboat-line:before {
  content: "\\f0ad";
}

.ri-save-2-fill:before {
  content: "\\f0ae";
}

.ri-save-2-line:before {
  content: "\\f0af";
}

.ri-save-3-fill:before {
  content: "\\f0b0";
}

.ri-save-3-line:before {
  content: "\\f0b1";
}

.ri-save-fill:before {
  content: "\\f0b2";
}

.ri-save-line:before {
  content: "\\f0b3";
}

.ri-scales-2-fill:before {
  content: "\\f0b4";
}

.ri-scales-2-line:before {
  content: "\\f0b5";
}

.ri-scales-3-fill:before {
  content: "\\f0b6";
}

.ri-scales-3-line:before {
  content: "\\f0b7";
}

.ri-scales-fill:before {
  content: "\\f0b8";
}

.ri-scales-line:before {
  content: "\\f0b9";
}

.ri-scan-2-fill:before {
  content: "\\f0ba";
}

.ri-scan-2-line:before {
  content: "\\f0bb";
}

.ri-scan-fill:before {
  content: "\\f0bc";
}

.ri-scan-line:before {
  content: "\\f0bd";
}

.ri-scissors-2-fill:before {
  content: "\\f0be";
}

.ri-scissors-2-line:before {
  content: "\\f0bf";
}

.ri-scissors-cut-fill:before {
  content: "\\f0c0";
}

.ri-scissors-cut-line:before {
  content: "\\f0c1";
}

.ri-scissors-fill:before {
  content: "\\f0c2";
}

.ri-scissors-line:before {
  content: "\\f0c3";
}

.ri-screenshot-2-fill:before {
  content: "\\f0c4";
}

.ri-screenshot-2-line:before {
  content: "\\f0c5";
}

.ri-screenshot-fill:before {
  content: "\\f0c6";
}

.ri-screenshot-line:before {
  content: "\\f0c7";
}

.ri-sd-card-fill:before {
  content: "\\f0c8";
}

.ri-sd-card-line:before {
  content: "\\f0c9";
}

.ri-sd-card-mini-fill:before {
  content: "\\f0ca";
}

.ri-sd-card-mini-line:before {
  content: "\\f0cb";
}

.ri-search-2-fill:before {
  content: "\\f0cc";
}

.ri-search-2-line:before {
  content: "\\f0cd";
}

.ri-search-eye-fill:before {
  content: "\\f0ce";
}

.ri-search-eye-line:before {
  content: "\\f0cf";
}

.ri-search-fill:before {
  content: "\\f0d0";
}

.ri-search-line:before {
  content: "\\f0d1";
}

.ri-secure-payment-fill:before {
  content: "\\f0d2";
}

.ri-secure-payment-line:before {
  content: "\\f0d3";
}

.ri-seedling-fill:before {
  content: "\\f0d4";
}

.ri-seedling-line:before {
  content: "\\f0d5";
}

.ri-send-backward:before {
  content: "\\f0d6";
}

.ri-send-plane-2-fill:before {
  content: "\\f0d7";
}

.ri-send-plane-2-line:before {
  content: "\\f0d8";
}

.ri-send-plane-fill:before {
  content: "\\f0d9";
}

.ri-send-plane-line:before {
  content: "\\f0da";
}

.ri-send-to-back:before {
  content: "\\f0db";
}

.ri-sensor-fill:before {
  content: "\\f0dc";
}

.ri-sensor-line:before {
  content: "\\f0dd";
}

.ri-separator:before {
  content: "\\f0de";
}

.ri-server-fill:before {
  content: "\\f0df";
}

.ri-server-line:before {
  content: "\\f0e0";
}

.ri-service-fill:before {
  content: "\\f0e1";
}

.ri-service-line:before {
  content: "\\f0e2";
}

.ri-settings-2-fill:before {
  content: "\\f0e3";
}

.ri-settings-2-line:before {
  content: "\\f0e4";
}

.ri-settings-3-fill:before {
  content: "\\f0e5";
}

.ri-settings-3-line:before {
  content: "\\f0e6";
}

.ri-settings-4-fill:before {
  content: "\\f0e7";
}

.ri-settings-4-line:before {
  content: "\\f0e8";
}

.ri-settings-5-fill:before {
  content: "\\f0e9";
}

.ri-settings-5-line:before {
  content: "\\f0ea";
}

.ri-settings-6-fill:before {
  content: "\\f0eb";
}

.ri-settings-6-line:before {
  content: "\\f0ec";
}

.ri-settings-fill:before {
  content: "\\f0ed";
}

.ri-settings-line:before {
  content: "\\f0ee";
}

.ri-shape-2-fill:before {
  content: "\\f0ef";
}

.ri-shape-2-line:before {
  content: "\\f0f0";
}

.ri-shape-fill:before {
  content: "\\f0f1";
}

.ri-shape-line:before {
  content: "\\f0f2";
}

.ri-share-box-fill:before {
  content: "\\f0f3";
}

.ri-share-box-line:before {
  content: "\\f0f4";
}

.ri-share-circle-fill:before {
  content: "\\f0f5";
}

.ri-share-circle-line:before {
  content: "\\f0f6";
}

.ri-share-fill:before {
  content: "\\f0f7";
}

.ri-share-forward-2-fill:before {
  content: "\\f0f8";
}

.ri-share-forward-2-line:before {
  content: "\\f0f9";
}

.ri-share-forward-box-fill:before {
  content: "\\f0fa";
}

.ri-share-forward-box-line:before {
  content: "\\f0fb";
}

.ri-share-forward-fill:before {
  content: "\\f0fc";
}

.ri-share-forward-line:before {
  content: "\\f0fd";
}

.ri-share-line:before {
  content: "\\f0fe";
}

.ri-shield-check-fill:before {
  content: "\\f0ff";
}

.ri-shield-check-line:before {
  content: "\\f100";
}

.ri-shield-cross-fill:before {
  content: "\\f101";
}

.ri-shield-cross-line:before {
  content: "\\f102";
}

.ri-shield-fill:before {
  content: "\\f103";
}

.ri-shield-flash-fill:before {
  content: "\\f104";
}

.ri-shield-flash-line:before {
  content: "\\f105";
}

.ri-shield-keyhole-fill:before {
  content: "\\f106";
}

.ri-shield-keyhole-line:before {
  content: "\\f107";
}

.ri-shield-line:before {
  content: "\\f108";
}

.ri-shield-star-fill:before {
  content: "\\f109";
}

.ri-shield-star-line:before {
  content: "\\f10a";
}

.ri-shield-user-fill:before {
  content: "\\f10b";
}

.ri-shield-user-line:before {
  content: "\\f10c";
}

.ri-ship-2-fill:before {
  content: "\\f10d";
}

.ri-ship-2-line:before {
  content: "\\f10e";
}

.ri-ship-fill:before {
  content: "\\f10f";
}

.ri-ship-line:before {
  content: "\\f110";
}

.ri-shirt-fill:before {
  content: "\\f111";
}

.ri-shirt-line:before {
  content: "\\f112";
}

.ri-shopping-bag-2-fill:before {
  content: "\\f113";
}

.ri-shopping-bag-2-line:before {
  content: "\\f114";
}

.ri-shopping-bag-3-fill:before {
  content: "\\f115";
}

.ri-shopping-bag-3-line:before {
  content: "\\f116";
}

.ri-shopping-bag-fill:before {
  content: "\\f117";
}

.ri-shopping-bag-line:before {
  content: "\\f118";
}

.ri-shopping-basket-2-fill:before {
  content: "\\f119";
}

.ri-shopping-basket-2-line:before {
  content: "\\f11a";
}

.ri-shopping-basket-fill:before {
  content: "\\f11b";
}

.ri-shopping-basket-line:before {
  content: "\\f11c";
}

.ri-shopping-cart-2-fill:before {
  content: "\\f11d";
}

.ri-shopping-cart-2-line:before {
  content: "\\f11e";
}

.ri-shopping-cart-fill:before {
  content: "\\f11f";
}

.ri-shopping-cart-line:before {
  content: "\\f120";
}

.ri-showers-fill:before {
  content: "\\f121";
}

.ri-showers-line:before {
  content: "\\f122";
}

.ri-shuffle-fill:before {
  content: "\\f123";
}

.ri-shuffle-line:before {
  content: "\\f124";
}

.ri-shut-down-fill:before {
  content: "\\f125";
}

.ri-shut-down-line:before {
  content: "\\f126";
}

.ri-side-bar-fill:before {
  content: "\\f127";
}

.ri-side-bar-line:before {
  content: "\\f128";
}

.ri-signal-tower-fill:before {
  content: "\\f129";
}

.ri-signal-tower-line:before {
  content: "\\f12a";
}

.ri-signal-wifi-1-fill:before {
  content: "\\f12b";
}

.ri-signal-wifi-1-line:before {
  content: "\\f12c";
}

.ri-signal-wifi-2-fill:before {
  content: "\\f12d";
}

.ri-signal-wifi-2-line:before {
  content: "\\f12e";
}

.ri-signal-wifi-3-fill:before {
  content: "\\f12f";
}

.ri-signal-wifi-3-line:before {
  content: "\\f130";
}

.ri-signal-wifi-error-fill:before {
  content: "\\f131";
}

.ri-signal-wifi-error-line:before {
  content: "\\f132";
}

.ri-signal-wifi-fill:before {
  content: "\\f133";
}

.ri-signal-wifi-line:before {
  content: "\\f134";
}

.ri-signal-wifi-off-fill:before {
  content: "\\f135";
}

.ri-signal-wifi-off-line:before {
  content: "\\f136";
}

.ri-sim-card-2-fill:before {
  content: "\\f137";
}

.ri-sim-card-2-line:before {
  content: "\\f138";
}

.ri-sim-card-fill:before {
  content: "\\f139";
}

.ri-sim-card-line:before {
  content: "\\f13a";
}

.ri-single-quotes-l:before {
  content: "\\f13b";
}

.ri-single-quotes-r:before {
  content: "\\f13c";
}

.ri-sip-fill:before {
  content: "\\f13d";
}

.ri-sip-line:before {
  content: "\\f13e";
}

.ri-skip-back-fill:before {
  content: "\\f13f";
}

.ri-skip-back-line:before {
  content: "\\f140";
}

.ri-skip-back-mini-fill:before {
  content: "\\f141";
}

.ri-skip-back-mini-line:before {
  content: "\\f142";
}

.ri-skip-forward-fill:before {
  content: "\\f143";
}

.ri-skip-forward-line:before {
  content: "\\f144";
}

.ri-skip-forward-mini-fill:before {
  content: "\\f145";
}

.ri-skip-forward-mini-line:before {
  content: "\\f146";
}

.ri-skull-2-fill:before {
  content: "\\f147";
}

.ri-skull-2-line:before {
  content: "\\f148";
}

.ri-skull-fill:before {
  content: "\\f149";
}

.ri-skull-line:before {
  content: "\\f14a";
}

.ri-skype-fill:before {
  content: "\\f14b";
}

.ri-skype-line:before {
  content: "\\f14c";
}

.ri-slack-fill:before {
  content: "\\f14d";
}

.ri-slack-line:before {
  content: "\\f14e";
}

.ri-slice-fill:before {
  content: "\\f14f";
}

.ri-slice-line:before {
  content: "\\f150";
}

.ri-slideshow-2-fill:before {
  content: "\\f151";
}

.ri-slideshow-2-line:before {
  content: "\\f152";
}

.ri-slideshow-3-fill:before {
  content: "\\f153";
}

.ri-slideshow-3-line:before {
  content: "\\f154";
}

.ri-slideshow-4-fill:before {
  content: "\\f155";
}

.ri-slideshow-4-line:before {
  content: "\\f156";
}

.ri-slideshow-fill:before {
  content: "\\f157";
}

.ri-slideshow-line:before {
  content: "\\f158";
}

.ri-smartphone-fill:before {
  content: "\\f159";
}

.ri-smartphone-line:before {
  content: "\\f15a";
}

.ri-snapchat-fill:before {
  content: "\\f15b";
}

.ri-snapchat-line:before {
  content: "\\f15c";
}

.ri-snowy-fill:before {
  content: "\\f15d";
}

.ri-snowy-line:before {
  content: "\\f15e";
}

.ri-sort-asc:before {
  content: "\\f15f";
}

.ri-sort-desc:before {
  content: "\\f160";
}

.ri-sound-module-fill:before {
  content: "\\f161";
}

.ri-sound-module-line:before {
  content: "\\f162";
}

.ri-soundcloud-fill:before {
  content: "\\f163";
}

.ri-soundcloud-line:before {
  content: "\\f164";
}

.ri-space-ship-fill:before {
  content: "\\f165";
}

.ri-space-ship-line:before {
  content: "\\f166";
}

.ri-space:before {
  content: "\\f167";
}

.ri-spam-2-fill:before {
  content: "\\f168";
}

.ri-spam-2-line:before {
  content: "\\f169";
}

.ri-spam-3-fill:before {
  content: "\\f16a";
}

.ri-spam-3-line:before {
  content: "\\f16b";
}

.ri-spam-fill:before {
  content: "\\f16c";
}

.ri-spam-line:before {
  content: "\\f16d";
}

.ri-speaker-2-fill:before {
  content: "\\f16e";
}

.ri-speaker-2-line:before {
  content: "\\f16f";
}

.ri-speaker-3-fill:before {
  content: "\\f170";
}

.ri-speaker-3-line:before {
  content: "\\f171";
}

.ri-speaker-fill:before {
  content: "\\f172";
}

.ri-speaker-line:before {
  content: "\\f173";
}

.ri-spectrum-fill:before {
  content: "\\f174";
}

.ri-spectrum-line:before {
  content: "\\f175";
}

.ri-speed-fill:before {
  content: "\\f176";
}

.ri-speed-line:before {
  content: "\\f177";
}

.ri-speed-mini-fill:before {
  content: "\\f178";
}

.ri-speed-mini-line:before {
  content: "\\f179";
}

.ri-split-cells-horizontal:before {
  content: "\\f17a";
}

.ri-split-cells-vertical:before {
  content: "\\f17b";
}

.ri-spotify-fill:before {
  content: "\\f17c";
}

.ri-spotify-line:before {
  content: "\\f17d";
}

.ri-spy-fill:before {
  content: "\\f17e";
}

.ri-spy-line:before {
  content: "\\f17f";
}

.ri-stack-fill:before {
  content: "\\f180";
}

.ri-stack-line:before {
  content: "\\f181";
}

.ri-stack-overflow-fill:before {
  content: "\\f182";
}

.ri-stack-overflow-line:before {
  content: "\\f183";
}

.ri-stackshare-fill:before {
  content: "\\f184";
}

.ri-stackshare-line:before {
  content: "\\f185";
}

.ri-star-fill:before {
  content: "\\f186";
}

.ri-star-half-fill:before {
  content: "\\f187";
}

.ri-star-half-line:before {
  content: "\\f188";
}

.ri-star-half-s-fill:before {
  content: "\\f189";
}

.ri-star-half-s-line:before {
  content: "\\f18a";
}

.ri-star-line:before {
  content: "\\f18b";
}

.ri-star-s-fill:before {
  content: "\\f18c";
}

.ri-star-s-line:before {
  content: "\\f18d";
}

.ri-star-smile-fill:before {
  content: "\\f18e";
}

.ri-star-smile-line:before {
  content: "\\f18f";
}

.ri-steam-fill:before {
  content: "\\f190";
}

.ri-steam-line:before {
  content: "\\f191";
}

.ri-steering-2-fill:before {
  content: "\\f192";
}

.ri-steering-2-line:before {
  content: "\\f193";
}

.ri-steering-fill:before {
  content: "\\f194";
}

.ri-steering-line:before {
  content: "\\f195";
}

.ri-stethoscope-fill:before {
  content: "\\f196";
}

.ri-stethoscope-line:before {
  content: "\\f197";
}

.ri-sticky-note-2-fill:before {
  content: "\\f198";
}

.ri-sticky-note-2-line:before {
  content: "\\f199";
}

.ri-sticky-note-fill:before {
  content: "\\f19a";
}

.ri-sticky-note-line:before {
  content: "\\f19b";
}

.ri-stock-fill:before {
  content: "\\f19c";
}

.ri-stock-line:before {
  content: "\\f19d";
}

.ri-stop-circle-fill:before {
  content: "\\f19e";
}

.ri-stop-circle-line:before {
  content: "\\f19f";
}

.ri-stop-fill:before {
  content: "\\f1a0";
}

.ri-stop-line:before {
  content: "\\f1a1";
}

.ri-stop-mini-fill:before {
  content: "\\f1a2";
}

.ri-stop-mini-line:before {
  content: "\\f1a3";
}

.ri-store-2-fill:before {
  content: "\\f1a4";
}

.ri-store-2-line:before {
  content: "\\f1a5";
}

.ri-store-3-fill:before {
  content: "\\f1a6";
}

.ri-store-3-line:before {
  content: "\\f1a7";
}

.ri-store-fill:before {
  content: "\\f1a8";
}

.ri-store-line:before {
  content: "\\f1a9";
}

.ri-strikethrough-2:before {
  content: "\\f1aa";
}

.ri-strikethrough:before {
  content: "\\f1ab";
}

.ri-subscript-2:before {
  content: "\\f1ac";
}

.ri-subscript:before {
  content: "\\f1ad";
}

.ri-subtract-fill:before {
  content: "\\f1ae";
}

.ri-subtract-line:before {
  content: "\\f1af";
}

.ri-subway-fill:before {
  content: "\\f1b0";
}

.ri-subway-line:before {
  content: "\\f1b1";
}

.ri-subway-wifi-fill:before {
  content: "\\f1b2";
}

.ri-subway-wifi-line:before {
  content: "\\f1b3";
}

.ri-suitcase-2-fill:before {
  content: "\\f1b4";
}

.ri-suitcase-2-line:before {
  content: "\\f1b5";
}

.ri-suitcase-3-fill:before {
  content: "\\f1b6";
}

.ri-suitcase-3-line:before {
  content: "\\f1b7";
}

.ri-suitcase-fill:before {
  content: "\\f1b8";
}

.ri-suitcase-line:before {
  content: "\\f1b9";
}

.ri-sun-cloudy-fill:before {
  content: "\\f1ba";
}

.ri-sun-cloudy-line:before {
  content: "\\f1bb";
}

.ri-sun-fill:before {
  content: "\\f1bc";
}

.ri-sun-foggy-fill:before {
  content: "\\f1bd";
}

.ri-sun-foggy-line:before {
  content: "\\f1be";
}

.ri-sun-line:before {
  content: "\\f1bf";
}

.ri-superscript-2:before {
  content: "\\f1c0";
}

.ri-superscript:before {
  content: "\\f1c1";
}

.ri-surgical-mask-fill:before {
  content: "\\f1c2";
}

.ri-surgical-mask-line:before {
  content: "\\f1c3";
}

.ri-surround-sound-fill:before {
  content: "\\f1c4";
}

.ri-surround-sound-line:before {
  content: "\\f1c5";
}

.ri-survey-fill:before {
  content: "\\f1c6";
}

.ri-survey-line:before {
  content: "\\f1c7";
}

.ri-swap-box-fill:before {
  content: "\\f1c8";
}

.ri-swap-box-line:before {
  content: "\\f1c9";
}

.ri-swap-fill:before {
  content: "\\f1ca";
}

.ri-swap-line:before {
  content: "\\f1cb";
}

.ri-switch-fill:before {
  content: "\\f1cc";
}

.ri-switch-line:before {
  content: "\\f1cd";
}

.ri-sword-fill:before {
  content: "\\f1ce";
}

.ri-sword-line:before {
  content: "\\f1cf";
}

.ri-syringe-fill:before {
  content: "\\f1d0";
}

.ri-syringe-line:before {
  content: "\\f1d1";
}

.ri-t-box-fill:before {
  content: "\\f1d2";
}

.ri-t-box-line:before {
  content: "\\f1d3";
}

.ri-t-shirt-2-fill:before {
  content: "\\f1d4";
}

.ri-t-shirt-2-line:before {
  content: "\\f1d5";
}

.ri-t-shirt-air-fill:before {
  content: "\\f1d6";
}

.ri-t-shirt-air-line:before {
  content: "\\f1d7";
}

.ri-t-shirt-fill:before {
  content: "\\f1d8";
}

.ri-t-shirt-line:before {
  content: "\\f1d9";
}

.ri-table-2:before {
  content: "\\f1da";
}

.ri-table-alt-fill:before {
  content: "\\f1db";
}

.ri-table-alt-line:before {
  content: "\\f1dc";
}

.ri-table-fill:before {
  content: "\\f1dd";
}

.ri-table-line:before {
  content: "\\f1de";
}

.ri-tablet-fill:before {
  content: "\\f1df";
}

.ri-tablet-line:before {
  content: "\\f1e0";
}

.ri-takeaway-fill:before {
  content: "\\f1e1";
}

.ri-takeaway-line:before {
  content: "\\f1e2";
}

.ri-taobao-fill:before {
  content: "\\f1e3";
}

.ri-taobao-line:before {
  content: "\\f1e4";
}

.ri-tape-fill:before {
  content: "\\f1e5";
}

.ri-tape-line:before {
  content: "\\f1e6";
}

.ri-task-fill:before {
  content: "\\f1e7";
}

.ri-task-line:before {
  content: "\\f1e8";
}

.ri-taxi-fill:before {
  content: "\\f1e9";
}

.ri-taxi-line:before {
  content: "\\f1ea";
}

.ri-taxi-wifi-fill:before {
  content: "\\f1eb";
}

.ri-taxi-wifi-line:before {
  content: "\\f1ec";
}

.ri-team-fill:before {
  content: "\\f1ed";
}

.ri-team-line:before {
  content: "\\f1ee";
}

.ri-telegram-fill:before {
  content: "\\f1ef";
}

.ri-telegram-line:before {
  content: "\\f1f0";
}

.ri-temp-cold-fill:before {
  content: "\\f1f1";
}

.ri-temp-cold-line:before {
  content: "\\f1f2";
}

.ri-temp-hot-fill:before {
  content: "\\f1f3";
}

.ri-temp-hot-line:before {
  content: "\\f1f4";
}

.ri-terminal-box-fill:before {
  content: "\\f1f5";
}

.ri-terminal-box-line:before {
  content: "\\f1f6";
}

.ri-terminal-fill:before {
  content: "\\f1f7";
}

.ri-terminal-line:before {
  content: "\\f1f8";
}

.ri-terminal-window-fill:before {
  content: "\\f1f9";
}

.ri-terminal-window-line:before {
  content: "\\f1fa";
}

.ri-test-tube-fill:before {
  content: "\\f1fb";
}

.ri-test-tube-line:before {
  content: "\\f1fc";
}

.ri-text-direction-l:before {
  content: "\\f1fd";
}

.ri-text-direction-r:before {
  content: "\\f1fe";
}

.ri-text-spacing:before {
  content: "\\f1ff";
}

.ri-text-wrap:before {
  content: "\\f200";
}

.ri-text:before {
  content: "\\f201";
}

.ri-thermometer-fill:before {
  content: "\\f202";
}

.ri-thermometer-line:before {
  content: "\\f203";
}

.ri-thumb-down-fill:before {
  content: "\\f204";
}

.ri-thumb-down-line:before {
  content: "\\f205";
}

.ri-thumb-up-fill:before {
  content: "\\f206";
}

.ri-thumb-up-line:before {
  content: "\\f207";
}

.ri-thunderstorms-fill:before {
  content: "\\f208";
}

.ri-thunderstorms-line:before {
  content: "\\f209";
}

.ri-ticket-2-fill:before {
  content: "\\f20a";
}

.ri-ticket-2-line:before {
  content: "\\f20b";
}

.ri-ticket-fill:before {
  content: "\\f20c";
}

.ri-ticket-line:before {
  content: "\\f20d";
}

.ri-time-fill:before {
  content: "\\f20e";
}

.ri-time-line:before {
  content: "\\f20f";
}

.ri-timer-2-fill:before {
  content: "\\f210";
}

.ri-timer-2-line:before {
  content: "\\f211";
}

.ri-timer-fill:before {
  content: "\\f212";
}

.ri-timer-flash-fill:before {
  content: "\\f213";
}

.ri-timer-flash-line:before {
  content: "\\f214";
}

.ri-timer-line:before {
  content: "\\f215";
}

.ri-todo-fill:before {
  content: "\\f216";
}

.ri-todo-line:before {
  content: "\\f217";
}

.ri-toggle-fill:before {
  content: "\\f218";
}

.ri-toggle-line:before {
  content: "\\f219";
}

.ri-tools-fill:before {
  content: "\\f21a";
}

.ri-tools-line:before {
  content: "\\f21b";
}

.ri-tornado-fill:before {
  content: "\\f21c";
}

.ri-tornado-line:before {
  content: "\\f21d";
}

.ri-trademark-fill:before {
  content: "\\f21e";
}

.ri-trademark-line:before {
  content: "\\f21f";
}

.ri-traffic-light-fill:before {
  content: "\\f220";
}

.ri-traffic-light-line:before {
  content: "\\f221";
}

.ri-train-fill:before {
  content: "\\f222";
}

.ri-train-line:before {
  content: "\\f223";
}

.ri-train-wifi-fill:before {
  content: "\\f224";
}

.ri-train-wifi-line:before {
  content: "\\f225";
}

.ri-translate-2:before {
  content: "\\f226";
}

.ri-translate:before {
  content: "\\f227";
}

.ri-travesti-fill:before {
  content: "\\f228";
}

.ri-travesti-line:before {
  content: "\\f229";
}

.ri-treasure-map-fill:before {
  content: "\\f22a";
}

.ri-treasure-map-line:before {
  content: "\\f22b";
}

.ri-trello-fill:before {
  content: "\\f22c";
}

.ri-trello-line:before {
  content: "\\f22d";
}

.ri-trophy-fill:before {
  content: "\\f22e";
}

.ri-trophy-line:before {
  content: "\\f22f";
}

.ri-truck-fill:before {
  content: "\\f230";
}

.ri-truck-line:before {
  content: "\\f231";
}

.ri-tumblr-fill:before {
  content: "\\f232";
}

.ri-tumblr-line:before {
  content: "\\f233";
}

.ri-tv-2-fill:before {
  content: "\\f234";
}

.ri-tv-2-line:before {
  content: "\\f235";
}

.ri-tv-fill:before {
  content: "\\f236";
}

.ri-tv-line:before {
  content: "\\f237";
}

.ri-twitch-fill:before {
  content: "\\f238";
}

.ri-twitch-line:before {
  content: "\\f239";
}

.ri-twitter-fill:before {
  content: "\\f23a";
}

.ri-twitter-line:before {
  content: "\\f23b";
}

.ri-typhoon-fill:before {
  content: "\\f23c";
}

.ri-typhoon-line:before {
  content: "\\f23d";
}

.ri-u-disk-fill:before {
  content: "\\f23e";
}

.ri-u-disk-line:before {
  content: "\\f23f";
}

.ri-ubuntu-fill:before {
  content: "\\f240";
}

.ri-ubuntu-line:before {
  content: "\\f241";
}

.ri-umbrella-fill:before {
  content: "\\f242";
}

.ri-umbrella-line:before {
  content: "\\f243";
}

.ri-underline:before {
  content: "\\f244";
}

.ri-uninstall-fill:before {
  content: "\\f245";
}

.ri-uninstall-line:before {
  content: "\\f246";
}

.ri-unsplash-fill:before {
  content: "\\f247";
}

.ri-unsplash-line:before {
  content: "\\f248";
}

.ri-upload-2-fill:before {
  content: "\\f249";
}

.ri-upload-2-line:before {
  content: "\\f24a";
}

.ri-upload-cloud-2-fill:before {
  content: "\\f24b";
}

.ri-upload-cloud-2-line:before {
  content: "\\f24c";
}

.ri-upload-cloud-fill:before {
  content: "\\f24d";
}

.ri-upload-cloud-line:before {
  content: "\\f24e";
}

.ri-upload-fill:before {
  content: "\\f24f";
}

.ri-upload-line:before {
  content: "\\f250";
}

.ri-usb-fill:before {
  content: "\\f251";
}

.ri-usb-line:before {
  content: "\\f252";
}

.ri-user-2-fill:before {
  content: "\\f253";
}

.ri-user-2-line:before {
  content: "\\f254";
}

.ri-user-3-fill:before {
  content: "\\f255";
}

.ri-user-3-line:before {
  content: "\\f256";
}

.ri-user-4-fill:before {
  content: "\\f257";
}

.ri-user-4-line:before {
  content: "\\f258";
}

.ri-user-5-fill:before {
  content: "\\f259";
}

.ri-user-5-line:before {
  content: "\\f25a";
}

.ri-user-6-fill:before {
  content: "\\f25b";
}

.ri-user-6-line:before {
  content: "\\f25c";
}

.ri-user-add-fill:before {
  content: "\\f25d";
}

.ri-user-add-line:before {
  content: "\\f25e";
}

.ri-user-fill:before {
  content: "\\f25f";
}

.ri-user-follow-fill:before {
  content: "\\f260";
}

.ri-user-follow-line:before {
  content: "\\f261";
}

.ri-user-heart-fill:before {
  content: "\\f262";
}

.ri-user-heart-line:before {
  content: "\\f263";
}

.ri-user-line:before {
  content: "\\f264";
}

.ri-user-location-fill:before {
  content: "\\f265";
}

.ri-user-location-line:before {
  content: "\\f266";
}

.ri-user-received-2-fill:before {
  content: "\\f267";
}

.ri-user-received-2-line:before {
  content: "\\f268";
}

.ri-user-received-fill:before {
  content: "\\f269";
}

.ri-user-received-line:before {
  content: "\\f26a";
}

.ri-user-search-fill:before {
  content: "\\f26b";
}

.ri-user-search-line:before {
  content: "\\f26c";
}

.ri-user-settings-fill:before {
  content: "\\f26d";
}

.ri-user-settings-line:before {
  content: "\\f26e";
}

.ri-user-shared-2-fill:before {
  content: "\\f26f";
}

.ri-user-shared-2-line:before {
  content: "\\f270";
}

.ri-user-shared-fill:before {
  content: "\\f271";
}

.ri-user-shared-line:before {
  content: "\\f272";
}

.ri-user-smile-fill:before {
  content: "\\f273";
}

.ri-user-smile-line:before {
  content: "\\f274";
}

.ri-user-star-fill:before {
  content: "\\f275";
}

.ri-user-star-line:before {
  content: "\\f276";
}

.ri-user-unfollow-fill:before {
  content: "\\f277";
}

.ri-user-unfollow-line:before {
  content: "\\f278";
}

.ri-user-voice-fill:before {
  content: "\\f279";
}

.ri-user-voice-line:before {
  content: "\\f27a";
}

.ri-video-add-fill:before {
  content: "\\f27b";
}

.ri-video-add-line:before {
  content: "\\f27c";
}

.ri-video-chat-fill:before {
  content: "\\f27d";
}

.ri-video-chat-line:before {
  content: "\\f27e";
}

.ri-video-download-fill:before {
  content: "\\f27f";
}

.ri-video-download-line:before {
  content: "\\f280";
}

.ri-video-fill:before {
  content: "\\f281";
}

.ri-video-line:before {
  content: "\\f282";
}

.ri-video-upload-fill:before {
  content: "\\f283";
}

.ri-video-upload-line:before {
  content: "\\f284";
}

.ri-vidicon-2-fill:before {
  content: "\\f285";
}

.ri-vidicon-2-line:before {
  content: "\\f286";
}

.ri-vidicon-fill:before {
  content: "\\f287";
}

.ri-vidicon-line:before {
  content: "\\f288";
}

.ri-vimeo-fill:before {
  content: "\\f289";
}

.ri-vimeo-line:before {
  content: "\\f28a";
}

.ri-vip-crown-2-fill:before {
  content: "\\f28b";
}

.ri-vip-crown-2-line:before {
  content: "\\f28c";
}

.ri-vip-crown-fill:before {
  content: "\\f28d";
}

.ri-vip-crown-line:before {
  content: "\\f28e";
}

.ri-vip-diamond-fill:before {
  content: "\\f28f";
}

.ri-vip-diamond-line:before {
  content: "\\f290";
}

.ri-vip-fill:before {
  content: "\\f291";
}

.ri-vip-line:before {
  content: "\\f292";
}

.ri-virus-fill:before {
  content: "\\f293";
}

.ri-virus-line:before {
  content: "\\f294";
}

.ri-visa-fill:before {
  content: "\\f295";
}

.ri-visa-line:before {
  content: "\\f296";
}

.ri-voice-recognition-fill:before {
  content: "\\f297";
}

.ri-voice-recognition-line:before {
  content: "\\f298";
}

.ri-voiceprint-fill:before {
  content: "\\f299";
}

.ri-voiceprint-line:before {
  content: "\\f29a";
}

.ri-volume-down-fill:before {
  content: "\\f29b";
}

.ri-volume-down-line:before {
  content: "\\f29c";
}

.ri-volume-mute-fill:before {
  content: "\\f29d";
}

.ri-volume-mute-line:before {
  content: "\\f29e";
}

.ri-volume-off-vibrate-fill:before {
  content: "\\f29f";
}

.ri-volume-off-vibrate-line:before {
  content: "\\f2a0";
}

.ri-volume-up-fill:before {
  content: "\\f2a1";
}

.ri-volume-up-line:before {
  content: "\\f2a2";
}

.ri-volume-vibrate-fill:before {
  content: "\\f2a3";
}

.ri-volume-vibrate-line:before {
  content: "\\f2a4";
}

.ri-vuejs-fill:before {
  content: "\\f2a5";
}

.ri-vuejs-line:before {
  content: "\\f2a6";
}

.ri-walk-fill:before {
  content: "\\f2a7";
}

.ri-walk-line:before {
  content: "\\f2a8";
}

.ri-wallet-2-fill:before {
  content: "\\f2a9";
}

.ri-wallet-2-line:before {
  content: "\\f2aa";
}

.ri-wallet-3-fill:before {
  content: "\\f2ab";
}

.ri-wallet-3-line:before {
  content: "\\f2ac";
}

.ri-wallet-fill:before {
  content: "\\f2ad";
}

.ri-wallet-line:before {
  content: "\\f2ae";
}

.ri-water-flash-fill:before {
  content: "\\f2af";
}

.ri-water-flash-line:before {
  content: "\\f2b0";
}

.ri-webcam-fill:before {
  content: "\\f2b1";
}

.ri-webcam-line:before {
  content: "\\f2b2";
}

.ri-wechat-2-fill:before {
  content: "\\f2b3";
}

.ri-wechat-2-line:before {
  content: "\\f2b4";
}

.ri-wechat-fill:before {
  content: "\\f2b5";
}

.ri-wechat-line:before {
  content: "\\f2b6";
}

.ri-wechat-pay-fill:before {
  content: "\\f2b7";
}

.ri-wechat-pay-line:before {
  content: "\\f2b8";
}

.ri-weibo-fill:before {
  content: "\\f2b9";
}

.ri-weibo-line:before {
  content: "\\f2ba";
}

.ri-whatsapp-fill:before {
  content: "\\f2bb";
}

.ri-whatsapp-line:before {
  content: "\\f2bc";
}

.ri-wheelchair-fill:before {
  content: "\\f2bd";
}

.ri-wheelchair-line:before {
  content: "\\f2be";
}

.ri-wifi-fill:before {
  content: "\\f2bf";
}

.ri-wifi-line:before {
  content: "\\f2c0";
}

.ri-wifi-off-fill:before {
  content: "\\f2c1";
}

.ri-wifi-off-line:before {
  content: "\\f2c2";
}

.ri-window-2-fill:before {
  content: "\\f2c3";
}

.ri-window-2-line:before {
  content: "\\f2c4";
}

.ri-window-fill:before {
  content: "\\f2c5";
}

.ri-window-line:before {
  content: "\\f2c6";
}

.ri-windows-fill:before {
  content: "\\f2c7";
}

.ri-windows-line:before {
  content: "\\f2c8";
}

.ri-windy-fill:before {
  content: "\\f2c9";
}

.ri-windy-line:before {
  content: "\\f2ca";
}

.ri-wireless-charging-fill:before {
  content: "\\f2cb";
}

.ri-wireless-charging-line:before {
  content: "\\f2cc";
}

.ri-women-fill:before {
  content: "\\f2cd";
}

.ri-women-line:before {
  content: "\\f2ce";
}

.ri-wubi-input:before {
  content: "\\f2cf";
}

.ri-xbox-fill:before {
  content: "\\f2d0";
}

.ri-xbox-line:before {
  content: "\\f2d1";
}

.ri-xing-fill:before {
  content: "\\f2d2";
}

.ri-xing-line:before {
  content: "\\f2d3";
}

.ri-youtube-fill:before {
  content: "\\f2d4";
}

.ri-youtube-line:before {
  content: "\\f2d5";
}

.ri-zcool-fill:before {
  content: "\\f2d6";
}

.ri-zcool-line:before {
  content: "\\f2d7";
}

.ri-zhihu-fill:before {
  content: "\\f2d8";
}

.ri-zhihu-line:before {
  content: "\\f2d9";
}

.ri-zoom-in-fill:before {
  content: "\\f2da";
}

.ri-zoom-in-line:before {
  content: "\\f2db";
}

.ri-zoom-out-fill:before {
  content: "\\f2dc";
}

.ri-zoom-out-line:before {
  content: "\\f2dd";
}

.ri-zzz-fill:before {
  content: "\\f2de";
}

.ri-zzz-line:before {
  content: "\\f2df";
}

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.4.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
/*!
 * Bootstrap  v5.2.3 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --vz-blue: #3577f1;
  --vz-indigo: #F26430;
  --vz-purple: #F28322;
  --vz-pink: #f672a7;
  --vz-red: #f06548;
  --vz-orange: #208C3B;
  --vz-yellow: #3FBF48;
  --vz-green: #0ab39c;
  --vz-teal: #02a8b5;
  --vz-cyan: #299cdb;
  --vz-white: #fff;
  --vz-gray: #878a99;
  --vz-gray-dark: #343a40;
  --vz-gray-100: #f3f6f9;
  --vz-gray-200: #eff2f7;
  --vz-gray-300: #e9ebec;
  --vz-gray-400: #ced4da;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #878a99;
  --vz-gray-700: #495057;
  --vz-gray-800: #343a40;
  --vz-gray-900: #212529;
  --vz-primary: #F26430;
  --vz-secondary: #208C3B;
  --vz-success: #0ab39c;
  --vz-info: #299cdb;
  --vz-warning: #3FBF48;
  --vz-danger: #f06548;
  --vz-light: #f3f6f9;
  --vz-dark: #212529;
  --vz-primary-rgb: 242, 100, 48;
  --vz-secondary-rgb: 32, 140, 59;
  --vz-success-rgb: 10, 179, 156;
  --vz-info-rgb: 41, 156, 219;
  --vz-warning-rgb: 63, 191, 72;
  --vz-danger-rgb: 240, 101, 72;
  --vz-light-rgb: 243, 246, 249;
  --vz-dark-rgb: 33, 37, 41;
  --vz-white-rgb: 255, 255, 255;
  --vz-black-rgb: 0, 0, 0;
  --vz-body-color-rgb: 33, 37, 41;
  --vz-body-bg-rgb: 243, 243, 249;
  --vz-font-sans-serif: "Poppins", sans-serif;
  --vz-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --vz-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --vz-body-font-family: var(--vz-font-sans-serif);
  --vz-body-font-size: 0.8125rem;
  --vz-body-font-weight: 400;
  --vz-body-line-height: 1.5;
  --vz-body-color: #212529;
  --vz-body-bg: #f3f3f9;
  --vz-border-width: 1px;
  --vz-border-style: solid;
  --vz-border-color: var(--vz-border-color);
  --vz-border-color-translucent: rgba(0, 0, 0, 0.175);
  --vz-border-radius: 0.25rem;
  --vz-border-radius-sm: 0.2rem;
  --vz-border-radius-lg: 0.3rem;
  --vz-border-radius-xl: 1rem;
  --vz-border-radius-2xl: 2rem;
  --vz-border-radius-pill: 50rem;
  --vz-link-color: var(--vz-link-color);
  --vz-link-hover-color: var(--vz-link-hover-color);
  --vz-code-color: #f672a7;
  --vz-highlight-bg: #fcf8e3;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--vz-body-font-family);
  font-size: var(--vz-body-font-size);
  font-weight: var(--vz-body-font-weight);
  line-height: var(--vz-body-line-height);
  color: var(--vz-body-color);
  text-align: var(--vz-body-text-align);
  background-color: var(--vz-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: calc(1.328125rem + 0.9375vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.03125rem;
  }
}

h2, .h2 {
  font-size: calc(1.2875rem + 0.45vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.625rem;
  }
}

h3, .h3 {
  font-size: calc(1.2671875rem + 0.20625vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.421875rem;
  }
}

h4, .h4 {
  font-size: 1.21875rem;
}

h5, .h5 {
  font-size: 1.015625rem;
}

h6, .h6 {
  font-size: 0.8125rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.2em;
  background-color: var(--vz-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--vz-link-color);
  text-decoration: underline;
}
a:hover {
  color: var(--vz-link-hover-color);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--vz-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--vz-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #878a99;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend {
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.015625rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-1 {
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-2 {
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-3 {
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-4 {
  font-weight: 300;
  line-height: 1.2;
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-5 {
  font-weight: 300;
  line-height: 1.2;
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.display-6 {
  font-weight: 300;
  line-height: 1.2;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.89375rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #878a99;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--vz-body-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #878a99;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --vz-gutter-x: 1rem;
  --vz-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--vz-gutter-x) * 0.5);
  padding-left: calc(var(--vz-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.row {
  --vz-gutter-x: 1rem;
  --vz-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--vz-gutter-y));
  margin-right: calc(-0.5 * var(--vz-gutter-x));
  margin-left: calc(-0.5 * var(--vz-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--vz-gutter-x) * 0.5);
  padding-left: calc(var(--vz-gutter-x) * 0.5);
  margin-top: var(--vz-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --vz-gutter-x: 0;
}

.g-0,
.gy-0 {
  --vz-gutter-y: 0;
}

.g-1,
.gx-1 {
  --vz-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --vz-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --vz-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --vz-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --vz-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --vz-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --vz-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --vz-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --vz-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --vz-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --vz-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --vz-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --vz-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --vz-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --vz-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --vz-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --vz-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --vz-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --vz-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --vz-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --vz-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --vz-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --vz-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --vz-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --vz-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --vz-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --vz-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --vz-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --vz-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --vz-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --vz-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --vz-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --vz-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --vz-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --vz-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --vz-gutter-y: 3rem;
  }
}
.table {
  --vz-table-color: var(--vz-body-color);
  --vz-table-bg: transparent;
  --vz-table-border-color: var(--vz-border-color);
  --vz-table-accent-bg: transparent;
  --vz-table-striped-color: var(--vz-body-color);
  --vz-table-striped-bg: rgba(var(--vz-dark-rgb), 0.02);
  --vz-table-active-color: var(--vz-body-color);
  --vz-table-active-bg: rgba(var(--vz-light-rgb), 1);
  --vz-table-hover-color: var(--vz-body-color);
  --vz-table-hover-bg: rgba(var(--vz-light-rgb), 1);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--vz-table-color);
  vertical-align: top;
  border-color: var(--vz-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.6rem;
  background-color: var(--vz-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--vz-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: 2px solid var(--vz-border-color);
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --vz-table-accent-bg: var(--vz-table-striped-bg);
  color: var(--vz-table-striped-color);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --vz-table-accent-bg: var(--vz-table-striped-bg);
  color: var(--vz-table-striped-color);
}

.table-active {
  --vz-table-accent-bg: var(--vz-table-active-bg);
  color: var(--vz-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --vz-table-accent-bg: var(--vz-table-hover-bg);
  color: var(--vz-table-hover-color);
}

.table-primary {
  --vz-table-color: #000;
  --vz-table-bg: rgb(252.4, 224, 213.6);
  --vz-table-border-color: rgb(227.16, 201.6, 192.24);
  --vz-table-striped-bg: rgb(247.352, 219.52, 209.328);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-secondary {
  --vz-table-color: #000;
  --vz-table-bg: rgb(210.4, 232, 215.8);
  --vz-table-border-color: rgb(189.36, 208.8, 194.22);
  --vz-table-striped-bg: rgb(206.192, 227.36, 211.484);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-success {
  --vz-table-color: #000;
  --vz-table-bg: rgb(206, 239.8, 235.2);
  --vz-table-border-color: rgb(185.4, 215.82, 211.68);
  --vz-table-striped-bg: rgb(201.88, 235.004, 230.496);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-info {
  --vz-table-color: #000;
  --vz-table-bg: rgb(212.2, 235.2, 247.8);
  --vz-table-border-color: rgb(190.98, 211.68, 223.02);
  --vz-table-striped-bg: rgb(207.956, 230.496, 242.844);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-warning {
  --vz-table-color: #000;
  --vz-table-bg: rgb(216.6, 242.2, 218.4);
  --vz-table-border-color: rgb(194.94, 217.98, 196.56);
  --vz-table-striped-bg: rgb(212.268, 237.356, 214.032);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-danger {
  --vz-table-color: #000;
  --vz-table-bg: rgb(252, 224.2, 218.4);
  --vz-table-border-color: rgb(226.8, 201.78, 196.56);
  --vz-table-striped-bg: rgb(246.96, 219.716, 214.032);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-light {
  --vz-table-color: #000;
  --vz-table-bg: #f3f6f9;
  --vz-table-border-color: rgb(218.7, 221.4, 224.1);
  --vz-table-striped-bg: rgb(238.14, 241.08, 244.02);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-dark {
  --vz-table-color: #fff;
  --vz-table-bg: #212529;
  --vz-table-border-color: rgb(55.2, 58.8, 62.4);
  --vz-table-striped-bg: rgb(37.44, 41.36, 45.28);
  --vz-table-striped-color: #fff;
  --vz-table-active-bg: white;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: white;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.7rem + 1px);
  padding-bottom: calc(0.7rem + 1px);
  font-size: 1.015625rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.7109375rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #878a99;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  border-color: var(--vz-input-focus-border);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25);
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::placeholder {
  color: #878a99;
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--vz-input-disabled-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5rem 0.9rem;
  margin: -0.5rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: var(--vz-body-color);
  background-color: var(--vz-input-group-addon-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--vz-input-group-addon-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
  padding: 0.7rem 1.2rem;
  font-size: 1.015625rem;
  border-radius: 0.3rem;
}
.form-control-lg::file-selector-button {
  padding: 0.7rem 1.2rem;
  margin: -0.7rem -1.2rem;
  margin-inline-end: 1.2rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  border-radius: 0.25rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.4rem + 2px);
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 2.7rem 0.5rem 0.9rem;
  -moz-padding-start: calc(0.9rem - 3px);
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 16px 12px;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select {
  appearance: none;
}
.form-select:focus {
  border-color: var(--vz-input-focus-border);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.9rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--vz-input-disabled-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--vz-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}

.form-select-lg {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 1.2rem;
  font-size: 1.015625rem;
  border-radius: 0.3rem;
}

.form-check {
  display: block;
  min-height: 1.21875rem;
  padding-left: 1.6em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.6em;
}

.form-check-reverse {
  padding-right: 1.6em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.6em;
  margin-left: 0;
}

.form-check-input {
  width: 1.1em;
  height: 1.1em;
  margin-top: 0.2em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--vz-input-focus-border);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25);
}
.form-check-input:checked {
  background-color: #F26430;
  border-color: #F26430;
}
.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #F26430;
  border-color: #F26430;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f3f3f9, 0 0 0 0 rgba(242, 100, 48, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f3f3f9, 0 0 0 0 rgba(242, 100, 48, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #F26430;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb {
  appearance: none;
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(251.1, 208.5, 192.9);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--vz-gray-300);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #F26430;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb {
  appearance: none;
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(251.1, 208.5, 192.9);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--vz-gray-300);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 0.9rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.9rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-input-group-addon-bg);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.7rem 1.2rem;
  font-size: 1.015625rem;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #0ab39c;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7109375rem;
  color: #fff;
  background-color: rgba(10, 179, 156, 0.9);
  border-radius: 0.2rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #0ab39c;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #0ab39c;
  box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #0ab39c;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.95rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #0ab39c;
  box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #0ab39c;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #0ab39c;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #0ab39c;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #f06548;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7109375rem;
  color: #fff;
  background-color: rgba(240, 101, 72, 0.9);
  border-radius: 0.2rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f06548;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #f06548;
  box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #f06548;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.95rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #f06548;
  box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #f06548;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #f06548;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #f06548;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --vz-btn-padding-x: 0.9rem;
  --vz-btn-padding-y: 0.5rem;
  --vz-btn-font-family: ;
  --vz-btn-font-size: 0.8125rem;
  --vz-btn-font-weight: 400;
  --vz-btn-line-height: 1.5;
  --vz-btn-color: #212529;
  --vz-btn-bg: transparent;
  --vz-btn-border-width: 1px;
  --vz-btn-border-color: transparent;
  --vz-btn-border-radius: 0.25rem;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --vz-btn-disabled-opacity: 0.65;
  --vz-btn-focus-box-shadow: 0 0 0 0 rgba(var(--vz-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--vz-btn-padding-y) var(--vz-btn-padding-x);
  font-family: var(--vz-btn-font-family);
  font-size: var(--vz-btn-font-size);
  font-weight: var(--vz-btn-font-weight);
  line-height: var(--vz-btn-line-height);
  color: var(--vz-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--vz-btn-border-width) solid var(--vz-btn-border-color);
  border-radius: var(--vz-btn-border-radius);
  background-color: var(--vz-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--vz-btn-hover-color);
  background-color: var(--vz-btn-hover-bg);
  border-color: var(--vz-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--vz-btn-color);
  background-color: var(--vz-btn-bg);
  border-color: var(--vz-btn-border-color);
}
.btn:focus-visible {
  color: var(--vz-btn-hover-color);
  background-color: var(--vz-btn-hover-bg);
  border-color: var(--vz-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--vz-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--vz-btn-active-color);
  background-color: var(--vz-btn-active-bg);
  border-color: var(--vz-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--vz-btn-disabled-color);
  pointer-events: none;
  background-color: var(--vz-btn-disabled-bg);
  border-color: var(--vz-btn-disabled-border-color);
  opacity: var(--vz-btn-disabled-opacity);
}

.btn-primary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #F26430;
  --vz-btn-border-color: #F26430;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(205.7, 85, 40.8);
  --vz-btn-hover-border-color: rgb(193.6, 80, 38.4);
  --vz-btn-focus-shadow-rgb: 244, 123, 79;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(193.6, 80, 38.4);
  --vz-btn-active-border-color: rgb(181.5, 75, 36);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #F26430;
  --vz-btn-disabled-border-color: #F26430;
}

.btn-secondary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #208C3B;
  --vz-btn-border-color: #208C3B;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(27.2, 119, 50.15);
  --vz-btn-hover-border-color: rgb(25.6, 112, 47.2);
  --vz-btn-focus-shadow-rgb: 65, 157, 88;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(25.6, 112, 47.2);
  --vz-btn-active-border-color: rgb(24, 105, 44.25);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #208C3B;
  --vz-btn-disabled-border-color: #208C3B;
}

.btn-success {
  --vz-btn-color: #fff;
  --vz-btn-bg: #0ab39c;
  --vz-btn-border-color: #0ab39c;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(8.5, 152.15, 132.6);
  --vz-btn-hover-border-color: rgb(8, 143.2, 124.8);
  --vz-btn-focus-shadow-rgb: 47, 190, 171;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(8, 143.2, 124.8);
  --vz-btn-active-border-color: rgb(7.5, 134.25, 117);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #0ab39c;
  --vz-btn-disabled-border-color: #0ab39c;
}

.btn-info {
  --vz-btn-color: #fff;
  --vz-btn-bg: #299cdb;
  --vz-btn-border-color: #299cdb;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(34.85, 132.6, 186.15);
  --vz-btn-hover-border-color: rgb(32.8, 124.8, 175.2);
  --vz-btn-focus-shadow-rgb: 73, 171, 224;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(32.8, 124.8, 175.2);
  --vz-btn-active-border-color: rgb(30.75, 117, 164.25);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #299cdb;
  --vz-btn-disabled-border-color: #299cdb;
}

.btn-warning {
  --vz-btn-color: #fff;
  --vz-btn-bg: #3FBF48;
  --vz-btn-border-color: #3FBF48;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(53.55, 162.35, 61.2);
  --vz-btn-hover-border-color: rgb(50.4, 152.8, 57.6);
  --vz-btn-focus-shadow-rgb: 92, 201, 99;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(50.4, 152.8, 57.6);
  --vz-btn-active-border-color: rgb(47.25, 143.25, 54);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #3FBF48;
  --vz-btn-disabled-border-color: #3FBF48;
}

.btn-danger {
  --vz-btn-color: #fff;
  --vz-btn-bg: #f06548;
  --vz-btn-border-color: #f06548;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(204, 85.85, 61.2);
  --vz-btn-hover-border-color: rgb(192, 80.8, 57.6);
  --vz-btn-focus-shadow-rgb: 242, 124, 99;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(192, 80.8, 57.6);
  --vz-btn-active-border-color: rgb(180, 75.75, 54);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #f06548;
  --vz-btn-disabled-border-color: #f06548;
}

.btn-light {
  --vz-btn-color: #000;
  --vz-btn-bg: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: rgb(206.55, 209.1, 211.65);
  --vz-btn-hover-border-color: rgb(194.4, 196.8, 199.2);
  --vz-btn-focus-shadow-rgb: 207, 209, 212;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: rgb(194.4, 196.8, 199.2);
  --vz-btn-active-border-color: rgb(182.25, 184.5, 186.75);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #f3f6f9;
  --vz-btn-disabled-border-color: #f3f6f9;
}

.btn-dark {
  --vz-btn-color: #fff;
  --vz-btn-bg: #212529;
  --vz-btn-border-color: #212529;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --vz-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --vz-btn-focus-shadow-rgb: 66, 70, 73;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --vz-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #212529;
  --vz-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --vz-btn-color: #F26430;
  --vz-btn-border-color: #F26430;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #F26430;
  --vz-btn-hover-border-color: #F26430;
  --vz-btn-focus-shadow-rgb: 242, 100, 48;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #F26430;
  --vz-btn-active-border-color: #F26430;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #F26430;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #F26430;
  --vz-gradient: none;
}

.btn-outline-secondary {
  --vz-btn-color: #208C3B;
  --vz-btn-border-color: #208C3B;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #208C3B;
  --vz-btn-hover-border-color: #208C3B;
  --vz-btn-focus-shadow-rgb: 32, 140, 59;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #208C3B;
  --vz-btn-active-border-color: #208C3B;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #208C3B;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #208C3B;
  --vz-gradient: none;
}

.btn-outline-success {
  --vz-btn-color: #0ab39c;
  --vz-btn-border-color: #0ab39c;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #0ab39c;
  --vz-btn-hover-border-color: #0ab39c;
  --vz-btn-focus-shadow-rgb: 10, 179, 156;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #0ab39c;
  --vz-btn-active-border-color: #0ab39c;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #0ab39c;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #0ab39c;
  --vz-gradient: none;
}

.btn-outline-info {
  --vz-btn-color: #299cdb;
  --vz-btn-border-color: #299cdb;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #299cdb;
  --vz-btn-hover-border-color: #299cdb;
  --vz-btn-focus-shadow-rgb: 41, 156, 219;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #299cdb;
  --vz-btn-active-border-color: #299cdb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #299cdb;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #299cdb;
  --vz-gradient: none;
}

.btn-outline-warning {
  --vz-btn-color: #3FBF48;
  --vz-btn-border-color: #3FBF48;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #3FBF48;
  --vz-btn-hover-border-color: #3FBF48;
  --vz-btn-focus-shadow-rgb: 63, 191, 72;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #3FBF48;
  --vz-btn-active-border-color: #3FBF48;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #3FBF48;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #3FBF48;
  --vz-gradient: none;
}

.btn-outline-danger {
  --vz-btn-color: #f06548;
  --vz-btn-border-color: #f06548;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #f06548;
  --vz-btn-hover-border-color: #f06548;
  --vz-btn-focus-shadow-rgb: 240, 101, 72;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #f06548;
  --vz-btn-active-border-color: #f06548;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f06548;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f06548;
  --vz-gradient: none;
}

.btn-outline-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #f3f6f9;
  --vz-btn-hover-border-color: #f3f6f9;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #f3f6f9;
  --vz-btn-active-border-color: #f3f6f9;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f3f6f9;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f3f6f9;
  --vz-gradient: none;
}

.btn-outline-dark {
  --vz-btn-color: #212529;
  --vz-btn-border-color: #212529;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #212529;
  --vz-btn-hover-border-color: #212529;
  --vz-btn-focus-shadow-rgb: 33, 37, 41;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #212529;
  --vz-btn-active-border-color: #212529;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #212529;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #212529;
  --vz-gradient: none;
}

.btn-link {
  --vz-btn-font-weight: 400;
  --vz-btn-color: var(--vz-link-color);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-link-hover-color);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-active-color: var(--vz-link-hover-color);
  --vz-btn-active-border-color: transparent;
  --vz-btn-disabled-color: #878a99;
  --vz-btn-disabled-border-color: transparent;
  --vz-btn-box-shadow: none;
  --vz-btn-focus-shadow-rgb: 244, 123, 79;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--vz-btn-color);
}
.btn-link:hover {
  color: var(--vz-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --vz-btn-padding-y: 0.7rem;
  --vz-btn-padding-x: 1.2rem;
  --vz-btn-font-size: 1.015625rem;
  --vz-btn-border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  --vz-btn-padding-y: 0.25rem;
  --vz-btn-padding-x: 0.5rem;
  --vz-btn-font-size: 0.7109375rem;
  --vz-btn-border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --vz-dropdown-zindex: 1000;
  --vz-dropdown-min-width: 10rem;
  --vz-dropdown-padding-x: 0;
  --vz-dropdown-padding-y: 0.5rem;
  --vz-dropdown-spacer: 0.125rem;
  --vz-dropdown-font-size: 0.8125rem;
  --vz-dropdown-color: var(--vz-body-color);
  --vz-dropdown-bg: #fff;
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-border-radius: 0.3rem;
  --vz-dropdown-border-width: 0;
  --vz-dropdown-inner-border-radius: 0.3rem;
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-divider-margin-y: 0.5rem;
  --vz-dropdown-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-dropdown-link-color: #212529;
  --vz-dropdown-link-hover-color: rgb(29.7, 33.3, 36.9);
  --vz-dropdown-link-hover-bg: #f3f6f9;
  --vz-dropdown-link-active-color: rgb(29.7, 33.3, 36.9);
  --vz-dropdown-link-active-bg: #f3f6f9;
  --vz-dropdown-link-disabled-color: #adb5bd;
  --vz-dropdown-item-padding-x: 1.2rem;
  --vz-dropdown-item-padding-y: 0.35rem;
  --vz-dropdown-header-color: #878a99;
  --vz-dropdown-header-padding-x: 1.2rem;
  --vz-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--vz-dropdown-zindex);
  display: none;
  min-width: var(--vz-dropdown-min-width);
  padding: var(--vz-dropdown-padding-y) var(--vz-dropdown-padding-x);
  margin: 0;
  font-size: var(--vz-dropdown-font-size);
  color: var(--vz-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--vz-dropdown-bg);
  background-clip: padding-box;
  border: var(--vz-dropdown-border-width) solid var(--vz-dropdown-border-color);
  border-radius: var(--vz-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--vz-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--vz-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--vz-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--vz-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--vz-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--vz-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--vz-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--vz-dropdown-link-hover-color);
  background-color: var(--vz-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--vz-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--vz-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--vz-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--vz-dropdown-header-padding-y) var(--vz-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.7109375rem;
  color: var(--vz-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  color: var(--vz-dropdown-link-color);
}

.dropdown-menu-dark {
  --vz-dropdown-color: #e9ebec;
  --vz-dropdown-bg: #343a40;
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-box-shadow: ;
  --vz-dropdown-link-color: #e9ebec;
  --vz-dropdown-link-hover-color: #fff;
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --vz-dropdown-link-active-color: #fff;
  --vz-dropdown-link-active-bg: rgb(63.4310344828, 70.75, 78.0689655172);
  --vz-dropdown-link-disabled-color: #adb5bd;
  --vz-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.25rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.9rem;
  padding-left: 0.9rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --vz-nav-link-padding-x: 1rem;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-link-color);
  --vz-nav-link-hover-color: var(--vz-link-hover-color);
  --vz-nav-link-disabled-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--vz-nav-link-padding-y) var(--vz-nav-link-padding-x);
  font-size: var(--vz-nav-link-font-size);
  font-weight: var(--vz-nav-link-font-weight);
  color: var(--vz-nav-link-color);
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--vz-nav-link-hover-color);
}
.nav-link.disabled {
  color: var(--vz-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --vz-nav-tabs-border-width: 1px;
  --vz-nav-tabs-border-color: var(--vz-gray-300);
  --vz-nav-tabs-border-radius: 0.25rem;
  --vz-nav-tabs-link-hover-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-gray-300);
  --vz-nav-tabs-link-active-color: #495057;
  --vz-nav-tabs-link-active-bg: var(--vz-nav-tabs-link-active-bg);
  --vz-nav-tabs-link-active-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-nav-tabs-link-active-bg);
  border-bottom: var(--vz-nav-tabs-border-width) solid var(--vz-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--vz-nav-tabs-border-width));
  background: none;
  border: var(--vz-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--vz-nav-tabs-border-radius);
  border-top-right-radius: var(--vz-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--vz-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: var(--vz-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--vz-nav-tabs-link-active-color);
  background-color: var(--vz-nav-tabs-link-active-bg);
  border-color: var(--vz-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--vz-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --vz-nav-pills-border-radius: 0.25rem;
  --vz-nav-pills-link-active-color: #fff;
  --vz-nav-pills-link-active-bg: #F26430;
}
.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: var(--vz-nav-pills-border-radius);
}
.nav-pills .nav-link:disabled {
  color: var(--vz-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--vz-nav-pills-link-active-color);
  background-color: var(--vz-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --vz-navbar-padding-x: 0;
  --vz-navbar-padding-y: 0.5rem;
  --vz-navbar-color: rgba(0, 0, 0, 0.55);
  --vz-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --vz-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --vz-navbar-active-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-brand-padding-y: 0.34765625rem;
  --vz-navbar-brand-margin-end: 1rem;
  --vz-navbar-brand-font-size: 1.015625rem;
  --vz-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-nav-link-padding-x: 0.5rem;
  --vz-navbar-toggler-padding-y: 0.25rem;
  --vz-navbar-toggler-padding-x: 0.75rem;
  --vz-navbar-toggler-font-size: 1.015625rem;
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  --vz-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --vz-navbar-toggler-border-radius: 0.25rem;
  --vz-navbar-toggler-focus-width: 0;
  --vz-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-navbar-padding-y) var(--vz-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--vz-navbar-brand-padding-y);
  padding-bottom: var(--vz-navbar-brand-padding-y);
  margin-right: var(--vz-navbar-brand-margin-end);
  font-size: var(--vz-navbar-brand-font-size);
  color: var(--vz-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--vz-navbar-brand-hover-color);
}

.navbar-nav {
  --vz-nav-link-padding-x: 0;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-navbar-color);
  --vz-nav-link-hover-color: var(--vz-navbar-hover-color);
  --vz-nav-link-disabled-color: var(--vz-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .show > .nav-link,
.navbar-nav .nav-link.active {
  color: var(--vz-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--vz-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--vz-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--vz-navbar-toggler-padding-y) var(--vz-navbar-toggler-padding-x);
  font-size: var(--vz-navbar-toggler-font-size);
  line-height: 1;
  color: var(--vz-navbar-color);
  background-color: transparent;
  border: var(--vz-border-width) solid var(--vz-navbar-toggler-border-color);
  border-radius: var(--vz-navbar-toggler-border-radius);
  transition: var(--vz-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--vz-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--vz-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--vz-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--vz-navbar-nav-link-padding-x);
  padding-left: var(--vz-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --vz-navbar-color: rgba(255, 255, 255, 0.55);
  --vz-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --vz-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --vz-navbar-active-color: #fff;
  --vz-navbar-brand-color: #fff;
  --vz-navbar-brand-hover-color: #fff;
  --vz-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

.card {
  --vz-card-spacer-y: 1rem;
  --vz-card-spacer-x: 1rem;
  --vz-card-title-spacer-y: 0.5rem;
  --vz-card-border-width: 0;
  --vz-card-border-color: rgba(0, 0, 0, 0.125);
  --vz-card-border-radius: 0.25rem;
  --vz-card-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-card-inner-border-radius: 0.25rem;
  --vz-card-cap-padding-y: 1rem;
  --vz-card-cap-padding-x: 1rem;
  --vz-card-cap-bg: #fff;
  --vz-card-cap-color: ;
  --vz-card-height: ;
  --vz-card-color: ;
  --vz-card-bg: #fff;
  --vz-card-img-overlay-padding: 1rem;
  --vz-card-group-margin: 0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--vz-card-height);
  word-wrap: break-word;
  background-color: var(--vz-card-bg);
  background-clip: border-box;
  border: var(--vz-card-border-width) solid var(--vz-card-border-color);
  border-radius: var(--vz-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--vz-card-inner-border-radius);
  border-top-right-radius: var(--vz-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--vz-card-inner-border-radius);
  border-bottom-left-radius: var(--vz-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--vz-card-spacer-y) var(--vz-card-spacer-x);
  color: var(--vz-card-color);
}

.card-title {
  margin-bottom: var(--vz-card-title-spacer-y);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--vz-card-title-spacer-y));
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--vz-card-spacer-x);
}

.card-header {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-bottom: var(--vz-card-border-width) solid var(--vz-card-border-color);
}
.card-header:first-child {
  border-radius: var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-top: var(--vz-card-border-width) solid var(--vz-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--vz-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--vz-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--vz-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--vz-card-bg);
  border-bottom-color: var(--vz-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--vz-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--vz-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--vz-card-img-overlay-padding);
  border-radius: var(--vz-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--vz-card-inner-border-radius);
  border-top-right-radius: var(--vz-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--vz-card-inner-border-radius);
  border-bottom-left-radius: var(--vz-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--vz-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --vz-accordion-color: var(--vz-body-color);
  --vz-accordion-bg: #fff;
  --vz-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --vz-accordion-border-color: var(--vz-border-color);
  --vz-accordion-border-width: 1px;
  --vz-accordion-border-radius: 0.25rem;
  --vz-accordion-inner-border-radius: calc(0.25rem - 1px);
  --vz-accordion-btn-padding-x: 1.25rem;
  --vz-accordion-btn-padding-y: 1rem;
  --vz-accordion-btn-color: var(--vz-body-color);
  --vz-accordion-btn-bg: #fff;
  --vz-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --vz-accordion-btn-icon-width: 0.75rem;
  --vz-accordion-btn-icon-transform: rotate(-180deg);
  --vz-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --vz-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --vz-accordion-btn-focus-border-color: var(--vz-input-focus-border);
  --vz-accordion-btn-focus-box-shadow: inset 0 -1px 0 var(--vz-border-color);
  --vz-accordion-body-padding-x: 1.25rem;
  --vz-accordion-body-padding-y: 1rem;
  --vz-accordion-active-color: rgb(217.8, 90, 43.2);
  --vz-accordion-active-bg: rgba(242, 100, 48, 0.05);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--vz-accordion-btn-padding-y) var(--vz-accordion-btn-padding-x);
  font-size: 0.8125rem;
  color: var(--vz-accordion-btn-color);
  text-align: left;
  background-color: var(--vz-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--vz-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--vz-accordion-active-color);
  background-color: var(--vz-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--vz-accordion-border-width)) 0 var(--vz-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--vz-accordion-btn-active-icon);
  transform: var(--vz-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--vz-accordion-btn-icon-width);
  height: var(--vz-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--vz-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--vz-accordion-btn-icon-width);
  transition: var(--vz-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--vz-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--vz-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--vz-accordion-color);
  background-color: var(--vz-accordion-bg);
  border: var(--vz-accordion-border-width) solid var(--vz-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--vz-accordion-border-radius);
  border-top-right-radius: var(--vz-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--vz-accordion-inner-border-radius);
  border-top-right-radius: var(--vz-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--vz-accordion-border-radius);
  border-bottom-left-radius: var(--vz-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--vz-accordion-inner-border-radius);
  border-bottom-left-radius: var(--vz-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--vz-accordion-border-radius);
  border-bottom-left-radius: var(--vz-accordion-border-radius);
}

.accordion-body {
  padding: var(--vz-accordion-body-padding-y) var(--vz-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --vz-breadcrumb-padding-x: 0;
  --vz-breadcrumb-padding-y: 0;
  --vz-breadcrumb-margin-bottom: 1rem;
  --vz-breadcrumb-bg: ;
  --vz-breadcrumb-border-radius: ;
  --vz-breadcrumb-divider-color: #878a99;
  --vz-breadcrumb-item-padding-x: 0.5rem;
  --vz-breadcrumb-item-active-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding: var(--vz-breadcrumb-padding-y) var(--vz-breadcrumb-padding-x);
  margin-bottom: var(--vz-breadcrumb-margin-bottom);
  font-size: var(--vz-breadcrumb-font-size);
  list-style: none;
  background-color: var(--vz-breadcrumb-bg);
  border-radius: var(--vz-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--vz-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--vz-breadcrumb-item-padding-x);
  color: var(--vz-breadcrumb-divider-color);
  content: var(--vz-breadcrumb-divider, "\\f0142") /* rtl: var(--vz-breadcrumb-divider, "\\f0142") */;
}
.breadcrumb-item.active {
  color: var(--vz-breadcrumb-item-active-color);
}

.pagination {
  --vz-pagination-padding-x: 0.75rem;
  --vz-pagination-padding-y: 0.375rem;
  --vz-pagination-font-size: 0.8125rem;
  --vz-pagination-color: var(--vz-link-color);
  --vz-pagination-bg: var(--vz-card-bg-custom);
  --vz-pagination-border-width: 1px;
  --vz-pagination-border-color: var(--vz-border-color);
  --vz-pagination-border-radius: 0.25rem;
  --vz-pagination-hover-color: var(--vz-link-hover-color);
  --vz-pagination-hover-bg: #eff2f7;
  --vz-pagination-hover-border-color: var(--vz-border-color);
  --vz-pagination-focus-color: var(--vz-link-hover-color);
  --vz-pagination-focus-bg: #eff2f7;
  --vz-pagination-focus-box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25);
  --vz-pagination-active-color: #fff;
  --vz-pagination-active-bg: #F26430;
  --vz-pagination-active-border-color: #F26430;
  --vz-pagination-disabled-color: #878a99;
  --vz-pagination-disabled-bg: var(--vz-card-bg-custom);
  --vz-pagination-disabled-border-color: var(--vz-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--vz-pagination-padding-y) var(--vz-pagination-padding-x);
  font-size: var(--vz-pagination-font-size);
  color: var(--vz-pagination-color);
  text-decoration: none;
  background-color: var(--vz-pagination-bg);
  border: var(--vz-pagination-border-width) solid var(--vz-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--vz-pagination-hover-color);
  background-color: var(--vz-pagination-hover-bg);
  border-color: var(--vz-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--vz-pagination-focus-color);
  background-color: var(--vz-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--vz-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--vz-pagination-active-color);
  background-color: var(--vz-pagination-active-bg);
  border-color: var(--vz-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--vz-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--vz-pagination-disabled-bg);
  border-color: var(--vz-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--vz-pagination-border-radius);
  border-bottom-left-radius: var(--vz-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--vz-pagination-border-radius);
  border-bottom-right-radius: var(--vz-pagination-border-radius);
}

.pagination-lg {
  --vz-pagination-padding-x: 1.2rem;
  --vz-pagination-padding-y: 0.6rem;
  --vz-pagination-font-size: 1.015625rem;
  --vz-pagination-border-radius: 0.3rem;
}

.pagination-sm {
  --vz-pagination-padding-x: 0.5rem;
  --vz-pagination-padding-y: 0.25rem;
  --vz-pagination-font-size: 0.7109375rem;
  --vz-pagination-border-radius: 0.2rem;
}

.badge {
  --vz-badge-padding-x: 0.65em;
  --vz-badge-padding-y: 0.35em;
  --vz-badge-font-size: 0.75em;
  --vz-badge-font-weight: 600;
  --vz-badge-color: #fff;
  --vz-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--vz-badge-padding-y) var(--vz-badge-padding-x);
  font-size: var(--vz-badge-font-size);
  font-weight: var(--vz-badge-font-weight);
  line-height: 1;
  color: var(--vz-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--vz-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --vz-alert-bg: transparent;
  --vz-alert-padding-x: 1rem;
  --vz-alert-padding-y: 0.8rem;
  --vz-alert-margin-bottom: 1rem;
  --vz-alert-color: inherit;
  --vz-alert-border-color: transparent;
  --vz-alert-border: 1px solid var(--vz-alert-border-color);
  --vz-alert-border-radius: 0.25rem;
  position: relative;
  padding: var(--vz-alert-padding-y) var(--vz-alert-padding-x);
  margin-bottom: var(--vz-alert-margin-bottom);
  color: var(--vz-alert-color);
  background-color: var(--vz-alert-bg);
  border: var(--vz-alert-border);
  border-radius: var(--vz-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1rem;
}

.alert-primary {
  --vz-alert-color: rgb(181.5, 75, 36);
  --vz-alert-bg: rgb(253.05, 231.75, 223.95);
  --vz-alert-border-color: rgb(251.1, 208.5, 192.9);
}
.alert-primary .alert-link {
  color: rgb(145.2, 60, 28.8);
}

.alert-secondary {
  --vz-alert-color: rgb(24, 105, 44.25);
  --vz-alert-bg: rgb(221.55, 237.75, 225.6);
  --vz-alert-border-color: rgb(188.1, 220.5, 196.2);
}
.alert-secondary .alert-link {
  color: rgb(19.2, 84, 35.4);
}

.alert-success {
  --vz-alert-color: rgb(7.5, 134.25, 117);
  --vz-alert-bg: rgb(218.25, 243.6, 240.15);
  --vz-alert-border-color: rgb(181.5, 232.2, 225.3);
}
.alert-success .alert-link {
  color: rgb(6, 107.4, 93.6);
}

.alert-info {
  --vz-alert-color: rgb(30.75, 117, 164.25);
  --vz-alert-bg: rgb(222.9, 240.15, 249.6);
  --vz-alert-border-color: rgb(190.8, 225.3, 244.2);
}
.alert-info .alert-link {
  color: rgb(24.6, 93.6, 131.4);
}

.alert-warning {
  --vz-alert-color: rgb(47.25, 143.25, 54);
  --vz-alert-bg: rgb(226.2, 245.4, 227.55);
  --vz-alert-border-color: rgb(197.4, 235.8, 200.1);
}
.alert-warning .alert-link {
  color: rgb(37.8, 114.6, 43.2);
}

.alert-danger {
  --vz-alert-color: rgb(180, 75.75, 54);
  --vz-alert-bg: rgb(252.75, 231.9, 227.55);
  --vz-alert-border-color: rgb(250.5, 208.8, 200.1);
}
.alert-danger .alert-link {
  color: rgb(144, 60.6, 43.2);
}

.alert-light {
  --vz-alert-color: rgb(182.25, 184.5, 186.75);
  --vz-alert-bg: rgb(253.2, 253.65, 254.1);
  --vz-alert-border-color: rgb(251.4, 252.3, 253.2);
}
.alert-light .alert-link {
  color: rgb(145.8, 147.6, 149.4);
}

.alert-dark {
  --vz-alert-color: rgb(24.75, 27.75, 30.75);
  --vz-alert-bg: rgb(221.7, 222.3, 222.9);
  --vz-alert-border-color: rgb(188.4, 189.6, 190.8);
}
.alert-dark .alert-link {
  color: rgb(19.8, 22.2, 24.6);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.625rem;
  }
}
.progress {
  --vz-progress-height: 0.625rem;
  --vz-progress-font-size: 0.609375rem;
  --vz-progress-bg: #eff2f7;
  --vz-progress-border-radius: 0.25rem;
  --vz-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --vz-progress-bar-color: #fff;
  --vz-progress-bar-bg: #F26430;
  --vz-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--vz-progress-height);
  overflow: hidden;
  font-size: var(--vz-progress-font-size);
  background-color: var(--vz-progress-bg);
  border-radius: var(--vz-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--vz-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-progress-bar-bg);
  transition: var(--vz-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--vz-progress-height) var(--vz-progress-height);
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --vz-list-group-color: var(--vz-body-color);
  --vz-list-group-bg: var(--vz-card-bg-custom);
  --vz-list-group-border-color: var(--vz-border-color);
  --vz-list-group-border-width: 1px;
  --vz-list-group-border-radius: 0.25rem;
  --vz-list-group-item-padding-x: 1rem;
  --vz-list-group-item-padding-y: 0.7rem;
  --vz-list-group-action-color: var(--vz-body-color);
  --vz-list-group-action-hover-color: var(--vz-body-color);
  --vz-list-group-action-hover-bg: var(--vz-list-group-hover-bg);
  --vz-list-group-action-active-color: var(--vz-body-color);
  --vz-list-group-action-active-bg: var(--vz-list-group-hover-bg);
  --vz-list-group-disabled-color: #878a99;
  --vz-list-group-disabled-bg: var(--vz-card-bg-custom);
  --vz-list-group-active-color: #fff;
  --vz-list-group-active-bg: #F26430;
  --vz-list-group-active-border-color: #F26430;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--vz-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--vz-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--vz-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--vz-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--vz-list-group-action-active-color);
  background-color: var(--vz-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--vz-list-group-item-padding-y) var(--vz-list-group-item-padding-x);
  color: var(--vz-list-group-color);
  text-decoration: none;
  background-color: var(--vz-list-group-bg);
  border: var(--vz-list-group-border-width) solid var(--vz-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--vz-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--vz-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--vz-list-group-active-color);
  background-color: var(--vz-list-group-active-bg);
  border-color: var(--vz-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--vz-list-group-border-width));
  border-top-width: var(--vz-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--vz-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--vz-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--vz-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--vz-list-group-border-width));
  border-left-width: var(--vz-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--vz-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(145.2, 60, 28.8);
  background-color: rgb(252.4, 224, 213.6);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(145.2, 60, 28.8);
  background-color: rgb(227.16, 201.6, 192.24);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(145.2, 60, 28.8);
  border-color: rgb(145.2, 60, 28.8);
}

.list-group-item-secondary {
  color: rgb(19.2, 84, 35.4);
  background-color: rgb(210.4, 232, 215.8);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(19.2, 84, 35.4);
  background-color: rgb(189.36, 208.8, 194.22);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(19.2, 84, 35.4);
  border-color: rgb(19.2, 84, 35.4);
}

.list-group-item-success {
  color: rgb(6, 107.4, 93.6);
  background-color: rgb(206, 239.8, 235.2);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(6, 107.4, 93.6);
  background-color: rgb(185.4, 215.82, 211.68);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(6, 107.4, 93.6);
  border-color: rgb(6, 107.4, 93.6);
}

.list-group-item-info {
  color: rgb(24.6, 93.6, 131.4);
  background-color: rgb(212.2, 235.2, 247.8);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(24.6, 93.6, 131.4);
  background-color: rgb(190.98, 211.68, 223.02);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(24.6, 93.6, 131.4);
  border-color: rgb(24.6, 93.6, 131.4);
}

.list-group-item-warning {
  color: rgb(37.8, 114.6, 43.2);
  background-color: rgb(216.6, 242.2, 218.4);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(37.8, 114.6, 43.2);
  background-color: rgb(194.94, 217.98, 196.56);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(37.8, 114.6, 43.2);
  border-color: rgb(37.8, 114.6, 43.2);
}

.list-group-item-danger {
  color: rgb(144, 60.6, 43.2);
  background-color: rgb(252, 224.2, 218.4);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(144, 60.6, 43.2);
  background-color: rgb(226.8, 201.78, 196.56);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(144, 60.6, 43.2);
  border-color: rgb(144, 60.6, 43.2);
}

.list-group-item-light {
  color: rgb(145.8, 147.6, 149.4);
  background-color: rgb(252.6, 253.2, 253.8);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(145.8, 147.6, 149.4);
  background-color: rgb(227.34, 227.88, 228.42);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(145.8, 147.6, 149.4);
  border-color: rgb(145.8, 147.6, 149.4);
}

.list-group-item-dark {
  color: rgb(19.8, 22.2, 24.6);
  background-color: rgb(210.6, 211.4, 212.2);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(19.8, 22.2, 24.6);
  background-color: rgb(189.54, 190.26, 190.98);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(19.8, 22.2, 24.6);
  border-color: rgb(19.8, 22.2, 24.6);
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_47___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25);
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --vz-toast-zindex: 1090;
  --vz-toast-padding-x: 0.75rem;
  --vz-toast-padding-y: 0.5rem;
  --vz-toast-spacing: 1rem;
  --vz-toast-max-width: 350px;
  --vz-toast-font-size: 0.875rem;
  --vz-toast-color: ;
  --vz-toast-bg: rgba(255, 255, 255, 0.85);
  --vz-toast-border-width: 1px;
  --vz-toast-border-color: rgba(0, 0, 0, 0.1);
  --vz-toast-border-radius: 0.25rem;
  --vz-toast-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-toast-header-color: #878a99;
  --vz-toast-header-bg: rgba(255, 255, 255, 0.85);
  --vz-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--vz-toast-max-width);
  max-width: 100%;
  font-size: var(--vz-toast-font-size);
  color: var(--vz-toast-color);
  pointer-events: auto;
  background-color: var(--vz-toast-bg);
  background-clip: padding-box;
  border: var(--vz-toast-border-width) solid var(--vz-toast-border-color);
  box-shadow: var(--vz-toast-box-shadow);
  border-radius: var(--vz-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --vz-toast-zindex: 1090;
  position: absolute;
  z-index: var(--vz-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--vz-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--vz-toast-padding-y) var(--vz-toast-padding-x);
  color: var(--vz-toast-header-color);
  background-color: var(--vz-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--vz-toast-border-width) solid var(--vz-toast-header-border-color);
  border-top-left-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width));
  border-top-right-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--vz-toast-padding-x));
  margin-left: var(--vz-toast-padding-x);
}

.toast-body {
  padding: var(--vz-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --vz-modal-zindex: 1055;
  --vz-modal-width: 500px;
  --vz-modal-padding: 1.25rem;
  --vz-modal-margin: 0.5rem;
  --vz-modal-color: ;
  --vz-modal-bg: #fff;
  --vz-modal-border-color: var(--vz-border-color);
  --vz-modal-border-width: 1px;
  --vz-modal-border-radius: 0.3rem;
  --vz-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --vz-modal-inner-border-radius: calc(0.3rem - 1px);
  --vz-modal-header-padding-x: 1.25rem;
  --vz-modal-header-padding-y: 1.25rem;
  --vz-modal-header-padding: 1.25rem 1.25rem;
  --vz-modal-header-border-color: var(--vz-border-color);
  --vz-modal-header-border-width: 0;
  --vz-modal-title-line-height: 1.5;
  --vz-modal-footer-gap: 0.5rem;
  --vz-modal-footer-bg: ;
  --vz-modal-footer-border-color: var(--vz-border-color);
  --vz-modal-footer-border-width: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--vz-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--vz-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--vz-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--vz-modal-color);
  pointer-events: auto;
  background-color: var(--vz-modal-bg);
  background-clip: padding-box;
  border: var(--vz-modal-border-width) solid var(--vz-modal-border-color);
  border-radius: var(--vz-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --vz-backdrop-zindex: 1050;
  --vz-backdrop-bg: #000;
  --vz-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--vz-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--vz-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-modal-header-padding);
  border-bottom: var(--vz-modal-header-border-width) solid var(--vz-modal-header-border-color);
  border-top-left-radius: var(--vz-modal-inner-border-radius);
  border-top-right-radius: var(--vz-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--vz-modal-header-padding-y) * 0.5) calc(var(--vz-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--vz-modal-header-padding-y)) calc(-0.5 * var(--vz-modal-header-padding-x)) calc(-0.5 * var(--vz-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--vz-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--vz-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--vz-modal-padding) - var(--vz-modal-footer-gap) * 0.5);
  background-color: var(--vz-modal-footer-bg);
  border-top: var(--vz-modal-footer-border-width) solid var(--vz-modal-footer-border-color);
  border-bottom-right-radius: var(--vz-modal-inner-border-radius);
  border-bottom-left-radius: var(--vz-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--vz-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --vz-modal-margin: 1.75rem;
    --vz-modal-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  }
  .modal-dialog {
    max-width: var(--vz-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --vz-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --vz-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --vz-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --vz-tooltip-zindex: 1080;
  --vz-tooltip-max-width: 200px;
  --vz-tooltip-padding-x: 0.7rem;
  --vz-tooltip-padding-y: 0.4rem;
  --vz-tooltip-margin: 0;
  --vz-tooltip-font-size: 0.7109375rem;
  --vz-tooltip-color: #fff;
  --vz-tooltip-bg: #000;
  --vz-tooltip-border-radius: 0.2rem;
  --vz-tooltip-opacity: 0.9;
  --vz-tooltip-arrow-width: 0.8rem;
  --vz-tooltip-arrow-height: 0.4rem;
  z-index: var(--vz-tooltip-zindex);
  display: block;
  padding: var(--vz-tooltip-arrow-height);
  margin: var(--vz-tooltip-margin);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--vz-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--vz-tooltip-arrow-width);
  height: var(--vz-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--vz-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--vz-tooltip-arrow-width) * 0.5) var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--vz-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--vz-tooltip-arrow-width) * 0.5) var(--vz-tooltip-arrow-height);
  border-bottom-color: var(--vz-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--vz-tooltip-arrow-width) * 0.5) 0 calc(var(--vz-tooltip-arrow-width) * 0.5) var(--vz-tooltip-arrow-height);
  border-left-color: var(--vz-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--vz-tooltip-max-width);
  padding: var(--vz-tooltip-padding-y) var(--vz-tooltip-padding-x);
  color: var(--vz-tooltip-color);
  text-align: center;
  background-color: var(--vz-tooltip-bg);
  border-radius: var(--vz-tooltip-border-radius);
}

.popover {
  --vz-popover-zindex: 1070;
  --vz-popover-max-width: 276px;
  --vz-popover-font-size: 0.8125rem;
  --vz-popover-bg: #fff;
  --vz-popover-border-width: 1px;
  --vz-popover-border-color: var(--vz-border-color);
  --vz-popover-border-radius: 0.25rem;
  --vz-popover-inner-border-radius: calc(0.25rem - 1px);
  --vz-popover-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-popover-header-padding-x: 1rem;
  --vz-popover-header-padding-y: 0.7rem;
  --vz-popover-header-font-size: 0.8125rem;
  --vz-popover-header-color: ;
  --vz-popover-header-bg: var(--vz-popover-bg);
  --vz-popover-body-padding-x: 1rem;
  --vz-popover-body-padding-y: 1rem;
  --vz-popover-body-color: var(--vz-body-color);
  --vz-popover-arrow-width: 1rem;
  --vz-popover-arrow-height: 0.5rem;
  --vz-popover-arrow-border: var(--vz-popover-border-color);
  z-index: var(--vz-popover-zindex);
  display: block;
  max-width: var(--vz-popover-max-width);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-popover-font-size);
  word-wrap: break-word;
  background-color: var(--vz-popover-bg);
  background-clip: padding-box;
  border: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-radius: var(--vz-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--vz-popover-arrow-width);
  height: var(--vz-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--vz-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--vz-popover-border-width);
  border-top-color: var(--vz-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--vz-popover-arrow-width) * 0.5) var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--vz-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--vz-popover-border-width);
  border-right-color: var(--vz-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--vz-popover-arrow-width) * 0.5) var(--vz-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--vz-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--vz-popover-border-width);
  border-bottom-color: var(--vz-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--vz-popover-arrow-width);
  margin-left: calc(-0.5 * var(--vz-popover-arrow-width));
  content: "";
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--vz-popover-arrow-width) * 0.5) 0 calc(var(--vz-popover-arrow-width) * 0.5) var(--vz-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--vz-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--vz-popover-border-width);
  border-left-color: var(--vz-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--vz-popover-header-padding-y) var(--vz-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--vz-popover-header-font-size);
  color: var(--vz-popover-header-color);
  background-color: var(--vz-popover-header-bg);
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-top-left-radius: var(--vz-popover-inner-border-radius);
  border-top-right-radius: var(--vz-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--vz-popover-body-padding-y) var(--vz-popover-body-padding-x);
  color: var(--vz-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--vz-spinner-width);
  height: var(--vz-spinner-height);
  vertical-align: var(--vz-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--vz-spinner-animation-speed) linear infinite var(--vz-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-border-width: 0.25em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-border;
  border: var(--vz-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem;
  --vz-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --vz-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --vz-offcanvas-zindex: 1045;
  --vz-offcanvas-width: 400px;
  --vz-offcanvas-height: 30vh;
  --vz-offcanvas-padding-x: 1.25rem;
  --vz-offcanvas-padding-y: 1.25rem;
  --vz-offcanvas-color: ;
  --vz-offcanvas-bg: #fff;
  --vz-offcanvas-border-width: 1px;
  --vz-offcanvas-border-color: var(--vz-border-color);
  --vz-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--vz-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--vz-offcanvas-color);
  visibility: hidden;
  background-color: var(--vz-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--vz-offcanvas-width);
  border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--vz-offcanvas-width);
  border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--vz-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--vz-offcanvas-height);
  max-height: 100%;
  border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--vz-offcanvas-padding-y) * 0.5) calc(var(--vz-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--vz-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--vz-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--vz-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(242, 100, 48, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(32, 140, 59, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(10, 179, 156, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(41, 156, 219, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(63, 191, 72, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(240, 101, 72, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(243, 246, 249, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, var(--vz-bg-opacity, 1)) !important;
}

.link-primary {
  color: #F26430 !important;
}
.link-primary:hover, .link-primary:focus {
  color: rgb(193.6, 80, 38.4) !important;
}

.link-secondary {
  color: #208C3B !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: rgb(25.6, 112, 47.2) !important;
}

.link-success {
  color: #0ab39c !important;
}
.link-success:hover, .link-success:focus {
  color: rgb(8, 143.2, 124.8) !important;
}

.link-info {
  color: #299cdb !important;
}
.link-info:hover, .link-info:focus {
  color: rgb(32.8, 124.8, 175.2) !important;
}

.link-warning {
  color: #3FBF48 !important;
}
.link-warning:hover, .link-warning:focus {
  color: rgb(50.4, 152.8, 57.6) !important;
}

.link-danger {
  color: #f06548 !important;
}
.link-danger:hover, .link-danger:focus {
  color: rgb(192, 80.8, 57.6) !important;
}

.link-light {
  color: #f3f6f9 !important;
}
.link-light:hover, .link-light:focus {
  color: rgb(245.4, 247.8, 250.2) !important;
}

.link-dark {
  color: #212529 !important;
}
.link-dark:hover, .link-dark:focus {
  color: rgb(26.4, 29.6, 32.8) !important;
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--vz-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --vz-aspect-ratio: 100%;
}

.ratio-4x3 {
  --vz-aspect-ratio: 75%;
}

.ratio-16x9 {
  --vz-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --vz-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-primary-rgb), var(--vz-border-opacity)) !important;
}

.border-secondary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-secondary-rgb), var(--vz-border-opacity)) !important;
}

.border-success {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-success-rgb), var(--vz-border-opacity)) !important;
}

.border-info {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-info-rgb), var(--vz-border-opacity)) !important;
}

.border-warning {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-warning-rgb), var(--vz-border-opacity)) !important;
}

.border-danger {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-danger-rgb), var(--vz-border-opacity)) !important;
}

.border-light {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-light-rgb), var(--vz-border-opacity)) !important;
}

.border-dark {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-dark-rgb), var(--vz-border-opacity)) !important;
}

.border-white {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-white-rgb), var(--vz-border-opacity)) !important;
}

.border-1 {
  --vz-border-width: 1px;
}

.border-2 {
  --vz-border-width: 2px;
}

.border-3 {
  --vz-border-width: 3px;
}

.border-4 {
  --vz-border-width: 4px;
}

.border-5 {
  --vz-border-width: 5px;
}

.border-opacity-10 {
  --vz-border-opacity: 0.1;
}

.border-opacity-25 {
  --vz-border-opacity: 0.25;
}

.border-opacity-50 {
  --vz-border-opacity: 0.5;
}

.border-opacity-75 {
  --vz-border-opacity: 0.75;
}

.border-opacity-100 {
  --vz-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.font-monospace {
  font-family: var(--vz-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.328125rem + 0.9375vw) !important;
}

.fs-2 {
  font-size: calc(1.2875rem + 0.45vw) !important;
}

.fs-3 {
  font-size: calc(1.2671875rem + 0.20625vw) !important;
}

.fs-4 {
  font-size: 1.21875rem !important;
}

.fs-5 {
  font-size: 1.015625rem !important;
}

.fs-6 {
  font-size: 0.8125rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-primary-rgb), var(--vz-text-opacity)) !important;
}

.text-secondary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-secondary-rgb), var(--vz-text-opacity)) !important;
}

.text-success {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-success-rgb), var(--vz-text-opacity)) !important;
}

.text-info {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-info-rgb), var(--vz-text-opacity)) !important;
}

.text-warning {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-warning-rgb), var(--vz-text-opacity)) !important;
}

.text-danger {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-danger-rgb), var(--vz-text-opacity)) !important;
}

.text-light {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-light-rgb), var(--vz-text-opacity)) !important;
}

.text-dark {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-dark-rgb), var(--vz-text-opacity)) !important;
}

.text-black {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-black-rgb), var(--vz-text-opacity)) !important;
}

.text-white {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-white-rgb), var(--vz-text-opacity)) !important;
}

.text-body {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-body-color-rgb), var(--vz-text-opacity)) !important;
}

.text-muted {
  --vz-text-opacity: 1;
  color: #878a99 !important;
}

.text-black-50 {
  --vz-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --vz-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --vz-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --vz-text-opacity: 0.25;
}

.text-opacity-50 {
  --vz-text-opacity: 0.5;
}

.text-opacity-75 {
  --vz-text-opacity: 0.75;
}

.text-opacity-100 {
  --vz-text-opacity: 1;
}

.bg-primary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-primary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-secondary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-secondary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-success {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-success-rgb), var(--vz-bg-opacity)) !important;
}

.bg-info {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-info-rgb), var(--vz-bg-opacity)) !important;
}

.bg-warning {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-warning-rgb), var(--vz-bg-opacity)) !important;
}

.bg-danger {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-danger-rgb), var(--vz-bg-opacity)) !important;
}

.bg-light {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-light-rgb), var(--vz-bg-opacity)) !important;
}

.bg-dark {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-dark-rgb), var(--vz-bg-opacity)) !important;
}

.bg-black {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-black-rgb), var(--vz-bg-opacity)) !important;
}

.bg-white {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-white-rgb), var(--vz-bg-opacity)) !important;
}

.bg-body {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-body-bg-rgb), var(--vz-bg-opacity)) !important;
}

.bg-transparent {
  --vz-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-opacity-10 {
  --vz-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --vz-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --vz-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --vz-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --vz-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--vz-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--vz-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--vz-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--vz-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--vz-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--vz-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--vz-border-radius-2xl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--vz-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--vz-border-radius) !important;
  border-top-right-radius: var(--vz-border-radius) !important;
}

.rounded-end {
  border-top-right-radius: var(--vz-border-radius) !important;
  border-bottom-right-radius: var(--vz-border-radius) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--vz-border-radius) !important;
  border-bottom-left-radius: var(--vz-border-radius) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--vz-border-radius) !important;
  border-top-left-radius: var(--vz-border-radius) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.03125rem !important;
  }
  .fs-2 {
    font-size: 1.625rem !important;
  }
  .fs-3 {
    font-size: 1.421875rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.4.0
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Main Css File
*/
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  src: local("hkgrotesk light"), url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("woff");
  font-weight: 300;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  src: local("hkgrotesk regular"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff");
  font-weight: 400;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  src: local("hkgrotesk medium"), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("woff");
  font-weight: 500;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  src: local("hkgrotesk semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff");
  font-weight: 600;
}
@font-face {
  font-family: "hkgrotesk";
  src: local("hkgrotesk bold"), url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format("woff");
  font-weight: 700;
}
:root {
  --vz-vertical-menu-bg: #fff;
  --vz-vertical-menu-item-color: rgb(108.8918918919, 112.0945945946, 128.1081081081);
  --vz-vertical-menu-item-hover-color: #F26430;
  --vz-vertical-menu-item-active-color: #F26430;
  --vz-vertical-menu-sub-item-color: rgb(123.972972973, 127.2486486486, 143.627027027);
  --vz-vertical-menu-sub-item-hover-color: #F26430;
  --vz-vertical-menu-sub-item-active-color: #F26430;
  --vz-vertical-menu-title-color: #919da9;
  --vz-vertical-menu-bg-dark: #F26430;
  --vz-vertical-menu-item-color-dark: #e0dcdc;
  --vz-vertical-menu-item-hover-color-dark: #fff;
  --vz-vertical-menu-item-active-color-dark: #fff;
  --vz-vertical-menu-sub-item-color-dark: #e0dcdc;
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark: #c1c6cb;
  --vz-header-bg: #fff;
  --vz-header-item-color: #e9ecef;
  --vz-header-bg-dark: #F26430;
  --vz-header-item-color-dark: #b0c4d9;
  --vz-topbar-search-bg: #f3f3f9;
  --vz-topbar-user-bg: #f3f3f9;
  --vz-topbar-user-bg-dark: #088F7D;
  --vz-footer-bg: #fff;
  --vz-footer-color: #98a6ad;
  --vz-topnav-bg: #fff;
  --vz-topnav-item-color: rgb(108.8918918919, 112.0945945946, 128.1081081081);
  --vz-topnav-item-color-active: #F26430;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg: #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark: rgb(242.6027272727, 107.1863636364, 57.5972727273);
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark: #fff;
  --vz-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: rgb(229.4, 229.4, 242.2);
  --vz-heading-color: #495057;
  --vz-link-color: #F26430;
  --vz-link-hover-color: #F26430;
  --vz-border-color: #e9ebec;
  --vz-card-bg-custom: #fff;
  --vz-card-logo-dark: block;
  --vz-card-logo-light: none;
}
:root .nav-tabs {
  --vz-nav-tabs-link-active-bg: #f3f3f9;
}
:root .choices, :root .flatpickr-calendar, :root .ck, :root .ql-toolbar, :root .select2-container, :root .menu-dropdown {
  --vz-choices-bg: #fff;
  --vz-choices-link-color: #212529;
  --vz-choices-link-hover-bg: #f3f6f9;
  --vz-choices-link-active-color: rgb(29.7, 33.3, 36.9);
}
:root {
  --vz-list-group-hover-bg: #f3f6f9;
  --vz-input-bg: #fff;
  --vz-input-border: #ced4da;
  --vz-input-focus-border: rgb(248.5, 177.5, 151.5);
  --vz-input-disabled-bg: #eff2f7;
  --vz-input-group-addon-bg: #eff2f7;
  --vz-input-check-border: var(--vz-input-border);
}

[data-layout-mode=dark] {
  --vz-gray-100: #1a1d21;
  --vz-gray-200: #212529;
  --vz-gray-300: #2a2f34;
  --vz-gray-400: #878a99;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #bfc8e2;
  --vz-gray-700: #ced4da;
  --vz-gray-800: #eff2f7;
  --vz-gray-900: #f3f6f9;
  --vz-body-bg: #1a1d21;
  --vz-body-bg-rgb: 26, 29, 33;
  --vz-body-color: #ced4da;
  --vz-body-color-rgb: 206, 212, 218;
  --vz-vertical-menu-bg: #212529;
  --vz-vertical-menu-item-color: rgb(94.8324324324, 97.6216216216, 111.5675675676);
  --vz-vertical-menu-item-hover-color: #F26430;
  --vz-vertical-menu-item-active-color: #F26430;
  --vz-vertical-menu-sub-item-color: rgb(104.2054054054, 107.2702702703, 122.5945945946);
  --vz-vertical-menu-sub-item-hover-color: #F26430;
  --vz-vertical-menu-sub-item-active-color: #F26430;
  --vz-vertical-menu-title-color: #878a99;
  --vz-vertical-menu-bg-dark: #212529;
  --vz-vertical-menu-item-color-dark: #878a99;
  --vz-vertical-menu-item-hover-color-dark: #fff;
  --vz-vertical-menu-item-active-color-dark: #fff;
  --vz-vertical-menu-sub-item-color-dark: rgb(123.972972973, 127.2486486486, 143.627027027);
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark: rgb(94.8324324324, 97.6216216216, 111.5675675676);
  --vz-header-bg: #292e32;
  --vz-header-item-color: #e9ecef;
  --vz-header-bg-dark: #F26430;
  --vz-header-item-color-dark: #b0c4d9;
  --vz-topbar-search-bg: #202328;
  --vz-topbar-user-bg: rgb(48.8361702128, 54.65, 60.4638297872);
  --vz-topbar-user-bg-dark: #088f7d;
  --vz-footer-bg: #212529;
  --vz-footer-color: #878a99;
  --vz-topnav-bg: rgb(38.6858108108, 43.375, 48.0641891892);
  --vz-topnav-item-color: #878a99;
  --vz-topnav-item-color-active: #fff;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg: #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark: #30363a;
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark: #fff;
  --vz-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: rgb(17.0101694915, 18.9728813559, 21.5898305085);
  --vz-heading-color: #ced4da;
  --vz-light: #2a2f34;
  --vz-light-rgb: 42, 47, 52;
  --vz-dark: #eff2f7;
  --vz-dark-rgb: 239, 242, 247;
  --vz-link-color: #ced4da;
  --vz-link-hover-color: #ced4da;
  --vz-border-color: rgb(49.9755319149, 55.925, 61.8744680851);
}
[data-layout-mode=dark] .dropdown-menu {
  --vz-dropdown-bg: rgb(40.9601351351, 45.925, 50.8898648649);
  --vz-dropdown-link-color: #adb5bd;
  --vz-dropdown-link-hover-color: rgb(185.4, 190.8, 196.2);
  --vz-dropdown-link-hover-bg: rgb(46.5574468085, 52.1, 57.6425531915);
  --vz-dropdown-border-width: 1px;
  --vz-dropdown-link-active-color: #adb5bd;
  --vz-dropdown-link-active-bg: rgb(46.5574468085, 52.1, 57.6425531915);
}
[data-layout-mode=dark] .choices, [data-layout-mode=dark] .flatpickr-calendar, [data-layout-mode=dark] .ck, [data-layout-mode=dark] .ql-toolbar, [data-layout-mode=dark] .select2-container, [data-layout-mode=dark] .menu-dropdown {
  --vz-choices-bg: rgb(40.9601351351, 45.925, 50.8898648649);
  --vz-choices-link-color: #adb5bd;
  --vz-choices-link-hover-bg: rgb(46.5574468085, 52.1, 57.6425531915);
  --vz-choices-link-active-color: rgb(218.7, 221.4, 224.1);
}
[data-layout-mode=dark] .btn-light {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: var(--vz-light);
  --vz-btn-border-color: var(--vz-light);
}
[data-layout-mode=dark] .btn-outline-light {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-light);
}
[data-layout-mode=dark] .btn-light, [data-layout-mode=dark] .btn-outline-light {
  --vz-btn-hover-color: var(--vz-dark);
  --vz-btn-hover-bg: rgba(var(--vz-light-rgb), 0.75);
  --vz-btn-hover-border-color: rgba(var(--vz-light-rgb), 0.75);
}
[data-layout-mode=dark] .btn-dark {
  --vz-btn-color: var(--vz-light);
  --vz-btn-bg: var(--vz-dark);
  --vz-btn-border-color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-outline-dark {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-dark, [data-layout-mode=dark] .btn-outline-dark {
  --vz-btn-hover-color: var(--vz-light);
  --vz-btn-hover-bg: rgba(var(--vz-dark-rgb), 0.75);
  --vz-btn-hover-border-color: rgba(var(--vz-dark-rgb), 0.75);
}
[data-layout-mode=dark] .card {
  --vz-card-bg: #212529;
  --vz-card-cap-bg: #212529;
}
[data-layout-mode=dark] {
  --vz-card-bg-custom: #212529;
  --vz-card-logo-dark: none;
  --vz-card-logo-light: block;
}
[data-layout-mode=dark] .modal {
  --vz-modal-bg: #212529;
}
[data-layout-mode=dark] .nav-tabs {
  --vz-nav-tabs-link-active-color: #f3f6f9;
  --vz-nav-tabs-link-active-bg: #2a2f34;
}
[data-layout-mode=dark] .accordion {
  --vz-accordion-button-active-color: #fff;
  --vz-accordion-bg: #212529;
  --vz-accordion-btn-bg: #212529;
}
[data-layout-mode=dark] :is(.offcanvas, .offcanvas-lg, .offcanvas-md, .offcanvas-sm, .offcanvas-xl, .offcanvas-xxl) {
  --vz-offcanvas-bg: #212529;
}
[data-layout-mode=dark] .progress {
  --vz-progress-bg: #2a2f34;
}
[data-layout-mode=dark] .table {
  --vz-table-striped-bg: rgba(255, 255, 255, 0.03);
  --vz-table-active-bg: rgba(255, 255, 255, 0.07);
  --vz-table-hover-bg: rgba(255, 255, 255, 0.07);
}
[data-layout-mode=dark] .table-light {
  --vz-table-color: #fff;
  --vz-table-bg: rgba(255, 255, 255, 0.05);
  --vz-table-border-color: var(--vz-border-color);
  --vz-table-striped-bg: rgba(255, 255, 255, 0.07);
  --vz-table-striped-color: #fff;
}
[data-layout-mode=dark] .toast {
  --vz-toast-bg: rgba(42, 47, 52, 0.85);
  --vz-toast-header-bg: rgba(42, 47, 52, 0.85);
  --vz-toast-border-color: rgba(255, 255, 255, 0.1);
  --vz-toast-header-border-color: rgba(255, 255, 255, 0.05);
}
[data-layout-mode=dark] {
  --vz-list-group-hover-bg: rgb(38.6858108108, 43.375, 48.0641891892);
}
[data-layout-mode=dark] .popover {
  --vz-popover-bg: rgb(35.2743243243, 39.55, 43.8256756757);
}
[data-layout-mode=dark] .pagination {
  --vz-pagination-hover-bg: rgb(42.0972972973, 47.2, 52.3027027027);
  --vz-pagination-focus-bg: rgb(42.0972972973, 47.2, 52.3027027027);
}
[data-layout-mode=dark] {
  --vz-input-bg: rgb(37.5486486486, 42.1, 46.6513513514);
  --vz-input-border: #2a2f34;
  --vz-input-focus-border: rgb(51.114893617, 57.2, 63.285106383);
  --vz-input-disabled-bg: #212529;
  --vz-input-group-addon-bg: #2a2f34;
  --vz-input-check-border: rgb(51.114893617, 57.2, 63.285106383);
}

[data-sidebar=gradient] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, var(--vz-primary), var(--vz-success));
  --vz-vertical-menu-border-gradient: var(--vz-success);
  --vz-twocolumn-menu-bg-dark: var(--vz-success);
}

[data-sidebar=gradient-2] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, var(--vz-info), var(--vz-secondary));
  --vz-vertical-menu-border-gradient: var(--vz-secondary);
  --vz-twocolumn-menu-bg-dark: var(--vz-secondary);
}

[data-sidebar=gradient-3] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, var(--vz-info), var(--vz-success));
  --vz-vertical-menu-border-gradient: var(--vz-success);
  --vz-twocolumn-menu-bg-dark: var(--vz-success);
}

[data-sidebar=gradient-4] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, #1a1d21, var(--vz-primary));
  --vz-vertical-menu-border-gradient: var(--vz-primary);
  --vz-twocolumn-menu-bg-dark: var(--vz-primary);
}

#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  background-color: var(--vz-header-bg);
  transition: all 0.1s ease-out;
  border: 1px solid none;
}
#page-topbar.topbar-shadow {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}
@media (min-width: 768px) {
  #page-topbar {
    left: 250px;
  }
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 1rem 0 calc(1rem / 2);
}
@media (max-width: 767.98px) {
  .navbar-header {
    padding: 0 calc(1rem / 2) 0 calc(1rem / 2);
  }
}
.navbar-header .topbar-head-dropdown .dropdown-menu.show {
  top: 13px !important;
}
.navbar-header .btn-topbar {
  height: 42px;
  width: 42px;
}
@media (max-width: 360px) {
  .navbar-header .btn-topbar {
    height: 36px;
    width: 36px;
  }
}
.navbar-header .user-name-text {
  color: var(--vz-gray-700);
}

/* Search */
.app-search {
  padding: calc(32px / 2) 0;
}
.app-search .form-control {
  border: none;
  height: 38px;
  padding-left: 40px;
  padding-right: 30px;
  background-color: var(--vz-topbar-search-bg);
  box-shadow: none;
}
.app-search span.search-widget-icon {
  position: absolute;
  z-index: 10;
  font-size: 18px;
  line-height: 38px;
  left: 13px;
  top: 0;
  color: #878a99;
}
.app-search .search-widget-icon-close {
  right: 7px;
  left: auto !important;
}
@media (max-width: 1023.99px) {
  .app-search {
    padding-left: calc(1rem / 2);
  }
}

.megamenu-list li {
  position: relative;
  padding: 5px 0px;
}
.megamenu-list li a {
  color: var(--vz-body-color);
}

@media (max-width: 767.98px) {
  .logo span.logo-lg {
    display: none;
  }
  .logo span.logo-sm {
    display: inline-block;
  }
}
.header-item {
  height: 70px;
  display: flex;
  align-items: center;
}

.header-profile-user {
  height: 45px;
  width: 45px;
  margin-left: 10px;
}

.topbar-badge-sm {
  right: 0;
  top: 7px !important;
}

.topbar-badge {
  right: -9px;
  top: 4px !important;
}

@media (min-width: 768px) {
  .topbar-user {
    background-color: transparent;
  }
}
.topbar-user .dropdown-menu {
  top: 6px !important;
}

.notification-item {
  padding: 0.75rem 1rem;
  white-space: inherit;
  position: relative;
}
.notification-item .form-check-input {
  position: relative;
  z-index: 2;
}

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  border: 1px solid transparent;
  color: var(--vz-dropdown-link-color);
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  background-color: var(--vz-dropdown-link-hover-bg);
}

.fullscreen-enable [data-toggle=fullscreen] .bx-fullscreen::before {
  content: "\\eacb";
}

[data-layout-mode=dark] .light-dark-mode .bx-moon::before {
  content: "\\ec34";
}

[data-topbar=dark] #page-topbar {
  background-color: var(--vz-header-bg-dark);
  border-color: var(--vz-header-bg-dark);
}
[data-topbar=dark] .navbar-header .btn-topbar {
  color: var(--vz-header-item-color-dark);
}
[data-topbar=dark] .navbar-header .btn-topbar:hover, [data-topbar=dark] .navbar-header .btn-topbar:focus {
  background-color: rgba(255, 255, 255, 0.07);
  color: #fff;
}
@media (min-width: 767.99px) {
  [data-topbar=dark] .topbar-user {
    background-color: var(--vz-topbar-user-bg-dark);
  }
}
[data-topbar=dark] .topbar-user .user-name-text {
  color: rgba(255, 255, 255, 0.85) !important;
}
[data-topbar=dark] .topbar-user .user-name-sub-text {
  color: var(--vz-header-item-color-dark) !important;
}
[data-topbar=dark] .logo-dark {
  display: none;
}
[data-topbar=dark] .logo-light {
  display: inline-block;
}
[data-topbar=dark] .app-search .form-control {
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff;
}
[data-topbar=dark] .app-search span.search-widget-icon,
[data-topbar=dark] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
[data-topbar=dark] .hamburger-icon span {
  background-color: #e9ebec;
}

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static;
  }
  .navbar-header .dropdown .dropdown-menu {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  #search-dropdown-reponsive {
    top: 54px !important;
  }
}
@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] #page-topbar {
    left: 0 !important;
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  }
  [data-layout=vertical][data-layout-style=detached] .horizontal-logo {
    display: inline-block;
    padding-left: 0;
  }
  [data-layout=vertical][data-layout-style=detached] .topnav-hamburger {
    visibility: hidden;
  }
  [data-layout=vertical][data-layout-style=detached] .layout-width {
    max-width: 95%;
    margin: 0 auto;
  }
  [data-layout=vertical][data-layout-style=detached]:is([data-sidebar-size=sm], [data-sidebar-size=sm-hover]) .navbar-brand-box {
    background-color: transparent !important;
    position: relative;
    width: auto;
    text-align: left;
  }
  [data-layout=vertical][data-layout-style=detached]:is([data-sidebar-size=sm], [data-sidebar-size=sm-hover]) .navbar-brand-box .logo-sm {
    display: none;
  }
  [data-layout=vertical][data-layout-style=detached]:is([data-sidebar-size=sm], [data-sidebar-size=sm-hover]) .navbar-brand-box .logo-lg {
    display: block;
  }
}
[data-layout=vertical][data-layout-style=detached][data-topbar=dark] .horizontal-logo .logo-dark {
  display: none;
}
[data-layout=vertical][data-layout-style=detached][data-topbar=dark] .horizontal-logo .logo-light {
  display: block;
}

[data-layout=horizontal] #page-topbar {
  left: 0;
  border-bottom: 1px solid var(--vz-gray-300);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] #page-topbar.topbar-shadow {
    box-shadow: none;
  }
  [data-layout=horizontal] .page-content {
    margin-top: 70px;
  }
}
@media (max-width: 1024.1px) {
  [data-layout=horizontal] .page-content {
    padding: calc(45px + 1rem * 1.8) calc(1rem / 2) 60px calc(1rem / 2);
  }
}
[data-layout=horizontal] .page-content {
  padding: calc(45px + 1rem) calc(1rem / 2) 60px calc(1rem / 2);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal][data-layout-width=boxed] .page-content {
    min-height: calc(100vh - 130px);
  }
}

@media (min-width: 768px) {
  [data-layout=vertical]:is([data-sidebar-size=sm], [data-sidebar-size=sm-hover]) #page-topbar {
    left: 70px;
  }
  [data-layout=vertical][data-sidebar-size=md] #page-topbar {
    left: 180px;
  }
  [data-layout=twocolumn] #page-topbar {
    left: calc(70px + 220px);
  }
}
[data-layout=twocolumn] .horizontal-logo {
  display: none;
}

.page-title-box {
  padding: 10px 1rem;
  background-color: var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  border-bottom: 1px solid none;
  margin: -23px -1rem 1rem -1rem;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4, .page-title-box .h4 {
  font-weight: 700;
  font-size: 15px !important;
  text-transform: uppercase;
}

[data-layout=horizontal] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .page-title-box {
    margin: -19px 0 0 0;
  }
}

[data-layout=vertical][data-layout-style=detached] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] .page-title-box {
    margin: -19px 0 0 0;
  }
}

.footer {
  bottom: 0;
  padding: 20px calc(1rem * 0.5);
  position: absolute;
  right: 0;
  color: var(--vz-footer-color);
  left: 250px;
  height: 60px;
  background-color: var(--vz-footer-bg);
}
@media (max-width: 991.98px) {
  .footer {
    left: 0;
  }
}

[data-layout=vertical]:is([data-sidebar-size=sm], [data-sidebar-size=sm-hover]) .footer {
  left: 70px;
}
@media (max-width: 767.98px) {
  [data-layout=vertical]:is([data-sidebar-size=sm], [data-sidebar-size=sm-hover]) .footer {
    left: 0;
  }
}
[data-layout=vertical][data-sidebar-size=md] .footer {
  left: 180px;
}
@media (max-width: 991.98px) {
  [data-layout=vertical][data-sidebar-size=md] .footer {
    left: 0;
  }
}

[data-layout=horizontal] .footer {
  left: 0 !important;
}

@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] .footer {
    left: 0 !important;
    background-color: transparent;
  }
}

@media (min-width: 768.1px) {
  [data-layout=twocolumn] .footer {
    left: calc(70px + 220px);
  }
}

.app-content {
  margin-left: 250px;
  overflow: hidden;
}
.app-content .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px;
}

.main-content {
  transition: all 0.1s ease-out;
}
@media (min-width: 768px) {
  .main-content {
    margin-left: 250px;
  }
}

.page-content {
  padding: 1rem calc(1rem) 60px calc(1rem);
}

.navbar-menu {
  width: 250px;
  z-index: 1002;
  background: var(--vz-vertical-menu-bg);
  border-right: 1px solid #fff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  padding: 0 0 calc(70px + 25px) 0;
  transition: all 0.1s ease-out;
}
.navbar-menu .navbar-nav .nav-link {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.5rem;
  color: var(--vz-vertical-menu-item-color);
  font-size: 1rem;
  font-family: "hkgrotesk", sans-serif;
}
.navbar-menu .navbar-nav .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color);
}
.navbar-menu .navbar-nav .nav-link i {
  display: inline-block;
  min-width: 1.75rem;
  font-size: 18px;
  line-height: inherit;
}
.navbar-menu .navbar-nav .nav-link svg {
  width: 18px;
  margin-right: 0.665rem;
  color: var(--vz-vertical-menu-item-color);
}
.navbar-menu .navbar-nav .nav-link .badge {
  margin-left: auto;
  margin-right: -2px;
  z-index: 1;
}
.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color);
}
.navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color);
  fill: rgba(242, 100, 48, 0.16);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  display: block;
  content: "\\f0142";
  font-family: "Material Design Icons";
  margin-left: auto;
  transition: transform 0.2s;
  font-size: 1.05rem;
  position: absolute;
  right: 18px;
  color: var(--vz-vertical-menu-title-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color);
  fill: rgba(242, 100, 48, 0.16);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(90deg);
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
  opacity: 1;
  background-color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link.collapsed.active::after {
  transform: rotate(90deg);
}
.navbar-menu .navbar-nav .nav-sm {
  padding-left: 1.75rem;
}
.navbar-menu .navbar-nav .nav-sm .nav-link {
  padding: 0.55rem 1.5rem !important;
  color: var(--vz-vertical-menu-sub-item-color);
  white-space: none;
  position: relative;
  font-size: 0.813rem;
  font-family: "Poppins", sans-serif;
}
.navbar-menu .navbar-nav .nav-sm .nav-link:before {
  content: "";
  width: 6px;
  height: 1.5px;
  background-color: var(--vz-vertical-menu-sub-item-color);
  position: absolute;
  left: 2px;
  top: 16.5px;
  transition: all 0.4s ease-in-out;
  opacity: 0.5;
}
.navbar-menu .navbar-nav .nav-sm .nav-link:hover {
  color: var(--vz-vertical-menu-sub-item-hover-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-sub-item-hover-color) !important;
  opacity: 1;
}
.navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-link.active:before {
  background-color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-sm {
  padding-left: 15px;
}
.navbar-menu .navbar-nav .nav-sm .nav-sm .nav-link:before {
  height: 5px;
  width: 5px;
  left: 5px;
  border-radius: 50%;
  background-color: transparent;
  border: 1px solid;
  top: 16px;
}
.navbar-menu .btn-vertical-sm-hover {
  color: #878a99;
  display: none;
}

.navbar-brand-box {
  padding: 0 1.3rem;
  text-align: center;
  transition: all 0.1s ease-out;
}
@media (max-width: 767.98px) {
  .navbar-brand-box {
    display: none;
  }
}

.hamburger-icon {
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.hamburger-icon span {
  background-color: #878a99;
  position: absolute;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  width: 100%;
  height: 2px;
  display: block;
  left: 0px;
}
.hamburger-icon span:nth-child(1) {
  top: 0;
  width: 80%;
}
.hamburger-icon span:nth-child(2) {
  top: 6px;
}
.hamburger-icon span:nth-child(3) {
  bottom: 0;
  width: 60%;
}
.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {
  top: -1px;
}
.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {
  bottom: -1px;
}
.hamburger-icon.open {
  transform: rotate(-90deg);
}
.hamburger-icon.open span:nth-child(1) {
  left: 1px;
  top: 5px;
  width: 20px;
  transform: rotate(90deg);
  transition-delay: 150ms;
}
.hamburger-icon.open span:nth-child(2) {
  left: 3px;
  top: 13px;
  width: 10px;
  transform: rotate(45deg);
  transition-delay: 50ms;
}
.hamburger-icon.open span:nth-child(3) {
  left: 9px;
  top: 13px;
  width: 10px;
  transform: rotate(-45deg);
  transition-delay: 100ms;
}

.logo {
  line-height: 70px;
}
.logo .logo-sm {
  display: none;
}

.logo-light {
  display: none;
}

:is([data-layout=vertical], [data-layout=semibox]) .app-menu .row {
  margin: 0;
}
:is([data-layout=vertical], [data-layout=semibox]) .app-menu .row > * {
  width: 100%;
  padding: 0;
}
@media (max-width: 767.98px) {
  :is([data-layout=vertical], [data-layout=semibox]) .app-menu {
    margin-left: -100%;
    padding: 10px 0 20px 0;
  }
}
:is([data-layout=vertical], [data-layout=semibox]) .navbar-menu .container-fluid, :is([data-layout=vertical], [data-layout=semibox]) .navbar-menu .container-sm, :is([data-layout=vertical], [data-layout=semibox]) .navbar-menu .container-md, :is([data-layout=vertical], [data-layout=semibox]) .navbar-menu .container-lg, :is([data-layout=vertical], [data-layout=semibox]) .navbar-menu .container-xl, :is([data-layout=vertical], [data-layout=semibox]) .navbar-menu .container-xxl {
  padding: 0;
}
@media (max-width: 767.98px) {
  :is([data-layout=vertical], [data-layout=semibox]) .navbar-brand-box {
    display: none;
  }
}
:is([data-layout=vertical], [data-layout=semibox]) .horizontal-logo {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .main-content {
  margin-left: 70px;
}
@media (max-width: 767.98px) {
  :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .main-content {
    margin-left: 0;
  }
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .logo span.logo-lg {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .logo span.logo-sm {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .btn-vertical-sm-hover {
  display: inline-block;
}
@media (min-width: 768px) {
  :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .topnav-hamburger {
    display: none;
  }
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu {
  width: 70px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .btn-vertical-sm-hover {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .btn-vertical-sm-hover i.ri-record-circle-line:before {
  content: "\\eb7d";
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .badge {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title {
  text-align: center;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title span {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title i {
  display: block;
  line-height: 36px;
  font-size: 1rem;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link span {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i {
  font-size: 22px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.las, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.lar, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.lab {
  font-size: 24px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link svg {
  margin-right: 0px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link:after, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link:before {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-dropdown {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover {
  width: 250px !important;
}
@media (min-width: 1024.99px) {
  :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .btn-vertical-sm-hover {
    display: inline-block;
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .navbar-brand-box {
    text-align: left;
  }
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .navbar-nav .menu-dropdown.show {
  display: block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i {
  font-size: 18px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.las, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.lar, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.lab {
  font-size: 20px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link svg {
  margin-right: 0.665rem;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link span, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link:after, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link:before {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .logo span.logo-lg {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .logo span.logo-sm {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title {
  text-align: left;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title span {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title i {
  display: none;
}
@media (min-width: 1025px) {
  :is([data-layout=vertical], [data-layout=semibox]):is([data-sidebar-size=sm-hover], [data-sidebar-size=sm-hover-active]) .navbar-header {
    padding-left: 1rem;
  }
}
:is([data-layout=vertical], [data-layout=semibox]):is([data-sidebar-size=sm-hover], [data-sidebar-size=sm-hover-active]) .navbar-header {
  padding-top: 0.5rem;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover-active] .navbar-brand-box {
  text-align: left;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover-active] .topnav-hamburger {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm-hover-active] .btn-vertical-sm-hover {
  display: inline-block;
}
@media (min-width: 768px) {
  :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] {
    min-height: 1400px;
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .main-content {
    margin-left: 70px;
  }
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] #page-topbar {
  /*  z-index: calc(1002 + 1); */
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-brand-box {
  position: fixed;
  padding: 0;
  width: 70px;
  z-index: 1;
  top: 0;
  background: var(--vz-vertical-menu-bg);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .logo span.logo-lg {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .logo span.logo-sm {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu {
  position: absolute;
  width: 70px !important;
  padding-top: 70px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .simplebar-mask,
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .simplebar-scrollbar,
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .vertical-menu-btn {
  display: none !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .simplebar-offset {
  bottom: 0 !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .badge {
  display: none !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title {
  text-align: center;
  font-size: 1rem;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title span {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title i {
  display: block;
  line-height: 36px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link span {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link i {
  font-size: 22px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link svg {
  margin-right: 0px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link:after, :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link:before {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-dropdown {
  display: none;
  height: auto !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item {
  position: relative;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
  position: relative;
  width: calc(200px + 70px);
  color: #fff;
  background-color: var(--vz-vertical-menu-bg-dark);
  transition: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link span {
  display: inline-block;
  padding-left: 25px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link:after {
  display: block;
  transform: rotate(90deg);
  color: #fff;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover .nav-link span {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  display: block;
  left: 70px;
  position: absolute;
  width: 200px;
  background: var(--vz-vertical-menu-bg);
  height: auto !important;
  padding: 0.5rem 0;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm {
  padding: 0;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
  color: var(--vz-vertical-menu-item-hover-color);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
  color: inherit;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
  display: block !important;
  transform: rotate(0deg) !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}
@media (min-width: 768px) {
  :is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .main-content {
    margin-left: 180px;
  }
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-brand-box {
  width: 180px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu {
  width: 180px !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link {
  display: block;
  text-align: center;
  padding: 0.55rem 0.525rem;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link i {
  display: block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link svg {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link:before {
  display: none !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  position: relative;
  display: inline-block;
  right: 0;
  top: 3px;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link.menu-link[data-bs-toggle=collapse]:after {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .badge {
  display: none !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .navbar-nav .nav-sm {
  padding-left: 0;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .menu-title {
  text-align: center;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar-size=md] .navbar-menu .menu-title span {
  text-decoration: underline;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-menu {
  background: var(--vz-vertical-menu-bg-dark);
  border-right: 1px solid var(--vz-vertical-menu-bg-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-menu .hamburger-icon span {
  background-color: var(--vz-vertical-menu-item-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-menu .btn-vertical-sm-hover {
  color: var(--vz-vertical-menu-item-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link {
  color: var(--vz-vertical-menu-item-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  color: inherit;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  color: inherit;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-vertical-menu-item-active-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link svg {
  color: var(--vz-vertical-menu-item-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav > .nav-item .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav > .nav-item .nav-link.active .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-link {
  color: var(--vz-vertical-menu-sub-item-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-link:before {
  background-color: var(--vz-vertical-menu-sub-item-color-dark) !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
  background-color: var(--vz-vertical-menu-item-active-color-dark) !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark][data-sidebar-size=sm] .navbar-brand-box {
  background: var(--vz-vertical-menu-bg-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  background: var(--vz-vertical-menu-bg-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm {
  padding: 0;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
  display: block !important;
  transform: rotate(0deg) !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
  color: inherit;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .menu-title {
  color: var(--vz-vertical-menu-title-color-dark);
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .logo-dark {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=dark] .logo-light {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=light] .logo-dark {
  display: inline-block;
}
:is([data-layout=vertical], [data-layout=semibox])[data-sidebar=light] .logo-light {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] #layout-wrapper,
:is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] .main-content {
  min-height: 100vh;
}
@media (min-width: 1024.1px) {
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] .main-content {
    position: relative;
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] #layout-wrapper {
    max-width: 100%;
    margin: 0 auto;
    /* padding-left: \$grid-gutter-width; */ /* templatletin default ayarını kaldırdım */
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] .navbar-header {
    padding-left: 1rem;
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] .navbar-menu {
    padding: 0;
    border-right: var(--vz-vertical-menu-bg);
    border-radius: 0 38px 38px 0;
    padding: 10px 0;
    z-index: 1;
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] .navbar-menu .navbar-brand-box {
    display: none;
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached]:is([data-sidebar=dark],
  [data-sidebar=gradient],
  [data-sidebar=gradient-2],
  [data-sidebar=gradient-3],
  [data-sidebar=gradient-4]) .logo-dark {
    display: inline-block;
  }
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached]:is([data-sidebar=dark],
  [data-sidebar=gradient],
  [data-sidebar=gradient-2],
  [data-sidebar=gradient-3],
  [data-sidebar=gradient-4]) .logo-light {
    display: none;
  }
}
:is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] .footer {
  border-top: 1px dashed var(--vz-border-color);
}
:is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached] .auth-page-wrapper .footer {
  border-top: none;
}
@media (min-width: 768px) {
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached][data-sidebar-size=sm] #layout-wrapper,
  :is([data-layout=vertical], [data-layout=semibox])[data-layout-style=detached][data-sidebar-size=sm] .main-content {
    min-height: 1400px;
  }
}
:is([data-layout=vertical], [data-layout=semibox]):is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .logo-dark {
  display: none;
}
:is([data-layout=vertical], [data-layout=semibox]):is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .logo-light {
  display: inline-block;
}

.menu-title {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--vz-vertical-menu-title-color);
  font-weight: 600;
}
.menu-title span {
  padding: 12px 20px;
  display: inline-block;
}
.menu-title i {
  display: none;
}

.vertical-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 37, 41, 0.35);
  z-index: 1003;
  display: none;
}

.vertical-sidebar-enable .vertical-overlay {
  display: block;
}
.vertical-sidebar-enable .app-menu {
  margin-left: 0 !important;
  z-index: 1004;
}

[dir=rtl] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(180deg);
}
[dir=rtl] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(270deg);
}

:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-menu {
  background: var(--vz-vertical-menu-bg-gradient);
  border-right: 1px solid var(--vz-vertical-menu-border-gradient);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-menu .hamburger-icon span {
  background-color: rgba(255, 255, 255, 0.5);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-menu .btn-vertical-sm-hover {
  color: rgba(255, 255, 255, 0.5);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  color: inherit;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  color: inherit;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-vertical-menu-item-active-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link svg {
  color: rgba(255, 255, 255, 0.5);
  fill: rgba(255, 255, 255, 0.1);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav > .nav-item .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav > .nav-item .nav-link.active .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-link:before {
  background-color: rgba(255, 255, 255, 0.5) !important;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
  background-color: var(--vz-vertical-menu-item-active-color-dark) !important;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm] .navbar-brand-box {
  background: var(--vz-vertical-menu-bg-gradient);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  background: var(--vz-vertical-menu-bg-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm {
  padding: 0;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
  display: block !important;
  transform: rotate(0deg) !important;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
  color: inherit;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4])[data-sidebar-size=sm][data-layout=vertical] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
  background: var(--vz-vertical-menu-bg-gradient);
}
:is([data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .menu-title {
  color: rgba(255, 255, 255, 0.5);
}

.bg-vertical-gradient {
  background: linear-gradient(to right, var(--vz-primary), var(--vz-success));
}

.bg-vertical-gradient-2 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-secondary));
}

.bg-vertical-gradient-3 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-success));
}

.bg-vertical-gradient-4 {
  background: linear-gradient(to right, var(--vz-dark), var(--vz-primary));
}

.sidebar-background {
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07;
}

[data-sidebar-image=img-1] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}

[data-sidebar-image=img-2] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}

[data-sidebar-image=img-3] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}

[data-sidebar-image=img-4] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}

[data-layout=semibox] .page-title-box {
  padding: 10px 0;
  background-color: transparent;
  box-shadow: none;
  margin: -15px 0 1.5rem 0;
}
@media (min-width: 768px) {
  [data-layout=semibox][data-sidebar-size=sm] .main-content, [data-layout=semibox][data-sidebar-size=sm-hover] .main-content {
    margin-left: 70px;
  }
  [data-layout=semibox][data-sidebar-size=sm] #page-topbar, [data-layout=semibox][data-sidebar-size=sm-hover] #page-topbar {
    left: 70px;
  }
  [data-layout=semibox][data-sidebar-size=sm] .footer, [data-layout=semibox][data-sidebar-size=sm-hover] .footer {
    left: 70px;
  }
  [data-layout=semibox][data-sidebar-size=md] #page-topbar {
    left: 180px;
  }
  [data-layout=semibox][data-sidebar-size=md] .footer {
    left: 180px;
  }
}
@media (min-width: 1440px) {
  [data-layout=semibox] .page-content {
    padding: calc(70px + 1rem * 2) calc(1rem * 0.5) 60px calc(1rem * 0.5);
  }
  [data-layout=semibox] .navbar-menu {
    margin: 25px;
    border-radius: 0.25rem;
  }
  [data-layout=semibox] .main-content {
    margin-left: calc(250px + 25px);
    padding: 0 110px;
  }
  [data-layout=semibox] .footer {
    left: calc(250px + 110px + 1rem + 25px);
    right: calc(110px + 1rem);
  }
  [data-layout=semibox] #page-topbar {
    left: calc(250px + 110px + 1rem + 25px);
    right: calc(110px + 1rem);
    top: 25px;
    border-radius: 0.25rem;
    transition: all 0.5s ease;
  }
  [data-layout=semibox] #page-topbar.topbar-shadow {
    top: 0px;
  }
  [data-layout=semibox][data-sidebar-size=md] .main-content {
    margin-left: calc(180px + 25px);
  }
  [data-layout=semibox][data-sidebar-size=md] #page-topbar {
    left: calc(180px + 110px + 1rem + 25px);
  }
  [data-layout=semibox][data-sidebar-size=md] .footer {
    left: calc(180px + 110px + 1rem + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm] .main-content {
    margin-left: calc(70px + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm] .navbar-brand-box {
    top: 25px;
  }
  [data-layout=semibox][data-sidebar-size=sm] #page-topbar {
    left: calc(70px + 110px + 1rem + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm] .footer {
    left: calc(70px + 110px + 1rem + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm-hover] .main-content {
    margin-left: calc(70px + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm-hover] #page-topbar {
    left: calc(70px + 110px + 1rem + 25px);
  }
  [data-layout=semibox][data-sidebar-size=sm-hover] .footer {
    left: calc(70px + 110px + 1rem + 25px);
  }
}
[data-layout=semibox] .mx-n4 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
[data-layout=semibox] .mx-n4.p-1 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

[data-layout=horizontal] .main-content {
  margin-left: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .layout-width,
  [data-layout=horizontal] .container-fluid,
  [data-layout=horizontal] .container-sm,
  [data-layout=horizontal] .container-md,
  [data-layout=horizontal] .container-lg,
  [data-layout=horizontal] .container-xl,
  [data-layout=horizontal] .container-xxl {
    max-width: 90%;
    margin: 0 auto;
  }
  [data-layout=horizontal] .topnav-hamburger {
    visibility: hidden;
  }
}
[data-layout=horizontal] .horizontal-logo {
  padding-left: calc(1rem / 2);
}
@media (max-width: 1024.98px) {
  [data-layout=horizontal] .horizontal-logo {
    padding-left: 1rem;
  }
}
[data-layout=horizontal] .navbar-menu {
  background: var(--vz-topnav-bg);
  border-right-color: transparent;
  padding: 0 calc(1rem / 2);
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  bottom: auto;
}
@media (max-width: 575.98px) {
  [data-layout=horizontal] .navbar-menu .container-fluid, [data-layout=horizontal] .navbar-menu .container-sm, [data-layout=horizontal] .navbar-menu .container-md, [data-layout=horizontal] .navbar-menu .container-lg, [data-layout=horizontal] .navbar-menu .container-xl, [data-layout=horizontal] .navbar-menu .container-xxl {
    padding: 0;
  }
}
[data-layout=horizontal] .navbar-menu .navbar-nav {
  flex-direction: row;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm {
  padding-left: 0;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link:before {
  opacity: 0 !important;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link {
  color: var(--vz-topnav-item-color);
  padding: 0.75rem 1.5rem;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link i {
  line-height: 1;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active:after {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(242, 100, 48, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(242, 100, 48, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(242, 100, 48, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
  right: 0px;
  transform: rotate(90deg) !important;
}
[data-layout=horizontal] .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
  padding-left: 0;
}
[data-layout=horizontal] .navbar-menu .navbar-brand-box {
  display: none;
}
[data-layout=horizontal] .navbar-nav .nav-item {
  position: relative;
}
[data-layout=horizontal] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  right: 10px;
  transform: rotate(0deg) !important;
}
[data-layout=horizontal] .navbar-nav .nav-item > .nav-link > .badge {
  display: none;
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(242, 100, 48, 0.1);
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link:after {
  color: var(--vz-topnav-item-color-active);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .navbar-nav .nav-item:hover > .menu-dropdown {
    display: block;
    height: auto !important;
  }
}
[data-layout=horizontal] .navbar-nav .nav-item.active {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .menu-dropdown {
  position: absolute;
  min-width: 12rem;
  padding: 0.5rem 0;
  box-shadow: 0 0px 5px rgba(15, 34, 58, 0.15);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  z-index: 1000;
  background-color: var(--vz-choices-bg);
  background-clip: padding-box;
  border: 0 solid var(--vz-border-color);
  border-radius: 0.3rem;
  display: none;
}
[data-layout=horizontal] .menu-dropdown .menu-dropdown {
  top: 0;
  left: 100%;
}
[data-layout=horizontal] .mega-dropdown-menu {
  width: 40rem;
}
[data-layout=horizontal] .menu-title {
  display: none;
}
[data-layout=horizontal] .dropdown-custom-right {
  left: -100% !important;
  right: 100%;
}
@media (max-width: 1024px) {
  [data-layout=horizontal] .navbar-menu {
    display: none;
  }
  [data-layout=horizontal] .menu .navbar-menu {
    display: block;
    max-height: 360px;
    overflow-y: auto;
    padding-left: 0;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav {
    flex-direction: column;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
    padding-left: 1.5rem;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav .nav-sm .nav-link:before {
    opacity: 1 !important;
  }
  [data-layout=horizontal] .menu .menu-dropdown {
    position: relative;
    min-width: 100%;
    box-shadow: none;
    padding-left: 28px;
    left: 0;
    animation: none;
    padding-top: 0;
  }
  [data-layout=horizontal] .menu .menu-dropdown.show {
    display: block;
  }
  [data-layout=horizontal] .menu .dropdown-custom-right {
    left: 0 !important;
  }
  [data-layout=horizontal] .menu .nav-item .nav-link[data-bs-toggle=collapse]:after {
    right: 0px;
  }
  [data-layout=horizontal] .menu .mega-dropdown-menu {
    width: 100%;
  }
}

[data-layout-mode=dark][data-topbar=light] .navbar-header .horizontal-logo .logo-dark {
  display: none;
}
[data-layout-mode=dark][data-topbar=light] .navbar-header .horizontal-logo .logo-light {
  display: block;
}

[dir=rtl][data-layout=horizontal] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-90deg) !important;
}
[dir=rtl][data-layout=horizontal] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-180deg) !important;
}

[data-layout=twocolumn] .app-menu {
  padding-bottom: 0;
  width: 220px;
  left: 70px;
}
[data-layout=twocolumn] .app-menu .menu-link {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--vz-vertical-menu-title-color) !important;
  font-weight: 600;
}
[data-layout=twocolumn] .app-menu .menu-link:after {
  display: none !important;
}
[data-layout=twocolumn] .app-menu .menu-link i {
  display: none;
}
[data-layout=twocolumn] .app-menu .navbar-nav {
  height: calc(100vh - 70px);
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] .app-menu .navbar-nav {
    padding-top: 16px;
  }
}
[data-layout=twocolumn] .app-menu .navbar-nav > li:not(.twocolumn-item-show) {
  display: none;
}
[data-layout=twocolumn] .app-menu .navbar-nav .twocolumn-item-show > div {
  display: block !important;
  height: auto !important;
}
[data-layout=twocolumn] .app-menu .navbar-nav > .nav-item > .menu-dropdown {
  display: block !important;
  height: auto !important;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-item .menu-dropdown .row {
  margin: 0;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-item .menu-dropdown .row .col-lg-4 {
  width: 100%;
  padding: 0;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-sm .nav-link {
  color: var(--vz-vertical-menu-item-color);
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
[data-layout=twocolumn] .app-menu .container-fluid, [data-layout=twocolumn] .app-menu .container-sm, [data-layout=twocolumn] .app-menu .container-md, [data-layout=twocolumn] .app-menu .container-lg, [data-layout=twocolumn] .app-menu .container-xl, [data-layout=twocolumn] .app-menu .container-xxl {
  padding: 0;
}
[data-layout=twocolumn] .main-content {
  margin-left: calc(220px + 70px);
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] .main-content {
    margin-left: 70px;
  }
}
[data-layout=twocolumn] .twocolumn-iconview {
  width: 70px;
  background-color: var(--vz-twocolumn-menu-iconview-bg);
  height: 100%;
  left: -70px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  top: 0;
  position: absolute;
  padding: 0;
  text-align: center;
}
[data-layout=twocolumn] .twocolumn-iconview li {
  position: relative;
  list-style: none;
}
[data-layout=twocolumn] .twocolumn-iconview li .nav-icon::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon {
  width: 42px;
  height: 42px;
  line-height: 42px;
  color: var(--vz-vertical-menu-item-color);
  z-index: 1;
  font-size: 22px;
  text-align: center;
  border-radius: 3px;
  margin: 5px 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon .icon-dual {
  width: 18px;
  color: var(--vz-vertical-menu-item-color);
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon.active {
  background-color: rgba(242, 100, 48, 0.15);
  color: #F26430;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon.active .icon-dual {
  color: #F26430;
  fill: rgba(242, 100, 48, 0.1);
}
[data-layout=twocolumn] .menu-title {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn] .logo span.logo-lg {
    display: block;
  }
  [data-layout=twocolumn] .logo span.logo-sm {
    display: none;
  }
}
[data-layout=twocolumn][data-sidebar=light] .app-menu .navbar-brand-box .logo-light {
  display: none;
}
[data-layout=twocolumn][data-sidebar=light] .app-menu .navbar-brand-box .logo-dark {
  display: block;
}
[data-layout=twocolumn][data-sidebar=dark] .twocolumn-iconview {
  background-color: var(--vz-twocolumn-menu-iconview-bg-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .twocolumn-iconview .nav-icon {
  color: var(--vz-twocolumn-menu-item-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .twocolumn-iconview .nav-icon.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
  background-color: var(--vz-twocolumn-menu-item-active-bg-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu {
  background-color: var(--vz-twocolumn-menu-bg-dark);
  border-right-color: var(--vz-twocolumn-menu-bg-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-brand-box .logo-light {
  display: block;
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-brand-box .logo-dark {
  display: none;
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-nav .nav-sm .nav-link {
  color: var(--vz-twocolumn-menu-item-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after {
  color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .twocolumn-iconview {
  background-color: var(--vz-twocolumn-menu-iconview-bg-dark);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .twocolumn-iconview .nav-icon {
  color: rgba(255, 255, 255, 0.6);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .twocolumn-iconview .nav-icon.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
  background-color: var(--vz-twocolumn-menu-item-active-bg-dark);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .app-menu {
  background-color: var(--vz-twocolumn-menu-bg-dark);
  border-right-color: var(--vz-twocolumn-menu-bg-dark);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .app-menu .navbar-brand-box .logo-light {
  display: block;
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .app-menu .navbar-brand-box .logo-dark {
  display: none;
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .app-menu .navbar-nav .nav-sm .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .navbar-menu .navbar-nav .nav-sm .nav-link.active::before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4]) .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after {
  color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn]:is([data-sidebar=gradient], [data-sidebar=gradient-2], [data-sidebar=gradient-3], [data-sidebar=gradient-4])[data-layout-mode=dark] .app-menu {
  border-right-color: #495057;
}
[data-layout=twocolumn] .twocolumn-panel .app-menu {
  width: 0;
  border-right: 0;
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .twocolumn-panel .app-menu {
    display: none;
  }
}
[data-layout=twocolumn] .twocolumn-panel .navbar-brand-box,
[data-layout=twocolumn] .twocolumn-panel .navbar-nav {
  display: none;
}
[data-layout=twocolumn] .twocolumn-panel .main-content {
  margin-left: 70px;
}
[data-layout=twocolumn] .twocolumn-panel #page-topbar,
[data-layout=twocolumn] .twocolumn-panel .footer {
  left: 70px;
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .twocolumn-panel .main-content {
    margin-left: 0;
  }
  [data-layout=twocolumn] .twocolumn-panel #page-topbar,
  [data-layout=twocolumn] .twocolumn-panel .footer {
    left: 0;
  }
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] #page-topbar,
  [data-layout=twocolumn] .footer {
    left: 70px;
  }
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .main-content {
    margin-left: 0;
  }
  [data-layout=twocolumn] #page-topbar,
  [data-layout=twocolumn] .footer {
    left: 0;
  }
}

[data-layout-width=boxed] body {
  background-color: var(--vz-boxed-body-bg);
}
[data-layout-width=boxed] #layout-wrapper {
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-body-bg);
}
[data-layout-width=boxed][data-layout=vertical] #layout-wrapper {
  min-height: 100vh;
}
[data-layout-width=boxed] #page-topbar,
[data-layout-width=boxed] .footer {
  max-width: 1300px;
  margin: 0 auto;
  left: 0 !important;
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover][data-layout=vertical] #layout-wrapper, [data-layout-width=boxed][data-sidebar-size=sm][data-layout=vertical] #layout-wrapper {
    min-height: 1400px;
  }
}
@media (max-width: 767.98px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover][data-layout=vertical] .main-content, [data-layout-width=boxed][data-sidebar-size=sm][data-layout=vertical] .main-content {
    margin-left: 0;
  }
}
[data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-sidebar-size=sm] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm] .footer {
  left: 0 !important;
  max-width: calc(1300px - 70px);
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-sidebar-size=sm] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=sm] .footer {
    left: 70px !important;
  }
}
[data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=lg] .footer {
  max-width: calc(1300px - 250px);
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=lg] .footer {
    left: 250px !important;
  }
}
[data-layout-width=boxed][data-sidebar-size=md] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=md] .footer {
  max-width: calc(1300px - 180px);
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=md] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=md] .footer {
    left: 180px !important;
  }
}
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] body {
  background-color: var(--vz-body-bg);
}
@media (min-width: 1024.1px) {
  [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] #layout-wrapper {
    max-width: 1300px;
    box-shadow: none;
  }
  [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] .layout-width {
    max-width: 1300px;
  }
}
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=md] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=md] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=lg] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=lg] .footer {
  max-width: 100%;
  left: 0 !important;
}

[data-layout=horizontal][data-layout-width=boxed] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed] #layout-wrapper,
[data-layout=horizontal][data-layout-width=boxed] .footer {
  max-width: 100%;
}
[data-layout=horizontal][data-layout-width=boxed] .container-fluid, [data-layout=horizontal][data-layout-width=boxed] .container-sm, [data-layout=horizontal][data-layout-width=boxed] .container-md, [data-layout=horizontal][data-layout-width=boxed] .container-lg, [data-layout=horizontal][data-layout-width=boxed] .container-xl, [data-layout=horizontal][data-layout-width=boxed] .container-xxl,
[data-layout=horizontal][data-layout-width=boxed] .navbar-header {
  max-width: 1300px;
}
[data-layout=horizontal][data-layout-width=boxed] .navbar-header {
  padding: 0 calc(1rem / 2) 0 0;
}
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm] [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm] [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=lg] .footer {
  left: 0 !important;
}

@media (min-width: 992px) {
  [data-layout-position=scrollable] #page-topbar,
  [data-layout-position=scrollable] .navbar-menu {
    position: absolute;
  }
  [data-layout-position=scrollable][data-layout=horizontal] #page-topbar,
  [data-layout-position=scrollable][data-layout=horizontal] .topnav {
    position: absolute;
  }
}

@media (min-width: 768px) {
  [data-layout=semibox][data-sidebar-visibility=hidden] .navbar-menu {
    display: none;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .horizontal-logo {
    display: inline-block;
    width: auto;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .footer {
    left: 0;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] #page-topbar {
    left: 0;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .main-content {
    margin-left: 0px;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .navbar-brand-box, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .navbar-brand-box {
    position: static;
    padding: 0 1.3rem;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-lg, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-lg {
    display: inline-block;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-sm, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-sm {
    display: none;
  }
}
[data-layout=semibox][data-sidebar-visibility=hidden]:is([data-sidebar=dark],
[data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .logo-dark {
  display: inline-block;
}
[data-layout=semibox][data-sidebar-visibility=hidden]:is([data-sidebar=dark],
[data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .logo-light {
  display: none;
}
[data-layout=semibox][data-sidebar-visibility=hidden][data-topbar=dark]:is([data-sidebar=dark],
[data-sidebar=light],
[data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .logo-dark {
  display: none;
}
[data-layout=semibox][data-sidebar-visibility=hidden][data-topbar=dark]:is([data-sidebar=dark],
[data-sidebar=light],
[data-sidebar=gradient],
[data-sidebar=gradient-2],
[data-sidebar=gradient-3],
[data-sidebar=gradient-4]) .logo-light {
  display: block;
}
@media (min-width: 1440px) {
  [data-layout=semibox][data-sidebar-visibility=hidden] .navbar-menu {
    display: none;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .horizontal-logo {
    display: inline-block;
    width: auto;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .footer {
    left: calc(110px + 1rem);
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] #page-topbar {
    left: calc(110px + 1rem);
  }
  [data-layout=semibox][data-sidebar-visibility=hidden] .main-content {
    margin-left: 0px;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .navbar-brand-box, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .navbar-brand-box {
    position: static;
    padding: 0 1.3rem;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-lg, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-lg {
    display: inline-block;
  }
  [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm] .logo span.logo-sm, [data-layout=semibox][data-sidebar-visibility=hidden][data-sidebar-size=sm-hover] .logo span.logo-sm {
    display: none;
  }
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(242, 100, 48, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(10, 179, 156, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(41, 156, 219, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(63, 191, 72, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(240, 101, 72, 0.4);
}

.avatar-xxs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: #F26430;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap;
}
.avatar-group .avatar-group-item {
  margin-left: -12px;
  border: 2px solid var(--vz-card-bg-custom);
  border-radius: 50%;
  transition: all 0.2s;
}
.avatar-group .avatar-group-item:hover {
  position: relative;
  transform: translateY(-2px);
  z-index: 1;
}

.accordion .accordion-button {
  font-weight: 500;
}
.accordion .accordion-body {
  color: #878a99;
}
.accordion.accordion-icon-none .accordion-button::after {
  content: "";
  background-image: none !important;
}
.accordion.accordion-icon-none .accordion-button:not(.collapsed)::after {
  content: "";
}

.custom-accordionwithicon .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\f0142";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}
.custom-accordionwithicon .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\f0140";
  margin-right: -3px;
}

.custom-accordionwithicon-plus .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\f0415";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}
.custom-accordionwithicon-plus .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\f0374";
  margin-right: -3px;
}

.lefticon-accordion .accordion-button {
  padding-left: 2.75rem;
}
.lefticon-accordion .accordion-button::after {
  position: absolute;
  left: 1.25rem;
  top: 14px;
}
.lefticon-accordion .accordion-button:not(.collapsed)::after {
  top: 20px;
}

.accordion-border-box .accordion-item {
  border-top: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.accordion-border-box .accordion-item:not(:first-of-type) {
  margin-top: 8px;
}
.accordion-border-box .accordion-item .accordion-button {
  border-radius: 0.25rem;
}
.accordion-border-box .accordion-item .accordion-button:not(.collapsed) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-accordion-border .accordion-item {
  border-left: 3px solid var(--vz-border-color);
}

.accordion-primary .accordion-item {
  border-color: rgba(242, 100, 48, 0.6);
}
.accordion-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #F26430;
  background-color: rgba(242, 100, 48, 0.1) !important;
}
.accordion-primary .accordion-item .accordion-button::after {
  color: #F26430;
}

.accordion-fill-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #F26430 !important;
}

.accordion-secondary .accordion-item {
  border-color: rgba(32, 140, 59, 0.6);
}
.accordion-secondary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #208C3B;
  background-color: rgba(32, 140, 59, 0.1) !important;
}
.accordion-secondary .accordion-item .accordion-button::after {
  color: #208C3B;
}

.accordion-fill-secondary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #208C3B !important;
}

.accordion-success .accordion-item {
  border-color: rgba(10, 179, 156, 0.6);
}
.accordion-success .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-success .accordion-item .accordion-button:not(.collapsed) {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1) !important;
}
.accordion-success .accordion-item .accordion-button::after {
  color: #0ab39c;
}

.accordion-fill-success .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-success .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #0ab39c !important;
}

.accordion-info .accordion-item {
  border-color: rgba(41, 156, 219, 0.6);
}
.accordion-info .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-info .accordion-item .accordion-button:not(.collapsed) {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1) !important;
}
.accordion-info .accordion-item .accordion-button::after {
  color: #299cdb;
}

.accordion-fill-info .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-info .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #299cdb !important;
}

.accordion-warning .accordion-item {
  border-color: rgba(63, 191, 72, 0.6);
}
.accordion-warning .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #3FBF48;
  background-color: rgba(63, 191, 72, 0.1) !important;
}
.accordion-warning .accordion-item .accordion-button::after {
  color: #3FBF48;
}

.accordion-fill-warning .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #3FBF48 !important;
}

.accordion-danger .accordion-item {
  border-color: rgba(240, 101, 72, 0.6);
}
.accordion-danger .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1) !important;
}
.accordion-danger .accordion-item .accordion-button::after {
  color: #f06548;
}

.accordion-fill-danger .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f06548 !important;
}

.accordion-light .accordion-item {
  border-color: rgba(243, 246, 249, 0.6);
}
.accordion-light .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-light .accordion-item .accordion-button:not(.collapsed) {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1) !important;
}
.accordion-light .accordion-item .accordion-button::after {
  color: #f3f6f9;
}

.accordion-fill-light .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-light .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f3f6f9 !important;
}

.accordion-dark .accordion-item {
  border-color: rgba(33, 37, 41, 0.6);
}
.accordion-dark .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1) !important;
}
.accordion-dark .accordion-item .accordion-button::after {
  color: #212529;
}

.accordion-fill-dark .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #212529 !important;
}

[data-layout-mode=dark] .accordion-button:not(.collapsed) {
  color: var(--vz-accordion-button-active-color);
}
[data-layout-mode=dark] .accordion-button:not(.collapsed):after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}
[data-layout-mode=dark] .accordion-button:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}

[dir=rtl] .custom-accordionwithicon .accordion-button::after {
  transform: rotate(180deg);
}

.fs-10 {
  font-size: 10px !important;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-17 {
  font-size: 17px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-19 {
  font-size: 19px !important;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-21 {
  font-size: 21px !important;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-23 {
  font-size: 23px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.fs-36 {
  font-size: 36px !important;
}

.fs-48 {
  font-size: 48px !important;
}

.border-dark {
  border-color: var(--vz-dark) !important;
}

.border-light {
  border-color: var(--vz-light) !important;
}

.border-double {
  border-style: double !important;
}

.border-top-double {
  border-top-style: double !important;
}

.border-bottom-double {
  border-bottom-style: double !important;
}

.border-end-double {
  border-right-style: double !important;
}

.border-start-double {
  border-left-style: double !important;
}

.list-group-flush.border-double {
  border: none !important;
}
.list-group-flush.border-double .list-group-item {
  border-style: double !important;
}

.border-dashed {
  border-style: dashed !important;
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.list-group-flush.border-dashed {
  border: none !important;
}
.list-group-flush.border-dashed .list-group-item {
  border-style: dashed !important;
}

.border-groove {
  border-style: groove !important;
}

.border-top-groove {
  border-top-style: groove !important;
}

.border-bottom-groove {
  border-bottom-style: groove !important;
}

.border-end-groove {
  border-right-style: groove !important;
}

.border-start-groove {
  border-left-style: groove !important;
}

.list-group-flush.border-groove {
  border: none !important;
}
.list-group-flush.border-groove .list-group-item {
  border-style: groove !important;
}

.border-outset {
  border-style: outset !important;
}

.border-top-outset {
  border-top-style: outset !important;
}

.border-bottom-outset {
  border-bottom-style: outset !important;
}

.border-end-outset {
  border-right-style: outset !important;
}

.border-start-outset {
  border-left-style: outset !important;
}

.list-group-flush.border-outset {
  border: none !important;
}
.list-group-flush.border-outset .list-group-item {
  border-style: outset !important;
}

.border-ridge {
  border-style: ridge !important;
}

.border-top-ridge {
  border-top-style: ridge !important;
}

.border-bottom-ridge {
  border-bottom-style: ridge !important;
}

.border-end-ridge {
  border-right-style: ridge !important;
}

.border-start-ridge {
  border-left-style: ridge !important;
}

.list-group-flush.border-ridge {
  border: none !important;
}
.list-group-flush.border-ridge .list-group-item {
  border-style: ridge !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.list-group-flush.border-dotted {
  border: none !important;
}
.list-group-flush.border-dotted .list-group-item {
  border-style: dotted !important;
}

.border-inset {
  border-style: inset !important;
}

.border-top-inset {
  border-top-style: inset !important;
}

.border-bottom-inset {
  border-bottom-style: inset !important;
}

.border-end-inset {
  border-right-style: inset !important;
}

.border-start-inset {
  border-left-style: inset !important;
}

.list-group-flush.border-inset {
  border: none !important;
}
.list-group-flush.border-inset .list-group-item {
  border-style: inset !important;
}

[data-layout-mode=dark] .link-dark, [data-layout-mode=dark] .link-light {
  color: var(--vz-dark) !important;
}
[data-layout-mode=dark] .link-dark:is(:focus, :hover), [data-layout-mode=dark] .link-light:is(:focus, :hover) {
  color: rgba(var(--vz-dark-rgb), 0.75) !important;
}

.ff-base {
  font-family: var(--vz-font-sans-serif);
}

.ff-secondary {
  font-family: "hkgrotesk", sans-serif;
}

.fw-medium {
  font-weight: 500;
}

.flex-1 {
  flex: 1 1;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s;
}
.social-list-item:hover {
  color: #878a99;
  background-color: #eff2f7;
}

.bg-pattern {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) #fff;
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

.icon-xs {
  height: 16px;
  width: 16px;
}

.icon-sm {
  height: 18px;
  width: 18px;
}

.icon-md {
  height: 22px;
  width: 22px;
}

.icon-lg {
  height: 24px;
  width: 24px;
}

.icon-xl {
  height: 28px;
  width: 28px;
}

.icon-xxl {
  height: 32px;
  width: 32px;
}

.icon-dual {
  color: #adb5bd;
  fill: rgba(173, 181, 189, 0.16);
}

.icon-dual-primary {
  color: #F26430;
  fill: rgba(242, 100, 48, 0.16);
}

.icon-dual-secondary {
  color: #208C3B;
  fill: rgba(32, 140, 59, 0.16);
}

.icon-dual-success {
  color: #0ab39c;
  fill: rgba(10, 179, 156, 0.16);
}

.icon-dual-info {
  color: #299cdb;
  fill: rgba(41, 156, 219, 0.16);
}

.icon-dual-warning {
  color: #3FBF48;
  fill: rgba(63, 191, 72, 0.16);
}

.icon-dual-danger {
  color: #f06548;
  fill: rgba(240, 101, 72, 0.16);
}

.icon-dual-light {
  color: #f3f6f9;
  fill: rgba(243, 246, 249, 0.16);
}

.icon-dual-dark {
  color: #212529;
  fill: rgba(33, 37, 41, 0.16);
}

.search-box {
  position: relative;
}
.search-box .form-control {
  padding-left: 40px;
}
.search-box .search-icon {
  font-size: 14px;
  position: absolute;
  left: 13px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  color: #878a99;
}

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.1;
  background-color: #000;
}

.customizer-setting {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000;
}

code {
  -webkit-user-select: all;
          user-select: all;
}

.layout-rightside {
  width: 280px;
  margin-right: -1rem;
  margin-top: calc(1px - 1rem * 1.1);
  height: calc(100% + 1rem * 1.1);
}

@media (max-width: 1699.98px) {
  .layout-rightside-col {
    display: none;
    position: fixed !important;
    height: 100vh;
    right: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 1004;
  }
  .layout-rightside-col .overlay {
    position: fixed;
    top: 0;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(33, 37, 41, 0.2);
  }
  .layout-rightside-col .layout-rightside {
    margin-top: 0px;
    height: 100%;
    margin-left: auto;
  }
  .layout-rightside-col .card-body {
    overflow-y: auto;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1700px) {
  [data-layout=horizontal] .layout-rightside, [data-layout-style=detached] .layout-rightside {
    margin-top: calc(28px - 1rem);
    margin-right: 0;
    height: calc(100% - 1rem / 5);
  }
}

.object-cover {
  object-fit: cover;
}

.text-truncate-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.favourite-btn {
  border-color: transparent;
}
.favourite-btn .ri-star-fill {
  color: #878a99;
}
.favourite-btn.active {
  border-color: transparent;
}
.favourite-btn.active .ri-star-fill {
  color: #3FBF48;
}
.favourite-btn.active .ri-star-fill:before {
  content: "\\f186";
}

.card-logo-light {
  display: var(--vz-card-logo-light);
}

.card-logo-dark {
  display: var(--vz-card-logo-dark);
}

[data-layout-mode=dark] .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

#back-to-top {
  position: fixed;
  bottom: 100px;
  right: 28px;
  transition: all 0.5s ease;
  display: none;
  z-index: 1000;
}
#back-to-top:hover {
  animation: fade-up 1.5s infinite linear;
}

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
.cursor-pointer {
  cursor: pointer;
}

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--vz-card-bg-custom);
  z-index: 9999;
}

[data-preloader=disable] #preloader {
  opacity: 0;
  visibility: hidden;
}

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

:is([type=tel], [type=url], [type=email], [type=number])::placeholder {
  text-align: left;
}

.main-chart .chart-border-left {
  border-left: 1.4px solid var(--vz-border-color);
  padding: 2px 20px;
}
.main-chart .chart-border-left:last-child {
  margin-right: 0px;
}

/* Activity */
.activity-feed {
  list-style: none;
}
.activity-feed .feed-item {
  position: relative;
  padding-bottom: 27px;
  padding-left: 16px;
  border-left: 2px solid #f3f6f9;
}
.activity-feed .feed-item:after {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  left: -6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #F26430;
  background-color: #fff;
}
.activity-feed .feed-item:last-child {
  border-color: transparent;
}

.mini-stats-wid {
  position: relative;
}
.mini-stats-wid .mini-stat-icon {
  overflow: hidden;
  position: relative;
}
.mini-stats-wid .mini-stat-icon:before, .mini-stats-wid .mini-stat-icon:after {
  content: "";
  position: absolute;
  width: 8px;
  height: 69px;
  background-color: rgba(10, 179, 156, 0.1);
  left: 3px;
  transform: rotate(32deg);
  top: -8px;
  transition: all 0.4s;
}
.mini-stats-wid .mini-stat-icon::after {
  left: 27px;
  width: 8px;
  transition: all 0.2s;
}
.mini-stats-wid:hover .mini-stat-icon::after {
  left: 60px;
}
.mini-stats-wid:hover .mini-stat-icon::before {
  left: 50px;
}

.card-wrapper .jp-card .jp-card-back, .card-wrapper .jp-card .jp-card-front {
  background-color: #0ab39c;
}

.notification-elem {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--vz-card-bg-custom);
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
}

.clothes-size li input[type=radio] {
  display: none;
}
.clothes-size li label {
  display: inline-block;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid var(--vz-border-color);
  text-transform: none;
  letter-spacing: 0;
  color: #F26430;
}
.clothes-size li input[type=radio]:checked + label {
  background-color: #F26430;
  border-color: #F26430;
  color: #fff;
}

.button-items {
  margin-left: -8px;
  margin-bottom: -12px;
}
.button-items .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}

[dir=rtl] .modal-open {
  padding-left: 0px !important;
}

.icon-demo-content {
  color: var(--vz-gray-500);
}
.icon-demo-content i {
  font-size: 24px;
  margin-right: 10px;
  color: var(--vz-gray-600);
  transition: all 0.4s;
  vertical-align: middle;
}
.icon-demo-content svg {
  margin-right: 10px;
  transition: all 0.4s;
  height: 20px;
}
.icon-demo-content .col-lg-4 {
  margin-top: 24px;
}
.icon-demo-content .col-lg-4:hover i, .icon-demo-content .col-lg-4:hover svg {
  color: #F26430;
  transform: scale(1.5);
}

.grid-structure .grid-container {
  background-color: #f3f6f9;
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 10px 20px;
}

.img-switch .card-radio .form-check-input {
  display: none;
}
.img-switch .card-radio .form-check-input:checked + .form-check-label::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(242, 100, 48, 0.5);
}
.img-switch .card-radio .form-check-input:checked + .form-check-label::after {
  content: "\\eb80";
  font-family: "remixicon";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 18px;
  color: #fff;
}

[data-bs-target="#collapseBgGradient"].active {
  border-color: #F26430 !important;
}
[data-bs-target="#collapseBgGradient"].active::before {
  content: "\\eb80";
  font-family: remixicon;
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #F26430;
}

[data-layout-mode=dark] .colorscheme-cardradio .form-check-label {
  background-color: var(--vz-dark);
}
[data-layout-mode=dark] .colorscheme-cardradio .bg-light {
  background-color: rgba(var(--vz-light-rgb), 0.1) !important;
}
[data-layout-mode=dark] .colorscheme-cardradio .bg-soft-light {
  background-color: rgba(var(--vz-dark-rgb), 0.1) !important;
}
[data-layout-mode=dark] .colorscheme-cardradio .dark .bg-dark {
  background-color: var(--vz-card-bg-custom) !important;
}

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .app-menu,
  .footer,
  #back-to-top {
    display: none !important;
  }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0;
  }
  .card {
    border: 0;
    box-shadow: none !important;
  }
  .invoice-details .d-sm-flex {
    display: flex !important;
  }
  .address.col-sm-6 {
    flex: 0 0 auto !important;
    width: 50% !important;
    max-width: 100% !important;
  }
}
.ribbon-box {
  position: relative;
}
.ribbon-box .ribbon {
  padding: 5px 12px;
  box-shadow: 2px 5px 10px rgba(33, 37, 41, 0.15);
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  position: absolute;
  left: -1px;
  top: 5px;
}
.ribbon-box .ribbon.round-shape {
  border-radius: 0 30px 30px 0;
}
.ribbon-box .ribbon.ribbon-shape {
  display: inline-block;
}
.ribbon-box .ribbon.ribbon-shape::before {
  content: "";
  position: absolute;
  right: -17px;
  top: 0;
  border: 14px solid transparent;
}
.ribbon-box .ribbon.ribbon-shape::after {
  content: "";
  position: absolute;
  right: -17px;
  bottom: 0;
  border: 14px solid transparent;
}
.ribbon-box.ribbon-circle .ribbon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 20px;
  top: 20px;
}
.ribbon-box.ribbon-fill {
  overflow: hidden;
}
.ribbon-box.ribbon-fill .ribbon {
  transform: rotate(-45deg);
  width: 93px;
  height: 52px;
  left: -36px;
  top: -16px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.ribbon-box.ribbon-fill.ribbon-sm .ribbon {
  padding: 2px 12px;
  width: 78px;
  height: 42px;
  font-size: 12px;
  box-shadow: none;
}
.ribbon-box.right .ribbon {
  position: absolute;
  left: auto;
  right: 0;
}
.ribbon-box.right .ribbon.round-shape {
  border-radius: 30px 0 0 30px;
}
.ribbon-box.right .ribbon.ribbon-shape {
  text-align: right;
}
.ribbon-box.right .ribbon.ribbon-shape::before, .ribbon-box.right .ribbon.ribbon-shape::after {
  right: auto;
  left: -17px;
  border-left-color: transparent;
}
.ribbon-box.right.ribbon-circle .ribbon {
  left: auto;
  right: 20px;
}
.ribbon-box.right .icon-ribbon {
  right: 24px;
  left: auto;
}
.ribbon-box.right.ribbon-fill .ribbon {
  transform: rotate(45deg);
  right: -38px;
  left: auto;
}
.ribbon-box.right.ribbon-box .ribbon-two {
  left: auto;
  right: -5px;
}
.ribbon-box.right.ribbon-box .ribbon-two span {
  left: auto;
  right: -21px;
  transform: rotate(45deg);
}
.ribbon-box .ribbon-content {
  clear: both;
}
.ribbon-box .ribbon-primary {
  background: #F26430;
}
.ribbon-box .ribbon-primary:before {
  border-color: rgb(224.8772727273, 70.6136363636, 14.1227272727) transparent transparent;
}
.ribbon-box .ribbon-primary.ribbon-shape::before {
  border-left-color: #F26430;
  border-top-color: #F26430;
}
.ribbon-box .ribbon-primary.ribbon-shape::after {
  border-left-color: #F26430;
  border-bottom-color: #F26430;
}
.ribbon-box.right .ribbon-primary {
  background: #F26430;
}
.ribbon-box.right .ribbon-primary.ribbon-shape::before {
  border-right-color: #F26430;
  border-top-color: #F26430;
}
.ribbon-box.right .ribbon-primary.ribbon-shape::after {
  border-right-color: #F26430;
  border-bottom-color: #F26430;
}
.ribbon-box .ribbon-secondary {
  background: #208C3B;
}
.ribbon-box .ribbon-secondary:before {
  border-color: rgb(22.511627907, 98.488372093, 41.5058139535) transparent transparent;
}
.ribbon-box .ribbon-secondary.ribbon-shape::before {
  border-left-color: #208C3B;
  border-top-color: #208C3B;
}
.ribbon-box .ribbon-secondary.ribbon-shape::after {
  border-left-color: #208C3B;
  border-bottom-color: #208C3B;
}
.ribbon-box.right .ribbon-secondary {
  background: #208C3B;
}
.ribbon-box.right .ribbon-secondary.ribbon-shape::before {
  border-right-color: #208C3B;
  border-top-color: #208C3B;
}
.ribbon-box.right .ribbon-secondary.ribbon-shape::after {
  border-right-color: #208C3B;
  border-bottom-color: #208C3B;
}
.ribbon-box .ribbon-success {
  background: #0ab39c;
}
.ribbon-box .ribbon-success:before {
  border-color: rgb(7.3015873016, 130.6984126984, 113.9047619048) transparent transparent;
}
.ribbon-box .ribbon-success.ribbon-shape::before {
  border-left-color: #0ab39c;
  border-top-color: #0ab39c;
}
.ribbon-box .ribbon-success.ribbon-shape::after {
  border-left-color: #0ab39c;
  border-bottom-color: #0ab39c;
}
.ribbon-box.right .ribbon-success {
  background: #0ab39c;
}
.ribbon-box.right .ribbon-success.ribbon-shape::before {
  border-right-color: #0ab39c;
  border-top-color: #0ab39c;
}
.ribbon-box.right .ribbon-success.ribbon-shape::after {
  border-right-color: #0ab39c;
  border-bottom-color: #0ab39c;
}
.ribbon-box .ribbon-info {
  background: #299cdb;
}
.ribbon-box .ribbon-info:before {
  border-color: rgb(30.096, 126.236, 178.904) transparent transparent;
}
.ribbon-box .ribbon-info.ribbon-shape::before {
  border-left-color: #299cdb;
  border-top-color: #299cdb;
}
.ribbon-box .ribbon-info.ribbon-shape::after {
  border-left-color: #299cdb;
  border-bottom-color: #299cdb;
}
.ribbon-box.right .ribbon-info {
  background: #299cdb;
}
.ribbon-box.right .ribbon-info.ribbon-shape::before {
  border-right-color: #299cdb;
  border-top-color: #299cdb;
}
.ribbon-box.right .ribbon-info.ribbon-shape::after {
  border-right-color: #299cdb;
  border-bottom-color: #299cdb;
}
.ribbon-box .ribbon-warning {
  background: #3FBF48;
}
.ribbon-box .ribbon-warning:before {
  border-color: rgb(50.3503937008, 152.6496062992, 57.5433070866) transparent transparent;
}
.ribbon-box .ribbon-warning.ribbon-shape::before {
  border-left-color: #3FBF48;
  border-top-color: #3FBF48;
}
.ribbon-box .ribbon-warning.ribbon-shape::after {
  border-left-color: #3FBF48;
  border-bottom-color: #3FBF48;
}
.ribbon-box.right .ribbon-warning {
  background: #3FBF48;
}
.ribbon-box.right .ribbon-warning.ribbon-shape::before {
  border-right-color: #3FBF48;
  border-top-color: #3FBF48;
}
.ribbon-box.right .ribbon-warning.ribbon-shape::after {
  border-right-color: #3FBF48;
  border-bottom-color: #3FBF48;
}
.ribbon-box .ribbon-danger {
  background: #f06548;
}
.ribbon-box .ribbon-danger:before {
  border-color: rgb(236.1363636364, 61.3333333333, 24.8636363636) transparent transparent;
}
.ribbon-box .ribbon-danger.ribbon-shape::before {
  border-left-color: #f06548;
  border-top-color: #f06548;
}
.ribbon-box .ribbon-danger.ribbon-shape::after {
  border-left-color: #f06548;
  border-bottom-color: #f06548;
}
.ribbon-box.right .ribbon-danger {
  background: #f06548;
}
.ribbon-box.right .ribbon-danger.ribbon-shape::before {
  border-right-color: #f06548;
  border-top-color: #f06548;
}
.ribbon-box.right .ribbon-danger.ribbon-shape::after {
  border-right-color: #f06548;
  border-bottom-color: #f06548;
}
.ribbon-box .ribbon-light {
  background: #f3f6f9;
}
.ribbon-box .ribbon-light:before {
  border-color: rgb(209, 220.5, 232) transparent transparent;
}
.ribbon-box .ribbon-light.ribbon-shape::before {
  border-left-color: #f3f6f9;
  border-top-color: #f3f6f9;
}
.ribbon-box .ribbon-light.ribbon-shape::after {
  border-left-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}
.ribbon-box.right .ribbon-light {
  background: #f3f6f9;
}
.ribbon-box.right .ribbon-light.ribbon-shape::before {
  border-right-color: #f3f6f9;
  border-top-color: #f3f6f9;
}
.ribbon-box.right .ribbon-light.ribbon-shape::after {
  border-right-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}
.ribbon-box .ribbon-dark {
  background: #212529;
}
.ribbon-box .ribbon-dark:before {
  border-color: rgb(10.2567567568, 11.5, 12.7432432432) transparent transparent;
}
.ribbon-box .ribbon-dark.ribbon-shape::before {
  border-left-color: #212529;
  border-top-color: #212529;
}
.ribbon-box .ribbon-dark.ribbon-shape::after {
  border-left-color: #212529;
  border-bottom-color: #212529;
}
.ribbon-box.right .ribbon-dark {
  background: #212529;
}
.ribbon-box.right .ribbon-dark.ribbon-shape::before {
  border-right-color: #212529;
  border-top-color: #212529;
}
.ribbon-box.right .ribbon-dark.ribbon-shape::after {
  border-right-color: #212529;
  border-bottom-color: #212529;
}
.ribbon-box .icon-ribbon {
  box-shadow: none;
  left: 24px;
  top: -12px;
  font-size: 40px;
  padding: 0;
}
.ribbon-box {
  /* Ribbon two */
}
.ribbon-box .ribbon-two {
  position: absolute;
  left: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}
.ribbon-box .ribbon-two span {
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  width: 100px;
  display: block;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  position: absolute;
  top: 19px;
  left: -21px;
  font-weight: 600;
}
.ribbon-box .ribbon-two span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two span:after {
  content: "";
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two-primary span {
  background: #F26430;
}
.ribbon-box .ribbon-two-primary span:before {
  border-left: 3px solid rgb(200.8840909091, 63.0795454545, 12.6159090909);
  border-top: 3px solid rgb(200.8840909091, 63.0795454545, 12.6159090909);
}
.ribbon-box .ribbon-two-primary span:after {
  border-right: 3px solid rgb(200.8840909091, 63.0795454545, 12.6159090909);
  border-top: 3px solid rgb(200.8840909091, 63.0795454545, 12.6159090909);
}
.ribbon-box .ribbon-two-secondary span {
  background: #208C3B;
}
.ribbon-box .ribbon-two-secondary span:before {
  border-left: 3px solid rgb(17.7674418605, 77.7325581395, 32.7587209302);
  border-top: 3px solid rgb(17.7674418605, 77.7325581395, 32.7587209302);
}
.ribbon-box .ribbon-two-secondary span:after {
  border-right: 3px solid rgb(17.7674418605, 77.7325581395, 32.7587209302);
  border-top: 3px solid rgb(17.7674418605, 77.7325581395, 32.7587209302);
}
.ribbon-box .ribbon-two-success span {
  background: #0ab39c;
}
.ribbon-box .ribbon-two-success span:before {
  border-left: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
  border-top: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
}
.ribbon-box .ribbon-two-success span:after {
  border-right: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
  border-top: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
}
.ribbon-box .ribbon-two-info span {
  background: #299cdb;
}
.ribbon-box .ribbon-two-info span:before {
  border-left: 3px solid rgb(26.424, 110.834, 157.076);
  border-top: 3px solid rgb(26.424, 110.834, 157.076);
}
.ribbon-box .ribbon-two-info span:after {
  border-right: 3px solid rgb(26.424, 110.834, 157.076);
  border-top: 3px solid rgb(26.424, 110.834, 157.076);
}
.ribbon-box .ribbon-two-warning span {
  background: #3FBF48;
}
.ribbon-box .ribbon-two-warning span:before {
  border-left: 3px solid rgb(44.0255905512, 133.4744094488, 50.3149606299);
  border-top: 3px solid rgb(44.0255905512, 133.4744094488, 50.3149606299);
}
.ribbon-box .ribbon-two-warning span:after {
  border-right: 3px solid rgb(44.0255905512, 133.4744094488, 50.3149606299);
  border-top: 3px solid rgb(44.0255905512, 133.4744094488, 50.3149606299);
}
.ribbon-box .ribbon-two-danger span {
  background: #f06548;
}
.ribbon-box .ribbon-two-danger span:before {
  border-left: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
  border-top: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
}
.ribbon-box .ribbon-two-danger span:after {
  border-right: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
  border-top: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
}
.ribbon-box .ribbon-two-light span {
  background: #f3f6f9;
}
.ribbon-box .ribbon-two-light span:before {
  border-left: 3px solid rgb(192, 207.75, 223.5);
  border-top: 3px solid rgb(192, 207.75, 223.5);
}
.ribbon-box .ribbon-two-light span:after {
  border-right: 3px solid rgb(192, 207.75, 223.5);
  border-top: 3px solid rgb(192, 207.75, 223.5);
}
.ribbon-box .ribbon-two-dark span {
  background: #212529;
}
.ribbon-box .ribbon-two-dark span:before {
  border-left: 3px solid black;
  border-top: 3px solid black;
}
.ribbon-box .ribbon-two-dark span:after {
  border-right: 3px solid black;
  border-top: 3px solid black;
}

.ribbon-box.right .ribbon-three {
  position: absolute;
  top: -6.1px;
  right: 10px;
  left: auto;
}

.ribbon-three {
  position: absolute;
  top: -6.1px;
  left: 10px;
}
.ribbon-three span {
  position: relative;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-top-right-radius: 8px;
  width: 90px;
}
.ribbon-three span::after, .ribbon-three span::before {
  position: absolute;
  content: "";
}
.ribbon-three span::before {
  height: 6px;
  width: 6px;
  left: -6px;
  top: 0;
}
.ribbon-three span::after {
  height: 6px;
  width: 8px;
  left: -8px;
  top: 0;
  border-radius: 8px 8px 0 0;
}
.ribbon-three::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 44px solid transparent;
  border-right: 44px solid transparent;
  border-top: 10px solid;
}

.ribbon-three-primary span {
  background: #F26430;
}
.ribbon-three-primary span:before {
  background: #F26430;
}
.ribbon-three-primary span:after {
  background: rgb(224.8772727273, 70.6136363636, 14.1227272727);
}
.ribbon-three-primary::after {
  border-top-color: #F26430;
}

.ribbon-three-secondary span {
  background: #208C3B;
}
.ribbon-three-secondary span:before {
  background: #208C3B;
}
.ribbon-three-secondary span:after {
  background: rgb(22.511627907, 98.488372093, 41.5058139535);
}
.ribbon-three-secondary::after {
  border-top-color: #208C3B;
}

.ribbon-three-success span {
  background: #0ab39c;
}
.ribbon-three-success span:before {
  background: #0ab39c;
}
.ribbon-three-success span:after {
  background: rgb(7.3015873016, 130.6984126984, 113.9047619048);
}
.ribbon-three-success::after {
  border-top-color: #0ab39c;
}

.ribbon-three-info span {
  background: #299cdb;
}
.ribbon-three-info span:before {
  background: #299cdb;
}
.ribbon-three-info span:after {
  background: rgb(30.096, 126.236, 178.904);
}
.ribbon-three-info::after {
  border-top-color: #299cdb;
}

.ribbon-three-warning span {
  background: #3FBF48;
}
.ribbon-three-warning span:before {
  background: #3FBF48;
}
.ribbon-three-warning span:after {
  background: rgb(50.3503937008, 152.6496062992, 57.5433070866);
}
.ribbon-three-warning::after {
  border-top-color: #3FBF48;
}

.ribbon-three-danger span {
  background: #f06548;
}
.ribbon-three-danger span:before {
  background: #f06548;
}
.ribbon-three-danger span:after {
  background: rgb(236.1363636364, 61.3333333333, 24.8636363636);
}
.ribbon-three-danger::after {
  border-top-color: #f06548;
}

.ribbon-three-light span {
  background: #f3f6f9;
}
.ribbon-three-light span:before {
  background: #f3f6f9;
}
.ribbon-three-light span:after {
  background: rgb(209, 220.5, 232);
}
.ribbon-three-light::after {
  border-top-color: #f3f6f9;
}

.ribbon-three-dark span {
  background: #212529;
}
.ribbon-three-dark span:before {
  background: #212529;
}
.ribbon-three-dark span:after {
  background: rgb(10.2567567568, 11.5, 12.7432432432);
}
.ribbon-three-dark::after {
  border-top-color: #212529;
}

.ribbon-box .trending-ribbon {
  transform: translateX(-50px);
  transition: all 0.5s ease;
}
.ribbon-box .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}
.ribbon-box:hover .trending-ribbon {
  transform: translateX(0);
}
.ribbon-box:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}
.ribbon-box.right .trending-ribbon {
  transform: translateX(50px);
  transition: all 0.5s ease;
}
.ribbon-box.right .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}
.ribbon-box.right:hover .trending-ribbon {
  transform: translateX(0);
}
.ribbon-box.right:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast-border-primary .toast-body {
  color: #F26430;
  border-bottom: 3px solid #F26430;
}

.toast-border-secondary .toast-body {
  color: #208C3B;
  border-bottom: 3px solid #208C3B;
}

.toast-border-success .toast-body {
  color: #0ab39c;
  border-bottom: 3px solid #0ab39c;
}

.toast-border-info .toast-body {
  color: #299cdb;
  border-bottom: 3px solid #299cdb;
}

.toast-border-warning .toast-body {
  color: #3FBF48;
  border-bottom: 3px solid #3FBF48;
}

.toast-border-danger .toast-body {
  color: #f06548;
  border-bottom: 3px solid #f06548;
}

.toast-border-light .toast-body {
  color: #f3f6f9;
  border-bottom: 3px solid #f3f6f9;
}

.toast-border-dark .toast-body {
  color: #212529;
  border-bottom: 3px solid #212529;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.scrollspy-example-2 {
  position: relative;
  height: 370px;
  overflow: auto;
}

html {
  position: relative;
  min-height: 100%;
}

:is(.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6) {
  color: var(--vz-heading-color);
  font-family: "Poppins", sans-serif;
}

a {
  text-decoration: none !important;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

b,
strong {
  font-weight: 600;
}

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid var(--vz-gray-300);
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid var(--vz-gray-300);
  text-align: right;
}

@media (min-width: 1200px) {
  :is(.container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl) {
    max-width: 1140px;
  }
}

.row > * {
  position: relative;
}

.alert-solid .alert-link {
  color: #fff;
}

.alert-outline {
  background-color: var(--vz-card-bg-custom);
  border-width: 2px;
}

.alert-borderless {
  border-width: 0;
}

.alert-label-icon {
  position: relative;
  padding-left: 60px;
  border: 0;
}
.alert-label-icon .label-icon {
  position: absolute;
  width: 45px;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.15);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert-label-icon.label-arrow {
  overflow: hidden;
}
.alert-label-icon.label-arrow .label-icon:after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  border-left-color: #F26430;
  right: -12px;
}

.alert-border-left {
  border-left: 3px solid;
}

.alert-top-border {
  background-color: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
  border-top: 2px solid;
  color: var(--vz-body-color);
}

.alert-additional {
  padding: 0;
}
.alert-additional .alert-body {
  padding: 0.8rem 1rem;
}
.alert-additional .alert-content {
  padding: 0.8rem 1rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  margin: 0 -1px -1px -1px;
}

.rounded-label .label-icon {
  width: 45px;
  height: 26px;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0 30px 30px 0;
}

.alert-solid.alert-primary {
  background-color: #F26430;
  border-color: #F26430;
  color: #fff;
}

.alert-outline.alert-primary {
  color: #F26430;
}

.alert-border-left.alert-primary {
  border-left-color: #F26430;
}

.alert-top-border.alert-primary {
  border-top-color: #F26430;
}

.rounded-label.alert-primary .label-icon {
  background-color: #F26430;
  color: #fff;
}

.label-arrow.alert-primary .label-icon {
  color: #fff;
  background-color: #F26430;
}
.label-arrow.alert-primary .label-icon:after {
  border-left-color: #F26430 !important;
}

.alert.alert-primary .btn-close::after {
  color: #F26430;
}

.alert-additional.alert-primary .alert-content {
  background-color: #F26430;
  color: #fff;
}

.alert-solid.alert-secondary {
  background-color: #208C3B;
  border-color: #208C3B;
  color: #fff;
}

.alert-outline.alert-secondary {
  color: #208C3B;
}

.alert-border-left.alert-secondary {
  border-left-color: #208C3B;
}

.alert-top-border.alert-secondary {
  border-top-color: #208C3B;
}

.rounded-label.alert-secondary .label-icon {
  background-color: #208C3B;
  color: #fff;
}

.label-arrow.alert-secondary .label-icon {
  color: #fff;
  background-color: #208C3B;
}
.label-arrow.alert-secondary .label-icon:after {
  border-left-color: #208C3B !important;
}

.alert.alert-secondary .btn-close::after {
  color: #208C3B;
}

.alert-additional.alert-secondary .alert-content {
  background-color: #208C3B;
  color: #fff;
}

.alert-solid.alert-success {
  background-color: #0ab39c;
  border-color: #0ab39c;
  color: #fff;
}

.alert-outline.alert-success {
  color: #0ab39c;
}

.alert-border-left.alert-success {
  border-left-color: #0ab39c;
}

.alert-top-border.alert-success {
  border-top-color: #0ab39c;
}

.rounded-label.alert-success .label-icon {
  background-color: #0ab39c;
  color: #fff;
}

.label-arrow.alert-success .label-icon {
  color: #fff;
  background-color: #0ab39c;
}
.label-arrow.alert-success .label-icon:after {
  border-left-color: #0ab39c !important;
}

.alert.alert-success .btn-close::after {
  color: #0ab39c;
}

.alert-additional.alert-success .alert-content {
  background-color: #0ab39c;
  color: #fff;
}

.alert-solid.alert-info {
  background-color: #299cdb;
  border-color: #299cdb;
  color: #fff;
}

.alert-outline.alert-info {
  color: #299cdb;
}

.alert-border-left.alert-info {
  border-left-color: #299cdb;
}

.alert-top-border.alert-info {
  border-top-color: #299cdb;
}

.rounded-label.alert-info .label-icon {
  background-color: #299cdb;
  color: #fff;
}

.label-arrow.alert-info .label-icon {
  color: #fff;
  background-color: #299cdb;
}
.label-arrow.alert-info .label-icon:after {
  border-left-color: #299cdb !important;
}

.alert.alert-info .btn-close::after {
  color: #299cdb;
}

.alert-additional.alert-info .alert-content {
  background-color: #299cdb;
  color: #fff;
}

.alert-solid.alert-warning {
  background-color: #3FBF48;
  border-color: #3FBF48;
  color: #fff;
}

.alert-outline.alert-warning {
  color: #3FBF48;
}

.alert-border-left.alert-warning {
  border-left-color: #3FBF48;
}

.alert-top-border.alert-warning {
  border-top-color: #3FBF48;
}

.rounded-label.alert-warning .label-icon {
  background-color: #3FBF48;
  color: #fff;
}

.label-arrow.alert-warning .label-icon {
  color: #fff;
  background-color: #3FBF48;
}
.label-arrow.alert-warning .label-icon:after {
  border-left-color: #3FBF48 !important;
}

.alert.alert-warning .btn-close::after {
  color: #3FBF48;
}

.alert-additional.alert-warning .alert-content {
  background-color: #3FBF48;
  color: #fff;
}

.alert-solid.alert-danger {
  background-color: #f06548;
  border-color: #f06548;
  color: #fff;
}

.alert-outline.alert-danger {
  color: #f06548;
}

.alert-border-left.alert-danger {
  border-left-color: #f06548;
}

.alert-top-border.alert-danger {
  border-top-color: #f06548;
}

.rounded-label.alert-danger .label-icon {
  background-color: #f06548;
  color: #fff;
}

.label-arrow.alert-danger .label-icon {
  color: #fff;
  background-color: #f06548;
}
.label-arrow.alert-danger .label-icon:after {
  border-left-color: #f06548 !important;
}

.alert.alert-danger .btn-close::after {
  color: #f06548;
}

.alert-additional.alert-danger .alert-content {
  background-color: #f06548;
  color: #fff;
}

.alert-solid.alert-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #000;
}

.alert-outline.alert-light {
  color: #f3f6f9;
}

.alert-border-left.alert-light {
  border-left-color: #f3f6f9;
}

.alert-top-border.alert-light {
  border-top-color: #f3f6f9;
}

.rounded-label.alert-light .label-icon {
  background-color: #f3f6f9;
  color: #000;
}

.label-arrow.alert-light .label-icon {
  color: #000;
  background-color: #f3f6f9;
}
.label-arrow.alert-light .label-icon:after {
  border-left-color: #f3f6f9 !important;
}

.alert.alert-light .btn-close::after {
  color: #f3f6f9;
}

.alert-additional.alert-light .alert-content {
  background-color: #f3f6f9;
  color: #000;
}

.alert-solid.alert-dark {
  background-color: #212529;
  border-color: #212529;
  color: #fff;
}

.alert-outline.alert-dark {
  color: #212529;
}

.alert-border-left.alert-dark {
  border-left-color: #212529;
}

.alert-top-border.alert-dark {
  border-top-color: #212529;
}

.rounded-label.alert-dark .label-icon {
  background-color: #212529;
  color: #fff;
}

.label-arrow.alert-dark .label-icon {
  color: #fff;
  background-color: #212529;
}
.label-arrow.alert-dark .label-icon:after {
  border-left-color: #212529 !important;
}

.alert.alert-dark .btn-close::after {
  color: #212529;
}

.alert-additional.alert-dark .alert-content {
  background-color: #212529;
  color: #fff;
}

.alert-dismissible .btn-close {
  background: transparent !important;
}
.alert-dismissible .btn-close::after {
  background: transparent !important;
  content: "\\f0156" !important;
  font-size: 18px;
  line-height: 15px;
  font-family: "Material Design Icons" !important;
}

.alert-outline.alert-dark {
  color: var(--vz-dark);
}

.bg-soft-primary {
  background-color: rgba(242, 100, 48, 0.18) !important;
}

.bg-soft-secondary {
  background-color: rgba(32, 140, 59, 0.18) !important;
}

.bg-soft-success {
  background-color: rgba(10, 179, 156, 0.18) !important;
}

.bg-soft-info {
  background-color: rgba(41, 156, 219, 0.18) !important;
}

.bg-soft-warning {
  background-color: rgba(63, 191, 72, 0.18) !important;
}

.bg-soft-danger {
  background-color: rgba(240, 101, 72, 0.18) !important;
}

.bg-soft-light {
  background-color: rgba(243, 246, 249, 0.18) !important;
}

.bg-soft-dark {
  background-color: rgba(33, 37, 41, 0.18) !important;
  background-color: rgba(var(--vz-dark-rgb), 0.18) !important;
}

.bg-soft-light {
  background-color: rgba(var(--vz-light-rgb), 0.18) !important;
}

.badge-outline-primary {
  color: #F26430;
  border: 1px solid #F26430;
  background-color: transparent;
}

.badge-outline-secondary {
  color: #208C3B;
  border: 1px solid #208C3B;
  background-color: transparent;
}

.badge-outline-success {
  color: #0ab39c;
  border: 1px solid #0ab39c;
  background-color: transparent;
}

.badge-outline-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent;
}

.badge-outline-warning {
  color: #3FBF48;
  border: 1px solid #3FBF48;
  background-color: transparent;
}

.badge-outline-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent;
}

.badge-outline-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent;
}

.badge-outline-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent;
}

.badge-outline {
  background-color: var(--vz-card-bg-custom);
  border: 1px solid;
}

.badge-soft-primary {
  color: #F26430;
  background-color: rgba(242, 100, 48, 0.1);
}

.badge-outline.badge-primary {
  color: #F26430;
  border: 1px solid #F26430;
  background-color: transparent;
}

.badge-label.bg-primary:before {
  border-right-color: #F26430;
}

.badge-soft-secondary {
  color: #208C3B;
  background-color: rgba(32, 140, 59, 0.1);
}

.badge-outline.badge-secondary {
  color: #208C3B;
  border: 1px solid #208C3B;
  background-color: transparent;
}

.badge-label.bg-secondary:before {
  border-right-color: #208C3B;
}

.badge-soft-success {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1);
}

.badge-outline.badge-success {
  color: #0ab39c;
  border: 1px solid #0ab39c;
  background-color: transparent;
}

.badge-label.bg-success:before {
  border-right-color: #0ab39c;
}

.badge-soft-info {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
}

.badge-outline.badge-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent;
}

.badge-label.bg-info:before {
  border-right-color: #299cdb;
}

.badge-soft-warning {
  color: #3FBF48;
  background-color: rgba(63, 191, 72, 0.1);
}

.badge-outline.badge-warning {
  color: #3FBF48;
  border: 1px solid #3FBF48;
  background-color: transparent;
}

.badge-label.bg-warning:before {
  border-right-color: #3FBF48;
}

.badge-soft-danger {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
}

.badge-outline.badge-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent;
}

.badge-label.bg-danger:before {
  border-right-color: #f06548;
}

.badge-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
}

.badge-outline.badge-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent;
}

.badge-label.bg-light:before {
  border-right-color: #f3f6f9;
}

.badge-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
}

.badge-outline.badge-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent;
}

.badge-label.bg-dark:before {
  border-right-color: #212529;
}

.badge-border {
  border-left: 2px solid;
}

.badge-label {
  margin-left: 8px;
  position: relative;
}
.badge-label:before {
  content: "";
  position: absolute;
  border: 8px solid transparent;
  border-right-color: #F26430;
  left: -14px;
  top: 0;
}

.badge-gradient-primary {
  background: linear-gradient(135deg, #F26430 0%, #0ab39c 100%);
}

.badge-gradient-secondary {
  background: linear-gradient(135deg, #208C3B 0%, #299cdb 100%);
}

.badge-gradient-success {
  background: linear-gradient(135deg, #0ab39c 0%, #3FBF48 100%);
}

.badge-gradient-danger {
  background: linear-gradient(135deg, #f06548 0%, #208C3B 100%);
}

.badge-gradient-warning {
  background: linear-gradient(135deg, #3FBF48 0%, rgb(44.0255905512, 133.4744094488, 50.3149606299) 100%);
}

.badge-gradient-info {
  background: linear-gradient(135deg, #299cdb 0%, #0ab39c 100%);
}

.badge-gradient-dark {
  background: linear-gradient(135deg, #212529 0%, #F26430 100%);
}

button,
a {
  outline: none !important;
  position: relative;
}

.btn {
  box-shadow: none;
}

:is(.btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active) {
  border-color: transparent;
}

.btn-rounded {
  border-radius: 30px;
}

.btn-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: calc(1rem + 1.5em + 2px);
  width: calc(1rem + 1.5em + 2px);
  padding: 0;
}
.btn-icon :is(i, svg, img) {
  vertical-align: middle;
}
.btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {
  height: calc(0.5rem + 1.5em + 2px);
  width: calc(0.5rem + 1.5em + 2px);
}
.btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {
  height: calc(1.4rem + 1.5em + 2px);
  width: calc(1.4rem + 1.5em + 2px);
}

.btn-soft-primary {
  --vz-btn-color: #F26430;
  --vz-btn-bg: rgba(242, 100, 48, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(217.8, 90, 43.2);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 242, 100, 48;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(193.6, 80, 38.4);
  --vz-btn-active-border-color: transparent;
}

.btn-soft-secondary {
  --vz-btn-color: #208C3B;
  --vz-btn-bg: rgba(32, 140, 59, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(28.8, 126, 53.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 32, 140, 59;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(25.6, 112, 47.2);
  --vz-btn-active-border-color: transparent;
}

.btn-soft-success {
  --vz-btn-color: #0ab39c;
  --vz-btn-bg: rgba(10, 179, 156, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(9, 161.1, 140.4);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 10, 179, 156;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(8, 143.2, 124.8);
  --vz-btn-active-border-color: transparent;
}

.btn-soft-info {
  --vz-btn-color: #299cdb;
  --vz-btn-bg: rgba(41, 156, 219, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(36.9, 140.4, 197.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 41, 156, 219;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(32.8, 124.8, 175.2);
  --vz-btn-active-border-color: transparent;
}

.btn-soft-warning {
  --vz-btn-color: #3FBF48;
  --vz-btn-bg: rgba(63, 191, 72, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(56.7, 171.9, 64.8);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 63, 191, 72;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(50.4, 152.8, 57.6);
  --vz-btn-active-border-color: transparent;
}

.btn-soft-danger {
  --vz-btn-color: #f06548;
  --vz-btn-bg: rgba(240, 101, 72, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(216, 90.9, 64.8);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 240, 101, 72;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(192, 80.8, 57.6);
  --vz-btn-active-border-color: transparent;
}

.btn-soft-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-bg: rgba(243, 246, 249, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(218.7, 221.4, 224.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(194.4, 196.8, 199.2);
  --vz-btn-active-border-color: transparent;
}

.btn-soft-dark {
  --vz-btn-color: #212529;
  --vz-btn-bg: rgba(33, 37, 41, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(29.7, 33.3, 36.9);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 33, 37, 41;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: rgb(26.4, 29.6, 32.8);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-primary {
  --vz-btn-color: #F26430;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #F26430;
  --vz-btn-hover-bg: rgba(242, 100, 48, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 242, 100, 48;
  --vz-btn-active-color: #F26430;
  --vz-btn-active-bg: rgba(242, 100, 48, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-secondary {
  --vz-btn-color: #208C3B;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #208C3B;
  --vz-btn-hover-bg: rgba(32, 140, 59, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 32, 140, 59;
  --vz-btn-active-color: #208C3B;
  --vz-btn-active-bg: rgba(32, 140, 59, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-success {
  --vz-btn-color: #0ab39c;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #0ab39c;
  --vz-btn-hover-bg: rgba(10, 179, 156, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 10, 179, 156;
  --vz-btn-active-color: #0ab39c;
  --vz-btn-active-bg: rgba(10, 179, 156, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-info {
  --vz-btn-color: #299cdb;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #299cdb;
  --vz-btn-hover-bg: rgba(41, 156, 219, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 41, 156, 219;
  --vz-btn-active-color: #299cdb;
  --vz-btn-active-bg: rgba(41, 156, 219, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-warning {
  --vz-btn-color: #3FBF48;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #3FBF48;
  --vz-btn-hover-bg: rgba(63, 191, 72, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 63, 191, 72;
  --vz-btn-active-color: #3FBF48;
  --vz-btn-active-bg: rgba(63, 191, 72, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-danger {
  --vz-btn-color: #f06548;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #f06548;
  --vz-btn-hover-bg: rgba(240, 101, 72, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 240, 101, 72;
  --vz-btn-active-color: #f06548;
  --vz-btn-active-bg: rgba(240, 101, 72, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #f3f6f9;
  --vz-btn-hover-bg: rgba(243, 246, 249, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: #f3f6f9;
  --vz-btn-active-bg: rgba(243, 246, 249, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-dark {
  --vz-btn-color: #212529;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #212529;
  --vz-btn-hover-bg: rgba(33, 37, 41, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 33, 37, 41;
  --vz-btn-active-color: #212529;
  --vz-btn-active-bg: rgba(33, 37, 41, 0.1);
  --vz-btn-active-border-color: transparent;
}

.btn-ghost-secondary {
  color: var(--vz-gray-700);
}

.btn-label {
  position: relative;
  padding-left: 44px;
}
.btn-label .label-icon {
  position: absolute;
  width: 35.5px;
  left: -1px;
  top: -1px;
  bottom: -1px;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-label.btn-light .label-icon {
  background-color: rgba(33, 37, 41, 0.05);
}
.btn-label.right {
  padding-left: 0.9rem;
  padding-right: 44px;
}
.btn-label.right .label-icon {
  right: -1px;
  left: auto;
}

.btn-animation {
  overflow: hidden;
  transition: border-color 0.3s, background-color 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation::after {
  content: attr(data-text);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transform: translate3d(0, 25%, 0);
  padding: 0.5rem 0.9rem;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation > span {
  display: block;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation:hover::after {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.btn-animation:hover > span {
  opacity: 0;
  transform: translate3d(0, -25%, 0);
}

.btn-primary.btn-animation {
  background-color: #F26430;
  border-color: #F26430 !important;
}
.btn-primary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #F26430;
  background-color: rgba(242, 100, 48, 0.1);
}

.btn-secondary.btn-animation {
  background-color: #208C3B;
  border-color: #208C3B !important;
}
.btn-secondary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #208C3B;
  background-color: rgba(32, 140, 59, 0.1);
}

.btn-success.btn-animation {
  background-color: #0ab39c;
  border-color: #0ab39c !important;
}
.btn-success.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1);
}

.btn-info.btn-animation {
  background-color: #299cdb;
  border-color: #299cdb !important;
}
.btn-info.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
}

.btn-warning.btn-animation {
  background-color: #3FBF48;
  border-color: #3FBF48 !important;
}
.btn-warning.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #3FBF48;
  background-color: rgba(63, 191, 72, 0.1);
}

.btn-danger.btn-animation {
  background-color: #f06548;
  border-color: #f06548 !important;
}
.btn-danger.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
}

.btn-light.btn-animation {
  background-color: #f3f6f9;
  border-color: #f3f6f9 !important;
}
.btn-light.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
}

.btn-dark.btn-animation {
  background-color: #212529;
  border-color: #212529 !important;
}
.btn-dark.btn-animation:is(:hover, :focus, :active, :focus-visible) {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
}

.btn-group-vertical label {
  margin-bottom: 0;
}

.btn-group.radio .btn {
  border: none;
}
.btn-group.radio .btn-check:active + .btn-light,
.btn-group.radio .btn-check:checked + .btn-light,
.btn-group.radio .btn-light.active,
.btn-group.radio .btn-light.dropdown-toggle.show,
.btn-group.radio .btn-light:active {
  background-color: rgba(41, 156, 219, 0.2);
  color: #299cdb;
}

[data-layout-mode=dark] .btn-check:focus + .btn-light,
[data-layout-mode=dark] .btn-check:focus + .btn-outline-light,
[data-layout-mode=dark] .btn-check:focus + .btn-soft-light,
[data-layout-mode=dark] .btn-soft-light:focus {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75);
}
[data-layout-mode=dark] .btn-check:active + .btn-light,
[data-layout-mode=dark] .btn-check:active + .btn-outline-light,
[data-layout-mode=dark] .btn-check:active + .btn-soft-light,
[data-layout-mode=dark] .btn-check:checked + .btn-light,
[data-layout-mode=dark] .btn-check:checked + .btn-outline-light,
[data-layout-mode=dark] .btn-check:checked + .btn-soft-light,
[data-layout-mode=dark] .btn-light.active,
[data-layout-mode=dark] .btn-light:active,
[data-layout-mode=dark] .btn-outline-light.active,
[data-layout-mode=dark] .btn-outline-light:active,
[data-layout-mode=dark] .btn-soft-light.active,
[data-layout-mode=dark] .btn-soft-light:active,
[data-layout-mode=dark] .show > .btn-light.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-outline-light.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-soft-light.dropdown-toggle {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75);
}
[data-layout-mode=dark] .btn-check:focus + .btn-dark,
[data-layout-mode=dark] .btn-check:focus + .btn-outline-dark,
[data-layout-mode=dark] .btn-check:focus + .btn-soft-dark,
[data-layout-mode=dark] .btn-soft-dark:focus {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75);
}
[data-layout-mode=dark] .btn-check:active + .btn-dark,
[data-layout-mode=dark] .btn-check:active + .btn-outline-dark,
[data-layout-mode=dark] .btn-check:active + .btn-soft-dark,
[data-layout-mode=dark] .btn-check:checked + .btn-dark,
[data-layout-mode=dark] .btn-check:checked + .btn-outline-dark,
[data-layout-mode=dark] .btn-check:checked + .btn-soft-dark,
[data-layout-mode=dark] .btn-dark.active,
[data-layout-mode=dark] .btn-dark:active,
[data-layout-mode=dark] .btn-outline-dark.active,
[data-layout-mode=dark] .btn-outline-dark:active,
[data-layout-mode=dark] .btn-soft-dark.active,
[data-layout-mode=dark] .btn-soft-dark:active,
[data-layout-mode=dark] .show > .btn-dark.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-outline-dark.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-soft-dark.dropdown-toggle {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75);
}
[data-layout-mode=dark] .btn-soft-light {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.1);
}
[data-layout-mode=dark] .btn-soft-light:hover {
  color: var(--vz-dark);
  background-color: var(--vz-light);
}
[data-layout-mode=dark] .btn-soft-dark {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.1);
}
[data-layout-mode=dark] .btn-soft-dark:hover {
  color: var(--vz-light);
  background-color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-ghost-light {
  color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-ghost-light:is(:hover, :focus, :active, :focus-visible) {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.5);
}
[data-layout-mode=dark] .btn-ghost-dark {
  color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-ghost-dark:is(:hover, :focus, :active, :focus-visible) {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.1);
}

.btn-load .spinner-border,
.btn-load .spinner-grow {
  height: 19px;
  width: 19px;
}

:is(.btn-primary, .btn-outline-primary, .btn-soft-primary).btn-border {
  border-bottom: 2px solid rgb(234.4745454545, 73.6272727273, 14.7254545455);
}

:is(.btn-secondary, .btn-outline-secondary, .btn-soft-secondary).btn-border {
  border-bottom: 2px solid rgb(24.4093023256, 106.7906976744, 45.0046511628);
}

:is(.btn-success, .btn-outline-success, .btn-soft-success).btn-border {
  border-bottom: 2px solid rgb(7.8412698413, 140.3587301587, 122.3238095238);
}

:is(.btn-info, .btn-outline-info, .btn-soft-info).btn-border {
  border-bottom: 2px solid rgb(31.5648, 132.3968, 187.6352);
}

:is(.btn-warning, .btn-outline-warning, .btn-soft-warning).btn-border {
  border-bottom: 2px solid rgb(52.8803149606, 160.3196850394, 60.4346456693);
}

:is(.btn-danger, .btn-outline-danger, .btn-soft-danger).btn-border {
  border-bottom: 2px solid rgb(236.9090909091, 69.2666666667, 34.2909090909);
}

:is(.btn-light, .btn-outline-light, .btn-soft-light).btn-border {
  border-bottom: 2px solid rgb(215.8, 225.6, 235.4);
}

:is(.btn-dark, .btn-outline-dark, .btn-soft-dark).btn-border {
  border-bottom: 2px solid rgb(14.8054054054, 16.6, 18.3945945946);
}

.custom-toggle .icon-off {
  display: none;
}
.custom-toggle.active .icon-on {
  display: none;
}
.custom-toggle.active .icon-off {
  display: block;
}

.breadcrumb-item > a {
  color: var(--vz-gray-700);
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
  font-size: 15px;
  line-height: 20px;
}

.card {
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}

.card-header {
  border-bottom: 1px solid var(--vz-border-color);
}

.card-header-dropdown .dropdown-btn {
  padding: 1rem 0;
}

.card-footer {
  border-top: 1px solid var(--vz-border-color);
}

.card-drop {
  color: #212529;
}

.card-title {
  font-size: 16px;
  margin: 0 0 7px 0;
}

.card-title-desc {
  margin-bottom: 24px;
}

.card-height-100 {
  height: calc(100% - 1rem);
}

.card-animate {
  transition: all 0.4s;
}
.card-animate:hover {
  transform: translateY(calc(-1rem / 5));
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.card-primary {
  color: #fff;
  background-color: #F26430;
}
.card-primary .card-header, .card-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-primary .card-title {
  color: #fff;
}

.card-secondary {
  color: #fff;
  background-color: #208C3B;
}
.card-secondary .card-header, .card-secondary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-secondary .card-title {
  color: #fff;
}

.card-success {
  color: #fff;
  background-color: #0ab39c;
}
.card-success .card-header, .card-success .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-success .card-title {
  color: #fff;
}

.card-info {
  color: #fff;
  background-color: #299cdb;
}
.card-info .card-header, .card-info .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-info .card-title {
  color: #fff;
}

.card-warning {
  color: #fff;
  background-color: #3FBF48;
}
.card-warning .card-header, .card-warning .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-warning .card-title {
  color: #fff;
}

.card-danger {
  color: #fff;
  background-color: #f06548;
}
.card-danger .card-header, .card-danger .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-danger .card-title {
  color: #fff;
}

.card-light {
  color: #fff;
  background-color: #f3f6f9;
}
.card-light .card-header, .card-light .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-light .card-title {
  color: #fff;
}

.card-dark {
  color: #fff;
  background-color: #212529;
}
.card-dark .card-header, .card-dark .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-dark .card-title {
  color: #fff;
}

.card-border-primary {
  border-color: #F26430 !important;
}
.card-border-primary .card-header, .card-border-primary .card-footer {
  border-color: #F26430;
}

.card-border-secondary {
  border-color: #208C3B !important;
}
.card-border-secondary .card-header, .card-border-secondary .card-footer {
  border-color: #208C3B;
}

.card-border-success {
  border-color: #0ab39c !important;
}
.card-border-success .card-header, .card-border-success .card-footer {
  border-color: #0ab39c;
}

.card-border-info {
  border-color: #299cdb !important;
}
.card-border-info .card-header, .card-border-info .card-footer {
  border-color: #299cdb;
}

.card-border-warning {
  border-color: #3FBF48 !important;
}
.card-border-warning .card-header, .card-border-warning .card-footer {
  border-color: #3FBF48;
}

.card-border-danger {
  border-color: #f06548 !important;
}
.card-border-danger .card-header, .card-border-danger .card-footer {
  border-color: #f06548;
}

.card-border-light {
  border-color: #f3f6f9 !important;
}
.card-border-light .card-header, .card-border-light .card-footer {
  border-color: #f3f6f9;
}

.card-border-dark {
  border-color: #212529 !important;
}
.card-border-dark .card-header, .card-border-dark .card-footer {
  border-color: #212529;
}

.card-light {
  background-color: var(--vz-light);
}
.card-light .card-header, .card-light .card-footer {
  color: var(--vz-body-color) !important;
  background-color: rgba(var(--vz-dark-rgb), 0.1);
}
.card-light .card-title, .card-light .card-text {
  color: var(--vz-body-color) !important;
}

.stretched-link {
  position: static;
}

.card-preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--vz-light-rgb), 0.6);
  z-index: 9999;
}

.card-status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) !important;
}

.custom-loader {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.card-overlay {
  position: relative;
  overflow: hidden;
}
.card-overlay:before {
  content: "";
  background-color: rgba(242, 100, 48, 0.2);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.card-overlay :is(.card-header, .card-footer) {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.card-toolbar-menu {
  line-height: 0.8;
}
.card-toolbar-menu a {
  font-size: 17px;
}
.card-toolbar-menu .minimize-card .plus {
  display: none;
}
.card-toolbar-menu .minimize-card .minus {
  display: block;
}
.card-toolbar-menu .minimize-card.collapsed .plus {
  display: block;
}
.card-toolbar-menu .minimize-card.collapsed .minus {
  display: none;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  font-size: 15px;
  line-height: 15px;
  content: "\\f0140";
  font-family: "Material Design Icons";
}

.dropdown-menu {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.dropdown-megamenu {
  padding: 20px;
  left: 0 !important;
  right: 0 !important;
}
.dropdown-menu[data-popper-placement=top-start] {
  animation-name: DropDownSlideDown;
}

@keyframes DropDownSlide {
  100% {
    margin-top: -1px;
  }
  0% {
    margin-top: 8px;
  }
}
@keyframes DropDownSlideDown {
  100% {
    margin-bottom: 0;
  }
  0% {
    margin-bottom: 8px;
  }
}
@media (min-width: 600px) {
  .dropdown-menu-xl {
    width: 420px;
  }
  .dropdown-menu-lg {
    width: 320px;
  }
  .dropdown-menu-md {
    width: 240px;
  }
}
.dropdown-toggle-split {
  border-left: none;
}
.dropdown-toggle-split::after {
  margin-left: 0px;
}
.dropdown-toggle-split:before {
  content: "";
  position: absolute;
  background-color: rgba(255, 255, 255, 0.12);
  top: -1px;
  bottom: -1px;
  right: -1px;
  left: 0;
  border-radius: 0 0.25rem 0.25rem 0;
}

.dropdown-mega {
  position: static !important;
}

.dropdown-mega-menu-xl {
  width: 38rem;
}

.dropdown-mega-menu-lg {
  width: 26rem;
}

[dir=ltr] .dropdown-menu-start {
  --bs-position: end;
}
[dir=ltr] .dropdown-menu-end {
  --bs-position: start;
}

.dropdown-head .nav-tabs-custom {
  border: 0;
}
.dropdown-head .nav-tabs-custom .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
.dropdown-head .nav-tabs-custom .nav-link.active {
  background-color: var(--vz-dropdown-bg);
}
.dropdown-head .nav-tabs-custom .nav-link:hover {
  color: #fff;
}

.dropdownmenu-primary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(242, 100, 48, 0.07);
  color: #F26430;
}

.dropdownmenu-secondary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(32, 140, 59, 0.07);
  color: #208C3B;
}

.dropdownmenu-success .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(10, 179, 156, 0.07);
  color: #0ab39c;
}

.dropdownmenu-info .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(41, 156, 219, 0.07);
  color: #299cdb;
}

.dropdownmenu-warning .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(63, 191, 72, 0.07);
  color: #3FBF48;
}

.dropdownmenu-danger .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(240, 101, 72, 0.07);
  color: #f06548;
}

.dropdownmenu-light .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(243, 246, 249, 0.07);
  color: #f3f6f9;
}

.dropdownmenu-dark .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(33, 37, 41, 0.07);
  color: #212529;
}

:is(.nav-tabs, .nav-pills) > li > a {
  color: var(--vz-gray-700);
  font-weight: 500;
}

.nav-pills > a {
  color: var(--vz-gray-700);
  font-weight: 500;
}

.nav-pills :is(.nav-link.active, .show > .nav-link) {
  box-shadow: none;
}

.nav-tabs-custom {
  border-bottom: 1px solid var(--vz-gray-300);
}
.nav-tabs-custom .nav-item {
  position: relative;
}
.nav-tabs-custom .nav-item .nav-link {
  border: none;
  font-weight: 500;
}
.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: #F26430;
  height: 1px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
.nav-tabs-custom .nav-item .nav-link.active {
  color: #F26430;
}
.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}
.nav-tabs-custom.card-header-tabs {
  margin-top: -1rem;
}
.nav-tabs-custom.card-header-tabs .nav-link {
  padding: 1rem 1rem;
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}
.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.navtab-bg li > a {
  background-color: #e9ebec;
  margin: 0 5px;
}

.arrow-navtabs .nav-item .nav-link {
  position: relative;
  text-align: center;
}
.arrow-navtabs .nav-item .nav-link:before {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .arrow-navtabs .nav-item .nav-link:before {
    transition: none;
  }
}
.arrow-navtabs .nav-item .nav-link.active:before {
  border-top-color: #F26430;
}

.custom-hover-nav-tabs .nav-item {
  text-align: center;
  overflow: hidden;
}
.custom-hover-nav-tabs .nav-item .nav-link {
  width: 120px;
  height: 45px;
  position: relative;
  border-radius: 0px;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-icon {
  font-size: 22px;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-titl {
  font-size: 14px;
}
.custom-hover-nav-tabs .nav-item .nav-link.active .nav-tab-position {
  color: #fff;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position {
  position: absolute;
  left: 0;
  right: 0;
  transition: all 0.4s;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-icon {
  top: 50%;
  transform: translateY(-50%);
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-titl {
  bottom: -20px;
}
.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-titl {
  bottom: 50%;
  transform: translateY(50%);
}
.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-icon {
  top: -20px;
}

.custom-verti-nav-pills .nav-link {
  background-color: var(--vz-light);
  margin-top: 7px;
  position: relative;
}
@media (min-width: 992px) {
  .custom-verti-nav-pills .nav-link::before {
    content: "";
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    border: 12px solid transparent;
    border-left-color: transparent;
    transition: border-left-color 0.04 ease;
  }
  .custom-verti-nav-pills .nav-link.active::before {
    border-left-color: #F26430;
  }
}

.animation-nav li {
  position: relative;
}
.animation-nav li a {
  color: var(--vz-body-color);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s;
  z-index: 1;
}
.animation-nav li a span {
  position: relative;
}
.animation-nav li a::before {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  right: 0;
  height: 100%;
  transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;
  background-color: #F26430;
  z-index: -1;
}
.animation-nav li a:hover, .animation-nav li a.active {
  color: #fff;
  background-color: transparent !important;
}
.animation-nav li a:hover::before, .animation-nav li a.active::before {
  width: 100%;
  left: 0;
}

.nav-border-top .nav-link {
  border-top: 3px solid transparent;
}
.nav-border-top .nav-link.active {
  border-top-color: #F26430;
}

.nav-border-top-primary .nav-link.active {
  color: #F26430;
  border-top-color: #F26430;
}

.nav-border-top-secondary .nav-link.active {
  color: #208C3B;
  border-top-color: #208C3B;
}

.nav-border-top-success .nav-link.active {
  color: #0ab39c;
  border-top-color: #0ab39c;
}

.nav-border-top-info .nav-link.active {
  color: #299cdb;
  border-top-color: #299cdb;
}

.nav-border-top-warning .nav-link.active {
  color: #3FBF48;
  border-top-color: #3FBF48;
}

.nav-border-top-danger .nav-link.active {
  color: #f06548;
  border-top-color: #f06548;
}

.nav-border-top-light .nav-link.active {
  color: #f3f6f9;
  border-top-color: #f3f6f9;
}

.nav-border-top-dark .nav-link.active {
  color: #212529;
  border-top-color: #212529;
}

.nav-custom {
  background-color: #F26430;
  border-radius: 0.25rem;
}
.nav-custom .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.75);
}
.nav-custom .nav-item .nav-link.active {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-custom.nav-custom-light .nav-item .nav-link {
  color: rgba(var(--vz-dark-rgb), 0.75);
}
.nav-custom.nav-custom-light .nav-item .nav-link.active {
  color: #f3f6f9;
  background-color: #F26430;
}

.nav-custom-primary {
  background-color: #F26430;
}

.nav-custom-secondary {
  background-color: #208C3B;
}

.nav-custom-success {
  background-color: #0ab39c;
}

.nav-custom-info {
  background-color: #299cdb;
}

.nav-custom-warning {
  background-color: #3FBF48;
}

.nav-custom-danger {
  background-color: #f06548;
}

.nav-custom-light {
  background-color: #f3f6f9;
}

.nav-custom-dark {
  background-color: #212529;
}

.nav-custom-light {
  background-color: var(--vz-light);
}

.nav-primary .nav-link.active {
  color: #fff;
  background-color: #F26430;
}
.nav-primary.nav-tabs .nav-link.active {
  color: #F26430;
  background-color: var(--vz-card-bg-custom);
}
.nav-primary.nav-tabs-custom .nav-link.active {
  color: #F26430;
  background-color: var(--vz-card-bg-custom);
}
.nav-primary.nav-tabs-custom .nav-link.active::after {
  background-color: #F26430;
}
.nav-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #F26430;
}
.nav-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #F26430;
}

.nav-secondary .nav-link.active {
  color: #fff;
  background-color: #208C3B;
}
.nav-secondary.nav-tabs .nav-link.active {
  color: #208C3B;
  background-color: var(--vz-card-bg-custom);
}
.nav-secondary.nav-tabs-custom .nav-link.active {
  color: #208C3B;
  background-color: var(--vz-card-bg-custom);
}
.nav-secondary.nav-tabs-custom .nav-link.active::after {
  background-color: #208C3B;
}
.nav-secondary.arrow-navtabs .nav-link.active::before {
  border-top-color: #208C3B;
}
.nav-secondary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #208C3B;
}

.nav-success .nav-link.active {
  color: #fff;
  background-color: #0ab39c;
}
.nav-success.nav-tabs .nav-link.active {
  color: #0ab39c;
  background-color: var(--vz-card-bg-custom);
}
.nav-success.nav-tabs-custom .nav-link.active {
  color: #0ab39c;
  background-color: var(--vz-card-bg-custom);
}
.nav-success.nav-tabs-custom .nav-link.active::after {
  background-color: #0ab39c;
}
.nav-success.arrow-navtabs .nav-link.active::before {
  border-top-color: #0ab39c;
}
.nav-success.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #0ab39c;
}

.nav-info .nav-link.active {
  color: #fff;
  background-color: #299cdb;
}
.nav-info.nav-tabs .nav-link.active {
  color: #299cdb;
  background-color: var(--vz-card-bg-custom);
}
.nav-info.nav-tabs-custom .nav-link.active {
  color: #299cdb;
  background-color: var(--vz-card-bg-custom);
}
.nav-info.nav-tabs-custom .nav-link.active::after {
  background-color: #299cdb;
}
.nav-info.arrow-navtabs .nav-link.active::before {
  border-top-color: #299cdb;
}
.nav-info.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #299cdb;
}

.nav-warning .nav-link.active {
  color: #fff;
  background-color: #3FBF48;
}
.nav-warning.nav-tabs .nav-link.active {
  color: #3FBF48;
  background-color: var(--vz-card-bg-custom);
}
.nav-warning.nav-tabs-custom .nav-link.active {
  color: #3FBF48;
  background-color: var(--vz-card-bg-custom);
}
.nav-warning.nav-tabs-custom .nav-link.active::after {
  background-color: #3FBF48;
}
.nav-warning.arrow-navtabs .nav-link.active::before {
  border-top-color: #3FBF48;
}
.nav-warning.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #3FBF48;
}

.nav-danger .nav-link.active {
  color: #fff;
  background-color: #f06548;
}
.nav-danger.nav-tabs .nav-link.active {
  color: #f06548;
  background-color: var(--vz-card-bg-custom);
}
.nav-danger.nav-tabs-custom .nav-link.active {
  color: #f06548;
  background-color: var(--vz-card-bg-custom);
}
.nav-danger.nav-tabs-custom .nav-link.active::after {
  background-color: #f06548;
}
.nav-danger.arrow-navtabs .nav-link.active::before {
  border-top-color: #f06548;
}
.nav-danger.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f06548;
}

.nav-light .nav-link.active {
  color: #fff;
  background-color: #f3f6f9;
}
.nav-light.nav-tabs .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg-custom);
}
.nav-light.nav-tabs-custom .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg-custom);
}
.nav-light.nav-tabs-custom .nav-link.active::after {
  background-color: #f3f6f9;
}
.nav-light.arrow-navtabs .nav-link.active::before {
  border-top-color: #f3f6f9;
}
.nav-light.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f3f6f9;
}

.nav-dark .nav-link.active {
  color: #fff;
  background-color: #212529;
}
.nav-dark.nav-tabs .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg-custom);
}
.nav-dark.nav-tabs-custom .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg-custom);
}
.nav-dark.nav-tabs-custom .nav-link.active::after {
  background-color: #212529;
}
.nav-dark.arrow-navtabs .nav-link.active::before {
  border-top-color: #212529;
}
.nav-dark.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #212529;
}

.progress-nav {
  position: relative;
  margin-right: 1rem;
  margin-left: 1rem;
}
.progress-nav .progress {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.progress-nav .nav {
  margin-right: -1rem;
  margin-left: -1rem;
  justify-content: space-between;
}
.progress-nav .nav .nav-link {
  width: 2rem;
  height: 2rem;
  background-color: var(--vz-light);
  padding: 0;
  color: var(--vz-dark);
  font-weight: 500;
}
.progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
  background-color: #F26430;
  color: #fff;
}

.step-arrow-nav .nav {
  background-color: var(--vz-light);
}
.step-arrow-nav .nav .nav-link {
  border-radius: 0;
  position: relative;
  font-weight: 500;
  color: var(--vz-dark);
}
.step-arrow-nav .nav .nav-link::before {
  content: "";
  position: absolute;
  border: 7px solid transparent;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
}
.step-arrow-nav .nav .nav-link.done {
  background-color: rgba(242, 100, 48, 0.05);
  color: #F26430;
}
.step-arrow-nav .nav .nav-link.done::before {
  border-left-color: transparent;
}
.step-arrow-nav .nav .nav-link.active {
  background-color: rgba(242, 100, 48, 0.1);
  color: #F26430;
  box-shadow: none;
}
.step-arrow-nav .nav .nav-link.active::before {
  border-left-color: rgba(242, 100, 48, 0.1);
}
.step-arrow-nav .nav .nav-item:last-child .nav-link:before {
  display: none;
}

.vertical-navs-step .nav {
  gap: 16px;
}
.vertical-navs-step .nav .nav-link {
  text-align: left;
  background-color: rgba(var(--vz-light-rgb), 0.4);
  border: 1px solid var(--vz-border-color);
  color: var(--vz-dark);
}
.vertical-navs-step .nav .nav-link .step-title {
  font-weight: 600;
}
.vertical-navs-step .nav .nav-link .step-icon {
  color: #f06548;
  vertical-align: middle;
  font-weight: 500;
  float: left;
}
.vertical-navs-step .nav .nav-link.active .step-icon, .vertical-navs-step .nav .nav-link.done .step-icon {
  color: #0ab39c;
}
.vertical-navs-step .nav .nav-link.active .step-icon:before, .vertical-navs-step .nav .nav-link.done .step-icon:before {
  content: "\\eb80";
}
.vertical-navs-step .nav .nav-link.active {
  border-color: #F26430;
}
.vertical-navs-step .nav .nav-link.done {
  border-color: #0ab39c;
}

.nav-custom-outline.nav .nav-link {
  border: 1px solid transparent;
  border-bottom: 2px solid transparent;
}
.nav-custom-outline.nav .nav-link.active {
  border-color: #F26430;
  background-color: transparent;
  color: #F26430;
}

.nav-primary.nav-custom-outline .nav-link.active {
  color: #F26430;
  border-color: #F26430;
}

.nav-secondary.nav-custom-outline .nav-link.active {
  color: #208C3B;
  border-color: #208C3B;
}

.nav-success.nav-custom-outline .nav-link.active {
  color: #0ab39c;
  border-color: #0ab39c;
}

.nav-info.nav-custom-outline .nav-link.active {
  color: #299cdb;
  border-color: #299cdb;
}

.nav-warning.nav-custom-outline .nav-link.active {
  color: #3FBF48;
  border-color: #3FBF48;
}

.nav-danger.nav-custom-outline .nav-link.active {
  color: #f06548;
  border-color: #f06548;
}

.nav-light.nav-custom-outline .nav-link.active {
  color: #f3f6f9;
  border-color: #f3f6f9;
}

.nav-dark.nav-custom-outline .nav-link.active {
  color: #212529;
  border-color: #212529;
}

.nav-customs.nav {
  padding-left: 34px;
  overflow: hidden;
}
.nav-customs.nav .nav-link {
  position: relative;
  display: block;
  float: right;
  background-color: var(--vz-body-bg);
  margin-right: 46px;
  transition: all 0.5s ease;
}
.nav-customs.nav .nav-link::before, .nav-customs.nav .nav-link::after {
  display: block;
  content: " ";
  position: absolute;
  top: -1px;
  bottom: -1px;
  width: 37px;
  background-color: var(--vz-body-bg);
  transition: all 0.5s ease;
}
.nav-customs.nav .nav-link::before {
  border-radius: 0 8px 0 0;
  right: -24px;
  transform: skew(30deg, 0deg);
}
.nav-customs.nav .nav-link::after {
  border-radius: 8px 0 0 0;
  left: -24px;
  transform: skew(-30deg, 0deg);
}
.nav-customs.nav .nav-link.active, .nav-customs.nav .nav-link.active:before, .nav-customs.nav .nav-link.active:after {
  background-color: #F26430;
  color: #fff;
}
.nav-customs.nav .nav-link.active {
  z-index: 1;
}

.table th {
  font-weight: 600;
}
.table > thead {
  border-color: var(--vz-border-color);
}
.table > :not(:first-child) {
  border-top-width: 1px;
}

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap;
}

.table-card {
  margin: -1rem -1rem;
}
.table-card th:first-child,
.table-card td:first-child {
  padding-left: 16px;
}
.table-card th:last-child,
.table-card td:last-child {
  padding-right: 16px;
}
.table-card .table > :not(:first-child) {
  border-top-width: 1px;
}

.border-primary.table > thead {
  border-color: #F26430 !important;
}

.table-primary.table > thead {
  border-bottom-color: rgb(245.0136363636, 135.9318181818, 95.9863636364) !important;
}

.border-secondary.table > thead {
  border-color: #208C3B !important;
}

.table-secondary.table > thead {
  border-bottom-color: rgb(41.488372093, 181.511627907, 76.4941860465) !important;
}

.border-success.table > thead {
  border-color: #0ab39c !important;
}

.table-success.table > thead {
  border-bottom-color: rgb(12.6984126984, 227.3015873016, 198.0952380952) !important;
}

.border-info.table > thead {
  border-color: #299cdb !important;
}

.table-info.table > thead {
  border-bottom-color: rgb(84.656, 176.196, 226.344) !important;
}

.border-warning.table > thead {
  border-color: #3FBF48 !important;
}

.table-warning.table > thead {
  border-bottom-color: rgb(100.8464566929, 204.1535433071, 108.1102362205) !important;
}

.border-danger.table > thead {
  border-color: #f06548 !important;
}

.table-danger.table > thead {
  border-bottom-color: rgb(243.8636363636, 140.6666666667, 119.1363636364) !important;
}

.border-light.table > thead {
  border-color: #f3f6f9 !important;
}

.table-light.table > thead {
  border-bottom-color: white !important;
}

.border-dark.table > thead {
  border-color: #212529 !important;
}

.table-dark.table > thead {
  border-bottom-color: rgb(55.7432432432, 62.5, 69.2567567568) !important;
}

.table .form-check {
  padding-left: 0px;
  margin-bottom: 0px;
}
.table .form-check .form-check-input {
  margin-left: 0px;
  margin-top: 0px;
  float: none;
  vertical-align: middle;
}
.table .sort {
  position: relative;
}
.table .sort::before {
  content: "\\f035d";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}
.table .sort::after {
  position: absolute;
  right: 0.5rem;
  content: "\\f0360";
  font-family: "Material Design Icons";
  font-size: 0.8rem;
  top: 12px;
}

[data-layout-mode=dark] .table-light {
  background-color: var(--vz-light);
  color: var(--vz-body-color);
}
[data-layout-mode=dark] .table-light th, [data-layout-mode=dark] .table-light td {
  background-color: var(--vz-light);
}

.rdt_Table.eSTlnH {
  background-color: var(--vz-card-bg) !important;
  color: var(--vz-body-color);
}
.rdt_Table .gZWIKX,
.rdt_Table .jVeafb {
  color: var(--vz-body-color);
  background-color: var(--vz-card-bg);
}
.rdt_Table .jVeafb:not(:last-of-type),
.rdt_Table .gZWIKX {
  border-bottom-color: var(--vz-border-color);
}

.rdt_Pagination.jxflYm {
  background-color: var(--vz-card-bg);
  color: var(--vz-body-color);
  border-top-color: var(--vz-border-color);
}
.rdt_Pagination .bvxQGL {
  fill: var(--vz-dark);
}
.rdt_Pagination .bvxQGL:disabled {
  fill: rgba(var(--vz-dark-rgb), 0.25);
}

.modal-title {
  font-weight: 600;
}

.modal-dialog:not(.modal-dialog-scrollable) .modal-header {
  padding-bottom: 0;
}
.modal-dialog:not(.modal-dialog-scrollable) .modal-header .btn-close {
  margin-top: -1.25rem 1.25rem;
}
.modal-dialog:not(.modal-dialog-scrollable) .modal-footer {
  padding-top: 0;
}

.modal.fadeInRight .modal-dialog {
  opacity: 0;
  transform: translateX(20%);
  transition: all 0.3s ease-in-out;
}
.modal.fadeInRight.show .modal-dialog {
  opacity: 1;
  transform: translateX(0);
}
.modal.fadeInLeft .modal-dialog {
  animation: fadeInLeft 0.3s ease-in-out;
  transform: translate(-50%, 0);
}
.modal.fadeInLeft.show .modal-dialog {
  transform: none;
}
.modal.fadeInUp .modal-dialog {
  animation: fadeInUp 0.3s ease-in-out;
  transform: translate(0, 30%);
}
.modal.fadeInUp.show .modal-dialog {
  transform: none;
}
.modal.flip {
  perspective: 1300px;
}
.modal.flip .modal-dialog {
  opacity: 0;
  transform: rotateY(-70deg);
  transition: all 0.3s;
}
.modal.flip.show .modal-dialog {
  opacity: 1;
  transform: rotateY(0deg);
}
.modal.zoomIn .modal-dialog {
  opacity: 0;
  transform: scale(0.7);
  transition: all 0.3s ease;
}
.modal.zoomIn.show .modal-dialog {
  opacity: 1;
  transform: scale(1);
}

.modal-dialog-right {
  margin-right: 1.75rem;
}

.modal-dialog-bottom {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
}
@media (min-width: 576px) {
  .modal-dialog-bottom {
    min-height: calc(100% - 3.5rem);
  }
}

.modal-dialog-bottom-right {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
  margin-right: 1.75rem;
}
@media (min-width: 576px) {
  .modal-dialog-bottom-right {
    min-height: calc(100% - 3.5rem);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 30%, 0);
  }
  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.login-modal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-size: cover;
  background-position: center;
}

.pagination-separated .page-item .page-link {
  margin-left: 0.35rem;
  border-radius: 0.25rem;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  min-width: 32px;
  min-height: 32px;
  text-align: center;
}
.pagination-rounded.pagination-sm .page-link {
  min-width: 25px;
  min-height: 25px;
}

.page-item.active .page-link {
  box-shadow: none;
}

.progress-sm {
  height: 5px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

.custom-progess {
  position: relative;
}
.custom-progess .progress-icon {
  position: absolute;
  top: -12px;
}
.custom-progess .progress-icon .avatar-title {
  background: var(--vz-card-bg-custom);
}

.animated-progress {
  position: relative;
}
.animated-progress .progress-bar {
  position: relative;
  border-radius: 6px;
  animation: animate-positive 2s;
}

@keyframes animate-positive {
  0% {
    width: 0;
  }
}
.custom-progress {
  height: 15px;
  padding: 4px;
  border-radius: 30px;
}
.custom-progress .progress-bar {
  position: relative;
  border-radius: 30px;
}
.custom-progress .progress-bar::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background-color: #fff;
  border-radius: 7px;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
}

.progress-label {
  overflow: visible;
}
.progress-label .progress-bar {
  position: relative;
  overflow: visible;
}
.progress-label .progress-bar .label {
  position: absolute;
  top: -25px;
  right: -9px;
  background-color: #F26430;
  color: #fff;
  display: inline-block;
  line-height: 18px;
  padding: 0 4px;
  border-radius: 4px;
}
.progress-label .progress-bar .label:after {
  content: "";
  position: absolute;
  border: 4px solid transparent;
  border-top-color: #F26430;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
}

.progress-step-arrow {
  height: 3.25rem;
}
.progress-step-arrow .progress-bar {
  position: relative;
  overflow: initial;
  font-size: 0.875rem;
  color: #fff;
}
.progress-step-arrow .progress-bar::after {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  bottom: 15px;
  right: -20px;
  z-index: 1;
}

.progress-primary .progress-bar {
  background-color: #F26430;
}
.progress-primary .progress-bar::after {
  border-left-color: #F26430;
}
.progress-primary .progress-bar:nth-child(2) {
  background-color: rgba(242, 100, 48, 0.1) !important;
  color: #F26430 !important;
}
.progress-primary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(242, 100, 48, 0.1);
}

.progress-secondary .progress-bar {
  background-color: #208C3B;
}
.progress-secondary .progress-bar::after {
  border-left-color: #208C3B;
}
.progress-secondary .progress-bar:nth-child(2) {
  background-color: rgba(32, 140, 59, 0.1) !important;
  color: #208C3B !important;
}
.progress-secondary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(32, 140, 59, 0.1);
}

.progress-success .progress-bar {
  background-color: #0ab39c;
}
.progress-success .progress-bar::after {
  border-left-color: #0ab39c;
}
.progress-success .progress-bar:nth-child(2) {
  background-color: rgba(10, 179, 156, 0.1) !important;
  color: #0ab39c !important;
}
.progress-success .progress-bar:nth-child(2)::after {
  border-left-color: rgba(10, 179, 156, 0.1);
}

.progress-info .progress-bar {
  background-color: #299cdb;
}
.progress-info .progress-bar::after {
  border-left-color: #299cdb;
}
.progress-info .progress-bar:nth-child(2) {
  background-color: rgba(41, 156, 219, 0.1) !important;
  color: #299cdb !important;
}
.progress-info .progress-bar:nth-child(2)::after {
  border-left-color: rgba(41, 156, 219, 0.1);
}

.progress-warning .progress-bar {
  background-color: #3FBF48;
}
.progress-warning .progress-bar::after {
  border-left-color: #3FBF48;
}
.progress-warning .progress-bar:nth-child(2) {
  background-color: rgba(63, 191, 72, 0.1) !important;
  color: #3FBF48 !important;
}
.progress-warning .progress-bar:nth-child(2)::after {
  border-left-color: rgba(63, 191, 72, 0.1);
}

.progress-danger .progress-bar {
  background-color: #f06548;
}
.progress-danger .progress-bar::after {
  border-left-color: #f06548;
}
.progress-danger .progress-bar:nth-child(2) {
  background-color: rgba(240, 101, 72, 0.1) !important;
  color: #f06548 !important;
}
.progress-danger .progress-bar:nth-child(2)::after {
  border-left-color: rgba(240, 101, 72, 0.1);
}

.progress-light .progress-bar {
  background-color: #f3f6f9;
}
.progress-light .progress-bar::after {
  border-left-color: #f3f6f9;
}
.progress-light .progress-bar:nth-child(2) {
  background-color: rgba(243, 246, 249, 0.1) !important;
  color: #f3f6f9 !important;
}
.progress-light .progress-bar:nth-child(2)::after {
  border-left-color: rgba(243, 246, 249, 0.1);
}

.progress-dark .progress-bar {
  background-color: #212529;
}
.progress-dark .progress-bar::after {
  border-left-color: #212529;
}
.progress-dark .progress-bar:nth-child(2) {
  background-color: rgba(33, 37, 41, 0.1) !important;
  color: #212529 !important;
}
.progress-dark .progress-bar:nth-child(2)::after {
  border-left-color: rgba(33, 37, 41, 0.1);
}

.popover {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.text-white-75 {
  color: rgba(255, 255, 255, 0.75) !important;
}

.custom-blockquote.blockquote {
  padding: 16px;
  border-left: 3px solid;
}
.custom-blockquote.blockquote.blockquote-outline {
  background-color: var(--vz-card-bg-custom) !important;
  border: 1px solid;
  border-left: 3px solid;
}

.custom-blockquote.blockquote.blockquote-primary {
  color: #F26430;
  border-color: #F26430;
  background-color: rgba(242, 100, 48, 0.15);
}
.custom-blockquote.blockquote.blockquote-primary .blockquote-footer {
  color: #F26430;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-primary {
  border-color: #F26430;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-primary .blockquote-footer {
  color: #F26430;
}

.custom-blockquote.blockquote.blockquote-secondary {
  color: #208C3B;
  border-color: #208C3B;
  background-color: rgba(32, 140, 59, 0.15);
}
.custom-blockquote.blockquote.blockquote-secondary .blockquote-footer {
  color: #208C3B;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary {
  border-color: #208C3B;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary .blockquote-footer {
  color: #208C3B;
}

.custom-blockquote.blockquote.blockquote-success {
  color: #0ab39c;
  border-color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.15);
}
.custom-blockquote.blockquote.blockquote-success .blockquote-footer {
  color: #0ab39c;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-success {
  border-color: #0ab39c;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-success .blockquote-footer {
  color: #0ab39c;
}

.custom-blockquote.blockquote.blockquote-info {
  color: #299cdb;
  border-color: #299cdb;
  background-color: rgba(41, 156, 219, 0.15);
}
.custom-blockquote.blockquote.blockquote-info .blockquote-footer {
  color: #299cdb;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-info {
  border-color: #299cdb;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-info .blockquote-footer {
  color: #299cdb;
}

.custom-blockquote.blockquote.blockquote-warning {
  color: #3FBF48;
  border-color: #3FBF48;
  background-color: rgba(63, 191, 72, 0.15);
}
.custom-blockquote.blockquote.blockquote-warning .blockquote-footer {
  color: #3FBF48;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-warning {
  border-color: #3FBF48;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-warning .blockquote-footer {
  color: #3FBF48;
}

.custom-blockquote.blockquote.blockquote-danger {
  color: #f06548;
  border-color: #f06548;
  background-color: rgba(240, 101, 72, 0.15);
}
.custom-blockquote.blockquote.blockquote-danger .blockquote-footer {
  color: #f06548;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-danger {
  border-color: #f06548;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-danger .blockquote-footer {
  color: #f06548;
}

.custom-blockquote.blockquote.blockquote-light {
  color: #f3f6f9;
  border-color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.15);
}
.custom-blockquote.blockquote.blockquote-light .blockquote-footer {
  color: #f3f6f9;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light {
  border-color: #f3f6f9;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light .blockquote-footer {
  color: #f3f6f9;
}

.custom-blockquote.blockquote.blockquote-dark {
  color: #212529;
  border-color: #212529;
  background-color: rgba(33, 37, 41, 0.15);
}
.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
  color: #212529;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: #212529;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
  color: #212529;
}

.custom-blockquote.blockquote.blockquote-dark {
  color: var(--vz-dark);
  border-color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.15);
}
.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
  color: var(--vz-dark);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: var(--vz-dark);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
  color: var(--vz-dark);
}

.form-check {
  position: relative;
  text-align: left;
}
.form-check .form-check-input {
  cursor: pointer;
}
.form-check label {
  cursor: pointer;
}

.form-check-primary .form-check-input:checked {
  background-color: #F26430;
  border-color: #F26430;
}

.form-radio-primary .form-check-input:checked {
  border-color: #F26430;
  background-color: #F26430;
}
.form-radio-primary .form-check-input:checked:after {
  background-color: #F26430;
}

.form-check-secondary .form-check-input:checked {
  background-color: #208C3B;
  border-color: #208C3B;
}

.form-radio-secondary .form-check-input:checked {
  border-color: #208C3B;
  background-color: #208C3B;
}
.form-radio-secondary .form-check-input:checked:after {
  background-color: #208C3B;
}

.form-check-success .form-check-input:checked {
  background-color: #0ab39c;
  border-color: #0ab39c;
}

.form-radio-success .form-check-input:checked {
  border-color: #0ab39c;
  background-color: #0ab39c;
}
.form-radio-success .form-check-input:checked:after {
  background-color: #0ab39c;
}

.form-check-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb;
}

.form-radio-info .form-check-input:checked {
  border-color: #299cdb;
  background-color: #299cdb;
}
.form-radio-info .form-check-input:checked:after {
  background-color: #299cdb;
}

.form-check-warning .form-check-input:checked {
  background-color: #3FBF48;
  border-color: #3FBF48;
}

.form-radio-warning .form-check-input:checked {
  border-color: #3FBF48;
  background-color: #3FBF48;
}
.form-radio-warning .form-check-input:checked:after {
  background-color: #3FBF48;
}

.form-check-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548;
}

.form-radio-danger .form-check-input:checked {
  border-color: #f06548;
  background-color: #f06548;
}
.form-radio-danger .form-check-input:checked:after {
  background-color: #f06548;
}

.form-check-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-radio-light .form-check-input:checked {
  border-color: #f3f6f9;
  background-color: #f3f6f9;
}
.form-radio-light .form-check-input:checked:after {
  background-color: #f3f6f9;
}

.form-check-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529;
}

.form-radio-dark .form-check-input:checked {
  border-color: #212529;
  background-color: #212529;
}
.form-radio-dark .form-check-input:checked:after {
  background-color: #212529;
}

.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

.form-check-right {
  padding-left: 0;
  display: inline-block;
}
.form-check-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.6em;
}
.form-check-right .form-check-label {
  display: block;
}
.form-check-right.form-switch .form-check-input {
  margin-right: -2.56em;
}

.form-check-outline.form-check-primary .form-check-input:checked[type=checkbox] {
  color: #F26430;
  background-color: transparent;
  border-color: #F26430;
}

.form-check-outline.form-check-secondary .form-check-input:checked[type=checkbox] {
  color: #208C3B;
  background-color: transparent;
  border-color: #208C3B;
}

.form-check-outline.form-check-success .form-check-input:checked[type=checkbox] {
  color: #0ab39c;
  background-color: transparent;
  border-color: #0ab39c;
}

.form-check-outline.form-check-info .form-check-input:checked[type=checkbox] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb;
}

.form-check-outline.form-check-warning .form-check-input:checked[type=checkbox] {
  color: #3FBF48;
  background-color: transparent;
  border-color: #3FBF48;
}

.form-check-outline.form-check-danger .form-check-input:checked[type=checkbox] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548;
}

.form-check-outline.form-check-light .form-check-input:checked[type=checkbox] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-check-outline.form-check-dark .form-check-input:checked[type=checkbox] {
  color: #212529;
  background-color: transparent;
  border-color: #212529;
}

.form-check-outline .form-check-input {
  position: relative;
}
.form-check-outline .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.form-check-outline .form-check-input:checked[type=checkbox]::before {
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: -2px;
  position: absolute;
  font-weight: 700;
  font-size: 11px;
  left: 1px;
}

.form-radio-outline.form-radio-primary .form-check-input:checked[type=radio] {
  color: #F26430;
  background-color: transparent;
  border-color: #F26430;
}

.form-radio-outline.form-radio-secondary .form-check-input:checked[type=radio] {
  color: #208C3B;
  background-color: transparent;
  border-color: #208C3B;
}

.form-radio-outline.form-radio-success .form-check-input:checked[type=radio] {
  color: #0ab39c;
  background-color: transparent;
  border-color: #0ab39c;
}

.form-radio-outline.form-radio-info .form-check-input:checked[type=radio] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb;
}

.form-radio-outline.form-radio-warning .form-check-input:checked[type=radio] {
  color: #3FBF48;
  background-color: transparent;
  border-color: #3FBF48;
}

.form-radio-outline.form-radio-danger .form-check-input:checked[type=radio] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548;
}

.form-radio-outline.form-radio-light .form-check-input:checked[type=radio] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-radio-outline.form-radio-dark .form-check-input:checked[type=radio] {
  color: #212529;
  background-color: transparent;
  border-color: #212529;
}

.form-radio-outline .form-check-input {
  position: relative;
}
.form-radio-outline .form-check-input:checked[type=radio] {
  background-image: none;
}
.form-radio-outline .form-check-input:checked[type=radio]::before {
  content: "\\f0765";
  font-family: "Material Design Icons";
  top: 0px;
  position: absolute;
  font-size: 8px;
  left: 2.2px;
}

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 22px;
  line-height: 22px;
}
.form-switch-md .form-check-input {
  width: 40px;
  height: 20px;
  left: -0.5rem;
  position: relative;
}
.form-switch-md .form-check-label {
  vertical-align: middle;
}

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px;
}
.form-switch-lg .form-check-input {
  width: 48px;
  height: 24px;
  left: -0.75rem;
  position: relative;
}

.input-group-text {
  margin-bottom: 0px;
}

.form-switch-primary .form-check-input:checked {
  background-color: #F26430;
  border-color: #F26430;
}

.form-switch-custom.form-switch-primary .form-check-input:checked::before {
  color: #F26430;
}

.form-switch-secondary .form-check-input:checked {
  background-color: #208C3B;
  border-color: #208C3B;
}

.form-switch-custom.form-switch-secondary .form-check-input:checked::before {
  color: #208C3B;
}

.form-switch-success .form-check-input:checked {
  background-color: #0ab39c;
  border-color: #0ab39c;
}

.form-switch-custom.form-switch-success .form-check-input:checked::before {
  color: #0ab39c;
}

.form-switch-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb;
}

.form-switch-custom.form-switch-info .form-check-input:checked::before {
  color: #299cdb;
}

.form-switch-warning .form-check-input:checked {
  background-color: #3FBF48;
  border-color: #3FBF48;
}

.form-switch-custom.form-switch-warning .form-check-input:checked::before {
  color: #3FBF48;
}

.form-switch-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548;
}

.form-switch-custom.form-switch-danger .form-check-input:checked::before {
  color: #f06548;
}

.form-switch-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-switch-custom.form-switch-light .form-check-input:checked::before {
  color: #f3f6f9;
}

.form-switch-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529;
}

.form-switch-custom.form-switch-dark .form-check-input:checked::before {
  color: #212529;
}

.form-switch-custom .form-check-input {
  position: relative;
  background-image: none;
}
.form-switch-custom .form-check-input::before {
  content: "\\f0765";
  font-family: "Material Design Icons";
  top: -9px;
  position: absolute;
  font-size: 20px;
  left: -3px;
  color: #878a99;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input::before {
    transition: none;
  }
}
.form-switch-custom .form-check-input:checked {
  background-image: none;
  background-color: var(--vz-input-bg);
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input:checked {
    transition: none;
  }
}
.form-switch-custom .form-check-input:checked::before {
  right: -3px;
  left: auto;
}
.form-switch-custom .form-check-input:focus {
  background-image: none;
}

.form-switch-right {
  display: inline-block;
  padding-right: 0.8em;
  margin-bottom: 0;
  padding-left: 0 !important;
}
.form-switch-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.6em;
  margin-top: 0.1em !important;
}
.form-switch-right label {
  margin-bottom: 0;
  margin-right: 1rem;
}

.card-radio {
  padding: 0;
}
.card-radio .form-check-label {
  background-color: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-input-check-border);
  border-radius: 0.25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding-right: 32px;
}
.card-radio .form-check-label:hover {
  cursor: pointer;
}
.card-radio .form-check-input {
  display: none;
}
.card-radio .form-check-input:checked + .form-check-label {
  border-color: #F26430 !important;
}
.card-radio .form-check-input:checked + .form-check-label:before {
  content: "\\eb80";
  font-family: "remixicon";
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #F26430;
}
.card-radio.dark .form-check-input:checked + .form-check-label:before {
  color: #fff;
}

[data-layout-mode=dark] .form-switch .form-check-input, [data-layout-mode=dark] .form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}

.form-icon {
  position: relative;
}
.form-icon .form-control-icon {
  padding-left: 2.7rem;
  position: relative;
}
.form-icon i {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 18px;
  display: flex;
  align-items: center;
}
.form-icon.right .form-control-icon {
  padding-right: 2.7rem;
  padding-left: 0.9rem;
  position: relative;
}
.form-icon.right i {
  left: auto;
  right: 18px;
}

[data-layout-mode=dark] .form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important;
}
[data-layout-mode=dark] .form-control {
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important;
}

.list-group-fill-primary .list-group-item.active {
  background-color: #F26430 !important;
  border-color: #F26430;
}

.list-group-fill-secondary .list-group-item.active {
  background-color: #208C3B !important;
  border-color: #208C3B;
}

.list-group-fill-success .list-group-item.active {
  background-color: #0ab39c !important;
  border-color: #0ab39c;
}

.list-group-fill-info .list-group-item.active {
  background-color: #299cdb !important;
  border-color: #299cdb;
}

.list-group-fill-warning .list-group-item.active {
  background-color: #3FBF48 !important;
  border-color: #3FBF48;
}

.list-group-fill-danger .list-group-item.active {
  background-color: #f06548 !important;
  border-color: #f06548;
}

.list-group-fill-light .list-group-item.active {
  background-color: #f3f6f9 !important;
  border-color: #f3f6f9;
}

.list-group-fill-dark .list-group-item.active {
  background-color: #212529 !important;
  border-color: #212529;
}

.list-group-fill-light {
  color: #212529 !important;
}

.list-group-item {
  margin-bottom: 0px;
}
.list-group-item .list-text {
  color: #878a99;
}
.list-group-item.active {
  box-shadow: none;
}
.list-group-item.active .list-title {
  color: #fff;
}
.list-group-item.active .list-text {
  color: rgba(255, 255, 255, 0.5);
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

[data-simplebar-track=primary] .simplebar-scrollbar:before {
  background: #F26430;
}

[data-simplebar-track=secondary] .simplebar-scrollbar:before {
  background: #208C3B;
}

[data-simplebar-track=success] .simplebar-scrollbar:before {
  background: #0ab39c;
}

[data-simplebar-track=info] .simplebar-scrollbar:before {
  background: #299cdb;
}

[data-simplebar-track=warning] .simplebar-scrollbar:before {
  background: #3FBF48;
}

[data-simplebar-track=danger] .simplebar-scrollbar:before {
  background: #f06548;
}

[data-simplebar-track=light] .simplebar-scrollbar:before {
  background: #f3f6f9;
}

[data-simplebar-track=dark] .simplebar-scrollbar:before {
  background: #212529;
}

/**
 * prism.js default theme for JavaScript, CSS and HTML
 * Based on dabblet (http://dabblet.com)
 * @author Lea Verou
 */
code[class*=language-],
pre[class*=language-] {
  color: black;
  background: none;
  text-shadow: 0 1px white;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-],
  pre[class*=language-] {
    text-shadow: none;
  }
}
/* Code blocks */
pre[class*=language-] {
  padding: 1em;
  margin: 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: var(--vz-light) !important;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray;
}

.token.punctuation {
  color: #999;
}

.token.namespace {
  opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #f06548;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #690;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  /* This background color was intended by the author of this theme. */
  background: hsla(0, 0%, 100%, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}

.token.function,
.token.class-name {
  color: #dd4a68;
}

.token.regex,
.token.important,
.token.variable {
  color: #e90;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

/* Prism editor */
:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #eff2f7;
}

code[class*=language-],
pre[class*=language-] {
  color: #878a99;
  text-shadow: none;
}

.language-markup::-webkit-scrollbar {
  -webkit-appearance: none;
}
.language-markup::-webkit-scrollbar:vertical {
  width: 10px;
}
.language-markup::-webkit-scrollbar:horizontal {
  height: 10px;
}
.language-markup::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.1);
  border-radius: 10px;
  border: 2px solid var(--vz-light);
}
.language-markup::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-light);
}

#scroll-top {
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 65px;
  right: 30px;
  background: #343a40;
  border-color: transparent;
  border-radius: 3px;
  color: #ffffff;
  transition: all 0.5s ease;
}

.btn-clipboard {
  position: absolute !important;
  right: 15px !important;
  z-index: 1 !important;
}

div.code-toolbar > .toolbar {
  opacity: 1 !important;
}
div.code-toolbar > .toolbar button {
  display: inline-block !important;
  margin: 0.375rem 0.5rem !important;
  padding: 0.25rem 0.75rem !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  border-radius: 0.2rem !important;
  border: 1px solid rgba(242, 100, 48, 0.35) !important;
  background-color: transparent;
  color: #F26430 !important;
  box-shadow: none !important;
}
div.code-toolbar > .toolbar button:focus {
  outline: none !important;
  box-shadow: none !important;
}
div.code-toolbar > .toolbar button:hover {
  background-color: #F26430 !important;
  color: #fff !important;
}

.swal2-container .swal2-title {
  padding: 24px 24px 0;
  font-size: 20px;
  font-weight: 500;
}

.swal2-popup {
  padding-bottom: 24px;
  border-radius: 0.3rem;
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-body-color);
}
.swal2-popup .swal2-title {
  color: var(--vz-heading-color);
}
.swal2-popup .swal2-html-container {
  color: var(--vz-body-color);
}

.swal2-footer {
  border-top: 1px solid var(--vz-border-color);
  color: var(--vz-body-color);
}

.swal2-html-container {
  font-size: 16px;
}

.swal2-icon.swal2-question {
  border-color: #299cdb;
  color: #299cdb;
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #0ab39c;
}
.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(10, 179, 156, 0.3);
}
.swal2-icon.swal2-warning {
  border-color: #3FBF48;
  color: #3FBF48;
}

.swal2-styled:focus {
  box-shadow: none;
}

.swal2-loader {
  border-color: #F26430 transparent #F26430 transparent;
}

.swal2-timer-progress-bar {
  background-color: rgba(10, 179, 156, 0.4);
}

.swal2-progress-steps .swal2-progress-step {
  background: #F26430;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #F26430;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(242, 100, 48, 0.3);
}
.swal2-progress-steps .swal2-progress-step-line {
  background: #F26430;
}

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  border-left-color: #F26430 !important;
  border-right-color: #F26430 !important;
}

.swal2-file, .swal2-input, .swal2-textarea {
  border: 1px solid var(--vz-input-border);
}
.swal2-file:focus, .swal2-input:focus, .swal2-textarea:focus {
  box-shadow: none;
  border-color: var(--vz-input-focus-border);
}

.swal2-input {
  height: auto;
  display: block;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
}

.swal2-close {
  font-family: var(--vz-font-sans-serif);
  font-weight: 300;
  font-size: 28px;
}
.swal2-close:focus {
  box-shadow: none;
}
.swal2-close:hover {
  color: #F26430;
}

.swal2-validation-message {
  background-color: transparent;
}

.dropzone {
  min-height: 230px;
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg-custom);
  border-radius: 6px;
}
.dropzone .dz-message {
  font-size: 24px;
  width: 100%;
  margin: 1em 0;
}

.noUi-connect {
  background: #0ab39c;
}

.noUi-handle {
  background: #0ab39c;
  border: 2px solid var(--vz-card-bg);
  box-shadow: none;
}

.noUi-horizontal {
  height: 4px;
}
.noUi-horizontal .noUi-handle {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  right: -10px !important;
  top: -7px;
}
.noUi-horizontal .noUi-handle::before, .noUi-horizontal .noUi-handle::after {
  display: none;
}
.noUi-horizontal .noUi-handle:focus {
  outline: 0;
}

.noUi-pips-horizontal {
  height: 50px;
}

.noUi-tooltip {
  padding: 0.4rem 0.7rem;
  border-color: var(--vz-border-color);
  border-radius: 0.2rem;
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-body-color);
}

.noUi-vertical {
  width: 4px;
}
.noUi-vertical .noUi-handle {
  height: 16px;
  width: 16px;
  right: -8px;
  top: -12px;
  left: auto;
  border-radius: 50%;
}
.noUi-vertical .noUi-handle::before, .noUi-vertical .noUi-handle::after {
  display: none;
}
.noUi-vertical .noUi-handle:focus {
  outline: 0;
}
.noUi-vertical .noUi-origin {
  top: 0;
}

.noUi-value {
  font-size: 12px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 12px;
}

.noUi-value-horizontal {
  padding-top: 4px;
}

.noUi-target {
  box-shadow: none;
  background-color: var(--vz-light);
  border-color: var(--vz-light);
}

.noUi-touch-area:focus {
  outline: 0;
}

#red, #green, #blue {
  margin: 10px;
  display: inline-block;
  height: 200px;
}

#colorpicker {
  height: 240px;
  width: 310px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid var(--vz-border-color);
}

#result {
  margin: 60px 26px;
  height: 100px;
  width: 100px;
  display: inline-block;
  vertical-align: top;
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 0 3px;
  border-radius: 7px;
}

#red .noUi-connect {
  background: #f06548;
}

#green .noUi-connect {
  background: #0ab39c;
}

#blue .noUi-connect {
  background: #F26430;
}

.form-control.keyboard {
  max-width: 340px !important;
}

.example-val {
  font-size: 12px;
  color: #878a99;
  display: block;
  margin: 15px 0;
}
.example-val:before {
  content: "Value: ";
  font-size: 12px;
  font-weight: 600;
}

.noUi-tooltip {
  display: none;
}

.noUi-active .noUi-tooltip {
  display: block;
}

.c-1-color {
  background: #f06548;
}

.c-2-color {
  background: #3FBF48;
}

.c-3-color {
  background: #0ab39c;
}

.c-4-color {
  background: #F26430;
}

.c-5-color {
  background: #F28322;
}

#slider-toggle {
  height: 50px;
}
#slider-toggle.off .noUi-handle {
  border-color: #f06548;
}

[data-slider-color=primary] .noUi-connect {
  background: #F26430;
}
[data-slider-color=primary] .noUi-handle {
  background: #F26430;
}
[data-slider-color=primary][data-slider-style=border] .noUi-handle, [data-slider-color=primary][data-slider-style=square] .noUi-handle {
  border-color: #F26430;
}

[data-slider-color=secondary] .noUi-connect {
  background: #208C3B;
}
[data-slider-color=secondary] .noUi-handle {
  background: #208C3B;
}
[data-slider-color=secondary][data-slider-style=border] .noUi-handle, [data-slider-color=secondary][data-slider-style=square] .noUi-handle {
  border-color: #208C3B;
}

[data-slider-color=success] .noUi-connect {
  background: #0ab39c;
}
[data-slider-color=success] .noUi-handle {
  background: #0ab39c;
}
[data-slider-color=success][data-slider-style=border] .noUi-handle, [data-slider-color=success][data-slider-style=square] .noUi-handle {
  border-color: #0ab39c;
}

[data-slider-color=info] .noUi-connect {
  background: #299cdb;
}
[data-slider-color=info] .noUi-handle {
  background: #299cdb;
}
[data-slider-color=info][data-slider-style=border] .noUi-handle, [data-slider-color=info][data-slider-style=square] .noUi-handle {
  border-color: #299cdb;
}

[data-slider-color=warning] .noUi-connect {
  background: #3FBF48;
}
[data-slider-color=warning] .noUi-handle {
  background: #3FBF48;
}
[data-slider-color=warning][data-slider-style=border] .noUi-handle, [data-slider-color=warning][data-slider-style=square] .noUi-handle {
  border-color: #3FBF48;
}

[data-slider-color=danger] .noUi-connect {
  background: #f06548;
}
[data-slider-color=danger] .noUi-handle {
  background: #f06548;
}
[data-slider-color=danger][data-slider-style=border] .noUi-handle, [data-slider-color=danger][data-slider-style=square] .noUi-handle {
  border-color: #f06548;
}

[data-slider-color=light] .noUi-connect {
  background: #f3f6f9;
}
[data-slider-color=light] .noUi-handle {
  background: #f3f6f9;
}
[data-slider-color=light][data-slider-style=border] .noUi-handle, [data-slider-color=light][data-slider-style=square] .noUi-handle {
  border-color: #f3f6f9;
}

[data-slider-color=dark] .noUi-connect {
  background: #212529;
}
[data-slider-color=dark] .noUi-handle {
  background: #212529;
}
[data-slider-color=dark][data-slider-style=border] .noUi-handle, [data-slider-color=dark][data-slider-style=square] .noUi-handle {
  border-color: #212529;
}

[data-slider-size=lg].noUi-horizontal {
  height: 12px;
}
[data-slider-size=lg].noUi-horizontal .noUi-handle {
  width: 24px;
  height: 24px;
}

[data-slider-size=md].noUi-horizontal {
  height: 8px;
}
[data-slider-size=md].noUi-horizontal .noUi-handle {
  width: 20px;
  height: 20px;
}

[data-slider-size=sm].noUi-horizontal {
  height: 4px;
}
[data-slider-size=sm].noUi-horizontal .noUi-handle {
  width: 16px;
  height: 16px;
}

[data-slider-style=line].noUi-horizontal .noUi-handle {
  width: 8px;
  border-radius: 4px;
  right: -8px;
}
[data-slider-style=line].noUi-vertical .noUi-handle {
  height: 8px;
  border-radius: 4px;
  top: -3px;
}

[data-slider-style=border] .noUi-handle {
  border-color: #0ab39c;
  background-color: #fff;
}

[data-slider-style=square] .noUi-handle {
  border-radius: 0px;
  transform: rotate(45deg);
  height: 10px;
  width: 10px;
  top: -4px;
  border-color: #0ab39c;
  background-color: #fff;
}

.nested-list .list-group-item {
  background-color: rgba(242, 100, 48, 0.05);
  border-color: rgba(242, 100, 48, 0.05);
}

.nested-list, .nested-1, .nested-2, .nested-3 {
  margin-top: 5px;
}

.nested-sortable-handle .handle {
  position: absolute;
  left: 0;
  top: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}
.nested-sortable-handle .list-group-item {
  padding-left: 42px;
}

.shepherd-element {
  background: var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}

.shepherd-has-title .shepherd-content .shepherd-header {
  background-color: var(--vz-light);
  padding: 0.5rem 0.75rem;
}
.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: rgba(var(--vz-dark-rgb), 0.75);
}
.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
  color: rgba(var(--vz-dark-rgb), 0.75);
}

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
  background-color: var(--vz-light);
}

.shepherd-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--vz-body-color);
}

.shepherd-text {
  padding: 0.75rem;
  font-size: 0.8125rem;
  color: var(--vz-body-color);
}

.shepherd-button.btn-success:not(:disabled):hover {
  background: rgb(9.3253968254, 166.9246031746, 145.4761904762);
  color: #fff;
}
.shepherd-button.btn-light:not(:disabled):hover {
  background: rgba(var(--vz-light-rgb), 0.75);
  color: var(--vz-dark);
}
.shepherd-button.btn-primary:not(:disabled):hover {
  background: rgb(241.2465909091, 91.0170454545, 36.0034090909);
  color: #fff;
}

.shepherd-footer {
  padding: 0 0.75rem 0.75rem;
}

.shepherd-arrow,
.shepherd-arrow:before {
  content: "\\ea75";
  font-family: "remixicon";
  font-size: 24px;
  z-index: 1;
  background-color: transparent !important;
  transform: rotate(0deg);
  color: #F26430;
}

.shepherd-element[data-popper-placement^=bottom] > .shepherd-arrow {
  top: -18px;
}

.shepherd-button {
  margin-right: 0.5rem;
}

.swiper-button-next, .swiper-button-prev {
  height: 32px !important;
  width: 32px !important;
  background-color: rgba(242, 100, 48, 0.2);
  backdrop-filter: blur(2px);
  border-radius: 8px;
}
.swiper-button-next::after, .swiper-button-prev::after {
  font-family: remixicon !important;
  font-size: 28px !important;
  color: #f26430;
  transition: all 0.3s ease;
}

.swiper-button-prev::after {
  content: "\\ea64" !important;
}

.swiper-button-next::after {
  content: "\\ea6e" !important;
}

.swiper-pagination-bullet {
  width: 22px !important;
  height: 5px !important;
  background-color: #fff !important;
  border-radius: 50px !important;
  box-shadow: none;
}
.swiper-pagination-bullet .swiper-pagination-bullet-active {
  opacity: 1;
}

.dynamic-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease;
}
.dynamic-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
  width: 20px;
}

.swiper-pagination-fraction {
  color: #fff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
}

.pagination-custom .swiper-pagination-bullet {
  height: 25px !important;
  width: 25px !important;
  line-height: 25px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  opacity: 0.5 !important;
  transition: all 0.5s ease;
}
.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
  color: #208C3B !important;
  opacity: 1 !important;
}

.swiper-pagination-progressbar {
  height: 6px !important;
  background-color: rgba(10, 179, 156, 0.25) !important;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background-color: #0ab39c !important;
}

.swiper-scrollbar {
  background-color: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(2px);
  padding: 1.2px;
  height: 6px !important;
}
.swiper-scrollbar .swiper-scrollbar-drag {
  background-color: #fff;
}

.swiper-pagination-dark .swiper-pagination-bullet {
  background-color: #208C3B !important;
}
.swiper-pagination-dark .dynamic-pagination .swiper-pagination-bullet {
  background-color: #208C3B !important;
}
.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet {
  color: #fff;
}
.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
}
.swiper-pagination-dark.swiper-scrollbar {
  background-color: rgba(33, 37, 41, 0.35);
}

.multi-wrapper {
  border: none;
  position: relative;
}
.multi-wrapper::before {
  content: "\\ea61";
  position: absolute;
  font-family: "remixicon";
  left: 50%;
  transform: translateX(-50%);
  bottom: 86px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 50%;
  color: #878a99;
  background-color: var(--vz-light);
  z-index: 1;
}
.multi-wrapper .non-selected-wrapper {
  border: 1px solid var(--vz-input-border);
  background-color: var(--vz-input-bg);
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar:vertical, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:vertical {
  width: 10px;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar:horizontal, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:horizontal {
  height: 9px;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar-thumb, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.2);
  border-radius: 10px;
  border: 2px solid var(--vz-input-bg);
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar-track, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-input-bg);
}
.multi-wrapper .item-group .group-label {
  font-size: 12px;
}
.multi-wrapper .item {
  color: var(--vz-body-color);
}
.multi-wrapper .item:hover {
  background-color: rgba(242, 100, 48, 0.1);
}
.multi-wrapper .selected-wrapper {
  border: 1px solid var(--vz-input-border);
  background: var(--vz-input-bg);
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.multi-wrapper .search-input {
  flex: 0 0 auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  margin-bottom: 16px;
}
.multi-wrapper .search-input::placeholder {
  color: #878a99;
}
.multi-wrapper .header {
  font-weight: 600;
  color: var(--vz-gray-600);
}

.pcr-app {
  background: var(--vz-card-bg-custom);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 4px;
  border: 1px solid var(--vz-border-color);
}

.pickr .pcr-button {
  border: 4px solid var(--vz-card-bg-custom);
  box-shadow: 0px 0px 0 2px var(--vz-border-color);
  border-radius: 50%;
  box-shadow: none;
}
.pickr .pcr-button::after, .pickr .pcr-button::before {
  border-radius: 50%;
}

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview {
  margin-right: 0.75em;
  margin-left: 0;
}
.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser, .pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity {
  margin-left: 0.75em;
  margin-right: 0;
}
.pcr-app[data-theme=monolith] .pcr-result {
  min-width: 100%;
}
.pcr-app .pcr-interaction .pcr-type.active {
  background: #F26430;
}
.pcr-app .pcr-interaction .pcr-result {
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
}
.pcr-app .pcr-interaction input {
  border-radius: 0.25rem !important;
}
.pcr-app .pcr-interaction input:focus {
  box-shadow: none;
  background-color: var(--vz-input-bg);
  border-color: var(--vz-input-focus-border);
}
.pcr-app .pcr-interaction .pcr-save {
  background: #0ab39c !important;
}
.pcr-app .pcr-interaction .pcr-clear, .pcr-app .pcr-interaction .pcr-cancel {
  background: #f06548 !important;
}

.filepond--root {
  margin-bottom: 0;
}
.filepond--root[data-style-panel-layout~=circle] .filepond--drop-label label {
  font-size: 14px;
}

.filepond--panel-root {
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg-custom);
}

.filepond--drop-label {
  color: var(--vz-body-color);
}
.filepond--drop-label label {
  font-weight: 500;
}

.filepond--credits {
  display: none;
}

.filepond--item-panel {
  background-color: #F26430 !important;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  height: auto;
}

.input-step {
  border: 1px solid var(--vz-input-border);
  display: inline-flex;
  overflow: visible;
  height: 37.5px;
  border-radius: 0.25rem;
  background: var(--vz-input-bg);
  padding: 4px;
}
.input-step input {
  width: 4em;
  height: 100%;
  text-align: center;
  border: 0;
  background: transparent;
  color: var(--vz-body-color);
  border-radius: 0.25rem;
}
.input-step input:focus-visible {
  outline: 0;
}
.input-step button {
  width: 1.4em;
  font-weight: 300;
  height: 100%;
  line-height: 0.1em;
  font-size: 1.4em;
  padding: 0.2em !important;
  background: var(--vz-light);
  color: var(--vz-body-color);
  border: none;
  border-radius: 0.25rem;
}
.input-step.light {
  background: var(--vz-light);
}
.input-step.light button {
  background-color: var(--vz-input-bg);
}
.input-step.light-input {
  background: var(--vz-light);
}
.input-step.light-input input {
  background-color: var(--vz-input-bg);
}
.input-step.full-width {
  display: flex;
  width: 100%;
}
.input-step.full-width button {
  flex-shrink: 0;
}
.input-step.full-width input {
  flex-grow: 1;
}

.input-step.step-primary button {
  background-color: #F26430;
  color: #fff;
}

.input-step.step-secondary button {
  background-color: #208C3B;
  color: #fff;
}

.input-step.step-success button {
  background-color: #0ab39c;
  color: #fff;
}

.input-step.step-info button {
  background-color: #299cdb;
  color: #fff;
}

.input-step.step-warning button {
  background-color: #3FBF48;
  color: #fff;
}

.input-step.step-danger button {
  background-color: #f06548;
  color: #fff;
}

.input-step.step-light button {
  background-color: #f3f6f9;
  color: #fff;
}

.input-step.step-dark button {
  background-color: #212529;
  color: #fff;
}

.ck {
  font-family: var(--vz-font-sans-serif) !important;
}
.ck.ck-reset_all, .ck.ck-reset_all * {
  color: var(--vz-body-color) !important;
}
.ck.ck-toolbar {
  background: rgba(var(--vz-light-rgb), 0.75) !important;
}
.ck p {
  margin-bottom: 0;
}
.ck.ck-toolbar {
  border: 1px solid var(--vz-input-border) !important;
}
.ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
  flex-wrap: wrap !important;
}
.ck.ck-toolbar .ck.ck-toolbar__separator {
  background: transparent !important;
}
.ck.ck-editor__main > .ck-editor__editable {
  border-top: 0 !important;
  background-color: var(--vz-card-bg-custom) !important;
  border-color: var(--vz-input-border) !important;
  box-shadow: none !important;
}
.ck.ck-dropdown__panel {
  background: var(--vz-choices-bg) !important;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  border-radius: 0.3rem;
}
.ck.ck-list {
  background: var(--vz-choices-bg) !important;
}
.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne, .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
  left: 0;
  right: auto !important;
}
.ck.ck-editor__editable_inline[dir=ltr] {
  text-align: left !important;
}
.ck.ck-dropdown__panel {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
  border-radius: 0.3rem !important;
  border: 1px solid var(--vz-border-color) !important;
}

.ck.ck-button:focus, .ck.ck-button:active,
a.ck.ck-button:focus,
a.ck.ck-button:active {
  box-shadow: none !important;
  border: 1px solid var(--vz-light) !important;
}
.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--vz-light) !important;
}
.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: var(--vz-light) !important;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.ck-editor__editable {
  min-height: 245px !important;
}

.ck[class*=ck-heading_heading] {
  font-weight: 500 !important;
}

.ck.ck-button.ck-on:not(.ck-disabled):hover, .ck.ck-button.ck-on:not(.ck-disabled):active,
a.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):active {
  box-shadow: none !important;
}

.ck.ck-tooltip .ck-tooltip__text {
  background: #212529 !important;
  color: #f3f6f9 !important;
}
.ck.ck-input-text {
  background: var(--vz-input-bg) !important;
  border: 1px solid var(--vz-input-border) !important;
}
.ck.ck-input-text:focus {
  border: 1px solid var(--vz-input-focus-border) !important;
  box-shadow: none !important;
}
.ck.ck-balloon-panel {
  background: #fff !important;
  border: 1px solid var(--vz-border-color) !important;
}
.ck.ck-balloon-panel[class*=arrow_n]:after {
  border-bottom-color: #fff !important;
}
.ck.ck-balloon-panel[class*=arrow_n]::before {
  border-bottom-color: var(--vz-border-color) !important;
}

.ck.ck-labeled-field-view > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
  background: #fff !important;
}

.ck-editor-reverse .ck-editor {
  display: flex;
  flex-direction: column-reverse;
}
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid var(--vz-input-border) !important;
  border-bottom: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck-editor-reverse .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

[dir=rtl] .ck.ck-toolbar > .ck-toolbar__items {
  flex-direction: row-reverse;
}

.ql-editor {
  text-align: left;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
  padding-right: 0;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}

.ql-container {
  font-family: var(--vz-font-sans-serif);
}
.ql-container.ql-snow {
  border-color: var(--vz-input-border);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ql-bubble {
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
}

.ql-toolbar {
  font-family: var(--vz-font-sans-serif) !important;
}
.ql-toolbar span {
  outline: none !important;
  color: var(--vz-choices-link-color);
}
.ql-toolbar span:hover {
  color: #F26430 !important;
}
.ql-toolbar.ql-snow {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-color: var(--vz-input-border);
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: transparent;
}
.ql-toolbar.ql-snow .ql-picker-options {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 0.3rem;
}

.ql-snow .ql-stroke,
.ql-snow .ql-script,
.ql-snow .ql-strike svg {
  stroke: var(--vz-choices-link-color);
}
.ql-snow .ql-fill {
  fill: var(--vz-choices-link-color);
}
.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  right: 0;
  left: auto;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: var(--vz-choices-link-color);
}

.ql-snow .ql-picker-options {
  background-color: var(--vz-choices-bg);
  border-color: var(--vz-border-color) !important;
}

.gridjs-container {
  color: var(--vz-body-color);
  padding: 0;
  display: block;
}

.gridjs-wrapper {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-radius: 0px;
}
.gridjs-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}
.gridjs-wrapper::-webkit-scrollbar:vertical {
  width: 12px;
}
.gridjs-wrapper::-webkit-scrollbar:horizontal {
  height: 12px;
}
.gridjs-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 10px;
  border: 2px solid var(--vz-card-bg-custom);
}
.gridjs-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-card-bg-custom);
}

.gridjs-footer {
  border: none !important;
  padding: 12px 0 0;
}

.gridjs-table {
  width: 100%;
}

.gridjs-tbody, td.gridjs-td {
  background-color: transparent;
}

th.gridjs-th,
td.gridjs-td {
  border: 1px solid var(--vz-border-color);
  padding: 0.75rem 0.6rem;
}

th.gridjs-th {
  border-top: 0;
  color: var(--vz-body-color);
  background-color: rgba(var(--vz-light-rgb), 0.75);
}
th.gridjs-th-sort:focus, th.gridjs-th-sort:hover {
  background-color: rgba(var(--vz-light-rgb), 0.85);
}

.gridjs-head {
  padding-top: 0;
}

.gridjs-footer {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-top: 0;
  background-color: transparent;
}

.gridjs-summary {
  color: #878a99;
  margin-top: 8px !important;
}

.gridjs-pagination .gridjs-pages button {
  margin-left: 0.3rem;
  border-radius: 0.25rem !important;
  border: 1px solid var(--vz-border-color);
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-link-color);
}
.gridjs-pagination .gridjs-pages button:last-child {
  border-right: 1px solid var(--vz-border-color);
}
.gridjs-pagination .gridjs-pages button:disabled, .gridjs-pagination .gridjs-pages button:hover:disabled, .gridjs-pagination .gridjs-pages button[disabled] {
  color: #878a99;
  background-color: var(--vz-card-bg-custom);
}
.gridjs-pagination .gridjs-pages button:hover {
  background-color: #eff2f7;
  color: var(--vz-link-hover-color);
}
.gridjs-pagination .gridjs-pages button:focus {
  box-shadow: none;
}
.gridjs-pagination .gridjs-pages button:last-child:hover, .gridjs-pagination .gridjs-pages button:first-child:hover {
  background-color: transparent;
}
.gridjs-pagination .gridjs-pages button.gridjs-currentPage {
  background-color: #F26430;
  color: #fff;
  border-color: #F26430;
  font-weight: 500;
}

.gridjs-search {
  position: relative;
  float: left;
}
.gridjs-search::before {
  content: "\\f0d1";
  font-family: "remixicon";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  font-size: 14px;
  color: #878a99;
}

input.gridjs-input {
  border-color: var(--vz-input-border);
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  line-height: 1.5;
  padding: 0.5rem 0.9rem 0.5rem 2.025rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
}
input.gridjs-input:focus {
  box-shadow: none;
  border-color: var(--vz-input-focus-border);
  background-color: var(--vz-input-bg);
}
input.gridjs-input::placeholder {
  color: #878a99;
}

th.gridjs-th .gridjs-th-content {
  float: none;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600;
}

button.gridjs-sort {
  float: none;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 20px;
}

th.gridjs-th-sort .gridjs-th-content {
  width: calc(100% - 10px);
}

button.gridjs-sort-asc, button.gridjs-sort-desc {
  background-size: 7px;
}

.table-card .gridjs-head {
  padding: 16px 16px 5px;
}
.table-card .gridjs-wrapper {
  border-top: 0;
  border-radius: 0;
  border-width: 1px 0;
}
.table-card .gridjs-footer {
  padding: 8px 16px;
}

.gridjs-tr-selected td {
  background-color: rgba(var(--vz-light-rgb), 1);
}
.gridjs-tr-selected .gridjs-td .gridjs-checkbox[type=checkbox] {
  background-color: #F26430;
  border-color: #F26430;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.gridjs-td .gridjs-checkbox {
  width: 1.1em;
  height: 1.1em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  print-color-adjust: exact;
}
.gridjs-td .gridjs-checkbox[type=checkbox] {
  border-radius: 0.25em;
}

.gridjs-border-none td.gridjs-td, .gridjs-border-none th.gridjs-th {
  border-right-width: 0;
  border-left-width: 0;
}

.gridjs-loading-bar {
  background-color: var(--vz-card-bg-custom);
}

[data-layout-mode=dark] button.gridjs-sort-neutral, [data-layout-mode=dark] button.gridjs-sort-asc, [data-layout-mode=dark] button.gridjs-sort-desc {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.listjs-pagination {
  margin-bottom: 0;
  justify-content: flex-end;
  gap: 8px;
}
.listjs-pagination li .page {
  display: block;
  padding: 0.375rem 0.75rem;
  color: var(--vz-link-color);
  background-color: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.listjs-pagination li.active .page {
  color: #fff;
  background-color: #F26430;
  border-color: #F26430;
}

.pagination-wrap {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
}
.pagination-wrap a {
  text-decoration: none;
  display: inline-block;
}

.pagination-next,
.pagination-prev {
  color: #F26430;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  background-color: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.pagination-next:hover,
.pagination-prev:hover {
  color: rgb(248.0272727273, 171.8636363636, 143.9727272727);
}
.pagination-next.disabled,
.pagination-prev.disabled {
  color: #878a99;
  cursor: default;
}
.pagination-next.disabled:hover,
.pagination-prev.disabled:hover {
  color: #878a99;
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: var(--vz-font-sans-serif) !important;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: var(--vz-font-sans-serif) !important;
}

.apexcharts-tooltip {
  border: 1px solid var(--vz-border-color) !important;
  background-color: var(--vz-card-bg-custom) !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
}
.apexcharts-tooltip * {
  font-family: var(--vz-font-sans-serif) !important;
  color: #878a99 !important;
}
.apexcharts-tooltip .apexcharts-tooltip-title {
  background-color: rgba(var(--vz-light-rgb), 0.75) !important;
  border-bottom: 1px solid var(--vz-border-color) !important;
}

.apexcharts-tooltip.apexcharts-theme-dark * {
  color: #fff !important;
}

.apexcharts-legend-series {
  font-weight: 500;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: rgba(var(--vz-light-rgb), 0.75);
}

.apexcharts-legend-text {
  color: #878a99 !important;
  font-family: var(--vz-font-sans-serif) !important;
  font-size: 13px !important;
}

.apexcharts-pie-label {
  fill: #fff !important;
}

.apexcharts-title-text, .apexcharts-subtitle-text {
  fill: #adb5bd;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--vz-font-sans-serif) !important;
  fill: #adb5bd;
}

.apexcharts-yaxis-title {
  font-weight: 500;
}

#dynamicloadedchart-wrap {
  margin: 0px auto;
  max-width: 800px;
  position: relative;
}

.chart-box {
  padding-left: 0;
}

#chart-year,
#chart-quarter {
  width: 96%;
  max-width: 48%;
  box-shadow: none;
  padding-left: 0;
  padding-top: 20px;
  background: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
}

#chart-year {
  float: left;
  position: relative;
  transition: 1s ease transform;
  z-index: 3;
}
#chart-year.chart-quarter-activated {
  transform: translateX(0);
  transition: 1s ease transform;
}

#chart-quarter {
  float: left;
  position: relative;
  z-index: -2;
  transition: 1s ease transform;
}
#chart-quarter.active {
  transition: 1.1s ease-in-out transform;
  transform: translateX(0);
  z-index: 1;
}

@media screen and (min-width: 480px) {
  #chart-year {
    transform: translateX(50%);
  }
  #chart-quarter {
    transform: translateX(-50%);
  }
}
.apexcharts-radar-series polygon, .apexcharts-radar-series line {
  stroke: var(--vz-border-color);
}

.apexcharts-pie circle, .apexcharts-pie line {
  stroke: var(--vz-border-color);
}
.apexcharts-pie text {
  fill: var(--vz-body-color);
}

.apex-charts .apexcharts-xaxis line,
.apex-charts .apexcharts-yaxis line {
  stroke: var(--vz-border-color);
}
.apex-charts .apexcharts-xaxis-tick {
  stroke: var(--vz-border-color);
}
.apex-charts .apexcharts-pie-series path,
.apex-charts .apexcharts-bar-series path {
  stroke: var(--vz-card-bg-custom);
}
.apex-charts .apexcharts-radialbar-track path {
  stroke: var(--vz-light);
}
.apex-charts .apexcharts-marker {
  stroke: var(--vz-card-bg-custom);
}
.apex-charts .apexcharts-boxPlot-series path {
  stroke: var(--vz-border-color);
}
.apex-charts .apexcharts-treemap rect,
.apex-charts .apexcharts-heatmap-series rect {
  stroke: var(--vz-card-bg-custom);
}

.chartjs-chart {
  max-height: 320px;
}

.e-charts {
  height: 350px;
}

.e-charts-height {
  height: 300px;
}

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #f3f6f9;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #F26430;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}
.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #F26430;
}
.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #F26430;
}

.autoComplete_wrapper {
  display: block;
}
.autoComplete_wrapper > input {
  display: block;
  width: 100%;
  height: auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  background-image: none;
}
.autoComplete_wrapper > input::placeholder {
  padding: 0 !important;
  color: #878a99 !important;
  font-size: 0.8125rem !important;
}
.autoComplete_wrapper > input:focus {
  border: 1px solid var(--vz-input-focus-border);
  color: var(--vz-body-color);
}
.autoComplete_wrapper > input:hover {
  color: var(--vz-body-color);
}
.autoComplete_wrapper > ul {
  border-radius: 0.25rem;
  border-color: var(--vz-border-color);
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 0;
  overflow: auto;
  max-height: 160px;
  margin: 0;
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
}
.autoComplete_wrapper > ul > li {
  font-size: 0.8125rem;
  margin: 0;
  padding: 0.35rem 1.2rem;
  border-radius: 0;
  background-color: #fff;
  color: var(--vz-body-color);
}
.autoComplete_wrapper > ul > li mark, .autoComplete_wrapper > ul > li .mark {
  color: #f06548;
  font-weight: 600;
  padding: 1px;
}
.autoComplete_wrapper > ul > li[aria-selected=true], .autoComplete_wrapper > ul > li:hover {
  color: rgb(29.7, 33.3, 36.9);
  background-color: #f3f6f9;
}
.autoComplete_wrapper > ul .no_result {
  padding: 0.7rem 1.2rem;
  font-style: italic;
  font-weight: 500;
}

.jvm-tooltip {
  border-radius: 3px;
  background-color: #F26430;
  font-family: var(--vz-font-sans-serif);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 5px 9px;
}

.jvm-container text {
  font-family: var(--vz-font-sans-serif);
  font-size: 0.8125rem;
  fill: var(--vz-gray-700);
}

.jvm-zoom-btn {
  background-color: #F26430;
}

.leaflet-map {
  height: 300px;
}
.leaflet-map.leaflet-container {
  z-index: 0;
  font-family: "Poppins", sans-serif;
}

.fc td,
.fc th {
  border: 1px solid var(--vz-border-color);
}

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
}
@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc .fc-toolbar .fc-today-button {
    display: none;
  }
}
.fc .fc-toolbar .btn {
  text-transform: capitalize;
}
.fc .fc-col-header-cell {
  background-color: var(--vz-light);
}
.fc .fc-col-header-cell-cushion {
  display: block;
  padding: 8px 4px;
}
.fc .fc-daygrid-day-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  margin: 2px;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(242, 100, 48, 0.1);
}
.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
  background-color: #F26430;
  color: #fff;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(242, 100, 48, 0.1);
}
.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(242, 100, 48, 0.1);
}
.fc .fc-list-event:hover td {
  background: transparent;
}
.fc .fc-list-event-title a {
  color: #fff !important;
}
.fc .fc-col-header,
.fc .fc-daygrid-body,
.fc .fc-scrollgrid-sync-table {
  width: 100% !important;
}
.fc .fc-scrollgrid-section > * {
  border-left: 1px solid var(--vz-border-color);
  border-top: 1px solid var(--vz-border-color);
}
.fc .fc-scrollgrid-section-liquid > td {
  border-top: 0;
}

.fc-theme-bootstrap a:not([href]) {
  color: var(--vz-body-color);
}

.fc-event {
  color: #fff;
}

.fc th.fc-widget-header {
  background: #e9ebec;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 700;
}

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #e9ebec;
}
.fc-unthemed td.fc-today {
  background: rgb(245.8, 247.525, 250.4);
}

.fc-button {
  background: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #F26430;
  color: #fff;
  text-shadow: none;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-event,
.fc-event-dot {
  background-color: #F26430;
}

.fc-daygrid-dot-event.fc-event-mirror,
.fc-daygrid-dot-event:hover {
  background-color: #F26430;
}

.fc-event-title,
.fc-sticky {
  font-weight: 600 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fc-daygrid-event-dot {
  border-color: #fff !important;
  display: none;
}

.fc-event-time {
  display: none;
}

.fc-event .fc-content {
  color: #fff;
}

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
  margin: 6px 0;
}

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #f3f6f9;
}

.fc-prev-button,
.fc-next-button {
  position: relative;
  height: 37.5px;
  width: 37.5px;
}
.fc-prev-button::before,
.fc-next-button::before {
  position: absolute;
  font-family: remixicon !important;
  font-size: 20px;
  top: 0;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fc-prev-button::before {
  content: "\\ea64";
}

.fc-next-button::before {
  content: "\\ea6e";
}

.fc-toolbar-chunk .btn-group {
  box-shadow: none;
}
.fc-toolbar-chunk .btn-group .btn {
  color: #208C3B;
  background-color: rgba(32, 140, 59, 0.15);
  border: none;
  box-shadow: none;
}
.fc-toolbar-chunk .btn-group .btn:hover, .fc-toolbar-chunk .btn-group .btn.active {
  color: #fff;
  background-color: #208C3B;
}
.fc-toolbar-chunk .fc-today-button {
  background-color: #208C3B !important;
  border: #208C3B;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    flex-direction: column;
    gap: 16px;
  }
}

#upcoming-event-list .card:last-child {
  margin-bottom: 6px !important;
}

#event-modal .event-details {
  display: none;
}
#event-modal .view-event .event-form {
  display: none;
}
#event-modal .view-event #event-category-tag {
  display: none;
}
#event-modal .view-event .event-details {
  display: block;
}

.fc-daygrid-event-harness .fc-daygrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-event-harness .fc-timegrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-slots table tr {
  border-color: var(--vz-border-color) !important;
}

.fc-list-table {
  border-color: var(--vz-border-color);
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-main {
  color: #F26430 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-primary .fc-event-title {
  color: #F26430 !important;
}

.fc-list-table .fc-list-event.bg-soft-primary {
  color: #F26430 !important;
}
.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-title > a {
  color: #F26430 !important;
}
.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-dot {
  border-color: #F26430;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-main {
  color: #208C3B !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-secondary .fc-event-title {
  color: #208C3B !important;
}

.fc-list-table .fc-list-event.bg-soft-secondary {
  color: #208C3B !important;
}
.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-title > a {
  color: #208C3B !important;
}
.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-dot {
  border-color: #208C3B;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-main {
  color: #0ab39c !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-success .fc-event-title {
  color: #0ab39c !important;
}

.fc-list-table .fc-list-event.bg-soft-success {
  color: #0ab39c !important;
}
.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-title > a {
  color: #0ab39c !important;
}
.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-dot {
  border-color: #0ab39c;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-main {
  color: #299cdb !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-info .fc-event-title {
  color: #299cdb !important;
}

.fc-list-table .fc-list-event.bg-soft-info {
  color: #299cdb !important;
}
.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-title > a {
  color: #299cdb !important;
}
.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-dot {
  border-color: #299cdb;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-main {
  color: #3FBF48 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-warning .fc-event-title {
  color: #3FBF48 !important;
}

.fc-list-table .fc-list-event.bg-soft-warning {
  color: #3FBF48 !important;
}
.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-title > a {
  color: #3FBF48 !important;
}
.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-dot {
  border-color: #3FBF48;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-main {
  color: #f06548 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-danger .fc-event-title {
  color: #f06548 !important;
}

.fc-list-table .fc-list-event.bg-soft-danger {
  color: #f06548 !important;
}
.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-title > a {
  color: #f06548 !important;
}
.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-dot {
  border-color: #f06548;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-main {
  color: #f3f6f9 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-light .fc-event-title {
  color: #f3f6f9 !important;
}

.fc-list-table .fc-list-event.bg-soft-light {
  color: #f3f6f9 !important;
}
.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-title > a {
  color: #f3f6f9 !important;
}
.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-dot {
  border-color: #f3f6f9;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main {
  color: #212529 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-dark .fc-event-title {
  color: #212529 !important;
}

.fc-list-table .fc-list-event.bg-soft-dark {
  color: #212529 !important;
}
.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-title > a {
  color: #212529 !important;
}
.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-dot {
  border-color: #212529;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main, .fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {
  color: var(--vz-dark) !important;
}

.fc-direction-ltr {
  direction: ltr;
}
.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

.fg-emoji-picker {
  width: 250px !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
  top: auto !important;
  bottom: 130px;
}
.fg-emoji-picker * {
  font-family: var(--vz-font-sans-serif) !important;
  color: var(--vz-body-color) !important;
}
@media (max-width: 991.98px) {
  .fg-emoji-picker {
    left: 14px !important;
    top: auto !important;
    bottom: 118px;
  }
}
.fg-emoji-picker .fg-emoji-picker-container-title {
  color: #212529 !important;
}
.fg-emoji-picker .fg-emoji-picker-search {
  height: 40px !important;
}
.fg-emoji-picker .fg-emoji-picker-search input {
  background-color: var(--vz-input-bg) !important;
  color: var(--vz-body-color) !important;
  padding: 0.5rem 0.9rem !important;
  font-size: 0.8125rem !important;
}
.fg-emoji-picker .fg-emoji-picker-search input::placeholder {
  color: #878a99 !important;
}
.fg-emoji-picker .fg-emoji-picker-search svg {
  fill: var(--vz-body-color) !important;
  right: 11px;
  top: 12px;
}
.fg-emoji-picker .fg-emoji-picker-categories {
  background-color: #f3f6f9 !important;
}
.fg-emoji-picker .fg-emoji-picker-categories li.active {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}
.fg-emoji-picker .fg-emoji-picker-categories a:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}

.fg-emoji-picker-grid > li:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2) !important;
}

a.fg-emoji-picker-close-button {
  background-color: rgb(229.4, 235.8, 242.2) !important;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
  padding: 50px;
  font-weight: 600;
  --vz-table-accent-bg: var(--vz-card-bg-custom);
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  content: "\\f0360";
  position: absolute;
  right: 0.5rem;
  top: 12px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  content: "\\f035d";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > tbody > tr.child span.dtr-title {
  font-weight: 600;
  min-width: 150px;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > th.dtr-control::before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control::before {
  background-color: #F26430;
  border-color: var(--vz-card-bg-custom);
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent.parent > th.dtr-control::before {
  background-color: #f06548;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td.dtr-control::before {
  background-color: #f06548;
}
table.dataTable > tbody > tr.child span.dtr-title {
  min-width: 135px;
}

.table-card .dataTables_length,
.table-card .dataTables_filter {
  padding: 1rem 1rem;
  padding-bottom: 0px;
}
.table-card .dataTables_info,
.table-card .dataTables_paginate {
  padding: 1rem 1rem;
}
.table-card div.dataTables_wrapper .col-md-6 {
  width: 100%;
}
.table-card div.dataTables_wrapper div.dataTables_filter input {
  width: calc(100% - 52px);
}
.table-card div.dataTables_wrapper div.dataTables_filter label {
  display: block;
}

div.dtr-modal div.dtr-modal-display {
  background-color: #fff;
  border-color: var(--vz-border-color);
  box-shadow: none;
  height: 70%;
}
div.dtr-modal div.dtr-modal-content {
  padding: 1.25rem;
}
div.dtr-modal div.dtr-modal-content h2, div.dtr-modal div.dtr-modal-content .h2 {
  font-size: 1.015625rem;
  font-weight: 600;
  margin-bottom: 15px;
}
div.dtr-modal div.dtr-modal-content .dtr-details tr td {
  padding: 0.75rem 0.6rem;
}
div.dtr-modal div.dtr-modal-close {
  font-size: 24px;
  top: 9px;
  right: 11px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
}
div.dtr-modal div.dtr-modal-close:hover {
  background-color: var(--vz-light);
}

.dt-buttons button.dt-button,
.dt-buttons div.dt-button,
.dt-buttons a.dt-button,
.dt-buttons input.dt-button {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-gray-800);
}

.rdt_Table .rdt_TableBody .rdt_TableRow {
  background-color: transparent;
  color: var(--vz-body-color);
  border-bottom-color: var(--vz-border-color);
  outline-color: var(--vz-border-color);
}

.select2.select2-container {
  width: 100% !important;
}

.select2-container .select2-selection--single {
  border: 1px solid var(--vz-input-border);
  height: calc(1.5em + 1rem + 2px);
  background-color: var(--vz-input-bg);
  outline: none;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 12px;
  color: var(--vz-body-color);
}
.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  /*rtl:ignore*/
  right: 3px;
}
.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: var(--vz-input-border) transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent var(--vz-input-border) transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-dropdown {
  border: 0 solid var(--vz-border-color);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-choices-bg);
  z-index: 1056;
}

.select2-container--default .select2-results__option--selected {
  background-color: var(--vz-input-disabled-bg);
}
.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: var(--vz-choices-bg);
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  outline: none;
  border: 1px solid var(--vz-input-border);
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  border-radius: 0.25rem;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #F26430;
}
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: var(--vz-choices-bg);
  color: var(--vz-choices-link-active-color);
}
.select2-container--default .select2-results__option[aria-selected=true]:hover {
  background-color: #F26430;
  color: #fff;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display {
  padding-left: 36px;
  padding-right: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  /*rtl:ignore*/
  right: 1px;
  /*rtl:ignore*/
  left: auto;
}

.select2-container .select2-selection--multiple {
  min-height: calc(1.5em + 1rem + 2px);
  border: 1px solid var(--vz-input-border) !important;
  background-color: var(--vz-input-bg);
}
.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 1px 4px;
}
.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: var(--vz-body-color);
}
.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: #F26430;
  border: none;
  color: #fff;
  border-radius: 3px;
  padding: 3px;
  margin-top: 6px;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff;
  margin-right: 7px;
  border-color: rgb(243.3, 115.5, 68.7);
  padding: 0 8px;
  top: 3px;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove:hover {
  color: #fff;
  background-color: #F26430;
}
.select2-container .select2-search--inline .select2-search__field {
  margin-top: 7px;
  font-family: var(--vz-font-sans-serif);
}
.select2-container .select2-search textarea::placeholder {
  color: #878a99;
}

.select2-container--default.select2-container--disabled .select2-selection--single, .select2-container--default.select2-container--disabled .select2-selection--multiple {
  background-color: var(--vz-input-disabled-bg);
  cursor: default;
}

.toastify {
  padding: 12px 16px;
  color: #fff;
  display: inline-block;
  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);
  background: #0ab39c;
  position: fixed;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  max-width: calc(50% - 20px);
  z-index: 2147483647;
}
.toastify.on {
  opacity: 1;
}

.toast-close {
  opacity: 0.4;
  padding: 0 5px;
  position: relative;
  left: 4px;
  margin-left: 4px;
  border: none;
  background: none;
}

.toastify-right {
  right: 15px;
}

.toastify-left {
  left: 15px;
}
.toastify-left .toast-close {
  left: -4px;
  margin-left: 0;
  margin-right: 4px;
}

.toastify-top {
  top: -150px;
}

.toastify-bottom {
  bottom: -150px;
}

.toastify-rounded {
  border-radius: 25px;
}

.toastify-avatar {
  width: 1.5em;
  height: 1.5em;
  margin: -7px 5px;
  border-radius: 2px;
}

.toastify-center {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  max-width: fit-content;
  max-width: -moz-fit-content;
}

@media only screen and (max-width: 360px) {
  .toastify-right, .toastify-left {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-width: fit-content;
  }
}
.choices {
  position: relative;
  margin-bottom: 24px;
  font-size: 16px;
}
.choices:focus {
  outline: none;
}
.choices:last-child {
  margin-bottom: 0;
}
.choices.is-disabled .choices__inner,
.choices.is-disabled .choices__input {
  background-color: rgba(var(--vz-light-rgb), 0.75);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.choices.is-disabled .choices__item {
  cursor: not-allowed;
}
.choices [hidden] {
  display: none !important;
}
.choices[data-type*=select-one] {
  cursor: pointer;
}
.choices[data-type*=select-one] .choices__inner {
  padding-bottom: 0.25rem;
}
.choices[data-type*=select-one] .choices__input {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  background-color: var(--vz-input-bg);
  border: 1px solid var(--vz-input-border);
  font-size: 0.8125rem;
  border-radius: 0.25rem;
  color: var(--vz-body-color);
  margin-bottom: 10px;
}
.choices[data-type*=select-one] .choices__button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  padding: 0;
  background-size: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  left: auto;
  margin-top: -10px;
  margin-right: 25px;
  margin-left: 0;
  height: 20px;
  width: 20px;
  border-radius: 10em;
  opacity: 0.5;
}
.choices[data-type*=select-one] .choices__button:hover, .choices[data-type*=select-one] .choices__button:focus {
  opacity: 1;
}
.choices[data-type*=select-one] .choices__button:focus {
  box-shadow: 0px 0px 0px 2px #00bcd4;
}
.choices[data-type*=select-one] .choices__item[data-value=""] .choices__button {
  display: none;
}
.choices[data-type*=select-one]:after {
  content: "\\f0140";
  position: absolute;
  border: 0;
  border-color: #212529 transparent transparent;
  right: 11.5px;
  left: auto;
  font-family: "Material Design Icons";
  width: auto;
  height: auto;
  margin-top: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.choices[data-type*=select-one].is-open:after {
  margin-top: 0;
  transform: translateY(-50%) rotate(-180deg);
}
.choices[data-type*=select-multiple] .choices__inner, .choices[data-type*=text] .choices__inner {
  cursor: text;
  padding-right: 0.9rem;
}
.choices[data-type*=select-multiple] .choices__button, .choices[data-type*=text] .choices__button {
  position: relative;
  display: inline-block;
  margin-top: 0;
  margin-right: -4px;
  margin-bottom: 0;
  margin-left: 8px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  border-right: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  background-size: 8px;
  width: 8px;
  line-height: 1;
  opacity: 0.75;
  border-radius: 0;
}
.choices[data-type*=select-multiple] .choices__button:hover, .choices[data-type*=select-multiple] .choices__button:focus, .choices[data-type*=text] .choices__button:hover, .choices[data-type*=text] .choices__button:focus {
  opacity: 1;
}
.choices[data-type*=select-multiple] .choices__list--dropdown, .choices[data-type*=text] .choices__list--dropdown {
  padding-bottom: 10px;
}
.choices[data-type*=select-multiple] .choices__list--dropdown .choices__list, .choices[data-type*=text] .choices__list--dropdown .choices__list {
  margin-bottom: 0;
}
.choices[data-type*=select-multiple] .choices__input {
  padding-top: 3px;
}

.input-light .choices__inner {
  background-color: var(--vz-light);
  border: none;
}

.choices__inner {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  background-color: var(--vz-input-bg);
  padding: 0.25rem 3.6rem 0.1rem 0.5rem;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem !important;
  font-size: 0.8125rem;
  min-height: 37.5px;
  overflow: hidden;
}

.is-focused .choices__inner,
.is-open .choices__inner {
  border-color: var(--vz-input-focus-border);
}

.choices__list {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.choices__list--single {
  display: inline-block;
  padding: 4px 16px 4px 4px;
  width: 100%;
}
.choices__list--single .choices__item {
  width: 100%;
}

.choices__list--multiple {
  display: inline;
}
.choices__list--multiple .choices__item {
  display: inline-block;
  vertical-align: initial;
  border-radius: 7px;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: 400;
  margin-right: 3.75px;
  margin-bottom: 3.75px;
  margin-top: 2px;
  background-color: #F26430;
  border: 1px solid #F26430;
  word-break: break-all;
  box-sizing: border-box;
  color: #fff;
  box-shadow: none;
}
.choices__list--multiple .choices__item[data-deletable] {
  padding-right: 5px;
}
.choices__list--multiple .choices__item.is-highlighted {
  background-color: #F26430;
  border: 1px solid #F26430;
}

.is-disabled .choices__list--multiple .choices__item {
  background-color: #208C3B;
  border: 1px solid #208C3B;
}

.choices__list--dropdown {
  visibility: hidden;
  z-index: 1;
  position: absolute;
  width: 100%;
  background-color: var(--vz-choices-bg);
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  top: 100%;
  margin-top: 0;
  padding: 10px 10px 20px 10px;
  border-bottom-left-radius: 2.5px;
  border-bottom-right-radius: 2.5px;
  overflow: hidden;
  word-break: break-all;
  will-change: visibility;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  transform: translateY(1px);
}
.choices__list--dropdown.is-active {
  visibility: visible;
  animation-name: DropDownSlide;
}
.choices__list--dropdown .choices__item--selectable.is-highlighted {
  background-color: var(--vz-choices-link-hover-bg);
}
.choices__list--dropdown .choices__list {
  margin: 0 -16px -16px;
}
.choices__list--dropdown .has-no-results {
  font-style: italic;
  font-weight: 500;
}
.choices__list--dropdown .choices__item--selectable:after {
  display: none;
}

.is-open .choices__list--dropdown {
  border-color: var(--vz-border-color);
}

.is-flipped .choices__list--dropdown {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: -1px;
  border-radius: 0.25rem 0.25rem 0 0;
}
.is-flipped .choices__list--dropdown.is-active {
  animation-name: DropDownSlideDown;
  transform: translateY(-1px);
}

.choices__list--dropdown .choices__list {
  position: relative;
  max-height: 300px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
}
.choices__list--dropdown .choices__item {
  position: relative;
  font-size: 0.8125rem;
  padding: 0.35rem 1.2rem 0.35rem 16px;
}

@media (min-width: 640px) {
  .choices__list--dropdown .choices__item--selectable:after {
    content: attr(data-select-text);
    font-size: 12px;
    opacity: 0;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .choices__list--dropdown .choices__item--selectable.is-highlighted:after {
    opacity: 0.5;
  }
}
.choices__item {
  cursor: default;
}

.choices__item--selectable {
  cursor: pointer;
}

.choices__item--disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.5;
}

.choices__heading {
  font-weight: 600;
  font-size: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--vz-border-color);
  color: #878a99;
}

.choices__button {
  text-indent: -9999px;
  appearance: none;
  border: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
.choices__button:focus {
  outline: none;
}

.choices__input {
  display: inline-block;
  vertical-align: baseline;
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  font-size: 0.8125rem;
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
  max-width: 100%;
  padding: 2px 0 2px 2px;
}
.choices__input:focus {
  outline: 0;
}
.choices__input::placeholder {
  color: #878a99;
}

.choices__placeholder {
  color: #878a99;
  opacity: 1;
}

[data-layout-mode=dark] .choices[data-type*=select-one] .choices__button {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: var(--vz-choices-bg);
  box-shadow: 1px 0 0 var(--vz-border-color), -1px 0 0 var(--vz-border-color), 0 1px 0 var(--vz-border-color), 0 -1px 0 var(--vz-border-color), 0 3px 13px rgba(0, 0, 0, 0.08);
}
.flatpickr-calendar.open, .flatpickr-calendar.inline {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
}
.flatpickr-calendar.open {
  display: inline-block;
  z-index: 1056;
}
.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.flatpickr-calendar.inline {
  display: block;
  position: relative;
  top: 2px;
  width: 100%;
  box-shadow: none;
}
.flatpickr-calendar.inline .flatpickr-rContainer {
  display: block;
  width: 100%;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days {
  width: 100%;
  border: 1px solid var(--vz-input-border);
  border-top: none;
  border-radius: 0 0 5px 5px;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer .flatpickr-day {
  max-width: 100%;
  border-radius: 4px;
}
.flatpickr-calendar.inline .flatpickr-time {
  border: 1px solid var(--vz-input-border) !important;
  border-radius: 0.25rem;
}
.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px);
}
.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
  box-shadow: none !important;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-calendar .hasWeeks .dayContainer,
.flatpickr-calendar .hasTime .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.flatpickr-calendar .hasWeeks .dayContainer {
  border-left: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid var(--vz-border-color);
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto;
}
.flatpickr-calendar::before, .flatpickr-calendar::after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
}
.flatpickr-calendar.rightMost::before, .flatpickr-calendar.arrowRight::before, .flatpickr-calendar.rightMost::after, .flatpickr-calendar.arrowRight::after {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.arrowCenter::before, .flatpickr-calendar.arrowCenter::after {
  left: 50%;
  right: 50%;
}
.flatpickr-calendar::before {
  border-width: 5px;
  margin: 0 -5px;
}
.flatpickr-calendar::after {
  border-width: 4px;
  margin: 0 -4px;
}
.flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {
  bottom: 100%;
}
.flatpickr-calendar.arrowTop::before {
  border-bottom-color: #F26430;
}
.flatpickr-calendar.arrowTop::after {
  border-bottom-color: #F26430;
}
.flatpickr-calendar.arrowBottom::before, .flatpickr-calendar.arrowBottom::after {
  top: 100%;
}
.flatpickr-calendar.arrowBottom::before {
  border-top-color: #F26430;
}
.flatpickr-calendar.arrowBottom::after {
  border-top-color: #F26430;
}
.flatpickr-calendar:focus {
  outline: 0;
}

.flatpickr-wrapper {
  position: relative;
  display: inline-block;
}

.flatpickr-months {
  display: flex;
  background-color: #F26430;
  border-radius: 5px 5px 0px 0px;
}
.flatpickr-months .flatpickr-month {
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  flex: 1 1;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
}
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
.flatpickr-months .flatpickr-next-month.flatpickr-disabled {
  display: none;
}
.flatpickr-months .flatpickr-prev-month i,
.flatpickr-months .flatpickr-next-month i {
  position: relative;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  left: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  /*
  /*rtl:begin:ignore*/
  /*
  /*rtl:end:ignore*/
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  right: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  /*
  /*rtl:begin:ignore*/
  /*
  /*rtl:end:ignore*/
}
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  color: #959ea9;
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: rgba(255, 255, 255, 0.9);
}
.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 14px;
  height: 14px;
}
.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  transition: fill 0.1s;
  fill: inherit;
}

.numInputWrapper {
  position: relative;
  height: auto;
}
.numInputWrapper input,
.numInputWrapper span {
  display: inline-block;
}
.numInputWrapper input {
  width: 100%;
}
.numInputWrapper input::-ms-clear {
  display: none;
}
.numInputWrapper input::-webkit-outer-spin-button, .numInputWrapper input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.numInputWrapper span {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(var(--vz-dark-rgb), 0.15);
  box-sizing: border-box;
}
.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1);
}
.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2);
}
.numInputWrapper span:after {
  display: block;
  content: "";
  position: absolute;
}
.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0;
}
.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(57, 57, 57, 0.6);
  top: 26%;
}
.numInputWrapper span.arrowDown {
  top: 50%;
}
.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(57, 57, 57, 0.6);
  top: 40%;
}
.numInputWrapper span svg {
  width: inherit;
  height: auto;
}
.numInputWrapper span svg path {
  fill: rgba(0, 0, 0, 0.5);
}
.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05);
}
.numInputWrapper:hover span {
  opacity: 1;
}

.flatpickr-current-month {
  font-size: 100%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px);
}
.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}
.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  width: 7ch\\0 ;
  display: inline-block;
}
.flatpickr-current-month span.arrowUp::after {
  border-bottom-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month span.arrowDown:after {
  border-top-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month input.cur-year {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 600;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  appearance: textfield;
}
.flatpickr-current-month input.cur-year:focus {
  outline: 0;
}
.flatpickr-current-month input.cur-year[disabled], .flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(255, 255, 255, 0.9);
  background: transparent;
  pointer-events: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  appearance: menulist;
  background: transparent;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 600;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: none;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  width: auto;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:focus, .flatpickr-current-month .flatpickr-monthDropdown-months:active {
  outline: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background-color: transparent;
}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background-color: transparent;
  outline: none;
  padding: 0;
  color: rgba(0, 0, 0, 0.8);
}

.flatpickr-weekdays {
  background-color: #F26430;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--vz-border-color);
}
.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1 1;
}

span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: #F26430;
  color: #fff;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: 500;
}

.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0;
}

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
}
.flatpickr-days:focus {
  outline: 0;
}

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1;
}
.dayContainer + .dayContainer {
  box-shadow: -1px 0 0 #e6e6e6;
}

.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: var(--vz-body-color);
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}
.flatpickr-day:hover, .flatpickr-day:focus {
  background-color: rgba(var(--vz-light-rgb), 0.7);
}
.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background-color: var(--vz-light);
  border-color: var(--vz-light);
}
.flatpickr-day.today {
  border-color: #F26430;
  background-color: rgba(242, 100, 48, 0.1);
  box-shadow: none;
}
.flatpickr-day.today:hover, .flatpickr-day.today:focus {
  border-color: #F26430;
  background-color: rgba(242, 100, 48, 0.15);
  color: var(--vz-dark);
}
.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background: #F26430;
  box-shadow: none;
  color: #fff;
  border-color: #F26430;
}
.flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #F26430;
}
.flatpickr-day.selected.startRange .endRange, .flatpickr-day.startRange.startRange .endRange, .flatpickr-day.endRange.startRange .endRange {
  border-radius: 50px;
}
.flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 var(--vz-light), 5px 0 0 var(--vz-light);
}
.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(var(--vz-body-color-rgb), 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {
  cursor: not-allowed;
  color: rgba(var(--vz-body-color-rgb), 0.3);
}
.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #F26430, 5px 0 0 #F26430;
}
.flatpickr-day.hidden {
  visibility: hidden;
}

.rangeMode .flatpickr-day {
  margin-top: 1px;
}

.flatpickr-weekwrapper {
  float: left;
}
.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  box-shadow: 1px 0 0 #e6e6e6;
}
.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 35px;
}
.flatpickr-weekwrapper span.flatpickr-day, .flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(var(--vz-dark-rgb), 0.3);
  background: transparent;
  cursor: default;
  border: none;
}

.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}

.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}

.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}
.flatpickr-time:after {
  content: "";
  display: table;
  clear: both;
}
.flatpickr-time .numInputWrapper {
  flex: 1 1;
  width: 40%;
  height: 40px;
  float: left;
}
.flatpickr-time .numInputWrapper span.arrowUp:after, .flatpickr-time .numInputWrapper span.arrowDown:after {
  border-bottom-color: var(--vz-border-color);
}
.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%;
}
.flatpickr-time.time24hr .numInputWrapper {
  width: 49%;
}
.flatpickr-time input {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: var(--vz-body-color);
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  appearance: textfield;
}
.flatpickr-time input.flatpickr-hour {
  font-weight: bold;
}
.flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second {
  font-weight: 400;
}
.flatpickr-time input:focus {
  outline: 0;
  border: 0;
}
.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  height: inherit;
  float: left;
  line-height: inherit;
  color: var(--vz-body-color);
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
          user-select: none;
  align-self: center;
}
.flatpickr-time .flatpickr-am-pm {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}
.flatpickr-time input:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time .flatpickr-am-pm:focus {
  background: rgba(242, 100, 48, 0.04);
}

.flatpickr-am-pm:focus, .flatpickr-am-pm:hover,
.numInput:focus,
.numInput:hover,
.numInputWrapper:focus,
.numInputWrapper:hover {
  background-color: transparent;
}

.flatpickr-input[readonly] {
  cursor: pointer;
  background-color: var(--vz-input-bg);
}

[data-inline-date=true], [data-time-inline] {
  display: none;
}

@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
[datepicker-inline],
[timepicker-inline] {
  display: none;
}

[data-input-flag] {
  position: relative;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list {
  max-height: 158px;
  overflow-y: auto;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar {
  -webkit-appearance: none;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:vertical {
  width: 8px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:horizontal {
  height: 10px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-track {
  border-radius: 8px;
}

[data-option-flag-img-name] .flag-input {
  padding-left: 45px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-repeat: no-repeat;
  background-position: 14px 8px;
  background-size: 18px;
}

[data-option-flag-name]::before,
[data-option-flag-img-name]::before {
  content: "\\f0140";
  font-family: "Material Design Icons";
  position: absolute;
  right: 0.9rem;
  top: 0.5rem;
  font-size: 16px;
}

[data-option-countrycode=false] .country-codeno {
  display: none;
}

[data-search-input=false] .searchlist-input {
  display: none;
}

.auth-page-wrapper .auth-page-content {
  padding-bottom: 60px;
  position: relative;
  z-index: 2;
  width: 100%;
}
.auth-page-wrapper .footer {
  left: 0;
  background-color: transparent;
  color: var(--vz-body-color);
}

.auth-one-bg-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 580px;
}
@media (max-width: 575.98px) {
  .auth-one-bg-position {
    height: 280px;
  }
}

.auth-one-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  background-size: cover;
}
.auth-one-bg .bg-overlay {
  background: linear-gradient(to right, rgb(240.1918181818, 78.4409090909, 19.2081818182), #F26430);
  opacity: 0.1;
}

.shape {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}
.shape > svg {
  width: 100%;
  height: auto;
  fill: var(--vz-body-bg);
}

.auth-pass-inputgroup input[type=text] + .btn .ri-eye-fill:before {
  content: "\\ecb6";
}

.particles-js-canvas-el {
  position: relative;
}

.signin-other-title {
  position: relative;
}
.signin-other-title:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  border-top: 1px dashed var(--vz-border-color);
  top: 10px;
}
.signin-other-title .title {
  display: inline-block;
  position: relative;
  z-index: 9;
  background-color: var(--vz-card-bg-custom);
  padding: 2px 16px;
}

.auth-bg-cover {
  background: linear-gradient(126deg, rgb(8, 143, 125) 0%, rgb(0, 57, 92) 100%);
}
.auth-bg-cover > .bg-overlay {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  background-position: center;
  background-size: cover;
  opacity: 1;
  background-color: transparent;
}
.auth-bg-cover .footer {
  color: rgba(255, 255, 255, 0.5);
}

#password-contain {
  display: none;
}
#password-contain p {
  padding-left: 13px;
}
#password-contain p.valid {
  color: #0ab39c;
}
#password-contain p.valid::before {
  position: relative;
  left: -8px;
  content: "✔";
}
#password-contain p.invalid {
  color: #f06548;
}
#password-contain p.invalid::before {
  position: relative;
  left: -8px;
  content: "✖";
}

.dash-filter-picker {
  min-width: 210px !important;
}

.upcoming-scheduled {
  position: relative;
}
@media (max-width: 575.98px) {
  .upcoming-scheduled {
    top: 35px !important;
  }
}
.upcoming-scheduled .flatpickr-months {
  position: absolute !important;
  top: -45px !important;
  left: auto !important;
  right: 0px !important;
  width: 200px;
  background-color: transparent;
}
.upcoming-scheduled .flatpickr-months .flatpickr-month {
  color: #878a99 !important;
  fill: #878a99 !important;
}
.upcoming-scheduled .flatpickr-months .flatpickr-prev-month,
.upcoming-scheduled .flatpickr-months .flatpickr-next-month {
  display: none;
}
.upcoming-scheduled .flatpickr-calendar {
  box-shadow: none !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-current-month {
  font-size: 13px;
  width: 100%;
  left: 0;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-monthDropdown-months {
  border: 1px solid var(--vz-border-color);
  border-radius: 4px;
  height: 26px;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays {
  background-color: var(--vz-light);
  border: none;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays span.flatpickr-weekday {
  color: var(--vz-dark);
  background-color: var(--vz-light);
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today {
  color: #fff !important;
  background-color: #0ab39c;
  border-color: #0ab39c !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today:hover {
  color: #0ab39c !important;
  background-color: rgba(10, 179, 156, 0.2) !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.selected {
  background-color: #0ab39c !important;
  border-color: #0ab39c !important;
  color: #fff;
}
.upcoming-scheduled .flatpickr-calendar .numInputWrapper {
  width: 7.5ch;
  margin-left: 10px;
}
.upcoming-scheduled .flatpickr-days {
  border: none !important;
}

.crm-widget .col {
  border-right: 1px solid var(--vz-border-color);
}
.crm-widget .col:last-child {
  border: 0px;
}
@media (min-width: 768px) and (max-width: 1399.98px) {
  .crm-widget .col:nth-child(3) {
    border-right: 0px;
  }
  .crm-widget .col:last-child {
    border-right: 1px solid var(--vz-border-color);
  }
}
@media (max-width: 767.98px) {
  .crm-widget .col {
    border-right: 0px;
    border-bottom: 1px solid var(--vz-border-color);
  }
}

@media (min-width: 1400px) and (max-width: 1599.98px) {
  .project-wrapper > .col-xxl-8,
  .project-wrapper .col-xxl-4 {
    width: 100%;
  }
}
.crypto-widget {
  max-width: 130px !important;
}

.bg-marketplace {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  background-size: cover;
}

.dash-countdown .countdownlist .count-num {
  background-color: var(--vz-card-bg-custom);
  padding: 16px 8px;
  font-size: 22px;
}
@media (max-width: 575.98px) {
  .dash-countdown .countdownlist .count-num {
    font-size: 16px;
    padding: 8px 6px;
  }
  .dash-countdown .countdownlist .count-title {
    font-size: 10px;
  }
}

.marketplace-icon {
  position: absolute;
  float: right;
  top: 30px;
  left: 30px;
}

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 34px;
  width: 28px;
  height: 28px;
  background-color: rgba(242, 100, 48, 0.1);
  color: #F26430;
  border-radius: 0.3rem;
  right: 16px !important;
}
.marketplace-swiper .swiper-button-prev {
  right: 58px !important;
  left: auto !important;
}

.dash-collection .content {
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(5px);
}

@media (max-width: 1441.98px) {
  .dash-nft .col-xxl-9,
  .dash-nft .col-xxl-3 {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
}

.timeline {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}
.timeline::after {
  content: "";
  position: absolute;
  width: 2px;
  background: var(--vz-card-bg-custom);
  top: 57px;
  bottom: 166px;
  left: 50%;
  margin-left: -1.5px;
}

.timeline-item {
  padding: 30px 60px;
  position: relative;
  background: inherit;
  width: 50%;
}
.timeline-item .icon {
  position: absolute;
  display: inline-flex;
  width: 60px;
  height: 60px;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  top: 30px;
  right: -30px;
  padding: 9px 0;
  background: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
  border-radius: 50px;
  color: #0ab39c;
  z-index: 1;
}
.timeline-item .date {
  position: absolute;
  display: inline-block;
  width: calc(100% - 48px);
  top: 50px;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}
.timeline-item .content {
  padding: 20px;
  background: var(--vz-card-bg-custom);
  position: relative;
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.timeline-item.left {
  left: 0;
}
.timeline-item.left .date {
  left: calc(100% + 48px);
  text-align: start;
}
.timeline-item.right {
  left: 50%;
}
.timeline-item.right .icon {
  left: -30px;
}
.timeline-item.right .date {
  right: calc(100% + 48px);
  text-align: end;
}
.timeline-item.right::before {
  left: 28px;
  border-color: transparent transparent transparent #fff;
}

@media (max-width: 991.98px) {
  .timeline::after {
    left: 24px;
    bottom: 180px;
  }
  .timeline-item {
    width: 100%;
    padding-left: 48px;
    padding-right: 0px;
  }
  .timeline-item.right, .timeline-item.left {
    left: 0%;
  }
  .timeline-item.right .icon, .timeline-item.left .icon {
    width: 45px;
    height: 45px;
    top: 0;
    font-size: 18px;
    left: 0;
  }
  .timeline-item.right::before, .timeline-item.left::before {
    left: 110px;
    border-color: transparent transparent transparent var(--vz-border-color);
  }
  .timeline-item.right .date, .timeline-item.left .date {
    right: auto;
    left: 48px;
    width: 79px;
    top: 8px;
    text-align: left;
  }
}
.timeline-2 {
  position: relative;
}
.timeline-2::after {
  position: absolute;
  content: "";
  width: 2px;
  height: 83%;
  top: 50px;
  left: 40px;
  margin-left: -1px;
  background: var(--vz-card-bg-custom);
}
.timeline-2 .timeline-year {
  position: relative;
  width: 100%;
  text-align: left;
  z-index: 1;
}
.timeline-2 .timeline-year p {
  display: inline-flex;
  width: 80px;
  height: 80px;
  margin: 0;
  padding: 23px 10px;
  background: var(--vz-card-bg-custom);
  border-radius: 50px;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.timeline-2 .timeline-year p span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.timeline-2 .timeline-date {
  font-size: 14px;
  font-weight: 500;
  margin: 24px 0 0 0;
  margin-left: 55px;
}
.timeline-2 .timeline-date::after {
  content: "";
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  top: 26px;
  left: 45px;
  align-items: left;
  background: #0ab39c;
  border: 3px solid var(--vz-card-bg-custom);
  border-radius: 50px;
  z-index: 1;
}
.timeline-2 .timeline-box {
  position: relative;
  display: inline-block;
  margin: 23px 62px;
  padding: 20px;
  border: 1px solid var(--vz-border-color);
  border-radius: 6px;
  background: var(--vz-card-bg-custom);
  max-width: 695px;
}
@media (max-width: 991.98px) {
  .timeline-2 .timeline-box {
    margin-right: 0;
  }
}
.timeline-2 .timeline-box::after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  top: 26px;
  right: 100%;
  border-color: transparent var(--vz-card-bg-custom) transparent transparent;
  border-width: 10px;
}
.timeline-2 .timeline-box::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  right: 100%;
  top: 24px;
  border-color: transparent var(--vz-border-color) transparent transparent;
  border-width: 12px;
}
.timeline-2 .timeline-box .timeline-text {
  position: relative;
  float: left;
}
.timeline-2 .timeline-launch {
  position: relative;
  display: inline-block;
  border: 1px solid var(--vz-border-color);
  border-radius: 6px;
  background: #fff;
  width: 100%;
  margin-top: 15px;
  padding: 0;
  border: none;
  text-align: left;
  background: transparent;
}
.timeline-2 .timeline-launch .timeline-box {
  margin-left: 0;
}
.timeline-2 .timeline-launch .timeline-box::after {
  left: 30px;
  margin-left: 0px;
  top: -20px;
  border-color: transparent transparent var(--vz-border-color) transparent;
}
.timeline-2 .timeline-launch .timeline-box::before {
  left: 30px;
  margin-left: 0px;
  top: -19px;
  border-color: transparent transparent var(--vz-card-bg-custom) transparent;
  border-width: 10px;
  z-index: 1;
}

.horizontal-timeline {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.horizontal-timeline::before {
  content: "";
  position: absolute;
  width: 100%;
  top: 174px;
  left: 0;
  height: 2px;
  background-color: var(--vz-card-bg-custom);
}
.horizontal-timeline .swiper-slide .item-box {
  margin: 227px 0px 0px;
  background-color: transparent;
  box-shadow: none;
}
.horizontal-timeline .swiper-slide .item-box::after {
  content: "";
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  background: #F26430;
  width: 13px;
  height: 13px;
  top: -59px;
  border-radius: 50px;
  border: 3px solid var(--vz-card-bg-custom);
}
.horizontal-timeline .swiper-slide .timeline-content {
  min-height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--vz-card-bg-custom);
}
.horizontal-timeline .swiper-slide .timeline-content::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  left: 0px;
  top: -23px;
  border-color: transparent transparent var(--vz-card-bg-custom) transparent;
  border-width: 12px;
  right: 0;
  margin: 0 auto;
}
.horizontal-timeline .swiper-slide .time {
  position: absolute;
  top: -86px;
  right: 0px;
  left: 0px;
  margin: 0px auto;
}
.horizontal-timeline .swiper-slide:nth-child(even) {
  margin-top: 5px;
  transform: rotate(-180deg);
}
.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content {
  transform: rotate(180deg);
}
.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content::before {
  bottom: -23px;
  top: auto;
  border-color: var(--vz-card-bg-custom) transparent transparent transparent;
}
.horizontal-timeline .swiper-slide:nth-child(even) .time {
  transform: rotate(180deg);
}
.horizontal-timeline .swiper-button-next,
.horizontal-timeline .swiper-button-prev {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: rgb(242.7534090909, 108.9829545455, 59.9965909091);
}
.horizontal-timeline .swiper-button-next::after,
.horizontal-timeline .swiper-button-prev::after {
  font-size: 24px;
  color: #fff;
}
.horizontal-timeline .swiper-button-next.swiper-button-disabled,
.horizontal-timeline .swiper-button-prev.swiper-button-disabled {
  background-color: rgba(242, 100, 48, 0.5);
  opacity: 1;
  cursor: auto;
  backdrop-filter: blur(25px);
  pointer-events: none;
}
.horizontal-timeline .swiper-button-next {
  right: 0;
}
.horizontal-timeline .swiper-button-next::after {
  content: "\\ea6e";
  font-family: remixicon;
}
.horizontal-timeline .swiper-button-prev {
  left: 0;
}
.horizontal-timeline .swiper-button-prev::after {
  content: "\\ea64";
  font-family: remixicon;
}

.acitivity-timeline {
  position: relative;
  overflow: hidden;
}
.acitivity-timeline .acitivity-item {
  position: relative;
}
.acitivity-timeline .acitivity-item .flex-shrink-0 {
  z-index: 2;
}
.acitivity-timeline .acitivity-item .acitivity-avatar {
  background-color: var(--vz-card-bg-custom);
  border: 3px solid var(--vz-card-bg-custom);
  height: 32px;
  width: 32px;
}
.acitivity-timeline .acitivity-item:before {
  content: "";
  position: absolute;
  border-left: 1px dashed var(--vz-border-color);
  left: 16px;
  height: 100%;
  top: 5px;
  z-index: 0;
}
.acitivity-timeline .acitivity-item:last-child::before {
  border-color: transparent;
}

.categories-filter .list-inline-item {
  position: relative;
  margin-right: 0;
}
.categories-filter .list-inline-item a {
  display: block;
  color: var(--vz-body-color);
  font-weight: 600;
  padding: 8px 15px;
  margin: 5px;
  cursor: pointer;
}

.gallery-box {
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  margin-bottom: 10px;
  box-shadow: none;
  background-color: transparent;
  padding: 8px;
}
.gallery-box::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 0;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.4s;
}
.gallery-box .gallery-container {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
.gallery-box .gallery-container a {
  display: block;
}
.gallery-box .gallery-container .gallery-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  opacity: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 100%);
  visibility: hidden;
  overflow: hidden;
  transition: all 0.4s ease-in-out 0s;
  display: flex;
  width: 100%;
  align-items: flex-end;
  padding: 16px;
}
.gallery-box .gallery-container .gallery-overlay .overlay-caption {
  color: #fff;
  margin: 0;
  font-size: 16px;
}
.gallery-box .gallery-img {
  transition: all 0.2s ease-in-out;
}
.gallery-box .box-content {
  position: relative;
}
.gallery-box .box-content .title {
  font-size: 14px;
  margin-bottom: 4px;
  display: none;
}
.gallery-box .box-content .post {
  margin: 0;
  transition: all 0.2s;
  color: #878a99;
}
.gallery-box:hover::before {
  height: 100%;
}
.gallery-box:hover .box-content {
  bottom: 0;
}
.gallery-box:hover .box-content .post {
  opacity: 1;
}
.gallery-box:hover .gallery-overlay {
  opacity: 1;
  visibility: visible;
}

.gallery-light .gallery-box::before {
  background-color: var(--vz-light);
}

.error-basic-img {
  max-width: 450px;
}

.error-500 .title {
  font-size: 250px;
}
.error-500 .error-500-img {
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .error-500 .title {
    font-size: 150px;
  }
  .error-500 .error-500-img {
    width: 20% !important;
    top: 43px;
  }
}
@media (max-width: 767.98px) {
  .error-500 .title {
    font-size: 68px;
    margin-top: 35px;
  }
  .error-500 .error-500-img {
    position: relative;
    top: 0px;
  }
}

@keyframes errorAnimation {
  0% {
    transform: translateX(0%);
  }
  15% {
    transform: translateX(-25%) rotate(-5deg);
  }
  30% {
    transform: translateX(20%) rotate(3deg);
  }
  45% {
    transform: translateX(-15%) rotate(-3deg);
  }
  60% {
    transform: translateX(10%) rotate(2deg);
  }
  75% {
    transform: translateX(-5%) rotate(-1deg);
  }
  100% {
    transform: translateX(0%);
  }
}
.error-img {
  animation: errorAnimation 20s infinite;
}

.error-text {
  text-shadow: 4px 4px rgba(10, 179, 156, 0.4);
}
@media (min-width: 1200px) {
  .error-text {
    font-size: 10rem;
  }
}

.profile-wid-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 320px;
}
@media (max-width: 575.98px) {
  .profile-wid-bg {
    height: 445px;
  }
}
.profile-wid-bg::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.9;
  background: #F26430;
  background: linear-gradient(to top, rgb(152.8977272727, 48.0113636364, 9.6022727273), #F26430);
}
.profile-wid-bg .profile-wid-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-nav.nav-pills .nav-link {
  color: rgba(255, 255, 255, 0.8);
}
.profile-nav.nav-pills .nav-link::before {
  background-color: rgba(255, 255, 255, 0.1);
}

.profile-project-card {
  border: 1px solid var(--vz-border-color);
  border-left: 3px solid var(--vz-border-color);
}

.profile-project-card.profile-project-primary {
  border-left-color: #F26430;
}

.profile-project-card.profile-project-secondary {
  border-left-color: #208C3B;
}

.profile-project-card.profile-project-success {
  border-left-color: #0ab39c;
}

.profile-project-card.profile-project-info {
  border-left-color: #299cdb;
}

.profile-project-card.profile-project-warning {
  border-left-color: #3FBF48;
}

.profile-project-card.profile-project-danger {
  border-left-color: #f06548;
}

.profile-project-card.profile-project-light {
  border-left-color: #f3f6f9;
}

.profile-project-card.profile-project-dark {
  border-left-color: #212529;
}

.user-profile-img {
  position: relative;
}
.user-profile-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
@media (max-width: 991px) {
  .user-profile-img .profile-img {
    height: 160px;
  }
}
.user-profile-img .profile-foreground-img-file-input {
  display: none;
}
.user-profile-img .profile-photo-edit {
  cursor: pointer;
}

.profile-user {
  position: relative;
  display: inline-block;
}
.profile-user .profile-photo-edit {
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
  cursor: pointer;
}
.profile-user .user-profile-image {
  object-fit: cover;
}
.profile-user .profile-img-file-input {
  display: none;
}

.profile-timeline .accordion-item {
  position: relative;
}
.profile-timeline .accordion-item .accordion-button {
  background-color: transparent;
}
.profile-timeline .accordion-item .accordion-button::after {
  background: none;
}
.profile-timeline .accordion-item::before {
  content: "";
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  height: 100%;
  left: 23px;
}
.profile-timeline .accordion-item:first-child::before {
  top: 8px;
}
.profile-timeline .accordion-item:last-child::before {
  height: 20px;
  top: 3px;
}

.profile-setting-img {
  position: relative;
  height: 260px;
}
.profile-setting-img .overlay-content {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
}
.profile-setting-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
@media (max-width: 991.98px) {
  .profile-setting-img .profile-img {
    height: 160px;
  }
}
.profile-setting-img .profile-foreground-img-file-input {
  display: none;
}
.profile-setting-img .profile-photo-edit {
  cursor: pointer;
}

@media (max-width: 575.98px) {
  [data-layout=horizontal] .profile-foreground {
    margin-top: 0 !important;
  }
}
[data-layout=semibox] .profile-wrapper {
  padding: 0 1rem;
}

.sitemap-content {
  width: 100%;
  max-width: 1142px;
  margin: 0 auto;
  padding: 0 20px;
}
.sitemap-content * {
  position: relative;
}

.sitemap-horizontal {
  position: relative;
}
.sitemap-horizontal ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.sitemap-horizontal ul a {
  display: block;
  background: var(--vz-light);
  border: 2px solid var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-size: 0.8125rem;
  height: 60px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sitemap-horizontal ul a span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.administration .director > li > a {
  width: 50%;
  margin: 0 auto 0px auto;
  border-radius: 4px;
}
.administration .subdirector {
  position: absolute;
  width: 100%;
}
.administration .subdirector::after {
  content: "";
  display: block;
  width: 0;
  height: 130px;
  border-left: 2px dashed var(--vz-border-color);
  left: 45.45%;
  position: relative;
}
.administration .subdirector > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  z-index: 1;
  float: right;
  right: 27.2%;
  border-left: 2px dashed var(--vz-border-color);
}
.administration .subdirector > li:first-child a {
  width: 100%;
  left: 25px;
}
@media screen and (max-width: 767px) {
  .administration .subdirector > li:first-child {
    width: 40%;
    right: 10%;
    margin-right: 2px;
  }
  .administration .subdirector::after {
    left: 49.8%;
  }
}

.departments {
  width: 100%;
}
.departments > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  z-index: 1;
  float: left;
  left: 27%;
}
.departments > li:first-child a {
  width: 100%;
  right: 25px;
}
.departments > li:nth-child(2) {
  margin-left: 0;
  clear: left;
}
.departments > li:nth-child(2).department:before {
  border: none;
}
.departments::after {
  content: "";
  display: block;
  position: absolute;
  width: 81.1%;
  height: 22px;
  border-top: 2px dashed var(--vz-border-color);
  border-right: 2px dashed var(--vz-border-color);
  border-left: 2px dashed var(--vz-border-color);
  margin: 0 auto;
  top: 130px;
  left: 9.1%;
}
@media screen and (max-width: 767px) {
  .departments > li:first-child {
    width: 40%;
    left: 10%;
    margin-left: 2px;
  }
  .departments::after {
    border-right: none;
    left: 0;
    width: 50%;
  }
}

.department {
  border-left: 2px dashed var(--vz-border-color);
  float: left;
  margin-left: 1.75%;
  margin-bottom: 60px;
  width: 18.25%;
}
.department::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 22px;
  border-left: 2px dashed var(--vz-border-color);
  z-index: 1;
  top: -22px;
  left: 50%;
  margin-left: -4px;
}
.department > a {
  margin: 0 0 -26px -4px;
  z-index: 1;
}
.department ul {
  margin-top: 0px;
  margin-bottom: 0px;
}
.department ul li {
  padding-left: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  height: 80px;
}
.department ul li a {
  background: var(--vz-card-bg-custom);
  margin-top: 48px;
  position: absolute;
  z-index: 1;
  width: 90%;
  height: 60px;
  vertical-align: middle;
  right: -1px;
  text-align: center;
}
.department:first-child {
  margin-left: 0;
  clear: left;
}
@media screen and (min-width: 768px) {
  .department:last-child:before {
    border: none;
  }
}
@media screen and (max-width: 767px) {
  .department {
    float: none;
    width: 100%;
    margin-left: 0;
  }
  .department::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 60px;
    border-left: 2px dashed #fff;
    z-index: 1;
    top: -60px;
    left: 0%;
    margin-left: -4px;
  }
  .department:nth-child(2)::before {
    display: none;
  }
}

.hori-sitemap ul {
  padding: 0;
  padding-top: 10px;
  text-align: center;
}
.hori-sitemap ul li {
  position: relative;
}
@media (max-width: 575.98px) {
  .hori-sitemap ul {
    text-align: left;
  }
  .hori-sitemap ul .parent-title a {
    padding-left: 0;
  }
  .hori-sitemap ul .parent-title a:after {
    display: none;
  }
  .hori-sitemap ul .parent-title:before {
    display: none;
  }
  .hori-sitemap > ul {
    position: relative;
  }
  .hori-sitemap > ul li {
    padding-top: 10px;
  }
  .hori-sitemap > ul li .second-list,
  .hori-sitemap > ul li .sub-list {
    position: relative;
  }
  .hori-sitemap > ul li .second-list:before,
  .hori-sitemap > ul li .sub-list:before {
    content: "";
    height: calc(100% - 14px);
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .hori-sitemap > ul li .sub-list:before {
    height: 38%;
  }
  .hori-sitemap > ul li a {
    position: relative;
    padding: 4px 16px 4px 36px;
  }
  .hori-sitemap > ul li a:after {
    content: "";
    width: 24px;
    border-top: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  .hori-sitemap > ul li ul {
    margin-left: 36px;
  }
}
@media (min-width: 576px) {
  .hori-sitemap ul {
    padding-top: 20px;
  }
  .hori-sitemap ul li {
    padding-top: 30px;
  }
  .hori-sitemap ul li:before {
    content: "";
    height: 24px;
    width: 0;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0px auto;
  }
  .hori-sitemap ul li:after {
    content: "";
    width: 100%;
    border-top: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    left: 50%;
  }
  .hori-sitemap ul li:last-of-type:after {
    display: none;
  }
  .hori-sitemap ul li.parent-title::before {
    content: "";
    height: 23px;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 28px;
    left: 0;
  }
  .hori-sitemap ul li.parent-title::after {
    border: none;
  }
  .hori-sitemap ul li .sub-title {
    position: relative;
  }
  .hori-sitemap ul li .sub-title::before {
    content: "";
    height: 21px;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 27px;
    left: 49%;
    margin: 0 auto;
  }
}
.hori-sitemap a {
  color: var(--vz-body-color);
  padding: 4px 0px;
  display: block;
}

.verti-sitemap a {
  color: var(--vz-body-color);
  display: block;
}
.verti-sitemap .parent-title a {
  padding-left: 0;
}
.verti-sitemap .parent-title a:before {
  display: none;
}
.verti-sitemap .parent-title:before {
  display: none;
}
.verti-sitemap .first-list {
  position: relative;
  padding-top: 10px;
}
.verti-sitemap .first-list:before {
  content: "";
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 0;
  height: 100%;
  bottom: 0;
  left: 0;
}
.verti-sitemap .first-list .list-wrap a, .verti-sitemap .first-list li a {
  position: relative;
  padding: 10px 16px 4px 36px;
}
.verti-sitemap .first-list .list-wrap a::before, .verti-sitemap .first-list li a::before {
  content: "";
  width: 24px;
  border-top: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.verti-sitemap .first-list .second-list, .verti-sitemap .first-list .third-list {
  margin-left: 42px;
}
.verti-sitemap .first-list .third-list, .verti-sitemap .first-list .second-list {
  position: relative;
}
.verti-sitemap .first-list .third-list li, .verti-sitemap .first-list .second-list li {
  position: relative;
}
.verti-sitemap .first-list .third-list li:before, .verti-sitemap .first-list .second-list li:before {
  content: "";
  height: 100%;
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 0;
  left: 0;
  margin: 0px auto;
}
.verti-sitemap .first-list .third-list li:last-child::before, .verti-sitemap .first-list .second-list li:last-child::before {
  height: 13px;
}
.verti-sitemap .first-list:last-child::before {
  height: 25px;
}

.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover {
  display: none;
  position: relative;
  margin-bottom: -140px;
}
.team-box .team-cover img, .profile-offcanvas .team-cover img, .modal-team-cover img {
  height: 140px;
  width: 100%;
  object-fit: cover;
}
.team-box .team-cover::before, .profile-offcanvas .team-cover::before, .modal-team-cover::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgb(152.8977272727, 48.0113636364, 9.6022727273), #F26430);
  opacity: 0.6;
}

.team-list.grid-view-filter {
  flex-flow: row wrap;
}
.team-list.grid-view-filter .col {
  flex: 0 0 auto;
  width: 25%;
}
.team-list.grid-view-filter .team-box {
  overflow: hidden;
}
.team-list.grid-view-filter .team-box .team-row {
  align-items: start;
}
.team-list.grid-view-filter .team-box .team-row .col {
  width: 100%;
}
.team-list.grid-view-filter .team-box .team-cover {
  display: block;
}
.team-list.grid-view-filter .team-box .team-settings .col {
  width: 50% !important;
  flex: 0 0 auto;
}
.team-list.grid-view-filter .team-box .team-settings .btn-star {
  color: #fff;
}
.team-list.grid-view-filter .team-box .team-settings .dropdown > a {
  color: #fff;
}
.team-list.grid-view-filter .team-box .team-profile-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
  margin-top: 36px;
}
.team-list.grid-view-filter .team-box .team-profile-img .avatar-lg {
  font-size: 22px;
}
.team-list.grid-view-filter .team-box .team-profile-img .team-content {
  margin-left: 0px;
  margin-top: 25px;
  text-align: center;
}
.team-list.grid-view-filter .team-box .view-btn {
  width: 100%;
  margin-top: 25px;
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 33.33%;
  }
}
@media (max-width: 1199.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 50%;
  }
}
@media (max-width: 767.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }
}
.team-list.list-view-filter {
  flex-direction: column;
}
.team-list.list-view-filter .team-box {
  margin-bottom: 10px;
}
.team-list.list-view-filter .team-box .team-row {
  align-items: center;
  justify-content: space-between;
}
.team-list.list-view-filter .team-box .team-profile-img {
  display: flex;
  align-items: center;
}
.team-list.list-view-filter .team-box .team-profile-img .avatar-lg {
  height: 4rem;
  width: 4rem;
  font-size: 16px;
}
.team-list.list-view-filter .team-box .team-profile-img .team-content {
  margin-left: 15px;
}
.team-list.list-view-filter .team-box .team-settings {
  width: auto;
  flex: 0 0 auto;
  order: 6;
}
.team-list.list-view-filter .team-box .btn-star {
  color: #F26430;
}
@media (max-width: 767.98px) {
  .team-list.list-view-filter {
    flex-direction: row;
  }
  .team-list.list-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }
  .team-list.list-view-filter .team-box .team-settings {
    width: 100%;
    flex: 0 0 auto;
    order: -1;
    margin-bottom: 10px;
  }
  .team-list.list-view-filter .team-box .team-settings .col {
    width: 50%;
  }
  .team-list.list-view-filter .team-box .team-profile-img {
    margin-bottom: 25px;
  }
  .team-list.list-view-filter .team-box .view-btn {
    width: 100%;
    margin-top: 25px;
  }
}

.modal-team-cover {
  display: block;
}

.list-grid-nav .nav-link.active {
  background-color: #299cdb;
  color: #fff;
}

.profile-offcanvas .team-cover {
  margin-bottom: -132px;
  display: block;
  z-index: -1;
}
.profile-offcanvas .btn-star {
  color: #fff;
}
.profile-offcanvas .dropdown > a {
  color: #fff;
}

.countdownlist {
  text-align: center;
  display: flex;
  gap: 24px;
}
.countdownlist .countdownlist-item {
  width: 25%;
}
.countdownlist .countdownlist-item:last-of-type .count-num::after {
  display: none;
}
.countdownlist .count-title {
  font-size: 13px;
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  color: rgba(var(--vz-dark-rgb), 0.5);
  text-transform: uppercase;
}
.countdownlist .count-num {
  background-color: var(--vz-card-bg-custom);
  padding: 16px 8px;
  position: relative;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-weight: 600;
  font-size: 32px;
}
@media (max-width: 575.98px) {
  .countdownlist .count-num {
    font-size: 18px;
  }
}
.countdownlist .count-num::after {
  content: ":";
  font-size: 20px;
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--vz-dark);
}

.move-animation {
  animation: mover 1s infinite alternate;
}

@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-16px);
  }
}
.coming-soon-text {
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 3px 4px #0ab39c;
}

.countdown-input-group {
  max-width: 400px;
}

.search-more-results {
  position: relative;
  overflow: hidden;
}
.search-more-results .nav-icon {
  font-size: 14px;
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  left: 0;
  right: 0;
}
.search-more-results .nav-icon i {
  font-size: 20px;
}
@media (max-width: 767.98px) {
  .search-more-results .nav-icon {
    font-size: 14px;
  }
  .search-more-results .nav-icon i {
    font-size: 18px;
  }
}

.video-list .list-element {
  display: none;
}
.video-list .list-element:nth-child(1) {
  display: block;
}
.video-list .list-element:nth-child(2) {
  display: block;
}
.video-list .list-element:nth-child(3) {
  display: block;
}

.search-voice {
  height: 120px;
  width: 120px;
  line-height: 120px;
  margin: 0px auto;
  text-align: center;
  border-radius: 50%;
  z-index: 1;
  position: relative;
}
.search-voice i {
  line-height: 56px;
  font-size: 30px;
}
.search-voice .voice-wave {
  position: absolute;
  width: 120px;
  height: 120px;
  z-index: -1;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  opacity: 0;
  border-radius: 100px;
  animation: voice-wave 1.8s infinite;
  background-color: var(--vz-light);
}
.search-voice .voice-wave:nth-child(2) {
  animation-delay: 0.3s;
}
.search-voice .voice-wave:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes voice-wave {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.images-menu .swiper-slide {
  width: auto;
  display: inline-block;
}

#selection-element {
  display: none;
}

.filter-choices-input .choices__inner {
  padding: 0;
  border: none;
  background-color: var(--vz-card-bg-custom);
}
.filter-choices-input .choices__input {
  background-color: var(--vz-card-bg-custom);
}

@media (min-width: 992px) {
  .sticky-side-div {
    position: sticky;
    top: calc(70px + 1rem);
  }
}

.product-img-slider .product-nav-slider .nav-slide-item {
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  padding: 0.5rem;
  cursor: pointer;
}
.product-img-slider .product-nav-slider .swiper-slide-thumb-active .nav-slide-item {
  background-color: var(--vz-light);
}

.filter-list a.active .listname {
  color: #0ab39c;
}

.invoice-table tbody:last-child {
  border: none;
}

.currency-select .choices__inner {
  padding: 0px;
  padding-right: 15px;
  min-height: 0px;
}
.currency-select .choices__list--single {
  padding: 0px 16px 0 4px;
}
.currency-select .choices[data-type*=select-one] {
  bottom: 0px;
}
.currency-select .choices[data-type*=select-one] :after {
  top: 4px;
}
.currency-select .choices[data-type*=select-one] .choices__inner {
  padding-bottom: 0px;
}

.chat-wrapper {
  position: relative;
  overflow-x: hidden;
}

.chat-leftsidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg-custom);
}
@media (min-width: 992px) {
  .chat-leftsidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}

.chat-list {
  margin: 0;
}
.chat-list > li.active a {
  background-color: rgba(var(--vz-success-rgb), 0.15);
  color: var(--vz-success);
}
.chat-list > li.active a .badge {
  background-color: rgba(var(--vz-success-rgb), 0.15) !important;
  color: #0ab39c !important;
}
.chat-list > li a {
  display: block;
  padding: 7px 24px;
  color: var(--vz-body-color);
  transition: all 0.4s;
  font-family: "hkgrotesk", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
}
.chat-list > li .chat-user-message {
  font-size: 14px;
}
.chat-list > li .unread-msg-user {
  font-weight: 600;
}
.chat-list > li .unread-message {
  position: absolute;
  display: inline-block;
  right: 24px;
  left: auto;
  top: 33px;
}
.chat-list > li .unread-message .badge {
  line-height: 16px;
  font-weight: 600;
  font-size: 10px;
}

.chat-user-img {
  position: relative;
}
.chat-user-img .user-status {
  width: 10px;
  height: 10px;
  background-color: #adb5bd;
  border-radius: 50%;
  border: 2px solid var(--vz-card-bg-custom);
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
}
.chat-user-img.online .user-status {
  background-color: #0ab39c;
}
.chat-user-img.away .user-status {
  background-color: #3FBF48;
}

.chat-room-list {
  max-height: calc(100vh - 296px);
}
@media (max-width: 991.98px) {
  .chat-room-list {
    height: calc(100vh - 296px);
  }
}

.contact-list li {
  cursor: pointer;
  padding: 8px 24px;
  transition: all 0.4s;
  color: var(--vz-body-color);
  font-family: "hkgrotesk", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
}

.contact-list-title {
  padding: 6px 24px;
  color: #F26430;
  font-weight: 500;
  position: relative;
  font-size: 12px;
}
.contact-list-title:after {
  content: "";
  height: 1px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 50px;
  right: 0;
  background-color: var(--vz-light);
}

.user-chat {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  transition: all 0.4s;
  position: relative;
  background-color: var(--vz-body-bg);
}
@media (max-width: 991.98px) {
  .user-chat {
    position: absolute;
    left: 0;
    top: 3px;
    width: 100%;
    height: calc(100% - 3px);
    visibility: hidden;
    transform: translateX(100%);
    z-index: 99;
    padding-top: 70px;
  }
  .user-chat.user-chat-show {
    visibility: visible;
    transform: translateX(0);
  }
}
.user-chat .chat-content {
  position: relative;
}
.user-chat.user-chat-show .chat-welcome-section {
  display: none;
}
@media (min-width: 992px) {
  .user-chat.user-chat-show .chat-content {
    display: flex !important;
  }
}

.user-chat-topbar {
  border-bottom: 1px solid transparent;
  background-color: var(--vz-card-bg-custom);
}
@media (max-width: 991.98px) {
  .user-chat-topbar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
  }
}

.user-chat-nav .nav-btn {
  height: 40px;
  width: 40px;
  line-height: 40px;
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  color: #343a40;
}
@media (max-width: 575.98px) {
  .user-chat-nav {
    display: flex;
    justify-content: flex-end;
  }
}

.chat-conversation {
  height: calc(100vh - 299px) !important;
}
@media (max-width: 991.98px) {
  .chat-conversation {
    height: calc(100vh - 275px) !important;
  }
}
.chat-conversation .simplebar-content-wrapper {
  display: flex;
  flex-direction: column;
}
.chat-conversation .simplebar-content-wrapper .simplebar-content {
  margin-top: auto;
}
.chat-conversation .chat-conversation-list {
  padding-top: 10px;
  margin-bottom: 0;
}
.chat-conversation .chat-conversation-list > li {
  display: flex;
}
.chat-conversation li:last-of-type .conversation-list {
  margin-bottom: 0;
}
.chat-conversation .chat-list.left .check-message-icon {
  display: none;
}
.chat-conversation .chat-list .message-box-drop {
  visibility: hidden;
}
.chat-conversation .chat-list:hover .message-box-drop {
  visibility: visible;
}
.chat-conversation .chat-avatar {
  margin: 0 16px 0 0;
}
.chat-conversation .chat-avatar img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 12px;
  width: 100%;
}
.chat-conversation .chat-day-title .title {
  background-color: #fff;
  position: relative;
  font-size: 13px;
  z-index: 1;
  padding: 6px 12px;
  border-radius: 5px;
}
.chat-conversation .chat-day-title:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: rgba(242, 100, 48, 0.2);
  top: 10px;
}
.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-flex;
  position: relative;
  align-items: flex-end;
  max-width: 80%;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list {
    max-width: 90%;
  }
}
.chat-conversation .conversation-list .ctext-wrap {
  display: flex;
  margin-bottom: 10px;
}
.chat-conversation .conversation-list .ctext-content {
  word-wrap: break-word;
  word-break: break-word;
}
.chat-conversation .conversation-list .ctext-wrap-content {
  padding: 12px 20px;
  background-color: var(--vz-light);
  position: relative;
  border-radius: 3px;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .ctext-wrap-content .attached-file .attached-file-avatar {
    display: none;
  }
  .chat-conversation .conversation-list .ctext-wrap-content .attached-file .dropdown .dropdown-toggle {
    display: block;
  }
}
.chat-conversation .conversation-list .conversation-name {
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #878a99;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle::after {
  display: none;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .dropdown .dropdown-toggle {
    display: none;
  }
}
.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}
.chat-conversation .conversation-list .message-img {
  border-radius: 0.2rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chat-conversation .conversation-list .message-img .message-img-list {
  position: relative;
}
.chat-conversation .conversation-list .message-img img {
  max-width: 150px;
}
.chat-conversation .conversation-list .message-img .message-img-link {
  position: absolute;
  right: 10px;
  left: auto;
  bottom: 10px;
}
.chat-conversation .conversation-list .message-img .message-img-link li > a {
  font-size: 18px;
  color: #fff;
  display: inline-block;
  line-height: 20px;
  width: 26px;
  height: 24px;
  border-radius: 3px;
  background-color: rgba(33, 37, 41, 0.7);
  text-align: center;
}
.chat-conversation .right {
  justify-content: flex-end;
}
.chat-conversation .right .chat-avatar {
  order: 3;
  margin-right: 0px;
  margin-left: 16px;
}
.chat-conversation .right .chat-time {
  text-align: left;
  color: #878a99;
}
.chat-conversation .right .conversation-list {
  text-align: right;
}
.chat-conversation .right .conversation-list .ctext-wrap {
  justify-content: flex-end;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {
  order: 2;
  background-color: rgba(var(--vz-success-rgb), 0.15);
  color: var(--vz-success);
  text-align: right;
  box-shadow: none;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block {
  background-color: rgba(255, 255, 255, 0.5);
  border-color: rgba(var(--vz-success-rgb), 1);
  color: #212529;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block .conversation-name {
  color: rgba(var(--vz-success-rgb), 1);
}
.chat-conversation .right .conversation-list .conversation-name {
  justify-content: flex-end;
}
.chat-conversation .right .conversation-list .conversation-name .check-message-icon {
  order: 1;
}
.chat-conversation .right .conversation-list .conversation-name .time {
  order: 2;
}
.chat-conversation .right .conversation-list .conversation-name .name {
  order: 3;
}
.chat-conversation .right .conversation-list .dropdown {
  order: 1;
}
.chat-conversation .right .dot {
  background-color: #212529;
}

.chat-input-section {
  border-top: 1px solid transparent;
  background-color: var(--vz-card-bg-custom);
  position: relative;
  z-index: 1;
}
.chat-input-section .chat-input-feedback {
  display: none;
  position: absolute;
  top: -20px;
  left: 4px;
  font-size: 12px;
  color: #f06548;
}
.chat-input-section .show {
  display: block;
}

.chat-input-links {
  display: flex;
}
.chat-input-links .links-list-item > .btn {
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  width: 37.5px;
  height: 37.5px;
}
.chat-input-links .links-list-item > .btn.btn-link {
  color: #878a99;
}

.copyclipboard-alert {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: none;
}

.replyCard {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid var(--vz-border-color);
  overflow: hidden;
  opacity: 0;
  bottom: 0;
  border-radius: 0;
  transition: all 0.4s;
}
@media (max-width: 991.98px) {
  .replyCard {
    bottom: -12px;
  }
}
.replyCard.show {
  transform: translateY(-88px);
  opacity: 1;
}
@media (max-width: 991.98px) {
  .replyCard.show {
    transform: translateY(-83px);
  }
}

.replymessage-block {
  padding: 12px 20px;
  margin-bottom: 8px;
  text-align: left;
  border-radius: 4px;
  background-color: rgba(var(--vz-success-rgb), 0.1);
  border-left: 2px solid rgba(var(--vz-success-rgb), 1);
}
.replymessage-block .conversation-name {
  color: rgba(var(--vz-success-rgb), 1);
  font-size: 14px;
}

.chat-sm .ctext-wrap-content {
  box-shadow: none !important;
}
.chat-sm .message-img img {
  max-width: 90px !important;
}
.chat-sm .message-img-link {
  bottom: 0 !important;
  right: 5px !important;
}

@media (min-width: 1025px) {
  [data-layout=horizontal] .chat-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-wrapper {
    margin-top: 0 !important;
  }
}
[data-layout=horizontal] .chat-leftsidebar {
  height: calc(100vh - 70px - 60px - 54px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-leftsidebar {
    height: calc(100vh - 70px - 60px - 8px);
  }
}
[data-layout=horizontal] .chat-room-list {
  height: calc(100vh - 352px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-room-list {
    height: calc(100vh - 265px);
  }
}
[data-layout=horizontal] .chat-conversation {
  height: calc(100vh - 343px) !important;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-conversation {
    height: calc(100vh - 275px) !important;
  }
}

.email-wrapper {
  position: relative;
  overflow-x: hidden;
}

.email-menu-sidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.2s;
}
@media (min-width: 992px) {
  .email-menu-sidebar {
    min-width: 250px;
    max-width: 250px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}
@media (max-width: 991.98px) {
  .email-menu-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }
  .email-menu-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}
.email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 295px);
}
@media (max-width: 991.98px) {
  .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}

.mail-list a {
  display: flex;
  align-items: center;
  color: #878a99;
  padding: 5px 0;
  font-weight: 500;
}
.mail-list a:hover {
  color: #F26430;
}
.mail-list a i {
  font-size: 14px;
}
.mail-list a.active {
  color: #0ab39c;
  font-weight: 600;
}
.mail-list a.active i {
  color: #0ab39c;
}

.email-chat-list a {
  padding: 6px 24px;
}
.email-chat-list a.active {
  background-color: rgba(var(--vz-light-rgb), 0.7);
}

.email-topbar-link .btn-ghost-secondary {
  color: #878a99;
}
.email-topbar-link .btn-ghost-secondary:hover {
  color: #208C3B;
}

.email-content {
  width: 100%;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.2s;
}

.unreadConversations-alert {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.email-detail-content {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 68%;
  width: 32%;
  background-color: var(--vz-card-bg-custom);
  transform: translateX(200%);
  transition: all 0.2s;
  visibility: hidden;
  border-left: 2px solid var(--vz-body-bg);
}

.email-detail-show .email-detail-content {
  transform: none;
  visibility: visible;
}
.email-detail-show .email-content {
  margin-right: 32%;
}
@media (max-width: 1349.98px) {
  .email-detail-show .email-content {
    margin-right: 0;
  }
}

.email-detail-content-scroll {
  height: calc(100vh - 390px);
}
@media (max-width: 1349.98px) {
  .email-detail-content-scroll {
    height: calc(100vh - 252px);
  }
}

.message-list-content {
  height: calc(100vh - 242px);
}
@media (max-width: 575.98px) {
  .message-list-content {
    height: calc(100vh - 230px);
  }
}

.message-list {
  display: block;
  padding-left: 0;
  margin: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  transition-duration: 0.3s;
  clear: both;
}
.message-list li a {
  color: var(--vz-gray-700);
}
.message-list li:hover {
  background: var(--vz-light);
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 280px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 0 0 20px;
  line-height: normal;
}
.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 95px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}
@media (max-width: 575.98px) {
  .message-list li .col-mail-1 .title {
    left: 95px;
  }
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 280px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .subject .teaser {
  color: var(--vz-gray-600);
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 100px;
  padding-left: 20px;
}
.message-list li.active, .message-list li.active:hover {
  box-shadow: inset 3px 0 0 #F26430;
  background-color: var(--vz-light);
}
.message-list li.unread {
  color: var(--vz-gray-800);
}
.message-list li.unread a {
  color: var(--vz-gray-800);
  font-weight: 600;
}

#unreadConversations,
#email-topbar-actions {
  display: none;
}

#elmLoader {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.email-compose-input {
  padding-right: 80px;
}

@media (max-width: 1349.98px) {
  .email-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
  }
  .email-detail-show .email-detail-content {
    transform: none;
  }
}
@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 180px;
  }
}
.email-editor .ck-editor__editable_inline {
  min-height: 200px !important;
}

.email-chat-detail {
  width: 350px;
  position: fixed;
  max-width: 100%;
  bottom: 60px;
  right: 60px;
  z-index: 9;
  display: none;
}
.email-chat-detail .card {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}
@media (max-width: 515.98px) {
  .email-chat-detail {
    left: 16px;
    right: 16px;
  }
}

@media (min-width: 1025px) {
  [data-layout=horizontal] .email-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-wrapper {
    margin-top: 0 !important;
  }
}
[data-layout=horizontal] .email-menu-sidebar {
  height: calc(100vh - 70px - 60px - 54px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-menu-sidebar {
    height: 100vh;
  }
}
[data-layout=horizontal] .email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 330px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}
[data-layout=horizontal] .message-list-content {
  height: calc(100vh - 289px);
}
[data-layout=horizontal] .email-detail-content-scroll {
  height: calc(100vh - 435px);
}
@media (max-width: 1349.98px) {
  [data-layout=horizontal] .email-detail-content-scroll {
    height: calc(100vh - 252px);
  }
}

.email-chat-element .chat-conversation1 {
  height: 250px !important;
}

.tasks-board {
  display: flex;
  overflow-x: auto;
  align-items: stretch;
}
.tasks-board .tasks-list {
  min-width: 300px;
  margin-right: 24px;
}
.tasks-board::-webkit-scrollbar {
  -webkit-appearance: none;
}
.tasks-board::-webkit-scrollbar:vertical {
  width: 10px;
}
.tasks-board::-webkit-scrollbar:horizontal {
  height: 8px;
}
.tasks-board::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
.tasks-board::-webkit-scrollbar-track {
  border-radius: 8px;
}

.tasks-box .progress {
  border-radius: 0px 0px 0.25rem 0.25rem;
}
.tasks-box .tasks-img {
  height: 135px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin: 12px 0px;
}
.tasks-box:last-child {
  margin-bottom: 0px;
}

.tasks-wrapper {
  max-height: calc(100vh - 418px);
}

.tasks {
  min-height: 180px;
  position: relative;
}
.tasks.noTask::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 180px;
  width: 270px;
  margin: 0 auto;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  background-size: cover;
  background-position: center;
}

#tasksList tr .tasks-list-menu {
  opacity: 0;
}
#tasksList tr:hover .tasks-list-menu {
  opacity: 1;
}

.layout-wrapper.landing {
  background-color: var(--vz-card-bg-custom);
  font-size: 15px;
}

.section {
  padding: 90px 0;
  position: relative;
}
@media (max-width: 767.98px) {
  .section {
    padding: 50px 0;
  }
}

.icon-effect {
  position: relative;
}
.icon-effect::before {
  content: "";
  position: absolute;
  width: 24px;
  height: 24px;
  background-color: rgba(10, 179, 156, 0.2);
  border-radius: 50%;
  bottom: 0;
  left: 0;
}

.navbar-landing {
  padding: 10px 0px;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .navbar-landing {
    background-color: var(--vz-card-bg-custom);
    box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
    padding: 10px 8px;
  }
}
.navbar-landing .navbar-nav .nav-item .nav-link {
  font-size: 16px;
  font-weight: 500;
  transition: all 0.4s;
  font-family: "hkgrotesk", sans-serif;
  color: var(--vz-dark);
  padding: 14px;
}
@media (max-width: 991.98px) {
  .navbar-landing .navbar-nav .nav-item .nav-link {
    padding: 8px 0px;
  }
}
.navbar-landing .navbar-nav .nav-item .nav-link:hover, .navbar-landing .navbar-nav .nav-item .nav-link.active, .navbar-landing .navbar-nav .nav-item .nav-link:focus {
  color: #0ab39c !important;
}
.navbar-landing .navbar-nav .nav-item.active .nav-link {
  color: #0ab39c !important;
}
.navbar-landing.is-sticky {
  background-color: var(--vz-card-bg-custom);
  box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
}

.navbar-light .navbar-brand .card-logo-dark {
  display: none;
}
.navbar-light .navbar-brand .card-logo-light {
  display: block;
}
.navbar-light .navbar-nav .nav-item .nav-link {
  color: rgba(var(--vz-white-rgb), 0.75);
}
.navbar-light.is-sticky .navbar-nav .nav-item .nav-link {
  color: var(--vz-dark);
}
.navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: block;
}
.navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: none;
}

.hero-section {
  background-color: rgba(var(--vz-light-rgb), 0.5);
}
.hero-section .hero-shape-svg svg path {
  fill: var(--vz-card-bg-custom);
}

.bg-overlay-pattern {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  background-color: transparent;
  background-position: center;
  background-size: cover;
  opacity: 0.2;
}

.demo-carousel {
  position: relative;
  z-index: 1;
}
.demo-carousel .carousel-item .demo-item {
  background-color: var(--vz-card-bg-custom);
  padding: 8px;
  border-radius: 7px;
}
.demo-carousel .demo-img-patten-top {
  position: absolute;
  right: -50px;
  top: -16px;
  max-width: 230px;
}
.demo-carousel .demo-img-patten-bottom {
  position: absolute;
  left: -70px;
  bottom: -50px;
  max-width: 230px;
}

.client-images img {
  max-height: 45px;
  width: auto;
  margin: 12px auto;
  transition: all 0.4s;
}

.plan-box {
  max-width: 356px;
  margin-left: auto;
  margin-right: auto;
}

.process-card {
  position: relative;
}
.process-card .process-arrow-img {
  position: absolute;
  left: 75%;
  top: 7%;
  width: 50%;
  opacity: 0.1;
}

.custom-footer {
  color: #9ba7b3;
}

.footer-list li a {
  color: #9ba7b3;
  padding: 7px 0;
  display: block;
  transition: all 0.3s ease-in-out;
}
.footer-list li a:hover {
  color: rgba(255, 255, 255, 0.9);
}

.footer-social-link .avatar-title {
  color: #778089;
  background-color: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}
.footer-social-link .avatar-title:hover {
  color: #fff;
  background-color: #F26430;
}

#back-to-top.landing-back-top {
  bottom: 35px;
}

[data-layout-mode=dark] .layout-wrapper.landing .demo-img-patten-top,
[data-layout-mode=dark] .layout-wrapper.landing .demo-img-patten-bottom {
  opacity: 0.2;
}
[data-layout-mode=dark] .layout-wrapper.landing footer.bg-dark {
  background-color: var(--vz-card-bg-custom) !important;
}
[data-layout-mode=dark] .navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: none;
}
[data-layout-mode=dark] .navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: block;
}

.bookmark-icon .btn {
  color: #878a99;
  background-color: var(--vz-light);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-size: 0.8125rem;
}
.bookmark-icon .btn:hover, .bookmark-icon .btn.active {
  border-color: transparent;
  color: #f06548;
}

.explore-box {
  border-radius: 9px;
  overflow: hidden;
}
.explore-box .explore-img {
  height: 280px;
  object-fit: cover;
}
.explore-box .explore-place-bid-img {
  position: relative;
  overflow: hidden;
  z-index: 0;
}
.explore-box .explore-place-bid-img .bg-overlay {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(33, 37, 41, 0.4);
  opacity: 0;
  transition: all 0.5s ease;
}
.explore-box .explore-place-bid-img .place-bid-btn {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
.explore-box .explore-place-bid-img .place-bid-btn .btn {
  opacity: 0;
  bottom: -25px;
  transition: 0.5s ease;
}
.explore-box:hover .explore-place-bid-img .place-bid-btn .btn {
  opacity: 1;
  bottom: 0;
}
.explore-box:hover .explore-place-bid-img .bg-overlay {
  opacity: 1;
}
.explore-box .discount-time {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(5px);
  padding: 8px;
}

.nft-hero {
  background-size: cover;
  background-position: bottom;
  padding: 222px 0 150px 0;
}
.nft-hero .bg-overlay {
  background-color: #05175f;
  opacity: 0.85;
}

#explorecard-list .list-element {
  display: none;
}
#explorecard-list .list-element:nth-child(-n+10) {
  display: block;
}

.file-manager-menu {
  max-height: calc(100vh - 296px);
}
@media (max-width: 991.98px) {
  .file-manager-menu {
    height: calc(100vh - 296px);
  }
}
.file-manager-menu li {
  padding: 5px 0px;
}
.file-manager-menu li a {
  color: var(--vz-dark);
  font-weight: 500;
  transition: all 0.5s ease;
}
.file-manager-menu li a.active, .file-manager-menu li a:hover, .file-manager-menu li a[aria-expanded=true] {
  color: #0ab39c;
}
.file-manager-menu li .sub-menu li {
  padding-left: 25px;
  position: relative;
}
.file-manager-menu li .sub-menu li::before {
  content: "\\f0374";
  position: absolute;
  left: 0px;
  font-family: Material Design Icons;
  color: rgba(var(--vz-dark-rgb), 0.4);
}

.file-manager-sidebar {
  position: relative;
  background-color: var(--vz-card-bg-custom);
}
@media (min-width: 992px) {
  .file-manager-sidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}
@media (max-width: 991.98px) {
  .file-manager-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }
  .file-manager-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}

.file-menu-sidebar-scroll {
  height: calc(100vh - 375px);
}
@media (max-width: 991.98px) {
  .file-menu-sidebar-scroll {
    height: calc(100vh - 190px);
  }
}

.file-manager-content {
  background-color: var(--vz-card-bg-custom);
}

.file-manager-content-scroll {
  height: calc(100vh - 185px);
  overflow-y: auto;
}
.file-manager-content-scroll::-webkit-scrollbar {
  -webkit-appearance: none;
}
.file-manager-content-scroll::-webkit-scrollbar:vertical {
  width: 12px;
}
.file-manager-content-scroll::-webkit-scrollbar:horizontal {
  height: 12px;
}
.file-manager-content-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 10px;
  border: 2px solid var(--vz-card-bg-custom);
}
.file-manager-content-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-card-bg-custom);
}
@media (max-width: 991.98px) {
  .file-manager-content-scroll {
    height: calc(100vh - 144px);
  }
}
.file-manager-content-scroll .simplebar-content {
  height: 100%;
}

.file-detail-content-scroll {
  height: calc(100vh - 180px);
}
@media (max-width: 991.98px) {
  .file-detail-content-scroll {
    height: 100vh;
  }
}
.file-detail-content-scroll .simplebar-content {
  height: 100%;
}

.file-manager-detail-content {
  width: 32%;
  max-width: 100%;
  background-color: var(--vz-card-bg-custom);
  display: none;
}

.file-detail-show .file-manager-detail-content {
  display: block;
}

#file-overview {
  display: none;
}

@media (max-width: 1399.98px) {
  .file-manager-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
  }
  .file-detail-show .file-manager-detail-content {
    transform: none;
  }
}
.file-details-box {
  height: 195px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.to-do-menu li .nav-link {
  color: var(--vz-body-color);
  padding-left: 0;
  font-weight: 500;
  background-color: var(--vz-light);
  padding: 10px 12px;
  border-radius: 4px;
  display: block;
  margin-bottom: 8px;
}
.to-do-menu li .nav-link:hover, .to-do-menu li .nav-link.active {
  color: #0ab39c;
}

.todo-content {
  height: calc(100vh - 362px);
  overflow-y: auto;
}
.todo-content::-webkit-scrollbar {
  -webkit-appearance: none;
}
.todo-content::-webkit-scrollbar:vertical {
  width: 8px;
}
.todo-content::-webkit-scrollbar:horizontal {
  height: 10px;
}
.todo-content::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
.todo-content::-webkit-scrollbar-track {
  border-radius: 8px;
}

.todo-task table .form-check .form-check-input:checked + .form-check-label {
  text-decoration: line-through;
}

.task-handle {
  cursor: move;
}

#task-error-msg {
  display: none;
}

.bg-job {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  background-size: cover;
  background-position: center;
}

.job-list-view-card .background {
  height: 130px;
}

@media (min-width: 1400px) and (max-width: 1499.98px) {
  .job-list-row.row .col-xxl-3 {
    width: 33%;
  }
}

.custom-container {
  width: 90%;
}

.job-navbar .dropdown-menu .dropdown-item .avatar-sm {
  height: 2.5rem;
  width: 2.5rem;
}
@media (max-width: 991.98px) {
  .job-navbar {
    background-color: var(--vz-card-bg-custom);
    padding: 16px 0;
  }
}

.job-hero-section {
  position: relative;
  padding: 165px 0;
  overflow-x: hidden;
}

.job-panel-filter {
  background-color: var(--vz-card-bg-custom);
  border-radius: 0.25rem;
  overflow: hidden;
}
.job-panel-filter .form-control {
  height: 45px;
  border: none;
  border-radius: 0;
  background-color: transparent;
}
.job-panel-filter .btn {
  border-radius: 0;
}
.job-panel-filter input.form-control {
  border-right: 1px solid var(--vz-border-color);
}
@media (max-width: 767.98px) {
  .job-panel-filter {
    background-color: transparent;
  }
  .job-panel-filter .form-control {
    background-color: #fff;
    border-radius: 0.25rem;
  }
  .job-panel-filter input.form-control {
    border: 0;
  }
  .job-panel-filter .btn {
    border-radius: 0.25rem;
  }
}

.circle-effect {
  position: absolute;
  top: 0;
  z-index: 0;
  right: -55px;
  margin: 0 auto;
}
.circle-effect .circle {
  border: 1px solid var(--vz-border-color);
  height: 240px;
  width: 240px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle2 {
  position: absolute;
  top: -20px;
  right: -20px;
  border: 1px solid var(--vz-border-color);
  height: 280px;
  width: 280px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle3 {
  position: absolute;
  top: -40px;
  right: -40px;
  border: 1px solid var(--vz-border-color);
  height: 320px;
  width: 320px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle4 {
  position: absolute;
  top: -60px;
  right: -60px;
  border: 1px solid var(--vz-border-color);
  height: 360px;
  width: 360px;
  margin: 0 auto;
  border-radius: 50%;
}
@media (max-width: 991.98px) {
  .circle-effect {
    display: none;
  }
}

.home-img .user-img {
  position: relative;
  z-index: 1;
}

.application-box,
.feedback-box,
.inquiry-box {
  max-width: 240px;
  position: absolute;
  z-index: 2;
  transition: all 0.5s ease;
}
.application-box:hover,
.feedback-box:hover,
.inquiry-box:hover {
  transform: translateY(-5px);
}

.inquiry-box {
  left: -134px;
  top: 90px;
}
@media (max-width: 991.98px) {
  .inquiry-box {
    left: 0;
  }
}

.application-box {
  bottom: 50px;
  right: -160px;
}
@media (max-width: 991.98px) {
  .application-box {
    right: 0;
  }
}

.feedback-box {
  right: -50px;
  bottom: -54px;
}
@media (max-width: 576.98px) {
  .feedback-box {
    right: 0;
    bottom: 0;
  }
}

.job-icon-effect {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 0px;
  left: -2%;
  border-radius: 50%;
  background: repeating-linear-gradient(-55deg, rgba(255, 255, 255, 0) 0.8px, #0ab39c 1.6px, #0ab39c 2px, rgba(255, 255, 255, 0) 3.8px, rgba(255, 255, 255, 0) 5px);
  z-index: 0;
  opacity: 0.2;
}
.job-icon-effect span {
  position: relative;
  z-index: 1;
}

.about-img-section {
  position: relative;
}
.about-img-section::before {
  content: "";
  position: absolute;
  left: 20px;
  right: -20px;
  top: -20px;
  bottom: 20px;
  border: 1px solid #299cdb;
  z-index: 0;
  border-radius: 0.25rem;
}
@media (max-width: 576.98px) {
  .about-img-section::before {
    right: 20px;
    top: 20px;
  }
}

.features-company-widgets {
  position: absolute;
  bottom: -18px;
  right: -35px;
}

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Custom Css File
*/
.css-b62m3t-container .css-13cymwt-control {
  background-color: #fff; /* input bg */
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-13cymwt-control:hover {
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-t3ipsp-control {
  background-color: var(--vz-gray-200);
  border-color: var(--vz-border-color);
  box-shadow: none;
}
.css-b62m3t-container .css-t3ipsp-control:hover {
  border-color: var(--vz-border-color) !important;
}
.css-b62m3t-container .css-1nmdiq5-menu {
  background-color: var(--vz-gray-200);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-10wo9uf-option {
  cursor: pointer;
  background-color: var(--vz-gray-200);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-10wo9uf-option:active {
  background-color: var(--vz-gray-200);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option {
  cursor: pointer;
  background-color: var(--vz-gray-100);
}
.css-b62m3t-container .css-1p3m7a8-multiValue {
  background-color: var(--vz-light);
}
.css-b62m3t-container .css-wsp0cs-MultiValueGeneric {
  color: var(--vz-heading-color);
}
.css-b62m3t-container .css-12jo7m5 {
  color: var(--vz-heading-color);
}
.css-b62m3t-container .css-6j8wv5-Input,
.css-b62m3t-container .css-qc6sy-singleValue {
  color: var(--vz-heading-color);
}
.css-b62m3t-container .css-1dimb5e-singleValue {
  color: var(--vz-body-color);
}

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 24px;
}

.marquee {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 22px;
  line-height: 2;
}

.marquee div {
  display: block;
  width: 200%;
  height: 30px;
  position: absolute;
  overflow: hidden;
  animation: marquee 35s linear infinite;
}

.marquee span {
  float: left;
  width: 50%;
}

@keyframes marquee {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
.kVrXuC,
.dwPlXY,
.gKbhqU,
.iSAVrt {
  background-color: transparent !important;
  color: var(--vz-body-color) !important;
}

.fyrdjl {
  color: rgba(var(--vz-body-color-rgb), 0.54) !important;
  fill: rgba(var(--vz-body-color-rgb), 0.54) !important;
}

.fyrdjl:disabled {
  color: rgba(var(--vz-body-color-rgb), 0.18) !important;
  fill: rgba(var(--vz-body-color-rgb), 0.18) !important;
}

.iSAVrt {
  background-color: var(--vz-card-bg-custom) !important;
  border-bottom-color: var(--vz-border-color) !important;
}

.dwPlXY:not(:last-of-type) {
  border-bottom-color: var(--vz-border-color) !important;
}

* {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-variation-settings: "slnt" 0;
}

.offcanvas-header-dark .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

body * {
  outline: none;
  margin: 0;
}

.noUi-horizontal .noUi-handle {
  height: 16px !important;
  width: 16px !important;
  border-radius: 50% !important;
  right: -10px !important;
  top: -7px !important;
}

.noUi-connect,
.noUi-horizontal {
  height: 2px !important;
}

.noUi-handle {
  background: #0ab39c !important;
  border: 2px solid var(--vz-card-bg) !important;
  box-shadow: none !important;
}

.noUi-target {
  background: #fafafa !important;
  border-radius: 4px !important;
  border: 1px solid #d3d3d3 !important;
  background-color: var(--vz-light) !important;
  border-color: var(--vz-light) !important;
  box-shadow: none !important;
  height: 4px !important;
}

.dropzone .dz-message {
  text-align: center;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  padding: 5px !important;
  font-size: 12px !important;
  margin-right: 2px;
}

.fc-event {
  border: none !important;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    display: block !important;
    text-align: center;
  }
  .fc-toolbar .fc-left,
  .fc-toolbar .fc-right,
  .fc-toolbar .fc-center {
    float: none;
    display: block;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc-today-button {
    display: none;
  }
}
.flatpickr-calendar.open {
  z-index: 1090 !important;
}

.upcoming-scheduled .flatpickr-input[readonly] {
  display: none;
}

.ql-container.ql-snow {
  height: 250px;
}

.rangeslider-horizontal .rangeslider__fill {
  background-color: #405189 !important;
}

.simplebar-track-primary .simplebar-scrollbar:before {
  background: #F26430 !important;
}

.simplebar-track-secondary .simplebar-scrollbar:before {
  background: #208C3B !important;
}

.simplebar-track-success .simplebar-scrollbar:before {
  background: #0ab39c !important;
}

.simplebar-track-info .simplebar-scrollbar:before {
  background: #299cdb !important;
}

.simplebar-track-warning .simplebar-scrollbar:before {
  background: #3FBF48 !important;
}

.simplebar-track-danger .simplebar-scrollbar:before {
  background: #f06548 !important;
}

.simplebar-track-light .simplebar-scrollbar:before {
  background: #f3f6f9 !important;
}

.simplebar-track-dark .simplebar-scrollbar:before {
  background: #212529 !important;
}

.chat-conversation .chat-list .message-box-drop .nav-btn {
  font-size: 18px;
  padding: 4px;
  color: #878a99;
}

.chatwidgets {
  height: 250px !important;
}

[data-layout=horizontal] .chat-conversation.chatwidgets {
  height: 250px !important;
}

#tsparticles canvas {
  position: absolute !important;
}

.alert-msg-show {
  right: 24px;
  top: 40px;
  z-index: 1005;
}

.pickerEmoji {
  position: absolute;
  bottom: -50px;
  left: 10%;
  transform: translateX(-50%);
}

.Toastify .Toastify__toast {
  min-height: 43px;
}
.Toastify .Toastify__close-button {
  top: 6px;
}
.Toastify .Toastify__close-button--light {
  color: #f3f6f9;
}

.rdl-filter,
.rdl-control {
  background-color: var(--vz-input-bg);
  border: 1px solid var(--vz-input-border) !important;
  color: var(--vz-body-color) !important;
}

.rdl-move {
  background: var(--vz-light) !important;
  border: 1px solid var(--vz-light) !important;
  color: var(--vz-body-color) !important;
}

.react-dual-listbox input:disabled,
.react-dual-listbox select:disabled {
  background-color: var(--vz-input-disabled-bg) !important;
  border: 1px solid var(--vz-input-border) !important;
}

.css-26l3qy-menu {
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important;
}

.css-1n7v3ny-option {
  background-color: var(--vz-gray-300) !important;
  border-color: var(--vz-border-color) !important;
}

/* 
.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels {
  display: inline-flex;
  animation: none;
  flex-wrap: nowrap;
  direction: ltr;

  @media (max-width: 768px) {
    display: inline-grid;
  }
} */
/* .ant-picker-dropdown {
  @media (max-width: 768px) {
    inset: 51.9333px auto auto 0px !important;
  }
}
 */
@media (max-width: 768px) {
  .ant-picker-dropdown .ant-picker-panel-container {
    max-width: 90vw !important;
    overflow: auto !important;
    /*   inset: 51.9333px auto auto 0px !important; */
  }
}

.card-footer {
  background-color: transparent !important;
}

.gm-style iframe + div {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/themes.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/plugins/icons/_boxicons.scss","webpack://./src/assets/scss/plugins/icons/_line-awesome.scss","webpack://./src/assets/scss/plugins/icons/_remixicon.scss","webpack://./src/assets/scss/config/default/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/config/default/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/config/default/app.scss","webpack://./src/assets/scss/fonts/_fonts.scss","webpack://./src/assets/scss/config/default/_theme-light.scss","webpack://./src/assets/scss/config/default/_theme-dark.scss","webpack://./src/assets/scss/structure/_topbar.scss","webpack://./src/assets/scss/structure/_page-head.scss","webpack://./src/assets/scss/structure/_footer.scss","webpack://./src/assets/scss/structure/_vertical.scss","webpack://./src/assets/scss/structure/_horizontal.scss","webpack://./src/assets/scss/structure/_two-column.scss","webpack://./src/assets/scss/structure/_layouts.scss","webpack://./src/assets/scss/components/_waves.scss","webpack://./src/assets/scss/components/_avatar.scss","webpack://./src/assets/scss/components/_accordion.scss","webpack://./src/assets/scss/components/_helper.scss","webpack://./src/assets/scss/components/_preloader.scss","webpack://./src/assets/scss/components/_forms.scss","webpack://./src/assets/scss/components/_widgets.scss","webpack://./src/assets/scss/components/_demos.scss","webpack://./src/assets/scss/components/_print.scss","webpack://./src/assets/scss/components/_ribbons.scss","webpack://./src/assets/scss/components/_toast.scss","webpack://./src/assets/scss/components/_scrollspy.scss","webpack://./src/assets/scss/components/_reboot.scss","webpack://./src/assets/scss/components/_alerts.scss","webpack://./src/assets/scss/components/_backgrounds.scss","webpack://./src/assets/scss/components/_badge.scss","webpack://./src/assets/scss/components/_buttons.scss","webpack://./src/assets/scss/components/_breadcrumb.scss","webpack://./src/assets/scss/components/_card.scss","webpack://./src/assets/scss/components/_dropdown.scss","webpack://./src/assets/scss/components/_nav.scss","webpack://./src/assets/scss/components/_table.scss","webpack://./src/assets/scss/components/_modal.scss","webpack://./src/assets/scss/components/_pagination.scss","webpack://./src/assets/scss/components/_progress.scss","webpack://./src/assets/scss/components/_popover.scss","webpack://./src/assets/scss/components/_type.scss","webpack://./src/assets/scss/components/_form-check.scss","webpack://./src/assets/scss/components/_form-control.scss","webpack://./src/assets/scss/components/_list-group.scss","webpack://./src/assets/scss/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/plugins/_prismjs.scss","webpack://./src/assets/scss/plugins/_sweetalert2.scss","webpack://./src/assets/scss/plugins/_dropzone.scss","webpack://./src/assets/scss/plugins/_range-slider.scss","webpack://./src/assets/scss/plugins/_sortablejs.scss","webpack://./src/assets/scss/plugins/_tour.scss","webpack://./src/assets/scss/plugins/_swiper.scss","webpack://./src/assets/scss/plugins/_multijs.scss","webpack://./src/assets/scss/plugins/_colorpicker.scss","webpack://./src/assets/scss/plugins/_filepond.scss","webpack://./src/assets/scss/plugins/_form-input-spin.scss","webpack://./src/assets/scss/plugins/_ckeditor.scss","webpack://./src/assets/scss/plugins/_quilljs.scss","webpack://./src/assets/scss/plugins/_gridjs.scss","webpack://./src/assets/scss/plugins/_listjs.scss","webpack://./src/assets/scss/plugins/_apexcharts.scss","webpack://./src/assets/scss/plugins/_chartjs.scss","webpack://./src/assets/scss/plugins/_echarts.scss","webpack://./src/assets/scss/plugins/_google-map.scss","webpack://./src/assets/scss/plugins/_autocomplete.scss","webpack://./src/assets/scss/plugins/_vector-maps.scss","webpack://./src/assets/scss/plugins/_leaflet-maps.scss","webpack://./src/assets/scss/plugins/_fullcalendar.scss","webpack://./src/assets/scss/plugins/_emoji-picker.scss","webpack://./src/assets/scss/plugins/_datatables.scss","webpack://./src/assets/scss/plugins/_select2.scss","webpack://./src/assets/scss/plugins/_toastify.scss","webpack://./src/assets/scss/plugins/_choices.scss","webpack://./src/assets/scss/plugins/_flatpicker.scss","webpack://./src/assets/scss/plugins/_flag-input.scss","webpack://./src/assets/scss/pages/_authentication.scss","webpack://./src/assets/scss/pages/_dashboard.scss","webpack://./src/assets/scss/pages/_timeline.scss","webpack://./src/assets/scss/pages/_gallery.scss","webpack://./src/assets/scss/pages/_errors.scss","webpack://./src/assets/scss/pages/_profile.scss","webpack://./src/assets/scss/pages/_sitemap.scss","webpack://./src/assets/scss/pages/_team.scss","webpack://./src/assets/scss/pages/_coming-soon.scss","webpack://./src/assets/scss/pages/_search-results.scss","webpack://./src/assets/scss/pages/_ecommerce.scss","webpack://./src/assets/scss/pages/_invoice.scss","webpack://./src/assets/scss/pages/_chat.scss","webpack://./src/assets/scss/pages/_email.scss","webpack://./src/assets/scss/pages/_kanban.scss","webpack://./src/assets/scss/pages/_landing.scss","webpack://./src/assets/scss/pages/_nft-landing.scss","webpack://./src/assets/scss/pages/_file-manager.scss","webpack://./src/assets/scss/pages/_to-do.scss","webpack://./src/assets/scss/pages/_jobs.scss","webpack://./src/assets/scss/pages/_job-landing.scss","webpack://./src/assets/scss/config/default/custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CAAA;ACAA,4BAAA;AACA;EACE,oCAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;AFcF;AEXA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,iBAAA;AFaF;;AEVA;EACE,gBAAA;EACA,kBAAA;AFaF;;AEVA;EACE,eAAA;AFaF;;AEVA;EACE,eAAA;AFaF;;AEVA;EACE,eAAA;AFaF;;AEVA;EACE,eAAA;AFaF;;AEVA;EACE,0BAAA;AFaF;;AEVA;EACE,0BAAA;AFaF;;AEVA;EACE,YAAA;AFaF;;AEVA;EACE,+BAAA;AFaF;;AEVA;EACE;;;;;;;;;;;;;;;SAAA;AF4BF;;AEVA;EAGE,wBAAA;AFaF;;AEVA;EACE;;;;;;;;;;;;;;;SAAA;AF4BF;;AEVA;EAGE,wBAAA;AFaF;;AEVA;EACE;;;;;;;;;;;;;;;SAAA;AF4BF;;AEVA;EAGE,yBAAA;AFaF;;AEVA;EACE;;;;;;;;;;;;;;;SAAA;AF4BF;;AEVA;EAGE,yBAAA;AFaF;;AEVA;EACE;;;;;;;;;;;;;;;SAAA;AF4BF;;AEVA;EAGE,yBAAA;AFaF;;AEVA;EACE;;;;;;;;;;;;;;;SAAA;AF4BF;;AEVA;EAGE,yBAAA;AFaF;;AEVA;EACE;;;;;;;;;;;;;;;SAAA;AF4BF;;AEVA;EAGE,yBAAA;AFaF;;AEVA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFaF;;AEVA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFaF;;AEVA;EAEE,sCAAA;AFaF;AECA;EACE;IAEE,uBAAA;EFYF;EEVA;IAEE,yBAAA;EFYF;AACF;;AGpi0BA;EAEI,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,4CAAA;EACA,4SAAA;AHqi0BJ;AG/h0BA;EAEI,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EAEA,oBAAA;EAEA,WAAA;EACA,mCAAA;EACA,kCAAA;AH8h0BJ;;AG5h0BA;EAEI,gBAAA;EACA,eAAA;EAEA,gBAAA;AH6h0BJ;;AG3h0BA;EAEI,kBAAA;AH6h0BJ;;AG3h0BA;EAEI,kBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,UAAA;EAEA,UAAA;EAEA,kBAAA;AH0h0BJ;AG3g0BA;EAEI;IAGY,oBAAA;EHsh0Bd;EGph0BE;IAGY,yBAAA;EHqh0Bd;AACF;AGlg0BA;EAEI;IAGY,mBAAA;IAER,UAAA;EH6g0BN;EG3g0BE;IAGY,qBAAA;IAER,UAAA;EH2g0BN;AACF;AG1/zBA;EAEI;IAEI,UAAA;EHqg0BN;EGng0BE;IAEI,UAAA;EHog0BN;EGlg0BE;IAEI,UAAA;EHmg0BN;AACF;AGh/zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EH2/zBN;EGz/zBE;IAGY,4BAAA;IAER,UAAA;EHy/zBN;AACF;AGt+zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHi/zBN;EG/+zBE;IAGY,2BAAA;IAER,UAAA;EH++zBN;AACF;AG59zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHu+zBN;EGr+zBE;IAGY,4BAAA;IAER,UAAA;EHq+zBN;AACF;AGl9zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EH69zBN;EG39zBE;IAGY,2BAAA;IAER,UAAA;EH29zBN;AACF;AGl7zBA;EAEI;IAGY,2BAAA;EHw8zBd;EGr8zBE;IAIY,8DAAA;EHq8zBd;EGl8zBE;IAMY,oDAAA;EHg8zBd;EG77zBE;IAKY,oCAAA;EH47zBd;EGz7zBE;IAGY,2BAAA;EH07zBd;AACF;AGx7zBA;EAGY,kCAAA;AHy7zBZ;;AGv7zBA;EAGY,kCAAA;AHy7zBZ;;AGt7zBA;EAGY,kCAAA;AHw7zBZ;;AGt7zBA;EAGY,kCAAA;AHw7zBZ;;AGr7zBA;EAGY,wCAAA;AHu7zBZ;;AGr7zBA;EAGY,wCAAA;AHu7zBZ;;AGp7zBA;EAGY,qCAAA;AHs7zBZ;;AGp7zBA;EAGY,qCAAA;AHs7zBZ;;AGp7zBA;EAGY,uCAAA;AHs7zBZ;;AGp7zBA;EAGY,uCAAA;AHs7zBZ;;AGp7zBA;EAGY,yCAAA;AHs7zBZ;;AGp7zBA;EAGY,yCAAA;AHs7zBZ;;AGp7zBA;EAGY,yCAAA;AHs7zBZ;;AGp7zBA;EAGY,yCAAA;AHs7zBZ;;AGp7zBA;EAGY,0CAAA;AHs7zBZ;;AGp7zBA;EAGY,0CAAA;AHs7zBZ;;AGp7zBA;EAEI,0BAAA;AHs7zBJ;;AGp7zBA;EAEI,6BAAA;AHs7zBJ;;AGp7zBA;EAEI,6BAAA;AHs7zBJ;;AGp7zBA;EAEI,0BAAA;AHs7zBJ;;AGp7zBA;EAEI,yBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,aAAA;EACA,6BAAA;EAEA,sBAAA;AHo7zBJ;;AGl7zBA;EAEI,WAAA;EAEA,8BAAA;AHm7zBJ;;AGj7zBA;EAEI,YAAA;EAEA,6BAAA;AHk7zBJ;;AGh7zBA;EAEI,wBAAA;EAEA,sEAAA;AHi7zBJ;;AG/6zBA;EAEI,yBAAA;EAEA,sEAAA;AHg7zBJ;;AG96zBA;EAEI,yBAAA;EAEA,sEAAA;AH+6zBJ;;AG76zBA;EAEI,qBAAA;EAEA,gFAAA;AH86zBJ;;AG56zBA;EAEI,qBAAA;EAEA,gFAAA;AH66zBJ;;AG36zBA;EAEI,eAAA;EAEA,uCAAA;EACA,qBAAA;AH46zBJ;;AG16zBA;EAEI,eAAA;EAEA,uCAAA;EACA,kBAAA;AH26zBJ;;AGv6zBE;EACE,gBAAA;AH06zBJ;;AGx6zBE;EACE,gBAAA;AH26zBJ;;AGz6zBE;EACE,gBAAA;AH46zBJ;;AG16zBE;EACE,gBAAA;AH66zBJ;;AG36zBE;EACE,gBAAA;AH86zBJ;;AG56zBE;EACE,gBAAA;AH+6zBJ;;AG76zBE;EACE,gBAAA;AHg7zBJ;;AG96zBE;EACE,gBAAA;AHi7zBJ;;AG/6zBE;EACE,gBAAA;AHk7zBJ;;AGh7zBE;EACE,gBAAA;AHm7zBJ;;AGj7zBE;EACE,gBAAA;AHo7zBJ;;AGl7zBE;EACE,gBAAA;AHq7zBJ;;AGn7zBE;EACE,gBAAA;AHs7zBJ;;AGp7zBE;EACE,gBAAA;AHu7zBJ;;AGr7zBE;EACE,gBAAA;AHw7zBJ;;AGt7zBE;EACE,gBAAA;AHy7zBJ;;AGv7zBE;EACE,gBAAA;AH07zBJ;;AGx7zBE;EACE,gBAAA;AH27zBJ;;AGz7zBE;EACE,gBAAA;AH47zBJ;;AG17zBE;EACE,gBAAA;AH67zBJ;;AG37zBE;EACE,gBAAA;AH87zBJ;;AG57zBE;EACE,gBAAA;AH+7zBJ;;AG77zBE;EACE,gBAAA;AHg8zBJ;;AG97zBE;EACE,gBAAA;AHi8zBJ;;AG/7zBE;EACE,gBAAA;AHk8zBJ;;AGh8zBE;EACE,gBAAA;AHm8zBJ;;AGj8zBE;EACE,gBAAA;AHo8zBJ;;AGl8zBE;EACE,gBAAA;AHq8zBJ;;AGn8zBE;EACE,gBAAA;AHs8zBJ;;AGp8zBE;EACE,gBAAA;AHu8zBJ;;AGr8zBE;EACE,gBAAA;AHw8zBJ;;AGt8zBE;EACE,gBAAA;AHy8zBJ;;AGv8zBE;EACE,gBAAA;AH08zBJ;;AGx8zBE;EACE,gBAAA;AH28zBJ;;AGz8zBE;EACE,gBAAA;AH48zBJ;;AG18zBE;EACE,gBAAA;AH68zBJ;;AG38zBE;EACE,gBAAA;AH88zBJ;;AG58zBE;EACE,gBAAA;AH+8zBJ;;AG78zBE;EACE,gBAAA;AHg9zBJ;;AG98zBE;EACE,gBAAA;AHi9zBJ;;AG/8zBE;EACE,gBAAA;AHk9zBJ;;AGh9zBE;EACE,gBAAA;AHm9zBJ;;AGj9zBE;EACE,gBAAA;AHo9zBJ;;AGl9zBE;EACE,gBAAA;AHq9zBJ;;AGn9zBE;EACE,gBAAA;AHs9zBJ;;AGp9zBE;EACE,gBAAA;AHu9zBJ;;AGr9zBE;EACE,gBAAA;AHw9zBJ;;AGt9zBE;EACE,gBAAA;AHy9zBJ;;AGv9zBE;EACE,gBAAA;AH09zBJ;;AGx9zBE;EACE,gBAAA;AH29zBJ;;AGz9zBE;EACE,gBAAA;AH49zBJ;;AG19zBE;EACE,gBAAA;AH69zBJ;;AG39zBE;EACE,gBAAA;AH89zBJ;;AG59zBE;EACE,gBAAA;AH+9zBJ;;AG79zBE;EACE,gBAAA;AHg+zBJ;;AG99zBE;EACE,gBAAA;AHi+zBJ;;AG/9zBE;EACE,gBAAA;AHk+zBJ;;AGh+zBE;EACE,gBAAA;AHm+zBJ;;AGj+zBE;EACE,gBAAA;AHo+zBJ;;AGl+zBE;EACE,gBAAA;AHq+zBJ;;AGn+zBE;EACE,gBAAA;AHs+zBJ;;AGp+zBE;EACE,gBAAA;AHu+zBJ;;AGr+zBE;EACE,gBAAA;AHw+zBJ;;AGt+zBE;EACE,gBAAA;AHy+zBJ;;AGv+zBE;EACE,gBAAA;AH0+zBJ;;AGx+zBE;EACE,gBAAA;AH2+zBJ;;AGz+zBE;EACE,gBAAA;AH4+zBJ;;AG1+zBE;EACE,gBAAA;AH6+zBJ;;AG3+zBE;EACE,gBAAA;AH8+zBJ;;AG5+zBE;EACE,gBAAA;AH++zBJ;;AG7+zBE;EACE,gBAAA;AHg/zBJ;;AG9+zBE;EACE,gBAAA;AHi/zBJ;;AG/+zBE;EACE,gBAAA;AHk/zBJ;;AGh/zBE;EACE,gBAAA;AHm/zBJ;;AGj/zBE;EACE,gBAAA;AHo/zBJ;;AGl/zBE;EACE,gBAAA;AHq/zBJ;;AGn/zBE;EACE,gBAAA;AHs/zBJ;;AGp/zBE;EACE,gBAAA;AHu/zBJ;;AGr/zBE;EACE,gBAAA;AHw/zBJ;;AGt/zBE;EACE,gBAAA;AHy/zBJ;;AGv/zBE;EACE,gBAAA;AH0/zBJ;;AGx/zBE;EACE,gBAAA;AH2/zBJ;;AGz/zBE;EACE,gBAAA;AH4/zBJ;;AG1/zBE;EACE,gBAAA;AH6/zBJ;;AG3/zBE;EACE,gBAAA;AH8/zBJ;;AG5/zBE;EACE,gBAAA;AH+/zBJ;;AG7/zBE;EACE,gBAAA;AHgg0BJ;;AG9/zBE;EACE,gBAAA;AHig0BJ;;AG//zBE;EACE,gBAAA;AHkg0BJ;;AGhg0BE;EACE,gBAAA;AHmg0BJ;;AGjg0BE;EACE,gBAAA;AHog0BJ;;AGlg0BE;EACE,gBAAA;AHqg0BJ;;AGng0BE;EACE,gBAAA;AHsg0BJ;;AGpg0BE;EACE,gBAAA;AHug0BJ;;AGrg0BE;EACE,gBAAA;AHwg0BJ;;AGtg0BE;EACE,gBAAA;AHyg0BJ;;AGvg0BE;EACE,gBAAA;AH0g0BJ;;AGxg0BE;EACE,gBAAA;AH2g0BJ;;AGzg0BE;EACE,gBAAA;AH4g0BJ;;AG1g0BE;EACE,gBAAA;AH6g0BJ;;AG3g0BE;EACE,gBAAA;AH8g0BJ;;AG5g0BE;EACE,gBAAA;AH+g0BJ;;AG7g0BE;EACE,gBAAA;AHgh0BJ;;AG9g0BE;EACE,gBAAA;AHih0BJ;;AG/g0BE;EACE,gBAAA;AHkh0BJ;;AGhh0BE;EACE,gBAAA;AHmh0BJ;;AGjh0BE;EACE,gBAAA;AHoh0BJ;;AGlh0BE;EACE,gBAAA;AHqh0BJ;;AGnh0BE;EACE,gBAAA;AHsh0BJ;;AGph0BE;EACE,gBAAA;AHuh0BJ;;AGrh0BE;EACE,gBAAA;AHwh0BJ;;AGth0BE;EACE,gBAAA;AHyh0BJ;;AGvh0BE;EACE,gBAAA;AH0h0BJ;;AGxh0BE;EACE,gBAAA;AH2h0BJ;;AGzh0BE;EACE,gBAAA;AH4h0BJ;;AG1h0BE;EACE,gBAAA;AH6h0BJ;;AG3h0BE;EACE,gBAAA;AH8h0BJ;;AG5h0BE;EACE,gBAAA;AH+h0BJ;;AG7h0BE;EACE,gBAAA;AHgi0BJ;;AG9h0BE;EACE,gBAAA;AHii0BJ;;AG/h0BE;EACE,gBAAA;AHki0BJ;;AGhi0BE;EACE,gBAAA;AHmi0BJ;;AGji0BE;EACE,gBAAA;AHoi0BJ;;AGli0BE;EACE,gBAAA;AHqi0BJ;;AGni0BE;EACE,gBAAA;AHsi0BJ;;AGpi0BE;EACE,gBAAA;AHui0BJ;;AGri0BE;EACE,gBAAA;AHwi0BJ;;AGti0BE;EACE,gBAAA;AHyi0BJ;;AGvi0BE;EACE,gBAAA;AH0i0BJ;;AGxi0BE;EACE,gBAAA;AH2i0BJ;;AGzi0BE;EACE,gBAAA;AH4i0BJ;;AG1i0BE;EACE,gBAAA;AH6i0BJ;;AG3i0BE;EACE,gBAAA;AH8i0BJ;;AG5i0BE;EACE,gBAAA;AH+i0BJ;;AG7i0BE;EACE,gBAAA;AHgj0BJ;;AG9i0BE;EACE,gBAAA;AHij0BJ;;AG/i0BE;EACE,gBAAA;AHkj0BJ;;AGhj0BE;EACE,gBAAA;AHmj0BJ;;AGjj0BE;EACE,gBAAA;AHoj0BJ;;AGlj0BE;EACE,gBAAA;AHqj0BJ;;AGnj0BE;EACE,gBAAA;AHsj0BJ;;AGpj0BE;EACE,gBAAA;AHuj0BJ;;AGrj0BE;EACE,gBAAA;AHwj0BJ;;AGtj0BE;EACE,gBAAA;AHyj0BJ;;AGvj0BE;EACE,gBAAA;AH0j0BJ;;AGxj0BE;EACE,gBAAA;AH2j0BJ;;AGzj0BE;EACE,gBAAA;AH4j0BJ;;AG1j0BE;EACE,gBAAA;AH6j0BJ;;AG3j0BE;EACE,gBAAA;AH8j0BJ;;AG5j0BE;EACE,gBAAA;AH+j0BJ;;AG7j0BE;EACE,gBAAA;AHgk0BJ;;AG9j0BE;EACE,gBAAA;AHik0BJ;;AG/j0BE;EACE,gBAAA;AHkk0BJ;;AGhk0BE;EACE,gBAAA;AHmk0BJ;;AGjk0BE;EACE,gBAAA;AHok0BJ;;AGlk0BE;EACE,gBAAA;AHqk0BJ;;AGnk0BE;EACE,gBAAA;AHsk0BJ;;AGpk0BE;EACE,gBAAA;AHuk0BJ;;AGrk0BE;EACE,gBAAA;AHwk0BJ;;AGtk0BE;EACE,gBAAA;AHyk0BJ;;AGvk0BE;EACE,gBAAA;AH0k0BJ;;AGxk0BE;EACE,gBAAA;AH2k0BJ;;AGzk0BE;EACE,gBAAA;AH4k0BJ;;AG1k0BE;EACE,gBAAA;AH6k0BJ;;AG3k0BE;EACE,gBAAA;AH8k0BJ;;AG5k0BE;EACE,gBAAA;AH+k0BJ;;AG7k0BE;EACE,gBAAA;AHgl0BJ;;AG9k0BE;EACE,gBAAA;AHil0BJ;;AG/k0BE;EACE,gBAAA;AHkl0BJ;;AGhl0BE;EACE,gBAAA;AHml0BJ;;AGjl0BE;EACE,gBAAA;AHol0BJ;;AGll0BE;EACE,gBAAA;AHql0BJ;;AGnl0BE;EACE,gBAAA;AHsl0BJ;;AGpl0BE;EACE,gBAAA;AHul0BJ;;AGrl0BE;EACE,gBAAA;AHwl0BJ;;AGtl0BE;EACE,gBAAA;AHyl0BJ;;AGvl0BE;EACE,gBAAA;AH0l0BJ;;AGxl0BE;EACE,gBAAA;AH2l0BJ;;AGzl0BE;EACE,gBAAA;AH4l0BJ;;AG1l0BE;EACE,gBAAA;AH6l0BJ;;AG3l0BE;EACE,gBAAA;AH8l0BJ;;AG5l0BE;EACE,gBAAA;AH+l0BJ;;AG7l0BE;EACE,gBAAA;AHgm0BJ;;AG9l0BE;EACE,gBAAA;AHim0BJ;;AG/l0BE;EACE,gBAAA;AHkm0BJ;;AGhm0BE;EACE,gBAAA;AHmm0BJ;;AGjm0BE;EACE,gBAAA;AHom0BJ;;AGlm0BE;EACE,gBAAA;AHqm0BJ;;AGnm0BE;EACE,gBAAA;AHsm0BJ;;AGpm0BE;EACE,gBAAA;AHum0BJ;;AGrm0BE;EACE,gBAAA;AHwm0BJ;;AGtm0BE;EACE,gBAAA;AHym0BJ;;AGvm0BE;EACE,gBAAA;AH0m0BJ;;AGxm0BE;EACE,gBAAA;AH2m0BJ;;AGzm0BE;EACE,gBAAA;AH4m0BJ;;AG1m0BE;EACE,gBAAA;AH6m0BJ;;AG3m0BE;EACE,gBAAA;AH8m0BJ;;AG5m0BE;EACE,gBAAA;AH+m0BJ;;AG7m0BE;EACE,gBAAA;AHgn0BJ;;AG9m0BE;EACE,gBAAA;AHin0BJ;;AG/m0BE;EACE,gBAAA;AHkn0BJ;;AGhn0BE;EACE,gBAAA;AHmn0BJ;;AGjn0BE;EACE,gBAAA;AHon0BJ;;AGln0BE;EACE,gBAAA;AHqn0BJ;;AGnn0BE;EACE,gBAAA;AHsn0BJ;;AGpn0BE;EACE,gBAAA;AHun0BJ;;AGrn0BE;EACE,gBAAA;AHwn0BJ;;AGtn0BE;EACE,gBAAA;AHyn0BJ;;AGvn0BE;EACE,gBAAA;AH0n0BJ;;AGxn0BE;EACE,gBAAA;AH2n0BJ;;AGzn0BE;EACE,gBAAA;AH4n0BJ;;AG1n0BE;EACE,gBAAA;AH6n0BJ;;AG3n0BE;EACE,gBAAA;AH8n0BJ;;AG5n0BE;EACE,gBAAA;AH+n0BJ;;AG7n0BE;EACE,gBAAA;AHgo0BJ;;AG9n0BE;EACE,gBAAA;AHio0BJ;;AG/n0BE;EACE,gBAAA;AHko0BJ;;AGho0BE;EACE,gBAAA;AHmo0BJ;;AGjo0BE;EACE,gBAAA;AHoo0BJ;;AGlo0BE;EACE,gBAAA;AHqo0BJ;;AGno0BE;EACE,gBAAA;AHso0BJ;;AGpo0BE;EACE,gBAAA;AHuo0BJ;;AGro0BE;EACE,gBAAA;AHwo0BJ;;AGto0BE;EACE,gBAAA;AHyo0BJ;;AGvo0BE;EACE,gBAAA;AH0o0BJ;;AGxo0BE;EACE,gBAAA;AH2o0BJ;;AGzo0BE;EACE,gBAAA;AH4o0BJ;;AG1o0BE;EACE,gBAAA;AH6o0BJ;;AG3o0BE;EACE,gBAAA;AH8o0BJ;;AG5o0BE;EACE,gBAAA;AH+o0BJ;;AG7o0BE;EACE,gBAAA;AHgp0BJ;;AG9o0BE;EACE,gBAAA;AHip0BJ;;AG/o0BE;EACE,gBAAA;AHkp0BJ;;AGhp0BE;EACE,gBAAA;AHmp0BJ;;AGjp0BE;EACE,gBAAA;AHop0BJ;;AGlp0BE;EACE,gBAAA;AHqp0BJ;;AGnp0BE;EACE,gBAAA;AHsp0BJ;;AGpp0BE;EACE,gBAAA;AHup0BJ;;AGrp0BE;EACE,gBAAA;AHwp0BJ;;AGtp0BE;EACE,gBAAA;AHyp0BJ;;AGvp0BE;EACE,gBAAA;AH0p0BJ;;AGxp0BE;EACE,gBAAA;AH2p0BJ;;AGzp0BE;EACE,gBAAA;AH4p0BJ;;AG1p0BE;EACE,gBAAA;AH6p0BJ;;AG3p0BE;EACE,gBAAA;AH8p0BJ;;AG5p0BE;EACE,gBAAA;AH+p0BJ;;AG7p0BE;EACE,gBAAA;AHgq0BJ;;AG9p0BE;EACE,gBAAA;AHiq0BJ;;AG/p0BE;EACE,gBAAA;AHkq0BJ;;AGhq0BE;EACE,gBAAA;AHmq0BJ;;AGjq0BE;EACE,gBAAA;AHoq0BJ;;AGlq0BE;EACE,gBAAA;AHqq0BJ;;AGnq0BE;EACE,gBAAA;AHsq0BJ;;AGpq0BE;EACE,gBAAA;AHuq0BJ;;AGrq0BE;EACE,gBAAA;AHwq0BJ;;AGtq0BE;EACE,gBAAA;AHyq0BJ;;AGvq0BE;EACE,gBAAA;AH0q0BJ;;AGxq0BE;EACE,gBAAA;AH2q0BJ;;AGzq0BE;EACE,gBAAA;AH4q0BJ;;AG1q0BE;EACE,gBAAA;AH6q0BJ;;AG3q0BE;EACE,gBAAA;AH8q0BJ;;AG5q0BE;EACE,gBAAA;AH+q0BJ;;AG7q0BE;EACE,gBAAA;AHgr0BJ;;AG9q0BE;EACE,gBAAA;AHir0BJ;;AG/q0BE;EACE,gBAAA;AHkr0BJ;;AGhr0BE;EACE,gBAAA;AHmr0BJ;;AGjr0BE;EACE,gBAAA;AHor0BJ;;AGlr0BE;EACE,gBAAA;AHqr0BJ;;AGnr0BE;EACE,gBAAA;AHsr0BJ;;AGpr0BE;EACE,gBAAA;AHur0BJ;;AGrr0BE;EACE,gBAAA;AHwr0BJ;;AGtr0BE;EACE,gBAAA;AHyr0BJ;;AGvr0BE;EACE,gBAAA;AH0r0BJ;;AGxr0BE;EACE,gBAAA;AH2r0BJ;;AGzr0BE;EACE,gBAAA;AH4r0BJ;;AG1r0BE;EACE,gBAAA;AH6r0BJ;;AG3r0BE;EACE,gBAAA;AH8r0BJ;;AG5r0BE;EACE,gBAAA;AH+r0BJ;;AG7r0BE;EACE,gBAAA;AHgs0BJ;;AG9r0BE;EACE,gBAAA;AHis0BJ;;AG/r0BE;EACE,gBAAA;AHks0BJ;;AGhs0BE;EACE,gBAAA;AHms0BJ;;AGjs0BE;EACE,gBAAA;AHos0BJ;;AGls0BE;EACE,gBAAA;AHqs0BJ;;AGns0BE;EACE,gBAAA;AHss0BJ;;AGps0BE;EACE,gBAAA;AHus0BJ;;AGrs0BE;EACE,gBAAA;AHws0BJ;;AGts0BE;EACE,gBAAA;AHys0BJ;;AGvs0BE;EACE,gBAAA;AH0s0BJ;;AGxs0BE;EACE,gBAAA;AH2s0BJ;;AGzs0BE;EACE,gBAAA;AH4s0BJ;;AG1s0BE;EACE,gBAAA;AH6s0BJ;;AG3s0BE;EACE,gBAAA;AH8s0BJ;;AG5s0BE;EACE,gBAAA;AH+s0BJ;;AG7s0BE;EACE,gBAAA;AHgt0BJ;;AG9s0BE;EACE,gBAAA;AHit0BJ;;AG/s0BE;EACE,gBAAA;AHkt0BJ;;AGht0BE;EACE,gBAAA;AHmt0BJ;;AGjt0BE;EACE,gBAAA;AHot0BJ;;AGlt0BE;EACE,gBAAA;AHqt0BJ;;AGnt0BE;EACE,gBAAA;AHst0BJ;;AGpt0BE;EACE,gBAAA;AHut0BJ;;AGrt0BE;EACE,gBAAA;AHwt0BJ;;AGtt0BE;EACE,gBAAA;AHyt0BJ;;AGvt0BE;EACE,gBAAA;AH0t0BJ;;AGxt0BE;EACE,gBAAA;AH2t0BJ;;AGzt0BE;EACE,gBAAA;AH4t0BJ;;AG1t0BE;EACE,gBAAA;AH6t0BJ;;AG3t0BE;EACE,gBAAA;AH8t0BJ;;AG5t0BE;EACE,gBAAA;AH+t0BJ;;AG7t0BE;EACE,gBAAA;AHgu0BJ;;AG9t0BE;EACE,gBAAA;AHiu0BJ;;AG/t0BE;EACE,gBAAA;AHku0BJ;;AGhu0BE;EACE,gBAAA;AHmu0BJ;;AGju0BE;EACE,gBAAA;AHou0BJ;;AGlu0BE;EACE,gBAAA;AHqu0BJ;;AGnu0BE;EACE,gBAAA;AHsu0BJ;;AGpu0BE;EACE,gBAAA;AHuu0BJ;;AGru0BE;EACE,gBAAA;AHwu0BJ;;AGtu0BE;EACE,gBAAA;AHyu0BJ;;AGvu0BE;EACE,gBAAA;AH0u0BJ;;AGxu0BE;EACE,gBAAA;AH2u0BJ;;AGzu0BE;EACE,gBAAA;AH4u0BJ;;AG1u0BE;EACE,gBAAA;AH6u0BJ;;AG3u0BE;EACE,gBAAA;AH8u0BJ;;AG5u0BE;EACE,gBAAA;AH+u0BJ;;AG7u0BE;EACE,gBAAA;AHgv0BJ;;AG9u0BE;EACE,gBAAA;AHiv0BJ;;AG/u0BE;EACE,gBAAA;AHkv0BJ;;AGhv0BE;EACE,gBAAA;AHmv0BJ;;AGjv0BE;EACE,gBAAA;AHov0BJ;;AGlv0BE;EACE,gBAAA;AHqv0BJ;;AGnv0BE;EACE,gBAAA;AHsv0BJ;;AGpv0BE;EACE,gBAAA;AHuv0BJ;;AGrv0BE;EACE,gBAAA;AHwv0BJ;;AGtv0BE;EACE,gBAAA;AHyv0BJ;;AGvv0BE;EACE,gBAAA;AH0v0BJ;;AGxv0BE;EACE,gBAAA;AH2v0BJ;;AGzv0BE;EACE,gBAAA;AH4v0BJ;;AG1v0BE;EACE,gBAAA;AH6v0BJ;;AG3v0BE;EACE,gBAAA;AH8v0BJ;;AG5v0BE;EACE,gBAAA;AH+v0BJ;;AG7v0BE;EACE,gBAAA;AHgw0BJ;;AG9v0BE;EACE,gBAAA;AHiw0BJ;;AG/v0BE;EACE,gBAAA;AHkw0BJ;;AGhw0BE;EACE,gBAAA;AHmw0BJ;;AGjw0BE;EACE,gBAAA;AHow0BJ;;AGlw0BE;EACE,gBAAA;AHqw0BJ;;AGnw0BE;EACE,gBAAA;AHsw0BJ;;AGpw0BE;EACE,gBAAA;AHuw0BJ;;AGrw0BE;EACE,gBAAA;AHww0BJ;;AGtw0BE;EACE,gBAAA;AHyw0BJ;;AGvw0BE;EACE,gBAAA;AH0w0BJ;;AGxw0BE;EACE,gBAAA;AH2w0BJ;;AGzw0BE;EACE,gBAAA;AH4w0BJ;;AG1w0BE;EACE,gBAAA;AH6w0BJ;;AG3w0BE;EACE,gBAAA;AH8w0BJ;;AG5w0BE;EACE,gBAAA;AH+w0BJ;;AG7w0BE;EACE,gBAAA;AHgx0BJ;;AG9w0BE;EACE,gBAAA;AHix0BJ;;AG/w0BE;EACE,gBAAA;AHkx0BJ;;AGhx0BE;EACE,gBAAA;AHmx0BJ;;AGjx0BE;EACE,gBAAA;AHox0BJ;;AGlx0BE;EACE,gBAAA;AHqx0BJ;;AGnx0BE;EACE,gBAAA;AHsx0BJ;;AGpx0BE;EACE,gBAAA;AHux0BJ;;AGrx0BE;EACE,gBAAA;AHwx0BJ;;AGtx0BE;EACE,gBAAA;AHyx0BJ;;AGvx0BE;EACE,gBAAA;AH0x0BJ;;AGxx0BE;EACE,gBAAA;AH2x0BJ;;AGzx0BE;EACE,gBAAA;AH4x0BJ;;AG1x0BE;EACE,gBAAA;AH6x0BJ;;AG3x0BE;EACE,gBAAA;AH8x0BJ;;AG5x0BE;EACE,gBAAA;AH+x0BJ;;AG7x0BE;EACE,gBAAA;AHgy0BJ;;AG9x0BE;EACE,gBAAA;AHiy0BJ;;AG/x0BE;EACE,gBAAA;AHky0BJ;;AGhy0BE;EACE,gBAAA;AHmy0BJ;;AGjy0BE;EACE,gBAAA;AHoy0BJ;;AGly0BE;EACE,gBAAA;AHqy0BJ;;AGny0BE;EACE,gBAAA;AHsy0BJ;;AGpy0BE;EACE,gBAAA;AHuy0BJ;;AGry0BE;EACE,gBAAA;AHwy0BJ;;AGty0BE;EACE,gBAAA;AHyy0BJ;;AGvy0BE;EACE,gBAAA;AH0y0BJ;;AGxy0BE;EACE,gBAAA;AH2y0BJ;;AGzy0BE;EACE,gBAAA;AH4y0BJ;;AG1y0BE;EACE,gBAAA;AH6y0BJ;;AG3y0BE;EACE,gBAAA;AH8y0BJ;;AG5y0BE;EACE,gBAAA;AH+y0BJ;;AG7y0BE;EACE,gBAAA;AHgz0BJ;;AG9y0BE;EACE,gBAAA;AHiz0BJ;;AG/y0BE;EACE,gBAAA;AHkz0BJ;;AGhz0BE;EACE,gBAAA;AHmz0BJ;;AGjz0BE;EACE,gBAAA;AHoz0BJ;;AGlz0BE;EACE,gBAAA;AHqz0BJ;;AGnz0BE;EACE,gBAAA;AHsz0BJ;;AGpz0BE;EACE,gBAAA;AHuz0BJ;;AGrz0BE;EACE,gBAAA;AHwz0BJ;;AGtz0BE;EACE,gBAAA;AHyz0BJ;;AGvz0BE;EACE,gBAAA;AH0z0BJ;;AGxz0BE;EACE,gBAAA;AH2z0BJ;;AGzz0BE;EACE,gBAAA;AH4z0BJ;;AG1z0BE;EACE,gBAAA;AH6z0BJ;;AG3z0BE;EACE,gBAAA;AH8z0BJ;;AG5z0BE;EACE,gBAAA;AH+z0BJ;;AG7z0BE;EACE,gBAAA;AHg00BJ;;AG9z0BE;EACE,gBAAA;AHi00BJ;;AG/z0BE;EACE,gBAAA;AHk00BJ;;AGh00BE;EACE,gBAAA;AHm00BJ;;AGj00BE;EACE,gBAAA;AHo00BJ;;AGl00BE;EACE,gBAAA;AHq00BJ;;AGn00BE;EACE,gBAAA;AHs00BJ;;AGp00BE;EACE,gBAAA;AHu00BJ;;AGr00BE;EACE,gBAAA;AHw00BJ;;AGt00BE;EACE,gBAAA;AHy00BJ;;AGv00BE;EACE,gBAAA;AH000BJ;;AGx00BE;EACE,gBAAA;AH200BJ;;AGz00BE;EACE,gBAAA;AH400BJ;;AG100BE;EACE,gBAAA;AH600BJ;;AG300BE;EACE,gBAAA;AH800BJ;;AG500BE;EACE,gBAAA;AH+00BJ;;AG700BE;EACE,gBAAA;AHg10BJ;;AG900BE;EACE,gBAAA;AHi10BJ;;AG/00BE;EACE,gBAAA;AHk10BJ;;AGh10BE;EACE,gBAAA;AHm10BJ;;AGj10BE;EACE,gBAAA;AHo10BJ;;AGl10BE;EACE,gBAAA;AHq10BJ;;AGn10BE;EACE,gBAAA;AHs10BJ;;AGp10BE;EACE,gBAAA;AHu10BJ;;AGr10BE;EACE,gBAAA;AHw10BJ;;AGt10BE;EACE,gBAAA;AHy10BJ;;AGv10BE;EACE,gBAAA;AH010BJ;;AGx10BE;EACE,gBAAA;AH210BJ;;AGz10BE;EACE,gBAAA;AH410BJ;;AG110BE;EACE,gBAAA;AH610BJ;;AG310BE;EACE,gBAAA;AH810BJ;;AG510BE;EACE,gBAAA;AH+10BJ;;AG710BE;EACE,gBAAA;AHg20BJ;;AG910BE;EACE,gBAAA;AHi20BJ;;AG/10BE;EACE,gBAAA;AHk20BJ;;AGh20BE;EACE,gBAAA;AHm20BJ;;AGj20BE;EACE,gBAAA;AHo20BJ;;AGl20BE;EACE,gBAAA;AHq20BJ;;AGn20BE;EACE,gBAAA;AHs20BJ;;AGp20BE;EACE,gBAAA;AHu20BJ;;AGr20BE;EACE,gBAAA;AHw20BJ;;AGt20BE;EACE,gBAAA;AHy20BJ;;AGv20BE;EACE,gBAAA;AH020BJ;;AGx20BE;EACE,gBAAA;AH220BJ;;AGz20BE;EACE,gBAAA;AH420BJ;;AG120BE;EACE,gBAAA;AH620BJ;;AG320BE;EACE,gBAAA;AH820BJ;;AG520BE;EACE,gBAAA;AH+20BJ;;AG720BE;EACE,gBAAA;AHg30BJ;;AG920BE;EACE,gBAAA;AHi30BJ;;AG/20BE;EACE,gBAAA;AHk30BJ;;AGh30BE;EACE,gBAAA;AHm30BJ;;AGj30BE;EACE,gBAAA;AHo30BJ;;AGl30BE;EACE,gBAAA;AHq30BJ;;AGn30BE;EACE,gBAAA;AHs30BJ;;AGp30BE;EACE,gBAAA;AHu30BJ;;AGr30BE;EACE,gBAAA;AHw30BJ;;AGt30BE;EACE,gBAAA;AHy30BJ;;AGv30BE;EACE,gBAAA;AH030BJ;;AGx30BE;EACE,gBAAA;AH230BJ;;AGz30BE;EACE,gBAAA;AH430BJ;;AG130BE;EACE,gBAAA;AH630BJ;;AG330BE;EACE,gBAAA;AH830BJ;;AG530BE;EACE,gBAAA;AH+30BJ;;AG730BE;EACE,gBAAA;AHg40BJ;;AG930BE;EACE,gBAAA;AHi40BJ;;AG/30BE;EACE,gBAAA;AHk40BJ;;AGh40BE;EACE,gBAAA;AHm40BJ;;AGj40BE;EACE,gBAAA;AHo40BJ;;AGl40BE;EACE,gBAAA;AHq40BJ;;AGn40BE;EACE,gBAAA;AHs40BJ;;AGp40BE;EACE,gBAAA;AHu40BJ;;AGr40BE;EACE,gBAAA;AHw40BJ;;AGt40BE;EACE,gBAAA;AHy40BJ;;AGv40BE;EACE,gBAAA;AH040BJ;;AGx40BE;EACE,gBAAA;AH240BJ;;AGz40BE;EACE,gBAAA;AH440BJ;;AG140BE;EACE,gBAAA;AH640BJ;;AG340BE;EACE,gBAAA;AH840BJ;;AG540BE;EACE,gBAAA;AH+40BJ;;AG740BE;EACE,gBAAA;AHg50BJ;;AG940BE;EACE,gBAAA;AHi50BJ;;AG/40BE;EACE,gBAAA;AHk50BJ;;AGh50BE;EACE,gBAAA;AHm50BJ;;AGj50BE;EACE,gBAAA;AHo50BJ;;AGl50BE;EACE,gBAAA;AHq50BJ;;AGn50BE;EACE,gBAAA;AHs50BJ;;AGp50BE;EACE,gBAAA;AHu50BJ;;AGr50BE;EACE,gBAAA;AHw50BJ;;AGt50BE;EACE,gBAAA;AHy50BJ;;AGv50BE;EACE,gBAAA;AH050BJ;;AGx50BE;EACE,gBAAA;AH250BJ;;AGz50BE;EACE,gBAAA;AH450BJ;;AG150BE;EACE,gBAAA;AH650BJ;;AG350BE;EACE,gBAAA;AH850BJ;;AG550BE;EACE,gBAAA;AH+50BJ;;AG750BE;EACE,gBAAA;AHg60BJ;;AG950BE;EACE,gBAAA;AHi60BJ;;AG/50BE;EACE,gBAAA;AHk60BJ;;AGh60BE;EACE,gBAAA;AHm60BJ;;AGj60BE;EACE,gBAAA;AHo60BJ;;AGl60BE;EACE,gBAAA;AHq60BJ;;AGn60BE;EACE,gBAAA;AHs60BJ;;AGp60BE;EACE,gBAAA;AHu60BJ;;AGr60BE;EACE,gBAAA;AHw60BJ;;AGt60BE;EACE,gBAAA;AHy60BJ;;AGv60BE;EACE,gBAAA;AH060BJ;;AGx60BE;EACE,gBAAA;AH260BJ;;AGz60BE;EACE,gBAAA;AH460BJ;;AG160BE;EACE,gBAAA;AH660BJ;;AG360BE;EACE,gBAAA;AH860BJ;;AG560BE;EACE,gBAAA;AH+60BJ;;AG760BE;EACE,gBAAA;AHg70BJ;;AG960BE;EACE,gBAAA;AHi70BJ;;AG/60BE;EACE,gBAAA;AHk70BJ;;AGh70BE;EACE,gBAAA;AHm70BJ;;AGj70BE;EACE,gBAAA;AHo70BJ;;AGl70BE;EACE,gBAAA;AHq70BJ;;AGn70BE;EACE,gBAAA;AHs70BJ;;AGp70BE;EACE,gBAAA;AHu70BJ;;AGr70BE;EACE,gBAAA;AHw70BJ;;AGt70BE;EACE,gBAAA;AHy70BJ;;AGv70BE;EACE,gBAAA;AH070BJ;;AGx70BE;EACE,gBAAA;AH270BJ;;AGz70BE;EACE,gBAAA;AH470BJ;;AG170BE;EACE,gBAAA;AH670BJ;;AG370BE;EACE,gBAAA;AH870BJ;;AG570BE;EACE,gBAAA;AH+70BJ;;AG770BE;EACE,gBAAA;AHg80BJ;;AG970BE;EACE,gBAAA;AHi80BJ;;AG/70BE;EACE,gBAAA;AHk80BJ;;AGh80BE;EACE,gBAAA;AHm80BJ;;AGj80BE;EACE,gBAAA;AHo80BJ;;AGl80BE;EACE,gBAAA;AHq80BJ;;AGn80BE;EACE,gBAAA;AHs80BJ;;AGp80BE;EACE,gBAAA;AHu80BJ;;AGr80BE;EACE,gBAAA;AHw80BJ;;AGt80BE;EACE,gBAAA;AHy80BJ;;AGv80BE;EACE,gBAAA;AH080BJ;;AGx80BE;EACE,gBAAA;AH280BJ;;AGz80BE;EACE,gBAAA;AH480BJ;;AG180BE;EACE,gBAAA;AH680BJ;;AG380BE;EACE,gBAAA;AH880BJ;;AG580BE;EACE,gBAAA;AH+80BJ;;AG780BE;EACE,gBAAA;AHg90BJ;;AG980BE;EACE,gBAAA;AHi90BJ;;AG/80BE;EACE,gBAAA;AHk90BJ;;AGh90BE;EACE,gBAAA;AHm90BJ;;AGj90BE;EACE,gBAAA;AHo90BJ;;AGl90BE;EACE,gBAAA;AHq90BJ;;AGn90BE;EACE,gBAAA;AHs90BJ;;AGp90BE;EACE,gBAAA;AHu90BJ;;AGr90BE;EACE,gBAAA;AHw90BJ;;AGt90BE;EACE,gBAAA;AHy90BJ;;AGv90BE;EACE,gBAAA;AH090BJ;;AGx90BE;EACE,gBAAA;AH290BJ;;AGz90BE;EACE,gBAAA;AH490BJ;;AG190BE;EACE,gBAAA;AH690BJ;;AG390BE;EACE,gBAAA;AH890BJ;;AG590BE;EACE,gBAAA;AH+90BJ;;AG790BE;EACE,gBAAA;AHg+0BJ;;AG990BE;EACE,gBAAA;AHi+0BJ;;AG/90BE;EACE,gBAAA;AHk+0BJ;;AGh+0BE;EACE,gBAAA;AHm+0BJ;;AGj+0BE;EACE,gBAAA;AHo+0BJ;;AGl+0BE;EACE,gBAAA;AHq+0BJ;;AGn+0BE;EACE,gBAAA;AHs+0BJ;;AGp+0BE;EACE,gBAAA;AHu+0BJ;;AGr+0BE;EACE,gBAAA;AHw+0BJ;;AGt+0BE;EACE,gBAAA;AHy+0BJ;;AGv+0BE;EACE,gBAAA;AH0+0BJ;;AGx+0BE;EACE,gBAAA;AH2+0BJ;;AGz+0BE;EACE,gBAAA;AH4+0BJ;;AG1+0BE;EACE,gBAAA;AH6+0BJ;;AG3+0BE;EACE,gBAAA;AH8+0BJ;;AG5+0BE;EACE,gBAAA;AH++0BJ;;AG7+0BE;EACE,gBAAA;AHg/0BJ;;AG9+0BE;EACE,gBAAA;AHi/0BJ;;AG/+0BE;EACE,gBAAA;AHk/0BJ;;AGh/0BE;EACE,gBAAA;AHm/0BJ;;AGj/0BE;EACE,gBAAA;AHo/0BJ;;AGl/0BE;EACE,gBAAA;AHq/0BJ;;AGn/0BE;EACE,gBAAA;AHs/0BJ;;AGp/0BE;EACE,gBAAA;AHu/0BJ;;AGr/0BE;EACE,gBAAA;AHw/0BJ;;AGt/0BE;EACE,gBAAA;AHy/0BJ;;AGv/0BE;EACE,gBAAA;AH0/0BJ;;AGx/0BE;EACE,gBAAA;AH2/0BJ;;AGz/0BE;EACE,gBAAA;AH4/0BJ;;AG1/0BE;EACE,gBAAA;AH6/0BJ;;AG3/0BE;EACE,gBAAA;AH8/0BJ;;AG5/0BE;EACE,gBAAA;AH+/0BJ;;AG7/0BE;EACE,gBAAA;AHgg1BJ;;AG9/0BE;EACE,gBAAA;AHig1BJ;;AG//0BE;EACE,gBAAA;AHkg1BJ;;AGhg1BE;EACE,gBAAA;AHmg1BJ;;AGjg1BE;EACE,gBAAA;AHog1BJ;;AGlg1BE;EACE,gBAAA;AHqg1BJ;;AGng1BE;EACE,gBAAA;AHsg1BJ;;AGpg1BE;EACE,gBAAA;AHug1BJ;;AGrg1BE;EACE,gBAAA;AHwg1BJ;;AGtg1BE;EACE,gBAAA;AHyg1BJ;;AGvg1BE;EACE,gBAAA;AH0g1BJ;;AGxg1BE;EACE,gBAAA;AH2g1BJ;;AGzg1BE;EACE,gBAAA;AH4g1BJ;;AG1g1BE;EACE,gBAAA;AH6g1BJ;;AG3g1BE;EACE,gBAAA;AH8g1BJ;;AG5g1BE;EACE,gBAAA;AH+g1BJ;;AG7g1BE;EACE,gBAAA;AHgh1BJ;;AG9g1BE;EACE,gBAAA;AHih1BJ;;AG/g1BE;EACE,gBAAA;AHkh1BJ;;AGhh1BE;EACE,gBAAA;AHmh1BJ;;AGjh1BE;EACE,gBAAA;AHoh1BJ;;AGlh1BE;EACE,gBAAA;AHqh1BJ;;AGnh1BE;EACE,gBAAA;AHsh1BJ;;AGph1BE;EACE,gBAAA;AHuh1BJ;;AGrh1BE;EACE,gBAAA;AHwh1BJ;;AGth1BE;EACE,gBAAA;AHyh1BJ;;AGvh1BE;EACE,gBAAA;AH0h1BJ;;AGxh1BE;EACE,gBAAA;AH2h1BJ;;AGzh1BE;EACE,gBAAA;AH4h1BJ;;AG1h1BE;EACE,gBAAA;AH6h1BJ;;AG3h1BE;EACE,gBAAA;AH8h1BJ;;AG5h1BE;EACE,gBAAA;AH+h1BJ;;AG7h1BE;EACE,gBAAA;AHgi1BJ;;AG9h1BE;EACE,gBAAA;AHii1BJ;;AG/h1BE;EACE,gBAAA;AHki1BJ;;AGhi1BE;EACE,gBAAA;AHmi1BJ;;AGji1BE;EACE,gBAAA;AHoi1BJ;;AGli1BE;EACE,gBAAA;AHqi1BJ;;AGni1BE;EACE,gBAAA;AHsi1BJ;;AGpi1BE;EACE,gBAAA;AHui1BJ;;AGri1BE;EACE,gBAAA;AHwi1BJ;;AGti1BE;EACE,gBAAA;AHyi1BJ;;AGvi1BE;EACE,gBAAA;AH0i1BJ;;AGxi1BE;EACE,gBAAA;AH2i1BJ;;AGzi1BE;EACE,gBAAA;AH4i1BJ;;AG1i1BE;EACE,gBAAA;AH6i1BJ;;AG3i1BE;EACE,gBAAA;AH8i1BJ;;AG5i1BE;EACE,gBAAA;AH+i1BJ;;AG7i1BE;EACE,gBAAA;AHgj1BJ;;AG9i1BE;EACE,gBAAA;AHij1BJ;;AG/i1BE;EACE,gBAAA;AHkj1BJ;;AGhj1BE;EACE,gBAAA;AHmj1BJ;;AGjj1BE;EACE,gBAAA;AHoj1BJ;;AGlj1BE;EACE,gBAAA;AHqj1BJ;;AGnj1BE;EACE,gBAAA;AHsj1BJ;;AGpj1BE;EACE,gBAAA;AHuj1BJ;;AGrj1BE;EACE,gBAAA;AHwj1BJ;;AGtj1BE;EACE,gBAAA;AHyj1BJ;;AGvj1BE;EACE,gBAAA;AH0j1BJ;;AGxj1BE;EACE,gBAAA;AH2j1BJ;;AGzj1BE;EACE,gBAAA;AH4j1BJ;;AG1j1BE;EACE,gBAAA;AH6j1BJ;;AG3j1BE;EACE,gBAAA;AH8j1BJ;;AG5j1BE;EACE,gBAAA;AH+j1BJ;;AG7j1BE;EACE,gBAAA;AHgk1BJ;;AG9j1BE;EACE,gBAAA;AHik1BJ;;AG/j1BE;EACE,gBAAA;AHkk1BJ;;AGhk1BE;EACE,gBAAA;AHmk1BJ;;AGjk1BE;EACE,gBAAA;AHok1BJ;;AGlk1BE;EACE,gBAAA;AHqk1BJ;;AGnk1BE;EACE,gBAAA;AHsk1BJ;;AGpk1BE;EACE,gBAAA;AHuk1BJ;;AGrk1BE;EACE,gBAAA;AHwk1BJ;;AGtk1BE;EACE,gBAAA;AHyk1BJ;;AGvk1BE;EACE,gBAAA;AH0k1BJ;;AGxk1BE;EACE,gBAAA;AH2k1BJ;;AGzk1BE;EACE,gBAAA;AH4k1BJ;;AG1k1BE;EACE,gBAAA;AH6k1BJ;;AG3k1BE;EACE,gBAAA;AH8k1BJ;;AG5k1BE;EACE,gBAAA;AH+k1BJ;;AG7k1BE;EACE,gBAAA;AHgl1BJ;;AG9k1BE;EACE,gBAAA;AHil1BJ;;AG/k1BE;EACE,gBAAA;AHkl1BJ;;AGhl1BE;EACE,gBAAA;AHml1BJ;;AGjl1BE;EACE,gBAAA;AHol1BJ;;AGll1BE;EACE,gBAAA;AHql1BJ;;AGnl1BE;EACE,gBAAA;AHsl1BJ;;AGpl1BE;EACE,gBAAA;AHul1BJ;;AGrl1BE;EACE,gBAAA;AHwl1BJ;;AGtl1BE;EACE,gBAAA;AHyl1BJ;;AGvl1BE;EACE,gBAAA;AH0l1BJ;;AGxl1BE;EACE,gBAAA;AH2l1BJ;;AGzl1BE;EACE,gBAAA;AH4l1BJ;;AG1l1BE;EACE,gBAAA;AH6l1BJ;;AG3l1BE;EACE,gBAAA;AH8l1BJ;;AG5l1BE;EACE,gBAAA;AH+l1BJ;;AG7l1BE;EACE,gBAAA;AHgm1BJ;;AG9l1BE;EACE,gBAAA;AHim1BJ;;AG/l1BE;EACE,gBAAA;AHkm1BJ;;AGhm1BE;EACE,gBAAA;AHmm1BJ;;AGjm1BE;EACE,gBAAA;AHom1BJ;;AGlm1BE;EACE,gBAAA;AHqm1BJ;;AGnm1BE;EACE,gBAAA;AHsm1BJ;;AGpm1BE;EACE,gBAAA;AHum1BJ;;AGrm1BE;EACE,gBAAA;AHwm1BJ;;AGtm1BE;EACE,gBAAA;AHym1BJ;;AGvm1BE;EACE,gBAAA;AH0m1BJ;;AGxm1BE;EACE,gBAAA;AH2m1BJ;;AGzm1BE;EACE,gBAAA;AH4m1BJ;;AG1m1BE;EACE,gBAAA;AH6m1BJ;;AG3m1BE;EACE,gBAAA;AH8m1BJ;;AG5m1BE;EACE,gBAAA;AH+m1BJ;;AG7m1BE;EACE,gBAAA;AHgn1BJ;;AG9m1BE;EACE,gBAAA;AHin1BJ;;AG/m1BE;EACE,gBAAA;AHkn1BJ;;AGhn1BE;EACE,gBAAA;AHmn1BJ;;AGjn1BE;EACE,gBAAA;AHon1BJ;;AGln1BE;EACE,gBAAA;AHqn1BJ;;AGnn1BE;EACE,gBAAA;AHsn1BJ;;AGpn1BE;EACE,gBAAA;AHun1BJ;;AGrn1BE;EACE,gBAAA;AHwn1BJ;;AGtn1BE;EACE,gBAAA;AHyn1BJ;;AGvn1BE;EACE,gBAAA;AH0n1BJ;;AGxn1BE;EACE,gBAAA;AH2n1BJ;;AGzn1BE;EACE,gBAAA;AH4n1BJ;;AG1n1BE;EACE,gBAAA;AH6n1BJ;;AG3n1BE;EACE,gBAAA;AH8n1BJ;;AG5n1BE;EACE,gBAAA;AH+n1BJ;;AG7n1BE;EACE,gBAAA;AHgo1BJ;;AG9n1BE;EACE,gBAAA;AHio1BJ;;AG/n1BE;EACE,gBAAA;AHko1BJ;;AGho1BE;EACE,gBAAA;AHmo1BJ;;AGjo1BE;EACE,gBAAA;AHoo1BJ;;AGlo1BE;EACE,gBAAA;AHqo1BJ;;AGno1BE;EACE,gBAAA;AHso1BJ;;AGpo1BE;EACE,gBAAA;AHuo1BJ;;AGro1BE;EACE,gBAAA;AHwo1BJ;;AGto1BE;EACE,gBAAA;AHyo1BJ;;AGvo1BE;EACE,gBAAA;AH0o1BJ;;AGxo1BE;EACE,gBAAA;AH2o1BJ;;AGzo1BE;EACE,gBAAA;AH4o1BJ;;AG1o1BE;EACE,gBAAA;AH6o1BJ;;AG3o1BE;EACE,gBAAA;AH8o1BJ;;AG5o1BE;EACE,gBAAA;AH+o1BJ;;AG7o1BE;EACE,gBAAA;AHgp1BJ;;AG9o1BE;EACE,gBAAA;AHip1BJ;;AG/o1BE;EACE,gBAAA;AHkp1BJ;;AGhp1BE;EACE,gBAAA;AHmp1BJ;;AGjp1BE;EACE,gBAAA;AHop1BJ;;AGlp1BE;EACE,gBAAA;AHqp1BJ;;AGnp1BE;EACE,gBAAA;AHsp1BJ;;AGpp1BE;EACE,gBAAA;AHup1BJ;;AGrp1BE;EACE,gBAAA;AHwp1BJ;;AGtp1BE;EACE,gBAAA;AHyp1BJ;;AGvp1BE;EACE,gBAAA;AH0p1BJ;;AGxp1BE;EACE,gBAAA;AH2p1BJ;;AGzp1BE;EACE,gBAAA;AH4p1BJ;;AG1p1BE;EACE,gBAAA;AH6p1BJ;;AG3p1BE;EACE,gBAAA;AH8p1BJ;;AG5p1BE;EACE,gBAAA;AH+p1BJ;;AG7p1BE;EACE,gBAAA;AHgq1BJ;;AG9p1BE;EACE,gBAAA;AHiq1BJ;;AG/p1BE;EACE,gBAAA;AHkq1BJ;;AGhq1BE;EACE,gBAAA;AHmq1BJ;;AGjq1BE;EACE,gBAAA;AHoq1BJ;;AGlq1BE;EACE,gBAAA;AHqq1BJ;;AGnq1BE;EACE,gBAAA;AHsq1BJ;;AGpq1BE;EACE,gBAAA;AHuq1BJ;;AGrq1BE;EACE,gBAAA;AHwq1BJ;;AGtq1BE;EACE,gBAAA;AHyq1BJ;;AGvq1BE;EACE,gBAAA;AH0q1BJ;;AGxq1BE;EACE,gBAAA;AH2q1BJ;;AGzq1BE;EACE,gBAAA;AH4q1BJ;;AG1q1BE;EACE,gBAAA;AH6q1BJ;;AG3q1BE;EACE,gBAAA;AH8q1BJ;;AG5q1BE;EACE,gBAAA;AH+q1BJ;;AG7q1BE;EACE,gBAAA;AHgr1BJ;;AG9q1BE;EACE,gBAAA;AHir1BJ;;AG/q1BE;EACE,gBAAA;AHkr1BJ;;AGhr1BE;EACE,gBAAA;AHmr1BJ;;AGjr1BE;EACE,gBAAA;AHor1BJ;;AGlr1BE;EACE,gBAAA;AHqr1BJ;;AGnr1BE;EACE,gBAAA;AHsr1BJ;;AGpr1BE;EACE,gBAAA;AHur1BJ;;AGrr1BE;EACE,gBAAA;AHwr1BJ;;AGtr1BE;EACE,gBAAA;AHyr1BJ;;AGvr1BE;EACE,gBAAA;AH0r1BJ;;AGxr1BE;EACE,gBAAA;AH2r1BJ;;AGzr1BE;EACE,gBAAA;AH4r1BJ;;AG1r1BE;EACE,gBAAA;AH6r1BJ;;AG3r1BE;EACE,gBAAA;AH8r1BJ;;AG5r1BE;EACE,gBAAA;AH+r1BJ;;AG7r1BE;EACE,gBAAA;AHgs1BJ;;AG9r1BE;EACE,gBAAA;AHis1BJ;;AG/r1BE;EACE,gBAAA;AHks1BJ;;AGhs1BE;EACE,gBAAA;AHms1BJ;;AGjs1BE;EACE,gBAAA;AHos1BJ;;AGls1BE;EACE,gBAAA;AHqs1BJ;;AGns1BE;EACE,gBAAA;AHss1BJ;;AGps1BE;EACE,gBAAA;AHus1BJ;;AGrs1BE;EACE,gBAAA;AHws1BJ;;AGts1BE;EACE,gBAAA;AHys1BJ;;AGvs1BE;EACE,gBAAA;AH0s1BJ;;AGxs1BE;EACE,gBAAA;AH2s1BJ;;AGzs1BE;EACE,gBAAA;AH4s1BJ;;AG1s1BE;EACE,gBAAA;AH6s1BJ;;AG3s1BE;EACE,gBAAA;AH8s1BJ;;AG5s1BE;EACE,gBAAA;AH+s1BJ;;AG7s1BE;EACE,gBAAA;AHgt1BJ;;AG9s1BE;EACE,gBAAA;AHit1BJ;;AG/s1BE;EACE,gBAAA;AHkt1BJ;;AGht1BE;EACE,gBAAA;AHmt1BJ;;AGjt1BE;EACE,gBAAA;AHot1BJ;;AGlt1BE;EACE,gBAAA;AHqt1BJ;;AGnt1BE;EACE,gBAAA;AHst1BJ;;AGpt1BE;EACE,gBAAA;AHut1BJ;;AGrt1BE;EACE,gBAAA;AHwt1BJ;;AGtt1BE;EACE,gBAAA;AHyt1BJ;;AGvt1BE;EACE,gBAAA;AH0t1BJ;;AGxt1BE;EACE,gBAAA;AH2t1BJ;;AGzt1BE;EACE,gBAAA;AH4t1BJ;;AG1t1BE;EACE,gBAAA;AH6t1BJ;;AG3t1BE;EACE,gBAAA;AH8t1BJ;;AG5t1BE;EACE,gBAAA;AH+t1BJ;;AG7t1BE;EACE,gBAAA;AHgu1BJ;;AG9t1BE;EACE,gBAAA;AHiu1BJ;;AG/t1BE;EACE,gBAAA;AHku1BJ;;AGhu1BE;EACE,gBAAA;AHmu1BJ;;AGju1BE;EACE,gBAAA;AHou1BJ;;AGlu1BE;EACE,gBAAA;AHqu1BJ;;AGnu1BE;EACE,gBAAA;AHsu1BJ;;AGpu1BE;EACE,gBAAA;AHuu1BJ;;AGru1BE;EACE,gBAAA;AHwu1BJ;;AGtu1BE;EACE,gBAAA;AHyu1BJ;;AGvu1BE;EACE,gBAAA;AH0u1BJ;;AGxu1BE;EACE,gBAAA;AH2u1BJ;;AGzu1BE;EACE,gBAAA;AH4u1BJ;;AG1u1BE;EACE,gBAAA;AH6u1BJ;;AG3u1BE;EACE,gBAAA;AH8u1BJ;;AG5u1BE;EACE,gBAAA;AH+u1BJ;;AG7u1BE;EACE,gBAAA;AHgv1BJ;;AG9u1BE;EACE,gBAAA;AHiv1BJ;;AG/u1BE;EACE,gBAAA;AHkv1BJ;;AGhv1BE;EACE,gBAAA;AHmv1BJ;;AGjv1BE;EACE,gBAAA;AHov1BJ;;AGlv1BE;EACE,gBAAA;AHqv1BJ;;AGnv1BE;EACE,gBAAA;AHsv1BJ;;AGpv1BE;EACE,gBAAA;AHuv1BJ;;AGrv1BE;EACE,gBAAA;AHwv1BJ;;AGtv1BE;EACE,gBAAA;AHyv1BJ;;AGvv1BE;EACE,gBAAA;AH0v1BJ;;AGxv1BE;EACE,gBAAA;AH2v1BJ;;AGzv1BE;EACE,gBAAA;AH4v1BJ;;AG1v1BE;EACE,gBAAA;AH6v1BJ;;AG3v1BE;EACE,gBAAA;AH8v1BJ;;AG5v1BE;EACE,gBAAA;AH+v1BJ;;AG7v1BE;EACE,gBAAA;AHgw1BJ;;AG9v1BE;EACE,gBAAA;AHiw1BJ;;AG/v1BE;EACE,gBAAA;AHkw1BJ;;AGhw1BE;EACE,gBAAA;AHmw1BJ;;AGjw1BE;EACE,gBAAA;AHow1BJ;;AGlw1BE;EACE,gBAAA;AHqw1BJ;;AGnw1BE;EACE,gBAAA;AHsw1BJ;;AGpw1BE;EACE,gBAAA;AHuw1BJ;;AGrw1BE;EACE,gBAAA;AHww1BJ;;AGtw1BE;EACE,gBAAA;AHyw1BJ;;AGvw1BE;EACE,gBAAA;AH0w1BJ;;AGxw1BE;EACE,gBAAA;AH2w1BJ;;AGzw1BE;EACE,gBAAA;AH4w1BJ;;AG1w1BE;EACE,gBAAA;AH6w1BJ;;AG3w1BE;EACE,gBAAA;AH8w1BJ;;AG5w1BE;EACE,gBAAA;AH+w1BJ;;AG7w1BE;EACE,gBAAA;AHgx1BJ;;AG9w1BE;EACE,gBAAA;AHix1BJ;;AG/w1BE;EACE,gBAAA;AHkx1BJ;;AGhx1BE;EACE,gBAAA;AHmx1BJ;;AGjx1BE;EACE,gBAAA;AHox1BJ;;AGlx1BE;EACE,gBAAA;AHqx1BJ;;AGnx1BE;EACE,gBAAA;AHsx1BJ;;AGpx1BE;EACE,gBAAA;AHux1BJ;;AGrx1BE;EACE,gBAAA;AHwx1BJ;;AGtx1BE;EACE,gBAAA;AHyx1BJ;;AGvx1BE;EACE,gBAAA;AH0x1BJ;;AGxx1BE;EACE,gBAAA;AH2x1BJ;;AGzx1BE;EACE,gBAAA;AH4x1BJ;;AG1x1BE;EACE,gBAAA;AH6x1BJ;;AG3x1BE;EACE,gBAAA;AH8x1BJ;;AG5x1BE;EACE,gBAAA;AH+x1BJ;;AG7x1BE;EACE,gBAAA;AHgy1BJ;;AG9x1BE;EACE,gBAAA;AHiy1BJ;;AG/x1BE;EACE,gBAAA;AHky1BJ;;AGhy1BE;EACE,gBAAA;AHmy1BJ;;AGjy1BE;EACE,gBAAA;AHoy1BJ;;AGly1BE;EACE,gBAAA;AHqy1BJ;;AGny1BE;EACE,gBAAA;AHsy1BJ;;AGpy1BE;EACE,gBAAA;AHuy1BJ;;AGry1BE;EACE,gBAAA;AHwy1BJ;;AGty1BE;EACE,gBAAA;AHyy1BJ;;AGvy1BE;EACE,gBAAA;AH0y1BJ;;AGxy1BE;EACE,gBAAA;AH2y1BJ;;AGzy1BE;EACE,gBAAA;AH4y1BJ;;AG1y1BE;EACE,gBAAA;AH6y1BJ;;AG3y1BE;EACE,gBAAA;AH8y1BJ;;AG5y1BE;EACE,gBAAA;AH+y1BJ;;AG7y1BE;EACE,gBAAA;AHgz1BJ;;AG9y1BE;EACE,gBAAA;AHiz1BJ;;AG/y1BE;EACE,gBAAA;AHkz1BJ;;AGhz1BE;EACE,gBAAA;AHmz1BJ;;AGjz1BE;EACE,gBAAA;AHoz1BJ;;AGlz1BE;EACE,gBAAA;AHqz1BJ;;AGnz1BE;EACE,gBAAA;AHsz1BJ;;AGpz1BE;EACE,gBAAA;AHuz1BJ;;AGrz1BE;EACE,gBAAA;AHwz1BJ;;AGtz1BE;EACE,gBAAA;AHyz1BJ;;AGvz1BE;EACE,gBAAA;AH0z1BJ;;AGxz1BE;EACE,gBAAA;AH2z1BJ;;AGzz1BE;EACE,gBAAA;AH4z1BJ;;AG1z1BE;EACE,gBAAA;AH6z1BJ;;AG3z1BE;EACE,gBAAA;AH8z1BJ;;AG5z1BE;EACE,gBAAA;AH+z1BJ;;AG7z1BE;EACE,gBAAA;AHg01BJ;;AG9z1BE;EACE,gBAAA;AHi01BJ;;AG/z1BE;EACE,gBAAA;AHk01BJ;;AGh01BE;EACE,gBAAA;AHm01BJ;;AGj01BE;EACE,gBAAA;AHo01BJ;;AGl01BE;EACE,gBAAA;AHq01BJ;;AGn01BE;EACE,gBAAA;AHs01BJ;;AGp01BE;EACE,gBAAA;AHu01BJ;;AGr01BE;EACE,gBAAA;AHw01BJ;;AGt01BE;EACE,gBAAA;AHy01BJ;;AGv01BE;EACE,gBAAA;AH001BJ;;AGx01BE;EACE,gBAAA;AH201BJ;;AGz01BE;EACE,gBAAA;AH401BJ;;AG101BE;EACE,gBAAA;AH601BJ;;AG301BE;EACE,gBAAA;AH801BJ;;AG501BE;EACE,gBAAA;AH+01BJ;;AG701BE;EACE,gBAAA;AHg11BJ;;AG901BE;EACE,gBAAA;AHi11BJ;;AG/01BE;EACE,gBAAA;AHk11BJ;;AGh11BE;EACE,gBAAA;AHm11BJ;;AGj11BE;EACE,gBAAA;AHo11BJ;;AGl11BE;EACE,gBAAA;AHq11BJ;;AGn11BE;EACE,gBAAA;AHs11BJ;;AGp11BE;EACE,gBAAA;AHu11BJ;;AGr11BE;EACE,gBAAA;AHw11BJ;;AGt11BE;EACE,gBAAA;AHy11BJ;;AGv11BE;EACE,gBAAA;AH011BJ;;AGx11BE;EACE,gBAAA;AH211BJ;;AGz11BE;EACE,gBAAA;AH411BJ;;AG111BE;EACE,gBAAA;AH611BJ;;AG311BE;EACE,gBAAA;AH811BJ;;AG511BE;EACE,gBAAA;AH+11BJ;;AG711BE;EACE,gBAAA;AHg21BJ;;AG911BE;EACE,gBAAA;AHi21BJ;;AG/11BE;EACE,gBAAA;AHk21BJ;;AGh21BE;EACE,gBAAA;AHm21BJ;;AGj21BE;EACE,gBAAA;AHo21BJ;;AGl21BE;EACE,gBAAA;AHq21BJ;;AGn21BE;EACE,gBAAA;AHs21BJ;;AGp21BE;EACE,gBAAA;AHu21BJ;;AGr21BE;EACE,gBAAA;AHw21BJ;;AGt21BE;EACE,gBAAA;AHy21BJ;;AGv21BE;EACE,gBAAA;AH021BJ;;AGx21BE;EACE,gBAAA;AH221BJ;;AGz21BE;EACE,gBAAA;AH421BJ;;AG121BE;EACE,gBAAA;AH621BJ;;AG321BE;EACE,gBAAA;AH821BJ;;AG521BE;EACE,gBAAA;AH+21BJ;;AG721BE;EACE,gBAAA;AHg31BJ;;AG921BE;EACE,gBAAA;AHi31BJ;;AG/21BE;EACE,gBAAA;AHk31BJ;;AGh31BE;EACE,gBAAA;AHm31BJ;;AGj31BE;EACE,gBAAA;AHo31BJ;;AGl31BE;EACE,gBAAA;AHq31BJ;;AGn31BE;EACE,gBAAA;AHs31BJ;;AGp31BE;EACE,gBAAA;AHu31BJ;;AGr31BE;EACE,gBAAA;AHw31BJ;;AGt31BE;EACE,gBAAA;AHy31BJ;;AGv31BE;EACE,gBAAA;AH031BJ;;AGx31BE;EACE,gBAAA;AH231BJ;;AGz31BE;EACE,gBAAA;AH431BJ;;AG131BE;EACE,gBAAA;AH631BJ;;AG331BE;EACE,gBAAA;AH831BJ;;AG531BE;EACE,gBAAA;AH+31BJ;;AG731BE;EACE,gBAAA;AHg41BJ;;AG931BE;EACE,gBAAA;AHi41BJ;;AG/31BE;EACE,gBAAA;AHk41BJ;;AGh41BE;EACE,gBAAA;AHm41BJ;;AGj41BE;EACE,gBAAA;AHo41BJ;;AGl41BE;EACE,gBAAA;AHq41BJ;;AGn41BE;EACE,gBAAA;AHs41BJ;;AGp41BE;EACE,gBAAA;AHu41BJ;;AGr41BE;EACE,gBAAA;AHw41BJ;;AGt41BE;EACE,gBAAA;AHy41BJ;;AGv41BE;EACE,gBAAA;AH041BJ;;AGx41BE;EACE,gBAAA;AH241BJ;;AGz41BE;EACE,gBAAA;AH441BJ;;AG141BE;EACE,gBAAA;AH641BJ;;AG341BE;EACE,gBAAA;AH841BJ;;AG541BE;EACE,gBAAA;AH+41BJ;;AG741BE;EACE,gBAAA;AHg51BJ;;AG941BE;EACE,gBAAA;AHi51BJ;;AG/41BE;EACE,gBAAA;AHk51BJ;;AGh51BE;EACE,gBAAA;AHm51BJ;;AGj51BE;EACE,gBAAA;AHo51BJ;;AGl51BE;EACE,gBAAA;AHq51BJ;;AGn51BE;EACE,gBAAA;AHs51BJ;;AGp51BE;EACE,gBAAA;AHu51BJ;;AGr51BE;EACE,gBAAA;AHw51BJ;;AGt51BE;EACE,gBAAA;AHy51BJ;;AGv51BE;EACE,gBAAA;AH051BJ;;AGx51BE;EACE,gBAAA;AH251BJ;;AGz51BE;EACE,gBAAA;AH451BJ;;AG151BE;EACE,gBAAA;AH651BJ;;AG351BE;EACE,gBAAA;AH851BJ;;AG551BE;EACE,gBAAA;AH+51BJ;;AG751BE;EACE,gBAAA;AHg61BJ;;AG951BE;EACE,gBAAA;AHi61BJ;;AG/51BE;EACE,gBAAA;AHk61BJ;;AGh61BE;EACE,gBAAA;AHm61BJ;;AGj61BE;EACE,gBAAA;AHo61BJ;;AGl61BE;EACE,gBAAA;AHq61BJ;;AGn61BE;EACE,gBAAA;AHs61BJ;;AGp61BE;EACE,gBAAA;AHu61BJ;;AGr61BE;EACE,gBAAA;AHw61BJ;;AGt61BE;EACE,gBAAA;AHy61BJ;;AGv61BE;EACE,gBAAA;AH061BJ;;AGx61BE;EACE,gBAAA;AH261BJ;;AGz61BE;EACE,gBAAA;AH461BJ;;AG161BE;EACE,gBAAA;AH661BJ;;AG361BE;EACE,gBAAA;AH861BJ;;AG561BE;EACE,gBAAA;AH+61BJ;;AG761BE;EACE,gBAAA;AHg71BJ;;AG961BE;EACE,gBAAA;AHi71BJ;;AG/61BE;EACE,gBAAA;AHk71BJ;;AGh71BE;EACE,gBAAA;AHm71BJ;;AGj71BE;EACE,gBAAA;AHo71BJ;;AGl71BE;EACE,gBAAA;AHq71BJ;;AGn71BE;EACE,gBAAA;AHs71BJ;;AGp71BE;EACE,gBAAA;AHu71BJ;;AGr71BE;EACE,gBAAA;AHw71BJ;;AGt71BE;EACE,gBAAA;AHy71BJ;;AGv71BE;EACE,gBAAA;AH071BJ;;AGx71BE;EACE,gBAAA;AH271BJ;;AGz71BE;EACE,gBAAA;AH471BJ;;AG171BE;EACE,gBAAA;AH671BJ;;AG371BE;EACE,gBAAA;AH871BJ;;AG571BE;EACE,gBAAA;AH+71BJ;;AG771BE;EACE,gBAAA;AHg81BJ;;AG971BE;EACE,gBAAA;AHi81BJ;;AG/71BE;EACE,gBAAA;AHk81BJ;;AGh81BE;EACE,gBAAA;AHm81BJ;;AGj81BE;EACE,gBAAA;AHo81BJ;;AGl81BE;EACE,gBAAA;AHq81BJ;;AGn81BE;EACE,gBAAA;AHs81BJ;;AGp81BE;EACE,gBAAA;AHu81BJ;;AGr81BE;EACE,gBAAA;AHw81BJ;;AGt81BE;EACE,gBAAA;AHy81BJ;;AGv81BE;EACE,gBAAA;AH081BJ;;AGx81BE;EACE,gBAAA;AH281BJ;;AGz81BE;EACE,gBAAA;AH481BJ;;AG181BE;EACE,gBAAA;AH681BJ;;AG381BE;EACE,gBAAA;AH881BJ;;AG581BE;EACE,gBAAA;AH+81BJ;;AG781BE;EACE,gBAAA;AHg91BJ;;AG981BE;EACE,gBAAA;AHi91BJ;;AG/81BE;EACE,gBAAA;AHk91BJ;;AGh91BE;EACE,gBAAA;AHm91BJ;;AGj91BE;EACE,gBAAA;AHo91BJ;;AGl91BE;EACE,gBAAA;AHq91BJ;;AGn91BE;EACE,gBAAA;AHs91BJ;;AGp91BE;EACE,gBAAA;AHu91BJ;;AGr91BE;EACE,gBAAA;AHw91BJ;;AGt91BE;EACE,gBAAA;AHy91BJ;;AGv91BE;EACE,gBAAA;AH091BJ;;AGx91BE;EACE,gBAAA;AH291BJ;;AGz91BE;EACE,gBAAA;AH491BJ;;AG191BE;EACE,gBAAA;AH691BJ;;AG391BE;EACE,gBAAA;AH891BJ;;AG591BE;EACE,gBAAA;AH+91BJ;;AG791BE;EACE,gBAAA;AHg+1BJ;;AG991BE;EACE,gBAAA;AHi+1BJ;;AG/91BE;EACE,gBAAA;AHk+1BJ;;AGh+1BE;EACE,gBAAA;AHm+1BJ;;AGj+1BE;EACE,gBAAA;AHo+1BJ;;AGl+1BE;EACE,gBAAA;AHq+1BJ;;AGn+1BE;EACE,gBAAA;AHs+1BJ;;AGp+1BE;EACE,gBAAA;AHu+1BJ;;AGr+1BE;EACE,gBAAA;AHw+1BJ;;AGt+1BE;EACE,gBAAA;AHy+1BJ;;AGv+1BE;EACE,gBAAA;AH0+1BJ;;AGx+1BE;EACE,gBAAA;AH2+1BJ;;AGz+1BE;EACE,gBAAA;AH4+1BJ;;AG1+1BE;EACE,gBAAA;AH6+1BJ;;AG3+1BE;EACE,gBAAA;AH8+1BJ;;AG5+1BE;EACE,gBAAA;AH++1BJ;;AG7+1BE;EACE,gBAAA;AHg/1BJ;;AG9+1BE;EACE,gBAAA;AHi/1BJ;;AG/+1BE;EACE,gBAAA;AHk/1BJ;;AGh/1BE;EACE,gBAAA;AHm/1BJ;;AGj/1BE;EACE,gBAAA;AHo/1BJ;;AGl/1BE;EACE,gBAAA;AHq/1BJ;;AGn/1BE;EACE,gBAAA;AHs/1BJ;;AGp/1BE;EACE,gBAAA;AHu/1BJ;;AGr/1BE;EACE,gBAAA;AHw/1BJ;;AGt/1BE;EACE,gBAAA;AHy/1BJ;;AGv/1BE;EACE,gBAAA;AH0/1BJ;;AGx/1BE;EACE,gBAAA;AH2/1BJ;;AGz/1BE;EACE,gBAAA;AH4/1BJ;;AG1/1BE;EACE,gBAAA;AH6/1BJ;;AG3/1BE;EACE,gBAAA;AH8/1BJ;;AG5/1BE;EACE,gBAAA;AH+/1BJ;;AG7/1BE;EACE,gBAAA;AHgg2BJ;;AG9/1BE;EACE,gBAAA;AHig2BJ;;AG//1BE;EACE,gBAAA;AHkg2BJ;;AGhg2BE;EACE,gBAAA;AHmg2BJ;;AGjg2BE;EACE,gBAAA;AHog2BJ;;AGlg2BE;EACE,gBAAA;AHqg2BJ;;AGng2BE;EACE,gBAAA;AHsg2BJ;;AGpg2BE;EACE,gBAAA;AHug2BJ;;AGrg2BE;EACE,gBAAA;AHwg2BJ;;AGtg2BE;EACE,gBAAA;AHyg2BJ;;AGvg2BE;EACE,gBAAA;AH0g2BJ;;AGxg2BE;EACE,gBAAA;AH2g2BJ;;AGzg2BE;EACE,gBAAA;AH4g2BJ;;AG1g2BE;EACE,gBAAA;AH6g2BJ;;AG3g2BE;EACE,gBAAA;AH8g2BJ;;AG5g2BE;EACE,gBAAA;AH+g2BJ;;AG7g2BE;EACE,gBAAA;AHgh2BJ;;AG9g2BE;EACE,gBAAA;AHih2BJ;;AG/g2BE;EACE,gBAAA;AHkh2BJ;;AGhh2BE;EACE,gBAAA;AHmh2BJ;;AGjh2BE;EACE,gBAAA;AHoh2BJ;;AGlh2BE;EACE,gBAAA;AHqh2BJ;;AGnh2BE;EACE,gBAAA;AHsh2BJ;;AGph2BE;EACE,gBAAA;AHuh2BJ;;AGrh2BE;EACE,gBAAA;AHwh2BJ;;AGth2BE;EACE,gBAAA;AHyh2BJ;;AGvh2BE;EACE,gBAAA;AH0h2BJ;;AGxh2BE;EACE,gBAAA;AH2h2BJ;;AGzh2BE;EACE,gBAAA;AH4h2BJ;;AG1h2BE;EACE,gBAAA;AH6h2BJ;;AG3h2BE;EACE,gBAAA;AH8h2BJ;;AG5h2BE;EACE,gBAAA;AH+h2BJ;;AG7h2BE;EACE,gBAAA;AHgi2BJ;;AG9h2BE;EACE,gBAAA;AHii2BJ;;AG/h2BE;EACE,gBAAA;AHki2BJ;;AGhi2BE;EACE,gBAAA;AHmi2BJ;;AGji2BE;EACE,gBAAA;AHoi2BJ;;AGli2BE;EACE,gBAAA;AHqi2BJ;;AGni2BE;EACE,gBAAA;AHsi2BJ;;AGpi2BE;EACE,gBAAA;AHui2BJ;;AGri2BE;EACE,gBAAA;AHwi2BJ;;AGti2BE;EACE,gBAAA;AHyi2BJ;;AGvi2BE;EACE,gBAAA;AH0i2BJ;;AGxi2BE;EACE,gBAAA;AH2i2BJ;;AGzi2BE;EACE,gBAAA;AH4i2BJ;;AG1i2BE;EACE,gBAAA;AH6i2BJ;;AG3i2BE;EACE,gBAAA;AH8i2BJ;;AG5i2BE;EACE,gBAAA;AH+i2BJ;;AG7i2BE;EACE,gBAAA;AHgj2BJ;;AG9i2BE;EACE,gBAAA;AHij2BJ;;AG/i2BE;EACE,gBAAA;AHkj2BJ;;AGhj2BE;EACE,gBAAA;AHmj2BJ;;AGjj2BE;EACE,gBAAA;AHoj2BJ;;AGlj2BE;EACE,gBAAA;AHqj2BJ;;AGnj2BE;EACE,gBAAA;AHsj2BJ;;AGpj2BE;EACE,gBAAA;AHuj2BJ;;AGrj2BE;EACE,gBAAA;AHwj2BJ;;AGtj2BE;EACE,gBAAA;AHyj2BJ;;AGvj2BE;EACE,gBAAA;AH0j2BJ;;AGxj2BE;EACE,gBAAA;AH2j2BJ;;AGzj2BE;EACE,gBAAA;AH4j2BJ;;AG1j2BE;EACE,gBAAA;AH6j2BJ;;AG3j2BE;EACE,gBAAA;AH8j2BJ;;AG5j2BE;EACE,gBAAA;AH+j2BJ;;AG7j2BE;EACE,gBAAA;AHgk2BJ;;AG9j2BE;EACE,gBAAA;AHik2BJ;;AG/j2BE;EACE,gBAAA;AHkk2BJ;;AGhk2BE;EACE,gBAAA;AHmk2BJ;;AGjk2BE;EACE,gBAAA;AHok2BJ;;AGlk2BE;EACE,gBAAA;AHqk2BJ;;AGnk2BE;EACE,gBAAA;AHsk2BJ;;AGpk2BE;EACE,gBAAA;AHuk2BJ;;AGrk2BE;EACE,gBAAA;AHwk2BJ;;AGtk2BE;EACE,gBAAA;AHyk2BJ;;AGvk2BE;EACE,gBAAA;AH0k2BJ;;AGxk2BE;EACE,gBAAA;AH2k2BJ;;AGzk2BE;EACE,gBAAA;AH4k2BJ;;AG1k2BE;EACE,gBAAA;AH6k2BJ;;AG3k2BE;EACE,gBAAA;AH8k2BJ;;AG5k2BE;EACE,gBAAA;AH+k2BJ;;AG7k2BE;EACE,gBAAA;AHgl2BJ;;AG9k2BE;EACE,gBAAA;AHil2BJ;;AG/k2BE;EACE,gBAAA;AHkl2BJ;;AGhl2BE;EACE,gBAAA;AHml2BJ;;AGjl2BE;EACE,gBAAA;AHol2BJ;;AGll2BE;EACE,gBAAA;AHql2BJ;;AGnl2BE;EACE,gBAAA;AHsl2BJ;;AGpl2BE;EACE,gBAAA;AHul2BJ;;AGrl2BE;EACE,gBAAA;AHwl2BJ;;AGtl2BE;EACE,gBAAA;AHyl2BJ;;AGvl2BE;EACE,gBAAA;AH0l2BJ;;AGxl2BE;EACE,gBAAA;AH2l2BJ;;AGzl2BE;EACE,gBAAA;AH4l2BJ;;AG1l2BE;EACE,gBAAA;AH6l2BJ;;AG3l2BE;EACE,gBAAA;AH8l2BJ;;AG5l2BE;EACE,gBAAA;AH+l2BJ;;AG7l2BE;EACE,gBAAA;AHgm2BJ;;AG9l2BE;EACE,gBAAA;AHim2BJ;;AG/l2BE;EACE,gBAAA;AHkm2BJ;;AGhm2BE;EACE,gBAAA;AHmm2BJ;;AGjm2BE;EACE,gBAAA;AHom2BJ;;AGlm2BE;EACE,gBAAA;AHqm2BJ;;AGnm2BE;EACE,gBAAA;AHsm2BJ;;AGpm2BE;EACE,gBAAA;AHum2BJ;;AGrm2BE;EACE,gBAAA;AHwm2BJ;;AGtm2BE;EACE,gBAAA;AHym2BJ;;AGvm2BE;EACE,gBAAA;AH0m2BJ;;AGxm2BE;EACE,gBAAA;AH2m2BJ;;AGzm2BE;EACE,gBAAA;AH4m2BJ;;AG1m2BE;EACE,gBAAA;AH6m2BJ;;AG3m2BE;EACE,gBAAA;AH8m2BJ;;AG5m2BE;EACE,gBAAA;AH+m2BJ;;AG7m2BE;EACE,gBAAA;AHgn2BJ;;AG9m2BE;EACE,gBAAA;AHin2BJ;;AG/m2BE;EACE,gBAAA;AHkn2BJ;;AGhn2BE;EACE,gBAAA;AHmn2BJ;;AGjn2BE;EACE,gBAAA;AHon2BJ;;AGln2BE;EACE,gBAAA;AHqn2BJ;;AGnn2BE;EACE,gBAAA;AHsn2BJ;;AGpn2BE;EACE,gBAAA;AHun2BJ;;AGrn2BE;EACE,gBAAA;AHwn2BJ;;AGtn2BE;EACE,gBAAA;AHyn2BJ;;AGvn2BE;EACE,gBAAA;AH0n2BJ;;AGxn2BE;EACE,gBAAA;AH2n2BJ;;AGzn2BE;EACE,gBAAA;AH4n2BJ;;AG1n2BE;EACE,gBAAA;AH6n2BJ;;AG3n2BE;EACE,gBAAA;AH8n2BJ;;AG5n2BE;EACE,gBAAA;AH+n2BJ;;AG7n2BE;EACE,gBAAA;AHgo2BJ;;AG9n2BE;EACE,gBAAA;AHio2BJ;;AG/n2BE;EACE,gBAAA;AHko2BJ;;AGho2BE;EACE,gBAAA;AHmo2BJ;;AGjo2BE;EACE,gBAAA;AHoo2BJ;;AGlo2BE;EACE,gBAAA;AHqo2BJ;;AGno2BE;EACE,gBAAA;AHso2BJ;;AGpo2BE;EACE,gBAAA;AHuo2BJ;;AGro2BE;EACE,gBAAA;AHwo2BJ;;AGto2BE;EACE,gBAAA;AHyo2BJ;;AGvo2BE;EACE,gBAAA;AH0o2BJ;;AGxo2BE;EACE,gBAAA;AH2o2BJ;;AGzo2BE;EACE,gBAAA;AH4o2BJ;;AG1o2BE;EACE,gBAAA;AH6o2BJ;;AG3o2BE;EACE,gBAAA;AH8o2BJ;;AG5o2BE;EACE,gBAAA;AH+o2BJ;;AG7o2BE;EACE,gBAAA;AHgp2BJ;;AG9o2BE;EACE,gBAAA;AHip2BJ;;AG/o2BE;EACE,gBAAA;AHkp2BJ;;AGhp2BE;EACE,gBAAA;AHmp2BJ;;AGjp2BE;EACE,gBAAA;AHop2BJ;;AGlp2BE;EACE,gBAAA;AHqp2BJ;;AGnp2BE;EACE,gBAAA;AHsp2BJ;;AGpp2BE;EACE,gBAAA;AHup2BJ;;AGrp2BE;EACE,gBAAA;AHwp2BJ;;AGtp2BE;EACE,gBAAA;AHyp2BJ;;AGvp2BE;EACE,gBAAA;AH0p2BJ;;AGxp2BE;EACE,gBAAA;AH2p2BJ;;AGzp2BE;EACE,gBAAA;AH4p2BJ;;AG1p2BE;EACE,gBAAA;AH6p2BJ;;AG3p2BE;EACE,gBAAA;AH8p2BJ;;AG5p2BE;EACE,gBAAA;AH+p2BJ;;AG7p2BE;EACE,gBAAA;AHgq2BJ;;AG9p2BE;EACE,gBAAA;AHiq2BJ;;AG/p2BE;EACE,gBAAA;AHkq2BJ;;AGhq2BE;EACE,gBAAA;AHmq2BJ;;AGjq2BE;EACE,gBAAA;AHoq2BJ;;AGlq2BE;EACE,gBAAA;AHqq2BJ;;AGnq2BE;EACE,gBAAA;AHsq2BJ;;AGpq2BE;EACE,gBAAA;AHuq2BJ;;AGrq2BE;EACE,gBAAA;AHwq2BJ;;AGtq2BE;EACE,gBAAA;AHyq2BJ;;AGvq2BE;EACE,gBAAA;AH0q2BJ;;AGxq2BE;EACE,gBAAA;AH2q2BJ;;AGzq2BE;EACE,gBAAA;AH4q2BJ;;AG1q2BE;EACE,gBAAA;AH6q2BJ;;AG3q2BE;EACE,gBAAA;AH8q2BJ;;AG5q2BE;EACE,gBAAA;AH+q2BJ;;AG7q2BE;EACE,gBAAA;AHgr2BJ;;AG9q2BE;EACE,gBAAA;AHir2BJ;;AG/q2BE;EACE,gBAAA;AHkr2BJ;;AGhr2BE;EACE,gBAAA;AHmr2BJ;;AGjr2BE;EACE,gBAAA;AHor2BJ;;AGlr2BE;EACE,gBAAA;AHqr2BJ;;AGnr2BE;EACE,gBAAA;AHsr2BJ;;AGpr2BE;EACE,gBAAA;AHur2BJ;;AGrr2BE;EACE,gBAAA;AHwr2BJ;;AGtr2BE;EACE,gBAAA;AHyr2BJ;;AGvr2BE;EACE,gBAAA;AH0r2BJ;;AGxr2BE;EACE,gBAAA;AH2r2BJ;;AGzr2BE;EACE,gBAAA;AH4r2BJ;;AG1r2BE;EACE,gBAAA;AH6r2BJ;;AG3r2BE;EACE,gBAAA;AH8r2BJ;;AG5r2BE;EACE,gBAAA;AH+r2BJ;;AG7r2BE;EACE,gBAAA;AHgs2BJ;;AG9r2BE;EACE,gBAAA;AHis2BJ;;AG/r2BE;EACE,gBAAA;AHks2BJ;;AGhs2BE;EACE,gBAAA;AHms2BJ;;AGjs2BE;EACE,gBAAA;AHos2BJ;;AGls2BE;EACE,gBAAA;AHqs2BJ;;AGns2BE;EACE,gBAAA;AHss2BJ;;AGps2BE;EACE,gBAAA;AHus2BJ;;AGrs2BE;EACE,gBAAA;AHws2BJ;;AGts2BE;EACE,gBAAA;AHys2BJ;;AGvs2BE;EACE,gBAAA;AH0s2BJ;;AGxs2BE;EACE,gBAAA;AH2s2BJ;;AGzs2BE;EACE,gBAAA;AH4s2BJ;;AG1s2BE;EACE,gBAAA;AH6s2BJ;;AG3s2BE;EACE,gBAAA;AH8s2BJ;;AG5s2BE;EACE,gBAAA;AH+s2BJ;;AG7s2BE;EACE,gBAAA;AHgt2BJ;;AG9s2BE;EACE,gBAAA;AHit2BJ;;AG/s2BE;EACE,gBAAA;AHkt2BJ;;AGht2BE;EACE,gBAAA;AHmt2BJ;;AGjt2BE;EACE,gBAAA;AHot2BJ;;AGlt2BE;EACE,gBAAA;AHqt2BJ;;AGnt2BE;EACE,gBAAA;AHst2BJ;;AGpt2BE;EACE,gBAAA;AHut2BJ;;AGrt2BE;EACE,gBAAA;AHwt2BJ;;AGtt2BE;EACE,gBAAA;AHyt2BJ;;AGvt2BE;EACE,gBAAA;AH0t2BJ;;AGxt2BE;EACE,gBAAA;AH2t2BJ;;AGzt2BE;EACE,gBAAA;AH4t2BJ;;AG1t2BE;EACE,gBAAA;AH6t2BJ;;AG3t2BE;EACE,gBAAA;AH8t2BJ;;AG5t2BE;EACE,gBAAA;AH+t2BJ;;AG7t2BE;EACE,gBAAA;AHgu2BJ;;AG9t2BE;EACE,gBAAA;AHiu2BJ;;AG/t2BE;EACE,gBAAA;AHku2BJ;;AGhu2BE;EACE,gBAAA;AHmu2BJ;;AGju2BE;EACE,gBAAA;AHou2BJ;;AGlu2BE;EACE,gBAAA;AHqu2BJ;;AGnu2BE;EACE,gBAAA;AHsu2BJ;;AGpu2BE;EACE,gBAAA;AHuu2BJ;;AGru2BE;EACE,gBAAA;AHwu2BJ;;AGtu2BE;EACE,gBAAA;AHyu2BJ;;AGvu2BE;EACE,gBAAA;AH0u2BJ;;AGxu2BE;EACE,gBAAA;AH2u2BJ;;AGzu2BE;EACE,gBAAA;AH4u2BJ;;AG1u2BE;EACE,gBAAA;AH6u2BJ;;AG3u2BE;EACE,gBAAA;AH8u2BJ;;AG5u2BE;EACE,gBAAA;AH+u2BJ;;AG7u2BE;EACE,gBAAA;AHgv2BJ;;AG9u2BE;EACE,gBAAA;AHiv2BJ;;AG/u2BE;EACE,gBAAA;AHkv2BJ;;AGhv2BE;EACE,gBAAA;AHmv2BJ;;AGjv2BE;EACE,gBAAA;AHov2BJ;;AGlv2BE;EACE,gBAAA;AHqv2BJ;;AGnv2BE;EACE,gBAAA;AHsv2BJ;;AGpv2BE;EACE,gBAAA;AHuv2BJ;;AGrv2BE;EACE,gBAAA;AHwv2BJ;;AGtv2BE;EACE,gBAAA;AHyv2BJ;;AGvv2BE;EACE,gBAAA;AH0v2BJ;;AGxv2BE;EACE,gBAAA;AH2v2BJ;;AGzv2BE;EACE,gBAAA;AH4v2BJ;;AG1v2BE;EACE,gBAAA;AH6v2BJ;;AG3v2BE;EACE,gBAAA;AH8v2BJ;;AG5v2BE;EACE,gBAAA;AH+v2BJ;;AG7v2BE;EACE,gBAAA;AHgw2BJ;;AG9v2BE;EACE,gBAAA;AHiw2BJ;;AG/v2BE;EACE,gBAAA;AHkw2BJ;;AGhw2BE;EACE,gBAAA;AHmw2BJ;;AGjw2BE;EACE,gBAAA;AHow2BJ;;AGlw2BE;EACE,gBAAA;AHqw2BJ;;AGnw2BE;EACE,gBAAA;AHsw2BJ;;AGpw2BE;EACE,gBAAA;AHuw2BJ;;AGrw2BE;EACE,gBAAA;AHww2BJ;;AGtw2BE;EACE,gBAAA;AHyw2BJ;;AGvw2BE;EACE,gBAAA;AH0w2BJ;;AGxw2BE;EACE,gBAAA;AH2w2BJ;;AGzw2BE;EACE,gBAAA;AH4w2BJ;;AG1w2BE;EACE,gBAAA;AH6w2BJ;;AG3w2BE;EACE,gBAAA;AH8w2BJ;;AG5w2BE;EACE,gBAAA;AH+w2BJ;;AG7w2BE;EACE,gBAAA;AHgx2BJ;;AG9w2BE;EACE,gBAAA;AHix2BJ;;AG/w2BE;EACE,gBAAA;AHkx2BJ;;AGhx2BE;EACE,gBAAA;AHmx2BJ;;AGjx2BE;EACE,gBAAA;AHox2BJ;;AGlx2BE;EACE,gBAAA;AHqx2BJ;;AGnx2BE;EACE,gBAAA;AHsx2BJ;;AGpx2BE;EACE,gBAAA;AHux2BJ;;AGrx2BE;EACE,gBAAA;AHwx2BJ;;AGtx2BE;EACE,gBAAA;AHyx2BJ;;AGvx2BE;EACE,gBAAA;AH0x2BJ;;AGxx2BE;EACE,gBAAA;AH2x2BJ;;AGzx2BE;EACE,gBAAA;AH4x2BJ;;AG1x2BE;EACE,gBAAA;AH6x2BJ;;AG3x2BE;EACE,gBAAA;AH8x2BJ;;AG5x2BE;EACE,gBAAA;AH+x2BJ;;AG7x2BE;EACE,gBAAA;AHgy2BJ;;AG9x2BE;EACE,gBAAA;AHiy2BJ;;AG/x2BE;EACE,gBAAA;AHky2BJ;;AGhy2BE;EACE,gBAAA;AHmy2BJ;;AGjy2BE;EACE,gBAAA;AHoy2BJ;;AGly2BE;EACE,gBAAA;AHqy2BJ;;AGny2BE;EACE,gBAAA;AHsy2BJ;;AGpy2BE;EACE,gBAAA;AHuy2BJ;;AGry2BE;EACE,gBAAA;AHwy2BJ;;AGty2BE;EACE,gBAAA;AHyy2BJ;;AGvy2BE;EACE,gBAAA;AH0y2BJ;;AGxy2BE;EACE,gBAAA;AH2y2BJ;;AGzy2BE;EACE,gBAAA;AH4y2BJ;;AG1y2BE;EACE,gBAAA;AH6y2BJ;;AG3y2BE;EACE,gBAAA;AH8y2BJ;;AG5y2BE;EACE,gBAAA;AH+y2BJ;;AG7y2BE;EACE,gBAAA;AHgz2BJ;;AG9y2BE;EACE,gBAAA;AHiz2BJ;;AG/y2BE;EACE,gBAAA;AHkz2BJ;;AGhz2BE;EACE,gBAAA;AHmz2BJ;;AGjz2BE;EACE,gBAAA;AHoz2BJ;;AGlz2BE;EACE,gBAAA;AHqz2BJ;;AGnz2BE;EACE,gBAAA;AHsz2BJ;;AGpz2BE;EACE,gBAAA;AHuz2BJ;;AGrz2BE;EACE,gBAAA;AHwz2BJ;;AGtz2BE;EACE,gBAAA;AHyz2BJ;;AGvz2BE;EACE,gBAAA;AH0z2BJ;;AGxz2BE;EACE,gBAAA;AH2z2BJ;;AGzz2BE;EACE,gBAAA;AH4z2BJ;;AG1z2BE;EACE,gBAAA;AH6z2BJ;;AG3z2BE;EACE,gBAAA;AH8z2BJ;;AG5z2BE;EACE,gBAAA;AH+z2BJ;;AG7z2BE;EACE,gBAAA;AHg02BJ;;AG9z2BE;EACE,gBAAA;AHi02BJ;;AG/z2BE;EACE,gBAAA;AHk02BJ;;AGh02BE;EACE,gBAAA;AHm02BJ;;AGj02BE;EACE,gBAAA;AHo02BJ;;AGl02BE;EACE,gBAAA;AHq02BJ;;AGn02BE;EACE,gBAAA;AHs02BJ;;AGp02BE;EACE,gBAAA;AHu02BJ;;AGr02BE;EACE,gBAAA;AHw02BJ;;AGt02BE;EACE,gBAAA;AHy02BJ;;AGv02BE;EACE,gBAAA;AH002BJ;;AGx02BE;EACE,gBAAA;AH202BJ;;AGz02BE;EACE,gBAAA;AH402BJ;;AG102BE;EACE,gBAAA;AH602BJ;;AG302BE;EACE,gBAAA;AH802BJ;;AG502BE;EACE,gBAAA;AH+02BJ;;AG702BE;EACE,gBAAA;AHg12BJ;;AG902BE;EACE,gBAAA;AHi12BJ;;AG/02BE;EACE,gBAAA;AHk12BJ;;AGh12BE;EACE,gBAAA;AHm12BJ;;AGj12BE;EACE,gBAAA;AHo12BJ;;AGl12BE;EACE,gBAAA;AHq12BJ;;AGn12BE;EACE,gBAAA;AHs12BJ;;AGp12BE;EACE,gBAAA;AHu12BJ;;AGr12BE;EACE,gBAAA;AHw12BJ;;AGt12BE;EACE,gBAAA;AHy12BJ;;AGv12BE;EACE,gBAAA;AH012BJ;;AGx12BE;EACE,gBAAA;AH212BJ;;AGz12BE;EACE,gBAAA;AH412BJ;;AG112BE;EACE,gBAAA;AH612BJ;;AG312BE;EACE,gBAAA;AH812BJ;;AG512BE;EACE,gBAAA;AH+12BJ;;AG712BE;EACE,gBAAA;AHg22BJ;;AG912BE;EACE,gBAAA;AHi22BJ;;AG/12BE;EACE,gBAAA;AHk22BJ;;AGh22BE;EACE,gBAAA;AHm22BJ;;AGj22BE;EACE,gBAAA;AHo22BJ;;AGl22BE;EACE,gBAAA;AHq22BJ;;AGn22BE;EACE,gBAAA;AHs22BJ;;AGp22BE;EACE,gBAAA;AHu22BJ;;AGr22BE;EACE,gBAAA;AHw22BJ;;AGt22BE;EACE,gBAAA;AHy22BJ;;AGv22BE;EACE,gBAAA;AH022BJ;;AGx22BE;EACE,gBAAA;AH222BJ;;AGz22BE;EACE,gBAAA;AH422BJ;;AG122BE;EACE,gBAAA;AH622BJ;;AG322BE;EACE,gBAAA;AH822BJ;;AG522BE;EACE,gBAAA;AH+22BJ;;AG722BE;EACE,gBAAA;AHg32BJ;;AG922BE;EACE,gBAAA;AHi32BJ;;AG/22BE;EACE,gBAAA;AHk32BJ;;AGh32BE;EACE,gBAAA;AHm32BJ;;AGj32BE;EACE,gBAAA;AHo32BJ;;AGl32BE;EACE,gBAAA;AHq32BJ;;AGn32BE;EACE,gBAAA;AHs32BJ;;AGp32BE;EACE,gBAAA;AHu32BJ;;AGr32BE;EACE,gBAAA;AHw32BJ;;AGt32BE;EACE,gBAAA;AHy32BJ;;AGv32BE;EACE,gBAAA;AH032BJ;;AGx32BE;EACE,gBAAA;AH232BJ;;AGz32BE;EACE,gBAAA;AH432BJ;;AG132BE;EACE,gBAAA;AH632BJ;;AG332BE;EACE,gBAAA;AH832BJ;;AG532BE;EACE,gBAAA;AH+32BJ;;AG732BE;EACE,gBAAA;AHg42BJ;;AG932BE;EACE,gBAAA;AHi42BJ;;AG/32BE;EACE,gBAAA;AHk42BJ;;AGh42BE;EACE,gBAAA;AHm42BJ;;AGj42BE;EACE,gBAAA;AHo42BJ;;AGl42BE;EACE,gBAAA;AHq42BJ;;AGn42BE;EACE,gBAAA;AHs42BJ;;AGp42BE;EACE,gBAAA;AHu42BJ;;AGr42BE;EACE,gBAAA;AHw42BJ;;AGt42BE;EACE,gBAAA;AHy42BJ;;AGv42BE;EACE,gBAAA;AH042BJ;;AGx42BE;EACE,gBAAA;AH242BJ;;AGz42BE;EACE,gBAAA;AH442BJ;;AG142BE;EACE,gBAAA;AH642BJ;;AG342BE;EACE,gBAAA;AH842BJ;;AG542BE;EACE,gBAAA;AH+42BJ;;AG742BE;EACE,gBAAA;AHg52BJ;;AG942BE;EACE,gBAAA;AHi52BJ;;AG/42BE;EACE,gBAAA;AHk52BJ;;AGh52BE;EACE,gBAAA;AHm52BJ;;AGj52BE;EACE,gBAAA;AHo52BJ;;AGl52BE;EACE,gBAAA;AHq52BJ;;AGn52BE;EACE,gBAAA;AHs52BJ;;AGp52BE;EACE,gBAAA;AHu52BJ;;AGr52BE;EACE,gBAAA;AHw52BJ;;AGt52BE;EACE,gBAAA;AHy52BJ;;AGv52BE;EACE,gBAAA;AH052BJ;;AGx52BE;EACE,gBAAA;AH252BJ;;AGz52BE;EACE,gBAAA;AH452BJ;;AG152BE;EACE,gBAAA;AH652BJ;;AG352BE;EACE,gBAAA;AH852BJ;;AG552BE;EACE,gBAAA;AH+52BJ;;AG752BE;EACE,gBAAA;AHg62BJ;;AG952BE;EACE,gBAAA;AHi62BJ;;AG/52BE;EACE,gBAAA;AHk62BJ;;AGh62BE;EACE,gBAAA;AHm62BJ;;AGj62BE;EACE,gBAAA;AHo62BJ;;AGl62BE;EACE,gBAAA;AHq62BJ;;AGn62BE;EACE,gBAAA;AHs62BJ;;AGp62BE;EACE,gBAAA;AHu62BJ;;AGr62BE;EACE,gBAAA;AHw62BJ;;AGt62BE;EACE,gBAAA;AHy62BJ;;AGv62BE;EACE,gBAAA;AH062BJ;;AGx62BE;EACE,gBAAA;AH262BJ;;AGz62BE;EACE,gBAAA;AH462BJ;;AG162BE;EACE,gBAAA;AH662BJ;;AG362BE;EACE,gBAAA;AH862BJ;;AG562BE;EACE,gBAAA;AH+62BJ;;AG762BE;EACE,gBAAA;AHg72BJ;;AG962BE;EACE,gBAAA;AHi72BJ;;AG/62BE;EACE,gBAAA;AHk72BJ;;AGh72BE;EACE,gBAAA;AHm72BJ;;AGj72BE;EACE,gBAAA;AHo72BJ;;AGl72BE;EACE,gBAAA;AHq72BJ;;AGn72BE;EACE,gBAAA;AHs72BJ;;AGp72BE;EACE,gBAAA;AHu72BJ;;AGr72BE;EACE,gBAAA;AHw72BJ;;AGt72BE;EACE,gBAAA;AHy72BJ;;AGv72BE;EACE,gBAAA;AH072BJ;;AGx72BE;EACE,gBAAA;AH272BJ;;AGz72BE;EACE,gBAAA;AH472BJ;;AG172BE;EACE,gBAAA;AH672BJ;;AG372BE;EACE,gBAAA;AH872BJ;;AG572BE;EACE,gBAAA;AH+72BJ;;AG772BE;EACE,gBAAA;AHg82BJ;;AG972BE;EACE,gBAAA;AHi82BJ;;AG/72BE;EACE,gBAAA;AHk82BJ;;AGh82BE;EACE,gBAAA;AHm82BJ;;AGj82BE;EACE,gBAAA;AHo82BJ;;AGl82BE;EACE,gBAAA;AHq82BJ;;AGn82BE;EACE,gBAAA;AHs82BJ;;AGp82BE;EACE,gBAAA;AHu82BJ;;AGr82BE;EACE,gBAAA;AHw82BJ;;AGt82BE;EACE,gBAAA;AHy82BJ;;AGv82BE;EACE,gBAAA;AH082BJ;;AGx82BE;EACE,gBAAA;AH282BJ;;AGz82BE;EACE,gBAAA;AH482BJ;;AG182BE;EACE,gBAAA;AH682BJ;;AG382BE;EACE,gBAAA;AH882BJ;;AG582BE;EACE,gBAAA;AH+82BJ;;AG782BE;EACE,gBAAA;AHg92BJ;;AG982BE;EACE,gBAAA;AHi92BJ;;AG/82BE;EACE,gBAAA;AHk92BJ;;AGh92BE;EACE,gBAAA;AHm92BJ;;AI5lhCA;;;;;;EAME,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AJ+lhCF;;AI7lhCA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AJgmhCF;;AI9lhCA;EACE,iBAAA;AJimhCF;;AI/lhCA;EACE,kBAAA;AJkmhCF;;AIhmhCA;EACE,cAAA;AJmmhCF;;AIjmhCA;EACE,cAAA;AJomhCF;;AIlmhCA;EACE,cAAA;AJqmhCF;;AInmhCA;EACE,cAAA;AJsmhCF;;AIpmhCA;EACE,cAAA;AJumhCF;;AIrmhCA;EACE,cAAA;AJwmhCF;;AItmhCA;EACE,cAAA;AJymhCF;;AIvmhCA;EACE,cAAA;AJ0mhCF;;AIxmhCA;EACE,cAAA;AJ2mhCF;;AIzmhCA;EACE,eAAA;AJ4mhCF;;AI1mhCA;EACE,kBAAA;EACA,aAAA;AJ6mhCF;;AI3mhCA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AJ8mhCF;;AI7mhCE;EACE,kBAAA;AJgnhCJ;;AI9mhCA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AJinhCF;;AI/mhCA;EACE,yBAAA;EACA,oBAAA;EACA,4BAAA;AJknhCF;;AIhnhCA;EACE,WAAA;AJmnhCF;;AIjnhCA;EACE,YAAA;AJonhCF;;AIlnhCA;;;;;EAKE,mBAAA;AJqnhCF;;AInnhCA;;;;;EAKE,kBAAA;AJsnhCF;;AIpnhCA;EAEU,qCAAA;AJunhCV;;AIrnhCA;EAEU,uCAAA;AJwnhCV;AI9mhCA;EACE;IAEU,uBAAA;EJ2nhCV;EI1nhCA;IAEU,yBAAA;EJ4nhCV;AACF;AI3nhCA;EACE,sEAAA;EAEQ,wBAAA;AJ6nhCV;;AI3nhCA;EACE,sEAAA;EAEQ,yBAAA;AJ8nhCV;;AI5nhCA;EACE,sEAAA;EAEQ,yBAAA;AJ+nhCV;;AI7nhCA;EACE,gFAAA;EAEQ,uBAAA;AJgohCV;;AI9nhCA;EACE,gFAAA;EAEQ,uBAAA;AJiohCV;;AI/nhCA;EACE,gFAAA;EAEQ,wBAAA;AJkohCV;;AIhohCA;;;;;;EAOU,YAAA;AJmohCV;;AIjohCA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AJoohCF;;AIlohCA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AJqohCF;;AInohCA;EACE,oBAAA;AJsohCF;;AIpohCA;EACE,cAAA;AJuohCF;;AIrohCA;EACE,WAAA;AJwohCF;;AItohCA;gEAAA;AAEA;EACE,gBAAA;AJyohCF;;AIvohCA;EACE,gBAAA;AJ0ohCF;;AIxohCA;EACE,gBAAA;AJ2ohCF;;AIzohCA;EACE,gBAAA;AJ4ohCF;;AI1ohCA;EACE,gBAAA;AJ6ohCF;;AI3ohCA;EACE,gBAAA;AJ8ohCF;;AI5ohCA;EACE,gBAAA;AJ+ohCF;;AI7ohCA;EACE,gBAAA;AJgphCF;;AI9ohCA;EACE,gBAAA;AJiphCF;;AI/ohCA;EACE,gBAAA;AJkphCF;;AIhphCA;EACE,gBAAA;AJmphCF;;AIjphCA;EACE,gBAAA;AJophCF;;AIlphCA;EACE,gBAAA;AJqphCF;;AInphCA;EACE,gBAAA;AJsphCF;;AIpphCA;EACE,gBAAA;AJuphCF;;AIrphCA;EACE,gBAAA;AJwphCF;;AItphCA;EACE,gBAAA;AJyphCF;;AIvphCA;EACE,gBAAA;AJ0phCF;;AIxphCA;EACE,gBAAA;AJ2phCF;;AIzphCA;EACE,gBAAA;AJ4phCF;;AI1phCA;EACE,gBAAA;AJ6phCF;;AI3phCA;EACE,gBAAA;AJ8phCF;;AI5phCA;EACE,gBAAA;AJ+phCF;;AI7phCA;EACE,gBAAA;AJgqhCF;;AI9phCA;EACE,gBAAA;AJiqhCF;;AI/phCA;EACE,gBAAA;AJkqhCF;;AIhqhCA;EACE,gBAAA;AJmqhCF;;AIjqhCA;EACE,gBAAA;AJoqhCF;;AIlqhCA;EACE,gBAAA;AJqqhCF;;AInqhCA;EACE,gBAAA;AJsqhCF;;AIpqhCA;EACE,gBAAA;AJuqhCF;;AIrqhCA;EACE,gBAAA;AJwqhCF;;AItqhCA;EACE,gBAAA;AJyqhCF;;AIvqhCA;EACE,gBAAA;AJ0qhCF;;AIxqhCA;EACE,gBAAA;AJ2qhCF;;AIzqhCA;EACE,gBAAA;AJ4qhCF;;AI1qhCA;EACE,gBAAA;AJ6qhCF;;AI3qhCA;EACE,gBAAA;AJ8qhCF;;AI5qhCA;EACE,gBAAA;AJ+qhCF;;AI7qhCA;EACE,gBAAA;AJgrhCF;;AI9qhCA;EACE,gBAAA;AJirhCF;;AI/qhCA;EACE,gBAAA;AJkrhCF;;AIhrhCA;EACE,gBAAA;AJmrhCF;;AIjrhCA;EACE,gBAAA;AJorhCF;;AIlrhCA;EACE,gBAAA;AJqrhCF;;AInrhCA;EACE,gBAAA;AJsrhCF;;AIprhCA;EACE,gBAAA;AJurhCF;;AIrrhCA;EACE,gBAAA;AJwrhCF;;AItrhCA;EACE,gBAAA;AJyrhCF;;AIvrhCA;EACE,gBAAA;AJ0rhCF;;AIxrhCA;EACE,gBAAA;AJ2rhCF;;AIzrhCA;EACE,gBAAA;AJ4rhCF;;AI1rhCA;EACE,gBAAA;AJ6rhCF;;AI3rhCA;EACE,gBAAA;AJ8rhCF;;AI5rhCA;EACE,gBAAA;AJ+rhCF;;AI7rhCA;EACE,gBAAA;AJgshCF;;AI9rhCA;EACE,gBAAA;AJishCF;;AI/rhCA;EACE,gBAAA;AJkshCF;;AIhshCA;EACE,gBAAA;AJmshCF;;AIjshCA;EACE,gBAAA;AJoshCF;;AIlshCA;EACE,gBAAA;AJqshCF;;AInshCA;EACE,gBAAA;AJsshCF;;AIpshCA;EACE,gBAAA;AJushCF;;AIrshCA;EACE,gBAAA;AJwshCF;;AItshCA;EACE,gBAAA;AJyshCF;;AIvshCA;EACE,gBAAA;AJ0shCF;;AIxshCA;EACE,gBAAA;AJ2shCF;;AIzshCA;EACE,gBAAA;AJ4shCF;;AI1shCA;EACE,gBAAA;AJ6shCF;;AI3shCA;EACE,gBAAA;AJ8shCF;;AI5shCA;EACE,gBAAA;AJ+shCF;;AI7shCA;EACE,gBAAA;AJgthCF;;AI9shCA;EACE,gBAAA;AJithCF;;AI/shCA;EACE,gBAAA;AJkthCF;;AIhthCA;EACE,gBAAA;AJmthCF;;AIjthCA;EACE,gBAAA;AJothCF;;AIlthCA;EACE,gBAAA;AJqthCF;;AInthCA;EACE,gBAAA;AJsthCF;;AIpthCA;EACE,gBAAA;AJuthCF;;AIrthCA;EACE,gBAAA;AJwthCF;;AItthCA;EACE,gBAAA;AJythCF;;AIvthCA;EACE,gBAAA;AJ0thCF;;AIxthCA;EACE,gBAAA;AJ2thCF;;AIzthCA;EACE,gBAAA;AJ4thCF;;AI1thCA;EACE,gBAAA;AJ6thCF;;AI3thCA;EACE,gBAAA;AJ8thCF;;AI5thCA;EACE,gBAAA;AJ+thCF;;AI7thCA;EACE,gBAAA;AJguhCF;;AI9thCA;EACE,gBAAA;AJiuhCF;;AI/thCA;EACE,gBAAA;AJkuhCF;;AIhuhCA;EACE,gBAAA;AJmuhCF;;AIjuhCA;EACE,gBAAA;AJouhCF;;AIluhCA;EACE,gBAAA;AJquhCF;;AInuhCA;EACE,gBAAA;AJsuhCF;;AIpuhCA;EACE,gBAAA;AJuuhCF;;AIruhCA;EACE,gBAAA;AJwuhCF;;AItuhCA;EACE,gBAAA;AJyuhCF;;AIvuhCA;EACE,gBAAA;AJ0uhCF;;AIxuhCA;EACE,gBAAA;AJ2uhCF;;AIzuhCA;EACE,gBAAA;AJ4uhCF;;AI1uhCA;EACE,gBAAA;AJ6uhCF;;AI3uhCA;EACE,gBAAA;AJ8uhCF;;AI5uhCA;EACE,gBAAA;AJ+uhCF;;AI7uhCA;EACE,gBAAA;AJgvhCF;;AI9uhCA;EACE,gBAAA;AJivhCF;;AI/uhCA;EACE,gBAAA;AJkvhCF;;AIhvhCA;EACE,gBAAA;AJmvhCF;;AIjvhCA;EACE,gBAAA;AJovhCF;;AIlvhCA;EACE,gBAAA;AJqvhCF;;AInvhCA;EACE,gBAAA;AJsvhCF;;AIpvhCA;EACE,gBAAA;AJuvhCF;;AIrvhCA;EACE,gBAAA;AJwvhCF;;AItvhCA;EACE,gBAAA;AJyvhCF;;AIvvhCA;EACE,gBAAA;AJ0vhCF;;AIxvhCA;EACE,gBAAA;AJ2vhCF;;AIzvhCA;EACE,gBAAA;AJ4vhCF;;AI1vhCA;EACE,gBAAA;AJ6vhCF;;AI3vhCA;EACE,gBAAA;AJ8vhCF;;AI5vhCA;EACE,gBAAA;AJ+vhCF;;AI7vhCA;EACE,gBAAA;AJgwhCF;;AI9vhCA;EACE,gBAAA;AJiwhCF;;AI/vhCA;EACE,gBAAA;AJkwhCF;;AIhwhCA;EACE,gBAAA;AJmwhCF;;AIjwhCA;EACE,gBAAA;AJowhCF;;AIlwhCA;EACE,gBAAA;AJqwhCF;;AInwhCA;EACE,gBAAA;AJswhCF;;AIpwhCA;EACE,gBAAA;AJuwhCF;;AIrwhCA;EACE,gBAAA;AJwwhCF;;AItwhCA;EACE,gBAAA;AJywhCF;;AIvwhCA;EACE,gBAAA;AJ0whCF;;AIxwhCA;EACE,gBAAA;AJ2whCF;;AIzwhCA;EACE,gBAAA;AJ4whCF;;AI1whCA;EACE,gBAAA;AJ6whCF;;AI3whCA;EACE,gBAAA;AJ8whCF;;AI5whCA;EACE,gBAAA;AJ+whCF;;AI7whCA;EACE,gBAAA;AJgxhCF;;AI9whCA;EACE,gBAAA;AJixhCF;;AI/whCA;EACE,gBAAA;AJkxhCF;;AIhxhCA;EACE,gBAAA;AJmxhCF;;AIjxhCA;EACE,gBAAA;AJoxhCF;;AIlxhCA;EACE,gBAAA;AJqxhCF;;AInxhCA;EACE,gBAAA;AJsxhCF;;AIpxhCA;EACE,gBAAA;AJuxhCF;;AIrxhCA;EACE,gBAAA;AJwxhCF;;AItxhCA;EACE,gBAAA;AJyxhCF;;AIvxhCA;EACE,gBAAA;AJ0xhCF;;AIxxhCA;EACE,gBAAA;AJ2xhCF;;AIzxhCA;EACE,gBAAA;AJ4xhCF;;AI1xhCA;EACE,gBAAA;AJ6xhCF;;AI3xhCA;EACE,gBAAA;AJ8xhCF;;AI5xhCA;EACE,gBAAA;AJ+xhCF;;AI7xhCA;EACE,gBAAA;AJgyhCF;;AI9xhCA;EACE,gBAAA;AJiyhCF;;AI/xhCA;EACE,gBAAA;AJkyhCF;;AIhyhCA;EACE,gBAAA;AJmyhCF;;AIjyhCA;EACE,gBAAA;AJoyhCF;;AIlyhCA;EACE,gBAAA;AJqyhCF;;AInyhCA;EACE,gBAAA;AJsyhCF;;AIpyhCA;EACE,gBAAA;AJuyhCF;;AIryhCA;EACE,gBAAA;AJwyhCF;;AItyhCA;EACE,gBAAA;AJyyhCF;;AIvyhCA;EACE,gBAAA;AJ0yhCF;;AIxyhCA;EACE,gBAAA;AJ2yhCF;;AIzyhCA;EACE,gBAAA;AJ4yhCF;;AI1yhCA;EACE,gBAAA;AJ6yhCF;;AI3yhCA;EACE,gBAAA;AJ8yhCF;;AI5yhCA;EACE,gBAAA;AJ+yhCF;;AI7yhCA;EACE,gBAAA;AJgzhCF;;AI9yhCA;EACE,gBAAA;AJizhCF;;AI/yhCA;EACE,gBAAA;AJkzhCF;;AIhzhCA;EACE,gBAAA;AJmzhCF;;AIjzhCA;EACE,gBAAA;AJozhCF;;AIlzhCA;EACE,gBAAA;AJqzhCF;;AInzhCA;EACE,gBAAA;AJszhCF;;AIpzhCA;EACE,gBAAA;AJuzhCF;;AIrzhCA;EACE,gBAAA;AJwzhCF;;AItzhCA;EACE,gBAAA;AJyzhCF;;AIvzhCA;EACE,gBAAA;AJ0zhCF;;AIxzhCA;EACE,gBAAA;AJ2zhCF;;AIzzhCA;EACE,gBAAA;AJ4zhCF;;AI1zhCA;EACE,gBAAA;AJ6zhCF;;AI3zhCA;EACE,gBAAA;AJ8zhCF;;AI5zhCA;EACE,gBAAA;AJ+zhCF;;AI7zhCA;EACE,gBAAA;AJg0hCF;;AI9zhCA;EACE,gBAAA;AJi0hCF;;AI/zhCA;EACE,gBAAA;AJk0hCF;;AIh0hCA;EACE,gBAAA;AJm0hCF;;AIj0hCA;EACE,gBAAA;AJo0hCF;;AIl0hCA;EACE,gBAAA;AJq0hCF;;AIn0hCA;EACE,gBAAA;AJs0hCF;;AIp0hCA;EACE,gBAAA;AJu0hCF;;AIr0hCA;EACE,gBAAA;AJw0hCF;;AIt0hCA;EACE,gBAAA;AJy0hCF;;AIv0hCA;EACE,gBAAA;AJ00hCF;;AIx0hCA;EACE,gBAAA;AJ20hCF;;AIz0hCA;EACE,gBAAA;AJ40hCF;;AI10hCA;EACE,gBAAA;AJ60hCF;;AI30hCA;EACE,gBAAA;AJ80hCF;;AI50hCA;EACE,gBAAA;AJ+0hCF;;AI70hCA;EACE,gBAAA;AJg1hCF;;AI90hCA;EACE,gBAAA;AJi1hCF;;AI/0hCA;EACE,gBAAA;AJk1hCF;;AIh1hCA;EACE,gBAAA;AJm1hCF;;AIj1hCA;EACE,gBAAA;AJo1hCF;;AIl1hCA;EACE,gBAAA;AJq1hCF;;AIn1hCA;EACE,gBAAA;AJs1hCF;;AIp1hCA;EACE,gBAAA;AJu1hCF;;AIr1hCA;EACE,gBAAA;AJw1hCF;;AIt1hCA;EACE,gBAAA;AJy1hCF;;AIv1hCA;EACE,gBAAA;AJ01hCF;;AIx1hCA;EACE,gBAAA;AJ21hCF;;AIz1hCA;EACE,gBAAA;AJ41hCF;;AI11hCA;EACE,gBAAA;AJ61hCF;;AI31hCA;EACE,gBAAA;AJ81hCF;;AI51hCA;EACE,gBAAA;AJ+1hCF;;AI71hCA;EACE,gBAAA;AJg2hCF;;AI91hCA;EACE,gBAAA;AJi2hCF;;AI/1hCA;EACE,gBAAA;AJk2hCF;;AIh2hCA;EACE,gBAAA;AJm2hCF;;AIj2hCA;EACE,gBAAA;AJo2hCF;;AIl2hCA;EACE,gBAAA;AJq2hCF;;AIn2hCA;EACE,gBAAA;AJs2hCF;;AIp2hCA;EACE,gBAAA;AJu2hCF;;AIr2hCA;EACE,gBAAA;AJw2hCF;;AIt2hCA;EACE,gBAAA;AJy2hCF;;AIv2hCA;EACE,gBAAA;AJ02hCF;;AIx2hCA;EACE,gBAAA;AJ22hCF;;AIz2hCA;EACE,gBAAA;AJ42hCF;;AI12hCA;EACE,gBAAA;AJ62hCF;;AI32hCA;EACE,gBAAA;AJ82hCF;;AI52hCA;EACE,gBAAA;AJ+2hCF;;AI72hCA;EACE,gBAAA;AJg3hCF;;AI92hCA;EACE,gBAAA;AJi3hCF;;AI/2hCA;EACE,gBAAA;AJk3hCF;;AIh3hCA;EACE,gBAAA;AJm3hCF;;AIj3hCA;EACE,gBAAA;AJo3hCF;;AIl3hCA;EACE,gBAAA;AJq3hCF;;AIn3hCA;EACE,gBAAA;AJs3hCF;;AIp3hCA;EACE,gBAAA;AJu3hCF;;AIr3hCA;EACE,gBAAA;AJw3hCF;;AIt3hCA;EACE,gBAAA;AJy3hCF;;AIv3hCA;EACE,gBAAA;AJ03hCF;;AIx3hCA;EACE,gBAAA;AJ23hCF;;AIz3hCA;EACE,gBAAA;AJ43hCF;;AI13hCA;EACE,gBAAA;AJ63hCF;;AI33hCA;EACE,gBAAA;AJ83hCF;;AI53hCA;EACE,gBAAA;AJ+3hCF;;AI73hCA;EACE,gBAAA;AJg4hCF;;AI93hCA;EACE,gBAAA;AJi4hCF;;AI/3hCA;EACE,gBAAA;AJk4hCF;;AIh4hCA;EACE,gBAAA;AJm4hCF;;AIj4hCA;EACE,gBAAA;AJo4hCF;;AIl4hCA;EACE,gBAAA;AJq4hCF;;AIn4hCA;EACE,gBAAA;AJs4hCF;;AIp4hCA;EACE,gBAAA;AJu4hCF;;AIr4hCA;EACE,gBAAA;AJw4hCF;;AIt4hCA;EACE,gBAAA;AJy4hCF;;AIv4hCA;EACE,gBAAA;AJ04hCF;;AIx4hCA;EACE,gBAAA;AJ24hCF;;AIz4hCA;EACE,gBAAA;AJ44hCF;;AI14hCA;EACE,gBAAA;AJ64hCF;;AI34hCA;EACE,gBAAA;AJ84hCF;;AI54hCA;EACE,gBAAA;AJ+4hCF;;AI74hCA;EACE,gBAAA;AJg5hCF;;AI94hCA;EACE,gBAAA;AJi5hCF;;AI/4hCA;EACE,gBAAA;AJk5hCF;;AIh5hCA;EACE,gBAAA;AJm5hCF;;AIj5hCA;EACE,gBAAA;AJo5hCF;;AIl5hCA;EACE,gBAAA;AJq5hCF;;AIn5hCA;EACE,gBAAA;AJs5hCF;;AIp5hCA;EACE,gBAAA;AJu5hCF;;AIr5hCA;EACE,gBAAA;AJw5hCF;;AIt5hCA;EACE,gBAAA;AJy5hCF;;AIv5hCA;EACE,gBAAA;AJ05hCF;;AIx5hCA;EACE,gBAAA;AJ25hCF;;AIz5hCA;EACE,gBAAA;AJ45hCF;;AI15hCA;EACE,gBAAA;AJ65hCF;;AI35hCA;EACE,gBAAA;AJ85hCF;;AI55hCA;EACE,gBAAA;AJ+5hCF;;AI75hCA;EACE,gBAAA;AJg6hCF;;AI95hCA;EACE,gBAAA;AJi6hCF;;AI/5hCA;EACE,gBAAA;AJk6hCF;;AIh6hCA;EACE,gBAAA;AJm6hCF;;AIj6hCA;EACE,gBAAA;AJo6hCF;;AIl6hCA;EACE,gBAAA;AJq6hCF;;AIn6hCA;EACE,gBAAA;AJs6hCF;;AIp6hCA;EACE,gBAAA;AJu6hCF;;AIr6hCA;EACE,gBAAA;AJw6hCF;;AIt6hCA;EACE,gBAAA;AJy6hCF;;AIv6hCA;EACE,gBAAA;AJ06hCF;;AIx6hCA;EACE,gBAAA;AJ26hCF;;AIz6hCA;EACE,gBAAA;AJ46hCF;;AI16hCA;EACE,gBAAA;AJ66hCF;;AI36hCA;EACE,gBAAA;AJ86hCF;;AI56hCA;EACE,gBAAA;AJ+6hCF;;AI76hCA;EACE,gBAAA;AJg7hCF;;AI96hCA;EACE,gBAAA;AJi7hCF;;AI/6hCA;EACE,gBAAA;AJk7hCF;;AIh7hCA;EACE,gBAAA;AJm7hCF;;AIj7hCA;EACE,gBAAA;AJo7hCF;;AIl7hCA;EACE,gBAAA;AJq7hCF;;AIn7hCA;EACE,gBAAA;AJs7hCF;;AIp7hCA;EACE,gBAAA;AJu7hCF;;AIr7hCA;EACE,gBAAA;AJw7hCF;;AIt7hCA;EACE,gBAAA;AJy7hCF;;AIv7hCA;EACE,gBAAA;AJ07hCF;;AIx7hCA;EACE,gBAAA;AJ27hCF;;AIz7hCA;EACE,gBAAA;AJ47hCF;;AI17hCA;EACE,gBAAA;AJ67hCF;;AI37hCA;EACE,gBAAA;AJ87hCF;;AI57hCA;EACE,gBAAA;AJ+7hCF;;AI77hCA;EACE,gBAAA;AJg8hCF;;AI97hCA;EACE,gBAAA;AJi8hCF;;AI/7hCA;EACE,gBAAA;AJk8hCF;;AIh8hCA;EACE,gBAAA;AJm8hCF;;AIj8hCA;EACE,gBAAA;AJo8hCF;;AIl8hCA;EACE,gBAAA;AJq8hCF;;AIn8hCA;EACE,gBAAA;AJs8hCF;;AIp8hCA;EACE,gBAAA;AJu8hCF;;AIr8hCA;EACE,gBAAA;AJw8hCF;;AIt8hCA;EACE,gBAAA;AJy8hCF;;AIv8hCA;EACE,gBAAA;AJ08hCF;;AIx8hCA;EACE,gBAAA;AJ28hCF;;AIz8hCA;EACE,gBAAA;AJ48hCF;;AI18hCA;EACE,gBAAA;AJ68hCF;;AI38hCA;EACE,gBAAA;AJ88hCF;;AI58hCA;EACE,gBAAA;AJ+8hCF;;AI78hCA;EACE,gBAAA;AJg9hCF;;AI98hCA;EACE,gBAAA;AJi9hCF;;AI/8hCA;EACE,gBAAA;AJk9hCF;;AIh9hCA;EACE,gBAAA;AJm9hCF;;AIj9hCA;EACE,gBAAA;AJo9hCF;;AIl9hCA;EACE,gBAAA;AJq9hCF;;AIn9hCA;EACE,gBAAA;AJs9hCF;;AIp9hCA;EACE,gBAAA;AJu9hCF;;AIr9hCA;EACE,gBAAA;AJw9hCF;;AIt9hCA;EACE,gBAAA;AJy9hCF;;AIv9hCA;EACE,gBAAA;AJ09hCF;;AIx9hCA;EACE,gBAAA;AJ29hCF;;AIz9hCA;EACE,gBAAA;AJ49hCF;;AI19hCA;EACE,gBAAA;AJ69hCF;;AI39hCA;EACE,gBAAA;AJ89hCF;;AI59hCA;EACE,gBAAA;AJ+9hCF;;AI79hCA;EACE,gBAAA;AJg+hCF;;AI99hCA;EACE,gBAAA;AJi+hCF;;AI/9hCA;EACE,gBAAA;AJk+hCF;;AIh+hCA;EACE,gBAAA;AJm+hCF;;AIj+hCA;EACE,gBAAA;AJo+hCF;;AIl+hCA;EACE,gBAAA;AJq+hCF;;AIn+hCA;EACE,gBAAA;AJs+hCF;;AIp+hCA;EACE,gBAAA;AJu+hCF;;AIr+hCA;EACE,gBAAA;AJw+hCF;;AIt+hCA;EACE,gBAAA;AJy+hCF;;AIv+hCA;EACE,gBAAA;AJ0+hCF;;AIx+hCA;EACE,gBAAA;AJ2+hCF;;AIz+hCA;EACE,gBAAA;AJ4+hCF;;AI1+hCA;EACE,gBAAA;AJ6+hCF;;AI3+hCA;EACE,gBAAA;AJ8+hCF;;AI5+hCA;EACE,gBAAA;AJ++hCF;;AI7+hCA;EACE,gBAAA;AJg/hCF;;AI9+hCA;EACE,gBAAA;AJi/hCF;;AI/+hCA;EACE,gBAAA;AJk/hCF;;AIh/hCA;EACE,gBAAA;AJm/hCF;;AIj/hCA;EACE,gBAAA;AJo/hCF;;AIl/hCA;EACE,gBAAA;AJq/hCF;;AIn/hCA;EACE,gBAAA;AJs/hCF;;AIp/hCA;EACE,gBAAA;AJu/hCF;;AIr/hCA;EACE,gBAAA;AJw/hCF;;AIt/hCA;EACE,gBAAA;AJy/hCF;;AIv/hCA;EACE,gBAAA;AJ0/hCF;;AIx/hCA;EACE,gBAAA;AJ2/hCF;;AIz/hCA;EACE,gBAAA;AJ4/hCF;;AI1/hCA;EACE,gBAAA;AJ6/hCF;;AI3/hCA;EACE,gBAAA;AJ8/hCF;;AI5/hCA;EACE,gBAAA;AJ+/hCF;;AI7/hCA;EACE,gBAAA;AJggiCF;;AI9/hCA;EACE,gBAAA;AJigiCF;;AI//hCA;EACE,gBAAA;AJkgiCF;;AIhgiCA;EACE,gBAAA;AJmgiCF;;AIjgiCA;EACE,gBAAA;AJogiCF;;AIlgiCA;EACE,gBAAA;AJqgiCF;;AIngiCA;EACE,gBAAA;AJsgiCF;;AIpgiCA;EACE,gBAAA;AJugiCF;;AIrgiCA;EACE,gBAAA;AJwgiCF;;AItgiCA;EACE,gBAAA;AJygiCF;;AIvgiCA;EACE,gBAAA;AJ0giCF;;AIxgiCA;EACE,gBAAA;AJ2giCF;;AIzgiCA;EACE,gBAAA;AJ4giCF;;AI1giCA;EACE,gBAAA;AJ6giCF;;AI3giCA;EACE,gBAAA;AJ8giCF;;AI5giCA;EACE,gBAAA;AJ+giCF;;AI7giCA;EACE,gBAAA;AJghiCF;;AI9giCA;EACE,gBAAA;AJihiCF;;AI/giCA;EACE,gBAAA;AJkhiCF;;AIhhiCA;EACE,gBAAA;AJmhiCF;;AIjhiCA;EACE,gBAAA;AJohiCF;;AIlhiCA;EACE,gBAAA;AJqhiCF;;AInhiCA;EACE,gBAAA;AJshiCF;;AIphiCA;EACE,gBAAA;AJuhiCF;;AIrhiCA;EACE,gBAAA;AJwhiCF;;AIthiCA;EACE,gBAAA;AJyhiCF;;AIvhiCA;EACE,gBAAA;AJ0hiCF;;AIxhiCA;EACE,gBAAA;AJ2hiCF;;AIzhiCA;EACE,gBAAA;AJ4hiCF;;AI1hiCA;EACE,gBAAA;AJ6hiCF;;AI3hiCA;EACE,gBAAA;AJ8hiCF;;AI5hiCA;EACE,gBAAA;AJ+hiCF;;AI7hiCA;EACE,gBAAA;AJgiiCF;;AI9hiCA;EACE,gBAAA;AJiiiCF;;AI/hiCA;EACE,gBAAA;AJkiiCF;;AIhiiCA;EACE,gBAAA;AJmiiCF;;AIjiiCA;EACE,gBAAA;AJoiiCF;;AIliiCA;EACE,gBAAA;AJqiiCF;;AIniiCA;EACE,gBAAA;AJsiiCF;;AIpiiCA;EACE,gBAAA;AJuiiCF;;AIriiCA;EACE,gBAAA;AJwiiCF;;AItiiCA;EACE,gBAAA;AJyiiCF;;AIviiCA;EACE,gBAAA;AJ0iiCF;;AIxiiCA;EACE,gBAAA;AJ2iiCF;;AIziiCA;EACE,gBAAA;AJ4iiCF;;AI1iiCA;EACE,gBAAA;AJ6iiCF;;AI3iiCA;EACE,gBAAA;AJ8iiCF;;AI5iiCA;EACE,gBAAA;AJ+iiCF;;AI7iiCA;EACE,gBAAA;AJgjiCF;;AI9iiCA;EACE,gBAAA;AJijiCF;;AI/iiCA;EACE,gBAAA;AJkjiCF;;AIhjiCA;EACE,gBAAA;AJmjiCF;;AIjjiCA;EACE,gBAAA;AJojiCF;;AIljiCA;EACE,gBAAA;AJqjiCF;;AInjiCA;EACE,gBAAA;AJsjiCF;;AIpjiCA;EACE,gBAAA;AJujiCF;;AIrjiCA;EACE,gBAAA;AJwjiCF;;AItjiCA;EACE,gBAAA;AJyjiCF;;AIvjiCA;EACE,gBAAA;AJ0jiCF;;AIxjiCA;EACE,gBAAA;AJ2jiCF;;AIzjiCA;EACE,gBAAA;AJ4jiCF;;AI1jiCA;EACE,gBAAA;AJ6jiCF;;AI3jiCA;EACE,gBAAA;AJ8jiCF;;AI5jiCA;EACE,gBAAA;AJ+jiCF;;AI7jiCA;EACE,gBAAA;AJgkiCF;;AI9jiCA;EACE,gBAAA;AJikiCF;;AI/jiCA;EACE,gBAAA;AJkkiCF;;AIhkiCA;EACE,gBAAA;AJmkiCF;;AIjkiCA;EACE,gBAAA;AJokiCF;;AIlkiCA;EACE,gBAAA;AJqkiCF;;AInkiCA;EACE,gBAAA;AJskiCF;;AIpkiCA;EACE,gBAAA;AJukiCF;;AIrkiCA;EACE,gBAAA;AJwkiCF;;AItkiCA;EACE,gBAAA;AJykiCF;;AIvkiCA;EACE,gBAAA;AJ0kiCF;;AIxkiCA;EACE,gBAAA;AJ2kiCF;;AIzkiCA;EACE,gBAAA;AJ4kiCF;;AI1kiCA;EACE,gBAAA;AJ6kiCF;;AI3kiCA;EACE,gBAAA;AJ8kiCF;;AI5kiCA;EACE,gBAAA;AJ+kiCF;;AI7kiCA;EACE,gBAAA;AJgliCF;;AI9kiCA;EACE,gBAAA;AJiliCF;;AI/kiCA;EACE,gBAAA;AJkliCF;;AIhliCA;EACE,gBAAA;AJmliCF;;AIjliCA;EACE,gBAAA;AJoliCF;;AIlliCA;EACE,gBAAA;AJqliCF;;AInliCA;EACE,gBAAA;AJsliCF;;AIpliCA;EACE,gBAAA;AJuliCF;;AIrliCA;EACE,gBAAA;AJwliCF;;AItliCA;EACE,gBAAA;AJyliCF;;AIvliCA;EACE,gBAAA;AJ0liCF;;AIxliCA;EACE,gBAAA;AJ2liCF;;AIzliCA;EACE,gBAAA;AJ4liCF;;AI1liCA;EACE,gBAAA;AJ6liCF;;AI3liCA;EACE,gBAAA;AJ8liCF;;AI5liCA;EACE,gBAAA;AJ+liCF;;AI7liCA;EACE,gBAAA;AJgmiCF;;AI9liCA;EACE,gBAAA;AJimiCF;;AI/liCA;EACE,gBAAA;AJkmiCF;;AIhmiCA;EACE,gBAAA;AJmmiCF;;AIjmiCA;EACE,gBAAA;AJomiCF;;AIlmiCA;EACE,gBAAA;AJqmiCF;;AInmiCA;EACE,gBAAA;AJsmiCF;;AIpmiCA;EACE,gBAAA;AJumiCF;;AIrmiCA;EACE,gBAAA;AJwmiCF;;AItmiCA;EACE,gBAAA;AJymiCF;;AIvmiCA;EACE,gBAAA;AJ0miCF;;AIxmiCA;EACE,gBAAA;AJ2miCF;;AIzmiCA;EACE,gBAAA;AJ4miCF;;AI1miCA;EACE,gBAAA;AJ6miCF;;AI3miCA;EACE,gBAAA;AJ8miCF;;AI5miCA;EACE,gBAAA;AJ+miCF;;AI7miCA;EACE,gBAAA;AJgniCF;;AI9miCA;EACE,gBAAA;AJiniCF;;AI/miCA;EACE,gBAAA;AJkniCF;;AIhniCA;EACE,gBAAA;AJmniCF;;AIjniCA;EACE,gBAAA;AJoniCF;;AIlniCA;EACE,gBAAA;AJqniCF;;AInniCA;EACE,gBAAA;AJsniCF;;AIpniCA;EACE,gBAAA;AJuniCF;;AIrniCA;EACE,gBAAA;AJwniCF;;AItniCA;EACE,gBAAA;AJyniCF;;AIvniCA;EACE,gBAAA;AJ0niCF;;AIxniCA;EACE,gBAAA;AJ2niCF;;AIzniCA;EACE,gBAAA;AJ4niCF;;AI1niCA;EACE,gBAAA;AJ6niCF;;AI3niCA;EACE,gBAAA;AJ8niCF;;AI5niCA;EACE,gBAAA;AJ+niCF;;AI7niCA;EACE,gBAAA;AJgoiCF;;AI9niCA;EACE,gBAAA;AJioiCF;;AI/niCA;EACE,gBAAA;AJkoiCF;;AIhoiCA;EACE,gBAAA;AJmoiCF;;AIjoiCA;EACE,gBAAA;AJooiCF;;AIloiCA;EACE,gBAAA;AJqoiCF;;AInoiCA;EACE,gBAAA;AJsoiCF;;AIpoiCA;EACE,gBAAA;AJuoiCF;;AIroiCA;EACE,gBAAA;AJwoiCF;;AItoiCA;EACE,gBAAA;AJyoiCF;;AIvoiCA;EACE,gBAAA;AJ0oiCF;;AIxoiCA;EACE,gBAAA;AJ2oiCF;;AIzoiCA;EACE,gBAAA;AJ4oiCF;;AI1oiCA;EACE,gBAAA;AJ6oiCF;;AI3oiCA;EACE,gBAAA;AJ8oiCF;;AI5oiCA;EACE,gBAAA;AJ+oiCF;;AI7oiCA;EACE,gBAAA;AJgpiCF;;AI9oiCA;EACE,gBAAA;AJipiCF;;AI/oiCA;EACE,gBAAA;AJkpiCF;;AIhpiCA;EACE,gBAAA;AJmpiCF;;AIjpiCA;EACE,gBAAA;AJopiCF;;AIlpiCA;EACE,gBAAA;AJqpiCF;;AInpiCA;EACE,gBAAA;AJspiCF;;AIppiCA;EACE,gBAAA;AJupiCF;;AIrpiCA;EACE,gBAAA;AJwpiCF;;AItpiCA;EACE,gBAAA;AJypiCF;;AIvpiCA;EACE,gBAAA;AJ0piCF;;AIxpiCA;EACE,gBAAA;AJ2piCF;;AIzpiCA;EACE,gBAAA;AJ4piCF;;AI1piCA;EACE,gBAAA;AJ6piCF;;AI3piCA;EACE,gBAAA;AJ8piCF;;AI5piCA;EACE,gBAAA;AJ+piCF;;AI7piCA;EACE,gBAAA;AJgqiCF;;AI9piCA;EACE,gBAAA;AJiqiCF;;AI/piCA;EACE,gBAAA;AJkqiCF;;AIhqiCA;EACE,gBAAA;AJmqiCF;;AIjqiCA;EACE,gBAAA;AJoqiCF;;AIlqiCA;EACE,gBAAA;AJqqiCF;;AInqiCA;EACE,gBAAA;AJsqiCF;;AIpqiCA;EACE,gBAAA;AJuqiCF;;AIrqiCA;EACE,gBAAA;AJwqiCF;;AItqiCA;EACE,gBAAA;AJyqiCF;;AIvqiCA;EACE,gBAAA;AJ0qiCF;;AIxqiCA;EACE,gBAAA;AJ2qiCF;;AIzqiCA;EACE,gBAAA;AJ4qiCF;;AI1qiCA;EACE,gBAAA;AJ6qiCF;;AI3qiCA;EACE,gBAAA;AJ8qiCF;;AI5qiCA;EACE,gBAAA;AJ+qiCF;;AI7qiCA;EACE,gBAAA;AJgriCF;;AI9qiCA;EACE,gBAAA;AJiriCF;;AI/qiCA;EACE,gBAAA;AJkriCF;;AIhriCA;EACE,gBAAA;AJmriCF;;AIjriCA;EACE,gBAAA;AJoriCF;;AIlriCA;EACE,gBAAA;AJqriCF;;AInriCA;EACE,gBAAA;AJsriCF;;AIpriCA;EACE,gBAAA;AJuriCF;;AIrriCA;EACE,gBAAA;AJwriCF;;AItriCA;EACE,gBAAA;AJyriCF;;AIvriCA;EACE,gBAAA;AJ0riCF;;AIxriCA;EACE,gBAAA;AJ2riCF;;AIzriCA;EACE,gBAAA;AJ4riCF;;AI1riCA;EACE,gBAAA;AJ6riCF;;AI3riCA;EACE,gBAAA;AJ8riCF;;AI5riCA;EACE,gBAAA;AJ+riCF;;AI7riCA;EACE,gBAAA;AJgsiCF;;AI9riCA;EACE,gBAAA;AJisiCF;;AI/riCA;EACE,gBAAA;AJksiCF;;AIhsiCA;EACE,gBAAA;AJmsiCF;;AIjsiCA;EACE,gBAAA;AJosiCF;;AIlsiCA;EACE,gBAAA;AJqsiCF;;AInsiCA;EACE,gBAAA;AJssiCF;;AIpsiCA;EACE,gBAAA;AJusiCF;;AIrsiCA;EACE,gBAAA;AJwsiCF;;AItsiCA;EACE,gBAAA;AJysiCF;;AIvsiCA;EACE,gBAAA;AJ0siCF;;AIxsiCA;EACE,gBAAA;AJ2siCF;;AIzsiCA;EACE,gBAAA;AJ4siCF;;AI1siCA;EACE,gBAAA;AJ6siCF;;AI3siCA;EACE,gBAAA;AJ8siCF;;AI5siCA;EACE,gBAAA;AJ+siCF;;AI7siCA;EACE,gBAAA;AJgtiCF;;AI9siCA;EACE,gBAAA;AJitiCF;;AI/siCA;EACE,gBAAA;AJktiCF;;AIhtiCA;EACE,gBAAA;AJmtiCF;;AIjtiCA;EACE,gBAAA;AJotiCF;;AIltiCA;EACE,gBAAA;AJqtiCF;;AIntiCA;EACE,gBAAA;AJstiCF;;AIptiCA;EACE,gBAAA;AJutiCF;;AIrtiCA;EACE,gBAAA;AJwtiCF;;AIttiCA;EACE,gBAAA;AJytiCF;;AIvtiCA;EACE,gBAAA;AJ0tiCF;;AIxtiCA;EACE,gBAAA;AJ2tiCF;;AIztiCA;EACE,gBAAA;AJ4tiCF;;AI1tiCA;EACE,gBAAA;AJ6tiCF;;AI3tiCA;EACE,gBAAA;AJ8tiCF;;AI5tiCA;EACE,gBAAA;AJ+tiCF;;AI7tiCA;EACE,gBAAA;AJguiCF;;AI9tiCA;EACE,gBAAA;AJiuiCF;;AI/tiCA;EACE,gBAAA;AJkuiCF;;AIhuiCA;EACE,gBAAA;AJmuiCF;;AIjuiCA;EACE,gBAAA;AJouiCF;;AIluiCA;EACE,gBAAA;AJquiCF;;AInuiCA;EACE,gBAAA;AJsuiCF;;AIpuiCA;EACE,gBAAA;AJuuiCF;;AIruiCA;EACE,gBAAA;AJwuiCF;;AItuiCA;EACE,gBAAA;AJyuiCF;;AIvuiCA;EACE,gBAAA;AJ0uiCF;;AIxuiCA;EACE,gBAAA;AJ2uiCF;;AIzuiCA;EACE,gBAAA;AJ4uiCF;;AI1uiCA;EACE,gBAAA;AJ6uiCF;;AI3uiCA;EACE,gBAAA;AJ8uiCF;;AI5uiCA;EACE,gBAAA;AJ+uiCF;;AI7uiCA;EACE,gBAAA;AJgviCF;;AI9uiCA;EACE,gBAAA;AJiviCF;;AI/uiCA;EACE,gBAAA;AJkviCF;;AIhviCA;EACE,gBAAA;AJmviCF;;AIjviCA;EACE,gBAAA;AJoviCF;;AIlviCA;EACE,gBAAA;AJqviCF;;AInviCA;EACE,gBAAA;AJsviCF;;AIpviCA;EACE,gBAAA;AJuviCF;;AIrviCA;EACE,gBAAA;AJwviCF;;AItviCA;EACE,gBAAA;AJyviCF;;AIvviCA;EACE,gBAAA;AJ0viCF;;AIxviCA;EACE,gBAAA;AJ2viCF;;AIzviCA;EACE,gBAAA;AJ4viCF;;AI1viCA;EACE,gBAAA;AJ6viCF;;AI3viCA;EACE,gBAAA;AJ8viCF;;AI5viCA;EACE,gBAAA;AJ+viCF;;AI7viCA;EACE,gBAAA;AJgwiCF;;AI9viCA;EACE,gBAAA;AJiwiCF;;AI/viCA;EACE,gBAAA;AJkwiCF;;AIhwiCA;EACE,gBAAA;AJmwiCF;;AIjwiCA;EACE,gBAAA;AJowiCF;;AIlwiCA;EACE,gBAAA;AJqwiCF;;AInwiCA;EACE,gBAAA;AJswiCF;;AIpwiCA;EACE,gBAAA;AJuwiCF;;AIrwiCA;EACE,gBAAA;AJwwiCF;;AItwiCA;EACE,gBAAA;AJywiCF;;AIvwiCA;EACE,gBAAA;AJ0wiCF;;AIxwiCA;EACE,gBAAA;AJ2wiCF;;AIzwiCA;EACE,gBAAA;AJ4wiCF;;AI1wiCA;EACE,gBAAA;AJ6wiCF;;AI3wiCA;EACE,gBAAA;AJ8wiCF;;AI5wiCA;EACE,gBAAA;AJ+wiCF;;AI7wiCA;EACE,gBAAA;AJgxiCF;;AI9wiCA;EACE,gBAAA;AJixiCF;;AI/wiCA;EACE,gBAAA;AJkxiCF;;AIhxiCA;EACE,gBAAA;AJmxiCF;;AIjxiCA;EACE,gBAAA;AJoxiCF;;AIlxiCA;EACE,gBAAA;AJqxiCF;;AInxiCA;EACE,gBAAA;AJsxiCF;;AIpxiCA;EACE,gBAAA;AJuxiCF;;AIrxiCA;EACE,gBAAA;AJwxiCF;;AItxiCA;EACE,gBAAA;AJyxiCF;;AIvxiCA;EACE,gBAAA;AJ0xiCF;;AIxxiCA;EACE,gBAAA;AJ2xiCF;;AIzxiCA;EACE,gBAAA;AJ4xiCF;;AI1xiCA;EACE,gBAAA;AJ6xiCF;;AI3xiCA;EACE,gBAAA;AJ8xiCF;;AI5xiCA;EACE,gBAAA;AJ+xiCF;;AI7xiCA;EACE,gBAAA;AJgyiCF;;AI9xiCA;EACE,gBAAA;AJiyiCF;;AI/xiCA;EACE,gBAAA;AJkyiCF;;AIhyiCA;EACE,gBAAA;AJmyiCF;;AIjyiCA;EACE,gBAAA;AJoyiCF;;AIlyiCA;EACE,gBAAA;AJqyiCF;;AInyiCA;EACE,gBAAA;AJsyiCF;;AIpyiCA;EACE,gBAAA;AJuyiCF;;AIryiCA;EACE,gBAAA;AJwyiCF;;AItyiCA;EACE,gBAAA;AJyyiCF;;AIvyiCA;EACE,gBAAA;AJ0yiCF;;AIxyiCA;EACE,gBAAA;AJ2yiCF;;AIzyiCA;EACE,gBAAA;AJ4yiCF;;AI1yiCA;EACE,gBAAA;AJ6yiCF;;AI3yiCA;EACE,gBAAA;AJ8yiCF;;AI5yiCA;EACE,gBAAA;AJ+yiCF;;AI7yiCA;EACE,gBAAA;AJgziCF;;AI9yiCA;EACE,gBAAA;AJiziCF;;AI/yiCA;EACE,gBAAA;AJkziCF;;AIhziCA;EACE,gBAAA;AJmziCF;;AIjziCA;EACE,gBAAA;AJoziCF;;AIlziCA;EACE,gBAAA;AJqziCF;;AInziCA;EACE,gBAAA;AJsziCF;;AIpziCA;EACE,gBAAA;AJuziCF;;AIrziCA;EACE,gBAAA;AJwziCF;;AItziCA;EACE,gBAAA;AJyziCF;;AIvziCA;EACE,gBAAA;AJ0ziCF;;AIxziCA;EACE,gBAAA;AJ2ziCF;;AIzziCA;EACE,gBAAA;AJ4ziCF;;AI1ziCA;EACE,gBAAA;AJ6ziCF;;AI3ziCA;EACE,gBAAA;AJ8ziCF;;AI5ziCA;EACE,gBAAA;AJ+ziCF;;AI7ziCA;EACE,gBAAA;AJg0iCF;;AI9ziCA;EACE,gBAAA;AJi0iCF;;AI/ziCA;EACE,gBAAA;AJk0iCF;;AIh0iCA;EACE,gBAAA;AJm0iCF;;AIj0iCA;EACE,gBAAA;AJo0iCF;;AIl0iCA;EACE,gBAAA;AJq0iCF;;AIn0iCA;EACE,gBAAA;AJs0iCF;;AIp0iCA;EACE,gBAAA;AJu0iCF;;AIr0iCA;EACE,gBAAA;AJw0iCF;;AIt0iCA;EACE,gBAAA;AJy0iCF;;AIv0iCA;EACE,gBAAA;AJ00iCF;;AIx0iCA;EACE,gBAAA;AJ20iCF;;AIz0iCA;EACE,gBAAA;AJ40iCF;;AI10iCA;EACE,gBAAA;AJ60iCF;;AI30iCA;EACE,gBAAA;AJ80iCF;;AI50iCA;EACE,gBAAA;AJ+0iCF;;AI70iCA;EACE,gBAAA;AJg1iCF;;AI90iCA;EACE,gBAAA;AJi1iCF;;AI/0iCA;EACE,gBAAA;AJk1iCF;;AIh1iCA;EACE,gBAAA;AJm1iCF;;AIj1iCA;EACE,gBAAA;AJo1iCF;;AIl1iCA;EACE,gBAAA;AJq1iCF;;AIn1iCA;EACE,gBAAA;AJs1iCF;;AIp1iCA;EACE,gBAAA;AJu1iCF;;AIr1iCA;EACE,gBAAA;AJw1iCF;;AIt1iCA;EACE,gBAAA;AJy1iCF;;AIv1iCA;EACE,gBAAA;AJ01iCF;;AIx1iCA;EACE,gBAAA;AJ21iCF;;AIz1iCA;EACE,gBAAA;AJ41iCF;;AI11iCA;EACE,gBAAA;AJ61iCF;;AI31iCA;EACE,gBAAA;AJ81iCF;;AI51iCA;EACE,gBAAA;AJ+1iCF;;AI71iCA;EACE,gBAAA;AJg2iCF;;AI91iCA;EACE,gBAAA;AJi2iCF;;AI/1iCA;EACE,gBAAA;AJk2iCF;;AIh2iCA;EACE,gBAAA;AJm2iCF;;AIj2iCA;EACE,gBAAA;AJo2iCF;;AIl2iCA;EACE,gBAAA;AJq2iCF;;AIn2iCA;EACE,gBAAA;AJs2iCF;;AIp2iCA;EACE,gBAAA;AJu2iCF;;AIr2iCA;EACE,gBAAA;AJw2iCF;;AIt2iCA;EACE,gBAAA;AJy2iCF;;AIv2iCA;EACE,gBAAA;AJ02iCF;;AIx2iCA;EACE,gBAAA;AJ22iCF;;AIz2iCA;EACE,gBAAA;AJ42iCF;;AI12iCA;EACE,gBAAA;AJ62iCF;;AI32iCA;EACE,gBAAA;AJ82iCF;;AI52iCA;EACE,gBAAA;AJ+2iCF;;AI72iCA;EACE,gBAAA;AJg3iCF;;AI92iCA;EACE,gBAAA;AJi3iCF;;AI/2iCA;EACE,gBAAA;AJk3iCF;;AIh3iCA;EACE,gBAAA;AJm3iCF;;AIj3iCA;EACE,gBAAA;AJo3iCF;;AIl3iCA;EACE,gBAAA;AJq3iCF;;AIn3iCA;EACE,gBAAA;AJs3iCF;;AIp3iCA;EACE,gBAAA;AJu3iCF;;AIr3iCA;EACE,gBAAA;AJw3iCF;;AIt3iCA;EACE,gBAAA;AJy3iCF;;AIv3iCA;EACE,gBAAA;AJ03iCF;;AIx3iCA;EACE,gBAAA;AJ23iCF;;AIz3iCA;EACE,gBAAA;AJ43iCF;;AI13iCA;EACE,gBAAA;AJ63iCF;;AI33iCA;EACE,gBAAA;AJ83iCF;;AI53iCA;EACE,gBAAA;AJ+3iCF;;AI73iCA;EACE,gBAAA;AJg4iCF;;AI93iCA;EACE,gBAAA;AJi4iCF;;AI/3iCA;EACE,gBAAA;AJk4iCF;;AIh4iCA;EACE,gBAAA;AJm4iCF;;AIj4iCA;EACE,gBAAA;AJo4iCF;;AIl4iCA;EACE,gBAAA;AJq4iCF;;AIn4iCA;EACE,gBAAA;AJs4iCF;;AIp4iCA;EACE,gBAAA;AJu4iCF;;AIr4iCA;EACE,gBAAA;AJw4iCF;;AIt4iCA;EACE,gBAAA;AJy4iCF;;AIv4iCA;EACE,gBAAA;AJ04iCF;;AIx4iCA;EACE,gBAAA;AJ24iCF;;AIz4iCA;EACE,gBAAA;AJ44iCF;;AI14iCA;EACE,gBAAA;AJ64iCF;;AI34iCA;EACE,gBAAA;AJ84iCF;;AI54iCA;EACE,gBAAA;AJ+4iCF;;AI74iCA;EACE,gBAAA;AJg5iCF;;AI94iCA;EACE,gBAAA;AJi5iCF;;AI/4iCA;EACE,gBAAA;AJk5iCF;;AIh5iCA;EACE,gBAAA;AJm5iCF;;AIj5iCA;EACE,gBAAA;AJo5iCF;;AIl5iCA;EACE,gBAAA;AJq5iCF;;AIn5iCA;EACE,gBAAA;AJs5iCF;;AIp5iCA;EACE,gBAAA;AJu5iCF;;AIr5iCA;EACE,gBAAA;AJw5iCF;;AIt5iCA;EACE,gBAAA;AJy5iCF;;AIv5iCA;EACE,gBAAA;AJ05iCF;;AIx5iCA;EACE,gBAAA;AJ25iCF;;AIz5iCA;EACE,gBAAA;AJ45iCF;;AI15iCA;EACE,gBAAA;AJ65iCF;;AI35iCA;EACE,gBAAA;AJ85iCF;;AI55iCA;EACE,gBAAA;AJ+5iCF;;AI75iCA;EACE,gBAAA;AJg6iCF;;AI95iCA;EACE,gBAAA;AJi6iCF;;AI/5iCA;EACE,gBAAA;AJk6iCF;;AIh6iCA;EACE,gBAAA;AJm6iCF;;AIj6iCA;EACE,gBAAA;AJo6iCF;;AIl6iCA;EACE,gBAAA;AJq6iCF;;AIn6iCA;EACE,gBAAA;AJs6iCF;;AIp6iCA;EACE,gBAAA;AJu6iCF;;AIr6iCA;EACE,gBAAA;AJw6iCF;;AIt6iCA;EACE,gBAAA;AJy6iCF;;AIv6iCA;EACE,gBAAA;AJ06iCF;;AIx6iCA;EACE,gBAAA;AJ26iCF;;AIz6iCA;EACE,gBAAA;AJ46iCF;;AI16iCA;EACE,gBAAA;AJ66iCF;;AI36iCA;EACE,gBAAA;AJ86iCF;;AI56iCA;EACE,gBAAA;AJ+6iCF;;AI76iCA;EACE,gBAAA;AJg7iCF;;AI96iCA;EACE,gBAAA;AJi7iCF;;AI/6iCA;EACE,gBAAA;AJk7iCF;;AIh7iCA;EACE,gBAAA;AJm7iCF;;AIj7iCA;EACE,gBAAA;AJo7iCF;;AIl7iCA;EACE,gBAAA;AJq7iCF;;AIn7iCA;EACE,gBAAA;AJs7iCF;;AIp7iCA;EACE,gBAAA;AJu7iCF;;AIr7iCA;EACE,gBAAA;AJw7iCF;;AIt7iCA;EACE,gBAAA;AJy7iCF;;AIv7iCA;EACE,gBAAA;AJ07iCF;;AIx7iCA;EACE,gBAAA;AJ27iCF;;AIz7iCA;EACE,gBAAA;AJ47iCF;;AI17iCA;EACE,gBAAA;AJ67iCF;;AI37iCA;EACE,gBAAA;AJ87iCF;;AI57iCA;EACE,gBAAA;AJ+7iCF;;AI77iCA;EACE,gBAAA;AJg8iCF;;AI97iCA;EACE,gBAAA;AJi8iCF;;AI/7iCA;EACE,gBAAA;AJk8iCF;;AIh8iCA;EACE,gBAAA;AJm8iCF;;AIj8iCA;EACE,gBAAA;AJo8iCF;;AIl8iCA;EACE,gBAAA;AJq8iCF;;AIn8iCA;EACE,gBAAA;AJs8iCF;;AIp8iCA;EACE,gBAAA;AJu8iCF;;AIr8iCA;EACE,gBAAA;AJw8iCF;;AIt8iCA;EACE,gBAAA;AJy8iCF;;AIv8iCA;EACE,gBAAA;AJ08iCF;;AIx8iCA;EACE,gBAAA;AJ28iCF;;AIz8iCA;EACE,gBAAA;AJ48iCF;;AI18iCA;EACE,gBAAA;AJ68iCF;;AI38iCA;EACE,gBAAA;AJ88iCF;;AI58iCA;EACE,gBAAA;AJ+8iCF;;AI78iCA;EACE,gBAAA;AJg9iCF;;AI98iCA;EACE,gBAAA;AJi9iCF;;AI/8iCA;EACE,gBAAA;AJk9iCF;;AIh9iCA;EACE,gBAAA;AJm9iCF;;AIj9iCA;EACE,gBAAA;AJo9iCF;;AIl9iCA;EACE,gBAAA;AJq9iCF;;AIn9iCA;EACE,gBAAA;AJs9iCF;;AIp9iCA;EACE,gBAAA;AJu9iCF;;AIr9iCA;EACE,gBAAA;AJw9iCF;;AIt9iCA;EACE,gBAAA;AJy9iCF;;AIv9iCA;EACE,gBAAA;AJ09iCF;;AIx9iCA;EACE,gBAAA;AJ29iCF;;AIz9iCA;EACE,gBAAA;AJ49iCF;;AI19iCA;EACE,gBAAA;AJ69iCF;;AI39iCA;EACE,gBAAA;AJ89iCF;;AI59iCA;EACE,gBAAA;AJ+9iCF;;AI79iCA;EACE,gBAAA;AJg+iCF;;AI99iCA;EACE,gBAAA;AJi+iCF;;AI/9iCA;EACE,gBAAA;AJk+iCF;;AIh+iCA;EACE,gBAAA;AJm+iCF;;AIj+iCA;EACE,gBAAA;AJo+iCF;;AIl+iCA;EACE,gBAAA;AJq+iCF;;AIn+iCA;EACE,gBAAA;AJs+iCF;;AIp+iCA;EACE,gBAAA;AJu+iCF;;AIr+iCA;EACE,gBAAA;AJw+iCF;;AIt+iCA;EACE,gBAAA;AJy+iCF;;AIv+iCA;EACE,gBAAA;AJ0+iCF;;AIx+iCA;EACE,gBAAA;AJ2+iCF;;AIz+iCA;EACE,gBAAA;AJ4+iCF;;AI1+iCA;EACE,gBAAA;AJ6+iCF;;AI3+iCA;EACE,gBAAA;AJ8+iCF;;AI5+iCA;EACE,gBAAA;AJ++iCF;;AI7+iCA;EACE,gBAAA;AJg/iCF;;AI9+iCA;EACE,gBAAA;AJi/iCF;;AI/+iCA;EACE,gBAAA;AJk/iCF;;AIh/iCA;EACE,gBAAA;AJm/iCF;;AIj/iCA;EACE,gBAAA;AJo/iCF;;AIl/iCA;EACE,gBAAA;AJq/iCF;;AIn/iCA;EACE,gBAAA;AJs/iCF;;AIp/iCA;EACE,gBAAA;AJu/iCF;;AIr/iCA;EACE,gBAAA;AJw/iCF;;AIt/iCA;EACE,gBAAA;AJy/iCF;;AIv/iCA;EACE,gBAAA;AJ0/iCF;;AIx/iCA;EACE,gBAAA;AJ2/iCF;;AIz/iCA;EACE,gBAAA;AJ4/iCF;;AI1/iCA;EACE,gBAAA;AJ6/iCF;;AI3/iCA;EACE,gBAAA;AJ8/iCF;;AI5/iCA;EACE,gBAAA;AJ+/iCF;;AI7/iCA;EACE,gBAAA;AJggjCF;;AI9/iCA;EACE,gBAAA;AJigjCF;;AI//iCA;EACE,gBAAA;AJkgjCF;;AIhgjCA;EACE,gBAAA;AJmgjCF;;AIjgjCA;EACE,gBAAA;AJogjCF;;AIlgjCA;EACE,gBAAA;AJqgjCF;;AIngjCA;EACE,gBAAA;AJsgjCF;;AIpgjCA;EACE,gBAAA;AJugjCF;;AIrgjCA;EACE,gBAAA;AJwgjCF;;AItgjCA;EACE,gBAAA;AJygjCF;;AIvgjCA;EACE,gBAAA;AJ0gjCF;;AIxgjCA;EACE,gBAAA;AJ2gjCF;;AIzgjCA;EACE,gBAAA;AJ4gjCF;;AI1gjCA;EACE,gBAAA;AJ6gjCF;;AI3gjCA;EACE,gBAAA;AJ8gjCF;;AI5gjCA;EACE,gBAAA;AJ+gjCF;;AI7gjCA;EACE,gBAAA;AJghjCF;;AI9gjCA;EACE,gBAAA;AJihjCF;;AI/gjCA;EACE,gBAAA;AJkhjCF;;AIhhjCA;EACE,gBAAA;AJmhjCF;;AIjhjCA;EACE,gBAAA;AJohjCF;;AIlhjCA;EACE,gBAAA;AJqhjCF;;AInhjCA;EACE,gBAAA;AJshjCF;;AIphjCA;EACE,gBAAA;AJuhjCF;;AIrhjCA;EACE,gBAAA;AJwhjCF;;AIthjCA;EACE,gBAAA;AJyhjCF;;AIvhjCA;EACE,gBAAA;AJ0hjCF;;AIxhjCA;EACE,gBAAA;AJ2hjCF;;AIzhjCA;EACE,gBAAA;AJ4hjCF;;AI1hjCA;EACE,gBAAA;AJ6hjCF;;AI3hjCA;EACE,gBAAA;AJ8hjCF;;AI5hjCA;EACE,gBAAA;AJ+hjCF;;AI7hjCA;EACE,gBAAA;AJgijCF;;AI9hjCA;EACE,gBAAA;AJiijCF;;AI/hjCA;EACE,gBAAA;AJkijCF;;AIhijCA;EACE,gBAAA;AJmijCF;;AIjijCA;EACE,gBAAA;AJoijCF;;AIlijCA;EACE,gBAAA;AJqijCF;;AInijCA;EACE,gBAAA;AJsijCF;;AIpijCA;EACE,gBAAA;AJuijCF;;AIrijCA;EACE,gBAAA;AJwijCF;;AItijCA;EACE,gBAAA;AJyijCF;;AIvijCA;EACE,gBAAA;AJ0ijCF;;AIxijCA;EACE,gBAAA;AJ2ijCF;;AIzijCA;EACE,gBAAA;AJ4ijCF;;AI1ijCA;EACE,gBAAA;AJ6ijCF;;AI3ijCA;EACE,gBAAA;AJ8ijCF;;AI5ijCA;EACE,gBAAA;AJ+ijCF;;AI7ijCA;EACE,gBAAA;AJgjjCF;;AI9ijCA;EACE,gBAAA;AJijjCF;;AI/ijCA;EACE,gBAAA;AJkjjCF;;AIhjjCA;EACE,gBAAA;AJmjjCF;;AIjjjCA;EACE,gBAAA;AJojjCF;;AIljjCA;EACE,gBAAA;AJqjjCF;;AInjjCA;EACE,gBAAA;AJsjjCF;;AIpjjCA;EACE,gBAAA;AJujjCF;;AIrjjCA;EACE,gBAAA;AJwjjCF;;AItjjCA;EACE,gBAAA;AJyjjCF;;AIvjjCA;EACE,gBAAA;AJ0jjCF;;AIxjjCA;EACE,gBAAA;AJ2jjCF;;AIzjjCA;EACE,gBAAA;AJ4jjCF;;AI1jjCA;EACE,gBAAA;AJ6jjCF;;AI3jjCA;EACE,gBAAA;AJ8jjCF;;AI5jjCA;EACE,gBAAA;AJ+jjCF;;AI7jjCA;EACE,gBAAA;AJgkjCF;;AI9jjCA;EACE,gBAAA;AJikjCF;;AI/jjCA;EACE,gBAAA;AJkkjCF;;AIhkjCA;EACE,gBAAA;AJmkjCF;;AIjkjCA;EACE,gBAAA;AJokjCF;;AIlkjCA;EACE,gBAAA;AJqkjCF;;AInkjCA;EACE,gBAAA;AJskjCF;;AIpkjCA;EACE,gBAAA;AJukjCF;;AIrkjCA;EACE,gBAAA;AJwkjCF;;AItkjCA;EACE,gBAAA;AJykjCF;;AIvkjCA;EACE,gBAAA;AJ0kjCF;;AIxkjCA;EACE,gBAAA;AJ2kjCF;;AIzkjCA;EACE,gBAAA;AJ4kjCF;;AI1kjCA;EACE,gBAAA;AJ6kjCF;;AI3kjCA;EACE,gBAAA;AJ8kjCF;;AI5kjCA;EACE,gBAAA;AJ+kjCF;;AI7kjCA;EACE,gBAAA;AJgljCF;;AI9kjCA;EACE,gBAAA;AJiljCF;;AI/kjCA;EACE,gBAAA;AJkljCF;;AIhljCA;EACE,gBAAA;AJmljCF;;AIjljCA;EACE,gBAAA;AJoljCF;;AIlljCA;EACE,gBAAA;AJqljCF;;AInljCA;EACE,gBAAA;AJsljCF;;AIpljCA;EACE,gBAAA;AJuljCF;;AIrljCA;EACE,gBAAA;AJwljCF;;AItljCA;EACE,gBAAA;AJyljCF;;AIvljCA;EACE,gBAAA;AJ0ljCF;;AIxljCA;EACE,gBAAA;AJ2ljCF;;AIzljCA;EACE,gBAAA;AJ4ljCF;;AI1ljCA;EACE,gBAAA;AJ6ljCF;;AI3ljCA;EACE,gBAAA;AJ8ljCF;;AI5ljCA;EACE,gBAAA;AJ+ljCF;;AI7ljCA;EACE,gBAAA;AJgmjCF;;AI9ljCA;EACE,gBAAA;AJimjCF;;AI/ljCA;EACE,gBAAA;AJkmjCF;;AIhmjCA;EACE,gBAAA;AJmmjCF;;AIjmjCA;EACE,gBAAA;AJomjCF;;AIlmjCA;EACE,gBAAA;AJqmjCF;;AInmjCA;EACE,gBAAA;AJsmjCF;;AIpmjCA;EACE,gBAAA;AJumjCF;;AIrmjCA;EACE,gBAAA;AJwmjCF;;AItmjCA;EACE,gBAAA;AJymjCF;;AIvmjCA;EACE,gBAAA;AJ0mjCF;;AIxmjCA;EACE,gBAAA;AJ2mjCF;;AIzmjCA;EACE,gBAAA;AJ4mjCF;;AI1mjCA;EACE,gBAAA;AJ6mjCF;;AI3mjCA;EACE,gBAAA;AJ8mjCF;;AI5mjCA;EACE,gBAAA;AJ+mjCF;;AI7mjCA;EACE,gBAAA;AJgnjCF;;AI9mjCA;EACE,gBAAA;AJinjCF;;AI/mjCA;EACE,gBAAA;AJknjCF;;AIhnjCA;EACE,gBAAA;AJmnjCF;;AIjnjCA;EACE,gBAAA;AJonjCF;;AIlnjCA;EACE,gBAAA;AJqnjCF;;AInnjCA;EACE,gBAAA;AJsnjCF;;AIpnjCA;EACE,gBAAA;AJunjCF;;AIrnjCA;EACE,gBAAA;AJwnjCF;;AItnjCA;EACE,gBAAA;AJynjCF;;AIvnjCA;EACE,gBAAA;AJ0njCF;;AIxnjCA;EACE,gBAAA;AJ2njCF;;AIznjCA;EACE,gBAAA;AJ4njCF;;AI1njCA;EACE,gBAAA;AJ6njCF;;AI3njCA;EACE,gBAAA;AJ8njCF;;AI5njCA;EACE,gBAAA;AJ+njCF;;AI7njCA;EACE,gBAAA;AJgojCF;;AI9njCA;EACE,gBAAA;AJiojCF;;AI/njCA;EACE,gBAAA;AJkojCF;;AIhojCA;EACE,gBAAA;AJmojCF;;AIjojCA;EACE,gBAAA;AJoojCF;;AIlojCA;EACE,gBAAA;AJqojCF;;AInojCA;EACE,gBAAA;AJsojCF;;AIpojCA;EACE,gBAAA;AJuojCF;;AIrojCA;EACE,gBAAA;AJwojCF;;AItojCA;EACE,gBAAA;AJyojCF;;AIvojCA;EACE,gBAAA;AJ0ojCF;;AIxojCA;EACE,gBAAA;AJ2ojCF;;AIzojCA;EACE,gBAAA;AJ4ojCF;;AI1ojCA;EACE,gBAAA;AJ6ojCF;;AI3ojCA;EACE,gBAAA;AJ8ojCF;;AI5ojCA;EACE,gBAAA;AJ+ojCF;;AI7ojCA;EACE,gBAAA;AJgpjCF;;AI9ojCA;EACE,gBAAA;AJipjCF;;AI/ojCA;EACE,gBAAA;AJkpjCF;;AIhpjCA;EACE,gBAAA;AJmpjCF;;AIjpjCA;EACE,gBAAA;AJopjCF;;AIlpjCA;EACE,gBAAA;AJqpjCF;;AInpjCA;EACE,gBAAA;AJspjCF;;AIppjCA;EACE,gBAAA;AJupjCF;;AIrpjCA;EACE,gBAAA;AJwpjCF;;AItpjCA;EACE,gBAAA;AJypjCF;;AIvpjCA;EACE,gBAAA;AJ0pjCF;;AIxpjCA;EACE,gBAAA;AJ2pjCF;;AIzpjCA;EACE,gBAAA;AJ4pjCF;;AI1pjCA;EACE,gBAAA;AJ6pjCF;;AI3pjCA;EACE,gBAAA;AJ8pjCF;;AI5pjCA;EACE,gBAAA;AJ+pjCF;;AI7pjCA;EACE,gBAAA;AJgqjCF;;AI9pjCA;EACE,gBAAA;AJiqjCF;;AI/pjCA;EACE,gBAAA;AJkqjCF;;AIhqjCA;EACE,gBAAA;AJmqjCF;;AIjqjCA;EACE,gBAAA;AJoqjCF;;AIlqjCA;EACE,gBAAA;AJqqjCF;;AInqjCA;EACE,gBAAA;AJsqjCF;;AIpqjCA;EACE,gBAAA;AJuqjCF;;AIrqjCA;EACE,gBAAA;AJwqjCF;;AItqjCA;EACE,gBAAA;AJyqjCF;;AIvqjCA;EACE,gBAAA;AJ0qjCF;;AIxqjCA;EACE,gBAAA;AJ2qjCF;;AIzqjCA;EACE,gBAAA;AJ4qjCF;;AI1qjCA;EACE,gBAAA;AJ6qjCF;;AI3qjCA;EACE,gBAAA;AJ8qjCF;;AI5qjCA;EACE,gBAAA;AJ+qjCF;;AI7qjCA;EACE,gBAAA;AJgrjCF;;AI9qjCA;EACE,gBAAA;AJirjCF;;AI/qjCA;EACE,gBAAA;AJkrjCF;;AIhrjCA;EACE,gBAAA;AJmrjCF;;AIjrjCA;EACE,gBAAA;AJorjCF;;AIlrjCA;EACE,gBAAA;AJqrjCF;;AInrjCA;EACE,gBAAA;AJsrjCF;;AIprjCA;EACE,gBAAA;AJurjCF;;AIrrjCA;EACE,gBAAA;AJwrjCF;;AItrjCA;EACE,gBAAA;AJyrjCF;;AIvrjCA;EACE,gBAAA;AJ0rjCF;;AIxrjCA;EACE,gBAAA;AJ2rjCF;;AIzrjCA;EACE,gBAAA;AJ4rjCF;;AI1rjCA;EACE,gBAAA;AJ6rjCF;;AI3rjCA;EACE,gBAAA;AJ8rjCF;;AI5rjCA;EACE,gBAAA;AJ+rjCF;;AI7rjCA;EACE,gBAAA;AJgsjCF;;AI9rjCA;EACE,gBAAA;AJisjCF;;AI/rjCA;EACE,gBAAA;AJksjCF;;AIhsjCA;EACE,gBAAA;AJmsjCF;;AIjsjCA;EACE,gBAAA;AJosjCF;;AIlsjCA;EACE,gBAAA;AJqsjCF;;AInsjCA;EACE,gBAAA;AJssjCF;;AIpsjCA;EACE,gBAAA;AJusjCF;;AIrsjCA;EACE,gBAAA;AJwsjCF;;AItsjCA;EACE,gBAAA;AJysjCF;;AIvsjCA;EACE,gBAAA;AJ0sjCF;;AIxsjCA;EACE,gBAAA;AJ2sjCF;;AIzsjCA;EACE,gBAAA;AJ4sjCF;;AI1sjCA;EACE,gBAAA;AJ6sjCF;;AI3sjCA;EACE,gBAAA;AJ8sjCF;;AI5sjCA;EACE,gBAAA;AJ+sjCF;;AI7sjCA;EACE,gBAAA;AJgtjCF;;AI9sjCA;EACE,gBAAA;AJitjCF;;AI/sjCA;EACE,gBAAA;AJktjCF;;AIhtjCA;EACE,gBAAA;AJmtjCF;;AIjtjCA;EACE,gBAAA;AJotjCF;;AIltjCA;EACE,gBAAA;AJqtjCF;;AIntjCA;EACE,gBAAA;AJstjCF;;AIptjCA;EACE,gBAAA;AJutjCF;;AIrtjCA;EACE,gBAAA;AJwtjCF;;AIttjCA;EACE,gBAAA;AJytjCF;;AIvtjCA;EACE,gBAAA;AJ0tjCF;;AIxtjCA;EACE,gBAAA;AJ2tjCF;;AIztjCA;EACE,gBAAA;AJ4tjCF;;AI1tjCA;EACE,gBAAA;AJ6tjCF;;AI3tjCA;EACE,gBAAA;AJ8tjCF;;AI5tjCA;EACE,gBAAA;AJ+tjCF;;AI7tjCA;EACE,gBAAA;AJgujCF;;AI9tjCA;EACE,gBAAA;AJiujCF;;AI/tjCA;EACE,gBAAA;AJkujCF;;AIhujCA;EACE,gBAAA;AJmujCF;;AIjujCA;EACE,gBAAA;AJoujCF;;AIlujCA;EACE,gBAAA;AJqujCF;;AInujCA;EACE,gBAAA;AJsujCF;;AIpujCA;EACE,gBAAA;AJuujCF;;AIrujCA;EACE,gBAAA;AJwujCF;;AItujCA;EACE,gBAAA;AJyujCF;;AIvujCA;EACE,gBAAA;AJ0ujCF;;AIxujCA;EACE,gBAAA;AJ2ujCF;;AIzujCA;EACE,gBAAA;AJ4ujCF;;AI1ujCA;EACE,gBAAA;AJ6ujCF;;AI3ujCA;EACE,gBAAA;AJ8ujCF;;AI5ujCA;EACE,gBAAA;AJ+ujCF;;AI7ujCA;EACE,gBAAA;AJgvjCF;;AI9ujCA;EACE,gBAAA;AJivjCF;;AI/ujCA;EACE,gBAAA;AJkvjCF;;AIhvjCA;EACE,gBAAA;AJmvjCF;;AIjvjCA;EACE,gBAAA;AJovjCF;;AIlvjCA;EACE,gBAAA;AJqvjCF;;AInvjCA;EACE,gBAAA;AJsvjCF;;AIpvjCA;EACE,gBAAA;AJuvjCF;;AIrvjCA;EACE,gBAAA;AJwvjCF;;AItvjCA;EACE,gBAAA;AJyvjCF;;AIvvjCA;EACE,gBAAA;AJ0vjCF;;AIxvjCA;EACE,gBAAA;AJ2vjCF;;AIzvjCA;EACE,gBAAA;AJ4vjCF;;AI1vjCA;EACE,gBAAA;AJ6vjCF;;AI3vjCA;EACE,gBAAA;AJ8vjCF;;AI5vjCA;EACE,gBAAA;AJ+vjCF;;AI7vjCA;EACE,gBAAA;AJgwjCF;;AI9vjCA;EACE,gBAAA;AJiwjCF;;AI/vjCA;EACE,gBAAA;AJkwjCF;;AIhwjCA;EACE,gBAAA;AJmwjCF;;AIjwjCA;EACE,gBAAA;AJowjCF;;AIlwjCA;EACE,gBAAA;AJqwjCF;;AInwjCA;EACE,gBAAA;AJswjCF;;AIpwjCA;EACE,gBAAA;AJuwjCF;;AIrwjCA;EACE,gBAAA;AJwwjCF;;AItwjCA;EACE,gBAAA;AJywjCF;;AIvwjCA;EACE,gBAAA;AJ0wjCF;;AIxwjCA;EACE,gBAAA;AJ2wjCF;;AIzwjCA;EACE,gBAAA;AJ4wjCF;;AI1wjCA;EACE,gBAAA;AJ6wjCF;;AI3wjCA;EACE,gBAAA;AJ8wjCF;;AI5wjCA;EACE,gBAAA;AJ+wjCF;;AI7wjCA;EACE,gBAAA;AJgxjCF;;AI9wjCA;EACE,gBAAA;AJixjCF;;AI/wjCA;EACE,gBAAA;AJkxjCF;;AIhxjCA;EACE,gBAAA;AJmxjCF;;AIjxjCA;EACE,gBAAA;AJoxjCF;;AIlxjCA;EACE,gBAAA;AJqxjCF;;AInxjCA;EACE,gBAAA;AJsxjCF;;AIpxjCA;EACE,gBAAA;AJuxjCF;;AIrxjCA;EACE,gBAAA;AJwxjCF;;AItxjCA;EACE,gBAAA;AJyxjCF;;AIvxjCA;EACE,gBAAA;AJ0xjCF;;AIxxjCA;EACE,gBAAA;AJ2xjCF;;AIzxjCA;EACE,gBAAA;AJ4xjCF;;AI1xjCA;EACE,gBAAA;AJ6xjCF;;AI3xjCA;EACE,gBAAA;AJ8xjCF;;AI5xjCA;EACE,gBAAA;AJ+xjCF;;AI7xjCA;EACE,gBAAA;AJgyjCF;;AI9xjCA;EACE,gBAAA;AJiyjCF;;AI/xjCA;EACE,gBAAA;AJkyjCF;;AIhyjCA;EACE,gBAAA;AJmyjCF;;AIjyjCA;EACE,gBAAA;AJoyjCF;;AIlyjCA;EACE,gBAAA;AJqyjCF;;AInyjCA;EACE,gBAAA;AJsyjCF;;AIpyjCA;EACE,gBAAA;AJuyjCF;;AIryjCA;EACE,gBAAA;AJwyjCF;;AItyjCA;EACE,gBAAA;AJyyjCF;;AIvyjCA;EACE,gBAAA;AJ0yjCF;;AIxyjCA;EACE,gBAAA;AJ2yjCF;;AIzyjCA;EACE,gBAAA;AJ4yjCF;;AI1yjCA;EACE,gBAAA;AJ6yjCF;;AI3yjCA;EACE,gBAAA;AJ8yjCF;;AI5yjCA;EACE,gBAAA;AJ+yjCF;;AI7yjCA;EACE,gBAAA;AJgzjCF;;AI9yjCA;EACE,gBAAA;AJizjCF;;AI/yjCA;EACE,gBAAA;AJkzjCF;;AIhzjCA;EACE,gBAAA;AJmzjCF;;AIjzjCA;EACE,gBAAA;AJozjCF;;AIlzjCA;EACE,gBAAA;AJqzjCF;;AInzjCA;EACE,gBAAA;AJszjCF;;AIpzjCA;EACE,gBAAA;AJuzjCF;;AIrzjCA;EACE,gBAAA;AJwzjCF;;AItzjCA;EACE,gBAAA;AJyzjCF;;AIvzjCA;EACE,gBAAA;AJ0zjCF;;AIxzjCA;EACE,gBAAA;AJ2zjCF;;AIzzjCA;EACE,gBAAA;AJ4zjCF;;AI1zjCA;EACE,gBAAA;AJ6zjCF;;AI3zjCA;EACE,gBAAA;AJ8zjCF;;AI5zjCA;EACE,gBAAA;AJ+zjCF;;AI7zjCA;EACE,gBAAA;AJg0jCF;;AI9zjCA;EACE,gBAAA;AJi0jCF;;AI/zjCA;EACE,gBAAA;AJk0jCF;;AIh0jCA;EACE,gBAAA;AJm0jCF;;AIj0jCA;EACE,gBAAA;AJo0jCF;;AIl0jCA;EACE,gBAAA;AJq0jCF;;AIn0jCA;EACE,gBAAA;AJs0jCF;;AIp0jCA;EACE,gBAAA;AJu0jCF;;AIr0jCA;EACE,gBAAA;AJw0jCF;;AIt0jCA;EACE,gBAAA;AJy0jCF;;AIv0jCA;EACE,gBAAA;AJ00jCF;;AIx0jCA;EACE,gBAAA;AJ20jCF;;AIz0jCA;EACE,gBAAA;AJ40jCF;;AI10jCA;EACE,gBAAA;AJ60jCF;;AI30jCA;EACE,gBAAA;AJ80jCF;;AI50jCA;EACE,gBAAA;AJ+0jCF;;AI70jCA;EACE,gBAAA;AJg1jCF;;AI90jCA;EACE,gBAAA;AJi1jCF;;AI/0jCA;EACE,gBAAA;AJk1jCF;;AIh1jCA;EACE,gBAAA;AJm1jCF;;AIj1jCA;EACE,gBAAA;AJo1jCF;;AIl1jCA;EACE,gBAAA;AJq1jCF;;AIn1jCA;EACE,gBAAA;AJs1jCF;;AIp1jCA;EACE,gBAAA;AJu1jCF;;AIr1jCA;EACE,gBAAA;AJw1jCF;;AIt1jCA;EACE,gBAAA;AJy1jCF;;AIv1jCA;EACE,gBAAA;AJ01jCF;;AIx1jCA;EACE,gBAAA;AJ21jCF;;AIz1jCA;EACE,gBAAA;AJ41jCF;;AI11jCA;EACE,gBAAA;AJ61jCF;;AI31jCA;EACE,gBAAA;AJ81jCF;;AI51jCA;EACE,gBAAA;AJ+1jCF;;AI71jCA;EACE,gBAAA;AJg2jCF;;AI91jCA;EACE,gBAAA;AJi2jCF;;AI/1jCA;EACE,gBAAA;AJk2jCF;;AIh2jCA;EACE,gBAAA;AJm2jCF;;AIj2jCA;EACE,gBAAA;AJo2jCF;;AIl2jCA;EACE,gBAAA;AJq2jCF;;AIn2jCA;EACE,gBAAA;AJs2jCF;;AIp2jCA;EACE,gBAAA;AJu2jCF;;AIr2jCA;EACE,gBAAA;AJw2jCF;;AIt2jCA;EACE,gBAAA;AJy2jCF;;AIv2jCA;EACE,gBAAA;AJ02jCF;;AIx2jCA;EACE,gBAAA;AJ22jCF;;AIz2jCA;EACE,gBAAA;AJ42jCF;;AI12jCA;EACE,gBAAA;AJ62jCF;;AI32jCA;EACE,gBAAA;AJ82jCF;;AI52jCA;EACE,gBAAA;AJ+2jCF;;AI72jCA;EACE,gBAAA;AJg3jCF;;AI92jCA;EACE,gBAAA;AJi3jCF;;AI/2jCA;EACE,gBAAA;AJk3jCF;;AIh3jCA;EACE,gBAAA;AJm3jCF;;AIj3jCA;EACE,gBAAA;AJo3jCF;;AIl3jCA;EACE,gBAAA;AJq3jCF;;AIn3jCA;EACE,gBAAA;AJs3jCF;;AIp3jCA;EACE,gBAAA;AJu3jCF;;AIr3jCA;EACE,gBAAA;AJw3jCF;;AIt3jCA;EACE,gBAAA;AJy3jCF;;AIv3jCA;EACE,gBAAA;AJ03jCF;;AIx3jCA;EACE,gBAAA;AJ23jCF;;AIz3jCA;EACE,gBAAA;AJ43jCF;;AI13jCA;EACE,gBAAA;AJ63jCF;;AI33jCA;EACE,gBAAA;AJ83jCF;;AI53jCA;EACE,gBAAA;AJ+3jCF;;AI73jCA;EACE,gBAAA;AJg4jCF;;AI93jCA;EACE,gBAAA;AJi4jCF;;AI/3jCA;EACE,gBAAA;AJk4jCF;;AIh4jCA;EACE,gBAAA;AJm4jCF;;AIj4jCA;EACE,gBAAA;AJo4jCF;;AIl4jCA;EACE,gBAAA;AJq4jCF;;AIn4jCA;EACE,gBAAA;AJs4jCF;;AIp4jCA;EACE,gBAAA;AJu4jCF;;AIr4jCA;EACE,gBAAA;AJw4jCF;;AIt4jCA;EACE,gBAAA;AJy4jCF;;AIv4jCA;EACE,gBAAA;AJ04jCF;;AIx4jCA;EACE,gBAAA;AJ24jCF;;AIz4jCA;EACE,gBAAA;AJ44jCF;;AI14jCA;EACE,gBAAA;AJ64jCF;;AI34jCA;EACE,gBAAA;AJ84jCF;;AI54jCA;EACE,gBAAA;AJ+4jCF;;AI74jCA;EACE,gBAAA;AJg5jCF;;AI94jCA;EACE,gBAAA;AJi5jCF;;AI/4jCA;EACE,gBAAA;AJk5jCF;;AIh5jCA;EACE,gBAAA;AJm5jCF;;AIj5jCA;EACE,gBAAA;AJo5jCF;;AIl5jCA;EACE,gBAAA;AJq5jCF;;AIn5jCA;EACE,gBAAA;AJs5jCF;;AIp5jCA;EACE,gBAAA;AJu5jCF;;AIr5jCA;EACE,gBAAA;AJw5jCF;;AIt5jCA;EACE,gBAAA;AJy5jCF;;AIv5jCA;EACE,gBAAA;AJ05jCF;;AIx5jCA;EACE,gBAAA;AJ25jCF;;AIz5jCA;EACE,gBAAA;AJ45jCF;;AI15jCA;EACE,gBAAA;AJ65jCF;;AI35jCA;EACE,gBAAA;AJ85jCF;;AI55jCA;EACE,gBAAA;AJ+5jCF;;AI75jCA;EACE,gBAAA;AJg6jCF;;AI95jCA;EACE,gBAAA;AJi6jCF;;AI/5jCA;EACE,gBAAA;AJk6jCF;;AIh6jCA;EACE,gBAAA;AJm6jCF;;AIj6jCA;EACE,gBAAA;AJo6jCF;;AIl6jCA;EACE,gBAAA;AJq6jCF;;AIn6jCA;EACE,gBAAA;AJs6jCF;;AIp6jCA;EACE,gBAAA;AJu6jCF;;AIr6jCA;EACE,gBAAA;AJw6jCF;;AIt6jCA;EACE,gBAAA;AJy6jCF;;AIv6jCA;EACE,gBAAA;AJ06jCF;;AIx6jCA;EACE,gBAAA;AJ26jCF;;AIz6jCA;EACE,gBAAA;AJ46jCF;;AI16jCA;EACE,gBAAA;AJ66jCF;;AI36jCA;EACE,gBAAA;AJ86jCF;;AI56jCA;EACE,gBAAA;AJ+6jCF;;AI76jCA;EACE,gBAAA;AJg7jCF;;AI96jCA;EACE,gBAAA;AJi7jCF;;AI/6jCA;EACE,gBAAA;AJk7jCF;;AIh7jCA;EACE,gBAAA;AJm7jCF;;AIj7jCA;EACE,gBAAA;AJo7jCF;;AIl7jCA;EACE,gBAAA;AJq7jCF;;AIn7jCA;EACE,gBAAA;AJs7jCF;;AIp7jCA;EACE,gBAAA;AJu7jCF;;AIr7jCA;EACE,gBAAA;AJw7jCF;;AIt7jCA;EACE,gBAAA;AJy7jCF;;AIv7jCA;EACE,gBAAA;AJ07jCF;;AIx7jCA;EACE,gBAAA;AJ27jCF;;AIz7jCA;EACE,gBAAA;AJ47jCF;;AI17jCA;EACE,gBAAA;AJ67jCF;;AI37jCA;EACE,gBAAA;AJ87jCF;;AI57jCA;EACE,gBAAA;AJ+7jCF;;AI77jCA;EACE,gBAAA;AJg8jCF;;AI97jCA;EACE,gBAAA;AJi8jCF;;AI/7jCA;EACE,gBAAA;AJk8jCF;;AIh8jCA;EACE,gBAAA;AJm8jCF;;AIj8jCA;EACE,gBAAA;AJo8jCF;;AIl8jCA;EACE,gBAAA;AJq8jCF;;AIn8jCA;EACE,gBAAA;AJs8jCF;;AIp8jCA;EACE,gBAAA;AJu8jCF;;AIr8jCA;EACE,gBAAA;AJw8jCF;;AIt8jCA;EACE,gBAAA;AJy8jCF;;AIv8jCA;EACE,gBAAA;AJ08jCF;;AIx8jCA;EACE,gBAAA;AJ28jCF;;AIz8jCA;EACE,gBAAA;AJ48jCF;;AI18jCA;EACE,gBAAA;AJ68jCF;;AI38jCA;EACE,gBAAA;AJ88jCF;;AI58jCA;EACE,gBAAA;AJ+8jCF;;AI78jCA;EACE,gBAAA;AJg9jCF;;AI98jCA;EACE,gBAAA;AJi9jCF;;AI/8jCA;EACE,gBAAA;AJk9jCF;;AIh9jCA;EACE,gBAAA;AJm9jCF;;AIj9jCA;EACE,gBAAA;AJo9jCF;;AIl9jCA;EACE,gBAAA;AJq9jCF;;AIn9jCA;EACE,gBAAA;AJs9jCF;;AIp9jCA;EACE,gBAAA;AJu9jCF;;AIr9jCA;EACE,gBAAA;AJw9jCF;;AIt9jCA;EACE,gBAAA;AJy9jCF;;AIv9jCA;EACE,gBAAA;AJ09jCF;;AIx9jCA;EACE,gBAAA;AJ29jCF;;AIz9jCA;EACE,gBAAA;AJ49jCF;;AI19jCA;EACE,gBAAA;AJ69jCF;;AI39jCA;EACE,gBAAA;AJ89jCF;;AI59jCA;EACE,gBAAA;AJ+9jCF;;AI79jCA;EACE,gBAAA;AJg+jCF;;AI99jCA;EACE,gBAAA;AJi+jCF;;AI/9jCA;EACE,gBAAA;AJk+jCF;;AIh+jCA;EACE,gBAAA;AJm+jCF;;AIj+jCA;EACE,gBAAA;AJo+jCF;;AIl+jCA;EACE,gBAAA;AJq+jCF;;AIn+jCA;EACE,gBAAA;AJs+jCF;;AIp+jCA;EACE,gBAAA;AJu+jCF;;AIr+jCA;EACE,gBAAA;AJw+jCF;;AIt+jCA;EACE,gBAAA;AJy+jCF;;AIv+jCA;EACE,gBAAA;AJ0+jCF;;AIx+jCA;EACE,gBAAA;AJ2+jCF;;AIz+jCA;EACE,gBAAA;AJ4+jCF;;AI1+jCA;EACE,gBAAA;AJ6+jCF;;AI3+jCA;EACE,gBAAA;AJ8+jCF;;AI5+jCA;EACE,gBAAA;AJ++jCF;;AI7+jCA;EACE,gBAAA;AJg/jCF;;AI9+jCA;EACE,gBAAA;AJi/jCF;;AI/+jCA;EACE,gBAAA;AJk/jCF;;AIh/jCA;EACE,gBAAA;AJm/jCF;;AIj/jCA;EACE,gBAAA;AJo/jCF;;AIl/jCA;EACE,gBAAA;AJq/jCF;;AIn/jCA;EACE,gBAAA;AJs/jCF;;AIp/jCA;EACE,gBAAA;AJu/jCF;;AIr/jCA;EACE,gBAAA;AJw/jCF;;AIt/jCA;EACE,gBAAA;AJy/jCF;;AIv/jCA;EACE,gBAAA;AJ0/jCF;;AIx/jCA;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AJ2/jCF;;AIz/jCA;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AJ4/jCF;;AI3/jCA;EACE,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJ8/jCF;AI5/jCA;EACE,kCAAA;AJ8/jCF;;AI7/jCA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJggkCF;AI9/jCA;EACE,gCAAA;EACA,gBAAA;AJggkCF;;AI//jCA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJkgkCF;AIhgkCA;;EAEE,gCAAA;EACA,gBAAA;AJkgkCF;;AIhgkCA;EACE,gBAAA;AJmgkCF;;AIjgkCA;EACE,kCAAA;EACA,gBAAA;AJogkCF;;AIlgkCA;EACE,gCAAA;EACA,gBAAA;AJqgkCF;;AIngkCA;EACE,gBAAA;AJsgkCF;;AIpgkCA;EACE,gBAAA;AJugkCF;;AIrgkCA;EACE,gBAAA;AJwgkCF;;AItgkCA;EACE,gBAAA;AJygkCF;;AIvgkCA;EACE,gCAAA;EACA,gBAAA;AJ0gkCF;;AIxgkCA;EACE,gBAAA;AJ2gkCF;;AIzgkCA;EACE,gCAAA;EACA,gBAAA;AJ4gkCF;;AI1gkCA;EACE,gBAAA;AJ6gkCF;;AI3gkCA;EACE,gCAAA;EACA,gBAAA;AJ8gkCF;;AI5gkCA;EACE,gBAAA;AJ+gkCF;;AI7gkCA;EACE,gCAAA;EACA,gBAAA;AJghkCF;;AI9gkCA;EACE,gBAAA;AJihkCF;;AI/gkCA;EACE,gCAAA;EACA,gBAAA;AJkhkCF;;AIhhkCA;EACE,gBAAA;AJmhkCF;;AIjhkCA;EACE,gCAAA;EACA,gBAAA;AJohkCF;;AIlhkCA;EACE,gBAAA;AJqhkCF;;AInhkCA;EACE,gBAAA;AJshkCF;;AIphkCA;EACE,gBAAA;AJuhkCF;;AIrhkCA;EACE,gBAAA;AJwhkCF;;AIthkCA;EACE,gCAAA;EACA,gBAAA;AJyhkCF;;AIvhkCA;EACE,gBAAA;AJ0hkCF;;AIxhkCA;EACE,gBAAA;AJ2hkCF;;AIzhkCA;EACE,gCAAA;EACA,gBAAA;AJ4hkCF;;AI1hkCA;EACE,gBAAA;AJ6hkCF;;AI3hkCA;EACE,gCAAA;EACA,gBAAA;AJ8hkCF;;AI5hkCA;EACE,gBAAA;AJ+hkCF;;AI7hkCA;EACE,gCAAA;EACA,gBAAA;AJgikCF;;AI9hkCA;EACE,gBAAA;AJiikCF;;AI/hkCA;EACE,gBAAA;AJkikCF;;AIhikCA;EACE,gBAAA;AJmikCF;;AIjikCA;EACE,gCAAA;EACA,gBAAA;AJoikCF;;AIlikCA;EACE,gBAAA;AJqikCF;;AInikCA;EACE,gCAAA;EACA,gBAAA;AJsikCF;;AIpikCA;EACE,gBAAA;AJuikCF;;AIrikCA;EACE,gCAAA;EACA,gBAAA;AJwikCF;;AItikCA;EACE,gBAAA;AJyikCF;;AIvikCA;EACE,gBAAA;AJ0ikCF;;AIxikCA;EACE,gCAAA;EACA,gBAAA;AJ2ikCF;;AIzikCA;EACE,gBAAA;AJ4ikCF;;AI1ikCA;EACE,gCAAA;EACA,gBAAA;AJ6ikCF;;AI3ikCA;EACE,gBAAA;AJ8ikCF;;AI5ikCA;EACE,gBAAA;AJ+ikCF;;AI7ikCA;EACE,gCAAA;EACA,gBAAA;AJgjkCF;;AI9ikCA;EACE,gCAAA;EACA,gBAAA;AJijkCF;;AI/ikCA;EACE,gBAAA;AJkjkCF;;AIhjkCA;EACE,gBAAA;AJmjkCF;;AIjjkCA;EACE,gBAAA;AJojkCF;;AIljkCA;EACE,gBAAA;AJqjkCF;;AInjkCA;EACE,gCAAA;EACA,gBAAA;AJsjkCF;;AIpjkCA;EACE,gBAAA;AJujkCF;;AIrjkCA;EACE,gCAAA;EACA,gBAAA;AJwjkCF;;AItjkCA;EACE,gBAAA;AJyjkCF;;AIvjkCA;EACE,kCAAA;EACA,gBAAA;AJ0jkCF;;AIxjkCA;EACE,kCAAA;EACA,gBAAA;AJ2jkCF;;AIzjkCA;EACE,gBAAA;AJ4jkCF;;AI1jkCA;EACE,gCAAA;EACA,gBAAA;AJ6jkCF;;AI3jkCA;EACE,gBAAA;AJ8jkCF;;AI5jkCA;EACE,gCAAA;EACA,gBAAA;AJ+jkCF;;AI7jkCA;EACE,gBAAA;AJgkkCF;;AI9jkCA;EACE,gCAAA;EACA,gBAAA;AJikkCF;;AI/jkCA;EACE,gBAAA;AJkkkCF;;AIhkkCA;EACE,gBAAA;AJmkkCF;;AIjkkCA;EACE,kCAAA;EACA,gBAAA;AJokkCF;;AIlkkCA;EACE,gBAAA;AJqkkCF;;AInkkCA;EACE,gBAAA;AJskkCF;;AIpkkCA;EACE,gBAAA;AJukkCF;;AIrkkCA;EACE,gBAAA;AJwkkCF;;AItkkCA;EACE,kCAAA;EACA,gBAAA;AJykkCF;;AIvkkCA;EACE,gCAAA;EACA,gBAAA;AJ0kkCF;;AIxkkCA;EACE,gBAAA;AJ2kkCF;;AIzkkCA;EACE,gCAAA;EACA,gBAAA;AJ4kkCF;;AI1kkCA;EACE,gBAAA;AJ6kkCF;;AI3kkCA;EACE,gCAAA;EACA,gBAAA;AJ8kkCF;;AI5kkCA;EACE,gBAAA;AJ+kkCF;;AI7kkCA;EACE,kCAAA;EACA,gBAAA;AJglkCF;;AI9kkCA;EACE,kCAAA;EACA,gBAAA;AJilkCF;;AI/kkCA;EACE,gBAAA;AJklkCF;;AIhlkCA;EACE,kCAAA;EACA,gBAAA;AJmlkCF;;AIjlkCA;EACE,gBAAA;AJolkCF;;AIllkCA;EACE,kCAAA;EACA,gBAAA;AJqlkCF;;AInlkCA;EACE,gCAAA;EACA,gBAAA;AJslkCF;;AIplkCA;EACE,gBAAA;AJulkCF;;AIrlkCA;EACE,gCAAA;EACA,gBAAA;AJwlkCF;;AItlkCA;EACE,gBAAA;AJylkCF;;AIvlkCA;EACE,gCAAA;EACA,gBAAA;AJ0lkCF;;AIxlkCA;EACE,gBAAA;AJ2lkCF;;AIzlkCA;EACE,gCAAA;EACA,gBAAA;AJ4lkCF;;AI1lkCA;EACE,gBAAA;AJ6lkCF;;AI3lkCA;EACE,gCAAA;EACA,gBAAA;AJ8lkCF;;AI5lkCA;EACE,gBAAA;AJ+lkCF;;AI7lkCA;EACE,gCAAA;EACA,gBAAA;AJgmkCF;;AI9lkCA;EACE,gBAAA;AJimkCF;;AI/lkCA;EACE,gBAAA;AJkmkCF;;AIhmkCA;EACE,gBAAA;AJmmkCF;;AIjmkCA;EACE,gBAAA;AJomkCF;;AIlmkCA;EACE,gBAAA;AJqmkCF;;AInmkCA;EACE,gCAAA;EACA,gBAAA;AJsmkCF;;AIpmkCA;EACE,gBAAA;AJumkCF;;AIrmkCA;EACE,gCAAA;EACA,gBAAA;AJwmkCF;;AItmkCA;EACE,gBAAA;AJymkCF;;AIvmkCA;EACE,gBAAA;AJ0mkCF;;AIxmkCA;EACE,gBAAA;AJ2mkCF;;AIzmkCA;EACE,kCAAA;EACA,gBAAA;AJ4mkCF;;AI1mkCA;EACE,kCAAA;EACA,gBAAA;AJ6mkCF;;AI3mkCA;EACE,kCAAA;EACA,gBAAA;AJ8mkCF;;AI5mkCA;EACE,kCAAA;EACA,gBAAA;AJ+mkCF;;AI7mkCA;EACE,gBAAA;AJgnkCF;;AI9mkCA;EACE,gCAAA;EACA,gBAAA;AJinkCF;;AI/mkCA;EACE,gBAAA;AJknkCF;;AIhnkCA;EACE,gBAAA;AJmnkCF;;AIjnkCA;EACE,gBAAA;AJonkCF;;AIlnkCA;EACE,gBAAA;AJqnkCF;;AInnkCA;EACE,kCAAA;EACA,gBAAA;AJsnkCF;;AIpnkCA;EACE,gBAAA;AJunkCF;;AIrnkCA;EACE,gBAAA;AJwnkCF;;AItnkCA;EACE,gBAAA;AJynkCF;;AIvnkCA;EACE,gBAAA;AJ0nkCF;;AIxnkCA;EACE,gBAAA;AJ2nkCF;;AIznkCA;EACE,gCAAA;EACA,gBAAA;AJ4nkCF;;AI1nkCA;EACE,gBAAA;AJ6nkCF;;AI3nkCA;EACE,gCAAA;EACA,gBAAA;AJ8nkCF;;AI5nkCA;EACE,gBAAA;AJ+nkCF;;AI7nkCA;EACE,gBAAA;AJgokCF;;AI9nkCA;EACE,gCAAA;EACA,gBAAA;AJiokCF;;AI/nkCA;EACE,gCAAA;EACA,gBAAA;AJkokCF;;AIhokCA;EACE,gBAAA;AJmokCF;;AIjokCA;EACE,gCAAA;EACA,gBAAA;AJookCF;;AIlokCA;EACE,gBAAA;AJqokCF;;AInokCA;EACE,gBAAA;AJsokCF;;AIpokCA;EACE,gBAAA;AJuokCF;;AIrokCA;EACE,gBAAA;AJwokCF;;AItokCA;EACE,gCAAA;EACA,gBAAA;AJyokCF;;AIvokCA;EACE,gBAAA;AJ0okCF;;AIxokCA;EACE,gBAAA;AJ2okCF;;AIzokCA;EACE,gCAAA;EACA,gBAAA;AJ4okCF;;AI1okCA;EACE,gBAAA;AJ6okCF;;AI3okCA;EACE,gCAAA;EACA,gBAAA;AJ8okCF;;AI5okCA;EACE,gBAAA;AJ+okCF;;AI7okCA;EACE,gCAAA;EACA,gBAAA;AJgpkCF;;AI9okCA;EACE,gBAAA;AJipkCF;;AI/okCA;EACE,gBAAA;AJkpkCF;;AIhpkCA;EACE,gBAAA;AJmpkCF;;AIjpkCA;EACE,gBAAA;AJopkCF;;AIlpkCA;EACE,gCAAA;EACA,gBAAA;AJqpkCF;;AInpkCA;EACE,gBAAA;AJspkCF;;AIppkCA;EACE,gBAAA;AJupkCF;;AIrpkCA;EACE,kCAAA;EACA,gBAAA;AJwpkCF;;AItpkCA;EACE,gCAAA;EACA,gBAAA;AJypkCF;;AIvpkCA;EACE,gBAAA;AJ0pkCF;;AIxpkCA;EACE,gCAAA;EACA,gBAAA;AJ2pkCF;;AIzpkCA;EACE,gBAAA;AJ4pkCF;;AI1pkCA;EACE,gCAAA;EACA,gBAAA;AJ6pkCF;;AI3pkCA;EACE,gBAAA;AJ8pkCF;;AI5pkCA;EACE,gCAAA;EACA,gBAAA;AJ+pkCF;;AI7pkCA;EACE,gBAAA;AJgqkCF;;AI9pkCA;EACE,gCAAA;EACA,gBAAA;AJiqkCF;;AI/pkCA;EACE,gBAAA;AJkqkCF;;AIhqkCA;EACE,gCAAA;EACA,gBAAA;AJmqkCF;;AIjqkCA;EACE,gBAAA;AJoqkCF;;AIlqkCA;EACE,gCAAA;EACA,gBAAA;AJqqkCF;;AInqkCA;EACE,gBAAA;AJsqkCF;;AIpqkCA;EACE,gBAAA;AJuqkCF;;AIrqkCA;EACE,gCAAA;EACA,gBAAA;AJwqkCF;;AItqkCA;EACE,gBAAA;AJyqkCF;;AIvqkCA;EACE,gCAAA;EACA,gBAAA;AJ0qkCF;;AIxqkCA;EACE,gBAAA;AJ2qkCF;;AIzqkCA;EACE,gCAAA;EACA,gBAAA;AJ4qkCF;;AI1qkCA;EACE,gBAAA;AJ6qkCF;;AI3qkCA;EACE,gBAAA;AJ8qkCF;;AI5qkCA;EACE,gBAAA;AJ+qkCF;;AI7qkCA;EACE,gBAAA;AJgrkCF;;AI9qkCA;EACE,gCAAA;EACA,gBAAA;AJirkCF;;AI/qkCA;EACE,gBAAA;AJkrkCF;;AIhrkCA;EACE,kCAAA;EACA,gBAAA;AJmrkCF;;AIjrkCA;EACE,kCAAA;EACA,gBAAA;AJorkCF;;AIlrkCA;EACE,kCAAA;EACA,gBAAA;AJqrkCF;;AInrkCA;EACE,gBAAA;AJsrkCF;;AIprkCA;EACE,gCAAA;EACA,gBAAA;AJurkCF;;AIrrkCA;EACE,gBAAA;AJwrkCF;;AItrkCA;EACE,gBAAA;AJyrkCF;;AIvrkCA;EACE,gBAAA;AJ0rkCF;;AIxrkCA;EACE,gBAAA;AJ2rkCF;;AIzrkCA;EACE,gBAAA;AJ4rkCF;;AI1rkCA;EACE,gCAAA;EACA,gBAAA;AJ6rkCF;;AI3rkCA;EACE,gCAAA;EACA,gBAAA;AJ8rkCF;;AI5rkCA;EACE,gBAAA;AJ+rkCF;;AI7rkCA;EACE,gCAAA;EACA,gBAAA;AJgskCF;;AI9rkCA;EACE,gBAAA;AJiskCF;;AI/rkCA;EACE,gCAAA;EACA,gBAAA;AJkskCF;;AIhskCA;EACE,gBAAA;AJmskCF;;AIjskCA;EACE,gCAAA;EACA,gBAAA;AJoskCF;;AIlskCA;EACE,gBAAA;AJqskCF;;AInskCA;EACE,gCAAA;EACA,gBAAA;AJsskCF;;AIpskCA;EACE,gBAAA;AJuskCF;;AIrskCA;EACE,gCAAA;EACA,gBAAA;AJwskCF;;AItskCA;EACE,gBAAA;AJyskCF;;AIvskCA;EACE,gBAAA;AJ0skCF;;AIxskCA;EACE,gBAAA;AJ2skCF;;AIzskCA;EACE,gBAAA;AJ4skCF;;AI1skCA;EACE,gBAAA;AJ6skCF;;AI3skCA;EACE,gBAAA;AJ8skCF;;AI5skCA;EACE,gBAAA;AJ+skCF;;AI7skCA;EACE,gBAAA;AJgtkCF;;AI9skCA;EACE,gBAAA;AJitkCF;;AI/skCA;EACE,gBAAA;AJktkCF;;AIhtkCA;EACE,gBAAA;AJmtkCF;;AIjtkCA;EACE,gBAAA;AJotkCF;;AIltkCA;EACE,gBAAA;AJqtkCF;;AIntkCA;EACE,gBAAA;AJstkCF;;AIptkCA;EACE,gBAAA;AJutkCF;;AIrtkCA;EACE,gBAAA;AJwtkCF;;AIttkCA;EACE,gBAAA;AJytkCF;;AIvtkCA;EACE,kCAAA;EACA,gBAAA;AJ0tkCF;;AIxtkCA;EACE,kCAAA;EACA,gBAAA;AJ2tkCF;;AIztkCA;EACE,gBAAA;AJ4tkCF;;AI1tkCA;EACE,gBAAA;AJ6tkCF;;AI3tkCA;EACE,gBAAA;AJ8tkCF;;AI5tkCA;EACE,gBAAA;AJ+tkCF;;AI7tkCA;EACE,gBAAA;AJgukCF;;AI9tkCA;EACE,gBAAA;AJiukCF;;AI/tkCA;EACE,gBAAA;AJkukCF;;AIhukCA;EACE,gBAAA;AJmukCF;;AIjukCA;EACE,kCAAA;EACA,gBAAA;AJoukCF;;AIlukCA;EACE,kCAAA;EACA,gBAAA;AJqukCF;;AInukCA;EACE,kCAAA;EACA,gBAAA;AJsukCF;;AIpukCA;EACE,kCAAA;EACA,gBAAA;AJuukCF;;AIrukCA;EACE,kCAAA;EACA,gBAAA;AJwukCF;;AItukCA;EACE,gBAAA;AJyukCF;;AIvukCA;EACE,kCAAA;EACA,gBAAA;AJ0ukCF;;AIxukCA;EACE,kCAAA;EACA,gBAAA;AJ2ukCF;;AIzukCA;EACE,kCAAA;EACA,gBAAA;AJ4ukCF;;AI1ukCA;EACE,kCAAA;EACA,gBAAA;AJ6ukCF;;AI3ukCA;EACE,kCAAA;EACA,gBAAA;AJ8ukCF;;AI5ukCA;EACE,kCAAA;EACA,gBAAA;AJ+ukCF;;AI7ukCA;EACE,kCAAA;EACA,gBAAA;AJgvkCF;;AI9ukCA;EACE,gBAAA;AJivkCF;;AI/ukCA;EACE,kCAAA;EACA,gBAAA;AJkvkCF;;AIhvkCA;EACE,kCAAA;EACA,gBAAA;AJmvkCF;;AIjvkCA;EACE,gBAAA;AJovkCF;;AIlvkCA;EACE,gBAAA;AJqvkCF;;AInvkCA;EACE,gBAAA;AJsvkCF;;AIpvkCA;EACE,gBAAA;AJuvkCF;;AIrvkCA;EACE,kCAAA;EACA,gBAAA;AJwvkCF;;AItvkCA;EACE,kCAAA;EACA,gBAAA;AJyvkCF;;AIvvkCA;EACE,kCAAA;EACA,gBAAA;AJ0vkCF;;AIxvkCA;EACE,kCAAA;EACA,gBAAA;AJ2vkCF;;AIzvkCA;EACE,kCAAA;EACA,gBAAA;AJ4vkCF;;AI1vkCA;EACE,kCAAA;EACA,gBAAA;AJ6vkCF;;AI3vkCA;EACE,kCAAA;EACA,gBAAA;AJ8vkCF;;AI5vkCA;EACE,kCAAA;EACA,gBAAA;AJ+vkCF;;AI7vkCA;EACE,kCAAA;EACA,gBAAA;AJgwkCF;;AI9vkCA;EACE,kCAAA;EACA,gBAAA;AJiwkCF;;AI/vkCA;EACE,gBAAA;AJkwkCF;;AIhwkCA;EACE,gCAAA;EACA,gBAAA;AJmwkCF;;AIjwkCA;EACE,gBAAA;AJowkCF;;AIlwkCA;EACE,gCAAA;EACA,gBAAA;AJqwkCF;;AInwkCA;EACE,gBAAA;AJswkCF;;AIpwkCA;EACE,kCAAA;EACA,gBAAA;AJuwkCF;;AIrwkCA;EACE,kCAAA;EACA,gBAAA;AJwwkCF;;AItwkCA;EACE,kCAAA;EACA,gBAAA;AJywkCF;;AIvwkCA;EACE,kCAAA;EACA,gBAAA;AJ0wkCF;;AIxwkCA;EACE,kCAAA;EACA,gBAAA;AJ2wkCF;;AIzwkCA;EACE,gCAAA;EACA,gBAAA;AJ4wkCF;;AI1wkCA;EACE,gBAAA;AJ6wkCF;;AI3wkCA;EACE,gCAAA;EACA,gBAAA;AJ8wkCF;;AI5wkCA;EACE,gBAAA;AJ+wkCF;;AI7wkCA;EACE,gCAAA;EACA,gBAAA;AJgxkCF;;AI9wkCA;EACE,gBAAA;AJixkCF;;AI/wkCA;EACE,gCAAA;EACA,gBAAA;AJkxkCF;;AIhxkCA;EACE,gBAAA;AJmxkCF;;AIjxkCA;EACE,gCAAA;EACA,gBAAA;AJoxkCF;;AIlxkCA;EACE,gBAAA;AJqxkCF;;AInxkCA;EACE,kCAAA;EACA,gBAAA;AJsxkCF;;AIpxkCA;EACE,gBAAA;AJuxkCF;;AIrxkCA;EACE,gBAAA;AJwxkCF;;AItxkCA;EACE,gCAAA;EACA,gBAAA;AJyxkCF;;AIvxkCA;EACE,gBAAA;AJ0xkCF;;AIxxkCA;EACE,kCAAA;EACA,gBAAA;AJ2xkCF;;AIzxkCA;EACE,kCAAA;EACA,gBAAA;AJ4xkCF;;AI1xkCA;EACE,kCAAA;EACA,gBAAA;AJ6xkCF;;AI3xkCA;EACE,gBAAA;AJ8xkCF;;AI5xkCA;EACE,gBAAA;AJ+xkCF;;AI7xkCA;EACE,gBAAA;AJgykCF;;AI9xkCA;EACE,kCAAA;EACA,gBAAA;AJiykCF;;AI/xkCA;EACE,kCAAA;EACA,gBAAA;AJkykCF;;AIhykCA;EACE,kCAAA;EACA,gBAAA;AJmykCF;;AIjykCA;EACE,kCAAA;EACA,gBAAA;AJoykCF;;AIlykCA;EACE,kCAAA;EACA,gBAAA;AJqykCF;;AInykCA;EACE,kCAAA;EACA,gBAAA;AJsykCF;;AIpykCA;EACE,kCAAA;EACA,gBAAA;AJuykCF;;AIrykCA;EACE,kCAAA;EACA,gBAAA;AJwykCF;;AItykCA;EACE,kCAAA;EACA,gBAAA;AJyykCF;;AIvykCA;EACE,kCAAA;EACA,gBAAA;AJ0ykCF;;AIxykCA;EACE,kCAAA;EACA,gBAAA;AJ2ykCF;;AIzykCA;EACE,kCAAA;EACA,gBAAA;AJ4ykCF;;AI1ykCA;EACE,gBAAA;AJ6ykCF;;AI3ykCA;EACE,kCAAA;EACA,gBAAA;AJ8ykCF;;AI5ykCA;EACE,kCAAA;EACA,gBAAA;AJ+ykCF;;AI7ykCA;EACE,kCAAA;EACA,gBAAA;AJgzkCF;;AI9ykCA;EACE,kCAAA;EACA,gBAAA;AJizkCF;;AI/ykCA;EACE,gBAAA;AJkzkCF;;AIhzkCA;EACE,gBAAA;AJmzkCF;;AIjzkCA;EACE,gCAAA;EACA,gBAAA;AJozkCF;;AIlzkCA;EACE,gBAAA;AJqzkCF;;AInzkCA;EACE,kCAAA;EACA,gBAAA;AJszkCF;;AIpzkCA;EACE,kCAAA;EACA,gBAAA;AJuzkCF;;AIrzkCA;EACE,gCAAA;EACA,gBAAA;AJwzkCF;;AItzkCA;EACE,gBAAA;AJyzkCF;;AIvzkCA;EACE,gCAAA;EACA,gBAAA;AJ0zkCF;;AIxzkCA;EACE,gBAAA;AJ2zkCF;;AIzzkCA;EACE,gCAAA;EACA,gBAAA;AJ4zkCF;;AI1zkCA;EACE,gBAAA;AJ6zkCF;;AI3zkCA;EACE,gCAAA;EACA,gBAAA;AJ8zkCF;;AI5zkCA;EACE,gBAAA;AJ+zkCF;;AI7zkCA;EACE,gCAAA;EACA,gBAAA;AJg0kCF;;AI9zkCA;EACE,gBAAA;AJi0kCF;;AI/zkCA;EACE,gCAAA;EACA,gBAAA;AJk0kCF;;AIh0kCA;EACE,gBAAA;AJm0kCF;;AIj0kCA;EACE,gCAAA;EACA,gBAAA;AJo0kCF;;AIl0kCA;EACE,gBAAA;AJq0kCF;;AIn0kCA;EACE,gCAAA;EACA,gBAAA;AJs0kCF;;AIp0kCA;EACE,gBAAA;AJu0kCF;;AIr0kCA;EACE,gCAAA;EACA,gBAAA;AJw0kCF;;AIt0kCA;EACE,gBAAA;AJy0kCF;;AIv0kCA;EACE,gCAAA;EACA,gBAAA;AJ00kCF;;AIx0kCA;EACE,gBAAA;AJ20kCF;;AIz0kCA;EACE,gCAAA;EACA,gBAAA;AJ40kCF;;AI10kCA;EACE,gBAAA;AJ60kCF;;AI30kCA;EACE,gCAAA;EACA,gBAAA;AJ80kCF;;AI50kCA;EACE,gBAAA;AJ+0kCF;;AI70kCA;EACE,gCAAA;EACA,gBAAA;AJg1kCF;;AI90kCA;EACE,gBAAA;AJi1kCF;;AI/0kCA;EACE,gCAAA;EACA,gBAAA;AJk1kCF;;AIh1kCA;EACE,gBAAA;AJm1kCF;;AIj1kCA;EACE,kCAAA;EACA,gBAAA;AJo1kCF;;AIl1kCA;EACE,kCAAA;EACA,gBAAA;AJq1kCF;;AIn1kCA;EACE,kCAAA;EACA,gBAAA;AJs1kCF;;AIp1kCA;EACE,gCAAA;EACA,gBAAA;AJu1kCF;;AIr1kCA;EACE,gCAAA;EACA,gBAAA;AJw1kCF;;AIt1kCA;EACE,gBAAA;AJy1kCF;;AIv1kCA;EACE,gCAAA;EACA,gBAAA;AJ01kCF;;AIx1kCA;EACE,gBAAA;AJ21kCF;;AIz1kCA;EACE,gCAAA;EACA,gBAAA;AJ41kCF;;AI11kCA;EACE,gBAAA;AJ61kCF;;AI31kCA;EACE,gCAAA;EACA,gBAAA;AJ81kCF;;AI51kCA;EACE,gBAAA;AJ+1kCF;;AI71kCA;EACE,gBAAA;AJg2kCF;;AI91kCA;EACE,kCAAA;EACA,gBAAA;AJi2kCF;;AI/1kCA;EACE,kCAAA;EACA,gBAAA;AJk2kCF;;AIh2kCA;EACE,gBAAA;AJm2kCF;;AIj2kCA;EACE,kCAAA;EACA,gBAAA;AJo2kCF;;AIl2kCA;EACE,gBAAA;AJq2kCF;;AIn2kCA;EACE,kCAAA;EACA,gBAAA;AJs2kCF;;AIp2kCA;EACE,kCAAA;EACA,gBAAA;AJu2kCF;;AIr2kCA;EACE,gBAAA;AJw2kCF;;AIt2kCA;EACE,kCAAA;EACA,gBAAA;AJy2kCF;;AIv2kCA;EACE,kCAAA;EACA,gBAAA;AJ02kCF;;AIx2kCA;EACE,kCAAA;EACA,gBAAA;AJ22kCF;;AIz2kCA;EACE,kCAAA;EACA,gBAAA;AJ42kCF;;AI12kCA;EACE,gBAAA;AJ62kCF;;AI32kCA;EACE,kCAAA;EACA,gBAAA;AJ82kCF;;AI52kCA;EACE,gBAAA;AJ+2kCF;;AI72kCA;EACE,kCAAA;EACA,gBAAA;AJg3kCF;;AI92kCA;EACE,kCAAA;EACA,gBAAA;AJi3kCF;;AI/2kCA;EACE,kCAAA;EACA,gBAAA;AJk3kCF;;AIh3kCA;EACE,kCAAA;EACA,gBAAA;AJm3kCF;;AIj3kCA;EACE,gBAAA;AJo3kCF;;AIl3kCA;EACE,gBAAA;AJq3kCF;;AIn3kCA;EACE,gCAAA;EACA,gBAAA;AJs3kCF;;AIp3kCA;EACE,gBAAA;AJu3kCF;;AIr3kCA;EACE,gCAAA;EACA,gBAAA;AJw3kCF;;AIt3kCA;EACE,gBAAA;AJy3kCF;;AIv3kCA;EACE,gCAAA;EACA,gBAAA;AJ03kCF;;AIx3kCA;EACE,gBAAA;AJ23kCF;;AIz3kCA;EACE,gBAAA;AJ43kCF;;AI13kCA;EACE,gBAAA;AJ63kCF;;AI33kCA;EACE,gCAAA;EACA,gBAAA;AJ83kCF;;AI53kCA;EACE,gBAAA;AJ+3kCF;;AI73kCA;EACE,gCAAA;EACA,gBAAA;AJg4kCF;;AI93kCA;EACE,gBAAA;AJi4kCF;;AI/3kCA;EACE,kCAAA;EACA,gBAAA;AJk4kCF;;AIh4kCA;EACE,kCAAA;EACA,gBAAA;AJm4kCF;;AIj4kCA;EACE,kCAAA;EACA,gBAAA;AJo4kCF;;AIl4kCA;EACE,gCAAA;EACA,gBAAA;AJq4kCF;;AIn4kCA;EACE,gBAAA;AJs4kCF;;AIp4kCA;EACE,kCAAA;EACA,gBAAA;AJu4kCF;;AIr4kCA;EACE,kCAAA;EACA,gBAAA;AJw4kCF;;AIt4kCA;EACE,kCAAA;EACA,gBAAA;AJy4kCF;;AIv4kCA;EACE,kCAAA;EACA,gBAAA;AJ04kCF;;AIx4kCA;EACE,kCAAA;EACA,gBAAA;AJ24kCF;;AIz4kCA;EACE,kCAAA;EACA,gBAAA;AJ44kCF;;AI14kCA;EACE,kCAAA;EACA,gBAAA;AJ64kCF;;AI34kCA;EACE,kCAAA;EACA,gBAAA;AJ84kCF;;AI54kCA;EACE,gCAAA;EACA,gBAAA;AJ+4kCF;;AI74kCA;EACE,gBAAA;AJg5kCF;;AI94kCA;EACE,gBAAA;AJi5kCF;;AI/4kCA;EACE,gCAAA;EACA,gBAAA;AJk5kCF;;AIh5kCA;EACE,gBAAA;AJm5kCF;;AIj5kCA;EACE,gBAAA;AJo5kCF;;AIl5kCA;EACE,gBAAA;AJq5kCF;;AIn5kCA;EACE,gBAAA;AJs5kCF;;AIp5kCA;EACE,kCAAA;EACA,gBAAA;AJu5kCF;;AIr5kCA;EACE,kCAAA;EACA,gBAAA;AJw5kCF;;AIt5kCA;EACE,kCAAA;EACA,gBAAA;AJy5kCF;;AIv5kCA;EACE,kCAAA;EACA,gBAAA;AJ05kCF;;AIx5kCA;EACE,gCAAA;EACA,gBAAA;AJ25kCF;;AIz5kCA;EACE,gBAAA;AJ45kCF;;AI15kCA;EACE,gBAAA;AJ65kCF;;AI35kCA;EACE,gBAAA;AJ85kCF;;AI55kCA;EACE,gBAAA;AJ+5kCF;;AI75kCA;EACE,kCAAA;EACA,gBAAA;AJg6kCF;;AI95kCA;EACE,gBAAA;AJi6kCF;;AI/5kCA;EACE,kCAAA;EACA,gBAAA;AJk6kCF;;AIh6kCA;EACE,kCAAA;EACA,gBAAA;AJm6kCF;;AIj6kCA;EACE,kCAAA;EACA,gBAAA;AJo6kCF;;AIl6kCA;EACE,kCAAA;EACA,gBAAA;AJq6kCF;;AIn6kCA;EACE,kCAAA;EACA,gBAAA;AJs6kCF;;AIp6kCA;EACE,kCAAA;EACA,gBAAA;AJu6kCF;;AIr6kCA;EACE,kCAAA;EACA,gBAAA;AJw6kCF;;AIt6kCA;EACE,kCAAA;EACA,gBAAA;AJy6kCF;;AIv6kCA;EACE,kCAAA;EACA,gBAAA;AJ06kCF;;AIx6kCA;EACE,gCAAA;EACA,gBAAA;AJ26kCF;;AIz6kCA;EACE,gBAAA;AJ46kCF;;AI16kCA;EACE,gBAAA;AJ66kCF;;AI36kCA;EACE,kCAAA;EACA,gBAAA;AJ86kCF;;AI56kCA;EACE,gBAAA;AJ+6kCF;;AI76kCA;EACE,kCAAA;EACA,gBAAA;AJg7kCF;;AI96kCA;EACE,kCAAA;EACA,gBAAA;AJi7kCF;;AI/6kCA;EACE,gBAAA;AJk7kCF;;AIh7kCA;EACE,kCAAA;EACA,gBAAA;AJm7kCF;;AIj7kCA;EACE,kCAAA;EACA,gBAAA;AJo7kCF;;AIl7kCA;EACE,kCAAA;EACA,gBAAA;AJq7kCF;;AIn7kCA;EACE,kCAAA;EACA,gBAAA;AJs7kCF;;AIp7kCA;EACE,gBAAA;AJu7kCF;;AIr7kCA;EACE,kCAAA;EACA,gBAAA;AJw7kCF;;AIt7kCA;EACE,kCAAA;EACA,gBAAA;AJy7kCF;;AIv7kCA;EACE,kCAAA;EACA,gBAAA;AJ07kCF;;AIx7kCA;EACE,gBAAA;AJ27kCF;;AIz7kCA;EACE,gBAAA;AJ47kCF;;AI17kCA;EACE,gBAAA;AJ67kCF;;AI37kCA;EACE,gBAAA;AJ87kCF;;AI57kCA;EACE,gBAAA;AJ+7kCF;;AI77kCA;EACE,gBAAA;AJg8kCF;;AI97kCA;EACE,gCAAA;EACA,gBAAA;AJi8kCF;;AI/7kCA;EACE,gCAAA;EACA,gBAAA;AJk8kCF;;AIh8kCA;EACE,gCAAA;EACA,gBAAA;AJm8kCF;;AIj8kCA;EACE,gBAAA;AJo8kCF;;AIl8kCA;EACE,kCAAA;EACA,gBAAA;AJq8kCF;;AIn8kCA;EACE,kCAAA;EACA,gBAAA;AJs8kCF;;AIp8kCA;EACE,gCAAA;EACA,gBAAA;AJu8kCF;;AIr8kCA;EACE,gCAAA;EACA,gBAAA;AJw8kCF;;AIt8kCA;EACE,gBAAA;AJy8kCF;;AIv8kCA;EACE,gBAAA;AJ08kCF;;AIx8kCA;EACE,gBAAA;AJ28kCF;;AIz8kCA;EACE,gBAAA;AJ48kCF;;AI18kCA;EACE,gCAAA;EACA,gBAAA;AJ68kCF;;AI38kCA;EACE,gBAAA;AJ88kCF;;AI58kCA;EACE,gCAAA;EACA,gBAAA;AJ+8kCF;;AI78kCA;EACE,gBAAA;AJg9kCF;;AI98kCA;EACE,gCAAA;EACA,gBAAA;AJi9kCF;;AI/8kCA;EACE,gBAAA;AJk9kCF;;AIh9kCA;EACE,gCAAA;EACA,gBAAA;AJm9kCF;;AIj9kCA;EACE,gBAAA;AJo9kCF;;AIl9kCA;EACE,gCAAA;EACA,gBAAA;AJq9kCF;;AIn9kCA;EACE,gBAAA;AJs9kCF;;AIp9kCA;EACE,gCAAA;EACA,gBAAA;AJu9kCF;;AIr9kCA;EACE,gBAAA;AJw9kCF;;AIt9kCA;EACE,gCAAA;EACA,gBAAA;AJy9kCF;;AIv9kCA;EACE,gBAAA;AJ09kCF;;AIx9kCA;EACE,gCAAA;EACA,gBAAA;AJ29kCF;;AIz9kCA;EACE,gBAAA;AJ49kCF;;AI19kCA;EACE,gCAAA;EACA,gBAAA;AJ69kCF;;AI39kCA;EACE,gBAAA;AJ89kCF;;AI59kCA;EACE,gCAAA;EACA,gBAAA;AJ+9kCF;;AI79kCA;EACE,kCAAA;EACA,gBAAA;AJg+kCF;;AI99kCA;EACE,kCAAA;EACA,gBAAA;AJi+kCF;;AI/9kCA;EACE,kCAAA;EACA,gBAAA;AJk+kCF;;AIh+kCA;EACE,kCAAA;EACA,gBAAA;AJm+kCF;;AIj+kCA;EACE,kCAAA;EACA,gBAAA;AJo+kCF;;AIl+kCA;EACE,kCAAA;EACA,gBAAA;AJq+kCF;;AIn+kCA;EACE,kCAAA;EACA,gBAAA;AJs+kCF;;AIp+kCA;EACE,kCAAA;EACA,gBAAA;AJu+kCF;;AIr+kCA;EACE,kCAAA;EACA,gBAAA;AJw+kCF;;AIt+kCA;EACE,kCAAA;EACA,gBAAA;AJy+kCF;;AIv+kCA;EACE,kCAAA;EACA,gBAAA;AJ0+kCF;;AIx+kCA;EACE,kCAAA;EACA,gBAAA;AJ2+kCF;;AIz+kCA;EACE,kCAAA;EACA,gBAAA;AJ4+kCF;;AI1+kCA;EACE,gBAAA;AJ6+kCF;;AI3+kCA;EACE,kCAAA;EACA,gBAAA;AJ8+kCF;;AI5+kCA;EACE,kCAAA;EACA,gBAAA;AJ++kCF;;AI7+kCA;EACE,kCAAA;EACA,gBAAA;AJg/kCF;;AI9+kCA;EACE,gCAAA;EACA,gBAAA;AJi/kCF;;AI/+kCA;EACE,gBAAA;AJk/kCF;;AIh/kCA;EACE,gCAAA;EACA,gBAAA;AJm/kCF;;AIj/kCA;EACE,gBAAA;AJo/kCF;;AIl/kCA;EACE,gCAAA;EACA,gBAAA;AJq/kCF;;AIn/kCA;EACE,gBAAA;AJs/kCF;;AIp/kCA;EACE,gCAAA;EACA,gBAAA;AJu/kCF;;AIr/kCA;EACE,gBAAA;AJw/kCF;;AIt/kCA;EACE,gCAAA;EACA,gBAAA;AJy/kCF;;AIv/kCA;EACE,gBAAA;AJ0/kCF;;AIx/kCA;EACE,gBAAA;AJ2/kCF;;AIz/kCA;EACE,gCAAA;EACA,gBAAA;AJ4/kCF;;AI1/kCA;EACE,gBAAA;AJ6/kCF;;AI3/kCA;EACE,kCAAA;EACA,gBAAA;AJ8/kCF;;AI5/kCA;EACE,kCAAA;EACA,gBAAA;AJ+/kCF;;AI7/kCA;EACE,gBAAA;AJgglCF;;AI9/kCA;EACE,kCAAA;EACA,gBAAA;AJiglCF;;AI//kCA;EACE,kCAAA;EACA,gBAAA;AJkglCF;;AIhglCA;EACE,kCAAA;EACA,gBAAA;AJmglCF;;AIjglCA;EACE,kCAAA;EACA,gBAAA;AJoglCF;;AIlglCA;EACE,gBAAA;AJqglCF;;AInglCA;EACE,kCAAA;EACA,gBAAA;AJsglCF;;AIpglCA;EACE,kCAAA;EACA,gBAAA;AJuglCF;;AIrglCA;EACE,kCAAA;EACA,gBAAA;AJwglCF;;AItglCA;EACE,kCAAA;EACA,gBAAA;AJyglCF;;AIvglCA;EACE,kCAAA;EACA,gBAAA;AJ0glCF;;AIxglCA;EACE,kCAAA;EACA,gBAAA;AJ2glCF;;AIzglCA;EACE,kCAAA;EACA,gBAAA;AJ4glCF;;AI1glCA;EACE,gCAAA;EACA,gBAAA;AJ6glCF;;AI3glCA;EACE,gBAAA;AJ8glCF;;AI5glCA;EACE,gCAAA;EACA,gBAAA;AJ+glCF;;AI7glCA;EACE,gBAAA;AJghlCF;;AI9glCA;EACE,kCAAA;EACA,gBAAA;AJihlCF;;AI/glCA;EACE,kCAAA;EACA,gBAAA;AJkhlCF;;AIhhlCA;EACE,kCAAA;EACA,gBAAA;AJmhlCF;;AIjhlCA;EACE,kCAAA;EACA,gBAAA;AJohlCF;;AIlhlCA;EACE,kCAAA;EACA,gBAAA;AJqhlCF;;AInhlCA;EACE,kCAAA;EACA,gBAAA;AJshlCF;;AIphlCA;EACE,kCAAA;EACA,gBAAA;AJuhlCF;;AIrhlCA;EACE,gBAAA;AJwhlCF;;AIthlCA;EACE,gCAAA;EACA,gBAAA;AJyhlCF;;AIvhlCA;EACE,gBAAA;AJ0hlCF;;AIxhlCA;EACE,gBAAA;AJ2hlCF;;AIzhlCA;EACE,gBAAA;AJ4hlCF;;AI1hlCA;EACE,gBAAA;AJ6hlCF;;AI3hlCA;EACE,gBAAA;AJ8hlCF;;AI5hlCA;EACE,kCAAA;EACA,gBAAA;AJ+hlCF;;AI7hlCA;EACE,kCAAA;EACA,gBAAA;AJgilCF;;AI9hlCA;EACE,gBAAA;AJiilCF;;AI/hlCA;EACE,kCAAA;EACA,gBAAA;AJkilCF;;AIhilCA;EACE,kCAAA;EACA,gBAAA;AJmilCF;;AIjilCA;EACE,kCAAA;EACA,gBAAA;AJoilCF;;AIlilCA;EACE,kCAAA;EACA,gBAAA;AJqilCF;;AInilCA;EACE,kCAAA;EACA,gBAAA;AJsilCF;;AIpilCA;EACE,kCAAA;EACA,gBAAA;AJuilCF;;AIrilCA;EACE,kCAAA;EACA,gBAAA;AJwilCF;;AItilCA;EACE,kCAAA;EACA,gBAAA;AJyilCF;;AIvilCA;EACE,kCAAA;EACA,gBAAA;AJ0ilCF;;AIxilCA;EACE,kCAAA;EACA,gBAAA;AJ2ilCF;;AIzilCA;EACE,gBAAA;AJ4ilCF;;AI1ilCA;EACE,kCAAA;EACA,gBAAA;AJ6ilCF;;AI3ilCA;EACE,gBAAA;AJ8ilCF;;AI5ilCA;EACE,kCAAA;EACA,gBAAA;AJ+ilCF;;AI7ilCA;EACE,kCAAA;EACA,gBAAA;AJgjlCF;;AI9ilCA;EACE,gBAAA;AJijlCF;;AI/ilCA;EACE,gCAAA;EACA,gBAAA;AJkjlCF;;AIhjlCA;EACE,gBAAA;AJmjlCF;;AIjjlCA;EACE,gCAAA;EACA,gBAAA;AJojlCF;;AIljlCA;EACE,gBAAA;AJqjlCF;;AInjlCA;EACE,kCAAA;EACA,gBAAA;AJsjlCF;;AIpjlCA;EACE,gCAAA;EACA,gBAAA;AJujlCF;;AIrjlCA;EACE,gBAAA;AJwjlCF;;AItjlCA;EACE,gBAAA;AJyjlCF;;AIvjlCA;EACE,gCAAA;EACA,gBAAA;AJ0jlCF;;AIxjlCA;EACE,gBAAA;AJ2jlCF;;AIzjlCA;EACE,gCAAA;EACA,gBAAA;AJ4jlCF;;AI1jlCA;EACE,gBAAA;AJ6jlCF;;AI3jlCA;EACE,gCAAA;EACA,gBAAA;AJ8jlCF;;AI5jlCA;EACE,gBAAA;AJ+jlCF;;AI7jlCA;EACE,gCAAA;EACA,gBAAA;AJgklCF;;AI9jlCA;EACE,gBAAA;AJiklCF;;AI/jlCA;EACE,gCAAA;EACA,gBAAA;AJkklCF;;AIhklCA;EACE,gBAAA;AJmklCF;;AIjklCA;EACE,gCAAA;EACA,gBAAA;AJoklCF;;AIlklCA;EACE,gBAAA;AJqklCF;;AInklCA;EACE,gCAAA;EACA,gBAAA;AJsklCF;;AIpklCA;EACE,gBAAA;AJuklCF;;AIrklCA;EACE,kCAAA;EACA,gBAAA;AJwklCF;;AItklCA;EACE,kCAAA;EACA,gBAAA;AJyklCF;;AIvklCA;EACE,kCAAA;EACA,gBAAA;AJ0klCF;;AIxklCA;EACE,gBAAA;AJ2klCF;;AIzklCA;EACE,gBAAA;AJ4klCF;;AI1klCA;EACE,gBAAA;AJ6klCF;;AI3klCA;EACE,gBAAA;AJ8klCF;;AI5klCA;EACE,gBAAA;AJ+klCF;;AI7klCA;EACE,gBAAA;AJgllCF;;AI9klCA;EACE,gBAAA;AJillCF;;AI/klCA;EACE,gBAAA;AJkllCF;;AIhllCA;EACE,gCAAA;EACA,gBAAA;AJmllCF;;AIjllCA;EACE,gCAAA;EACA,gBAAA;AJollCF;;AIlllCA;EACE,gBAAA;AJqllCF;;AInllCA;EACE,gCAAA;EACA,gBAAA;AJsllCF;;AIpllCA;EACE,gBAAA;AJullCF;;AIrllCA;EACE,gCAAA;EACA,gBAAA;AJwllCF;;AItllCA;EACE,gBAAA;AJyllCF;;AIvllCA;EACE,kCAAA;EACA,gBAAA;AJ0llCF;;AIxllCA;EACE,kCAAA;EACA,gBAAA;AJ2llCF;;AIzllCA;EACE,kCAAA;EACA,gBAAA;AJ4llCF;;AI1llCA;EACE,kCAAA;EACA,gBAAA;AJ6llCF;;AI3llCA;EACE,kCAAA;EACA,gBAAA;AJ8llCF;;AI5llCA;EACE,kCAAA;EACA,gBAAA;AJ+llCF;;AI7llCA;EACE,gBAAA;AJgmlCF;;AI9llCA;EACE,gCAAA;EACA,gBAAA;AJimlCF;;AI/llCA;EACE,gBAAA;AJkmlCF;;AIhmlCA;EACE,kCAAA;EACA,gBAAA;AJmmlCF;;AIjmlCA;EACE,kCAAA;EACA,gBAAA;AJomlCF;;AIlmlCA;EACE,kCAAA;EACA,gBAAA;AJqmlCF;;AK1hyCA;;;;;;;;;CAAA;AAUA;EACE,wBAAA;EACA,6CAAA,EAAA,OAAA;EACA,iTAAA,EAI6E,aAAA;EAC7E,kBAAA;ALyhyCF;AKthyCA;EACE,mCAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;ALwhyCF;;AKrhyCA;EAAS,mBAAA;EAAqB,mBAAA;EAAqB,yBAAA;AL2hyCnD;;AK1hyCA;EAAS,gBAAA;EAAkB,qBAAA;EAAuB,wBAAA;ALgiyClD;;AK/hyCA;EAAU,gBAAA;ALmiyCV;;AKliyCA;EAAS,iBAAA;ALsiyCT;;AKriyCA;EAAS,kBAAA;ALyiyCT;;AKxiyCA;EAAS,cAAA;AL4iyCT;;AK3iyCA;EAAS,cAAA;AL+iyCT;;AK9iyCA;EAAS,cAAA;ALkjyCT;;AKjjyCA;EAAS,cAAA;ALqjyCT;;AKpjyCA;EAAS,cAAA;ALwjyCT;;AKvjyCA;EAAS,cAAA;AL2jyCT;;AK1jyCA;EAAS,cAAA;AL8jyCT;;AK7jyCA;EAAS,cAAA;ALikyCT;;AKhkyCA;EAAS,cAAA;ALokyCT;;AKnkyCA;EAAU,eAAA;ALukyCV;;AKtkyCA;EAAS,kBAAA;EAAoB,aAAA;AL2kyC7B;;AKzkyCA;EAA2B,gBAAA;AL6kyC3B;;AK5kyCA;EAA2B,gBAAA;ALglyC3B;;AK/kyCA;EAAqB,gBAAA;ALmlyCrB;;AKllyCA;EAAqB,gBAAA;ALslyCrB;;AKrlyCA;EAAiB,gBAAA;ALylyCjB;;AKxlyCA;EAA8B,gBAAA;AL4lyC9B;;AK3lyCA;EAA8B,gBAAA;AL+lyC9B;;AK9lyCA;EAAiC,gBAAA;ALkmyCjC;;AKjmyCA;EAAiC,gBAAA;ALqmyCjC;;AKpmyCA;EAAkC,gBAAA;ALwmyClC;;AKvmyCA;EAAkC,gBAAA;AL2myClC;;AK1myCA;EAAqC,gBAAA;AL8myCrC;;AK7myCA;EAAqC,gBAAA;ALinyCrC;;AKhnyCA;EAA0B,gBAAA;ALonyC1B;;AKnnyCA;EAA0B,gBAAA;ALunyC1B;;AKtnyCA;EAA6B,gBAAA;AL0nyC7B;;AKznyCA;EAA6B,gBAAA;AL6nyC7B;;AK5nyCA;EAAsB,gBAAA;ALgoyCtB;;AK/nyCA;EAAsB,gBAAA;ALmoyCtB;;AKloyCA;EAAwB,gBAAA;ALsoyCxB;;AKroyCA;EAAwB,gBAAA;ALyoyCxB;;AKxoyCA;EAAgC,gBAAA;AL4oyChC;;AK3oyCA;EAAgC,gBAAA;AL+oyChC;;AK9oyCA;EAA0B,gBAAA;ALkpyC1B;;AKjpyCA;EAA0B,gBAAA;ALqpyC1B;;AKppyCA;EAAwB,gBAAA;ALwpyCxB;;AKvpyCA;EAAwB,gBAAA;AL2pyCxB;;AK1pyCA;EAAgC,gBAAA;AL8pyChC;;AK7pyCA;EAAgC,gBAAA;ALiqyChC;;AKhqyCA;EAAwB,gBAAA;ALoqyCxB;;AKnqyCA;EAAwB,gBAAA;ALuqyCxB;;AKtqyCA;EAAwB,gBAAA;AL0qyCxB;;AKzqyCA;EAAwB,gBAAA;AL6qyCxB;;AK5qyCA;EAAyB,gBAAA;ALgryCzB;;AK/qyCA;EAAyB,gBAAA;ALmryCzB;;AKlryCA;EAA0B,gBAAA;ALsryC1B;;AKrryCA;EAA0B,gBAAA;ALyryC1B;;AKxryCA;EAA2B,gBAAA;AL4ryC3B;;AK3ryCA;EAAwB,gBAAA;AL+ryCxB;;AK9ryCA;EAAyB,gBAAA;ALksyCzB;;AKjsyCA;EAAuB,gBAAA;ALqsyCvB;;AKpsyCA;EAA8B,gBAAA;ALwsyC9B;;AKvsyCA;EAAyB,gBAAA;AL2syCzB;;AK1syCA;EAAyB,gBAAA;AL8syCzB;;AK7syCA;EAAyB,gBAAA;ALityCzB;;AKhtyCA;EAAyB,gBAAA;ALotyCzB;;AKntyCA;EAAyB,gBAAA;ALutyCzB;;AKttyCA;EAAyB,gBAAA;AL0tyCzB;;AKztyCA;EAA+B,gBAAA;AL6tyC/B;;AK5tyCA;EAA+B,gBAAA;ALguyC/B;;AK/tyCA;EAAmC,gBAAA;ALmuyCnC;;AKluyCA;EAAmC,gBAAA;ALsuyCnC;;AKruyCA;EAA0B,gBAAA;ALyuyC1B;;AKxuyCA;EAA0B,gBAAA;AL4uyC1B;;AK3uyCA;EAA4B,gBAAA;AL+uyC5B;;AK9uyCA;EAA4B,gBAAA;ALkvyC5B;;AKjvyCA;EAAkC,gBAAA;ALqvyClC;;AKpvyCA;EAAkC,gBAAA;ALwvyClC;;AKvvyCA;EAAgC,gBAAA;AL2vyChC;;AK1vyCA;EAAgC,gBAAA;AL8vyChC;;AK7vyCA;EAA4B,gBAAA;ALiwyC5B;;AKhwyCA;EAA4B,gBAAA;ALowyC5B;;AKnwyCA;EAAwB,gBAAA;ALuwyCxB;;AKtwyCA;EAAwB,gBAAA;AL0wyCxB;;AKzwyCA;EAAyB,gBAAA;AL6wyCzB;;AK5wyCA;EAAyB,gBAAA;ALgxyCzB;;AK/wyCA;EAAuB,gBAAA;ALmxyCvB;;AKlxyCA;EAAuB,gBAAA;ALsxyCvB;;AKrxyCA;EAAiC,gBAAA;ALyxyCjC;;AKxxyCA;EAAiC,gBAAA;AL4xyCjC;;AK3xyCA;EAA0B,gBAAA;AL+xyC1B;;AK9xyCA;EAA0B,gBAAA;ALkyyC1B;;AKjyyCA;EAAoC,gBAAA;ALqyyCpC;;AKpyyCA;EAAoC,gBAAA;ALwyyCpC;;AKvyyCA;EAA6B,gBAAA;AL2yyC7B;;AK1yyCA;EAA6B,gBAAA;AL8yyC7B;;AK7yyCA;EAA+B,gBAAA;ALizyC/B;;AKhzyCA;EAA+B,gBAAA;ALozyC/B;;AKnzyCA;EAAkC,gBAAA;ALuzyClC;;AKtzyCA;EAAkC,gBAAA;AL0zyClC;;AKzzyCA;EAAkC,gBAAA;AL6zyClC;;AK5zyCA;EAAkC,gBAAA;ALg0yClC;;AK/zyCA;EAAmC,gBAAA;ALm0yCnC;;AKl0yCA;EAAmC,gBAAA;ALs0yCnC;;AKr0yCA;EAAgC,gBAAA;ALy0yChC;;AKx0yCA;EAAgC,gBAAA;AL40yChC;;AK30yCA;EAAgC,gBAAA;AL+0yChC;;AK90yCA;EAAgC,gBAAA;ALk1yChC;;AKj1yCA;EAAmC,gBAAA;ALq1yCnC;;AKp1yCA;EAAmC,gBAAA;ALw1yCnC;;AKv1yCA;EAAoC,gBAAA;AL21yCpC;;AK11yCA;EAAoC,gBAAA;AL81yCpC;;AK71yCA;EAAkC,gBAAA;ALi2yClC;;AKh2yCA;EAAkC,gBAAA;ALo2yClC;;AKn2yCA;EAA6B,gBAAA;ALu2yC7B;;AKt2yCA;EAA6B,gBAAA;AL02yC7B;;AKz2yCA;EAAmC,gBAAA;AL62yCnC;;AK52yCA;EAAmC,gBAAA;ALg3yCnC;;AK/2yCA;EAA+B,gBAAA;ALm3yC/B;;AKl3yCA;EAA+B,gBAAA;ALs3yC/B;;AKr3yCA;EAAgC,gBAAA;ALy3yChC;;AKx3yCA;EAAgC,gBAAA;AL43yChC;;AK33yCA;EAAqC,gBAAA;AL+3yCrC;;AK93yCA;EAAqC,gBAAA;ALk4yCrC;;AKj4yCA;EAAmC,gBAAA;ALq4yCnC;;AKp4yCA;EAAmC,gBAAA;ALw4yCnC;;AKv4yCA;EAA8B,gBAAA;AL24yC9B;;AK14yCA;EAA8B,gBAAA;AL84yC9B;;AK74yCA;EAAgC,gBAAA;ALi5yChC;;AKh5yCA;EAAgC,gBAAA;ALo5yChC;;AKn5yCA;EAAiC,gBAAA;ALu5yCjC;;AKt5yCA;EAAiC,gBAAA;AL05yCjC;;AKz5yCA;EAAkC,gBAAA;AL65yClC;;AK55yCA;EAAkC,gBAAA;ALg6yClC;;AK/5yCA;EAAgC,gBAAA;ALm6yChC;;AKl6yCA;EAAgC,gBAAA;ALs6yChC;;AKr6yCA;EAA2B,gBAAA;ALy6yC3B;;AKx6yCA;EAA2B,gBAAA;AL46yC3B;;AK36yCA;EAA6B,gBAAA;AL+6yC7B;;AK96yCA;EAA6B,gBAAA;ALk7yC7B;;AKj7yCA;EAA6B,gBAAA;ALq7yC7B;;AKp7yCA;EAA6B,gBAAA;ALw7yC7B;;AKv7yCA;EAA2B,gBAAA;AL27yC3B;;AK17yCA;EAA2B,gBAAA;AL87yC3B;;AK77yCA;EAA0B,gBAAA;ALi8yC1B;;AKh8yCA;EAA0B,gBAAA;ALo8yC1B;;AKn8yCA;EAA+B,gBAAA;ALu8yC/B;;AKt8yCA;EAA+B,gBAAA;AL08yC/B;;AKz8yCA;EAAsB,gBAAA;AL68yCtB;;AK58yCA;EAAqB,gBAAA;ALg9yCrB;;AK/8yCA;EAAqB,gBAAA;ALm9yCrB;;AKl9yCA;EAA0B,gBAAA;ALs9yC1B;;AKr9yCA;EAA6B,gBAAA;ALy9yC7B;;AKx9yCA;EAA6B,gBAAA;AL49yC7B;;AK39yCA;EAA0B,gBAAA;AL+9yC1B;;AK99yCA;EAA0B,gBAAA;ALk+yC1B;;AKj+yCA;EAAwB,gBAAA;ALq+yCxB;;AKp+yCA;EAAwB,gBAAA;ALw+yCxB;;AKv+yCA;EAAwB,gBAAA;AL2+yCxB;;AK1+yCA;EAAwB,gBAAA;AL8+yCxB;;AK7+yCA;EAA2B,gBAAA;ALi/yC3B;;AKh/yCA;EAA2B,gBAAA;ALo/yC3B;;AKn/yCA;EAA8B,gBAAA;ALu/yC9B;;AKt/yCA;EAA8B,gBAAA;AL0/yC9B;;AKz/yCA;EAA4B,gBAAA;AL6/yC5B;;AK5/yCA;EAA4B,gBAAA;ALggzC5B;;AK//yCA;EAAuB,gBAAA;ALmgzCvB;;AKlgzCA;EAAuB,gBAAA;ALsgzCvB;;AKrgzCA;EAA8B,gBAAA;ALygzC9B;;AKxgzCA;EAA8B,gBAAA;AL4gzC9B;;AK3gzCA;EAAgC,gBAAA;AL+gzChC;;AK9gzCA;EAAgC,gBAAA;ALkhzChC;;AKjhzCA;EAA4B,gBAAA;ALqhzC5B;;AKphzCA;EAAoC,gBAAA;ALwhzCpC;;AKvhzCA;EAAoC,gBAAA;AL2hzCpC;;AK1hzCA;EAAuC,gBAAA;AL8hzCvC;;AK7hzCA;EAAuC,gBAAA;ALiizCvC;;AKhizCA;EAA4B,gBAAA;ALoizC5B;;AKnizCA;EAA8B,gBAAA;ALuizC9B;;AKtizCA;EAA8B,gBAAA;AL0izC9B;;AKzizCA;EAA0B,gBAAA;AL6izC1B;;AK5izCA;EAA0B,gBAAA;ALgjzC1B;;AK/izCA;EAA4B,gBAAA;ALmjzC5B;;AKljzCA;EAA4B,gBAAA;ALsjzC5B;;AKrjzCA;EAA+B,gBAAA;ALyjzC/B;;AKxjzCA;EAA+B,gBAAA;AL4jzC/B;;AK3jzCA;EAA6B,gBAAA;AL+jzC7B;;AK9jzCA;EAA6B,gBAAA;ALkkzC7B;;AKjkzCA;EAAmC,gBAAA;ALqkzCnC;;AKpkzCA;EAAmC,gBAAA;ALwkzCnC;;AKvkzCA;EAA4B,gBAAA;AL2kzC5B;;AK1kzCA;EAA4B,gBAAA;AL8kzC5B;;AK7kzCA;EAAiC,gBAAA;ALilzCjC;;AKhlzCA;EAAiC,gBAAA;ALolzCjC;;AKnlzCA;EAA0B,gBAAA;ALulzC1B;;AKtlzCA;EAA0B,gBAAA;AL0lzC1B;;AKzlzCA;EAA8B,gBAAA;AL6lzC9B;;AK5lzCA;EAA8B,gBAAA;ALgmzC9B;;AK/lzCA;EAAgC,gBAAA;ALmmzChC;;AKlmzCA;EAAgC,gBAAA;ALsmzChC;;AKrmzCA;EAAgC,gBAAA;ALymzChC;;AKxmzCA;EAAgC,gBAAA;AL4mzChC;;AK3mzCA;EAA6B,gBAAA;AL+mzC7B;;AK9mzCA;EAA6B,gBAAA;ALknzC7B;;AKjnzCA;EAA0B,gBAAA;ALqnzC1B;;AKpnzCA;EAA0B,gBAAA;ALwnzC1B;;AKvnzCA;EAAuB,gBAAA;AL2nzCvB;;AK1nzCA;EAAuB,gBAAA;AL8nzCvB;;AK7nzCA;EAAuB,gBAAA;ALiozCvB;;AKhozCA;EAAuB,gBAAA;ALoozCvB;;AKnozCA;EAA2B,gBAAA;ALuozC3B;;AKtozCA;EAA2B,gBAAA;AL0ozC3B;;AKzozCA;EAAuB,gBAAA;AL6ozCvB;;AK5ozCA;EAAuB,gBAAA;ALgpzCvB;;AK/ozCA;EAA4B,gBAAA;ALmpzC5B;;AKlpzCA;EAA4B,gBAAA;ALspzC5B;;AKrpzCA;EAA2B,gBAAA;ALypzC3B;;AKxpzCA;EAA2B,gBAAA;AL4pzC3B;;AK3pzCA;EAAwB,gBAAA;AL+pzCxB;;AK9pzCA;EAAwB,gBAAA;ALkqzCxB;;AKjqzCA;EAAoC,gBAAA;ALqqzCpC;;AKpqzCA;EAAoC,gBAAA;ALwqzCpC;;AKvqzCA;EAA4B,gBAAA;AL2qzC5B;;AK1qzCA;EAA4B,gBAAA;AL8qzC5B;;AK7qzCA;EAA2B,gBAAA;ALirzC3B;;AKhrzCA;EAA2B,gBAAA;ALorzC3B;;AKnrzCA;EAA4B,gBAAA;ALurzC5B;;AKtrzCA;EAA4B,gBAAA;AL0rzC5B;;AKzrzCA;EAAkB,gBAAA;AL6rzClB;;AK5rzCA;EAAyB,gBAAA;ALgszCzB;;AK/rzCA;EAAyB,gBAAA;ALmszCzB;;AKlszCA;EAAyB,gBAAA;ALsszCzB;;AKrszCA;EAAyB,gBAAA;ALyszCzB;;AKxszCA;EAAuB,gBAAA;AL4szCvB;;AK3szCA;EAAuB,gBAAA;AL+szCvB;;AK9szCA;EAA4B,gBAAA;ALktzC5B;;AKjtzCA;EAA4B,gBAAA;ALqtzC5B;;AKptzCA;EAA4B,gBAAA;ALwtzC5B;;AKvtzCA;EAA4B,gBAAA;AL2tzC5B;;AK1tzCA;EAA4B,gBAAA;AL8tzC5B;;AK7tzCA;EAA4B,gBAAA;ALiuzC5B;;AKhuzCA;EAA0B,gBAAA;ALouzC1B;;AKnuzCA;EAA0B,gBAAA;ALuuzC1B;;AKtuzCA;EAA6B,gBAAA;AL0uzC7B;;AKzuzCA;EAA6B,gBAAA;AL6uzC7B;;AK5uzCA;EAA6B,gBAAA;ALgvzC7B;;AK/uzCA;EAA6B,gBAAA;ALmvzC7B;;AKlvzCA;EAA2B,gBAAA;ALsvzC3B;;AKrvzCA;EAA2B,gBAAA;ALyvzC3B;;AKxvzCA;EAAyB,gBAAA;AL4vzCzB;;AK3vzCA;EAAyB,gBAAA;AL+vzCzB;;AK9vzCA;EAAyB,gBAAA;ALkwzCzB;;AKjwzCA;EAAyB,gBAAA;ALqwzCzB;;AKpwzCA;EAA2B,gBAAA;ALwwzC3B;;AKvwzCA;EAA2B,gBAAA;AL2wzC3B;;AK1wzCA;EAA8B,gBAAA;AL8wzC9B;;AK7wzCA;EAA8B,gBAAA;ALixzC9B;;AKhxzCA;EAA8B,gBAAA;ALoxzC9B;;AKnxzCA;EAA8B,gBAAA;ALuxzC9B;;AKtxzCA;EAA8B,gBAAA;AL0xzC9B;;AKzxzCA;EAA8B,gBAAA;AL6xzC9B;;AK5xzCA;EAA8B,gBAAA;ALgyzC9B;;AK/xzCA;EAA8B,gBAAA;ALmyzC9B;;AKlyzCA;EAA4B,gBAAA;ALsyzC5B;;AKryzCA;EAA4B,gBAAA;ALyyzC5B;;AKxyzCA;EAA2B,gBAAA;AL4yzC3B;;AK3yzCA;EAA4B,gBAAA;AL+yzC5B;;AK9yzCA;EAA4B,gBAAA;ALkzzC5B;;AKjzzCA;EAA4B,gBAAA;ALqzzC5B;;AKpzzCA;EAA0B,gBAAA;ALwzzC1B;;AKvzzCA;EAA0B,gBAAA;AL2zzC1B;;AK1zzCA;EAA0B,gBAAA;AL8zzC1B;;AK7zzCA;EAA0B,gBAAA;ALi0zC1B;;AKh0zCA;EAA0B,gBAAA;ALo0zC1B;;AKn0zCA;EAA0B,gBAAA;ALu0zC1B;;AKt0zCA;EAAwB,gBAAA;AL00zCxB;;AKz0zCA;EAAwB,gBAAA;AL60zCxB;;AK50zCA;EAA+B,gBAAA;ALg1zC/B;;AK/0zCA;EAA+B,gBAAA;ALm1zC/B;;AKl1zCA;EAAwB,gBAAA;ALs1zCxB;;AKr1zCA;EAAwB,gBAAA;ALy1zCxB;;AKx1zCA;EAAsB,gBAAA;AL41zCtB;;AK31zCA;EAAsB,gBAAA;AL+1zCtB;;AK91zCA;EAA6B,gBAAA;ALk2zC7B;;AKj2zCA;EAA6B,gBAAA;ALq2zC7B;;AKp2zCA;EAA6B,gBAAA;ALw2zC7B;;AKv2zCA;EAA6B,gBAAA;AL22zC7B;;AK12zCA;EAA6B,gBAAA;AL82zC7B;;AK72zCA;EAA6B,gBAAA;ALi3zC7B;;AKh3zCA;EAA2B,gBAAA;ALo3zC3B;;AKn3zCA;EAA2B,gBAAA;ALu3zC3B;;AKt3zCA;EAAwB,gBAAA;AL03zCxB;;AKz3zCA;EAAwB,gBAAA;AL63zCxB;;AK53zCA;EAAsB,gBAAA;ALg4zCtB;;AK/3zCA;EAAsB,gBAAA;ALm4zCtB;;AKl4zCA;EAA2B,gBAAA;ALs4zC3B;;AKr4zCA;EAA2B,gBAAA;ALy4zC3B;;AKx4zCA;EAAyB,gBAAA;AL44zCzB;;AK34zCA;EAAyB,gBAAA;AL+4zCzB;;AK94zCA;EAAyB,gBAAA;ALk5zCzB;;AKj5zCA;EAAyB,gBAAA;ALq5zCzB;;AKp5zCA;EAAyB,gBAAA;ALw5zCzB;;AKv5zCA;EAAyB,gBAAA;AL25zCzB;;AK15zCA;EAAuB,gBAAA;AL85zCvB;;AK75zCA;EAAuB,gBAAA;ALi6zCvB;;AKh6zCA;EAA6B,gBAAA;ALo6zC7B;;AKn6zCA;EAA6B,gBAAA;ALu6zC7B;;AKt6zCA;EAA6B,gBAAA;AL06zC7B;;AKz6zCA;EAA6B,gBAAA;AL66zC7B;;AK56zCA;EAAiC,gBAAA;ALg7zCjC;;AK/6zCA;EAAiC,gBAAA;ALm7zCjC;;AKl7zCA;EAAiC,gBAAA;ALs7zCjC;;AKr7zCA;EAAiC,gBAAA;ALy7zCjC;;AKx7zCA;EAA2B,gBAAA;AL47zC3B;;AK37zCA;EAA2B,gBAAA;AL+7zC3B;;AK97zCA;EAAgC,gBAAA;ALk8zChC;;AKj8zCA;EAAgC,gBAAA;ALq8zChC;;AKp8zCA;EAA2B,gBAAA;ALw8zC3B;;AKv8zCA;EAA2B,gBAAA;AL28zC3B;;AK18zCA;EAA2B,gBAAA;AL88zC3B;;AK78zCA;EAA2B,gBAAA;ALi9zC3B;;AKh9zCA;EAAyB,gBAAA;ALo9zCzB;;AKn9zCA;EAA8B,gBAAA;ALu9zC9B;;AKt9zCA;EAA8B,gBAAA;AL09zC9B;;AKz9zCA;EAAyB,gBAAA;AL69zCzB;;AK59zCA;EAA6B,gBAAA;ALg+zC7B;;AK/9zCA;EAA6B,gBAAA;ALm+zC7B;;AKl+zCA;EAAgC,gBAAA;ALs+zChC;;AKr+zCA;EAAgC,gBAAA;ALy+zChC;;AKx+zCA;EAA0B,gBAAA;AL4+zC1B;;AK3+zCA;EAA0B,gBAAA;AL++zC1B;;AK9+zCA;EAAsB,gBAAA;ALk/zCtB;;AKj/zCA;EAAsB,gBAAA;ALq/zCtB;;AKp/zCA;EAA8B,gBAAA;ALw/zC9B;;AKv/zCA;EAA8B,gBAAA;AL2/zC9B;;AK1/zCA;EAA0B,gBAAA;AL8/zC1B;;AK7/zCA;EAA0B,gBAAA;ALig0C1B;;AKhg0CA;EAAuB,gBAAA;ALog0CvB;;AKng0CA;EAAuB,gBAAA;ALug0CvB;;AKtg0CA;EAA4B,gBAAA;AL0g0C5B;;AKzg0CA;EAA4B,gBAAA;AL6g0C5B;;AK5g0CA;EAA0B,gBAAA;ALgh0C1B;;AK/g0CA;EAA0B,gBAAA;ALmh0C1B;;AKlh0CA;EAAyB,gBAAA;ALsh0CzB;;AKrh0CA;EAAyB,gBAAA;ALyh0CzB;;AKxh0CA;EAAwC,gBAAA;AL4h0CxC;;AK3h0CA;EAAwC,gBAAA;AL+h0CxC;;AK9h0CA;EAAkC,gBAAA;ALki0ClC;;AKji0CA;EAAkC,gBAAA;ALqi0ClC;;AKpi0CA;EAAgC,gBAAA;ALwi0ChC;;AKvi0CA;EAAgC,gBAAA;AL2i0ChC;;AK1i0CA;EAAyB,gBAAA;AL8i0CzB;;AK7i0CA;EAAyB,gBAAA;ALij0CzB;;AKhj0CA;EAAyB,gBAAA;ALoj0CzB;;AKnj0CA;EAAyB,gBAAA;ALuj0CzB;;AKtj0CA;EAAyB,gBAAA;AL0j0CzB;;AKzj0CA;EAAyB,gBAAA;AL6j0CzB;;AK5j0CA;EAAyB,gBAAA;ALgk0CzB;;AK/j0CA;EAAyB,gBAAA;ALmk0CzB;;AKlk0CA;EAA6B,gBAAA;ALsk0C7B;;AKrk0CA;EAA6B,gBAAA;ALyk0C7B;;AKxk0CA;EAA8B,gBAAA;AL4k0C9B;;AK3k0CA;EAA8B,gBAAA;AL+k0C9B;;AK9k0CA;EAAgC,gBAAA;ALkl0ChC;;AKjl0CA;EAAgC,gBAAA;ALql0ChC;;AKpl0CA;EAAiC,gBAAA;ALwl0CjC;;AKvl0CA;EAAiC,gBAAA;AL2l0CjC;;AK1l0CA;EAA+B,gBAAA;AL8l0C/B;;AK7l0CA;EAA+B,gBAAA;ALim0C/B;;AKhm0CA;EAA6B,gBAAA;ALom0C7B;;AKnm0CA;EAA6B,gBAAA;ALum0C7B;;AKtm0CA;EAA+B,gBAAA;AL0m0C/B;;AKzm0CA;EAA+B,gBAAA;AL6m0C/B;;AK5m0CA;EAA2B,gBAAA;ALgn0C3B;;AK/m0CA;EAA2B,gBAAA;ALmn0C3B;;AKln0CA;EAA2B,gBAAA;ALsn0C3B;;AKrn0CA;EAA2B,gBAAA;ALyn0C3B;;AKxn0CA;EAA4B,gBAAA;AL4n0C5B;;AK3n0CA;EAA4B,gBAAA;AL+n0C5B;;AK9n0CA;EAA+B,gBAAA;ALko0C/B;;AKjo0CA;EAA+B,gBAAA;ALqo0C/B;;AKpo0CA;EAA6B,gBAAA;ALwo0C7B;;AKvo0CA;EAA6B,gBAAA;AL2o0C7B;;AK1o0CA;EAAgC,gBAAA;AL8o0ChC;;AK7o0CA;EAAgC,gBAAA;ALip0ChC;;AKhp0CA;EAA+B,gBAAA;ALop0C/B;;AKnp0CA;EAA+B,gBAAA;ALup0C/B;;AKtp0CA;EAA+B,gBAAA;AL0p0C/B;;AKzp0CA;EAA+B,gBAAA;AL6p0C/B;;AK5p0CA;EAA6B,gBAAA;ALgq0C7B;;AK/p0CA;EAA6B,gBAAA;ALmq0C7B;;AKlq0CA;EAA8B,gBAAA;ALsq0C9B;;AKrq0CA;EAA8B,gBAAA;ALyq0C9B;;AKxq0CA;EAA6B,gBAAA;AL4q0C7B;;AK3q0CA;EAA6B,gBAAA;AL+q0C7B;;AK9q0CA;EAA+B,gBAAA;ALkr0C/B;;AKjr0CA;EAA+B,gBAAA;ALqr0C/B;;AKpr0CA;EAAwB,gBAAA;ALwr0CxB;;AKvr0CA;EAAwB,gBAAA;AL2r0CxB;;AK1r0CA;EAAwC,gBAAA;AL8r0CxC;;AK7r0CA;EAAwC,gBAAA;ALis0CxC;;AKhs0CA;EAAiC,gBAAA;ALos0CjC;;AKns0CA;EAAiC,gBAAA;ALus0CjC;;AKts0CA;EAAkC,gBAAA;AL0s0ClC;;AKzs0CA;EAAkC,gBAAA;AL6s0ClC;;AK5s0CA;EAA2B,gBAAA;ALgt0C3B;;AK/s0CA;EAAyC,gBAAA;ALmt0CzC;;AKlt0CA;EAAyC,gBAAA;ALst0CzC;;AKrt0CA;EAA2B,gBAAA;ALyt0C3B;;AKxt0CA;EAA0C,gBAAA;AL4t0C1C;;AK3t0CA;EAA0C,gBAAA;AL+t0C1C;;AK9t0CA;EAAoC,gBAAA;ALku0CpC;;AKju0CA;EAAoC,gBAAA;ALqu0CpC;;AKpu0CA;EAAgC,gBAAA;ALwu0ChC;;AKvu0CA;EAAgC,gBAAA;AL2u0ChC;;AK1u0CA;EAAyB,gBAAA;AL8u0CzB;;AK7u0CA;EAAyB,gBAAA;ALiv0CzB;;AKhv0CA;EAA+B,gBAAA;ALov0C/B;;AKnv0CA;EAA+B,gBAAA;ALuv0C/B;;AKtv0CA;EAA4B,gBAAA;AL0v0C5B;;AKzv0CA;EAA4B,gBAAA;AL6v0C5B;;AK5v0CA;EAA8B,gBAAA;ALgw0C9B;;AK/v0CA;EAA8B,gBAAA;ALmw0C9B;;AKlw0CA;EAA4B,gBAAA;ALsw0C5B;;AKrw0CA;EAA4B,gBAAA;ALyw0C5B;;AKxw0CA;EAA+B,gBAAA;AL4w0C/B;;AK3w0CA;EAA+B,gBAAA;AL+w0C/B;;AK9w0CA;EAAwB,gBAAA;ALkx0CxB;;AKjx0CA;EAAwB,gBAAA;ALqx0CxB;;AKpx0CA;EAAoC,gBAAA;ALwx0CpC;;AKvx0CA;EAAoC,gBAAA;AL2x0CpC;;AK1x0CA;EAAwB,gBAAA;AL8x0CxB;;AK7x0CA;EAAwB,gBAAA;ALiy0CxB;;AKhy0CA;EAA4B,gBAAA;ALoy0C5B;;AKny0CA;EAA4B,gBAAA;ALuy0C5B;;AKty0CA;EAA8B,gBAAA;AL0y0C9B;;AKzy0CA;EAA8B,gBAAA;AL6y0C9B;;AK5y0CA;EAA2B,gBAAA;ALgz0C3B;;AK/y0CA;EAA2B,gBAAA;ALmz0C3B;;AKlz0CA;EAAyB,gBAAA;ALsz0CzB;;AKrz0CA;EAAyB,gBAAA;ALyz0CzB;;AKxz0CA;EAA2B,gBAAA;AL4z0C3B;;AK3z0CA;EAA2B,gBAAA;AL+z0C3B;;AK9z0CA;EAAuB,gBAAA;ALk00CvB;;AKj00CA;EAAuB,gBAAA;ALq00CvB;;AKp00CA;EAAyB,gBAAA;ALw00CzB;;AKv00CA;EAAyB,gBAAA;AL200CzB;;AK100CA;EAA+B,gBAAA;AL800C/B;;AK700CA;EAA+B,gBAAA;ALi10C/B;;AKh10CA;EAAuB,gBAAA;ALo10CvB;;AKn10CA;EAA0B,gBAAA;ALu10C1B;;AKt10CA;EAA0B,gBAAA;AL010C1B;;AKz10CA;EAAuB,gBAAA;AL610CvB;;AK510CA;EAAuB,gBAAA;ALg20CvB;;AK/10CA;EAAwB,gBAAA;ALm20CxB;;AKl20CA;EAAwB,gBAAA;ALs20CxB;;AKr20CA;EAA0B,gBAAA;ALy20C1B;;AKx20CA;EAA0B,gBAAA;AL420C1B;;AK320CA;EAA0B,gBAAA;AL+20C1B;;AK920CA;EAA0B,gBAAA;ALk30C1B;;AKj30CA;EAA4B,gBAAA;ALq30C5B;;AKp30CA;EAA4B,gBAAA;ALw30C5B;;AKv30CA;EAA4B,gBAAA;AL230C5B;;AK130CA;EAA4B,gBAAA;AL830C5B;;AK730CA;EAA4B,gBAAA;ALi40C5B;;AKh40CA;EAA4B,gBAAA;ALo40C5B;;AKn40CA;EAA4B,gBAAA;ALu40C5B;;AKt40CA;EAA4B,gBAAA;AL040C5B;;AKz40CA;EAAmC,gBAAA;AL640CnC;;AK540CA;EAAmC,gBAAA;ALg50CnC;;AK/40CA;EAA0B,gBAAA;ALm50C1B;;AKl50CA;EAA0B,gBAAA;ALs50C1B;;AKr50CA;EAA8B,gBAAA;ALy50C9B;;AKx50CA;EAA8B,gBAAA;AL450C9B;;AK350CA;EAA4B,gBAAA;AL+50C5B;;AK950CA;EAA4B,gBAAA;ALk60C5B;;AKj60CA;EAA2B,gBAAA;ALq60C3B;;AKp60CA;EAA2B,gBAAA;ALw60C3B;;AKv60CA;EAAkC,gBAAA;AL260ClC;;AK160CA;EAAkC,gBAAA;AL860ClC;;AK760CA;EAAgC,gBAAA;ALi70ChC;;AKh70CA;EAAgC,gBAAA;ALo70ChC;;AKn70CA;EAAuC,gBAAA;ALu70CvC;;AKt70CA;EAAuC,gBAAA;AL070CvC;;AKz70CA;EAA2B,gBAAA;AL670C3B;;AK570CA;EAA2B,gBAAA;ALg80C3B;;AK/70CA;EAA6B,gBAAA;ALm80C7B;;AKl80CA;EAA6B,gBAAA;ALs80C7B;;AKr80CA;EAAkC,gBAAA;ALy80ClC;;AKx80CA;EAAkC,gBAAA;AL480ClC;;AK380CA;EAAgC,gBAAA;AL+80ChC;;AK980CA;EAAgC,gBAAA;ALk90ChC;;AKj90CA;EAA2B,gBAAA;ALq90C3B;;AKp90CA;EAA2B,gBAAA;ALw90C3B;;AKv90CA;EAA8B,gBAAA;AL290C9B;;AK190CA;EAA8B,gBAAA;AL890C9B;;AK790CA;EAAiC,gBAAA;ALi+0CjC;;AKh+0CA;EAAiC,gBAAA;ALo+0CjC;;AKn+0CA;EAA2B,gBAAA;ALu+0C3B;;AKt+0CA;EAA2B,gBAAA;AL0+0C3B;;AKz+0CA;EAA4B,gBAAA;AL6+0C5B;;AK5+0CA;EAA4B,gBAAA;ALg/0C5B;;AK/+0CA;EAAyB,gBAAA;ALm/0CzB;;AKl/0CA;EAAyB,gBAAA;ALs/0CzB;;AKr/0CA;EAA2B,gBAAA;ALy/0C3B;;AKx/0CA;EAA2B,gBAAA;AL4/0C3B;;AK3/0CA;EAA2B,gBAAA;AL+/0C3B;;AK9/0CA;EAA2B,gBAAA;ALkg1C3B;;AKjg1CA;EAA2B,gBAAA;ALqg1C3B;;AKpg1CA;EAA2B,gBAAA;ALwg1C3B;;AKvg1CA;EAA2B,gBAAA;AL2g1C3B;;AK1g1CA;EAA2B,gBAAA;AL8g1C3B;;AK7g1CA;EAAyB,gBAAA;ALih1CzB;;AKhh1CA;EAAyB,gBAAA;ALoh1CzB;;AKnh1CA;EAAsB,gBAAA;ALuh1CtB;;AKth1CA;EAAsB,gBAAA;AL0h1CtB;;AKzh1CA;EAAsC,gBAAA;AL6h1CtC;;AK5h1CA;EAAsC,gBAAA;ALgi1CtC;;AK/h1CA;EAAmC,gBAAA;ALmi1CnC;;AKli1CA;EAAmC,gBAAA;ALsi1CnC;;AKri1CA;EAAsC,gBAAA;ALyi1CtC;;AKxi1CA;EAAsC,gBAAA;AL4i1CtC;;AK3i1CA;EAAsC,gBAAA;AL+i1CtC;;AK9i1CA;EAAsC,gBAAA;ALkj1CtC;;AKjj1CA;EAAsC,gBAAA;ALqj1CtC;;AKpj1CA;EAAsC,gBAAA;ALwj1CtC;;AKvj1CA;EAAwC,gBAAA;AL2j1CxC;;AK1j1CA;EAAwC,gBAAA;AL8j1CxC;;AK7j1CA;EAA2B,gBAAA;ALik1C3B;;AKhk1CA;EAA2B,gBAAA;ALok1C3B;;AKnk1CA;EAAyB,gBAAA;ALuk1CzB;;AKtk1CA;EAAyB,gBAAA;AL0k1CzB;;AKzk1CA;EAAuB,gBAAA;AL6k1CvB;;AK5k1CA;EAAuB,gBAAA;ALgl1CvB;;AK/k1CA;EAAuB,gBAAA;ALml1CvB;;AKll1CA;EAAuB,gBAAA;ALsl1CvB;;AKrl1CA;EAAsB,gBAAA;ALyl1CtB;;AKxl1CA;EAAsB,gBAAA;AL4l1CtB;;AK3l1CA;EAA2B,gBAAA;AL+l1C3B;;AK9l1CA;EAA2B,gBAAA;ALkm1C3B;;AKjm1CA;EAAyB,gBAAA;ALqm1CzB;;AKpm1CA;EAAyB,gBAAA;ALwm1CzB;;AKvm1CA;EAAqC,gBAAA;AL2m1CrC;;AK1m1CA;EAAqC,gBAAA;AL8m1CrC;;AK7m1CA;EAAmC,gBAAA;ALin1CnC;;AKhn1CA;EAAmC,gBAAA;ALon1CnC;;AKnn1CA;EAA8B,gBAAA;ALun1C9B;;AKtn1CA;EAA8B,gBAAA;AL0n1C9B;;AKzn1CA;EAA8B,gBAAA;AL6n1C9B;;AK5n1CA;EAA8B,gBAAA;ALgo1C9B;;AK/n1CA;EAA4B,gBAAA;ALmo1C5B;;AKlo1CA;EAA4B,gBAAA;ALso1C5B;;AKro1CA;EAA6B,gBAAA;ALyo1C7B;;AKxo1CA;EAA6B,gBAAA;AL4o1C7B;;AK3o1CA;EAA2B,gBAAA;AL+o1C3B;;AK9o1CA;EAA2B,gBAAA;ALkp1C3B;;AKjp1CA;EAAgC,gBAAA;ALqp1ChC;;AKpp1CA;EAAgC,gBAAA;ALwp1ChC;;AKvp1CA;EAA8B,gBAAA;AL2p1C9B;;AK1p1CA;EAA8B,gBAAA;AL8p1C9B;;AK7p1CA;EAA+B,gBAAA;ALiq1C/B;;AKhq1CA;EAA+B,gBAAA;ALoq1C/B;;AKnq1CA;EAA+B,gBAAA;ALuq1C/B;;AKtq1CA;EAA+B,gBAAA;AL0q1C/B;;AKzq1CA;EAA+B,gBAAA;AL6q1C/B;;AK5q1CA;EAA+B,gBAAA;ALgr1C/B;;AK/q1CA;EAA+B,gBAAA;ALmr1C/B;;AKlr1CA;EAA+B,gBAAA;ALsr1C/B;;AKrr1CA;EAA+B,gBAAA;ALyr1C/B;;AKxr1CA;EAA+B,gBAAA;AL4r1C/B;;AK3r1CA;EAA+B,gBAAA;AL+r1C/B;;AK9r1CA;EAA+B,gBAAA;ALks1C/B;;AKjs1CA;EAA6B,gBAAA;ALqs1C7B;;AKps1CA;EAA6B,gBAAA;ALws1C7B;;AKvs1CA;EAA2B,gBAAA;AL2s1C3B;;AK1s1CA;EAAwB,gBAAA;AL8s1CxB;;AK7s1CA;EAAyB,gBAAA;ALit1CzB;;AKht1CA;EAAyB,gBAAA;ALot1CzB;;AKnt1CA;EAAiC,gBAAA;ALut1CjC;;AKtt1CA;EAAiC,gBAAA;AL0t1CjC;;AKzt1CA;EAA2B,gBAAA;AL6t1C3B;;AK5t1CA;EAA2B,gBAAA;ALgu1C3B;;AK/t1CA;EAA4B,gBAAA;ALmu1C5B;;AKlu1CA;EAA4B,gBAAA;ALsu1C5B;;AKru1CA;EAAuB,gBAAA;ALyu1CvB;;AKxu1CA;EAAuB,gBAAA;AL4u1CvB;;AK3u1CA;EAA0B,gBAAA;AL+u1C1B;;AK9u1CA;EAA0B,gBAAA;ALkv1C1B;;AKjv1CA;EAA0B,gBAAA;ALqv1C1B;;AKpv1CA;EAA0B,gBAAA;ALwv1C1B;;AKvv1CA;EAA0B,gBAAA;AL2v1C1B;;AK1v1CA;EAA0B,gBAAA;AL8v1C1B;;AK7v1CA;EAAyB,gBAAA;ALiw1CzB;;AKhw1CA;EAAyB,gBAAA;ALow1CzB;;AKnw1CA;EAAyB,gBAAA;ALuw1CzB;;AKtw1CA;EAAyB,gBAAA;AL0w1CzB;;AKzw1CA;EAA8B,gBAAA;AL6w1C9B;;AK5w1CA;EAA8B,gBAAA;ALgx1C9B;;AK/w1CA;EAA8B,gBAAA;ALmx1C9B;;AKlx1CA;EAA8B,gBAAA;ALsx1C9B;;AKrx1CA;EAAuB,gBAAA;ALyx1CvB;;AKxx1CA;EAAuB,gBAAA;AL4x1CvB;;AK3x1CA;EAAgC,gBAAA;AL+x1ChC;;AK9x1CA;EAAgC,gBAAA;ALky1ChC;;AKjy1CA;EAA4B,gBAAA;ALqy1C5B;;AKpy1CA;EAA4B,gBAAA;ALwy1C5B;;AKvy1CA;EAA4B,gBAAA;AL2y1C5B;;AK1y1CA;EAA4B,gBAAA;AL8y1C5B;;AK7y1CA;EAA0B,gBAAA;ALiz1C1B;;AKhz1CA;EAA0B,gBAAA;ALoz1C1B;;AKnz1CA;EAAyB,gBAAA;ALuz1CzB;;AKtz1CA;EAAyB,gBAAA;AL0z1CzB;;AKzz1CA;EAA6B,gBAAA;AL6z1C7B;;AK5z1CA;EAA6B,gBAAA;ALg01C7B;;AK/z1CA;EAA6B,gBAAA;ALm01C7B;;AKl01CA;EAA6B,gBAAA;ALs01C7B;;AKr01CA;EAAmC,gBAAA;ALy01CnC;;AKx01CA;EAAmC,gBAAA;AL401CnC;;AK301CA;EAAiC,gBAAA;AL+01CjC;;AK901CA;EAAiC,gBAAA;ALk11CjC;;AKj11CA;EAA2B,gBAAA;ALq11C3B;;AKp11CA;EAA2B,gBAAA;ALw11C3B;;AKv11CA;EAAwB,gBAAA;AL211CxB;;AK111CA;EAAwB,gBAAA;AL811CxB;;AK711CA;EAA4B,gBAAA;ALi21C5B;;AKh21CA;EAA4B,gBAAA;ALo21C5B;;AKn21CA;EAA8B,gBAAA;ALu21C9B;;AKt21CA;EAA8B,gBAAA;AL021C9B;;AKz21CA;EAA4B,gBAAA;AL621C5B;;AK521CA;EAA4B,gBAAA;ALg31C5B;;AK/21CA;EAA2B,gBAAA;ALm31C3B;;AKl31CA;EAA2B,gBAAA;ALs31C3B;;AKr31CA;EAAwB,gBAAA;ALy31CxB;;AKx31CA;EAAwB,gBAAA;AL431CxB;;AK331CA;EAA0B,gBAAA;AL+31C1B;;AK931CA;EAA0B,gBAAA;ALk41C1B;;AKj41CA;EAAuB,gBAAA;ALq41CvB;;AKp41CA;EAAuB,gBAAA;ALw41CvB;;AKv41CA;EAA0B,gBAAA;AL241C1B;;AK141CA;EAA0B,gBAAA;AL841C1B;;AK741CA;EAA6B,gBAAA;ALi51C7B;;AKh51CA;EAA6B,gBAAA;ALo51C7B;;AKn51CA;EAA6B,gBAAA;ALu51C7B;;AKt51CA;EAA6B,gBAAA;AL051C7B;;AKz51CA;EAAqB,gBAAA;AL651CrB;;AK551CA;EAAqB,gBAAA;ALg61CrB;;AK/51CA;EAAsB,gBAAA;ALm61CtB;;AKl61CA;EAAsB,gBAAA;ALs61CtB;;AKr61CA;EAA2B,gBAAA;ALy61C3B;;AKx61CA;EAA2B,gBAAA;AL461C3B;;AK361CA;EAAyB,gBAAA;AL+61CzB;;AK961CA;EAAyB,gBAAA;ALk71CzB;;AKj71CA;EAAwB,gBAAA;ALq71CxB;;AKp71CA;EAAwB,gBAAA;ALw71CxB;;AKv71CA;EAA6B,gBAAA;AL271C7B;;AK171CA;EAA6B,gBAAA;AL871C7B;;AK771CA;EAAuB,gBAAA;ALi81CvB;;AKh81CA;EAAuB,gBAAA;ALo81CvB;;AKn81CA;EAAyB,gBAAA;ALu81CzB;;AKt81CA;EAAyB,gBAAA;AL081CzB;;AKz81CA;EAA2B,gBAAA;AL681C3B;;AK581CA;EAA2B,gBAAA;ALg91C3B;;AK/81CA;EAA8B,gBAAA;ALm91C9B;;AKl91CA;EAA8B,gBAAA;ALs91C9B;;AKr91CA;EAAuB,gBAAA;ALy91CvB;;AKx91CA;EAAuB,gBAAA;AL491CvB;;AK391CA;EAAwB,gBAAA;AL+91CxB;;AK991CA;EAAwB,gBAAA;ALk+1CxB;;AKj+1CA;EAA4B,gBAAA;ALq+1C5B;;AKp+1CA;EAA4B,gBAAA;ALw+1C5B;;AKv+1CA;EAA0B,gBAAA;AL2+1C1B;;AK1+1CA;EAAgC,gBAAA;AL8+1ChC;;AK7+1CA;EAAgC,gBAAA;ALi/1ChC;;AKh/1CA;EAAgC,gBAAA;ALo/1ChC;;AKn/1CA;EAAgC,gBAAA;ALu/1ChC;;AKt/1CA;EAA0B,gBAAA;AL0/1C1B;;AKz/1CA;EAAiC,gBAAA;AL6/1CjC;;AK5/1CA;EAAiC,gBAAA;ALgg2CjC;;AK//1CA;EAA8B,gBAAA;ALmg2C9B;;AKlg2CA;EAA8B,gBAAA;ALsg2C9B;;AKrg2CA;EAAkC,gBAAA;ALyg2ClC;;AKxg2CA;EAAkC,gBAAA;AL4g2ClC;;AK3g2CA;EAA4B,gBAAA;AL+g2C5B;;AK9g2CA;EAA4B,gBAAA;ALkh2C5B;;AKjh2CA;EAAyB,gBAAA;ALqh2CzB;;AKph2CA;EAAsB,gBAAA;ALwh2CtB;;AKvh2CA;EAA2B,gBAAA;AL2h2C3B;;AK1h2CA;EAA4B,gBAAA;AL8h2C5B;;AK7h2CA;EAA4B,gBAAA;ALii2C5B;;AKhi2CA;EAAyB,gBAAA;ALoi2CzB;;AKni2CA;EAAyB,gBAAA;ALui2CzB;;AKti2CA;EAAgC,gBAAA;AL0i2ChC;;AKzi2CA;EAAgC,gBAAA;AL6i2ChC;;AK5i2CA;EAA2B,gBAAA;ALgj2C3B;;AK/i2CA;EAA2B,gBAAA;ALmj2C3B;;AKlj2CA;EAA+B,gBAAA;ALsj2C/B;;AKrj2CA;EAA+B,gBAAA;ALyj2C/B;;AKxj2CA;EAA+B,gBAAA;AL4j2C/B;;AK3j2CA;EAA+B,gBAAA;AL+j2C/B;;AK9j2CA;EAAkC,gBAAA;ALkk2ClC;;AKjk2CA;EAAkC,gBAAA;ALqk2ClC;;AKpk2CA;EAA2B,gBAAA;ALwk2C3B;;AKvk2CA;EAAiC,gBAAA;AL2k2CjC;;AK1k2CA;EAAiC,gBAAA;AL8k2CjC;;AK7k2CA;EAA2B,gBAAA;ALil2C3B;;AKhl2CA;EAAgC,gBAAA;ALol2ChC;;AKnl2CA;EAAgC,gBAAA;ALul2ChC;;AKtl2CA;EAAwB,gBAAA;AL0l2CxB;;AKzl2CA;EAAwB,gBAAA;AL6l2CxB;;AK5l2CA;EAA4B,gBAAA;ALgm2C5B;;AK/l2CA;EAA4B,gBAAA;ALmm2C5B;;AKlm2CA;EAAsB,gBAAA;ALsm2CtB;;AKrm2CA;EAAsB,gBAAA;ALym2CtB;;AKxm2CA;EAA0B,gBAAA;AL4m2C1B;;AK3m2CA;EAA0B,gBAAA;AL+m2C1B;;AK9m2CA;EAA+B,gBAAA;ALkn2C/B;;AKjn2CA;EAA+B,gBAAA;ALqn2C/B;;AKpn2CA;EAAkC,gBAAA;ALwn2ClC;;AKvn2CA;EAAkC,gBAAA;AL2n2ClC;;AK1n2CA;EAA2B,gBAAA;AL8n2C3B;;AK7n2CA;EAA2B,gBAAA;ALio2C3B;;AKho2CA;EAA6B,gBAAA;ALoo2C7B;;AKno2CA;EAA6B,gBAAA;ALuo2C7B;;AKto2CA;EAA2B,gBAAA;AL0o2C3B;;AKzo2CA;EAA2B,gBAAA;AL6o2C3B;;AK5o2CA;EAAyB,gBAAA;ALgp2CzB;;AK/o2CA;EAAyB,gBAAA;ALmp2CzB;;AKlp2CA;EAAyB,gBAAA;ALsp2CzB;;AKrp2CA;EAAyB,gBAAA;ALyp2CzB;;AKxp2CA;EAAyB,gBAAA;AL4p2CzB;;AK3p2CA;EAAyB,gBAAA;AL+p2CzB;;AK9p2CA;EAA2B,gBAAA;ALkq2C3B;;AKjq2CA;EAA2B,gBAAA;ALqq2C3B;;AKpq2CA;EAA+B,gBAAA;ALwq2C/B;;AKvq2CA;EAA+B,gBAAA;AL2q2C/B;;AK1q2CA;EAA6B,gBAAA;AL8q2C7B;;AK7q2CA;EAA6B,gBAAA;ALir2C7B;;AKhr2CA;EAA6B,gBAAA;ALor2C7B;;AKnr2CA;EAA6B,gBAAA;ALur2C7B;;AKtr2CA;EAA4B,gBAAA;AL0r2C5B;;AKzr2CA;EAA4B,gBAAA;AL6r2C5B;;AK5r2CA;EAA8B,gBAAA;ALgs2C9B;;AK/r2CA;EAA8B,gBAAA;ALms2C9B;;AKls2CA;EAA4B,gBAAA;ALss2C5B;;AKrs2CA;EAA4B,gBAAA;ALys2C5B;;AKxs2CA;EAA8B,gBAAA;AL4s2C9B;;AK3s2CA;EAA8B,gBAAA;AL+s2C9B;;AK9s2CA;EAAgC,gBAAA;ALkt2ChC;;AKjt2CA;EAAgC,gBAAA;ALqt2ChC;;AKpt2CA;EAA4B,gBAAA;ALwt2C5B;;AKvt2CA;EAA4B,gBAAA;AL2t2C5B;;AK1t2CA;EAA+B,gBAAA;AL8t2C/B;;AK7t2CA;EAA+B,gBAAA;ALiu2C/B;;AKhu2CA;EAA6B,gBAAA;ALou2C7B;;AKnu2CA;EAA6B,gBAAA;ALuu2C7B;;AKtu2CA;EAAuB,gBAAA;AL0u2CvB;;AKzu2CA;EAA8B,gBAAA;AL6u2C9B;;AK5u2CA;EAA8B,gBAAA;ALgv2C9B;;AK/u2CA;EAA2B,gBAAA;ALmv2C3B;;AKlv2CA;EAA2B,gBAAA;ALsv2C3B;;AKrv2CA;EAA+B,gBAAA;ALyv2C/B;;AKxv2CA;EAA+B,gBAAA;AL4v2C/B;;AK3v2CA;EAA2B,gBAAA;AL+v2C3B;;AK9v2CA;EAA2B,gBAAA;ALkw2C3B;;AKjw2CA;EAA4B,gBAAA;ALqw2C5B;;AKpw2CA;EAA4B,gBAAA;ALww2C5B;;AKvw2CA;EAAuB,gBAAA;AL2w2CvB;;AK1w2CA;EAA8B,gBAAA;AL8w2C9B;;AK7w2CA;EAA8B,gBAAA;ALix2C9B;;AKhx2CA;EAA8B,gBAAA;ALox2C9B;;AKnx2CA;EAA8B,gBAAA;ALux2C9B;;AKtx2CA;EAA4B,gBAAA;AL0x2C5B;;AKzx2CA;EAA4B,gBAAA;AL6x2C5B;;AK5x2CA;EAA4B,gBAAA;ALgy2C5B;;AK/x2CA;EAA4B,gBAAA;ALmy2C5B;;AKly2CA;EAA4B,gBAAA;ALsy2C5B;;AKry2CA;EAA4B,gBAAA;ALyy2C5B;;AKxy2CA;EAA6B,gBAAA;AL4y2C7B;;AK3y2CA;EAA6B,gBAAA;AL+y2C7B;;AK9y2CA;EAA+B,gBAAA;ALkz2C/B;;AKjz2CA;EAA+B,gBAAA;ALqz2C/B;;AKpz2CA;EAA6B,gBAAA;ALwz2C7B;;AKvz2CA;EAA6B,gBAAA;AL2z2C7B;;AK1z2CA;EAA2B,gBAAA;AL8z2C3B;;AK7z2CA;EAA2B,gBAAA;ALi02C3B;;AKh02CA;EAA6B,gBAAA;ALo02C7B;;AKn02CA;EAA6B,gBAAA;ALu02C7B;;AKt02CA;EAA2B,gBAAA;AL002C3B;;AKz02CA;EAA2B,gBAAA;AL602C3B;;AK502CA;EAA8B,gBAAA;ALg12C9B;;AK/02CA;EAA8B,gBAAA;ALm12C9B;;AKl12CA;EAA8B,gBAAA;ALs12C9B;;AKr12CA;EAA8B,gBAAA;ALy12C9B;;AKx12CA;EAAgC,gBAAA;AL412ChC;;AK312CA;EAAgC,gBAAA;AL+12ChC;;AK912CA;EAAgC,gBAAA;ALk22ChC;;AKj22CA;EAAgC,gBAAA;ALq22ChC;;AKp22CA;EAA8B,gBAAA;ALw22C9B;;AKv22CA;EAA8B,gBAAA;AL222C9B;;AK122CA;EAA6B,gBAAA;AL822C7B;;AK722CA;EAA6B,gBAAA;ALi32C7B;;AKh32CA;EAA4B,gBAAA;ALo32C5B;;AKn32CA;EAA4B,gBAAA;ALu32C5B;;AKt32CA;EAAgC,gBAAA;AL032ChC;;AKz32CA;EAAgC,gBAAA;AL632ChC;;AK532CA;EAA8B,gBAAA;ALg42C9B;;AK/32CA;EAA8B,gBAAA;ALm42C9B;;AKl42CA;EAA8B,gBAAA;ALs42C9B;;AKr42CA;EAA8B,gBAAA;ALy42C9B;;AKx42CA;EAA4B,gBAAA;AL442C5B;;AK342CA;EAA4B,gBAAA;AL+42C5B;;AK942CA;EAA+B,gBAAA;ALk52C/B;;AKj52CA;EAA+B,gBAAA;ALq52C/B;;AKp52CA;EAA8B,gBAAA;ALw52C9B;;AKv52CA;EAA8B,gBAAA;AL252C9B;;AK152CA;EAA4B,gBAAA;AL852C5B;;AK752CA;EAA4B,gBAAA;ALi62C5B;;AKh62CA;EAA2B,gBAAA;ALo62C3B;;AKn62CA;EAA2B,gBAAA;ALu62C3B;;AKt62CA;EAAuB,gBAAA;AL062CvB;;AKz62CA;EAAuB,gBAAA;AL662CvB;;AK562CA;EAA2B,gBAAA;ALg72C3B;;AK/62CA;EAA2B,gBAAA;ALm72C3B;;AKl72CA;EAA2B,gBAAA;ALs72C3B;;AKr72CA;EAA2B,gBAAA;ALy72C3B;;AKx72CA;EAAyB,gBAAA;AL472CzB;;AK372CA;EAAyB,gBAAA;AL+72CzB;;AK972CA;EAA6B,gBAAA;ALk82C7B;;AKj82CA;EAA6B,gBAAA;ALq82C7B;;AKp82CA;EAA+B,gBAAA;ALw82C/B;;AKv82CA;EAA+B,gBAAA;AL282C/B;;AK182CA;EAAyB,gBAAA;AL882CzB;;AK782CA;EAAyB,gBAAA;ALi92CzB;;AKh92CA;EAAgC,gBAAA;ALo92ChC;;AKn92CA;EAAgC,gBAAA;ALu92ChC;;AKt92CA;EAA8B,gBAAA;AL092C9B;;AKz92CA;EAA8B,gBAAA;AL692C9B;;AK592CA;EAAuB,gBAAA;ALg+2CvB;;AK/92CA;EAAuB,gBAAA;ALm+2CvB;;AKl+2CA;EAA0B,gBAAA;ALs+2C1B;;AKr+2CA;EAA0B,gBAAA;ALy+2C1B;;AKx+2CA;EAAgC,gBAAA;AL4+2ChC;;AK3+2CA;EAAgC,gBAAA;AL++2ChC;;AK9+2CA;EAAyB,gBAAA;ALk/2CzB;;AKj/2CA;EAAyB,gBAAA;ALq/2CzB;;AKp/2CA;EAAuB,gBAAA;ALw/2CvB;;AKv/2CA;EAAuB,gBAAA;AL2/2CvB;;AK1/2CA;EAA6B,gBAAA;AL8/2C7B;;AK7/2CA;EAA6B,gBAAA;ALig3C7B;;AKhg3CA;EAAwB,gBAAA;ALog3CxB;;AKng3CA;EAAwB,gBAAA;ALug3CxB;;AKtg3CA;EAA8B,gBAAA;AL0g3C9B;;AKzg3CA;EAA8B,gBAAA;AL6g3C9B;;AK5g3CA;EAAiC,gBAAA;ALgh3CjC;;AK/g3CA;EAAiC,gBAAA;ALmh3CjC;;AKlh3CA;EAAwB,gBAAA;ALsh3CxB;;AKrh3CA;EAAwB,gBAAA;ALyh3CxB;;AKxh3CA;EAAwB,gBAAA;AL4h3CxB;;AK3h3CA;EAA0B,gBAAA;AL+h3C1B;;AK9h3CA;EAA0B,gBAAA;ALki3C1B;;AKji3CA;EAA0B,gBAAA;ALqi3C1B;;AKpi3CA;EAA0B,gBAAA;ALwi3C1B;;AKvi3CA;EAA0B,gBAAA;AL2i3C1B;;AK1i3CA;EAA0B,gBAAA;AL8i3C1B;;AK7i3CA;EAAwB,gBAAA;ALij3CxB;;AKhj3CA;EAAwB,gBAAA;ALoj3CxB;;AKnj3CA;EAAwB,gBAAA;ALuj3CxB;;AKtj3CA;EAAwB,gBAAA;AL0j3CxB;;AKzj3CA;EAA2B,gBAAA;AL6j3C3B;;AK5j3CA;EAA2B,gBAAA;ALgk3C3B;;AK/j3CA;EAA2B,gBAAA;ALmk3C3B;;AKlk3CA;EAA2B,gBAAA;ALsk3C3B;;AKrk3CA;EAA2B,gBAAA;ALyk3C3B;;AKxk3CA;EAA2B,gBAAA;AL4k3C3B;;AK3k3CA;EAA2B,gBAAA;AL+k3C3B;;AK9k3CA;EAA2B,gBAAA;ALkl3C3B;;AKjl3CA;EAA6B,gBAAA;ALql3C7B;;AKpl3CA;EAA6B,gBAAA;ALwl3C7B;;AKvl3CA;EAAiC,gBAAA;AL2l3CjC;;AK1l3CA;EAAiC,gBAAA;AL8l3CjC;;AK7l3CA;EAA+B,gBAAA;ALim3C/B;;AKhm3CA;EAA+B,gBAAA;ALom3C/B;;AKnm3CA;EAAkC,gBAAA;ALum3ClC;;AKtm3CA;EAAkC,gBAAA;AL0m3ClC;;AKzm3CA;EAAyB,gBAAA;AL6m3CzB;;AK5m3CA;EAAgC,gBAAA;ALgn3ChC;;AK/m3CA;EAAgC,gBAAA;ALmn3ChC;;AKln3CA;EAAiC,gBAAA;ALsn3CjC;;AKrn3CA;EAAiC,gBAAA;ALyn3CjC;;AKxn3CA;EAA8B,gBAAA;AL4n3C9B;;AK3n3CA;EAA8B,gBAAA;AL+n3C9B;;AK9n3CA;EAAiC,gBAAA;ALko3CjC;;AKjo3CA;EAAiC,gBAAA;ALqo3CjC;;AKpo3CA;EAAyB,gBAAA;ALwo3CzB;;AKvo3CA;EAA8B,gBAAA;AL2o3C9B;;AK1o3CA;EAA8B,gBAAA;AL8o3C9B;;AK7o3CA;EAA+B,gBAAA;ALip3C/B;;AKhp3CA;EAA+B,gBAAA;ALop3C/B;;AKnp3CA;EAA8B,gBAAA;ALup3C9B;;AKtp3CA;EAA8B,gBAAA;AL0p3C9B;;AKzp3CA;EAAkC,gBAAA;AL6p3ClC;;AK5p3CA;EAAkC,gBAAA;ALgq3ClC;;AK/p3CA;EAAgC,gBAAA;ALmq3ChC;;AKlq3CA;EAAgC,gBAAA;ALsq3ChC;;AKrq3CA;EAAkC,gBAAA;ALyq3ClC;;AKxq3CA;EAAkC,gBAAA;AL4q3ClC;;AK3q3CA;EAAgC,gBAAA;AL+q3ChC;;AK9q3CA;EAAgC,gBAAA;ALkr3ChC;;AKjr3CA;EAAkC,gBAAA;ALqr3ClC;;AKpr3CA;EAAkC,gBAAA;ALwr3ClC;;AKvr3CA;EAAgC,gBAAA;AL2r3ChC;;AK1r3CA;EAAgC,gBAAA;AL8r3ChC;;AK7r3CA;EAAkC,gBAAA;ALis3ClC;;AKhs3CA;EAAkC,gBAAA;ALos3ClC;;AKns3CA;EAAgC,gBAAA;ALus3ChC;;AKts3CA;EAAgC,gBAAA;AL0s3ChC;;AKzs3CA;EAAgC,gBAAA;AL6s3ChC;;AK5s3CA;EAAgC,gBAAA;ALgt3ChC;;AK/s3CA;EAA8B,gBAAA;ALmt3C9B;;AKlt3CA;EAA8B,gBAAA;ALst3C9B;;AKrt3CA;EAAiC,gBAAA;ALyt3CjC;;AKxt3CA;EAAiC,gBAAA;AL4t3CjC;;AK3t3CA;EAA6B,gBAAA;AL+t3C7B;;AK9t3CA;EAA6B,gBAAA;ALku3C7B;;AKju3CA;EAA0B,gBAAA;ALqu3C1B;;AKpu3CA;EAA0B,gBAAA;ALwu3C1B;;AKvu3CA;EAAwB,gBAAA;AL2u3CxB;;AK1u3CA;EAAyB,gBAAA;AL8u3CzB;;AK7u3CA;EAAuB,gBAAA;ALiv3CvB;;AKhv3CA;EAA2B,gBAAA;ALov3C3B;;AKnv3CA;EAA2B,gBAAA;ALuv3C3B;;AKtv3CA;EAA4B,gBAAA;AL0v3C5B;;AKzv3CA;EAA4B,gBAAA;AL6v3C5B;;AK5v3CA;EAA2B,gBAAA;ALgw3C3B;;AK/v3CA;EAA2B,gBAAA;ALmw3C3B;;AKlw3CA;EAAyB,gBAAA;ALsw3CzB;;AKrw3CA;EAAyB,gBAAA;ALyw3CzB;;AKxw3CA;EAA0B,gBAAA;AL4w3C1B;;AK3w3CA;EAAyB,gBAAA;AL+w3CzB;;AK9w3CA;EAAyB,gBAAA;ALkx3CzB;;AKjx3CA;EAAkC,gBAAA;ALqx3ClC;;AKpx3CA;EAAkC,gBAAA;ALwx3ClC;;AKvx3CA;EAA6B,gBAAA;AL2x3C7B;;AK1x3CA;EAA6B,gBAAA;AL8x3C7B;;AK7x3CA;EAA2B,gBAAA;ALiy3C3B;;AKhy3CA;EAA2B,gBAAA;ALoy3C3B;;AKny3CA;EAAuB,gBAAA;ALuy3CvB;;AKty3CA;EAA4B,gBAAA;AL0y3C5B;;AKzy3CA;EAA4B,gBAAA;AL6y3C5B;;AK5y3CA;EAAwB,gBAAA;ALgz3CxB;;AK/y3CA;EAAwB,gBAAA;ALmz3CxB;;AKlz3CA;EAA0B,gBAAA;ALsz3C1B;;AKrz3CA;EAA0B,gBAAA;ALyz3C1B;;AKxz3CA;EAAiC,gBAAA;AL4z3CjC;;AK3z3CA;EAAiC,gBAAA;AL+z3CjC;;AK9z3CA;EAAuB,gBAAA;ALk03CvB;;AKj03CA;EAAuB,gBAAA;ALq03CvB;;AKp03CA;EAA0B,gBAAA;ALw03C1B;;AKv03CA;EAA0B,gBAAA;AL203C1B;;AK103CA;EAA8B,gBAAA;AL803C9B;;AK703CA;EAA8B,gBAAA;ALi13C9B;;AKh13CA;EAAyB,gBAAA;ALo13CzB;;AKn13CA;EAAyB,gBAAA;ALu13CzB;;AKt13CA;EAA6B,gBAAA;AL013C7B;;AKz13CA;EAA6B,gBAAA;AL613C7B;;AK513CA;EAA0B,gBAAA;ALg23C1B;;AK/13CA;EAA0B,gBAAA;ALm23C1B;;AKl23CA;EAAwB,gBAAA;ALs23CxB;;AKr23CA;EAAwB,gBAAA;ALy23CxB;;AKx23CA;EAA8B,gBAAA;AL423C9B;;AK323CA;EAA8B,gBAAA;AL+23C9B;;AK923CA;EAAyB,gBAAA;ALk33CzB;;AKj33CA;EAAyB,gBAAA;ALq33CzB;;AKp33CA;EAAuB,gBAAA;ALw33CvB;;AKv33CA;EAAuB,gBAAA;AL233CvB;;AK133CA;EAA6B,gBAAA;AL833C7B;;AK733CA;EAA6B,gBAAA;ALi43C7B;;AKh43CA;EAA6B,gBAAA;ALo43C7B;;AKn43CA;EAA6B,gBAAA;ALu43C7B;;AKt43CA;EAA4B,gBAAA;AL043C5B;;AKz43CA;EAA4B,gBAAA;AL643C5B;;AK543CA;EAAmC,gBAAA;ALg53CnC;;AK/43CA;EAAmC,gBAAA;ALm53CnC;;AKl53CA;EAAyC,gBAAA;ALs53CzC;;AKr53CA;EAAyC,gBAAA;ALy53CzC;;AKx53CA;EAAiC,gBAAA;AL453CjC;;AK353CA;EAAiC,gBAAA;AL+53CjC;;AK953CA;EAAyC,gBAAA;ALk63CzC;;AKj63CA;EAAyC,gBAAA;ALq63CzC;;AKp63CA;EAAyB,gBAAA;ALw63CzB;;AKv63CA;EAAyB,gBAAA;AL263CzB;;AK163CA;EAAyB,gBAAA;AL863CzB;;AK763CA;EAAyB,gBAAA;ALi73CzB;;AKh73CA;EAAyB,gBAAA;ALo73CzB;;AKn73CA;EAAyB,gBAAA;ALu73CzB;;AKt73CA;EAAwB,gBAAA;AL073CxB;;AKz73CA;EAAwB,gBAAA;AL673CxB;;AK573CA;EAAyB,gBAAA;ALg83CzB;;AK/73CA;EAAyB,gBAAA;ALm83CzB;;AKl83CA;EAAyB,gBAAA;ALs83CzB;;AKr83CA;EAAyB,gBAAA;ALy83CzB;;AKx83CA;EAA8B,gBAAA;AL483C9B;;AK383CA;EAA8B,gBAAA;AL+83C9B;;AK983CA;EAA6B,gBAAA;ALk93C7B;;AKj93CA;EAA6B,gBAAA;ALq93C7B;;AKp93CA;EAAsB,gBAAA;ALw93CtB;;AKv93CA;EAAsB,gBAAA;AL293CtB;;AK193CA;EAA6B,gBAAA;AL893C7B;;AK793CA;EAA6B,gBAAA;ALi+3C7B;;AKh+3CA;EAAuB,gBAAA;ALo+3CvB;;AKn+3CA;EAAuB,gBAAA;ALu+3CvB;;AKt+3CA;EAA0B,gBAAA;AL0+3C1B;;AKz+3CA;EAA0B,gBAAA;AL6+3C1B;;AK5+3CA;EAAwB,gBAAA;ALg/3CxB;;AK/+3CA;EAAwB,gBAAA;ALm/3CxB;;AKl/3CA;EAAwB,gBAAA;ALs/3CxB;;AKr/3CA;EAAwB,gBAAA;ALy/3CxB;;AKx/3CA;EAAiB,gBAAA;AL4/3CjB;;AK3/3CA;EAAiB,gBAAA;AL+/3CjB;;AK9/3CA;EAAiB,gBAAA;ALkg4CjB;;AKjg4CA;EAAiB,gBAAA;ALqg4CjB;;AKpg4CA;EAAiB,gBAAA;ALwg4CjB;;AKvg4CA;EAAiB,gBAAA;AL2g4CjB;;AK1g4CA;EAAuB,gBAAA;AL8g4CvB;;AK7g4CA;EAAuB,gBAAA;ALih4CvB;;AKhh4CA;EAAyB,gBAAA;ALoh4CzB;;AKnh4CA;EAAyB,gBAAA;ALuh4CzB;;AKth4CA;EAA4B,gBAAA;AL0h4C5B;;AKzh4CA;EAA4B,gBAAA;AL6h4C5B;;AK5h4CA;EAA6B,gBAAA;ALgi4C7B;;AK/h4CA;EAA6B,gBAAA;ALmi4C7B;;AKli4CA;EAAiC,gBAAA;ALsi4CjC;;AKri4CA;EAAiC,gBAAA;ALyi4CjC;;AKxi4CA;EAA0B,gBAAA;AL4i4C1B;;AK3i4CA;EAA0B,gBAAA;AL+i4C1B;;AK9i4CA;EAA+B,gBAAA;ALkj4C/B;;AKjj4CA;EAA+B,gBAAA;ALqj4C/B;;AKpj4CA;EAA6B,gBAAA;ALwj4C7B;;AKvj4CA;EAA6B,gBAAA;AL2j4C7B;;AK1j4CA;EAAqB,gBAAA;AL8j4CrB;;AK7j4CA;EAAyB,gBAAA;ALik4CzB;;AKhk4CA;EAAyB,gBAAA;ALok4CzB;;AKnk4CA;EAAuB,gBAAA;ALuk4CvB;;AKtk4CA;EAAuB,gBAAA;AL0k4CvB;;AKzk4CA;EAAqB,gBAAA;AL6k4CrB;;AK5k4CA;EAAqB,gBAAA;ALgl4CrB;;AK/k4CA;EAAqB,gBAAA;ALml4CrB;;AKll4CA;EAA4B,gBAAA;ALsl4C5B;;AKrl4CA;EAA4B,gBAAA;ALyl4C5B;;AKxl4CA;EAA8B,gBAAA;AL4l4C9B;;AK3l4CA;EAA8B,gBAAA;AL+l4C9B;;AK9l4CA;EAA0B,gBAAA;ALkm4C1B;;AKjm4CA;EAA0B,gBAAA;ALqm4C1B;;AKpm4CA;EAA0B,gBAAA;ALwm4C1B;;AKvm4CA;EAA0B,gBAAA;AL2m4C1B;;AK1m4CA;EAA4B,gBAAA;AL8m4C5B;;AK7m4CA;EAA4B,gBAAA;ALin4C5B;;AKhn4CA;EAAwB,gBAAA;ALon4CxB;;AKnn4CA;EAAwB,gBAAA;ALun4CxB;;AKtn4CA;EAA8B,gBAAA;AL0n4C9B;;AKzn4CA;EAA8B,gBAAA;AL6n4C9B;;AK5n4CA;EAAyB,gBAAA;ALgo4CzB;;AK/n4CA;EAAyB,gBAAA;ALmo4CzB;;AKlo4CA;EAAgC,gBAAA;ALso4ChC;;AKro4CA;EAAgC,gBAAA;ALyo4ChC;;AKxo4CA;EAA0B,gBAAA;AL4o4C1B;;AK3o4CA;EAA0B,gBAAA;AL+o4C1B;;AK9o4CA;EAAyB,gBAAA;ALkp4CzB;;AKjp4CA;EAAyB,gBAAA;ALqp4CzB;;AKpp4CA;EAAyB,gBAAA;ALwp4CzB;;AKvp4CA;EAAyB,gBAAA;AL2p4CzB;;AK1p4CA;EAAyB,gBAAA;AL8p4CzB;;AK7p4CA;EAAyB,gBAAA;ALiq4CzB;;AKhq4CA;EAAyB,gBAAA;ALoq4CzB;;AKnq4CA;EAAyB,gBAAA;ALuq4CzB;;AKtq4CA;EAAyB,gBAAA;AL0q4CzB;;AKzq4CA;EAAyB,gBAAA;AL6q4CzB;;AK5q4CA;EAAyB,gBAAA;ALgr4CzB;;AK/q4CA;EAAyB,gBAAA;ALmr4CzB;;AKlr4CA;EAAyB,gBAAA;ALsr4CzB;;AKrr4CA;EAAyB,gBAAA;ALyr4CzB;;AKxr4CA;EAAuB,gBAAA;AL4r4CvB;;AK3r4CA;EAA4B,gBAAA;AL+r4C5B;;AK9r4CA;EAA4B,gBAAA;ALks4C5B;;AKjs4CA;EAA6B,gBAAA;ALqs4C7B;;AKps4CA;EAA6B,gBAAA;ALws4C7B;;AKvs4CA;EAAuB,gBAAA;AL2s4CvB;;AK1s4CA;EAA+B,gBAAA;AL8s4C/B;;AK7s4CA;EAA+B,gBAAA;ALit4C/B;;AKht4CA;EAA6B,gBAAA;ALot4C7B;;AKnt4CA;EAA6B,gBAAA;ALut4C7B;;AKtt4CA;EAA4B,gBAAA;AL0t4C5B;;AKzt4CA;EAA4B,gBAAA;AL6t4C5B;;AK5t4CA;EAAiC,gBAAA;ALgu4CjC;;AK/t4CA;EAAiC,gBAAA;ALmu4CjC;;AKlu4CA;EAAyB,gBAAA;ALsu4CzB;;AKru4CA;EAAyB,gBAAA;ALyu4CzB;;AKxu4CA;EAA2B,gBAAA;AL4u4C3B;;AK3u4CA;EAA2B,gBAAA;AL+u4C3B;;AK9u4CA;EAA4B,gBAAA;ALkv4C5B;;AKjv4CA;EAA4B,gBAAA;ALqv4C5B;;AKpv4CA;EAAwB,gBAAA;ALwv4CxB;;AKvv4CA;EAAwB,gBAAA;AL2v4CxB;;AK1v4CA;EAA0B,gBAAA;AL8v4C1B;;AK7v4CA;EAA0B,gBAAA;ALiw4C1B;;AKhw4CA;EAAqB,gBAAA;ALow4CrB;;AKnw4CA;EAAqB,gBAAA;ALuw4CrB;;AKtw4CA;EAAwB,gBAAA;AL0w4CxB;;AKzw4CA;EAAwB,gBAAA;AL6w4CxB;;AK5w4CA;EAAqB,gBAAA;ALgx4CrB;;AK/w4CA;EAAqB,gBAAA;ALmx4CrB;;AKlx4CA;EAA0B,gBAAA;ALsx4C1B;;AKrx4CA;EAA0B,gBAAA;ALyx4C1B;;AKxx4CA;EAA4B,gBAAA;AL4x4C5B;;AK3x4CA;EAA4B,gBAAA;AL+x4C5B;;AK9x4CA;EAA6B,gBAAA;ALky4C7B;;AKjy4CA;EAA6B,gBAAA;ALqy4C7B;;AKpy4CA;EAAwB,gBAAA;ALwy4CxB;;AKvy4CA;EAAwB,gBAAA;AL2y4CxB;;AK1y4CA;EAAgC,gBAAA;AL8y4ChC;;AK7y4CA;EAAgC,gBAAA;ALiz4ChC;;AKhz4CA;EAAwB,gBAAA;ALoz4CxB;;AKnz4CA;EAAwB,gBAAA;ALuz4CxB;;AKtz4CA;EAAkC,gBAAA;AL0z4ClC;;AKzz4CA;EAAkC,gBAAA;AL6z4ClC;;AK5z4CA;EAAoC,gBAAA;ALg04CpC;;AK/z4CA;EAAoC,gBAAA;ALm04CpC;;AKl04CA;EAA6B,gBAAA;ALs04C7B;;AKr04CA;EAA6B,gBAAA;ALy04C7B;;AKx04CA;EAAuC,gBAAA;AL404CvC;;AK304CA;EAAuC,gBAAA;AL+04CvC;;AK904CA;EAA8B,gBAAA;ALk14C9B;;AKj14CA;EAA8B,gBAAA;ALq14C9B;;AKp14CA;EAAuC,gBAAA;ALw14CvC;;AKv14CA;EAAuC,gBAAA;AL214CvC;;AK114CA;EAA6B,gBAAA;AL814C7B;;AK714CA;EAA6B,gBAAA;ALi24C7B;;AKh24CA;EAA+B,gBAAA;ALo24C/B;;AKn24CA;EAA+B,gBAAA;ALu24C/B;;AKt24CA;EAA+B,gBAAA;AL024C/B;;AKz24CA;EAAgC,gBAAA;AL624ChC;;AK524CA;EAAiC,gBAAA;ALg34CjC;;AK/24CA;EAA+B,gBAAA;ALm34C/B;;AKl34CA;EAA4B,gBAAA;ALs34C5B;;AKr34CA;EAA4B,gBAAA;ALy34C5B;;AKx34CA;EAA4B,gBAAA;AL434C5B;;AK334CA;EAA0B,gBAAA;AL+34C1B;;AK934CA;EAA0B,gBAAA;ALk44C1B;;AKj44CA;EAA2B,gBAAA;ALq44C3B;;AKp44CA;EAA2B,gBAAA;ALw44C3B;;AKv44CA;EAAoB,gBAAA;AL244CpB;;AK144CA;EAA6B,gBAAA;AL844C7B;;AK744CA;EAA6B,gBAAA;ALi54C7B;;AKh54CA;EAAwB,gBAAA;ALo54CxB;;AKn54CA;EAAwB,gBAAA;ALu54CxB;;AKt54CA;EAAsB,gBAAA;AL054CtB;;AKz54CA;EAAsB,gBAAA;AL654CtB;;AK554CA;EAA+B,gBAAA;ALg64C/B;;AK/54CA;EAA+B,gBAAA;ALm64C/B;;AKl64CA;EAA2B,gBAAA;ALs64C3B;;AKr64CA;EAA2B,gBAAA;ALy64C3B;;AKx64CA;EAA0B,gBAAA;AL464C1B;;AK364CA;EAA0B,gBAAA;AL+64C1B;;AK964CA;EAA8B,gBAAA;ALk74C9B;;AKj74CA;EAA8B,gBAAA;ALq74C9B;;AKp74CA;EAAwB,gBAAA;ALw74CxB;;AKv74CA;EAAwB,gBAAA;AL274CxB;;AK174CA;EAA4B,gBAAA;AL874C5B;;AK774CA;EAA4B,gBAAA;ALi84C5B;;AKh84CA;EAA2B,gBAAA;ALo84C3B;;AKn84CA;EAA2B,gBAAA;ALu84C3B;;AKt84CA;EAA2B,gBAAA;AL084C3B;;AKz84CA;EAA2B,gBAAA;AL684C3B;;AK584CA;EAA2B,gBAAA;ALg94C3B;;AK/84CA;EAA2B,gBAAA;ALm94C3B;;AKl94CA;EAA2B,gBAAA;ALs94C3B;;AKr94CA;EAA2B,gBAAA;ALy94C3B;;AKx94CA;EAA2B,gBAAA;AL494C3B;;AK394CA;EAA2B,gBAAA;AL+94C3B;;AK994CA;EAAkC,gBAAA;ALk+4ClC;;AKj+4CA;EAAkC,gBAAA;ALq+4ClC;;AKp+4CA;EAAgC,gBAAA;ALw+4ChC;;AKv+4CA;EAAgC,gBAAA;AL2+4ChC;;AK1+4CA;EAAgC,gBAAA;AL8+4ChC;;AK7+4CA;EAAgC,gBAAA;ALi/4ChC;;AKh/4CA;EAAyB,gBAAA;ALo/4CzB;;AKn/4CA;EAA8B,gBAAA;ALu/4C9B;;AKt/4CA;EAA8B,gBAAA;AL0/4C9B;;AKz/4CA;EAAgC,gBAAA;AL6/4ChC;;AK5/4CA;EAAgC,gBAAA;ALgg5ChC;;AK//4CA;EAA8B,gBAAA;ALmg5C9B;;AKlg5CA;EAA8B,gBAAA;ALsg5C9B;;AKrg5CA;EAAyB,gBAAA;ALyg5CzB;;AKxg5CA;EAAiC,gBAAA;AL4g5CjC;;AK3g5CA;EAAiC,gBAAA;AL+g5CjC;;AK9g5CA;EAAiC,gBAAA;ALkh5CjC;;AKjh5CA;EAAiC,gBAAA;ALqh5CjC;;AKph5CA;EAA+B,gBAAA;ALwh5C/B;;AKvh5CA;EAA+B,gBAAA;AL2h5C/B;;AK1h5CA;EAA6B,gBAAA;AL8h5C7B;;AK7h5CA;EAA6B,gBAAA;ALii5C7B;;AKhi5CA;EAA+B,gBAAA;ALoi5C/B;;AKni5CA;EAA+B,gBAAA;ALui5C/B;;AKti5CA;EAA6B,gBAAA;AL0i5C7B;;AKzi5CA;EAA6B,gBAAA;AL6i5C7B;;AK5i5CA;EAAuB,gBAAA;ALgj5CvB;;AK/i5CA;EAAuB,gBAAA;ALmj5CvB;;AKlj5CA;EAA2B,gBAAA;ALsj5C3B;;AKrj5CA;EAA2B,gBAAA;ALyj5C3B;;AKxj5CA;EAA4B,gBAAA;AL4j5C5B;;AK3j5CA;EAAkC,gBAAA;AL+j5ClC;;AK9j5CA;EAAkC,gBAAA;ALkk5ClC;;AKjk5CA;EAA4B,gBAAA;ALqk5C5B;;AKpk5CA;EAA6B,gBAAA;ALwk5C7B;;AKvk5CA;EAA6B,gBAAA;AL2k5C7B;;AK1k5CA;EAAuB,gBAAA;AL8k5CvB;;AK7k5CA;EAAyB,gBAAA;ALil5CzB;;AKhl5CA;EAAuB,gBAAA;ALol5CvB;;AKnl5CA;EAAoB,gBAAA;ALul5CpB;;AKtl5CA;EAA2B,gBAAA;AL0l5C3B;;AKzl5CA;EAAyB,gBAAA;AL6l5CzB;;AK5l5CA;EAAkB,gBAAA;ALgm5ClB;;AK/l5CA;EAA+B,gBAAA;ALmm5C/B;;AKlm5CA;EAA+B,gBAAA;ALsm5C/B;;AKrm5CA;EAA2B,gBAAA;ALym5C3B;;AKxm5CA;EAA2B,gBAAA;AL4m5C3B;;AK3m5CA;EAAwB,gBAAA;AL+m5CxB;;AK9m5CA;EAAwB,gBAAA;ALkn5CxB;;AKjn5CA;EAA0B,gBAAA;ALqn5C1B;;AKpn5CA;EAAwB,gBAAA;ALwn5CxB;;AKvn5CA;EAA0B,gBAAA;AL2n5C1B;;AK1n5CA;EAAgC,gBAAA;AL8n5ChC;;AK7n5CA;EAAgC,gBAAA;ALio5ChC;;AKho5CA;EAA4B,gBAAA;ALoo5C5B;;AKno5CA;EAAuB,gBAAA;ALuo5CvB;;AKto5CA;EAAuB,gBAAA;AL0o5CvB;;AKzo5CA;EAA2B,gBAAA;AL6o5C3B;;AK5o5CA;EAA2B,gBAAA;ALgp5C3B;;AK/o5CA;EAA2B,gBAAA;ALmp5C3B;;AKlp5CA;EAA2B,gBAAA;ALsp5C3B;;AKrp5CA;EAA2B,gBAAA;ALyp5C3B;;AKxp5CA;EAA2B,gBAAA;AL4p5C3B;;AK3p5CA;EAA2B,gBAAA;AL+p5C3B;;AK9p5CA;EAA2B,gBAAA;ALkq5C3B;;AKjq5CA;EAAyB,gBAAA;ALqq5CzB;;AKpq5CA;EAAyB,gBAAA;ALwq5CzB;;AKvq5CA;EAAyB,gBAAA;AL2q5CzB;;AK1q5CA;EAAyB,gBAAA;AL8q5CzB;;AK7q5CA;EAAuB,gBAAA;ALir5CvB;;AKhr5CA;EAAuB,gBAAA;ALor5CvB;;AKnr5CA;EAAgC,gBAAA;ALur5ChC;;AKtr5CA;EAAgC,gBAAA;AL0r5ChC;;AKzr5CA;EAA8B,gBAAA;AL6r5C9B;;AK5r5CA;EAA8B,gBAAA;ALgs5C9B;;AK/r5CA;EAA4B,gBAAA;ALms5C5B;;AKls5CA;EAA4B,gBAAA;ALss5C5B;;AKrs5CA;EAA+B,gBAAA;ALys5C/B;;AKxs5CA;EAA+B,gBAAA;AL4s5C/B;;AK3s5CA;EAA6B,gBAAA;AL+s5C7B;;AK9s5CA;EAA6B,gBAAA;ALkt5C7B;;AKjt5CA;EAA+B,gBAAA;ALqt5C/B;;AKpt5CA;EAA+B,gBAAA;ALwt5C/B;;AKvt5CA;EAAgC,gBAAA;AL2t5ChC;;AK1t5CA;EAAgC,gBAAA;AL8t5ChC;;AK7t5CA;EAAkC,gBAAA;ALiu5ClC;;AKhu5CA;EAAkC,gBAAA;ALou5ClC;;AKnu5CA;EAA+B,gBAAA;ALuu5C/B;;AKtu5CA;EAA+B,gBAAA;AL0u5C/B;;AKzu5CA;EAAkC,gBAAA;AL6u5ClC;;AK5u5CA;EAAkC,gBAAA;ALgv5ClC;;AK/u5CA;EAAwB,gBAAA;ALmv5CxB;;AKlv5CA;EAAwB,gBAAA;ALsv5CxB;;AKrv5CA;EAAsB,gBAAA;ALyv5CtB;;AKxv5CA;EAAsB,gBAAA;AL4v5CtB;;AK3v5CA;EAA0B,gBAAA;AL+v5C1B;;AK9v5CA;EAA0B,gBAAA;ALkw5C1B;;AKjw5CA;EAAwB,gBAAA;ALqw5CxB;;AKpw5CA;EAAwB,gBAAA;ALww5CxB;;AKvw5CA;EAA2B,gBAAA;AL2w5C3B;;AK1w5CA;EAA2B,gBAAA;AL8w5C3B;;AK7w5CA;EAA6B,gBAAA;ALix5C7B;;AKhx5CA;EAA6B,gBAAA;ALox5C7B;;AKnx5CA;EAA6B,gBAAA;ALux5C7B;;AKtx5CA;EAA6B,gBAAA;AL0x5C7B;;AKzx5CA;EAAgC,gBAAA;AL6x5ChC;;AK5x5CA;EAAgC,gBAAA;ALgy5ChC;;AK/x5CA;EAAuB,gBAAA;ALmy5CvB;;AKly5CA;EAA8B,gBAAA;ALsy5C9B;;AKry5CA;EAA8B,gBAAA;ALyy5C9B;;AKxy5CA;EAAuB,gBAAA;AL4y5CvB;;AK3y5CA;EAA4B,gBAAA;AL+y5C5B;;AK9y5CA;EAA4B,gBAAA;ALkz5C5B;;AKjz5CA;EAA4B,gBAAA;ALqz5C5B;;AKpz5CA;EAA4B,gBAAA;ALwz5C5B;;AKvz5CA;EAA4B,gBAAA;AL2z5C5B;;AK1z5CA;EAA4B,gBAAA;AL8z5C5B;;AK7z5CA;EAAgC,gBAAA;ALi05ChC;;AKh05CA;EAAgC,gBAAA;ALo05ChC;;AKn05CA;EAA4B,gBAAA;ALu05C5B;;AKt05CA;EAA4B,gBAAA;AL005C5B;;AKz05CA;EAA8B,gBAAA;AL605C9B;;AK505CA;EAA8B,gBAAA;ALg15C9B;;AK/05CA;EAA8B,gBAAA;ALm15C9B;;AKl15CA;EAA8B,gBAAA;ALs15C9B;;AKr15CA;EAAwB,gBAAA;ALy15CxB;;AKx15CA;EAAwB,gBAAA;AL415CxB;;AK315CA;EAAsB,gBAAA;AL+15CtB;;AK915CA;EAAsB,gBAAA;ALk25CtB;;AKj25CA;EAA4B,gBAAA;ALq25C5B;;AKp25CA;EAA4B,gBAAA;ALw25C5B;;AKv25CA;EAA4B,gBAAA;AL225C5B;;AK125CA;EAA4B,gBAAA;AL825C5B;;AK725CA;EAA4B,gBAAA;ALi35C5B;;AKh35CA;EAA4B,gBAAA;ALo35C5B;;AKn35CA;EAA4B,gBAAA;ALu35C5B;;AKt35CA;EAA4B,gBAAA;AL035C5B;;AKz35CA;EAA8B,gBAAA;AL635C9B;;AK535CA;EAA8B,gBAAA;ALg45C9B;;AK/35CA;EAA0B,gBAAA;ALm45C1B;;AKl45CA;EAA0B,gBAAA;ALs45C1B;;AKr45CA;EAAgC,gBAAA;ALy45ChC;;AKx45CA;EAAgC,gBAAA;AL445ChC;;AK345CA;EAA+B,gBAAA;AL+45C/B;;AK945CA;EAA+B,gBAAA;ALk55C/B;;AKj55CA;EAA+B,gBAAA;ALq55C/B;;AKp55CA;EAA+B,gBAAA;ALw55C/B;;AKv55CA;EAA2B,gBAAA;AL255C3B;;AK155CA;EAA2B,gBAAA;AL855C3B;;AK755CA;EAA2B,gBAAA;ALi65C3B;;AKh65CA;EAA2B,gBAAA;ALo65C3B;;AKn65CA;EAAyB,gBAAA;ALu65CzB;;AKt65CA;EAAyB,gBAAA;AL065CzB;;AKz65CA;EAA6B,gBAAA;AL665C7B;;AK565CA;EAA6B,gBAAA;ALg75C7B;;AK/65CA;EAA2B,gBAAA;ALm75C3B;;AKl75CA;EAA2B,gBAAA;ALs75C3B;;AKr75CA;EAA0B,gBAAA;ALy75C1B;;AKx75CA;EAA0B,gBAAA;AL475C1B;;AK375CA;EAAwB,gBAAA;AL+75CxB;;AK975CA;EAAwB,gBAAA;ALk85CxB;;AKj85CA;EAAkC,gBAAA;ALq85ClC;;AKp85CA;EAAkC,gBAAA;ALw85ClC;;AKv85CA;EAAyB,gBAAA;AL285CzB;;AK185CA;EAAyB,gBAAA;AL885CzB;;AK785CA;EAAsB,gBAAA;ALi95CtB;;AKh95CA;EAAsB,gBAAA;ALo95CtB;;AKn95CA;EAAgC,gBAAA;ALu95ChC;;AKt95CA;EAAgC,gBAAA;AL095ChC;;AKz95CA;EAAyB,gBAAA;AL695CzB;;AK595CA;EAAyB,gBAAA;ALg+5CzB;;AK/95CA;EAAyB,gBAAA;ALm+5CzB;;AKl+5CA;EAAyB,gBAAA;ALs+5CzB;;AKr+5CA;EAAyB,gBAAA;ALy+5CzB;;AKx+5CA;EAAyB,gBAAA;AL4+5CzB;;AK3+5CA;EAAyB,gBAAA;AL++5CzB;;AK9+5CA;EAAyB,gBAAA;ALk/5CzB;;AKj/5CA;EAA2B,gBAAA;ALq/5C3B;;AKp/5CA;EAA2B,gBAAA;ALw/5C3B;;AKv/5CA;EAAuB,gBAAA;AL2/5CvB;;AK1/5CA;EAA4B,gBAAA;AL8/5C5B;;AK7/5CA;EAA4B,gBAAA;ALig6C5B;;AKhg6CA;EAAuB,gBAAA;ALog6CvB;;AKng6CA;EAA8B,gBAAA;ALug6C9B;;AKtg6CA;EAA8B,gBAAA;AL0g6C9B;;AKzg6CA;EAAoC,gBAAA;AL6g6CpC;;AK5g6CA;EAAkC,gBAAA;ALgh6ClC;;AK/g6CA;EAA4B,gBAAA;ALmh6C5B;;AKlh6CA;EAA4B,gBAAA;ALsh6C5B;;AKrh6CA;EAA4B,gBAAA;ALyh6C5B;;AKxh6CA;EAA4B,gBAAA;AL4h6C5B;;AK3h6CA;EAA0B,gBAAA;AL+h6C1B;;AK9h6CA;EAA0B,gBAAA;ALki6C1B;;AKji6CA;EAA4B,gBAAA;ALqi6C5B;;AKpi6CA;EAA4B,gBAAA;ALwi6C5B;;AKvi6CA;EAAyB,gBAAA;AL2i6CzB;;AK1i6CA;EAAyB,gBAAA;AL8i6CzB;;AK7i6CA;EAAwB,gBAAA;ALij6CxB;;AKhj6CA;EAAwB,gBAAA;ALoj6CxB;;AKnj6CA;EAAsB,gBAAA;ALuj6CtB;;AKtj6CA;EAAsB,gBAAA;AL0j6CtB;;AKzj6CA;EAA0B,gBAAA;AL6j6C1B;;AK5j6CA;EAA0B,gBAAA;ALgk6C1B;;AK/j6CA;EAAyB,gBAAA;ALmk6CzB;;AKlk6CA;EAAyB,gBAAA;ALsk6CzB;;AKrk6CA;EAA6B,gBAAA;ALyk6C7B;;AKxk6CA;EAA6B,gBAAA;AL4k6C7B;;AK3k6CA;EAA4B,gBAAA;AL+k6C5B;;AK9k6CA;EAA4B,gBAAA;ALkl6C5B;;AKjl6CA;EAAsB,gBAAA;ALql6CtB;;AKpl6CA;EAA+B,gBAAA;ALwl6C/B;;AKvl6CA;EAA+B,gBAAA;AL2l6C/B;;AK1l6CA;EAAuB,gBAAA;AL8l6CvB;;AK7l6CA;EAAuB,gBAAA;ALim6CvB;;AKhm6CA;EAAgC,gBAAA;ALom6ChC;;AKnm6CA;EAAgC,gBAAA;ALum6ChC;;AKtm6CA;EAAmC,gBAAA;AL0m6CnC;;AKzm6CA;EAAmC,gBAAA;AL6m6CnC;;AK5m6CA;EAAmC,gBAAA;ALgn6CnC;;AK/m6CA;EAAmC,gBAAA;ALmn6CnC;;AKln6CA;EAAsC,gBAAA;ALsn6CtC;;AKrn6CA;EAAsC,gBAAA;ALyn6CtC;;AKxn6CA;EAAiC,gBAAA;AL4n6CjC;;AK3n6CA;EAAiC,gBAAA;AL+n6CjC;;AK9n6CA;EAAoC,gBAAA;ALko6CpC;;AKjo6CA;EAAoC,gBAAA;ALqo6CpC;;AKpo6CA;EAAkC,gBAAA;ALwo6ClC;;AKvo6CA;EAAkC,gBAAA;AL2o6ClC;;AK1o6CA;EAAqC,gBAAA;AL8o6CrC;;AK7o6CA;EAAqC,gBAAA;ALip6CrC;;AKhp6CA;EAA6B,gBAAA;ALop6C7B;;AKnp6CA;EAA6B,gBAAA;ALup6C7B;;AKtp6CA;EAA8B,gBAAA;AL0p6C9B;;AKzp6CA;EAA8B,gBAAA;AL6p6C9B;;AK5p6CA;EAAuB,gBAAA;ALgq6CvB;;AK/p6CA;EAA6B,gBAAA;ALmq6C7B;;AKlq6CA;EAA6B,gBAAA;ALsq6C7B;;AKrq6CA;EAAuB,gBAAA;ALyq6CvB;;AKxq6CA;EAAyB,gBAAA;AL4q6CzB;;AK3q6CA;EAAyB,gBAAA;AL+q6CzB;;AK9q6CA;EAAuB,gBAAA;ALkr6CvB;;AKjr6CA;EAAuB,gBAAA;ALqr6CvB;;AKpr6CA;EAA4B,gBAAA;ALwr6C5B;;AKvr6CA;EAA4B,gBAAA;AL2r6C5B;;AK1r6CA;EAAwB,gBAAA;AL8r6CxB;;AK7r6CA;EAAwB,gBAAA;ALis6CxB;;AKhs6CA;EAA0B,gBAAA;ALos6C1B;;AKns6CA;EAA0B,gBAAA;ALus6C1B;;AKts6CA;EAAwB,gBAAA;AL0s6CxB;;AKzs6CA;EAAwB,gBAAA;AL6s6CxB;;AK5s6CA;EAA0B,gBAAA;ALgt6C1B;;AK/s6CA;EAA0B,gBAAA;ALmt6C1B;;AKlt6CA;EAAwB,gBAAA;ALst6CxB;;AKrt6CA;EAAwB,gBAAA;ALyt6CxB;;AKxt6CA;EAAqB,gBAAA;AL4t6CrB;;AK3t6CA;EAAqB,gBAAA;AL+t6CrB;;AK9t6CA;EAA6B,gBAAA;ALku6C7B;;AKju6CA;EAA6B,gBAAA;ALqu6C7B;;AKpu6CA;EAAsC,gBAAA;ALwu6CtC;;AKvu6CA;EAAsC,gBAAA;AL2u6CtC;;AK1u6CA;EAA0B,gBAAA;AL8u6C1B;;AK7u6CA;EAA0B,gBAAA;ALiv6C1B;;AKhv6CA;EAA4B,gBAAA;ALov6C5B;;AKnv6CA;EAA4B,gBAAA;ALuv6C5B;;AKtv6CA;EAAuB,gBAAA;AL0v6CvB;;AKzv6CA;EAAiC,gBAAA;AL6v6CjC;;AK5v6CA;EAAiC,gBAAA;ALgw6CjC;;AK/v6CA;EAAiC,gBAAA;ALmw6CjC;;AKlw6CA;EAAiC,gBAAA;ALsw6CjC;;AKrw6CA;EAAiC,gBAAA;ALyw6CjC;;AKxw6CA;EAAiC,gBAAA;AL4w6CjC;;AK3w6CA;EAAqC,gBAAA;AL+w6CrC;;AK9w6CA;EAAqC,gBAAA;ALkx6CrC;;AKjx6CA;EAA+B,gBAAA;ALqx6C/B;;AKpx6CA;EAA+B,gBAAA;ALwx6C/B;;AKvx6CA;EAAmC,gBAAA;AL2x6CnC;;AK1x6CA;EAAmC,gBAAA;AL8x6CnC;;AK7x6CA;EAAwB,gBAAA;ALiy6CxB;;AKhy6CA;EAAwB,gBAAA;ALoy6CxB;;AKny6CA;EAAsB,gBAAA;ALuy6CtB;;AKty6CA;EAAsB,gBAAA;AL0y6CtB;;AKzy6CA;EAAsB,gBAAA;AL6y6CtB;;AK5y6CA;EAAsB,gBAAA;ALgz6CtB;;AK/y6CA;EAAsB,gBAAA;ALmz6CtB;;AKlz6CA;EAAsB,gBAAA;ALsz6CtB;;AKrz6CA;EAAsB,gBAAA;ALyz6CtB;;AKxz6CA;EAAsB,gBAAA;AL4z6CtB;;AK3z6CA;EAAsB,gBAAA;AL+z6CtB;;AK9z6CA;EAAsB,gBAAA;ALk06CtB;;AKj06CA;EAA0B,gBAAA;ALq06C1B;;AKp06CA;EAA0B,gBAAA;ALw06C1B;;AKv06CA;EAAwB,gBAAA;AL206CxB;;AK106CA;EAAwB,gBAAA;AL806CxB;;AK706CA;EAAsB,gBAAA;ALi16CtB;;AKh16CA;EAAsB,gBAAA;ALo16CtB;;AKn16CA;EAAmB,gBAAA;ALu16CnB;;AKt16CA;EAA2B,gBAAA;AL016C3B;;AKz16CA;EAA2B,gBAAA;AL616C3B;;AK516CA;EAA8B,gBAAA;ALg26C9B;;AK/16CA;EAA8B,gBAAA;ALm26C9B;;AKl26CA;EAAwB,gBAAA;ALs26CxB;;AKr26CA;EAAwB,gBAAA;ALy26CxB;;AKx26CA;EAA6B,gBAAA;AL426C7B;;AK326CA;EAA6B,gBAAA;AL+26C7B;;AK926CA;EAAgC,gBAAA;ALk36ChC;;AKj36CA;EAA2B,gBAAA;ALq36C3B;;AKp36CA;EAA2B,gBAAA;ALw36C3B;;AKv36CA;EAAyB,gBAAA;AL236CzB;;AK136CA;EAAyB,gBAAA;AL836CzB;;AK736CA;EAA4B,gBAAA;ALi46C5B;;AKh46CA;EAAwB,gBAAA;ALo46CxB;;AKn46CA;EAAwB,gBAAA;ALu46CxB;;AKt46CA;EAA8B,gBAAA;AL046C9B;;AKz46CA;EAA8B,gBAAA;AL646C9B;;AK546CA;EAAwB,gBAAA;ALg56CxB;;AK/46CA;EAAwB,gBAAA;ALm56CxB;;AKl56CA;EAA0B,gBAAA;ALs56C1B;;AKr56CA;EAA0B,gBAAA;ALy56C1B;;AKx56CA;EAA0B,gBAAA;AL456C1B;;AK356CA;EAA0B,gBAAA;AL+56C1B;;AK956CA;EAAuB,gBAAA;ALk66CvB;;AKj66CA;EAAyB,gBAAA;ALq66CzB;;AKp66CA;EAAyB,gBAAA;ALw66CzB;;AKv66CA;EAA8B,gBAAA;AL266C9B;;AK166CA;EAA8B,gBAAA;AL866C9B;;AK766CA;EAA8B,gBAAA;ALi76C9B;;AKh76CA;EAA8B,gBAAA;ALo76C9B;;AKn76CA;EAA0B,gBAAA;ALu76C1B;;AKt76CA;EAA0B,gBAAA;AL076C1B;;AKz76CA;EAA2B,gBAAA;AL676C3B;;AK576CA;EAA2B,gBAAA;ALg86C3B;;AK/76CA;EAA0B,gBAAA;ALm86C1B;;AKl86CA;EAA0B,gBAAA;ALs86C1B;;AKr86CA;EAA+B,gBAAA;ALy86C/B;;AKx86CA;EAA+B,gBAAA;AL486C/B;;AK386CA;EAAwB,gBAAA;AL+86CxB;;AK986CA;EAAwB,gBAAA;ALk96CxB;;AKj96CA;EAA6B,gBAAA;ALq96C7B;;AKp96CA;EAA6B,gBAAA;ALw96C7B;;AKv96CA;EAAyB,gBAAA;AL296CzB;;AK196CA;EAAyB,gBAAA;AL896CzB;;AK796CA;EAA0B,gBAAA;ALi+6C1B;;AKh+6CA;EAA0B,gBAAA;ALo+6C1B;;AKn+6CA;EAAyB,gBAAA;ALu+6CzB;;AKt+6CA;EAAyB,gBAAA;AL0+6CzB;;AKz+6CA;EAAiC,gBAAA;AL6+6CjC;;AK5+6CA;EAAiC,gBAAA;ALg/6CjC;;AK/+6CA;EAA+B,gBAAA;ALm/6C/B;;AKl/6CA;EAA+B,gBAAA;ALs/6C/B;;AKr/6CA;EAA0B,gBAAA;ALy/6C1B;;AKx/6CA;EAA0B,gBAAA;AL4/6C1B;;AK3/6CA;EAA+B,gBAAA;AL+/6C/B;;AK9/6CA;EAA+B,gBAAA;ALkg7C/B;;AKjg7CA;EAAwB,gBAAA;ALqg7CxB;;AKpg7CA;EAA6B,gBAAA;ALwg7C7B;;AKvg7CA;EAA6B,gBAAA;AL2g7C7B;;AK1g7CA;EAAwB,gBAAA;AL8g7CxB;;AK7g7CA;EAA6B,gBAAA;ALih7C7B;;AKhh7CA;EAA6B,gBAAA;ALoh7C7B;;AKnh7CA;EAAuC,gBAAA;ALuh7CvC;;AKth7CA;EAAuC,gBAAA;AL0h7CvC;;AKzh7CA;EAA0C,gBAAA;AL6h7C1C;;AK5h7CA;EAA0C,gBAAA;ALgi7C1C;;AK/h7CA;EAAqC,gBAAA;ALmi7CrC;;AKli7CA;EAAqC,gBAAA;ALsi7CrC;;AKri7CA;EAA8B,gBAAA;ALyi7C9B;;AKxi7CA;EAA8B,gBAAA;AL4i7C9B;;AK3i7CA;EAAgC,gBAAA;AL+i7ChC;;AK9i7CA;EAAgC,gBAAA;ALkj7ChC;;AKjj7CA;EAA4B,gBAAA;ALqj7C5B;;AKpj7CA;EAA4B,gBAAA;ALwj7C5B;;AKvj7CA;EAA+B,gBAAA;AL2j7C/B;;AK1j7CA;EAA+B,gBAAA;AL8j7C/B;;AK7j7CA;EAA4B,gBAAA;ALik7C5B;;AKhk7CA;EAA4B,gBAAA;ALok7C5B;;AKnk7CA;EAA4B,gBAAA;ALuk7C5B;;AKtk7CA;EAA4B,gBAAA;AL0k7C5B;;AKzk7CA;EAA0B,gBAAA;AL6k7C1B;;AK5k7CA;EAA2B,gBAAA;ALgl7C3B;;AK/k7CA;EAA2B,gBAAA;ALml7C3B;;AKll7CA;EAAwB,gBAAA;ALsl7CxB;;AKrl7CA;EAAwB,gBAAA;ALyl7CxB;;AKxl7CA;EAAwB,gBAAA;AL4l7CxB;;AK3l7CA;EAAwB,gBAAA;AL+l7CxB;;AK9l7CA;EAA8B,gBAAA;ALkm7C9B;;AKjm7CA;EAA8B,gBAAA;ALqm7C9B;;AKpm7CA;EAAuB,gBAAA;ALwm7CvB;;AKvm7CA;EAAuB,gBAAA;AL2m7CvB;;AK1m7CA;EAA8B,gBAAA;AL8m7C9B;;AK7m7CA;EAA8B,gBAAA;ALin7C9B;;AKhn7CA;EAAgC,gBAAA;ALon7ChC;;AKnn7CA;EAAgC,gBAAA;ALun7ChC;;AKtn7CA;EAA4B,gBAAA;AL0n7C5B;;AKzn7CA;EAA4B,gBAAA;AL6n7C5B;;AK5n7CA;EAA4B,gBAAA;ALgo7C5B;;AK/n7CA;EAA4B,gBAAA;ALmo7C5B;;AKlo7CA;EAA8B,gBAAA;ALso7C9B;;AKro7CA;EAA8B,gBAAA;ALyo7C9B;;AKxo7CA;EAAyB,gBAAA;AL4o7CzB;;AK3o7CA;EAAyB,gBAAA;AL+o7CzB;;AK9o7CA;EAAuB,gBAAA;ALkp7CvB;;AKjp7CA;EAAuB,gBAAA;ALqp7CvB;;AKpp7CA;EAA6B,gBAAA;ALwp7C7B;;AKvp7CA;EAA6B,gBAAA;AL2p7C7B;;AK1p7CA;EAA2B,gBAAA;AL8p7C3B;;AK7p7CA;EAA2B,gBAAA;ALiq7C3B;;AKhq7CA;EAA6B,gBAAA;ALoq7C7B;;AKnq7CA;EAA6B,gBAAA;ALuq7C7B;;AKtq7CA;EAA8B,gBAAA;AL0q7C9B;;AKzq7CA;EAA8B,gBAAA;AL6q7C9B;;AK5q7CA;EAA8B,gBAAA;ALgr7C9B;;AK/q7CA;EAA8B,gBAAA;ALmr7C9B;;AKlr7CA;EAA4B,gBAAA;ALsr7C5B;;AKrr7CA;EAA4B,gBAAA;ALyr7C5B;;AKxr7CA;EAAgC,gBAAA;AL4r7ChC;;AK3r7CA;EAAgC,gBAAA;AL+r7ChC;;AK9r7CA;EAA0B,gBAAA;ALks7C1B;;AKjs7CA;EAA0B,gBAAA;ALqs7C1B;;AKps7CA;EAA+B,gBAAA;ALws7C/B;;AKvs7CA;EAA+B,gBAAA;AL2s7C/B;;AK1s7CA;EAA0B,gBAAA;AL8s7C1B;;AK7s7CA;EAA0B,gBAAA;ALit7C1B;;AKht7CA;EAA8B,gBAAA;ALot7C9B;;AKnt7CA;EAA8B,gBAAA;ALut7C9B;;AKtt7CA;EAA4B,gBAAA;AL0t7C5B;;AKzt7CA;EAA4B,gBAAA;AL6t7C5B;;AK5t7CA;EAAgC,gBAAA;ALgu7ChC;;AK/t7CA;EAAgC,gBAAA;ALmu7ChC;;AKlu7CA;EAAwB,gBAAA;ALsu7CxB;;AKru7CA;EAAwB,gBAAA;ALyu7CxB;;AKxu7CA;EAA4B,gBAAA;AL4u7C5B;;AK3u7CA;EAA4B,gBAAA;AL+u7C5B;;AK9u7CA;EAA0B,gBAAA;ALkv7C1B;;AKjv7CA;EAA0B,gBAAA;ALqv7C1B;;AKpv7CA;EAAqB,gBAAA;ALwv7CrB;;AKvv7CA;EAAqB,gBAAA;AL2v7CrB;;AK1v7CA;EAA0B,gBAAA;AL8v7C1B;;AK7v7CA;EAA0B,gBAAA;ALiw7C1B;;AKhw7CA;EAA4B,gBAAA;ALow7C5B;;AKnw7CA;EAA4B,gBAAA;ALuw7C5B;;AKtw7CA;EAA0B,gBAAA;AL0w7C1B;;AKzw7CA;EAA0B,gBAAA;AL6w7C1B;;AK5w7CA;EAAkC,gBAAA;ALgx7ClC;;AK/w7CA;EAAkC,gBAAA;ALmx7ClC;;AKlx7CA;EAA2B,gBAAA;ALsx7C3B;;AKrx7CA;EAA2B,gBAAA;ALyx7C3B;;AKxx7CA;EAA2B,gBAAA;AL4x7C3B;;AK3x7CA;EAAgC,gBAAA;AL+x7ChC;;AK9x7CA;EAAgC,gBAAA;ALky7ChC;;AKjy7CA;EAA4B,gBAAA;ALqy7C5B;;AKpy7CA;EAA4B,gBAAA;ALwy7C5B;;AKvy7CA;EAAwB,gBAAA;AL2y7CxB;;AK1y7CA;EAAwB,gBAAA;AL8y7CxB;;AK7y7CA;EAA0B,gBAAA;ALiz7C1B;;AKhz7CA;EAA0B,gBAAA;ALoz7C1B;;AKnz7CA;EAA+B,gBAAA;ALuz7C/B;;AKtz7CA;EAA+B,gBAAA;AL0z7C/B;;AKzz7CA;EAAwB,gBAAA;AL6z7CxB;;AK5z7CA;EAAwB,gBAAA;ALg07CxB;;AK/z7CA;EAA0B,gBAAA;ALm07C1B;;AKl07CA;EAA0B,gBAAA;ALs07C1B;;AKr07CA;EAAwB,gBAAA;ALy07CxB;;AKx07CA;EAAwB,gBAAA;AL407CxB;;AK307CA;EAA0B,gBAAA;AL+07C1B;;AK907CA;EAA0B,gBAAA;ALk17C1B;;AKj17CA;EAAgC,gBAAA;ALq17ChC;;AKp17CA;EAAgC,gBAAA;ALw17ChC;;AKv17CA;EAA8B,gBAAA;AL217C9B;;AK117CA;EAA8B,gBAAA;AL817C9B;;AK717CA;EAA0B,gBAAA;ALi27C1B;;AKh27CA;EAA0B,gBAAA;ALo27C1B;;AKn27CA;EAA6B,gBAAA;ALu27C7B;;AKt27CA;EAA6B,gBAAA;AL027C7B;;AKz27CA;EAAyB,gBAAA;AL627CzB;;AK527CA;EAAyB,gBAAA;ALg37CzB;;AK/27CA;EAA0B,gBAAA;ALm37C1B;;AKl37CA;EAA0B,gBAAA;ALs37C1B;;AKr37CA;EAA2B,gBAAA;ALy37C3B;;AKx37CA;EAA2B,gBAAA;AL437C3B;;AK337CA;EAAyB,gBAAA;AL+37CzB;;AK937CA;EAAyB,gBAAA;ALk47CzB;;AKj47CA;EAA6B,gBAAA;ALq47C7B;;AKp47CA;EAA6B,gBAAA;ALw47C7B;;AKv47CA;EAA4B,gBAAA;AL247C5B;;AK147CA;EAA4B,gBAAA;AL847C5B;;AK747CA;EAAmC,gBAAA;ALi57CnC;;AKh57CA;EAAmC,gBAAA;ALo57CnC;;AKn57CA;EAAiC,gBAAA;ALu57CjC;;AKt57CA;EAAiC,gBAAA;AL057CjC;;AKz57CA;EAA2B,gBAAA;AL657C3B;;AK557CA;EAA2B,gBAAA;ALg67C3B;;AK/57CA;EAAyB,gBAAA;ALm67CzB;;AKl67CA;EAAyB,gBAAA;ALs67CzB;;AKr67CA;EAA6B,gBAAA;ALy67C7B;;AKx67CA;EAA6B,gBAAA;AL467C7B;;AK367CA;EAA4B,gBAAA;AL+67C5B;;AK967CA;EAA4B,gBAAA;ALk77C5B;;AKj77CA;EAAwB,gBAAA;ALq77CxB;;AKp77CA;EAAwB,gBAAA;ALw77CxB;;AKv77CA;EAA2B,gBAAA;AL277C3B;;AK177CA;EAA2B,gBAAA;AL877C3B;;AK777CA;EAA4B,gBAAA;ALi87C5B;;AKh87CA;EAA4B,gBAAA;ALo87C5B;;AKn87CA;EAA0B,gBAAA;ALu87C1B;;AKt87CA;EAA0B,gBAAA;AL087C1B;;AKz87CA;EAA+B,gBAAA;AL687C/B;;AK587CA;EAA+B,gBAAA;ALg97C/B;;AK/87CA;EAA6B,gBAAA;ALm97C7B;;AKl97CA;EAA6B,gBAAA;ALs97C7B;;AKr97CA;EAAyB,gBAAA;ALy97CzB;;AKx97CA;EAAyB,gBAAA;AL497CzB;;AK397CA;EAA8B,gBAAA;AL+97C9B;;AK997CA;EAA8B,gBAAA;ALk+7C9B;;AKj+7CA;EAAyB,gBAAA;ALq+7CzB;;AKp+7CA;EAAyB,gBAAA;ALw+7CzB;;AKv+7CA;EAAyB,gBAAA;AL2+7CzB;;AK1+7CA;EAAyB,gBAAA;AL8+7CzB;;AK7+7CA;EAA2B,gBAAA;ALi/7C3B;;AKh/7CA;EAA2B,gBAAA;ALo/7C3B;;AKn/7CA;EAA2B,gBAAA;ALu/7C3B;;AKt/7CA;EAA2B,gBAAA;AL0/7C3B;;AKz/7CA;EAAwB,gBAAA;AL6/7CxB;;AK5/7CA;EAAwB,gBAAA;ALgg8CxB;;AK//7CA;EAA2B,gBAAA;ALmg8C3B;;AKlg8CA;EAA2B,gBAAA;ALsg8C3B;;AKrg8CA;EAAyB,gBAAA;ALyg8CzB;;AKxg8CA;EAAyB,gBAAA;AL4g8CzB;;AK3g8CA;EAA8B,gBAAA;AL+g8C9B;;AK9g8CA;EAA8B,gBAAA;ALkh8C9B;;AKjh8CA;EAA4B,gBAAA;ALqh8C5B;;AKph8CA;EAAwB,gBAAA;ALwh8CxB;;AKvh8CA;EAAwB,gBAAA;AL2h8CxB;;AK1h8CA;EAAyB,gBAAA;AL8h8CzB;;AK7h8CA;EAAyB,gBAAA;ALii8CzB;;AKhi8CA;EAAsB,gBAAA;ALoi8CtB;;AKni8CA;EAAsB,gBAAA;ALui8CtB;;AKti8CA;EAA0B,gBAAA;AL0i8C1B;;AKzi8CA;EAA0B,gBAAA;AL6i8C1B;;AK5i8CA;EAAwB,gBAAA;ALgj8CxB;;AK/i8CA;EAAwB,gBAAA;ALmj8CxB;;AKlj8CA;EAAsB,gBAAA;ALsj8CtB;;AKrj8CA;EAAsB,gBAAA;ALyj8CtB;;AKxj8CA;EAAyB,gBAAA;AL4j8CzB;;AK3j8CA;EAAyB,gBAAA;AL+j8CzB;;AK9j8CA;EAAyB,gBAAA;ALkk8CzB;;AKjk8CA;EAAyB,gBAAA;ALqk8CzB;;AKpk8CA;EAAuB,gBAAA;ALwk8CvB;;AKvk8CA;EAAuB,gBAAA;AL2k8CvB;;AK1k8CA;EAA2B,gBAAA;AL8k8C3B;;AK7k8CA;EAA2B,gBAAA;ALil8C3B;;AKhl8CA;EAAyB,gBAAA;ALol8CzB;;AKnl8CA;EAAyB,gBAAA;ALul8CzB;;AKtl8CA;EAAyB,gBAAA;AL0l8CzB;;AKzl8CA;EAAyB,gBAAA;AL6l8CzB;;AK5l8CA;EAAuB,gBAAA;ALgm8CvB;;AK/l8CA;EAAuB,gBAAA;ALmm8CvB;;AKlm8CA;EAA2B,gBAAA;ALsm8C3B;;AKrm8CA;EAA2B,gBAAA;ALym8C3B;;AKxm8CA;EAA2B,gBAAA;AL4m8C3B;;AK3m8CA;EAA2B,gBAAA;AL+m8C3B;;AK9m8CA;EAAyB,gBAAA;ALkn8CzB;;AKjn8CA;EAAyB,gBAAA;ALqn8CzB;;AKpn8CA;EAAyB,gBAAA;ALwn8CzB;;AKvn8CA;EAAyB,gBAAA;AL2n8CzB;;AK1n8CA;EAAuB,gBAAA;AL8n8CvB;;AK7n8CA;EAAuB,gBAAA;ALio8CvB;;AKho8CA;EAA6B,gBAAA;ALoo8C7B;;AKno8CA;EAA6B,gBAAA;ALuo8C7B;;AKto8CA;EAA+B,gBAAA;AL0o8C/B;;AKzo8CA;EAA+B,gBAAA;AL6o8C/B;;AK5o8CA;EAA2B,gBAAA;ALgp8C3B;;AK/o8CA;EAA2B,gBAAA;ALmp8C3B;;AKlp8CA;EAA+B,gBAAA;ALsp8C/B;;AKrp8CA;EAA+B,gBAAA;ALyp8C/B;;AKxp8CA;EAA6B,gBAAA;AL4p8C7B;;AK3p8CA;EAA6B,gBAAA;AL+p8C7B;;AK9p8CA;EAA0B,gBAAA;ALkq8C1B;;AKjq8CA;EAA0B,gBAAA;ALqq8C1B;;AKpq8CA;EAA+B,gBAAA;ALwq8C/B;;AKvq8CA;EAA+B,gBAAA;AL2q8C/B;;AK1q8CA;EAA2B,gBAAA;AL8q8C3B;;AK7q8CA;EAA2B,gBAAA;ALir8C3B;;AKhr8CA;EAA6B,gBAAA;ALor8C7B;;AKnr8CA;EAA6B,gBAAA;ALur8C7B;;AKtr8CA;EAAyB,gBAAA;AL0r8CzB;;AKzr8CA;EAAyB,gBAAA;AL6r8CzB;;AK5r8CA;EAAiC,gBAAA;ALgs8CjC;;AK/r8CA;EAAiC,gBAAA;ALms8CjC;;AKls8CA;EAA2B,gBAAA;ALss8C3B;;AKrs8CA;EAA2B,gBAAA;ALys8C3B;;AKxs8CA;EAA2B,gBAAA;AL4s8C3B;;AK3s8CA;EAA+B,gBAAA;AL+s8C/B;;AK9s8CA;EAA+B,gBAAA;ALkt8C/B;;AKjt8CA;EAA6B,gBAAA;ALqt8C7B;;AKpt8CA;EAA6B,gBAAA;ALwt8C7B;;AKvt8CA;EAA0B,gBAAA;AL2t8C1B;;AK1t8CA;EAAyB,gBAAA;AL8t8CzB;;AK7t8CA;EAAyB,gBAAA;ALiu8CzB;;AKhu8CA;EAAuB,gBAAA;ALou8CvB;;AKnu8CA;EAAyB,gBAAA;ALuu8CzB;;AKtu8CA;EAAyB,gBAAA;AL0u8CzB;;AKzu8CA;EAA0B,gBAAA;AL6u8C1B;;AK5u8CA;EAA0B,gBAAA;ALgv8C1B;;AK/u8CA;EAA6B,gBAAA;ALmv8C7B;;AKlv8CA;EAA6B,gBAAA;ALsv8C7B;;AKrv8CA;EAA6B,gBAAA;ALyv8C7B;;AKxv8CA;EAA6B,gBAAA;AL4v8C7B;;AK3v8CA;EAA6B,gBAAA;AL+v8C7B;;AK9v8CA;EAA6B,gBAAA;ALkw8C7B;;AKjw8CA;EAA6B,gBAAA;ALqw8C7B;;AKpw8CA;EAA6B,gBAAA;ALww8C7B;;AKvw8CA;EAA6B,gBAAA;AL2w8C7B;;AK1w8CA;EAA6B,gBAAA;AL8w8C7B;;AK7w8CA;EAA2B,gBAAA;ALix8C3B;;AKhx8CA;EAA2B,gBAAA;ALox8C3B;;AKnx8CA;EAA0B,gBAAA;ALux8C1B;;AKtx8CA;EAA0B,gBAAA;AL0x8C1B;;AKzx8CA;EAAwB,gBAAA;AL6x8CxB;;AK5x8CA;EAAwB,gBAAA;ALgy8CxB;;AK/x8CA;EAA4B,gBAAA;ALmy8C5B;;AKly8CA;EAA4B,gBAAA;ALsy8C5B;;AKry8CA;EAA+B,gBAAA;ALyy8C/B;;AKxy8CA;EAA+B,gBAAA;AL4y8C/B;;AK3y8CA;EAAwB,gBAAA;AL+y8CxB;;AK9y8CA;EAAkC,gBAAA;ALkz8ClC;;AKjz8CA;EAAkC,gBAAA;ALqz8ClC;;AKpz8CA;EAAoC,gBAAA;ALwz8CpC;;AKvz8CA;EAAoC,gBAAA;AL2z8CpC;;AK1z8CA;EAAgC,gBAAA;AL8z8ChC;;AK7z8CA;EAAgC,gBAAA;ALi08ChC;;AKh08CA;EAAwB,gBAAA;ALo08CxB;;AKn08CA;EAA+B,gBAAA;ALu08C/B;;AKt08CA;EAA+B,gBAAA;AL008C/B;;AKz08CA;EAA+B,gBAAA;AL608C/B;;AK508CA;EAA+B,gBAAA;ALg18C/B;;AK/08CA;EAAyB,gBAAA;ALm18CzB;;AKl18CA;EAA+B,gBAAA;ALs18C/B;;AKr18CA;EAA+B,gBAAA;ALy18C/B;;AKx18CA;EAAiC,gBAAA;AL418CjC;;AK318CA;EAAiC,gBAAA;AL+18CjC;;AK918CA;EAAyB,gBAAA;ALk28CzB;;AKj28CA;EAA8B,gBAAA;ALq28C9B;;AKp28CA;EAA8B,gBAAA;ALw28C9B;;AKv28CA;EAA8B,gBAAA;AL228C9B;;AK128CA;EAA8B,gBAAA;AL828C9B;;AK728CA;EAAyB,gBAAA;ALi38CzB;;AKh38CA;EAAyB,gBAAA;ALo38CzB;;AKn38CA;EAAuB,gBAAA;ALu38CvB;;AKt38CA;EAAuB,gBAAA;AL038CvB;;AKz38CA;EAAwB,gBAAA;AL638CxB;;AK538CA;EAAwB,gBAAA;ALg48CxB;;AK/38CA;EAAiC,gBAAA;ALm48CjC;;AKl48CA;EAAiC,gBAAA;ALs48CjC;;AKr48CA;EAAiC,gBAAA;ALy48CjC;;AKx48CA;EAAiC,gBAAA;AL448CjC;;AK348CA;EAA+B,gBAAA;AL+48C/B;;AK948CA;EAA+B,gBAAA;ALk58C/B;;AKj58CA;EAAoC,gBAAA;ALq58CpC;;AKp58CA;EAAoC,gBAAA;ALw58CpC;;AKv58CA;EAAkC,gBAAA;AL258ClC;;AK158CA;EAAkC,gBAAA;AL858ClC;;AK758CA;EAAkC,gBAAA;ALi68ClC;;AKh68CA;EAAkC,gBAAA;ALo68ClC;;AKn68CA;EAAgC,gBAAA;ALu68ChC;;AKt68CA;EAAgC,gBAAA;AL068ChC;;AKz68CA;EAA0B,gBAAA;AL668C1B;;AK568CA;EAA0B,gBAAA;ALg78C1B;;AK/68CA;EAA0B,gBAAA;ALm78C1B;;AKl78CA;EAA0B,gBAAA;ALs78C1B;;AKr78CA;EAA4B,gBAAA;ALy78C5B;;AKx78CA;EAA4B,gBAAA;AL478C5B;;AK378CA;EAA2B,gBAAA;AL+78C3B;;AK978CA;EAA2B,gBAAA;ALk88C3B;;AKj88CA;EAA+B,gBAAA;ALq88C/B;;AKp88CA;EAA+B,gBAAA;ALw88C/B;;AKv88CA;EAAgC,gBAAA;AL288ChC;;AK188CA;EAAgC,gBAAA;AL888ChC;;AK788CA;EAAgC,gBAAA;ALi98ChC;;AKh98CA;EAAgC,gBAAA;ALo98ChC;;AKn98CA;EAAgC,gBAAA;ALu98ChC;;AKt98CA;EAAgC,gBAAA;AL098ChC;;AKz98CA;EAAoC,gBAAA;AL698CpC;;AK598CA;EAAoC,gBAAA;ALg+8CpC;;AK/98CA;EAA8B,gBAAA;ALm+8C9B;;AKl+8CA;EAA8B,gBAAA;ALs+8C9B;;AKr+8CA;EAAkC,gBAAA;ALy+8ClC;;AKx+8CA;EAAkC,gBAAA;AL4+8ClC;;AK3+8CA;EAA6B,gBAAA;AL++8C7B;;AK9+8CA;EAA6B,gBAAA;ALk/8C7B;;AKj/8CA;EAA2B,gBAAA;ALq/8C3B;;AKp/8CA;EAA2B,gBAAA;ALw/8C3B;;AKv/8CA;EAA6B,gBAAA;AL2/8C7B;;AK1/8CA;EAA6B,gBAAA;AL8/8C7B;;AK7/8CA;EAAsB,gBAAA;ALig9CtB;;AKhg9CA;EAAsB,gBAAA;ALog9CtB;;AKng9CA;EAA4B,gBAAA;ALug9C5B;;AKtg9CA;EAA4B,gBAAA;AL0g9C5B;;AKzg9CA;EAAiC,gBAAA;AL6g9CjC;;AK5g9CA;EAAiC,gBAAA;ALgh9CjC;;AK/g9CA;EAA+B,gBAAA;ALmh9C/B;;AKlh9CA;EAA+B,gBAAA;ALsh9C/B;;AKrh9CA;EAAoC,gBAAA;ALyh9CpC;;AKxh9CA;EAAoC,gBAAA;AL4h9CpC;;AK3h9CA;EAA0B,gBAAA;AL+h9C1B;;AK9h9CA;EAA0B,gBAAA;ALki9C1B;;AKji9CA;EAAwB,gBAAA;ALqi9CxB;;AKpi9CA;EAAwB,gBAAA;ALwi9CxB;;AKvi9CA;EAAwB,gBAAA;AL2i9CxB;;AK1i9CA;EAAwB,gBAAA;AL8i9CxB;;AK7i9CA;EAAwB,gBAAA;ALij9CxB;;AKhj9CA;EAAwB,gBAAA;ALoj9CxB;;AKnj9CA;EAAwB,gBAAA;ALuj9CxB;;AKtj9CA;EAAwB,gBAAA;AL0j9CxB;;AKzj9CA;EAA8B,gBAAA;AL6j9C9B;;AK5j9CA;EAA8B,gBAAA;ALgk9C9B;;AK/j9CA;EAA8B,gBAAA;ALmk9C9B;;AKlk9CA;EAA8B,gBAAA;ALsk9C9B;;AKrk9CA;EAA8B,gBAAA;ALyk9C9B;;AKxk9CA;EAA8B,gBAAA;AL4k9C9B;;AK3k9CA;EAA4B,gBAAA;AL+k9C5B;;AK9k9CA;EAA4B,gBAAA;ALkl9C5B;;AKjl9CA;EAA6B,gBAAA;ALql9C7B;;AKpl9CA;EAA6B,gBAAA;ALwl9C7B;;AKvl9CA;EAA2B,gBAAA;AL2l9C3B;;AK1l9CA;EAA2B,gBAAA;AL8l9C3B;;AK7l9CA;EAAwB,gBAAA;ALim9CxB;;AKhm9CA;EAAwB,gBAAA;ALom9CxB;;AKnm9CA;EAAsB,gBAAA;ALum9CtB;;AKtm9CA;EAAuB,gBAAA;AL0m9CvB;;AKzm9CA;EAA+B,gBAAA;AL6m9C/B;;AK5m9CA;EAA+B,gBAAA;ALgn9C/B;;AK/m9CA;EAA6B,gBAAA;ALmn9C7B;;AKln9CA;EAA6B,gBAAA;ALsn9C7B;;AKrn9CA;EAA6B,gBAAA;ALyn9C7B;;AKxn9CA;EAA6B,gBAAA;AL4n9C7B;;AK3n9CA;EAAmB,gBAAA;AL+n9CnB;;AK9n9CA;EAAyB,gBAAA;ALko9CzB;;AKjo9CA;EAAyB,gBAAA;ALqo9CzB;;AKpo9CA;EAAyB,gBAAA;ALwo9CzB;;AKvo9CA;EAAyB,gBAAA;AL2o9CzB;;AK1o9CA;EAAuB,gBAAA;AL8o9CvB;;AK7o9CA;EAAuB,gBAAA;ALip9CvB;;AKhp9CA;EAA4B,gBAAA;ALop9C5B;;AKnp9CA;EAA4B,gBAAA;ALup9C5B;;AKtp9CA;EAA4B,gBAAA;AL0p9C5B;;AKzp9CA;EAA4B,gBAAA;AL6p9C5B;;AK5p9CA;EAA0B,gBAAA;ALgq9C1B;;AK/p9CA;EAA0B,gBAAA;ALmq9C1B;;AKlq9CA;EAA2B,gBAAA;ALsq9C3B;;AKrq9CA;EAA2B,gBAAA;ALyq9C3B;;AKxq9CA;EAAwB,gBAAA;AL4q9CxB;;AK3q9CA;EAAwB,gBAAA;AL+q9CxB;;AK9q9CA;EAA6B,gBAAA;ALkr9C7B;;AKjr9CA;EAA6B,gBAAA;ALqr9C7B;;AKpr9CA;EAAoC,gBAAA;ALwr9CpC;;AKvr9CA;EAAkC,gBAAA;AL2r9ClC;;AK1r9CA;EAA0B,gBAAA;AL8r9C1B;;AK7r9CA;EAA0B,gBAAA;ALis9C1B;;AKhs9CA;EAAsB,gBAAA;ALos9CtB;;AKns9CA;EAAsB,gBAAA;ALus9CtB;;AKts9CA;EAAwB,gBAAA;AL0s9CxB;;AKzs9CA;EAAwB,gBAAA;AL6s9CxB;;AK5s9CA;EAAiC,gBAAA;ALgt9CjC;;AK/s9CA;EAAiC,gBAAA;ALmt9CjC;;AKlt9CA;EAA6B,gBAAA;ALst9C7B;;AKrt9CA;EAA6B,gBAAA;ALyt9C7B;;AKxt9CA;EAAuB,gBAAA;AL4t9CvB;;AK3t9CA;EAA4B,gBAAA;AL+t9C5B;;AK9t9CA;EAA4B,gBAAA;ALku9C5B;;AKju9CA;EAA8B,gBAAA;ALqu9C9B;;AKpu9CA;EAA8B,gBAAA;ALwu9C9B;;AKvu9CA;EAAuB,gBAAA;AL2u9CvB;;AK1u9CA;EAAyB,gBAAA;AL8u9CzB;;AK7u9CA;EAAyB,gBAAA;ALiv9CzB;;AKhv9CA;EAA6B,gBAAA;ALov9C7B;;AKnv9CA;EAA6B,gBAAA;ALuv9C7B;;AKtv9CA;EAAwB,gBAAA;AL0v9CxB;;AKzv9CA;EAAwB,gBAAA;AL6v9CxB;;AK5v9CA;EAA6B,gBAAA;ALgw9C7B;;AK/v9CA;EAA6B,gBAAA;ALmw9C7B;;AKlw9CA;EAA2B,gBAAA;ALsw9C3B;;AKrw9CA;EAA2B,gBAAA;ALyw9C3B;;AKxw9CA;EAA8B,gBAAA;AL4w9C9B;;AK3w9CA;EAA8B,gBAAA;AL+w9C9B;;AK9w9CA;EAAgC,gBAAA;ALkx9ChC;;AKjx9CA;EAAgC,gBAAA;ALqx9ChC;;AKpx9CA;EAA8B,gBAAA;ALwx9C9B;;AKvx9CA;EAA8B,gBAAA;AL2x9C9B;;AK1x9CA;EAAwB,gBAAA;AL8x9CxB;;AK7x9CA;EAAwB,gBAAA;ALiy9CxB;;AKhy9CA;EAA8B,gBAAA;ALoy9C9B;;AKny9CA;EAA8B,gBAAA;ALuy9C9B;;AKty9CA;EAAuB,gBAAA;AL0y9CvB;;AKzy9CA;EAAuB,gBAAA;AL6y9CvB;;AK5y9CA;EAA4B,gBAAA;ALgz9C5B;;AK/y9CA;EAA4B,gBAAA;ALmz9C5B;;AKlz9CA;EAA0B,gBAAA;ALsz9C1B;;AKrz9CA;EAA0B,gBAAA;ALyz9C1B;;AKxz9CA;EAA0B,gBAAA;AL4z9C1B;;AK3z9CA;EAA0B,gBAAA;AL+z9C1B;;AK9z9CA;EAAwB,gBAAA;ALk09CxB;;AKj09CA;EAAwB,gBAAA;ALq09CxB;;AKp09CA;EAA6B,gBAAA;ALw09C7B;;AKv09CA;EAA2B,gBAAA;AL209C3B;;AK109CA;EAAyB,gBAAA;AL809CzB;;AK709CA;EAAuB,gBAAA;ALi19CvB;;AKh19CA;EAA2B,gBAAA;ALo19C3B;;AKn19CA;EAA2B,gBAAA;ALu19C3B;;AKt19CA;EAAyB,gBAAA;AL019CzB;;AKz19CA;EAAyB,gBAAA;AL619CzB;;AK519CA;EAA8B,gBAAA;ALg29C9B;;AK/19CA;EAA8B,gBAAA;ALm29C9B;;AKl29CA;EAA6B,gBAAA;ALs29C7B;;AKr29CA;EAA6B,gBAAA;ALy29C7B;;AKx29CA;EAA6B,gBAAA;AL429C7B;;AK329CA;EAA6B,gBAAA;AL+29C7B;;AK929CA;EAA2B,gBAAA;ALk39C3B;;AKj39CA;EAA2B,gBAAA;ALq39C3B;;AKp39CA;EAA6B,gBAAA;ALw39C7B;;AKv39CA;EAA6B,gBAAA;AL239C7B;;AK139CA;EAAsB,gBAAA;AL839CtB;;AK739CA;EAA4B,gBAAA;ALi49C5B;;AKh49CA;EAA4B,gBAAA;ALo49C5B;;AKn49CA;EAAsB,gBAAA;ALu49CtB;;AKt49CA;EAA2B,gBAAA;AL049C3B;;AKz49CA;EAAyB,gBAAA;AL649CzB;;AK549CA;EAAgC,gBAAA;ALg59ChC;;AK/49CA;EAAgC,gBAAA;ALm59ChC;;AKl59CA;EAAiC,gBAAA;ALs59CjC;;AKr59CA;EAAiC,gBAAA;ALy59CjC;;AKx59CA;EAAyB,gBAAA;AL459CzB;;AK359CA;EAAyB,gBAAA;AL+59CzB;;AK959CA;EAA2B,gBAAA;ALk69C3B;;AKj69CA;EAA2B,gBAAA;ALq69C3B;;AKp69CA;EAAuB,gBAAA;ALw69CvB;;AKv69CA;EAAuB,gBAAA;AL269CvB;;AK169CA;EAAyB,gBAAA;AL869CzB;;AK769CA;EAAyB,gBAAA;ALi79CzB;;AKh79CA;EAAwB,gBAAA;ALo79CxB;;AKn79CA;EAAwB,gBAAA;ALu79CxB;;AKt79CA;EAA0B,gBAAA;AL079C1B;;AKz79CA;EAA0B,gBAAA;AL679C1B;;AK579CA;EAAwB,gBAAA;ALg89CxB;;AK/79CA;EAAwB,gBAAA;ALm89CxB;;AKl89CA;EAA4B,gBAAA;ALs89C5B;;AKr89CA;EAA4B,gBAAA;ALy89C5B;;AKx89CA;EAA8B,gBAAA;AL489C9B;;AK389CA;EAA8B,gBAAA;AL+89C9B;;AK989CA;EAA0B,gBAAA;ALk99C1B;;AKj99CA;EAA0B,gBAAA;ALq99C1B;;AKp99CA;EAAqB,gBAAA;ALw99CrB;;AKv99CA;EAA4B,gBAAA;AL299C5B;;AK199CA;EAA4B,gBAAA;AL899C5B;;AK799CA;EAAwB,gBAAA;ALi+9CxB;;AKh+9CA;EAAwB,gBAAA;ALo+9CxB;;AKn+9CA;EAAyB,gBAAA;ALu+9CzB;;AKt+9CA;EAAyB,gBAAA;AL0+9CzB;;AKz+9CA;EAA2B,gBAAA;AL6+9C3B;;AK5+9CA;EAA2B,gBAAA;ALg/9C3B;;AK/+9CA;EAAyB,gBAAA;ALm/9CzB;;AKl/9CA;EAAyB,gBAAA;ALs/9CzB;;AKr/9CA;EAAuB,gBAAA;ALy/9CvB;;AKx/9CA;EAAuB,gBAAA;AL4/9CvB;;AK3/9CA;EAAuB,gBAAA;AL+/9CvB;;AK9/9CA;EAAuB,gBAAA;ALkg+CvB;;AKjg+CA;EAAuB,gBAAA;ALqg+CvB;;AKpg+CA;EAAuB,gBAAA;ALwg+CvB;;AKvg+CA;EAA4B,gBAAA;AL2g+C5B;;AK1g+CA;EAA4B,gBAAA;AL8g+C5B;;AK7g+CA;EAAuB,gBAAA;ALih+CvB;;AKhh+CA;EAAuB,gBAAA;ALoh+CvB;;AKnh+CA;EAA2B,gBAAA;ALuh+C3B;;AKth+CA;EAA2B,gBAAA;AL0h+C3B;;AKzh+CA;EAA4B,gBAAA;AL6h+C5B;;AK5h+CA;EAA4B,gBAAA;ALgi+C5B;;AK/h+CA;EAA2B,gBAAA;ALmi+C3B;;AKli+CA;EAA2B,gBAAA;ALsi+C3B;;AKri+CA;EAA+B,gBAAA;ALyi+C/B;;AKxi+CA;EAA+B,gBAAA;AL4i+C/B;;AK3i+CA;EAA2B,gBAAA;AL+i+C3B;;AK9i+CA;EAA2B,gBAAA;ALkj+C3B;;AKjj+CA;EAAkC,gBAAA;ALqj+ClC;;AKpj+CA;EAAkC,gBAAA;ALwj+ClC;;AKvj+CA;EAA4B,gBAAA;AL2j+C5B;;AK1j+CA;EAA4B,gBAAA;AL8j+C5B;;AK7j+CA;EAA8B,gBAAA;ALik+C9B;;AKhk+CA;EAA8B,gBAAA;ALok+C9B;;AKnk+CA;EAA0B,gBAAA;ALuk+C1B;;AKtk+CA;EAAuB,gBAAA;AL0k+CvB;;AKzk+CA;EAAkB,gBAAA;AL6k+ClB;;AK5k+CA;EAA8B,gBAAA;ALgl+C9B;;AK/k+CA;EAA8B,gBAAA;ALml+C9B;;AKll+CA;EAA6B,gBAAA;ALsl+C7B;;AKrl+CA;EAA6B,gBAAA;ALyl+C7B;;AKxl+CA;EAA2B,gBAAA;AL4l+C3B;;AK3l+CA;EAA2B,gBAAA;AL+l+C3B;;AK9l+CA;EAAgC,gBAAA;ALkm+ChC;;AKjm+CA;EAAgC,gBAAA;ALqm+ChC;;AKpm+CA;EAA2B,gBAAA;ALwm+C3B;;AKvm+CA;EAA2B,gBAAA;AL2m+C3B;;AK1m+CA;EAAyB,gBAAA;AL8m+CzB;;AK7m+CA;EAAyB,gBAAA;ALin+CzB;;AKhn+CA;EAAuB,gBAAA;ALon+CvB;;AKnn+CA;EAAuB,gBAAA;ALun+CvB;;AKtn+CA;EAA0B,gBAAA;AL0n+C1B;;AKzn+CA;EAA0B,gBAAA;AL6n+C1B;;AK5n+CA;EAAwB,gBAAA;ALgo+CxB;;AK/n+CA;EAA8B,gBAAA;ALmo+C9B;;AKlo+CA;EAA8B,gBAAA;ALso+C9B;;AKro+CA;EAAwB,gBAAA;ALyo+CxB;;AKxo+CA;EAAuB,gBAAA;AL4o+CvB;;AK3o+CA;EAAuB,gBAAA;AL+o+CvB;;AK9o+CA;EAAyB,gBAAA;ALkp+CzB;;AKjp+CA;EAAyB,gBAAA;ALqp+CzB;;AKpp+CA;EAAwB,gBAAA;ALwp+CxB;;AKvp+CA;EAAwB,gBAAA;AL2p+CxB;;AK1p+CA;EAA0B,gBAAA;AL8p+C1B;;AK7p+CA;EAA0B,gBAAA;ALiq+C1B;;AKhq+CA;EAA4B,gBAAA;ALoq+C5B;;AKnq+CA;EAA4B,gBAAA;ALuq+C5B;;AKtq+CA;EAAgC,gBAAA;AL0q+ChC;;AKzq+CA;EAAgC,gBAAA;AL6q+ChC;;AK5q+CA;EAAwB,gBAAA;ALgr+CxB;;AK/q+CA;EAAwB,gBAAA;ALmr+CxB;;AKlr+CA;EAA6B,gBAAA;ALsr+C7B;;AKrr+CA;EAA6B,gBAAA;ALyr+C7B;;AKxr+CA;EAAyB,gBAAA;AL4r+CzB;;AK3r+CA;EAAuB,gBAAA;AL+r+CvB;;AK9r+CA;EAA2B,gBAAA;ALks+C3B;;AKjs+CA;EAA2B,gBAAA;ALqs+C3B;;AKps+CA;EAA+B,gBAAA;ALws+C/B;;AKvs+CA;EAA+B,gBAAA;AL2s+C/B;;AK1s+CA;EAAyB,gBAAA;AL8s+CzB;;AK7s+CA;EAAyB,gBAAA;ALit+CzB;;AKht+CA;EAAyB,gBAAA;ALot+CzB;;AKnt+CA;EAAyB,gBAAA;ALut+CzB;;AKtt+CA;EAAwB,gBAAA;AL0t+CxB;;AKzt+CA;EAAwB,gBAAA;AL6t+CxB;;AK5t+CA;EAAyB,gBAAA;ALgu+CzB;;AK/t+CA;EAAyB,gBAAA;ALmu+CzB;;AKlu+CA;EAAuB,gBAAA;ALsu+CvB;;AKru+CA;EAAuB,gBAAA;ALyu+CvB;;AKxu+CA;EAAqB,gBAAA;AL4u+CrB;;AK3u+CA;EAAqB,gBAAA;AL+u+CrB;;AK9u+CA;EAAyB,gBAAA;ALkv+CzB;;AKjv+CA;EAAyB,gBAAA;ALqv+CzB;;AKpv+CA;EAA0B,gBAAA;ALwv+C1B;;AKvv+CA;EAA0B,gBAAA;AL2v+C1B;;AK1v+CA;EAA0B,gBAAA;AL8v+C1B;;AK7v+CA;EAA0B,gBAAA;ALiw+C1B;;AKhw+CA;EAAyB,gBAAA;ALow+CzB;;AKnw+CA;EAAyB,gBAAA;ALuw+CzB;;AKtw+CA;EAAyB,gBAAA;AL0w+CzB;;AKzw+CA;EAAyB,gBAAA;AL6w+CzB;;AK5w+CA;EAA2B,gBAAA;ALgx+C3B;;AK/w+CA;EAA2B,gBAAA;ALmx+C3B;;AKlx+CA;EAAuB,gBAAA;ALsx+CvB;;AKrx+CA;EAA4B,gBAAA;ALyx+C5B;;AKxx+CA;EAA4B,gBAAA;AL4x+C5B;;AK3x+CA;EAA2B,gBAAA;AL+x+C3B;;AK9x+CA;EAA2B,gBAAA;ALky+C3B;;AKjy+CA;EAA2B,gBAAA;ALqy+C3B;;AKpy+CA;EAA2B,gBAAA;ALwy+C3B;;AKvy+CA;EAAiC,gBAAA;AL2y+CjC;;AK1y+CA;EAAiC,gBAAA;AL8y+CjC;;AK7y+CA;EAA+B,gBAAA;ALiz+C/B;;AKhz+CA;EAA+B,gBAAA;ALoz+C/B;;AKnz+CA;EAAyB,gBAAA;ALuz+CzB;;AKtz+CA;EAAyB,gBAAA;AL0z+CzB;;AKzz+CA;EAAsB,gBAAA;AL6z+CtB;;AK5z+CA;EAAsB,gBAAA;ALg0+CtB;;AK/z+CA;EAAyB,gBAAA;ALm0+CzB;;AKl0+CA;EAAyB,gBAAA;ALs0+CzB;;AKr0+CA;EAAyB,gBAAA;ALy0+CzB;;AKx0+CA;EAAyB,gBAAA;AL40+CzB;;AK30+CA;EAAyB,gBAAA;AL+0+CzB;;AK90+CA;EAAyB,gBAAA;ALk1+CzB;;AKj1+CA;EAAyB,gBAAA;ALq1+CzB;;AKp1+CA;EAAyB,gBAAA;ALw1+CzB;;AKv1+CA;EAAyB,gBAAA;AL21+CzB;;AK11+CA;EAAyB,gBAAA;AL81+CzB;;AK71+CA;EAA2B,gBAAA;ALi2+C3B;;AKh2+CA;EAA2B,gBAAA;ALo2+C3B;;AKn2+CA;EAAuB,gBAAA;ALu2+CvB;;AKt2+CA;EAA8B,gBAAA;AL02+C9B;;AKz2+CA;EAA8B,gBAAA;AL62+C9B;;AK52+CA;EAA6B,gBAAA;ALg3+C7B;;AK/2+CA;EAA6B,gBAAA;ALm3+C7B;;AKl3+CA;EAAuB,gBAAA;ALs3+CvB;;AKr3+CA;EAAgC,gBAAA;ALy3+ChC;;AKx3+CA;EAAgC,gBAAA;AL43+ChC;;AK33+CA;EAAkC,gBAAA;AL+3+ClC;;AK93+CA;EAAkC,gBAAA;ALk4+ClC;;AKj4+CA;EAAgC,gBAAA;ALq4+ChC;;AKp4+CA;EAAgC,gBAAA;ALw4+ChC;;AKv4+CA;EAA8B,gBAAA;AL24+C9B;;AK14+CA;EAA8B,gBAAA;AL84+C9B;;AK74+CA;EAAgC,gBAAA;ALi5+ChC;;AKh5+CA;EAAgC,gBAAA;ALo5+ChC;;AKn5+CA;EAAgC,gBAAA;ALu5+ChC;;AKt5+CA;EAAgC,gBAAA;AL05+ChC;;AKz5+CA;EAA8B,gBAAA;AL65+C9B;;AK55+CA;EAA8B,gBAAA;ALg6+C9B;;AK/5+CA;EAA6B,gBAAA;ALm6+C7B;;AKl6+CA;EAA6B,gBAAA;ALs6+C7B;;AKr6+CA;EAA4B,gBAAA;ALy6+C5B;;AKx6+CA;EAA4B,gBAAA;AL46+C5B;;AK36+CA;EAAgC,gBAAA;AL+6+ChC;;AK96+CA;EAAgC,gBAAA;ALk7+ChC;;AKj7+CA;EAA6B,gBAAA;ALq7+C7B;;AKp7+CA;EAA6B,gBAAA;ALw7+C7B;;AKv7+CA;EAA4B,gBAAA;AL27+C5B;;AK17+CA;EAA4B,gBAAA;AL87+C5B;;AK77+CA;EAA6B,gBAAA;ALi8+C7B;;AKh8+CA;EAA6B,gBAAA;ALo8+C7B;;AKn8+CA;EAAiC,gBAAA;ALu8+CjC;;AKt8+CA;EAAiC,gBAAA;AL08+CjC;;AKz8+CA;EAAwB,gBAAA;AL68+CxB;;AK58+CA;EAAwB,gBAAA;ALg9+CxB;;AK/8+CA;EAA+B,gBAAA;ALm9+C/B;;AKl9+CA;EAA+B,gBAAA;ALs9+C/B;;AKr9+CA;EAA4B,gBAAA;ALy9+C5B;;AKx9+CA;EAA4B,gBAAA;AL49+C5B;;AK39+CA;EAA0B,gBAAA;AL+9+C1B;;AK99+CA;EAA0B,gBAAA;ALk++C1B;;AKj++CA;EAAwB,gBAAA;ALq++CxB;;AKp++CA;EAAwB,gBAAA;ALw++CxB;;AKv++CA;EAA8B,gBAAA;AL2++C9B;;AK1++CA;EAA8B,gBAAA;AL8++C9B;;AK7++CA;EAA4B,gBAAA;ALi/+C5B;;AKh/+CA;EAA4B,gBAAA;ALo/+C5B;;AKn/+CA;EAA8B,gBAAA;ALu/+C9B;;AKt/+CA;EAA8B,gBAAA;AL0/+C9B;;AKz/+CA;EAAsB,gBAAA;AL6/+CtB;;AK5/+CA;EAAsB,gBAAA;ALgg/CtB;;AK//+CA;EAAwB,gBAAA;ALmg/CxB;;AKlg/CA;EAAwB,gBAAA;ALsg/CxB;;AKrg/CA;EAAuB,gBAAA;ALyg/CvB;;AKxg/CA;EAAuB,gBAAA;AL4g/CvB;;AK3g/CA;EAAoC,gBAAA;AL+g/CpC;;AK9g/CA;EAAoC,gBAAA;ALkh/CpC;;AKjh/CA;EAA6B,gBAAA;ALqh/C7B;;AKph/CA;EAA6B,gBAAA;ALwh/C7B;;AKvh/CA;EAA8B,gBAAA;AL2h/C9B;;AK1h/CA;EAA8B,gBAAA;AL8h/C9B;;AK7h/CA;EAA8B,gBAAA;ALii/C9B;;AKhi/CA;EAA8B,gBAAA;ALoi/C9B;;AKni/CA;EAAqC,gBAAA;ALui/CrC;;AKti/CA;EAAqC,gBAAA;AL0i/CrC;;AKzi/CA;EAA4B,gBAAA;AL6i/C5B;;AK5i/CA;EAA4B,gBAAA;ALgj/C5B;;AK/i/CA;EAAiC,gBAAA;ALmj/CjC;;AKlj/CA;EAAiC,gBAAA;ALsj/CjC;;AKrj/CA;EAAwB,gBAAA;ALyj/CxB;;AKxj/CA;EAAwB,gBAAA;AL4j/CxB;;AK3j/CA;EAAuB,gBAAA;AL+j/CvB;;AK9j/CA;EAAuB,gBAAA;ALkk/CvB;;AKjk/CA;EAA2B,gBAAA;ALqk/C3B;;AKpk/CA;EAA2B,gBAAA;ALwk/C3B;;AKvk/CA;EAA2B,gBAAA;AL2k/C3B;;AK1k/CA;EAA2B,gBAAA;AL8k/C3B;;AK7k/CA;EAAyB,gBAAA;ALil/CzB;;AKhl/CA;EAAyB,gBAAA;ALol/CzB;;AKnl/CA;EAA8B,gBAAA;ALul/C9B;;AKtl/CA;EAA8B,gBAAA;AL0l/C9B;;AKzl/CA;EAAyB,gBAAA;AL6l/CzB;;AK5l/CA;EAAyB,gBAAA;ALgm/CzB;;AK/l/CA;EAA2B,gBAAA;ALmm/C3B;;AKlm/CA;EAA2B,gBAAA;ALsm/C3B;;AKrm/CA;EAAyB,gBAAA;ALym/CzB;;AKxm/CA;EAAyB,gBAAA;AL4m/CzB;;AK3m/CA;EAA6B,gBAAA;AL+m/C7B;;AK9m/CA;EAA6B,gBAAA;ALkn/C7B;;AKjn/CA;EAAwB,gBAAA;ALqn/CxB;;AKpn/CA;EAAwB,gBAAA;ALwn/CxB;;AKvn/CA;EAA2B,gBAAA;AL2n/C3B;;AK1n/CA;EAA2B,gBAAA;AL8n/C3B;;AK7n/CA;EAA6B,gBAAA;ALio/C7B;;AKho/CA;EAA6B,gBAAA;ALoo/C7B;;AKno/CA;EAAuB,gBAAA;ALuo/CvB;;AKto/CA;EAAuB,gBAAA;AL0o/CvB;;AKzo/CA;EAA2B,gBAAA;AL6o/C3B;;AK5o/CA;EAA2B,gBAAA;ALgp/C3B;;AK/o/CA;EAA2B,gBAAA;ALmp/C3B;;AKlp/CA;EAA2B,gBAAA;ALsp/C3B;;AKrp/CA;EAAyB,gBAAA;ALyp/CzB;;AKxp/CA;EAAyB,gBAAA;AL4p/CzB;;AK3p/CA;EAA0B,gBAAA;AL+p/C1B;;AK9p/CA;EAA0B,gBAAA;ALkq/C1B;;AKjq/CA;EAAwB,gBAAA;ALqq/CxB;;AKpq/CA;EAAwB,gBAAA;ALwq/CxB;;AKvq/CA;EAAoC,gBAAA;AL2q/CpC;;AK1q/CA;EAAoC,gBAAA;AL8q/CpC;;AK7q/CA;EAAwB,gBAAA;ALir/CxB;;AKhr/CA;EAAwB,gBAAA;ALor/CxB;;AKnr/CA;EAAwB,gBAAA;ALur/CxB;;AKtr/CA;EAAuB,gBAAA;AL0r/CvB;;AKzr/CA;EAAuB,gBAAA;AL6r/CvB;;AK5r/CA;EAAuB,gBAAA;ALgs/CvB;;AK/r/CA;EAAuB,gBAAA;ALms/CvB;;AKls/CA;EAA0B,gBAAA;ALss/C1B;;AKrs/CA;EAA0B,gBAAA;ALys/C1B;;AKxs/CA;EAAwB,gBAAA;AL4s/CxB;;AK3s/CA;EAAwB,gBAAA;AL+s/CxB;;AK9s/CA;EAAwB,gBAAA;ALkt/CxB;;AKjt/CA;EAAwB,gBAAA;ALqt/CxB;;AKpt/CA;EAA0B,gBAAA;ALwt/C1B;;AKvt/CA;EAA0B,gBAAA;AL2t/C1B;;AK1t/CA;EAA2B,gBAAA;AL8t/C3B;;AK7t/CA;EAA2B,gBAAA;ALiu/C3B;;AKhu/CA;EAAsB,gBAAA;ALou/CtB;;AKnu/CA;EAAsB,gBAAA;ALuu/CtB;;AMl/jDA;;;;;;;CAAA;ACCE;;;;;EAAA;ACDF;EAQI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAGF,6BAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EAMA,2CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC4PI,8BALI;EDrPR,0BAAA;EACA,0BAAA;EACA,wBAAA;EAIA,qBAAA;EAIA,sBAAA;EACA,wBAAA;EACA,yCAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EAGA,qCAAA;EACA,iDAAA;EAEA,wBAAA;EAEA,0BAAA;AR6/jDF;;AUrjkDA;;;EAGE,sBAAA;AVwjkDF;;AUzikDI;EANJ;IAOM,uBAAA;EV6ikDJ;AACF;;AUhikDA;EACE,SAAA;EACA,uCAAA;EDmPI,mCALI;EC5OR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AVmikDF;;AU1hkDA;EACE,cAAA;EACA,cCksB4B;EDjsB5B,SAAA;EACA,qBAAA;EACA,aCssB4B;AXu1iD9B;;AUnhkDA;EACE,aAAA;EACA,qBCyoB4B;EDtoB5B,gBCyoB4B;EDxoB5B,gBCyoB4B;AX24iD9B;;AUhhkDA;ED6MQ,uCAAA;ATu0jDR;ASz+jDI;EC3CJ;IDoNQ,qBAAA;ETo0jDN;AACF;;AUphkDA;EDwMQ,mCAAA;ATg1jDR;ASl/jDI;ECtCJ;ID+MQ,mBAAA;ET60jDN;AACF;;AUxhkDA;EDmMQ,yCAAA;ATy1jDR;AS3/jDI;ECjCJ;ID0MQ,sBAAA;ETs1jDN;AACF;;AU5hkDA;ED0LM,qBALI;AT22jDV;;AU3hkDA;EDqLM,sBALI;AT+2jDV;;AU1hkDA;EDgLM,oBALI;ATm3jDV;;AUnhkDA;EACE,aAAA;EACA,mBCmb0B;AXmmjD5B;;AU5gkDA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AV+gkDF;;AUzgkDA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AV4gkDF;;AUtgkDA;;EAEE,kBAAA;AVygkDF;;AUtgkDA;;;EAGE,aAAA;EACA,mBAAA;AVygkDF;;AUtgkDA;;;;EAIE,gBAAA;AVygkDF;;AUtgkDA;EACE,gBC6gB4B;AX4/iD9B;;AUpgkDA;EACE,qBAAA;EACA,cAAA;AVugkDF;;AUjgkDA;EACE,gBAAA;AVogkDF;;AU5/jDA;;EAEE,mBCuf4B;AXwgjD9B;;AUv/jDA;EDmFM,kBALI;AT66jDV;;AUp/jDA;EACE,cC0jB4B;EDzjB5B,wCAAA;AVu/jDF;;AU9+jDA;;EAEE,kBAAA;ED+DI,iBALI;ECxDR,cAAA;EACA,wBAAA;AVi/jDF;;AU9+jDA;EAAM,eAAA;AVk/jDN;;AUj/jDA;EAAM,WAAA;AVq/jDN;;AUh/jDA;EACE,2BAAA;EACA,0BCqTwC;AX8rjD1C;AUj/jDE;EACE,iCAAA;AVm/jDJ;;AUx+jDE;EAEE,cAAA;EACA,qBAAA;AV0+jDJ;;AUn+jDA;;;;EAIE,qCCma4B;EF9YxB,cALI;ATu9jDV;;AU/9jDA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDSI,kBALI;AT+9jDV;AU99jDE;EDII,kBALI;ECGN,cAAA;EACA,kBAAA;AVg+jDJ;;AU59jDA;EDHM,kBALI;ECUR,2BAAA;EACA,qBAAA;AV+9jDF;AU59jDE;EACE,cAAA;AV89jDJ;;AU19jDA;EACE,sBAAA;EDfI,kBALI;ECsBR,WC5JS;ED6JT,yBCpJS;EChJP,qBAAA;AZkwkDJ;AU39jDE;EACE,UAAA;EDtBE,cALI;EC6BN,gBCmY0B;AX0ljD9B;;AUp9jDA;EACE,gBAAA;AVu9jDF;;AUj9jDA;;EAEE,sBAAA;AVo9jDF;;AU58jDA;EACE,oBAAA;EACA,yBAAA;AV+8jDF;;AU58jDA;EACE,oBCsc4B;EDrc5B,uBCqc4B;EDpc5B,cC/LS;EDgMT,gBAAA;AV+8jDF;;AUx8jDA;EAEE,mBAAA;EACA,gCAAA;AV08jDF;;AUv8jDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AV08jDF;;AUl8jDA;EACE,qBAAA;AVq8jDF;;AU/7jDA;EAEE,gBAAA;AVi8jDF;;AUz7jDA;EACE,UAAA;AV47jDF;;AUv7jDA;;;;;EAKE,SAAA;EACA,oBAAA;EDrHI,kBALI;EC4HR,oBAAA;AV07jDF;;AUt7jDA;;EAEE,oBAAA;AVy7jDF;;AUp7jDA;EACE,eAAA;AVu7jDF;;AUp7jDA;EAGE,iBAAA;AVq7jDF;AUl7jDE;EACE,UAAA;AVo7jDJ;;AU76jDA;EACE,wBAAA;AVg7jDF;;AUx6jDA;;;;EAIE,0BAAA;AV26jDF;AUx6jDI;;;;EACE,eAAA;AV66jDN;;AUt6jDA;EACE,UAAA;EACA,kBAAA;AVy6jDF;;AUp6jDA;EACE,gBAAA;AVu6jDF;;AU75jDA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AVg6jDF;;AUx5jDA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC6R4B;EFvetB,iCAAA;ATsmkDR;ASxwkDI;ECwWJ;ID/LQ,iBAAA;ETmmkDN;AACF;AUr6jDA;EAOE,oBAAA;AVi6jDF;AU/5jDE;EACE,WAAA;AVi6jDJ;;AU15jDA;;;;;;;EAOE,UAAA;AV65jDF;;AU15jDA;EACE,YAAA;AV65jDF;;AUp5jDA;EACE,oBAAA;EACA,6BAAA;AVu5jDF;;AU/4jDA;;;;;;;CAAA;AAWA;EACE,wBAAA;AV+4jDF;;AU14jDA;EACE,UAAA;AV64jDF;;AUt4jDA;EACE,aAAA;EACA,0BAAA;AVy4jDF;;AUp4jDA;EACE,qBAAA;AVu4jDF;;AUl4jDA;EACE,SAAA;AVq4jDF;;AU93jDA;EACE,kBAAA;EACA,eAAA;AVi4jDF;;AUz3jDA;EACE,wBAAA;AV43jDF;;AUp3jDA;EACE,wBAAA;AVu3jDF;;Aa37kDA;EJyQM,sBALI;EIlQR,gBFytB4B;AXqujD9B;;Aaz7kDE;EJsQM,iCAAA;ATurkDR;ASz1kDI;EIpGF;IJ6QM,eAAA;ETorkDN;AACF;Aal8kDE;EAIE,gBF0sBkB;EEzsBlB,gBFyrB0B;AXwwjD9B;;Aat8kDE;EJsQM,iCAAA;AToskDR;ASt2kDI;EIpGF;IJ6QM,iBAAA;ETiskDN;AACF;Aa/8kDE;EAIE,gBF0sBkB;EEzsBlB,gBFyrB0B;AXqxjD9B;;Aan9kDE;EJsQM,iCAAA;ATitkDR;ASn3kDI;EIpGF;IJ6QM,eAAA;ET8skDN;AACF;Aa59kDE;EAIE,gBF0sBkB;EEzsBlB,gBFyrB0B;AXkyjD9B;;Aah+kDE;EJsQM,iCAAA;AT8tkDR;ASh4kDI;EIpGF;IJ6QM,iBAAA;ET2tkDN;AACF;Aaz+kDE;EAIE,gBF0sBkB;EEzsBlB,gBFyrB0B;AX+yjD9B;;Aa7+kDE;EJsQM,iCAAA;AT2ukDR;AS74kDI;EIpGF;IJ6QM,eAAA;ETwukDN;AACF;Aat/kDE;EAIE,gBF0sBkB;EEzsBlB,gBFyrB0B;AX4zjD9B;;Aa1/kDE;EJsQM,iCAAA;ATwvkDR;AS15kDI;EIpGF;IJ6QM,iBAAA;ETqvkDN;AACF;AanglDE;EAIE,gBF0sBkB;EEzsBlB,gBFyrB0B;AXy0jD9B;;Aa/+kDA;ECvDE,eAAA;EACA,gBAAA;Ad0ilDF;;Aa/+kDA;EC5DE,eAAA;EACA,gBAAA;Ad+ilDF;;Aaj/kDA;EACE,qBAAA;Abo/kDF;Aal/kDE;EACE,oBFitB0B;AXmyjD9B;;Aa1+kDA;EJoNM,kBALI;EI7MR,yBAAA;Ab6+kDF;;Aaz+kDA;EACE,mBF2aO;EF9NH,qBALI;ATqykDV;Aa1+kDE;EACE,gBAAA;Ab4+kDJ;;Aax+kDA;EACE,iBAAA;EACA,mBFiaO;EF9NH,kBALI;EI5LR,cF4DS;AX+6kDX;Aaz+kDE;EACE,aAAA;Ab2+kDJ;;Ae3klDA;ECIE,eAAA;EAGA,YAAA;AhByklDF;;Ae1klDA;EACE,gBJolDkC;EInlDlC,mCJolDkC;EInlDlC,wCAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AhBkllDF;;AepklDA;EAEE,qBAAA;AfsklDF;;AenklDA;EACE,qBAAA;EACA,cAAA;AfsklDF;;AenklDA;EN+PM,kBALI;EMxPR,cJwHS;AX88kDX;;AiBxmlDE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AlBqnlDF;;AmB/jlDI;EF5CE;IACE,gBN6jBe;EXkjkDrB;AACF;AmBrklDI;EF5CE;IACE,gBN6jBe;EXujkDrB;AACF;AmB1klDI;EF5CE;IACE,gBN6jBe;EX4jkDrB;AACF;AmB/klDI;EF5CE;IACE,iBN6jBe;EXikkDrB;AACF;AmBpllDI;EF5CE;IACE,iBN6jBe;EXskkDrB;AACF;AoBnplDE;ECAA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;ArBqplDF;AoBzplDI;ECaF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;ArB+olDF;;AqBhmlDM;EACE,SAAA;ArBmmlDR;;AqBhmlDM;EApCJ,cAAA;EACA,WAAA;ArBwolDF;;AqB1nlDE;EACE,cAAA;EACA,WAAA;ArB6nlDJ;;AqB/nlDE;EACE,cAAA;EACA,UAAA;ArBkolDJ;;AqBpolDE;EACE,cAAA;EACA,qBAAA;ArBuolDJ;;AqBzolDE;EACE,cAAA;EACA,UAAA;ArB4olDJ;;AqB9olDE;EACE,cAAA;EACA,UAAA;ArBiplDJ;;AqBnplDE;EACE,cAAA;EACA,qBAAA;ArBsplDJ;;AqBvnlDM;EAhDJ,cAAA;EACA,WAAA;ArB2qlDF;;AqBtnlDU;EAhEN,cAAA;EACA,kBAAA;ArB0rlDJ;;AqB3nlDU;EAhEN,cAAA;EACA,mBAAA;ArB+rlDJ;;AqBholDU;EAhEN,cAAA;EACA,UAAA;ArBoslDJ;;AqBrolDU;EAhEN,cAAA;EACA,mBAAA;ArByslDJ;;AqB1olDU;EAhEN,cAAA;EACA,mBAAA;ArB8slDJ;;AqB/olDU;EAhEN,cAAA;EACA,UAAA;ArBmtlDJ;;AqBpplDU;EAhEN,cAAA;EACA,mBAAA;ArBwtlDJ;;AqBzplDU;EAhEN,cAAA;EACA,mBAAA;ArB6tlDJ;;AqB9plDU;EAhEN,cAAA;EACA,UAAA;ArBkulDJ;;AqBnqlDU;EAhEN,cAAA;EACA,mBAAA;ArBuulDJ;;AqBxqlDU;EAhEN,cAAA;EACA,mBAAA;ArB4ulDJ;;AqB7qlDU;EAhEN,cAAA;EACA,WAAA;ArBivlDJ;;AqB1qlDY;EAxDV,wBAAA;ArBsulDF;;AqB9qlDY;EAxDV,yBAAA;ArB0ulDF;;AqBlrlDY;EAxDV,gBAAA;ArB8ulDF;;AqBtrlDY;EAxDV,yBAAA;ArBkvlDF;;AqB1rlDY;EAxDV,yBAAA;ArBsvlDF;;AqB9rlDY;EAxDV,gBAAA;ArB0vlDF;;AqBlslDY;EAxDV,yBAAA;ArB8vlDF;;AqBtslDY;EAxDV,yBAAA;ArBkwlDF;;AqB1slDY;EAxDV,gBAAA;ArBswlDF;;AqB9slDY;EAxDV,yBAAA;ArB0wlDF;;AqBltlDY;EAxDV,yBAAA;ArB8wlDF;;AqB3slDQ;;EAEE,gBAAA;ArB8slDV;;AqB3slDQ;;EAEE,gBAAA;ArB8slDV;;AqBrtlDQ;;EAEE,sBAAA;ArBwtlDV;;AqBrtlDQ;;EAEE,sBAAA;ArBwtlDV;;AqB/tlDQ;;EAEE,qBAAA;ArBkulDV;;AqB/tlDQ;;EAEE,qBAAA;ArBkulDV;;AqBzulDQ;;EAEE,mBAAA;ArB4ulDV;;AqBzulDQ;;EAEE,mBAAA;ArB4ulDV;;AqBnvlDQ;;EAEE,qBAAA;ArBsvlDV;;AqBnvlDQ;;EAEE,qBAAA;ArBsvlDV;;AqB7vlDQ;;EAEE,mBAAA;ArBgwlDV;;AqB7vlDQ;;EAEE,mBAAA;ArBgwlDV;;AmB1zlDI;EEUE;IACE,SAAA;ErBozlDN;EqBjzlDI;IApCJ,cAAA;IACA,WAAA;ErBw1lDA;EqB10lDA;IACE,cAAA;IACA,WAAA;ErB40lDF;EqB90lDA;IACE,cAAA;IACA,UAAA;ErBg1lDF;EqBl1lDA;IACE,cAAA;IACA,qBAAA;ErBo1lDF;EqBt1lDA;IACE,cAAA;IACA,UAAA;ErBw1lDF;EqB11lDA;IACE,cAAA;IACA,UAAA;ErB41lDF;EqB91lDA;IACE,cAAA;IACA,qBAAA;ErBg2lDF;EqBj0lDI;IAhDJ,cAAA;IACA,WAAA;ErBo3lDA;EqB/zlDQ;IAhEN,cAAA;IACA,kBAAA;ErBk4lDF;EqBn0lDQ;IAhEN,cAAA;IACA,mBAAA;ErBs4lDF;EqBv0lDQ;IAhEN,cAAA;IACA,UAAA;ErB04lDF;EqB30lDQ;IAhEN,cAAA;IACA,mBAAA;ErB84lDF;EqB/0lDQ;IAhEN,cAAA;IACA,mBAAA;ErBk5lDF;EqBn1lDQ;IAhEN,cAAA;IACA,UAAA;ErBs5lDF;EqBv1lDQ;IAhEN,cAAA;IACA,mBAAA;ErB05lDF;EqB31lDQ;IAhEN,cAAA;IACA,mBAAA;ErB85lDF;EqB/1lDQ;IAhEN,cAAA;IACA,UAAA;ErBk6lDF;EqBn2lDQ;IAhEN,cAAA;IACA,mBAAA;ErBs6lDF;EqBv2lDQ;IAhEN,cAAA;IACA,mBAAA;ErB06lDF;EqB32lDQ;IAhEN,cAAA;IACA,WAAA;ErB86lDF;EqBv2lDU;IAxDV,cAAA;ErBk6lDA;EqB12lDU;IAxDV,wBAAA;ErBq6lDA;EqB72lDU;IAxDV,yBAAA;ErBw6lDA;EqBh3lDU;IAxDV,gBAAA;ErB26lDA;EqBn3lDU;IAxDV,yBAAA;ErB86lDA;EqBt3lDU;IAxDV,yBAAA;ErBi7lDA;EqBz3lDU;IAxDV,gBAAA;ErBo7lDA;EqB53lDU;IAxDV,yBAAA;ErBu7lDA;EqB/3lDU;IAxDV,yBAAA;ErB07lDA;EqBl4lDU;IAxDV,gBAAA;ErB67lDA;EqBr4lDU;IAxDV,yBAAA;ErBg8lDA;EqBx4lDU;IAxDV,yBAAA;ErBm8lDA;EqBh4lDM;;IAEE,gBAAA;ErBk4lDR;EqB/3lDM;;IAEE,gBAAA;ErBi4lDR;EqBx4lDM;;IAEE,sBAAA;ErB04lDR;EqBv4lDM;;IAEE,sBAAA;ErBy4lDR;EqBh5lDM;;IAEE,qBAAA;ErBk5lDR;EqB/4lDM;;IAEE,qBAAA;ErBi5lDR;EqBx5lDM;;IAEE,mBAAA;ErB05lDR;EqBv5lDM;;IAEE,mBAAA;ErBy5lDR;EqBh6lDM;;IAEE,qBAAA;ErBk6lDR;EqB/5lDM;;IAEE,qBAAA;ErBi6lDR;EqBx6lDM;;IAEE,mBAAA;ErB06lDR;EqBv6lDM;;IAEE,mBAAA;ErBy6lDR;AACF;AmBp+lDI;EEUE;IACE,SAAA;ErB69lDN;EqB19lDI;IApCJ,cAAA;IACA,WAAA;ErBigmDA;EqBn/lDA;IACE,cAAA;IACA,WAAA;ErBq/lDF;EqBv/lDA;IACE,cAAA;IACA,UAAA;ErBy/lDF;EqB3/lDA;IACE,cAAA;IACA,qBAAA;ErB6/lDF;EqB//lDA;IACE,cAAA;IACA,UAAA;ErBigmDF;EqBngmDA;IACE,cAAA;IACA,UAAA;ErBqgmDF;EqBvgmDA;IACE,cAAA;IACA,qBAAA;ErBygmDF;EqB1+lDI;IAhDJ,cAAA;IACA,WAAA;ErB6hmDA;EqBx+lDQ;IAhEN,cAAA;IACA,kBAAA;ErB2imDF;EqB5+lDQ;IAhEN,cAAA;IACA,mBAAA;ErB+imDF;EqBh/lDQ;IAhEN,cAAA;IACA,UAAA;ErBmjmDF;EqBp/lDQ;IAhEN,cAAA;IACA,mBAAA;ErBujmDF;EqBx/lDQ;IAhEN,cAAA;IACA,mBAAA;ErB2jmDF;EqB5/lDQ;IAhEN,cAAA;IACA,UAAA;ErB+jmDF;EqBhgmDQ;IAhEN,cAAA;IACA,mBAAA;ErBmkmDF;EqBpgmDQ;IAhEN,cAAA;IACA,mBAAA;ErBukmDF;EqBxgmDQ;IAhEN,cAAA;IACA,UAAA;ErB2kmDF;EqB5gmDQ;IAhEN,cAAA;IACA,mBAAA;ErB+kmDF;EqBhhmDQ;IAhEN,cAAA;IACA,mBAAA;ErBmlmDF;EqBphmDQ;IAhEN,cAAA;IACA,WAAA;ErBulmDF;EqBhhmDU;IAxDV,cAAA;ErB2kmDA;EqBnhmDU;IAxDV,wBAAA;ErB8kmDA;EqBthmDU;IAxDV,yBAAA;ErBilmDA;EqBzhmDU;IAxDV,gBAAA;ErBolmDA;EqB5hmDU;IAxDV,yBAAA;ErBulmDA;EqB/hmDU;IAxDV,yBAAA;ErB0lmDA;EqBlimDU;IAxDV,gBAAA;ErB6lmDA;EqBrimDU;IAxDV,yBAAA;ErBgmmDA;EqBximDU;IAxDV,yBAAA;ErBmmmDA;EqB3imDU;IAxDV,gBAAA;ErBsmmDA;EqB9imDU;IAxDV,yBAAA;ErBymmDA;EqBjjmDU;IAxDV,yBAAA;ErB4mmDA;EqBzimDM;;IAEE,gBAAA;ErB2imDR;EqBximDM;;IAEE,gBAAA;ErB0imDR;EqBjjmDM;;IAEE,sBAAA;ErBmjmDR;EqBhjmDM;;IAEE,sBAAA;ErBkjmDR;EqBzjmDM;;IAEE,qBAAA;ErB2jmDR;EqBxjmDM;;IAEE,qBAAA;ErB0jmDR;EqBjkmDM;;IAEE,mBAAA;ErBmkmDR;EqBhkmDM;;IAEE,mBAAA;ErBkkmDR;EqBzkmDM;;IAEE,qBAAA;ErB2kmDR;EqBxkmDM;;IAEE,qBAAA;ErB0kmDR;EqBjlmDM;;IAEE,mBAAA;ErBmlmDR;EqBhlmDM;;IAEE,mBAAA;ErBklmDR;AACF;AmB7omDI;EEUE;IACE,SAAA;ErBsomDN;EqBnomDI;IApCJ,cAAA;IACA,WAAA;ErB0qmDA;EqB5pmDA;IACE,cAAA;IACA,WAAA;ErB8pmDF;EqBhqmDA;IACE,cAAA;IACA,UAAA;ErBkqmDF;EqBpqmDA;IACE,cAAA;IACA,qBAAA;ErBsqmDF;EqBxqmDA;IACE,cAAA;IACA,UAAA;ErB0qmDF;EqB5qmDA;IACE,cAAA;IACA,UAAA;ErB8qmDF;EqBhrmDA;IACE,cAAA;IACA,qBAAA;ErBkrmDF;EqBnpmDI;IAhDJ,cAAA;IACA,WAAA;ErBssmDA;EqBjpmDQ;IAhEN,cAAA;IACA,kBAAA;ErBotmDF;EqBrpmDQ;IAhEN,cAAA;IACA,mBAAA;ErBwtmDF;EqBzpmDQ;IAhEN,cAAA;IACA,UAAA;ErB4tmDF;EqB7pmDQ;IAhEN,cAAA;IACA,mBAAA;ErBgumDF;EqBjqmDQ;IAhEN,cAAA;IACA,mBAAA;ErBoumDF;EqBrqmDQ;IAhEN,cAAA;IACA,UAAA;ErBwumDF;EqBzqmDQ;IAhEN,cAAA;IACA,mBAAA;ErB4umDF;EqB7qmDQ;IAhEN,cAAA;IACA,mBAAA;ErBgvmDF;EqBjrmDQ;IAhEN,cAAA;IACA,UAAA;ErBovmDF;EqBrrmDQ;IAhEN,cAAA;IACA,mBAAA;ErBwvmDF;EqBzrmDQ;IAhEN,cAAA;IACA,mBAAA;ErB4vmDF;EqB7rmDQ;IAhEN,cAAA;IACA,WAAA;ErBgwmDF;EqBzrmDU;IAxDV,cAAA;ErBovmDA;EqB5rmDU;IAxDV,wBAAA;ErBuvmDA;EqB/rmDU;IAxDV,yBAAA;ErB0vmDA;EqBlsmDU;IAxDV,gBAAA;ErB6vmDA;EqBrsmDU;IAxDV,yBAAA;ErBgwmDA;EqBxsmDU;IAxDV,yBAAA;ErBmwmDA;EqB3smDU;IAxDV,gBAAA;ErBswmDA;EqB9smDU;IAxDV,yBAAA;ErBywmDA;EqBjtmDU;IAxDV,yBAAA;ErB4wmDA;EqBptmDU;IAxDV,gBAAA;ErB+wmDA;EqBvtmDU;IAxDV,yBAAA;ErBkxmDA;EqB1tmDU;IAxDV,yBAAA;ErBqxmDA;EqBltmDM;;IAEE,gBAAA;ErBotmDR;EqBjtmDM;;IAEE,gBAAA;ErBmtmDR;EqB1tmDM;;IAEE,sBAAA;ErB4tmDR;EqBztmDM;;IAEE,sBAAA;ErB2tmDR;EqBlumDM;;IAEE,qBAAA;ErBoumDR;EqBjumDM;;IAEE,qBAAA;ErBmumDR;EqB1umDM;;IAEE,mBAAA;ErB4umDR;EqBzumDM;;IAEE,mBAAA;ErB2umDR;EqBlvmDM;;IAEE,qBAAA;ErBovmDR;EqBjvmDM;;IAEE,qBAAA;ErBmvmDR;EqB1vmDM;;IAEE,mBAAA;ErB4vmDR;EqBzvmDM;;IAEE,mBAAA;ErB2vmDR;AACF;AmBtzmDI;EEUE;IACE,SAAA;ErB+ymDN;EqB5ymDI;IApCJ,cAAA;IACA,WAAA;ErBm1mDA;EqBr0mDA;IACE,cAAA;IACA,WAAA;ErBu0mDF;EqBz0mDA;IACE,cAAA;IACA,UAAA;ErB20mDF;EqB70mDA;IACE,cAAA;IACA,qBAAA;ErB+0mDF;EqBj1mDA;IACE,cAAA;IACA,UAAA;ErBm1mDF;EqBr1mDA;IACE,cAAA;IACA,UAAA;ErBu1mDF;EqBz1mDA;IACE,cAAA;IACA,qBAAA;ErB21mDF;EqB5zmDI;IAhDJ,cAAA;IACA,WAAA;ErB+2mDA;EqB1zmDQ;IAhEN,cAAA;IACA,kBAAA;ErB63mDF;EqB9zmDQ;IAhEN,cAAA;IACA,mBAAA;ErBi4mDF;EqBl0mDQ;IAhEN,cAAA;IACA,UAAA;ErBq4mDF;EqBt0mDQ;IAhEN,cAAA;IACA,mBAAA;ErBy4mDF;EqB10mDQ;IAhEN,cAAA;IACA,mBAAA;ErB64mDF;EqB90mDQ;IAhEN,cAAA;IACA,UAAA;ErBi5mDF;EqBl1mDQ;IAhEN,cAAA;IACA,mBAAA;ErBq5mDF;EqBt1mDQ;IAhEN,cAAA;IACA,mBAAA;ErBy5mDF;EqB11mDQ;IAhEN,cAAA;IACA,UAAA;ErB65mDF;EqB91mDQ;IAhEN,cAAA;IACA,mBAAA;ErBi6mDF;EqBl2mDQ;IAhEN,cAAA;IACA,mBAAA;ErBq6mDF;EqBt2mDQ;IAhEN,cAAA;IACA,WAAA;ErBy6mDF;EqBl2mDU;IAxDV,cAAA;ErB65mDA;EqBr2mDU;IAxDV,wBAAA;ErBg6mDA;EqBx2mDU;IAxDV,yBAAA;ErBm6mDA;EqB32mDU;IAxDV,gBAAA;ErBs6mDA;EqB92mDU;IAxDV,yBAAA;ErBy6mDA;EqBj3mDU;IAxDV,yBAAA;ErB46mDA;EqBp3mDU;IAxDV,gBAAA;ErB+6mDA;EqBv3mDU;IAxDV,yBAAA;ErBk7mDA;EqB13mDU;IAxDV,yBAAA;ErBq7mDA;EqB73mDU;IAxDV,gBAAA;ErBw7mDA;EqBh4mDU;IAxDV,yBAAA;ErB27mDA;EqBn4mDU;IAxDV,yBAAA;ErB87mDA;EqB33mDM;;IAEE,gBAAA;ErB63mDR;EqB13mDM;;IAEE,gBAAA;ErB43mDR;EqBn4mDM;;IAEE,sBAAA;ErBq4mDR;EqBl4mDM;;IAEE,sBAAA;ErBo4mDR;EqB34mDM;;IAEE,qBAAA;ErB64mDR;EqB14mDM;;IAEE,qBAAA;ErB44mDR;EqBn5mDM;;IAEE,mBAAA;ErBq5mDR;EqBl5mDM;;IAEE,mBAAA;ErBo5mDR;EqB35mDM;;IAEE,qBAAA;ErB65mDR;EqB15mDM;;IAEE,qBAAA;ErB45mDR;EqBn6mDM;;IAEE,mBAAA;ErBq6mDR;EqBl6mDM;;IAEE,mBAAA;ErBo6mDR;AACF;AmB/9mDI;EEUE;IACE,SAAA;ErBw9mDN;EqBr9mDI;IApCJ,cAAA;IACA,WAAA;ErB4/mDA;EqB9+mDA;IACE,cAAA;IACA,WAAA;ErBg/mDF;EqBl/mDA;IACE,cAAA;IACA,UAAA;ErBo/mDF;EqBt/mDA;IACE,cAAA;IACA,qBAAA;ErBw/mDF;EqB1/mDA;IACE,cAAA;IACA,UAAA;ErB4/mDF;EqB9/mDA;IACE,cAAA;IACA,UAAA;ErBggnDF;EqBlgnDA;IACE,cAAA;IACA,qBAAA;ErBognDF;EqBr+mDI;IAhDJ,cAAA;IACA,WAAA;ErBwhnDA;EqBn+mDQ;IAhEN,cAAA;IACA,kBAAA;ErBsinDF;EqBv+mDQ;IAhEN,cAAA;IACA,mBAAA;ErB0inDF;EqB3+mDQ;IAhEN,cAAA;IACA,UAAA;ErB8inDF;EqB/+mDQ;IAhEN,cAAA;IACA,mBAAA;ErBkjnDF;EqBn/mDQ;IAhEN,cAAA;IACA,mBAAA;ErBsjnDF;EqBv/mDQ;IAhEN,cAAA;IACA,UAAA;ErB0jnDF;EqB3/mDQ;IAhEN,cAAA;IACA,mBAAA;ErB8jnDF;EqB//mDQ;IAhEN,cAAA;IACA,mBAAA;ErBkknDF;EqBngnDQ;IAhEN,cAAA;IACA,UAAA;ErBsknDF;EqBvgnDQ;IAhEN,cAAA;IACA,mBAAA;ErB0knDF;EqB3gnDQ;IAhEN,cAAA;IACA,mBAAA;ErB8knDF;EqB/gnDQ;IAhEN,cAAA;IACA,WAAA;ErBklnDF;EqB3gnDU;IAxDV,cAAA;ErBsknDA;EqB9gnDU;IAxDV,wBAAA;ErByknDA;EqBjhnDU;IAxDV,yBAAA;ErB4knDA;EqBphnDU;IAxDV,gBAAA;ErB+knDA;EqBvhnDU;IAxDV,yBAAA;ErBklnDA;EqB1hnDU;IAxDV,yBAAA;ErBqlnDA;EqB7hnDU;IAxDV,gBAAA;ErBwlnDA;EqBhinDU;IAxDV,yBAAA;ErB2lnDA;EqBninDU;IAxDV,yBAAA;ErB8lnDA;EqBtinDU;IAxDV,gBAAA;ErBimnDA;EqBzinDU;IAxDV,yBAAA;ErBomnDA;EqB5inDU;IAxDV,yBAAA;ErBumnDA;EqBpinDM;;IAEE,gBAAA;ErBsinDR;EqBninDM;;IAEE,gBAAA;ErBqinDR;EqB5inDM;;IAEE,sBAAA;ErB8inDR;EqB3inDM;;IAEE,sBAAA;ErB6inDR;EqBpjnDM;;IAEE,qBAAA;ErBsjnDR;EqBnjnDM;;IAEE,qBAAA;ErBqjnDR;EqB5jnDM;;IAEE,mBAAA;ErB8jnDR;EqB3jnDM;;IAEE,mBAAA;ErB6jnDR;EqBpknDM;;IAEE,qBAAA;ErBsknDR;EqBnknDM;;IAEE,qBAAA;ErBqknDR;EqB5knDM;;IAEE,mBAAA;ErB8knDR;EqB3knDM;;IAEE,mBAAA;ErB6knDR;AACF;AsBnsnDA;EACE,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,qDAAA;EACA,6CAAA;EACA,kDAAA;EACA,4CAAA;EACA,iDAAA;EAEA,WAAA;EACA,mBXkfO;EWjfP,4BAAA;EACA,mBXqxB4B;EWpxB5B,0CAAA;AtBosnDF;AsB7rnDE;EACE,uBAAA;EACA,oCAAA;EACA,wBXilB0B;EWhlB1B,wDAAA;AtB+rnDJ;AsB5rnDE;EACE,uBAAA;AtB8rnDJ;AsB3rnDE;EACE,sBAAA;AtB6rnDJ;;AsBzrnDA;EACE,4CAAA;AtB4rnDF;;AsBrrnDA;EACE,iBAAA;AtBwrnDF;;AsB9qnDE;EACE,uBAAA;AtBirnDJ;;AsBlqnDE;EACE,mBAAA;AtBqqnDJ;AsBlqnDI;EACE,mBAAA;AtBoqnDN;;AsB7pnDE;EACE,sBAAA;AtBgqnDJ;AsB7pnDE;EACE,mBAAA;AtB+pnDJ;;AsBrpnDE;EACE,gDAAA;EACA,oCAAA;AtBwpnDJ;;AsBlpnDE;EACE,gDAAA;EACA,oCAAA;AtBqpnDJ;;AsB7onDA;EACE,+CAAA;EACA,mCAAA;AtBgpnDF;;AsBxonDE;EACE,8CAAA;EACA,kCAAA;AtB2onDJ;;AuBhxnDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvB4wnDJ;;AuB9xnDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvB0xnDJ;;AuB5ynDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBwynDJ;;AuB1znDE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,qDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBsznDJ;;AuBx0nDE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,qDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBo0nDJ;;AuBt1nDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBk1nDJ;;AuBp2nDE;EAOE,sBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBg2nDJ;;AuBl3nDE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,+CAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvB82nDJ;;AsBpunDI;EACE,gBAAA;EACA,iCAAA;AtBuunDN;;AmB3znDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtB6unDJ;AACF;AmBl0nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtBmvnDJ;AACF;AmBx0nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtByvnDJ;AACF;AmB90nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtB+vnDJ;AACF;AmBp1nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtBqwnDJ;AACF;AwBl6nDA;EACE,qBb86BsC;AXs/lDxC;;AwB35nDA;EACE,+BAAA;EACA,kCAAA;EACA,gBAAA;EfoRI,kBALI;Ee3QR,gBbgrB4B;AX4umD9B;;AwBx5nDA;EACE,+BAAA;EACA,kCAAA;Ef0QI,sBALI;ATupnDV;;AwBx5nDA;EACE,gCAAA;EACA,mCAAA;EfoQI,uBALI;AT6pnDV;;AyBz7nDA;EACE,mBds6BsC;EFtoBlC,kBALI;EgBvRR,cduJS;AXmynDX;;A0B/7nDA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EjB8RI,oBALI;EiBtRR,gBforB4B;EenrB5B,gBf0rB4B;EezrB5B,2Bfm8BsC;Eel8BtC,oCf67BsC;Ee57BtC,4BAAA;EACA,wCAAA;EACA,gBAAA;EdGE,sBAAA;EeHE,wEDMJ;A1B67nDF;A2B/7nDM;EDhBN;ICiBQ,gBAAA;E3Bk8nDN;AACF;A0Bh8nDE;EACE,gBAAA;A1Bk8nDJ;A0Bh8nDI;EACE,eAAA;A1Bk8nDN;A0B77nDE;EACE,2Bf66BoC;Ee56BpC,oCfu6BoC;Eet6BpC,0Cfq7BoC;Eep7BpC,UAAA;EAKE,4Cf6zB0B;AX8nmDhC;A0Bp7nDE;EAEE,aAAA;A1Bq7nDJ;A0Bj7nDE;EACE,cfwGO;EetGP,UAAA;A1Bk7nDJ;A0B16nDE;EAEE,6Cfw4BoC;Eer4BpC,UAAA;A1By6nDJ;A0Br6nDE;EACE,sBAAA;EACA,uBAAA;EACA,yBfgxB0B;Ee/wB1B,2Bfg4BoC;EiB38BtC,gDjBoiCsC;Eev9BpC,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4Bf0hB0B;EezhB1B,gBAAA;ECtEE,qIDuEF;A1Bu6nDJ;A2B1+nDM;EDuDJ;ICtDM,gBAAA;E3B6+nDN;AACF;A0Bz6nDE;EACE,gDf68BoC;AX89lDxC;;A0Bl6nDA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBf4lB4B;Ee3lB5B,2Bfq3BsC;Eep3BtC,6BAAA;EACA,yBAAA;EACA,mBAAA;A1Bq6nDF;A0Bn6nDE;EACE,UAAA;A1Bq6nDJ;A0Bl6nDE;EAEE,gBAAA;EACA,eAAA;A1Bm6nDJ;;A0Bx5nDA;EACE,sCfs2BsC;Eer2BtC,uBAAA;EjBkKI,uBALI;EG7QN,qBAAA;AZ6goDJ;A0Bz5nDE;EACE,uBAAA;EACA,wBAAA;EACA,yBfguB0B;AX2rmD9B;;A0Bv5nDA;EACE,sCf01BsC;Eez1BtC,sBAAA;EjBqJI,sBALI;EG7QN,qBAAA;AZyhoDJ;A0Bx5nDE;EACE,sBAAA;EACA,uBAAA;EACA,yBfutB0B;AXmsmD9B;;A0Bl5nDE;EACE,oCfu0BoC;AX8kmDxC;A0Bl5nDE;EACE,sCfo0BoC;AXglmDxC;A0Bj5nDE;EACE,sCfi0BoC;AXklmDxC;;A0B94nDA;EACE,Wf8zBsC;Ee7zBtC,gCfwzBsC;EevzBtC,ef6qB4B;AXoumD9B;A0B/4nDE;EACE,eAAA;A1Bi5nDJ;A0B94nDE;EACE,oBAAA;EdpKA,sBAAA;AZqjoDJ;A0B74nDE;EdxKE,sBAAA;AZwjoDJ;A0B54nDE;EAAoB,kCfyyBkB;AXsmmDxC;A0B94nDE;EAAoB,kCfyyBkB;AXwmmDxC;;A6B5koDA;EACE,cAAA;EACA,WAAA;EACA,oCAAA;EACA,sCAAA;EpB4RI,oBALI;EoBpRR,gBlBkrB4B;EkBjrB5B,gBlBwrB4B;EkBvrB5B,2BlBi8BsC;EkBh8BtC,oClB27BsC;EkB17BtC,0DAAA;EACA,4BAAA;EACA,wClBuiCkC;EkBtiClC,0BlBuiCkC;EkBtiClC,wCAAA;EjBDE,sBAAA;EeHE,wEEOJ;A7B6koDF;A2BhloDM;EEfN;IFgBQ,gBAAA;E3BmloDN;AACF;A6BpmoDA;EAmBE,gBAAA;A7BoloDF;A6BlloDE;EACE,0ClB87BoC;EkB77BpC,UAAA;EAKE,4ClBwiC4B;AXwimDlC;A6B5koDE;EAEE,qBlBuzB0B;EkBtzB1B,sBAAA;A7B6koDJ;A6B1koDE;EAEE,6ClB+5BoC;AX4qmDxC;A6BtkoDE;EACE,kBAAA;EACA,uCAAA;A7BwkoDJ;;A6BpkoDA;EACE,oBlBgzB4B;EkB/yB5B,uBlB+yB4B;EkB9yB5B,oBlB+yB4B;EFrkBxB,uBALI;EG7QN,qBAAA;AZinoDJ;;A6BpkoDA;EACE,mBlB4yB4B;EkB3yB5B,sBlB2yB4B;EkB1yB5B,oBlB2yB4B;EFzkBxB,sBALI;EG7QN,qBAAA;AZynoDJ;;A8BxooDA;EACE,cAAA;EACA,sBnB2+BwC;EmB1+BxC,mBnB2+BwC;EmB1+BxC,uBnB2+BwC;AXgqmD1C;A8BzooDE;EACE,WAAA;EACA,mBAAA;A9B2ooDJ;;A8BvooDA;EACE,oBnBi+BwC;EmBh+BxC,eAAA;EACA,iBAAA;A9B0ooDF;A8BxooDE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A9B0ooDJ;;A8BtooDA;EACE,YnBm9BwC;EmBl9BxC,anBk9BwC;EmBj9BxC,iBAAA;EACA,mBAAA;EACA,oCnBy6BsC;EmBx6BtC,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8CnBs9BwC;EmBr9BxC,gBAAA;EACA,yBAAA;A9ByooDF;A8BtooDE;ElBvBE,qBAAA;AZgqoDJ;A8BrooDE;EAEE,kBnB68BsC;AXyrmD1C;A8BnooDE;EACE,uBnBo8BsC;AXismD1C;A8BlooDE;EACE,0CnBi6BoC;EmBh6BpC,UAAA;EACA,4CnB6yB4B;AXu1mDhC;A8BjooDE;EACE,yBnB0HS;EmBzHT,qBnByHS;AX0goDb;A8BjooDI;EAII,0DAAA;A9BgooDR;A8B5noDI;EAII,0DAAA;A9B2noDR;A8BtnoDE;EACE,yBnBqGS;EmBpGT,qBnBoGS;EmB/FP,0DAAA;A9BonoDN;A8BhnoDE;EACE,oBAAA;EACA,YAAA;EACA,YnB46BuC;AXssmD3C;A8B3moDI;EACE,eAAA;EACA,YnBm6BqC;AX0smD3C;;A8B/loDA;EACE,mBnB85BgC;AXosmDlC;A8BhmoDE;EACE,UnB05B8B;EmBz5B9B,mBAAA;EACA,0DAAA;EACA,gCAAA;ElB3GA,kBAAA;EeHE,iDGgHF;A9BkmoDJ;A2B9soDM;EGsGJ;IHrGM,gBAAA;E3BitoDN;AACF;A8BrmoDI;EACE,0DAAA;A9BumoDN;A8BpmoDI;EACE,iCnBy5B4B;EmBp5B1B,0DAAA;A9BkmoDR;A8B7loDE;EACE,oBnBo4B8B;EmBn4B9B,eAAA;A9B+loDJ;A8B7loDI;EACE,oBAAA;EACA,cAAA;A9B+loDN;;A8B1loDA;EACE,qBAAA;EACA,kBnBk3BgC;AX2umDlC;;A8B1loDA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9B6loDF;A8BzloDI;EACE,oBAAA;EACA,YAAA;EACA,anBouBwB;AXu3mD9B;;A+BhwoDA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A/BmwoDF;A+BjwoDE;EACE,UAAA;A/BmwoDJ;A+B/voDI;EAA0B,+DpBolCa;AX8qmD3C;A+BjwoDI;EAA0B,+DpBmlCa;AXirmD3C;A+BjwoDE;EACE,SAAA;A/BmwoDJ;A+BhwoDE;EACE,WpBqkCuC;EoBpkCvC,YpBokCuC;EoBnkCvC,oBAAA;EHzBF,yBjBoLW;EoBzJT,SpBokCuC;EChlCvC,mBAAA;EeHE,oHIkBF;EJlBE,4GIkBF;A/BiwoDJ;A2B/woDM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;E3BkxoDN;AACF;A+B9woDE;EASE,gBAAA;A/BwwoDJ;A+BtwoDI;EHjCF,0CjBomCyC;AXssmD3C;A+BpwoDE;EACE,WpB8iC8B;EoB7iC9B,cpB8iC8B;EoB7iC9B,kBAAA;EACA,epB6iC8B;EoB5iC9B,oCpB6iC8B;EoB5iC9B,yBAAA;EnB7BA,mBAAA;AZoyoDJ;A+BlwoDE;EACE,WpB0iCuC;EoBziCvC,YpByiCuC;EiB5lCzC,yBjBoLW;EoB/HT,SpB0iCuC;EChlCvC,mBAAA;EeHE,iHI4CF;EJ5CE,4GI4CF;A/BmwoDJ;A2B3yoDM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;E3B8yoDN;AACF;A+B/woDE;EAQE,gBAAA;A/B0woDJ;A+BxwoDI;EH3DF,0CjBomCyC;AXkumD3C;A+BtwoDE;EACE,WpBohC8B;EoBnhC9B,cpBohC8B;EoBnhC9B,kBAAA;EACA,epBmhC8B;EoBlhC9B,oCpBmhC8B;EoBlhC9B,yBAAA;EnBvDA,mBAAA;AZg0oDJ;A+BpwoDE;EACE,oBAAA;A/BswoDJ;A+BpwoDI;EACE,yBpB4EK;AX0roDX;A+BnwoDI;EACE,yBpBwEK;AX6roDX;;AgC51oDA;EACE,kBAAA;AhC+1oDF;AgC71oDE;;;EAGE,0BrB8mC8B;EqB7mC9B,iBrB8mC8B;AXivmDlC;AgC51oDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELPE,gEKQF;AhC81oDJ;A2Bl2oDM;EKVJ;ILWM,gBAAA;E3Bq2oDN;AACF;AgCh2oDE;;EAEE,oBAAA;AhCk2oDJ;AgCh2oDI;;EACE,kBAAA;AhCm2oDN;AgCh2oDI;;;EAEE,qBrBmlC4B;EqBllC5B,wBrBmlC4B;AXgxmDlC;AgCh2oDI;;EACE,qBrB8kC4B;EqB7kC5B,wBrB8kC4B;AXqxmDlC;AgC/1oDE;EACE,qBrBwkC8B;EqBvkC9B,wBrBwkC8B;AXyxmDlC;AgC11oDI;;;;EACE,arBikC4B;EqBhkC5B,8DrBikC4B;AX8xmDlC;AgC11oDI;EACE,arB0jC4B;EqBzjC5B,8DrB0jC4B;AXkymDlC;AgCv1oDI;EACE,mBAAA;AhCy1oDN;;AiC55oDA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AjC+5oDF;AiC75oDE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AjC+5oDJ;AiC35oDE;;;EAGE,UAAA;AjC65oDJ;AiCv5oDE;EACE,kBAAA;EACA,UAAA;AjCy5oDJ;AiCv5oDI;EACE,UAAA;AjCy5oDN;;AiC94oDA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ExBoPI,oBALI;EwB7OR,gBtB2oB4B;EsB1oB5B,gBtBipB4B;EsBhpB5B,2BtB05BsC;EsBz5BtC,kBAAA;EACA,mBAAA;EACA,gDtBg/BsC;EsB/+BtC,wCAAA;ErBtCE,sBAAA;AZw7oDJ;;AiCx4oDA;;;;EAIE,sBAAA;ExB8NI,sBALI;EG7QN,qBAAA;AZi8oDJ;;AiCx4oDA;;;;EAIE,uBAAA;ExBqNI,uBALI;EG7QN,qBAAA;AZ08oDJ;;AiCx4oDA;;EAEE,qBAAA;AjC24oDF;;AiC93oDI;;;;ErBjEA,0BAAA;EACA,6BAAA;AZs8oDJ;AiC73oDI;;;;ErB1EA,0BAAA;EACA,6BAAA;AZ68oDJ;AiCv3oDE;EACE,iBAAA;ErB1EA,yBAAA;EACA,4BAAA;AZo8oDJ;AiCv3oDE;;ErB9EE,yBAAA;EACA,4BAAA;AZy8oDJ;;AkCl+oDE;EACE,aAAA;EACA,WAAA;EACA,mBvB+4BoC;EFtoBlC,kBALI;EyBjQN,cvBgnCqB;AXo3mDzB;;AkCj+oDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EzB4PE,uBALI;EyBpPN,WAvBc;EAwBd,yCAvBiB;EtBHjB,qBAAA;AZ8/oDJ;;AkC/9oDI;;;;EAEE,cAAA;AlCo+oDN;;AkClhpDI;EAoDE,qBvBqlCmB;EuBllCjB,iCvBs6BgC;EuBr6BhC,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;AlCg+oDR;AkC79oDM;EACE,qBvB0kCiB;EuBzkCjB,4CA/Ca;AlC8gpDrB;;AkC/hpDI;EAyEI,iCvBo5BgC;EuBn5BhC,8EAAA;AlC09oDR;;AkCpipDI;EAiFE,qBvBwjCmB;AX+5mDzB;AkCp9oDQ;EAEE,sBvBk+B8B;EuBj+B9B,oGAAA;EACA,6DAAA;EACA,uEAAA;AlCq9oDV;AkCj9oDM;EACE,qBvB2iCiB;EuB1iCjB,4CA9Ea;AlCiipDrB;;AkCljpDI;EAuGI,sCAAA;AlC+8oDR;;AkCtjpDI;EA8GE,qBvB2hCmB;AXi7mDzB;AkC18oDM;EACE,yBvBwhCiB;AXo7mDzB;AkCz8oDM;EACE,4CApGa;AlC+ipDrB;AkCx8oDM;EACE,cvBghCiB;AX07mDzB;;AkCr8oDI;EACE,kBAAA;AlCw8oDN;;AkCvkpDI;;;;;EAyIM,UAAA;AlCs8oDV;;AkC5jpDE;EACE,aAAA;EACA,WAAA;EACA,mBvB+4BoC;EFtoBlC,kBALI;EyBjQN,cvBgnCqB;AX88mDzB;;AkC3jpDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EzB4PE,uBALI;EyBpPN,WAvBc;EAwBd,yCAvBiB;EtBHjB,qBAAA;AZwlpDJ;;AkCzjpDI;;;;EAEE,cAAA;AlC8jpDN;;AkC5mpDI;EAoDE,qBvBqlCmB;EuBllCjB,iCvBs6BgC;EuBr6BhC,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;AlC0jpDR;AkCvjpDM;EACE,qBvB0kCiB;EuBzkCjB,4CA/Ca;AlCwmpDrB;;AkCznpDI;EAyEI,iCvBo5BgC;EuBn5BhC,8EAAA;AlCojpDR;;AkC9npDI;EAiFE,qBvBwjCmB;AXy/mDzB;AkC9ipDQ;EAEE,sBvBk+B8B;EuBj+B9B,oGAAA;EACA,6DAAA;EACA,uEAAA;AlC+ipDV;AkC3ipDM;EACE,qBvB2iCiB;EuB1iCjB,4CA9Ea;AlC2npDrB;;AkC5opDI;EAuGI,sCAAA;AlCyipDR;;AkChppDI;EA8GE,qBvB2hCmB;AX2gnDzB;AkCpipDM;EACE,yBvBwhCiB;AX8gnDzB;AkCnipDM;EACE,4CApGa;AlCyopDrB;AkClipDM;EACE,cvBghCiB;AXohnDzB;;AkC/hpDI;EACE,kBAAA;AlCkipDN;;AkCjqpDI;;;;;EA2IM,UAAA;AlC8hpDV;;AmC3qpDA;EAEE,0BAAA;EACA,0BAAA;EACA,sBAAA;E1B6RI,6BALI;E0BtRR,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,+BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,2EAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E1B4QI,kCALI;E0BrQR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;AnCyqpDF;A2B7rpDM;EQhBN;IRiBQ,gBAAA;E3BgspDN;AACF;AmC5qpDE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AnC6qpDJ;AmC1qpDE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AnC2qpDJ;AmCxqpDE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AnCsqpDN;AmClqpDE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AnCgqpDN;AmC5ppDE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AnCwppDJ;AmCrppDI;EAKI,0CAAA;AnCmppDR;AmC9opDE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AnC6opDJ;;AmCjopDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,gDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC2upDF;;AmClppDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,iDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC4vpDF;;AmCnqpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC6wpDF;;AmCprpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC8xpDF;;AmCrspDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,mDAAA;EACA,sCAAA;EACA,2BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC+ypDF;;AmCttpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCg0pDF;;AmCvupDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,wDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCi1pDF;;AmCxvpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCk2pDF;;AmC/upDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC01pDF;;AmChwpDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC22pDF;;AmCjxpDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC43pDF;;AmClypDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC64pDF;;AmCnzpDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC85pDF;;AmCp0pDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC+6pDF;;AmCr1pDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCg8pDF;;AmCt2pDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCi9pDF;;AmC32pDA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,yBAAA;EACA,uCAAA;EAEA,0BxB2XwC;AXk/oD1C;AmCn2pDE;EACE,0BAAA;AnCq2pDJ;AmCl2pDE;EACE,gCAAA;AnCo2pDJ;;AmCz1pDA;ECxIE,0BAAA;EACA,0BAAA;E3BoOI,+BALI;E2B7NR,8BAAA;ApCq+pDF;;AmC51pDA;EC5IE,2BAAA;EACA,0BAAA;E3BoOI,gCALI;E2B7NR,8BAAA;ApC4+pDF;;AqC/iqDA;EVgBM,gCUfJ;ArCkjqDF;A2B/hqDM;EUpBN;IVqBQ,gBAAA;E3BkiqDN;AACF;AqCrjqDE;EACE,UAAA;ArCujqDJ;;AqCjjqDE;EACE,aAAA;ArCojqDJ;;AqChjqDA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;ArCmjqDF;A2BjjqDM;EULN;IVMQ,gBAAA;E3BojqDN;AACF;AqCtjqDE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;ArCwjqDJ;A2B3jqDM;EUAJ;IVCM,gBAAA;E3B8jqDN;AACF;;AsCnlqDA;;;;;;EAME,kBAAA;AtCslqDF;;AsCnlqDA;EACE,mBAAA;AtCslqDF;;AsC/kqDA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E7B6QI,kCALI;E6BtQR,yCAAA;EACA,sBAAA;EACA,kDAAA;EACA,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,gDAAA;EACA,sCAAA;EACA,2DAAA;EACA,iCAAA;EACA,qDAAA;EACA,oCAAA;EACA,sDAAA;EACA,qCAAA;EACA,0CAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,sCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E7BgPI,uCALI;E6BzOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AZynqDJ;AsC5kqDE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AtC8kqDJ;;AsCtjqDI;EACE,oBAAA;AtCyjqDN;AsCvjqDM;EACE,WAAA;EACA,OAAA;AtCyjqDR;;AsCrjqDI;EACE,kBAAA;AtCwjqDN;AsCtjqDM;EACE,QAAA;EACA,UAAA;AtCwjqDR;;AmBlmqDI;EmB4BA;IACE,oBAAA;EtC0kqDJ;EsCxkqDI;IACE,WAAA;IACA,OAAA;EtC0kqDN;EsCtkqDE;IACE,kBAAA;EtCwkqDJ;EsCtkqDI;IACE,QAAA;IACA,UAAA;EtCwkqDN;AACF;AmBnnqDI;EmB4BA;IACE,oBAAA;EtC0lqDJ;EsCxlqDI;IACE,WAAA;IACA,OAAA;EtC0lqDN;EsCtlqDE;IACE,kBAAA;EtCwlqDJ;EsCtlqDI;IACE,QAAA;IACA,UAAA;EtCwlqDN;AACF;AmBnoqDI;EmB4BA;IACE,oBAAA;EtC0mqDJ;EsCxmqDI;IACE,WAAA;IACA,OAAA;EtC0mqDN;EsCtmqDE;IACE,kBAAA;EtCwmqDJ;EsCtmqDI;IACE,QAAA;IACA,UAAA;EtCwmqDN;AACF;AmBnpqDI;EmB4BA;IACE,oBAAA;EtC0nqDJ;EsCxnqDI;IACE,WAAA;IACA,OAAA;EtC0nqDN;EsCtnqDE;IACE,kBAAA;EtCwnqDJ;EsCtnqDI;IACE,QAAA;IACA,UAAA;EtCwnqDN;AACF;AmBnqqDI;EmB4BA;IACE,oBAAA;EtC0oqDJ;EsCxoqDI;IACE,WAAA;IACA,OAAA;EtC0oqDN;EsCtoqDE;IACE,kBAAA;EtCwoqDJ;EsCtoqDI;IACE,QAAA;IACA,UAAA;EtCwoqDN;AACF;AsC/nqDE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AtCioqDJ;AsCxnqDE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AtC0nqDJ;AsCrnqDI;EACE,iBAAA;AtCunqDN;;AsCjnqDE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AtConqDJ;AsC/mqDI;EACE,iBAAA;AtCinqDN;;AsC1mqDA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AtC6mqDF;;AsCvmqDA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3B2gB4B;E2B1gB5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AtC0mqDF;AsCxmqDE;EAEE,0CAAA;EVzLF,kDU2LuB;AtCwmqDzB;AsCrmqDE;EAEE,2CAAA;EACA,qBAAA;EVjMF,mDUkMuB;AtCsmqDzB;AsCnmqDE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AtComqDJ;;AsC9lqDA;EACE,cAAA;AtCimqDF;;AsC7lqDA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E7B0EI,uBALI;E6BnER,sCAAA;EACA,mBAAA;AtCgmqDF;;AsC5lqDA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AtC+lqDF;;AsC3lqDA;EAEE,4BAAA;EACA,yBAAA;EACA,kDAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,gDAAA;EACA,sDAAA;EACA,qCAAA;EACA,sEAAA;EACA,0CAAA;EACA,mCAAA;AtC6lqDF;;AuCl1qDA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AvCq1qDF;AuCn1qDE;;EACE,kBAAA;EACA,cAAA;AvCs1qDJ;AuCj1qDE;;;;;;;;;;;;EAME,UAAA;AvCy1qDJ;;AuCp1qDA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AvCu1qDF;AuCr1qDE;EACE,WAAA;AvCu1qDJ;;AuCn1qDA;E3BhBI,sBAAA;AZu2qDJ;AuCn1qDE;;EAEE,iBAAA;AvCq1qDJ;AuCj1qDE;;;E3BVE,0BAAA;EACA,6BAAA;AZg2qDJ;AuC70qDE;;;E3BNE,yBAAA;EACA,4BAAA;AZw1qDJ;;AuCh0qDA;EACE,uBAAA;EACA,sBAAA;AvCm0qDF;AuCj0qDE;EAGE,cAAA;AvCi0qDJ;AuC9zqDE;EACE,eAAA;AvCg0qDJ;;AuC5zqDA;EACE,uBAAA;EACA,sBAAA;AvC+zqDF;;AuC5zqDA;EACE,qBAAA;EACA,oBAAA;AvC+zqDF;;AuC3yqDA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AvC8yqDF;AuC5yqDE;;EAEE,WAAA;AvC8yqDJ;AuC3yqDE;;EAEE,gBAAA;AvC6yqDJ;AuCzyqDE;;E3B1FE,6BAAA;EACA,4BAAA;AZu4qDJ;AuCzyqDE;;E3B7GE,yBAAA;EACA,0BAAA;AZ05qDJ;;AwCl7qDA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AxCi7qDF;;AwC96qDA;EACE,cAAA;EACA,kEAAA;E/B4QI,uCALI;E+BrQR,2CAAA;EACA,+BAAA;EACA,qBAAA;EbbI,uGacJ;AxCi7qDF;A2B37qDM;EaGN;IbFQ,gBAAA;E3B87qDN;AACF;AwCp7qDE;EAEE,qCAAA;AxCq7qDJ;AwCh7qDE;EACE,wCAAA;EACA,oBAAA;EACA,eAAA;AxCk7qDJ;;AwC16qDA;EAEE,+BAAA;EACA,8CAAA;EACA,oCAAA;EACA,+FAAA;EACA,wCAAA;EACA,+DAAA;EACA,+GAAA;EAGA,oFAAA;AxC06qDF;AwCx6qDE;EACE,yDAAA;EACA,gBAAA;EACA,yDAAA;E5BtCA,wDAAA;EACA,yDAAA;AZi9qDJ;AwCz6qDI;EAGE,kBAAA;EACA,wDAAA;AxCy6qDN;AwCt6qDI;EAEE,wCAAA;EACA,6BAAA;EACA,yBAAA;AxCu6qDN;AwCn6qDE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AxCq6qDJ;AwCl6qDE;EAEE,sDAAA;E5BjEA,yBAAA;EACA,0BAAA;AZq+qDJ;;AwC15qDA;EAEE,qCAAA;EACA,sCAAA;EACA,sCAAA;AxC45qDF;AwCz5qDE;EACE,gBAAA;EACA,SAAA;E5B9FA,gDAAA;AZ0/qDJ;AwCz5qDI;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;AxC25qDN;AwCv5qDE;;EAEE,4CAAA;EZzHF,oDY0HuB;AxCy5qDzB;;AwC/4qDE;;EAEE,cAAA;EACA,kBAAA;AxCk5qDJ;;AwC74qDE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AxCg5qDJ;;AwC14qDE;;EACE,WAAA;AxC84qDJ;;AwCp4qDE;EACE,aAAA;AxCu4qDJ;AwCr4qDE;EACE,cAAA;AxCu4qDJ;;AyC3irDA;EAEE,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,0CAAA;EACA,kCAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EACA,qEAAA;EACA,oDAAA;EACA,0CAAA;EACA,kCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AzC2irDF;AyCrirDE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AzC6irDJ;AyCzhrDA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EhCkOI,2CALI;EgC3NR,mCAAA;EACA,qBAAA;EACA,mBAAA;AzC2hrDF;AyCzhrDE;EAEE,yCAAA;AzC0hrDJ;;AyChhrDA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AzC+grDF;AyC7grDE;;EAEE,oCAAA;AzC+grDJ;AyC5grDE;EACE,gBAAA;AzC8grDJ;;AyCrgrDA;EACE,mB9B2jCkC;E8B1jClC,sB9B0jCkC;E8BzjClC,6BAAA;AzCwgrDF;AyCtgrDE;;;EAGE,oCAAA;AzCwgrDJ;;AyC3/qDA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AzC4/qDF;;AyCx/qDA;EACE,8EAAA;EhCiJI,6CALI;EgC1IR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E7BtIE,qDAAA;EeHE,+Cc2IJ;AzC2/qDF;A2BlorDM;Ec+HN;Id9HQ,gBAAA;E3BqorDN;AACF;AyC9/qDE;EACE,qBAAA;AzCggrDJ;AyC7/qDE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AzC+/qDJ;;AyCz/qDA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AzC4/qDF;;AyCz/qDA;EACE,yCAAA;EACA,gBAAA;AzC4/qDF;;AmBpnrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCm/qDN;EyCj/qDM;IACE,mBAAA;EzCm/qDR;EyCj/qDQ;IACE,kBAAA;EzCm/qDV;EyCh/qDQ;IACE,kDAAA;IACA,iDAAA;EzCk/qDV;EyC9+qDM;IACE,iBAAA;EzCg/qDR;EyC7+qDM;IACE,wBAAA;IACA,gBAAA;EzC++qDR;EyC5+qDM;IACE,aAAA;EzC8+qDR;EyC3+qDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzC2+qDR;EyCx+qDQ;IACE,aAAA;EzC0+qDV;EyCv+qDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCy+qDV;AACF;AmBpqrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCkirDN;EyChirDM;IACE,mBAAA;EzCkirDR;EyChirDQ;IACE,kBAAA;EzCkirDV;EyC/hrDQ;IACE,kDAAA;IACA,iDAAA;EzCiirDV;EyC7hrDM;IACE,iBAAA;EzC+hrDR;EyC5hrDM;IACE,wBAAA;IACA,gBAAA;EzC8hrDR;EyC3hrDM;IACE,aAAA;EzC6hrDR;EyC1hrDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzC0hrDR;EyCvhrDQ;IACE,aAAA;EzCyhrDV;EyCthrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCwhrDV;AACF;AmBntrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCilrDN;EyC/krDM;IACE,mBAAA;EzCilrDR;EyC/krDQ;IACE,kBAAA;EzCilrDV;EyC9krDQ;IACE,kDAAA;IACA,iDAAA;EzCglrDV;EyC5krDM;IACE,iBAAA;EzC8krDR;EyC3krDM;IACE,wBAAA;IACA,gBAAA;EzC6krDR;EyC1krDM;IACE,aAAA;EzC4krDR;EyCzkrDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzCykrDR;EyCtkrDQ;IACE,aAAA;EzCwkrDV;EyCrkrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCukrDV;AACF;AmBlwrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCgorDN;EyC9nrDM;IACE,mBAAA;EzCgorDR;EyC9nrDQ;IACE,kBAAA;EzCgorDV;EyC7nrDQ;IACE,kDAAA;IACA,iDAAA;EzC+nrDV;EyC3nrDM;IACE,iBAAA;EzC6nrDR;EyC1nrDM;IACE,wBAAA;IACA,gBAAA;EzC4nrDR;EyCznrDM;IACE,aAAA;EzC2nrDR;EyCxnrDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzCwnrDR;EyCrnrDQ;IACE,aAAA;EzCunrDV;EyCpnrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCsnrDV;AACF;AmBjzrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzC+qrDN;EyC7qrDM;IACE,mBAAA;EzC+qrDR;EyC7qrDQ;IACE,kBAAA;EzC+qrDV;EyC5qrDQ;IACE,kDAAA;IACA,iDAAA;EzC8qrDV;EyC1qrDM;IACE,iBAAA;EzC4qrDR;EyCzqrDM;IACE,wBAAA;IACA,gBAAA;EzC2qrDR;EyCxqrDM;IACE,aAAA;EzC0qrDR;EyCvqrDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzCuqrDR;EyCpqrDQ;IACE,aAAA;EzCsqrDV;EyCnqrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCqqrDV;AACF;AyC5trDI;EAEI,iBAAA;EACA,2BAAA;AzC6trDR;AyC3trDQ;EACE,mBAAA;AzC6trDV;AyC3trDU;EACE,kBAAA;AzC6trDZ;AyC1trDU;EACE,kDAAA;EACA,iDAAA;AzC4trDZ;AyCxtrDQ;EACE,iBAAA;AzC0trDV;AyCvtrDQ;EACE,wBAAA;EACA,gBAAA;AzCytrDV;AyCttrDQ;EACE,aAAA;AzCwtrDV;AyCrtrDQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ed5NJ,gBc8NI;AzCqtrDV;AyCltrDU;EACE,aAAA;AzCotrDZ;AyCjtrDU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AzCmtrDZ;;AyClsrDA;EAEE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AzCosrDF;;A0Cn9rDA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,yBAAA;EACA,4CAAA;EACA,gCAAA;EACA,sDAAA;EACA,sCAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E9BdE,2CAAA;AZk+rDJ;A0Ch9rDE;EACE,eAAA;EACA,cAAA;A1Ck9rDJ;A0C/8rDE;EACE,mBAAA;EACA,sBAAA;A1Ci9rDJ;A0C/8rDI;EACE,mBAAA;E9BnBF,0DAAA;EACA,2DAAA;AZq+rDJ;A0C/8rDI;EACE,sBAAA;E9BVF,8DAAA;EACA,6DAAA;AZ49rDJ;A0C58rDE;;EAEE,aAAA;A1C88rDJ;;A0C18rDA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A1C28rDF;;A0Cx8rDA;EACE,4CAAA;A1C28rDF;;A0Cx8rDA;EACE,sDAAA;EACA,gBAAA;A1C28rDF;;A0Cx8rDA;EACE,gBAAA;A1C28rDF;;A0Cn8rDE;EACE,oCAAA;A1Cs8rDJ;;A0C97rDA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A1Ci8rDF;A0C/7rDE;E9BxFE,wFAAA;AZ0hsDJ;;A0C77rDA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A1Cg8rDF;A0C97rDE;E9BnGE,wFAAA;AZoisDJ;;A0Cv7rDA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A1C07rDF;A0Cx7rDE;EACE,mCAAA;EACA,sCAAA;A1C07rDJ;;A0Ct7rDA;EACE,uDAAA;EACA,sDAAA;A1Cy7rDF;;A0Cr7rDA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E9BrIE,iDAAA;AZ8jsDJ;;A0Cr7rDA;;;EAGE,WAAA;A1Cw7rDF;;A0Cr7rDA;;E9BtII,0DAAA;EACA,2DAAA;AZgksDJ;;A0Ct7rDA;;E9B7HI,8DAAA;EACA,6DAAA;AZwjsDJ;;A0C/6rDE;EACE,0CAAA;A1Ck7rDJ;AmBxisDI;EuBkHJ;IAQI,aAAA;IACA,mBAAA;E1Ck7rDF;E0C/6rDE;IAEE,SAAA;IACA,gBAAA;E1Cg7rDJ;E0C96rDI;IACE,cAAA;IACA,cAAA;E1Cg7rDN;E0C36rDM;I9BtKJ,0BAAA;IACA,6BAAA;EZolsDF;E0C56rDQ;;IAGE,0BAAA;E1C66rDV;E0C36rDQ;;IAGE,6BAAA;E1C46rDV;E0Cx6rDM;I9BvKJ,yBAAA;IACA,4BAAA;EZklsDF;E0Cz6rDQ;;IAGE,yBAAA;E1C06rDV;E0Cx6rDQ;;IAGE,4BAAA;E1Cy6rDV;AACF;;A2CzosDA;EAEE,0CAAA;EACA,uBAAA;EACA,8KAAA;EACA,mDAAA;EACA,gCAAA;EACA,qCAAA;EACA,uDAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,2BAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,mEAAA;EACA,0EAAA;EACA,sCAAA;EACA,mCAAA;EACA,iDAAA;EACA,kDAAA;A3C2osDF;;A2CvosDA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;ElCiQI,oBALI;EkC1PR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;E/BtBE,gBAAA;E+BwBF,qBAAA;EhB3BI,0CgB4BJ;A3C0osDF;A2BlqsDM;EgBWN;IhBVQ,gBAAA;E3BqqsDN;AACF;A2C7osDE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A3C+osDJ;A2C7osDI;EACE,qDAAA;EACA,iDAAA;A3C+osDN;A2C1osDE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EhBlDE,mDgBmDF;A3C4osDJ;A2B3rsDM;EgBsCJ;IhBrCM,gBAAA;E3B8rsDN;AACF;A2C9osDE;EACE,UAAA;A3CgpsDJ;A2C7osDE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;A3C+osDJ;;A2C3osDA;EACE,gBAAA;A3C8osDF;;A2C3osDA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A3C8osDF;A2C5osDE;E/B/DE,yDAAA;EACA,0DAAA;AZ8ssDJ;A2C7osDI;E/BlEA,+DAAA;EACA,gEAAA;AZktsDJ;A2C5osDE;EACE,aAAA;A3C8osDJ;A2C1osDE;E/B9DE,6DAAA;EACA,4DAAA;AZ2ssDJ;A2C1osDM;E/BlEF,mEAAA;EACA,kEAAA;AZ+ssDJ;A2CzosDI;E/BvEA,6DAAA;EACA,4DAAA;AZmtsDJ;;A2CvosDA;EACE,8EAAA;A3C0osDF;;A2CjosDE;EACE,eAAA;A3CoosDJ;A2CjosDE;EACE,eAAA;EACA,cAAA;E/BpHA,gBAAA;AZwvsDJ;A2CjosDI;EAAgB,aAAA;A3CoosDpB;A2CnosDI;EAAe,gBAAA;A3CsosDnB;A2CnosDM;E/B3HF,gBAAA;AZiwsDJ;;A4CpxsDA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EnCqRI,yCALI;EmC9QR,gBAAA;EACA,yCAAA;EhCAE,iDAAA;AZoxsDJ;;A4C9wsDE;EACE,iDAAA;A5CixsDJ;A4C/wsDI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,iGAAA;A5CixsDN;A4C7wsDE;EACE,6CAAA;A5C+wsDJ;;A6CpzsDA;EAEE,kCAAA;EACA,mCAAA;EpCkSI,oCALI;EoC3RR,2CAAA;EACA,4CAAA;EACA,iCAAA;EACA,oDAAA;EACA,sCAAA;EACA,uDAAA;EACA,iCAAA;EACA,0DAAA;EACA,uDAAA;EACA,iCAAA;EACA,kEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,qDAAA;EACA,6DAAA;EAGA,aAAA;E/BpBA,eAAA;EACA,gBAAA;Ady0sDF;;A6ClzsDA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EpCsQI,yCALI;EoC/PR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;ElBpBI,qIkBqBJ;A7CqzsDF;A2Bt0sDM;EkBQN;IlBPQ,gBAAA;E3By0sDN;AACF;A6CxzsDE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A7CyzsDJ;A6CtzsDE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UlC8wCgC;EkC7wChC,iDAAA;A7CwzsDJ;A6CrzsDE;EAEE,UAAA;EACA,wCAAA;EjBtDF,gDiBuDuB;EACrB,sDAAA;A7CszsDJ;A6CnzsDE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A7CozsDJ;;A6C/ysDE;EACE,iBlCivCgC;AXikqDpC;A6C7ysDM;EjC9BF,0DAAA;EACA,6DAAA;AZ80sDJ;A6C3ysDM;EjClDF,2DAAA;EACA,8DAAA;AZg2sDJ;;A6C9xsDA;EClGE,iCAAA;EACA,iCAAA;ErCgSI,sCALI;EqCzRR,qCAAA;A9Co4sDF;;A6CjysDA;ECtGE,iCAAA;EACA,kCAAA;ErCgSI,uCALI;EqCzRR,qCAAA;A9C24sDF;;A+C74sDA;EAEE,4BAAA;EACA,4BAAA;EtC6RI,4BALI;EsCtRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;EtCqRI,oCALI;EsC9QR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EnCJE,4CAAA;AZk5sDJ;A+Cz4sDE;EACE,aAAA;A/C24sDJ;;A+Ct4sDA;EACE,kBAAA;EACA,SAAA;A/Cy4sDF;;AgDz6sDA;EAEE,0BAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,iCAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EpCFE,4CAAA;AZ46sDJ;;AgDr6sDA;EAEE,cAAA;AhDu6sDF;;AgDn6sDA;EACE,gBrC8pB4B;AXwwrD9B;;AgD95sDA;EACE,mBrCogD8B;AX65pDhC;AgD95sDE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AhDg6sDJ;;AgDh5sDE;EChEA,oCAAA;EACA,0CAAA;EACA,iDAAA;AjDo9sDF;AiD98sDE;EACE,2BAAA;AjDg9sDJ;;AgDz5sDE;EChEA,qCAAA;EACA,yCAAA;EACA,iDAAA;AjD69sDF;AiDv9sDE;EACE,0BAAA;AjDy9sDJ;;AgDl6sDE;EChEA,uCAAA;EACA,yCAAA;EACA,iDAAA;AjDs+sDF;AiDh+sDE;EACE,0BAAA;AjDk+sDJ;;AgD36sDE;EChEA,yCAAA;EACA,wCAAA;EACA,iDAAA;AjD++sDF;AiDz+sDE;EACE,6BAAA;AjD2+sDJ;;AgDp7sDE;EChEA,wCAAA;EACA,wCAAA;EACA,iDAAA;AjDw/sDF;AiDl/sDE;EACE,6BAAA;AjDo/sDJ;;AgD77sDE;EChEA,qCAAA;EACA,yCAAA;EACA,iDAAA;AjDigtDF;AiD3/sDE;EACE,2BAAA;AjD6/sDJ;;AgDt8sDE;EChEA,4CAAA;EACA,wCAAA;EACA,iDAAA;AjD0gtDF;AiDpgtDE;EACE,+BAAA;AjDsgtDJ;;AgD/8sDE;EChEA,0CAAA;EACA,uCAAA;EACA,iDAAA;AjDmhtDF;AiD7gtDE;EACE,4BAAA;AjD+gtDJ;;AkDthtDE;EACE;IAAK,+BvCgjD2B;EX0+pDlC;AACF;AkDthtDA;EAEE,8BAAA;EzCyRI,oCALI;EyClRR,yBAAA;EACA,oCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EzC6QI,uCALI;EyCtQR,uCAAA;EtCPE,+CAAA;AZ6htDJ;;AkDjhtDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBvBI,6CuBwBJ;AlDohtDF;A2BxitDM;EuBWN;IvBVQ,gBAAA;E3B2itDN;AACF;;AkDthtDA;EtBCE,qMAAA;EsBCA,oEAAA;AlDyhtDF;;AkDrhtDE;EACE,kDAAA;AlDwhtDJ;AkDrhtDM;EAJJ;IAKM,eAAA;ElDwhtDN;AACF;;AmD3ktDA;EAEE,2CAAA;EACA,4CAAA;EACA,oDAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,sCAAA;EACA,kDAAA;EACA,wDAAA;EACA,8DAAA;EACA,yDAAA;EACA,+DAAA;EACA,uCAAA;EACA,qDAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AZqltDJ;;AmDtktDA;EACE,qBAAA;EACA,sBAAA;AnDyktDF;AmDvktDE;EAEE,oCAAA;EACA,0BAAA;AnDwktDJ;;AmD/jtDA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AnDkktDF;AmD/jtDE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AnDgktDJ;AmD7jtDE;EACE,+CAAA;EACA,uDAAA;AnD+jtDJ;;AmDvjtDA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AnD0jtDF;AmDxjtDE;EvCvDE,+BAAA;EACA,gCAAA;AZkntDJ;AmDxjtDE;EvC7CE,mCAAA;EACA,kCAAA;AZwmtDJ;AmDxjtDE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AnDyjtDJ;AmDrjtDE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AnDujtDJ;AmDnjtDE;EACE,mBAAA;AnDqjtDJ;AmDnjtDI;EACE,wDAAA;EACA,mDAAA;AnDqjtDN;;AmDxitDI;EACE,mBAAA;AnD2itDN;AmDxitDQ;EvCvDJ,6DAAA;EAZA,0BAAA;AZ+mtDJ;AmDvitDQ;EvCxEJ,2DAAA;EAYA,4BAAA;AZumtDJ;AmDtitDQ;EACE,aAAA;AnDwitDV;AmDritDQ;EACE,mDAAA;EACA,oBAAA;AnDuitDV;AmDritDU;EACE,yDAAA;EACA,oDAAA;AnDuitDZ;;AmB7ntDI;EgC8DA;IACE,mBAAA;EnDmktDJ;EmDhktDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZuotDF;EmD/jtDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZ+ntDF;EmD9jtDM;IACE,aAAA;EnDgktDR;EmD7jtDM;IACE,mDAAA;IACA,oBAAA;EnD+jtDR;EmD7jtDQ;IACE,yDAAA;IACA,oDAAA;EnD+jtDV;AACF;AmBtptDI;EgC8DA;IACE,mBAAA;EnD2ltDJ;EmDxltDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZ+ptDF;EmDvltDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZuptDF;EmDtltDM;IACE,aAAA;EnDwltDR;EmDrltDM;IACE,mDAAA;IACA,oBAAA;EnDultDR;EmDrltDQ;IACE,yDAAA;IACA,oDAAA;EnDultDV;AACF;AmB9qtDI;EgC8DA;IACE,mBAAA;EnDmntDJ;EmDhntDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZurtDF;EmD/mtDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZ+qtDF;EmD9mtDM;IACE,aAAA;EnDgntDR;EmD7mtDM;IACE,mDAAA;IACA,oBAAA;EnD+mtDR;EmD7mtDQ;IACE,yDAAA;IACA,oDAAA;EnD+mtDV;AACF;AmBtstDI;EgC8DA;IACE,mBAAA;EnD2otDJ;EmDxotDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZ+stDF;EmDvotDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZustDF;EmDtotDM;IACE,aAAA;EnDwotDR;EmDrotDM;IACE,mDAAA;IACA,oBAAA;EnDuotDR;EmDrotDQ;IACE,yDAAA;IACA,oDAAA;EnDuotDV;AACF;AmB9ttDI;EgC8DA;IACE,mBAAA;EnDmqtDJ;EmDhqtDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZuutDF;EmD/ptDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZ+ttDF;EmD9ptDM;IACE,aAAA;EnDgqtDR;EmD7ptDM;IACE,mDAAA;IACA,oBAAA;EnD+ptDR;EmD7ptDQ;IACE,yDAAA;IACA,oDAAA;EnD+ptDV;AACF;AmDlptDA;EvChJI,gBAAA;AZqytDJ;AmDlptDE;EACE,mDAAA;AnDoptDJ;AmDlptDI;EACE,sBAAA;AnDoptDN;;AoD1ztDE;EACE,2BDmLyB;EClLzB,wCDiLsB;AnD4otD1B;AoD1ztDM;EAEE,2BD6KqB;EC5KrB,4CAAA;ApD2ztDR;AoDxztDM;EACE,WzC0IG;EyCzIH,sCDuKqB;ECtKrB,kCDsKqB;AnDoptD7B;;AoDx0tDE;EACE,0BDmLyB;EClLzB,wCDiLsB;AnD0ptD1B;AoDx0tDM;EAEE,0BD6KqB;EC5KrB,4CAAA;ApDy0tDR;AoDt0tDM;EACE,WzC0IG;EyCzIH,qCDuKqB;ECtKrB,iCDsKqB;AnDkqtD7B;;AoDt1tDE;EACE,0BDmLyB;EClLzB,wCDiLsB;AnDwqtD1B;AoDt1tDM;EAEE,0BD6KqB;EC5KrB,4CAAA;ApDu1tDR;AoDp1tDM;EACE,WzC0IG;EyCzIH,qCDuKqB;ECtKrB,iCDsKqB;AnDgrtD7B;;AoDp2tDE;EACE,6BDmLyB;EClLzB,0CDiLsB;AnDsrtD1B;AoDp2tDM;EAEE,6BD6KqB;EC5KrB,6CAAA;ApDq2tDR;AoDl2tDM;EACE,WzC0IG;EyCzIH,wCDuKqB;ECtKrB,oCDsKqB;AnD8rtD7B;;AoDl3tDE;EACE,6BDmLyB;EClLzB,0CDiLsB;AnDostD1B;AoDl3tDM;EAEE,6BD6KqB;EC5KrB,6CAAA;ApDm3tDR;AoDh3tDM;EACE,WzC0IG;EyCzIH,wCDuKqB;ECtKrB,oCDsKqB;AnD4stD7B;;AoDh4tDE;EACE,2BDmLyB;EClLzB,wCDiLsB;AnDkttD1B;AoDh4tDM;EAEE,2BD6KqB;EC5KrB,4CAAA;ApDi4tDR;AoD93tDM;EACE,WzC0IG;EyCzIH,sCDuKqB;ECtKrB,kCDsKqB;AnD0ttD7B;;AoD94tDE;EACE,+BDmLyB;EClLzB,0CDiLsB;AnDgutD1B;AoD94tDM;EAEE,+BD6KqB;EC5KrB,6CAAA;ApD+4tDR;AoD54tDM;EACE,WzC0IG;EyCzIH,0CDuKqB;ECtKrB,sCDsKqB;AnDwutD7B;;AoD55tDE;EACE,4BDmLyB;EClLzB,0CDiLsB;AnD8utD1B;AoD55tDM;EAEE,4BD6KqB;EC5KrB,6CAAA;ApD65tDR;AoD15tDM;EACE,WzC0IG;EyCzIH,uCDuKqB;ECtKrB,mCDsKqB;AnDsvtD7B;;AqDz6tDA;EACE,uBAAA;EACA,U1CmrD2B;E0ClrD3B,W1CkrD2B;E0CjrD3B,sBAAA;EACA,W1C0JS;E0CzJT,0FAAA;EACA,SAAA;EzCOE,sBAAA;EyCLF,Y1CmrD2B;AXyvqD7B;AqDz6tDE;EACE,W1CkJO;E0CjJP,qBAAA;EACA,a1C8qDyB;AX6vqD7B;AqDx6tDE;EACE,UAAA;EACA,4C1C80B4B;E0C70B5B,U1CyqDyB;AXiwqD7B;AqDv6tDE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,a1CmqDyB;AXqwqD7B;;AqDp6tDA;EACE,kD1C+pD2B;AXwwqD7B;;AsD78tDA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E7C+RI,8BALI;E6CxRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2CAAA;EACA,iCAAA;EACA,uDAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;E7CiRI,oCALI;E6C1QR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E1CRE,4CAAA;AZs9tDJ;AsD38tDE;EACE,UAAA;AtD68tDJ;AsD18tDE;EACE,aAAA;AtD48tDJ;;AsDx8tDA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AtD08tDF;AsDx8tDE;EACE,sCAAA;AtD08tDJ;;AsDt8tDA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E1ChCE,0FAAA;EACA,2FAAA;AZ0+tDJ;AsDx8tDE;EACE,oDAAA;EACA,sCAAA;AtD08tDJ;;AsDt8tDA;EACE,kCAAA;EACA,qBAAA;AtDy8tDF;;AuDvguDA;EAEE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,4BAAA;EACA,gCAAA;EACA,8DAAA;EACA,kDAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,sDAAA;EACA,iCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,iCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AvDqguDF;;AuD9/tDA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AvDgguDF;AuD7/tDE;E5B5CI,mC4B6CF;AvD+/tDJ;A2BxiuDM;E4BwCJ;I5BvCM,gBAAA;E3B2iuDN;AACF;AuDrguDE;EAEE,8B5C29CgC;AX2irDpC;AuDpguDE;EACE,e5Cy9CgC;AX6irDpC;AuDlguDE;EACE,sB5Cs9CgC;AX8irDpC;;AuDhguDA;EACE,+CAAA;AvDmguDF;AuDjguDE;EACE,gBAAA;EACA,gBAAA;AvDmguDJ;AuDhguDE;EACE,gBAAA;AvDkguDJ;;AuD9/tDA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AvDiguDF;;AuD7/tDA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E3CrFE,4CAAA;E2CyFF,UAAA;AvD6/tDF;;AuDz/tDA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AvD+/tD9D;AwD3muDE;EAAS,UAAA;AxD8muDX;AwD7muDE;EAAS,mCD2GiF;AvDqguD5F;;AuDhguDA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E3CtGE,2DAAA;EACA,4DAAA;AZ0muDJ;AuDlguDE;EACE,kGAAA;EACA,sJAAA;AvDoguDJ;;AuD//tDA;EACE,gBAAA;EACA,8CAAA;AvDkguDF;;AuD7/tDA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AvD8/tDF;;AuD1/tDA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E3C1HE,+DAAA;EACA,8DAAA;AZwnuDJ;AuDz/tDE;EACE,8CAAA;AvD2/tDJ;;AmBvmuDI;EoCkHF;IACE,0BAAA;IACA,uDAAA;EvDy/tDF;EuDr/tDA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EvDu/tDF;EuDp/tDA;IACE,uBAAA;EvDs/tDF;AACF;AmBtnuDI;EoCoIF;;IAEE,uBAAA;EvDq/tDF;AACF;AmB5nuDI;EoC2IF;IACE,wBAAA;EvDo/tDF;AACF;AuD3+tDI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AvD6+tDN;AuD3+tDM;EACE,YAAA;EACA,SAAA;E3C1MJ,gBAAA;AZwruDJ;AuD1+tDM;;E3C9MF,gBAAA;AZ4ruDJ;AuDz+tDM;EACE,gBAAA;AvD2+tDR;;AmBtouDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDiguDJ;EuD//tDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZ4suDF;EuD9/tDI;;I3C9MF,gBAAA;EZgtuDF;EuD7/tDI;IACE,gBAAA;EvD+/tDN;AACF;AmB3puDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDqhuDJ;EuDnhuDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZguuDF;EuDlhuDI;;I3C9MF,gBAAA;EZouuDF;EuDjhuDI;IACE,gBAAA;EvDmhuDN;AACF;AmB/quDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDyiuDJ;EuDviuDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZovuDF;EuDtiuDI;;I3C9MF,gBAAA;EZwvuDF;EuDriuDI;IACE,gBAAA;EvDuiuDN;AACF;AmBnsuDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD6juDJ;EuD3juDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZwwuDF;EuD1juDI;;I3C9MF,gBAAA;EZ4wuDF;EuDzjuDI;IACE,gBAAA;EvD2juDN;AACF;AmBvtuDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDiluDJ;EuD/kuDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZ4xuDF;EuD9kuDI;;I3C9MF,gBAAA;EZgyuDF;EuD7kuDI;IACE,gBAAA;EvD+kuDN;AACF;AyDtzuDA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EhD8RI,oCALI;EgDvRR,wBAAA;EACA,qBAAA;EACA,kCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,uCAAA;EACA,gCAAA;ECnBA,sC/CirB4B;E+C/qB5B,kBAAA;EACA,gB/C0rB4B;E+CzrB5B,gB/CgsB4B;E+C/rB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDsRI,sCALI;EgDrQR,qBAAA;EACA,UAAA;AzD8zuDF;AyD5zuDE;EAAS,kCAAA;AzD+zuDX;AyD7zuDE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AzD+zuDJ;AyD7zuDI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AzD+zuDN;;AyD1zuDA;EACE,SAAA;AzD6zuDF;AyD3zuDE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AzD6zuDJ;;AyDzzuDA,qBAAA;AACA;EACE,OAAA;EACA,qCAAA;EACA,qCAAA;AzD4zuDF;AyD1zuDE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AzD4zuDJ;;AyDxzuDA,mBAAA;AAEA;EACE,MAAA;AzD0zuDF;AyDxzuDE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AzD0zuDJ;;AyDtzuDA,qBAAA;AACA;EACE,QAAA;EACA,qCAAA;EACA,qCAAA;AzDyzuDF;AyDvzuDE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AzDyzuDJ;;AyDrzuDA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E7ClGE,8CAAA;AZ04uDJ;;A2D75uDA;EAEE,yBAAA;EACA,6BAAA;ElDkSI,iCALI;EkD3RR,qBAAA;EACA,8BAAA;EACA,iDAAA;EACA,mCAAA;EACA,qDAAA;EACA,0DAAA;EACA,mCAAA;EACA,qCAAA;ElDyRI,wCALI;EkDlRR,2BAAA;EACA,4CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC/CirB4B;E+C/qB5B,kBAAA;EACA,gB/C0rB4B;E+CzrB5B,gB/CgsB4B;E+C/rB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDsRI,sCALI;EkDhQR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E/ChBE,8CAAA;AZw7uDJ;A2Dp6uDE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;A3Ds6uDJ;A2Dp6uDI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;A3Dq6uDN;;A2D/5uDE;EACE,oFAAA;A3Dk6uDJ;A2Dh6uDI;EAEE,wFAAA;A3Di6uDN;A2D95uDI;EACE,SAAA;EACA,gDAAA;A3Dg6uDN;A2D75uDI;EACE,sCAAA;EACA,sCAAA;A3D+5uDN;;A2D15uDA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;A3D45uDJ;A2D15uDI;EAEE,kIAAA;A3D25uDN;A2Dx5uDI;EACE,OAAA;EACA,kDAAA;A3D05uDN;A2Dv5uDI;EACE,oCAAA;EACA,wCAAA;A3Dy5uDN;;A2Dp5uDA,mBAAA;AAGE;EACE,iFAAA;A3Dq5uDJ;A2Dn5uDI;EAEE,wFAAA;A3Do5uDN;A2Dj5uDI;EACE,MAAA;EACA,mDAAA;A3Dm5uDN;A2Dh5uDI;EACE,mCAAA;EACA,yCAAA;A3Dk5uDN;A2D74uDE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;A3D+4uDJ;;A2D34uDA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;A3D64uDJ;A2D34uDI;EAEE,kIAAA;A3D44uDN;A2Dz4uDI;EACE,QAAA;EACA,iDAAA;A3D24uDN;A2Dx4uDI;EACE,qCAAA;EACA,uCAAA;A3D04uDN;;A2Dr4uDA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElDiHI,6CALI;EkD1GR,qCAAA;EACA,6CAAA;EACA,kFAAA;E/C5JE,6DAAA;EACA,8DAAA;AZohvDJ;A2Dt3uDE;EACE,aAAA;A3Dw3uDJ;;A2Dp3uDA;EACE,0EAAA;EACA,mCAAA;A3Du3uDF;;A4D5ivDA;EACE,kBAAA;A5D+ivDF;;A4D5ivDA;EACE,mBAAA;A5D+ivDF;;A4D5ivDA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A5D+ivDF;A6DrkvDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7DukvDJ;;A4DhjvDA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;A5DmjvDF;A2BlkvDM;EiCQN;IjCPQ,gBAAA;E3BqkvDN;AACF;;A4DrjvDA;;;EAGE,cAAA;A5DwjvDF;;A4DrjvDA;;EAEE,2BAAA;A5DwjvDF;;A4DrjvDA;;EAEE,4BAAA;A5DwjvDF;;A4D/ivDE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A5DkjvDJ;A4D/ivDE;;;EAGE,UAAA;EACA,UAAA;A5DijvDJ;A4D9ivDE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;A5DgjvDJ;A2BzmvDM;EiCqDJ;;IjCpDM,gBAAA;E3B6mvDN;AACF;;A4D7ivDA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDuiDmC;EiDtiDnC,UAAA;EACA,WjDwDS;EiDvDT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDkiDmC;EgBxnD/B,8BiCuFJ;A5D+ivDF;A2BlovDM;EiCkEN;;IjCjEQ,gBAAA;E3BsovDN;AACF;A4DljvDE;;;EAEE,WjD8CO;EiD7CP,qBAAA;EACA,UAAA;EACA,YjD0hDiC;AX2hsDrC;;A4DljvDA;EACE,OAAA;A5DqjvDF;;A4DljvDA;EACE,QAAA;A5DqjvDF;;A4DhjvDA;;EAEE,qBAAA;EACA,WjD2hDmC;EiD1hDnC,YjD0hDmC;EiDzhDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;A5DmjvDF;;A4DhjvDA;;;;;;;GAAA;AAQA;EACE,0DAAA;A5DmjvDF;;A4DjjvDA;EACE,0DAAA;A5DojvDF;;A4D5ivDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBjDm+CmC;EiDl+CnC,mBAAA;EACA,gBjDi+CmC;EiDh+CnC,gBAAA;A5D8ivDF;A4D5ivDE;EACE,uBAAA;EACA,cAAA;EACA,WjDg+CiC;EiD/9CjC,WjDg+CiC;EiD/9CjC,UAAA;EACA,iBjDg+CiC;EiD/9CjC,gBjD+9CiC;EiD99CjC,mBAAA;EACA,eAAA;EACA,sBjDzBO;EiD0BP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YjDu9CiC;EgBhoD/B,6BiC0KF;A5D6ivDJ;A2BntvDM;EiCqJJ;IjCpJM,gBAAA;E3BstvDN;AACF;A4D/ivDE;EACE,UjDo9CiC;AX6lsDrC;;A4DxivDA;EACE,kBAAA;EACA,UAAA;EACA,ejD88CmC;EiD78CnC,SAAA;EACA,oBjD28CmC;EiD18CnC,uBjD08CmC;EiDz8CnC,WjDpDS;EiDqDT,kBAAA;A5D2ivDF;;A4DrivDE;;EAEE,gCjD68CiC;AX2lsDrC;A4DrivDE;EACE,sBjDvDO;AX8lvDX;A4DpivDE;EACE,WjD3DO;AXimvDX;;A8DjwvDA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A9DmwvDF;;A8D/vvDA;EACE;IAAK,0CAAA;E9DmwvDL;AACF;A8DhwvDA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A9D+vvDF;;A8D5vvDA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A9D8vvDF;;A8DrvvDA;EACE;IACE,mBAAA;E9DwvvDF;E8DtvvDA;IACE,UAAA;IACA,eAAA;E9DwvvDF;AACF;A8DpvvDA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A9DmvvDF;;A8DhvvDA;EACE,wBAAA;EACA,yBAAA;A9DmvvDF;;A8D/uvDE;EACE;;IAEE,kCAAA;E9DkvvDJ;AACF;A+Dl0vDA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,mDAAA;EACA,kEAAA;A/Dm0vDF;;AmBpwvDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/DozvDJ;AACF;A2B70vDM;EoCUJ;IpCTM,gBAAA;E3Bg1vDN;AACF;AmB1xvDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D2zvDN;E+DxzvDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D0zvDN;E+DvzvDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DyzvDN;E+DtzvDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DwzvDN;E+DrzvDI;IAEE,eAAA;E/DszvDN;E+DnzvDI;IAGE,mBAAA;E/DmzvDN;AACF;AmB90vDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/DkzvDN;E+DhzvDM;IACE,aAAA;E/DkzvDR;E+D/yvDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/DgzvDR;AACF;;AmBl1vDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/Dk4vDJ;AACF;A2B35vDM;EoCUJ;IpCTM,gBAAA;E3B85vDN;AACF;AmBx2vDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Dy4vDN;E+Dt4vDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Dw4vDN;E+Dr4vDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Du4vDN;E+Dp4vDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Ds4vDN;E+Dn4vDI;IAEE,eAAA;E/Do4vDN;E+Dj4vDI;IAGE,mBAAA;E/Di4vDN;AACF;AmB55vDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Dg4vDN;E+D93vDM;IACE,aAAA;E/Dg4vDR;E+D73vDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D83vDR;AACF;;AmBh6vDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/Dg9vDJ;AACF;A2Bz+vDM;EoCUJ;IpCTM,gBAAA;E3B4+vDN;AACF;AmBt7vDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Du9vDN;E+Dp9vDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Ds9vDN;E+Dn9vDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Dq9vDN;E+Dl9vDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Do9vDN;E+Dj9vDI;IAEE,eAAA;E/Dk9vDN;E+D/8vDI;IAGE,mBAAA;E/D+8vDN;AACF;AmB1+vDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D88vDN;E+D58vDM;IACE,aAAA;E/D88vDR;E+D38vDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D48vDR;AACF;;AmB9+vDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/D8hwDJ;AACF;A2BvjwDM;EoCUJ;IpCTM,gBAAA;E3B0jwDN;AACF;AmBpgwDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/DqiwDN;E+DliwDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/DoiwDN;E+DjiwDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DmiwDN;E+DhiwDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DkiwDN;E+D/hwDI;IAEE,eAAA;E/DgiwDN;E+D7hwDI;IAGE,mBAAA;E/D6hwDN;AACF;AmBxjwDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D4hwDN;E+D1hwDM;IACE,aAAA;E/D4hwDR;E+DzhwDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D0hwDR;AACF;;AmB5jwDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/D4mwDJ;AACF;A2BrowDM;EoCUJ;IpCTM,gBAAA;E3BwowDN;AACF;AmBllwDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/DmnwDN;E+DhnwDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/DknwDN;E+D/mwDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DinwDN;E+D9mwDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DgnwDN;E+D7mwDI;IAEE,eAAA;E/D8mwDN;E+D3mwDI;IAGE,mBAAA;E/D2mwDN;AACF;AmBtowDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D0mwDN;E+DxmwDM;IACE,aAAA;E/D0mwDR;E+DvmwDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/DwmwDR;AACF;;A+DxrwDE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EpC1BA,sCoC4BA;A/DyrwDN;A2BjtwDM;EoCUJ;IpCTM,gBAAA;E3BotwDN;AACF;A+D5rwDM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A/D8rwDR;A+D3rwDM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A/D6rwDR;A+D1rwDM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A/D4rwDR;A+DzrwDM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A/D2rwDR;A+DxrwDM;EAEE,eAAA;A/DyrwDR;A+DtrwDM;EAGE,mBAAA;A/DsrwDR;;A+D3pwDA;EPlHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C+pCkC;E6C9pClC,YAAA;EACA,aAAA;EACA,sB7C4JS;AXqnwDX;AwD9wwDE;EAAS,UAAA;AxDixwDX;AwDhxwDE;EAAS,Y7C8/CyB;AXqxtDpC;;A+DvqwDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A/D0qwDF;A+DxqwDE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A/D0qwDJ;;A+DtqwDA;EACE,gBAAA;EACA,gBpD6jB4B;AX4mvD9B;;A+DtqwDA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A/DyqwDF;;AgEvzwDA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrDm1CkC;AXu+tDpC;AgExzwDE;EACE,qBAAA;EACA,WAAA;AhE0zwDJ;;AgErzwDA;EACE,iBAAA;AhEwzwDF;;AgErzwDA;EACE,iBAAA;AhEwzwDF;;AgErzwDA;EACE,iBAAA;AhEwzwDF;;AgEnzwDE;EACE,mDAAA;AhEszwDJ;;AgElzwDA;EACE;IACE,YrDszCgC;EX+/tDlC;AACF;AgElzwDA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AhEozwDF;;AgEjzwDA;EACE;IACE,uBAAA;EhEozwDF;AACF;A6Dn2wDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7Dq2wDJ;;AiEr2wDE;EACE,sBAAA;EACA,wEAAA;AjEw2wDJ;;AiE12wDE;EACE,sBAAA;EACA,uEAAA;AjE62wDJ;;AiE/2wDE;EACE,sBAAA;EACA,wEAAA;AjEk3wDJ;;AiEp3wDE;EACE,sBAAA;EACA,wEAAA;AjEu3wDJ;;AiEz3wDE;EACE,sBAAA;EACA,uEAAA;AjE43wDJ;;AiE93wDE;EACE,sBAAA;EACA,wEAAA;AjEi4wDJ;;AiEn4wDE;EACE,sBAAA;EACA,yEAAA;AjEs4wDJ;;AiEx4wDE;EACE,sBAAA;EACA,sEAAA;AjE24wDJ;;AkEj5wDE;EACE,yBAAA;AlEo5wDJ;AkEj5wDM;EAEE,sCAAA;AlEk5wDR;;AkEx5wDE;EACE,yBAAA;AlE25wDJ;AkEx5wDM;EAEE,sCAAA;AlEy5wDR;;AkE/5wDE;EACE,yBAAA;AlEk6wDJ;AkE/5wDM;EAEE,sCAAA;AlEg6wDR;;AkEt6wDE;EACE,yBAAA;AlEy6wDJ;AkEt6wDM;EAEE,yCAAA;AlEu6wDR;;AkE76wDE;EACE,yBAAA;AlEg7wDJ;AkE76wDM;EAEE,wCAAA;AlE86wDR;;AkEp7wDE;EACE,yBAAA;AlEu7wDJ;AkEp7wDM;EAEE,sCAAA;AlEq7wDR;;AkE37wDE;EACE,yBAAA;AlE87wDJ;AkE37wDM;EAEE,0CAAA;AlE47wDR;;AkEl8wDE;EACE,yBAAA;AlEq8wDJ;AkEl8wDM;EAEE,uCAAA;AlEm8wDR;;AmEx8wDA;EACE,kBAAA;EACA,WAAA;AnE28wDF;AmEz8wDE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AnE28wDJ;AmEx8wDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AnE08wDJ;;AmEr8wDE;EACE,uBAAA;AnEw8wDJ;;AmEz8wDE;EACE,sBAAA;AnE48wDJ;;AmE78wDE;EACE,yBAAA;AnEg9wDJ;;AmEj9wDE;EACE,iCAAA;AnEo9wDJ;;AoEz+wDA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,azD4pCkC;AXg1uDpC;;AoEz+wDA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,azDopCkC;AXw1uDpC;;AoEp+wDI;EACE,gBAAA;EACA,MAAA;EACA,azDwoC8B;AX+1uDpC;;AoEp+wDI;EACE,gBAAA;EACA,SAAA;EACA,azDkoC8B;AXq2uDpC;;AmBx8wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDwoC8B;EX42uDlC;EoEj/wDE;IACE,gBAAA;IACA,SAAA;IACA,azDkoC8B;EXi3uDlC;AACF;AmBr9wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDwoC8B;EXw3uDlC;EoE7/wDE;IACE,gBAAA;IACA,SAAA;IACA,azDkoC8B;EX63uDlC;AACF;AmBj+wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDwoC8B;EXo4uDlC;EoEzgxDE;IACE,gBAAA;IACA,SAAA;IACA,azDkoC8B;EXy4uDlC;AACF;AmB7+wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDwoC8B;EXg5uDlC;EoErhxDE;IACE,gBAAA;IACA,SAAA;IACA,azDkoC8B;EXq5uDlC;AACF;AmBz/wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDwoC8B;EX45uDlC;EoEjixDE;IACE,gBAAA;IACA,SAAA;IACA,azDkoC8B;EXi6uDlC;AACF;AqEnkxDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ArEqkxDF;;AqElkxDA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;ArEqkxDF;;AsE7kxDA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AvE8kxDF;;AwEzlxDE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U7DoiBsC;E6DniBtC,WAAA;AxE4lxDJ;;AyEpmxDA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1EwmxDF;;A2E9mxDA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,ahEwwB4B;AXy2vD9B;;A4ErjxDQ;EAOI,mCAAA;A5EkjxDZ;;A4EzjxDQ;EAOI,8BAAA;A5EsjxDZ;;A4E7jxDQ;EAOI,iCAAA;A5E0jxDZ;;A4EjkxDQ;EAOI,iCAAA;A5E8jxDZ;;A4ErkxDQ;EAOI,sCAAA;A5EkkxDZ;;A4EzkxDQ;EAOI,mCAAA;A5EskxDZ;;A4E7kxDQ;EAOI,sBAAA;A5E0kxDZ;;A4EjlxDQ;EAOI,uBAAA;A5E8kxDZ;;A4ErlxDQ;EAOI,sBAAA;A5EklxDZ;;A4EzlxDQ;EAOI,qBAAA;A5EslxDZ;;A4E7lxDQ;EAOI,wBAAA;A5E0lxDZ;;A4EjmxDQ;EAOI,uBAAA;A5E8lxDZ;;A4ErmxDQ;EAOI,wBAAA;A5EkmxDZ;;A4EzmxDQ;EAOI,qBAAA;A5EsmxDZ;;A4E7mxDQ;EAOI,yBAAA;A5E0mxDZ;;A4EjnxDQ;EAOI,2BAAA;A5E8mxDZ;;A4ErnxDQ;EAOI,4BAAA;A5EknxDZ;;A4EznxDQ;EAOI,2BAAA;A5EsnxDZ;;A4E7nxDQ;EAOI,0BAAA;A5E0nxDZ;;A4EjoxDQ;EAOI,gCAAA;A5E8nxDZ;;A4EroxDQ;EAOI,yBAAA;A5EkoxDZ;;A4EzoxDQ;EAOI,wBAAA;A5EsoxDZ;;A4E7oxDQ;EAOI,yBAAA;A5E0oxDZ;;A4EjpxDQ;EAOI,6BAAA;A5E8oxDZ;;A4ErpxDQ;EAOI,8BAAA;A5EkpxDZ;;A4EzpxDQ;EAOI,wBAAA;A5EspxDZ;;A4E7pxDQ;EAOI,+BAAA;A5E0pxDZ;;A4EjqxDQ;EAOI,wBAAA;A5E8pxDZ;;A4ErqxDQ;EAOI,uDAAA;A5EkqxDZ;;A4EzqxDQ;EAOI,8DAAA;A5EsqxDZ;;A4E7qxDQ;EAOI,wDAAA;A5E0qxDZ;;A4EjrxDQ;EAOI,2BAAA;A5E8qxDZ;;A4ErrxDQ;EAOI,2BAAA;A5EkrxDZ;;A4EzrxDQ;EAOI,6BAAA;A5EsrxDZ;;A4E7rxDQ;EAOI,6BAAA;A5E0rxDZ;;A4EjsxDQ;EAOI,0BAAA;A5E8rxDZ;;A4ErsxDQ;EAOI,2BAAA;A5EksxDZ;;A4EzsxDQ;EAOI,iBAAA;A5EssxDZ;;A4E7sxDQ;EAOI,mBAAA;A5E0sxDZ;;A4EjtxDQ;EAOI,oBAAA;A5E8sxDZ;;A4ErtxDQ;EAOI,oBAAA;A5EktxDZ;;A4EztxDQ;EAOI,sBAAA;A5EstxDZ;;A4E7txDQ;EAOI,uBAAA;A5E0txDZ;;A4EjuxDQ;EAOI,kBAAA;A5E8txDZ;;A4EruxDQ;EAOI,oBAAA;A5EkuxDZ;;A4EzuxDQ;EAOI,qBAAA;A5EsuxDZ;;A4E7uxDQ;EAOI,mBAAA;A5E0uxDZ;;A4EjvxDQ;EAOI,qBAAA;A5E8uxDZ;;A4ErvxDQ;EAOI,sBAAA;A5EkvxDZ;;A4EzvxDQ;EAOI,2CAAA;A5EsvxDZ;;A4E7vxDQ;EAOI,sCAAA;A5E0vxDZ;;A4EjwxDQ;EAOI,sCAAA;A5E8vxDZ;;A4ErwxDQ;EAOI,uFAAA;A5EkwxDZ;;A4EzwxDQ;EAOI,oBAAA;A5EswxDZ;;A4E7wxDQ;EAOI,2FAAA;A5E0wxDZ;;A4EjxxDQ;EAOI,wBAAA;A5E8wxDZ;;A4ErxxDQ;EAOI,6FAAA;A5EkxxDZ;;A4EzxxDQ;EAOI,0BAAA;A5EsxxDZ;;A4E7xxDQ;EAOI,8FAAA;A5E0xxDZ;;A4EjyxDQ;EAOI,2BAAA;A5E8xxDZ;;A4EryxDQ;EAOI,4FAAA;A5EkyxDZ;;A4EzyxDQ;EAOI,yBAAA;A5EsyxDZ;;A4E7yxDQ;EAIQ,sBAAA;EAGJ,8EAAA;A5E2yxDZ;;A4ElzxDQ;EAIQ,sBAAA;EAGJ,gFAAA;A5EgzxDZ;;A4EvzxDQ;EAIQ,sBAAA;EAGJ,8EAAA;A5EqzxDZ;;A4E5zxDQ;EAIQ,sBAAA;EAGJ,2EAAA;A5E0zxDZ;;A4Ej0xDQ;EAIQ,sBAAA;EAGJ,8EAAA;A5E+zxDZ;;A4Et0xDQ;EAIQ,sBAAA;EAGJ,6EAAA;A5Eo0xDZ;;A4E30xDQ;EAIQ,sBAAA;EAGJ,4EAAA;A5Ey0xDZ;;A4Eh1xDQ;EAIQ,sBAAA;EAGJ,2EAAA;A5E80xDZ;;A4Er1xDQ;EAIQ,sBAAA;EAGJ,4EAAA;A5Em1xDZ;;A4Ep2xDQ;EACE,sBAAA;A5Eu2xDV;;A4Ex2xDQ;EACE,sBAAA;A5E22xDV;;A4E52xDQ;EACE,sBAAA;A5E+2xDV;;A4Eh3xDQ;EACE,sBAAA;A5Em3xDV;;A4Ep3xDQ;EACE,sBAAA;A5Eu3xDV;;A4Ex3xDQ;EACE,wBAAA;A5E23xDV;;A4E53xDQ;EACE,yBAAA;A5E+3xDV;;A4Eh4xDQ;EACE,wBAAA;A5Em4xDV;;A4Ep4xDQ;EACE,yBAAA;A5Eu4xDV;;A4Ex4xDQ;EACE,sBAAA;A5E24xDV;;A4El4xDQ;EAOI,qBAAA;A5E+3xDZ;;A4Et4xDQ;EAOI,qBAAA;A5Em4xDZ;;A4E14xDQ;EAOI,qBAAA;A5Eu4xDZ;;A4E94xDQ;EAOI,sBAAA;A5E24xDZ;;A4El5xDQ;EAOI,sBAAA;A5E+4xDZ;;A4Et5xDQ;EAOI,0BAAA;A5Em5xDZ;;A4E15xDQ;EAOI,uBAAA;A5Eu5xDZ;;A4E95xDQ;EAOI,2BAAA;A5E25xDZ;;A4El6xDQ;EAOI,sBAAA;A5E+5xDZ;;A4Et6xDQ;EAOI,sBAAA;A5Em6xDZ;;A4E16xDQ;EAOI,sBAAA;A5Eu6xDZ;;A4E96xDQ;EAOI,uBAAA;A5E26xDZ;;A4El7xDQ;EAOI,uBAAA;A5E+6xDZ;;A4Et7xDQ;EAOI,2BAAA;A5Em7xDZ;;A4E17xDQ;EAOI,wBAAA;A5Eu7xDZ;;A4E97xDQ;EAOI,4BAAA;A5E27xDZ;;A4El8xDQ;EAOI,yBAAA;A5E+7xDZ;;A4Et8xDQ;EAOI,8BAAA;A5Em8xDZ;;A4E18xDQ;EAOI,iCAAA;A5Eu8xDZ;;A4E98xDQ;EAOI,sCAAA;A5E28xDZ;;A4El9xDQ;EAOI,yCAAA;A5E+8xDZ;;A4Et9xDQ;EAOI,uBAAA;A5Em9xDZ;;A4E19xDQ;EAOI,uBAAA;A5Eu9xDZ;;A4E99xDQ;EAOI,yBAAA;A5E29xDZ;;A4El+xDQ;EAOI,yBAAA;A5E+9xDZ;;A4Et+xDQ;EAOI,0BAAA;A5Em+xDZ;;A4E1+xDQ;EAOI,4BAAA;A5Eu+xDZ;;A4E9+xDQ;EAOI,kCAAA;A5E2+xDZ;;A4El/xDQ;EAOI,sCAAA;A5E++xDZ;;A4Et/xDQ;EAOI,oCAAA;A5Em/xDZ;;A4E1/xDQ;EAOI,kCAAA;A5Eu/xDZ;;A4E9/xDQ;EAOI,yCAAA;A5E2/xDZ;;A4ElgyDQ;EAOI,wCAAA;A5E+/xDZ;;A4EtgyDQ;EAOI,wCAAA;A5EmgyDZ;;A4E1gyDQ;EAOI,kCAAA;A5EugyDZ;;A4E9gyDQ;EAOI,gCAAA;A5E2gyDZ;;A4ElhyDQ;EAOI,8BAAA;A5E+gyDZ;;A4EthyDQ;EAOI,gCAAA;A5EmhyDZ;;A4E1hyDQ;EAOI,+BAAA;A5EuhyDZ;;A4E9hyDQ;EAOI,oCAAA;A5E2hyDZ;;A4EliyDQ;EAOI,kCAAA;A5E+hyDZ;;A4EtiyDQ;EAOI,gCAAA;A5EmiyDZ;;A4E1iyDQ;EAOI,uCAAA;A5EuiyDZ;;A4E9iyDQ;EAOI,sCAAA;A5E2iyDZ;;A4EljyDQ;EAOI,iCAAA;A5E+iyDZ;;A4EtjyDQ;EAOI,2BAAA;A5EmjyDZ;;A4E1jyDQ;EAOI,iCAAA;A5EujyDZ;;A4E9jyDQ;EAOI,+BAAA;A5E2jyDZ;;A4ElkyDQ;EAOI,6BAAA;A5E+jyDZ;;A4EtkyDQ;EAOI,+BAAA;A5EmkyDZ;;A4E1kyDQ;EAOI,8BAAA;A5EukyDZ;;A4E9kyDQ;EAOI,oBAAA;A5E2kyDZ;;A4EllyDQ;EAOI,mBAAA;A5E+kyDZ;;A4EtlyDQ;EAOI,mBAAA;A5EmlyDZ;;A4E1lyDQ;EAOI,mBAAA;A5EulyDZ;;A4E9lyDQ;EAOI,mBAAA;A5E2lyDZ;;A4ElmyDQ;EAOI,mBAAA;A5E+lyDZ;;A4EtmyDQ;EAOI,mBAAA;A5EmmyDZ;;A4E1myDQ;EAOI,mBAAA;A5EumyDZ;;A4E9myDQ;EAOI,oBAAA;A5E2myDZ;;A4ElnyDQ;EAOI,0BAAA;A5E+myDZ;;A4EtnyDQ;EAOI,yBAAA;A5EmnyDZ;;A4E1nyDQ;EAOI,uBAAA;A5EunyDZ;;A4E9nyDQ;EAOI,yBAAA;A5E2nyDZ;;A4EloyDQ;EAOI,uBAAA;A5E+nyDZ;;A4EtoyDQ;EAOI,uBAAA;A5EmoyDZ;;A4E1oyDQ;EAOI,0BAAA;EAAA,yBAAA;A5EwoyDZ;;A4E/oyDQ;EAOI,gCAAA;EAAA,+BAAA;A5E6oyDZ;;A4EppyDQ;EAOI,+BAAA;EAAA,8BAAA;A5EkpyDZ;;A4EzpyDQ;EAOI,6BAAA;EAAA,4BAAA;A5EupyDZ;;A4E9pyDQ;EAOI,+BAAA;EAAA,8BAAA;A5E4pyDZ;;A4EnqyDQ;EAOI,6BAAA;EAAA,4BAAA;A5EiqyDZ;;A4ExqyDQ;EAOI,6BAAA;EAAA,4BAAA;A5EsqyDZ;;A4E7qyDQ;EAOI,wBAAA;EAAA,2BAAA;A5E2qyDZ;;A4ElryDQ;EAOI,8BAAA;EAAA,iCAAA;A5EgryDZ;;A4EvryDQ;EAOI,6BAAA;EAAA,gCAAA;A5EqryDZ;;A4E5ryDQ;EAOI,2BAAA;EAAA,8BAAA;A5E0ryDZ;;A4EjsyDQ;EAOI,6BAAA;EAAA,gCAAA;A5E+ryDZ;;A4EtsyDQ;EAOI,2BAAA;EAAA,8BAAA;A5EosyDZ;;A4E3syDQ;EAOI,2BAAA;EAAA,8BAAA;A5EysyDZ;;A4EhtyDQ;EAOI,wBAAA;A5E6syDZ;;A4EptyDQ;EAOI,8BAAA;A5EityDZ;;A4ExtyDQ;EAOI,6BAAA;A5EqtyDZ;;A4E5tyDQ;EAOI,2BAAA;A5EytyDZ;;A4EhuyDQ;EAOI,6BAAA;A5E6tyDZ;;A4EpuyDQ;EAOI,2BAAA;A5EiuyDZ;;A4ExuyDQ;EAOI,2BAAA;A5EquyDZ;;A4E5uyDQ;EAOI,0BAAA;A5EyuyDZ;;A4EhvyDQ;EAOI,gCAAA;A5E6uyDZ;;A4EpvyDQ;EAOI,+BAAA;A5EivyDZ;;A4ExvyDQ;EAOI,6BAAA;A5EqvyDZ;;A4E5vyDQ;EAOI,+BAAA;A5EyvyDZ;;A4EhwyDQ;EAOI,6BAAA;A5E6vyDZ;;A4EpwyDQ;EAOI,6BAAA;A5EiwyDZ;;A4ExwyDQ;EAOI,2BAAA;A5EqwyDZ;;A4E5wyDQ;EAOI,iCAAA;A5EywyDZ;;A4EhxyDQ;EAOI,gCAAA;A5E6wyDZ;;A4EpxyDQ;EAOI,8BAAA;A5EixyDZ;;A4ExxyDQ;EAOI,gCAAA;A5EqxyDZ;;A4E5xyDQ;EAOI,8BAAA;A5EyxyDZ;;A4EhyyDQ;EAOI,8BAAA;A5E6xyDZ;;A4EpyyDQ;EAOI,yBAAA;A5EiyyDZ;;A4ExyyDQ;EAOI,+BAAA;A5EqyyDZ;;A4E5yyDQ;EAOI,8BAAA;A5EyyyDZ;;A4EhzyDQ;EAOI,4BAAA;A5E6yyDZ;;A4EpzyDQ;EAOI,8BAAA;A5EizyDZ;;A4ExzyDQ;EAOI,4BAAA;A5EqzyDZ;;A4E5zyDQ;EAOI,4BAAA;A5EyzyDZ;;A4Eh0yDQ;EAOI,2BAAA;A5E6zyDZ;;A4Ep0yDQ;EAOI,0BAAA;A5Ei0yDZ;;A4Ex0yDQ;EAOI,wBAAA;A5Eq0yDZ;;A4E50yDQ;EAOI,0BAAA;A5Ey0yDZ;;A4Eh1yDQ;EAOI,wBAAA;A5E60yDZ;;A4Ep1yDQ;EAOI,iCAAA;EAAA,gCAAA;A5Ek1yDZ;;A4Ez1yDQ;EAOI,gCAAA;EAAA,+BAAA;A5Eu1yDZ;;A4E91yDQ;EAOI,8BAAA;EAAA,6BAAA;A5E41yDZ;;A4En2yDQ;EAOI,gCAAA;EAAA,+BAAA;A5Ei2yDZ;;A4Ex2yDQ;EAOI,8BAAA;EAAA,6BAAA;A5Es2yDZ;;A4E72yDQ;EAOI,+BAAA;EAAA,kCAAA;A5E22yDZ;;A4El3yDQ;EAOI,8BAAA;EAAA,iCAAA;A5Eg3yDZ;;A4Ev3yDQ;EAOI,4BAAA;EAAA,+BAAA;A5Eq3yDZ;;A4E53yDQ;EAOI,8BAAA;EAAA,iCAAA;A5E03yDZ;;A4Ej4yDQ;EAOI,4BAAA;EAAA,+BAAA;A5E+3yDZ;;A4Et4yDQ;EAOI,+BAAA;A5Em4yDZ;;A4E14yDQ;EAOI,8BAAA;A5Eu4yDZ;;A4E94yDQ;EAOI,4BAAA;A5E24yDZ;;A4El5yDQ;EAOI,8BAAA;A5E+4yDZ;;A4Et5yDQ;EAOI,4BAAA;A5Em5yDZ;;A4E15yDQ;EAOI,iCAAA;A5Eu5yDZ;;A4E95yDQ;EAOI,gCAAA;A5E25yDZ;;A4El6yDQ;EAOI,8BAAA;A5E+5yDZ;;A4Et6yDQ;EAOI,gCAAA;A5Em6yDZ;;A4E16yDQ;EAOI,8BAAA;A5Eu6yDZ;;A4E96yDQ;EAOI,kCAAA;A5E26yDZ;;A4El7yDQ;EAOI,iCAAA;A5E+6yDZ;;A4Et7yDQ;EAOI,+BAAA;A5Em7yDZ;;A4E17yDQ;EAOI,iCAAA;A5Eu7yDZ;;A4E97yDQ;EAOI,+BAAA;A5E27yDZ;;A4El8yDQ;EAOI,gCAAA;A5E+7yDZ;;A4Et8yDQ;EAOI,+BAAA;A5Em8yDZ;;A4E18yDQ;EAOI,6BAAA;A5Eu8yDZ;;A4E98yDQ;EAOI,+BAAA;A5E28yDZ;;A4El9yDQ;EAOI,6BAAA;A5E+8yDZ;;A4Et9yDQ;EAOI,qBAAA;A5Em9yDZ;;A4E19yDQ;EAOI,2BAAA;A5Eu9yDZ;;A4E99yDQ;EAOI,0BAAA;A5E29yDZ;;A4El+yDQ;EAOI,wBAAA;A5E+9yDZ;;A4Et+yDQ;EAOI,0BAAA;A5Em+yDZ;;A4E1+yDQ;EAOI,wBAAA;A5Eu+yDZ;;A4E9+yDQ;EAOI,2BAAA;EAAA,0BAAA;A5E4+yDZ;;A4En/yDQ;EAOI,iCAAA;EAAA,gCAAA;A5Ei/yDZ;;A4Ex/yDQ;EAOI,gCAAA;EAAA,+BAAA;A5Es/yDZ;;A4E7/yDQ;EAOI,8BAAA;EAAA,6BAAA;A5E2/yDZ;;A4ElgzDQ;EAOI,gCAAA;EAAA,+BAAA;A5EggzDZ;;A4EvgzDQ;EAOI,8BAAA;EAAA,6BAAA;A5EqgzDZ;;A4E5gzDQ;EAOI,yBAAA;EAAA,4BAAA;A5E0gzDZ;;A4EjhzDQ;EAOI,+BAAA;EAAA,kCAAA;A5E+gzDZ;;A4EthzDQ;EAOI,8BAAA;EAAA,iCAAA;A5EohzDZ;;A4E3hzDQ;EAOI,4BAAA;EAAA,+BAAA;A5EyhzDZ;;A4EhizDQ;EAOI,8BAAA;EAAA,iCAAA;A5E8hzDZ;;A4ErizDQ;EAOI,4BAAA;EAAA,+BAAA;A5EmizDZ;;A4E1izDQ;EAOI,yBAAA;A5EuizDZ;;A4E9izDQ;EAOI,+BAAA;A5E2izDZ;;A4EljzDQ;EAOI,8BAAA;A5E+izDZ;;A4EtjzDQ;EAOI,4BAAA;A5EmjzDZ;;A4E1jzDQ;EAOI,8BAAA;A5EujzDZ;;A4E9jzDQ;EAOI,4BAAA;A5E2jzDZ;;A4ElkzDQ;EAOI,2BAAA;A5E+jzDZ;;A4EtkzDQ;EAOI,iCAAA;A5EmkzDZ;;A4E1kzDQ;EAOI,gCAAA;A5EukzDZ;;A4E9kzDQ;EAOI,8BAAA;A5E2kzDZ;;A4EllzDQ;EAOI,gCAAA;A5E+kzDZ;;A4EtlzDQ;EAOI,8BAAA;A5EmlzDZ;;A4E1lzDQ;EAOI,4BAAA;A5EulzDZ;;A4E9lzDQ;EAOI,kCAAA;A5E2lzDZ;;A4ElmzDQ;EAOI,iCAAA;A5E+lzDZ;;A4EtmzDQ;EAOI,+BAAA;A5EmmzDZ;;A4E1mzDQ;EAOI,iCAAA;A5EumzDZ;;A4E9mzDQ;EAOI,+BAAA;A5E2mzDZ;;A4ElnzDQ;EAOI,0BAAA;A5E+mzDZ;;A4EtnzDQ;EAOI,gCAAA;A5EmnzDZ;;A4E1nzDQ;EAOI,+BAAA;A5EunzDZ;;A4E9nzDQ;EAOI,6BAAA;A5E2nzDZ;;A4ElozDQ;EAOI,+BAAA;A5E+nzDZ;;A4EtozDQ;EAOI,6BAAA;A5EmozDZ;;A4E1ozDQ;EAOI,iBAAA;A5EuozDZ;;A4E9ozDQ;EAOI,uBAAA;A5E2ozDZ;;A4ElpzDQ;EAOI,sBAAA;A5E+ozDZ;;A4EtpzDQ;EAOI,oBAAA;A5EmpzDZ;;A4E1pzDQ;EAOI,sBAAA;A5EupzDZ;;A4E9pzDQ;EAOI,oBAAA;A5E2pzDZ;;A4ElqzDQ;EAOI,gDAAA;A5E+pzDZ;;A4EtqzDQ;EAOI,kDAAA;A5EmqzDZ;;A4E1qzDQ;EAOI,8CAAA;A5EuqzDZ;;A4E9qzDQ;EAOI,oDAAA;A5E2qzDZ;;A4ElrzDQ;EAOI,gCAAA;A5E+qzDZ;;A4EtrzDQ;EAOI,iCAAA;A5EmrzDZ;;A4E1rzDQ;EAOI,+BAAA;A5EurzDZ;;A4E9rzDQ;EAOI,6BAAA;A5E2rzDZ;;A4ElszDQ;EAOI,6BAAA;A5E+rzDZ;;A4EtszDQ;EAOI,2BAAA;A5EmszDZ;;A4E1szDQ;EAOI,+BAAA;A5EuszDZ;;A4E9szDQ;EAOI,2BAAA;A5E2szDZ;;A4EltzDQ;EAOI,2BAAA;A5E+szDZ;;A4EttzDQ;EAOI,2BAAA;A5EmtzDZ;;A4E1tzDQ;EAOI,8BAAA;A5EutzDZ;;A4E9tzDQ;EAOI,yBAAA;A5E2tzDZ;;A4EluzDQ;EAOI,4BAAA;A5E+tzDZ;;A4EtuzDQ;EAOI,2BAAA;A5EmuzDZ;;A4E1uzDQ;EAOI,yBAAA;A5EuuzDZ;;A4E9uzDQ;EAOI,2BAAA;A5E2uzDZ;;A4ElvzDQ;EAOI,4BAAA;A5E+uzDZ;;A4EtvzDQ;EAOI,6BAAA;A5EmvzDZ;;A4E1vzDQ;EAOI,gCAAA;A5EuvzDZ;;A4E9vzDQ;EAOI,qCAAA;A5E2vzDZ;;A4ElwzDQ;EAOI,wCAAA;A5E+vzDZ;;A4EtwzDQ;EAOI,oCAAA;A5EmwzDZ;;A4E1wzDQ;EAOI,oCAAA;A5EuwzDZ;;A4E9wzDQ;EAOI,qCAAA;A5E2wzDZ;;A4ElxzDQ;EAOI,8BAAA;A5E+wzDZ;;A4EtxzDQ;EAOI,8BAAA;A5EmxzDZ;;A4ExyzDQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A5EyxzDZ;;A4EtwzDQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A5E+xzDZ;;A4EtyzDQ;EAIQ,oBAAA;EAGJ,uEAAA;A5EoyzDZ;;A4E3yzDQ;EAIQ,oBAAA;EAGJ,qEAAA;A5EyyzDZ;;A4EhzzDQ;EAIQ,oBAAA;EAGJ,kEAAA;A5E8yzDZ;;A4ErzzDQ;EAIQ,oBAAA;EAGJ,qEAAA;A5EmzzDZ;;A4E1zzDQ;EAIQ,oBAAA;EAGJ,oEAAA;A5EwzzDZ;;A4E/zzDQ;EAIQ,oBAAA;EAGJ,mEAAA;A5E6zzDZ;;A4Ep0zDQ;EAIQ,oBAAA;EAGJ,kEAAA;A5Ek0zDZ;;A4Ez0zDQ;EAIQ,oBAAA;EAGJ,mEAAA;A5Eu0zDZ;;A4E90zDQ;EAIQ,oBAAA;EAGJ,mEAAA;A5E40zDZ;;A4En1zDQ;EAIQ,oBAAA;EAGJ,wEAAA;A5Ei1zDZ;;A4Ex1zDQ;EAIQ,oBAAA;EAGJ,yBAAA;A5Es1zDZ;;A4E71zDQ;EAIQ,oBAAA;EAGJ,oCAAA;A5E21zDZ;;A4El2zDQ;EAIQ,oBAAA;EAGJ,0CAAA;A5Eg2zDZ;;A4Ev2zDQ;EAIQ,oBAAA;EAGJ,yBAAA;A5Eq2zDZ;;A4Et3zDQ;EACE,uBAAA;A5Ey3zDV;;A4E13zDQ;EACE,sBAAA;A5E63zDV;;A4E93zDQ;EACE,uBAAA;A5Ei4zDV;;A4El4zDQ;EACE,oBAAA;A5Eq4zDV;;A4E53zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5E03zDZ;;A4Ej4zDQ;EAIQ,kBAAA;EAGJ,gFAAA;A5E+3zDZ;;A4Et4zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5Eo4zDZ;;A4E34zDQ;EAIQ,kBAAA;EAGJ,2EAAA;A5Ey4zDZ;;A4Eh5zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5E84zDZ;;A4Er5zDQ;EAIQ,kBAAA;EAGJ,6EAAA;A5Em5zDZ;;A4E15zDQ;EAIQ,kBAAA;EAGJ,4EAAA;A5Ew5zDZ;;A4E/5zDQ;EAIQ,kBAAA;EAGJ,2EAAA;A5E65zDZ;;A4Ep6zDQ;EAIQ,kBAAA;EAGJ,4EAAA;A5Ek6zDZ;;A4Ez6zDQ;EAIQ,kBAAA;EAGJ,4EAAA;A5Eu6zDZ;;A4E96zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5E46zDZ;;A4En7zDQ;EAIQ,kBAAA;EAGJ,wCAAA;A5Ei7zDZ;;A4El8zDQ;EACE,oBAAA;A5Eq8zDV;;A4Et8zDQ;EACE,qBAAA;A5Ey8zDV;;A4E18zDQ;EACE,oBAAA;A5E68zDV;;A4E98zDQ;EACE,qBAAA;A5Ei9zDV;;A4El9zDQ;EACE,kBAAA;A5Eq9zDV;;A4E58zDQ;EAOI,+CAAA;A5Ey8zDZ;;A4Eh9zDQ;EAOI,mCAAA;UAAA,2BAAA;A5E68zDZ;;A4Ep9zDQ;EAOI,oCAAA;UAAA,4BAAA;A5Ei9zDZ;;A4Ex9zDQ;EAOI,oCAAA;UAAA,4BAAA;A5Eq9zDZ;;A4E59zDQ;EAOI,+BAAA;A5Ey9zDZ;;A4Eh+zDQ;EAOI,+BAAA;A5E69zDZ;;A4Ep+zDQ;EAOI,iDAAA;A5Ei+zDZ;;A4Ex+zDQ;EAOI,2BAAA;A5Eq+zDZ;;A4E5+zDQ;EAOI,oDAAA;A5Ey+zDZ;;A4Eh/zDQ;EAOI,iDAAA;A5E6+zDZ;;A4Ep/zDQ;EAOI,oDAAA;A5Ei/zDZ;;A4Ex/zDQ;EAOI,oDAAA;A5Eq/zDZ;;A4E5/zDQ;EAOI,qDAAA;A5Ey/zDZ;;A4Ehg0DQ;EAOI,6BAAA;A5E6/zDZ;;A4Epg0DQ;EAOI,sDAAA;A5Eig0DZ;;A4Exg0DQ;EAOI,0DAAA;EAAA,2DAAA;A5Esg0DZ;;A4E7g0DQ;EAOI,2DAAA;EAAA,8DAAA;A5E2g0DZ;;A4Elh0DQ;EAOI,8DAAA;EAAA,6DAAA;A5Egh0DZ;;A4Evh0DQ;EAOI,6DAAA;EAAA,0DAAA;A5Eqh0DZ;;A4E5h0DQ;EAOI,8BAAA;A5Eyh0DZ;;A4Ehi0DQ;EAOI,6BAAA;A5E6h0DZ;;AmBvi0DI;EyDGI;IAOI,sBAAA;E5Eki0DV;E4Ezi0DM;IAOI,uBAAA;E5Eqi0DV;E4E5i0DM;IAOI,sBAAA;E5Ewi0DV;E4E/i0DM;IAOI,0BAAA;E5E2i0DV;E4Elj0DM;IAOI,gCAAA;E5E8i0DV;E4Erj0DM;IAOI,yBAAA;E5Eij0DV;E4Exj0DM;IAOI,wBAAA;E5Eoj0DV;E4E3j0DM;IAOI,yBAAA;E5Euj0DV;E4E9j0DM;IAOI,6BAAA;E5E0j0DV;E4Ejk0DM;IAOI,8BAAA;E5E6j0DV;E4Epk0DM;IAOI,wBAAA;E5Egk0DV;E4Evk0DM;IAOI,+BAAA;E5Emk0DV;E4E1k0DM;IAOI,wBAAA;E5Esk0DV;E4E7k0DM;IAOI,yBAAA;E5Eyk0DV;E4Ehl0DM;IAOI,8BAAA;E5E4k0DV;E4Enl0DM;IAOI,iCAAA;E5E+k0DV;E4Etl0DM;IAOI,sCAAA;E5Ekl0DV;E4Ezl0DM;IAOI,yCAAA;E5Eql0DV;E4E5l0DM;IAOI,uBAAA;E5Ewl0DV;E4E/l0DM;IAOI,uBAAA;E5E2l0DV;E4Elm0DM;IAOI,yBAAA;E5E8l0DV;E4Erm0DM;IAOI,yBAAA;E5Eim0DV;E4Exm0DM;IAOI,0BAAA;E5Eom0DV;E4E3m0DM;IAOI,4BAAA;E5Eum0DV;E4E9m0DM;IAOI,kCAAA;E5E0m0DV;E4Ejn0DM;IAOI,sCAAA;E5E6m0DV;E4Epn0DM;IAOI,oCAAA;E5Egn0DV;E4Evn0DM;IAOI,kCAAA;E5Emn0DV;E4E1n0DM;IAOI,yCAAA;E5Esn0DV;E4E7n0DM;IAOI,wCAAA;E5Eyn0DV;E4Eho0DM;IAOI,wCAAA;E5E4n0DV;E4Eno0DM;IAOI,kCAAA;E5E+n0DV;E4Eto0DM;IAOI,gCAAA;E5Eko0DV;E4Ezo0DM;IAOI,8BAAA;E5Eqo0DV;E4E5o0DM;IAOI,gCAAA;E5Ewo0DV;E4E/o0DM;IAOI,+BAAA;E5E2o0DV;E4Elp0DM;IAOI,oCAAA;E5E8o0DV;E4Erp0DM;IAOI,kCAAA;E5Eip0DV;E4Exp0DM;IAOI,gCAAA;E5Eop0DV;E4E3p0DM;IAOI,uCAAA;E5Eup0DV;E4E9p0DM;IAOI,sCAAA;E5E0p0DV;E4Ejq0DM;IAOI,iCAAA;E5E6p0DV;E4Epq0DM;IAOI,2BAAA;E5Egq0DV;E4Evq0DM;IAOI,iCAAA;E5Emq0DV;E4E1q0DM;IAOI,+BAAA;E5Esq0DV;E4E7q0DM;IAOI,6BAAA;E5Eyq0DV;E4Ehr0DM;IAOI,+BAAA;E5E4q0DV;E4Enr0DM;IAOI,8BAAA;E5E+q0DV;E4Etr0DM;IAOI,oBAAA;E5Ekr0DV;E4Ezr0DM;IAOI,mBAAA;E5Eqr0DV;E4E5r0DM;IAOI,mBAAA;E5Ewr0DV;E4E/r0DM;IAOI,mBAAA;E5E2r0DV;E4Els0DM;IAOI,mBAAA;E5E8r0DV;E4Ers0DM;IAOI,mBAAA;E5Eis0DV;E4Exs0DM;IAOI,mBAAA;E5Eos0DV;E4E3s0DM;IAOI,mBAAA;E5Eus0DV;E4E9s0DM;IAOI,oBAAA;E5E0s0DV;E4Ejt0DM;IAOI,0BAAA;E5E6s0DV;E4Ept0DM;IAOI,yBAAA;E5Egt0DV;E4Evt0DM;IAOI,uBAAA;E5Emt0DV;E4E1t0DM;IAOI,yBAAA;E5Est0DV;E4E7t0DM;IAOI,uBAAA;E5Eyt0DV;E4Ehu0DM;IAOI,uBAAA;E5E4t0DV;E4Enu0DM;IAOI,0BAAA;IAAA,yBAAA;E5Egu0DV;E4Evu0DM;IAOI,gCAAA;IAAA,+BAAA;E5Eou0DV;E4E3u0DM;IAOI,+BAAA;IAAA,8BAAA;E5Ewu0DV;E4E/u0DM;IAOI,6BAAA;IAAA,4BAAA;E5E4u0DV;E4Env0DM;IAOI,+BAAA;IAAA,8BAAA;E5Egv0DV;E4Evv0DM;IAOI,6BAAA;IAAA,4BAAA;E5Eov0DV;E4E3v0DM;IAOI,6BAAA;IAAA,4BAAA;E5Ewv0DV;E4E/v0DM;IAOI,wBAAA;IAAA,2BAAA;E5E4v0DV;E4Enw0DM;IAOI,8BAAA;IAAA,iCAAA;E5Egw0DV;E4Evw0DM;IAOI,6BAAA;IAAA,gCAAA;E5Eow0DV;E4E3w0DM;IAOI,2BAAA;IAAA,8BAAA;E5Eww0DV;E4E/w0DM;IAOI,6BAAA;IAAA,gCAAA;E5E4w0DV;E4Enx0DM;IAOI,2BAAA;IAAA,8BAAA;E5Egx0DV;E4Evx0DM;IAOI,2BAAA;IAAA,8BAAA;E5Eox0DV;E4E3x0DM;IAOI,wBAAA;E5Eux0DV;E4E9x0DM;IAOI,8BAAA;E5E0x0DV;E4Ejy0DM;IAOI,6BAAA;E5E6x0DV;E4Epy0DM;IAOI,2BAAA;E5Egy0DV;E4Evy0DM;IAOI,6BAAA;E5Emy0DV;E4E1y0DM;IAOI,2BAAA;E5Esy0DV;E4E7y0DM;IAOI,2BAAA;E5Eyy0DV;E4Ehz0DM;IAOI,0BAAA;E5E4y0DV;E4Enz0DM;IAOI,gCAAA;E5E+y0DV;E4Etz0DM;IAOI,+BAAA;E5Ekz0DV;E4Ezz0DM;IAOI,6BAAA;E5Eqz0DV;E4E5z0DM;IAOI,+BAAA;E5Ewz0DV;E4E/z0DM;IAOI,6BAAA;E5E2z0DV;E4El00DM;IAOI,6BAAA;E5E8z0DV;E4Er00DM;IAOI,2BAAA;E5Ei00DV;E4Ex00DM;IAOI,iCAAA;E5Eo00DV;E4E300DM;IAOI,gCAAA;E5Eu00DV;E4E900DM;IAOI,8BAAA;E5E000DV;E4Ej10DM;IAOI,gCAAA;E5E600DV;E4Ep10DM;IAOI,8BAAA;E5Eg10DV;E4Ev10DM;IAOI,8BAAA;E5Em10DV;E4E110DM;IAOI,yBAAA;E5Es10DV;E4E710DM;IAOI,+BAAA;E5Ey10DV;E4Eh20DM;IAOI,8BAAA;E5E410DV;E4En20DM;IAOI,4BAAA;E5E+10DV;E4Et20DM;IAOI,8BAAA;E5Ek20DV;E4Ez20DM;IAOI,4BAAA;E5Eq20DV;E4E520DM;IAOI,4BAAA;E5Ew20DV;E4E/20DM;IAOI,2BAAA;E5E220DV;E4El30DM;IAOI,0BAAA;E5E820DV;E4Er30DM;IAOI,wBAAA;E5Ei30DV;E4Ex30DM;IAOI,0BAAA;E5Eo30DV;E4E330DM;IAOI,wBAAA;E5Eu30DV;E4E930DM;IAOI,iCAAA;IAAA,gCAAA;E5E230DV;E4El40DM;IAOI,gCAAA;IAAA,+BAAA;E5E+30DV;E4Et40DM;IAOI,8BAAA;IAAA,6BAAA;E5Em40DV;E4E140DM;IAOI,gCAAA;IAAA,+BAAA;E5Eu40DV;E4E940DM;IAOI,8BAAA;IAAA,6BAAA;E5E240DV;E4El50DM;IAOI,+BAAA;IAAA,kCAAA;E5E+40DV;E4Et50DM;IAOI,8BAAA;IAAA,iCAAA;E5Em50DV;E4E150DM;IAOI,4BAAA;IAAA,+BAAA;E5Eu50DV;E4E950DM;IAOI,8BAAA;IAAA,iCAAA;E5E250DV;E4El60DM;IAOI,4BAAA;IAAA,+BAAA;E5E+50DV;E4Et60DM;IAOI,+BAAA;E5Ek60DV;E4Ez60DM;IAOI,8BAAA;E5Eq60DV;E4E560DM;IAOI,4BAAA;E5Ew60DV;E4E/60DM;IAOI,8BAAA;E5E260DV;E4El70DM;IAOI,4BAAA;E5E860DV;E4Er70DM;IAOI,iCAAA;E5Ei70DV;E4Ex70DM;IAOI,gCAAA;E5Eo70DV;E4E370DM;IAOI,8BAAA;E5Eu70DV;E4E970DM;IAOI,gCAAA;E5E070DV;E4Ej80DM;IAOI,8BAAA;E5E670DV;E4Ep80DM;IAOI,kCAAA;E5Eg80DV;E4Ev80DM;IAOI,iCAAA;E5Em80DV;E4E180DM;IAOI,+BAAA;E5Es80DV;E4E780DM;IAOI,iCAAA;E5Ey80DV;E4Eh90DM;IAOI,+BAAA;E5E480DV;E4En90DM;IAOI,gCAAA;E5E+80DV;E4Et90DM;IAOI,+BAAA;E5Ek90DV;E4Ez90DM;IAOI,6BAAA;E5Eq90DV;E4E590DM;IAOI,+BAAA;E5Ew90DV;E4E/90DM;IAOI,6BAAA;E5E290DV;E4El+0DM;IAOI,qBAAA;E5E890DV;E4Er+0DM;IAOI,2BAAA;E5Ei+0DV;E4Ex+0DM;IAOI,0BAAA;E5Eo+0DV;E4E3+0DM;IAOI,wBAAA;E5Eu+0DV;E4E9+0DM;IAOI,0BAAA;E5E0+0DV;E4Ej/0DM;IAOI,wBAAA;E5E6+0DV;E4Ep/0DM;IAOI,2BAAA;IAAA,0BAAA;E5Ei/0DV;E4Ex/0DM;IAOI,iCAAA;IAAA,gCAAA;E5Eq/0DV;E4E5/0DM;IAOI,gCAAA;IAAA,+BAAA;E5Ey/0DV;E4Ehg1DM;IAOI,8BAAA;IAAA,6BAAA;E5E6/0DV;E4Epg1DM;IAOI,gCAAA;IAAA,+BAAA;E5Eig1DV;E4Exg1DM;IAOI,8BAAA;IAAA,6BAAA;E5Eqg1DV;E4E5g1DM;IAOI,yBAAA;IAAA,4BAAA;E5Eyg1DV;E4Ehh1DM;IAOI,+BAAA;IAAA,kCAAA;E5E6g1DV;E4Eph1DM;IAOI,8BAAA;IAAA,iCAAA;E5Eih1DV;E4Exh1DM;IAOI,4BAAA;IAAA,+BAAA;E5Eqh1DV;E4E5h1DM;IAOI,8BAAA;IAAA,iCAAA;E5Eyh1DV;E4Ehi1DM;IAOI,4BAAA;IAAA,+BAAA;E5E6h1DV;E4Epi1DM;IAOI,yBAAA;E5Egi1DV;E4Evi1DM;IAOI,+BAAA;E5Emi1DV;E4E1i1DM;IAOI,8BAAA;E5Esi1DV;E4E7i1DM;IAOI,4BAAA;E5Eyi1DV;E4Ehj1DM;IAOI,8BAAA;E5E4i1DV;E4Enj1DM;IAOI,4BAAA;E5E+i1DV;E4Etj1DM;IAOI,2BAAA;E5Ekj1DV;E4Ezj1DM;IAOI,iCAAA;E5Eqj1DV;E4E5j1DM;IAOI,gCAAA;E5Ewj1DV;E4E/j1DM;IAOI,8BAAA;E5E2j1DV;E4Elk1DM;IAOI,gCAAA;E5E8j1DV;E4Erk1DM;IAOI,8BAAA;E5Eik1DV;E4Exk1DM;IAOI,4BAAA;E5Eok1DV;E4E3k1DM;IAOI,kCAAA;E5Euk1DV;E4E9k1DM;IAOI,iCAAA;E5E0k1DV;E4Ejl1DM;IAOI,+BAAA;E5E6k1DV;E4Epl1DM;IAOI,iCAAA;E5Egl1DV;E4Evl1DM;IAOI,+BAAA;E5Eml1DV;E4E1l1DM;IAOI,0BAAA;E5Esl1DV;E4E7l1DM;IAOI,gCAAA;E5Eyl1DV;E4Ehm1DM;IAOI,+BAAA;E5E4l1DV;E4Enm1DM;IAOI,6BAAA;E5E+l1DV;E4Etm1DM;IAOI,+BAAA;E5Ekm1DV;E4Ezm1DM;IAOI,6BAAA;E5Eqm1DV;E4E5m1DM;IAOI,iBAAA;E5Ewm1DV;E4E/m1DM;IAOI,uBAAA;E5E2m1DV;E4Eln1DM;IAOI,sBAAA;E5E8m1DV;E4Ern1DM;IAOI,oBAAA;E5Ein1DV;E4Exn1DM;IAOI,sBAAA;E5Eon1DV;E4E3n1DM;IAOI,oBAAA;E5Eun1DV;E4E9n1DM;IAOI,2BAAA;E5E0n1DV;E4Ejo1DM;IAOI,4BAAA;E5E6n1DV;E4Epo1DM;IAOI,6BAAA;E5Ego1DV;AACF;AmB3o1DI;EyDGI;IAOI,sBAAA;E5Eqo1DV;E4E5o1DM;IAOI,uBAAA;E5Ewo1DV;E4E/o1DM;IAOI,sBAAA;E5E2o1DV;E4Elp1DM;IAOI,0BAAA;E5E8o1DV;E4Erp1DM;IAOI,gCAAA;E5Eip1DV;E4Exp1DM;IAOI,yBAAA;E5Eop1DV;E4E3p1DM;IAOI,wBAAA;E5Eup1DV;E4E9p1DM;IAOI,yBAAA;E5E0p1DV;E4Ejq1DM;IAOI,6BAAA;E5E6p1DV;E4Epq1DM;IAOI,8BAAA;E5Egq1DV;E4Evq1DM;IAOI,wBAAA;E5Emq1DV;E4E1q1DM;IAOI,+BAAA;E5Esq1DV;E4E7q1DM;IAOI,wBAAA;E5Eyq1DV;E4Ehr1DM;IAOI,yBAAA;E5E4q1DV;E4Enr1DM;IAOI,8BAAA;E5E+q1DV;E4Etr1DM;IAOI,iCAAA;E5Ekr1DV;E4Ezr1DM;IAOI,sCAAA;E5Eqr1DV;E4E5r1DM;IAOI,yCAAA;E5Ewr1DV;E4E/r1DM;IAOI,uBAAA;E5E2r1DV;E4Els1DM;IAOI,uBAAA;E5E8r1DV;E4Ers1DM;IAOI,yBAAA;E5Eis1DV;E4Exs1DM;IAOI,yBAAA;E5Eos1DV;E4E3s1DM;IAOI,0BAAA;E5Eus1DV;E4E9s1DM;IAOI,4BAAA;E5E0s1DV;E4Ejt1DM;IAOI,kCAAA;E5E6s1DV;E4Ept1DM;IAOI,sCAAA;E5Egt1DV;E4Evt1DM;IAOI,oCAAA;E5Emt1DV;E4E1t1DM;IAOI,kCAAA;E5Est1DV;E4E7t1DM;IAOI,yCAAA;E5Eyt1DV;E4Ehu1DM;IAOI,wCAAA;E5E4t1DV;E4Enu1DM;IAOI,wCAAA;E5E+t1DV;E4Etu1DM;IAOI,kCAAA;E5Eku1DV;E4Ezu1DM;IAOI,gCAAA;E5Equ1DV;E4E5u1DM;IAOI,8BAAA;E5Ewu1DV;E4E/u1DM;IAOI,gCAAA;E5E2u1DV;E4Elv1DM;IAOI,+BAAA;E5E8u1DV;E4Erv1DM;IAOI,oCAAA;E5Eiv1DV;E4Exv1DM;IAOI,kCAAA;E5Eov1DV;E4E3v1DM;IAOI,gCAAA;E5Euv1DV;E4E9v1DM;IAOI,uCAAA;E5E0v1DV;E4Ejw1DM;IAOI,sCAAA;E5E6v1DV;E4Epw1DM;IAOI,iCAAA;E5Egw1DV;E4Evw1DM;IAOI,2BAAA;E5Emw1DV;E4E1w1DM;IAOI,iCAAA;E5Esw1DV;E4E7w1DM;IAOI,+BAAA;E5Eyw1DV;E4Ehx1DM;IAOI,6BAAA;E5E4w1DV;E4Enx1DM;IAOI,+BAAA;E5E+w1DV;E4Etx1DM;IAOI,8BAAA;E5Ekx1DV;E4Ezx1DM;IAOI,oBAAA;E5Eqx1DV;E4E5x1DM;IAOI,mBAAA;E5Ewx1DV;E4E/x1DM;IAOI,mBAAA;E5E2x1DV;E4Ely1DM;IAOI,mBAAA;E5E8x1DV;E4Ery1DM;IAOI,mBAAA;E5Eiy1DV;E4Exy1DM;IAOI,mBAAA;E5Eoy1DV;E4E3y1DM;IAOI,mBAAA;E5Euy1DV;E4E9y1DM;IAOI,mBAAA;E5E0y1DV;E4Ejz1DM;IAOI,oBAAA;E5E6y1DV;E4Epz1DM;IAOI,0BAAA;E5Egz1DV;E4Evz1DM;IAOI,yBAAA;E5Emz1DV;E4E1z1DM;IAOI,uBAAA;E5Esz1DV;E4E7z1DM;IAOI,yBAAA;E5Eyz1DV;E4Eh01DM;IAOI,uBAAA;E5E4z1DV;E4En01DM;IAOI,uBAAA;E5E+z1DV;E4Et01DM;IAOI,0BAAA;IAAA,yBAAA;E5Em01DV;E4E101DM;IAOI,gCAAA;IAAA,+BAAA;E5Eu01DV;E4E901DM;IAOI,+BAAA;IAAA,8BAAA;E5E201DV;E4El11DM;IAOI,6BAAA;IAAA,4BAAA;E5E+01DV;E4Et11DM;IAOI,+BAAA;IAAA,8BAAA;E5Em11DV;E4E111DM;IAOI,6BAAA;IAAA,4BAAA;E5Eu11DV;E4E911DM;IAOI,6BAAA;IAAA,4BAAA;E5E211DV;E4El21DM;IAOI,wBAAA;IAAA,2BAAA;E5E+11DV;E4Et21DM;IAOI,8BAAA;IAAA,iCAAA;E5Em21DV;E4E121DM;IAOI,6BAAA;IAAA,gCAAA;E5Eu21DV;E4E921DM;IAOI,2BAAA;IAAA,8BAAA;E5E221DV;E4El31DM;IAOI,6BAAA;IAAA,gCAAA;E5E+21DV;E4Et31DM;IAOI,2BAAA;IAAA,8BAAA;E5Em31DV;E4E131DM;IAOI,2BAAA;IAAA,8BAAA;E5Eu31DV;E4E931DM;IAOI,wBAAA;E5E031DV;E4Ej41DM;IAOI,8BAAA;E5E631DV;E4Ep41DM;IAOI,6BAAA;E5Eg41DV;E4Ev41DM;IAOI,2BAAA;E5Em41DV;E4E141DM;IAOI,6BAAA;E5Es41DV;E4E741DM;IAOI,2BAAA;E5Ey41DV;E4Eh51DM;IAOI,2BAAA;E5E441DV;E4En51DM;IAOI,0BAAA;E5E+41DV;E4Et51DM;IAOI,gCAAA;E5Ek51DV;E4Ez51DM;IAOI,+BAAA;E5Eq51DV;E4E551DM;IAOI,6BAAA;E5Ew51DV;E4E/51DM;IAOI,+BAAA;E5E251DV;E4El61DM;IAOI,6BAAA;E5E851DV;E4Er61DM;IAOI,6BAAA;E5Ei61DV;E4Ex61DM;IAOI,2BAAA;E5Eo61DV;E4E361DM;IAOI,iCAAA;E5Eu61DV;E4E961DM;IAOI,gCAAA;E5E061DV;E4Ej71DM;IAOI,8BAAA;E5E661DV;E4Ep71DM;IAOI,gCAAA;E5Eg71DV;E4Ev71DM;IAOI,8BAAA;E5Em71DV;E4E171DM;IAOI,8BAAA;E5Es71DV;E4E771DM;IAOI,yBAAA;E5Ey71DV;E4Eh81DM;IAOI,+BAAA;E5E471DV;E4En81DM;IAOI,8BAAA;E5E+71DV;E4Et81DM;IAOI,4BAAA;E5Ek81DV;E4Ez81DM;IAOI,8BAAA;E5Eq81DV;E4E581DM;IAOI,4BAAA;E5Ew81DV;E4E/81DM;IAOI,4BAAA;E5E281DV;E4El91DM;IAOI,2BAAA;E5E881DV;E4Er91DM;IAOI,0BAAA;E5Ei91DV;E4Ex91DM;IAOI,wBAAA;E5Eo91DV;E4E391DM;IAOI,0BAAA;E5Eu91DV;E4E991DM;IAOI,wBAAA;E5E091DV;E4Ej+1DM;IAOI,iCAAA;IAAA,gCAAA;E5E891DV;E4Er+1DM;IAOI,gCAAA;IAAA,+BAAA;E5Ek+1DV;E4Ez+1DM;IAOI,8BAAA;IAAA,6BAAA;E5Es+1DV;E4E7+1DM;IAOI,gCAAA;IAAA,+BAAA;E5E0+1DV;E4Ej/1DM;IAOI,8BAAA;IAAA,6BAAA;E5E8+1DV;E4Er/1DM;IAOI,+BAAA;IAAA,kCAAA;E5Ek/1DV;E4Ez/1DM;IAOI,8BAAA;IAAA,iCAAA;E5Es/1DV;E4E7/1DM;IAOI,4BAAA;IAAA,+BAAA;E5E0/1DV;E4Ejg2DM;IAOI,8BAAA;IAAA,iCAAA;E5E8/1DV;E4Erg2DM;IAOI,4BAAA;IAAA,+BAAA;E5Ekg2DV;E4Ezg2DM;IAOI,+BAAA;E5Eqg2DV;E4E5g2DM;IAOI,8BAAA;E5Ewg2DV;E4E/g2DM;IAOI,4BAAA;E5E2g2DV;E4Elh2DM;IAOI,8BAAA;E5E8g2DV;E4Erh2DM;IAOI,4BAAA;E5Eih2DV;E4Exh2DM;IAOI,iCAAA;E5Eoh2DV;E4E3h2DM;IAOI,gCAAA;E5Euh2DV;E4E9h2DM;IAOI,8BAAA;E5E0h2DV;E4Eji2DM;IAOI,gCAAA;E5E6h2DV;E4Epi2DM;IAOI,8BAAA;E5Egi2DV;E4Evi2DM;IAOI,kCAAA;E5Emi2DV;E4E1i2DM;IAOI,iCAAA;E5Esi2DV;E4E7i2DM;IAOI,+BAAA;E5Eyi2DV;E4Ehj2DM;IAOI,iCAAA;E5E4i2DV;E4Enj2DM;IAOI,+BAAA;E5E+i2DV;E4Etj2DM;IAOI,gCAAA;E5Ekj2DV;E4Ezj2DM;IAOI,+BAAA;E5Eqj2DV;E4E5j2DM;IAOI,6BAAA;E5Ewj2DV;E4E/j2DM;IAOI,+BAAA;E5E2j2DV;E4Elk2DM;IAOI,6BAAA;E5E8j2DV;E4Erk2DM;IAOI,qBAAA;E5Eik2DV;E4Exk2DM;IAOI,2BAAA;E5Eok2DV;E4E3k2DM;IAOI,0BAAA;E5Euk2DV;E4E9k2DM;IAOI,wBAAA;E5E0k2DV;E4Ejl2DM;IAOI,0BAAA;E5E6k2DV;E4Epl2DM;IAOI,wBAAA;E5Egl2DV;E4Evl2DM;IAOI,2BAAA;IAAA,0BAAA;E5Eol2DV;E4E3l2DM;IAOI,iCAAA;IAAA,gCAAA;E5Ewl2DV;E4E/l2DM;IAOI,gCAAA;IAAA,+BAAA;E5E4l2DV;E4Enm2DM;IAOI,8BAAA;IAAA,6BAAA;E5Egm2DV;E4Evm2DM;IAOI,gCAAA;IAAA,+BAAA;E5Eom2DV;E4E3m2DM;IAOI,8BAAA;IAAA,6BAAA;E5Ewm2DV;E4E/m2DM;IAOI,yBAAA;IAAA,4BAAA;E5E4m2DV;E4Enn2DM;IAOI,+BAAA;IAAA,kCAAA;E5Egn2DV;E4Evn2DM;IAOI,8BAAA;IAAA,iCAAA;E5Eon2DV;E4E3n2DM;IAOI,4BAAA;IAAA,+BAAA;E5Ewn2DV;E4E/n2DM;IAOI,8BAAA;IAAA,iCAAA;E5E4n2DV;E4Eno2DM;IAOI,4BAAA;IAAA,+BAAA;E5Ego2DV;E4Evo2DM;IAOI,yBAAA;E5Emo2DV;E4E1o2DM;IAOI,+BAAA;E5Eso2DV;E4E7o2DM;IAOI,8BAAA;E5Eyo2DV;E4Ehp2DM;IAOI,4BAAA;E5E4o2DV;E4Enp2DM;IAOI,8BAAA;E5E+o2DV;E4Etp2DM;IAOI,4BAAA;E5Ekp2DV;E4Ezp2DM;IAOI,2BAAA;E5Eqp2DV;E4E5p2DM;IAOI,iCAAA;E5Ewp2DV;E4E/p2DM;IAOI,gCAAA;E5E2p2DV;E4Elq2DM;IAOI,8BAAA;E5E8p2DV;E4Erq2DM;IAOI,gCAAA;E5Eiq2DV;E4Exq2DM;IAOI,8BAAA;E5Eoq2DV;E4E3q2DM;IAOI,4BAAA;E5Euq2DV;E4E9q2DM;IAOI,kCAAA;E5E0q2DV;E4Ejr2DM;IAOI,iCAAA;E5E6q2DV;E4Epr2DM;IAOI,+BAAA;E5Egr2DV;E4Evr2DM;IAOI,iCAAA;E5Emr2DV;E4E1r2DM;IAOI,+BAAA;E5Esr2DV;E4E7r2DM;IAOI,0BAAA;E5Eyr2DV;E4Ehs2DM;IAOI,gCAAA;E5E4r2DV;E4Ens2DM;IAOI,+BAAA;E5E+r2DV;E4Ets2DM;IAOI,6BAAA;E5Eks2DV;E4Ezs2DM;IAOI,+BAAA;E5Eqs2DV;E4E5s2DM;IAOI,6BAAA;E5Ews2DV;E4E/s2DM;IAOI,iBAAA;E5E2s2DV;E4Elt2DM;IAOI,uBAAA;E5E8s2DV;E4Ert2DM;IAOI,sBAAA;E5Eit2DV;E4Ext2DM;IAOI,oBAAA;E5Eot2DV;E4E3t2DM;IAOI,sBAAA;E5Eut2DV;E4E9t2DM;IAOI,oBAAA;E5E0t2DV;E4Eju2DM;IAOI,2BAAA;E5E6t2DV;E4Epu2DM;IAOI,4BAAA;E5Egu2DV;E4Evu2DM;IAOI,6BAAA;E5Emu2DV;AACF;AmB9u2DI;EyDGI;IAOI,sBAAA;E5Ewu2DV;E4E/u2DM;IAOI,uBAAA;E5E2u2DV;E4Elv2DM;IAOI,sBAAA;E5E8u2DV;E4Erv2DM;IAOI,0BAAA;E5Eiv2DV;E4Exv2DM;IAOI,gCAAA;E5Eov2DV;E4E3v2DM;IAOI,yBAAA;E5Euv2DV;E4E9v2DM;IAOI,wBAAA;E5E0v2DV;E4Ejw2DM;IAOI,yBAAA;E5E6v2DV;E4Epw2DM;IAOI,6BAAA;E5Egw2DV;E4Evw2DM;IAOI,8BAAA;E5Emw2DV;E4E1w2DM;IAOI,wBAAA;E5Esw2DV;E4E7w2DM;IAOI,+BAAA;E5Eyw2DV;E4Ehx2DM;IAOI,wBAAA;E5E4w2DV;E4Enx2DM;IAOI,yBAAA;E5E+w2DV;E4Etx2DM;IAOI,8BAAA;E5Ekx2DV;E4Ezx2DM;IAOI,iCAAA;E5Eqx2DV;E4E5x2DM;IAOI,sCAAA;E5Ewx2DV;E4E/x2DM;IAOI,yCAAA;E5E2x2DV;E4Ely2DM;IAOI,uBAAA;E5E8x2DV;E4Ery2DM;IAOI,uBAAA;E5Eiy2DV;E4Exy2DM;IAOI,yBAAA;E5Eoy2DV;E4E3y2DM;IAOI,yBAAA;E5Euy2DV;E4E9y2DM;IAOI,0BAAA;E5E0y2DV;E4Ejz2DM;IAOI,4BAAA;E5E6y2DV;E4Epz2DM;IAOI,kCAAA;E5Egz2DV;E4Evz2DM;IAOI,sCAAA;E5Emz2DV;E4E1z2DM;IAOI,oCAAA;E5Esz2DV;E4E7z2DM;IAOI,kCAAA;E5Eyz2DV;E4Eh02DM;IAOI,yCAAA;E5E4z2DV;E4En02DM;IAOI,wCAAA;E5E+z2DV;E4Et02DM;IAOI,wCAAA;E5Ek02DV;E4Ez02DM;IAOI,kCAAA;E5Eq02DV;E4E502DM;IAOI,gCAAA;E5Ew02DV;E4E/02DM;IAOI,8BAAA;E5E202DV;E4El12DM;IAOI,gCAAA;E5E802DV;E4Er12DM;IAOI,+BAAA;E5Ei12DV;E4Ex12DM;IAOI,oCAAA;E5Eo12DV;E4E312DM;IAOI,kCAAA;E5Eu12DV;E4E912DM;IAOI,gCAAA;E5E012DV;E4Ej22DM;IAOI,uCAAA;E5E612DV;E4Ep22DM;IAOI,sCAAA;E5Eg22DV;E4Ev22DM;IAOI,iCAAA;E5Em22DV;E4E122DM;IAOI,2BAAA;E5Es22DV;E4E722DM;IAOI,iCAAA;E5Ey22DV;E4Eh32DM;IAOI,+BAAA;E5E422DV;E4En32DM;IAOI,6BAAA;E5E+22DV;E4Et32DM;IAOI,+BAAA;E5Ek32DV;E4Ez32DM;IAOI,8BAAA;E5Eq32DV;E4E532DM;IAOI,oBAAA;E5Ew32DV;E4E/32DM;IAOI,mBAAA;E5E232DV;E4El42DM;IAOI,mBAAA;E5E832DV;E4Er42DM;IAOI,mBAAA;E5Ei42DV;E4Ex42DM;IAOI,mBAAA;E5Eo42DV;E4E342DM;IAOI,mBAAA;E5Eu42DV;E4E942DM;IAOI,mBAAA;E5E042DV;E4Ej52DM;IAOI,mBAAA;E5E642DV;E4Ep52DM;IAOI,oBAAA;E5Eg52DV;E4Ev52DM;IAOI,0BAAA;E5Em52DV;E4E152DM;IAOI,yBAAA;E5Es52DV;E4E752DM;IAOI,uBAAA;E5Ey52DV;E4Eh62DM;IAOI,yBAAA;E5E452DV;E4En62DM;IAOI,uBAAA;E5E+52DV;E4Et62DM;IAOI,uBAAA;E5Ek62DV;E4Ez62DM;IAOI,0BAAA;IAAA,yBAAA;E5Es62DV;E4E762DM;IAOI,gCAAA;IAAA,+BAAA;E5E062DV;E4Ej72DM;IAOI,+BAAA;IAAA,8BAAA;E5E862DV;E4Er72DM;IAOI,6BAAA;IAAA,4BAAA;E5Ek72DV;E4Ez72DM;IAOI,+BAAA;IAAA,8BAAA;E5Es72DV;E4E772DM;IAOI,6BAAA;IAAA,4BAAA;E5E072DV;E4Ej82DM;IAOI,6BAAA;IAAA,4BAAA;E5E872DV;E4Er82DM;IAOI,wBAAA;IAAA,2BAAA;E5Ek82DV;E4Ez82DM;IAOI,8BAAA;IAAA,iCAAA;E5Es82DV;E4E782DM;IAOI,6BAAA;IAAA,gCAAA;E5E082DV;E4Ej92DM;IAOI,2BAAA;IAAA,8BAAA;E5E882DV;E4Er92DM;IAOI,6BAAA;IAAA,gCAAA;E5Ek92DV;E4Ez92DM;IAOI,2BAAA;IAAA,8BAAA;E5Es92DV;E4E792DM;IAOI,2BAAA;IAAA,8BAAA;E5E092DV;E4Ej+2DM;IAOI,wBAAA;E5E692DV;E4Ep+2DM;IAOI,8BAAA;E5Eg+2DV;E4Ev+2DM;IAOI,6BAAA;E5Em+2DV;E4E1+2DM;IAOI,2BAAA;E5Es+2DV;E4E7+2DM;IAOI,6BAAA;E5Ey+2DV;E4Eh/2DM;IAOI,2BAAA;E5E4+2DV;E4En/2DM;IAOI,2BAAA;E5E++2DV;E4Et/2DM;IAOI,0BAAA;E5Ek/2DV;E4Ez/2DM;IAOI,gCAAA;E5Eq/2DV;E4E5/2DM;IAOI,+BAAA;E5Ew/2DV;E4E//2DM;IAOI,6BAAA;E5E2/2DV;E4Elg3DM;IAOI,+BAAA;E5E8/2DV;E4Erg3DM;IAOI,6BAAA;E5Eig3DV;E4Exg3DM;IAOI,6BAAA;E5Eog3DV;E4E3g3DM;IAOI,2BAAA;E5Eug3DV;E4E9g3DM;IAOI,iCAAA;E5E0g3DV;E4Ejh3DM;IAOI,gCAAA;E5E6g3DV;E4Eph3DM;IAOI,8BAAA;E5Egh3DV;E4Evh3DM;IAOI,gCAAA;E5Emh3DV;E4E1h3DM;IAOI,8BAAA;E5Esh3DV;E4E7h3DM;IAOI,8BAAA;E5Eyh3DV;E4Ehi3DM;IAOI,yBAAA;E5E4h3DV;E4Eni3DM;IAOI,+BAAA;E5E+h3DV;E4Eti3DM;IAOI,8BAAA;E5Eki3DV;E4Ezi3DM;IAOI,4BAAA;E5Eqi3DV;E4E5i3DM;IAOI,8BAAA;E5Ewi3DV;E4E/i3DM;IAOI,4BAAA;E5E2i3DV;E4Elj3DM;IAOI,4BAAA;E5E8i3DV;E4Erj3DM;IAOI,2BAAA;E5Eij3DV;E4Exj3DM;IAOI,0BAAA;E5Eoj3DV;E4E3j3DM;IAOI,wBAAA;E5Euj3DV;E4E9j3DM;IAOI,0BAAA;E5E0j3DV;E4Ejk3DM;IAOI,wBAAA;E5E6j3DV;E4Epk3DM;IAOI,iCAAA;IAAA,gCAAA;E5Eik3DV;E4Exk3DM;IAOI,gCAAA;IAAA,+BAAA;E5Eqk3DV;E4E5k3DM;IAOI,8BAAA;IAAA,6BAAA;E5Eyk3DV;E4Ehl3DM;IAOI,gCAAA;IAAA,+BAAA;E5E6k3DV;E4Epl3DM;IAOI,8BAAA;IAAA,6BAAA;E5Eil3DV;E4Exl3DM;IAOI,+BAAA;IAAA,kCAAA;E5Eql3DV;E4E5l3DM;IAOI,8BAAA;IAAA,iCAAA;E5Eyl3DV;E4Ehm3DM;IAOI,4BAAA;IAAA,+BAAA;E5E6l3DV;E4Epm3DM;IAOI,8BAAA;IAAA,iCAAA;E5Eim3DV;E4Exm3DM;IAOI,4BAAA;IAAA,+BAAA;E5Eqm3DV;E4E5m3DM;IAOI,+BAAA;E5Ewm3DV;E4E/m3DM;IAOI,8BAAA;E5E2m3DV;E4Eln3DM;IAOI,4BAAA;E5E8m3DV;E4Ern3DM;IAOI,8BAAA;E5Ein3DV;E4Exn3DM;IAOI,4BAAA;E5Eon3DV;E4E3n3DM;IAOI,iCAAA;E5Eun3DV;E4E9n3DM;IAOI,gCAAA;E5E0n3DV;E4Ejo3DM;IAOI,8BAAA;E5E6n3DV;E4Epo3DM;IAOI,gCAAA;E5Ego3DV;E4Evo3DM;IAOI,8BAAA;E5Emo3DV;E4E1o3DM;IAOI,kCAAA;E5Eso3DV;E4E7o3DM;IAOI,iCAAA;E5Eyo3DV;E4Ehp3DM;IAOI,+BAAA;E5E4o3DV;E4Enp3DM;IAOI,iCAAA;E5E+o3DV;E4Etp3DM;IAOI,+BAAA;E5Ekp3DV;E4Ezp3DM;IAOI,gCAAA;E5Eqp3DV;E4E5p3DM;IAOI,+BAAA;E5Ewp3DV;E4E/p3DM;IAOI,6BAAA;E5E2p3DV;E4Elq3DM;IAOI,+BAAA;E5E8p3DV;E4Erq3DM;IAOI,6BAAA;E5Eiq3DV;E4Exq3DM;IAOI,qBAAA;E5Eoq3DV;E4E3q3DM;IAOI,2BAAA;E5Euq3DV;E4E9q3DM;IAOI,0BAAA;E5E0q3DV;E4Ejr3DM;IAOI,wBAAA;E5E6q3DV;E4Epr3DM;IAOI,0BAAA;E5Egr3DV;E4Evr3DM;IAOI,wBAAA;E5Emr3DV;E4E1r3DM;IAOI,2BAAA;IAAA,0BAAA;E5Eur3DV;E4E9r3DM;IAOI,iCAAA;IAAA,gCAAA;E5E2r3DV;E4Els3DM;IAOI,gCAAA;IAAA,+BAAA;E5E+r3DV;E4Ets3DM;IAOI,8BAAA;IAAA,6BAAA;E5Ems3DV;E4E1s3DM;IAOI,gCAAA;IAAA,+BAAA;E5Eus3DV;E4E9s3DM;IAOI,8BAAA;IAAA,6BAAA;E5E2s3DV;E4Elt3DM;IAOI,yBAAA;IAAA,4BAAA;E5E+s3DV;E4Ett3DM;IAOI,+BAAA;IAAA,kCAAA;E5Emt3DV;E4E1t3DM;IAOI,8BAAA;IAAA,iCAAA;E5Eut3DV;E4E9t3DM;IAOI,4BAAA;IAAA,+BAAA;E5E2t3DV;E4Elu3DM;IAOI,8BAAA;IAAA,iCAAA;E5E+t3DV;E4Etu3DM;IAOI,4BAAA;IAAA,+BAAA;E5Emu3DV;E4E1u3DM;IAOI,yBAAA;E5Esu3DV;E4E7u3DM;IAOI,+BAAA;E5Eyu3DV;E4Ehv3DM;IAOI,8BAAA;E5E4u3DV;E4Env3DM;IAOI,4BAAA;E5E+u3DV;E4Etv3DM;IAOI,8BAAA;E5Ekv3DV;E4Ezv3DM;IAOI,4BAAA;E5Eqv3DV;E4E5v3DM;IAOI,2BAAA;E5Ewv3DV;E4E/v3DM;IAOI,iCAAA;E5E2v3DV;E4Elw3DM;IAOI,gCAAA;E5E8v3DV;E4Erw3DM;IAOI,8BAAA;E5Eiw3DV;E4Exw3DM;IAOI,gCAAA;E5Eow3DV;E4E3w3DM;IAOI,8BAAA;E5Euw3DV;E4E9w3DM;IAOI,4BAAA;E5E0w3DV;E4Ejx3DM;IAOI,kCAAA;E5E6w3DV;E4Epx3DM;IAOI,iCAAA;E5Egx3DV;E4Evx3DM;IAOI,+BAAA;E5Emx3DV;E4E1x3DM;IAOI,iCAAA;E5Esx3DV;E4E7x3DM;IAOI,+BAAA;E5Eyx3DV;E4Ehy3DM;IAOI,0BAAA;E5E4x3DV;E4Eny3DM;IAOI,gCAAA;E5E+x3DV;E4Ety3DM;IAOI,+BAAA;E5Eky3DV;E4Ezy3DM;IAOI,6BAAA;E5Eqy3DV;E4E5y3DM;IAOI,+BAAA;E5Ewy3DV;E4E/y3DM;IAOI,6BAAA;E5E2y3DV;E4Elz3DM;IAOI,iBAAA;E5E8y3DV;E4Erz3DM;IAOI,uBAAA;E5Eiz3DV;E4Exz3DM;IAOI,sBAAA;E5Eoz3DV;E4E3z3DM;IAOI,oBAAA;E5Euz3DV;E4E9z3DM;IAOI,sBAAA;E5E0z3DV;E4Ej03DM;IAOI,oBAAA;E5E6z3DV;E4Ep03DM;IAOI,2BAAA;E5Eg03DV;E4Ev03DM;IAOI,4BAAA;E5Em03DV;E4E103DM;IAOI,6BAAA;E5Es03DV;AACF;AmBj13DI;EyDGI;IAOI,sBAAA;E5E203DV;E4El13DM;IAOI,uBAAA;E5E803DV;E4Er13DM;IAOI,sBAAA;E5Ei13DV;E4Ex13DM;IAOI,0BAAA;E5Eo13DV;E4E313DM;IAOI,gCAAA;E5Eu13DV;E4E913DM;IAOI,yBAAA;E5E013DV;E4Ej23DM;IAOI,wBAAA;E5E613DV;E4Ep23DM;IAOI,yBAAA;E5Eg23DV;E4Ev23DM;IAOI,6BAAA;E5Em23DV;E4E123DM;IAOI,8BAAA;E5Es23DV;E4E723DM;IAOI,wBAAA;E5Ey23DV;E4Eh33DM;IAOI,+BAAA;E5E423DV;E4En33DM;IAOI,wBAAA;E5E+23DV;E4Et33DM;IAOI,yBAAA;E5Ek33DV;E4Ez33DM;IAOI,8BAAA;E5Eq33DV;E4E533DM;IAOI,iCAAA;E5Ew33DV;E4E/33DM;IAOI,sCAAA;E5E233DV;E4El43DM;IAOI,yCAAA;E5E833DV;E4Er43DM;IAOI,uBAAA;E5Ei43DV;E4Ex43DM;IAOI,uBAAA;E5Eo43DV;E4E343DM;IAOI,yBAAA;E5Eu43DV;E4E943DM;IAOI,yBAAA;E5E043DV;E4Ej53DM;IAOI,0BAAA;E5E643DV;E4Ep53DM;IAOI,4BAAA;E5Eg53DV;E4Ev53DM;IAOI,kCAAA;E5Em53DV;E4E153DM;IAOI,sCAAA;E5Es53DV;E4E753DM;IAOI,oCAAA;E5Ey53DV;E4Eh63DM;IAOI,kCAAA;E5E453DV;E4En63DM;IAOI,yCAAA;E5E+53DV;E4Et63DM;IAOI,wCAAA;E5Ek63DV;E4Ez63DM;IAOI,wCAAA;E5Eq63DV;E4E563DM;IAOI,kCAAA;E5Ew63DV;E4E/63DM;IAOI,gCAAA;E5E263DV;E4El73DM;IAOI,8BAAA;E5E863DV;E4Er73DM;IAOI,gCAAA;E5Ei73DV;E4Ex73DM;IAOI,+BAAA;E5Eo73DV;E4E373DM;IAOI,oCAAA;E5Eu73DV;E4E973DM;IAOI,kCAAA;E5E073DV;E4Ej83DM;IAOI,gCAAA;E5E673DV;E4Ep83DM;IAOI,uCAAA;E5Eg83DV;E4Ev83DM;IAOI,sCAAA;E5Em83DV;E4E183DM;IAOI,iCAAA;E5Es83DV;E4E783DM;IAOI,2BAAA;E5Ey83DV;E4Eh93DM;IAOI,iCAAA;E5E483DV;E4En93DM;IAOI,+BAAA;E5E+83DV;E4Et93DM;IAOI,6BAAA;E5Ek93DV;E4Ez93DM;IAOI,+BAAA;E5Eq93DV;E4E593DM;IAOI,8BAAA;E5Ew93DV;E4E/93DM;IAOI,oBAAA;E5E293DV;E4El+3DM;IAOI,mBAAA;E5E893DV;E4Er+3DM;IAOI,mBAAA;E5Ei+3DV;E4Ex+3DM;IAOI,mBAAA;E5Eo+3DV;E4E3+3DM;IAOI,mBAAA;E5Eu+3DV;E4E9+3DM;IAOI,mBAAA;E5E0+3DV;E4Ej/3DM;IAOI,mBAAA;E5E6+3DV;E4Ep/3DM;IAOI,mBAAA;E5Eg/3DV;E4Ev/3DM;IAOI,oBAAA;E5Em/3DV;E4E1/3DM;IAOI,0BAAA;E5Es/3DV;E4E7/3DM;IAOI,yBAAA;E5Ey/3DV;E4Ehg4DM;IAOI,uBAAA;E5E4/3DV;E4Eng4DM;IAOI,yBAAA;E5E+/3DV;E4Etg4DM;IAOI,uBAAA;E5Ekg4DV;E4Ezg4DM;IAOI,uBAAA;E5Eqg4DV;E4E5g4DM;IAOI,0BAAA;IAAA,yBAAA;E5Eyg4DV;E4Ehh4DM;IAOI,gCAAA;IAAA,+BAAA;E5E6g4DV;E4Eph4DM;IAOI,+BAAA;IAAA,8BAAA;E5Eih4DV;E4Exh4DM;IAOI,6BAAA;IAAA,4BAAA;E5Eqh4DV;E4E5h4DM;IAOI,+BAAA;IAAA,8BAAA;E5Eyh4DV;E4Ehi4DM;IAOI,6BAAA;IAAA,4BAAA;E5E6h4DV;E4Epi4DM;IAOI,6BAAA;IAAA,4BAAA;E5Eii4DV;E4Exi4DM;IAOI,wBAAA;IAAA,2BAAA;E5Eqi4DV;E4E5i4DM;IAOI,8BAAA;IAAA,iCAAA;E5Eyi4DV;E4Ehj4DM;IAOI,6BAAA;IAAA,gCAAA;E5E6i4DV;E4Epj4DM;IAOI,2BAAA;IAAA,8BAAA;E5Eij4DV;E4Exj4DM;IAOI,6BAAA;IAAA,gCAAA;E5Eqj4DV;E4E5j4DM;IAOI,2BAAA;IAAA,8BAAA;E5Eyj4DV;E4Ehk4DM;IAOI,2BAAA;IAAA,8BAAA;E5E6j4DV;E4Epk4DM;IAOI,wBAAA;E5Egk4DV;E4Evk4DM;IAOI,8BAAA;E5Emk4DV;E4E1k4DM;IAOI,6BAAA;E5Esk4DV;E4E7k4DM;IAOI,2BAAA;E5Eyk4DV;E4Ehl4DM;IAOI,6BAAA;E5E4k4DV;E4Enl4DM;IAOI,2BAAA;E5E+k4DV;E4Etl4DM;IAOI,2BAAA;E5Ekl4DV;E4Ezl4DM;IAOI,0BAAA;E5Eql4DV;E4E5l4DM;IAOI,gCAAA;E5Ewl4DV;E4E/l4DM;IAOI,+BAAA;E5E2l4DV;E4Elm4DM;IAOI,6BAAA;E5E8l4DV;E4Erm4DM;IAOI,+BAAA;E5Eim4DV;E4Exm4DM;IAOI,6BAAA;E5Eom4DV;E4E3m4DM;IAOI,6BAAA;E5Eum4DV;E4E9m4DM;IAOI,2BAAA;E5E0m4DV;E4Ejn4DM;IAOI,iCAAA;E5E6m4DV;E4Epn4DM;IAOI,gCAAA;E5Egn4DV;E4Evn4DM;IAOI,8BAAA;E5Emn4DV;E4E1n4DM;IAOI,gCAAA;E5Esn4DV;E4E7n4DM;IAOI,8BAAA;E5Eyn4DV;E4Eho4DM;IAOI,8BAAA;E5E4n4DV;E4Eno4DM;IAOI,yBAAA;E5E+n4DV;E4Eto4DM;IAOI,+BAAA;E5Eko4DV;E4Ezo4DM;IAOI,8BAAA;E5Eqo4DV;E4E5o4DM;IAOI,4BAAA;E5Ewo4DV;E4E/o4DM;IAOI,8BAAA;E5E2o4DV;E4Elp4DM;IAOI,4BAAA;E5E8o4DV;E4Erp4DM;IAOI,4BAAA;E5Eip4DV;E4Exp4DM;IAOI,2BAAA;E5Eop4DV;E4E3p4DM;IAOI,0BAAA;E5Eup4DV;E4E9p4DM;IAOI,wBAAA;E5E0p4DV;E4Ejq4DM;IAOI,0BAAA;E5E6p4DV;E4Epq4DM;IAOI,wBAAA;E5Egq4DV;E4Evq4DM;IAOI,iCAAA;IAAA,gCAAA;E5Eoq4DV;E4E3q4DM;IAOI,gCAAA;IAAA,+BAAA;E5Ewq4DV;E4E/q4DM;IAOI,8BAAA;IAAA,6BAAA;E5E4q4DV;E4Enr4DM;IAOI,gCAAA;IAAA,+BAAA;E5Egr4DV;E4Evr4DM;IAOI,8BAAA;IAAA,6BAAA;E5Eor4DV;E4E3r4DM;IAOI,+BAAA;IAAA,kCAAA;E5Ewr4DV;E4E/r4DM;IAOI,8BAAA;IAAA,iCAAA;E5E4r4DV;E4Ens4DM;IAOI,4BAAA;IAAA,+BAAA;E5Egs4DV;E4Evs4DM;IAOI,8BAAA;IAAA,iCAAA;E5Eos4DV;E4E3s4DM;IAOI,4BAAA;IAAA,+BAAA;E5Ews4DV;E4E/s4DM;IAOI,+BAAA;E5E2s4DV;E4Elt4DM;IAOI,8BAAA;E5E8s4DV;E4Ert4DM;IAOI,4BAAA;E5Eit4DV;E4Ext4DM;IAOI,8BAAA;E5Eot4DV;E4E3t4DM;IAOI,4BAAA;E5Eut4DV;E4E9t4DM;IAOI,iCAAA;E5E0t4DV;E4Eju4DM;IAOI,gCAAA;E5E6t4DV;E4Epu4DM;IAOI,8BAAA;E5Egu4DV;E4Evu4DM;IAOI,gCAAA;E5Emu4DV;E4E1u4DM;IAOI,8BAAA;E5Esu4DV;E4E7u4DM;IAOI,kCAAA;E5Eyu4DV;E4Ehv4DM;IAOI,iCAAA;E5E4u4DV;E4Env4DM;IAOI,+BAAA;E5E+u4DV;E4Etv4DM;IAOI,iCAAA;E5Ekv4DV;E4Ezv4DM;IAOI,+BAAA;E5Eqv4DV;E4E5v4DM;IAOI,gCAAA;E5Ewv4DV;E4E/v4DM;IAOI,+BAAA;E5E2v4DV;E4Elw4DM;IAOI,6BAAA;E5E8v4DV;E4Erw4DM;IAOI,+BAAA;E5Eiw4DV;E4Exw4DM;IAOI,6BAAA;E5Eow4DV;E4E3w4DM;IAOI,qBAAA;E5Euw4DV;E4E9w4DM;IAOI,2BAAA;E5E0w4DV;E4Ejx4DM;IAOI,0BAAA;E5E6w4DV;E4Epx4DM;IAOI,wBAAA;E5Egx4DV;E4Evx4DM;IAOI,0BAAA;E5Emx4DV;E4E1x4DM;IAOI,wBAAA;E5Esx4DV;E4E7x4DM;IAOI,2BAAA;IAAA,0BAAA;E5E0x4DV;E4Ejy4DM;IAOI,iCAAA;IAAA,gCAAA;E5E8x4DV;E4Ery4DM;IAOI,gCAAA;IAAA,+BAAA;E5Eky4DV;E4Ezy4DM;IAOI,8BAAA;IAAA,6BAAA;E5Esy4DV;E4E7y4DM;IAOI,gCAAA;IAAA,+BAAA;E5E0y4DV;E4Ejz4DM;IAOI,8BAAA;IAAA,6BAAA;E5E8y4DV;E4Erz4DM;IAOI,yBAAA;IAAA,4BAAA;E5Ekz4DV;E4Ezz4DM;IAOI,+BAAA;IAAA,kCAAA;E5Esz4DV;E4E7z4DM;IAOI,8BAAA;IAAA,iCAAA;E5E0z4DV;E4Ej04DM;IAOI,4BAAA;IAAA,+BAAA;E5E8z4DV;E4Er04DM;IAOI,8BAAA;IAAA,iCAAA;E5Ek04DV;E4Ez04DM;IAOI,4BAAA;IAAA,+BAAA;E5Es04DV;E4E704DM;IAOI,yBAAA;E5Ey04DV;E4Eh14DM;IAOI,+BAAA;E5E404DV;E4En14DM;IAOI,8BAAA;E5E+04DV;E4Et14DM;IAOI,4BAAA;E5Ek14DV;E4Ez14DM;IAOI,8BAAA;E5Eq14DV;E4E514DM;IAOI,4BAAA;E5Ew14DV;E4E/14DM;IAOI,2BAAA;E5E214DV;E4El24DM;IAOI,iCAAA;E5E814DV;E4Er24DM;IAOI,gCAAA;E5Ei24DV;E4Ex24DM;IAOI,8BAAA;E5Eo24DV;E4E324DM;IAOI,gCAAA;E5Eu24DV;E4E924DM;IAOI,8BAAA;E5E024DV;E4Ej34DM;IAOI,4BAAA;E5E624DV;E4Ep34DM;IAOI,kCAAA;E5Eg34DV;E4Ev34DM;IAOI,iCAAA;E5Em34DV;E4E134DM;IAOI,+BAAA;E5Es34DV;E4E734DM;IAOI,iCAAA;E5Ey34DV;E4Eh44DM;IAOI,+BAAA;E5E434DV;E4En44DM;IAOI,0BAAA;E5E+34DV;E4Et44DM;IAOI,gCAAA;E5Ek44DV;E4Ez44DM;IAOI,+BAAA;E5Eq44DV;E4E544DM;IAOI,6BAAA;E5Ew44DV;E4E/44DM;IAOI,+BAAA;E5E244DV;E4El54DM;IAOI,6BAAA;E5E844DV;E4Er54DM;IAOI,iBAAA;E5Ei54DV;E4Ex54DM;IAOI,uBAAA;E5Eo54DV;E4E354DM;IAOI,sBAAA;E5Eu54DV;E4E954DM;IAOI,oBAAA;E5E054DV;E4Ej64DM;IAOI,sBAAA;E5E654DV;E4Ep64DM;IAOI,oBAAA;E5Eg64DV;E4Ev64DM;IAOI,2BAAA;E5Em64DV;E4E164DM;IAOI,4BAAA;E5Es64DV;E4E764DM;IAOI,6BAAA;E5Ey64DV;AACF;AmBp74DI;EyDGI;IAOI,sBAAA;E5E864DV;E4Er74DM;IAOI,uBAAA;E5Ei74DV;E4Ex74DM;IAOI,sBAAA;E5Eo74DV;E4E374DM;IAOI,0BAAA;E5Eu74DV;E4E974DM;IAOI,gCAAA;E5E074DV;E4Ej84DM;IAOI,yBAAA;E5E674DV;E4Ep84DM;IAOI,wBAAA;E5Eg84DV;E4Ev84DM;IAOI,yBAAA;E5Em84DV;E4E184DM;IAOI,6BAAA;E5Es84DV;E4E784DM;IAOI,8BAAA;E5Ey84DV;E4Eh94DM;IAOI,wBAAA;E5E484DV;E4En94DM;IAOI,+BAAA;E5E+84DV;E4Et94DM;IAOI,wBAAA;E5Ek94DV;E4Ez94DM;IAOI,yBAAA;E5Eq94DV;E4E594DM;IAOI,8BAAA;E5Ew94DV;E4E/94DM;IAOI,iCAAA;E5E294DV;E4El+4DM;IAOI,sCAAA;E5E894DV;E4Er+4DM;IAOI,yCAAA;E5Ei+4DV;E4Ex+4DM;IAOI,uBAAA;E5Eo+4DV;E4E3+4DM;IAOI,uBAAA;E5Eu+4DV;E4E9+4DM;IAOI,yBAAA;E5E0+4DV;E4Ej/4DM;IAOI,yBAAA;E5E6+4DV;E4Ep/4DM;IAOI,0BAAA;E5Eg/4DV;E4Ev/4DM;IAOI,4BAAA;E5Em/4DV;E4E1/4DM;IAOI,kCAAA;E5Es/4DV;E4E7/4DM;IAOI,sCAAA;E5Ey/4DV;E4Ehg5DM;IAOI,oCAAA;E5E4/4DV;E4Eng5DM;IAOI,kCAAA;E5E+/4DV;E4Etg5DM;IAOI,yCAAA;E5Ekg5DV;E4Ezg5DM;IAOI,wCAAA;E5Eqg5DV;E4E5g5DM;IAOI,wCAAA;E5Ewg5DV;E4E/g5DM;IAOI,kCAAA;E5E2g5DV;E4Elh5DM;IAOI,gCAAA;E5E8g5DV;E4Erh5DM;IAOI,8BAAA;E5Eih5DV;E4Exh5DM;IAOI,gCAAA;E5Eoh5DV;E4E3h5DM;IAOI,+BAAA;E5Euh5DV;E4E9h5DM;IAOI,oCAAA;E5E0h5DV;E4Eji5DM;IAOI,kCAAA;E5E6h5DV;E4Epi5DM;IAOI,gCAAA;E5Egi5DV;E4Evi5DM;IAOI,uCAAA;E5Emi5DV;E4E1i5DM;IAOI,sCAAA;E5Esi5DV;E4E7i5DM;IAOI,iCAAA;E5Eyi5DV;E4Ehj5DM;IAOI,2BAAA;E5E4i5DV;E4Enj5DM;IAOI,iCAAA;E5E+i5DV;E4Etj5DM;IAOI,+BAAA;E5Ekj5DV;E4Ezj5DM;IAOI,6BAAA;E5Eqj5DV;E4E5j5DM;IAOI,+BAAA;E5Ewj5DV;E4E/j5DM;IAOI,8BAAA;E5E2j5DV;E4Elk5DM;IAOI,oBAAA;E5E8j5DV;E4Erk5DM;IAOI,mBAAA;E5Eik5DV;E4Exk5DM;IAOI,mBAAA;E5Eok5DV;E4E3k5DM;IAOI,mBAAA;E5Euk5DV;E4E9k5DM;IAOI,mBAAA;E5E0k5DV;E4Ejl5DM;IAOI,mBAAA;E5E6k5DV;E4Epl5DM;IAOI,mBAAA;E5Egl5DV;E4Evl5DM;IAOI,mBAAA;E5Eml5DV;E4E1l5DM;IAOI,oBAAA;E5Esl5DV;E4E7l5DM;IAOI,0BAAA;E5Eyl5DV;E4Ehm5DM;IAOI,yBAAA;E5E4l5DV;E4Enm5DM;IAOI,uBAAA;E5E+l5DV;E4Etm5DM;IAOI,yBAAA;E5Ekm5DV;E4Ezm5DM;IAOI,uBAAA;E5Eqm5DV;E4E5m5DM;IAOI,uBAAA;E5Ewm5DV;E4E/m5DM;IAOI,0BAAA;IAAA,yBAAA;E5E4m5DV;E4Enn5DM;IAOI,gCAAA;IAAA,+BAAA;E5Egn5DV;E4Evn5DM;IAOI,+BAAA;IAAA,8BAAA;E5Eon5DV;E4E3n5DM;IAOI,6BAAA;IAAA,4BAAA;E5Ewn5DV;E4E/n5DM;IAOI,+BAAA;IAAA,8BAAA;E5E4n5DV;E4Eno5DM;IAOI,6BAAA;IAAA,4BAAA;E5Ego5DV;E4Evo5DM;IAOI,6BAAA;IAAA,4BAAA;E5Eoo5DV;E4E3o5DM;IAOI,wBAAA;IAAA,2BAAA;E5Ewo5DV;E4E/o5DM;IAOI,8BAAA;IAAA,iCAAA;E5E4o5DV;E4Enp5DM;IAOI,6BAAA;IAAA,gCAAA;E5Egp5DV;E4Evp5DM;IAOI,2BAAA;IAAA,8BAAA;E5Eop5DV;E4E3p5DM;IAOI,6BAAA;IAAA,gCAAA;E5Ewp5DV;E4E/p5DM;IAOI,2BAAA;IAAA,8BAAA;E5E4p5DV;E4Enq5DM;IAOI,2BAAA;IAAA,8BAAA;E5Egq5DV;E4Evq5DM;IAOI,wBAAA;E5Emq5DV;E4E1q5DM;IAOI,8BAAA;E5Esq5DV;E4E7q5DM;IAOI,6BAAA;E5Eyq5DV;E4Ehr5DM;IAOI,2BAAA;E5E4q5DV;E4Enr5DM;IAOI,6BAAA;E5E+q5DV;E4Etr5DM;IAOI,2BAAA;E5Ekr5DV;E4Ezr5DM;IAOI,2BAAA;E5Eqr5DV;E4E5r5DM;IAOI,0BAAA;E5Ewr5DV;E4E/r5DM;IAOI,gCAAA;E5E2r5DV;E4Els5DM;IAOI,+BAAA;E5E8r5DV;E4Ers5DM;IAOI,6BAAA;E5Eis5DV;E4Exs5DM;IAOI,+BAAA;E5Eos5DV;E4E3s5DM;IAOI,6BAAA;E5Eus5DV;E4E9s5DM;IAOI,6BAAA;E5E0s5DV;E4Ejt5DM;IAOI,2BAAA;E5E6s5DV;E4Ept5DM;IAOI,iCAAA;E5Egt5DV;E4Evt5DM;IAOI,gCAAA;E5Emt5DV;E4E1t5DM;IAOI,8BAAA;E5Est5DV;E4E7t5DM;IAOI,gCAAA;E5Eyt5DV;E4Ehu5DM;IAOI,8BAAA;E5E4t5DV;E4Enu5DM;IAOI,8BAAA;E5E+t5DV;E4Etu5DM;IAOI,yBAAA;E5Eku5DV;E4Ezu5DM;IAOI,+BAAA;E5Equ5DV;E4E5u5DM;IAOI,8BAAA;E5Ewu5DV;E4E/u5DM;IAOI,4BAAA;E5E2u5DV;E4Elv5DM;IAOI,8BAAA;E5E8u5DV;E4Erv5DM;IAOI,4BAAA;E5Eiv5DV;E4Exv5DM;IAOI,4BAAA;E5Eov5DV;E4E3v5DM;IAOI,2BAAA;E5Euv5DV;E4E9v5DM;IAOI,0BAAA;E5E0v5DV;E4Ejw5DM;IAOI,wBAAA;E5E6v5DV;E4Epw5DM;IAOI,0BAAA;E5Egw5DV;E4Evw5DM;IAOI,wBAAA;E5Emw5DV;E4E1w5DM;IAOI,iCAAA;IAAA,gCAAA;E5Euw5DV;E4E9w5DM;IAOI,gCAAA;IAAA,+BAAA;E5E2w5DV;E4Elx5DM;IAOI,8BAAA;IAAA,6BAAA;E5E+w5DV;E4Etx5DM;IAOI,gCAAA;IAAA,+BAAA;E5Emx5DV;E4E1x5DM;IAOI,8BAAA;IAAA,6BAAA;E5Eux5DV;E4E9x5DM;IAOI,+BAAA;IAAA,kCAAA;E5E2x5DV;E4Ely5DM;IAOI,8BAAA;IAAA,iCAAA;E5E+x5DV;E4Ety5DM;IAOI,4BAAA;IAAA,+BAAA;E5Emy5DV;E4E1y5DM;IAOI,8BAAA;IAAA,iCAAA;E5Euy5DV;E4E9y5DM;IAOI,4BAAA;IAAA,+BAAA;E5E2y5DV;E4Elz5DM;IAOI,+BAAA;E5E8y5DV;E4Erz5DM;IAOI,8BAAA;E5Eiz5DV;E4Exz5DM;IAOI,4BAAA;E5Eoz5DV;E4E3z5DM;IAOI,8BAAA;E5Euz5DV;E4E9z5DM;IAOI,4BAAA;E5E0z5DV;E4Ej05DM;IAOI,iCAAA;E5E6z5DV;E4Ep05DM;IAOI,gCAAA;E5Eg05DV;E4Ev05DM;IAOI,8BAAA;E5Em05DV;E4E105DM;IAOI,gCAAA;E5Es05DV;E4E705DM;IAOI,8BAAA;E5Ey05DV;E4Eh15DM;IAOI,kCAAA;E5E405DV;E4En15DM;IAOI,iCAAA;E5E+05DV;E4Et15DM;IAOI,+BAAA;E5Ek15DV;E4Ez15DM;IAOI,iCAAA;E5Eq15DV;E4E515DM;IAOI,+BAAA;E5Ew15DV;E4E/15DM;IAOI,gCAAA;E5E215DV;E4El25DM;IAOI,+BAAA;E5E815DV;E4Er25DM;IAOI,6BAAA;E5Ei25DV;E4Ex25DM;IAOI,+BAAA;E5Eo25DV;E4E325DM;IAOI,6BAAA;E5Eu25DV;E4E925DM;IAOI,qBAAA;E5E025DV;E4Ej35DM;IAOI,2BAAA;E5E625DV;E4Ep35DM;IAOI,0BAAA;E5Eg35DV;E4Ev35DM;IAOI,wBAAA;E5Em35DV;E4E135DM;IAOI,0BAAA;E5Es35DV;E4E735DM;IAOI,wBAAA;E5Ey35DV;E4Eh45DM;IAOI,2BAAA;IAAA,0BAAA;E5E635DV;E4Ep45DM;IAOI,iCAAA;IAAA,gCAAA;E5Ei45DV;E4Ex45DM;IAOI,gCAAA;IAAA,+BAAA;E5Eq45DV;E4E545DM;IAOI,8BAAA;IAAA,6BAAA;E5Ey45DV;E4Eh55DM;IAOI,gCAAA;IAAA,+BAAA;E5E645DV;E4Ep55DM;IAOI,8BAAA;IAAA,6BAAA;E5Ei55DV;E4Ex55DM;IAOI,yBAAA;IAAA,4BAAA;E5Eq55DV;E4E555DM;IAOI,+BAAA;IAAA,kCAAA;E5Ey55DV;E4Eh65DM;IAOI,8BAAA;IAAA,iCAAA;E5E655DV;E4Ep65DM;IAOI,4BAAA;IAAA,+BAAA;E5Ei65DV;E4Ex65DM;IAOI,8BAAA;IAAA,iCAAA;E5Eq65DV;E4E565DM;IAOI,4BAAA;IAAA,+BAAA;E5Ey65DV;E4Eh75DM;IAOI,yBAAA;E5E465DV;E4En75DM;IAOI,+BAAA;E5E+65DV;E4Et75DM;IAOI,8BAAA;E5Ek75DV;E4Ez75DM;IAOI,4BAAA;E5Eq75DV;E4E575DM;IAOI,8BAAA;E5Ew75DV;E4E/75DM;IAOI,4BAAA;E5E275DV;E4El85DM;IAOI,2BAAA;E5E875DV;E4Er85DM;IAOI,iCAAA;E5Ei85DV;E4Ex85DM;IAOI,gCAAA;E5Eo85DV;E4E385DM;IAOI,8BAAA;E5Eu85DV;E4E985DM;IAOI,gCAAA;E5E085DV;E4Ej95DM;IAOI,8BAAA;E5E685DV;E4Ep95DM;IAOI,4BAAA;E5Eg95DV;E4Ev95DM;IAOI,kCAAA;E5Em95DV;E4E195DM;IAOI,iCAAA;E5Es95DV;E4E795DM;IAOI,+BAAA;E5Ey95DV;E4Eh+5DM;IAOI,iCAAA;E5E495DV;E4En+5DM;IAOI,+BAAA;E5E+95DV;E4Et+5DM;IAOI,0BAAA;E5Ek+5DV;E4Ez+5DM;IAOI,gCAAA;E5Eq+5DV;E4E5+5DM;IAOI,+BAAA;E5Ew+5DV;E4E/+5DM;IAOI,6BAAA;E5E2+5DV;E4El/5DM;IAOI,+BAAA;E5E8+5DV;E4Er/5DM;IAOI,6BAAA;E5Ei/5DV;E4Ex/5DM;IAOI,iBAAA;E5Eo/5DV;E4E3/5DM;IAOI,uBAAA;E5Eu/5DV;E4E9/5DM;IAOI,sBAAA;E5E0/5DV;E4Ejg6DM;IAOI,oBAAA;E5E6/5DV;E4Epg6DM;IAOI,sBAAA;E5Egg6DV;E4Evg6DM;IAOI,oBAAA;E5Emg6DV;E4E1g6DM;IAOI,2BAAA;E5Esg6DV;E4E7g6DM;IAOI,4BAAA;E5Eyg6DV;E4Ehh6DM;IAOI,6BAAA;E5E4g6DV;AACF;A6Enk6DA;ED+CQ;IAOI,gCAAA;E5Eih6DV;E4Exh6DM;IAOI,8BAAA;E5Eoh6DV;E4E3h6DM;IAOI,iCAAA;E5Euh6DV;AACF;A6E3j6DA;ED4BQ;IAOI,0BAAA;E5E4h6DV;E4Eni6DM;IAOI,gCAAA;E5E+h6DV;E4Eti6DM;IAOI,yBAAA;E5Eki6DV;E4Ezi6DM;IAOI,wBAAA;E5Eqi6DV;E4E5i6DM;IAOI,yBAAA;E5Ewi6DV;E4E/i6DM;IAOI,6BAAA;E5E2i6DV;E4Elj6DM;IAOI,8BAAA;E5E8i6DV;E4Erj6DM;IAOI,wBAAA;E5Eij6DV;E4Exj6DM;IAOI,+BAAA;E5Eoj6DV;E4E3j6DM;IAOI,wBAAA;E5Euj6DV;AACF;A8Ejo6DA;;;;;;;CAAA;ACUA;EACI,wBAAA;EACA,6CAAA;EACA,sFAAA;EACA,gBAAA;A/Eio6DJ;A+E9n6DA;EACI,wBAAA;EACA,6CAAA;EACA,wFAAA;EACA,gBAAA;A/Ego6DJ;A+E9n6DA;EACI,wBAAA;EACA,6CAAA;EACA,uFAAA;EACA,gBAAA;A/Ego6DJ;A+E9n6DA;EACI,wBAAA;EACA,6CAAA;EACA,yFAAA;EACA,gBAAA;A/Ego6DJ;A+E9n6DA;EACI,wBAAA;EAEA,qFAAA;EACA,gBAAA;A/E+n6DJ;AgFpq6DA;EAGE,2BAAA;EACA,kFAAA;EACA,4CAAA;EACA,6CAAA;EACA,oFAAA;EACA,gDAAA;EACA,iDAAA;EACA,uCAAA;EAGA,mCAAA;EACA,2CAAA;EACA,8CAAA;EACA,+CAAA;EACA,+CAAA;EACA,kDAAA;EACA,mDAAA;EACA,4CAAA;EAGA,oBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,oCAAA;EAGA,8BAAA;EAEA,4BAAA;EACA,iCAAA;EAGA,oBAAA;EACA,0BAAA;EAGA,oBAAA;EACA,2EAAA;EACA,sCAAA;EAGA,qCAAA;EACA,4BAAA;EAEA,qEAAA;EACA,+EAAA;EACA,4EAAA;EACA,gDAAA;EACA,kEAAA;EAGA,4CAAA;EAGA,2BAAA;EAIA,wBAAA;EACA,8BAAA;EAGA,0BAAA;EAGA,yBAAA;EACA,0BAAA;EACA,0BAAA;AhF0o6DF;AgFvo6DE;EACE,qCAAA;AhFyo6DJ;AgFro6DE;EACE,qBAAA;EACA,gCAAA;EACA,mCAAA;EACA,qDAAA;AhFuo6DJ;AgF1t6DA;EAuFE,iCAAA;EAGA,mBAAA;EACA,0BAAA;EACA,iDAAA;EACA,+BAAA;EAGA,kCAAA;EAGA,+CAAA;AhFgo6DF;;AiFlu6DA;EA2BI,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIF,qBAAA;EACA,4BAAA;EACA,wBAAA;EACA,kCAAA;EAGA,8BAAA;EACA,gFAAA;EACA,4CAAA;EACA,6CAAA;EACA,sFAAA;EACA,gDAAA;EACA,iDAAA;EACA,uCAAA;EAGA,mCAAA;EACA,2CAAA;EACA,8CAAA;EACA,+CAAA;EACA,yFAAA;EACA,kDAAA;EACA,mDAAA;EACA,sFAAA;EAGA,uBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,oCAAA;EAGA,8BAAA;EAEA,6DAAA;EACA,iCAAA;EAGA,uBAAA;EACA,0BAAA;EAGA,yDAAA;EACA,+BAAA;EACA,mCAAA;EAGA,qCAAA;EACA,4BAAA;EAGA,qEAAA;EACA,oCAAA;EACA,4EAAA;EACA,gDAAA;EACA,kEAAA;EAGA,oEAAA;EAGA,2BAAA;EAGA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,4BAAA;EAGA,wBAAA;EACA,8BAAA;EAGA,4DAAA;AjFor6DF;AiFjr6DE;EACE,2DAAA;EACA,iCAAA;EACA,wDAAA;EACA,oEAAA;EACA,+BAAA;EACA,wCAAA;EACA,qEAAA;AjFmr6DJ;AiF/q6DE;EACE,0DAAA;EACA,gCAAA;EACA,mEAAA;EACA,wDAAA;AjFir6DJ;AiF7q6DE;EACE,8BAAA;EACA,4BAAA;EACA,sCAAA;AjF+q6DJ;AiF5q6DE;EACE,8BAAA;EACA,wBAAA;EACA,sCAAA;AjF8q6DJ;AiF3q6DE;EACE,oCAAA;EACA,kDAAA;EACA,4DAAA;AjF6q6DJ;AiF1q6DE;EACE,+BAAA;EACA,2BAAA;EACA,qCAAA;AjF4q6DJ;AiFzq6DE;EACE,8BAAA;EACA,wBAAA;EACA,qCAAA;AjF2q6DJ;AiFxq6DE;EACE,qCAAA;EACA,iDAAA;EACA,2DAAA;AjF0q6DJ;AiFtq6DE;EACE,qBAAA;EACA,yBAAA;AjFwq6DJ;AiF/06DA;EA0KE,4BAAA;EACA,yBAAA;EACA,2BAAA;AjFwq6DF;AiFrq6DE;EACE,sBAAA;AjFuq6DJ;AiFnq6DE;EACE,wCAAA;EACA,qCAAA;AjFqq6DJ;AiFjq6DE;EACE,wCAAA;EACA,0BAAA;EACA,8BAAA;AjFmq6DJ;AiF/p6DE;EACE,0BAAA;AjFiq6DJ;AiF5p6DE;EACE,yBAAA;AjF8p6DJ;AiF1p6DE;EACE,gDAAA;EACA,+CAAA;EACA,8CAAA;AjF4p6DJ;AiFzp6DE;EACE,sBAAA;EACA,wCAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;AjF2p6DJ;AiFvp6DE;EACE,qCAAA;EACA,4CAAA;EACA,iDAAA;EACA,yDAAA;AjFyp6DJ;AiFx36DA;EAmOE,mEAAA;AjFwp6DF;AiFrp6DE;EACE,yDAAA;AjFup6DJ;AiFnp6DE;EACE,iEAAA;EACA,iEAAA;AjFqp6DJ;AiFl46DA;EAiPE,sDAAA;EACA,0BAAA;EACA,8DAAA;EACA,+BAAA;EAGA,kCAAA;EAGA,8DAAA;AjFgp6DF;;AiF5o6DA;EACE,+FAAA;EACA,qDAAA;EACA,8CAAA;AjF+o6DF;;AiF5o6DA;EACE,8FAAA;EACA,uDAAA;EACA,gDAAA;AjF+o6DF;;AiF5o6DA;EACE,4FAAA;EACA,qDAAA;EACA,8CAAA;AjF+o6DF;;AiF5o6DA;EACE,qFAAA;EACA,qDAAA;EACA,8CAAA;AjF+o6DF;;AkFj66DA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,qCvEuF8C;EuEtF9C,6BAAA;EACA,sBAAA;AlFo66DJ;AkFl66DI;EACI,4CvEwnBsB;AX4y5D9B;AkFj66DI;EAdJ;IAeQ,WvED0C;EXq66DhD;AACF;;AkFj66DA;EACI,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YvEmE+C;EuElE/C,gCAAA;AlFo66DJ;AkFh66DI;EAXJ;IAYQ,0CAAA;ElFm66DN;AACF;AkFh66DQ;EACI,oBAAA;AlFk66DZ;AkF956DI;EACI,YAAA;EACA,WAAA;AlFg66DR;AkF956DQ;EAJJ;IAKQ,YAAA;IACA,WAAA;ElFi66DV;AACF;AkF956DI;EACI,yBAAA;AlFg66DR;;AkF556DA,WAAA;AAEA;EACI,yBAAA;AlF856DJ;AkF556DI;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CvEoC0C;EuEnC1C,gBAAA;AlF856DR;AkF356DI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,cvEgFG;AX606DX;AkF156DI;EACI,UAAA;EACA,qBAAA;AlF456DR;AkFz56DI;EA3BJ;IA4BQ,4BAAA;ElF456DN;AACF;;AkFt56DI;EACI,kBAAA;EACA,gBAAA;AlFy56DR;AkFv56DQ;EACI,2BvE0pCwB;AX+v4DpC;;AkFp56DA;EAEQ;IACI,aAAA;ElFs56DV;EkFn56DM;IACI,qBAAA;ElFq56DV;AACF;AkFj56DA;EACI,YvEvB+C;EuEwB/C,aAAA;EACA,mBAAA;AlFm56DJ;;AkFh56DA;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AlFm56DJ;;AkFh56DA;EACI,QAAA;EACA,mBAAA;AlFm56DJ;;AkFh56DA;EACI,WAAA;EACA,mBAAA;AlFm56DJ;;AkF/46DI;EADJ;IAEQ,6BAAA;ElFm56DN;AACF;AkFj56DI;EACI,mBAAA;AlFm56DR;;AkF/46DA;EACI,qBAAA;EACA,oBAAA;EACA,kBAAA;AlFk56DJ;AkFh56DI;EACI,kBAAA;EACA,UAAA;AlFk56DR;;AkF746DA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oCAAA;AlFg56DJ;AkF946DI;EACI,YAAA;AlFg56DR;AkF746DI;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlF+46DR;AkF546DI;EACI,kDAAA;AlF846DR;;AkFv46DQ;EACI,gBAAA;AlF046DZ;;AkFl46DQ;EACI,gBAAA;AlFq46DZ;;AkF/36DI;EACI,0CvE1GyC;EuE2GzC,sCvE3GyC;AX6+6DjD;AkF936DQ;EACI,uCvE/GqC;AX++6DjD;AkF936DY;EAEI,2CAAA;EACA,WvEhEL;AX+76DX;AkFz36DQ;EADJ;IAEQ,+CvElHU;EX8+6DpB;AACF;AkF136DQ;EACI,2CAAA;AlF436DZ;AkFz36DQ;EACI,kDAAA;AlF236DZ;AkFv36DI;EACI,aAAA;AlFy36DR;AkFt36DI;EACI,qBAAA;AlFw36DR;AkFp36DQ;EACI,2CAAA;EACA,WvE9FD;AXo96DX;AkFn36DQ;;EAEI,+BAAA;AlFq36DZ;AkFh36DQ;EACI,yBvEtGD;AXw96DX;;AkF726DA;EAEQ;IACI,gBAAA;ElF+26DV;EkF726DU;IACI,WAAA;ElF+26Dd;AACF;AkF126DA;EACI;IACI,oBAAA;ElF426DN;AACF;AkFv26DQ;EACI;IACI,kBAAA;IACA,4CvEwWc;EXig6D5B;EkFt26DU;IACI,qBAAA;IACA,eAAA;ElFw26Dd;EkFr26DU;IACI,kBAAA;ElFu26Dd;EkFp26DU;IACI,cAAA;IACA,cAAA;ElFs26Dd;EkFl26Dc;IACI,wCAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;ElFo26DlB;EkFl26DkB;IACI,aAAA;ElFo26DtB;EkFj26DkB;IACI,cAAA;ElFm26DtB;AACF;AkF516DgB;EACI,aAAA;AlF816DpB;AkF316DgB;EACI,cAAA;AlF616DpB;;AkFr16DI;EACI,OAAA;EACA,2CAAA;AlFw16DR;AkFt16DQ;EACI;IACI,gBAAA;ElFw16Dd;EkFn16DE;IAEQ,gBvE9PuC;EXol7DjD;AAJF;AkF/06DQ;EALJ;IAMQ,mEAAA;ElFu16DV;AACF;AkF916DI;EASI,6DAAA;AlFw16DR;AkFn16DY;EADJ;IAEQ,+BAAA;ElFs16Dd;AACF;;AkF706DY;EADJ;IAEQ,UvElWkC;EXmr7DhD;EkF306DM;IAEQ,WvE3WkC;EXyr7DhD;EkFv06DE;IAEQ,wBAAA;ElF206DV;AAVF;AkF7z6DI;EACI,aAAA;AlF006DR;;AmFlt7DA;EACI,kBAAA;EACA,0CAAA;EACA,4CxEmG8C;EwElG9C,6BAAA;EACA,8BAAA;AnFqt7DJ;AmFnt7DI;EACI,6BAAA;EACA,UAAA;AnFqt7DR;AmFlt7DI;EACI,gBAAA;EACA,0BAAA;EACA,yBAAA;AnFot7DR;;AmF/s7DI;EACI,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AnFkt7DR;AmFht7DQ;EARJ;IASQ,mBAAA;EnFmt7DV;AACF;;AmF7s7DQ;EACI,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AnFgt7DZ;AmF9s7DY;EARJ;IASQ,mBAAA;EnFit7Dd;AACF;;AoF/v7DA;EACI,SAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,6BzE2GW;EyE1GX,WzEQ8C;EyEP9C,YzEuGY;EyEtGZ,qCzEuGQ;AX2p7DZ;AoFhw7DI;EAVJ;IAWQ,OAAA;EpFmw7DN;AACF;;AoF7v7DQ;EACI,UzEHsC;AXmw7DlD;AoF9v7DY;EAHJ;IAIQ,OAAA;EpFiw7Dd;AACF;AoF7v7DQ;EACI,WzEbsC;AX4w7DlD;AoF7v7DY;EAHJ;IAIQ,OAAA;EpFgw7Dd;AACF;;AoFzv7DI;EACI,kBAAA;ApF4v7DR;;AoFtv7DI;EACI;IACI,kBAAA;IACA,6BAAA;EpFyv7DV;AACF;;AoFnv7DQ;EADJ;IAEQ,wBAAA;EpFuv7DV;AACF;;AqFjz7DA;EACC,kB1EaiD;E0EZjD,gBAAA;ArFoz7DD;AqFlz7DC;EACC,yBAAA;EACA,gB1EsFiD;AX8t7DnD;;AqFhz7DA;EACC,6BAAA;ArFmz7DD;AqFjz7DC;EAHD;IAIE,kBAAA;ErFoz7DA;AACF;;AqFjz7DA;EACC,wCAAA;ArFoz7DD;;AqFjz7DA;EACC,Y1ETiD;E0EUjD,a1EFiD;E0EGjD,sC1ENiD;E0EOjD,4BAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,4C1EXiD;E0EYjD,gCAAA;EACA,6BAAA;ArFoz7DD;AqFjz7DE;EACC,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,yC1Ef+C;E0EgB/C,e1ElB+C;E0EmB/C,oC1EjC+C;AXo17DlD;AqFjz7DG;EACC,gD1ElB8C;AXq07DlD;AqFhz7DG;EACC,+C1EvB8C;AXy07DlD;AqF/y7DG;EACC,qBAAA;EACA,kB1Ef8C;E0EgB9C,eAAA;EACA,oBAAA;ArFiz7DJ;AqF9y7DG;EACC,WAAA;EACA,sBAAA;EACA,yC1ErC8C;AXq17DlD;AqF7y7DG;EACC,iBAAA;EACA,kBAAA;EACA,UAAA;ArF+y7DJ;AqF5y7DG;EACC,+C1E9C8C;AX417DlD;AqF5y7DI;EACC,+C1EjD6C;E0EkD7C,8BAAA;ArF8y7DL;AqFzy7DI;EACC,cAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,0C1EpD6C;AX+17DlD;AqFxy7DI;EACC,gD1EnE6C;AX627DlD;AqFxy7DK;EACC,+C1EvE4C;E0EwE5C,8BAAA;ArF0y7DN;AqFvy7DK;EACC,wBAAA;EACA,gD1E5E4C;AXq37DlD;AqFty7DK;EACC,UAAA;EACA,2D1EjF4C;AXy37DlD;AqFjy7DK;EACC,wBAAA;ArFmy7DN;AqF7x7DE;EACC,qB1EpF+C;AXm37DlD;AqF7x7DG;EACC,kCAAA;EACA,6C1E/F8C;E0EgG9C,iBAAA;EACA,kBAAA;EACA,mB1EpG8C;E0EqG9C,kC1E3H8C;AX057DlD;AqF7x7DI;EACC,WAAA;EACA,UAAA;EACA,aAAA;EACA,wD1EzG6C;E0E0G7C,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;ArF+x7DL;AqF5x7DI;EACC,mD1EjH6C;AX+47DlD;AqF5x7DK;EACC,yEAAA;EACA,UAAA;ArF8x7DN;AqF1x7DI;EACC,gD1EhI6C;AX457DlD;AqF1x7DK;EACC,2D1EnI4C;AX+57DlD;AqFvx7DG;EACC,kBAAA;ArFyx7DJ;AqFtx7DK;EACC,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,SAAA;ArFwx7DN;AqFjx7DC;EACC,c1E1BS;E0E2BT,aAAA;ArFmx7DF;;AqF/w7DA;EACC,iBAAA;EACA,kBAAA;EACA,6BAAA;ArFkx7DD;AqFhx7DC;EALD;IAME,aAAA;ErFmx7DA;AACF;;AqFhx7DA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;ArFmx7DD;AqFjx7DC;EACC,yB1EjDS;E0EkDT,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;ArFmx7DF;AqFjx7DE;EACC,MAAA;EACA,UAAA;ArFmx7DH;AqFhx7DE;EACC,QAAA;ArFkx7DH;AqF/w7DE;EACC,SAAA;EACA,UAAA;ArFix7DH;AqF3w7DG;EACC,SAAA;ArF6w7DJ;AqF1w7DG;EACC,YAAA;ArF4w7DJ;AqFvw7DC;EACC,yBAAA;ArFyw7DF;AqFtw7DG;EACC,SAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;ArFww7DJ;AqFrw7DG;EACC,SAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;ArFuw7DJ;AqFpw7DG;EACC,SAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;ArFsw7DJ;;AqFhw7DA;EACC,iB1ErLkD;AXw77DnD;AqFjw7DC;EACC,aAAA;ArFmw7DF;;AqF/v7DA;EACC,aAAA;ArFkw7DD;;AqF7v7DE;EACC,SAAA;ArFgw7DH;AqF9v7DG;EACC,WAAA;EACA,UAAA;ArFgw7DJ;AqF5v7DE;EAVD;IAWE,kBAAA;IACA,sBAAA;ErF+v7DD;AACF;AqF3v7DE;EACC,UAAA;ArF6v7DH;AqFxv7DE;EADD;IAEE,aAAA;ErF2v7DD;AACF;AqFxv7DC;EACC,aAAA;ArF0v7DF;AqFtv7DE;EACC,iB1E/S+C;AXui8DlD;AqFtv7DG;EAHD;IAIE,cAAA;ErFyv7DF;AACF;AqFrv7DG;EACC,aAAA;ArFuv7DJ;AqFpv7DG;EACC,qBAAA;ArFsv7DJ;AqFlv7DE;EACC,qBAAA;ArFov7DH;AqFjv7DE;EACC;IACC,aAAA;ErFmv7DF;AACF;AqF/u7DE;EACC,W1E5U+C;AX6j8DlD;AqF/u7DG;EACC,aAAA;ArFiv7DJ;AqF9u7DK;EACC,gBAAA;ArFgv7DN;AqFzu7DI;EACC,aAAA;ArF2u7DL;AqFxu7DI;EACC,kBAAA;ArF0u7DL;AqFxu7DK;EACC,aAAA;ArF0u7DN;AqFvu7DK;EACC,cAAA;EACA,iBAAA;EACA,eAAA;ArFyu7DN;AqFpu7DK;EACC,aAAA;ArFsu7DN;AqFnu7DK;EACC,eAAA;ArFqu7DN;AqFnu7DM;EAGC,eAAA;ArFmu7DP;AqF/t7DK;EACC,iBAAA;ArFiu7DN;AqF9t7DK;EAEC,aAAA;ArF+t7DN;AqF3t7DI;EACC,aAAA;ArF6t7DL;AqFzt7DG;EACC,uBAAA;ArF2t7DJ;AqFzt7DI;EACC;IACC,qBAAA;ErF2t7DJ;EqFxt7DG;IACC,gBAAA;ErF0t7DJ;AACF;AqFtt7DK;EACC,cAAA;ArFwt7DN;AqFnt7DK;EACC,eAAA;ArFqt7DN;AqFnt7DM;EAGC,eAAA;ArFmt7DP;AqF/s7DK;EACC,sBAAA;ArFit7DN;AqF9s7DK;EAGC,qBAAA;ArF8s7DN;AqFzs7DK;EACC,qBAAA;ArF2s7DN;AqFxs7DK;EACC,aAAA;ArF0s7DN;AqFts7DI;EACC,gBAAA;ArFws7DL;AqFts7DK;EACC,qBAAA;ArFws7DN;AqFrs7DK;EACC,aAAA;ArFus7DN;AqF9r7DG;EADD;IAEE,kB1E+H0B;EXkk7D5B;AACF;AqFps7DE;EAIC,mBAAA;ArFms7DH;AqF9r7DE;EACC,gBAAA;ArFgs7DH;AqF7r7DE;EACC,aAAA;ArF+r7DH;AqF5r7DE;EACC,qBAAA;ArF8r7DH;AqFzr7DE;EADD;IAEE,kBAAA;ErF4r7DD;EqF1r7DC;IACC,iB1Exe8C;EXoq8DhD;AACF;AqFzr7DE;EACC,8BAAA;ArF2r7DH;AqFxr7DE;EACC,eAAA;EACA,UAAA;EACA,W1Enf+C;E0Eof/C,UAAA;EACA,MAAA;EACA,sC1Enf+C;AX6q8DlD;AqFtr7DG;EACC,aAAA;ArFwr7DJ;AqFrr7DG;EACC,qBAAA;ArFur7DJ;AqFlr7DE;EACC,kBAAA;EACA,sBAAA;EACA,iB1E3bgD;AX+m8DnD;AqFlr7DG;;EAEC,4BAAA;ArFor7DJ;AqFjr7DG;;EAEC,wBAAA;ArFmr7DJ;AqFhr7DG;EACC,oBAAA;ArFkr7DJ;AqF7q7DI;EACC,wBAAA;ArF+q7DL;AqF5q7DI;EACC,kBAAA;EACA,eAAA;ArF8q7DL;AqF5q7DK;EACC,aAAA;ArF8q7DN;AqF3q7DK;EACC,cAAA;EACA,iBAAA;ArF6q7DN;AqFxq7DK;EACC,aAAA;ArF0q7DN;AqFvq7DK;EACC,eAAA;ArFyq7DN;AqFtq7DK;EACC,iBAAA;ArFwq7DN;AqFrq7DK;EAEC,aAAA;ArFsq7DN;AqFlq7DI;EACC,aAAA;EACA,uBAAA;ArFoq7DL;AqFjq7DI;EACC,kBAAA;ArFmq7DL;AqFhq7DM;EACC,kBAAA;EACA,yBAAA;EACA,W1EpcI;E0EqcJ,iD1EjjByC;E0EkjBzC,gBAAA;ArFkq7DP;AqFhq7DO;EACC,oD1EljBwC;E0EmjBxC,+BAAA;ArFkq7DR;AqF/p7DO;EACC,qBAAA;EACA,kBAAA;ArFiq7DR;AqF9p7DO;EACC,cAAA;EACA,wBAAA;EACA,W1ErdG;AXqn8DX;AqF3p7DO;EACC,qBAAA;ArF6p7DR;AqFzp7DM;EACC,cAAA;EACA,U1EvmB2C;E0EwmB3C,kBAAA;EACA,YAAA;EACA,sC1EvmB2C;E0EwmB3C,uBAAA;EACA,iBAAA;EACA,0BAAA;EACA,4C1EzlB2C;AXov8DlD;AqFtp7DI;EACC,UAAA;ArFwp7DL;AqFpp7DO;EACC,+C1E/mB0C;AXqw8DlD;AqFpp7DQ;EACC,cAAA;ArFsp7DT;AqF/o7DM;EACC,yBAAA;EACA,kCAAA;ArFip7DP;AqF7o7DK;EACC,qBAAA;EACA,MAAA;EACA,6BAAA;ArF+o7DN;AqFvo7DE;EACC;IACC,kB1EvpB8C;EXgy8DhD;AACF;AqFto7DE;EACC,Y1E5pB+C;AXoy8DlD;AqFpo7DE;EACC,uBAAA;ArFso7DH;AqFlo7DI;EACC,cAAA;EACA,kBAAA;EACA,yBAAA;ArFoo7DL;AqFjo7DK;EACC,cAAA;ArFmo7DN;AqFho7DK;EACC,cAAA;EACA,iBAAA;EACA,kBAAA;ArFko7DN;AqF/n7DK;EACC,wBAAA;ArFio7DN;AqF9n7DK;EACC,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,QAAA;ArFgo7DN;AqF5n7DM;EACC,aAAA;ArF8n7DP;AqFzn7DI;EACC,wBAAA;ArF2n7DL;AqFxn7DI;EACC,eAAA;ArF0n7DL;AqFtn7DG;EACC,kBAAA;ArFwn7DJ;AqFtn7DI;EACC,0BAAA;ArFwn7DL;AqFjn7DE;EACC,2C1EjsB6C;E0EksB7C,uDAAA;ArFmn7DH;AqFhn7DI;EACC,yD1EpsB2C;AXsz8DhD;AqF9m7DG;EACC,8C1EzsB4C;AXyz8DhD;AqF3m7DG;EACC,8C1E/sB4C;AX4z8DhD;AqF3m7DI;EACC,qD1EhtB2C;AX6z8DhD;AqFzm7DK;EACC,cAAA;ArF2m7DN;AqFxm7DK;EACC,qD1EztB0C;AXm08DhD;AqFxm7DM;EACC,cAAA;ArF0m7DP;AqFvm7DM;EACC,qD1EhuByC;E0EiuBzC,8BAAA;ArFym7DP;AqFpm7DI;EACC,8C1EzuB2C;E0E0uB3C,8BAAA;ArFsm7DL;AqFnm7DI;EACC,oD1E7uB2C;AXk18DhD;AqFnm7DK;EACC,oD1EhvB0C;E0EivB1C,+BAAA;ArFqm7DN;AqF/l7DI;EACC,qD1EvvB2C;AXw18DhD;AqF/l7DK;EACC,oD1E3vB0C;E0E4vB1C,+BAAA;ArFim7DN;AqF3l7DI;EACC,kD1EjwB2C;AX818DhD;AqF3l7DK;EACC,wEAAA;ArF6l7DN;AqF1l7DK;EACC,oD1E1wB0C;AXs28DhD;AqF1l7DM;EACC,0EAAA;ArF4l7DP;AqFxl7DK;EACC,qD1EjxB0C;AX228DhD;AqFpl7DM;EACC,wCAAA;ArFsl7DP;AqFll7DO;EACC,0EAAA;ArFol7DR;AqFhl7DM;EACC,qD1ElyByC;AXo38DhD;AqFhl7DO;EACC,2EAAA;ArFkl7DR;AqFzk7DG;EACC,2C1EnzB4C;AX838DhD;AqFnk7DO;EACC,2C1E5zBwC;AXi48DhD;AqFhk7DK;EACC,UAAA;ArFkk7DN;AqF/j7DO;EACC,yBAAA;EACA,kCAAA;ArFik7DR;AqF3j7DQ;EACC,qD1E10BuC;AXu48DhD;AqF3j7DS;EACC,cAAA;ArF6j7DV;AqFvj7DM;EACC,qBAAA;EACA,MAAA;EACA,6BAAA;ArFyj7DP;AqFlj7DE;EACC,+C1E11B6C;AX848DhD;AqFjj7DE;EACC,aAAA;ArFmj7DH;AqFhj7DE;EACC,qBAAA;ArFkj7DH;AqF7i7DE;EACC,qBAAA;ArF+i7DH;AqF5i7DE;EACC,aAAA;ArF8i7DH;AqFzi7DE;;EAEC,iBAAA;ArF2i7DH;AqFxi7DE;EACC;IACC,kBAAA;ErF0i7DF;EqFvi7DC;IACC,eAAA;IACA,cAAA;IACA,sCAAA,EAAA,2CAAA;ErFyi7DF;EqFti7DC;IACC,kB1EtV0B;EX837D5B;EqFri7DC;IAGC,UAAA;IACA,wC1Ex6B8C;I0Ey6B9C,4BAAA;IACA,eAAA;IACA,UAAA;ErFqi7DF;EqFni7DE;IACC,aAAA;ErFqi7DH;EqF1h7DE;;;;;IACC,qBAAA;ErFgi7DH;EqF7h7DE;;;;;IACC,aAAA;ErFmi7DH;AACF;AqF/h7DE;EACC,6CAAA;ArFii7DH;AqF7h7DG;EACC,gBAAA;ArF+h7DJ;AqF1h7DG;EACC;;IAEC,kBAAA;ErF4h7DH;AACF;AqFjh7DE;;;;EACC,aAAA;ArFsh7DH;AqFnh7DE;;;;EACC,qBAAA;ArFwh7DH;;AqFnh7DA;EACC,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,0C1Ez9BiD;E0E09BjD,gB1ErU6B;AX217D9B;AqFph7DC;EACC,kBAAA;EACA,qBAAA;ArFsh7DF;AqFnh7DC;EACC,aAAA;ArFqh7DF;;AqFjh7DA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;ArFoh7DD;;AqF/g7DC;EACC,cAAA;ArFkh7DF;AqF/g7DC;EACC,yBAAA;EACA,aAAA;ArFih7DF;;AqFxg7DI;EACC,yBAAA;ArF2g7DL;AqFxg7DI;EACC,yBAAA;ArF0g7DL;;AqF5/6DC;;;;EACC,+C1EvgCkD;E0EwgClD,+DAAA;ArFkg7DF;AqF//6DG;;;;EACC,0C1E1gCgD;AX8g9DpD;AqFhg7DE;;;;EACC,+B1E/gCiD;AXoh9DpD;AqFhg7DE;;;;EACC,+B1ErhCiD;AX0h9DpD;AqFng7DG;;;;EACC,qD1EjiC4C;AXyi9DhD;AqFpg7DI;;;;EACC,cAAA;ArFyg7DL;AqFtg7DI;;;;EACC,qD1E1iC2C;AXqj9DhD;AqFzg7DK;;;;EACC,cAAA;ArF8g7DN;AqF3g7DK;;;;EACC,qD1EjjC0C;E0EkjC1C,8BAAA;ArFgh7DN;AqF3g7DG;;;;EACC,+B1E/iCgD;E0EgjChD,8BAAA;ArFgh7DJ;AqF7g7DG;;;;EACC,oD1E9jC4C;AXgl9DhD;AqFhh7DI;;;;EACC,oD1EjkC2C;E0EkkC3C,+BAAA;ArFqh7DL;AqF/g7DG;;;;EACC,qD1ExkC4C;AX4l9DhD;AqFlh7DI;;;;EACC,oD1E5kC2C;E0E6kC3C,+BAAA;ArFuh7DL;AqFjh7DG;;;;EACC,+B1EzkCgD;AX+l9DpD;AqFph7DI;;;;EACC,qDAAA;ArFyh7DL;AqFth7DI;;;;EACC,oD1E3lC2C;AXsn9DhD;AqFzh7DK;;;;EACC,0EAAA;ArF8h7DN;AqF1h7DI;;;;EACC,qD1ElmC2C;AXio9DhD;AqFzh7DK;;;;EACC,wCAAA;ArF8h7DN;AqF1h7DM;;;;EACC,0EAAA;ArF+h7DP;AqF3h7DK;;;;EACC,qD1EnnC0C;AXmp9DhD;AqF9h7DM;;;;EACC,2EAAA;ArFmi7DP;AqF1h7DE;;;;EACC,+C1EznCiD;AXwp9DpD;AqFvh7DM;;;;EACC,2C1E7oCyC;AXyq9DhD;AqFvh7DI;;;;EACC,UAAA;ArF4h7DL;AqFzh7DM;;;;EACC,yBAAA;EACA,kCAAA;ArF8h7DP;AqFxh7DO;;;;EACC,qD1E3pCwC;AXwr9DhD;AqF3h7DQ;;;;EACC,cAAA;ArFgi7DT;AqF1h7DK;;;;EACC,qBAAA;EACA,MAAA;EACA,6BAAA;ArF+h7DN;AqFph7DO;;;;EACC,+C1E5qC4C;AXqs9DpD;AqFhh7DC;;;;EACC,+B1ElrCkD;AXus9DpD;;AqFjh7DA;EACC,2EAAA;ArFoh7DD;;AqF7g7DA;EACC,0EAAA;ArFgh7DD;;AqFzg7DA;EACC,wEAAA;ArF4g7DD;;AqFrg7DA;EACC,wEAAA;ArFwg7DD;;AqFhg7DA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;ArFmg7DD;;AqF//6DC;EACC,0DAAA;ArFkg7DF;;AqF7/6DC;EACC,0DAAA;ArFgg7DF;;AqF3/6DC;EACC,0DAAA;ArF8/6DF;;AqFz/6DC;EACC,0DAAA;ArF4/6DF;;AqFv/6DC;EACC,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,wBAAA;ArF0/6DF;AqFv/6DC;EAGE;IACC,iB1EjzC8C;EXwy9DhD;EqFp/6DC;IACC,U1ErzC8C;EX2y9DhD;EqFn/6DC;IACC,U1EzzC8C;EX8y9DhD;EqFh/6DC;IACC,W1Eh0C8C;EXkz9DhD;EqF/+6DC;IACC,W1Ep0C8C;EXqz9DhD;AACF;AqF7+6DC;EACC;IACC,qEAAA;ErF++6DD;EqF1+6DA;IACC,YAAA;IACA,sB1EvuB2B;EXmt8D5B;EqFz+6DA;IACC,+BAAA;IACA,gBAAA;ErF2+6DD;EqFx+6DA;IACC,uCAAA;IAGA,yBAAA;ErFw+6DD;EqFr+6DA;IACC,uCAAA;IAGA,yBAAA;IACA,SAAA;IACA,sB1E5vB2B;I0E6vB3B,yBAAA;ErFq+6DD;EqFn+6DC;IACC,QAAA;ErFq+6DF;EqFh+6DC;IACC,+BAAA;ErFk+6DF;EqF/96DC;IACC,uCAAA;ErFi+6DF;EqF596DC;IACC,uCAAA;ErF896DF;EqFv96DC;IACC,8BAAA;ErFy96DF;EqFt96DC;IACC,SAAA;ErFw96DF;EqFr96DC;IACC,sCAAA;ErFu96DF;EqFl96DC;IACC,sCAAA;ErFo96DF;EqF786DC;IACC,8BAAA;ErF+86DF;EqF586DC;IACC,sCAAA;ErF886DF;EqFz86DC;IACC,sCAAA;ErF286DF;AACF;AqFr86DC;EACC,2BAAA;EACA,4BAAA;ArFu86DF;AqFr86DE;EACC,4BAAA;EACA,6BAAA;ArFu86DH;;AsFp49DI;EACI,cAAA;AtFu49DR;AsFp49DI;EAEI;;;;;;;IAEI,cAAA;IACA,cAAA;EtF049DV;EsFv49DM;IACI,kBAAA;EtFy49DV;AACF;AsFt49DI;EACI,4BAAA;AtFw49DR;AsFt49DQ;EAHJ;IAIQ,kB3EukBkB;EXk08D5B;AACF;AsFt49DI;EACI,+B3EuFM;E2EtFN,+BAAA;EACA,yBAAA;EACA,4C3E+B2C;E2E9B3C,gB3E4D2C;E2E3D3C,eAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AtFw49DR;AsFt49DQ;EACI;IACI,UAAA;EtFw49Dd;AACF;AsFr49DQ;EACI,mBAAA;AtFu49DZ;AsFr49DY;EACI,eAAA;AtFu49DhB;AsFp49DoB;EACI,qBAAA;AtFs49DxB;AsFn49DoB;EAEI,yC3E0DK;AX009D7B;AsF/39DY;EACI,kC3EmDM;E2ElDN,uBAAA;AtFi49DhB;AsF/39DgB;EACI,cAAA;AtFi49DpB;AsF939DgB;EACI,yC3E4CS;AXo19D7B;AsF/39DoB;EACI,yC3E0CK;AXu19D7B;AsF/39DoB;EACI,yC3EuCK;E2EtCL,6BAAA;AtFi49DxB;AsF739DgB;EACI,yC3EiCS;AX819D7B;AsF739DoB;EACI,yC3E8BK;E2E7BL,6BAAA;AtF+39DxB;AsF539DoB;EACI,yC3EyBK;AXq29D7B;AsFz39DoB;EACI,yC3EmBK;E2ElBL,6BAAA;AtF239DxB;AsFr39DgB;EACI,UAAA;EACA,mCAAA;AtFu39DpB;AsFl39DgB;EACI,eAAA;AtFo39DpB;AsF/29DQ;EACI,aAAA;AtFi39DZ;AsF529DQ;EACI,kBAAA;AtF829DZ;AsF529DY;EACI,WAAA;EACA,kCAAA;AtF829DhB;AsF129DgB;EACI,aAAA;AtF429DpB;AsFv29DgB;EACI,yC3EvBS;AXg49D7B;AsFv29DoB;EACI,yC3E1BK;E2E2BL,6BAAA;AtFy29DxB;AsFt29DoB;EACI,yC3E/BK;AXu49D7B;AsFp29DgB;EACI;IACI,cAAA;IACA,uBAAA;EtFs29DtB;AACF;AsFl29DY;EACI,yC3E5Ca;AXg59D7B;AsF/19DI;EACI,kBAAA;EACA,gB3ExG2C;E2EyG3C,iBAAA;EACA,4C3E3G2C;E2E4G3C,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,a3E8+B4B;E2E7+B5B,sCAAA;EACA,4BAAA;EACA,sCAAA;EACA,qB3EycsB;E2ExctB,aAAA;AtFi29DR;AsF/19DQ;EACI,MAAA;EACA,UAAA;AtFi29DZ;AsF719DI;EACI,YAAA;AtF+19DR;AsF519DI;EACI,aAAA;AtF819DR;AsF319DI;EACI,sBAAA;EACA,WAAA;AtF619DR;AsF119DI;EACI;IACI,aAAA;EtF419DV;EsFp19DU;IACI,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;EtFy19Dd;EsFv19Dc;IACI,sBAAA;EtFy19DlB;EsFv19DkB;IACI,oB3EjM0B;EX0h+DhD;EsFt19DkB;IACI,qBAAA;EtFw19DtB;EsFn19DU;IACI,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,OAAA;IACA,eAAA;IACA,cAAA;EtFq19Dd;EsFn19Dc;IACI,cAAA;EtFq19DlB;EsFj19DU;IACI,kBAAA;EtFm19Dd;EsFh19DU;IACI,UAAA;EtFk19Dd;EsF/09DU;IACI,WAAA;EtFi19Dd;AAtCF;;AsFhy9DgB;EACI,aAAA;AtF009DpB;AsFv09DgB;EACI,cAAA;AtFy09DpB;;AsF7z9DgB;EACI,oCAAA;AtFg09DpB;AsFxz9DoB;EACI,qCAAA;AtF0z9DxB;;AuF5l+DI;EACI,iBAAA;EACA,Y5EuE2C;E4EtE3C,U5EqE2C;AX0h+DnD;AuF7l+DQ;EACI,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qDAAA;EACA,gB5E+qBkB;AXg78D9B;AuF7l+DY;EACI,wBAAA;AvF+l+DhB;AuF5l+DY;EACI,aAAA;AvF8l+DhB;AuF1l+DQ;EACI,0BAAA;AvF4l+DZ;AuF1l+DY;EAHJ;IAIQ,iBAAA;EvF6l+Dd;AACF;AuF3l+DY;EACI,aAAA;AvF6l+DhB;AuFzl+DgB;EACI,yBAAA;EACA,uBAAA;AvF2l+DpB;AuFtl+DgB;EACI,yBAAA;EACA,uBAAA;AvFwl+DpB;AuFll+DoB;EACI,SAAA;AvFol+DxB;AuFll+DwB;EACI,WAAA;EACA,UAAA;AvFol+D5B;AuF7k+DgB;EACI,yC5EtC8B;AXqn+DlD;AuF7k+DoB;EACI,gD5EvC0B;AXsn+DlD;AuFzk+DQ;EACI,UAAA;AvF2k+DZ;AuFvk+DI;EACI,+BAAA;AvFyk+DR;AuFvk+DQ;EAHJ;IAIQ,iB5ERuC;EXkl+DjD;AACF;AuFvk+DI;EACI,W5Eb2C;E4Ec3C,sD5EhB2C;E4EiB3C,YAAA;EACA,WAAA;EACA,4C5Ef2C;E4EgB3C,MAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AvFyk+DR;AuFvk+DQ;EACI,kBAAA;EACA,gBAAA;AvFyk+DZ;AuFtk+DgB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AvFwk+DpB;AuFnk+DQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yC5E3FsC;E4E4FtC,UAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AvFqk+DZ;AuFnk+DY;EACI,WAAA;EACA,yC5EvGkC;AX4q+DlD;AuFlk+DY;EACI,0CAAA;EACA,c5E+CH;AXqh+Db;AuFlk+DgB;EACI,c5E4CP;E4E3CO,6BAAA;AvFok+DpB;AuF9j+DI;EACI,aAAA;AvFgk+DR;AuF7j+DI;EAGQ;IACI,cAAA;EvF6j+Dd;EuF1j+DU;IACI,aAAA;EvF4j+Dd;AACF;AuFrj+DgB;EACI,aAAA;AvFuj+DpB;AuFpj+DgB;EACI,cAAA;AvFsj+DpB;AuF/i+DQ;EACI,2D5ElGsC;AXmp+DlD;AuF/i+DY;EACI,+C5ElGkC;AXmp+DlD;AuF/i+DgB;EACI,sD5EpG8B;E4EqG9B,8D5EpG8B;AXqp+DlD;AuF5i+DQ;EACI,kD5E9GsC;E4E+GtC,oD5E9GsC;AX4p+DlD;AuF3i+DgB;EACI,cAAA;AvF6i+DpB;AuF1i+DgB;EACI,aAAA;AvF4i+DpB;AuFti+DoB;EACI,+C5E5H0B;AXoq+DlD;AuF7h+DwB;EAEI,sD5ExIsB;AXsq+DlD;AuF5h+D4B;EACI,4EAAA;AvF8h+DhC;AuFvh+DoB;EACI,sD5EnJ0B;AX4q+DlD;AuFvh+DwB;EACI,iE5EtJsB;AX+q+DlD;AuFth+DwB;EACI,iEAAA;AvFwh+D5B;AuF/g+DQ;EACI,2D5ExKsC;AXyr+DlD;AuF/g+DY;EACI,+B5EnKkC;AXor+DlD;AuF/g+DgB;EACI,sD5E1K8B;E4E2K9B,8D5E1K8B;AX2r+DlD;AuF5g+DQ;EACI,kD5EpLsC;E4EqLtC,oD5EpLsC;AXks+DlD;AuF3g+DgB;EACI,cAAA;AvF6g+DpB;AuF1g+DgB;EACI,aAAA;AvF4g+DpB;AuFtg+DoB;EACI,+B5E7L0B;AXqs+DlD;AuF7/9DwB;EAEI,sD5E9MsB;AX4s+DlD;AuF5/9D4B;EACI,4EAAA;AvF8/9DhC;AuFv/9DoB;EACI,sD5EzN0B;AXkt+DlD;AuFv/9DwB;EACI,iE5E5NsB;AXqt+DlD;AuFt/9DwB;EACI,iEAAA;AvFw/9D5B;AuFh/9DY;EACI,2B5E9JL;AXgp+DX;AuF5+9DQ;EACI,QAAA;EACA,eAAA;AvF8+9DZ;AuF5+9DY;EAJJ;IAKQ,aAAA;EvF++9Dd;AACF;AuF5+9DQ;;EAEI,aAAA;AvF8+9DZ;AuF3+9DQ;EACI,iB5EvQuC;AXov+DnD;AuF1+9DQ;;EAEI,U5E5QuC;AXwv+DnD;AuFz+9DQ;EACI;IACI,cAAA;EvF2+9Dd;EuFx+9DU;;IAEI,OAAA;EvF0+9Dd;AACF;AuFn+9DQ;EAFJ;;IAGQ,U5E/RuC;EXsw+DjD;AACF;AuFp+9DI;EACI;IACI,cAAA;EvFs+9DV;EuFn+9DM;;IAEI,OAAA;EvFq+9DV;AACF;;AwFx1+DC;EACC,yC7E0HsB;AXiu+DxB;AwFx1+DC;EACC,iB7EqHsB;E6EpHtB,cAAA;EACA,4C7E2nB4B;E6E1nB5B,mCAAA;AxF01+DF;AwFt1+DE;EACC,iBAAA;AxFw1+DH;AwFp1+DC;;EAEC,iB7EuGsB;E6EtGtB,cAAA;EACA,kBAAA;AxFs1+DF;AwFh1+DG;EACC;IACC,kBAAA;ExFk1+DH;AACF;AwF90+DI;EADD;IAEE,cAAA;ExFi1+DH;AACF;AwF70+DE;;;EAEC,kBAAA;EACA,8BAAA;AxFg1+DH;AwF90+DG;EALD;;;IAME,qBAAA;ExFm1+DF;AACF;AwF70+DE;;;EAEC,+BAAA;AxFg1+DH;AwF90+DG;EAJD;;;IAKE,sBAAA;ExFm1+DF;AACF;AwF90+DE;;EAEC,+BAAA;AxFg1+DH;AwF90+DG;EAJD;;IAKE,sBAAA;ExFk1+DF;AACF;AwF30+DE;EACC,mCAAA;AxF60+DH;AwF10+DE;EACC;IACC,iBAAA;IACA,gBAAA;ExF40+DF;EwFz0+DC;IACC,iBAAA;ExF20+DF;AACF;AwFp0+DG;;;;;EAEC,eAAA;EACA,kBAAA;AxFy0+DJ;;AwFh0+DC;;;EAGC,eAAA;AxFm0+DF;AwFh0+DC;;EAEC,iB7EMsB;AX4z+DxB;AwF/z+DC;EACC,6BAAA;AxFi0+DF;AwF3z+DE;;;;EAEC,kBAAA;AxF+z+DH;;AwFvz+DC;EACC;;IAEC,kBAAA;ExF0z+DD;EwFpz+DC;;IAEC,kBAAA;ExFwz+DF;AALF;;AwF1y+DC;EACC;IACC,aAAA;ExFmz+DD;EwFhz+DA;IACC,qBAAA;IACA,WAAA;ExFkz+DD;EwF/y+DA;IACC,OAAA;ExFiz+DD;EwF9y+DA;IACC,OAAA;ExFgz+DD;EwF7y+DA;IACC,gBAAA;ExF+y+DD;EwF1y+DC;IACC,gBAAA;IACA,iBAAA;ExF4y+DF;EwFxy+DE;IACC,qBAAA;ExF0y+DH;EwFvy+DE;IACC,aAAA;ExFyy+DH;AACF;AwF7x+DE;;;;;EACC,qBAAA;AxFmy+DH;AwFhy+DE;;;;;EACC,aAAA;AxFsy+DH;AwF1x+DE;;;;;;EACC,aAAA;AxFiy+DH;AwF9x+DE;;;;;;EACC,cAAA;AxFqy+DH;AwFjy+DC;EACC;IACC,aAAA;ExFmy+DD;EwFhy+DA;IACC,qBAAA;IACA,WAAA;ExFky+DD;EwF/x+DA;IACC,wBAAA;ExFiy+DD;EwF9x+DA;IACC,wBAAA;ExFgy+DD;EwF7x+DA;IACC,gBAAA;ExF+x+DD;EwF1x+DC;IACC,gBAAA;IACA,iBAAA;ExF4x+DF;EwFxx+DE;IACC,qBAAA;ExF0x+DH;EwFvx+DE;IACC,aAAA;ExFyx+DH;AACF;;AyFvi/DA;;;;;;uDAAA;AAOC;EACG,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,wCAAA;AzF0i/DJ;;AyFxi/DE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EAIA,qJAAA;EAIA,6BAAA;EAIA,uCAAA;EAKA,mCAAA;EACA,oBAAA;AzF2i/DJ;;AyFzi/DE;EACE,oCAAA;EAIA,6KAAA;AzF4i/DJ;;AyF1i/DE;EACE,8BAAA;AzF6i/DJ;;AyF3i/DE;EACE,oCAAA;AzF8i/DJ;;AyF5i/DE;EAIE,2BAAA;AzF+i/DJ;;AyF7i/DE;;EAME,wBAAA;EACA,2EAAA;AzFgj/DJ;;AyF9i/DE;;;;EAIE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AzFij/DJ;;AyF/i/DE;EACE,qBAAA;EACA,oBAAA;AzFkj/DJ;;AyFhj/DE;EACE,SAAA;EACA,qBAAA;AzFmj/DJ;;AyFjj/DE;EACE,oBAAA;EACA,sBAAA;AzFoj/DJ;;AyFlj/DE;EACE,UAAA;AzFqj/DJ;;AyFnj/DE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AzFsj/DJ;;AyFpj/DE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AzFuj/DJ;;AyFrj/DE;EACE,wBAAA;EAEA,iDAAA;EAIA,qBAAA;AzFwj/DJ;;AyFtj/DE;EAEE,+CAAA;AzFyj/DJ;;AyFvj/DE;EACE,cAAA;AzF0j/DJ;;AyFtj/DI;EACI,0CAAA;AzFyj/DR;;AyFpj/DI;EACI,yCAAA;AzFuj/DR;;AyFnj/DI;EACI,yCAAA;AzFsj/DR;;AyFlj/DI;EACI,yCAAA;AzFqj/DR;;AyFjj/DI;EACI,wCAAA;AzFoj/DR;;AyFhj/DI;EACI,yCAAA;AzFmj/DR;;A0Fpt/DA;EACI,cAAA;EACA,aAAA;A1Fut/DJ;;A0Fpt/DA;EACI,YAAA;EACA,WAAA;A1Fut/DJ;;A0Fpt/DA;EACI,YAAA;EACA,WAAA;A1Fut/DJ;;A0Fpt/DA;EACI,cAAA;EACA,aAAA;A1Fut/DJ;;A0Fpt/DA;EACI,YAAA;EACA,WAAA;A1Fut/DJ;;A0Fpt/DA;EACI,cAAA;EACA,aAAA;A1Fut/DJ;;A0Fpt/DA;EACI,mBAAA;EACA,yB/EoJS;E+EnJT,W/EqHO;E+EpHP,aAAA;EACA,gB/E4FiB;E+E3FjB,YAAA;EACA,uBAAA;EACA,WAAA;A1Fut/DJ;;A0Fnt/DA;EACI,kBAAA;EACA,aAAA;EACA,eAAA;A1Fst/DJ;A0Fpt/DI;EACI,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,oBAAA;A1Fst/DR;A0Fpt/DQ;EACI,kBAAA;EACA,2BAAA;EACA,UAAA;A1Fst/DZ;;A2F7w/DI;EACI,gBhF6Ha;AXmp/DrB;A2F7w/DI;EACI,chFsJG;AXyn/DX;A2F1w/DY;EACI,WAAA;EACA,iCAAA;A3F4w/DhB;A2Fxw/DgB;EACI,WAAA;A3F0w/DpB;;A2F/v/DQ;EACI,iCAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;A3Fkw/DZ;A2F9v/DY;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;A3Fgw/DhB;;A2Ftv/DQ;EACI,iCAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;A3Fyv/DZ;A2Frv/DY;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;A3Fuv/DhB;;A2F7u/DI;EACI,qBAAA;A3Fgv/DR;A2F9u/DQ;EACI,kBAAA;EACA,ahFmyC8B;EgFlyC9B,SAAA;A3Fgv/DZ;A2F5u/DY;EACI,SAAA;A3F8u/DhB;;A2Fru/DI;EACI,4CAAA;EACA,sBhFyhBsB;AX+s+D9B;A2Ftu/DQ;EACI,eAAA;A3Fwu/DZ;A2Fru/DQ;EACI,sBhFkhBkB;AXqt+D9B;A2Fru/DY;EACI,4BAAA;EACA,6BAAA;A3Fuu/DhB;;A2Fhu/DI;EACI,6CAAA;A3Fmu/DR;;A2F1t/DQ;EACI,qCAAA;A3F6t/DZ;A2F3t/DY;EACI,gBAAA;A3F6t/DhB;A2F3t/DgB;EACI,chFyFL;EgFxFK,oDAAA;A3F6t/DpB;A2F1t/DgB;EACI,chFoFL;AXwo/Df;;A2Fpt/DY;EACI,gBAAA;A3Fut/DhB;A2Frt/DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fut/DpB;;A2Fhv/DQ;EACI,oCAAA;A3Fmv/DZ;A2Fjv/DY;EACI,gBAAA;A3Fmv/DhB;A2Fjv/DgB;EACI,chFyFL;EgFxFK,mDAAA;A3Fmv/DpB;A2Fhv/DgB;EACI,chFoFL;AX8p/Df;;A2F1u/DY;EACI,gBAAA;A3F6u/DhB;A2F3u/DgB;EACI,WhFCT;EgFAS,oCAAA;A3F6u/DpB;;A2Ftw/DQ;EACI,qCAAA;A3Fyw/DZ;A2Fvw/DY;EACI,gBAAA;A3Fyw/DhB;A2Fvw/DgB;EACI,chFyFL;EgFxFK,oDAAA;A3Fyw/DpB;A2Ftw/DgB;EACI,chFoFL;AXor/Df;;A2Fhw/DY;EACI,gBAAA;A3Fmw/DhB;A2Fjw/DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fmw/DpB;;A2F5x/DQ;EACI,qCAAA;A3F+x/DZ;A2F7x/DY;EACI,gBAAA;A3F+x/DhB;A2F7x/DgB;EACI,chFyFL;EgFxFK,oDAAA;A3F+x/DpB;A2F5x/DgB;EACI,chFoFL;AX0s/Df;;A2Ftx/DY;EACI,gBAAA;A3Fyx/DhB;A2Fvx/DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fyx/DpB;;A2Flz/DQ;EACI,oCAAA;A3Fqz/DZ;A2Fnz/DY;EACI,gBAAA;A3Fqz/DhB;A2Fnz/DgB;EACI,chFyFL;EgFxFK,mDAAA;A3Fqz/DpB;A2Flz/DgB;EACI,chFoFL;AXgu/Df;;A2F5y/DY;EACI,gBAAA;A3F+y/DhB;A2F7y/DgB;EACI,WhFCT;EgFAS,oCAAA;A3F+y/DpB;;A2Fx0/DQ;EACI,qCAAA;A3F20/DZ;A2Fz0/DY;EACI,gBAAA;A3F20/DhB;A2Fz0/DgB;EACI,chFyFL;EgFxFK,oDAAA;A3F20/DpB;A2Fx0/DgB;EACI,chFoFL;AXsv/Df;;A2Fl0/DY;EACI,gBAAA;A3Fq0/DhB;A2Fn0/DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fq0/DpB;;A2F91/DQ;EACI,sCAAA;A3Fi2/DZ;A2F/1/DY;EACI,gBAAA;A3Fi2/DhB;A2F/1/DgB;EACI,chFyFL;EgFxFK,qDAAA;A3Fi2/DpB;A2F91/DgB;EACI,chFoFL;AX4w/Df;;A2Fx1/DY;EACI,gBAAA;A3F21/DhB;A2Fz1/DgB;EACI,WhFCT;EgFAS,oCAAA;A3F21/DpB;;A2Fp3/DQ;EACI,mCAAA;A3Fu3/DZ;A2Fr3/DY;EACI,gBAAA;A3Fu3/DhB;A2Fr3/DgB;EACI,chFyFL;EgFxFK,kDAAA;A3Fu3/DpB;A2Fp3/DgB;EACI,chFoFL;AXky/Df;;A2F92/DY;EACI,gBAAA;A3Fi3/DhB;A2F/2/DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fi3/DpB;;A2Fr2/DQ;EACI,8CAAA;A3Fw2/DZ;A2Fv2/DY;EACI,0DAAA;A3Fy2/DhB;A2Fr2/DQ;EACI,0DAAA;A3Fu2/DZ;;A2F/1/DQ;EACI,yBAAA;A3Fk2/DZ;;A4FlhgEE;EACE,0BAAA;A5FqhgEJ;;A4FthgEE;EACE,0BAAA;A5FyhgEJ;;A4F1hgEE;EACE,0BAAA;A5F6hgEJ;;A4F9hgEE;EACE,0BAAA;A5FiigEJ;;A4FligEE;EACE,0BAAA;A5FqigEJ;;A4FtigEE;EACE,0BAAA;A5FyigEJ;;A4F1igEE;EACE,0BAAA;A5F6igEJ;;A4F9igEE;EACE,0BAAA;A5FijgEJ;;A4FljgEE;EACE,0BAAA;A5FqjgEJ;;A4FtjgEE;EACE,0BAAA;A5FyjgEJ;;A4F1jgEE;EACE,0BAAA;A5F6jgEJ;;A4F9jgEE;EACE,0BAAA;A5FikgEJ;;A4FlkgEE;EACE,0BAAA;A5FqkgEJ;;A4FtkgEE;EACE,0BAAA;A5FykgEJ;;A4F1kgEE;EACE,0BAAA;A5F6kgEJ;;A4F9kgEE;EACE,0BAAA;A5FilgEJ;;A4FllgEE;EACE,0BAAA;A5FqlgEJ;;A4FhlgEA;EACI,uCAAA;A5FmlgEJ;;A4FjlgEA;EACI,wCAAA;A5FolgEJ;;A4F9kgEI;EACI,+BAAA;A5FilgER;;A4F/kgEI;EACI,mCAAA;A5FklgER;;A4FhlgEI;EACI,sCAAA;A5FmlgER;;A4FjlgEI;EACI,qCAAA;A5FolgER;;A4FllgEI;EACI,oCAAA;A5FqlgER;;A4FhlgEQ;EACI,uBAAA;A5FmlgEZ;A4FllgEY;EACI,+BAAA;A5FolgEhB;;A4FzmgEI;EACI,+BAAA;A5F4mgER;;A4F1mgEI;EACI,mCAAA;A5F6mgER;;A4F3mgEI;EACI,sCAAA;A5F8mgER;;A4F5mgEI;EACI,qCAAA;A5F+mgER;;A4F7mgEI;EACI,oCAAA;A5FgngER;;A4F3mgEQ;EACI,uBAAA;A5F8mgEZ;A4F7mgEY;EACI,+BAAA;A5F+mgEhB;;A4FpogEI;EACI,+BAAA;A5FuogER;;A4FrogEI;EACI,mCAAA;A5FwogER;;A4FtogEI;EACI,sCAAA;A5FyogER;;A4FvogEI;EACI,qCAAA;A5F0ogER;;A4FxogEI;EACI,oCAAA;A5F2ogER;;A4FtogEQ;EACI,uBAAA;A5FyogEZ;A4FxogEY;EACI,+BAAA;A5F0ogEhB;;A4F/pgEI;EACI,+BAAA;A5FkqgER;;A4FhqgEI;EACI,mCAAA;A5FmqgER;;A4FjqgEI;EACI,sCAAA;A5FoqgER;;A4FlqgEI;EACI,qCAAA;A5FqqgER;;A4FnqgEI;EACI,oCAAA;A5FsqgER;;A4FjqgEQ;EACI,uBAAA;A5FoqgEZ;A4FnqgEY;EACI,+BAAA;A5FqqgEhB;;A4F1rgEI;EACI,8BAAA;A5F6rgER;;A4F3rgEI;EACI,kCAAA;A5F8rgER;;A4F5rgEI;EACI,qCAAA;A5F+rgER;;A4F7rgEI;EACI,oCAAA;A5FgsgER;;A4F9rgEI;EACI,mCAAA;A5FisgER;;A4F5rgEQ;EACI,uBAAA;A5F+rgEZ;A4F9rgEY;EACI,8BAAA;A5FgsgEhB;;A4FrtgEI;EACI,+BAAA;A5FwtgER;;A4FttgEI;EACI,mCAAA;A5FytgER;;A4FvtgEI;EACI,sCAAA;A5F0tgER;;A4FxtgEI;EACI,qCAAA;A5F2tgER;;A4FztgEI;EACI,oCAAA;A5F4tgER;;A4FvtgEQ;EACI,uBAAA;A5F0tgEZ;A4FztgEY;EACI,+BAAA;A5F2tgEhB;;A4FhvgEI;EACI,8BAAA;A5FmvgER;;A4FjvgEI;EACI,kCAAA;A5FovgER;;A4FlvgEI;EACI,qCAAA;A5FqvgER;;A4FnvgEI;EACI,oCAAA;A5FsvgER;;A4FpvgEI;EACI,mCAAA;A5FuvgER;;A4FlvgEQ;EACI,uBAAA;A5FqvgEZ;A4FpvgEY;EACI,8BAAA;A5FsvgEhB;;A4F9ugEI;EACI,gCAAA;A5FivgER;A4FhvgEQ;EACI,gDAAA;A5FkvgEZ;;A4F1ugEA;EACI,sCjFknB0B;AX2n/D9B;;A4F1ugEA;EACI,oCjFvD8C;AXoygElD;;A4FxugEA;EACI,gBjFyDiB;AXkrgErB;;A4FtugEA;EACI,SAAA;A5FyugEJ;;A4FpugEA;EACI,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cjFmEO;EiFlEP,kBAAA;EACA,oBAAA;A5FuugEJ;A4FrugEI;EACI,cjF+DG;EiF9DH,yBjF0DG;AX6qgEX;;A4FjugEA;EACI,yDAAA;A5FougEJ;;A4FhugEA;EACI,eAAA;A5FmugEJ;;A4FhugEA;EACI,eAAA;A5FmugEJ;;A4FhugEA;EACI,gBAAA;A5FmugEJ;;A4FhugEA;EACI,gBAAA;A5FmugEJ;;A4FhugEA;EACI,gBAAA;A5FmugEJ;;A4F/tgEA;EACI,YAAA;EACA,WAAA;A5FkugEJ;;A4F/tgEA;EACI,YAAA;EACA,WAAA;A5FkugEJ;;A4F/tgEA;EACI,YAAA;EACA,WAAA;A5FkugEJ;;A4F/tgEA;EACI,YAAA;EACA,WAAA;A5FkugEJ;;A4F/tgEA;EACI,YAAA;EACA,WAAA;A5FkugEJ;;A4F/tgEA;EACI,YAAA;EACA,WAAA;A5FkugEJ;;A4F9tgEA;EACI,cjFHO;EiFIP,+BAAA;A5FiugEJ;;A4F5tgEI;EACI,cjFwDO;EiFvDP,8BAAA;A5F+tgER;;A4FjugEI;EACI,cjFwDO;EiFvDP,6BAAA;A5FougER;;A4FtugEI;EACI,cjFwDO;EiFvDP,8BAAA;A5FyugER;;A4F3ugEI;EACI,cjFwDO;EiFvDP,8BAAA;A5F8ugER;;A4FhvgEI;EACI,cjFwDO;EiFvDP,6BAAA;A5FmvgER;;A4FrvgEI;EACI,cjFwDO;EiFvDP,8BAAA;A5FwvgER;;A4F1vgEI;EACI,cjFwDO;EiFvDP,+BAAA;A5F6vgER;;A4F/vgEI;EACI,cjFwDO;EiFvDP,4BAAA;A5FkwgER;;A4F7vgEA;EACI,kBAAA;A5FgwgEJ;A4F/vgEI;EACI,kBAAA;A5FiwgER;A4F/vgEI;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cjF5BG;AX6xgEX;;A4F1vgEA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,sBjFxCO;AXqygEX;;A4FxvgEA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;A5F2vgEJ;;A4FvvgEA;EACI,wBAAA;UAAA,gBAAA;A5F0vgEJ;;A4FvvgEA;EACI,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,+BAAA;A5F0vgEJ;;A4FrvgEI;EAFJ;IAGQ,aAAA;IACA,0BAAA;IACA,aAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;IACA,aAAA;E5FyvgEN;E4FxvgEM;IACI,eAAA;IACA,MAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,uCAAA;E5F0vgEV;E4FvvgEM;IACI,eAAA;IACA,YAAA;IACA,iBAAA;E5FyvgEV;E4FvvgEM;IACI,gBAAA;IACA,+BAAA;E5FyvgEV;AACF;;A4FpvgEI;EACI;IACI,6BAAA;IACA,eAAA;IACA,6BAAA;E5FuvgEV;AACF;;A4FlvgEA;EACI,iBAAA;A5FqvgEJ;;A4FjvgEA;EACI,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EACA,mBAAA;A5FovgEJ;;A4FhvgEA;EACI,yBAAA;A5FmvgEJ;A4FlvgEI;EACI,cjFhIG;AXo3gEX;A4FlvgEI;EACI,yBAAA;A5FovgER;A4FnvgEQ;EACI,cjFxGC;AX61gEb;A4FnvgEY;EACI,gBAAA;A5FqvgEhB;;A4F/ugEA;EACI,kCAAA;A5FkvgEJ;;A4F/ugEA;EACI,iCAAA;A5FkvgEJ;;A4F9ugEI;EACI,kDAAA;A5FivgER;;A4F5ugEA;EACI,eAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;A5F+ugEJ;A4F9ugEI;EACI,uCAAA;A5FgvgER;;A4F5ugEA;EACE;IACE,wBAAA;IACA,UAAA;E5F+ugEF;E4F5ugEA;IACE,4BAAA;IACA,UAAA;E5F8ugEF;AACF;A4F3ugEA;EACI,eAAA;A5F6ugEJ;;A6F/jhEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,aAAA;A7FkkhEJ;;A6F/jhEA;EACI,UAAA;EACA,kBAAA;A7FkkhEJ;;A6F/jhEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;A7FkkhEJ;;A8FtlhEI;EACI,gBAAA;A9FylhER;;A+F1lhEI;EACI,+CAAA;EACA,iBAAA;A/F6lhER;A+F3lhEQ;EACI,iBAAA;A/F6lhEZ;;A+FtlhEA,aAAA;AAEA;EACI,gBAAA;A/FwlhEJ;A+FtlhEI;EACI,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;A/FwlhER;A+FtlhEQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBpFoHD;AXo+gEX;A+FrlhEQ;EACI,yBAAA;A/FulhEZ;;A+FjlhEA;EACI,kBAAA;A/FolhEJ;A+FllhEI;EACI,gBAAA;EACA,kBAAA;A/FolhER;A+FllhEQ;EAEI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yCAAA;EACA,SAAA;EACA,wBAAA;EACA,SAAA;EACA,oBAAA;A/FmlhEZ;A+FhlhEQ;EACI,UAAA;EACA,UAAA;EACA,oBAAA;A/FklhEZ;A+F5khEY;EACI,UAAA;A/F8khEhB;A+F3khEY;EACI,UAAA;A/F6khEhB;;A+FpkhEQ;EACI,yBpFkGC;AXq+gEb;;A+FlkhEA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;A/FqkhEJ;;A+F/jhEQ;EACI,aAAA;A/FkkhEZ;A+F/jhEQ;EACI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,oBAAA;EACA,iBAAA;EACA,cpF2DC;AXsghEb;A+F9jhEQ;EACI,yBpFuDC;EoFtDD,qBpFsDC;EoFrDD,WpFuBD;AXyihEX;;AgG9rhEA;EACI,iBAAA;EACA,oBAAA;AhGishEJ;AgG/rhEI;EACI,mBAAA;EACA,gBAAA;AhGishER;;AgG5rhEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;AhG+rhEJ;;AgG3rhEI;EACI,4BAAA;AhG8rhER;;AgGzrhEA;EACI,yBAAA;AhG4rhEJ;AgG1rhEI;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AhG4rhER;AgGzrhEI;EACI,kBAAA;EACA,oBAAA;EACA,YAAA;AhG2rhER;AgGxrhEI;EACI,gBAAA;AhG0rhER;AgGvrhEY;EACI,crFiIH;EqFhIG,qBAAA;AhGyrhEhB;;AgGhrhEI;EACI,yBrFyFG;EqFxFH,gBAAA;EACA,iBAAA;EACA,gBrF8Da;EqF7Db,kBAAA;AhGmrhER;;AgG3qhEQ;EACI,aAAA;AhG8qhEZ;AgG3qhEgB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,yCAAA;AhG6qhEpB;AgG3qhEgB;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,eAAA;EACA,WrFuDT;AXsnhEX;;AgGrqhEI;EACI,gCAAA;AhGwqhER;AgGvqhEQ;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,crFoEC;AXqmhEb;;AgGlqhEQ;EACI,gCAAA;AhGqqhEZ;AgGnqhEQ;EACI,2DAAA;AhGqqhEZ;AgGlqhEQ;EACI,0DAAA;AhGoqhEZ;AgGhqhEY;EACI,qDAAA;AhGkqhEhB;;AiGryhEA;EACI;;;;;;;IAOI,wBAAA;EjGwyhEN;EiGtyhEE;;;;;IAKI,UAAA;IACA,SAAA;EjGwyhEN;EiGryhEE;IACI,SAAA;IACA,2BAAA;EjGuyhEN;EiGnyhEM;IACI,wBAAA;EjGqyhEV;EiGjyhEM;IACI,yBAAA;IACA,qBAAA;IACA,0BAAA;EjGmyhEV;AACF;AkGt0hEA;EACI,kBAAA;AlGw0hEJ;AkGt0hEI;EACI,iBAAA;EACA,+CAAA;EACA,WvFgJG;EuF/IH,oBvF6qBsB;EuF5qBtB,gBvFmrBsB;EuFlrBtB,kBAAA;EACA,UAAA;EACA,QAAA;AlGw0hER;AkGt0hEQ;EACI,4BAAA;AlGw0hEZ;AkGr0hEQ;EACI,qBAAA;AlGu0hEZ;AkGr0hEY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,8BAAA;AlGu0hEhB;AkGp0hEY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;AlGs0hEhB;AkG9zhEQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;AlGg0hEZ;AkG1zhEI;EACI,gBAAA;AlG4zhER;AkG1zhEQ;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AlG4zhEZ;AkGzzhEY;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AlG2zhEhB;AkGpzhEQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AlGszhEZ;AkGpzhEY;EACI,4BAAA;AlGszhEhB;AkGnzhEY;EACI,iBAAA;AlGqzhEhB;AkGnzhEgB;EAEI,WAAA;EACA,WAAA;EACA,8BAAA;AlGozhEpB;AkG9yhEY;EACI,UAAA;EACA,WAAA;AlGgzhEhB;AkG5yhEQ;EACI,WAAA;EACA,UAAA;AlG8yhEZ;AkG1yhEY;EACI,wBAAA;EACA,YAAA;EACA,UAAA;AlG4yhEhB;AkGvyhEY;EACI,UAAA;EACA,WAAA;AlGyyhEhB;AkGvyhEgB;EACI,UAAA;EACA,YAAA;EACA,wBAAA;AlGyyhEpB;AkGlyhEI;EACI,WAAA;AlGoyhER;AkG/xhEQ;EACI,mBAAA;AlGiyhEZ;AkG/xhEY;EACI,uFAAA;AlGiyhEhB;AkG7xhEgB;EACI,0BAAA;EACA,yBAAA;AlG+xhEpB;AkG5xhEgB;EACI,0BAAA;EACA,4BAAA;AlG8xhEpB;AkGxxhEY;EACI,mBAAA;AlG0xhEhB;AkGvxhEoB;EACI,2BAAA;EACA,yBAAA;AlGyxhExB;AkGtxhEoB;EACI,2BAAA;EACA,4BAAA;AlGwxhExB;AkGxzhEQ;EACI,mBAAA;AlG0zhEZ;AkGxzhEY;EACI,oFAAA;AlG0zhEhB;AkGtzhEgB;EACI,0BAAA;EACA,yBAAA;AlGwzhEpB;AkGrzhEgB;EACI,0BAAA;EACA,4BAAA;AlGuzhEpB;AkGjzhEY;EACI,mBAAA;AlGmzhEhB;AkGhzhEoB;EACI,2BAAA;EACA,yBAAA;AlGkzhExB;AkG/yhEoB;EACI,2BAAA;EACA,4BAAA;AlGizhExB;AkGj1hEQ;EACI,mBAAA;AlGm1hEZ;AkGj1hEY;EACI,uFAAA;AlGm1hEhB;AkG/0hEgB;EACI,0BAAA;EACA,yBAAA;AlGi1hEpB;AkG90hEgB;EACI,0BAAA;EACA,4BAAA;AlGg1hEpB;AkG10hEY;EACI,mBAAA;AlG40hEhB;AkGz0hEoB;EACI,2BAAA;EACA,yBAAA;AlG20hExB;AkGx0hEoB;EACI,2BAAA;EACA,4BAAA;AlG00hExB;AkG12hEQ;EACI,mBAAA;AlG42hEZ;AkG12hEY;EACI,mEAAA;AlG42hEhB;AkGx2hEgB;EACI,0BAAA;EACA,yBAAA;AlG02hEpB;AkGv2hEgB;EACI,0BAAA;EACA,4BAAA;AlGy2hEpB;AkGn2hEY;EACI,mBAAA;AlGq2hEhB;AkGl2hEoB;EACI,2BAAA;EACA,yBAAA;AlGo2hExB;AkGj2hEoB;EACI,2BAAA;EACA,4BAAA;AlGm2hExB;AkGn4hEQ;EACI,mBAAA;AlGq4hEZ;AkGn4hEY;EACI,uFAAA;AlGq4hEhB;AkGj4hEgB;EACI,0BAAA;EACA,yBAAA;AlGm4hEpB;AkGh4hEgB;EACI,0BAAA;EACA,4BAAA;AlGk4hEpB;AkG53hEY;EACI,mBAAA;AlG83hEhB;AkG33hEoB;EACI,2BAAA;EACA,yBAAA;AlG63hExB;AkG13hEoB;EACI,2BAAA;EACA,4BAAA;AlG43hExB;AkG55hEQ;EACI,mBAAA;AlG85hEZ;AkG55hEY;EACI,uFAAA;AlG85hEhB;AkG15hEgB;EACI,0BAAA;EACA,yBAAA;AlG45hEpB;AkGz5hEgB;EACI,0BAAA;EACA,4BAAA;AlG25hEpB;AkGr5hEY;EACI,mBAAA;AlGu5hEhB;AkGp5hEoB;EACI,2BAAA;EACA,yBAAA;AlGs5hExB;AkGn5hEoB;EACI,2BAAA;EACA,4BAAA;AlGq5hExB;AkGr7hEQ;EACI,mBAAA;AlGu7hEZ;AkGr7hEY;EACI,0DAAA;AlGu7hEhB;AkGn7hEgB;EACI,0BAAA;EACA,yBAAA;AlGq7hEpB;AkGl7hEgB;EACI,0BAAA;EACA,4BAAA;AlGo7hEpB;AkG96hEY;EACI,mBAAA;AlGg7hEhB;AkG76hEoB;EACI,2BAAA;EACA,yBAAA;AlG+6hExB;AkG56hEoB;EACI,2BAAA;EACA,4BAAA;AlG86hExB;AkG98hEQ;EACI,mBAAA;AlGg9hEZ;AkG98hEY;EACI,6EAAA;AlGg9hEhB;AkG58hEgB;EACI,0BAAA;EACA,yBAAA;AlG88hEpB;AkG38hEgB;EACI,0BAAA;EACA,4BAAA;AlG68hEpB;AkGv8hEY;EACI,mBAAA;AlGy8hEhB;AkGt8hEoB;EACI,2BAAA;EACA,yBAAA;AlGw8hExB;AkGr8hEoB;EACI,2BAAA;EACA,4BAAA;AlGu8hExB;AkG77hEI;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AlG+7hER;AkG9niEA;EAmMI,eAAA;AlG87hEJ;AkG77hEI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlG+7hER;AkG77hEQ;EACI,eAAA;EACA,WvF1DD;EuF2DC,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,wEAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBvFiekB;AX89gE9B;AkG77hEY;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;AlG+7hEhB;AkG57hEY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,oCAAA;AlG87hEhB;AkGr7hEY;EACI,mBAAA;AlGu7hEhB;AkGr7hEgB;EACI,wEAAA;EACA,uEAAA;AlGu7hEpB;AkGp7hEgB;EACI,yEAAA;EACA,uEAAA;AlGs7hEpB;AkGh8hEY;EACI,mBAAA;AlGk8hEhB;AkGh8hEgB;EACI,uEAAA;EACA,sEAAA;AlGk8hEpB;AkG/7hEgB;EACI,wEAAA;EACA,sEAAA;AlGi8hEpB;AkG38hEY;EACI,mBAAA;AlG68hEhB;AkG38hEgB;EACI,uEAAA;EACA,sEAAA;AlG68hEpB;AkG18hEgB;EACI,wEAAA;EACA,sEAAA;AlG48hEpB;AkGt9hEY;EACI,mBAAA;AlGw9hEhB;AkGt9hEgB;EACI,oDAAA;EACA,mDAAA;AlGw9hEpB;AkGr9hEgB;EACI,qDAAA;EACA,mDAAA;AlGu9hEpB;AkGj+hEY;EACI,mBAAA;AlGm+hEhB;AkGj+hEgB;EACI,wEAAA;EACA,uEAAA;AlGm+hEpB;AkGh+hEgB;EACI,yEAAA;EACA,uEAAA;AlGk+hEpB;AkG5+hEY;EACI,mBAAA;AlG8+hEhB;AkG5+hEgB;EACI,wEAAA;EACA,uEAAA;AlG8+hEpB;AkG3+hEgB;EACI,yEAAA;EACA,uEAAA;AlG6+hEpB;AkGv/hEY;EACI,mBAAA;AlGy/hEhB;AkGv/hEgB;EACI,8CAAA;EACA,6CAAA;AlGy/hEpB;AkGt/hEgB;EACI,+CAAA;EACA,6CAAA;AlGw/hEpB;AkGlgiEY;EACI,mBAAA;AlGogiEhB;AkGlgiEgB;EACI,4BAAA;EACA,2BAAA;AlGogiEpB;AkGjgiEgB;EACI,6BAAA;EACA,2BAAA;AlGmgiEpB;;AkGx/hEQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AlG2/hEZ;;AkGt/hEA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AlGy/hEJ;AkGv/hEI;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WvFvIG;EuFwIH,eAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;AlGy/hER;AkGv/hEQ;EAEI,kBAAA;EACA,WAAA;AlGw/hEZ;AkGr/hEQ;EACI,WAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;AlGu/hEZ;AkGp/hEQ;EACI,WAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,0BAAA;AlGs/hEZ;AkGl/hEI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,sBAAA;AlGo/hER;;AkG5+hEQ;EACI,mBAAA;AlG++hEZ;AkG7+hEY;EACI,mBAAA;AlG++hEhB;AkG5+hEY;EACI,6DAAA;AlG8+hEhB;AkG1+hEQ;EACI,yBAAA;AlG4+hEZ;;AkGz/hEQ;EACI,mBAAA;AlG4/hEZ;AkG1/hEY;EACI,mBAAA;AlG4/hEhB;AkGz/hEY;EACI,0DAAA;AlG2/hEhB;AkGv/hEQ;EACI,yBAAA;AlGy/hEZ;;AkGtgiEQ;EACI,mBAAA;AlGygiEZ;AkGvgiEY;EACI,mBAAA;AlGygiEhB;AkGtgiEY;EACI,6DAAA;AlGwgiEhB;AkGpgiEQ;EACI,yBAAA;AlGsgiEZ;;AkGnhiEQ;EACI,mBAAA;AlGshiEZ;AkGphiEY;EACI,mBAAA;AlGshiEhB;AkGnhiEY;EACI,yCAAA;AlGqhiEhB;AkGjhiEQ;EACI,yBAAA;AlGmhiEZ;;AkGhiiEQ;EACI,mBAAA;AlGmiiEZ;AkGjiiEY;EACI,mBAAA;AlGmiiEhB;AkGhiiEY;EACI,6DAAA;AlGkiiEhB;AkG9hiEQ;EACI,yBAAA;AlGgiiEZ;;AkG7iiEQ;EACI,mBAAA;AlGgjiEZ;AkG9iiEY;EACI,mBAAA;AlGgjiEhB;AkG7iiEY;EACI,6DAAA;AlG+iiEhB;AkG3iiEQ;EACI,yBAAA;AlG6iiEZ;;AkG1jiEQ;EACI,mBAAA;AlG6jiEZ;AkG3jiEY;EACI,mBAAA;AlG6jiEhB;AkG1jiEY;EACI,gCAAA;AlG4jiEhB;AkGxjiEQ;EACI,yBAAA;AlG0jiEZ;;AkGvkiEQ;EACI,mBAAA;AlG0kiEZ;AkGxkiEY;EACI,mBAAA;AlG0kiEhB;AkGvkiEY;EACI,mDAAA;AlGykiEhB;AkGrkiEQ;EACI,yBAAA;AlGukiEZ;;AkGhkiEI;EACI,4BAAA;EACA,yBAAA;AlGmkiER;AkGjkiEQ;EACI,yBAAA;EACA,UAAA;AlGmkiEZ;AkG9jiEQ;EACI,wBAAA;AlGgkiEZ;AkG9jiEY;EACI,UAAA;AlGgkiEhB;AkG3jiEQ;EACI,2BAAA;EACA,yBAAA;AlG6jiEZ;AkG3jiEY;EACI,yBAAA;EACA,UAAA;AlG6jiEhB;AkGxjiEY;EACI,wBAAA;AlG0jiEhB;AkGxjiEgB;EACI,UAAA;AlG0jiEpB;;AmGv7iEI;EACE,sBxF88C8B;AX4+/DpC;;AmGr7iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGw7iER;;AmG17iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnG67iER;;AmG/7iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGk8iER;;AmGp8iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGu8iER;;AmGz8iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnG48iER;;AmG98iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGi9iER;;AmGn9iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGs9iER;;AmGx9iEI;EACI,cxFmNO;EwFlNP,gCAAA;AnG29iER;;AoGr+iEA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;ApGw+iEF;;AoGr+iEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;ApGw+iEF;;AqGn/iEA;EACI,kBAAA;EACA,gBAAA;ArGs/iEJ;;AqGn/iEA;;;;;;;;;;;;EAYI,8B1FiHY;E0FhHZ,kC1FV8C;AXggjElD;;AqGn/iEA;EACI,gCAAA;ArGs/iEJ;;AqGn/iEA;EACI,gB1FqGiB;E0FpGjB,qB1Fo5BoC;AXkmhExC;;AqGp/iEA;;EAEE,gB1F4pB4B;AX21hE9B;;AqGl/iEA;EACI,kBAAA;EACA,yCAAA;ArGq/iEJ;;AqGl/iEA;EACI,cAAA;EACA,0CAAA;EACA,iBAAA;ArGq/iEJ;;AqG1+iEI;EANJ;;;;;;IAOQ,iBAAA;ErGm/iEN;AACF;;AqG/+iEA;EACI,kBAAA;ArGk/iEJ;;AsG7ijEI;EACI,W3FkJG;AX85iEX;;AsG1ijEA;EACI,0CAAA;EACA,iBAAA;AtG6ijEJ;;AsGxijEA;EACI,eAAA;AtG2ijEJ;;AsGtijEA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AtGyijEJ;AsGvijEI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,2CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AtGyijER;AsGrijEI;EACI,gBAAA;AtGuijER;AsGrijEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,0B3FmIH;E2FlIG,YAAA;AtGuijEhB;;AsG9hjEA;EACI,sBAAA;AtGiijEJ;;AsG5hjEA;EACI,0CAAA;EACA,oC3FmjB0B;E2FljB1B,qBAAA;EACA,2BAAA;AtG+hjEJ;;AsG1hjEA;EACI,UAAA;AtG6hjEJ;AsG3hjEI;EACI,oBAAA;AtG6hjER;AsG3hjEI;EACI,oBAAA;EACA,kC3FwiBsB;E2FviBtB,mC3FuiBsB;E2FtiBtB,wBAAA;AtG6hjER;;AsGthjEI;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,4BAAA;AtGyhjER;;AsGhhjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGmhjEZ;;AsG7gjEQ;EACI,c3FyGG;AXu6iEf;;AsG1gjEQ;EACI,0B3FkGG;AX26iEf;;AsGvgjEQ;EACI,yB3F2FG;AX+6iEf;;AsGjgjEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGogjEhB;;AsG3/iEY;EACI,WAAA;EACA,yB3FqED;AXy7iEf;AsG7/iEgB;EACI,qCAAA;AtG+/iEpB;;AsGv/iEY;EACI,c3F0DD;AXg8iEf;;AsGj/iEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGo/iEhB;;AsGxjjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG2jjEZ;;AsGrjjEQ;EACI,c3FyGG;AX+8iEf;;AsGljjEQ;EACI,0B3FkGG;AXm9iEf;;AsG/ijEQ;EACI,yB3F2FG;AXu9iEf;;AsGzijEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG4ijEhB;;AsGnijEY;EACI,WAAA;EACA,yB3FqED;AXi+iEf;AsGrijEgB;EACI,qCAAA;AtGuijEpB;;AsG/hjEY;EACI,c3F0DD;AXw+iEf;;AsGzhjEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG4hjEhB;;AsGhmjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGmmjEZ;;AsG7ljEQ;EACI,c3FyGG;AXu/iEf;;AsG1ljEQ;EACI,0B3FkGG;AX2/iEf;;AsGvljEQ;EACI,yB3F2FG;AX+/iEf;;AsGjljEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGoljEhB;;AsG3kjEY;EACI,WAAA;EACA,yB3FqED;AXygjEf;AsG7kjEgB;EACI,qCAAA;AtG+kjEpB;;AsGvkjEY;EACI,c3F0DD;AXghjEf;;AsGjkjEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGokjEhB;;AsGxojEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG2ojEZ;;AsGrojEQ;EACI,c3FyGG;AX+hjEf;;AsGlojEQ;EACI,0B3FkGG;AXmijEf;;AsG/njEQ;EACI,yB3F2FG;AXuijEf;;AsGznjEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG4njEhB;;AsGnnjEY;EACI,WAAA;EACA,yB3FqED;AXijjEf;AsGrnjEgB;EACI,qCAAA;AtGunjEpB;;AsG/mjEY;EACI,c3F0DD;AXwjjEf;;AsGzmjEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG4mjEhB;;AsGhrjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGmrjEZ;;AsG7qjEQ;EACI,c3FyGG;AXukjEf;;AsG1qjEQ;EACI,0B3FkGG;AX2kjEf;;AsGvqjEQ;EACI,yB3F2FG;AX+kjEf;;AsGjqjEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGoqjEhB;;AsG3pjEY;EACI,WAAA;EACA,yB3FqED;AXyljEf;AsG7pjEgB;EACI,qCAAA;AtG+pjEpB;;AsGvpjEY;EACI,c3F0DD;AXgmjEf;;AsGjpjEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGopjEhB;;AsGxtjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG2tjEZ;;AsGrtjEQ;EACI,c3FyGG;AX+mjEf;;AsGltjEQ;EACI,0B3FkGG;AXmnjEf;;AsG/sjEQ;EACI,yB3F2FG;AXunjEf;;AsGzsjEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG4sjEhB;;AsGnsjEY;EACI,WAAA;EACA,yB3FqED;AXiojEf;AsGrsjEgB;EACI,qCAAA;AtGusjEpB;;AsG/rjEY;EACI,c3F0DD;AXwojEf;;AsGzrjEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG4rjEhB;;AsGhwjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGmwjEZ;;AsG7vjEQ;EACI,c3FyGG;AXupjEf;;AsG1vjEQ;EACI,0B3FkGG;AX2pjEf;;AsGvvjEQ;EACI,yB3F2FG;AX+pjEf;;AsGjvjEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGovjEhB;;AsG3ujEY;EACI,WAAA;EACA,yB3FqED;AXyqjEf;AsG7ujEgB;EACI,qCAAA;AtG+ujEpB;;AsGvujEY;EACI,c3F0DD;AXgrjEf;;AsGjujEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGoujEhB;;AsGxyjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG2yjEZ;;AsGryjEQ;EACI,c3FyGG;AX+rjEf;;AsGlyjEQ;EACI,0B3FkGG;AXmsjEf;;AsG/xjEQ;EACI,yB3F2FG;AXusjEf;;AsGzxjEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG4xjEhB;;AsGnxjEY;EACI,WAAA;EACA,yB3FqED;AXitjEf;AsGrxjEgB;EACI,qCAAA;AtGuxjEpB;;AsG/wjEY;EACI,c3F0DD;AXwtjEf;;AsGzwjEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG4wjEhB;;AsGtwjEI;EACI,kCAAA;AtGywjER;AsGxwjEQ;EACI,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;AtG0wjEZ;;AsGrwjEA;EACI,qBAAA;AtGwwjEJ;;AuGt8jEI;EACI,qDAAA;AvGy8jER;;AuG18jEI;EACI,oDAAA;AvG68jER;;AuG98jEI;EACI,qDAAA;AvGi9jER;;AuGl9jEI;EACI,qDAAA;AvGq9jER;;AuGt9jEI;EACI,oDAAA;AvGy9jER;;AuG19jEI;EACI,qDAAA;AvG69jER;;AuG99jEI;EACI,sDAAA;AvGi+jER;;AuGl+jEI;EACI,mDAAA;EAKJ,2DAAA;AvGg+jEJ;;AuG79jEA;EACI,4DAAA;AvGo+jEJ;;AwGl+jEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxG4+jEJ;;AwGx+jEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGk/jEJ;;AwG9+jEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGw/jEJ;;AwGp/jEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxG8/jEJ;;AwG1/jEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGogkEJ;;AwGhgkEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxG0gkEJ;;AwGtgkEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGghkEJ;;AwG5gkEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGshkEJ;;AwG3gkEA;EACI,0CAAA;EACA,iBAAA;AxG8gkEJ;;AwG1gkEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGwikEJ;;AwG1gkEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGsikEJ;;AwGzgkEY;EACI,2B7FoLD;AXw1jEf;;AwGzhkEI;EA1BA,c7F2NW;E6F1NX,wCAAA;AxGujkEJ;;AwGzhkEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGqjkEJ;;AwGxhkEY;EACI,2B7FoLD;AXu2jEf;;AwGxikEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGskkEJ;;AwGxikEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGokkEJ;;AwGvikEY;EACI,2B7FoLD;AXs3jEf;;AwGvjkEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGqlkEJ;;AwGvjkEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGmlkEJ;;AwGtjkEY;EACI,2B7FoLD;AXq4jEf;;AwGtkkEI;EA1BA,c7F2NW;E6F1NX,wCAAA;AxGomkEJ;;AwGtkkEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGkmkEJ;;AwGrkkEY;EACI,2B7FoLD;AXo5jEf;;AwGrlkEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGmnkEJ;;AwGrlkEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGinkEJ;;AwGplkEY;EACI,2B7FoLD;AXm6jEf;;AwGpmkEI;EA1BA,c7F2NW;E6F1NX,0CAAA;AxGkokEJ;;AwGpmkEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGgokEJ;;AwGnmkEY;EACI,2B7FoLD;AXk7jEf;;AwGnnkEI;EA1BA,c7F2NW;E6F1NX,uCAAA;AxGipkEJ;;AwGnnkEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxG+okEJ;;AwGlnkEY;EACI,2B7FoLD;AXi8jEf;;AwG7mkEA;EACI,sBAAA;AxGgnkEJ;;AwG3mkEA;EACI,gBAAA;EACA,kBAAA;AxG8mkEJ;AwG7mkEI;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,2B7FsHK;E6FrHL,WAAA;EACA,MAAA;AxG+mkER;;AwGllkEI;EACI,6DAXI;AxGgmkEZ;;AwGtlkEI;EACI,6DAXI;AxGomkEZ;;AwG1lkEI;EACI,6DAXI;AxGwmkEZ;;AwG9lkEI;EACI,6DAXI;AxG4mkEZ;;AwGlmkEI;EACI,uGAXI;AxGgnkEZ;;AwGtmkEI;EACI,6DAXI;AxGonkEZ;;AwG1mkEI;EACI,6DAXI;AxGwnkEZ;;AyG3skEA;;EAEI,wBAAA;EACA,kBAAA;AzG8skEJ;;AyG3skEA;EACI,gB9FgoB0B;AX8kjE9B;;AyG3skEA;EACI,yBAAA;AzG8skEJ;;AyG1skEA;EACI,mBAAA;AzG6skEJ;;AyGzskEA;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,+BAAA;EACA,UAAA;AzG4skEJ;AyG1skEI;EACI,sBAAA;AzG4skER;AyGzskEI;EACI,kCAAA;EACA,iCAAA;AzG2skER;AyGxskEI;EACI,kCAAA;EACA,iCAAA;AzG0skER;;AyGhskEI;EACI,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,uCAAA;EACA,wCAAA;EACA,uCAAA;EACA,gDAAA;EACA,wCAAA;EACA,yCAAA;AzGmskER;;AyG7skEI;EACI,uBAAA;EACA,mCAAA;EACA,kCAAA;EACA,0BAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;EACA,gDAAA;EACA,wCAAA;EACA,yCAAA;AzGgtkER;;AyG1tkEI;EACI,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,uCAAA;EACA,wCAAA;EACA,uCAAA;EACA,gDAAA;EACA,wCAAA;EACA,yCAAA;AzG6tkER;;AyGvukEI;EACI,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,0CAAA;EACA,wCAAA;EACA,uCAAA;EACA,gDAAA;EACA,2CAAA;EACA,yCAAA;AzG0ukER;;AyGpvkEI;EACI,uBAAA;EACA,mCAAA;EACA,kCAAA;EACA,0BAAA;EACA,yCAAA;EACA,wCAAA;EACA,sCAAA;EACA,gDAAA;EACA,0CAAA;EACA,yCAAA;AzGuvkER;;AyGjwkEI;EACI,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,0BAAA;EACA,uCAAA;EACA,wCAAA;EACA,uCAAA;EACA,gDAAA;EACA,wCAAA;EACA,yCAAA;AzGowkER;;AyG9wkEI;EACI,uBAAA;EACA,qCAAA;EACA,kCAAA;EACA,0BAAA;EACA,2CAAA;EACA,wCAAA;EACA,wCAAA;EACA,gDAAA;EACA,4CAAA;EACA,yCAAA;AzGixkER;;AyG3xkEI;EACI,uBAAA;EACA,kCAAA;EACA,kCAAA;EACA,0BAAA;EACA,wCAAA;EACA,wCAAA;EACA,qCAAA;EACA,gDAAA;EACA,yCAAA;EACA,yCAAA;AzG8xkER;;AyGpxkEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0CAAA;EACA,wCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2CAAA;EACA,yCAAA;AzGuxkER;;AyGjykEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,yCAAA;EACA,wCAAA;EACA,sCAAA;EACA,8BAAA;EACA,0CAAA;EACA,yCAAA;AzGoykER;;AyG9ykEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0CAAA;EACA,wCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2CAAA;EACA,yCAAA;AzGizkER;;AyG3zkEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0CAAA;EACA,wCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2CAAA;EACA,yCAAA;AzG8zkER;;AyGx0kEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,yCAAA;EACA,wCAAA;EACA,sCAAA;EACA,8BAAA;EACA,0CAAA;EACA,yCAAA;AzG20kER;;AyGr1kEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0CAAA;EACA,wCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2CAAA;EACA,yCAAA;AzGw1kER;;AyGl2kEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,2CAAA;EACA,wCAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,yCAAA;AzGq2kER;;AyG/2kEI;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,wCAAA;EACA,wCAAA;EACA,qCAAA;EACA,8BAAA;EACA,yCAAA;EACA,yCAAA;AzGk3kER;;AyG92kEA;EACI,yBAAA;AzGi3kEJ;;AyG72kEA;EACI,kBAAA;EACA,kBAAA;AzGg3kEJ;AyG92kEI;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzGg3kER;AyG52kEQ;EACI,wCAAA;AzG82kEZ;AyG12kEI;EACI,oB9F0uBsB;E8FzuBtB,mBAAA;AzG42kER;AyG12kEQ;EACI,WAAA;EACA,UAAA;AzG42kEZ;;AyGr2kEA;EACI,gBAAA;EACA,oDAAA;EACA,wDAAA;AzGw2kEJ;AyGt2kEI;EACI,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,iCAAA;EACA,sBAAA;EACA,wCAAA;EACA,wDAAA;AzGw2kER;AyGr2kEI;EACI,cAAA;EACA,wCAAA;EACA,wDAAA;AzGu2kER;AyGn2kEQ;EACI,UAAA;EACA,+BAAA;AzGq2kEZ;AyGl2kEQ;EACI,UAAA;EACA,kCAAA;AzGo2kEZ;;AyG71kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzGg2kER;AyG91kEQ;EACI,c9FoDG;E8FnDH,yCAAA;AzGg2kEZ;;AyGt2kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzGy2kER;AyGv2kEQ;EACI,c9FoDG;E8FnDH,wCAAA;AzGy2kEZ;;AyG/2kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzGk3kER;AyGh3kEQ;EACI,c9FoDG;E8FnDH,yCAAA;AzGk3kEZ;;AyGx3kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzG23kER;AyGz3kEQ;EACI,c9FoDG;E8FnDH,yCAAA;AzG23kEZ;;AyGj4kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzGo4kER;AyGl4kEQ;EACI,c9FoDG;E8FnDH,wCAAA;AzGo4kEZ;;AyG14kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzG64kER;AyG34kEQ;EACI,c9FoDG;E8FnDH,yCAAA;AzG64kEZ;;AyGn5kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzGs5kER;AyGp5kEQ;EACI,c9FoDG;E8FnDH,0CAAA;AzGs5kEZ;;AyG55kEI;EACI,yB9FwDO;E8FvDP,gCAAA;AzG+5kER;AyG75kEQ;EACI,c9FoDG;E8FnDH,uCAAA;AzG+5kEZ;;AyGj5kEI;EACI,gBAAA;AzGo5kER;;AyG94kEI;EACI,YAAA;AzGi5kER;AyG94kEI;;;;;EAKI,yCAAA;EACA,c9FbK;AX65kEb;;AyGz4kEI;;;;EAII,qBAAA;EACA,iDAAA;EACA,6CAAA;AzG44kER;AyGz4kEI;;;;;;;;;;;;;;;EAeI,qBAAA;EACA,iDAAA;EACA,6CAAA;AzG24kER;AyGx4kEI;;;;EAII,sBAAA;EACA,gDAAA;EACA,4CAAA;AzG04kER;AyGv4kEI;;;;;;;;;;;;;;;EAeI,sBAAA;EACA,gDAAA;EACA,4CAAA;AzGy4kER;AyGp4kEI;EACI,qBAAA;EACA,gDAAA;AzGs4kER;AyGp4kEQ;EACI,qBAAA;EACA,iCAAA;AzGs4kEZ;AyGl4kEI;EACI,qBAAA;EACA,+CAAA;AzGo4kER;AyGl4kEQ;EACI,sBAAA;EACA,gCAAA;AzGo4kEZ;AyG/3kEI;EACI,qBAAA;AzGi4kER;AyG/3kEQ;EACI,qBAAA;EACA,gDAAA;AzGi4kEZ;AyG73kEI;EACI,qBAAA;AzG+3kER;AyG73kEQ;EACI,qBAAA;EACA,+CAAA;AzG+3kEZ;;AyGx3kEI;;EAEI,YAAA;EACA,WAAA;AzG23kER;;AyGl3kEQ;EACI,0EAAA;AzGq3kEZ;;AyGt3kEQ;EACI,0EAAA;AzGy3kEZ;;AyG13kEQ;EACI,0EAAA;AzG63kEZ;;AyG93kEQ;EACI,yDAAA;AzGi4kEZ;;AyGl4kEQ;EACI,0EAAA;AzGq4kEZ;;AyGt4kEQ;EACI,0EAAA;AzGy4kEZ;;AyG14kEQ;EACI,iDAAA;AzG64kEZ;;AyG94kEQ;EACI,gEAAA;AzGi5kEZ;;AyG14kEI;EACI,aAAA;AzG64kER;AyGz4kEQ;EACI,aAAA;AzG24kEZ;AyGx4kEQ;EACI,cAAA;AzG04kEZ;;A0G3tlEI;EACI,yBAAA;A1G8tlER;A0G3tlEQ;EACI,oCAAA;EACA,eAAA;EACA,iBAAA;A1G6tlEZ;;A2GvulEA;EACI,mBhG6lB0B;EgG5lB1B,4ChGioB0B;AXymkE9B;;A2GvulEA;EACI,+CAAA;A3G0ulEJ;;A2GrulEI;EACI,eAAA;A3GwulER;;A2GpulEA;EACI,4CAAA;A3GuulEJ;;A2GpulEA;EACI,chG0IO;AX6llEX;;A2GpulEA;EACI,eAAA;EACA,iBAAA;A3GuulEJ;;A2GpulEA;EACI,mBAAA;A3GuulEJ;;A2GpulEA;EACI,yBAAA;A3GuulEJ;;A2GpulEA;EACI,oBAAA;A3GuulEJ;A2GrulEI;EACI,sCAAA;EACA,6ChG2lBsB;AX4okE9B;;A2GztlEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXyjlEf;A2G3tlEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3G6tlEZ;A2G1tlEQ;EACI,WhGoFD;AXwolEX;;A2GtulEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXsklEf;A2GxulEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3G0ulEZ;A2GvulEQ;EACI,WhGoFD;AXqplEX;;A2GnvlEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXmllEf;A2GrvlEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3GuvlEZ;A2GpvlEQ;EACI,WhGoFD;AXkqlEX;;A2GhwlEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXgmlEf;A2GlwlEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3GowlEZ;A2GjwlEQ;EACI,WhGoFD;AX+qlEX;;A2G7wlEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AX6mlEf;A2G/wlEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3GixlEZ;A2G9wlEQ;EACI,WhGoFD;AX4rlEX;;A2G1xlEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AX0nlEf;A2G5xlEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3G8xlEZ;A2G3xlEQ;EACI,WhGoFD;AXyslEX;;A2GvylEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXuolEf;A2GzylEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3G2ylEZ;A2GxylEQ;EACI,WhGoFD;AXstlEX;;A2GpzlEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXoplEf;A2GtzlEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3GwzlEZ;A2GrzlEQ;EACI,WhGoFD;AXmulEX;;A2GhzlEI;EACI,gCAAA;A3GmzlER;A2GlzlEQ;EACI,qBhGiJG;AXmqlEf;;A2GvzlEI;EACI,gCAAA;A3G0zlER;A2GzzlEQ;EACI,qBhGiJG;AX0qlEf;;A2G9zlEI;EACI,gCAAA;A3Gi0lER;A2Gh0lEQ;EACI,qBhGiJG;AXirlEf;;A2Gr0lEI;EACI,gCAAA;A3Gw0lER;A2Gv0lEQ;EACI,qBhGiJG;AXwrlEf;;A2G50lEI;EACI,gCAAA;A3G+0lER;A2G90lEQ;EACI,qBhGiJG;AX+rlEf;;A2Gn1lEI;EACI,gCAAA;A3Gs1lER;A2Gr1lEQ;EACI,qBhGiJG;AXsslEf;;A2G11lEI;EACI,gCAAA;A3G61lER;A2G51lEQ;EACI,qBhGiJG;AX6slEf;;A2Gj2lEI;EACI,gCAAA;A3Go2lER;A2Gn2lEQ;EACI,qBhGiJG;AXotlEf;;A2G/1lEA;EACI,iCAAA;A3Gk2lEJ;A2Gj2lEI;EACI,sCAAA;EACA,+CAAA;A3Gm2lER;A2Gj2lEI;EACI,sCAAA;A3Gm2lER;;A2G/1lEA;EACI,gBAAA;A3Gk2lEJ;;A2G51lEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gDAAA;EACA,aAAA;A3G+1lEJ;;A2G51lEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2CAAA;A3G+1lEJ;;A2G51lEA;EACI,kCAAA;A3G+1lEJ;;A2G51lEA;EACC;IAAK,yBAAA;E3Gg2lEJ;AACF;A2G91lEA;EACI,kBAAA;EACA,gBAAA;A3Gg2lEJ;A2G/1lEI;EACI,WAAA;EACA,yCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;A3Gi2lER;A2G/1lEI;EACI,kDAAA;A3Gi2lER;;A2G71lEA;EACI,gBAAA;A3Gg2lEJ;A2G/1lEI;EACI,eAAA;A3Gi2lER;A2G91lEQ;EACI,aAAA;A3Gg2lEZ;A2G91lEQ;EACI,cAAA;A3Gg2lEZ;A2G71lEY;EACI,cAAA;A3G+1lEhB;A2G71lEY;EACI,aAAA;A3G+1lEhB;;A4GhgmEA;EACI,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oCAAA;A5GmgmEJ;;A4GhgmEA;EACI,6CjG2nB0B;EiG1nB1B,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;A5GmgmEJ;A4GjgmEI;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;A5GmgmER;A4GhgmEI;EACI,iCAAA;A5GkgmER;;A4G9/lEA;EACI;IACI,gBAAA;E5GigmEN;E4G9/lEE;IACI,eAAA;E5GggmEN;AACF;A4G7/lEA;EACI;IACI,gBAAA;E5G+/lEN;E4G5/lEE;IACI,kBAAA;E5G8/lEN;AACF;A4G3/lEA;EACI;IACI,YAAA;E5G6/lEN;E4G1/lEE;IACI,YAAA;E5G4/lEN;E4Gz/lEE;IACI,YAAA;E5G2/lEN;AACF;A4Gx/lEA;EACI,iBAAA;A5G0/lEJ;A4Gz/lEI;EACI,gBAAA;A5G2/lER;A4Gx/lEI;EACI,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,kCAAA;A5G0/lER;;A4Gp/lEA;EACI,2BAAA;A5Gu/lEJ;;A4Gh/lEA;EACI,YAAA;A5Gm/lEJ;;A4Gh/lEA;EACI,YAAA;A5Gm/lEJ;;A4G/+lEI;EACI,kBAAA;A5Gk/lER;A4G/+lEI;EACI,oBAAA;A5Gi/lER;;A4G5+lEI;EACI,SAAA;A5G++lER;A4G9+lEQ;EACI,+BAAA;A5Gg/lEZ;A4G/+lEY;EACI,uCAAA;A5Gi/lEhB;A4G/+lEY;EACI,WjGiCL;AXg9lEX;;A4Gv+lEQ;EACE,0CAAA;EACA,cjG4FK;AX84lEf;;A4G5+lEQ;EACE,yCAAA;EACA,cjG4FK;AXm5lEf;;A4Gj/lEQ;EACE,0CAAA;EACA,cjG4FK;AXw5lEf;;A4Gt/lEQ;EACE,0CAAA;EACA,cjG4FK;AX65lEf;;A4G3/lEQ;EACE,yCAAA;EACA,cjG4FK;AXk6lEf;;A4GhgmEQ;EACE,0CAAA;EACA,cjG4FK;AXu6lEf;;A4GrgmEQ;EACE,2CAAA;EACA,cjG4FK;AX46lEf;;A4G1gmEQ;EACE,wCAAA;EACA,cjG4FK;AXi7lEf;;A6G5omEQ;EACI,yBAAA;EACA,gBlG2HS;AXohmErB;;A6GzomEI;EACI,yBAAA;EACA,gBlGmHa;AXyhmErB;;A6GtomEI;EACI,gBlGonBsB;AXqhlE9B;;A6GromEA;EACI,2CAAA;A7GwomEJ;A6GtomEI;EACI,kBAAA;A7GwomER;A6GtomEQ;EACI,YAAA;EACA,gBlGgGS;AXwimErB;A6GtomEY;EACI,WAAA;EACA,mBlGiJH;EkGhJG,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,mBAAA;A7GwomEhB;A6GromEY;EACI,clGsIH;AXigmEb;A6GromEgB;EACI,mBAAA;A7GuomEpB;A6GjomEI;EACI,iBAAA;A7GmomER;A6GjomEQ;EACI,kBAAA;A7GmomEZ;;A6G1nmEQ;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;A7G6nmEZ;A6G3nmEY;EACI,eAAA;A7G6nmEhB;;A6GpnmEQ;EACI,yBlGqED;EkGpEC,aAAA;A7GunmEZ;;A6G9mmEQ;EACI,kBAAA;EACA,kBAAA;A7GinmEZ;A6G/mmEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;ElF5FV,uGkF6FU;A7GinmEhB;A2B1smEM;EkFkFM;IlFjFJ,gBAAA;E3B6smEN;AACF;A6GlnmEgB;EACI,yBlGsEP;AX8imEb;;A6G3mmEI;EACI,kBAAA;EACA,gBAAA;A7G8mmER;A6G5mmEQ;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7G8mmEZ;A6G5mmEY;EACI,eAAA;A7G8mmEhB;A6G3mmEY;EACI,eAAA;A7G6mmEhB;A6GzmmEgB;EACI,WlGWT;AXgmmEX;A6GvmmEY;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;A7GymmEhB;A6GvmmEgB;EACI,QAAA;EACA,2BAAA;A7GymmEpB;A6GtmmEgB;EACI,aAAA;A7GwmmEpB;A6GnmmEgB;EACI,WAAA;EACA,0BAAA;A7GqmmEpB;A6GlmmEgB;EACI,UAAA;A7GommEpB;;A6G1lmEI;EACI,iCAAA;EACA,eAAA;EACA,kBAAA;A7G6lmER;A6G3lmEQ;EACI;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;IACA,2BAAA;IACA,8BAAA;IACA,8BAAA;IACA,uCAAA;E7G6lmEd;E6GzlmEc;IACI,0BlGfP;EX0mmEX;AACF;;A6GnlmEI;EACI,kBAAA;A7GslmER;A6GplmEQ;EACI,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;A7GslmEZ;A6GplmEY;EACI,kBAAA;A7GslmEhB;A6GnlmEY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,6DAAA;EACA,yBlG/CH;EkGgDG,WAAA;A7GqlmEhB;A6GllmEY;EAEI,WlGnFL;EkGoFK,wCAAA;A7GmlmEhB;A6GjlmEgB;EACI,WAAA;EACA,OAAA;A7GmlmEpB;;A6G3kmEI;EACI,iCAAA;A7G8kmER;A6G5kmEQ;EACI,yBlGtEC;AXopmEb;;A6GrkmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AXgnmEf;;A6G1kmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AXqnmEf;;A6G/kmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AX0nmEf;;A6GplmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AX+nmEf;;A6GzlmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AXoomEf;;A6G9lmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AXyomEf;;A6GnmmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AX8omEf;;A6GxmmEY;EACI,clGvCD;EkGwCC,yBlGxCD;AXmpmEf;;A6GrmmEA;EACI,yBlGxFS;EkGyFT,sBlG6W0B;AX2vlE9B;A6GrmmEQ;EACI,gCAAA;A7GummEZ;A6GrmmEY;EACI,WlG9HL;EkG+HK,0CAAA;A7GummEhB;A6GhmmEY;EACI,qCAAA;A7GkmmEhB;A6GhmmEgB;EACI,clGzIT;EkG0IS,yBlG7GP;AX+smEb;;A6GzlmEI;EACI,yBlG9EO;AX0qmEf;;A6G7lmEI;EACI,yBlG9EO;AX8qmEf;;A6GjmmEI;EACI,yBlG9EO;AXkrmEf;;A6GrmmEI;EACI,yBlG9EO;AXsrmEf;;A6GzmmEI;EACI,yBlG9EO;AX0rmEf;;A6G7mmEI;EACI,yBlG9EO;AX8rmEf;;A6GjnmEI;EACI,yBlG9EO;AXksmEf;;A6GrnmEI;EACI,yBlG9EO;AXssmEf;;A6GpnmEA;EACI,iCAAA;A7GunmEJ;;A6GhnmEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AX+smEf;A6G7mmEgB;EACI,clGnGL;EkGoGK,0CAAA;A7G+mmEpB;A6GxmmEgB;EACI,clG5GL;EkG6GK,0CAAA;A7G0mmEpB;A6GxmmEoB;EACI,yBlGhHT;AX0tmEf;A6GjmmEoB;EACI,yBlG1HT;AX6tmEf;A6G1lmEoB;EACI,0BlGpIT;AXgumEf;;A6GtomEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AXqumEf;A6GnomEgB;EACI,clGnGL;EkGoGK,0CAAA;A7GqomEpB;A6G9nmEgB;EACI,clG5GL;EkG6GK,0CAAA;A7GgomEpB;A6G9nmEoB;EACI,yBlGhHT;AXgvmEf;A6GvnmEoB;EACI,yBlG1HT;AXmvmEf;A6GhnmEoB;EACI,0BlGpIT;AXsvmEf;;A6G5pmEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AX2vmEf;A6GzpmEgB;EACI,clGnGL;EkGoGK,0CAAA;A7G2pmEpB;A6GppmEgB;EACI,clG5GL;EkG6GK,0CAAA;A7GspmEpB;A6GppmEoB;EACI,yBlGhHT;AXswmEf;A6G7omEoB;EACI,yBlG1HT;AXywmEf;A6GtomEoB;EACI,0BlGpIT;AX4wmEf;;A6GlrmEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AXixmEf;A6G/qmEgB;EACI,clGnGL;EkGoGK,0CAAA;A7GirmEpB;A6G1qmEgB;EACI,clG5GL;EkG6GK,0CAAA;A7G4qmEpB;A6G1qmEoB;EACI,yBlGhHT;AX4xmEf;A6GnqmEoB;EACI,yBlG1HT;AX+xmEf;A6G5pmEoB;EACI,0BlGpIT;AXkymEf;;A6GxsmEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AXuymEf;A6GrsmEgB;EACI,clGnGL;EkGoGK,0CAAA;A7GusmEpB;A6GhsmEgB;EACI,clG5GL;EkG6GK,0CAAA;A7GksmEpB;A6GhsmEoB;EACI,yBlGhHT;AXkzmEf;A6GzrmEoB;EACI,yBlG1HT;AXqzmEf;A6GlrmEoB;EACI,0BlGpIT;AXwzmEf;;A6G9tmEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AX6zmEf;A6G3tmEgB;EACI,clGnGL;EkGoGK,0CAAA;A7G6tmEpB;A6GttmEgB;EACI,clG5GL;EkG6GK,0CAAA;A7GwtmEpB;A6GttmEoB;EACI,yBlGhHT;AXw0mEf;A6G/smEoB;EACI,yBlG1HT;AX20mEf;A6GxsmEoB;EACI,0BlGpIT;AX80mEf;;A6GpvmEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AXm1mEf;A6GjvmEgB;EACI,clGnGL;EkGoGK,0CAAA;A7GmvmEpB;A6G5umEgB;EACI,clG5GL;EkG6GK,0CAAA;A7G8umEpB;A6G5umEoB;EACI,yBlGhHT;AX81mEf;A6GrumEoB;EACI,yBlG1HT;AXi2mEf;A6G9tmEoB;EACI,0BlGpIT;AXo2mEf;;A6G1wmEY;EACI,WlGlKL;EkGmKK,yBlG5FD;AXy2mEf;A6GvwmEgB;EACI,clGnGL;EkGoGK,0CAAA;A7GywmEpB;A6GlwmEgB;EACI,clG5GL;EkG6GK,0CAAA;A7GowmEpB;A6GlwmEoB;EACI,yBlGhHT;AXo3mEf;A6G3vmEoB;EACI,yBlG1HT;AXu3mEf;A6GpvmEoB;EACI,0BlGpIT;AX03mEf;;A6G7umEA;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;A7GgvmEJ;A6G9umEI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;A7GgvmER;A6G7umEI;EACI,mBAAA;EACA,kBAAA;EACA,8BAAA;A7G+umER;A6G7umEQ;EACI,WAAA;EACA,YAAA;EACA,iCAAA;EACA,UAAA;EACA,qBAAA;EACA,gBlGnQS;AXk/mErB;A6G7umEY;EAEI,yBlGlNH;EkGmNG,WlGjPL;AX+9mEX;;A6GtumEI;EACI,iCAAA;A7GyumER;A6GvumEQ;EACI,gBAAA;EACA,kBAAA;EACA,gBlGtRS;EkGuRT,qBAAA;A7GyumEZ;A6GvumEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;A7GyumEhB;A6GtumEY;EACI,0CAAA;EACA,clG/OH;AXu9mEb;A6GtumEgB;EACI,8BAAA;A7GwumEpB;A6GpumEY;EACI,yCAAA;EACA,clGxPH;EkGyPG,gBAAA;A7GsumEhB;A6GpumEgB;EACI,0CAAA;A7GsumEpB;A6G9tmEoB;EACI,aAAA;A7GgumExB;;A6GttmEI;EACI,SAAA;A7GytmER;A6GvtmEQ;EACI,gBAAA;EACA,gDAAA;EACA,wCAAA;EACA,qBAAA;A7GytmEZ;A6GvtmEY;EACI,gBlG8Oc;AX2+lE9B;A6GttmEY;EACI,clG1RH;EkG2RG,sBAAA;EACA,gBlGpVK;EkGqVL,WAAA;A7GwtmEhB;A6GntmEgB;EACI,clGhSP;AXq/mEb;A6GntmEoB;EACI,gBAAA;A7GqtmExB;A6GhtmEY;EACI,qBlG/SH;AXignEb;A6G/smEY;EACI,qBlG7SH;AX8/mEb;;A6GxsmEQ;EACI,6BAAA;EACA,oCAAA;A7G2smEZ;A6GzsmEY;EACI,qBlGjUH;EkGkUG,6BAAA;EACA,clGnUH;AX8gnEb;;A6GhsmEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AX0+mEf;;A6GrsmEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AX++mEf;;A6G1smEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AXo/mEf;;A6G/smEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AXy/mEf;;A6GptmEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AX8/mEf;;A6GztmEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AXmgnEf;;A6G9tmEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AXwgnEf;;A6GnumEgB;EACI,clGtSL;EkGuSK,qBlGvSL;AX6gnEf;;A6G7tmEI;EACI,kBAAA;EACA,gBAAA;A7GgumER;A6G9tmEQ;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,yBAAA;A7GgumEZ;A6G9tmEY;EAEI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;A7G+tmEhB;A6G5tmEY;EACI,wBAAA;EACA,YAAA;EACA,4BAAA;A7G8tmEhB;A6G3tmEY;EACI,wBAAA;EACA,WAAA;EACA,6BAAA;A7G6tmEhB;A6G1tmEY;EAGI,yBlGhYH;EkGiYG,WlG/ZL;AXynnEX;A6GvtmEY;EACI,UAAA;A7GytmEhB;;A8GjxnEI;EACI,gBnGyrBsB;AX2lmE9B;A8GjxnEI;EACI,oCnGgnBsB;AXmqmE9B;A8GjxnEI;EACI,qBnGkmBsB;AXirmE9B;;A8G5wnEI;;EAEI,mBAAA;A9G+wnER;;A8GzwnEA;EACI,mBAAA;A9G4wnEJ;A8GvwnEQ;;EACI,kBAAA;A9G0wnEZ;A8GvwnEQ;;EACI,mBAAA;A9G0wnEZ;A8GtwnEI;EACI,qBnGmkBsB;AXqsmE9B;;A8GhwnEY;EACI,gCAAA;A9GmwnEhB;;A8G7vnEY;EACI,kFAAA;A9GgwnEhB;;A8GxwnEY;EACI,gCAAA;A9G2wnEhB;;A8GrwnEY;EACI,+EAAA;A9GwwnEhB;;A8GhxnEY;EACI,gCAAA;A9GmxnEhB;;A8G7wnEY;EACI,kFAAA;A9GgxnEhB;;A8GxxnEY;EACI,gCAAA;A9G2xnEhB;;A8GrxnEY;EACI,6DAAA;A9GwxnEhB;;A8GhynEY;EACI,gCAAA;A9GmynEhB;;A8G7xnEY;EACI,mFAAA;A9GgynEhB;;A8GxynEY;EACI,gCAAA;A9G2ynEhB;;A8GrynEY;EACI,mFAAA;A9GwynEhB;;A8GhznEY;EACI,gCAAA;A9GmznEhB;;A8G7ynEY;EACI,qCAAA;A9GgznEhB;;A8GxznEY;EACI,gCAAA;A9G2znEhB;;A8GrznEY;EACI,uEAAA;A9GwznEhB;;A8GjznEI;EACI,iBAAA;EACA,kBAAA;A9GoznER;A8GnznEQ;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;A9GqznEZ;A8GlznEI;EACI,kBAAA;A9GoznER;A8GnznEQ;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;A9GqznEZ;A8GnznEQ;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,SAAA;A9GqznEZ;;A8G/ynEI;EACI,iCAAA;EACA,2BAAA;A9GkznER;A8GjznEQ;EACI,iCAAA;A9GmznEZ;;A8G7ynEI;EACI,8CAAA;EACA,2BAAA;A9GgznER;A8G7ynEI;;EAEI,2BAAA;EACA,mCAAA;A9G+ynER;A8G5ynEI;;EAEI,2CAAA;A9G8ynER;;A8GzynEI;EACI,mCAAA;EACA,2BAAA;EACA,wCAAA;A9G4ynER;A8GzynEI;EACI,oBAAA;A9G2ynER;A8GxynEI;EACI,oCAAA;A9G0ynER;;A+Gh7nEA;EACI,gBpG0rB0B;AXyvmE9B;;A+G/6nEI;EACI,iBAAA;A/Gk7nER;A+Gh7nEQ;EACI,4BAAA;A/Gk7nEZ;A+G96nEI;EACI,cAAA;A/Gg7nER;;A+G16nEE;EACC,UAAA;EACA,0BAAA;EACA,gCAAA;A/G66nEH;A+Gz6nEG;EACC,UAAA;EACA,wBAAA;A/G26nEJ;A+Gr6nEE;EACC,sCAAA;EACA,6BAAA;A/Gu6nEH;A+Gn6nEG;EACC,eAAA;A/Gq6nEJ;A+G/5nEE;EACC,oCAAA;EACA,4BAAA;A/Gi6nEH;A+G75nEG;EACC,eAAA;A/G+5nEJ;A+G15nEC;EACC,mBAAA;A/G45nEF;A+G15nEE;EACC,UAAA;EACA,0BAAA;EACA,oBAAA;A/G45nEH;A+Gx5nEG;EACC,UAAA;EACA,wBAAA;A/G05nEJ;A+Gp5nEE;EACC,UAAA;EACA,qBAAA;EACA,yBAAA;A/Gs5nEH;A+Gl5nEG;EACC,UAAA;EACA,mBAAA;A/Go5nEJ;;A+G74nEA;EACC,qBpGy5CmC;AXu/kEpC;;A+G54nEA;EACC,aAAA;EACA,qBAAA;EACA,gCAAA;A/G+4nED;A+G74nEC;EALD;IAME,+BAAA;E/Gg5nEA;AACF;;A+G74nEA;EACC,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,qBpGu4CmC;AXyglEpC;A+G94nEC;EAND;IAOE,+BAAA;E/Gi5nEA;AACF;;A+G94nEA;EACC;IACC,UAAA;IACA,kCAAA;E/Gi5nEA;E+G94nED;IACC,UAAA;IACA,wBAAA;E/Gg5nEA;AACF;A+G54nEA;EACC;IACC,UAAA;IACA,iCAAA;E/G84nEA;E+G34nED;IACC,UAAA;IACA,wBAAA;E/G64nEA;AACF;A+G14nEA;EACC;IACC,UAAA;IACA,iCAAA;E/G44nEA;E+Gz4nED;IACC,UAAA;E/G24nEA;AACF;A+Gx4nEA;EACC,0DAAA;EACA,sBAAA;EACA,2BAAA;A/G04nED;;AgHtioEQ;EACI,oBAAA;EACA,sBrGqnBkB;AXo7mE9B;;AgHlioEI;EACI,8BAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AhHqioER;AgHjioEQ;EACI,eAAA;EACA,gBAAA;AhHmioEZ;;AgH7hoEI;EACI,gBrGwmBsB;AXw7mE9B;;AiH9joEA;EACI,WAAA;AjHikoEJ;;AiH7joEA;EACI,YAAA;AjHgkoEJ;;AiH5joEA;EACI,YAAA;AjH+joEJ;;AiH5joEA;EACI,kBAAA;AjH+joEJ;AiH7joEI;EACI,kBAAA;EACA,UAAA;AjH+joER;AiH7joEQ;EACI,oCAAA;AjH+joEZ;;AiHxjoEA;EACI,kBAAA;AjH2joEJ;AiHzjoEI;EACI,kBAAA;EACA,kBAAA;EACA,8BAAA;AjH2joER;;AiHvjoEA;EACI;IACI,QAAA;EjH0joEN;AACF;AiHrjoEA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;AjHujoEJ;AiHrjoEI;EACI,kBAAA;EACA,mBAAA;AjHujoER;AiHrjoEQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sBtGwFD;EsGvFC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AjHujoEZ;;AiHhjoEA;EACI,iBAAA;AjHmjoEJ;AiHjjoEI;EACI,kBAAA;EACA,iBAAA;AjHmjoER;AiHjjoEQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBtGgGC;EsG/FD,WtGiED;EsGhEC,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AjHmjoEZ;AiHjjoEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBtGqFH;EsGpFG,YAAA;EACA,SAAA;EACA,2BAAA;AjHmjoEhB;;AiH5ioEA;EACI,eAAA;AjH+ioEJ;AiH7ioEI;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WtGsCG;AXygoEX;AiH9ioEQ;EACI,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AjHgjoEZ;;AiHzioEI;EACI,yBtG8FO;AX88nEf;AiH3ioEQ;EACI,0BtG4FG;AXi9nEf;AiH3ioEQ;EACI,oDAAA;EACA,yBAAA;AjH6ioEZ;AiH5ioEY;EACI,0CAAA;AjH8ioEhB;;AiHvjoEI;EACI,yBtG8FO;AX49nEf;AiHzjoEQ;EACI,0BtG4FG;AX+9nEf;AiHzjoEQ;EACI,mDAAA;EACA,yBAAA;AjH2joEZ;AiH1joEY;EACI,yCAAA;AjH4joEhB;;AiHrkoEI;EACI,yBtG8FO;AX0+nEf;AiHvkoEQ;EACI,0BtG4FG;AX6+nEf;AiHvkoEQ;EACI,oDAAA;EACA,yBAAA;AjHykoEZ;AiHxkoEY;EACI,0CAAA;AjH0koEhB;;AiHnloEI;EACI,yBtG8FO;AXw/nEf;AiHrloEQ;EACI,0BtG4FG;AX2/nEf;AiHrloEQ;EACI,oDAAA;EACA,yBAAA;AjHuloEZ;AiHtloEY;EACI,0CAAA;AjHwloEhB;;AiHjmoEI;EACI,yBtG8FO;AXsgoEf;AiHnmoEQ;EACI,0BtG4FG;AXygoEf;AiHnmoEQ;EACI,mDAAA;EACA,yBAAA;AjHqmoEZ;AiHpmoEY;EACI,yCAAA;AjHsmoEhB;;AiH/moEI;EACI,yBtG8FO;AXohoEf;AiHjnoEQ;EACI,0BtG4FG;AXuhoEf;AiHjnoEQ;EACI,oDAAA;EACA,yBAAA;AjHmnoEZ;AiHlnoEY;EACI,0CAAA;AjHonoEhB;;AiH7noEI;EACI,yBtG8FO;AXkioEf;AiH/noEQ;EACI,0BtG4FG;AXqioEf;AiH/noEQ;EACI,qDAAA;EACA,yBAAA;AjHiooEZ;AiHhooEY;EACI,2CAAA;AjHkooEhB;;AiH3ooEI;EACI,yBtG8FO;AXgjoEf;AiH7ooEQ;EACI,0BtG4FG;AXmjoEf;AiH7ooEQ;EACI,kDAAA;EACA,yBAAA;AjH+ooEZ;AiH9ooEY;EACI,wCAAA;AjHgpoEhB;;AkHvxoEA;EACI,6CvGooB0B;AXspnE9B;;AmH1xoEA;EACI,2CAAA;AnH6xoEJ;;AmHxxoEI;EACI,aAAA;EACA,sBAAA;AnH2xoER;AmHzxoEQ;EACI,qDAAA;EACA,iBAAA;EACA,sBAAA;AnH2xoEZ;;AmHlxoEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnHqxoEhB;AmHnxoEgB;EACI,cAAA;AnHqxoEpB;AmHhxoEgB;EACI,qBAAA;AnHkxoEpB;AmHhxoEoB;EACI,cAAA;AnHkxoExB;;AmHjyoEY;EACI,cAAA;EACA,qBAAA;EACA,yCAAA;AnHoyoEhB;AmHlyoEgB;EACI,cAAA;AnHoyoEpB;AmH/xoEgB;EACI,qBAAA;AnHiyoEpB;AmH/xoEoB;EACI,cAAA;AnHiyoExB;;AmHhzoEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnHmzoEhB;AmHjzoEgB;EACI,cAAA;AnHmzoEpB;AmH9yoEgB;EACI,qBAAA;AnHgzoEpB;AmH9yoEoB;EACI,cAAA;AnHgzoExB;;AmH/zoEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnHk0oEhB;AmHh0oEgB;EACI,cAAA;AnHk0oEpB;AmH7zoEgB;EACI,qBAAA;AnH+zoEpB;AmH7zoEoB;EACI,cAAA;AnH+zoExB;;AmH90oEY;EACI,cAAA;EACA,qBAAA;EACA,yCAAA;AnHi1oEhB;AmH/0oEgB;EACI,cAAA;AnHi1oEpB;AmH50oEgB;EACI,qBAAA;AnH80oEpB;AmH50oEoB;EACI,cAAA;AnH80oExB;;AmH71oEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnHg2oEhB;AmH91oEgB;EACI,cAAA;AnHg2oEpB;AmH31oEgB;EACI,qBAAA;AnH61oEpB;AmH31oEoB;EACI,cAAA;AnH61oExB;;AmH52oEY;EACI,cAAA;EACA,qBAAA;EACA,2CAAA;AnH+2oEhB;AmH72oEgB;EACI,cAAA;AnH+2oEpB;AmH12oEgB;EACI,qBAAA;AnH42oEpB;AmH12oEoB;EACI,cAAA;AnH42oExB;;AmH33oEY;EACI,cAAA;EACA,qBAAA;EACA,wCAAA;AnH83oEhB;AmH53oEgB;EACI,cAAA;AnH83oEpB;AmHz3oEgB;EACI,qBAAA;AnH23oEpB;AmHz3oEoB;EACI,cAAA;AnH23oExB;;AmHj3oEQ;EACI,qBAAA;EACA,4BAAA;EACA,gDAAA;AnHo3oEZ;AmHn3oEY;EACI,qBAAA;AnHq3oEhB;AmHj3oEY;EACI,4BAAA;AnHm3oEhB;AmHl3oEgB;EACI,qBAAA;AnHo3oEpB;;AoHh7oEA;EACI,kBAAA;EACA,gBAAA;ApHm7oEJ;AoHh7oEI;EACI,eAAA;ApHk7oER;AoH/6oEI;EACI,eAAA;ApHi7oER;;AoHt6oEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXmuoEf;;AoHl6oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXwuoEf;AoHn6oEgB;EACI,yBzG0LL;AX2uoEf;;AoHn7oEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXgvoEf;;AoH/6oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXqvoEf;AoHh7oEgB;EACI,yBzG0LL;AXwvoEf;;AoHh8oEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AX6voEf;;AoH57oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXkwoEf;AoH77oEgB;EACI,yBzG0LL;AXqwoEf;;AoH78oEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AX0woEf;;AoHz8oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AX+woEf;AoH18oEgB;EACI,yBzG0LL;AXkxoEf;;AoH19oEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXuxoEf;;AoHt9oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AX4xoEf;AoHv9oEgB;EACI,yBzG0LL;AX+xoEf;;AoHv+oEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXoyoEf;;AoHn+oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXyyoEf;AoHp+oEgB;EACI,yBzG0LL;AX4yoEf;;AoHp/oEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXizoEf;;AoHh/oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXszoEf;AoHj/oEgB;EACI,yBzG0LL;AXyzoEf;;AoHjgpEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AX8zoEf;;AoH7/oEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXm0oEf;AoH9/oEgB;EACI,yBzG0LL;AXs0oEf;;AoHz/oEA;EACI,eAAA;EACA,gBAAA;ApH4/oEJ;;AoHx/oEA;EACI,eAAA;EACA,qBAAA;ApH2/oEJ;AoHz/oEI;EACI,YAAA;EACA,cAAA;EACA,oBAAA;ApH2/oER;AoHx/oEI;EACI,cAAA;ApH0/oER;AoHt/oEQ;EACI,qBAAA;ApHw/oEZ;;AoH3+oEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXi2oEf;;AoHj/oEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXu2oEf;;AoHv/oEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AX62oEf;;AoH7/oEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXm3oEf;;AoHngpEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXy3oEf;;AoHzgpEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AX+3oEf;;AoH/gpEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXq4oEf;;AoHrhpEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AX24oEf;;AoHhhpEI;EACI,kBAAA;ApHmhpER;AoHjhpEQ;EACI,sBAAA;ApHmhpEZ;AoHjhpEY;EACI,iBAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;ApHmhpEhB;;AoHrgpEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXi6oEf;;AoH3gpEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXu6oEf;;AoHjhpEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AX66oEf;;AoHvhpEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXm7oEf;;AoH7hpEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXy7oEf;;AoHnipEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AX+7oEf;;AoHzipEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXq8oEf;;AoH/ipEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AX28oEf;;AoH1ipEI;EACI,kBAAA;ApH6ipER;AoH3ipEQ;EACI,sBAAA;ApH6ipEZ;AoH3ipEY;EACI,iBAAA;EACA,oCAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;ApH6ipEhB;;AoHpipEA;EACI,oBAAA;EACA,gBAAA;EACA,iBAAA;ApHuipEJ;AoHripEI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ApHuipER;AoHpipEI;EACI,sBAAA;ApHsipER;;AoHlipEA;EACI,qBAAA;EACA,gBAAA;EACA,iBAAA;ApHqipEJ;AoHnipEI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;ApHqipER;;AoHjipEA;EACI,kBAAA;ApHoipEJ;;AoH3hpEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AX8/oEf;;AoHrhpEoB;EACI,czGsBT;AXkgpEf;;AoHpipEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXugpEf;;AoH9hpEoB;EACI,czGsBT;AX2gpEf;;AoH7ipEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXghpEf;;AoHvipEoB;EACI,czGsBT;AXohpEf;;AoHtjpEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXyhpEf;;AoHhjpEoB;EACI,czGsBT;AX6hpEf;;AoH/jpEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXkipEf;;AoHzjpEoB;EACI,czGsBT;AXsipEf;;AoHxkpEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AX2ipEf;;AoHlkpEoB;EACI,czGsBT;AX+ipEf;;AoHjlpEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXojpEf;;AoH3kpEoB;EACI,czGsBT;AXwjpEf;;AoH1lpEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AX6jpEf;;AoHplpEoB;EACI,czGsBT;AXikpEf;;AoH3kpEI;EACI,kBAAA;EACA,sBAAA;ApH8kpER;AoH5kpEQ;EACI,iBAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,czGlED;EgBhJL,iDyFmNM;ApH8kpEZ;A2B7xpEM;EyFuME;IzFtMA,gBAAA;E3BgypEN;AACF;AoHhlpEQ;EACI,sBAAA;EACA,oCzGkuB4B;EgB17BlC,iDyFyNM;ApHklpEZ;A2BvypEM;EyFkNE;IzFjNA,gBAAA;E3B0ypEN;AACF;AoHrlpEY;EACI,WAAA;EACA,UAAA;ApHulpEhB;AoHnlpEQ;EACI,sBAAA;ApHqlpEZ;;AoH9kpEA;EACI,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;ApHilpEJ;AoH/kpEI;EACI,YAAA;EACA,cAAA;EACA,oBAAA;EACA,4BAAA;ApHilpER;AoH9kpEI;EACI,gBAAA;EACA,kBAAA;ApHglpER;;AoH3kpEA;EACI,UAAA;ApH8kpEJ;AoH5kpEI;EACI,0CAAA;EACA,8CAAA;EACA,sBzG2WsB;EyG1WtB,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;ApH8kpER;AoH5kpEQ;EACI,eAAA;ApH8kpEZ;AoH1kpEI;EACI,aAAA;ApH4kpER;AoH1kpEQ;EACI,gCAAA;ApH4kpEZ;AoH1kpEY;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,czGtHH;AXkspEb;AoHpkpEgB;EACI,WzG7JT;AXmupEX;;AoH7jpEQ;EACI,0DAAA;ApHgkpEZ;;AqH53pEA;EACI,kBAAA;ArH+3pEJ;AqH93pEI;EACI,oBAAA;EACA,kBAAA;ArHg4pER;AqH93pEI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;ArHg4pER;AqH73pEQ;EACI,qBAAA;EACA,oB1Gw0BkB;E0Gv0BlB,kBAAA;ArH+3pEZ;AqH73pEQ;EACI,UAAA;EACA,WAAA;ArH+3pEZ;;AqHz3pEI;EACI,0DAAA;EACA,+CAAA;EACA,+CAAA;ArH43pER;AqHz3pEI;EACI,+CAAA;EACA,+CAAA;ArH23pER;;AsH35pEY;EACI,oCAAA;EACA,qB3GsND;AXwspEf;;AsHh6pEY;EACI,oCAAA;EACA,qB3GsND;AX6spEf;;AsHr6pEY;EACI,oCAAA;EACA,qB3GsND;AXktpEf;;AsH16pEY;EACI,oCAAA;EACA,qB3GsND;AXutpEf;;AsH/6pEY;EACI,oCAAA;EACA,qB3GsND;AX4tpEf;;AsHp7pEY;EACI,oCAAA;EACA,qB3GsND;AXiupEf;;AsHz7pEY;EACI,oCAAA;EACA,qB3GsND;AXsupEf;;AsH97pEY;EACI,oCAAA;EACA,qB3GsND;AX2upEf;;AsH37pEA;EACI,yBAAA;AtH87pEJ;;AsH37pEA;EACI,kBAAA;AtH87pEJ;AsH77pEI;EACI,c3GwIG;AXuzpEX;AsH77pEI;EACI,gB3GgnBsB;AX+0oE9B;AsH97pEQ;EACI,W3G6HD;AXm0pEX;AsH97pEQ;EACI,+BAAA;AtHg8pEZ;;AuH59pEA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;AvH+9pEF;;AuH59pEA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AvH+9pEF;;AuH59pEA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AvH+9pEF;;AuH59pEA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AvH+9pEF;;AuH59pEA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA,EAAA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA,EAAA,mFAAA;EACA,eAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,0CAAA;EACA,qBAAA;EACA,uBAAA;AvH+9pEF;;AuH59pEA;;EAEE,aAAA;AvH+9pEF;;AuH59pEA;;EAEE,YAAA;EACA,cAAA;AvH+9pEF;;AuH59pEA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AvH+9pEF;;AuH59pEA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AvH+9pEF;;AuH59pEA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;AvH+9pEF;;AuH59pEA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AvH+9pEF;;AuH59pEA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;AvH+9pEF;;AuH59pEA;EACE,mBAAA;AvH+9pEF;;AuH59pEA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;AvH+9pEF;;AuH59pEA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;AvH+9pEF;;AuH59pEA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;AvH+9pEF;;AuH59pEA;EACE,MAAA;EACA,WAAA;AvH+9pEF;;AuH59pEA;EACE,QAAA;EACA,WAAA;AvH+9pEF;;AuH59pEA;EACE,OAAA;EACA,YAAA;AvH+9pEF;;AuH59pEA;EACE,YAAA;EACA,SAAA;EACA,UAAA;AvH+9pEF;;AuH59pEA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AvH+9pEF;;AuH59pEA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;AvH+9pEF;;AuH59pEA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AvH+9pEF;;AuH59pEA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AvH+9pEF;;AuH59pEA;EACE,YAAA;AvH+9pEF;;AuH19pEI;EACE,mB5GES;AX29pEf;;AuH99pEI;EACE,mB5GES;AX+9pEf;;AuHl+pEI;EACE,mB5GES;AXm+pEf;;AuHt+pEI;EACE,mB5GES;AXu+pEf;;AuH1+pEI;EACE,mB5GES;AX2+pEf;;AuH9+pEI;EACE,mB5GES;AX++pEf;;AuHl/pEI;EACE,mB5GES;AXm/pEf;;AuHt/pEI;EACE,mB5GES;AXu/pEf;;AwHxtqEA;;;;EAAA;AAMA;;EAEI,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,sEAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAIA,WAAA;EAKA,aAAA;AxHwtqEJ;;AwH7sqEA;;;;EAII,iBAAA;EACA,mBAAA;AxHwtqEJ;;AwHrtqEA;EACI;;IAEI,iBAAA;ExHwtqEN;AACF;AwHrtqEA,gBAAA;AACA;EACI,YAAA;EACA,SAAA;EACA,cAAA;AxHutqEJ;;AwHptqEA;;EAEI,sCAAA;AxHutqEJ;;AwHptqEA,gBAAA;AACA;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;AxHutqEJ;;AwHptqEA;;;;EAII,gBAAA;AxHutqEJ;;AwHptqEA;EACI,WAAA;AxHutqEJ;;AwHptqEA;EACI,YAAA;AxHutqEJ;;AwHptqEA;;;;;;;EAOI,c7G6FS;AX0nqEb;;AwHptqEA;;;;;;EAMI,WAAA;AxHutqEJ;;AwHptqEA;;;;;EAKI,cAAA;EACA,oEAAA;EACA,kCAAA;AxHutqEJ;;AwHptqEA;;;EAGI,WAAA;AxHutqEJ;;AwHptqEA;;EAEI,cAAA;AxHutqEJ;;AwHptqEA;;;EAGI,WAAA;AxHutqEJ;;AwHptqEA;;EAEI,iBAAA;AxHutqEJ;;AwHrtqEA;EACI,kBAAA;AxHwtqEJ;;AwHrtqEA;EACI,YAAA;AxHwtqEJ;;AwHrtqEA,iBAAA;AACA;;EAEI,mB7GQO;AXgtqEX;;AwHrtqEA;;EAEI,c7GOO;E6GNP,iBAAA;AxHwtqEJ;;AwHhtqEI;EACI,wBAAA;AxHmtqER;AwHhtqEI;EACI,WAAA;AxHktqER;AwH/sqEI;EACI,YAAA;AxHitqER;AwH9sqEI;EACI,+CAAA;EACA,mBAAA;EACA,iCAAA;AxHgtqER;AwH7sqEI;EACI,mBAAA;EACA,iCAAA;AxH+sqER;;AwHxsqEA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AxH2sqEJ;;AwHtsqEA;EACI,6BAAA;EACA,sBAAA;EACA,qBAAA;AxHysqEJ;;AwHtsqEA;EACI,qBAAA;AxHysqEJ;AwHxsqEI;EACI,gCAAA;EACA,kCAAA;EACA,mCAAA;EACA,gJAAA;EACA,gCAAA;EACA,qDAAA;EACA,6BAAA;EACA,yBAAA;EACA,2BAAA;AxH0sqER;AwHzsqEQ;EACI,wBAAA;EACA,2BAAA;AxH2sqEZ;AwHzsqEQ;EACI,oCAAA;EACA,sBAAA;AxH2sqEZ;;AyHz6qEE;EACE,oBAAA;EACA,eAAA;EACA,gB9G0HiB;AXkzqErB;;AyHx6qEA;EACE,oBAAA;EACA,qB9GinB4B;E8GhnB5B,0CAAA;EACA,2BAAA;AzH26qEF;AyHz6qEE;EACE,8BAAA;AzH26qEJ;AyHx6qEE;EACE,2BAAA;AzH06qEJ;;AyHt6qEA;EACE,4CAAA;EACA,2BAAA;AzHy6qEF;;AyHt6qEA;EACE,eAAA;AzHy6qEF;;AyHr6qEE;EACE,qB9GyJS;E8GxJT,c9GwJS;AXgxqEb;AyHr6qEI;EACE,yB9GkJO;AXqxqEb;AyHp6qEI;EACE,qCAAA;AzHs6qEN;AyHn6qEE;EACE,qB9GyIS;E8GxIT,c9GwIS;AX6xqEb;;AyHh6qEE;EACE,gBAAA;AzHm6qEJ;;AyH/5qEA;EACE,qDAAA;AzHk6qEF;;AyH/5qEA;EACE,yCAAA;AzHk6qEF;;AyH95qEE;EACE,mB9G+GS;AXkzqEb;AyHh6qEI;EACE,mB9G6GO;AXqzqEb;AyHj6qEM;EACE,mCAAA;AzHm6qER;AyH/5qEE;EACE,mB9GsGS;AX2zqEb;;AyH55qEE;EACE,qCAAA;EACA,sCAAA;AzH+5qEJ;;AyH35qEA;EACE,wCAAA;AzH85qEF;AyH75qEE;EACE,gBAAA;EACA,0C9Gw3BoC;AXuipExC;;AyH35qEA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EhH6LI,oBALI;EgHrLR,gB9GmlB4B;E8GllB5B,gB9GylB4B;E8GxlB5B,2B9Gk2BsC;E8Gj2BtC,oC9G41BsC;E8G31BtC,4BAAA;EACA,wCAAA;AzH65qEF;;AyH15qEA;EACE,sC9G8jB4B;E8G7jB5B,gB9GwkB4B;E8GvkB5B,eAAA;AzH65qEF;AyH55qEE;EACE,gBAAA;AzH85qEJ;AyH35qEE;EACE,c9G4DS;AXi2qEb;;AyHz5qEA;EACE,6BAAA;AzH45qEF;;A0HxhrEA;EACE,iBAAA;EACA,yCAAA;EACA,oCAAA;EACA,kBAAA;A1H2hrEF;A0HzhrEE;EACE,eAAA;EACA,WAAA;EACA,aAAA;A1H2hrEJ;;A2HpirEA;EACE,mBhHwLW;AX+2qEb;;A2HpirEA;EACE,mBhHoLW;EgHnLX,mCAAA;EACA,gBAAA;A3HuirEF;;A2HpirEA;EACE,WAAA;A3HuirEF;A2HtirEE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;A3HwirEJ;A2HtirEI;EACE,aAAA;A3HwirEN;A2HtirEI;EACE,UAAA;A3HwirEN;;A2HnirEA;EACE,YAAA;A3HsirEF;;A2HjirEA;EACE,sBAAA;EACA,oChHilB4B;EgHhlB5B,qBhHqlB4B;EgHplB5B,0CAAA;EACA,2BAAA;A3HoirEF;;A2H/hrEA;EACE,UAAA;A3HkirEF;A2HjirEE;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;A3HmirEJ;A2HlirEI;EACE,aAAA;A3HoirEN;A2HlirEI;EACE,UAAA;A3HoirEN;A2HhirEE;EACE,MAAA;A3HkirEJ;;A2H9hrEA;EACE,eAAA;A3HiirEF;;A2H7hrEE;EACE,YAAA;A3HgirEJ;;A2H5hrEA;EACE,gBAAA;A3H+hrEF;;A2H5hrEA;EACE,gBAAA;EACA,iCAAA;EACA,6BAAA;A3H+hrEF;;A2H3hrEE;EACE,UAAA;A3H8hrEJ;;A2HxhrEA;EACC,YAAA;EACA,qBAAA;EACA,aAAA;A3H2hrED;;A2HxhrEA;EACC,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,wCAAA;A3H2hrED;;A2HxhrEA;EACC,iBAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,wCAAA;EACG,mBAAA;EACA,kBAAA;A3H2hrEJ;;A2HvhrEI;EACI,mBhH6DK;AX69qEb;;A2HrhrEI;EACI,mBhH0DK;AX89qEb;;A2HnhrEI;EACI,mBhH8CK;AXw+qEb;;A2H/grEI;EACI,2BAAA;A3HkhrER;;A2H3grEA;EACI,eAAA;EACA,chHKO;EgHJP,cAAA;EACA,cAAA;A3H8grEJ;A2H7grEI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;A3H+grER;;A2HzgrEA;EACI,aAAA;A3H4grEJ;;A2H1grEA;EACI,cAAA;A3H6grEJ;;A2HxgrEA;EAAa,mBhHWA;AXigrEb;;A2H3grEA;EAAa,mBhHYA;AXmgrEb;;A2H9grEA;EAAa,mBhHYA;AXsgrEb;;A2HjhrEA;EAAa,mBhHKA;AXghrEb;;A2HphrEA;EAAa,mBhHKA;AXmhrEb;;A2HphrEA;EACI,YAAA;A3HuhrEJ;A2HrhrEQ;EACI,qBhHDC;AXwhrEb;;A2H9grEI;EACE,mBhH2BS;AXs/qEf;A2H9grEI;EACE,mBhHuBS;AXy/qEf;A2H5grEM;EACE,qBhHkBO;AX4/qEf;;A2HxhrEI;EACE,mBhH2BS;AXggrEf;A2HxhrEI;EACE,mBhHuBS;AXmgrEf;A2HthrEM;EACE,qBhHkBO;AXsgrEf;;A2HlirEI;EACE,mBhH2BS;AX0grEf;A2HlirEI;EACE,mBhHuBS;AX6grEf;A2HhirEM;EACE,qBhHkBO;AXghrEf;;A2H5irEI;EACE,mBhH2BS;AXohrEf;A2H5irEI;EACE,mBhHuBS;AXuhrEf;A2H1irEM;EACE,qBhHkBO;AX0hrEf;;A2HtjrEI;EACE,mBhH2BS;AX8hrEf;A2HtjrEI;EACE,mBhHuBS;AXiirEf;A2HpjrEM;EACE,qBhHkBO;AXoirEf;;A2HhkrEI;EACE,mBhH2BS;AXwirEf;A2HhkrEI;EACE,mBhHuBS;AX2irEf;A2H9jrEM;EACE,qBhHkBO;AX8irEf;;A2H1krEI;EACE,mBhH2BS;AXkjrEf;A2H1krEI;EACE,mBhHuBS;AXqjrEf;A2HxkrEM;EACE,qBhHkBO;AXwjrEf;;A2HplrEI;EACE,mBhH2BS;AX4jrEf;A2HplrEI;EACE,mBhHuBS;AX+jrEf;A2HllrEM;EACE,qBhHkBO;AXkkrEf;;A2H3krEE;EACE,YAAA;A3H8krEJ;A2H5krEI;EACE,WAAA;EACA,YAAA;A3H8krEN;;A2HxkrEE;EACE,WAAA;A3H2krEJ;A2HzkrEI;EACE,WAAA;EACA,YAAA;A3H2krEN;;A2HrkrEE;EACE,WAAA;A3HwkrEJ;A2HtkrEI;EACE,WAAA;EACA,YAAA;A3HwkrEN;;A2HhkrEE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;A3HmkrEJ;A2HjkrEE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;A3HmkrEJ;;A2H9jrEE;EACE,qBhH3ES;EgH4ET,sBhHhHO;AXirrEX;;A2H5jrEE;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,qBhHvFS;EgHwFT,sBhH5HO;AX2rrEX;;A4H/0rEI;EACI,0CAAA;EACA,sCAAA;A5Hk1rER;;A4H90rEA;EACI,eAAA;A5Hi1rEJ;;A4H50rEI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;A5H+0rER;A4H70rEI;EACI,kBAAA;A5H+0rER;;A6Hz2rEA;EACI,oCAAA;EACA,4ClHioB0B;AX2uqE9B;;A6Hv2rEQ;EACI,iCAAA;EACA,uBAAA;A7H02rEZ;A6Hv2rEQ;EACI,qCAAA;A7Hy2rEZ;A6Hx2rEY;EACI,qCAAA;A7H02rEhB;;A6Hp2rEA;EACI,iCAAA;A7Hu2rEJ;;A6Hp2rEA;EACI,eAAA;EACA,gBlHoGiB;EkHnGjB,2BAAA;A7Hu2rEJ;;A6Hp2rEA;EACI,gBlHk7CgC;EkHj7ChC,oBlHmpB0B;EkHlpB1B,2BAAA;A7Hu2rEJ;;A6Hn2rEI;EACI,6DAAA;EACA,WlH8GG;AXwvrEX;A6Hn2rEI;EACI,2CAAA;EACA,qBAAA;A7Hq2rER;A6Hl2rEI;EACI,6DAAA;EACA,WlHoGG;AXgwrEX;;A6Hh2rEA;EACI,0BAAA;A7Hm2rEJ;;A6Hj2rEA;;EAEI,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,UAAA;EACA,wCAAA;EACA,uBAAA;EACA,clHmHS;AXivrEb;;A6Hj2rEA;EACI,UAAA;A7Ho2rEJ;;A6Hj2rEA;EACI,oBAAA;A7Ho2rEJ;;A8H76rEA;EACI,uBAAA;EACA,sBAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;A9Hg7rEJ;A8H/6rEI;EACI,iCAAA;EACA,0BAAA;EACA,cAAA;EACA,yBAAA;A9Hi7rER;;A8H56rEI;EACI,2BAAA;A9H+6rER;;A8H36rEI;EACI,2BAAA;A9H86rER;;A8H16rEA;EACI,sBAAA;EACA,sBAAA;EACA,iCAAA;EACA,8BAAA;EACA,gBnHymB0B;AXo0qE9B;A8H56rEI;EACI,UAAA;A9H86rER;;A8Hz6rEI;EACI,UAAA;EACA,WAAA;EACA,sBnH8GG;EmH7GH,YAAA;EACA,yBAAA;A9H46rER;A8H36rEQ;EACI,UAAA;EACA,WAAA;A9H66rEZ;;A8Hx6rEA;EACI,WnHmGO;EmHlGP,eAAA;EACA,oCAAA;EACA,0BAAA;A9H26rEJ;;A8Ht6rEI;EACI,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;EACA,uBAAA;EACA,yBAAA;A9Hy6rER;A8Hx6rEQ;EACI,yBAAA;EACA,qBAAA;A9H06rEZ;;A8Hr6rEA;EACI,sBAAA;EACA,qDAAA;A9Hw6rEJ;A8Hv6rEI;EACI,oCAAA;A9Hy6rER;;A8Hp6rEA;EACI,2CAAA;EACA,0BAAA;EACA,cAAA;EACA,sBAAA;A9Hu6rEJ;A8Ht6rEI;EACI,sBnH6DG;AX22rEX;;A8Hn6rEI;EACI,oCAAA;A9Hs6rER;A8Hn6rEQ;EACI,oCAAA;A9Hq6rEZ;A8Hj6rEQ;EACI,WnH8CD;AXq3rEX;A8Hl6rEY;EACI,UAAA;A9Ho6rEhB;A8Hh6rEI;EACI,wCAAA;A9Hk6rER;;A+HhhsEA;EACE,YAAA;EACA,kBAAA;A/HmhsEF;A+HjhsEE;EACE,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cpHyIO;EoHxIP,iCAAA;EACA,UAAA;A/HmhsEJ;A+HhhsEE;EACE,wCAAA;EACA,oCpH46BoC;EoH36BpC,+BpH+lB0B;EoH9lB1B,kCpH8lB0B;AXo7qE9B;A+H9gsEI;EACE,wBAAA;A/HghsEN;A+H7gsEI;EACE,WAAA;A/H+gsEN;A+H5gsEI;EACE,WAAA;A/H8gsEN;A+H3gsEI;EACE,+CAAA;EACA,mBAAA;EACA,oCAAA;A/H6gsEN;A+H1gsEI;EACE,mBAAA;EACA,oCpHk5BkC;AX0nqExC;A+HxgsEE;EACE,eAAA;A/H0gsEJ;A+HvgsEE;EACE,2BpH84BoC;AX2nqExC;A+HxgsEI;EACE,yCAAA;A/H0gsEN;A+HtgsEE;EACE,wCAAA;EACA,8BpHi4BoC;EoHh4BpC,gCpHojB0B;EoHnjB1B,mCpHmjB0B;AXq9qE9B;A+HrgsEE;EACE,cAAA;EACA,sBAAA;EAEA,oBpHsmB0B;EoHrmB1B,2BpH43BoC;EoH33BpC,oCpHs3BoC;EoHr3BpC,wCAAA;EACA,sBpHwiB0B;EoHviB1B,mBAAA;A/HsgsEJ;A+HrgsEI;EACE,cpHuEK;AXg8rEX;A+HngsEE;EACE,gBpHimB0B;EoHhmB1B,yBAAA;A/HqgsEJ;;AgIhmsEA;EACE,oCAAA;EACA,6CrHmoB4B;EqHloB5B,kBAAA;EACA,wCAAA;AhImmsEF;;AgI/lsEE;EACE,0CAAA;EACA,gDAAA;EACA,kBAAA;EACA,gBrH2nB0B;AXu+qE9B;AgIjmsEI;EACE,kBAAA;AhImmsEN;;AgI3lsEM;EACE,oBAAA;EACA,cAAA;AhI8lsER;AgI3lsEM;EACE,mBAAA;EACA,eAAA;AhI6lsER;AgIvlsEI;EACE,eAAA;AhIylsEN;AgIplsEI;EACE,mBrH0IO;AX48rEb;AgInlsEI;EACE,oCrHw5BkC;EqHv5BlC,2BrH45BkC;EqH35BlC,wCAAA;EACA,sBrHykBwB;AX4grE9B;AgIllsEI;EACE,iCAAA;AhIolsEN;AgInlsEM;EACE,gBAAA;EACA,oCrH84BgC;EqH74BhC,0CrH45BgC;AXyrqExC;AgIjlsEI;EACE,8BAAA;AhImlsEN;AgIhlsEI;EACE,8BAAA;AhIklsEN;;AiIppsEA;EACE,gBAAA;AjIupsEF;AiIppsEI;EACE,eAAA;AjIspsEN;;AiIjpsEA;EACE,yCAAA;EACA,oCAAA;AjIopsEF;;AiIjpsEA;EACE,2BAAA;AjIopsEF;AiInpsEE;EACE,gBtH6GiB;AXwisErB;;AiIjpsEA;EACE,aAAA;AjIopsEF;;AiIjpsEA;EACE,oCAAA;AjIopsEF;;AkI9qsEA;;EAEI,wBAAA;EACA,YAAA;AlIirsEJ;;AkI9qsEA;EACI,wCAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EtHIA,sBAAA;EsHFA,8BvHy7BoC;EuHx7BpC,YAAA;AlIirsEJ;AkI/qsEI;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,2BvHq7BgC;EuHp7BhC,sBvHmmBsB;AX8krE9B;AkI/qsEQ;EACI,UAAA;AlIirsEZ;AkI7qsEI;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;EACA,YAAA;EACA,sBvHklBsB;AX6lrE9B;AkI5qsEI;EACI,2BAAA;AlI8qsER;AkI5qsEQ;EACI,oCvHu5B4B;AXuxqExC;AkI1qsEI;EACI,2BAAA;AlI4qsER;AkI1qsEQ;EACI,oCvH+4B4B;AX6xqExC;AkIxqsEI;EACI,aAAA;EACA,WAAA;AlI0qsER;AkIxqsEQ;EACI,cAAA;AlI0qsEZ;AkIvqsEQ;EACI,YAAA;AlIyqsEZ;;AkIhqsEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AX4lsEX;;AkIrqsEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXimsEX;;AkI1qsEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXsmsEX;;AkI/qsEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AX2msEX;;AkIprsEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXgnsEX;;AkIzrsEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXqnsEX;;AkI9rsEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AX0nsEX;;AkInssEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AX+nsEX;;AmIrxsEA;EACI,iDAAA;AnIwxsEJ;AmItxsEI;EACI,sCAAA;AnIwxsER;AmItxsEI;EACI,sDAAA;AnIwxsER;AmIrxsEI;EACI,gBAAA;AnIuxsER;AmIpxsEI;EACI,mDAAA;AnIsxsER;AmIpxsEQ;EACI,0BAAA;AnIsxsEZ;AmInxsEQ;EACI,kCAAA;AnIqxsEZ;AmIjxsEI;EACI,wBAAA;EACA,qDAAA;EACA,+CAAA;EACA,2BAAA;AnImxsER;AmIhxsEI;EACI,2CAAA;EACA,6CxHkmBsB;EwHjmBtB,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBxHqlBsB;AX6rrE9B;AmI/wsEI;EACI,2CAAA;AnIixsER;AmI5wsEY;EAEI,OAAA;EACA,sBAAA;AnI6wsEhB;AmIvwsEQ;EACI,2BAAA;AnIywsEZ;AmIrwsEI;EACI,wDAAA;EACA,gCAAA;EACA,mDAAA;AnIuwsER;;AmIhwsEI;;;EACI,2BAAA;EACA,4CAAA;AnIqwsER;AmIjwsEQ;;EACI,sCAAA;AnIowsEZ;AmIhwsEI;;EACI,sCAAA;AnImwsER;;AmI/vsEA;;EAEI,iCAAA;EACA,uCAAA;EACA,wCAAA;AnIkwsEJ;;AmI/vsEA;;EAEI,iCAAA;EACA,oCAAA;EACA,qCAAA;AnIkwsEJ;;AmI/vsEA;EACI,4BAAA;AnIkwsEJ;;AmI/vsEA;EACI,2BAAA;AnIkwsEJ;;AmI3vsEY;;;EAEI,2BAAA;AnI+vsEhB;;AmIvvsEQ;EACI,8BAAA;EACA,yBAAA;AnI0vsEZ;AmItvsEI;EACI,yCAAA;EACA,mDAAA;AnIwvsER;AmIvvsEQ;EACI,yDAAA;EACA,2BAAA;AnIyvsEZ;AmIrvsEI;EACI,2BAAA;EACA,mDAAA;AnIuvsER;AmIpvsEY;EACI,oCAAA;AnIsvsEhB;AmInvsEY;EACI,sDAAA;AnIqvsEhB;;AmI7usEA;EACI,2BAAA;AnIgvsEJ;;AmI1usEI;EACE,aAAA;EACA,8BAAA;AnI6usEN;AmIzusEM;EACE,mDAAA;EACA,2BAAA;AnI2usER;AmIvusEI;;EAEE,iCAAA;EACA,uCAAA;EACA,wCAAA;AnIyusEN;AmItusEI;;EAEE,iCAAA;EACA,oCAAA;EACA,qCAAA;AnIwusEN;;AmInusEI;EACI,2BAAA;AnIsusER;;AoIv6sEA;EACI,gBAAA;ApI06sEJ;AoIx6sEI;;EAEI,mBAAA;EACA,gBAAA;ApI06sER;AoIv6sEI;EACI,mBAAA;EACA,mBAAA;EACA,iBAAA;ApIy6sER;;AoIr6sEA;EACI,sCzH6pB0B;AX2wrE9B;AoIt6sEI;EACI,oCzHw7BgC;EyHv7BhC,8BAAA;EACA,+BAAA;ApIw6sER;;AoIp6sEA;EACI,wCAAA;EACA,sBzH8lB0B;AXy0rE9B;;AoIp6sEA;EACI,iDAAA;ApIu6sEJ;AoIr6sEI;EACI,wBAAA;EACA,mCAAA;ApIu6sER;AoIr6sEQ;EACI,yBAAA;ApIu6sEZ;AoIn6sEI;EACI,2BAAA;EACA,4BAAA;EACA,oCzH85BgC;AXugrExC;AoIl6sEY;EACI,yBAAA;ApIo6sEhB;AoIh6sEQ;EACI,6CzH8kBkB;EyH7kBlB,qBzHokBkB;AX81rE9B;;AoI35sEI;;;EAGI,oCAAA;ApI85sER;AoI35sEI;EACI,kCAAA;ApI65sER;AoIz5sEQ;EACI,QAAA;EACA,UAAA;ApI25sEZ;AoIt5sEQ;EACI,mCAAA;ApIw5sEZ;;AoIl5sEI;EACI,sCAAA;EACA,+CAAA;ApIq5sER;;AqI/+sEA;EACI,2B1HqyB0B;E0HpyB1B,UAAA;EACA,cAAA;ArIk/sEJ;;AqI/+sEA;EACI,gBAAA;EACA,wCAAA;EACA,kBAAA;ArIk/sEJ;AqIh/sEI;EACI,wBAAA;ArIk/sER;AqI/+sEI;EACI,WAAA;ArIi/sER;AqI9+sEI;EACI,YAAA;ArIg/sER;AqI7+sEI;EACI,iDAAA;EACA,mBAAA;EACA,0CAAA;ArI++sER;AqI5+sEI;EACI,mBAAA;EACA,0CAAA;ArI8+sER;;AqI1+sEA;EACI,uBAAA;EACA,iBAAA;ArI6+sEJ;;AqI1+sEA;EACI,WAAA;ArI6+sEJ;;AqI1+sEA;EACI,6B1H0vB0B;AXmvrE9B;;AqI1+sEA;;EAEI,wCAAA;EACA,uBAAA;ArI6+sEJ;;AqIz+sEI;EACI,aAAA;EACA,2B1H6uBsB;E0H5uBtB,iDAAA;ArI4+sER;AqIt+sEQ;EAEI,iDAAA;ArIu+sEZ;;AqIl+sEA;EACI,cAAA;ArIq+sEJ;;AqIl+sEA;EACI,gBAAA;EACA,wCAAA;EACA,aAAA;EACA,6B1HwtB0B;AX6wrE9B;;AqIl+sEA;EACI,c1HyEO;E0HxEP,0BAAA;ArIq+sEJ;;AqIh+sEI;EACI,mBAAA;EACA,iCAAA;EACA,wCAAA;EACA,0C1HutC4B;E0HttC5B,2B1HsckC;AX6hsE1C;AqIj+sEQ;EACI,8CAAA;ArIm+sEZ;AqIh+sEQ;EAGI,c1HqDD;E0HpDC,0C1H4sCwB;AXoxqEpC;AqI79sEQ;EACI,yB1H4CD;E0H3CC,iC1H0b8B;AXqisE1C;AqI59sEQ;EACI,gBAAA;ArI89sEZ;AqIz9sEY;EACI,6BAAA;ArI29sEhB;AqIv9sEQ;EACI,yB1HwDC;E0HvDD,W1HyBD;E0HxBC,qB1HsDC;E0HrDD,gBAAA;ArIy9sEZ;;AqIp9sEA;EACI,kBAAA;EACA,WAAA;ArIu9sEJ;AqIr9sEI;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,c1HYG;AX28sEX;;AqIn9sEA;EACI,oC1HuzBoC;E0HtzBpC,oC1HgzBoC;E0H/yBpC,2B1HozBoC;E0HnzBpC,gB1HyiB0B;E0HxiB1B,sCAAA;EACA,sB1Hge0B;EFzVxB,oBALI;ATq1sEV;AqIp9sEI;EACI,gBAAA;EACA,0C1HszBgC;E0HrzBhC,oC1HsyBgC;AXgrrExC;AqIn9sEI;EACI,c1HRG;AX69sEX;;AqIh9sEI;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,gB1H8gBsB;AXq8rE9B;;AqI/8sEA;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;ArIk9sEJ;;AqI/8sEA;EACI,wBAAA;ArIk9sEJ;;AqI98sEI;EACI,oBAAA;ArIi9sER;;AqIx8sEI;EACI,sBAAA;ArI28sER;AqIx8sEI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;ArI08sER;AqIv8sEI;EACI,iBAAA;ArIy8sER;;AqIn8sEI;EACI,8C1HwlBsB;AX82rE9B;AqIp8sEI;EACI,yB1HzCK;E0H0CL,qB1H1CK;E0H8CD,0DAAA;ArIm8sEZ;;AqI97sEI;EACI,Y1HowBkC;E0HnwBlC,a1HmwBkC;E0HlwBlC,mBAAA;EACA,oC1H2tBgC;E0H1tBhC,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8C1HwwBkC;E0HvwBlC,gBAAA;EACA,yBAAA;ArIi8sER;AqI/7sEQ;EzHpOJ,qBAAA;AZsqtEJ;;AqI37sEI;EACI,qBAAA;EACA,oBAAA;ArI87sER;;AqI17sEA;EACI,0CAAA;ArI67sEJ;;AqIx7sEQ;EACI,kD1H07CiB;AXigqE7B;;AsIlstEA;EACI,gBAAA;EACA,yBAAA;EACA,QAAA;AtIqstEJ;AsInstEQ;EACI,cAAA;EACA,yBAAA;EACA,2B3H4hB8B;E2H3hB9B,0C3H2yCwB;E2H1yCxB,wCAAA;EACA,sB3H+mBkB;AXslsE9B;AsIjstEY;EACI,W3HsIL;EiBtJT,yBjBoLW;E2HlKG,qB3HkKH;AXiitEb;;AsI7rtEA;EACI,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;AtIgstEJ;AsI/rtEI;EACI,qBAAA;EACA,qBAAA;AtIistER;;AsI7rtEA;;EAEI,c3HgJS;E2H/IT,gB3H0FiB;E2HzFjB,yBAAA;EACA,0C3H6wCgC;E2H5wChC,wCAAA;EACA,sB3HilB0B;AX+msE9B;AsI/rtEI;;EACI,0DAAA;AtIkstER;AsI/rtEI;;EACI,c3H6GG;E2H5GH,eAAA;AtIkstER;AsIhstEQ;;EACI,c3HyGD;AX0ltEX;;AuItvtEA;EACI,2BAAA;AvIyvtEJ;AuIxvtEI;EACI,iDAAA;AvI0vtER;AuIxvtEI;EACI,cAAA;AvI0vtER;;AuItvtEA;;EAEI,iDAAA;AvIyvtEJ;;AuItvtEA;EACI,mDAAA;EACA,qDAAA;EACA,uDAAA;AvIyvtEJ;AuIxvtEI;EACI,iDAAA;EACA,yBAAA;AvI0vtER;AuIvvtEI;EACI,4DAAA;EACA,0DAAA;AvIyvtER;;AuIpvtEI;EACI,sBAAA;AvIuvtER;;AuInvtEA;EACI,gB5H0FiB;AX4ptErB;;AuInvtEA;EACI,oBAAA;EACA,uCAAA;AvIsvtEJ;;AuInvtEA;EACI,yBAAA;EACA,iDAAA;EACA,0BAAA;AvIsvtEJ;;AuInvtEA;EACI,qBAAA;AvIsvtEJ;;AuInvtEA;EACI,a5HmGO;AXmptEX;;AuIjvtEI;;EACI,iDAAA;EACA,a5H4FG;AXyptEX;;AuIjvtEA;EACI,gBAAA;AvIovtEJ;;AuI/utEA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;AvIkvtEJ;;AuI/utEA;EACI,eAAA;AvIkvtEJ;;AuI/utEA;;EAEI,UAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,wCAAA;AvIkvtEJ;;AuI/utEA;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;AvIkvtEJ;AuIjvtEI;EACI,wBAAA;EACA,6BAAA;AvImvtER;;AuI/utEA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,6BAAA;AvIkvtEJ;AuIjvtEI;EACI,sCAAA;EACA,wBAAA;EACA,UAAA;AvImvtER;;AuI/utEA;EACI;IACI,0BAAA;EvIkvtEN;EuIhvtEE;IACI,2BAAA;EvIkvtEN;AACF;AuI5utEI;EACI,8B5HofsB;AX0vsE9B;;AuIzutEI;EACI,8B5H8esB;AX8vsE9B;AuI1utEI;EACI,0BAAA;AvI4utER;;AuIputEQ;;EACI,8BAAA;AvIwutEZ;AuIputEI;EACI,8BAAA;AvIsutER;AuIjutEQ;;EACI,gCAAA;AvIoutEZ;AuI/ttEQ;EACI,uBAAA;AvIiutEZ;AuI7ttEI;EACI,gCAAA;AvI+ttER;AuI3ttEQ;EACI,8BAAA;AvI6ttEZ;AuIvttEQ;;EACI,gCAAA;AvI0ttEZ;;AwI/4tEA;EACE,iBAAA;AxIk5tEF;;AyIp5tEA;EACI,aAAA;AzIu5tEJ;;AyIp5tEA;EACI,aAAA;AzIu5tEJ;;A0I35tEA;EACE,aAAA;EACA,mB/HoJS;E+HnJT,kBAAA;A1I85tEF;;A0I35tEA;EACE,cAAA;EACA,kBAAA;EACA,W/H4IS;E+H3IT,eAAA;EACA,iBAAA;EACA,mB/HuKW;E+HtKX,kBAAA;EACA,kBAAA;A1I85tEF;;A0I35tEA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;A1I85tEF;A0I75tEE;EACE,aAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;A1I+5tEJ;A0I75tEE;EACE,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;A1I+5tEJ;;A2Ij8tEA;EACI,cAAA;A3Io8tEJ;A2Il8tEI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,oBhI2qBsB;EgI1qBtB,gBhIgrBsB;EgI/qBtB,gBhIsrBsB;EgIrrBtB,2BhI+7BgC;EgI97BhC,oChIy7BgC;EgIx7BhC,4BAAA;EACA,wCAAA;EACA,sBhI0mBsB;EgIzmBtB,sBAAA;A3Im8tER;A2Ij8tEQ;EACI,qBAAA;EACA,yBAAA;EACA,+BAAA;A3Im8tEZ;A2Ih8tEQ;EACI,8CAAA;EACA,2BhIg7B4B;AXkhsExC;A2I/7tEQ;EACI,2BhI46B4B;AXqhsExC;A2I77tEI;EACI,sBhIslBsB;EgIrlBtB,oChIwtC4B;EgIvtC5B,sBhIgHG;EgI/GH,6ChI8lBsB;EgI7lBtB,UAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA;A3I+7tER;A2I77tEQ;EACI,oBhImoBkB;EgIloBlB,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBhIiGD;EgIhGC,2BhIqsCwB;AX0vrEpC;A2I77tEY;EACI,chI8HH;EgI7HG,gBhIioBc;EgIhoBd,YAAA;A3I+7tEhB;A2I57tEY;EAEI,4BhIssCoB;EiBtwClC,yBjBuJS;AXu2tEX;A2Iz7tEQ;EACI,sBAAA;EACA,kBAAA;EACA,gBhIuDS;AXo4tErB;;A4InguEA;EACI,kBAAA;EACA,yBjIkLS;EiIjLT,sCjI2qB0B;EiI1qB1B,6CjIioB0B;EiIhoB1B,gBAAA;A5IsguEJ;;A4IlguEI;EACI,sCjIoqBsB;EiInqBtB,oBjIyqBsB;EiIxqBtB,wBAAA;A5IqguER;;A4IjguEA;EACI,yBjImKS;AXi2tEb;;A6IrhuEA;EACI,aAAA;A7IwhuEJ;A6IvhuEI;EACI,UAAA;EACA,kClII0C;AXqhuElD;;A8I5huEA;;EAEI,wCAAA;A9I+huEJ;;A8I1huEQ;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;A9I6huEZ;A8I1huEQ;EAEI;;;IAGI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;E9I2huEd;E8IxhuEU;IACI,WAAA;E9I0huEd;E8IvhuEU;IACI,aAAA;E9IyhuEd;AACF;A8IthuEQ;EACI,0BAAA;A9IwhuEZ;A8IphuEI;EACI,iCAAA;A9IshuER;A8InhuEI;EACI,cAAA;EACA,gBAAA;A9IqhuER;A8IlhuEI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBnIqEa;EmIpEb,WAAA;A9IohuER;A8IhhuEQ;EACI,yCAAA;A9IkhuEZ;A8IhhuEY;EACI,yBnIiHH;EmIhHG,WnIkFL;AXg8tEX;A8I5guEQ;EACI,yCAAA;A9I8guEZ;A8IzguEQ;EACI,yCAAA;A9I2guEZ;A8IvguEI;EACI,uBAAA;A9IyguER;A8IrguEQ;EACI,sBAAA;A9IuguEZ;A8InguEI;;;EAGI,sBAAA;A9IqguER;A8IlguEI;EACI,6CAAA;EACA,4CAAA;A9IoguER;A8IjguEI;EACI,aAAA;A9ImguER;;A8I//tEA;EACI,2BAAA;A9IkguEJ;;A8I//tEA;EACI,WnIkCO;AXg+tEX;;A8I9/tEI;EACI,mBnIgCG;EmI/BH,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBnI+jBsB;AXk8sE9B;;A8I3/tEI;;;;;;;;;;EAUI,qBnIYG;AXk/tEX;A8I3/tEI;EACI,sCAAA;A9I6/tER;;A8Iz/tEA;EACI,oCAAA;EACA,oCnI+d0B;EmI9d1B,cnIKO;EmIJP,0BAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;A9I4/tEJ;;A8Iz/tEA;;;EAGI,yBnIkBS;EmIjBT,WnIbO;EmIcP,iBAAA;A9I4/tEJ;;A8Iz/tEA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A9I4/tEJ;;A8Iz/tEA;;EAEI,yBnICS;AX2/tEb;;A8Iz/tEA;;EAEI,yBnIJS;AXgguEb;;A8Ir/tEA;;EAEI,2BAAA;EACA,uBAAA;EACA,mBAAA;A9Iw/tEJ;;A8Ir/tEA;EACI,6BAAA;EACA,aAAA;A9Iw/tEJ;;A8Ir/tEA;EACI,aAAA;A9Iw/tEJ;;A8Ir/tEA;EACI,WnI1DO;AXkjuEX;;A8Ip/tEI;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;A9Iu/tER;;A8Ij/tEI;EACI,cnIvEG;AX2juEX;;A8Ih/tEA;;EAEI,kBAAA;EACA,cAAA;EACA,aAAA;A9Im/tEJ;A8Ij/tEI;;EACI,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A9Io/tER;;A8I/+tEI;EACI,gBAAA;A9Ik/tER;;A8I7+tEI;EACI,gBAAA;A9Ig/tER;;A8I3+tEI;EACI,gBnImYsB;AX2mtE9B;A8I7+tEQ;EACI,cnI9EC;EmI+ED,yCAAA;EACA,YAAA;EACA,gBAAA;A9I++tEZ;A8I7+tEY;EAEI,WnIvHL;EmIwHK,yBnItFH;AXokuEb;A8Iz+tEI;EACI,oCAAA;EACA,enI7FK;AXwkuEb;;A8It+tEI;EADJ;IAEQ,sBAAA;IACA,SAAA;E9I0+tEN;AACF;;A8Ir+tEQ;EACI,6BAAA;A9Iw+tEZ;;A8Il+tEI;EACI,aAAA;A9Iq+tER;A8Ij+tEQ;EACI,aAAA;A9Im+tEZ;A8Ih+tEQ;EACI,aAAA;A9Ik+tEZ;A8I/9tEQ;EACI,cAAA;A9Ii+tEZ;;A8I39tEI;EACI,0BAAA;A9I89tER;;A8Iz9tEI;EACI,0BAAA;A9I49tER;;A8Ir9tEQ;EACI,+CAAA;A9Iw9tEZ;;A8In9tEA;EACI,oCnIoS0B;AXkrtE9B;;A8I78tEgB;;EAEI,yBAAA;A9Ig9tEpB;;A8Iv8tEgB;EACI,yBAAA;A9I08tEpB;;A8Il8tEY;EACI,yBAAA;A9Iq8tEhB;A8Il8tEoB;EACI,yBAAA;A9Io8tExB;A8Ih8tEgB;EACI,qBnI5JL;AX8luEf;;A8Ih+tEgB;;EAEI,yBAAA;A9Im+tEpB;;A8I19tEgB;EACI,yBAAA;A9I69tEpB;;A8Ir9tEY;EACI,yBAAA;A9Iw9tEhB;A8Ir9tEoB;EACI,yBAAA;A9Iu9tExB;A8In9tEgB;EACI,qBnI5JL;AXinuEf;;A8In/tEgB;;EAEI,yBAAA;A9Is/tEpB;;A8I7+tEgB;EACI,yBAAA;A9Ig/tEpB;;A8Ix+tEY;EACI,yBAAA;A9I2+tEhB;A8Ix+tEoB;EACI,yBAAA;A9I0+tExB;A8It+tEgB;EACI,qBnI5JL;AXoouEf;;A8ItguEgB;;EAEI,yBAAA;A9IyguEpB;;A8IhguEgB;EACI,yBAAA;A9ImguEpB;;A8I3/tEY;EACI,yBAAA;A9I8/tEhB;A8I3/tEoB;EACI,yBAAA;A9I6/tExB;A8Iz/tEgB;EACI,qBnI5JL;AXupuEf;;A8IzhuEgB;;EAEI,yBAAA;A9I4huEpB;;A8InhuEgB;EACI,yBAAA;A9IshuEpB;;A8I9guEY;EACI,yBAAA;A9IihuEhB;A8I9guEoB;EACI,yBAAA;A9IghuExB;A8I5guEgB;EACI,qBnI5JL;AX0quEf;;A8I5iuEgB;;EAEI,yBAAA;A9I+iuEpB;;A8ItiuEgB;EACI,yBAAA;A9IyiuEpB;;A8IjiuEY;EACI,yBAAA;A9IoiuEhB;A8IjiuEoB;EACI,yBAAA;A9ImiuExB;A8I/huEgB;EACI,qBnI5JL;AX6ruEf;;A8I/juEgB;;EAEI,yBAAA;A9IkkuEpB;;A8IzjuEgB;EACI,yBAAA;A9I4juEpB;;A8IpjuEY;EACI,yBAAA;A9IujuEhB;A8IpjuEoB;EACI,yBAAA;A9IsjuExB;A8IljuEgB;EACI,qBnI5JL;AXgtuEf;;A8IlluEgB;;EAEI,yBAAA;A9IqluEpB;;A8I5kuEgB;EACI,yBAAA;A9I+kuEpB;;A8IvkuEY;EACI,yBAAA;A9I0kuEhB;A8IvkuEoB;EACI,yBAAA;A9IykuExB;A8IrkuEgB;EACI,qBnI5JL;AXmuuEf;;A8I/juEI;EACI,gCAAA;A9IkkuER;;A8I9juEA;EACI,cAAA;A9IikuEJ;A8IhkuEI;EACI,mBAAA;A9IkkuER;;A+I38uEA;EACI,uBAAA;EACA,uDAAA;EACA,oBAAA;EACA,aAAA;A/I88uEJ;A+I58uEI;EACI,iDAAA;EACA,sCAAA;A/I88uER;A+I58uEI;EAVJ;IAWQ,qBAAA;IACA,oBAAA;IACA,aAAA;E/I+8uEN;AACF;A+I78uEI;EACI,yBAAA;A/I+8uER;A+I58uEI;EACI,uBAAA;A/I88uER;A+I78uEQ;EACI,+CAAA;EACA,sCAAA;EACA,iCAAA;EACA,+BAAA;A/I+8uEZ;A+I98uEY;EACI,yBAAA;A/Ig9uEhB;A+I58uEQ;EACI,qCAAA;EACA,WAAA;EACA,SAAA;A/I88uEZ;A+I18uEI;EACI,oCAAA;A/I48uER;A+I38uEQ;EACI,kDAAA;A/I68uEZ;A+I18uEY;EACI,kDAAA;A/I48uEhB;;A+Ir8uEA;EACI,6DAAA;A/Iw8uEJ;;A+Ir8uEA;EACI,qDAAA;A/Iw8uEJ;;AgJlgvEA;;EAEI,kBAAA;EACA,aAAA;EACA,gBrIurB0B;EqItrB1B,8CAAA;AhJqgvEJ;;AgJlgvEA;;;;;EAKI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AhJqgvEJ;;AgJlgvEA;;;;;EAKI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AhJqgvEJ;;AgJlgvEA;EACI,gBrIwpB0B;EqIvpB1B,gBAAA;AhJqgvEJ;;AgJt/uEgC;;EACI,yBrIgIvB;EqI/HuB,sCAAA;AhJ0/uEpC;AgJj/uEwC;EACI,yBrIwH/B;AX23uEb;AgJ3+uEoC;EACI,yBrI+G3B;AX83uEb;AgJ/9uEwB;EACI,gBAAA;AhJi+uE5B;;AgJr9uEI;;EAEI,kBAAA;EACA,mBAAA;AhJw9uER;AgJr9uEI;;EAEI,kBAAA;AhJu9uER;AgJn9uEQ;EACI,WAAA;AhJq9uEZ;AgJh9uEgB;EACI,wBAAA;AhJk9uEpB;AgJ/8uEgB;EACI,cAAA;AhJi9uEpB;;AgJt8uEY;EACI,sBrIgBL;EqIfK,oCrI+ec;EqI9ed,gBAAA;EACA,WAAA;AhJy8uEhB;AgJv8uEY;EACI,gBrIs2CoB;AXmmsEpC;AgJx8uEgB;EACI,sBrIwiBU;EqIviBV,gBrI4iBU;EqI3iBV,mBAAA;AhJ08uEpB;AgJt8uEwB;EACI,uBAAA;AhJw8uE5B;AgJn8uEY;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA;EACA,oCrIodc;AXi/tE9B;AgJp8uEgB;EACI,iCAAA;AhJs8uEpB;;AgJ97uEI;;;;EAII,oCrIscsB;EqIrctB,2BAAA;EACA,yBAAA;AhJi8uER;;AgJ37uEQ;EACA,6BrI8mBsB;EqI7mBtB,2BrI4mBsB;EqI3mBtB,2CrI2bsB;EqI1btB,qCrI0bsB;AXoguE9B;;AiJ1nvEA;EACI,sBAAA;AjJ6nvEJ;;AiJ1nvEI;EACI,wCAAA;EACA,gCtI69BgC;EsI59BhC,oCtI+7BgC;EsI97BhC,aAAA;AjJ6nvER;AiJ5nvEQ;EACI,iBAAA;EACA,kBAAA;EACA,2BtI+7B4B;AX+rtExC;AiJ5nvEQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AjJ8nvEZ;AiJ7nvEY;EACI,wEAAA;EACA,2BAAA;AjJ+nvEhB;;AiJtnvEY;EACI,mFAAA;EACA,sCAAA;AjJynvEhB;;AiJnnvEA;EACI,iBAAA;AjJsnvEJ;;AiJnnvEA;EACI,sCAAA;EACA,4CtIulB0B;EsItlB1B,sCAAA;EACA,aAAA;AjJsnvEJ;;AiJlnvEI;EACI,6CtIq5BgC;AXgutExC;AiJnnvEI;EACI,aAAA;EACA,sCAAA;AjJqnvER;AiJpnvEQ;EACI,aAAA;EACA,wCAAA;EACA,oCtI24B4B;EsI14B5B,2BtI+4B4B;EsI94B5B,sBtI6jBkB;AXyjuE9B;AiJnnvEI;EACI,yBtImHK;AXkgvEb;AiJnnvEI;EACI,sCAAA;EACA,0CAAA;AjJqnvER;AiJpnvEQ;EACI,yBtI6GC;EsI5GD,WtI8ED;AXwivEX;AiJlnvEQ;EACI,kBAAA;EACA,kBAAA;AjJonvEZ;AiJhnvEQ;EACI,aAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;AjJknvEZ;;AiJ3mvEI;EACI,oCtIq4BgC;EsIp4BhC,mDAAA;EACA,oCtIs2BgC;AXwwtExC;AiJ5mvEQ;EACI,gBAAA;AjJ8mvEZ;AiJ5mvEQ;EACI,SAAA;EACA,2BtIo2B4B;AX0wtExC;AiJ5mvEQ;EACI,yBtI0EC;EsIzED,YAAA;EACA,WtI0CD;EsIzCC,kBAAA;EACA,YAAA;EACA,eAAA;AjJ8mvEZ;AiJ5mvEQ;EACI,WtIoCD;EsInCC,iBAAA;EACA,qCAAA;EACA,cAAA;EACA,QAAA;AjJ8mvEZ;AiJ7mvEY;EACI,WtI8BL;EsI7BK,yBtI2DH;AXojvEb;AiJ1mvEQ;EACI,eAAA;EACA,sCtI8iBkB;AX8juE9B;AiJvmvEY;EACI,ctIsBL;AXmlvEX;;AiJjmvEQ;EACI,6CtIyzB4B;EsIxzB5B,eAAA;AjJomvEZ;;AkJnvvEA;EACI,kBAAA;EACA,WvImJO;EuIlJP,qBAAA;EACA,uFAAA;EACA,mBvIoLS;EuInLT,eAAA;EACA,UAAA;EACA,wDAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;AlJsvvEJ;AkJrvvEI;EACI,UAAA;AlJuvvER;;AkJlvvEA;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AlJqvvEJ;;AkJlvvEA;EACI,WAAA;AlJqvvEJ;;AkJlvvEA;EACI,UAAA;AlJqvvEJ;AkJpvvEI;EACI,UAAA;EACA,cAAA;EACA,iBAAA;AlJsvvER;;AkJlvvEA;EACI,WAAA;AlJqvvEJ;;AkJlvvEA;EACI,cAAA;AlJqvvEJ;;AkJlvvEA;EACI,mBAAA;AlJqvvEJ;;AkJlvvEA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AlJqvvEJ;;AkJlvvEA;EACI,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;AlJqvvEJ;;AkJlvvEA;EACI;IACI,iBAAA;IACA,kBAAA;IACA,OAAA;IACA,QAAA;IACA,sBAAA;ElJqvvEN;AACF;AmJp0vEA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;AnJs0vEJ;AmJp0vEI;EACI,aAAA;AnJs0vER;AmJn0vEI;EACI,gBAAA;AnJq0vER;AmJj0vEQ;;EAEI,iDAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AnJm0vEZ;AmJh0vEQ;EACI,mBAAA;AnJk0vEZ;AmJ9zvEI;EACI,wBAAA;AnJg0vER;AmJ5zvEI;EACI,eAAA;AnJ8zvER;AmJ7zvEQ;EACI,uBAAA;AnJ+zvEZ;AmJ5zvEQ;EACI,cAAA;EACA,WAAA;EACA,sBAAA;EACA,oCxI65B4B;EwI55B5B,wCAAA;EACA,oBxIyoBkB;EwIxoBlB,sBxI8kBkB;EwI7kBlB,2BxI85B4B;EwI75B5B,mBAAA;AnJ8zvEZ;AmJ3zvEQ;EACI,0DAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AnJ6zvEZ;AmJ3zvEY;EACI,UAAA;AnJ6zvEhB;AmJ1zvEY;EACI,mCAAA;AnJ4zvEhB;AmJxzvEQ;EACI,aAAA;AnJ0zvEZ;AmJvzvEQ;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,6CAAA;EACA,aAAA;EACA,UAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AnJyzvEZ;AmJtzvEQ;EACI,aAAA;EACA,2CAAA;AnJwzvEZ;AmJ9yvEQ;EACI,YAAA;EACA,qBxI8uBkB;AXkkuE9B;AmJ7yvEQ;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+CAAA;EACA,eAAA;EACA,0DAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AnJ+yvEZ;AmJ9yvEY;EACI,UAAA;AnJgzvEhB;AmJ7yvEQ;EACI,oBAAA;AnJ+yvEZ;AmJ9yvEY;EACI,gBAAA;AnJgzvEhB;AmJ1yvEQ;EACI,gBAAA;AnJ4yvEZ;;AmJryvEI;EACI,iCAAA;EACA,YAAA;AnJwyvER;;AmJpyvEA;EACI,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,oCxIwyBoC;EwIvyBpC,qCAAA;EACA,wCAAA;EACA,iCAAA;EACA,oBxIkhB0B;EwIjhB1B,kBAAA;EACA,gBAAA;AnJuyvEJ;;AmJjyvEI;;EACI,0CxI0yBgC;AX2/tExC;;AmJjyvEA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AnJoyvEJ;;AmJjyvEA;EACI,qBAAA;EACA,yBAAA;EACA,WAAA;AnJoyvEJ;AmJlyvEI;EACI,WAAA;AnJoyvER;;AmJhyvEA;EACI,eAAA;AnJmyvEJ;AmJlyvEI;EACI,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBxImfsB;EwIlftB,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBxIvBK;EwIwBL,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WxIzDG;EwI0DH,gBxIubsB;AX62uE9B;AmJnyvEQ;EACI,kBAAA;AnJqyvEZ;AmJlyvEQ;EACI,yBxIlCC;EwImCD,yBAAA;AnJoyvEZ;;AmJ5xvEQ;EACI,yBxIxCC;EwIyCD,yBAAA;AnJ+xvEZ;;AmJ1xvEA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;EACA,wCAAA;EACA,6CxIwZ0B;EwIvZ1B,SAAA;EACA,aAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;AnJ6xvEJ;AmJ5xvEI;EACI,mBAAA;EACA,6BAAA;AnJ8xvER;AmJ3xvEI;EACI,iDAAA;AnJ6xvER;AmJ1xvEI;EACI,qBAAA;AnJ4xvER;AmJzxvEI;EACI,kBAAA;EACA,gBxIzIa;AXo6vErB;AmJxxvEI;EACI,aAAA;AnJ0xvER;;AmJrxvEI;EACI,oCxI2+B4B;AX6ytEpC;;AmJnxvEI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;AnJsxvER;AmJrxvEQ;EACI,iCAAA;EACA,2BAAA;AnJuxvEZ;;AmJjxvEI;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,4BAAA;AnJoxvER;AmJjxvEI;EACI,kBAAA;EACA,oBxIqYsB;EwIpYtB,oCAAA;AnJmxvER;;AmJ7wvEA;EAIY;IACI,+BAAA;IACA,eAAA;IACA,UAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;EnJ6wvEd;EmJzwvEc;IACI,YAAA;EnJ2wvElB;AACF;AmJnwvEA;EACI,eAAA;AnJqwvEJ;;AmJlwvEA;EACI,eAAA;AnJqwvEJ;;AmJlwvEA;EACI,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AnJqwvEJ;;AmJlwvEA;EACI,gBxI6V0B;EwI5V1B,eAAA;EACA,kBAAA;EACA,+CAAA;EACA,cxItMO;AX28vEX;;AmJlwvEA;EACI,oBAAA;EACA,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;AnJqwvEJ;AmJpwvEI;EACI,aAAA;AnJswvER;;AmJlwvEA;EACI,qBAAA;EACA,wBAAA;EACA,oCxIilBoC;EwIhlBpC,2BxIqlBoC;EwIplBpC,oBxI6T0B;EwI5T1B,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AnJqwvEJ;AmJpwvEI;EACI,UAAA;AnJswvER;AmJpwvEI;EACI,cxIrOG;AX2+vEX;;AmJlwvEA;EACI,cxI1OO;EwI2OP,UAAA;AnJqwvEJ;;AmJ/vvEQ;EACI,kDxImzCiB;AX+8sE7B;;AoJhpwEA;EACI,uBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gCAAA;EACA,4KAAA;ApJmpwEJ;AoJjpwEI;EAEI,UAAA;EACA,iBAAA;EACA,mBAAA;ApJkpwER;AoJ/owEI;EACI,qBAAA;EACA,aAAA;ApJipwER;AoJ9owEI;EACQ,4DAAA;ApJgpwEZ;AoJ7owEI;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;ApJ+owER;AoJ7owEQ;EACI,cAAA;EACA,WAAA;ApJ+owEZ;AoJ7owEY;EACI,WAAA;EACA,wCAAA;EACA,gBAAA;EACA,0BAAA;ApJ+owEhB;AoJ5owEgB;EACI,WAAA;EACA,eAAA;EACA,eAAA;ApJ8owEpB;AoJ5owEoB;EACI,eAAA;EACA,kBAAA;ApJ8owExB;AoJxowEQ;EACI,mDAAA;EACA,sBzIqjBkB;AXqlvE9B;AoJtowEI;EACI,kBAAA;EACA,qBAAA;ApJwowER;AoJvowEQ;EACI,YAAA;EACA,cAAA;ApJyowEZ;AoJrowEI;EACI,2BAAA;ApJuowER;AoJpowEI;EACI,6CAAA;ApJsowER;AoJnowEI;;EAEI,gBAAA;EACA,6BAAA;EACA,4BAAA;ApJqowER;AoJlowEI;EACI,cAAA;ApJoowER;AoJjowEI;EACI,YAAA;EACA,4CAAA;ApJmowER;AoJhowEI;EACI,YAAA;ApJkowER;AoJ/nwEI;EAEI,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;ApJgowER;AoJ7nwEI;EAIE,UAAA;EACA,WAAA;ApJ4nwEN;AoJznwEI;EAEE,SAAA;EACA,UAAA;ApJ0nwEN;AoJvnwEI;EACI,iBAAA;EACA,cAAA;ApJynwER;AoJvnwEI;EACI,iBAAA;EACA,cAAA;ApJynwER;AoJtnwEI;EAEI,YAAA;ApJunwER;AoJrnwEI;EACI,4BzI8BK;AXylwEb;AoJrnwEI;EACI,4BzI2BK;AX4lwEb;AoJpnwEI;EAEI,SAAA;ApJqnwER;AoJnnwEI;EACI,yBzImBK;AXkmwEb;AoJnnwEI;EACI,yBzIgBK;AXqmwEb;AoJnnwEI;EACI,UAAA;ApJqnwER;;AoJjnwEA;EACI,kBAAA;EACA,qBAAA;ApJonwEJ;;AoJjnwEA;EACI,aAAA;EACA,yBzIES;EyIDT,8BAAA;ApJonwEJ;AoJlnwEI;EACI,uBAAA;EACA,+BAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,SAAA;ApJonwER;AoJjnwEI;;EAEI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;ApJmnwER;AoJjnwEQ;;EACE,aAAA;ApJonwEV;AoJjnwEQ;;EACI,kBAAA;ApJonwEZ;AoJjnwEQ;;EACI;2BAAA;EAEA;SAAA;EAEE,OAAA;EACF;yBAAA;EAEA;SAAA;ApJqnwEZ;AoJjpwEI;;EA+BM;qBAAA;EAEF;mBAAA;ApJunwER;AoJpnwEQ;;EACI;2BAAA;EAEA;SAAA;EAEE,QAAA;EACF;yBAAA;EAEA;SAAA;ApJwnwEZ;AoJpqwEI;;EA+CM;qBAAA;EAEF;mBAAA;ApJ0nwER;AoJvnwEQ;;EACI,cAAA;ApJ0nwEZ;AoJxnwEY;;EACI,8BAAA;ApJ2nwEhB;AoJvnwEQ;;EACI,WAAA;EACA,YAAA;ApJ0nwEZ;AoJxnwEY;;EACI,qBAAA;EACA,aAAA;ApJ2nwEhB;;AoJrnwEA;EACI,kBAAA;EACA,YAAA;ApJwnwEJ;AoJtnwEI;;EAEI,qBAAA;ApJwnwER;AoJrnwEI;EACI,WAAA;ApJunwER;AoJrnwEQ;EACI,aAAA;ApJunwEZ;AoJpnwEQ;EAEI,SAAA;EACA,wBAAA;ApJqnwEZ;AoJjnwEI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gDAAA;EACA,sBAAA;ApJmnwER;AoJjnwEQ;EACI,8BAAA;ApJmnwEZ;AoJhnwEQ;EACI,8BAAA;ApJknwEZ;AoJ/mwEQ;EACI,cAAA;EACA,WAAA;EACA,kBAAA;ApJinwEZ;AoJ9mwEQ;EACI,MAAA;EACA,gBAAA;ApJgnwEZ;AoJ9mwEY;EACI,kCAAA;EACA,mCAAA;EACA,8CAAA;EACA,QAAA;ApJgnwEhB;AoJ5mwEQ;EACI,QAAA;ApJ8mwEZ;AoJ5mwEY;EACI,kCAAA;EACA,mCAAA;EACA,2CAAA;EACA,QAAA;ApJ8mwEhB;AoJ1mwEQ;EACI,cAAA;EACA,YAAA;ApJ4mwEZ;AoJ1mwEY;EACI,wBAAA;ApJ4mwEhB;AoJtmwEI;EACI,+BAAA;ApJwmwER;AoJvmwEQ;EACI,UAAA;ApJymwEZ;;AoJpmwEA;EACI,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,qCAAA;ApJumwEJ;AoJrmwEI;EACI,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;ApJumwER;AoJrmwEQ;EACI,+BAAA;ApJumwEZ;AoJnmwEI;EACI,UAAA;EACA,aAAA;EACA,qBAAA;ApJqmwER;AoJjmwEQ;EACI,uCAAA;ApJmmwEZ;AoJjmwEQ;EACI,oCAAA;ApJmmwEZ;AoJ/lwEI;EACI,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBzIiSsB;EyIhStB,oBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;ApJimwER;AoJ/lwEQ;EACI,UAAA;ApJimwEZ;AoJ9lwEQ;EAEI,eAAA;EACA,+BAAA;EACA,uBAAA;EACA,oBAAA;ApJ+lwEZ;AoJ3lwEI;EACI,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBzIkQsB;EyIjQtB,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;ApJ6lwER;AoJ3lwEQ;EAEI,aAAA;ApJ4lwEZ;AoJzlwEQ;EACI,6BAAA;ApJ2lwEZ;AoJxlwEQ;EACI,6BAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;ApJ0lwEZ;;AoJplwEA;EACI,yBzInSS;EyIoST,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,+CAAA;ApJulwEJ;AoJtlwEI;EACI,aAAA;EACA,SAAA;ApJwlwER;;AoJplwEA;EACI,eAAA;EACA,cAAA;EACA,mBzIpTS;EyIqTT,WzInVO;EyIoVP,cAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gBzIhXiB;AXu8wErB;;AoJplwEA;;EAEI,kBAAA;ApJulwEJ;;AoJrlwEA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;ApJwlwEJ;AoJvlwEI;EACI,UAAA;ApJylwER;;AoJrlwEA;EACI,UAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,qCAAA;EACA,UAAA;ApJwlwEJ;AoJvlwEI;EACI,4BAAA;ApJylwER;;AoJrlwEA;EACI,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;ApJwlwEJ;AoJtlwEI;EAEI,gDAAA;ApJulwER;AoJplwEI;EAYI,eAAA;EACA,UAAA;EACA,iCAAA;EACA,6BAAA;ApJ2kwER;AoJxkwEI;EACI,qBzI3YK;EyI4YL,yCAAA;EACA,gBzIsEsB;AXogwE9B;AoJxkwEQ;EAEI,qBzIjZC;EyIkZD,0CAAA;EACA,qBAAA;ApJykwEZ;AoJrkwEI;EAkBI,mBzIzaK;EyI0aL,gBzIyCsB;EyIxCtB,WzIzcG;EyI0cH,qBzI5aK;AXk+wEb;AoJhjwEQ;EACI,4BAAA;ApJkjwEZ;AoJjjwEY;EACI,6BAAA;ApJmjwEhB;AoJhjwEY;EACI,mBAAA;ApJkjwEhB;AoJ1iwEQ;EACI,4BAAA;ApJ4iwEZ;AoJxiwEI;EACI,gBAAA;EACA,6DAAA;ApJ0iwER;AoJviwEI;EAOI,0CAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;ApJmiwER;AoJhiwEI;EAEI,mBAAA;EACA,0CAAA;ApJiiwER;AoJ9hwEI;EACI,gBAAA;EACA,6CAAA;ApJgiwER;AoJ7hwEI;EACI,kBAAA;ApJ+hwER;;AoJ3hwEA;EACI,eAAA;ApJ8hwEJ;;AoJ3hwEA;EACI,WAAA;ApJ8hwEJ;AoJ7hwEI;EACI,eAAA;EACA,2BAAA;ApJ+hwER;AoJ5hwEI;EACI,WAAA;EACA,WAAA;EACA,iBAAA;ApJ8hwER;AoJ1hwEQ;EAEI,cAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;ApJ2hwEZ;;AoJrhwEA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;ApJwhwEJ;;AoJrhwEA;EACI,qBAAA;EACA,UAAA;EACA,sBAAA;ApJwhwEJ;;AoJrhwEA;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;ApJwhwEJ;AoJthwEI;EACI,WAAA;EACA,cAAA;EACA,WAAA;ApJwhwER;AoJthwEI;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;ApJwhwER;AoJrhwEgB;EACI,2CzI3GU;AXkowE9B;AoJjhwEI;EACI,UAAA;ApJmhwER;AoJhhwEI;EACI,UAAA;ApJkhwER;AoJ9gwEI;EACI,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;ApJghwER;AoJ9gwEQ;EACI,iBAAA;ApJghwEZ;AoJ7gwEQ;EAEE,gBAAA;ApJ8gwEV;AoJ3gwEQ;EACI,UAAA;EACA,SAAA;ApJ6gwEZ;AoJxgwEI;;EAEI,eAAA;EACA,WAAA;EACA,oBAAA;EACA,2BAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;ApJ0gwER;AoJvgwEI;EACI,UAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ApJygwER;AoJrgwEQ;EACI,oCAAA;ApJugwEZ;;AoJ//vEI;;;;;EAEI,6BAAA;ApJqgwER;;AoJjgwEA;EACI,eAAA;EACA,oCzIgJoC;AXo3vExC;;AoJjgwEA;EACI,aAAA;ApJogwEJ;;AoJjgwEA;EACI;IACI,UAAA;IACA,mCAAA;EpJogwEN;EoJlgwEE;IACI,UAAA;IACA,+BAAA;EpJogwEN;AACF;AoJjgwEA;;EAEI,aAAA;ApJmgwEJ;;AqJ/0xEA;EACI,kBAAA;ArJk1xEJ;AqJ/0xEQ;EACI,iBAAA;EACA,gBAAA;ArJi1xEZ;AqJ/0xEY;EACI,wBAAA;ArJi1xEhB;AqJ90xEY;EACI,UAAA;ArJg1xEhB;AqJ70xEY;EACI,YAAA;ArJ+0xEhB;AqJ50xEY;EACI,iDAAA;EACA,kBAAA;ArJ80xEhB;AqJ30xEY;EACI,kBAAA;ArJ60xEhB;;AqJt0xEI;EACI,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;ArJy0xER;;AqJn0xEI;;EACI,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,a1I4yBsB;E0I3yBtB,W1I0yBsB;E0IzyBtB,eAAA;ArJu0xER;;AqJl0xEI;EACI,aAAA;ArJq0xER;;AqJh0xEI;EACI,aAAA;ArJm0xER;;AsJ73xEI;EACI,oB3I2GQ;E2I1GR,kBAAA;EACA,UAAA;EACA,WAAA;AtJg4xER;AsJ93xEI;EACI,OAAA;EACA,6BAAA;EACA,2BAAA;AtJg4xER;;AsJ53xEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;AtJ+3xEJ;AsJ73xEI;EARJ;IASQ,aAAA;EtJg4xEN;AACF;;AsJ73xEA;EACI,0DAAA;EACA,sBAAA;AtJg4xEJ;AsJ93xEI;EACI,iGAAA;EACA,YAAA;AtJg4xER;;AsJ53xEA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,oBAAA;AtJ+3xEJ;AsJ93xEI;EACI,WAAA;EACA,YAAA;EACA,uBAAA;AtJg4xER;;AsJx3xEQ;EACI,gBAAA;AtJ23xEZ;;AsJt3xEA;EACI,kBAAA;AtJy3xEJ;;AsJp3xEA;EACI,kBAAA;AtJu3xEJ;AsJt3xEI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,6CAAA;EACA,SAAA;AtJw3xER;AsJr3xEI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,0CAAA;EACA,iBAAA;AtJu3xER;;AsJj3xEA;EACI,6E3IiDY;AXm0xEhB;AsJl3xEI;EACI,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,6BAAA;AtJo3xER;AsJj3xEI;EACI,+BAAA;AtJm3xER;;AsJ92xEA;EACI,aAAA;AtJi3xEJ;AsJ/2xEI;EACI,kBAAA;AtJi3xER;AsJ/2xEQ;EACI,c3IsEC;AX2yxEb;AsJ/2xEY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AtJi3xEhB;AsJ72xEQ;EACI,c3IyDC;AXszxEb;AsJ72xEY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AtJ+2xEhB;;AuJl/xEA;EACE,2BAAA;AvJq/xEF;;AuJh/xEA;EACE,kBAAA;AvJm/xEF;AuJl/xEE;EAFF;IAGI,oBAAA;EvJq/xEF;AACF;AuJp/xEE;EACE,6BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;AvJs/xEJ;AuJp/xEI;EACE,yBAAA;EACA,wBAAA;AvJs/xEN;AuJp/xEI;;EAEE,aAAA;AvJs/xEN;AuJn/xEE;EACE,2BAAA;AvJq/xEJ;AuJp/xEI;EACE,eAAA;EACA,WAAA;EACA,OAAA;AvJs/xEN;AuJp/xEI;EACE,wCAAA;EACA,kBAAA;EACA,YAAA;AvJs/xEN;AuJp/xEI;EACE,iCAAA;EACA,YAAA;AvJs/xEN;AuJr/xEM;EACE,qBAAA;EACA,iCAAA;AvJu/xER;AuJn/xEM;EACE,sBAAA;EACA,yB5IuIK;E4ItIL,gCAAA;AvJq/xER;AuJp/xEQ;EACE,yBAAA;EACA,oDAAA;AvJs/xEV;AuJn/xEM;EACE,oCAAA;EACA,gCAAA;EACA,W5IyFG;AX45xEX;AuJl/xEI;EACE,YAAA;EACA,iBAAA;AvJo/xEN;AuJh/xEE;EACE,uBAAA;AvJk/xEJ;;AuJ7+xEE;EACE,8CAAA;AvJg/xEJ;AuJ/+xEI;EACE,WAAA;AvJi/xEN;AuJ/+xEI;EACE;IACE,iBAAA;EvJi/xEN;EuJ/+xEI;IACE,8CAAA;EvJi/xEN;AACF;AuJ/+xEI;EAbF;IAcI,iBAAA;IACA,+CAAA;EvJk/xEJ;AACF;;AuJ9+xEA;EAEI;;IAEE,WAAA;EvJg/xEJ;AACF;AuJ5+xEA;EACE,2BAAA;AvJ8+xEF;;AuJz+xEA;EACE,0DAAA;EACA,sBAAA;AvJ4+xEF;;AuJv+xEI;EACE,0CAAA;EACA,iBAAA;EACA,eAAA;AvJ0+xEN;AuJx+xEM;EALF;IAMI,eAAA;IACA,gBAAA;EvJ2+xEN;EuJv+xEE;IAEI,eAAA;EvJ0+xEN;AAJF;;AuJh+xEA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AvJw+xEF;;AuJp+xEE;;EAEE,SAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,c5I6BS;E4I5BT,qBAAA;EACA,sBAAA;AvJu+xEJ;AuJr+xEE;EACE,sBAAA;EACA,qBAAA;AvJu+xEJ;;AuJl+xEE;EACE,2CAAA;EACA,0BAAA;AvJq+xEJ;;AuJh+xEE;EACE;;IAEE,sBAAA;IACA,0BAAA;EvJm+xEJ;AACF;;AuJ/9xEA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AvJk+xEF;;AwJxpyEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AxJ2pyEF;AwJzpyEE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,oC7IiIe;E6IhIf,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AxJ2pyEJ;;AwJvpyEA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AxJ0pyEF;AwJxpyEE;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;EACA,wCAAA;EACA,mBAAA;EACA,c7IoJS;E6InJT,UAAA;AxJ0pyEJ;AwJvpyEE;EACE,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AxJypyEJ;AwJtpyEE;EACE,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,wCAAA;EACA,sB7IikB0B;E6IhkB1B,mD7I0kB0B;AX8kxE9B;AwJrpyEE;EACE,OAAA;AxJupyEJ;AwJrpyEI;EACE,uBAAA;EACA,iBAAA;AxJupyEN;AwJnpyEE;EACE,SAAA;AxJqpyEJ;AwJnpyEI;EACE,WAAA;AxJqpyEN;AwJlpyEI;EACE,wBAAA;EACA,eAAA;AxJopyEN;AwJjpyEI;EACE,UAAA;EACA,sDAAA;AxJmpyEN;;AwJ9oyEA;EAEI;IACE,UAAA;IACA,aAAA;ExJgpyEJ;EwJ5oyEA;IACE,WAAA;IACA,kBAAA;IACA,kBAAA;ExJ8oyEF;EwJ5oyEE;IAEE,QAAA;ExJ6oyEJ;EwJ3oyEI;IACE,WAAA;IACA,YAAA;IACA,MAAA;IACA,eAAA;IACA,OAAA;ExJ6oyEN;EwJ1oyEI;IACE,WAAA;IACA,wEAAA;ExJ4oyEN;EwJzoyEI;IACE,WAAA;IACA,UAAA;IACA,WAAA;IACA,QAAA;IACA,gBAAA;ExJ2oyEN;AACF;AwJtoyEA;EACE,kBAAA;AxJwoyEF;AwJtoyEE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,oC7IFe;AX0oyEnB;AwJroyEE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AxJuoyEJ;AwJroyEI;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,oC7IjBa;E6IkBb,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AxJuoyEN;AwJtoyEM;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AxJwoyER;AwJnoyEE;EACE,eAAA;EACA,gB7I/CiB;E6IgDjB,kBAAA;EACA,iBAAA;AxJqoyEJ;AwJnoyEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,mB7IDO;E6IEP,0CAAA;EACA,mBAAA;EACA,UAAA;AxJqoyEN;AwJjoyEE;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AxJmoyEJ;AwJloyEI;EATF;IAUI,eAAA;ExJqoyEJ;AACF;AwJnoyEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,0EAAA;EAEA,kBAAA;AxJooyEN;AwJjoyEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,wEAAA;EACA,kBAAA;AxJmoyEN;AwJhoyEI;EACE,kBAAA;EACA,WAAA;AxJkoyEN;AwJ9nyEE;EACE,kBAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gB7I/FO;E6IgGP,WAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AxJgoyEJ;AwJ9nyEI;EACE,cAAA;AxJgoyEN;AwJ9nyEM;EACE,UAAA;EACA,gBAAA;EACA,UAAA;EACA,wEAAA;AxJgoyER;AwJ7nyEM;EACE,UAAA;EACA,gBAAA;EACA,UAAA;EACA,0EAAA;EAEA,kBAAA;EACA,UAAA;AxJ8nyER;;AwJvnyEA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AxJ0nyEF;AwJxnyEE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,0C7ItJe;AXgxyEnB;AwJtnyEI;EACE,qBAAA;EACA,6BAAA;EACA,gBAAA;AxJwnyEN;AwJtnyEM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mB7I5HK;E6I6HL,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,0CAAA;AxJwnyER;AwJpnyEI;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0C7IpLa;AX0yyEnB;AwJpnyEM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,0EAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;AxJsnyER;AwJlnyEI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AxJonyEN;AwJjnyEI;EACE,eAAA;EACA,0BAAA;AxJmnyEN;AwJjnyEM;EACE,yBAAA;AxJmnyER;AwJjnyEQ;EACE,aAAA;EACA,SAAA;EACA,0EAAA;AxJmnyEV;AwJ/myEM;EACE,yBAAA;AxJinyER;AwJ5myEE;;EAEE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,oEAAA;AxJ8myEJ;AwJ5myEI;;EACE,eAAA;EACA,W7IjOK;AXg1yEX;AwJ7myEI;;EACE,yCAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,oBAAA;AxJgnyEN;AwJ5myEE;EACE,QAAA;AxJ8myEJ;AwJ5myEI;EACE,gBAAA;EACA,sBAAA;AxJ8myEN;AwJ1myEE;EACE,OAAA;AxJ4myEJ;AwJ1myEI;EACE,gBAAA;EACA,sBAAA;AxJ4myEN;;AwJrmyEA;EACE,kBAAA;EACA,gBAAA;AxJwmyEF;AwJtmyEE;EACE,kBAAA;AxJwmyEJ;AwJtmyEI;EACE,UAAA;AxJwmyEN;AwJrmyEI;EACE,0CAAA;EACA,0CAAA;EACA,YAAA;EACA,WAAA;AxJumyEN;AwJpmyEI;EACE,WAAA;EACA,kBAAA;EACA,8CAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AxJsmyEN;AwJnmyEM;EACE,yBAAA;AxJqmyER;;AyJxhzEI;EACI,kBAAA;EACA,eAAA;AzJ2hzER;AyJzhzEQ;EACI,cAAA;EACA,2BAAA;EACA,gB9ImrBkB;E8IlrBlB,iBAAA;EACA,WAAA;EACA,eAAA;AzJ2hzEZ;;AyJthzEA;EACI,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;AzJyhzEJ;AyJvhzEI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,0CAAA;EACA,oBAAA;AzJyhzER;AyJthzEI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;AzJwhzER;AyJthzEQ;EACI,cAAA;AzJwhzEZ;AyJrhzEQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,wGAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;AzJuhzEZ;AyJrhzEY;EACI,W9IuFL;E8ItFK,SAAA;EACA,eAAA;AzJuhzEhB;AyJlhzEI;EACI,gCAAA;AzJohzER;AyJjhzEI;EACI,kBAAA;AzJmhzER;AyJjhzEQ;EACI,eAAA;EACA,kBAAA;EACA,aAAA;AzJmhzEZ;AyJhhzEQ;EACI,SAAA;EACA,oBAAA;EACA,c9IsED;AX48yEX;AyJ7gzEQ;EACI,YAAA;AzJ+gzEZ;AyJ5gzEQ;EACI,SAAA;AzJ8gzEZ;AyJ5gzEY;EACI,UAAA;AzJ8gzEhB;AyJ1gzEQ;EACI,UAAA;EACA,mBAAA;AzJ4gzEZ;;AyJrgzEQ;EACI,iCAAA;AzJwgzEZ;;A0JznzEA;EACI,gBAAA;A1J4nzEJ;;A0JxnzEI;EACI,gBAAA;A1J2nzER;A0JxnzEI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;A1J0nzER;A0JvnzEI;EACI;IACI,gBAAA;E1JynzEV;E0JtnzEM;IACI,qBAAA;IACA,SAAA;E1JwnzEV;AACF;A0JrnzEI;EACI;IACI,eAAA;IACA,gBAAA;E1JunzEV;E0JpnzEM;IACI,kBAAA;IACA,QAAA;E1JsnzEV;AACF;;A0JjnzEA;EACI;IACI,yBAAA;E1JonzEN;E0JjnzEE;IACI,yCAAA;E1JmnzEN;E0JhnzEE;IACI,uCAAA;E1JknzEN;E0J/mzEE;IACI,yCAAA;E1JinzEN;E0J9mzEE;IACI,uCAAA;E1JgnzEN;E0J7mzEE;IACI,wCAAA;E1J+mzEN;E0J5mzEE;IACI,yBAAA;E1J8mzEN;AACF;A0J3mzEA;EACI,sCAAA;A1J6mzEJ;;A2JtrzEA;EACI,4CAAA;A3JyrzEJ;A2JvrzEI;EAHJ;IAIQ,gBAAA;E3J0rzEN;AACF;;A2JprzEA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;A3JurzEJ;A2JtrzEI;EANJ;IAOQ,aAAA;E3JyrzEN;AACF;A2JvrzEI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,mBhJuJK;EgJtJL,8FAAA;A3JyrzER;A2JrrzEI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A3JurzER;;A2JjrzEQ;EACI,+BAAA;A3JorzEZ;A2JlrzEY;EACI,0CAAA;A3JorzEhB;;A2J9qzEA;EACI,wCAAA;EACA,6CAAA;A3JirzEJ;;A2J3qzEQ;EACI,0BhJ+JG;AX+gzEf;;A2J/qzEQ;EACI,0BhJ+JG;AXmhzEf;;A2JnrzEQ;EACI,0BhJ+JG;AXuhzEf;;A2JvrzEQ;EACI,0BhJ+JG;AX2hzEf;;A2J3rzEQ;EACI,0BhJ+JG;AX+hzEf;;A2J/rzEQ;EACI,0BhJ+JG;AXmizEf;;A2JnszEQ;EACI,0BhJ+JG;AXuizEf;;A2JvszEQ;EACI,0BhJ+JG;AX2izEf;;A2JrszEA;EACI,kBAAA;A3JwszEJ;A2JtszEI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;A3JwszER;A2JtszEQ;EALJ;IAMQ,aAAA;E3JyszEV;AACF;A2JtszEI;EACI,aAAA;A3JwszER;A2JrszEI;EACI,eAAA;A3JuszER;;A2JnszEA;EACI,kBAAA;EACA,qBAAA;A3JsszEJ;A2JpszEI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;A3JsszER;A2JnszEI;EACI,iBAAA;A3JqszER;A2JlszEI;EACI,aAAA;A3JoszER;;A2J/rzEI;EACI,kBAAA;A3JkszER;A2JhszEQ;EACI,6BAAA;A3JkszEZ;A2JhszEY;EACI,gBAAA;A3JkszEhB;A2J9rzEQ;EACI,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;A3JgszEZ;A2J5rzEY;EACI,QAAA;A3J8rzEhB;A2JzrzEY;EACI,YAAA;EACA,QAAA;A3J2rzEhB;;A2JrrzEA;EACI,kBAAA;EACA,aAAA;A3JwrzEJ;A2JtrzEI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;A3JwrzER;A2JrrzEI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;A3JurzER;A2JrrzEQ;EALJ;IAMQ,aAAA;E3JwrzEV;AACF;A2JrrzEI;EACI,aAAA;A3JurzER;A2JprzEI;EACI,eAAA;A3JsrzER;;A2JlrzEA;EAGQ;IACI,wBAAA;E3JmrzEV;AACF;A2J9qzEI;EACI,eAAA;A3JgrzER;;A4J12zEA;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;A5J62zEJ;A4J32zEI;EACI,kBAAA;A5J62zER;;A4Jz2zEA;EACI,kBAAA;A5J42zEJ;A4J12zEI;EACI,UAAA;EACA,SAAA;EACA,gBAAA;A5J42zER;A4J12zEQ;EACI,cAAA;EACA,2BAAA;EACA,0CAAA;EACA,4CjJ4mBkB;EiJ3mBlB,oBjJ4pBkB;EiJ3pBlB,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A5J42zEZ;A4J12zEY;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;A5J42zEhB;;A4Jn2zEY;EACI,UAAA;EACA,uBAAA;EACA,kBAAA;A5Js2zEhB;A4Jj2zEI;EACI,kBAAA;EACA,WAAA;A5Jm2zER;A4Jj2zEQ;EACI,WAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;EACA,8CAAA;EACA,YAAA;EACA,kBAAA;A5Jm2zEZ;A4J/1zEY;EACI,aAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,gDAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8CAAA;A5Ji2zEhB;A4J/1zEgB;EACI,WAAA;EACA,UAAA;A5Ji2zEpB;A4J31zEI;EAGY;IACI,UAAA;IACA,UAAA;IACA,iBAAA;E5J21zElB;E4Jv1zEU;IACI,WAAA;E5Jy1zEd;AACF;;A4Jp1zEA;EACI,WAAA;A5Ju1zEJ;A4Jp1zEQ;EACI,aAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,gDAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;A5Js1zEZ;A4Jp1zEY;EACI,WAAA;EACA,WAAA;A5Js1zEhB;A4Jl1zEQ;EACI,cAAA;EACA,WAAA;A5Jo1zEZ;A4Jj1zEgB;EACI,YAAA;A5Jm1zEpB;A4J70zEI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,6CAAA;EACA,+CAAA;EACA,8CAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;A5J+0zER;A4J50zEI;EAEQ;IACI,UAAA;IACA,SAAA;IACA,gBAAA;E5J60zEd;E4Jz0zEM;IACI,kBAAA;IACA,OAAA;IACA,UAAA;E5J20zEV;AACF;;A4Jv0zEA;EACI,8CAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;A5J00zEJ;A4Jx0zEI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,8CAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;A5J00zER;A4Jv0zEI;EACI,sBAAA;EACA,UAAA;A5Jy0zER;A4Jt0zEI;EACI,eAAA;EACA,kBAAA;A5Jw0zER;A4Jt0zEQ;EACI,kBAAA;EACA,gDAAA;EACA,YAAA;A5Jw0zEZ;A4Jt0zEY;EACI,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;A5Jw0zEhB;A4Jn0zEI;EACI,cAAA;EACA,WAAA;A5Jq0zER;A4Jl0zEI;EACI;IACI,YAAA;E5Jo0zEV;AACF;A4Jj0zEI;EA3DJ;IA4DQ,WAAA;IACA,WAAA;IACA,cAAA;E5Jo0zEN;E4Jl0zEM;IACI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;IACA,4BAAA;IACA,UAAA;IACA,UAAA;IACA,QAAA;IACA,iBAAA;E5Jo0zEV;E4Jh0zEU;IACI,aAAA;E5Jk0zEd;AACF;;A4JxzzEI;EACI,UAAA;EACA,iBAAA;EACA,kBAAA;A5J2zzER;A4J1zzEQ;EACI,kBAAA;A5J4zzEZ;A4J1zzEQ;EAPJ;IAQQ,gBAAA;E5J6zzEV;E4J3zzEc;IACI,eAAA;E5J6zzElB;E4J5zzEkB;IACI,aAAA;E5J8zzEtB;E4J1zzEc;IACI,aAAA;E5J4zzElB;E4JrzzEM;IACI,kBAAA;E5JyzzEV;E4JxzzEU;IACI,iBAAA;E5J0zzEd;E4JzzzEc;;IAEI,kBAAA;E5J2zzElB;E4JzzzEkB;;IACI,WAAA;IACA,yBAAA;IACA,+CAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;E5J4zzEtB;E4JxzzEkB;IACI,WAAA;E5J0zzEtB;E4JvzzEc;IACI,kBAAA;IACA,0BAAA;E5JyzzElB;E4JvzzEkB;IACI,WAAA;IACA,WAAA;IACA,6CAAA;IACA,kBAAA;IACA,QAAA;IACA,2BAAA;IACA,OAAA;E5JyzzEtB;E4JrzzEc;IACI,iBAAA;E5JuzzElB;AAvCF;A4J3wzEI;EACI;IACI,iBAAA;E5JqzzEV;E4JpzzEU;IACI,iBAAA;E5JszzEd;E4JpzzEc;IACI,WAAA;IACA,YAAA;IACA,QAAA;IACA,+CAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,gBAAA;E5JszzElB;E4JnzzEc;IACI,WAAA;IACA,WAAA;IACA,6CAAA;IACA,kBAAA;IACA,MAAA;IACA,SAAA;E5JqzzElB;E4JjzzEkB;IACI,aAAA;E5JmzzEtB;E4J9yzEkB;IACI,WAAA;IACA,YAAA;IACA,+CAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;E5JgzzEtB;E4J9yzEkB;IACI,YAAA;E5JgzzEtB;E4J5yzEc;IACI,kBAAA;E5J8yzElB;E4J5yzEkB;IACI,WAAA;IACA,YAAA;IACA,+CAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,cAAA;E5J8yzEtB;AACF;A4JxyzEI;EACI,2BAAA;EACA,gBAAA;EACA,cAAA;A5J0yzER;;A4JlyzEI;EACI,2BAAA;EACA,cAAA;A5JqyzER;A4JlyzEQ;EACI,eAAA;A5JoyzEZ;A4JlyzEY;EACI,aAAA;A5JoyzEhB;A4JhyzEQ;EACI,aAAA;A5JkyzEZ;A4J/xzEI;EACI,kBAAA;EACA,iBAAA;A5JiyzER;A4JhyzEQ;EACI,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;A5JkyzEZ;A4J/xzEY;EACI,kBAAA;EACA,2BAAA;A5JiyzEhB;A4JhyzEgB;EACI,WAAA;EACA,WAAA;EACA,6CAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;A5JkyzEpB;A4J9xzEQ;EACI,iBAAA;A5JgyzEZ;A4J5xzEQ;EACI,kBAAA;A5J8xzEZ;A4J7xzEY;EACI,kBAAA;A5J+xzEhB;A4J9xzEgB;EACI,WAAA;EACA,YAAA;EACA,8CAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;A5JgyzEpB;A4J7xzEoB;EACI,YAAA;A5J+xzExB;A4JxxzEY;EACI,YAAA;A5J0xzEhB;;A6Jlv0EA;EACI,aAAA;EACA,kBAAA;EACA,qBAAA;A7Jqv0EJ;A6Jnv0EI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;A7Jqv0ER;A6Jlv0EI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8FAAA;EACA,YAAA;A7Jov0ER;;A6J/u0EI;EACI,mBAAA;A7Jkv0ER;A6Jhv0EQ;EACI,cAAA;EACA,UAAA;A7Jkv0EZ;A6J/u0EQ;EACI,gBAAA;A7Jiv0EZ;A6J/u0EY;EACI,kBAAA;A7Jiv0EhB;A6J/u0EgB;EACI,WAAA;A7Jiv0EpB;A6J7u0EY;EACI,cAAA;A7J+u0EhB;A6J3u0EgB;EACI,qBAAA;EACA,cAAA;A7J6u0EpB;A6J1u0EgB;EACI,WlJkGT;AX0o0EX;A6Jxu0EoB;EACI,WlJ6Fb;AX6o0EX;A6Jru0EY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;A7Juu0EhB;A6Jru0EgB;EACI,eAAA;A7Juu0EpB;A6Jpu0EgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;A7Jsu0EpB;A6Jlu0EY;EACI,WAAA;EACA,gBAAA;A7Jou0EhB;A6Jhu0EQ;EACI;IACI,cAAA;IACA,aAAA;E7Jku0Ed;AACF;A6J/t0EQ;EACI;IACI,cAAA;IACA,UAAA;E7Jiu0Ed;AACF;A6J9t0EQ;EACI;IACI,cAAA;IACA,WAAA;E7Jgu0Ed;AACF;A6J5t0EI;EACI,sBAAA;A7J8t0ER;A6J5t0EQ;EACI,mBAAA;A7J8t0EZ;A6J5t0EY;EACI,mBAAA;EACA,8BAAA;A7J8t0EhB;A6J3t0EY;EACI,aAAA;EACA,mBAAA;A7J6t0EhB;A6J3t0EgB;EACI,YAAA;EACA,WAAA;EACA,eAAA;A7J6t0EpB;A6J1t0EgB;EACI,iBAAA;A7J4t0EpB;A6Jxt0EY;EACI,WAAA;EACA,cAAA;EAEA,QAAA;A7J0t0EhB;A6Jvt0EY;EACI,clJsCH;AXmr0Eb;A6Jrt0EQ;EAtCJ;IAuCQ,mBAAA;E7Jwt0EV;E6Jvt0EU;IAGI,cAAA;IACA,WAAA;E7Jyt0Ed;E6Jrt0Ec;IACI,WAAA;IACA,cAAA;IACA,SAAA;IACA,mBAAA;E7Jut0ElB;E6Jrt0EkB;IACI,UAAA;E7Jut0EtB;E6Jnt0Ec;IACI,mBAAA;E7Jqt0ElB;E6Jlt0Ec;IACI,WAAA;IACA,gBAAA;E7Jot0ElB;AACF;;A6J9s0EA;EACI,cAAA;A7Jit0EJ;;A6J5s0EQ;EACI,yBlJCC;EkJAD,WlJtCD;AXqv0EX;;A6Jzs0EI;EACI,qBAAA;EACA,cAAA;EACA,WAAA;A7J4s0ER;A6J1s0EI;EACI,WlJlDG;AX8v0EX;A6Jxs0EQ;EACI,WlJvDD;AXiw0EX;;A8Jr50EA;EACI,kBAAA;EACA,aAAA;EACA,SAAA;A9Jw50EJ;A8Jr50EI;EACI,UAAA;A9Ju50ER;A8Jp50EgB;EACI,aAAA;A9Js50EpB;A8Jj50EI;EACI,eAAA;EACA,gBnJ2Ga;EmJ1Gb,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;A9Jm50ER;A8Jh50EI;EACI,0CAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBnJ2lBsB;EmJ1lBtB,4CnJmmBsB;EmJlmBtB,gBnJ0pBsB;EmJzpBtB,eAAA;A9Jk50ER;A8Jj50EQ;EARJ;IASQ,eAAA;E9Jo50EV;AACF;A8Jl50EQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,qBAAA;A9Jo50EZ;;A8J940EA;EACI,sCAAA;A9Ji50EJ;;A8J940EA;EACI;IAAK,wBAAA;E9Jk50EP;E8Jj50EE;IAAO,4BAAA;E9Jo50ET;AACF;A8Jl50EA;EACI,gBnJ6nB0B;EmJ5nB1B,yBAAA;EACA,WnJsFO;EmJrFP,4BAAA;A9Jo50EJ;;A8Jj50EA;EACI,gBAAA;A9Jo50EJ;;A+Jz90EA;EACI,kBAAA;EACA,gBAAA;A/J490EJ;A+J190EI;EACI,eAAA;EACA,WpJgJG;EoJ/IH,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;A/J490ER;A+J190EQ;EACI,eAAA;A/J490EZ;A+Jz90EQ;EAdJ;IAeQ,eAAA;E/J490EV;E+J190EU;IACI,eAAA;E/J490Ed;AACF;;A+Jt90EI;EACI,aAAA;A/Jy90ER;A+Jx90EQ;EACI,cAAA;A/J090EZ;A+Jx90EQ;EACI,cAAA;A/J090EZ;A+Jx90EQ;EACI,cAAA;A/J090EZ;;A+Jr90EA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A/Jw90EJ;A+Jt90EI;EACI,iBAAA;EACA,eAAA;A/Jw90ER;A+Jr90EI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,mCAAA;EACA,iCAAA;A/Ju90ER;A+Jr90EQ;EACI,qBAAA;A/Ju90EZ;A+Jp90EQ;EACI,qBAAA;A/Js90EZ;;A+Jj90EA;EACI;IACI,UAAA;IACA,mBAAA;E/Jo90EN;E+Jj90EE;IACI,UAAA;IACA,mBAAA;E/Jm90EN;AACF;A+J/80EI;EACI,WAAA;EACA,qBAAA;A/Ji90ER;;AgK/i1EA;EACI,aAAA;AhKkj1EJ;;AgK9i1EI;EACI,UAAA;EACA,YAAA;EACA,0CAAA;AhKij1ER;AgK9i1EI;EACI,0CAAA;AhKgj1ER;;AgKzi1EI;EADJ;IAEQ,gBAAA;IACA,sBAAA;EhK6i1EN;AACF;;AgKxi1EQ;EACI,wCAAA;EACA,sBrJ2lBkB;EqJ1lBlB,eAAA;EACA,eAAA;AhK2i1EZ;AgKvi1EY;EACI,iCAAA;AhKyi1EhB;;AgKhi1EY;EACI,crJ0IH;AXy50Eb;;AiKjl1EQ;EACI,YAAA;AjKol1EZ;;AiK9k1EI;EACI,YAAA;EACA,mBAAA;EACA,eAAA;AjKil1ER;AiK/k1EI;EACI,uBAAA;AjKil1ER;AiK/k1EI;EACI,WAAA;AjKil1ER;AiKhl1EQ;EACI,QAAA;AjKkl1EZ;AiKhl1EQ;EACI,mBAAA;AjKkl1EZ;;AkKzm1EA;EACE,kBAAA;EACA,kBAAA;AlK4m1EF;;AkKvm1EA;EACE,2BAAA;EACA,kBAAA;EACA,0CAAA;AlK0m1EF;AkKxm1EE;EALF;IAMI,gBAAA;IACA,gBAAA;IACA,uCAAA;ElK2m1EF;AACF;;AkKxm1EA;EACE,SAAA;AlK2m1EF;AkKvm1EM;EACE,mDvJ8Ge;EuJ7Gf,wBvJ8GgB;AX2/0ExB;AkKvm1EQ;EACE,8DAAA;EACA,yBAAA;AlKym1EV;AkKpm1EI;EACE,cAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oCvJ/B4C;EuJgC5C,gBvJsFe;EuJrFf,oBvJ0oBwB;AX49zE9B;AkKnm1EI;EACE,eAAA;AlKqm1EN;AkKlm1EI;EACE,gBvJyoBwB;AX29zE9B;AkKjm1EI;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AlKmm1EN;AkKjm1EM;EACE,iBAAA;EACA,gBvJ6nBsB;EuJ5nBtB,eAAA;AlKmm1ER;;AkK7l1EA;EACE,kBAAA;AlKgm1EF;AkK9l1EE;EACE,WAAA;EACA,YAAA;EACA,yBvJgFO;EuJ/EP,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AlKgm1EJ;AkK5l1EI;EACE,yBvJoGO;AX0/0Eb;AkKzl1EI;EACE,yBvJ6FO;AX8/0Eb;;AkKtl1EA;EACE,+BAAA;AlKyl1EF;AkKvl1EE;EAHF;IAII,2BAAA;ElK0l1EF;AACF;;AkKpl1EE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oCvJxG8C;EuJyG9C,gBvJaiB;EuJZjB,oBvJikB0B;AXsh0E9B;;AkKnl1EA;EACE,iBAAA;EACA,cvJ2DW;EuJ1DX,gBvJKmB;EuJJnB,kBAAA;EACA,eAAA;AlKsl1EF;AkKrl1EE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,QAAA;EACA,iCAAA;AlKul1EJ;;AkKjl1EA;EACE,oDAAA;EACA,oBAAA;EACA,kBAAA;EACA,mCAAA;AlKol1EF;AkKll1EE;EANF;IAOI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,wBAAA;IACA,kBAAA;IACA,2BAAA;IACA,WAAA;IACA,iBAAA;ElKql1EF;EkKnl1EE;IACE,mBAAA;IACA,wBAAA;ElKql1EJ;AACF;AkKll1EE;EACE,kBAAA;AlKol1EJ;AkKhl1EI;EACE,aAAA;AlKkl1EN;AkK/k1EM;EADF;IAEI,wBAAA;ElKkl1EN;AACF;;AkK7k1EA;EACE,oCAAA;EACA,0CAAA;AlKgl1EF;AkK/k1EE;EAHF;IAII,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,UAAA;ElKkl1EF;AACF;;AkK9k1EE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cvJxCO;AXyn1EX;AkK/k1EE;EAVF;IAWI,aAAA;IACA,yBAAA;ElKkl1EF;AACF;;AkK/k1EA;EACE,sCAAA;AlKkl1EF;AkKjl1EE;EAFF;IAGI,sCAAA;ElKol1EF;AACF;AkKll1EE;EACE,aAAA;EACA,sBAAA;AlKol1EJ;AkKll1EI;EACE,gBAAA;AlKol1EN;AkKhl1EE;EACE,iBAAA;EACA,gBAAA;AlKkl1EJ;AkKjl1EI;EACE,aAAA;AlKml1EN;AkK7k1EM;EACE,gBAAA;AlK+k1ER;AkKxk1EM;EACE,aAAA;AlK0k1ER;AkKvk1EI;EACE,kBAAA;AlKyk1EN;AkKrk1EM;EACE,mBAAA;AlKuk1ER;AkKlk1EE;EACE,kBAAA;AlKok1EJ;AkKlk1EI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AlKok1EN;AkKhk1EE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AlKkk1EJ;AkKhk1EI;EACE,sBvJ1HK;EuJ2HL,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AlKkk1EN;AkK/j1EI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,yCAAA;EACA,SAAA;AlKik1EN;AkK9j1EI;EACE,eAAA;AlKgk1EN;AkK5j1EE;EACE,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AlK8j1EJ;AkK5j1EI;EAPF;IAQI,cAAA;ElK+j1EJ;AACF;AkK7j1EI;EACE,aAAA;EACA,mBAAA;AlK+j1EN;AkK5j1EI;EACE,qBAAA;EACA,sBAAA;AlK8j1EN;AkK3j1EI;EACE,kBAAA;EACA,iCvJzLkB;EuJ0LlB,kBAAA;EACA,kBAAA;EACA,6CvJmUwB;AX0v0E9B;AkK1j1EQ;EACE;IACE,aAAA;ElK4j1EV;EkKzj1EQ;IACE,cAAA;ElK2j1EV;AACF;AkKtj1EI;EACE,gBvJnNe;EuJoNf,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AlKwj1EN;AkKpj1EM;EACE,eAAA;EACA,YAAA;EACA,cvJjMG;AXuv1EX;AkKrj1EQ;EACE,aAAA;AlKuj1EV;AkKpj1EQ;EARF;IASI,aAAA;ElKuj1ER;AACF;AkKnj1EI;EACE,eAAA;EACA,eAAA;EACA,iBAAA;AlKqj1EN;AkKlj1EI;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AlKoj1EN;AkKlj1EM;EACE,kBAAA;AlKoj1ER;AkKjj1EM;EACE,gBAAA;AlKmj1ER;AkKhj1EM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AlKkj1ER;AkK/i1EU;EACE,eAAA;EACA,WvJhPD;EuJiPC,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AlKij1EZ;AkK1i1EE;EACE,yBAAA;AlK4i1EJ;AkK1i1EI;EACE,QAAA;EACA,iBAAA;EACA,iBAAA;AlK4i1EN;AkKzi1EI;EACE,gBAAA;EACA,cvJnQK;AX8y1EX;AkKxi1EI;EACE,iBAAA;AlK0i1EN;AkKxi1EM;EACE,yBAAA;AlK0i1ER;AkKxi1EQ;EACE,QAAA;EACA,mDvJnSa;EuJoSb,wBvJnSc;EuJoSd,iBAAA;EACA,gBvJ0NoB;AXg10E9B;AkKxi1EU;EACE,0CAAA;EACA,4CAAA;EACA,cvJnRD;AX6z1EX;AkKxi1EY;EACE,qCAAA;AlK0i1Ed;AkKpi1EM;EACE,yBAAA;AlKsi1ER;AkKpi1EQ;EACE,QAAA;AlKsi1EV;AkKni1EQ;EACE,QAAA;AlKqi1EV;AkKli1EQ;EACE,QAAA;AlKoi1EV;AkKhi1EM;EACE,QAAA;AlKki1ER;AkK9h1EI;EACE,yBvJlTK;AXk11EX;;AkK3h1EA;EACE,iCAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;AlK8h1EF;AkK5h1EE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cvJ3SS;AXy01Eb;AkK5h1EE;EACE,cAAA;AlK8h1EJ;;AkK1h1EA;EACE,aAAA;AlK6h1EF;AkK3h1EI;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AlK6h1EN;AkK5h1EM;EACE,cvJvVG;AXq31EX;;AkKvh1EA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;AlK0h1EF;;AkKvh1EA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,4CAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AlK0h1EF;AkKxh1EE;EAXF;IAYI,aAAA;ElK2h1EF;AACF;AkKzh1EE;EACE,4BAAA;EACA,UAAA;AlK2h1EJ;AkKzh1EI;EAJF;IAKI,4BAAA;ElK4h1EJ;AACF;;AkKxh1EA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kDAAA;EACA,qDAAA;AlK2h1EF;AkKzh1EE;EACE,qCAAA;EACA,eAAA;AlK2h1EJ;;AkKrh1EE;EACE,2BAAA;AlKwh1EJ;AkKph1EI;EACE,0BAAA;AlKsh1EN;AkKlh1EE;EACE,oBAAA;EACA,qBAAA;AlKoh1EJ;;AkK7g1EI;EADF;IAEI,yBAAA;IACA,0BAAA;ElKih1EJ;AACF;AkKhh1EI;EALF;IAMI,wBAAA;ElKmh1EJ;AACF;AkKhh1EE;EACE,wCAAA;AlKkh1EJ;AkKjh1EI;EAFF;IAGI,uCAAA;ElKoh1EJ;AACF;AkKjh1EE;EACE,2BAAA;AlKmh1EJ;AkKlh1EI;EAFF;IAGI,2BAAA;ElKqh1EJ;AACF;AkKlh1EE;EACE,sCAAA;AlKoh1EJ;AkKnh1EI;EAFF;IAGI,sCAAA;ElKsh1EJ;AACF;;AmK/m2EA;EACE,kBAAA;EACA,kBAAA;AnKkn2EF;;AmK7m2EA;EACE,2BAAA;EACA,kBAAA;EACA,0CAAA;EACA,oBAAA;AnKgn2EF;AmK9m2EE;EANF;IAOI,gBAAA;IACA,gBAAA;IACA,uCAAA;EnKin2EF;AACF;AmK/m2EE;EAZF;IAaI,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6CxJ0mB0B;IwJzmB1B,4BAAA;IACA,kBAAA;IACA,aAAA;EnKkn2EF;EmKhn2EE;IACE,mBAAA;IACA,eAAA;EnKkn2EJ;AACF;AmK/m2EE;EACE,2BAAA;AnKin2EJ;AmK/m2EI;EAHF;IAII,2BAAA;EnKkn2EJ;AACF;;AmK7m2EE;EACE,aAAA;EACA,mBAAA;EACA,cxJyGO;EwJxGP,cAAA;EACA,gBxJ0EiB;AXsi2ErB;AmK9m2EI;EACE,cxJ4HO;AXo/1Eb;AmK7m2EI;EACE,eAAA;AnK+m2EN;AmK5m2EI;EACE,cxJ0HO;EwJzHP,gBxJ0nBwB;AXo/0E9B;AmK5m2EM;EACE,cxJsHK;AXw/1Eb;;AmKvm2EE;EACE,iBAAA;AnK0m2EJ;AmKzm2EI;EACE,gDAAA;AnK2m2EN;;AmKtm2EE;EACE,cxJwEO;AXii2EX;AmKvm2EI;EACE,cxJiGO;AXwg2Eb;;AmKpm2EA;EACE,WAAA;EACA,0CAAA;EACA,oBAAA;AnKum2EF;;AmKpm2EA;EACE,eAAA;EACA,YxJUc;EwJTd,SAAA;EACA,2BAAA;EACA,UAAA;AnKum2EF;;AmKpm2EA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,wCAAA;AnKum2EF;;AmKnm2EE;EACE,eAAA;EACA,mBAAA;AnKsm2EJ;AmKnm2EE;EACE,iBAAA;AnKqm2EJ;AmKnm2EI;EAHF;IAII,eAAA;EnKsm2EJ;AACF;;AmKlm2EA;EACE,2BAAA;AnKqm2EF;AmKnm2EE;EAHF;IAII,2BAAA;EnKsm2EF;AACF;;AmKnm2EA;EACE,2BAAA;AnKsm2EF;AmKpm2EE;EAHF;IAII,2BAAA;EnKum2EF;AACF;;AmKpm2EA;EACE,cAAA;EACA,eAAA;EACA,SAAA;AnKum2EF;AmKrm2EE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AnKum2EJ;AmKrm2EI;EACE,yBAAA;AnKum2EN;AmKpm2EI;EACE,2BAAA;EACA,0BAAA;AnKsm2EN;AmKnm2EI;EACE,WAAA;EACA,kBAAA;AnKqm2EN;AmKlm2EI;EACE,YAAA;AnKom2EN;AmKlm2EM;;;EAGE,cAAA;EACA,WAAA;AnKom2ER;AmKjm2EM;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AnKmm2ER;AmKhm2EM;EACE,qBAAA;EACA,mBAAA;AnKkm2ER;AmK/l2EM;EACE,gBAAA;EACA,gBAAA;AnKim2ER;AmK9l2EM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AnKgm2ER;AmK9l2EQ;EAVF;IAWI,UAAA;EnKim2ER;AACF;AmK7l2EI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AnK+l2EN;AmK7l2EM;;EAEE,kBAAA;EACA,MAAA;AnK+l2ER;AmK5l2EM;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AnK8l2ER;AmK5l2EQ;EACE,yBAAA;AnK8l2EV;AmK1l2EM;EACE,QAAA;EACA,YAAA;EACA,kBAAA;AnK4l2ER;AmKxl2EI;EAEE,iCAAA;EACA,iCAAA;AnKyl2EN;AmKtl2EI;EACE,yBAAA;AnKwl2EN;AmKtl2EM;EACE,yBAAA;EACA,gBxJgbsB;AXwq1E9B;;AmKll2EA;;EAEE,aAAA;AnKql2EF;;AmKll2EA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;AnKql2EF;;AmKll2EA;EACE,mBAAA;AnKql2EF;;AmKll2EA;EACE;IACE,eAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6CxJsV0B;IwJrV1B,2BAAA;EnKql2EF;EmKjl2EE;IACE,eAAA;EnKml2EJ;AACF;AmK/k2EA;EACE;IACE,YAAA;EnKil2EF;AACF;AmK7k2EE;EACE,4BAAA;AnK+k2EJ;;AmK3k2EA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,YxJ5Nc;EwJ6Nd,WxJ7Nc;EwJ8Nd,UAAA;EACA,aAAA;AnK8k2EF;AmK7k2EE;EACE,6CxJsT0B;AXyx1E9B;AmK5k2EE;EAZF;IAaI,UAAA;IACA,WAAA;EnK+k2EF;AACF;;AmKzk2EI;EADF;IAEI,yBAAA;IACA,0BAAA;EnK6k2EJ;AACF;AmK5k2EI;EALF;IAMI,wBAAA;EnK+k2EJ;AACF;AmK5k2EE;EACE,wCAAA;AnK8k2EJ;AmK7k2EI;EAFF;IAGI,aAAA;EnKgl2EJ;AACF;AmK/k2EI;EACE,2BAAA;AnKil2EN;AmKhl2EM;EAFF;IAGI,2BAAA;EnKml2EN;AACF;AmK/k2EE;EACE,2BAAA;AnKil2EJ;AmK9k2EE;EACE,2BAAA;AnKgl2EJ;AmK/k2EI;EAFF;IAGI,2BAAA;EnKkl2EJ;AACF;;AmK7k2EE;EACE,wBAAA;AnKgl2EJ;;AoK/82EA;EACI,aAAA;EACA,gBAAA;EACA,oBAAA;ApKk92EJ;AoKh92EI;EACI,gBAAA;EACA,kBAAA;ApKk92ER;AoK/82EI;EACI,wBAAA;ApKi92ER;AoK982EI;EACI,WAAA;ApKg92ER;AoK782EI;EACI,WAAA;ApK+82ER;AoK582EI;EACI,iDAAA;EACA,kBAAA;ApK882ER;AoK382EI;EACI,kBAAA;ApK682ER;;AoKx82EI;EACI,sCAAA;ApK282ER;AoKx82EI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;ApK082ER;AoKv82EI;EACI,kBAAA;ApKy82ER;;AoKr82EA;EACI,+BAAA;ApKw82EJ;;AoKp82EA;EACI,iBAAA;EACA,kBAAA;ApKu82EJ;AoKp82EQ;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;ApKs82ER;;AoK/72EQ;EACI,UAAA;ApKk82EZ;AoK972EY;EACI,UAAA;ApKg82EhB;;AqKph3EI;EACI,0CAAA;EACA,eAAA;ArKuh3ER;;AqKjh3EA;EACI,eAAA;EACA,kBAAA;ArKoh3EJ;AqKlh3EI;EAJJ;IAKQ,eAAA;ErKqh3EN;AACF;;AqKlh3EA;EACI,kBAAA;ArKqh3EJ;AqKnh3EI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;ArKqh3ER;;AqK/g3EA;EACI,iBAAA;EACA,yBAAA;ArKkh3EJ;AqKjh3EI;EAHJ;IAIQ,0CAAA;IACA,kDAAA;IACA,iBAAA;ErKoh3EN;AACF;AqKhh3EY;EACI,eAAA;EACA,gB1J+EK;E0J9EL,oBAAA;EACA,oC1JzCkC;E0J0ClC,qBAAA;EACA,aAAA;ArKkh3EhB;AqKhh3EgB;EARJ;IASQ,gBAAA;ErKmh3ElB;AACF;AqKjh3EgB;EAGI,yBAAA;ArKih3EpB;AqK7g3EgB;EACI,yBAAA;ArK+g3EpB;AqKzg3EI;EACI,0CAAA;EACA,kDAAA;ArK2g3ER;;AqKpg3EQ;EACI,aAAA;ArKug3EZ;AqKpg3EQ;EACI,cAAA;ArKsg3EZ;AqKjg3EY;EACI,sCAAA;ArKmg3EhB;AqK5/2EgB;EACI,qBAAA;ArK8/2EpB;AqKz/2EY;EACI,cAAA;ArK2/2EhB;AqKx/2EY;EACI,aAAA;ArK0/2EhB;;AqKl/2EA;EACI,gDAAA;ArKq/2EJ;AqKj/2EY;EACI,8BAAA;ArKm/2EhB;;AqK7+2EA;EACI,0DAAA;EACA,6BAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;ArKg/2EJ;;AqK7+2EA;EACI,kBAAA;EACA,UAAA;ArKg/2EJ;AqK7+2EQ;EACI,0CAAA;EACA,YAAA;EACA,kBAAA;ArK++2EZ;AqK3+2EI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;ArK6+2ER;AqK1+2EI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;ArK4+2ER;;AqKv+2EA;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;ArK0+2EJ;;AqKr+2EA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;ArKw+2EJ;;AqKp+2EA;EACI,kBAAA;ArKu+2EJ;AqKr+2EI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;ArKu+2ER;;AqKn+2EA;EACI,cAAA;ArKs+2EJ;;AqKj+2EQ;EACI,cAAA;EACA,cAAA;EACA,cAAA;EACA,gCAAA;ArKo+2EZ;AqKl+2EY;EACI,+BAAA;ArKo+2EhB;;AqK792EI;EACI,cAAA;EACA,2CAAA;EACA,yBAAA;ArKg+2ER;AqK992EQ;EACI,W1JtED;E0JuEC,yB1JzCC;AXyg3Eb;;AqK192EI;EACI,YAAA;ArK692ER;;AqKp92EQ;;EAEI,YAAA;ArKu92EZ;AqKp92EQ;EACI,qDAAA;ArKs92EZ;AqK982EgB;EACI,aAAA;ArKg92EpB;AqK782EgB;EACI,cAAA;ArK+82EpB;;AsK9s3EI;EACI,c3J0JG;E2JzJH,iCAAA;EACA,4C3J+nBsB;E2J9nBtB,oB3J+qBsB;AXki2E9B;AsKht3EQ;EAEI,yBAAA;EACA,c3J8KC;AXmi3Eb;;AsK5s3EA;EACI,kBAAA;EACA,gBAAA;AtK+s3EJ;AsK9s3EI;EACI,aAAA;EACA,iBAAA;AtKgt3ER;AsK9s3EI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AtKgt3ER;AsK/s3EQ;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,uCAAA;EACA,UAAA;EACA,yBAAA;AtKit3EZ;AsK9s3EQ;EACI,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;AtKgt3EZ;AsK9s3EY;EACI,UAAA;EACA,aAAA;EACA,qBAAA;AtKgt3EhB;AsKxs3EgB;EACI,UAAA;EACA,SAAA;AtK0s3EpB;AsKts3EY;EACI,UAAA;AtKws3EhB;AsKps3EI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,0CAAA;EACA,0BAAA;EACA,YAAA;AtKss3ER;;AsKjs3EA;EAEI,sBAAA;EACA,2BAAA;EACA,wBAAA;AtKms3EJ;AsKls3EI;EACI,yBAAA;EACA,aAAA;AtKos3ER;;AsK/r3EI;EACI,aAAA;AtKks3ER;AsKhs3EQ;EACI,cAAA;AtKks3EZ;;AuK/x3EA;EACI,+BAAA;AvKky3EJ;AuKhy3EI;EAHJ;IAIQ,2BAAA;EvKmy3EN;AACF;AuKjy3EI;EACI,gBAAA;AvKmy3ER;AuKjy3EQ;EACI,qBAAA;EACA,gB5JmHS;E4JlHT,yBAAA;AvKmy3EZ;AuKjy3EY;EAGI,c5JwKH;AXyn3Eb;AuK5x3EY;EACI,kBAAA;EACA,kBAAA;AvK8x3EhB;AuK5x3EgB;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,kCAAA;EACA,oCAAA;AvK8x3EpB;;AuKvx3EA;EACI,kBAAA;EACA,0CAAA;AvK0x3EJ;AuKxx3EI;EAJJ;IAKQ,gBAAA;IACA,gBAAA;IACA,uCAAA;EvK2x3EN;AACF;AuKzx3EI;EAVJ;IAWQ,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6C5J4kBsB;I4J3kBtB,4BAAA;IACA,kBAAA;IACA,aAAA;EvK4x3EN;EuK1x3EM;IACI,mBAAA;IACA,eAAA;EvK4x3EV;AACF;;AuKxx3EA;EACI,2BAAA;AvK2x3EJ;AuK1x3EI;EAFJ;IAGQ,2BAAA;EvK6x3EN;AACF;;AuK1x3EA;EACI,0CAAA;AvK6x3EJ;;AuK1x3EA;EACI,2BAAA;EACA,gBAAA;AvK6x3EJ;AuK3x3EQ;EACI,wBAAA;AvK6x3EZ;AuK1x3EQ;EACI,WAAA;AvK4x3EZ;AuKzx3EQ;EACI,YAAA;AvK2x3EZ;AuKxx3EQ;EACI,iDAAA;EACA,mBAAA;EACA,0CAAA;AvK0x3EZ;AuKvx3EQ;EACI,mBAAA;EACA,0CAAA;AvKyx3EZ;AuKvx3EI;EA1BJ;IA2BQ,2BAAA;EvK0x3EN;AACF;AuKxx3EI;EACI,YAAA;AvK0x3ER;;AuKtx3EA;EACI,2BAAA;AvKyx3EJ;AuKxx3EI;EAFJ;IAGQ,aAAA;EvK2x3EN;AACF;AuKzx3EI;EACI,YAAA;AvK2x3ER;;AuKvx3EA;EACI,UAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;AvK0x3EJ;;AuKtx3EI;EACI,cAAA;AvKyx3ER;;AuKrx3EA;EACI,aAAA;AvKwx3EJ;;AuKrx3EA;EACI;IACI,eAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6C5J4esB;I4J3etB,2BAAA;EvKwx3EN;EuKpx3EM;IACI,eAAA;EvKsx3EV;AACF;AuKlx3EA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AvKox3EJ;;AwK173EQ;EACI,2BAAA;EACA,eAAA;EACA,gB7J0HS;E6JzHT,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AxK673EZ;AwK573EY;EACI,c7J8KH;AXgx3Eb;;AwKx73EA;EACI,2BAAA;EACA,gBAAA;AxK273EJ;AwK173EI;EACI,wBAAA;AxK473ER;AwKz73EI;EACI,UAAA;AxK273ER;AwKx73EI;EACI,YAAA;AxK073ER;AwKv73EI;EACI,iDAAA;EACA,kBAAA;AxKy73ER;AwKt73EI;EACI,kBAAA;AxKw73ER;;AwKh73EgB;EACI,6BAAA;AxKm73EpB;;AwK563EA;EACI,YAAA;AxK+63EJ;;AwK563EA;EACI,aAAA;AxK+63EJ;;AyK3+3EA;EACI,0DAAA;EACA,sBAAA;EACA,2BAAA;AzK8+3EJ;;AyK1+3EI;EACI,aAAA;AzK6+3ER;;AyKt+3EY;EADJ;IAEQ,UAAA;EzK0+3Ed;AACF;;A0K//3EA;EACI,UAAA;A1Kkg4EJ;;A0K3/3EY;EACI,cAAA;EACA,aAAA;A1K8/3EhB;A0Kz/3EI;EAVJ;IAWQ,0CAAA;IACA,eAAA;E1K4/3EN;AACF;;A0Kx/3EA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;A1K2/3EJ;;A0Kx/3EA;EACI,0CAAA;EACA,sB/JgmB0B;E+J/lB1B,gBAAA;A1K2/3EJ;A0Kz/3EI;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;A1K2/3ER;A0Kx/3EI;EACI,gBAAA;A1K0/3ER;A0Kv/3EI;EACI,8CAAA;A1Ky/3ER;A0Kt/3EI;EApBJ;IAqBQ,6BAAA;E1Ky/3EN;E0Kv/3EM;IACI,sB/JsGD;I+JrGC,sB/JykBkB;EXg72E5B;E0Kt/3EM;IACI,SAAA;E1Kw/3EV;E0Kr/3EM;IACI,sB/JikBkB;EXs72E5B;AACF;;A0Kn/3EA;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;A1Ks/3EJ;A0Kp/3EI;EACI,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1Ks/3ER;A0Kn/3EI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1Kq/3ER;A0Kl/3EI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1Ko/3ER;A0Kj/3EI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1Km/3ER;A0Kh/3EI;EAhDJ;IAiDQ,aAAA;E1Km/3EN;AACF;;A0K/+3EI;EACI,kBAAA;EACA,UAAA;A1Kk/3ER;;A0K7+3EA;;;EAGI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;A1Kg/3EJ;A0K9+3EI;;;EACI,2BAAA;A1Kk/3ER;;A0K9+3EA;EACI,YAAA;EACA,SAAA;A1Ki/3EJ;A0K/+3EI;EAJJ;IAKQ,OAAA;E1Kk/3EN;AACF;;A0K/+3EA;EACI,YAAA;EACA,aAAA;A1Kk/3EJ;A0Kh/3EI;EAJJ;IAKQ,QAAA;E1Km/3EN;AACF;;A0Kh/3EA;EACI,YAAA;EACA,aAAA;A1Km/3EJ;A0Kj/3EI;EAJJ;IAKQ,QAAA;IACA,SAAA;E1Ko/3EN;AACF;;A0Kj/3EA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iKAAA;EACA,UAAA;EACA,YAAA;A1Ko/3EJ;A0Kl/3EI;EACI,kBAAA;EACA,UAAA;A1Ko/3ER;;A0Kh/3EA;EACI,kBAAA;A1Km/3EJ;A0Kj/3EI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,sB/JybsB;AX0j3E9B;A0Kj/3EQ;EAXJ;IAYQ,WAAA;IACA,SAAA;E1Ko/3EV;AACF;;A0K/+3EA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;A1Kk/3EJ;;A2Kps4EA;;;;;;CAAA;AASE;EACE,sBAAA,EAAA,aAAA;EACA,oCAAA;A3Kqs4EJ;A2Kps4EI;EACE,oCAAA;A3Kss4EN;A2Kns4EE;EACE,oCAAA;EACA,oCAAA;EACA,gBAAA;A3Kqs4EJ;A2Kps4EI;EACE,+CAAA;A3Kss4EN;A2Kns4EE;EACE,oCAAA;A3Kqs4EJ;A2Kps4EI;EACE,eAAA;EACA,oCAAA;A3Kss4EN;A2Krs4EM;EACE,oCAAA;A3Kus4ER;A2Kps4EI;EACE,eAAA;EACA,oCAAA;A3Kss4EN;A2Kns4EE;EACE,iCAAA;A3Kqs4EJ;A2Kns4EE;EACE,8BhK4FY;AXym4EhB;A2Kns4EE;EACE,8BhKyFY;AX4m4EhB;A2Kns4EE;;EAEE,8BhKqFY;AXgn4EhB;A2Kls4EE;EACE,2BAAA;A3Kos4EJ;;A2Khs4EA;;EAEE,SAAA;A3Kms4EF;;A2Khs4EA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;A3Kms4EF;;A2Khs4EA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,sCAAA;A3Kms4EF;;A2Khs4EA;EACE,WAAA;EACA,UAAA;A3Kms4EF;;A2Khs4EA;EACE;IACE,OAAA;E3Kms4EF;E2Khs4EA;IACE,WAAA;E3Kks4EF;AACF;A2K7r4EA;;;;EAIE,wCAAA;EACA,sCAAA;A3K+r4EF;;A2K5r4EA;EACE,sDAAA;EACA,qDAAA;A3K+r4EF;;A2K5r4EA;EACE,sDAAA;EACA,qDAAA;A3K+r4EF;;A2K5r4EA;EACE,qDAAA;EACA,sDAAA;A3K+r4EF;;A2K5r4EA;EACE,sDAAA;A3K+r4EF;;AA7y4EA;EACE,gCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCACE;AA+y4EJ;;AAly4EE;EACE,kDAAA;AAqy4EJ;;AAhy4EE;EACE,aAAA;EACA,SAAA;AAmy4EJ;;AA/x4EA;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;EACA,oBAAA;AAky4EF;;AA/x4EA;;EAEE,sBAAA;AAky4EF;;AA/x4EA;EACE,8BAAA;EACA,8CAAA;EAEA,2BAAA;AAky4EF;;AA/x4EA;EACE,8BAAA;EACA,6BAAA;EACA,oCAAA;EACA,4CAAA;EACA,wCAAA;EACA,2BAAA;EACA,sBAAA;AAky4EF;;AA/x4EA;EACE,kBAAA;AAky4EF;;AA9x4EA;;EAEE,uBAAA;EACA,0BAAA;EACA,iBAAA;AAiy4EF;;AA9x4EA;EACE,uBAAA;AAiy4EF;;AmBzy4EI;EnBYF;IACE,yBAAA;IACA,kBAAA;EAiy4EF;EA/x4EE;;;IAGE,WAAA;IACA,cAAA;IACA,WAAA;IACA,cAAA;EAiy4EJ;EA1x4EM;IACE,WAAA;EA4x4ER;EAtx4EA;IACE,aAAA;EAwx4EF;AACF;AArx4EA;EACE,wBAAA;AAux4EF;;AApx4EA;EACE,aAAA;AAux4EF;;AApx4EA;EACE,aAAA;AAux4EF;;AApx4EA;EACE,oCAAA;AAux4EF;;AA5w4EI;EACE,8BAAA;AA+w4EN;;AAhx4EI;EACE,8BAAA;AAmx4EN;;AApx4EI;EACE,8BAAA;AAux4EN;;AAxx4EI;EACE,8BAAA;AA2x4EN;;AA5x4EI;EACE,8BAAA;AA+x4EN;;AAhy4EI;EACE,8BAAA;AAmy4EN;;AApy4EI;EACE,8BAAA;AAuy4EN;;AAxy4EI;EACE,8BAAA;AA2y4EN;;AApy4EE;EACE,eAAA;EACA,YAAA;EACA,cWQO;AX+x4EX;;AAny4EA;EACE,wBAAA;AAsy4EF;;AAly4EE;EACE,wBAAA;AAqy4EJ;;AA9x4EE;EACE,6BAAA;AAiy4EJ;;AA7x4EA;EACE,WAAA;EACA,SAAA;EACA,aAAA;AAgy4EF;;AA3x4EA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AA8x4EF;;AA1x4EE;EACE,gBAAA;AA6x4EJ;AA1x4EE;EACE,QAAA;AA4x4EJ;AAzx4EE;EACE,cW5CO;AXu04EX;;AArx4EA;;EAEE,oCW2vBsC;EX1vBtC,mDAAA;EACA,sCAAA;AAwx4EF;;AArx4EA;EACE,sCAAA;EACA,4CAAA;EACA,sCAAA;AAwx4EF;;AAnx4EE;;EAEE,wDAAA;EACA,mDAAA;AAsx4EJ;;AAlx4EA;EACE,+CAAA;EACA,+CAAA;AAqx4EF;;AAlx4EA;EACE,+CAAA;EACA,+CAAA;AAqx4EF;;AAlx4EA;;;;;;;;;;GAAA;AAYA;;;;;EAAA;AAOE;EADF;IAEI,0BAAA;IACA,yBAAA;IACA,iDAAA;EAox4EF;AACF;;AAlx4EA;EACE,wCAAA;AAqx4EF;;AAlx4EA;EAAyB,uBAAA;AAsx4EzB","sourcesContent":["@import \"../scss/icons.scss\";\n@import \"../scss/config/default/bootstrap.scss\";\n@import \"../scss/config/default/app.scss\";\n@import \"../scss/config/default/custom.scss\";\n@import\"./shepherd.css\";\n@import \"./mermaid.min.css\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Inter:wght@100..900&display=swap\");\n\n\n* {\n  font-family: \"Inter\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-variation-settings:\n    \"slnt\" 0;\n\n}\n\n//RTL \n// @import \"../scss/rtl/components-rtl\";\n// @import \"../scss/rtl/layouts-rtl\";\n// @import \"../scss/rtl/plugins-rtl\";\n// @import \"../scss/rtl/pages-rtl\";\n\n\n//Rigthsidebar offcanvas\n.offcanvas-header-dark {\n  .btn-close {\n    filter: invert(1) grayscale(100%) brightness(200%);\n  }\n}\n\nbody {\n  * {\n    outline: none;\n    margin: 0;\n  }\n}\n\n.noUi-horizontal .noUi-handle {\n  height: 16px !important;\n  width: 16px !important;\n  border-radius: 50% !important;\n  right: -10px !important;\n  top: -7px !important;\n}\n\n.noUi-connect,\n.noUi-horizontal {\n  height: 2px !important;\n}\n\n.noUi-handle {\n  background: #0ab39c !important;\n  border: 2px solid var(--vz-card-bg) !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.noUi-target {\n  background: #fafafa !important;\n  border-radius: 4px !important;\n  border: 1px solid #d3d3d3 !important;\n  background-color: var(--vz-light) !important;\n  border-color: var(--vz-light) !important;\n  box-shadow: none !important;\n  height: 4px !important;\n}\n\n.dropzone .dz-message {\n  text-align: center;\n}\n\n// //Calendar\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  padding: 5px !important;\n  font-size: 12px !important;\n  margin-right: 2px;\n}\n\n.fc-event {\n  border: none !important;\n}\n\n@include media-breakpoint-down(sm) {\n  .fc-toolbar {\n    display: block !important;\n    text-align: center;\n\n    .fc-left,\n    .fc-right,\n    .fc-center {\n      float: none;\n      display: block;\n      clear: both;\n      margin: 10px 0;\n    }\n  }\n\n  .fc {\n    .fc-toolbar {\n      >* {\n        >* {\n          float: none;\n        }\n      }\n    }\n  }\n\n  .fc-today-button {\n    display: none;\n  }\n}\n\n.flatpickr-calendar.open {\n  z-index: 1090 !important;\n}\n\n.upcoming-scheduled .flatpickr-input[readonly] {\n  display: none;\n}\n\n.ql-container.ql-snow {\n  height: 250px;\n}\n\n.rangeslider-horizontal .rangeslider__fill {\n  background-color: #405189 !important;\n}\n\n// .Toastify__toast {\n//   min-height: 43px !important;\n//   max-height: 43px !important;\n// }\n\n@each $color,\n$value in $theme-colors {\n  .simplebar-track-#{$color} {\n    .simplebar-scrollbar:before {\n      background: $value !important;\n    }\n  }\n}\n\n// chat\n.chat-conversation .chat-list .message-box-drop {\n  .nav-btn {\n    font-size: 18px;\n    padding: 4px;\n    color: $gray-600;\n  }\n}\n\n.chatwidgets {\n  height: 250px !important;\n}\n\n[data-layout=\"horizontal\"] .chat-conversation {\n  &.chatwidgets {\n    height: 250px !important;\n  }\n}\n\n// authentication\n\n#tsparticles {\n  canvas {\n    position: absolute !important;\n  }\n}\n\n.alert-msg-show {\n  right: 24px;\n  top: 40px;\n  z-index: 1005;\n}\n\n// Emoji Picker\n\n.pickerEmoji {\n  position: absolute;\n  bottom: -50px;\n  left: 10%;\n  transform: translateX(-50%);\n}\n\n.Toastify {\n  .Toastify__toast {\n    min-height: 43px;\n  }\n\n  .Toastify__close-button {\n    top: 6px;\n  }\n\n  .Toastify__close-button--light {\n    color: $light;\n  }\n}\n\n// Tranfer List\n\n.rdl-filter,\n.rdl-control {\n  background-color: $input-bg;\n  border: 1px solid $input-border-color !important;\n  color: $input-color !important;\n}\n\n.rdl-move {\n  background: var(--#{$prefix}light) !important;\n  border: 1px solid var(--#{$prefix}light) !important;\n  color: var(--#{$prefix}body-color) !important;\n}\n\n.react-dual-listbox {\n\n  input:disabled,\n  select:disabled {\n    background-color: $input-disabled-bg !important;\n    border: 1px solid $input-border-color !important;\n  }\n}\n\n.css-26l3qy-menu {\n  background-color: var(--#{$prefix}gray-200) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n.css-1n7v3ny-option {\n  background-color: var(--#{$prefix}gray-300) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n/* \n.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels {\n  display: inline-flex;\n  animation: none;\n  flex-wrap: nowrap;\n  direction: ltr;\n\n  @media (max-width: 768px) {\n    display: inline-grid;\n  }\n} */\n\n/* .ant-picker-dropdown {\n  @media (max-width: 768px) {\n    inset: 51.9333px auto auto 0px !important;\n  }\n}\n */\n.ant-picker-dropdown .ant-picker-panel-container {\n  @media (max-width: 768px) {\n    max-width: 90vw !important;\n    overflow: auto !important;\n    /*   inset: 51.9333px auto auto 0px !important; */\n  }\n}\n.card-footer{\n  background-color: transparent !important;\n}\n\n.gm-style iframe + div { border:none!important; }","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 2.4.0\nWebsite: https://Themesbrand.com/\nContact: Themesbrand@gmail.com\nFile: Icons Css File\n*/\n\n// Icons Scss\n@import \"plugins/icons/materialdesignicons\";\n@import \"plugins/icons/boxicons\";\n@import \"plugins/icons/line-awesome\";\n@import \"plugins/icons/remixicon\";","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?v=6.5.95\");\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95\") format(\"embedded-opentype\"), url(\"../../../fonts/materialdesignicons-webfont.woff2?v=6.5.95\") format(\"woff2\"), url(\"../../../fonts/materialdesignicons-webfont.woff?v=6.5.95\") format(\"woff\"), url(\"../../../fonts/materialdesignicons-webfont.ttf?v=6.5.95\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abacus::before {\n  content: \"\\F16E0\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-down::before {\n  content: \"\\F1868\";\n}\n\n.mdi-account-arrow-down-outline::before {\n  content: \"\\F1869\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-arrow-up::before {\n  content: \"\\F1867\";\n}\n\n.mdi-account-arrow-up-outline::before {\n  content: \"\\F186A\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-cowboy-hat-outline::before {\n  content: \"\\F17F3\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-eye::before {\n  content: \"\\F0420\";\n}\n\n.mdi-account-eye-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-account-filter::before {\n  content: \"\\F0936\";\n}\n\n.mdi-account-filter-outline::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-injury::before {\n  content: \"\\F1815\";\n}\n\n.mdi-account-injury-outline::before {\n  content: \"\\F1816\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-open::before {\n  content: \"\\F1960\";\n}\n\n.mdi-account-lock-open-outline::before {\n  content: \"\\F1961\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-sync::before {\n  content: \"\\F191B\";\n}\n\n.mdi-account-sync-outline::before {\n  content: \"\\F191C\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-hat::before {\n  content: \"\\F1898\";\n}\n\n.mdi-account-tie-hat-outline::before {\n  content: \"\\F1899\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-account-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-account-wrench::before {\n  content: \"\\F189A\";\n}\n\n.mdi-account-wrench-outline::before {\n  content: \"\\F189B\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-advertisements::before {\n  content: \"\\F192A\";\n}\n\n.mdi-advertisements-off::before {\n  content: \"\\F192B\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-alert::before {\n  content: \"\\F187A\";\n}\n\n.mdi-airplane-check::before {\n  content: \"\\F187B\";\n}\n\n.mdi-airplane-clock::before {\n  content: \"\\F187C\";\n}\n\n.mdi-airplane-cog::before {\n  content: \"\\F187D\";\n}\n\n.mdi-airplane-edit::before {\n  content: \"\\F187E\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-marker::before {\n  content: \"\\F187F\";\n}\n\n.mdi-airplane-minus::before {\n  content: \"\\F1880\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-plus::before {\n  content: \"\\F1881\";\n}\n\n.mdi-airplane-remove::before {\n  content: \"\\F1882\";\n}\n\n.mdi-airplane-search::before {\n  content: \"\\F1883\";\n}\n\n.mdi-airplane-settings::before {\n  content: \"\\F1884\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-off::before {\n  content: \"\\F171E\";\n}\n\n.mdi-alarm-light-off-outline::before {\n  content: \"\\F171F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-distribute::before {\n  content: \"\\F1962\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-distribute::before {\n  content: \"\\F1963\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-all-inclusive-box::before {\n  content: \"\\F188D\";\n}\n\n.mdi-all-inclusive-box-outline::before {\n  content: \"\\F188E\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-application-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-application-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-application-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-application-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-application-brackets::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-application-brackets-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F0675\";\n}\n\n.mdi-application-cog-outline::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-edit::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-application-edit-outline::before {\n  content: \"\\F0619\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-outline::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-application-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-application-settings-outline::before {\n  content: \"\\F1555\";\n}\n\n.mdi-application-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-application-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-cancel::before {\n  content: \"\\F174B\";\n}\n\n.mdi-archive-cancel-outline::before {\n  content: \"\\F174C\";\n}\n\n.mdi-archive-check::before {\n  content: \"\\F174D\";\n}\n\n.mdi-archive-check-outline::before {\n  content: \"\\F174E\";\n}\n\n.mdi-archive-clock::before {\n  content: \"\\F174F\";\n}\n\n.mdi-archive-clock-outline::before {\n  content: \"\\F1750\";\n}\n\n.mdi-archive-cog::before {\n  content: \"\\F1751\";\n}\n\n.mdi-archive-cog-outline::before {\n  content: \"\\F1752\";\n}\n\n.mdi-archive-edit::before {\n  content: \"\\F1753\";\n}\n\n.mdi-archive-edit-outline::before {\n  content: \"\\F1754\";\n}\n\n.mdi-archive-eye::before {\n  content: \"\\F1755\";\n}\n\n.mdi-archive-eye-outline::before {\n  content: \"\\F1756\";\n}\n\n.mdi-archive-lock::before {\n  content: \"\\F1757\";\n}\n\n.mdi-archive-lock-open::before {\n  content: \"\\F1758\";\n}\n\n.mdi-archive-lock-open-outline::before {\n  content: \"\\F1759\";\n}\n\n.mdi-archive-lock-outline::before {\n  content: \"\\F175A\";\n}\n\n.mdi-archive-marker::before {\n  content: \"\\F175B\";\n}\n\n.mdi-archive-marker-outline::before {\n  content: \"\\F175C\";\n}\n\n.mdi-archive-minus::before {\n  content: \"\\F175D\";\n}\n\n.mdi-archive-minus-outline::before {\n  content: \"\\F175E\";\n}\n\n.mdi-archive-music::before {\n  content: \"\\F175F\";\n}\n\n.mdi-archive-music-outline::before {\n  content: \"\\F1760\";\n}\n\n.mdi-archive-off::before {\n  content: \"\\F1761\";\n}\n\n.mdi-archive-off-outline::before {\n  content: \"\\F1762\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-archive-plus::before {\n  content: \"\\F1763\";\n}\n\n.mdi-archive-plus-outline::before {\n  content: \"\\F1764\";\n}\n\n.mdi-archive-refresh::before {\n  content: \"\\F1765\";\n}\n\n.mdi-archive-refresh-outline::before {\n  content: \"\\F1766\";\n}\n\n.mdi-archive-remove::before {\n  content: \"\\F1767\";\n}\n\n.mdi-archive-remove-outline::before {\n  content: \"\\F1768\";\n}\n\n.mdi-archive-search::before {\n  content: \"\\F1769\";\n}\n\n.mdi-archive-search-outline::before {\n  content: \"\\F176A\";\n}\n\n.mdi-archive-settings::before {\n  content: \"\\F176B\";\n}\n\n.mdi-archive-settings-outline::before {\n  content: \"\\F176C\";\n}\n\n.mdi-archive-star::before {\n  content: \"\\F176D\";\n}\n\n.mdi-archive-star-outline::before {\n  content: \"\\F176E\";\n}\n\n.mdi-archive-sync::before {\n  content: \"\\F176F\";\n}\n\n.mdi-archive-sync-outline::before {\n  content: \"\\F1770\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-box::before {\n  content: \"\\F1964\";\n}\n\n.mdi-arrow-bottom-left-bold-box-outline::before {\n  content: \"\\F1965\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin::before {\n  content: \"\\F19B6\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-box::before {\n  content: \"\\F1966\";\n}\n\n.mdi-arrow-bottom-right-bold-box-outline::before {\n  content: \"\\F1967\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin::before {\n  content: \"\\F19B7\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-left::before {\n  content: \"\\F17A1\";\n}\n\n.mdi-arrow-down-left-bold::before {\n  content: \"\\F17A2\";\n}\n\n.mdi-arrow-down-right::before {\n  content: \"\\F17A3\";\n}\n\n.mdi-arrow-down-right-bold::before {\n  content: \"\\F17A4\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin::before {\n  content: \"\\F19B3\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-bottom::before {\n  content: \"\\F17A5\";\n}\n\n.mdi-arrow-left-bottom-bold::before {\n  content: \"\\F17A6\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin::before {\n  content: \"\\F19B1\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-left-top::before {\n  content: \"\\F17A7\";\n}\n\n.mdi-arrow-left-top-bold::before {\n  content: \"\\F17A8\";\n}\n\n.mdi-arrow-projectile::before {\n  content: \"\\F1840\";\n}\n\n.mdi-arrow-projectile-multiple::before {\n  content: \"\\F183F\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-bottom::before {\n  content: \"\\F17A9\";\n}\n\n.mdi-arrow-right-bottom-bold::before {\n  content: \"\\F17AA\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin::before {\n  content: \"\\F19B0\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-right-top::before {\n  content: \"\\F17AB\";\n}\n\n.mdi-arrow-right-top-bold::before {\n  content: \"\\F17AC\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-box::before {\n  content: \"\\F1968\";\n}\n\n.mdi-arrow-top-left-bold-box-outline::before {\n  content: \"\\F1969\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin::before {\n  content: \"\\F19B5\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-box::before {\n  content: \"\\F196A\";\n}\n\n.mdi-arrow-top-right-bold-box-outline::before {\n  content: \"\\F196B\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin::before {\n  content: \"\\F19B4\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-u-down-left::before {\n  content: \"\\F17AD\";\n}\n\n.mdi-arrow-u-down-left-bold::before {\n  content: \"\\F17AE\";\n}\n\n.mdi-arrow-u-down-right::before {\n  content: \"\\F17AF\";\n}\n\n.mdi-arrow-u-down-right-bold::before {\n  content: \"\\F17B0\";\n}\n\n.mdi-arrow-u-left-bottom::before {\n  content: \"\\F17B1\";\n}\n\n.mdi-arrow-u-left-bottom-bold::before {\n  content: \"\\F17B2\";\n}\n\n.mdi-arrow-u-left-top::before {\n  content: \"\\F17B3\";\n}\n\n.mdi-arrow-u-left-top-bold::before {\n  content: \"\\F17B4\";\n}\n\n.mdi-arrow-u-right-bottom::before {\n  content: \"\\F17B5\";\n}\n\n.mdi-arrow-u-right-bottom-bold::before {\n  content: \"\\F17B6\";\n}\n\n.mdi-arrow-u-right-top::before {\n  content: \"\\F17B7\";\n}\n\n.mdi-arrow-u-right-top-bold::before {\n  content: \"\\F17B8\";\n}\n\n.mdi-arrow-u-up-left::before {\n  content: \"\\F17B9\";\n}\n\n.mdi-arrow-u-up-left-bold::before {\n  content: \"\\F17BA\";\n}\n\n.mdi-arrow-u-up-right::before {\n  content: \"\\F17BB\";\n}\n\n.mdi-arrow-u-up-right-bold::before {\n  content: \"\\F17BC\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-left::before {\n  content: \"\\F17BD\";\n}\n\n.mdi-arrow-up-left-bold::before {\n  content: \"\\F17BE\";\n}\n\n.mdi-arrow-up-right::before {\n  content: \"\\F17BF\";\n}\n\n.mdi-arrow-up-right-bold::before {\n  content: \"\\F17C0\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin::before {\n  content: \"\\F19B2\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-input-rca::before {\n  content: \"\\F186B\";\n}\n\n.mdi-audio-input-stereo-minijack::before {\n  content: \"\\F186C\";\n}\n\n.mdi-audio-input-xlr::before {\n  content: \"\\F186D\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axe-battle::before {\n  content: \"\\F1842\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balcony::before {\n  content: \"\\F1817\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-check::before {\n  content: \"\\F18E5\";\n}\n\n.mdi-basket-check-outline::before {\n  content: \"\\F18E6\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-bathtub::before {\n  content: \"\\F1818\";\n}\n\n.mdi-bathtub-outline::before {\n  content: \"\\F1819\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-arrow-down::before {\n  content: \"\\F17DE\";\n}\n\n.mdi-battery-arrow-down-outline::before {\n  content: \"\\F17DF\";\n}\n\n.mdi-battery-arrow-up::before {\n  content: \"\\F17E0\";\n}\n\n.mdi-battery-arrow-up-outline::before {\n  content: \"\\F17E1\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-check::before {\n  content: \"\\F17E2\";\n}\n\n.mdi-battery-check-outline::before {\n  content: \"\\F17E3\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-lock::before {\n  content: \"\\F179C\";\n}\n\n.mdi-battery-lock-open::before {\n  content: \"\\F179D\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F17E4\";\n}\n\n.mdi-battery-minus-outline::before {\n  content: \"\\F17E5\";\n}\n\n.mdi-battery-minus-variant::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F17E6\";\n}\n\n.mdi-battery-plus-outline::before {\n  content: \"\\F17E7\";\n}\n\n.mdi-battery-plus-variant::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-remove::before {\n  content: \"\\F17E8\";\n}\n\n.mdi-battery-remove-outline::before {\n  content: \"\\F17E9\";\n}\n\n.mdi-battery-sync::before {\n  content: \"\\F1834\";\n}\n\n.mdi-battery-sync-outline::before {\n  content: \"\\F1835\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-badge::before {\n  content: \"\\F116B\";\n}\n\n.mdi-bell-badge-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-cargo::before {\n  content: \"\\F189C\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-outline::before {\n  content: \"\\F181A\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-box-multiple::before {\n  content: \"\\F196C\";\n}\n\n.mdi-bookmark-box-multiple-outline::before {\n  content: \"\\F196D\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-arrow-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-arrow-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-arrow-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-arrow-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F17F9\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F17FA\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-arrow::before {\n  content: \"\\F1841\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-eye::before {\n  content: \"\\F17D9\";\n}\n\n.mdi-briefcase-eye-outline::before {\n  content: \"\\F17DA\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broadcast::before {\n  content: \"\\F1720\";\n}\n\n.mdi-broadcast-off::before {\n  content: \"\\F1721\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-brush-off::before {\n  content: \"\\F1771\";\n}\n\n.mdi-brush-variant::before {\n  content: \"\\F1813\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullhorn-variant::before {\n  content: \"\\F196E\";\n}\n\n.mdi-bullhorn-variant-outline::before {\n  content: \"\\F196F\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-electric::before {\n  content: \"\\F191D\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cabin-a-frame::before {\n  content: \"\\F188C\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-cake-variant-outline::before {\n  content: \"\\F17F0\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-clock-outline::before {\n  content: \"\\F16E1\";\n}\n\n.mdi-calendar-collapse-horizontal::before {\n  content: \"\\F189D\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-expand-horizontal::before {\n  content: \"\\F189E\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-document::before {\n  content: \"\\F1871\";\n}\n\n.mdi-camera-document-off::before {\n  content: \"\\F1872\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-marker::before {\n  content: \"\\F19A7\";\n}\n\n.mdi-camera-marker-outline::before {\n  content: \"\\F19A8\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-off-outline::before {\n  content: \"\\F19BF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candelabra::before {\n  content: \"\\F17D2\";\n}\n\n.mdi-candelabra-fire::before {\n  content: \"\\F17D3\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candy::before {\n  content: \"\\F1970\";\n}\n\n.mdi-candy-off::before {\n  content: \"\\F1971\";\n}\n\n.mdi-candy-off-outline::before {\n  content: \"\\F1972\";\n}\n\n.mdi-candy-outline::before {\n  content: \"\\F1973\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-fluid-level::before {\n  content: \"\\F1909\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-low-pressure::before {\n  content: \"\\F190A\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-brake-temperature::before {\n  content: \"\\F190B\";\n}\n\n.mdi-car-brake-worn-linings::before {\n  content: \"\\F190C\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clock::before {\n  content: \"\\F1974\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-alert::before {\n  content: \"\\F190D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-select::before {\n  content: \"\\F1879\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-speed-limiter::before {\n  content: \"\\F190E\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-car-wireless::before {\n  content: \"\\F1878\";\n}\n\n.mdi-car-wrench::before {\n  content: \"\\F1814\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-multiple::before {\n  content: \"\\F17F1\";\n}\n\n.mdi-card-multiple-outline::before {\n  content: \"\\F17F2\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-club-outline::before {\n  content: \"\\F189F\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-heart-outline::before {\n  content: \"\\F18A0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing::before {\n  content: \"\\F18A1\";\n}\n\n.mdi-cards-playing-club::before {\n  content: \"\\F18A2\";\n}\n\n.mdi-cards-playing-club-multiple::before {\n  content: \"\\F18A3\";\n}\n\n.mdi-cards-playing-club-multiple-outline::before {\n  content: \"\\F18A4\";\n}\n\n.mdi-cards-playing-club-outline::before {\n  content: \"\\F18A5\";\n}\n\n.mdi-cards-playing-diamond::before {\n  content: \"\\F18A6\";\n}\n\n.mdi-cards-playing-diamond-multiple::before {\n  content: \"\\F18A7\";\n}\n\n.mdi-cards-playing-diamond-multiple-outline::before {\n  content: \"\\F18A8\";\n}\n\n.mdi-cards-playing-diamond-outline::before {\n  content: \"\\F18A9\";\n}\n\n.mdi-cards-playing-heart::before {\n  content: \"\\F18AA\";\n}\n\n.mdi-cards-playing-heart-multiple::before {\n  content: \"\\F18AB\";\n}\n\n.mdi-cards-playing-heart-multiple-outline::before {\n  content: \"\\F18AC\";\n}\n\n.mdi-cards-playing-heart-outline::before {\n  content: \"\\F18AD\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-playing-spade::before {\n  content: \"\\F18AE\";\n}\n\n.mdi-cards-playing-spade-multiple::before {\n  content: \"\\F18AF\";\n}\n\n.mdi-cards-playing-spade-multiple-outline::before {\n  content: \"\\F18B0\";\n}\n\n.mdi-cards-playing-spade-outline::before {\n  content: \"\\F18B1\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-spade-outline::before {\n  content: \"\\F18B2\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-heart::before {\n  content: \"\\F18E0\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-fast::before {\n  content: \"\\F185C\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-audio-variant::before {\n  content: \"\\F1749\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-cast-variant::before {\n  content: \"\\F001F\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-cctv-off::before {\n  content: \"\\F185F\";\n}\n\n.mdi-ceiling-fan::before {\n  content: \"\\F1797\";\n}\n\n.mdi-ceiling-fan-light::before {\n  content: \"\\F1798\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-ceiling-light-multiple::before {\n  content: \"\\F18DD\";\n}\n\n.mdi-ceiling-light-multiple-outline::before {\n  content: \"\\F18DE\";\n}\n\n.mdi-ceiling-light-outline::before {\n  content: \"\\F17C7\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-check::before {\n  content: \"\\F17FD\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-marker::before {\n  content: \"\\F183A\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-remove::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-chandelier::before {\n  content: \"\\F1793\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chart-waterfall::before {\n  content: \"\\F1918\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-question::before {\n  content: \"\\F1738\";\n}\n\n.mdi-chat-question-outline::before {\n  content: \"\\F1739\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-decagram-outline::before {\n  content: \"\\F1740\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-badge::before {\n  content: \"\\F1176\";\n}\n\n.mdi-checkbox-blank-badge-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-circle-plus-outline::before {\n  content: \"\\F1927\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkbox-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-checkbox-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-alert::before {\n  content: \"\\F17EA\";\n}\n\n.mdi-chili-alert-outline::before {\n  content: \"\\F17EB\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-hot-outline::before {\n  content: \"\\F17EC\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-medium-outline::before {\n  content: \"\\F17ED\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-mild-outline::before {\n  content: \"\\F17EE\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chili-off-outline::before {\n  content: \"\\F17EF\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-opacity::before {\n  content: \"\\F1853\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-clock::before {\n  content: \"\\F16E2\";\n}\n\n.mdi-clipboard-clock-outline::before {\n  content: \"\\F16E3\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-clock::before {\n  content: \"\\F18F9\";\n}\n\n.mdi-clipboard-text-clock-outline::before {\n  content: \"\\F18FA\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-edit::before {\n  content: \"\\F19BA\";\n}\n\n.mdi-clock-edit-outline::before {\n  content: \"\\F19BB\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-minus::before {\n  content: \"\\F1863\";\n}\n\n.mdi-clock-minus-outline::before {\n  content: \"\\F1864\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-plus::before {\n  content: \"\\F1861\";\n}\n\n.mdi-clock-plus-outline::before {\n  content: \"\\F1862\";\n}\n\n.mdi-clock-remove::before {\n  content: \"\\F1865\";\n}\n\n.mdi-clock-remove-outline::before {\n  content: \"\\F1866\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-maker-check::before {\n  content: \"\\F1931\";\n}\n\n.mdi-coffee-maker-check-outline::before {\n  content: \"\\F1932\";\n}\n\n.mdi-coffee-maker-outline::before {\n  content: \"\\F181B\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-pause::before {\n  content: \"\\F1933\";\n}\n\n.mdi-cog-pause-outline::before {\n  content: \"\\F1934\";\n}\n\n.mdi-cog-play::before {\n  content: \"\\F1935\";\n}\n\n.mdi-cog-play-outline::before {\n  content: \"\\F1936\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-stop::before {\n  content: \"\\F1937\";\n}\n\n.mdi-cog-stop-outline::before {\n  content: \"\\F1938\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-remove::before {\n  content: \"\\F18B3\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-cone::before {\n  content: \"\\F194C\";\n}\n\n.mdi-cone-off::before {\n  content: \"\\F194D\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-check::before {\n  content: \"\\F18EA\";\n}\n\n.mdi-content-save-check-outline::before {\n  content: \"\\F18EB\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-clock::before {\n  content: \"\\F16E4\";\n}\n\n.mdi-cookie-clock-outline::before {\n  content: \"\\F16E5\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-edit::before {\n  content: \"\\F16E6\";\n}\n\n.mdi-cookie-edit-outline::before {\n  content: \"\\F16E7\";\n}\n\n.mdi-cookie-lock::before {\n  content: \"\\F16E8\";\n}\n\n.mdi-cookie-lock-outline::before {\n  content: \"\\F16E9\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-off::before {\n  content: \"\\F16EA\";\n}\n\n.mdi-cookie-off-outline::before {\n  content: \"\\F16EB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-refresh::before {\n  content: \"\\F16EC\";\n}\n\n.mdi-cookie-refresh-outline::before {\n  content: \"\\F16ED\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyleft::before {\n  content: \"\\F1939\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-countertop::before {\n  content: \"\\F181C\";\n}\n\n.mdi-countertop-outline::before {\n  content: \"\\F181D\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cow-off::before {\n  content: \"\\F18FC\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-cradle::before {\n  content: \"\\F198B\";\n}\n\n.mdi-cradle-outline::before {\n  content: \"\\F1991\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-chip::before {\n  content: \"\\F190F\";\n}\n\n.mdi-credit-card-chip-outline::before {\n  content: \"\\F1910\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-edit::before {\n  content: \"\\F17D7\";\n}\n\n.mdi-credit-card-edit-outline::before {\n  content: \"\\F17D8\";\n}\n\n.mdi-credit-card-fast::before {\n  content: \"\\F1911\";\n}\n\n.mdi-credit-card-fast-outline::before {\n  content: \"\\F1912\";\n}\n\n.mdi-credit-card-lock::before {\n  content: \"\\F18E7\";\n}\n\n.mdi-credit-card-lock-outline::before {\n  content: \"\\F18E8\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-cross::before {\n  content: \"\\F0953\";\n}\n\n.mdi-cross-bolnisi::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-cross-celtic::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-cross-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crowd::before {\n  content: \"\\F1975\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-circle::before {\n  content: \"\\F17DC\";\n}\n\n.mdi-crown-circle-outline::before {\n  content: \"\\F17DD\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-rupee::before {\n  content: \"\\F1976\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-curtains::before {\n  content: \"\\F1846\";\n}\n\n.mdi-curtains-closed::before {\n  content: \"\\F1847\";\n}\n\n.mdi-cylinder::before {\n  content: \"\\F194E\";\n}\n\n.mdi-cylinder-off::before {\n  content: \"\\F194F\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-eye::before {\n  content: \"\\F191F\";\n}\n\n.mdi-database-eye-off::before {\n  content: \"\\F1920\";\n}\n\n.mdi-database-eye-off-outline::before {\n  content: \"\\F1921\";\n}\n\n.mdi-database-eye-outline::before {\n  content: \"\\F1922\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-dharmachakra::before {\n  content: \"\\F094B\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diversify::before {\n  content: \"\\F1877\";\n}\n\n.mdi-diving::before {\n  content: \"\\F1977\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dog-side-off::before {\n  content: \"\\F16EE\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-dolphin::before {\n  content: \"\\F18B4\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-door-sliding::before {\n  content: \"\\F181E\";\n}\n\n.mdi-door-sliding-lock::before {\n  content: \"\\F181F\";\n}\n\n.mdi-door-sliding-open::before {\n  content: \"\\F1820\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-circle::before {\n  content: \"\\F1978\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-draw-pen::before {\n  content: \"\\F19B9\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earbuds::before {\n  content: \"\\F184F\";\n}\n\n.mdi-earbuds-off::before {\n  content: \"\\F1850\";\n}\n\n.mdi-earbuds-off-outline::before {\n  content: \"\\F1851\";\n}\n\n.mdi-earbuds-outline::before {\n  content: \"\\F1852\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-fried::before {\n  content: \"\\F184A\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-passenger-off::before {\n  content: \"\\F1979\";\n}\n\n.mdi-elevator-passenger-off-outline::before {\n  content: \"\\F197A\";\n}\n\n.mdi-elevator-passenger-outline::before {\n  content: \"\\F197B\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-fast::before {\n  content: \"\\F186F\";\n}\n\n.mdi-email-fast-outline::before {\n  content: \"\\F1870\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-seal::before {\n  content: \"\\F195B\";\n}\n\n.mdi-email-seal-outline::before {\n  content: \"\\F195C\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-arrow-left::before {\n  content: \"\\F18FD\";\n}\n\n.mdi-eye-arrow-left-outline::before {\n  content: \"\\F18FE\";\n}\n\n.mdi-eye-arrow-right::before {\n  content: \"\\F18FF\";\n}\n\n.mdi-eye-arrow-right-outline::before {\n  content: \"\\F1900\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-refresh::before {\n  content: \"\\F197C\";\n}\n\n.mdi-eye-refresh-outline::before {\n  content: \"\\F197D\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-man::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-man-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-man-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-man-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-man-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-profile::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-auto::before {\n  content: \"\\F171D\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-15::before {\n  content: \"\\F193A\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fence::before {\n  content: \"\\F179A\";\n}\n\n.mdi-fence-electric::before {\n  content: \"\\F17F6\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-gif-box::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-marker::before {\n  content: \"\\F1772\";\n}\n\n.mdi-file-image-marker-outline::before {\n  content: \"\\F1773\";\n}\n\n.mdi-file-image-minus::before {\n  content: \"\\F193B\";\n}\n\n.mdi-file-image-minus-outline::before {\n  content: \"\\F193C\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-image-plus::before {\n  content: \"\\F193D\";\n}\n\n.mdi-file-image-plus-outline::before {\n  content: \"\\F193E\";\n}\n\n.mdi-file-image-remove::before {\n  content: \"\\F193F\";\n}\n\n.mdi-file-image-remove-outline::before {\n  content: \"\\F1940\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-jpg-box::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-marker::before {\n  content: \"\\F1774\";\n}\n\n.mdi-file-marker-outline::before {\n  content: \"\\F1775\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-png-box::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-sign::before {\n  content: \"\\F19C3\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-check::before {\n  content: \"\\F18EC\";\n}\n\n.mdi-filter-check-outline::before {\n  content: \"\\F18ED\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-circle::before {\n  content: \"\\F1807\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-off::before {\n  content: \"\\F1722\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firewire::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-firework-off::before {\n  content: \"\\F1723\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-fit-to-screen::before {\n  content: \"\\F18F4\";\n}\n\n.mdi-fit-to-screen-outline::before {\n  content: \"\\F18F5\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-off::before {\n  content: \"\\F18EE\";\n}\n\n.mdi-flag-off-outline::before {\n  content: \"\\F18EF\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-dual-outline::before {\n  content: \"\\F17CE\";\n}\n\n.mdi-floor-lamp-outline::before {\n  content: \"\\F17C8\";\n}\n\n.mdi-floor-lamp-torchiere::before {\n  content: \"\\F1747\";\n}\n\n.mdi-floor-lamp-torchiere-outline::before {\n  content: \"\\F17D6\";\n}\n\n.mdi-floor-lamp-torchiere-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-lamp-torchiere-variant-outline::before {\n  content: \"\\F17CF\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-pollen::before {\n  content: \"\\F1885\";\n}\n\n.mdi-flower-pollen-outline::before {\n  content: \"\\F1886\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-check::before {\n  content: \"\\F197E\";\n}\n\n.mdi-folder-check-outline::before {\n  content: \"\\F197F\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-eye::before {\n  content: \"\\F178A\";\n}\n\n.mdi-folder-eye-outline::before {\n  content: \"\\F178B\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-hidden::before {\n  content: \"\\F179E\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-hot-dog::before {\n  content: \"\\F184B\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-off-outline::before {\n  content: \"\\F1915\";\n}\n\n.mdi-food-outline::before {\n  content: \"\\F1916\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-takeout-box::before {\n  content: \"\\F1836\";\n}\n\n.mdi-food-takeout-box-outline::before {\n  content: \"\\F1837\";\n}\n\n.mdi-food-turkey::before {\n  content: \"\\F171C\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forest::before {\n  content: \"\\F1897\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-spacing::before {\n  content: \"\\F1956\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-group::before {\n  content: \"\\F1860\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-page-split::before {\n  content: \"\\F1917\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-underline-wavy::before {\n  content: \"\\F18E9\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-fraction-one-half::before {\n  content: \"\\F1992\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-french-fries::before {\n  content: \"\\F1957\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fuel-cell::before {\n  content: \"\\F18B5\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-outline::before {\n  content: \"\\F1919\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-lock::before {\n  content: \"\\F17FB\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-garage-variant-lock::before {\n  content: \"\\F17FC\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-alert::before {\n  content: \"\\F17F8\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-left::before {\n  content: \"\\F17F7\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-off::before {\n  content: \"\\F16EF\";\n}\n\n.mdi-gift-off-outline::before {\n  content: \"\\F16F0\";\n}\n\n.mdi-gift-open::before {\n  content: \"\\F16F1\";\n}\n\n.mdi-gift-open-outline::before {\n  content: \"\\F16F2\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-fragile::before {\n  content: \"\\F1873\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient-horizontal::before {\n  content: \"\\F174A\";\n}\n\n.mdi-gradient-vertical::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-greenhouse::before {\n  content: \"\\F002D\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hamburger-check::before {\n  content: \"\\F1776\";\n}\n\n.mdi-hamburger-minus::before {\n  content: \"\\F1777\";\n}\n\n.mdi-hamburger-off::before {\n  content: \"\\F1778\";\n}\n\n.mdi-hamburger-plus::before {\n  content: \"\\F1779\";\n}\n\n.mdi-hamburger-remove::before {\n  content: \"\\F177A\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-sickle::before {\n  content: \"\\F1887\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand-back-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-back-left-off::before {\n  content: \"\\F1830\";\n}\n\n.mdi-hand-back-left-off-outline::before {\n  content: \"\\F1832\";\n}\n\n.mdi-hand-back-left-outline::before {\n  content: \"\\F182C\";\n}\n\n.mdi-hand-back-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-back-right-off::before {\n  content: \"\\F1831\";\n}\n\n.mdi-hand-back-right-off-outline::before {\n  content: \"\\F1833\";\n}\n\n.mdi-hand-back-right-outline::before {\n  content: \"\\F182D\";\n}\n\n.mdi-hand-clap::before {\n  content: \"\\F194B\";\n}\n\n.mdi-hand-coin::before {\n  content: \"\\F188F\";\n}\n\n.mdi-hand-coin-outline::before {\n  content: \"\\F1890\";\n}\n\n.mdi-hand-extended::before {\n  content: \"\\F18B6\";\n}\n\n.mdi-hand-extended-outline::before {\n  content: \"\\F18B7\";\n}\n\n.mdi-hand-front-left::before {\n  content: \"\\F182B\";\n}\n\n.mdi-hand-front-left-outline::before {\n  content: \"\\F182E\";\n}\n\n.mdi-hand-front-right::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-front-right-outline::before {\n  content: \"\\F182F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-hand-wave::before {\n  content: \"\\F1821\";\n}\n\n.mdi-hand-wave-outline::before {\n  content: \"\\F1822\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-hands-pray::before {\n  content: \"\\F0579\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-battery::before {\n  content: \"\\F1901\";\n}\n\n.mdi-home-battery-outline::before {\n  content: \"\\F1902\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-group-minus::before {\n  content: \"\\F19C1\";\n}\n\n.mdi-home-group-plus::before {\n  content: \"\\F19C0\";\n}\n\n.mdi-home-group-remove::before {\n  content: \"\\F19C2\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lightning-bolt::before {\n  content: \"\\F1903\";\n}\n\n.mdi-home-lightning-bolt-outline::before {\n  content: \"\\F1904\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-switch::before {\n  content: \"\\F1794\";\n}\n\n.mdi-home-switch-outline::before {\n  content: \"\\F1795\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hoop-house::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horse-variant-fast::before {\n  content: \"\\F186E\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-dolly::before {\n  content: \"\\F1980\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F17C4\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-greeting-variant::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-board::before {\n  content: \"\\F0890\";\n}\n\n.mdi-human-male-board-poll::before {\n  content: \"\\F0846\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-female-child::before {\n  content: \"\\F1823\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-non-binary::before {\n  content: \"\\F1848\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-human-white-cane::before {\n  content: \"\\F1981\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-hydrogen-station::before {\n  content: \"\\F1894\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-marker::before {\n  content: \"\\F177B\";\n}\n\n.mdi-image-marker-outline::before {\n  content: \"\\F177C\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-induction::before {\n  content: \"\\F184C\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-off::before {\n  content: \"\\F178C\";\n}\n\n.mdi-information-off-outline::before {\n  content: \"\\F178D\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-integrated-circuit-chip::before {\n  content: \"\\F1913\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ip-outline::before {\n  content: \"\\F1982\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-iron::before {\n  content: \"\\F1824\";\n}\n\n.mdi-iron-board::before {\n  content: \"\\F1838\";\n}\n\n.mdi-iron-outline::before {\n  content: \"\\F1825\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-kayaking::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-pour-over::before {\n  content: \"\\F173C\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-alert::before {\n  content: \"\\F1983\";\n}\n\n.mdi-key-alert-outline::before {\n  content: \"\\F1984\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-tab-reverse::before {\n  content: \"\\F0325\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-kite::before {\n  content: \"\\F1985\";\n}\n\n.mdi-kite-outline::before {\n  content: \"\\F1986\";\n}\n\n.mdi-kitesurfing::before {\n  content: \"\\F1744\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-koala::before {\n  content: \"\\F173F\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamp-outline::before {\n  content: \"\\F17D0\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lamps-outline::before {\n  content: \"\\F17D1\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-edit::before {\n  content: \"\\F1892\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-circle::before {\n  content: \"\\F1905\";\n}\n\n.mdi-leaf-circle-outline::before {\n  content: \"\\F1906\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-flood-down::before {\n  content: \"\\F1987\";\n}\n\n.mdi-light-flood-up::before {\n  content: \"\\F1988\";\n}\n\n.mdi-light-recessed::before {\n  content: \"\\F179B\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-auto::before {\n  content: \"\\F1800\";\n}\n\n.mdi-lightbulb-auto-outline::before {\n  content: \"\\F1801\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-fluorescent-tube::before {\n  content: \"\\F1804\";\n}\n\n.mdi-lightbulb-fluorescent-tube-outline::before {\n  content: \"\\F1805\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lightbulb-spot::before {\n  content: \"\\F17F4\";\n}\n\n.mdi-lightbulb-spot-off::before {\n  content: \"\\F17F5\";\n}\n\n.mdi-lightbulb-variant::before {\n  content: \"\\F1802\";\n}\n\n.mdi-lightbulb-variant-outline::before {\n  content: \"\\F1803\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-line-scan::before {\n  content: \"\\F0624\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-liquid-spot::before {\n  content: \"\\F1826\";\n}\n\n.mdi-liquor::before {\n  content: \"\\F191E\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-mace::before {\n  content: \"\\F1843\";\n}\n\n.mdi-magazine-pistol::before {\n  content: \"\\F0324\";\n}\n\n.mdi-magazine-rifle::before {\n  content: \"\\F0323\";\n}\n\n.mdi-magic-staff::before {\n  content: \"\\F1844\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-expand::before {\n  content: \"\\F1874\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-account::before {\n  content: \"\\F18E3\";\n}\n\n.mdi-map-marker-account-outline::before {\n  content: \"\\F18E4\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menorah::before {\n  content: \"\\F17D4\";\n}\n\n.mdi-menorah-fire::before {\n  content: \"\\F17D5\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-badge::before {\n  content: \"\\F1941\";\n}\n\n.mdi-message-badge-outline::before {\n  content: \"\\F1942\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-question::before {\n  content: \"\\F173A\";\n}\n\n.mdi-message-question-outline::before {\n  content: \"\\F173B\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-outline::before {\n  content: \"\\F173D\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-reply-text-outline::before {\n  content: \"\\F173E\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-star::before {\n  content: \"\\F069A\";\n}\n\n.mdi-message-star-outline::before {\n  content: \"\\F1250\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-question::before {\n  content: \"\\F1989\";\n}\n\n.mdi-microphone-question-outline::before {\n  content: \"\\F198A\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mirror-rectangle::before {\n  content: \"\\F179F\";\n}\n\n.mdi-mirror-variant::before {\n  content: \"\\F17A0\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-shimmer::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-small::before {\n  content: \"\\F1876\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mortar-pestle::before {\n  content: \"\\F1748\";\n}\n\n.mdi-mortar-pestle-plus::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-mosque::before {\n  content: \"\\F1827\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-check::before {\n  content: \"\\F16F3\";\n}\n\n.mdi-movie-check-outline::before {\n  content: \"\\F16F4\";\n}\n\n.mdi-movie-cog::before {\n  content: \"\\F16F5\";\n}\n\n.mdi-movie-cog-outline::before {\n  content: \"\\F16F6\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-minus::before {\n  content: \"\\F16F7\";\n}\n\n.mdi-movie-minus-outline::before {\n  content: \"\\F16F8\";\n}\n\n.mdi-movie-off::before {\n  content: \"\\F16F9\";\n}\n\n.mdi-movie-off-outline::before {\n  content: \"\\F16FA\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-check::before {\n  content: \"\\F16FB\";\n}\n\n.mdi-movie-open-check-outline::before {\n  content: \"\\F16FC\";\n}\n\n.mdi-movie-open-cog::before {\n  content: \"\\F16FD\";\n}\n\n.mdi-movie-open-cog-outline::before {\n  content: \"\\F16FE\";\n}\n\n.mdi-movie-open-edit::before {\n  content: \"\\F16FF\";\n}\n\n.mdi-movie-open-edit-outline::before {\n  content: \"\\F1700\";\n}\n\n.mdi-movie-open-minus::before {\n  content: \"\\F1701\";\n}\n\n.mdi-movie-open-minus-outline::before {\n  content: \"\\F1702\";\n}\n\n.mdi-movie-open-off::before {\n  content: \"\\F1703\";\n}\n\n.mdi-movie-open-off-outline::before {\n  content: \"\\F1704\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-open-play::before {\n  content: \"\\F1705\";\n}\n\n.mdi-movie-open-play-outline::before {\n  content: \"\\F1706\";\n}\n\n.mdi-movie-open-plus::before {\n  content: \"\\F1707\";\n}\n\n.mdi-movie-open-plus-outline::before {\n  content: \"\\F1708\";\n}\n\n.mdi-movie-open-remove::before {\n  content: \"\\F1709\";\n}\n\n.mdi-movie-open-remove-outline::before {\n  content: \"\\F170A\";\n}\n\n.mdi-movie-open-settings::before {\n  content: \"\\F170B\";\n}\n\n.mdi-movie-open-settings-outline::before {\n  content: \"\\F170C\";\n}\n\n.mdi-movie-open-star::before {\n  content: \"\\F170D\";\n}\n\n.mdi-movie-open-star-outline::before {\n  content: \"\\F170E\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-play::before {\n  content: \"\\F170F\";\n}\n\n.mdi-movie-play-outline::before {\n  content: \"\\F1710\";\n}\n\n.mdi-movie-plus::before {\n  content: \"\\F1711\";\n}\n\n.mdi-movie-plus-outline::before {\n  content: \"\\F1712\";\n}\n\n.mdi-movie-remove::before {\n  content: \"\\F1713\";\n}\n\n.mdi-movie-remove-outline::before {\n  content: \"\\F1714\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-movie-settings::before {\n  content: \"\\F1715\";\n}\n\n.mdi-movie-settings-outline::before {\n  content: \"\\F1716\";\n}\n\n.mdi-movie-star::before {\n  content: \"\\F1717\";\n}\n\n.mdi-movie-star-outline::before {\n  content: \"\\F1718\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multicast::before {\n  content: \"\\F1893\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-navigation-variant::before {\n  content: \"\\F18F0\";\n}\n\n.mdi-navigation-variant-outline::before {\n  content: \"\\F18F1\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-4-cog::before {\n  content: \"\\F191A\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-check::before {\n  content: \"\\F1943\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-remove::before {\n  content: \"\\F1944\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-alert::before {\n  content: \"\\F177D\";\n}\n\n.mdi-note-alert-outline::before {\n  content: \"\\F177E\";\n}\n\n.mdi-note-check::before {\n  content: \"\\F177F\";\n}\n\n.mdi-note-check-outline::before {\n  content: \"\\F1780\";\n}\n\n.mdi-note-edit::before {\n  content: \"\\F1781\";\n}\n\n.mdi-note-edit-outline::before {\n  content: \"\\F1782\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-off::before {\n  content: \"\\F1783\";\n}\n\n.mdi-note-off-outline::before {\n  content: \"\\F1784\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-octahedron::before {\n  content: \"\\F1950\";\n}\n\n.mdi-octahedron-off::before {\n  content: \"\\F1951\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-cog::before {\n  content: \"\\F1949\";\n}\n\n.mdi-office-building-cog-outline::before {\n  content: \"\\F194A\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-om::before {\n  content: \"\\F0973\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palette-swatch-variant::before {\n  content: \"\\F195A\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F1928\";\n}\n\n.mdi-panorama-horizontal-outline::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-outline::before {\n  content: \"\\F198C\";\n}\n\n.mdi-panorama-sphere::before {\n  content: \"\\F198D\";\n}\n\n.mdi-panorama-sphere-outline::before {\n  content: \"\\F198E\";\n}\n\n.mdi-panorama-variant::before {\n  content: \"\\F198F\";\n}\n\n.mdi-panorama-variant-outline::before {\n  content: \"\\F1990\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F1929\";\n}\n\n.mdi-panorama-vertical-outline::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F195F\";\n}\n\n.mdi-panorama-wide-angle-outline::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-paragliding::before {\n  content: \"\\F1745\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-ph::before {\n  content: \"\\F17C5\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-refresh::before {\n  content: \"\\F1993\";\n}\n\n.mdi-phone-refresh-outline::before {\n  content: \"\\F1994\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-sync::before {\n  content: \"\\F1995\";\n}\n\n.mdi-phone-sync-outline::before {\n  content: \"\\F1996\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-piano-off::before {\n  content: \"\\F0698\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-valve::before {\n  content: \"\\F184D\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-pliers::before {\n  content: \"\\F19A4\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-police-station::before {\n  content: \"\\F1839\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-ch::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-heat::before {\n  content: \"\\F18B8\";\n}\n\n.mdi-printer-3d-nozzle-heat-outline::before {\n  content: \"\\F18B9\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-off-outline::before {\n  content: \"\\F1785\";\n}\n\n.mdi-printer-outline::before {\n  content: \"\\F1786\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-pencil::before {\n  content: \"\\F1787\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-star::before {\n  content: \"\\F1788\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-projector-screen-off::before {\n  content: \"\\F180D\";\n}\n\n.mdi-projector-screen-off-outline::before {\n  content: \"\\F180E\";\n}\n\n.mdi-projector-screen-outline::before {\n  content: \"\\F1724\";\n}\n\n.mdi-projector-screen-variant::before {\n  content: \"\\F180F\";\n}\n\n.mdi-projector-screen-variant-off::before {\n  content: \"\\F1810\";\n}\n\n.mdi-projector-screen-variant-off-outline::before {\n  content: \"\\F1811\";\n}\n\n.mdi-projector-screen-variant-outline::before {\n  content: \"\\F1812\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-publish-off::before {\n  content: \"\\F1945\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-pyramid::before {\n  content: \"\\F1952\";\n}\n\n.mdi-pyramid-off::before {\n  content: \"\\F1953\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-circle::before {\n  content: \"\\F185D\";\n}\n\n.mdi-radioactive-circle-outline::before {\n  content: \"\\F185E\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-razor-double-edge::before {\n  content: \"\\F1997\";\n}\n\n.mdi-razor-single-edge::before {\n  content: \"\\F1998\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-auto::before {\n  content: \"\\F18F2\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-repeat-variant::before {\n  content: \"\\F0547\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-15::before {\n  content: \"\\F1946\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-happy::before {\n  content: \"\\F1719\";\n}\n\n.mdi-robot-happy-outline::before {\n  content: \"\\F171A\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-360::before {\n  content: \"\\F1999\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-sausage-off::before {\n  content: \"\\F1789\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scale-unbalanced::before {\n  content: \"\\F19B8\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-scent::before {\n  content: \"\\F1958\";\n}\n\n.mdi-scent-off::before {\n  content: \"\\F1959\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-key::before {\n  content: \"\\F1725\";\n}\n\n.mdi-script-text-key-outline::before {\n  content: \"\\F1726\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-script-text-play::before {\n  content: \"\\F1727\";\n}\n\n.mdi-script-text-play-outline::before {\n  content: \"\\F1728\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-remove::before {\n  content: \"\\F17C1\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-ellipse-remove::before {\n  content: \"\\F17C2\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-remove::before {\n  content: \"\\F17C3\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark::before {\n  content: \"\\F18BA\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-shark-off::before {\n  content: \"\\F18BB\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-crown::before {\n  content: \"\\F18BC\";\n}\n\n.mdi-shield-crown-outline::before {\n  content: \"\\F18BD\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-open::before {\n  content: \"\\F199A\";\n}\n\n.mdi-shield-lock-open-outline::before {\n  content: \"\\F199B\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-moon::before {\n  content: \"\\F1828\";\n}\n\n.mdi-shield-moon-outline::before {\n  content: \"\\F1829\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sword::before {\n  content: \"\\F18BE\";\n}\n\n.mdi-shield-sword-outline::before {\n  content: \"\\F18BF\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-shimmer::before {\n  content: \"\\F1545\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shipping-pallet::before {\n  content: \"\\F184E\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sickle::before {\n  content: \"\\F18C0\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-sitemap-outline::before {\n  content: \"\\F199C\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skate-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skateboarding::before {\n  content: \"\\F0501\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sledding::before {\n  content: \"\\F041B\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-off::before {\n  content: \"\\F18F7\";\n}\n\n.mdi-smart-card-off-outline::before {\n  content: \"\\F18F8\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke::before {\n  content: \"\\F1799\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoke-detector-alert::before {\n  content: \"\\F192E\";\n}\n\n.mdi-smoke-detector-alert-outline::before {\n  content: \"\\F192F\";\n}\n\n.mdi-smoke-detector-off::before {\n  content: \"\\F1809\";\n}\n\n.mdi-smoke-detector-off-outline::before {\n  content: \"\\F180A\";\n}\n\n.mdi-smoke-detector-outline::before {\n  content: \"\\F1808\";\n}\n\n.mdi-smoke-detector-variant::before {\n  content: \"\\F180B\";\n}\n\n.mdi-smoke-detector-variant-alert::before {\n  content: \"\\F1930\";\n}\n\n.mdi-smoke-detector-variant-off::before {\n  content: \"\\F180C\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-snowmobile::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundbar::before {\n  content: \"\\F17DB\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-spear::before {\n  content: \"\\F1845\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-sphere::before {\n  content: \"\\F1954\";\n}\n\n.mdi-sphere-off::before {\n  content: \"\\F1955\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-fire::before {\n  content: \"\\F199D\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-opacity::before {\n  content: \"\\F1854\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-crescent::before {\n  content: \"\\F0979\";\n}\n\n.mdi-star-david::before {\n  content: \"\\F097A\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-shooting::before {\n  content: \"\\F1741\";\n}\n\n.mdi-star-shooting-outline::before {\n  content: \"\\F1742\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-sticker-text::before {\n  content: \"\\F178E\";\n}\n\n.mdi-sticker-text-outline::before {\n  content: \"\\F178F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stool::before {\n  content: \"\\F195D\";\n}\n\n.mdi-stool-outline::before {\n  content: \"\\F195E\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-alert::before {\n  content: \"\\F18C1\";\n}\n\n.mdi-store-alert-outline::before {\n  content: \"\\F18C2\";\n}\n\n.mdi-store-check::before {\n  content: \"\\F18C3\";\n}\n\n.mdi-store-check-outline::before {\n  content: \"\\F18C4\";\n}\n\n.mdi-store-clock::before {\n  content: \"\\F18C5\";\n}\n\n.mdi-store-clock-outline::before {\n  content: \"\\F18C6\";\n}\n\n.mdi-store-cog::before {\n  content: \"\\F18C7\";\n}\n\n.mdi-store-cog-outline::before {\n  content: \"\\F18C8\";\n}\n\n.mdi-store-edit::before {\n  content: \"\\F18C9\";\n}\n\n.mdi-store-edit-outline::before {\n  content: \"\\F18CA\";\n}\n\n.mdi-store-marker::before {\n  content: \"\\F18CB\";\n}\n\n.mdi-store-marker-outline::before {\n  content: \"\\F18CC\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-minus-outline::before {\n  content: \"\\F18CD\";\n}\n\n.mdi-store-off::before {\n  content: \"\\F18CE\";\n}\n\n.mdi-store-off-outline::before {\n  content: \"\\F18CF\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-plus-outline::before {\n  content: \"\\F18D0\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-store-remove-outline::before {\n  content: \"\\F18D1\";\n}\n\n.mdi-store-search::before {\n  content: \"\\F18D2\";\n}\n\n.mdi-store-search-outline::before {\n  content: \"\\F18D3\";\n}\n\n.mdi-store-settings::before {\n  content: \"\\F18D4\";\n}\n\n.mdi-store-settings-outline::before {\n  content: \"\\F18D5\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sun-compass::before {\n  content: \"\\F19A5\";\n}\n\n.mdi-sun-snowflake::before {\n  content: \"\\F1796\";\n}\n\n.mdi-sun-thermometer::before {\n  content: \"\\F18D6\";\n}\n\n.mdi-sun-thermometer-outline::before {\n  content: \"\\F18D7\";\n}\n\n.mdi-sun-wireless::before {\n  content: \"\\F17FE\";\n}\n\n.mdi-sun-wireless-outline::before {\n  content: \"\\F17FF\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surfing::before {\n  content: \"\\F1746\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-2-1::before {\n  content: \"\\F1729\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-5-1-2::before {\n  content: \"\\F172A\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-search::before {\n  content: \"\\F199E\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-picnic::before {\n  content: \"\\F1743\";\n}\n\n.mdi-table-pivot::before {\n  content: \"\\F183C\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-arrow-down::before {\n  content: \"\\F172B\";\n}\n\n.mdi-tag-arrow-down-outline::before {\n  content: \"\\F172C\";\n}\n\n.mdi-tag-arrow-left::before {\n  content: \"\\F172D\";\n}\n\n.mdi-tag-arrow-left-outline::before {\n  content: \"\\F172E\";\n}\n\n.mdi-tag-arrow-right::before {\n  content: \"\\F172F\";\n}\n\n.mdi-tag-arrow-right-outline::before {\n  content: \"\\F1730\";\n}\n\n.mdi-tag-arrow-up::before {\n  content: \"\\F1731\";\n}\n\n.mdi-tag-arrow-up-outline::before {\n  content: \"\\F1732\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-search::before {\n  content: \"\\F1907\";\n}\n\n.mdi-tag-search-outline::before {\n  content: \"\\F1908\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tangram::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-teddy-bear::before {\n  content: \"\\F18FB\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-shimmer::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-long::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-bluetooth::before {\n  content: \"\\F1895\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-thumbs-up-down-outline::before {\n  content: \"\\F1914\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-tilde-off::before {\n  content: \"\\F18F3\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-cog::before {\n  content: \"\\F1925\";\n}\n\n.mdi-timer-cog-outline::before {\n  content: \"\\F1926\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-complete::before {\n  content: \"\\F199F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timer-sand-paused::before {\n  content: \"\\F19A0\";\n}\n\n.mdi-timer-settings::before {\n  content: \"\\F1923\";\n}\n\n.mdi-timer-settings-outline::before {\n  content: \"\\F1924\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-tire::before {\n  content: \"\\F1896\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-cellphone::before {\n  content: \"\\F183B\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-town-hall::before {\n  content: \"\\F1875\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-traffic-light-outline::before {\n  content: \"\\F182A\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-car-passenger::before {\n  content: \"\\F1733\";\n}\n\n.mdi-train-car-passenger-door::before {\n  content: \"\\F1734\";\n}\n\n.mdi-train-car-passenger-door-open::before {\n  content: \"\\F1735\";\n}\n\n.mdi-train-car-passenger-variant::before {\n  content: \"\\F1736\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-transmission-tower-export::before {\n  content: \"\\F192C\";\n}\n\n.mdi-transmission-tower-import::before {\n  content: \"\\F192D\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-arrow-down::before {\n  content: \"\\F0120\";\n}\n\n.mdi-tray-arrow-up::before {\n  content: \"\\F011D\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-cargo-container::before {\n  content: \"\\F18D8\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-flatbed::before {\n  content: \"\\F1891\";\n}\n\n.mdi-truck-minus::before {\n  content: \"\\F19AE\";\n}\n\n.mdi-truck-minus-outline::before {\n  content: \"\\F19BD\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-plus::before {\n  content: \"\\F19AD\";\n}\n\n.mdi-truck-plus-outline::before {\n  content: \"\\F19BC\";\n}\n\n.mdi-truck-remove::before {\n  content: \"\\F19AF\";\n}\n\n.mdi-truck-remove-outline::before {\n  content: \"\\F19BE\";\n}\n\n.mdi-truck-snowflake::before {\n  content: \"\\F19A6\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-tunnel::before {\n  content: \"\\F183D\";\n}\n\n.mdi-tunnel-outline::before {\n  content: \"\\F183E\";\n}\n\n.mdi-turkey::before {\n  content: \"\\F171B\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-beach::before {\n  content: \"\\F188A\";\n}\n\n.mdi-umbrella-beach-outline::before {\n  content: \"\\F188B\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-vacuum::before {\n  content: \"\\F19A1\";\n}\n\n.mdi-vacuum-outline::before {\n  content: \"\\F19A2\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polygon-variant::before {\n  content: \"\\F1856\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-square-close::before {\n  content: \"\\F1857\";\n}\n\n.mdi-vector-square-edit::before {\n  content: \"\\F18D9\";\n}\n\n.mdi-vector-square-minus::before {\n  content: \"\\F18DA\";\n}\n\n.mdi-vector-square-open::before {\n  content: \"\\F1858\";\n}\n\n.mdi-vector-square-plus::before {\n  content: \"\\F18DB\";\n}\n\n.mdi-vector-square-remove::before {\n  content: \"\\F18DC\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-marker::before {\n  content: \"\\F19A9\";\n}\n\n.mdi-video-marker-outline::before {\n  content: \"\\F19AA\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-edit::before {\n  content: \"\\F1947\";\n}\n\n.mdi-view-dashboard-edit-outline::before {\n  content: \"\\F1948\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-gallery::before {\n  content: \"\\F1888\";\n}\n\n.mdi-view-gallery-outline::before {\n  content: \"\\F1889\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-off::before {\n  content: \"\\F18E1\";\n}\n\n.mdi-virus-off-outline::before {\n  content: \"\\F18E2\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-outline::before {\n  content: \"\\F17C9\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-flat-variant-outline::before {\n  content: \"\\F17CA\";\n}\n\n.mdi-wall-sconce-outline::before {\n  content: \"\\F17CB\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-outline::before {\n  content: \"\\F17CC\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wall-sconce-round-variant-outline::before {\n  content: \"\\F17CD\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-circle::before {\n  content: \"\\F1806\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-opacity::before {\n  content: \"\\F1855\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-sync::before {\n  content: \"\\F17C6\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-waterfall::before {\n  content: \"\\F1849\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waves-arrow-left::before {\n  content: \"\\F1859\";\n}\n\n.mdi-waves-arrow-right::before {\n  content: \"\\F185A\";\n}\n\n.mdi-waves-arrow-up::before {\n  content: \"\\F185B\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-cloudy-clock::before {\n  content: \"\\F18F6\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-cancel::before {\n  content: \"\\F1790\";\n}\n\n.mdi-web-check::before {\n  content: \"\\F0789\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-web-minus::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-web-off::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-web-plus::before {\n  content: \"\\F0033\";\n}\n\n.mdi-web-refresh::before {\n  content: \"\\F1791\";\n}\n\n.mdi-web-remove::before {\n  content: \"\\F0551\";\n}\n\n.mdi-web-sync::before {\n  content: \"\\F1792\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webcam-off::before {\n  content: \"\\F1737\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-wind-turbine-alert::before {\n  content: \"\\F19AB\";\n}\n\n.mdi-wind-turbine-check::before {\n  content: \"\\F19AC\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wiper-wash-alert::before {\n  content: \"\\F18DF\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-clock::before {\n  content: \"\\F19A3\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */","// boxicons 2.1.1\n\n@font-face\n{\n    font-family: 'boxicons';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('../../../fonts/boxicons.eot');\n    src: url('../../../fonts/boxicons.eot') format('embedded-opentype'),\n    url('../../../fonts/boxicons.woff2') format('woff2'),\n    url('../../../fonts/boxicons.woff') format('woff'),\n    url('../../../fonts/boxicons.ttf') format('truetype'),\n    url('../../../fonts/boxicons.svg?#boxicons') format('svg');\n}\n.bx\n{\n    font-family: 'boxicons' !important;\n    font-weight: normal;\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n    text-rendering: auto;\n    display: inline-block;\n\n    text-transform: none;\n\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.bx-ul\n{\n    margin-left: 2em;\n    padding-left: 0;\n\n    list-style: none;\n}\n.bx-ul > li\n{\n    position: relative;\n}\n.bx-ul .bx\n{\n    font-size: inherit;\n    line-height: inherit;\n\n    position: absolute;\n    left: -2em;\n\n    width: 2em;\n\n    text-align: center;\n}\n@-webkit-keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@-webkit-keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@-webkit-keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n\n@keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n                transform: rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n.bx-spin\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n.bx-spin-hover:hover\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n\n.bx-tada\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n.bx-tada-hover:hover\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n\n.bx-flashing\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n.bx-flashing-hover:hover\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n\n.bx-burst\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-burst-hover:hover\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-fade-up\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-up-hover:hover\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-down\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-down-hover:hover\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-left\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-left-hover:hover\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-right\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-fade-right-hover:hover\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-xs\n{\n    font-size: 1rem!important;\n}\n.bx-sm\n{\n    font-size: 1.55rem!important;\n}\n.bx-md\n{\n    font-size: 2.25rem!important;\n}\n.bx-lg\n{\n    font-size: 3.0rem!important;\n}\n.bx-fw\n{\n    font-size: 1.2857142857em;\n    line-height: .8em;\n\n    width: 1.2857142857em;\n    height: .8em;\n    margin-top: -.2em!important;\n\n    vertical-align: middle;\n}\n.bx-pull-left\n{\n    float: left;\n\n    margin-right: .3em!important;\n}\n.bx-pull-right\n{\n    float: right;\n\n    margin-left: .3em!important;\n}\n.bx-rotate-90\n{\n    transform: rotate(90deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\n}\n.bx-rotate-180\n{\n    transform: rotate(180deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\n}\n.bx-rotate-270\n{\n    transform: rotate(270deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\n}\n.bx-flip-horizontal\n{\n    transform: scaleX(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\n}\n.bx-flip-vertical\n{\n    transform: scaleY(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\n}\n.bx-border\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: .25em;\n}\n.bx-border-circle\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: 50%;\n}\n\n  \n  .bxl-meta:before {\n    content: \"\\ef27\";\n  }\n  .bx-lemon:before {\n    content: \"\\ef28\";\n  }\n  .bxs-lemon:before {\n    content: \"\\ef29\";\n  }\n  .bx-cricket-ball:before {\n    content: \"\\ef0c\";\n  }\n  .bx-baguette:before {\n    content: \"\\ef0d\";\n  }\n  .bx-bowl-hot:before {\n    content: \"\\ef0e\";\n  }\n  .bx-bowl-rice:before {\n    content: \"\\ef0f\";\n  }\n  .bx-cable-car:before {\n    content: \"\\ef10\";\n  }\n  .bx-candles:before {\n    content: \"\\ef11\";\n  }\n  .bx-circle-half:before {\n    content: \"\\ef12\";\n  }\n  .bx-circle-quarter:before {\n    content: \"\\ef13\";\n  }\n  .bx-circle-three-quarter:before {\n    content: \"\\ef14\";\n  }\n  .bx-cross:before {\n    content: \"\\ef15\";\n  }\n  .bx-fork:before {\n    content: \"\\ef16\";\n  }\n  .bx-knife:before {\n    content: \"\\ef17\";\n  }\n  .bx-money-withdraw:before {\n    content: \"\\ef18\";\n  }\n  .bx-popsicle:before {\n    content: \"\\ef19\";\n  }\n  .bx-scatter-chart:before {\n    content: \"\\ef1a\";\n  }\n  .bxs-baguette:before {\n    content: \"\\ef1b\";\n  }\n  .bxs-bowl-hot:before {\n    content: \"\\ef1c\";\n  }\n  .bxs-bowl-rice:before {\n    content: \"\\ef1d\";\n  }\n  .bxs-cable-car:before {\n    content: \"\\ef1e\";\n  }\n  .bxs-circle-half:before {\n    content: \"\\ef1f\";\n  }\n  .bxs-circle-quarter:before {\n    content: \"\\ef20\";\n  }\n  .bxs-circle-three-quarter:before {\n    content: \"\\ef21\";\n  }\n  .bxs-cricket-ball:before {\n    content: \"\\ef22\";\n  }\n  .bxs-invader:before {\n    content: \"\\ef23\";\n  }\n  .bx-male-female:before {\n    content: \"\\ef24\";\n  }\n  .bxs-popsicle:before {\n    content: \"\\ef25\";\n  }\n  .bxs-tree-alt:before {\n    content: \"\\ef26\";\n  }\n  .bxl-venmo:before {\n    content: \"\\e900\";\n  }\n  .bxl-upwork:before {\n    content: \"\\e901\";\n  }\n  .bxl-netlify:before {\n    content: \"\\e902\";\n  }\n  .bxl-java:before {\n    content: \"\\e903\";\n  }\n  .bxl-heroku:before {\n    content: \"\\e904\";\n  }\n  .bxl-go-lang:before {\n    content: \"\\e905\";\n  }\n  .bxl-gmail:before {\n    content: \"\\e906\";\n  }\n  .bxl-flask:before {\n    content: \"\\e907\";\n  }\n  .bxl-99designs:before {\n    content: \"\\e908\";\n  }\n  .bxl-500px:before {\n    content: \"\\e909\";\n  }\n  .bxl-adobe:before {\n    content: \"\\e90a\";\n  }\n  .bxl-airbnb:before {\n    content: \"\\e90b\";\n  }\n  .bxl-algolia:before {\n    content: \"\\e90c\";\n  }\n  .bxl-amazon:before {\n    content: \"\\e90d\";\n  }\n  .bxl-android:before {\n    content: \"\\e90e\";\n  }\n  .bxl-angular:before {\n    content: \"\\e90f\";\n  }\n  .bxl-apple:before {\n    content: \"\\e910\";\n  }\n  .bxl-audible:before {\n    content: \"\\e911\";\n  }\n  .bxl-aws:before {\n    content: \"\\e912\";\n  }\n  .bxl-baidu:before {\n    content: \"\\e913\";\n  }\n  .bxl-behance:before {\n    content: \"\\e914\";\n  }\n  .bxl-bing:before {\n    content: \"\\e915\";\n  }\n  .bxl-bitcoin:before {\n    content: \"\\e916\";\n  }\n  .bxl-blender:before {\n    content: \"\\e917\";\n  }\n  .bxl-blogger:before {\n    content: \"\\e918\";\n  }\n  .bxl-bootstrap:before {\n    content: \"\\e919\";\n  }\n  .bxl-chrome:before {\n    content: \"\\e91a\";\n  }\n  .bxl-codepen:before {\n    content: \"\\e91b\";\n  }\n  .bxl-c-plus-plus:before {\n    content: \"\\e91c\";\n  }\n  .bxl-creative-commons:before {\n    content: \"\\e91d\";\n  }\n  .bxl-css3:before {\n    content: \"\\e91e\";\n  }\n  .bxl-dailymotion:before {\n    content: \"\\e91f\";\n  }\n  .bxl-deviantart:before {\n    content: \"\\e920\";\n  }\n  .bxl-dev-to:before {\n    content: \"\\e921\";\n  }\n  .bxl-digg:before {\n    content: \"\\e922\";\n  }\n  .bxl-digitalocean:before {\n    content: \"\\e923\";\n  }\n  .bxl-discord:before {\n    content: \"\\e924\";\n  }\n  .bxl-discord-alt:before {\n    content: \"\\e925\";\n  }\n  .bxl-discourse:before {\n    content: \"\\e926\";\n  }\n  .bxl-django:before {\n    content: \"\\e927\";\n  }\n  .bxl-docker:before {\n    content: \"\\e928\";\n  }\n  .bxl-dribbble:before {\n    content: \"\\e929\";\n  }\n  .bxl-dropbox:before {\n    content: \"\\e92a\";\n  }\n  .bxl-drupal:before {\n    content: \"\\e92b\";\n  }\n  .bxl-ebay:before {\n    content: \"\\e92c\";\n  }\n  .bxl-edge:before {\n    content: \"\\e92d\";\n  }\n  .bxl-etsy:before {\n    content: \"\\e92e\";\n  }\n  .bxl-facebook:before {\n    content: \"\\e92f\";\n  }\n  .bxl-facebook-circle:before {\n    content: \"\\e930\";\n  }\n  .bxl-facebook-square:before {\n    content: \"\\e931\";\n  }\n  .bxl-figma:before {\n    content: \"\\e932\";\n  }\n  .bxl-firebase:before {\n    content: \"\\e933\";\n  }\n  .bxl-firefox:before {\n    content: \"\\e934\";\n  }\n  .bxl-flickr:before {\n    content: \"\\e935\";\n  }\n  .bxl-flickr-square:before {\n    content: \"\\e936\";\n  }\n  .bxl-flutter:before {\n    content: \"\\e937\";\n  }\n  .bxl-foursquare:before {\n    content: \"\\e938\";\n  }\n  .bxl-git:before {\n    content: \"\\e939\";\n  }\n  .bxl-github:before {\n    content: \"\\e93a\";\n  }\n  .bxl-gitlab:before {\n    content: \"\\e93b\";\n  }\n  .bxl-google:before {\n    content: \"\\e93c\";\n  }\n  .bxl-google-cloud:before {\n    content: \"\\e93d\";\n  }\n  .bxl-google-plus:before {\n    content: \"\\e93e\";\n  }\n  .bxl-google-plus-circle:before {\n    content: \"\\e93f\";\n  }\n  .bxl-html5:before {\n    content: \"\\e940\";\n  }\n  .bxl-imdb:before {\n    content: \"\\e941\";\n  }\n  .bxl-instagram:before {\n    content: \"\\e942\";\n  }\n  .bxl-instagram-alt:before {\n    content: \"\\e943\";\n  }\n  .bxl-internet-explorer:before {\n    content: \"\\e944\";\n  }\n  .bxl-invision:before {\n    content: \"\\e945\";\n  }\n  .bxl-javascript:before {\n    content: \"\\e946\";\n  }\n  .bxl-joomla:before {\n    content: \"\\e947\";\n  }\n  .bxl-jquery:before {\n    content: \"\\e948\";\n  }\n  .bxl-jsfiddle:before {\n    content: \"\\e949\";\n  }\n  .bxl-kickstarter:before {\n    content: \"\\e94a\";\n  }\n  .bxl-kubernetes:before {\n    content: \"\\e94b\";\n  }\n  .bxl-less:before {\n    content: \"\\e94c\";\n  }\n  .bxl-linkedin:before {\n    content: \"\\e94d\";\n  }\n  .bxl-linkedin-square:before {\n    content: \"\\e94e\";\n  }\n  .bxl-magento:before {\n    content: \"\\e94f\";\n  }\n  .bxl-mailchimp:before {\n    content: \"\\e950\";\n  }\n  .bxl-markdown:before {\n    content: \"\\e951\";\n  }\n  .bxl-mastercard:before {\n    content: \"\\e952\";\n  }\n  .bxl-mastodon:before {\n    content: \"\\e953\";\n  }\n  .bxl-medium:before {\n    content: \"\\e954\";\n  }\n  .bxl-medium-old:before {\n    content: \"\\e955\";\n  }\n  .bxl-medium-square:before {\n    content: \"\\e956\";\n  }\n  .bxl-messenger:before {\n    content: \"\\e957\";\n  }\n  .bxl-microsoft:before {\n    content: \"\\e958\";\n  }\n  .bxl-microsoft-teams:before {\n    content: \"\\e959\";\n  }\n  .bxl-nodejs:before {\n    content: \"\\e95a\";\n  }\n  .bxl-ok-ru:before {\n    content: \"\\e95b\";\n  }\n  .bxl-opera:before {\n    content: \"\\e95c\";\n  }\n  .bxl-patreon:before {\n    content: \"\\e95d\";\n  }\n  .bxl-paypal:before {\n    content: \"\\e95e\";\n  }\n  .bxl-periscope:before {\n    content: \"\\e95f\";\n  }\n  .bxl-php:before {\n    content: \"\\e960\";\n  }\n  .bxl-pinterest:before {\n    content: \"\\e961\";\n  }\n  .bxl-pinterest-alt:before {\n    content: \"\\e962\";\n  }\n  .bxl-play-store:before {\n    content: \"\\e963\";\n  }\n  .bxl-pocket:before {\n    content: \"\\e964\";\n  }\n  .bxl-product-hunt:before {\n    content: \"\\e965\";\n  }\n  .bxl-python:before {\n    content: \"\\e966\";\n  }\n  .bxl-quora:before {\n    content: \"\\e967\";\n  }\n  .bxl-react:before {\n    content: \"\\e968\";\n  }\n  .bxl-redbubble:before {\n    content: \"\\e969\";\n  }\n  .bxl-reddit:before {\n    content: \"\\e96a\";\n  }\n  .bxl-redux:before {\n    content: \"\\e96b\";\n  }\n  .bxl-sass:before {\n    content: \"\\e96c\";\n  }\n  .bxl-shopify:before {\n    content: \"\\e96d\";\n  }\n  .bxl-sketch:before {\n    content: \"\\e96e\";\n  }\n  .bxl-skype:before {\n    content: \"\\e96f\";\n  }\n  .bxl-slack:before {\n    content: \"\\e970\";\n  }\n  .bxl-slack-old:before {\n    content: \"\\e971\";\n  }\n  .bxl-snapchat:before {\n    content: \"\\e972\";\n  }\n  .bxl-soundcloud:before {\n    content: \"\\e973\";\n  }\n  .bxl-spotify:before {\n    content: \"\\e974\";\n  }\n  .bxl-spring-boot:before {\n    content: \"\\e975\";\n  }\n  .bxl-squarespace:before {\n    content: \"\\e976\";\n  }\n  .bxl-stack-overflow:before {\n    content: \"\\e977\";\n  }\n  .bxl-steam:before {\n    content: \"\\e978\";\n  }\n  .bxl-stripe:before {\n    content: \"\\e979\";\n  }\n  .bxl-tailwind-css:before {\n    content: \"\\e97a\";\n  }\n  .bxl-telegram:before {\n    content: \"\\e97b\";\n  }\n  .bxl-tiktok:before {\n    content: \"\\e97c\";\n  }\n  .bxl-trello:before {\n    content: \"\\e97d\";\n  }\n  .bxl-trip-advisor:before {\n    content: \"\\e97e\";\n  }\n  .bxl-tumblr:before {\n    content: \"\\e97f\";\n  }\n  .bxl-tux:before {\n    content: \"\\e980\";\n  }\n  .bxl-twitch:before {\n    content: \"\\e981\";\n  }\n  .bxl-twitter:before {\n    content: \"\\e982\";\n  }\n  .bxl-unity:before {\n    content: \"\\e983\";\n  }\n  .bxl-unsplash:before {\n    content: \"\\e984\";\n  }\n  .bxl-vimeo:before {\n    content: \"\\e985\";\n  }\n  .bxl-visa:before {\n    content: \"\\e986\";\n  }\n  .bxl-visual-studio:before {\n    content: \"\\e987\";\n  }\n  .bxl-vk:before {\n    content: \"\\e988\";\n  }\n  .bxl-vuejs:before {\n    content: \"\\e989\";\n  }\n  .bxl-whatsapp:before {\n    content: \"\\e98a\";\n  }\n  .bxl-whatsapp-square:before {\n    content: \"\\e98b\";\n  }\n  .bxl-wikipedia:before {\n    content: \"\\e98c\";\n  }\n  .bxl-windows:before {\n    content: \"\\e98d\";\n  }\n  .bxl-wix:before {\n    content: \"\\e98e\";\n  }\n  .bxl-wordpress:before {\n    content: \"\\e98f\";\n  }\n  .bxl-yahoo:before {\n    content: \"\\e990\";\n  }\n  .bxl-yelp:before {\n    content: \"\\e991\";\n  }\n  .bxl-youtube:before {\n    content: \"\\e992\";\n  }\n  .bxl-zoom:before {\n    content: \"\\e993\";\n  }\n  .bx-collapse-alt:before {\n    content: \"\\e994\";\n  }\n  .bx-collapse-horizontal:before {\n    content: \"\\e995\";\n  }\n  .bx-collapse-vertical:before {\n    content: \"\\e996\";\n  }\n  .bx-expand-horizontal:before {\n    content: \"\\e997\";\n  }\n  .bx-expand-vertical:before {\n    content: \"\\e998\";\n  }\n  .bx-injection:before {\n    content: \"\\e999\";\n  }\n  .bx-leaf:before {\n    content: \"\\e99a\";\n  }\n  .bx-math:before {\n    content: \"\\e99b\";\n  }\n  .bx-party:before {\n    content: \"\\e99c\";\n  }\n  .bx-abacus:before {\n    content: \"\\e99d\";\n  }\n  .bx-accessibility:before {\n    content: \"\\e99e\";\n  }\n  .bx-add-to-queue:before {\n    content: \"\\e99f\";\n  }\n  .bx-adjust:before {\n    content: \"\\e9a0\";\n  }\n  .bx-alarm:before {\n    content: \"\\e9a1\";\n  }\n  .bx-alarm-add:before {\n    content: \"\\e9a2\";\n  }\n  .bx-alarm-exclamation:before {\n    content: \"\\e9a3\";\n  }\n  .bx-alarm-off:before {\n    content: \"\\e9a4\";\n  }\n  .bx-alarm-snooze:before {\n    content: \"\\e9a5\";\n  }\n  .bx-album:before {\n    content: \"\\e9a6\";\n  }\n  .bx-align-justify:before {\n    content: \"\\e9a7\";\n  }\n  .bx-align-left:before {\n    content: \"\\e9a8\";\n  }\n  .bx-align-middle:before {\n    content: \"\\e9a9\";\n  }\n  .bx-align-right:before {\n    content: \"\\e9aa\";\n  }\n  .bx-analyse:before {\n    content: \"\\e9ab\";\n  }\n  .bx-anchor:before {\n    content: \"\\e9ac\";\n  }\n  .bx-angry:before {\n    content: \"\\e9ad\";\n  }\n  .bx-aperture:before {\n    content: \"\\e9ae\";\n  }\n  .bx-arch:before {\n    content: \"\\e9af\";\n  }\n  .bx-archive:before {\n    content: \"\\e9b0\";\n  }\n  .bx-archive-in:before {\n    content: \"\\e9b1\";\n  }\n  .bx-archive-out:before {\n    content: \"\\e9b2\";\n  }\n  .bx-area:before {\n    content: \"\\e9b3\";\n  }\n  .bx-arrow-back:before {\n    content: \"\\e9b4\";\n  }\n  .bx-arrow-from-bottom:before {\n    content: \"\\e9b5\";\n  }\n  .bx-arrow-from-left:before {\n    content: \"\\e9b6\";\n  }\n  .bx-arrow-from-right:before {\n    content: \"\\e9b7\";\n  }\n  .bx-arrow-from-top:before {\n    content: \"\\e9b8\";\n  }\n  .bx-arrow-to-bottom:before {\n    content: \"\\e9b9\";\n  }\n  .bx-arrow-to-left:before {\n    content: \"\\e9ba\";\n  }\n  .bx-arrow-to-right:before {\n    content: \"\\e9bb\";\n  }\n  .bx-arrow-to-top:before {\n    content: \"\\e9bc\";\n  }\n  .bx-at:before {\n    content: \"\\e9bd\";\n  }\n  .bx-atom:before {\n    content: \"\\e9be\";\n  }\n  .bx-award:before {\n    content: \"\\e9bf\";\n  }\n  .bx-badge:before {\n    content: \"\\e9c0\";\n  }\n  .bx-badge-check:before {\n    content: \"\\e9c1\";\n  }\n  .bx-ball:before {\n    content: \"\\e9c2\";\n  }\n  .bx-band-aid:before {\n    content: \"\\e9c3\";\n  }\n  .bx-bar-chart:before {\n    content: \"\\e9c4\";\n  }\n  .bx-bar-chart-alt:before {\n    content: \"\\e9c5\";\n  }\n  .bx-bar-chart-alt-2:before {\n    content: \"\\e9c6\";\n  }\n  .bx-bar-chart-square:before {\n    content: \"\\e9c7\";\n  }\n  .bx-barcode:before {\n    content: \"\\e9c8\";\n  }\n  .bx-barcode-reader:before {\n    content: \"\\e9c9\";\n  }\n  .bx-baseball:before {\n    content: \"\\e9ca\";\n  }\n  .bx-basket:before {\n    content: \"\\e9cb\";\n  }\n  .bx-basketball:before {\n    content: \"\\e9cc\";\n  }\n  .bx-bath:before {\n    content: \"\\e9cd\";\n  }\n  .bx-battery:before {\n    content: \"\\e9ce\";\n  }\n  .bx-bed:before {\n    content: \"\\e9cf\";\n  }\n  .bx-been-here:before {\n    content: \"\\e9d0\";\n  }\n  .bx-beer:before {\n    content: \"\\e9d1\";\n  }\n  .bx-bell:before {\n    content: \"\\e9d2\";\n  }\n  .bx-bell-minus:before {\n    content: \"\\e9d3\";\n  }\n  .bx-bell-off:before {\n    content: \"\\e9d4\";\n  }\n  .bx-bell-plus:before {\n    content: \"\\e9d5\";\n  }\n  .bx-bible:before {\n    content: \"\\e9d6\";\n  }\n  .bx-bitcoin:before {\n    content: \"\\e9d7\";\n  }\n  .bx-blanket:before {\n    content: \"\\e9d8\";\n  }\n  .bx-block:before {\n    content: \"\\e9d9\";\n  }\n  .bx-bluetooth:before {\n    content: \"\\e9da\";\n  }\n  .bx-body:before {\n    content: \"\\e9db\";\n  }\n  .bx-bold:before {\n    content: \"\\e9dc\";\n  }\n  .bx-bolt-circle:before {\n    content: \"\\e9dd\";\n  }\n  .bx-bomb:before {\n    content: \"\\e9de\";\n  }\n  .bx-bone:before {\n    content: \"\\e9df\";\n  }\n  .bx-bong:before {\n    content: \"\\e9e0\";\n  }\n  .bx-book:before {\n    content: \"\\e9e1\";\n  }\n  .bx-book-add:before {\n    content: \"\\e9e2\";\n  }\n  .bx-book-alt:before {\n    content: \"\\e9e3\";\n  }\n  .bx-book-bookmark:before {\n    content: \"\\e9e4\";\n  }\n  .bx-book-content:before {\n    content: \"\\e9e5\";\n  }\n  .bx-book-heart:before {\n    content: \"\\e9e6\";\n  }\n  .bx-bookmark:before {\n    content: \"\\e9e7\";\n  }\n  .bx-bookmark-alt:before {\n    content: \"\\e9e8\";\n  }\n  .bx-bookmark-alt-minus:before {\n    content: \"\\e9e9\";\n  }\n  .bx-bookmark-alt-plus:before {\n    content: \"\\e9ea\";\n  }\n  .bx-bookmark-heart:before {\n    content: \"\\e9eb\";\n  }\n  .bx-bookmark-minus:before {\n    content: \"\\e9ec\";\n  }\n  .bx-bookmark-plus:before {\n    content: \"\\e9ed\";\n  }\n  .bx-bookmarks:before {\n    content: \"\\e9ee\";\n  }\n  .bx-book-open:before {\n    content: \"\\e9ef\";\n  }\n  .bx-book-reader:before {\n    content: \"\\e9f0\";\n  }\n  .bx-border-all:before {\n    content: \"\\e9f1\";\n  }\n  .bx-border-bottom:before {\n    content: \"\\e9f2\";\n  }\n  .bx-border-inner:before {\n    content: \"\\e9f3\";\n  }\n  .bx-border-left:before {\n    content: \"\\e9f4\";\n  }\n  .bx-border-none:before {\n    content: \"\\e9f5\";\n  }\n  .bx-border-outer:before {\n    content: \"\\e9f6\";\n  }\n  .bx-border-radius:before {\n    content: \"\\e9f7\";\n  }\n  .bx-border-right:before {\n    content: \"\\e9f8\";\n  }\n  .bx-border-top:before {\n    content: \"\\e9f9\";\n  }\n  .bx-bot:before {\n    content: \"\\e9fa\";\n  }\n  .bx-bowling-ball:before {\n    content: \"\\e9fb\";\n  }\n  .bx-box:before {\n    content: \"\\e9fc\";\n  }\n  .bx-bracket:before {\n    content: \"\\e9fd\";\n  }\n  .bx-braille:before {\n    content: \"\\e9fe\";\n  }\n  .bx-brain:before {\n    content: \"\\e9ff\";\n  }\n  .bx-briefcase:before {\n    content: \"\\ea00\";\n  }\n  .bx-briefcase-alt:before {\n    content: \"\\ea01\";\n  }\n  .bx-briefcase-alt-2:before {\n    content: \"\\ea02\";\n  }\n  .bx-brightness:before {\n    content: \"\\ea03\";\n  }\n  .bx-brightness-half:before {\n    content: \"\\ea04\";\n  }\n  .bx-broadcast:before {\n    content: \"\\ea05\";\n  }\n  .bx-brush:before {\n    content: \"\\ea06\";\n  }\n  .bx-brush-alt:before {\n    content: \"\\ea07\";\n  }\n  .bx-bug:before {\n    content: \"\\ea08\";\n  }\n  .bx-bug-alt:before {\n    content: \"\\ea09\";\n  }\n  .bx-building:before {\n    content: \"\\ea0a\";\n  }\n  .bx-building-house:before {\n    content: \"\\ea0b\";\n  }\n  .bx-buildings:before {\n    content: \"\\ea0c\";\n  }\n  .bx-bulb:before {\n    content: \"\\ea0d\";\n  }\n  .bx-bullseye:before {\n    content: \"\\ea0e\";\n  }\n  .bx-buoy:before {\n    content: \"\\ea0f\";\n  }\n  .bx-bus:before {\n    content: \"\\ea10\";\n  }\n  .bx-bus-school:before {\n    content: \"\\ea11\";\n  }\n  .bx-cabinet:before {\n    content: \"\\ea12\";\n  }\n  .bx-cake:before {\n    content: \"\\ea13\";\n  }\n  .bx-calculator:before {\n    content: \"\\ea14\";\n  }\n  .bx-calendar:before {\n    content: \"\\ea15\";\n  }\n  .bx-calendar-alt:before {\n    content: \"\\ea16\";\n  }\n  .bx-calendar-check:before {\n    content: \"\\ea17\";\n  }\n  .bx-calendar-edit:before {\n    content: \"\\ea18\";\n  }\n  .bx-calendar-event:before {\n    content: \"\\ea19\";\n  }\n  .bx-calendar-exclamation:before {\n    content: \"\\ea1a\";\n  }\n  .bx-calendar-heart:before {\n    content: \"\\ea1b\";\n  }\n  .bx-calendar-minus:before {\n    content: \"\\ea1c\";\n  }\n  .bx-calendar-plus:before {\n    content: \"\\ea1d\";\n  }\n  .bx-calendar-star:before {\n    content: \"\\ea1e\";\n  }\n  .bx-calendar-week:before {\n    content: \"\\ea1f\";\n  }\n  .bx-calendar-x:before {\n    content: \"\\ea20\";\n  }\n  .bx-camera:before {\n    content: \"\\ea21\";\n  }\n  .bx-camera-home:before {\n    content: \"\\ea22\";\n  }\n  .bx-camera-movie:before {\n    content: \"\\ea23\";\n  }\n  .bx-camera-off:before {\n    content: \"\\ea24\";\n  }\n  .bx-capsule:before {\n    content: \"\\ea25\";\n  }\n  .bx-captions:before {\n    content: \"\\ea26\";\n  }\n  .bx-car:before {\n    content: \"\\ea27\";\n  }\n  .bx-card:before {\n    content: \"\\ea28\";\n  }\n  .bx-caret-down:before {\n    content: \"\\ea29\";\n  }\n  .bx-caret-down-circle:before {\n    content: \"\\ea2a\";\n  }\n  .bx-caret-down-square:before {\n    content: \"\\ea2b\";\n  }\n  .bx-caret-left:before {\n    content: \"\\ea2c\";\n  }\n  .bx-caret-left-circle:before {\n    content: \"\\ea2d\";\n  }\n  .bx-caret-left-square:before {\n    content: \"\\ea2e\";\n  }\n  .bx-caret-right:before {\n    content: \"\\ea2f\";\n  }\n  .bx-caret-right-circle:before {\n    content: \"\\ea30\";\n  }\n  .bx-caret-right-square:before {\n    content: \"\\ea31\";\n  }\n  .bx-caret-up:before {\n    content: \"\\ea32\";\n  }\n  .bx-caret-up-circle:before {\n    content: \"\\ea33\";\n  }\n  .bx-caret-up-square:before {\n    content: \"\\ea34\";\n  }\n  .bx-carousel:before {\n    content: \"\\ea35\";\n  }\n  .bx-cart:before {\n    content: \"\\ea36\";\n  }\n  .bx-cart-alt:before {\n    content: \"\\ea37\";\n  }\n  .bx-cast:before {\n    content: \"\\ea38\";\n  }\n  .bx-category:before {\n    content: \"\\ea39\";\n  }\n  .bx-category-alt:before {\n    content: \"\\ea3a\";\n  }\n  .bx-cctv:before {\n    content: \"\\ea3b\";\n  }\n  .bx-certification:before {\n    content: \"\\ea3c\";\n  }\n  .bx-chair:before {\n    content: \"\\ea3d\";\n  }\n  .bx-chalkboard:before {\n    content: \"\\ea3e\";\n  }\n  .bx-chart:before {\n    content: \"\\ea3f\";\n  }\n  .bx-chat:before {\n    content: \"\\ea40\";\n  }\n  .bx-check:before {\n    content: \"\\ea41\";\n  }\n  .bx-checkbox:before {\n    content: \"\\ea42\";\n  }\n  .bx-checkbox-checked:before {\n    content: \"\\ea43\";\n  }\n  .bx-checkbox-minus:before {\n    content: \"\\ea44\";\n  }\n  .bx-checkbox-square:before {\n    content: \"\\ea45\";\n  }\n  .bx-check-circle:before {\n    content: \"\\ea46\";\n  }\n  .bx-check-double:before {\n    content: \"\\ea47\";\n  }\n  .bx-check-shield:before {\n    content: \"\\ea48\";\n  }\n  .bx-check-square:before {\n    content: \"\\ea49\";\n  }\n  .bx-chevron-down:before {\n    content: \"\\ea4a\";\n  }\n  .bx-chevron-down-circle:before {\n    content: \"\\ea4b\";\n  }\n  .bx-chevron-down-square:before {\n    content: \"\\ea4c\";\n  }\n  .bx-chevron-left:before {\n    content: \"\\ea4d\";\n  }\n  .bx-chevron-left-circle:before {\n    content: \"\\ea4e\";\n  }\n  .bx-chevron-left-square:before {\n    content: \"\\ea4f\";\n  }\n  .bx-chevron-right:before {\n    content: \"\\ea50\";\n  }\n  .bx-chevron-right-circle:before {\n    content: \"\\ea51\";\n  }\n  .bx-chevron-right-square:before {\n    content: \"\\ea52\";\n  }\n  .bx-chevrons-down:before {\n    content: \"\\ea53\";\n  }\n  .bx-chevrons-left:before {\n    content: \"\\ea54\";\n  }\n  .bx-chevrons-right:before {\n    content: \"\\ea55\";\n  }\n  .bx-chevrons-up:before {\n    content: \"\\ea56\";\n  }\n  .bx-chevron-up:before {\n    content: \"\\ea57\";\n  }\n  .bx-chevron-up-circle:before {\n    content: \"\\ea58\";\n  }\n  .bx-chevron-up-square:before {\n    content: \"\\ea59\";\n  }\n  .bx-chip:before {\n    content: \"\\ea5a\";\n  }\n  .bx-church:before {\n    content: \"\\ea5b\";\n  }\n  .bx-circle:before {\n    content: \"\\ea5c\";\n  }\n  .bx-clinic:before {\n    content: \"\\ea5d\";\n  }\n  .bx-clipboard:before {\n    content: \"\\ea5e\";\n  }\n  .bx-closet:before {\n    content: \"\\ea5f\";\n  }\n  .bx-cloud:before {\n    content: \"\\ea60\";\n  }\n  .bx-cloud-download:before {\n    content: \"\\ea61\";\n  }\n  .bx-cloud-drizzle:before {\n    content: \"\\ea62\";\n  }\n  .bx-cloud-lightning:before {\n    content: \"\\ea63\";\n  }\n  .bx-cloud-light-rain:before {\n    content: \"\\ea64\";\n  }\n  .bx-cloud-rain:before {\n    content: \"\\ea65\";\n  }\n  .bx-cloud-snow:before {\n    content: \"\\ea66\";\n  }\n  .bx-cloud-upload:before {\n    content: \"\\ea67\";\n  }\n  .bx-code:before {\n    content: \"\\ea68\";\n  }\n  .bx-code-alt:before {\n    content: \"\\ea69\";\n  }\n  .bx-code-block:before {\n    content: \"\\ea6a\";\n  }\n  .bx-code-curly:before {\n    content: \"\\ea6b\";\n  }\n  .bx-coffee:before {\n    content: \"\\ea6c\";\n  }\n  .bx-coffee-togo:before {\n    content: \"\\ea6d\";\n  }\n  .bx-cog:before {\n    content: \"\\ea6e\";\n  }\n  .bx-coin:before {\n    content: \"\\ea6f\";\n  }\n  .bx-coin-stack:before {\n    content: \"\\ea70\";\n  }\n  .bx-collapse:before {\n    content: \"\\ea71\";\n  }\n  .bx-collection:before {\n    content: \"\\ea72\";\n  }\n  .bx-color-fill:before {\n    content: \"\\ea73\";\n  }\n  .bx-columns:before {\n    content: \"\\ea74\";\n  }\n  .bx-command:before {\n    content: \"\\ea75\";\n  }\n  .bx-comment:before {\n    content: \"\\ea76\";\n  }\n  .bx-comment-add:before {\n    content: \"\\ea77\";\n  }\n  .bx-comment-check:before {\n    content: \"\\ea78\";\n  }\n  .bx-comment-detail:before {\n    content: \"\\ea79\";\n  }\n  .bx-comment-dots:before {\n    content: \"\\ea7a\";\n  }\n  .bx-comment-edit:before {\n    content: \"\\ea7b\";\n  }\n  .bx-comment-error:before {\n    content: \"\\ea7c\";\n  }\n  .bx-comment-minus:before {\n    content: \"\\ea7d\";\n  }\n  .bx-comment-x:before {\n    content: \"\\ea7e\";\n  }\n  .bx-compass:before {\n    content: \"\\ea7f\";\n  }\n  .bx-confused:before {\n    content: \"\\ea80\";\n  }\n  .bx-conversation:before {\n    content: \"\\ea81\";\n  }\n  .bx-cookie:before {\n    content: \"\\ea82\";\n  }\n  .bx-cool:before {\n    content: \"\\ea83\";\n  }\n  .bx-copy:before {\n    content: \"\\ea84\";\n  }\n  .bx-copy-alt:before {\n    content: \"\\ea85\";\n  }\n  .bx-copyright:before {\n    content: \"\\ea86\";\n  }\n  .bx-credit-card:before {\n    content: \"\\ea87\";\n  }\n  .bx-credit-card-alt:before {\n    content: \"\\ea88\";\n  }\n  .bx-credit-card-front:before {\n    content: \"\\ea89\";\n  }\n  .bx-crop:before {\n    content: \"\\ea8a\";\n  }\n  .bx-crosshair:before {\n    content: \"\\ea8b\";\n  }\n  .bx-crown:before {\n    content: \"\\ea8c\";\n  }\n  .bx-cube:before {\n    content: \"\\ea8d\";\n  }\n  .bx-cube-alt:before {\n    content: \"\\ea8e\";\n  }\n  .bx-cuboid:before {\n    content: \"\\ea8f\";\n  }\n  .bx-current-location:before {\n    content: \"\\ea90\";\n  }\n  .bx-customize:before {\n    content: \"\\ea91\";\n  }\n  .bx-cut:before {\n    content: \"\\ea92\";\n  }\n  .bx-cycling:before {\n    content: \"\\ea93\";\n  }\n  .bx-cylinder:before {\n    content: \"\\ea94\";\n  }\n  .bx-data:before {\n    content: \"\\ea95\";\n  }\n  .bx-desktop:before {\n    content: \"\\ea96\";\n  }\n  .bx-detail:before {\n    content: \"\\ea97\";\n  }\n  .bx-devices:before {\n    content: \"\\ea98\";\n  }\n  .bx-dialpad:before {\n    content: \"\\ea99\";\n  }\n  .bx-dialpad-alt:before {\n    content: \"\\ea9a\";\n  }\n  .bx-diamond:before {\n    content: \"\\ea9b\";\n  }\n  .bx-dice-1:before {\n    content: \"\\ea9c\";\n  }\n  .bx-dice-2:before {\n    content: \"\\ea9d\";\n  }\n  .bx-dice-3:before {\n    content: \"\\ea9e\";\n  }\n  .bx-dice-4:before {\n    content: \"\\ea9f\";\n  }\n  .bx-dice-5:before {\n    content: \"\\eaa0\";\n  }\n  .bx-dice-6:before {\n    content: \"\\eaa1\";\n  }\n  .bx-directions:before {\n    content: \"\\eaa2\";\n  }\n  .bx-disc:before {\n    content: \"\\eaa3\";\n  }\n  .bx-dish:before {\n    content: \"\\eaa4\";\n  }\n  .bx-dislike:before {\n    content: \"\\eaa5\";\n  }\n  .bx-dizzy:before {\n    content: \"\\eaa6\";\n  }\n  .bx-dna:before {\n    content: \"\\eaa7\";\n  }\n  .bx-dock-bottom:before {\n    content: \"\\eaa8\";\n  }\n  .bx-dock-left:before {\n    content: \"\\eaa9\";\n  }\n  .bx-dock-right:before {\n    content: \"\\eaaa\";\n  }\n  .bx-dock-top:before {\n    content: \"\\eaab\";\n  }\n  .bx-dollar:before {\n    content: \"\\eaac\";\n  }\n  .bx-dollar-circle:before {\n    content: \"\\eaad\";\n  }\n  .bx-donate-blood:before {\n    content: \"\\eaae\";\n  }\n  .bx-donate-heart:before {\n    content: \"\\eaaf\";\n  }\n  .bx-door-open:before {\n    content: \"\\eab0\";\n  }\n  .bx-dots-horizontal:before {\n    content: \"\\eab1\";\n  }\n  .bx-dots-horizontal-rounded:before {\n    content: \"\\eab2\";\n  }\n  .bx-dots-vertical:before {\n    content: \"\\eab3\";\n  }\n  .bx-dots-vertical-rounded:before {\n    content: \"\\eab4\";\n  }\n  .bx-doughnut-chart:before {\n    content: \"\\eab5\";\n  }\n  .bx-down-arrow:before {\n    content: \"\\eab6\";\n  }\n  .bx-down-arrow-alt:before {\n    content: \"\\eab7\";\n  }\n  .bx-down-arrow-circle:before {\n    content: \"\\eab8\";\n  }\n  .bx-download:before {\n    content: \"\\eab9\";\n  }\n  .bx-downvote:before {\n    content: \"\\eaba\";\n  }\n  .bx-drink:before {\n    content: \"\\eabb\";\n  }\n  .bx-droplet:before {\n    content: \"\\eabc\";\n  }\n  .bx-dumbbell:before {\n    content: \"\\eabd\";\n  }\n  .bx-duplicate:before {\n    content: \"\\eabe\";\n  }\n  .bx-edit:before {\n    content: \"\\eabf\";\n  }\n  .bx-edit-alt:before {\n    content: \"\\eac0\";\n  }\n  .bx-envelope:before {\n    content: \"\\eac1\";\n  }\n  .bx-envelope-open:before {\n    content: \"\\eac2\";\n  }\n  .bx-equalizer:before {\n    content: \"\\eac3\";\n  }\n  .bx-eraser:before {\n    content: \"\\eac4\";\n  }\n  .bx-error:before {\n    content: \"\\eac5\";\n  }\n  .bx-error-alt:before {\n    content: \"\\eac6\";\n  }\n  .bx-error-circle:before {\n    content: \"\\eac7\";\n  }\n  .bx-euro:before {\n    content: \"\\eac8\";\n  }\n  .bx-exclude:before {\n    content: \"\\eac9\";\n  }\n  .bx-exit:before {\n    content: \"\\eaca\";\n  }\n  .bx-exit-fullscreen:before {\n    content: \"\\eacb\";\n  }\n  .bx-expand:before {\n    content: \"\\eacc\";\n  }\n  .bx-expand-alt:before {\n    content: \"\\eacd\";\n  }\n  .bx-export:before {\n    content: \"\\eace\";\n  }\n  .bx-extension:before {\n    content: \"\\eacf\";\n  }\n  .bx-face:before {\n    content: \"\\ead0\";\n  }\n  .bx-fast-forward:before {\n    content: \"\\ead1\";\n  }\n  .bx-fast-forward-circle:before {\n    content: \"\\ead2\";\n  }\n  .bx-female:before {\n    content: \"\\ead3\";\n  }\n  .bx-female-sign:before {\n    content: \"\\ead4\";\n  }\n  .bx-file:before {\n    content: \"\\ead5\";\n  }\n  .bx-file-blank:before {\n    content: \"\\ead6\";\n  }\n  .bx-file-find:before {\n    content: \"\\ead7\";\n  }\n  .bx-film:before {\n    content: \"\\ead8\";\n  }\n  .bx-filter:before {\n    content: \"\\ead9\";\n  }\n  .bx-filter-alt:before {\n    content: \"\\eada\";\n  }\n  .bx-fingerprint:before {\n    content: \"\\eadb\";\n  }\n  .bx-first-aid:before {\n    content: \"\\eadc\";\n  }\n  .bx-first-page:before {\n    content: \"\\eadd\";\n  }\n  .bx-flag:before {\n    content: \"\\eade\";\n  }\n  .bx-folder:before {\n    content: \"\\eadf\";\n  }\n  .bx-folder-minus:before {\n    content: \"\\eae0\";\n  }\n  .bx-folder-open:before {\n    content: \"\\eae1\";\n  }\n  .bx-folder-plus:before {\n    content: \"\\eae2\";\n  }\n  .bx-font:before {\n    content: \"\\eae3\";\n  }\n  .bx-font-color:before {\n    content: \"\\eae4\";\n  }\n  .bx-font-family:before {\n    content: \"\\eae5\";\n  }\n  .bx-font-size:before {\n    content: \"\\eae6\";\n  }\n  .bx-food-menu:before {\n    content: \"\\eae7\";\n  }\n  .bx-food-tag:before {\n    content: \"\\eae8\";\n  }\n  .bx-football:before {\n    content: \"\\eae9\";\n  }\n  .bx-fridge:before {\n    content: \"\\eaea\";\n  }\n  .bx-fullscreen:before {\n    content: \"\\eaeb\";\n  }\n  .bx-game:before {\n    content: \"\\eaec\";\n  }\n  .bx-gas-pump:before {\n    content: \"\\eaed\";\n  }\n  .bx-ghost:before {\n    content: \"\\eaee\";\n  }\n  .bx-gift:before {\n    content: \"\\eaef\";\n  }\n  .bx-git-branch:before {\n    content: \"\\eaf0\";\n  }\n  .bx-git-commit:before {\n    content: \"\\eaf1\";\n  }\n  .bx-git-compare:before {\n    content: \"\\eaf2\";\n  }\n  .bx-git-merge:before {\n    content: \"\\eaf3\";\n  }\n  .bx-git-pull-request:before {\n    content: \"\\eaf4\";\n  }\n  .bx-git-repo-forked:before {\n    content: \"\\eaf5\";\n  }\n  .bx-glasses:before {\n    content: \"\\eaf6\";\n  }\n  .bx-glasses-alt:before {\n    content: \"\\eaf7\";\n  }\n  .bx-globe:before {\n    content: \"\\eaf8\";\n  }\n  .bx-globe-alt:before {\n    content: \"\\eaf9\";\n  }\n  .bx-grid:before {\n    content: \"\\eafa\";\n  }\n  .bx-grid-alt:before {\n    content: \"\\eafb\";\n  }\n  .bx-grid-horizontal:before {\n    content: \"\\eafc\";\n  }\n  .bx-grid-small:before {\n    content: \"\\eafd\";\n  }\n  .bx-grid-vertical:before {\n    content: \"\\eafe\";\n  }\n  .bx-group:before {\n    content: \"\\eaff\";\n  }\n  .bx-handicap:before {\n    content: \"\\eb00\";\n  }\n  .bx-happy:before {\n    content: \"\\eb01\";\n  }\n  .bx-happy-alt:before {\n    content: \"\\eb02\";\n  }\n  .bx-happy-beaming:before {\n    content: \"\\eb03\";\n  }\n  .bx-happy-heart-eyes:before {\n    content: \"\\eb04\";\n  }\n  .bx-hash:before {\n    content: \"\\eb05\";\n  }\n  .bx-hdd:before {\n    content: \"\\eb06\";\n  }\n  .bx-heading:before {\n    content: \"\\eb07\";\n  }\n  .bx-headphone:before {\n    content: \"\\eb08\";\n  }\n  .bx-health:before {\n    content: \"\\eb09\";\n  }\n  .bx-heart:before {\n    content: \"\\eb0a\";\n  }\n  .bx-heart-circle:before {\n    content: \"\\eb0b\";\n  }\n  .bx-heart-square:before {\n    content: \"\\eb0c\";\n  }\n  .bx-help-circle:before {\n    content: \"\\eb0d\";\n  }\n  .bx-hide:before {\n    content: \"\\eb0e\";\n  }\n  .bx-highlight:before {\n    content: \"\\eb0f\";\n  }\n  .bx-history:before {\n    content: \"\\eb10\";\n  }\n  .bx-hive:before {\n    content: \"\\eb11\";\n  }\n  .bx-home:before {\n    content: \"\\eb12\";\n  }\n  .bx-home-alt:before {\n    content: \"\\eb13\";\n  }\n  .bx-home-circle:before {\n    content: \"\\eb14\";\n  }\n  .bx-home-heart:before {\n    content: \"\\eb15\";\n  }\n  .bx-home-smile:before {\n    content: \"\\eb16\";\n  }\n  .bx-horizontal-center:before {\n    content: \"\\eb17\";\n  }\n  .bx-hotel:before {\n    content: \"\\eb18\";\n  }\n  .bx-hourglass:before {\n    content: \"\\eb19\";\n  }\n  .bx-id-card:before {\n    content: \"\\eb1a\";\n  }\n  .bx-image:before {\n    content: \"\\eb1b\";\n  }\n  .bx-image-add:before {\n    content: \"\\eb1c\";\n  }\n  .bx-image-alt:before {\n    content: \"\\eb1d\";\n  }\n  .bx-images:before {\n    content: \"\\eb1e\";\n  }\n  .bx-import:before {\n    content: \"\\eb1f\";\n  }\n  .bx-infinite:before {\n    content: \"\\eb20\";\n  }\n  .bx-info-circle:before {\n    content: \"\\eb21\";\n  }\n  .bx-info-square:before {\n    content: \"\\eb22\";\n  }\n  .bx-intersect:before {\n    content: \"\\eb23\";\n  }\n  .bx-italic:before {\n    content: \"\\eb24\";\n  }\n  .bx-joystick:before {\n    content: \"\\eb25\";\n  }\n  .bx-joystick-alt:before {\n    content: \"\\eb26\";\n  }\n  .bx-joystick-button:before {\n    content: \"\\eb27\";\n  }\n  .bx-key:before {\n    content: \"\\eb28\";\n  }\n  .bx-label:before {\n    content: \"\\eb29\";\n  }\n  .bx-landscape:before {\n    content: \"\\eb2a\";\n  }\n  .bx-laptop:before {\n    content: \"\\eb2b\";\n  }\n  .bx-last-page:before {\n    content: \"\\eb2c\";\n  }\n  .bx-laugh:before {\n    content: \"\\eb2d\";\n  }\n  .bx-layer:before {\n    content: \"\\eb2e\";\n  }\n  .bx-layer-minus:before {\n    content: \"\\eb2f\";\n  }\n  .bx-layer-plus:before {\n    content: \"\\eb30\";\n  }\n  .bx-layout:before {\n    content: \"\\eb31\";\n  }\n  .bx-left-arrow:before {\n    content: \"\\eb32\";\n  }\n  .bx-left-arrow-alt:before {\n    content: \"\\eb33\";\n  }\n  .bx-left-arrow-circle:before {\n    content: \"\\eb34\";\n  }\n  .bx-left-down-arrow-circle:before {\n    content: \"\\eb35\";\n  }\n  .bx-left-indent:before {\n    content: \"\\eb36\";\n  }\n  .bx-left-top-arrow-circle:before {\n    content: \"\\eb37\";\n  }\n  .bx-library:before {\n    content: \"\\eb38\";\n  }\n  .bx-like:before {\n    content: \"\\eb39\";\n  }\n  .bx-line-chart:before {\n    content: \"\\eb3a\";\n  }\n  .bx-line-chart-down:before {\n    content: \"\\eb3b\";\n  }\n  .bx-link:before {\n    content: \"\\eb3c\";\n  }\n  .bx-link-alt:before {\n    content: \"\\eb3d\";\n  }\n  .bx-link-external:before {\n    content: \"\\eb3e\";\n  }\n  .bx-lira:before {\n    content: \"\\eb3f\";\n  }\n  .bx-list-check:before {\n    content: \"\\eb40\";\n  }\n  .bx-list-minus:before {\n    content: \"\\eb41\";\n  }\n  .bx-list-ol:before {\n    content: \"\\eb42\";\n  }\n  .bx-list-plus:before {\n    content: \"\\eb43\";\n  }\n  .bx-list-ul:before {\n    content: \"\\eb44\";\n  }\n  .bx-loader:before {\n    content: \"\\eb45\";\n  }\n  .bx-loader-alt:before {\n    content: \"\\eb46\";\n  }\n  .bx-loader-circle:before {\n    content: \"\\eb47\";\n  }\n  .bx-location-plus:before {\n    content: \"\\eb48\";\n  }\n  .bx-lock:before {\n    content: \"\\eb49\";\n  }\n  .bx-lock-alt:before {\n    content: \"\\eb4a\";\n  }\n  .bx-lock-open:before {\n    content: \"\\eb4b\";\n  }\n  .bx-lock-open-alt:before {\n    content: \"\\eb4c\";\n  }\n  .bx-log-in:before {\n    content: \"\\eb4d\";\n  }\n  .bx-log-in-circle:before {\n    content: \"\\eb4e\";\n  }\n  .bx-log-out:before {\n    content: \"\\eb4f\";\n  }\n  .bx-log-out-circle:before {\n    content: \"\\eb50\";\n  }\n  .bx-low-vision:before {\n    content: \"\\eb51\";\n  }\n  .bx-magnet:before {\n    content: \"\\eb52\";\n  }\n  .bx-mail-send:before {\n    content: \"\\eb53\";\n  }\n  .bx-male:before {\n    content: \"\\eb54\";\n  }\n  .bx-male-sign:before {\n    content: \"\\eb55\";\n  }\n  .bx-map:before {\n    content: \"\\eb56\";\n  }\n  .bx-map-alt:before {\n    content: \"\\eb57\";\n  }\n  .bx-map-pin:before {\n    content: \"\\eb58\";\n  }\n  .bx-mask:before {\n    content: \"\\eb59\";\n  }\n  .bx-medal:before {\n    content: \"\\eb5a\";\n  }\n  .bx-meh:before {\n    content: \"\\eb5b\";\n  }\n  .bx-meh-alt:before {\n    content: \"\\eb5c\";\n  }\n  .bx-meh-blank:before {\n    content: \"\\eb5d\";\n  }\n  .bx-memory-card:before {\n    content: \"\\eb5e\";\n  }\n  .bx-menu:before {\n    content: \"\\eb5f\";\n  }\n  .bx-menu-alt-left:before {\n    content: \"\\eb60\";\n  }\n  .bx-menu-alt-right:before {\n    content: \"\\eb61\";\n  }\n  .bx-merge:before {\n    content: \"\\eb62\";\n  }\n  .bx-message:before {\n    content: \"\\eb63\";\n  }\n  .bx-message-add:before {\n    content: \"\\eb64\";\n  }\n  .bx-message-alt:before {\n    content: \"\\eb65\";\n  }\n  .bx-message-alt-add:before {\n    content: \"\\eb66\";\n  }\n  .bx-message-alt-check:before {\n    content: \"\\eb67\";\n  }\n  .bx-message-alt-detail:before {\n    content: \"\\eb68\";\n  }\n  .bx-message-alt-dots:before {\n    content: \"\\eb69\";\n  }\n  .bx-message-alt-edit:before {\n    content: \"\\eb6a\";\n  }\n  .bx-message-alt-error:before {\n    content: \"\\eb6b\";\n  }\n  .bx-message-alt-minus:before {\n    content: \"\\eb6c\";\n  }\n  .bx-message-alt-x:before {\n    content: \"\\eb6d\";\n  }\n  .bx-message-check:before {\n    content: \"\\eb6e\";\n  }\n  .bx-message-detail:before {\n    content: \"\\eb6f\";\n  }\n  .bx-message-dots:before {\n    content: \"\\eb70\";\n  }\n  .bx-message-edit:before {\n    content: \"\\eb71\";\n  }\n  .bx-message-error:before {\n    content: \"\\eb72\";\n  }\n  .bx-message-minus:before {\n    content: \"\\eb73\";\n  }\n  .bx-message-rounded:before {\n    content: \"\\eb74\";\n  }\n  .bx-message-rounded-add:before {\n    content: \"\\eb75\";\n  }\n  .bx-message-rounded-check:before {\n    content: \"\\eb76\";\n  }\n  .bx-message-rounded-detail:before {\n    content: \"\\eb77\";\n  }\n  .bx-message-rounded-dots:before {\n    content: \"\\eb78\";\n  }\n  .bx-message-rounded-edit:before {\n    content: \"\\eb79\";\n  }\n  .bx-message-rounded-error:before {\n    content: \"\\eb7a\";\n  }\n  .bx-message-rounded-minus:before {\n    content: \"\\eb7b\";\n  }\n  .bx-message-rounded-x:before {\n    content: \"\\eb7c\";\n  }\n  .bx-message-square:before {\n    content: \"\\eb7d\";\n  }\n  .bx-message-square-add:before {\n    content: \"\\eb7e\";\n  }\n  .bx-message-square-check:before {\n    content: \"\\eb7f\";\n  }\n  .bx-message-square-detail:before {\n    content: \"\\eb80\";\n  }\n  .bx-message-square-dots:before {\n    content: \"\\eb81\";\n  }\n  .bx-message-square-edit:before {\n    content: \"\\eb82\";\n  }\n  .bx-message-square-error:before {\n    content: \"\\eb83\";\n  }\n  .bx-message-square-minus:before {\n    content: \"\\eb84\";\n  }\n  .bx-message-square-x:before {\n    content: \"\\eb85\";\n  }\n  .bx-message-x:before {\n    content: \"\\eb86\";\n  }\n  .bx-meteor:before {\n    content: \"\\eb87\";\n  }\n  .bx-microchip:before {\n    content: \"\\eb88\";\n  }\n  .bx-microphone:before {\n    content: \"\\eb89\";\n  }\n  .bx-microphone-off:before {\n    content: \"\\eb8a\";\n  }\n  .bx-minus:before {\n    content: \"\\eb8b\";\n  }\n  .bx-minus-back:before {\n    content: \"\\eb8c\";\n  }\n  .bx-minus-circle:before {\n    content: \"\\eb8d\";\n  }\n  .bx-minus-front:before {\n    content: \"\\eb8e\";\n  }\n  .bx-mobile:before {\n    content: \"\\eb8f\";\n  }\n  .bx-mobile-alt:before {\n    content: \"\\eb90\";\n  }\n  .bx-mobile-landscape:before {\n    content: \"\\eb91\";\n  }\n  .bx-mobile-vibration:before {\n    content: \"\\eb92\";\n  }\n  .bx-money:before {\n    content: \"\\eb93\";\n  }\n  .bx-moon:before {\n    content: \"\\eb94\";\n  }\n  .bx-mouse:before {\n    content: \"\\eb95\";\n  }\n  .bx-mouse-alt:before {\n    content: \"\\eb96\";\n  }\n  .bx-move:before {\n    content: \"\\eb97\";\n  }\n  .bx-move-horizontal:before {\n    content: \"\\eb98\";\n  }\n  .bx-move-vertical:before {\n    content: \"\\eb99\";\n  }\n  .bx-movie:before {\n    content: \"\\eb9a\";\n  }\n  .bx-movie-play:before {\n    content: \"\\eb9b\";\n  }\n  .bx-music:before {\n    content: \"\\eb9c\";\n  }\n  .bx-navigation:before {\n    content: \"\\eb9d\";\n  }\n  .bx-network-chart:before {\n    content: \"\\eb9e\";\n  }\n  .bx-news:before {\n    content: \"\\eb9f\";\n  }\n  .bx-no-entry:before {\n    content: \"\\eba0\";\n  }\n  .bx-note:before {\n    content: \"\\eba1\";\n  }\n  .bx-notepad:before {\n    content: \"\\eba2\";\n  }\n  .bx-notification:before {\n    content: \"\\eba3\";\n  }\n  .bx-notification-off:before {\n    content: \"\\eba4\";\n  }\n  .bx-outline:before {\n    content: \"\\eba5\";\n  }\n  .bx-package:before {\n    content: \"\\eba6\";\n  }\n  .bx-paint:before {\n    content: \"\\eba7\";\n  }\n  .bx-paint-roll:before {\n    content: \"\\eba8\";\n  }\n  .bx-palette:before {\n    content: \"\\eba9\";\n  }\n  .bx-paperclip:before {\n    content: \"\\ebaa\";\n  }\n  .bx-paper-plane:before {\n    content: \"\\ebab\";\n  }\n  .bx-paragraph:before {\n    content: \"\\ebac\";\n  }\n  .bx-paste:before {\n    content: \"\\ebad\";\n  }\n  .bx-pause:before {\n    content: \"\\ebae\";\n  }\n  .bx-pause-circle:before {\n    content: \"\\ebaf\";\n  }\n  .bx-pen:before {\n    content: \"\\ebb0\";\n  }\n  .bx-pencil:before {\n    content: \"\\ebb1\";\n  }\n  .bx-phone:before {\n    content: \"\\ebb2\";\n  }\n  .bx-phone-call:before {\n    content: \"\\ebb3\";\n  }\n  .bx-phone-incoming:before {\n    content: \"\\ebb4\";\n  }\n  .bx-phone-off:before {\n    content: \"\\ebb5\";\n  }\n  .bx-phone-outgoing:before {\n    content: \"\\ebb6\";\n  }\n  .bx-photo-album:before {\n    content: \"\\ebb7\";\n  }\n  .bx-pie-chart:before {\n    content: \"\\ebb8\";\n  }\n  .bx-pie-chart-alt:before {\n    content: \"\\ebb9\";\n  }\n  .bx-pie-chart-alt-2:before {\n    content: \"\\ebba\";\n  }\n  .bx-pin:before {\n    content: \"\\ebbb\";\n  }\n  .bx-planet:before {\n    content: \"\\ebbc\";\n  }\n  .bx-play:before {\n    content: \"\\ebbd\";\n  }\n  .bx-play-circle:before {\n    content: \"\\ebbe\";\n  }\n  .bx-plug:before {\n    content: \"\\ebbf\";\n  }\n  .bx-plus:before {\n    content: \"\\ebc0\";\n  }\n  .bx-plus-circle:before {\n    content: \"\\ebc1\";\n  }\n  .bx-plus-medical:before {\n    content: \"\\ebc2\";\n  }\n  .bx-podcast:before {\n    content: \"\\ebc3\";\n  }\n  .bx-pointer:before {\n    content: \"\\ebc4\";\n  }\n  .bx-poll:before {\n    content: \"\\ebc5\";\n  }\n  .bx-polygon:before {\n    content: \"\\ebc6\";\n  }\n  .bx-pound:before {\n    content: \"\\ebc7\";\n  }\n  .bx-power-off:before {\n    content: \"\\ebc8\";\n  }\n  .bx-printer:before {\n    content: \"\\ebc9\";\n  }\n  .bx-pulse:before {\n    content: \"\\ebca\";\n  }\n  .bx-purchase-tag:before {\n    content: \"\\ebcb\";\n  }\n  .bx-purchase-tag-alt:before {\n    content: \"\\ebcc\";\n  }\n  .bx-pyramid:before {\n    content: \"\\ebcd\";\n  }\n  .bx-qr:before {\n    content: \"\\ebce\";\n  }\n  .bx-qr-scan:before {\n    content: \"\\ebcf\";\n  }\n  .bx-question-mark:before {\n    content: \"\\ebd0\";\n  }\n  .bx-radar:before {\n    content: \"\\ebd1\";\n  }\n  .bx-radio:before {\n    content: \"\\ebd2\";\n  }\n  .bx-radio-circle:before {\n    content: \"\\ebd3\";\n  }\n  .bx-radio-circle-marked:before {\n    content: \"\\ebd4\";\n  }\n  .bx-receipt:before {\n    content: \"\\ebd5\";\n  }\n  .bx-rectangle:before {\n    content: \"\\ebd6\";\n  }\n  .bx-recycle:before {\n    content: \"\\ebd7\";\n  }\n  .bx-redo:before {\n    content: \"\\ebd8\";\n  }\n  .bx-refresh:before {\n    content: \"\\ebd9\";\n  }\n  .bx-registered:before {\n    content: \"\\ebda\";\n  }\n  .bx-rename:before {\n    content: \"\\ebdb\";\n  }\n  .bx-repeat:before {\n    content: \"\\ebdc\";\n  }\n  .bx-reply:before {\n    content: \"\\ebdd\";\n  }\n  .bx-reply-all:before {\n    content: \"\\ebde\";\n  }\n  .bx-repost:before {\n    content: \"\\ebdf\";\n  }\n  .bx-reset:before {\n    content: \"\\ebe0\";\n  }\n  .bx-restaurant:before {\n    content: \"\\ebe1\";\n  }\n  .bx-revision:before {\n    content: \"\\ebe2\";\n  }\n  .bx-rewind:before {\n    content: \"\\ebe3\";\n  }\n  .bx-rewind-circle:before {\n    content: \"\\ebe4\";\n  }\n  .bx-right-arrow:before {\n    content: \"\\ebe5\";\n  }\n  .bx-right-arrow-alt:before {\n    content: \"\\ebe6\";\n  }\n  .bx-right-arrow-circle:before {\n    content: \"\\ebe7\";\n  }\n  .bx-right-down-arrow-circle:before {\n    content: \"\\ebe8\";\n  }\n  .bx-right-indent:before {\n    content: \"\\ebe9\";\n  }\n  .bx-right-top-arrow-circle:before {\n    content: \"\\ebea\";\n  }\n  .bx-rocket:before {\n    content: \"\\ebeb\";\n  }\n  .bx-rotate-left:before {\n    content: \"\\ebec\";\n  }\n  .bx-rotate-right:before {\n    content: \"\\ebed\";\n  }\n  .bx-rss:before {\n    content: \"\\ebee\";\n  }\n  .bx-ruble:before {\n    content: \"\\ebef\";\n  }\n  .bx-ruler:before {\n    content: \"\\ebf0\";\n  }\n  .bx-run:before {\n    content: \"\\ebf1\";\n  }\n  .bx-rupee:before {\n    content: \"\\ebf2\";\n  }\n  .bx-sad:before {\n    content: \"\\ebf3\";\n  }\n  .bx-save:before {\n    content: \"\\ebf4\";\n  }\n  .bx-scan:before {\n    content: \"\\ebf5\";\n  }\n  .bx-screenshot:before {\n    content: \"\\ebf6\";\n  }\n  .bx-search:before {\n    content: \"\\ebf7\";\n  }\n  .bx-search-alt:before {\n    content: \"\\ebf8\";\n  }\n  .bx-search-alt-2:before {\n    content: \"\\ebf9\";\n  }\n  .bx-selection:before {\n    content: \"\\ebfa\";\n  }\n  .bx-select-multiple:before {\n    content: \"\\ebfb\";\n  }\n  .bx-send:before {\n    content: \"\\ebfc\";\n  }\n  .bx-server:before {\n    content: \"\\ebfd\";\n  }\n  .bx-shape-circle:before {\n    content: \"\\ebfe\";\n  }\n  .bx-shape-polygon:before {\n    content: \"\\ebff\";\n  }\n  .bx-shape-square:before {\n    content: \"\\ec00\";\n  }\n  .bx-shape-triangle:before {\n    content: \"\\ec01\";\n  }\n  .bx-share:before {\n    content: \"\\ec02\";\n  }\n  .bx-share-alt:before {\n    content: \"\\ec03\";\n  }\n  .bx-shekel:before {\n    content: \"\\ec04\";\n  }\n  .bx-shield:before {\n    content: \"\\ec05\";\n  }\n  .bx-shield-alt:before {\n    content: \"\\ec06\";\n  }\n  .bx-shield-alt-2:before {\n    content: \"\\ec07\";\n  }\n  .bx-shield-quarter:before {\n    content: \"\\ec08\";\n  }\n  .bx-shield-x:before {\n    content: \"\\ec09\";\n  }\n  .bx-shocked:before {\n    content: \"\\ec0a\";\n  }\n  .bx-shopping-bag:before {\n    content: \"\\ec0b\";\n  }\n  .bx-show:before {\n    content: \"\\ec0c\";\n  }\n  .bx-show-alt:before {\n    content: \"\\ec0d\";\n  }\n  .bx-shuffle:before {\n    content: \"\\ec0e\";\n  }\n  .bx-sidebar:before {\n    content: \"\\ec0f\";\n  }\n  .bx-sitemap:before {\n    content: \"\\ec10\";\n  }\n  .bx-skip-next:before {\n    content: \"\\ec11\";\n  }\n  .bx-skip-next-circle:before {\n    content: \"\\ec12\";\n  }\n  .bx-skip-previous:before {\n    content: \"\\ec13\";\n  }\n  .bx-skip-previous-circle:before {\n    content: \"\\ec14\";\n  }\n  .bx-sleepy:before {\n    content: \"\\ec15\";\n  }\n  .bx-slider:before {\n    content: \"\\ec16\";\n  }\n  .bx-slider-alt:before {\n    content: \"\\ec17\";\n  }\n  .bx-slideshow:before {\n    content: \"\\ec18\";\n  }\n  .bx-smile:before {\n    content: \"\\ec19\";\n  }\n  .bx-sort:before {\n    content: \"\\ec1a\";\n  }\n  .bx-sort-alt-2:before {\n    content: \"\\ec1b\";\n  }\n  .bx-sort-a-z:before {\n    content: \"\\ec1c\";\n  }\n  .bx-sort-down:before {\n    content: \"\\ec1d\";\n  }\n  .bx-sort-up:before {\n    content: \"\\ec1e\";\n  }\n  .bx-sort-z-a:before {\n    content: \"\\ec1f\";\n  }\n  .bx-spa:before {\n    content: \"\\ec20\";\n  }\n  .bx-space-bar:before {\n    content: \"\\ec21\";\n  }\n  .bx-speaker:before {\n    content: \"\\ec22\";\n  }\n  .bx-spray-can:before {\n    content: \"\\ec23\";\n  }\n  .bx-spreadsheet:before {\n    content: \"\\ec24\";\n  }\n  .bx-square:before {\n    content: \"\\ec25\";\n  }\n  .bx-square-rounded:before {\n    content: \"\\ec26\";\n  }\n  .bx-star:before {\n    content: \"\\ec27\";\n  }\n  .bx-station:before {\n    content: \"\\ec28\";\n  }\n  .bx-stats:before {\n    content: \"\\ec29\";\n  }\n  .bx-sticker:before {\n    content: \"\\ec2a\";\n  }\n  .bx-stop:before {\n    content: \"\\ec2b\";\n  }\n  .bx-stop-circle:before {\n    content: \"\\ec2c\";\n  }\n  .bx-stopwatch:before {\n    content: \"\\ec2d\";\n  }\n  .bx-store:before {\n    content: \"\\ec2e\";\n  }\n  .bx-store-alt:before {\n    content: \"\\ec2f\";\n  }\n  .bx-street-view:before {\n    content: \"\\ec30\";\n  }\n  .bx-strikethrough:before {\n    content: \"\\ec31\";\n  }\n  .bx-subdirectory-left:before {\n    content: \"\\ec32\";\n  }\n  .bx-subdirectory-right:before {\n    content: \"\\ec33\";\n  }\n  .bx-sun:before {\n    content: \"\\ec34\";\n  }\n  .bx-support:before {\n    content: \"\\ec35\";\n  }\n  .bx-swim:before {\n    content: \"\\ec36\";\n  }\n  .bx-sync:before {\n    content: \"\\ec37\";\n  }\n  .bx-tab:before {\n    content: \"\\ec38\";\n  }\n  .bx-table:before {\n    content: \"\\ec39\";\n  }\n  .bx-tachometer:before {\n    content: \"\\ec3a\";\n  }\n  .bx-tag:before {\n    content: \"\\ec3b\";\n  }\n  .bx-tag-alt:before {\n    content: \"\\ec3c\";\n  }\n  .bx-target-lock:before {\n    content: \"\\ec3d\";\n  }\n  .bx-task:before {\n    content: \"\\ec3e\";\n  }\n  .bx-task-x:before {\n    content: \"\\ec3f\";\n  }\n  .bx-taxi:before {\n    content: \"\\ec40\";\n  }\n  .bx-tennis-ball:before {\n    content: \"\\ec41\";\n  }\n  .bx-terminal:before {\n    content: \"\\ec42\";\n  }\n  .bx-test-tube:before {\n    content: \"\\ec43\";\n  }\n  .bx-text:before {\n    content: \"\\ec44\";\n  }\n  .bx-time:before {\n    content: \"\\ec45\";\n  }\n  .bx-time-five:before {\n    content: \"\\ec46\";\n  }\n  .bx-timer:before {\n    content: \"\\ec47\";\n  }\n  .bx-tired:before {\n    content: \"\\ec48\";\n  }\n  .bx-toggle-left:before {\n    content: \"\\ec49\";\n  }\n  .bx-toggle-right:before {\n    content: \"\\ec4a\";\n  }\n  .bx-tone:before {\n    content: \"\\ec4b\";\n  }\n  .bx-traffic-cone:before {\n    content: \"\\ec4c\";\n  }\n  .bx-train:before {\n    content: \"\\ec4d\";\n  }\n  .bx-transfer:before {\n    content: \"\\ec4e\";\n  }\n  .bx-transfer-alt:before {\n    content: \"\\ec4f\";\n  }\n  .bx-trash:before {\n    content: \"\\ec50\";\n  }\n  .bx-trash-alt:before {\n    content: \"\\ec51\";\n  }\n  .bx-trending-down:before {\n    content: \"\\ec52\";\n  }\n  .bx-trending-up:before {\n    content: \"\\ec53\";\n  }\n  .bx-trim:before {\n    content: \"\\ec54\";\n  }\n  .bx-trip:before {\n    content: \"\\ec55\";\n  }\n  .bx-trophy:before {\n    content: \"\\ec56\";\n  }\n  .bx-tv:before {\n    content: \"\\ec57\";\n  }\n  .bx-underline:before {\n    content: \"\\ec58\";\n  }\n  .bx-undo:before {\n    content: \"\\ec59\";\n  }\n  .bx-unite:before {\n    content: \"\\ec5a\";\n  }\n  .bx-unlink:before {\n    content: \"\\ec5b\";\n  }\n  .bx-up-arrow:before {\n    content: \"\\ec5c\";\n  }\n  .bx-up-arrow-alt:before {\n    content: \"\\ec5d\";\n  }\n  .bx-up-arrow-circle:before {\n    content: \"\\ec5e\";\n  }\n  .bx-upload:before {\n    content: \"\\ec5f\";\n  }\n  .bx-upside-down:before {\n    content: \"\\ec60\";\n  }\n  .bx-upvote:before {\n    content: \"\\ec61\";\n  }\n  .bx-usb:before {\n    content: \"\\ec62\";\n  }\n  .bx-user:before {\n    content: \"\\ec63\";\n  }\n  .bx-user-check:before {\n    content: \"\\ec64\";\n  }\n  .bx-user-circle:before {\n    content: \"\\ec65\";\n  }\n  .bx-user-minus:before {\n    content: \"\\ec66\";\n  }\n  .bx-user-pin:before {\n    content: \"\\ec67\";\n  }\n  .bx-user-plus:before {\n    content: \"\\ec68\";\n  }\n  .bx-user-voice:before {\n    content: \"\\ec69\";\n  }\n  .bx-user-x:before {\n    content: \"\\ec6a\";\n  }\n  .bx-vector:before {\n    content: \"\\ec6b\";\n  }\n  .bx-vertical-center:before {\n    content: \"\\ec6c\";\n  }\n  .bx-vial:before {\n    content: \"\\ec6d\";\n  }\n  .bx-video:before {\n    content: \"\\ec6e\";\n  }\n  .bx-video-off:before {\n    content: \"\\ec6f\";\n  }\n  .bx-video-plus:before {\n    content: \"\\ec70\";\n  }\n  .bx-video-recording:before {\n    content: \"\\ec71\";\n  }\n  .bx-voicemail:before {\n    content: \"\\ec72\";\n  }\n  .bx-volume:before {\n    content: \"\\ec73\";\n  }\n  .bx-volume-full:before {\n    content: \"\\ec74\";\n  }\n  .bx-volume-low:before {\n    content: \"\\ec75\";\n  }\n  .bx-volume-mute:before {\n    content: \"\\ec76\";\n  }\n  .bx-walk:before {\n    content: \"\\ec77\";\n  }\n  .bx-wallet:before {\n    content: \"\\ec78\";\n  }\n  .bx-wallet-alt:before {\n    content: \"\\ec79\";\n  }\n  .bx-water:before {\n    content: \"\\ec7a\";\n  }\n  .bx-webcam:before {\n    content: \"\\ec7b\";\n  }\n  .bx-wifi:before {\n    content: \"\\ec7c\";\n  }\n  .bx-wifi-0:before {\n    content: \"\\ec7d\";\n  }\n  .bx-wifi-1:before {\n    content: \"\\ec7e\";\n  }\n  .bx-wifi-2:before {\n    content: \"\\ec7f\";\n  }\n  .bx-wifi-off:before {\n    content: \"\\ec80\";\n  }\n  .bx-wind:before {\n    content: \"\\ec81\";\n  }\n  .bx-window:before {\n    content: \"\\ec82\";\n  }\n  .bx-window-alt:before {\n    content: \"\\ec83\";\n  }\n  .bx-window-close:before {\n    content: \"\\ec84\";\n  }\n  .bx-window-open:before {\n    content: \"\\ec85\";\n  }\n  .bx-windows:before {\n    content: \"\\ec86\";\n  }\n  .bx-wine:before {\n    content: \"\\ec87\";\n  }\n  .bx-wink-smile:before {\n    content: \"\\ec88\";\n  }\n  .bx-wink-tongue:before {\n    content: \"\\ec89\";\n  }\n  .bx-won:before {\n    content: \"\\ec8a\";\n  }\n  .bx-world:before {\n    content: \"\\ec8b\";\n  }\n  .bx-wrench:before {\n    content: \"\\ec8c\";\n  }\n  .bx-x:before {\n    content: \"\\ec8d\";\n  }\n  .bx-x-circle:before {\n    content: \"\\ec8e\";\n  }\n  .bx-yen:before {\n    content: \"\\ec8f\";\n  }\n  .bx-zoom-in:before {\n    content: \"\\ec90\";\n  }\n  .bx-zoom-out:before {\n    content: \"\\ec91\";\n  }\n  .bxs-party:before {\n    content: \"\\ec92\";\n  }\n  .bxs-hot:before {\n    content: \"\\ec93\";\n  }\n  .bxs-droplet:before {\n    content: \"\\ec94\";\n  }\n  .bxs-cat:before {\n    content: \"\\ec95\";\n  }\n  .bxs-dog:before {\n    content: \"\\ec96\";\n  }\n  .bxs-injection:before {\n    content: \"\\ec97\";\n  }\n  .bxs-leaf:before {\n    content: \"\\ec98\";\n  }\n  .bxs-add-to-queue:before {\n    content: \"\\ec99\";\n  }\n  .bxs-adjust:before {\n    content: \"\\ec9a\";\n  }\n  .bxs-adjust-alt:before {\n    content: \"\\ec9b\";\n  }\n  .bxs-alarm:before {\n    content: \"\\ec9c\";\n  }\n  .bxs-alarm-add:before {\n    content: \"\\ec9d\";\n  }\n  .bxs-alarm-exclamation:before {\n    content: \"\\ec9e\";\n  }\n  .bxs-alarm-off:before {\n    content: \"\\ec9f\";\n  }\n  .bxs-alarm-snooze:before {\n    content: \"\\eca0\";\n  }\n  .bxs-album:before {\n    content: \"\\eca1\";\n  }\n  .bxs-ambulance:before {\n    content: \"\\eca2\";\n  }\n  .bxs-analyse:before {\n    content: \"\\eca3\";\n  }\n  .bxs-angry:before {\n    content: \"\\eca4\";\n  }\n  .bxs-arch:before {\n    content: \"\\eca5\";\n  }\n  .bxs-archive:before {\n    content: \"\\eca6\";\n  }\n  .bxs-archive-in:before {\n    content: \"\\eca7\";\n  }\n  .bxs-archive-out:before {\n    content: \"\\eca8\";\n  }\n  .bxs-area:before {\n    content: \"\\eca9\";\n  }\n  .bxs-arrow-from-bottom:before {\n    content: \"\\ecaa\";\n  }\n  .bxs-arrow-from-left:before {\n    content: \"\\ecab\";\n  }\n  .bxs-arrow-from-right:before {\n    content: \"\\ecac\";\n  }\n  .bxs-arrow-from-top:before {\n    content: \"\\ecad\";\n  }\n  .bxs-arrow-to-bottom:before {\n    content: \"\\ecae\";\n  }\n  .bxs-arrow-to-left:before {\n    content: \"\\ecaf\";\n  }\n  .bxs-arrow-to-right:before {\n    content: \"\\ecb0\";\n  }\n  .bxs-arrow-to-top:before {\n    content: \"\\ecb1\";\n  }\n  .bxs-award:before {\n    content: \"\\ecb2\";\n  }\n  .bxs-baby-carriage:before {\n    content: \"\\ecb3\";\n  }\n  .bxs-backpack:before {\n    content: \"\\ecb4\";\n  }\n  .bxs-badge:before {\n    content: \"\\ecb5\";\n  }\n  .bxs-badge-check:before {\n    content: \"\\ecb6\";\n  }\n  .bxs-badge-dollar:before {\n    content: \"\\ecb7\";\n  }\n  .bxs-ball:before {\n    content: \"\\ecb8\";\n  }\n  .bxs-band-aid:before {\n    content: \"\\ecb9\";\n  }\n  .bxs-bank:before {\n    content: \"\\ecba\";\n  }\n  .bxs-bar-chart-alt-2:before {\n    content: \"\\ecbb\";\n  }\n  .bxs-bar-chart-square:before {\n    content: \"\\ecbc\";\n  }\n  .bxs-barcode:before {\n    content: \"\\ecbd\";\n  }\n  .bxs-baseball:before {\n    content: \"\\ecbe\";\n  }\n  .bxs-basket:before {\n    content: \"\\ecbf\";\n  }\n  .bxs-basketball:before {\n    content: \"\\ecc0\";\n  }\n  .bxs-bath:before {\n    content: \"\\ecc1\";\n  }\n  .bxs-battery:before {\n    content: \"\\ecc2\";\n  }\n  .bxs-battery-charging:before {\n    content: \"\\ecc3\";\n  }\n  .bxs-battery-full:before {\n    content: \"\\ecc4\";\n  }\n  .bxs-battery-low:before {\n    content: \"\\ecc5\";\n  }\n  .bxs-bed:before {\n    content: \"\\ecc6\";\n  }\n  .bxs-been-here:before {\n    content: \"\\ecc7\";\n  }\n  .bxs-beer:before {\n    content: \"\\ecc8\";\n  }\n  .bxs-bell:before {\n    content: \"\\ecc9\";\n  }\n  .bxs-bell-minus:before {\n    content: \"\\ecca\";\n  }\n  .bxs-bell-off:before {\n    content: \"\\eccb\";\n  }\n  .bxs-bell-plus:before {\n    content: \"\\eccc\";\n  }\n  .bxs-bell-ring:before {\n    content: \"\\eccd\";\n  }\n  .bxs-bible:before {\n    content: \"\\ecce\";\n  }\n  .bxs-binoculars:before {\n    content: \"\\eccf\";\n  }\n  .bxs-blanket:before {\n    content: \"\\ecd0\";\n  }\n  .bxs-bolt:before {\n    content: \"\\ecd1\";\n  }\n  .bxs-bolt-circle:before {\n    content: \"\\ecd2\";\n  }\n  .bxs-bomb:before {\n    content: \"\\ecd3\";\n  }\n  .bxs-bone:before {\n    content: \"\\ecd4\";\n  }\n  .bxs-bong:before {\n    content: \"\\ecd5\";\n  }\n  .bxs-book:before {\n    content: \"\\ecd6\";\n  }\n  .bxs-book-add:before {\n    content: \"\\ecd7\";\n  }\n  .bxs-book-alt:before {\n    content: \"\\ecd8\";\n  }\n  .bxs-book-bookmark:before {\n    content: \"\\ecd9\";\n  }\n  .bxs-book-content:before {\n    content: \"\\ecda\";\n  }\n  .bxs-book-heart:before {\n    content: \"\\ecdb\";\n  }\n  .bxs-bookmark:before {\n    content: \"\\ecdc\";\n  }\n  .bxs-bookmark-alt:before {\n    content: \"\\ecdd\";\n  }\n  .bxs-bookmark-alt-minus:before {\n    content: \"\\ecde\";\n  }\n  .bxs-bookmark-alt-plus:before {\n    content: \"\\ecdf\";\n  }\n  .bxs-bookmark-heart:before {\n    content: \"\\ece0\";\n  }\n  .bxs-bookmark-minus:before {\n    content: \"\\ece1\";\n  }\n  .bxs-bookmark-plus:before {\n    content: \"\\ece2\";\n  }\n  .bxs-bookmarks:before {\n    content: \"\\ece3\";\n  }\n  .bxs-bookmark-star:before {\n    content: \"\\ece4\";\n  }\n  .bxs-book-open:before {\n    content: \"\\ece5\";\n  }\n  .bxs-book-reader:before {\n    content: \"\\ece6\";\n  }\n  .bxs-bot:before {\n    content: \"\\ece7\";\n  }\n  .bxs-bowling-ball:before {\n    content: \"\\ece8\";\n  }\n  .bxs-box:before {\n    content: \"\\ece9\";\n  }\n  .bxs-brain:before {\n    content: \"\\ecea\";\n  }\n  .bxs-briefcase:before {\n    content: \"\\eceb\";\n  }\n  .bxs-briefcase-alt:before {\n    content: \"\\ecec\";\n  }\n  .bxs-briefcase-alt-2:before {\n    content: \"\\eced\";\n  }\n  .bxs-brightness:before {\n    content: \"\\ecee\";\n  }\n  .bxs-brightness-half:before {\n    content: \"\\ecef\";\n  }\n  .bxs-brush:before {\n    content: \"\\ecf0\";\n  }\n  .bxs-brush-alt:before {\n    content: \"\\ecf1\";\n  }\n  .bxs-bug:before {\n    content: \"\\ecf2\";\n  }\n  .bxs-bug-alt:before {\n    content: \"\\ecf3\";\n  }\n  .bxs-building:before {\n    content: \"\\ecf4\";\n  }\n  .bxs-building-house:before {\n    content: \"\\ecf5\";\n  }\n  .bxs-buildings:before {\n    content: \"\\ecf6\";\n  }\n  .bxs-bulb:before {\n    content: \"\\ecf7\";\n  }\n  .bxs-bullseye:before {\n    content: \"\\ecf8\";\n  }\n  .bxs-buoy:before {\n    content: \"\\ecf9\";\n  }\n  .bxs-bus:before {\n    content: \"\\ecfa\";\n  }\n  .bxs-business:before {\n    content: \"\\ecfb\";\n  }\n  .bxs-bus-school:before {\n    content: \"\\ecfc\";\n  }\n  .bxs-cabinet:before {\n    content: \"\\ecfd\";\n  }\n  .bxs-cake:before {\n    content: \"\\ecfe\";\n  }\n  .bxs-calculator:before {\n    content: \"\\ecff\";\n  }\n  .bxs-calendar:before {\n    content: \"\\ed00\";\n  }\n  .bxs-calendar-alt:before {\n    content: \"\\ed01\";\n  }\n  .bxs-calendar-check:before {\n    content: \"\\ed02\";\n  }\n  .bxs-calendar-edit:before {\n    content: \"\\ed03\";\n  }\n  .bxs-calendar-event:before {\n    content: \"\\ed04\";\n  }\n  .bxs-calendar-exclamation:before {\n    content: \"\\ed05\";\n  }\n  .bxs-calendar-heart:before {\n    content: \"\\ed06\";\n  }\n  .bxs-calendar-minus:before {\n    content: \"\\ed07\";\n  }\n  .bxs-calendar-plus:before {\n    content: \"\\ed08\";\n  }\n  .bxs-calendar-star:before {\n    content: \"\\ed09\";\n  }\n  .bxs-calendar-week:before {\n    content: \"\\ed0a\";\n  }\n  .bxs-calendar-x:before {\n    content: \"\\ed0b\";\n  }\n  .bxs-camera:before {\n    content: \"\\ed0c\";\n  }\n  .bxs-camera-home:before {\n    content: \"\\ed0d\";\n  }\n  .bxs-camera-movie:before {\n    content: \"\\ed0e\";\n  }\n  .bxs-camera-off:before {\n    content: \"\\ed0f\";\n  }\n  .bxs-camera-plus:before {\n    content: \"\\ed10\";\n  }\n  .bxs-capsule:before {\n    content: \"\\ed11\";\n  }\n  .bxs-captions:before {\n    content: \"\\ed12\";\n  }\n  .bxs-car:before {\n    content: \"\\ed13\";\n  }\n  .bxs-car-battery:before {\n    content: \"\\ed14\";\n  }\n  .bxs-car-crash:before {\n    content: \"\\ed15\";\n  }\n  .bxs-card:before {\n    content: \"\\ed16\";\n  }\n  .bxs-caret-down-circle:before {\n    content: \"\\ed17\";\n  }\n  .bxs-caret-down-square:before {\n    content: \"\\ed18\";\n  }\n  .bxs-caret-left-circle:before {\n    content: \"\\ed19\";\n  }\n  .bxs-caret-left-square:before {\n    content: \"\\ed1a\";\n  }\n  .bxs-caret-right-circle:before {\n    content: \"\\ed1b\";\n  }\n  .bxs-caret-right-square:before {\n    content: \"\\ed1c\";\n  }\n  .bxs-caret-up-circle:before {\n    content: \"\\ed1d\";\n  }\n  .bxs-caret-up-square:before {\n    content: \"\\ed1e\";\n  }\n  .bxs-car-garage:before {\n    content: \"\\ed1f\";\n  }\n  .bxs-car-mechanic:before {\n    content: \"\\ed20\";\n  }\n  .bxs-carousel:before {\n    content: \"\\ed21\";\n  }\n  .bxs-cart:before {\n    content: \"\\ed22\";\n  }\n  .bxs-cart-add:before {\n    content: \"\\ed23\";\n  }\n  .bxs-cart-alt:before {\n    content: \"\\ed24\";\n  }\n  .bxs-cart-download:before {\n    content: \"\\ed25\";\n  }\n  .bxs-car-wash:before {\n    content: \"\\ed26\";\n  }\n  .bxs-category:before {\n    content: \"\\ed27\";\n  }\n  .bxs-category-alt:before {\n    content: \"\\ed28\";\n  }\n  .bxs-cctv:before {\n    content: \"\\ed29\";\n  }\n  .bxs-certification:before {\n    content: \"\\ed2a\";\n  }\n  .bxs-chalkboard:before {\n    content: \"\\ed2b\";\n  }\n  .bxs-chart:before {\n    content: \"\\ed2c\";\n  }\n  .bxs-chat:before {\n    content: \"\\ed2d\";\n  }\n  .bxs-checkbox:before {\n    content: \"\\ed2e\";\n  }\n  .bxs-checkbox-checked:before {\n    content: \"\\ed2f\";\n  }\n  .bxs-checkbox-minus:before {\n    content: \"\\ed30\";\n  }\n  .bxs-check-circle:before {\n    content: \"\\ed31\";\n  }\n  .bxs-check-shield:before {\n    content: \"\\ed32\";\n  }\n  .bxs-check-square:before {\n    content: \"\\ed33\";\n  }\n  .bxs-chess:before {\n    content: \"\\ed34\";\n  }\n  .bxs-chevron-down:before {\n    content: \"\\ed35\";\n  }\n  .bxs-chevron-down-circle:before {\n    content: \"\\ed36\";\n  }\n  .bxs-chevron-down-square:before {\n    content: \"\\ed37\";\n  }\n  .bxs-chevron-left:before {\n    content: \"\\ed38\";\n  }\n  .bxs-chevron-left-circle:before {\n    content: \"\\ed39\";\n  }\n  .bxs-chevron-left-square:before {\n    content: \"\\ed3a\";\n  }\n  .bxs-chevron-right:before {\n    content: \"\\ed3b\";\n  }\n  .bxs-chevron-right-circle:before {\n    content: \"\\ed3c\";\n  }\n  .bxs-chevron-right-square:before {\n    content: \"\\ed3d\";\n  }\n  .bxs-chevrons-down:before {\n    content: \"\\ed3e\";\n  }\n  .bxs-chevrons-left:before {\n    content: \"\\ed3f\";\n  }\n  .bxs-chevrons-right:before {\n    content: \"\\ed40\";\n  }\n  .bxs-chevrons-up:before {\n    content: \"\\ed41\";\n  }\n  .bxs-chevron-up:before {\n    content: \"\\ed42\";\n  }\n  .bxs-chevron-up-circle:before {\n    content: \"\\ed43\";\n  }\n  .bxs-chevron-up-square:before {\n    content: \"\\ed44\";\n  }\n  .bxs-chip:before {\n    content: \"\\ed45\";\n  }\n  .bxs-church:before {\n    content: \"\\ed46\";\n  }\n  .bxs-circle:before {\n    content: \"\\ed47\";\n  }\n  .bxs-city:before {\n    content: \"\\ed48\";\n  }\n  .bxs-clinic:before {\n    content: \"\\ed49\";\n  }\n  .bxs-cloud:before {\n    content: \"\\ed4a\";\n  }\n  .bxs-cloud-download:before {\n    content: \"\\ed4b\";\n  }\n  .bxs-cloud-lightning:before {\n    content: \"\\ed4c\";\n  }\n  .bxs-cloud-rain:before {\n    content: \"\\ed4d\";\n  }\n  .bxs-cloud-upload:before {\n    content: \"\\ed4e\";\n  }\n  .bxs-coffee:before {\n    content: \"\\ed4f\";\n  }\n  .bxs-coffee-alt:before {\n    content: \"\\ed50\";\n  }\n  .bxs-coffee-togo:before {\n    content: \"\\ed51\";\n  }\n  .bxs-cog:before {\n    content: \"\\ed52\";\n  }\n  .bxs-coin:before {\n    content: \"\\ed53\";\n  }\n  .bxs-coin-stack:before {\n    content: \"\\ed54\";\n  }\n  .bxs-collection:before {\n    content: \"\\ed55\";\n  }\n  .bxs-color-fill:before {\n    content: \"\\ed56\";\n  }\n  .bxs-comment:before {\n    content: \"\\ed57\";\n  }\n  .bxs-comment-add:before {\n    content: \"\\ed58\";\n  }\n  .bxs-comment-check:before {\n    content: \"\\ed59\";\n  }\n  .bxs-comment-detail:before {\n    content: \"\\ed5a\";\n  }\n  .bxs-comment-dots:before {\n    content: \"\\ed5b\";\n  }\n  .bxs-comment-edit:before {\n    content: \"\\ed5c\";\n  }\n  .bxs-comment-error:before {\n    content: \"\\ed5d\";\n  }\n  .bxs-comment-minus:before {\n    content: \"\\ed5e\";\n  }\n  .bxs-comment-x:before {\n    content: \"\\ed5f\";\n  }\n  .bxs-compass:before {\n    content: \"\\ed60\";\n  }\n  .bxs-component:before {\n    content: \"\\ed61\";\n  }\n  .bxs-confused:before {\n    content: \"\\ed62\";\n  }\n  .bxs-contact:before {\n    content: \"\\ed63\";\n  }\n  .bxs-conversation:before {\n    content: \"\\ed64\";\n  }\n  .bxs-cookie:before {\n    content: \"\\ed65\";\n  }\n  .bxs-cool:before {\n    content: \"\\ed66\";\n  }\n  .bxs-copy:before {\n    content: \"\\ed67\";\n  }\n  .bxs-copy-alt:before {\n    content: \"\\ed68\";\n  }\n  .bxs-copyright:before {\n    content: \"\\ed69\";\n  }\n  .bxs-coupon:before {\n    content: \"\\ed6a\";\n  }\n  .bxs-credit-card:before {\n    content: \"\\ed6b\";\n  }\n  .bxs-credit-card-alt:before {\n    content: \"\\ed6c\";\n  }\n  .bxs-credit-card-front:before {\n    content: \"\\ed6d\";\n  }\n  .bxs-crop:before {\n    content: \"\\ed6e\";\n  }\n  .bxs-crown:before {\n    content: \"\\ed6f\";\n  }\n  .bxs-cube:before {\n    content: \"\\ed70\";\n  }\n  .bxs-cube-alt:before {\n    content: \"\\ed71\";\n  }\n  .bxs-cuboid:before {\n    content: \"\\ed72\";\n  }\n  .bxs-customize:before {\n    content: \"\\ed73\";\n  }\n  .bxs-cylinder:before {\n    content: \"\\ed74\";\n  }\n  .bxs-dashboard:before {\n    content: \"\\ed75\";\n  }\n  .bxs-data:before {\n    content: \"\\ed76\";\n  }\n  .bxs-detail:before {\n    content: \"\\ed77\";\n  }\n  .bxs-devices:before {\n    content: \"\\ed78\";\n  }\n  .bxs-diamond:before {\n    content: \"\\ed79\";\n  }\n  .bxs-dice-1:before {\n    content: \"\\ed7a\";\n  }\n  .bxs-dice-2:before {\n    content: \"\\ed7b\";\n  }\n  .bxs-dice-3:before {\n    content: \"\\ed7c\";\n  }\n  .bxs-dice-4:before {\n    content: \"\\ed7d\";\n  }\n  .bxs-dice-5:before {\n    content: \"\\ed7e\";\n  }\n  .bxs-dice-6:before {\n    content: \"\\ed7f\";\n  }\n  .bxs-direction-left:before {\n    content: \"\\ed80\";\n  }\n  .bxs-direction-right:before {\n    content: \"\\ed81\";\n  }\n  .bxs-directions:before {\n    content: \"\\ed82\";\n  }\n  .bxs-disc:before {\n    content: \"\\ed83\";\n  }\n  .bxs-discount:before {\n    content: \"\\ed84\";\n  }\n  .bxs-dish:before {\n    content: \"\\ed85\";\n  }\n  .bxs-dislike:before {\n    content: \"\\ed86\";\n  }\n  .bxs-dizzy:before {\n    content: \"\\ed87\";\n  }\n  .bxs-dock-bottom:before {\n    content: \"\\ed88\";\n  }\n  .bxs-dock-left:before {\n    content: \"\\ed89\";\n  }\n  .bxs-dock-right:before {\n    content: \"\\ed8a\";\n  }\n  .bxs-dock-top:before {\n    content: \"\\ed8b\";\n  }\n  .bxs-dollar-circle:before {\n    content: \"\\ed8c\";\n  }\n  .bxs-donate-blood:before {\n    content: \"\\ed8d\";\n  }\n  .bxs-donate-heart:before {\n    content: \"\\ed8e\";\n  }\n  .bxs-door-open:before {\n    content: \"\\ed8f\";\n  }\n  .bxs-doughnut-chart:before {\n    content: \"\\ed90\";\n  }\n  .bxs-down-arrow:before {\n    content: \"\\ed91\";\n  }\n  .bxs-down-arrow-alt:before {\n    content: \"\\ed92\";\n  }\n  .bxs-down-arrow-circle:before {\n    content: \"\\ed93\";\n  }\n  .bxs-down-arrow-square:before {\n    content: \"\\ed94\";\n  }\n  .bxs-download:before {\n    content: \"\\ed95\";\n  }\n  .bxs-downvote:before {\n    content: \"\\ed96\";\n  }\n  .bxs-drink:before {\n    content: \"\\ed97\";\n  }\n  .bxs-droplet-half:before {\n    content: \"\\ed98\";\n  }\n  .bxs-dryer:before {\n    content: \"\\ed99\";\n  }\n  .bxs-duplicate:before {\n    content: \"\\ed9a\";\n  }\n  .bxs-edit:before {\n    content: \"\\ed9b\";\n  }\n  .bxs-edit-alt:before {\n    content: \"\\ed9c\";\n  }\n  .bxs-edit-location:before {\n    content: \"\\ed9d\";\n  }\n  .bxs-eject:before {\n    content: \"\\ed9e\";\n  }\n  .bxs-envelope:before {\n    content: \"\\ed9f\";\n  }\n  .bxs-envelope-open:before {\n    content: \"\\eda0\";\n  }\n  .bxs-eraser:before {\n    content: \"\\eda1\";\n  }\n  .bxs-error:before {\n    content: \"\\eda2\";\n  }\n  .bxs-error-alt:before {\n    content: \"\\eda3\";\n  }\n  .bxs-error-circle:before {\n    content: \"\\eda4\";\n  }\n  .bxs-ev-station:before {\n    content: \"\\eda5\";\n  }\n  .bxs-exit:before {\n    content: \"\\eda6\";\n  }\n  .bxs-extension:before {\n    content: \"\\eda7\";\n  }\n  .bxs-eyedropper:before {\n    content: \"\\eda8\";\n  }\n  .bxs-face:before {\n    content: \"\\eda9\";\n  }\n  .bxs-face-mask:before {\n    content: \"\\edaa\";\n  }\n  .bxs-factory:before {\n    content: \"\\edab\";\n  }\n  .bxs-fast-forward-circle:before {\n    content: \"\\edac\";\n  }\n  .bxs-file:before {\n    content: \"\\edad\";\n  }\n  .bxs-file-archive:before {\n    content: \"\\edae\";\n  }\n  .bxs-file-blank:before {\n    content: \"\\edaf\";\n  }\n  .bxs-file-css:before {\n    content: \"\\edb0\";\n  }\n  .bxs-file-doc:before {\n    content: \"\\edb1\";\n  }\n  .bxs-file-export:before {\n    content: \"\\edb2\";\n  }\n  .bxs-file-find:before {\n    content: \"\\edb3\";\n  }\n  .bxs-file-gif:before {\n    content: \"\\edb4\";\n  }\n  .bxs-file-html:before {\n    content: \"\\edb5\";\n  }\n  .bxs-file-image:before {\n    content: \"\\edb6\";\n  }\n  .bxs-file-import:before {\n    content: \"\\edb7\";\n  }\n  .bxs-file-jpg:before {\n    content: \"\\edb8\";\n  }\n  .bxs-file-js:before {\n    content: \"\\edb9\";\n  }\n  .bxs-file-json:before {\n    content: \"\\edba\";\n  }\n  .bxs-file-md:before {\n    content: \"\\edbb\";\n  }\n  .bxs-file-pdf:before {\n    content: \"\\edbc\";\n  }\n  .bxs-file-plus:before {\n    content: \"\\edbd\";\n  }\n  .bxs-file-png:before {\n    content: \"\\edbe\";\n  }\n  .bxs-file-txt:before {\n    content: \"\\edbf\";\n  }\n  .bxs-film:before {\n    content: \"\\edc0\";\n  }\n  .bxs-filter-alt:before {\n    content: \"\\edc1\";\n  }\n  .bxs-first-aid:before {\n    content: \"\\edc2\";\n  }\n  .bxs-flag:before {\n    content: \"\\edc3\";\n  }\n  .bxs-flag-alt:before {\n    content: \"\\edc4\";\n  }\n  .bxs-flag-checkered:before {\n    content: \"\\edc5\";\n  }\n  .bxs-flame:before {\n    content: \"\\edc6\";\n  }\n  .bxs-flask:before {\n    content: \"\\edc7\";\n  }\n  .bxs-florist:before {\n    content: \"\\edc8\";\n  }\n  .bxs-folder:before {\n    content: \"\\edc9\";\n  }\n  .bxs-folder-minus:before {\n    content: \"\\edca\";\n  }\n  .bxs-folder-open:before {\n    content: \"\\edcb\";\n  }\n  .bxs-folder-plus:before {\n    content: \"\\edcc\";\n  }\n  .bxs-food-menu:before {\n    content: \"\\edcd\";\n  }\n  .bxs-fridge:before {\n    content: \"\\edce\";\n  }\n  .bxs-game:before {\n    content: \"\\edcf\";\n  }\n  .bxs-gas-pump:before {\n    content: \"\\edd0\";\n  }\n  .bxs-ghost:before {\n    content: \"\\edd1\";\n  }\n  .bxs-gift:before {\n    content: \"\\edd2\";\n  }\n  .bxs-graduation:before {\n    content: \"\\edd3\";\n  }\n  .bxs-grid:before {\n    content: \"\\edd4\";\n  }\n  .bxs-grid-alt:before {\n    content: \"\\edd5\";\n  }\n  .bxs-group:before {\n    content: \"\\edd6\";\n  }\n  .bxs-guitar-amp:before {\n    content: \"\\edd7\";\n  }\n  .bxs-hand:before {\n    content: \"\\edd8\";\n  }\n  .bxs-hand-down:before {\n    content: \"\\edd9\";\n  }\n  .bxs-hand-left:before {\n    content: \"\\edda\";\n  }\n  .bxs-hand-right:before {\n    content: \"\\eddb\";\n  }\n  .bxs-hand-up:before {\n    content: \"\\eddc\";\n  }\n  .bxs-happy:before {\n    content: \"\\eddd\";\n  }\n  .bxs-happy-alt:before {\n    content: \"\\edde\";\n  }\n  .bxs-happy-beaming:before {\n    content: \"\\eddf\";\n  }\n  .bxs-happy-heart-eyes:before {\n    content: \"\\ede0\";\n  }\n  .bxs-hdd:before {\n    content: \"\\ede1\";\n  }\n  .bxs-heart:before {\n    content: \"\\ede2\";\n  }\n  .bxs-heart-circle:before {\n    content: \"\\ede3\";\n  }\n  .bxs-heart-square:before {\n    content: \"\\ede4\";\n  }\n  .bxs-help-circle:before {\n    content: \"\\ede5\";\n  }\n  .bxs-hide:before {\n    content: \"\\ede6\";\n  }\n  .bxs-home:before {\n    content: \"\\ede7\";\n  }\n  .bxs-home-circle:before {\n    content: \"\\ede8\";\n  }\n  .bxs-home-heart:before {\n    content: \"\\ede9\";\n  }\n  .bxs-home-smile:before {\n    content: \"\\edea\";\n  }\n  .bxs-hotel:before {\n    content: \"\\edeb\";\n  }\n  .bxs-hourglass:before {\n    content: \"\\edec\";\n  }\n  .bxs-hourglass-bottom:before {\n    content: \"\\eded\";\n  }\n  .bxs-hourglass-top:before {\n    content: \"\\edee\";\n  }\n  .bxs-id-card:before {\n    content: \"\\edef\";\n  }\n  .bxs-image:before {\n    content: \"\\edf0\";\n  }\n  .bxs-image-add:before {\n    content: \"\\edf1\";\n  }\n  .bxs-image-alt:before {\n    content: \"\\edf2\";\n  }\n  .bxs-inbox:before {\n    content: \"\\edf3\";\n  }\n  .bxs-info-circle:before {\n    content: \"\\edf4\";\n  }\n  .bxs-info-square:before {\n    content: \"\\edf5\";\n  }\n  .bxs-institution:before {\n    content: \"\\edf6\";\n  }\n  .bxs-joystick:before {\n    content: \"\\edf7\";\n  }\n  .bxs-joystick-alt:before {\n    content: \"\\edf8\";\n  }\n  .bxs-joystick-button:before {\n    content: \"\\edf9\";\n  }\n  .bxs-key:before {\n    content: \"\\edfa\";\n  }\n  .bxs-keyboard:before {\n    content: \"\\edfb\";\n  }\n  .bxs-label:before {\n    content: \"\\edfc\";\n  }\n  .bxs-landmark:before {\n    content: \"\\edfd\";\n  }\n  .bxs-landscape:before {\n    content: \"\\edfe\";\n  }\n  .bxs-laugh:before {\n    content: \"\\edff\";\n  }\n  .bxs-layer:before {\n    content: \"\\ee00\";\n  }\n  .bxs-layer-minus:before {\n    content: \"\\ee01\";\n  }\n  .bxs-layer-plus:before {\n    content: \"\\ee02\";\n  }\n  .bxs-layout:before {\n    content: \"\\ee03\";\n  }\n  .bxs-left-arrow:before {\n    content: \"\\ee04\";\n  }\n  .bxs-left-arrow-alt:before {\n    content: \"\\ee05\";\n  }\n  .bxs-left-arrow-circle:before {\n    content: \"\\ee06\";\n  }\n  .bxs-left-arrow-square:before {\n    content: \"\\ee07\";\n  }\n  .bxs-left-down-arrow-circle:before {\n    content: \"\\ee08\";\n  }\n  .bxs-left-top-arrow-circle:before {\n    content: \"\\ee09\";\n  }\n  .bxs-like:before {\n    content: \"\\ee0a\";\n  }\n  .bxs-location-plus:before {\n    content: \"\\ee0b\";\n  }\n  .bxs-lock:before {\n    content: \"\\ee0c\";\n  }\n  .bxs-lock-alt:before {\n    content: \"\\ee0d\";\n  }\n  .bxs-lock-open:before {\n    content: \"\\ee0e\";\n  }\n  .bxs-lock-open-alt:before {\n    content: \"\\ee0f\";\n  }\n  .bxs-log-in:before {\n    content: \"\\ee10\";\n  }\n  .bxs-log-in-circle:before {\n    content: \"\\ee11\";\n  }\n  .bxs-log-out:before {\n    content: \"\\ee12\";\n  }\n  .bxs-log-out-circle:before {\n    content: \"\\ee13\";\n  }\n  .bxs-low-vision:before {\n    content: \"\\ee14\";\n  }\n  .bxs-magic-wand:before {\n    content: \"\\ee15\";\n  }\n  .bxs-magnet:before {\n    content: \"\\ee16\";\n  }\n  .bxs-map:before {\n    content: \"\\ee17\";\n  }\n  .bxs-map-alt:before {\n    content: \"\\ee18\";\n  }\n  .bxs-map-pin:before {\n    content: \"\\ee19\";\n  }\n  .bxs-mask:before {\n    content: \"\\ee1a\";\n  }\n  .bxs-medal:before {\n    content: \"\\ee1b\";\n  }\n  .bxs-megaphone:before {\n    content: \"\\ee1c\";\n  }\n  .bxs-meh:before {\n    content: \"\\ee1d\";\n  }\n  .bxs-meh-alt:before {\n    content: \"\\ee1e\";\n  }\n  .bxs-meh-blank:before {\n    content: \"\\ee1f\";\n  }\n  .bxs-memory-card:before {\n    content: \"\\ee20\";\n  }\n  .bxs-message:before {\n    content: \"\\ee21\";\n  }\n  .bxs-message-add:before {\n    content: \"\\ee22\";\n  }\n  .bxs-message-alt:before {\n    content: \"\\ee23\";\n  }\n  .bxs-message-alt-add:before {\n    content: \"\\ee24\";\n  }\n  .bxs-message-alt-check:before {\n    content: \"\\ee25\";\n  }\n  .bxs-message-alt-detail:before {\n    content: \"\\ee26\";\n  }\n  .bxs-message-alt-dots:before {\n    content: \"\\ee27\";\n  }\n  .bxs-message-alt-edit:before {\n    content: \"\\ee28\";\n  }\n  .bxs-message-alt-error:before {\n    content: \"\\ee29\";\n  }\n  .bxs-message-alt-minus:before {\n    content: \"\\ee2a\";\n  }\n  .bxs-message-alt-x:before {\n    content: \"\\ee2b\";\n  }\n  .bxs-message-check:before {\n    content: \"\\ee2c\";\n  }\n  .bxs-message-detail:before {\n    content: \"\\ee2d\";\n  }\n  .bxs-message-dots:before {\n    content: \"\\ee2e\";\n  }\n  .bxs-message-edit:before {\n    content: \"\\ee2f\";\n  }\n  .bxs-message-error:before {\n    content: \"\\ee30\";\n  }\n  .bxs-message-minus:before {\n    content: \"\\ee31\";\n  }\n  .bxs-message-rounded:before {\n    content: \"\\ee32\";\n  }\n  .bxs-message-rounded-add:before {\n    content: \"\\ee33\";\n  }\n  .bxs-message-rounded-check:before {\n    content: \"\\ee34\";\n  }\n  .bxs-message-rounded-detail:before {\n    content: \"\\ee35\";\n  }\n  .bxs-message-rounded-dots:before {\n    content: \"\\ee36\";\n  }\n  .bxs-message-rounded-edit:before {\n    content: \"\\ee37\";\n  }\n  .bxs-message-rounded-error:before {\n    content: \"\\ee38\";\n  }\n  .bxs-message-rounded-minus:before {\n    content: \"\\ee39\";\n  }\n  .bxs-message-rounded-x:before {\n    content: \"\\ee3a\";\n  }\n  .bxs-message-square:before {\n    content: \"\\ee3b\";\n  }\n  .bxs-message-square-add:before {\n    content: \"\\ee3c\";\n  }\n  .bxs-message-square-check:before {\n    content: \"\\ee3d\";\n  }\n  .bxs-message-square-detail:before {\n    content: \"\\ee3e\";\n  }\n  .bxs-message-square-dots:before {\n    content: \"\\ee3f\";\n  }\n  .bxs-message-square-edit:before {\n    content: \"\\ee40\";\n  }\n  .bxs-message-square-error:before {\n    content: \"\\ee41\";\n  }\n  .bxs-message-square-minus:before {\n    content: \"\\ee42\";\n  }\n  .bxs-message-square-x:before {\n    content: \"\\ee43\";\n  }\n  .bxs-message-x:before {\n    content: \"\\ee44\";\n  }\n  .bxs-meteor:before {\n    content: \"\\ee45\";\n  }\n  .bxs-microchip:before {\n    content: \"\\ee46\";\n  }\n  .bxs-microphone:before {\n    content: \"\\ee47\";\n  }\n  .bxs-microphone-alt:before {\n    content: \"\\ee48\";\n  }\n  .bxs-microphone-off:before {\n    content: \"\\ee49\";\n  }\n  .bxs-minus-circle:before {\n    content: \"\\ee4a\";\n  }\n  .bxs-minus-square:before {\n    content: \"\\ee4b\";\n  }\n  .bxs-mobile:before {\n    content: \"\\ee4c\";\n  }\n  .bxs-mobile-vibration:before {\n    content: \"\\ee4d\";\n  }\n  .bxs-moon:before {\n    content: \"\\ee4e\";\n  }\n  .bxs-mouse:before {\n    content: \"\\ee4f\";\n  }\n  .bxs-mouse-alt:before {\n    content: \"\\ee50\";\n  }\n  .bxs-movie:before {\n    content: \"\\ee51\";\n  }\n  .bxs-movie-play:before {\n    content: \"\\ee52\";\n  }\n  .bxs-music:before {\n    content: \"\\ee53\";\n  }\n  .bxs-navigation:before {\n    content: \"\\ee54\";\n  }\n  .bxs-network-chart:before {\n    content: \"\\ee55\";\n  }\n  .bxs-news:before {\n    content: \"\\ee56\";\n  }\n  .bxs-no-entry:before {\n    content: \"\\ee57\";\n  }\n  .bxs-note:before {\n    content: \"\\ee58\";\n  }\n  .bxs-notepad:before {\n    content: \"\\ee59\";\n  }\n  .bxs-notification:before {\n    content: \"\\ee5a\";\n  }\n  .bxs-notification-off:before {\n    content: \"\\ee5b\";\n  }\n  .bxs-offer:before {\n    content: \"\\ee5c\";\n  }\n  .bxs-package:before {\n    content: \"\\ee5d\";\n  }\n  .bxs-paint:before {\n    content: \"\\ee5e\";\n  }\n  .bxs-paint-roll:before {\n    content: \"\\ee5f\";\n  }\n  .bxs-palette:before {\n    content: \"\\ee60\";\n  }\n  .bxs-paper-plane:before {\n    content: \"\\ee61\";\n  }\n  .bxs-parking:before {\n    content: \"\\ee62\";\n  }\n  .bxs-paste:before {\n    content: \"\\ee63\";\n  }\n  .bxs-pen:before {\n    content: \"\\ee64\";\n  }\n  .bxs-pencil:before {\n    content: \"\\ee65\";\n  }\n  .bxs-phone:before {\n    content: \"\\ee66\";\n  }\n  .bxs-phone-call:before {\n    content: \"\\ee67\";\n  }\n  .bxs-phone-incoming:before {\n    content: \"\\ee68\";\n  }\n  .bxs-phone-off:before {\n    content: \"\\ee69\";\n  }\n  .bxs-phone-outgoing:before {\n    content: \"\\ee6a\";\n  }\n  .bxs-photo-album:before {\n    content: \"\\ee6b\";\n  }\n  .bxs-piano:before {\n    content: \"\\ee6c\";\n  }\n  .bxs-pie-chart:before {\n    content: \"\\ee6d\";\n  }\n  .bxs-pie-chart-alt:before {\n    content: \"\\ee6e\";\n  }\n  .bxs-pie-chart-alt-2:before {\n    content: \"\\ee6f\";\n  }\n  .bxs-pin:before {\n    content: \"\\ee70\";\n  }\n  .bxs-pizza:before {\n    content: \"\\ee71\";\n  }\n  .bxs-plane:before {\n    content: \"\\ee72\";\n  }\n  .bxs-plane-alt:before {\n    content: \"\\ee73\";\n  }\n  .bxs-plane-land:before {\n    content: \"\\ee74\";\n  }\n  .bxs-planet:before {\n    content: \"\\ee75\";\n  }\n  .bxs-plane-take-off:before {\n    content: \"\\ee76\";\n  }\n  .bxs-playlist:before {\n    content: \"\\ee77\";\n  }\n  .bxs-plug:before {\n    content: \"\\ee78\";\n  }\n  .bxs-plus-circle:before {\n    content: \"\\ee79\";\n  }\n  .bxs-plus-square:before {\n    content: \"\\ee7a\";\n  }\n  .bxs-pointer:before {\n    content: \"\\ee7b\";\n  }\n  .bxs-polygon:before {\n    content: \"\\ee7c\";\n  }\n  .bxs-printer:before {\n    content: \"\\ee7d\";\n  }\n  .bxs-purchase-tag:before {\n    content: \"\\ee7e\";\n  }\n  .bxs-purchase-tag-alt:before {\n    content: \"\\ee7f\";\n  }\n  .bxs-pyramid:before {\n    content: \"\\ee80\";\n  }\n  .bxs-quote-alt-left:before {\n    content: \"\\ee81\";\n  }\n  .bxs-quote-alt-right:before {\n    content: \"\\ee82\";\n  }\n  .bxs-quote-left:before {\n    content: \"\\ee83\";\n  }\n  .bxs-quote-right:before {\n    content: \"\\ee84\";\n  }\n  .bxs-quote-single-left:before {\n    content: \"\\ee85\";\n  }\n  .bxs-quote-single-right:before {\n    content: \"\\ee86\";\n  }\n  .bxs-radiation:before {\n    content: \"\\ee87\";\n  }\n  .bxs-radio:before {\n    content: \"\\ee88\";\n  }\n  .bxs-receipt:before {\n    content: \"\\ee89\";\n  }\n  .bxs-rectangle:before {\n    content: \"\\ee8a\";\n  }\n  .bxs-registered:before {\n    content: \"\\ee8b\";\n  }\n  .bxs-rename:before {\n    content: \"\\ee8c\";\n  }\n  .bxs-report:before {\n    content: \"\\ee8d\";\n  }\n  .bxs-rewind-circle:before {\n    content: \"\\ee8e\";\n  }\n  .bxs-right-arrow:before {\n    content: \"\\ee8f\";\n  }\n  .bxs-right-arrow-alt:before {\n    content: \"\\ee90\";\n  }\n  .bxs-right-arrow-circle:before {\n    content: \"\\ee91\";\n  }\n  .bxs-right-arrow-square:before {\n    content: \"\\ee92\";\n  }\n  .bxs-right-down-arrow-circle:before {\n    content: \"\\ee93\";\n  }\n  .bxs-right-top-arrow-circle:before {\n    content: \"\\ee94\";\n  }\n  .bxs-rocket:before {\n    content: \"\\ee95\";\n  }\n  .bxs-ruler:before {\n    content: \"\\ee96\";\n  }\n  .bxs-sad:before {\n    content: \"\\ee97\";\n  }\n  .bxs-save:before {\n    content: \"\\ee98\";\n  }\n  .bxs-school:before {\n    content: \"\\ee99\";\n  }\n  .bxs-search:before {\n    content: \"\\ee9a\";\n  }\n  .bxs-search-alt-2:before {\n    content: \"\\ee9b\";\n  }\n  .bxs-select-multiple:before {\n    content: \"\\ee9c\";\n  }\n  .bxs-send:before {\n    content: \"\\ee9d\";\n  }\n  .bxs-server:before {\n    content: \"\\ee9e\";\n  }\n  .bxs-shapes:before {\n    content: \"\\ee9f\";\n  }\n  .bxs-share:before {\n    content: \"\\eea0\";\n  }\n  .bxs-share-alt:before {\n    content: \"\\eea1\";\n  }\n  .bxs-shield:before {\n    content: \"\\eea2\";\n  }\n  .bxs-shield-alt-2:before {\n    content: \"\\eea3\";\n  }\n  .bxs-shield-x:before {\n    content: \"\\eea4\";\n  }\n  .bxs-ship:before {\n    content: \"\\eea5\";\n  }\n  .bxs-shocked:before {\n    content: \"\\eea6\";\n  }\n  .bxs-shopping-bag:before {\n    content: \"\\eea7\";\n  }\n  .bxs-shopping-bag-alt:before {\n    content: \"\\eea8\";\n  }\n  .bxs-shopping-bags:before {\n    content: \"\\eea9\";\n  }\n  .bxs-show:before {\n    content: \"\\eeaa\";\n  }\n  .bxs-skip-next-circle:before {\n    content: \"\\eeab\";\n  }\n  .bxs-skip-previous-circle:before {\n    content: \"\\eeac\";\n  }\n  .bxs-skull:before {\n    content: \"\\eead\";\n  }\n  .bxs-sleepy:before {\n    content: \"\\eeae\";\n  }\n  .bxs-slideshow:before {\n    content: \"\\eeaf\";\n  }\n  .bxs-smile:before {\n    content: \"\\eeb0\";\n  }\n  .bxs-sort-alt:before {\n    content: \"\\eeb1\";\n  }\n  .bxs-spa:before {\n    content: \"\\eeb2\";\n  }\n  .bxs-speaker:before {\n    content: \"\\eeb3\";\n  }\n  .bxs-spray-can:before {\n    content: \"\\eeb4\";\n  }\n  .bxs-spreadsheet:before {\n    content: \"\\eeb5\";\n  }\n  .bxs-square:before {\n    content: \"\\eeb6\";\n  }\n  .bxs-square-rounded:before {\n    content: \"\\eeb7\";\n  }\n  .bxs-star:before {\n    content: \"\\eeb8\";\n  }\n  .bxs-star-half:before {\n    content: \"\\eeb9\";\n  }\n  .bxs-sticker:before {\n    content: \"\\eeba\";\n  }\n  .bxs-stopwatch:before {\n    content: \"\\eebb\";\n  }\n  .bxs-store:before {\n    content: \"\\eebc\";\n  }\n  .bxs-store-alt:before {\n    content: \"\\eebd\";\n  }\n  .bxs-sun:before {\n    content: \"\\eebe\";\n  }\n  .bxs-tachometer:before {\n    content: \"\\eebf\";\n  }\n  .bxs-tag:before {\n    content: \"\\eec0\";\n  }\n  .bxs-tag-alt:before {\n    content: \"\\eec1\";\n  }\n  .bxs-tag-x:before {\n    content: \"\\eec2\";\n  }\n  .bxs-taxi:before {\n    content: \"\\eec3\";\n  }\n  .bxs-tennis-ball:before {\n    content: \"\\eec4\";\n  }\n  .bxs-terminal:before {\n    content: \"\\eec5\";\n  }\n  .bxs-thermometer:before {\n    content: \"\\eec6\";\n  }\n  .bxs-time:before {\n    content: \"\\eec7\";\n  }\n  .bxs-time-five:before {\n    content: \"\\eec8\";\n  }\n  .bxs-timer:before {\n    content: \"\\eec9\";\n  }\n  .bxs-tired:before {\n    content: \"\\eeca\";\n  }\n  .bxs-toggle-left:before {\n    content: \"\\eecb\";\n  }\n  .bxs-toggle-right:before {\n    content: \"\\eecc\";\n  }\n  .bxs-tone:before {\n    content: \"\\eecd\";\n  }\n  .bxs-torch:before {\n    content: \"\\eece\";\n  }\n  .bxs-to-top:before {\n    content: \"\\eecf\";\n  }\n  .bxs-traffic:before {\n    content: \"\\eed0\";\n  }\n  .bxs-traffic-barrier:before {\n    content: \"\\eed1\";\n  }\n  .bxs-traffic-cone:before {\n    content: \"\\eed2\";\n  }\n  .bxs-train:before {\n    content: \"\\eed3\";\n  }\n  .bxs-trash:before {\n    content: \"\\eed4\";\n  }\n  .bxs-trash-alt:before {\n    content: \"\\eed5\";\n  }\n  .bxs-tree:before {\n    content: \"\\eed6\";\n  }\n  .bxs-trophy:before {\n    content: \"\\eed7\";\n  }\n  .bxs-truck:before {\n    content: \"\\eed8\";\n  }\n  .bxs-t-shirt:before {\n    content: \"\\eed9\";\n  }\n  .bxs-tv:before {\n    content: \"\\eeda\";\n  }\n  .bxs-up-arrow:before {\n    content: \"\\eedb\";\n  }\n  .bxs-up-arrow-alt:before {\n    content: \"\\eedc\";\n  }\n  .bxs-up-arrow-circle:before {\n    content: \"\\eedd\";\n  }\n  .bxs-up-arrow-square:before {\n    content: \"\\eede\";\n  }\n  .bxs-upside-down:before {\n    content: \"\\eedf\";\n  }\n  .bxs-upvote:before {\n    content: \"\\eee0\";\n  }\n  .bxs-user:before {\n    content: \"\\eee1\";\n  }\n  .bxs-user-account:before {\n    content: \"\\eee2\";\n  }\n  .bxs-user-badge:before {\n    content: \"\\eee3\";\n  }\n  .bxs-user-check:before {\n    content: \"\\eee4\";\n  }\n  .bxs-user-circle:before {\n    content: \"\\eee5\";\n  }\n  .bxs-user-detail:before {\n    content: \"\\eee6\";\n  }\n  .bxs-user-minus:before {\n    content: \"\\eee7\";\n  }\n  .bxs-user-pin:before {\n    content: \"\\eee8\";\n  }\n  .bxs-user-plus:before {\n    content: \"\\eee9\";\n  }\n  .bxs-user-rectangle:before {\n    content: \"\\eeea\";\n  }\n  .bxs-user-voice:before {\n    content: \"\\eeeb\";\n  }\n  .bxs-user-x:before {\n    content: \"\\eeec\";\n  }\n  .bxs-vector:before {\n    content: \"\\eeed\";\n  }\n  .bxs-vial:before {\n    content: \"\\eeee\";\n  }\n  .bxs-video:before {\n    content: \"\\eeef\";\n  }\n  .bxs-video-off:before {\n    content: \"\\eef0\";\n  }\n  .bxs-video-plus:before {\n    content: \"\\eef1\";\n  }\n  .bxs-video-recording:before {\n    content: \"\\eef2\";\n  }\n  .bxs-videos:before {\n    content: \"\\eef3\";\n  }\n  .bxs-virus:before {\n    content: \"\\eef4\";\n  }\n  .bxs-virus-block:before {\n    content: \"\\eef5\";\n  }\n  .bxs-volume:before {\n    content: \"\\eef6\";\n  }\n  .bxs-volume-full:before {\n    content: \"\\eef7\";\n  }\n  .bxs-volume-low:before {\n    content: \"\\eef8\";\n  }\n  .bxs-volume-mute:before {\n    content: \"\\eef9\";\n  }\n  .bxs-wallet:before {\n    content: \"\\eefa\";\n  }\n  .bxs-wallet-alt:before {\n    content: \"\\eefb\";\n  }\n  .bxs-washer:before {\n    content: \"\\eefc\";\n  }\n  .bxs-watch:before {\n    content: \"\\eefd\";\n  }\n  .bxs-watch-alt:before {\n    content: \"\\eefe\";\n  }\n  .bxs-webcam:before {\n    content: \"\\eeff\";\n  }\n  .bxs-widget:before {\n    content: \"\\ef00\";\n  }\n  .bxs-window-alt:before {\n    content: \"\\ef01\";\n  }\n  .bxs-wine:before {\n    content: \"\\ef02\";\n  }\n  .bxs-wink-smile:before {\n    content: \"\\ef03\";\n  }\n  .bxs-wink-tongue:before {\n    content: \"\\ef04\";\n  }\n  .bxs-wrench:before {\n    content: \"\\ef05\";\n  }\n  .bxs-x-circle:before {\n    content: \"\\ef06\";\n  }\n  .bxs-x-square:before {\n    content: \"\\ef07\";\n  }\n  .bxs-yin-yang:before {\n    content: \"\\ef08\";\n  }\n  .bxs-zap:before {\n    content: \"\\ef09\";\n  }\n  .bxs-zoom-in:before {\n    content: \"\\ef0a\";\n  }\n  .bxs-zoom-out:before {\n    content: \"\\ef0b\";\n  }\n  ",".la,\n.las,\n.lar,\n.lal,\n.lad,\n.lab {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1; }\n\n.la-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.la-xs {\n  font-size: .75em; }\n\n.la-sm {\n  font-size: .875em; }\n\n.la-1x {\n  font-size: 1em; }\n\n.la-2x {\n  font-size: 2em; }\n\n.la-3x {\n  font-size: 3em; }\n\n.la-4x {\n  font-size: 4em; }\n\n.la-5x {\n  font-size: 5em; }\n\n.la-6x {\n  font-size: 6em; }\n\n.la-7x {\n  font-size: 7em; }\n\n.la-8x {\n  font-size: 8em; }\n\n.la-9x {\n  font-size: 9em; }\n\n.la-10x {\n  font-size: 10em; }\n\n.la-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.la-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .la-ul > li {\n    position: relative; }\n\n.la-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.la-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.la-pull-left {\n  float: left; }\n\n.la-pull-right {\n  float: right; }\n\n.la.la-pull-left,\n.las.la-pull-left,\n.lar.la-pull-left,\n.lal.la-pull-left,\n.lab.la-pull-left {\n  margin-right: .3em; }\n\n.la.la-pull-right,\n.las.la-pull-right,\n.lar.la-pull-right,\n.lal.la-pull-right,\n.lab.la-pull-right {\n  margin-left: .3em; }\n\n.la-spin {\n  -webkit-animation: la-spin 2s infinite linear;\n          animation: la-spin 2s infinite linear; }\n\n.la-pulse {\n  -webkit-animation: la-spin 1s infinite steps(8);\n          animation: la-spin 1s infinite steps(8); }\n\n@-webkit-keyframes la-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes la-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.la-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.la-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.la-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.la-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.la-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.la-flip-both, .la-flip-horizontal.la-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .la-rotate-90,\n:root .la-rotate-180,\n:root .la-rotate-270,\n:root .la-flip-horizontal,\n:root .la-flip-vertical,\n:root .la-flip-both {\n  -webkit-filter: none;\n          filter: none; }\n\n.la-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em; }\n\n.la-stack-1x,\n.la-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.la-stack-1x {\n  line-height: inherit; }\n\n.la-stack-2x {\n  font-size: 2em; }\n\n.la-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.la-500px:before {\n  content: \"\\f26e\"; }\n\n.la-accessible-icon:before {\n  content: \"\\f368\"; }\n\n.la-accusoft:before {\n  content: \"\\f369\"; }\n\n.la-acquisitions-incorporated:before {\n  content: \"\\f6af\"; }\n\n.la-ad:before {\n  content: \"\\f641\"; }\n\n.la-address-book:before {\n  content: \"\\f2b9\"; }\n\n.la-address-card:before {\n  content: \"\\f2bb\"; }\n\n.la-adjust:before {\n  content: \"\\f042\"; }\n\n.la-adn:before {\n  content: \"\\f170\"; }\n\n.la-adobe:before {\n  content: \"\\f778\"; }\n\n.la-adversal:before {\n  content: \"\\f36a\"; }\n\n.la-affiliatetheme:before {\n  content: \"\\f36b\"; }\n\n.la-air-freshener:before {\n  content: \"\\f5d0\"; }\n\n.la-airbnb:before {\n  content: \"\\f834\"; }\n\n.la-algolia:before {\n  content: \"\\f36c\"; }\n\n.la-align-center:before {\n  content: \"\\f037\"; }\n\n.la-align-justify:before {\n  content: \"\\f039\"; }\n\n.la-align-left:before {\n  content: \"\\f036\"; }\n\n.la-align-right:before {\n  content: \"\\f038\"; }\n\n.la-alipay:before {\n  content: \"\\f642\"; }\n\n.la-allergies:before {\n  content: \"\\f461\"; }\n\n.la-amazon:before {\n  content: \"\\f270\"; }\n\n.la-amazon-pay:before {\n  content: \"\\f42c\"; }\n\n.la-ambulance:before {\n  content: \"\\f0f9\"; }\n\n.la-american-sign-language-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.la-amilia:before {\n  content: \"\\f36d\"; }\n\n.la-anchor:before {\n  content: \"\\f13d\"; }\n\n.la-android:before {\n  content: \"\\f17b\"; }\n\n.la-angellist:before {\n  content: \"\\f209\"; }\n\n.la-angle-double-down:before {\n  content: \"\\f103\"; }\n\n.la-angle-double-left:before {\n  content: \"\\f100\"; }\n\n.la-angle-double-right:before {\n  content: \"\\f101\"; }\n\n.la-angle-double-up:before {\n  content: \"\\f102\"; }\n\n.la-angle-down:before {\n  content: \"\\f107\"; }\n\n.la-angle-left:before {\n  content: \"\\f104\"; }\n\n.la-angle-right:before {\n  content: \"\\f105\"; }\n\n.la-angle-up:before {\n  content: \"\\f106\"; }\n\n.la-angry:before {\n  content: \"\\f556\"; }\n\n.la-angrycreative:before {\n  content: \"\\f36e\"; }\n\n.la-angular:before {\n  content: \"\\f420\"; }\n\n.la-ankh:before {\n  content: \"\\f644\"; }\n\n.la-app-store:before {\n  content: \"\\f36f\"; }\n\n.la-app-store-ios:before {\n  content: \"\\f370\"; }\n\n.la-apper:before {\n  content: \"\\f371\"; }\n\n.la-apple:before {\n  content: \"\\f179\"; }\n\n.la-apple-alt:before {\n  content: \"\\f5d1\"; }\n\n.la-apple-pay:before {\n  content: \"\\f415\"; }\n\n.la-archive:before {\n  content: \"\\f187\"; }\n\n.la-archway:before {\n  content: \"\\f557\"; }\n\n.la-arrow-alt-circle-down:before {\n  content: \"\\f358\"; }\n\n.la-arrow-alt-circle-left:before {\n  content: \"\\f359\"; }\n\n.la-arrow-alt-circle-right:before {\n  content: \"\\f35a\"; }\n\n.la-arrow-alt-circle-up:before {\n  content: \"\\f35b\"; }\n\n.la-arrow-circle-down:before {\n  content: \"\\f0ab\"; }\n\n.la-arrow-circle-left:before {\n  content: \"\\f0a8\"; }\n\n.la-arrow-circle-right:before {\n  content: \"\\f0a9\"; }\n\n.la-arrow-circle-up:before {\n  content: \"\\f0aa\"; }\n\n.la-arrow-down:before {\n  content: \"\\f063\"; }\n\n.la-arrow-left:before {\n  content: \"\\f060\"; }\n\n.la-arrow-right:before {\n  content: \"\\f061\"; }\n\n.la-arrow-up:before {\n  content: \"\\f062\"; }\n\n.la-arrows-alt:before {\n  content: \"\\f0b2\"; }\n\n.la-arrows-alt-h:before {\n  content: \"\\f337\"; }\n\n.la-arrows-alt-v:before {\n  content: \"\\f338\"; }\n\n.la-artstation:before {\n  content: \"\\f77a\"; }\n\n.la-assistive-listening-systems:before {\n  content: \"\\f2a2\"; }\n\n.la-asterisk:before {\n  content: \"\\f069\"; }\n\n.la-asymmetrik:before {\n  content: \"\\f372\"; }\n\n.la-at:before {\n  content: \"\\f1fa\"; }\n\n.la-atlas:before {\n  content: \"\\f558\"; }\n\n.la-atlassian:before {\n  content: \"\\f77b\"; }\n\n.la-atom:before {\n  content: \"\\f5d2\"; }\n\n.la-audible:before {\n  content: \"\\f373\"; }\n\n.la-audio-description:before {\n  content: \"\\f29e\"; }\n\n.la-autoprefixer:before {\n  content: \"\\f41c\"; }\n\n.la-avianex:before {\n  content: \"\\f374\"; }\n\n.la-aviato:before {\n  content: \"\\f421\"; }\n\n.la-award:before {\n  content: \"\\f559\"; }\n\n.la-aws:before {\n  content: \"\\f375\"; }\n\n.la-baby:before {\n  content: \"\\f77c\"; }\n\n.la-baby-carriage:before {\n  content: \"\\f77d\"; }\n\n.la-backspace:before {\n  content: \"\\f55a\"; }\n\n.la-backward:before {\n  content: \"\\f04a\"; }\n\n.la-bacon:before {\n  content: \"\\f7e5\"; }\n\n.la-balance-scale:before {\n  content: \"\\f24e\"; }\n\n.la-balance-scale-left:before {\n  content: \"\\f515\"; }\n\n.la-balance-scale-right:before {\n  content: \"\\f516\"; }\n\n.la-ban:before {\n  content: \"\\f05e\"; }\n\n.la-band-aid:before {\n  content: \"\\f462\"; }\n\n.la-bandcamp:before {\n  content: \"\\f2d5\"; }\n\n.la-barcode:before {\n  content: \"\\f02a\"; }\n\n.la-bars:before {\n  content: \"\\f0c9\"; }\n\n.la-baseball-ball:before {\n  content: \"\\f433\"; }\n\n.la-basketball-ball:before {\n  content: \"\\f434\"; }\n\n.la-bath:before {\n  content: \"\\f2cd\"; }\n\n.la-battery-empty:before {\n  content: \"\\f244\"; }\n\n.la-battery-full:before {\n  content: \"\\f240\"; }\n\n.la-battery-half:before {\n  content: \"\\f242\"; }\n\n.la-battery-quarter:before {\n  content: \"\\f243\"; }\n\n.la-battery-three-quarters:before {\n  content: \"\\f241\"; }\n\n.la-battle-net:before {\n  content: \"\\f835\"; }\n\n.la-bed:before {\n  content: \"\\f236\"; }\n\n.la-beer:before {\n  content: \"\\f0fc\"; }\n\n.la-behance:before {\n  content: \"\\f1b4\"; }\n\n.la-behance-square:before {\n  content: \"\\f1b5\"; }\n\n.la-bell:before {\n  content: \"\\f0f3\"; }\n\n.la-bell-slash:before {\n  content: \"\\f1f6\"; }\n\n.la-bezier-curve:before {\n  content: \"\\f55b\"; }\n\n.la-bible:before {\n  content: \"\\f647\"; }\n\n.la-bicycle:before {\n  content: \"\\f206\"; }\n\n.la-biking:before {\n  content: \"\\f84a\"; }\n\n.la-bimobject:before {\n  content: \"\\f378\"; }\n\n.la-binoculars:before {\n  content: \"\\f1e5\"; }\n\n.la-biohazard:before {\n  content: \"\\f780\"; }\n\n.la-birthday-cake:before {\n  content: \"\\f1fd\"; }\n\n.la-bitbucket:before {\n  content: \"\\f171\"; }\n\n.la-bitcoin:before {\n  content: \"\\f379\"; }\n\n.la-bity:before {\n  content: \"\\f37a\"; }\n\n.la-black-tie:before {\n  content: \"\\f27e\"; }\n\n.la-blackberry:before {\n  content: \"\\f37b\"; }\n\n.la-blender:before {\n  content: \"\\f517\"; }\n\n.la-blender-phone:before {\n  content: \"\\f6b6\"; }\n\n.la-blind:before {\n  content: \"\\f29d\"; }\n\n.la-blog:before {\n  content: \"\\f781\"; }\n\n.la-blogger:before {\n  content: \"\\f37c\"; }\n\n.la-blogger-b:before {\n  content: \"\\f37d\"; }\n\n.la-bluetooth:before {\n  content: \"\\f293\"; }\n\n.la-bluetooth-b:before {\n  content: \"\\f294\"; }\n\n.la-bold:before {\n  content: \"\\f032\"; }\n\n.la-bolt:before {\n  content: \"\\f0e7\"; }\n\n.la-bomb:before {\n  content: \"\\f1e2\"; }\n\n.la-bone:before {\n  content: \"\\f5d7\"; }\n\n.la-bong:before {\n  content: \"\\f55c\"; }\n\n.la-book:before {\n  content: \"\\f02d\"; }\n\n.la-book-dead:before {\n  content: \"\\f6b7\"; }\n\n.la-book-medical:before {\n  content: \"\\f7e6\"; }\n\n.la-book-open:before {\n  content: \"\\f518\"; }\n\n.la-book-reader:before {\n  content: \"\\f5da\"; }\n\n.la-bookmark:before {\n  content: \"\\f02e\"; }\n\n.la-bootstrap:before {\n  content: \"\\f836\"; }\n\n.la-border-all:before {\n  content: \"\\f84c\"; }\n\n.la-border-none:before {\n  content: \"\\f850\"; }\n\n.la-border-style:before {\n  content: \"\\f853\"; }\n\n.la-bowling-ball:before {\n  content: \"\\f436\"; }\n\n.la-box:before {\n  content: \"\\f466\"; }\n\n.la-box-open:before {\n  content: \"\\f49e\"; }\n\n.la-boxes:before {\n  content: \"\\f468\"; }\n\n.la-braille:before {\n  content: \"\\f2a1\"; }\n\n.la-brain:before {\n  content: \"\\f5dc\"; }\n\n.la-bread-slice:before {\n  content: \"\\f7ec\"; }\n\n.la-briefcase:before {\n  content: \"\\f0b1\"; }\n\n.la-briefcase-medical:before {\n  content: \"\\f469\"; }\n\n.la-broadcast-tower:before {\n  content: \"\\f519\"; }\n\n.la-broom:before {\n  content: \"\\f51a\"; }\n\n.la-brush:before {\n  content: \"\\f55d\"; }\n\n.la-btc:before {\n  content: \"\\f15a\"; }\n\n.la-buffer:before {\n  content: \"\\f837\"; }\n\n.la-bug:before {\n  content: \"\\f188\"; }\n\n.la-building:before {\n  content: \"\\f1ad\"; }\n\n.la-bullhorn:before {\n  content: \"\\f0a1\"; }\n\n.la-bullseye:before {\n  content: \"\\f140\"; }\n\n.la-burn:before {\n  content: \"\\f46a\"; }\n\n.la-buromobelexperte:before {\n  content: \"\\f37f\"; }\n\n.la-bus:before {\n  content: \"\\f207\"; }\n\n.la-bus-alt:before {\n  content: \"\\f55e\"; }\n\n.la-business-time:before {\n  content: \"\\f64a\"; }\n\n.la-buy-n-large:before {\n  content: \"\\f8a6\"; }\n\n.la-buysellads:before {\n  content: \"\\f20d\"; }\n\n.la-calculator:before {\n  content: \"\\f1ec\"; }\n\n.la-calendar:before {\n  content: \"\\f133\"; }\n\n.la-calendar-alt:before {\n  content: \"\\f073\"; }\n\n.la-calendar-check:before {\n  content: \"\\f274\"; }\n\n.la-calendar-day:before {\n  content: \"\\f783\"; }\n\n.la-calendar-minus:before {\n  content: \"\\f272\"; }\n\n.la-calendar-plus:before {\n  content: \"\\f271\"; }\n\n.la-calendar-times:before {\n  content: \"\\f273\"; }\n\n.la-calendar-week:before {\n  content: \"\\f784\"; }\n\n.la-camera:before {\n  content: \"\\f030\"; }\n\n.la-camera-retro:before {\n  content: \"\\f083\"; }\n\n.la-campground:before {\n  content: \"\\f6bb\"; }\n\n.la-canadian-maple-leaf:before {\n  content: \"\\f785\"; }\n\n.la-candy-cane:before {\n  content: \"\\f786\"; }\n\n.la-cannabis:before {\n  content: \"\\f55f\"; }\n\n.la-capsules:before {\n  content: \"\\f46b\"; }\n\n.la-car:before {\n  content: \"\\f1b9\"; }\n\n.la-car-alt:before {\n  content: \"\\f5de\"; }\n\n.la-car-battery:before {\n  content: \"\\f5df\"; }\n\n.la-car-crash:before {\n  content: \"\\f5e1\"; }\n\n.la-car-side:before {\n  content: \"\\f5e4\"; }\n\n.la-caret-down:before {\n  content: \"\\f0d7\"; }\n\n.la-caret-left:before {\n  content: \"\\f0d9\"; }\n\n.la-caret-right:before {\n  content: \"\\f0da\"; }\n\n.la-caret-square-down:before {\n  content: \"\\f150\"; }\n\n.la-caret-square-left:before {\n  content: \"\\f191\"; }\n\n.la-caret-square-right:before {\n  content: \"\\f152\"; }\n\n.la-caret-square-up:before {\n  content: \"\\f151\"; }\n\n.la-caret-up:before {\n  content: \"\\f0d8\"; }\n\n.la-carrot:before {\n  content: \"\\f787\"; }\n\n.la-cart-arrow-down:before {\n  content: \"\\f218\"; }\n\n.la-cart-plus:before {\n  content: \"\\f217\"; }\n\n.la-cash-register:before {\n  content: \"\\f788\"; }\n\n.la-cat:before {\n  content: \"\\f6be\"; }\n\n.la-cc-amazon-pay:before {\n  content: \"\\f42d\"; }\n\n.la-cc-amex:before {\n  content: \"\\f1f3\"; }\n\n.la-cc-apple-pay:before {\n  content: \"\\f416\"; }\n\n.la-cc-diners-club:before {\n  content: \"\\f24c\"; }\n\n.la-cc-discover:before {\n  content: \"\\f1f2\"; }\n\n.la-cc-jcb:before {\n  content: \"\\f24b\"; }\n\n.la-cc-mastercard:before {\n  content: \"\\f1f1\"; }\n\n.la-cc-paypal:before {\n  content: \"\\f1f4\"; }\n\n.la-cc-stripe:before {\n  content: \"\\f1f5\"; }\n\n.la-cc-visa:before {\n  content: \"\\f1f0\"; }\n\n.la-centercode:before {\n  content: \"\\f380\"; }\n\n.la-centos:before {\n  content: \"\\f789\"; }\n\n.la-certificate:before {\n  content: \"\\f0a3\"; }\n\n.la-chair:before {\n  content: \"\\f6c0\"; }\n\n.la-chalkboard:before {\n  content: \"\\f51b\"; }\n\n.la-chalkboard-teacher:before {\n  content: \"\\f51c\"; }\n\n.la-charging-station:before {\n  content: \"\\f5e7\"; }\n\n.la-chart-area:before {\n  content: \"\\f1fe\"; }\n\n.la-chart-bar:before {\n  content: \"\\f080\"; }\n\n.la-chart-line:before {\n  content: \"\\f201\"; }\n\n.la-chart-pie:before {\n  content: \"\\f200\"; }\n\n.la-check:before {\n  content: \"\\f00c\"; }\n\n.la-check-circle:before {\n  content: \"\\f058\"; }\n\n.la-check-double:before {\n  content: \"\\f560\"; }\n\n.la-check-square:before {\n  content: \"\\f14a\"; }\n\n.la-cheese:before {\n  content: \"\\f7ef\"; }\n\n.la-chess:before {\n  content: \"\\f439\"; }\n\n.la-chess-bishop:before {\n  content: \"\\f43a\"; }\n\n.la-chess-board:before {\n  content: \"\\f43c\"; }\n\n.la-chess-king:before {\n  content: \"\\f43f\"; }\n\n.la-chess-knight:before {\n  content: \"\\f441\"; }\n\n.la-chess-pawn:before {\n  content: \"\\f443\"; }\n\n.la-chess-queen:before {\n  content: \"\\f445\"; }\n\n.la-chess-rook:before {\n  content: \"\\f447\"; }\n\n.la-chevron-circle-down:before {\n  content: \"\\f13a\"; }\n\n.la-chevron-circle-left:before {\n  content: \"\\f137\"; }\n\n.la-chevron-circle-right:before {\n  content: \"\\f138\"; }\n\n.la-chevron-circle-up:before {\n  content: \"\\f139\"; }\n\n.la-chevron-down:before {\n  content: \"\\f078\"; }\n\n.la-chevron-left:before {\n  content: \"\\f053\"; }\n\n.la-chevron-right:before {\n  content: \"\\f054\"; }\n\n.la-chevron-up:before {\n  content: \"\\f077\"; }\n\n.la-child:before {\n  content: \"\\f1ae\"; }\n\n.la-chrome:before {\n  content: \"\\f268\"; }\n\n.la-chromecast:before {\n  content: \"\\f838\"; }\n\n.la-church:before {\n  content: \"\\f51d\"; }\n\n.la-circle:before {\n  content: \"\\f111\"; }\n\n.la-circle-notch:before {\n  content: \"\\f1ce\"; }\n\n.la-city:before {\n  content: \"\\f64f\"; }\n\n.la-clinic-medical:before {\n  content: \"\\f7f2\"; }\n\n.la-clipboard:before {\n  content: \"\\f328\"; }\n\n.la-clipboard-check:before {\n  content: \"\\f46c\"; }\n\n.la-clipboard-list:before {\n  content: \"\\f46d\"; }\n\n.la-clock:before {\n  content: \"\\f017\"; }\n\n.la-clone:before {\n  content: \"\\f24d\"; }\n\n.la-closed-captioning:before {\n  content: \"\\f20a\"; }\n\n.la-cloud:before {\n  content: \"\\f0c2\"; }\n\n.la-cloud-download-alt:before {\n  content: \"\\f381\"; }\n\n.la-cloud-meatball:before {\n  content: \"\\f73b\"; }\n\n.la-cloud-moon:before {\n  content: \"\\f6c3\"; }\n\n.la-cloud-moon-rain:before {\n  content: \"\\f73c\"; }\n\n.la-cloud-rain:before {\n  content: \"\\f73d\"; }\n\n.la-cloud-showers-heavy:before {\n  content: \"\\f740\"; }\n\n.la-cloud-sun:before {\n  content: \"\\f6c4\"; }\n\n.la-cloud-sun-rain:before {\n  content: \"\\f743\"; }\n\n.la-cloud-upload-alt:before {\n  content: \"\\f382\"; }\n\n.la-cloudscale:before {\n  content: \"\\f383\"; }\n\n.la-cloudsmith:before {\n  content: \"\\f384\"; }\n\n.la-cloudversify:before {\n  content: \"\\f385\"; }\n\n.la-cocktail:before {\n  content: \"\\f561\"; }\n\n.la-code:before {\n  content: \"\\f121\"; }\n\n.la-code-branch:before {\n  content: \"\\f126\"; }\n\n.la-codepen:before {\n  content: \"\\f1cb\"; }\n\n.la-codiepie:before {\n  content: \"\\f284\"; }\n\n.la-coffee:before {\n  content: \"\\f0f4\"; }\n\n.la-cog:before {\n  content: \"\\f013\"; }\n\n.la-cogs:before {\n  content: \"\\f085\"; }\n\n.la-coins:before {\n  content: \"\\f51e\"; }\n\n.la-columns:before {\n  content: \"\\f0db\"; }\n\n.la-comment:before {\n  content: \"\\f075\"; }\n\n.la-comment-alt:before {\n  content: \"\\f27a\"; }\n\n.la-comment-dollar:before {\n  content: \"\\f651\"; }\n\n.la-comment-dots:before {\n  content: \"\\f4ad\"; }\n\n.la-comment-medical:before {\n  content: \"\\f7f5\"; }\n\n.la-comment-slash:before {\n  content: \"\\f4b3\"; }\n\n.la-comments:before {\n  content: \"\\f086\"; }\n\n.la-comments-dollar:before {\n  content: \"\\f653\"; }\n\n.la-compact-disc:before {\n  content: \"\\f51f\"; }\n\n.la-compass:before {\n  content: \"\\f14e\"; }\n\n.la-compress:before {\n  content: \"\\f066\"; }\n\n.la-compress-arrows-alt:before {\n  content: \"\\f78c\"; }\n\n.la-concierge-bell:before {\n  content: \"\\f562\"; }\n\n.la-confluence:before {\n  content: \"\\f78d\"; }\n\n.la-connectdevelop:before {\n  content: \"\\f20e\"; }\n\n.la-contao:before {\n  content: \"\\f26d\"; }\n\n.la-cookie:before {\n  content: \"\\f563\"; }\n\n.la-cookie-bite:before {\n  content: \"\\f564\"; }\n\n.la-copy:before {\n  content: \"\\f0c5\"; }\n\n.la-copyright:before {\n  content: \"\\f1f9\"; }\n\n.la-cotton-bureau:before {\n  content: \"\\f89e\"; }\n\n.la-couch:before {\n  content: \"\\f4b8\"; }\n\n.la-cpanel:before {\n  content: \"\\f388\"; }\n\n.la-creative-commons:before {\n  content: \"\\f25e\"; }\n\n.la-creative-commons-by:before {\n  content: \"\\f4e7\"; }\n\n.la-creative-commons-nc:before {\n  content: \"\\f4e8\"; }\n\n.la-creative-commons-nc-eu:before {\n  content: \"\\f4e9\"; }\n\n.la-creative-commons-nc-jp:before {\n  content: \"\\f4ea\"; }\n\n.la-creative-commons-nd:before {\n  content: \"\\f4eb\"; }\n\n.la-creative-commons-pd:before {\n  content: \"\\f4ec\"; }\n\n.la-creative-commons-pd-alt:before {\n  content: \"\\f4ed\"; }\n\n.la-creative-commons-remix:before {\n  content: \"\\f4ee\"; }\n\n.la-creative-commons-sa:before {\n  content: \"\\f4ef\"; }\n\n.la-creative-commons-sampling:before {\n  content: \"\\f4f0\"; }\n\n.la-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\"; }\n\n.la-creative-commons-share:before {\n  content: \"\\f4f2\"; }\n\n.la-creative-commons-zero:before {\n  content: \"\\f4f3\"; }\n\n.la-credit-card:before {\n  content: \"\\f09d\"; }\n\n.la-critical-role:before {\n  content: \"\\f6c9\"; }\n\n.la-crop:before {\n  content: \"\\f125\"; }\n\n.la-crop-alt:before {\n  content: \"\\f565\"; }\n\n.la-cross:before {\n  content: \"\\f654\"; }\n\n.la-crosshairs:before {\n  content: \"\\f05b\"; }\n\n.la-crow:before {\n  content: \"\\f520\"; }\n\n.la-crown:before {\n  content: \"\\f521\"; }\n\n.la-crutch:before {\n  content: \"\\f7f7\"; }\n\n.la-css3:before {\n  content: \"\\f13c\"; }\n\n.la-css3-alt:before {\n  content: \"\\f38b\"; }\n\n.la-cube:before {\n  content: \"\\f1b2\"; }\n\n.la-cubes:before {\n  content: \"\\f1b3\"; }\n\n.la-cut:before {\n  content: \"\\f0c4\"; }\n\n.la-cuttlefish:before {\n  content: \"\\f38c\"; }\n\n.la-d-and-d:before {\n  content: \"\\f38d\"; }\n\n.la-d-and-d-beyond:before {\n  content: \"\\f6ca\"; }\n\n.la-dashcube:before {\n  content: \"\\f210\"; }\n\n.la-database:before {\n  content: \"\\f1c0\"; }\n\n.la-deaf:before {\n  content: \"\\f2a4\"; }\n\n.la-delicious:before {\n  content: \"\\f1a5\"; }\n\n.la-democrat:before {\n  content: \"\\f747\"; }\n\n.la-deploydog:before {\n  content: \"\\f38e\"; }\n\n.la-deskpro:before {\n  content: \"\\f38f\"; }\n\n.la-desktop:before {\n  content: \"\\f108\"; }\n\n.la-dev:before {\n  content: \"\\f6cc\"; }\n\n.la-deviantart:before {\n  content: \"\\f1bd\"; }\n\n.la-dharmachakra:before {\n  content: \"\\f655\"; }\n\n.la-dhl:before {\n  content: \"\\f790\"; }\n\n.la-diagnoses:before {\n  content: \"\\f470\"; }\n\n.la-diaspora:before {\n  content: \"\\f791\"; }\n\n.la-dice:before {\n  content: \"\\f522\"; }\n\n.la-dice-d20:before {\n  content: \"\\f6cf\"; }\n\n.la-dice-d6:before {\n  content: \"\\f6d1\"; }\n\n.la-dice-five:before {\n  content: \"\\f523\"; }\n\n.la-dice-four:before {\n  content: \"\\f524\"; }\n\n.la-dice-one:before {\n  content: \"\\f525\"; }\n\n.la-dice-six:before {\n  content: \"\\f526\"; }\n\n.la-dice-three:before {\n  content: \"\\f527\"; }\n\n.la-dice-two:before {\n  content: \"\\f528\"; }\n\n.la-digg:before {\n  content: \"\\f1a6\"; }\n\n.la-digital-ocean:before {\n  content: \"\\f391\"; }\n\n.la-digital-tachograph:before {\n  content: \"\\f566\"; }\n\n.la-directions:before {\n  content: \"\\f5eb\"; }\n\n.la-discord:before {\n  content: \"\\f392\"; }\n\n.la-discourse:before {\n  content: \"\\f393\"; }\n\n.la-divide:before {\n  content: \"\\f529\"; }\n\n.la-dizzy:before {\n  content: \"\\f567\"; }\n\n.la-dna:before {\n  content: \"\\f471\"; }\n\n.la-dochub:before {\n  content: \"\\f394\"; }\n\n.la-docker:before {\n  content: \"\\f395\"; }\n\n.la-dog:before {\n  content: \"\\f6d3\"; }\n\n.la-dollar-sign:before {\n  content: \"\\f155\"; }\n\n.la-dolly:before {\n  content: \"\\f472\"; }\n\n.la-dolly-flatbed:before {\n  content: \"\\f474\"; }\n\n.la-donate:before {\n  content: \"\\f4b9\"; }\n\n.la-door-closed:before {\n  content: \"\\f52a\"; }\n\n.la-door-open:before {\n  content: \"\\f52b\"; }\n\n.la-dot-circle:before {\n  content: \"\\f192\"; }\n\n.la-dove:before {\n  content: \"\\f4ba\"; }\n\n.la-download:before {\n  content: \"\\f019\"; }\n\n.la-draft2digital:before {\n  content: \"\\f396\"; }\n\n.la-drafting-compass:before {\n  content: \"\\f568\"; }\n\n.la-dragon:before {\n  content: \"\\f6d5\"; }\n\n.la-draw-polygon:before {\n  content: \"\\f5ee\"; }\n\n.la-dribbble:before {\n  content: \"\\f17d\"; }\n\n.la-dribbble-square:before {\n  content: \"\\f397\"; }\n\n.la-dropbox:before {\n  content: \"\\f16b\"; }\n\n.la-drum:before {\n  content: \"\\f569\"; }\n\n.la-drum-steelpan:before {\n  content: \"\\f56a\"; }\n\n.la-drumstick-bite:before {\n  content: \"\\f6d7\"; }\n\n.la-drupal:before {\n  content: \"\\f1a9\"; }\n\n.la-dumbbell:before {\n  content: \"\\f44b\"; }\n\n.la-dumpster:before {\n  content: \"\\f793\"; }\n\n.la-dumpster-fire:before {\n  content: \"\\f794\"; }\n\n.la-dungeon:before {\n  content: \"\\f6d9\"; }\n\n.la-dyalog:before {\n  content: \"\\f399\"; }\n\n.la-earlybirds:before {\n  content: \"\\f39a\"; }\n\n.la-ebay:before {\n  content: \"\\f4f4\"; }\n\n.la-edge:before {\n  content: \"\\f282\"; }\n\n.la-edit:before {\n  content: \"\\f044\"; }\n\n.la-egg:before {\n  content: \"\\f7fb\"; }\n\n.la-eject:before {\n  content: \"\\f052\"; }\n\n.la-elementor:before {\n  content: \"\\f430\"; }\n\n.la-ellipsis-h:before {\n  content: \"\\f141\"; }\n\n.la-ellipsis-v:before {\n  content: \"\\f142\"; }\n\n.la-ello:before {\n  content: \"\\f5f1\"; }\n\n.la-ember:before {\n  content: \"\\f423\"; }\n\n.la-empire:before {\n  content: \"\\f1d1\"; }\n\n.la-envelope:before {\n  content: \"\\f0e0\"; }\n\n.la-envelope-open:before {\n  content: \"\\f2b6\"; }\n\n.la-envelope-open-text:before {\n  content: \"\\f658\"; }\n\n.la-envelope-square:before {\n  content: \"\\f199\"; }\n\n.la-envira:before {\n  content: \"\\f299\"; }\n\n.la-equals:before {\n  content: \"\\f52c\"; }\n\n.la-eraser:before {\n  content: \"\\f12d\"; }\n\n.la-erlang:before {\n  content: \"\\f39d\"; }\n\n.la-ethereum:before {\n  content: \"\\f42e\"; }\n\n.la-ethernet:before {\n  content: \"\\f796\"; }\n\n.la-etsy:before {\n  content: \"\\f2d7\"; }\n\n.la-euro-sign:before {\n  content: \"\\f153\"; }\n\n.la-evernote:before {\n  content: \"\\f839\"; }\n\n.la-exchange-alt:before {\n  content: \"\\f362\"; }\n\n.la-exclamation:before {\n  content: \"\\f12a\"; }\n\n.la-exclamation-circle:before {\n  content: \"\\f06a\"; }\n\n.la-exclamation-triangle:before {\n  content: \"\\f071\"; }\n\n.la-expand:before {\n  content: \"\\f065\"; }\n\n.la-expand-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.la-expeditedssl:before {\n  content: \"\\f23e\"; }\n\n.la-external-link-alt:before {\n  content: \"\\f35d\"; }\n\n.la-external-link-square-alt:before {\n  content: \"\\f360\"; }\n\n.la-eye:before {\n  content: \"\\f06e\"; }\n\n.la-eye-dropper:before {\n  content: \"\\f1fb\"; }\n\n.la-eye-slash:before {\n  content: \"\\f070\"; }\n\n.la-facebook:before {\n  content: \"\\f09a\"; }\n\n.la-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.la-facebook-messenger:before {\n  content: \"\\f39f\"; }\n\n.la-facebook-square:before {\n  content: \"\\f082\"; }\n\n.la-fan:before {\n  content: \"\\f863\"; }\n\n.la-fantasy-flight-games:before {\n  content: \"\\f6dc\"; }\n\n.la-fast-backward:before {\n  content: \"\\f049\"; }\n\n.la-fast-forward:before {\n  content: \"\\f050\"; }\n\n.la-fax:before {\n  content: \"\\f1ac\"; }\n\n.la-feather:before {\n  content: \"\\f52d\"; }\n\n.la-feather-alt:before {\n  content: \"\\f56b\"; }\n\n.la-fedex:before {\n  content: \"\\f797\"; }\n\n.la-fedora:before {\n  content: \"\\f798\"; }\n\n.la-female:before {\n  content: \"\\f182\"; }\n\n.la-fighter-jet:before {\n  content: \"\\f0fb\"; }\n\n.la-figma:before {\n  content: \"\\f799\"; }\n\n.la-file:before {\n  content: \"\\f15b\"; }\n\n.la-file-alt:before {\n  content: \"\\f15c\"; }\n\n.la-file-archive:before {\n  content: \"\\f1c6\"; }\n\n.la-file-audio:before {\n  content: \"\\f1c7\"; }\n\n.la-file-code:before {\n  content: \"\\f1c9\"; }\n\n.la-file-contract:before {\n  content: \"\\f56c\"; }\n\n.la-file-csv:before {\n  content: \"\\f6dd\"; }\n\n.la-file-download:before {\n  content: \"\\f56d\"; }\n\n.la-file-excel:before {\n  content: \"\\f1c3\"; }\n\n.la-file-export:before {\n  content: \"\\f56e\"; }\n\n.la-file-image:before {\n  content: \"\\f1c5\"; }\n\n.la-file-import:before {\n  content: \"\\f56f\"; }\n\n.la-file-invoice:before {\n  content: \"\\f570\"; }\n\n.la-file-invoice-dollar:before {\n  content: \"\\f571\"; }\n\n.la-file-medical:before {\n  content: \"\\f477\"; }\n\n.la-file-medical-alt:before {\n  content: \"\\f478\"; }\n\n.la-file-pdf:before {\n  content: \"\\f1c1\"; }\n\n.la-file-powerpoint:before {\n  content: \"\\f1c4\"; }\n\n.la-file-prescription:before {\n  content: \"\\f572\"; }\n\n.la-file-signature:before {\n  content: \"\\f573\"; }\n\n.la-file-upload:before {\n  content: \"\\f574\"; }\n\n.la-file-video:before {\n  content: \"\\f1c8\"; }\n\n.la-file-word:before {\n  content: \"\\f1c2\"; }\n\n.la-fill:before {\n  content: \"\\f575\"; }\n\n.la-fill-drip:before {\n  content: \"\\f576\"; }\n\n.la-film:before {\n  content: \"\\f008\"; }\n\n.la-filter:before {\n  content: \"\\f0b0\"; }\n\n.la-fingerprint:before {\n  content: \"\\f577\"; }\n\n.la-fire:before {\n  content: \"\\f06d\"; }\n\n.la-fire-alt:before {\n  content: \"\\f7e4\"; }\n\n.la-fire-extinguisher:before {\n  content: \"\\f134\"; }\n\n.la-firefox:before {\n  content: \"\\f269\"; }\n\n.la-first-aid:before {\n  content: \"\\f479\"; }\n\n.la-first-order:before {\n  content: \"\\f2b0\"; }\n\n.la-first-order-alt:before {\n  content: \"\\f50a\"; }\n\n.la-firstdraft:before {\n  content: \"\\f3a1\"; }\n\n.la-fish:before {\n  content: \"\\f578\"; }\n\n.la-fist-raised:before {\n  content: \"\\f6de\"; }\n\n.la-flag:before {\n  content: \"\\f024\"; }\n\n.la-flag-checkered:before {\n  content: \"\\f11e\"; }\n\n.la-flag-usa:before {\n  content: \"\\f74d\"; }\n\n.la-flask:before {\n  content: \"\\f0c3\"; }\n\n.la-flickr:before {\n  content: \"\\f16e\"; }\n\n.la-flipboard:before {\n  content: \"\\f44d\"; }\n\n.la-flushed:before {\n  content: \"\\f579\"; }\n\n.la-fly:before {\n  content: \"\\f417\"; }\n\n.la-folder:before {\n  content: \"\\f07b\"; }\n\n.la-folder-minus:before {\n  content: \"\\f65d\"; }\n\n.la-folder-open:before {\n  content: \"\\f07c\"; }\n\n.la-folder-plus:before {\n  content: \"\\f65e\"; }\n\n.la-font:before {\n  content: \"\\f031\"; }\n\n.la-font-awesome:before {\n  content: \"\\f2b4\"; }\n\n.la-font-awesome-alt:before {\n  content: \"\\f35c\"; }\n\n.la-font-awesome-flag:before {\n  content: \"\\f425\"; }\n\n.la-font-awesome-logo-full:before {\n  content: \"\\f4e6\"; }\n\n.la-fonticons:before {\n  content: \"\\f280\"; }\n\n.la-fonticons-fi:before {\n  content: \"\\f3a2\"; }\n\n.la-football-ball:before {\n  content: \"\\f44e\"; }\n\n.la-fort-awesome:before {\n  content: \"\\f286\"; }\n\n.la-fort-awesome-alt:before {\n  content: \"\\f3a3\"; }\n\n.la-forumbee:before {\n  content: \"\\f211\"; }\n\n.la-forward:before {\n  content: \"\\f04e\"; }\n\n.la-foursquare:before {\n  content: \"\\f180\"; }\n\n.la-free-code-camp:before {\n  content: \"\\f2c5\"; }\n\n.la-freebsd:before {\n  content: \"\\f3a4\"; }\n\n.la-frog:before {\n  content: \"\\f52e\"; }\n\n.la-frown:before {\n  content: \"\\f119\"; }\n\n.la-frown-open:before {\n  content: \"\\f57a\"; }\n\n.la-fulcrum:before {\n  content: \"\\f50b\"; }\n\n.la-funnel-dollar:before {\n  content: \"\\f662\"; }\n\n.la-futbol:before {\n  content: \"\\f1e3\"; }\n\n.la-galactic-republic:before {\n  content: \"\\f50c\"; }\n\n.la-galactic-senate:before {\n  content: \"\\f50d\"; }\n\n.la-gamepad:before {\n  content: \"\\f11b\"; }\n\n.la-gas-pump:before {\n  content: \"\\f52f\"; }\n\n.la-gavel:before {\n  content: \"\\f0e3\"; }\n\n.la-gem:before {\n  content: \"\\f3a5\"; }\n\n.la-genderless:before {\n  content: \"\\f22d\"; }\n\n.la-get-pocket:before {\n  content: \"\\f265\"; }\n\n.la-gg:before {\n  content: \"\\f260\"; }\n\n.la-gg-circle:before {\n  content: \"\\f261\"; }\n\n.la-ghost:before {\n  content: \"\\f6e2\"; }\n\n.la-gift:before {\n  content: \"\\f06b\"; }\n\n.la-gifts:before {\n  content: \"\\f79c\"; }\n\n.la-git:before {\n  content: \"\\f1d3\"; }\n\n.la-git-alt:before {\n  content: \"\\f841\"; }\n\n.la-git-square:before {\n  content: \"\\f1d2\"; }\n\n.la-github:before {\n  content: \"\\f09b\"; }\n\n.la-github-alt:before {\n  content: \"\\f113\"; }\n\n.la-github-square:before {\n  content: \"\\f092\"; }\n\n.la-gitkraken:before {\n  content: \"\\f3a6\"; }\n\n.la-gitlab:before {\n  content: \"\\f296\"; }\n\n.la-gitter:before {\n  content: \"\\f426\"; }\n\n.la-glass-cheers:before {\n  content: \"\\f79f\"; }\n\n.la-glass-martini:before {\n  content: \"\\f000\"; }\n\n.la-glass-martini-alt:before {\n  content: \"\\f57b\"; }\n\n.la-glass-whiskey:before {\n  content: \"\\f7a0\"; }\n\n.la-glasses:before {\n  content: \"\\f530\"; }\n\n.la-glide:before {\n  content: \"\\f2a5\"; }\n\n.la-glide-g:before {\n  content: \"\\f2a6\"; }\n\n.la-globe:before {\n  content: \"\\f0ac\"; }\n\n.la-globe-africa:before {\n  content: \"\\f57c\"; }\n\n.la-globe-americas:before {\n  content: \"\\f57d\"; }\n\n.la-globe-asia:before {\n  content: \"\\f57e\"; }\n\n.la-globe-europe:before {\n  content: \"\\f7a2\"; }\n\n.la-gofore:before {\n  content: \"\\f3a7\"; }\n\n.la-golf-ball:before {\n  content: \"\\f450\"; }\n\n.la-goodreads:before {\n  content: \"\\f3a8\"; }\n\n.la-goodreads-g:before {\n  content: \"\\f3a9\"; }\n\n.la-google:before {\n  content: \"\\f1a0\"; }\n\n.la-google-drive:before {\n  content: \"\\f3aa\"; }\n\n.la-google-play:before {\n  content: \"\\f3ab\"; }\n\n.la-google-plus:before {\n  content: \"\\f2b3\"; }\n\n.la-google-plus-g:before {\n  content: \"\\f0d5\"; }\n\n.la-google-plus-square:before {\n  content: \"\\f0d4\"; }\n\n.la-google-wallet:before {\n  content: \"\\f1ee\"; }\n\n.la-gopuram:before {\n  content: \"\\f664\"; }\n\n.la-graduation-cap:before {\n  content: \"\\f19d\"; }\n\n.la-gratipay:before {\n  content: \"\\f184\"; }\n\n.la-grav:before {\n  content: \"\\f2d6\"; }\n\n.la-greater-than:before {\n  content: \"\\f531\"; }\n\n.la-greater-than-equal:before {\n  content: \"\\f532\"; }\n\n.la-grimace:before {\n  content: \"\\f57f\"; }\n\n.la-grin:before {\n  content: \"\\f580\"; }\n\n.la-grin-alt:before {\n  content: \"\\f581\"; }\n\n.la-grin-beam:before {\n  content: \"\\f582\"; }\n\n.la-grin-beam-sweat:before {\n  content: \"\\f583\"; }\n\n.la-grin-hearts:before {\n  content: \"\\f584\"; }\n\n.la-grin-squint:before {\n  content: \"\\f585\"; }\n\n.la-grin-squint-tears:before {\n  content: \"\\f586\"; }\n\n.la-grin-stars:before {\n  content: \"\\f587\"; }\n\n.la-grin-tears:before {\n  content: \"\\f588\"; }\n\n.la-grin-tongue:before {\n  content: \"\\f589\"; }\n\n.la-grin-tongue-squint:before {\n  content: \"\\f58a\"; }\n\n.la-grin-tongue-wink:before {\n  content: \"\\f58b\"; }\n\n.la-grin-wink:before {\n  content: \"\\f58c\"; }\n\n.la-grip-horizontal:before {\n  content: \"\\f58d\"; }\n\n.la-grip-lines:before {\n  content: \"\\f7a4\"; }\n\n.la-grip-lines-vertical:before {\n  content: \"\\f7a5\"; }\n\n.la-grip-vertical:before {\n  content: \"\\f58e\"; }\n\n.la-gripfire:before {\n  content: \"\\f3ac\"; }\n\n.la-grunt:before {\n  content: \"\\f3ad\"; }\n\n.la-guitar:before {\n  content: \"\\f7a6\"; }\n\n.la-gulp:before {\n  content: \"\\f3ae\"; }\n\n.la-h-square:before {\n  content: \"\\f0fd\"; }\n\n.la-hacker-news:before {\n  content: \"\\f1d4\"; }\n\n.la-hacker-news-square:before {\n  content: \"\\f3af\"; }\n\n.la-hackerrank:before {\n  content: \"\\f5f7\"; }\n\n.la-hamburger:before {\n  content: \"\\f805\"; }\n\n.la-hammer:before {\n  content: \"\\f6e3\"; }\n\n.la-hamsa:before {\n  content: \"\\f665\"; }\n\n.la-hand-holding:before {\n  content: \"\\f4bd\"; }\n\n.la-hand-holding-heart:before {\n  content: \"\\f4be\"; }\n\n.la-hand-holding-usd:before {\n  content: \"\\f4c0\"; }\n\n.la-hand-lizard:before {\n  content: \"\\f258\"; }\n\n.la-hand-middle-finger:before {\n  content: \"\\f806\"; }\n\n.la-hand-paper:before {\n  content: \"\\f256\"; }\n\n.la-hand-peace:before {\n  content: \"\\f25b\"; }\n\n.la-hand-point-down:before {\n  content: \"\\f0a7\"; }\n\n.la-hand-point-left:before {\n  content: \"\\f0a5\"; }\n\n.la-hand-point-right:before {\n  content: \"\\f0a4\"; }\n\n.la-hand-point-up:before {\n  content: \"\\f0a6\"; }\n\n.la-hand-pointer:before {\n  content: \"\\f25a\"; }\n\n.la-hand-rock:before {\n  content: \"\\f255\"; }\n\n.la-hand-scissors:before {\n  content: \"\\f257\"; }\n\n.la-hand-spock:before {\n  content: \"\\f259\"; }\n\n.la-hands:before {\n  content: \"\\f4c2\"; }\n\n.la-hands-helping:before {\n  content: \"\\f4c4\"; }\n\n.la-handshake:before {\n  content: \"\\f2b5\"; }\n\n.la-hanukiah:before {\n  content: \"\\f6e6\"; }\n\n.la-hard-hat:before {\n  content: \"\\f807\"; }\n\n.la-hashtag:before {\n  content: \"\\f292\"; }\n\n.la-hat-cowboy:before {\n  content: \"\\f8c0\"; }\n\n.la-hat-cowboy-side:before {\n  content: \"\\f8c1\"; }\n\n.la-hat-wizard:before {\n  content: \"\\f6e8\"; }\n\n.la-haykal:before {\n  content: \"\\f666\"; }\n\n.la-hdd:before {\n  content: \"\\f0a0\"; }\n\n.la-heading:before {\n  content: \"\\f1dc\"; }\n\n.la-headphones:before {\n  content: \"\\f025\"; }\n\n.la-headphones-alt:before {\n  content: \"\\f58f\"; }\n\n.la-headset:before {\n  content: \"\\f590\"; }\n\n.la-heart:before {\n  content: \"\\f004\"; }\n\n.la-heart-broken:before {\n  content: \"\\f7a9\"; }\n\n.la-heartbeat:before {\n  content: \"\\f21e\"; }\n\n.la-helicopter:before {\n  content: \"\\f533\"; }\n\n.la-highlighter:before {\n  content: \"\\f591\"; }\n\n.la-hiking:before {\n  content: \"\\f6ec\"; }\n\n.la-hippo:before {\n  content: \"\\f6ed\"; }\n\n.la-hips:before {\n  content: \"\\f452\"; }\n\n.la-hire-a-helper:before {\n  content: \"\\f3b0\"; }\n\n.la-history:before {\n  content: \"\\f1da\"; }\n\n.la-hockey-puck:before {\n  content: \"\\f453\"; }\n\n.la-holly-berry:before {\n  content: \"\\f7aa\"; }\n\n.la-home:before {\n  content: \"\\f015\"; }\n\n.la-hooli:before {\n  content: \"\\f427\"; }\n\n.la-hornbill:before {\n  content: \"\\f592\"; }\n\n.la-horse:before {\n  content: \"\\f6f0\"; }\n\n.la-horse-head:before {\n  content: \"\\f7ab\"; }\n\n.la-hospital:before {\n  content: \"\\f0f8\"; }\n\n.la-hospital-alt:before {\n  content: \"\\f47d\"; }\n\n.la-hospital-symbol:before {\n  content: \"\\f47e\"; }\n\n.la-hot-tub:before {\n  content: \"\\f593\"; }\n\n.la-hotdog:before {\n  content: \"\\f80f\"; }\n\n.la-hotel:before {\n  content: \"\\f594\"; }\n\n.la-hotjar:before {\n  content: \"\\f3b1\"; }\n\n.la-hourglass:before {\n  content: \"\\f254\"; }\n\n.la-hourglass-end:before {\n  content: \"\\f253\"; }\n\n.la-hourglass-half:before {\n  content: \"\\f252\"; }\n\n.la-hourglass-start:before {\n  content: \"\\f251\"; }\n\n.la-house-damage:before {\n  content: \"\\f6f1\"; }\n\n.la-houzz:before {\n  content: \"\\f27c\"; }\n\n.la-hryvnia:before {\n  content: \"\\f6f2\"; }\n\n.la-html5:before {\n  content: \"\\f13b\"; }\n\n.la-hubspot:before {\n  content: \"\\f3b2\"; }\n\n.la-i-cursor:before {\n  content: \"\\f246\"; }\n\n.la-ice-cream:before {\n  content: \"\\f810\"; }\n\n.la-icicles:before {\n  content: \"\\f7ad\"; }\n\n.la-icons:before {\n  content: \"\\f86d\"; }\n\n.la-id-badge:before {\n  content: \"\\f2c1\"; }\n\n.la-id-card:before {\n  content: \"\\f2c2\"; }\n\n.la-id-card-alt:before {\n  content: \"\\f47f\"; }\n\n.la-igloo:before {\n  content: \"\\f7ae\"; }\n\n.la-image:before {\n  content: \"\\f03e\"; }\n\n.la-images:before {\n  content: \"\\f302\"; }\n\n.la-imdb:before {\n  content: \"\\f2d8\"; }\n\n.la-inbox:before {\n  content: \"\\f01c\"; }\n\n.la-indent:before {\n  content: \"\\f03c\"; }\n\n.la-industry:before {\n  content: \"\\f275\"; }\n\n.la-infinity:before {\n  content: \"\\f534\"; }\n\n.la-info:before {\n  content: \"\\f129\"; }\n\n.la-info-circle:before {\n  content: \"\\f05a\"; }\n\n.la-instagram:before {\n  content: \"\\f16d\"; }\n\n.la-intercom:before {\n  content: \"\\f7af\"; }\n\n.la-internet-explorer:before {\n  content: \"\\f26b\"; }\n\n.la-invision:before {\n  content: \"\\f7b0\"; }\n\n.la-ioxhost:before {\n  content: \"\\f208\"; }\n\n.la-italic:before {\n  content: \"\\f033\"; }\n\n.la-itch-io:before {\n  content: \"\\f83a\"; }\n\n.la-itunes:before {\n  content: \"\\f3b4\"; }\n\n.la-itunes-note:before {\n  content: \"\\f3b5\"; }\n\n.la-java:before {\n  content: \"\\f4e4\"; }\n\n.la-jedi:before {\n  content: \"\\f669\"; }\n\n.la-jedi-order:before {\n  content: \"\\f50e\"; }\n\n.la-jenkins:before {\n  content: \"\\f3b6\"; }\n\n.la-jira:before {\n  content: \"\\f7b1\"; }\n\n.la-joget:before {\n  content: \"\\f3b7\"; }\n\n.la-joint:before {\n  content: \"\\f595\"; }\n\n.la-joomla:before {\n  content: \"\\f1aa\"; }\n\n.la-journal-whills:before {\n  content: \"\\f66a\"; }\n\n.la-js:before {\n  content: \"\\f3b8\"; }\n\n.la-js-square:before {\n  content: \"\\f3b9\"; }\n\n.la-jsfiddle:before {\n  content: \"\\f1cc\"; }\n\n.la-kaaba:before {\n  content: \"\\f66b\"; }\n\n.la-kaggle:before {\n  content: \"\\f5fa\"; }\n\n.la-key:before {\n  content: \"\\f084\"; }\n\n.la-keybase:before {\n  content: \"\\f4f5\"; }\n\n.la-keyboard:before {\n  content: \"\\f11c\"; }\n\n.la-keycdn:before {\n  content: \"\\f3ba\"; }\n\n.la-khanda:before {\n  content: \"\\f66d\"; }\n\n.la-kickstarter:before {\n  content: \"\\f3bb\"; }\n\n.la-kickstarter-k:before {\n  content: \"\\f3bc\"; }\n\n.la-kiss:before {\n  content: \"\\f596\"; }\n\n.la-kiss-beam:before {\n  content: \"\\f597\"; }\n\n.la-kiss-wink-heart:before {\n  content: \"\\f598\"; }\n\n.la-kiwi-bird:before {\n  content: \"\\f535\"; }\n\n.la-korvue:before {\n  content: \"\\f42f\"; }\n\n.la-landmark:before {\n  content: \"\\f66f\"; }\n\n.la-language:before {\n  content: \"\\f1ab\"; }\n\n.la-laptop:before {\n  content: \"\\f109\"; }\n\n.la-laptop-code:before {\n  content: \"\\f5fc\"; }\n\n.la-laptop-medical:before {\n  content: \"\\f812\"; }\n\n.la-laravel:before {\n  content: \"\\f3bd\"; }\n\n.la-lastfm:before {\n  content: \"\\f202\"; }\n\n.la-lastfm-square:before {\n  content: \"\\f203\"; }\n\n.la-laugh:before {\n  content: \"\\f599\"; }\n\n.la-laugh-beam:before {\n  content: \"\\f59a\"; }\n\n.la-laugh-squint:before {\n  content: \"\\f59b\"; }\n\n.la-laugh-wink:before {\n  content: \"\\f59c\"; }\n\n.la-layer-group:before {\n  content: \"\\f5fd\"; }\n\n.la-leaf:before {\n  content: \"\\f06c\"; }\n\n.la-leanpub:before {\n  content: \"\\f212\"; }\n\n.la-lemon:before {\n  content: \"\\f094\"; }\n\n.la-less:before {\n  content: \"\\f41d\"; }\n\n.la-less-than:before {\n  content: \"\\f536\"; }\n\n.la-less-than-equal:before {\n  content: \"\\f537\"; }\n\n.la-level-down-alt:before {\n  content: \"\\f3be\"; }\n\n.la-level-up-alt:before {\n  content: \"\\f3bf\"; }\n\n.la-life-ring:before {\n  content: \"\\f1cd\"; }\n\n.la-lightbulb:before {\n  content: \"\\f0eb\"; }\n\n.la-line:before {\n  content: \"\\f3c0\"; }\n\n.la-link:before {\n  content: \"\\f0c1\"; }\n\n.la-linkedin:before {\n  content: \"\\f08c\"; }\n\n.la-linkedin-in:before {\n  content: \"\\f0e1\"; }\n\n.la-linode:before {\n  content: \"\\f2b8\"; }\n\n.la-linux:before {\n  content: \"\\f17c\"; }\n\n.la-lira-sign:before {\n  content: \"\\f195\"; }\n\n.la-list:before {\n  content: \"\\f03a\"; }\n\n.la-list-alt:before {\n  content: \"\\f022\"; }\n\n.la-list-ol:before {\n  content: \"\\f0cb\"; }\n\n.la-list-ul:before {\n  content: \"\\f0ca\"; }\n\n.la-location-arrow:before {\n  content: \"\\f124\"; }\n\n.la-lock:before {\n  content: \"\\f023\"; }\n\n.la-lock-open:before {\n  content: \"\\f3c1\"; }\n\n.la-long-arrow-alt-down:before {\n  content: \"\\f309\"; }\n\n.la-long-arrow-alt-left:before {\n  content: \"\\f30a\"; }\n\n.la-long-arrow-alt-right:before {\n  content: \"\\f30b\"; }\n\n.la-long-arrow-alt-up:before {\n  content: \"\\f30c\"; }\n\n.la-low-vision:before {\n  content: \"\\f2a8\"; }\n\n.la-luggage-cart:before {\n  content: \"\\f59d\"; }\n\n.la-lyft:before {\n  content: \"\\f3c3\"; }\n\n.la-magento:before {\n  content: \"\\f3c4\"; }\n\n.la-magic:before {\n  content: \"\\f0d0\"; }\n\n.la-magnet:before {\n  content: \"\\f076\"; }\n\n.la-mail-bulk:before {\n  content: \"\\f674\"; }\n\n.la-mailchimp:before {\n  content: \"\\f59e\"; }\n\n.la-male:before {\n  content: \"\\f183\"; }\n\n.la-mandalorian:before {\n  content: \"\\f50f\"; }\n\n.la-map:before {\n  content: \"\\f279\"; }\n\n.la-map-marked:before {\n  content: \"\\f59f\"; }\n\n.la-map-marked-alt:before {\n  content: \"\\f5a0\"; }\n\n.la-map-marker:before {\n  content: \"\\f041\"; }\n\n.la-map-marker-alt:before {\n  content: \"\\f3c5\"; }\n\n.la-map-pin:before {\n  content: \"\\f276\"; }\n\n.la-map-signs:before {\n  content: \"\\f277\"; }\n\n.la-markdown:before {\n  content: \"\\f60f\"; }\n\n.la-marker:before {\n  content: \"\\f5a1\"; }\n\n.la-mars:before {\n  content: \"\\f222\"; }\n\n.la-mars-double:before {\n  content: \"\\f227\"; }\n\n.la-mars-stroke:before {\n  content: \"\\f229\"; }\n\n.la-mars-stroke-h:before {\n  content: \"\\f22b\"; }\n\n.la-mars-stroke-v:before {\n  content: \"\\f22a\"; }\n\n.la-mask:before {\n  content: \"\\f6fa\"; }\n\n.la-mastodon:before {\n  content: \"\\f4f6\"; }\n\n.la-maxcdn:before {\n  content: \"\\f136\"; }\n\n.la-mdb:before {\n  content: \"\\f8ca\"; }\n\n.la-medal:before {\n  content: \"\\f5a2\"; }\n\n.la-medapps:before {\n  content: \"\\f3c6\"; }\n\n.la-medium:before {\n  content: \"\\f23a\"; }\n\n.la-medium-m:before {\n  content: \"\\f3c7\"; }\n\n.la-medkit:before {\n  content: \"\\f0fa\"; }\n\n.la-medrt:before {\n  content: \"\\f3c8\"; }\n\n.la-meetup:before {\n  content: \"\\f2e0\"; }\n\n.la-megaport:before {\n  content: \"\\f5a3\"; }\n\n.la-meh:before {\n  content: \"\\f11a\"; }\n\n.la-meh-blank:before {\n  content: \"\\f5a4\"; }\n\n.la-meh-rolling-eyes:before {\n  content: \"\\f5a5\"; }\n\n.la-memory:before {\n  content: \"\\f538\"; }\n\n.la-mendeley:before {\n  content: \"\\f7b3\"; }\n\n.la-menorah:before {\n  content: \"\\f676\"; }\n\n.la-mercury:before {\n  content: \"\\f223\"; }\n\n.la-meteor:before {\n  content: \"\\f753\"; }\n\n.la-microchip:before {\n  content: \"\\f2db\"; }\n\n.la-microphone:before {\n  content: \"\\f130\"; }\n\n.la-microphone-alt:before {\n  content: \"\\f3c9\"; }\n\n.la-microphone-alt-slash:before {\n  content: \"\\f539\"; }\n\n.la-microphone-slash:before {\n  content: \"\\f131\"; }\n\n.la-microscope:before {\n  content: \"\\f610\"; }\n\n.la-microsoft:before {\n  content: \"\\f3ca\"; }\n\n.la-minus:before {\n  content: \"\\f068\"; }\n\n.la-minus-circle:before {\n  content: \"\\f056\"; }\n\n.la-minus-square:before {\n  content: \"\\f146\"; }\n\n.la-mitten:before {\n  content: \"\\f7b5\"; }\n\n.la-mix:before {\n  content: \"\\f3cb\"; }\n\n.la-mixcloud:before {\n  content: \"\\f289\"; }\n\n.la-mizuni:before {\n  content: \"\\f3cc\"; }\n\n.la-mobile:before {\n  content: \"\\f10b\"; }\n\n.la-mobile-alt:before {\n  content: \"\\f3cd\"; }\n\n.la-modx:before {\n  content: \"\\f285\"; }\n\n.la-monero:before {\n  content: \"\\f3d0\"; }\n\n.la-money-bill:before {\n  content: \"\\f0d6\"; }\n\n.la-money-bill-alt:before {\n  content: \"\\f3d1\"; }\n\n.la-money-bill-wave:before {\n  content: \"\\f53a\"; }\n\n.la-money-bill-wave-alt:before {\n  content: \"\\f53b\"; }\n\n.la-money-check:before {\n  content: \"\\f53c\"; }\n\n.la-money-check-alt:before {\n  content: \"\\f53d\"; }\n\n.la-monument:before {\n  content: \"\\f5a6\"; }\n\n.la-moon:before {\n  content: \"\\f186\"; }\n\n.la-mortar-pestle:before {\n  content: \"\\f5a7\"; }\n\n.la-mosque:before {\n  content: \"\\f678\"; }\n\n.la-motorcycle:before {\n  content: \"\\f21c\"; }\n\n.la-mountain:before {\n  content: \"\\f6fc\"; }\n\n.la-mouse:before {\n  content: \"\\f8cc\"; }\n\n.la-mouse-pointer:before {\n  content: \"\\f245\"; }\n\n.la-mug-hot:before {\n  content: \"\\f7b6\"; }\n\n.la-music:before {\n  content: \"\\f001\"; }\n\n.la-napster:before {\n  content: \"\\f3d2\"; }\n\n.la-neos:before {\n  content: \"\\f612\"; }\n\n.la-network-wired:before {\n  content: \"\\f6ff\"; }\n\n.la-neuter:before {\n  content: \"\\f22c\"; }\n\n.la-newspaper:before {\n  content: \"\\f1ea\"; }\n\n.la-nimblr:before {\n  content: \"\\f5a8\"; }\n\n.la-node:before {\n  content: \"\\f419\"; }\n\n.la-node-js:before {\n  content: \"\\f3d3\"; }\n\n.la-not-equal:before {\n  content: \"\\f53e\"; }\n\n.la-notes-medical:before {\n  content: \"\\f481\"; }\n\n.la-npm:before {\n  content: \"\\f3d4\"; }\n\n.la-ns8:before {\n  content: \"\\f3d5\"; }\n\n.la-nutritionix:before {\n  content: \"\\f3d6\"; }\n\n.la-object-group:before {\n  content: \"\\f247\"; }\n\n.la-object-ungroup:before {\n  content: \"\\f248\"; }\n\n.la-odnoklassniki:before {\n  content: \"\\f263\"; }\n\n.la-odnoklassniki-square:before {\n  content: \"\\f264\"; }\n\n.la-oil-can:before {\n  content: \"\\f613\"; }\n\n.la-old-republic:before {\n  content: \"\\f510\"; }\n\n.la-om:before {\n  content: \"\\f679\"; }\n\n.la-opencart:before {\n  content: \"\\f23d\"; }\n\n.la-openid:before {\n  content: \"\\f19b\"; }\n\n.la-opera:before {\n  content: \"\\f26a\"; }\n\n.la-optin-monster:before {\n  content: \"\\f23c\"; }\n\n.la-orcid:before {\n  content: \"\\f8d2\"; }\n\n.la-osi:before {\n  content: \"\\f41a\"; }\n\n.la-otter:before {\n  content: \"\\f700\"; }\n\n.la-outdent:before {\n  content: \"\\f03b\"; }\n\n.la-page4:before {\n  content: \"\\f3d7\"; }\n\n.la-pagelines:before {\n  content: \"\\f18c\"; }\n\n.la-pager:before {\n  content: \"\\f815\"; }\n\n.la-paint-brush:before {\n  content: \"\\f1fc\"; }\n\n.la-paint-roller:before {\n  content: \"\\f5aa\"; }\n\n.la-palette:before {\n  content: \"\\f53f\"; }\n\n.la-palfed:before {\n  content: \"\\f3d8\"; }\n\n.la-pallet:before {\n  content: \"\\f482\"; }\n\n.la-paper-plane:before {\n  content: \"\\f1d8\"; }\n\n.la-paperclip:before {\n  content: \"\\f0c6\"; }\n\n.la-parachute-box:before {\n  content: \"\\f4cd\"; }\n\n.la-paragraph:before {\n  content: \"\\f1dd\"; }\n\n.la-parking:before {\n  content: \"\\f540\"; }\n\n.la-passport:before {\n  content: \"\\f5ab\"; }\n\n.la-pastafarianism:before {\n  content: \"\\f67b\"; }\n\n.la-paste:before {\n  content: \"\\f0ea\"; }\n\n.la-patreon:before {\n  content: \"\\f3d9\"; }\n\n.la-pause:before {\n  content: \"\\f04c\"; }\n\n.la-pause-circle:before {\n  content: \"\\f28b\"; }\n\n.la-paw:before {\n  content: \"\\f1b0\"; }\n\n.la-paypal:before {\n  content: \"\\f1ed\"; }\n\n.la-peace:before {\n  content: \"\\f67c\"; }\n\n.la-pen:before {\n  content: \"\\f304\"; }\n\n.la-pen-alt:before {\n  content: \"\\f305\"; }\n\n.la-pen-fancy:before {\n  content: \"\\f5ac\"; }\n\n.la-pen-nib:before {\n  content: \"\\f5ad\"; }\n\n.la-pen-square:before {\n  content: \"\\f14b\"; }\n\n.la-pencil-alt:before {\n  content: \"\\f303\"; }\n\n.la-pencil-ruler:before {\n  content: \"\\f5ae\"; }\n\n.la-penny-arcade:before {\n  content: \"\\f704\"; }\n\n.la-people-carry:before {\n  content: \"\\f4ce\"; }\n\n.la-pepper-hot:before {\n  content: \"\\f816\"; }\n\n.la-percent:before {\n  content: \"\\f295\"; }\n\n.la-percentage:before {\n  content: \"\\f541\"; }\n\n.la-periscope:before {\n  content: \"\\f3da\"; }\n\n.la-person-booth:before {\n  content: \"\\f756\"; }\n\n.la-phabricator:before {\n  content: \"\\f3db\"; }\n\n.la-phoenix-framework:before {\n  content: \"\\f3dc\"; }\n\n.la-phoenix-squadron:before {\n  content: \"\\f511\"; }\n\n.la-phone:before {\n  content: \"\\f095\"; }\n\n.la-phone-alt:before {\n  content: \"\\f879\"; }\n\n.la-phone-slash:before {\n  content: \"\\f3dd\"; }\n\n.la-phone-square:before {\n  content: \"\\f098\"; }\n\n.la-phone-square-alt:before {\n  content: \"\\f87b\"; }\n\n.la-phone-volume:before {\n  content: \"\\f2a0\"; }\n\n.la-photo-video:before {\n  content: \"\\f87c\"; }\n\n.la-php:before {\n  content: \"\\f457\"; }\n\n.la-pied-piper:before {\n  content: \"\\f2ae\"; }\n\n.la-pied-piper-alt:before {\n  content: \"\\f1a8\"; }\n\n.la-pied-piper-hat:before {\n  content: \"\\f4e5\"; }\n\n.la-pied-piper-pp:before {\n  content: \"\\f1a7\"; }\n\n.la-piggy-bank:before {\n  content: \"\\f4d3\"; }\n\n.la-pills:before {\n  content: \"\\f484\"; }\n\n.la-pinterest:before {\n  content: \"\\f0d2\"; }\n\n.la-pinterest-p:before {\n  content: \"\\f231\"; }\n\n.la-pinterest-square:before {\n  content: \"\\f0d3\"; }\n\n.la-pizza-slice:before {\n  content: \"\\f818\"; }\n\n.la-place-of-worship:before {\n  content: \"\\f67f\"; }\n\n.la-plane:before {\n  content: \"\\f072\"; }\n\n.la-plane-arrival:before {\n  content: \"\\f5af\"; }\n\n.la-plane-departure:before {\n  content: \"\\f5b0\"; }\n\n.la-play:before {\n  content: \"\\f04b\"; }\n\n.la-play-circle:before {\n  content: \"\\f144\"; }\n\n.la-playstation:before {\n  content: \"\\f3df\"; }\n\n.la-plug:before {\n  content: \"\\f1e6\"; }\n\n.la-plus:before {\n  content: \"\\f067\"; }\n\n.la-plus-circle:before {\n  content: \"\\f055\"; }\n\n.la-plus-square:before {\n  content: \"\\f0fe\"; }\n\n.la-podcast:before {\n  content: \"\\f2ce\"; }\n\n.la-poll:before {\n  content: \"\\f681\"; }\n\n.la-poll-h:before {\n  content: \"\\f682\"; }\n\n.la-poo:before {\n  content: \"\\f2fe\"; }\n\n.la-poo-storm:before {\n  content: \"\\f75a\"; }\n\n.la-poop:before {\n  content: \"\\f619\"; }\n\n.la-portrait:before {\n  content: \"\\f3e0\"; }\n\n.la-pound-sign:before {\n  content: \"\\f154\"; }\n\n.la-power-off:before {\n  content: \"\\f011\"; }\n\n.la-pray:before {\n  content: \"\\f683\"; }\n\n.la-praying-hands:before {\n  content: \"\\f684\"; }\n\n.la-prescription:before {\n  content: \"\\f5b1\"; }\n\n.la-prescription-bottle:before {\n  content: \"\\f485\"; }\n\n.la-prescription-bottle-alt:before {\n  content: \"\\f486\"; }\n\n.la-print:before {\n  content: \"\\f02f\"; }\n\n.la-procedures:before {\n  content: \"\\f487\"; }\n\n.la-product-hunt:before {\n  content: \"\\f288\"; }\n\n.la-project-diagram:before {\n  content: \"\\f542\"; }\n\n.la-pushed:before {\n  content: \"\\f3e1\"; }\n\n.la-puzzle-piece:before {\n  content: \"\\f12e\"; }\n\n.la-python:before {\n  content: \"\\f3e2\"; }\n\n.la-qq:before {\n  content: \"\\f1d6\"; }\n\n.la-qrcode:before {\n  content: \"\\f029\"; }\n\n.la-question:before {\n  content: \"\\f128\"; }\n\n.la-question-circle:before {\n  content: \"\\f059\"; }\n\n.la-quidditch:before {\n  content: \"\\f458\"; }\n\n.la-quinscape:before {\n  content: \"\\f459\"; }\n\n.la-quora:before {\n  content: \"\\f2c4\"; }\n\n.la-quote-left:before {\n  content: \"\\f10d\"; }\n\n.la-quote-right:before {\n  content: \"\\f10e\"; }\n\n.la-quran:before {\n  content: \"\\f687\"; }\n\n.la-r-project:before {\n  content: \"\\f4f7\"; }\n\n.la-radiation:before {\n  content: \"\\f7b9\"; }\n\n.la-radiation-alt:before {\n  content: \"\\f7ba\"; }\n\n.la-rainbow:before {\n  content: \"\\f75b\"; }\n\n.la-random:before {\n  content: \"\\f074\"; }\n\n.la-raspberry-pi:before {\n  content: \"\\f7bb\"; }\n\n.la-ravelry:before {\n  content: \"\\f2d9\"; }\n\n.la-react:before {\n  content: \"\\f41b\"; }\n\n.la-reacteurope:before {\n  content: \"\\f75d\"; }\n\n.la-readme:before {\n  content: \"\\f4d5\"; }\n\n.la-rebel:before {\n  content: \"\\f1d0\"; }\n\n.la-receipt:before {\n  content: \"\\f543\"; }\n\n.la-record-vinyl:before {\n  content: \"\\f8d9\"; }\n\n.la-recycle:before {\n  content: \"\\f1b8\"; }\n\n.la-red-river:before {\n  content: \"\\f3e3\"; }\n\n.la-reddit:before {\n  content: \"\\f1a1\"; }\n\n.la-reddit-alien:before {\n  content: \"\\f281\"; }\n\n.la-reddit-square:before {\n  content: \"\\f1a2\"; }\n\n.la-redhat:before {\n  content: \"\\f7bc\"; }\n\n.la-redo:before {\n  content: \"\\f01e\"; }\n\n.la-redo-alt:before {\n  content: \"\\f2f9\"; }\n\n.la-registered:before {\n  content: \"\\f25d\"; }\n\n.la-remove-format:before {\n  content: \"\\f87d\"; }\n\n.la-renren:before {\n  content: \"\\f18b\"; }\n\n.la-reply:before {\n  content: \"\\f3e5\"; }\n\n.la-reply-all:before {\n  content: \"\\f122\"; }\n\n.la-replyd:before {\n  content: \"\\f3e6\"; }\n\n.la-republican:before {\n  content: \"\\f75e\"; }\n\n.la-researchgate:before {\n  content: \"\\f4f8\"; }\n\n.la-resolving:before {\n  content: \"\\f3e7\"; }\n\n.la-restroom:before {\n  content: \"\\f7bd\"; }\n\n.la-retweet:before {\n  content: \"\\f079\"; }\n\n.la-rev:before {\n  content: \"\\f5b2\"; }\n\n.la-ribbon:before {\n  content: \"\\f4d6\"; }\n\n.la-ring:before {\n  content: \"\\f70b\"; }\n\n.la-road:before {\n  content: \"\\f018\"; }\n\n.la-robot:before {\n  content: \"\\f544\"; }\n\n.la-rocket:before {\n  content: \"\\f135\"; }\n\n.la-rocketchat:before {\n  content: \"\\f3e8\"; }\n\n.la-rockrms:before {\n  content: \"\\f3e9\"; }\n\n.la-route:before {\n  content: \"\\f4d7\"; }\n\n.la-rss:before {\n  content: \"\\f09e\"; }\n\n.la-rss-square:before {\n  content: \"\\f143\"; }\n\n.la-ruble-sign:before {\n  content: \"\\f158\"; }\n\n.la-ruler:before {\n  content: \"\\f545\"; }\n\n.la-ruler-combined:before {\n  content: \"\\f546\"; }\n\n.la-ruler-horizontal:before {\n  content: \"\\f547\"; }\n\n.la-ruler-vertical:before {\n  content: \"\\f548\"; }\n\n.la-running:before {\n  content: \"\\f70c\"; }\n\n.la-rupee-sign:before {\n  content: \"\\f156\"; }\n\n.la-sad-cry:before {\n  content: \"\\f5b3\"; }\n\n.la-sad-tear:before {\n  content: \"\\f5b4\"; }\n\n.la-safari:before {\n  content: \"\\f267\"; }\n\n.la-salesforce:before {\n  content: \"\\f83b\"; }\n\n.la-sass:before {\n  content: \"\\f41e\"; }\n\n.la-satellite:before {\n  content: \"\\f7bf\"; }\n\n.la-satellite-dish:before {\n  content: \"\\f7c0\"; }\n\n.la-save:before {\n  content: \"\\f0c7\"; }\n\n.la-schlix:before {\n  content: \"\\f3ea\"; }\n\n.la-school:before {\n  content: \"\\f549\"; }\n\n.la-screwdriver:before {\n  content: \"\\f54a\"; }\n\n.la-scribd:before {\n  content: \"\\f28a\"; }\n\n.la-scroll:before {\n  content: \"\\f70e\"; }\n\n.la-sd-card:before {\n  content: \"\\f7c2\"; }\n\n.la-search:before {\n  content: \"\\f002\"; }\n\n.la-search-dollar:before {\n  content: \"\\f688\"; }\n\n.la-search-location:before {\n  content: \"\\f689\"; }\n\n.la-search-minus:before {\n  content: \"\\f010\"; }\n\n.la-search-plus:before {\n  content: \"\\f00e\"; }\n\n.la-searchengin:before {\n  content: \"\\f3eb\"; }\n\n.la-seedling:before {\n  content: \"\\f4d8\"; }\n\n.la-sellcast:before {\n  content: \"\\f2da\"; }\n\n.la-sellsy:before {\n  content: \"\\f213\"; }\n\n.la-server:before {\n  content: \"\\f233\"; }\n\n.la-servicestack:before {\n  content: \"\\f3ec\"; }\n\n.la-shapes:before {\n  content: \"\\f61f\"; }\n\n.la-share:before {\n  content: \"\\f064\"; }\n\n.la-share-alt:before {\n  content: \"\\f1e0\"; }\n\n.la-share-alt-square:before {\n  content: \"\\f1e1\"; }\n\n.la-share-square:before {\n  content: \"\\f14d\"; }\n\n.la-shekel-sign:before {\n  content: \"\\f20b\"; }\n\n.la-shield-alt:before {\n  content: \"\\f3ed\"; }\n\n.la-ship:before {\n  content: \"\\f21a\"; }\n\n.la-shipping-fast:before {\n  content: \"\\f48b\"; }\n\n.la-shirtsinbulk:before {\n  content: \"\\f214\"; }\n\n.la-shoe-prints:before {\n  content: \"\\f54b\"; }\n\n.la-shopping-bag:before {\n  content: \"\\f290\"; }\n\n.la-shopping-basket:before {\n  content: \"\\f291\"; }\n\n.la-shopping-cart:before {\n  content: \"\\f07a\"; }\n\n.la-shopware:before {\n  content: \"\\f5b5\"; }\n\n.la-shower:before {\n  content: \"\\f2cc\"; }\n\n.la-shuttle-van:before {\n  content: \"\\f5b6\"; }\n\n.la-sign:before {\n  content: \"\\f4d9\"; }\n\n.la-sign-in-alt:before {\n  content: \"\\f2f6\"; }\n\n.la-sign-language:before {\n  content: \"\\f2a7\"; }\n\n.la-sign-out-alt:before {\n  content: \"\\f2f5\"; }\n\n.la-signal:before {\n  content: \"\\f012\"; }\n\n.la-signature:before {\n  content: \"\\f5b7\"; }\n\n.la-sim-card:before {\n  content: \"\\f7c4\"; }\n\n.la-simplybuilt:before {\n  content: \"\\f215\"; }\n\n.la-sistrix:before {\n  content: \"\\f3ee\"; }\n\n.la-sitemap:before {\n  content: \"\\f0e8\"; }\n\n.la-sith:before {\n  content: \"\\f512\"; }\n\n.la-skating:before {\n  content: \"\\f7c5\"; }\n\n.la-sketch:before {\n  content: \"\\f7c6\"; }\n\n.la-skiing:before {\n  content: \"\\f7c9\"; }\n\n.la-skiing-nordic:before {\n  content: \"\\f7ca\"; }\n\n.la-skull:before {\n  content: \"\\f54c\"; }\n\n.la-skull-crossbones:before {\n  content: \"\\f714\"; }\n\n.la-skyatlas:before {\n  content: \"\\f216\"; }\n\n.la-skype:before {\n  content: \"\\f17e\"; }\n\n.la-slack:before {\n  content: \"\\f198\"; }\n\n.la-slack-hash:before {\n  content: \"\\f3ef\"; }\n\n.la-slash:before {\n  content: \"\\f715\"; }\n\n.la-sleigh:before {\n  content: \"\\f7cc\"; }\n\n.la-sliders-h:before {\n  content: \"\\f1de\"; }\n\n.la-slideshare:before {\n  content: \"\\f1e7\"; }\n\n.la-smile:before {\n  content: \"\\f118\"; }\n\n.la-smile-beam:before {\n  content: \"\\f5b8\"; }\n\n.la-smile-wink:before {\n  content: \"\\f4da\"; }\n\n.la-smog:before {\n  content: \"\\f75f\"; }\n\n.la-smoking:before {\n  content: \"\\f48d\"; }\n\n.la-smoking-ban:before {\n  content: \"\\f54d\"; }\n\n.la-sms:before {\n  content: \"\\f7cd\"; }\n\n.la-snapchat:before {\n  content: \"\\f2ab\"; }\n\n.la-snapchat-ghost:before {\n  content: \"\\f2ac\"; }\n\n.la-snapchat-square:before {\n  content: \"\\f2ad\"; }\n\n.la-snowboarding:before {\n  content: \"\\f7ce\"; }\n\n.la-snowflake:before {\n  content: \"\\f2dc\"; }\n\n.la-snowman:before {\n  content: \"\\f7d0\"; }\n\n.la-snowplow:before {\n  content: \"\\f7d2\"; }\n\n.la-socks:before {\n  content: \"\\f696\"; }\n\n.la-solar-panel:before {\n  content: \"\\f5ba\"; }\n\n.la-sort:before {\n  content: \"\\f0dc\"; }\n\n.la-sort-alpha-down:before {\n  content: \"\\f15d\"; }\n\n.la-sort-alpha-down-alt:before {\n  content: \"\\f881\"; }\n\n.la-sort-alpha-up:before {\n  content: \"\\f15e\"; }\n\n.la-sort-alpha-up-alt:before {\n  content: \"\\f882\"; }\n\n.la-sort-amount-down:before {\n  content: \"\\f160\"; }\n\n.la-sort-amount-down-alt:before {\n  content: \"\\f884\"; }\n\n.la-sort-amount-up:before {\n  content: \"\\f161\"; }\n\n.la-sort-amount-up-alt:before {\n  content: \"\\f885\"; }\n\n.la-sort-down:before {\n  content: \"\\f0dd\"; }\n\n.la-sort-numeric-down:before {\n  content: \"\\f162\"; }\n\n.la-sort-numeric-down-alt:before {\n  content: \"\\f886\"; }\n\n.la-sort-numeric-up:before {\n  content: \"\\f163\"; }\n\n.la-sort-numeric-up-alt:before {\n  content: \"\\f887\"; }\n\n.la-sort-up:before {\n  content: \"\\f0de\"; }\n\n.la-soundcloud:before {\n  content: \"\\f1be\"; }\n\n.la-sourcetree:before {\n  content: \"\\f7d3\"; }\n\n.la-spa:before {\n  content: \"\\f5bb\"; }\n\n.la-space-shuttle:before {\n  content: \"\\f197\"; }\n\n.la-speakap:before {\n  content: \"\\f3f3\"; }\n\n.la-speaker-deck:before {\n  content: \"\\f83c\"; }\n\n.la-spell-check:before {\n  content: \"\\f891\"; }\n\n.la-spider:before {\n  content: \"\\f717\"; }\n\n.la-spinner:before {\n  content: \"\\f110\"; }\n\n.la-splotch:before {\n  content: \"\\f5bc\"; }\n\n.la-spotify:before {\n  content: \"\\f1bc\"; }\n\n.la-spray-can:before {\n  content: \"\\f5bd\"; }\n\n.la-square:before {\n  content: \"\\f0c8\"; }\n\n.la-square-full:before {\n  content: \"\\f45c\"; }\n\n.la-square-root-alt:before {\n  content: \"\\f698\"; }\n\n.la-squarespace:before {\n  content: \"\\f5be\"; }\n\n.la-stack-exchange:before {\n  content: \"\\f18d\"; }\n\n.la-stack-overflow:before {\n  content: \"\\f16c\"; }\n\n.la-stackpath:before {\n  content: \"\\f842\"; }\n\n.la-stamp:before {\n  content: \"\\f5bf\"; }\n\n.la-star:before {\n  content: \"\\f005\"; }\n\n.la-star-and-crescent:before {\n  content: \"\\f699\"; }\n\n.la-star-half:before {\n  content: \"\\f089\"; }\n\n.la-star-half-alt:before {\n  content: \"\\f5c0\"; }\n\n.la-star-of-david:before {\n  content: \"\\f69a\"; }\n\n.la-star-of-life:before {\n  content: \"\\f621\"; }\n\n.la-staylinked:before {\n  content: \"\\f3f5\"; }\n\n.la-steam:before {\n  content: \"\\f1b6\"; }\n\n.la-steam-square:before {\n  content: \"\\f1b7\"; }\n\n.la-steam-symbol:before {\n  content: \"\\f3f6\"; }\n\n.la-step-backward:before {\n  content: \"\\f048\"; }\n\n.la-step-forward:before {\n  content: \"\\f051\"; }\n\n.la-stethoscope:before {\n  content: \"\\f0f1\"; }\n\n.la-sticker-mule:before {\n  content: \"\\f3f7\"; }\n\n.la-sticky-note:before {\n  content: \"\\f249\"; }\n\n.la-stop:before {\n  content: \"\\f04d\"; }\n\n.la-stop-circle:before {\n  content: \"\\f28d\"; }\n\n.la-stopwatch:before {\n  content: \"\\f2f2\"; }\n\n.la-store:before {\n  content: \"\\f54e\"; }\n\n.la-store-alt:before {\n  content: \"\\f54f\"; }\n\n.la-strava:before {\n  content: \"\\f428\"; }\n\n.la-stream:before {\n  content: \"\\f550\"; }\n\n.la-street-view:before {\n  content: \"\\f21d\"; }\n\n.la-strikethrough:before {\n  content: \"\\f0cc\"; }\n\n.la-stripe:before {\n  content: \"\\f429\"; }\n\n.la-stripe-s:before {\n  content: \"\\f42a\"; }\n\n.la-stroopwafel:before {\n  content: \"\\f551\"; }\n\n.la-studiovinari:before {\n  content: \"\\f3f8\"; }\n\n.la-stumbleupon:before {\n  content: \"\\f1a4\"; }\n\n.la-stumbleupon-circle:before {\n  content: \"\\f1a3\"; }\n\n.la-subscript:before {\n  content: \"\\f12c\"; }\n\n.la-subway:before {\n  content: \"\\f239\"; }\n\n.la-suitcase:before {\n  content: \"\\f0f2\"; }\n\n.la-suitcase-rolling:before {\n  content: \"\\f5c1\"; }\n\n.la-sun:before {\n  content: \"\\f185\"; }\n\n.la-superpowers:before {\n  content: \"\\f2dd\"; }\n\n.la-superscript:before {\n  content: \"\\f12b\"; }\n\n.la-supple:before {\n  content: \"\\f3f9\"; }\n\n.la-surprise:before {\n  content: \"\\f5c2\"; }\n\n.la-suse:before {\n  content: \"\\f7d6\"; }\n\n.la-swatchbook:before {\n  content: \"\\f5c3\"; }\n\n.la-swift:before {\n  content: \"\\f8e1\"; }\n\n.la-swimmer:before {\n  content: \"\\f5c4\"; }\n\n.la-swimming-pool:before {\n  content: \"\\f5c5\"; }\n\n.la-symfony:before {\n  content: \"\\f83d\"; }\n\n.la-synagogue:before {\n  content: \"\\f69b\"; }\n\n.la-sync:before {\n  content: \"\\f021\"; }\n\n.la-sync-alt:before {\n  content: \"\\f2f1\"; }\n\n.la-syringe:before {\n  content: \"\\f48e\"; }\n\n.la-table:before {\n  content: \"\\f0ce\"; }\n\n.la-table-tennis:before {\n  content: \"\\f45d\"; }\n\n.la-tablet:before {\n  content: \"\\f10a\"; }\n\n.la-tablet-alt:before {\n  content: \"\\f3fa\"; }\n\n.la-tablets:before {\n  content: \"\\f490\"; }\n\n.la-tachometer-alt:before {\n  content: \"\\f3fd\"; }\n\n.la-tag:before {\n  content: \"\\f02b\"; }\n\n.la-tags:before {\n  content: \"\\f02c\"; }\n\n.la-tape:before {\n  content: \"\\f4db\"; }\n\n.la-tasks:before {\n  content: \"\\f0ae\"; }\n\n.la-taxi:before {\n  content: \"\\f1ba\"; }\n\n.la-teamspeak:before {\n  content: \"\\f4f9\"; }\n\n.la-teeth:before {\n  content: \"\\f62e\"; }\n\n.la-teeth-open:before {\n  content: \"\\f62f\"; }\n\n.la-telegram:before {\n  content: \"\\f2c6\"; }\n\n.la-telegram-plane:before {\n  content: \"\\f3fe\"; }\n\n.la-temperature-high:before {\n  content: \"\\f769\"; }\n\n.la-temperature-low:before {\n  content: \"\\f76b\"; }\n\n.la-tencent-weibo:before {\n  content: \"\\f1d5\"; }\n\n.la-tenge:before {\n  content: \"\\f7d7\"; }\n\n.la-terminal:before {\n  content: \"\\f120\"; }\n\n.la-text-height:before {\n  content: \"\\f034\"; }\n\n.la-text-width:before {\n  content: \"\\f035\"; }\n\n.la-th:before {\n  content: \"\\f00a\"; }\n\n.la-th-large:before {\n  content: \"\\f009\"; }\n\n.la-th-list:before {\n  content: \"\\f00b\"; }\n\n.la-the-red-yeti:before {\n  content: \"\\f69d\"; }\n\n.la-theater-masks:before {\n  content: \"\\f630\"; }\n\n.la-themeco:before {\n  content: \"\\f5c6\"; }\n\n.la-themeisle:before {\n  content: \"\\f2b2\"; }\n\n.la-thermometer:before {\n  content: \"\\f491\"; }\n\n.la-thermometer-empty:before {\n  content: \"\\f2cb\"; }\n\n.la-thermometer-full:before {\n  content: \"\\f2c7\"; }\n\n.la-thermometer-half:before {\n  content: \"\\f2c9\"; }\n\n.la-thermometer-quarter:before {\n  content: \"\\f2ca\"; }\n\n.la-thermometer-three-quarters:before {\n  content: \"\\f2c8\"; }\n\n.la-think-peaks:before {\n  content: \"\\f731\"; }\n\n.la-thumbs-down:before {\n  content: \"\\f165\"; }\n\n.la-thumbs-up:before {\n  content: \"\\f164\"; }\n\n.la-thumbtack:before {\n  content: \"\\f08d\"; }\n\n.la-ticket-alt:before {\n  content: \"\\f3ff\"; }\n\n.la-times:before {\n  content: \"\\f00d\"; }\n\n.la-times-circle:before {\n  content: \"\\f057\"; }\n\n.la-tint:before {\n  content: \"\\f043\"; }\n\n.la-tint-slash:before {\n  content: \"\\f5c7\"; }\n\n.la-tired:before {\n  content: \"\\f5c8\"; }\n\n.la-toggle-off:before {\n  content: \"\\f204\"; }\n\n.la-toggle-on:before {\n  content: \"\\f205\"; }\n\n.la-toilet:before {\n  content: \"\\f7d8\"; }\n\n.la-toilet-paper:before {\n  content: \"\\f71e\"; }\n\n.la-toolbox:before {\n  content: \"\\f552\"; }\n\n.la-tools:before {\n  content: \"\\f7d9\"; }\n\n.la-tooth:before {\n  content: \"\\f5c9\"; }\n\n.la-torah:before {\n  content: \"\\f6a0\"; }\n\n.la-torii-gate:before {\n  content: \"\\f6a1\"; }\n\n.la-tractor:before {\n  content: \"\\f722\"; }\n\n.la-trade-federation:before {\n  content: \"\\f513\"; }\n\n.la-trademark:before {\n  content: \"\\f25c\"; }\n\n.la-traffic-light:before {\n  content: \"\\f637\"; }\n\n.la-train:before {\n  content: \"\\f238\"; }\n\n.la-tram:before {\n  content: \"\\f7da\"; }\n\n.la-transgender:before {\n  content: \"\\f224\"; }\n\n.la-transgender-alt:before {\n  content: \"\\f225\"; }\n\n.la-trash:before {\n  content: \"\\f1f8\"; }\n\n.la-trash-alt:before {\n  content: \"\\f2ed\"; }\n\n.la-trash-restore:before {\n  content: \"\\f829\"; }\n\n.la-trash-restore-alt:before {\n  content: \"\\f82a\"; }\n\n.la-tree:before {\n  content: \"\\f1bb\"; }\n\n.la-trello:before {\n  content: \"\\f181\"; }\n\n.la-tripadvisor:before {\n  content: \"\\f262\"; }\n\n.la-trophy:before {\n  content: \"\\f091\"; }\n\n.la-truck:before {\n  content: \"\\f0d1\"; }\n\n.la-truck-loading:before {\n  content: \"\\f4de\"; }\n\n.la-truck-monster:before {\n  content: \"\\f63b\"; }\n\n.la-truck-moving:before {\n  content: \"\\f4df\"; }\n\n.la-truck-pickup:before {\n  content: \"\\f63c\"; }\n\n.la-tshirt:before {\n  content: \"\\f553\"; }\n\n.la-tty:before {\n  content: \"\\f1e4\"; }\n\n.la-tumblr:before {\n  content: \"\\f173\"; }\n\n.la-tumblr-square:before {\n  content: \"\\f174\"; }\n\n.la-tv:before {\n  content: \"\\f26c\"; }\n\n.la-twitch:before {\n  content: \"\\f1e8\"; }\n\n.la-twitter:before {\n  content: \"\\f099\"; }\n\n.la-twitter-square:before {\n  content: \"\\f081\"; }\n\n.la-typo3:before {\n  content: \"\\f42b\"; }\n\n.la-uber:before {\n  content: \"\\f402\"; }\n\n.la-ubuntu:before {\n  content: \"\\f7df\"; }\n\n.la-uikit:before {\n  content: \"\\f403\"; }\n\n.la-umbraco:before {\n  content: \"\\f8e8\"; }\n\n.la-umbrella:before {\n  content: \"\\f0e9\"; }\n\n.la-umbrella-beach:before {\n  content: \"\\f5ca\"; }\n\n.la-underline:before {\n  content: \"\\f0cd\"; }\n\n.la-undo:before {\n  content: \"\\f0e2\"; }\n\n.la-undo-alt:before {\n  content: \"\\f2ea\"; }\n\n.la-uniregistry:before {\n  content: \"\\f404\"; }\n\n.la-universal-access:before {\n  content: \"\\f29a\"; }\n\n.la-university:before {\n  content: \"\\f19c\"; }\n\n.la-unlink:before {\n  content: \"\\f127\"; }\n\n.la-unlock:before {\n  content: \"\\f09c\"; }\n\n.la-unlock-alt:before {\n  content: \"\\f13e\"; }\n\n.la-untappd:before {\n  content: \"\\f405\"; }\n\n.la-upload:before {\n  content: \"\\f093\"; }\n\n.la-ups:before {\n  content: \"\\f7e0\"; }\n\n.la-usb:before {\n  content: \"\\f287\"; }\n\n.la-user:before {\n  content: \"\\f007\"; }\n\n.la-user-alt:before {\n  content: \"\\f406\"; }\n\n.la-user-alt-slash:before {\n  content: \"\\f4fa\"; }\n\n.la-user-astronaut:before {\n  content: \"\\f4fb\"; }\n\n.la-user-check:before {\n  content: \"\\f4fc\"; }\n\n.la-user-circle:before {\n  content: \"\\f2bd\"; }\n\n.la-user-clock:before {\n  content: \"\\f4fd\"; }\n\n.la-user-cog:before {\n  content: \"\\f4fe\"; }\n\n.la-user-edit:before {\n  content: \"\\f4ff\"; }\n\n.la-user-friends:before {\n  content: \"\\f500\"; }\n\n.la-user-graduate:before {\n  content: \"\\f501\"; }\n\n.la-user-injured:before {\n  content: \"\\f728\"; }\n\n.la-user-lock:before {\n  content: \"\\f502\"; }\n\n.la-user-md:before {\n  content: \"\\f0f0\"; }\n\n.la-user-minus:before {\n  content: \"\\f503\"; }\n\n.la-user-ninja:before {\n  content: \"\\f504\"; }\n\n.la-user-nurse:before {\n  content: \"\\f82f\"; }\n\n.la-user-plus:before {\n  content: \"\\f234\"; }\n\n.la-user-secret:before {\n  content: \"\\f21b\"; }\n\n.la-user-shield:before {\n  content: \"\\f505\"; }\n\n.la-user-slash:before {\n  content: \"\\f506\"; }\n\n.la-user-tag:before {\n  content: \"\\f507\"; }\n\n.la-user-tie:before {\n  content: \"\\f508\"; }\n\n.la-user-times:before {\n  content: \"\\f235\"; }\n\n.la-users:before {\n  content: \"\\f0c0\"; }\n\n.la-users-cog:before {\n  content: \"\\f509\"; }\n\n.la-usps:before {\n  content: \"\\f7e1\"; }\n\n.la-ussunnah:before {\n  content: \"\\f407\"; }\n\n.la-utensil-spoon:before {\n  content: \"\\f2e5\"; }\n\n.la-utensils:before {\n  content: \"\\f2e7\"; }\n\n.la-vaadin:before {\n  content: \"\\f408\"; }\n\n.la-vector-square:before {\n  content: \"\\f5cb\"; }\n\n.la-venus:before {\n  content: \"\\f221\"; }\n\n.la-venus-double:before {\n  content: \"\\f226\"; }\n\n.la-venus-mars:before {\n  content: \"\\f228\"; }\n\n.la-viacoin:before {\n  content: \"\\f237\"; }\n\n.la-viadeo:before {\n  content: \"\\f2a9\"; }\n\n.la-viadeo-square:before {\n  content: \"\\f2aa\"; }\n\n.la-vial:before {\n  content: \"\\f492\"; }\n\n.la-vials:before {\n  content: \"\\f493\"; }\n\n.la-viber:before {\n  content: \"\\f409\"; }\n\n.la-video:before {\n  content: \"\\f03d\"; }\n\n.la-video-slash:before {\n  content: \"\\f4e2\"; }\n\n.la-vihara:before {\n  content: \"\\f6a7\"; }\n\n.la-vimeo:before {\n  content: \"\\f40a\"; }\n\n.la-vimeo-square:before {\n  content: \"\\f194\"; }\n\n.la-vimeo-v:before {\n  content: \"\\f27d\"; }\n\n.la-vine:before {\n  content: \"\\f1ca\"; }\n\n.la-vk:before {\n  content: \"\\f189\"; }\n\n.la-vnv:before {\n  content: \"\\f40b\"; }\n\n.la-voicemail:before {\n  content: \"\\f897\"; }\n\n.la-volleyball-ball:before {\n  content: \"\\f45f\"; }\n\n.la-volume-down:before {\n  content: \"\\f027\"; }\n\n.la-volume-mute:before {\n  content: \"\\f6a9\"; }\n\n.la-volume-off:before {\n  content: \"\\f026\"; }\n\n.la-volume-up:before {\n  content: \"\\f028\"; }\n\n.la-vote-yea:before {\n  content: \"\\f772\"; }\n\n.la-vr-cardboard:before {\n  content: \"\\f729\"; }\n\n.la-vuejs:before {\n  content: \"\\f41f\"; }\n\n.la-walking:before {\n  content: \"\\f554\"; }\n\n.la-wallet:before {\n  content: \"\\f555\"; }\n\n.la-warehouse:before {\n  content: \"\\f494\"; }\n\n.la-water:before {\n  content: \"\\f773\"; }\n\n.la-wave-square:before {\n  content: \"\\f83e\"; }\n\n.la-waze:before {\n  content: \"\\f83f\"; }\n\n.la-weebly:before {\n  content: \"\\f5cc\"; }\n\n.la-weibo:before {\n  content: \"\\f18a\"; }\n\n.la-weight:before {\n  content: \"\\f496\"; }\n\n.la-weight-hanging:before {\n  content: \"\\f5cd\"; }\n\n.la-weixin:before {\n  content: \"\\f1d7\"; }\n\n.la-whatsapp:before {\n  content: \"\\f232\"; }\n\n.la-whatsapp-square:before {\n  content: \"\\f40c\"; }\n\n.la-wheelchair:before {\n  content: \"\\f193\"; }\n\n.la-whmcs:before {\n  content: \"\\f40d\"; }\n\n.la-wifi:before {\n  content: \"\\f1eb\"; }\n\n.la-wikipedia-w:before {\n  content: \"\\f266\"; }\n\n.la-wind:before {\n  content: \"\\f72e\"; }\n\n.la-window-close:before {\n  content: \"\\f410\"; }\n\n.la-window-maximize:before {\n  content: \"\\f2d0\"; }\n\n.la-window-minimize:before {\n  content: \"\\f2d1\"; }\n\n.la-window-restore:before {\n  content: \"\\f2d2\"; }\n\n.la-windows:before {\n  content: \"\\f17a\"; }\n\n.la-wine-bottle:before {\n  content: \"\\f72f\"; }\n\n.la-wine-glass:before {\n  content: \"\\f4e3\"; }\n\n.la-wine-glass-alt:before {\n  content: \"\\f5ce\"; }\n\n.la-wix:before {\n  content: \"\\f5cf\"; }\n\n.la-wizards-of-the-coast:before {\n  content: \"\\f730\"; }\n\n.la-wolf-pack-battalion:before {\n  content: \"\\f514\"; }\n\n.la-won-sign:before {\n  content: \"\\f159\"; }\n\n.la-wordpress:before {\n  content: \"\\f19a\"; }\n\n.la-wordpress-simple:before {\n  content: \"\\f411\"; }\n\n.la-wpbeginner:before {\n  content: \"\\f297\"; }\n\n.la-wpexplorer:before {\n  content: \"\\f2de\"; }\n\n.la-wpforms:before {\n  content: \"\\f298\"; }\n\n.la-wpressr:before {\n  content: \"\\f3e4\"; }\n\n.la-wrench:before {\n  content: \"\\f0ad\"; }\n\n.la-x-ray:before {\n  content: \"\\f497\"; }\n\n.la-xbox:before {\n  content: \"\\f412\"; }\n\n.la-xing:before {\n  content: \"\\f168\"; }\n\n.la-xing-square:before {\n  content: \"\\f169\"; }\n\n.la-y-combinator:before {\n  content: \"\\f23b\"; }\n\n.la-yahoo:before {\n  content: \"\\f19e\"; }\n\n.la-yammer:before {\n  content: \"\\f840\"; }\n\n.la-yandex:before {\n  content: \"\\f413\"; }\n\n.la-yandex-international:before {\n  content: \"\\f414\"; }\n\n.la-yarn:before {\n  content: \"\\f7e3\"; }\n\n.la-yelp:before {\n  content: \"\\f1e9\"; }\n\n.la-yen-sign:before {\n  content: \"\\f157\"; }\n\n.la-yin-yang:before {\n  content: \"\\f6ad\"; }\n\n.la-yoast:before {\n  content: \"\\f2b1\"; }\n\n.la-youtube:before {\n  content: \"\\f167\"; }\n\n.la-youtube-square:before {\n  content: \"\\f431\"; }\n\n.la-zhihu:before {\n  content: \"\\f63f\"; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n@font-face {\n  font-family: 'Line Awesome Brands';\n  font-style: normal;\n  font-weight: normal;\n  font-display: auto;\n  src: url(\"../../../fonts/la-brands-400.eot\");\n  src: url(\"../../../fonts/la-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-brands-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-brands-400.woff\") format(\"woff\"), url(\"../../../fonts/la-brands-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-brands-400.svg#lineawesome\") format(\"svg\"); }\n\n.lab {\n  font-family: 'Line Awesome Brands'; }\n@font-face {\n  font-family: 'Line Awesome Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: auto;\n  src: url(\"../../../fonts/la-regular-400.eot\");\n  src: url(\"../../../fonts/la-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-regular-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-regular-400.woff\") format(\"woff\"), url(\"../../../fonts/la-regular-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-regular-400.svg#lineawesome\") format(\"svg\"); }\n\n.lar {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Line Awesome Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: auto;\n  src: url(\"../../../fonts/la-solid-900.eot\");\n  src: url(\"../../../fonts/la-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-solid-900.woff2\") format(\"woff2\"), url(\"../../../fonts/la-solid-900.woff\") format(\"woff\"), url(\"../../../fonts/la-solid-900.ttf\") format(\"truetype\"), url(\"../../../fonts/la-solid-900.svg#lineawesome\") format(\"svg\"); }\n\n.la,\n.las {\n  font-family: 'Line Awesome Free';\n  font-weight: 900; }\n\n.la.la-glass:before {\n  content: \"\\f000\"; }\n\n.la.la-meetup {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-star-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-o:before {\n  content: \"\\f005\"; }\n\n.la.la-remove:before {\n  content: \"\\f00d\"; }\n\n.la.la-close:before {\n  content: \"\\f00d\"; }\n\n.la.la-gear:before {\n  content: \"\\f013\"; }\n\n.la.la-trash-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-trash-o:before {\n  content: \"\\f2ed\"; }\n\n.la.la-file-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-o:before {\n  content: \"\\f15b\"; }\n\n.la.la-clock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-clock-o:before {\n  content: \"\\f017\"; }\n\n.la.la-arrow-circle-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-down:before {\n  content: \"\\f358\"; }\n\n.la.la-arrow-circle-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-up:before {\n  content: \"\\f35b\"; }\n\n.la.la-play-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-play-circle-o:before {\n  content: \"\\f144\"; }\n\n.la.la-repeat:before {\n  content: \"\\f01e\"; }\n\n.la.la-rotate-right:before {\n  content: \"\\f01e\"; }\n\n.la.la-refresh:before {\n  content: \"\\f021\"; }\n\n.la.la-list-alt {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-dedent:before {\n  content: \"\\f03b\"; }\n\n.la.la-video-camera:before {\n  content: \"\\f03d\"; }\n\n.la.la-picture-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-picture-o:before {\n  content: \"\\f03e\"; }\n\n.la.la-photo {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-photo:before {\n  content: \"\\f03e\"; }\n\n.la.la-image {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-image:before {\n  content: \"\\f03e\"; }\n\n.la.la-pencil:before {\n  content: \"\\f303\"; }\n\n.la.la-map-marker:before {\n  content: \"\\f3c5\"; }\n\n.la.la-pencil-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-pencil-square-o:before {\n  content: \"\\f044\"; }\n\n.la.la-share-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-share-square-o:before {\n  content: \"\\f14d\"; }\n\n.la.la-check-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-check-square-o:before {\n  content: \"\\f14a\"; }\n\n.la.la-arrows:before {\n  content: \"\\f0b2\"; }\n\n.la.la-times-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-circle-o:before {\n  content: \"\\f057\"; }\n\n.la.la-check-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-check-circle-o:before {\n  content: \"\\f058\"; }\n\n.la.la-mail-forward:before {\n  content: \"\\f064\"; }\n\n.la.la-eye {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-eye-slash {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-warning:before {\n  content: \"\\f071\"; }\n\n.la.la-calendar:before {\n  content: \"\\f073\"; }\n\n.la.la-arrows-v:before {\n  content: \"\\f338\"; }\n\n.la.la-arrows-h:before {\n  content: \"\\f337\"; }\n\n.la.la-bar-chart {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bar-chart:before {\n  content: \"\\f080\"; }\n\n.la.la-bar-chart-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bar-chart-o:before {\n  content: \"\\f080\"; }\n\n.la.la-twitter-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gears:before {\n  content: \"\\f085\"; }\n\n.la.la-thumbs-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-thumbs-o-up:before {\n  content: \"\\f164\"; }\n\n.la.la-thumbs-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-thumbs-o-down:before {\n  content: \"\\f165\"; }\n\n.la.la-heart-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-heart-o:before {\n  content: \"\\f004\"; }\n\n.la.la-sign-out:before {\n  content: \"\\f2f5\"; }\n\n.la.la-linkedin-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linkedin-square:before {\n  content: \"\\f08c\"; }\n\n.la.la-thumb-tack:before {\n  content: \"\\f08d\"; }\n\n.la.la-external-link:before {\n  content: \"\\f35d\"; }\n\n.la.la-sign-in:before {\n  content: \"\\f2f6\"; }\n\n.la.la-github-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-lemon-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-lemon-o:before {\n  content: \"\\f094\"; }\n\n.la.la-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-square-o:before {\n  content: \"\\f0c8\"; }\n\n.la.la-bookmark-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bookmark-o:before {\n  content: \"\\f02e\"; }\n\n.la.la-twitter {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook:before {\n  content: \"\\f39e\"; }\n\n.la.la-facebook-f {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.la.la-github {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-credit-card {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-feed:before {\n  content: \"\\f09e\"; }\n\n.la.la-hdd-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hdd-o:before {\n  content: \"\\f0a0\"; }\n\n.la.la-hand-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-right:before {\n  content: \"\\f0a4\"; }\n\n.la.la-hand-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-left:before {\n  content: \"\\f0a5\"; }\n\n.la.la-hand-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-up:before {\n  content: \"\\f0a6\"; }\n\n.la.la-hand-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-down:before {\n  content: \"\\f0a7\"; }\n\n.la.la-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.la.la-group:before {\n  content: \"\\f0c0\"; }\n\n.la.la-chain:before {\n  content: \"\\f0c1\"; }\n\n.la.la-scissors:before {\n  content: \"\\f0c4\"; }\n\n.la.la-files-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-files-o:before {\n  content: \"\\f0c5\"; }\n\n.la.la-floppy-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-floppy-o:before {\n  content: \"\\f0c7\"; }\n\n.la.la-navicon:before {\n  content: \"\\f0c9\"; }\n\n.la.la-reorder:before {\n  content: \"\\f0c9\"; }\n\n.la.la-pinterest {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pinterest-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus:before {\n  content: \"\\f0d5\"; }\n\n.la.la-money {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-money:before {\n  content: \"\\f3d1\"; }\n\n.la.la-unsorted:before {\n  content: \"\\f0dc\"; }\n\n.la.la-sort-desc:before {\n  content: \"\\f0dd\"; }\n\n.la.la-sort-asc:before {\n  content: \"\\f0de\"; }\n\n.la.la-linkedin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linkedin:before {\n  content: \"\\f0e1\"; }\n\n.la.la-rotate-left:before {\n  content: \"\\f0e2\"; }\n\n.la.la-legal:before {\n  content: \"\\f0e3\"; }\n\n.la.la-tachometer:before {\n  content: \"\\f3fd\"; }\n\n.la.la-dashboard:before {\n  content: \"\\f3fd\"; }\n\n.la.la-comment-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-comment-o:before {\n  content: \"\\f075\"; }\n\n.la.la-comments-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-comments-o:before {\n  content: \"\\f086\"; }\n\n.la.la-flash:before {\n  content: \"\\f0e7\"; }\n\n.la.la-clipboard {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paste {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paste:before {\n  content: \"\\f328\"; }\n\n.la.la-lightbulb-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-lightbulb-o:before {\n  content: \"\\f0eb\"; }\n\n.la.la-exchange:before {\n  content: \"\\f362\"; }\n\n.la.la-cloud-download:before {\n  content: \"\\f381\"; }\n\n.la.la-cloud-upload:before {\n  content: \"\\f382\"; }\n\n.la.la-bell-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bell-o:before {\n  content: \"\\f0f3\"; }\n\n.la.la-cutlery:before {\n  content: \"\\f2e7\"; }\n\n.la.la-file-text-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-text-o:before {\n  content: \"\\f15c\"; }\n\n.la.la-building-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-building-o:before {\n  content: \"\\f1ad\"; }\n\n.la.la-hospital-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hospital-o:before {\n  content: \"\\f0f8\"; }\n\n.la.la-tablet:before {\n  content: \"\\f3fa\"; }\n\n.la.la-mobile:before {\n  content: \"\\f3cd\"; }\n\n.la.la-mobile-phone:before {\n  content: \"\\f3cd\"; }\n\n.la.la-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-circle-o:before {\n  content: \"\\f111\"; }\n\n.la.la-mail-reply:before {\n  content: \"\\f3e5\"; }\n\n.la.la-github-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-folder-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-folder-o:before {\n  content: \"\\f07b\"; }\n\n.la.la-folder-open-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-folder-open-o:before {\n  content: \"\\f07c\"; }\n\n.la.la-smile-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-smile-o:before {\n  content: \"\\f118\"; }\n\n.la.la-frown-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-frown-o:before {\n  content: \"\\f119\"; }\n\n.la.la-meh-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-meh-o:before {\n  content: \"\\f11a\"; }\n\n.la.la-keyboard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-keyboard-o:before {\n  content: \"\\f11c\"; }\n\n.la.la-flag-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-flag-o:before {\n  content: \"\\f024\"; }\n\n.la.la-mail-reply-all:before {\n  content: \"\\f122\"; }\n\n.la.la-star-half-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-o:before {\n  content: \"\\f089\"; }\n\n.la.la-star-half-empty {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-empty:before {\n  content: \"\\f089\"; }\n\n.la.la-star-half-full {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-full:before {\n  content: \"\\f089\"; }\n\n.la.la-code-fork:before {\n  content: \"\\f126\"; }\n\n.la.la-chain-broken:before {\n  content: \"\\f127\"; }\n\n.la.la-shield:before {\n  content: \"\\f3ed\"; }\n\n.la.la-calendar-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-o:before {\n  content: \"\\f133\"; }\n\n.la.la-maxcdn {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-html5 {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-css3 {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ticket:before {\n  content: \"\\f3ff\"; }\n\n.la.la-minus-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-minus-square-o:before {\n  content: \"\\f146\"; }\n\n.la.la-level-up:before {\n  content: \"\\f3bf\"; }\n\n.la.la-level-down:before {\n  content: \"\\f3be\"; }\n\n.la.la-pencil-square:before {\n  content: \"\\f14b\"; }\n\n.la.la-external-link-square:before {\n  content: \"\\f360\"; }\n\n.la.la-compass {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-down:before {\n  content: \"\\f150\"; }\n\n.la.la-toggle-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-down:before {\n  content: \"\\f150\"; }\n\n.la.la-caret-square-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-up:before {\n  content: \"\\f151\"; }\n\n.la.la-toggle-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-up:before {\n  content: \"\\f151\"; }\n\n.la.la-caret-square-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-right:before {\n  content: \"\\f152\"; }\n\n.la.la-toggle-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-right:before {\n  content: \"\\f152\"; }\n\n.la.la-eur:before {\n  content: \"\\f153\"; }\n\n.la.la-euro:before {\n  content: \"\\f153\"; }\n\n.la.la-gbp:before {\n  content: \"\\f154\"; }\n\n.la.la-usd:before {\n  content: \"\\f155\"; }\n\n.la.la-dollar:before {\n  content: \"\\f155\"; }\n\n.la.la-inr:before {\n  content: \"\\f156\"; }\n\n.la.la-rupee:before {\n  content: \"\\f156\"; }\n\n.la.la-jpy:before {\n  content: \"\\f157\"; }\n\n.la.la-cny:before {\n  content: \"\\f157\"; }\n\n.la.la-rmb:before {\n  content: \"\\f157\"; }\n\n.la.la-yen:before {\n  content: \"\\f157\"; }\n\n.la.la-rub:before {\n  content: \"\\f158\"; }\n\n.la.la-ruble:before {\n  content: \"\\f158\"; }\n\n.la.la-rouble:before {\n  content: \"\\f158\"; }\n\n.la.la-krw:before {\n  content: \"\\f159\"; }\n\n.la.la-won:before {\n  content: \"\\f159\"; }\n\n.la.la-btc {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitcoin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitcoin:before {\n  content: \"\\f15a\"; }\n\n.la.la-file-text:before {\n  content: \"\\f15c\"; }\n\n.la.la-sort-alpha-asc:before {\n  content: \"\\f15d\"; }\n\n.la.la-sort-alpha-desc:before {\n  content: \"\\f881\"; }\n\n.la.la-sort-amount-asc:before {\n  content: \"\\f160\"; }\n\n.la.la-sort-amount-desc:before {\n  content: \"\\f884\"; }\n\n.la.la-sort-numeric-asc:before {\n  content: \"\\f162\"; }\n\n.la.la-sort-numeric-desc:before {\n  content: \"\\f886\"; }\n\n.la.la-youtube-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-xing {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-xing-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube-play {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube-play:before {\n  content: \"\\f167\"; }\n\n.la.la-dropbox {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stack-overflow {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-instagram {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-flickr {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-adn {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket-square:before {\n  content: \"\\f171\"; }\n\n.la.la-tumblr {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-tumblr-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-long-arrow-down:before {\n  content: \"\\f309\"; }\n\n.la.la-long-arrow-up:before {\n  content: \"\\f30c\"; }\n\n.la.la-long-arrow-left:before {\n  content: \"\\f30a\"; }\n\n.la.la-long-arrow-right:before {\n  content: \"\\f30b\"; }\n\n.la.la-apple {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-windows {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-android {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linux {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-dribbble {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-skype {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-foursquare {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-trello {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gratipay {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gittip {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gittip:before {\n  content: \"\\f184\"; }\n\n.la.la-sun-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sun-o:before {\n  content: \"\\f185\"; }\n\n.la.la-moon-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-moon-o:before {\n  content: \"\\f186\"; }\n\n.la.la-vk {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-weibo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-renren {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pagelines {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stack-exchange {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-right:before {\n  content: \"\\f35a\"; }\n\n.la.la-arrow-circle-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-left:before {\n  content: \"\\f359\"; }\n\n.la.la-caret-square-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-left:before {\n  content: \"\\f191\"; }\n\n.la.la-toggle-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-left:before {\n  content: \"\\f191\"; }\n\n.la.la-dot-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-dot-circle-o:before {\n  content: \"\\f192\"; }\n\n.la.la-vimeo-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-try:before {\n  content: \"\\f195\"; }\n\n.la.la-turkish-lira:before {\n  content: \"\\f195\"; }\n\n.la.la-plus-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-plus-square-o:before {\n  content: \"\\f0fe\"; }\n\n.la.la-slack {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wordpress {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-openid {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-institution:before {\n  content: \"\\f19c\"; }\n\n.la.la-bank:before {\n  content: \"\\f19c\"; }\n\n.la.la-mortar-board:before {\n  content: \"\\f19d\"; }\n\n.la.la-yahoo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stumbleupon-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stumbleupon {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-delicious {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-digg {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper-pp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-drupal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-joomla {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-spoon:before {\n  content: \"\\f2e5\"; }\n\n.la.la-behance {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-behance-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-steam {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-steam-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-automobile:before {\n  content: \"\\f1b9\"; }\n\n.la.la-cab:before {\n  content: \"\\f1ba\"; }\n\n.la.la-envelope-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-envelope-o:before {\n  content: \"\\f0e0\"; }\n\n.la.la-deviantart {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-soundcloud {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-file-pdf-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-pdf-o:before {\n  content: \"\\f1c1\"; }\n\n.la.la-file-word-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-word-o:before {\n  content: \"\\f1c2\"; }\n\n.la.la-file-excel-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-excel-o:before {\n  content: \"\\f1c3\"; }\n\n.la.la-file-powerpoint-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-powerpoint-o:before {\n  content: \"\\f1c4\"; }\n\n.la.la-file-image-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-image-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-photo-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-photo-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-picture-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-picture-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-archive-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-archive-o:before {\n  content: \"\\f1c6\"; }\n\n.la.la-file-zip-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-zip-o:before {\n  content: \"\\f1c6\"; }\n\n.la.la-file-audio-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-audio-o:before {\n  content: \"\\f1c7\"; }\n\n.la.la-file-sound-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-sound-o:before {\n  content: \"\\f1c7\"; }\n\n.la.la-file-video-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-video-o:before {\n  content: \"\\f1c8\"; }\n\n.la.la-file-movie-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-movie-o:before {\n  content: \"\\f1c8\"; }\n\n.la.la-file-code-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-code-o:before {\n  content: \"\\f1c9\"; }\n\n.la.la-vine {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-codepen {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-jsfiddle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-life-ring {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-bouy {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-bouy:before {\n  content: \"\\f1cd\"; }\n\n.la.la-life-buoy {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-buoy:before {\n  content: \"\\f1cd\"; }\n\n.la.la-life-saver {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-saver:before {\n  content: \"\\f1cd\"; }\n\n.la.la-support {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-support:before {\n  content: \"\\f1cd\"; }\n\n.la.la-circle-o-notch:before {\n  content: \"\\f1ce\"; }\n\n.la.la-rebel {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ra {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ra:before {\n  content: \"\\f1d0\"; }\n\n.la.la-resistance {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-resistance:before {\n  content: \"\\f1d0\"; }\n\n.la.la-empire {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ge {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ge:before {\n  content: \"\\f1d1\"; }\n\n.la.la-git-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-git {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-hacker-news {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator-square:before {\n  content: \"\\f1d4\"; }\n\n.la.la-yc-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc-square:before {\n  content: \"\\f1d4\"; }\n\n.la.la-tencent-weibo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-qq {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-weixin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wechat {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wechat:before {\n  content: \"\\f1d7\"; }\n\n.la.la-send:before {\n  content: \"\\f1d8\"; }\n\n.la.la-paper-plane-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paper-plane-o:before {\n  content: \"\\f1d8\"; }\n\n.la.la-send-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-send-o:before {\n  content: \"\\f1d8\"; }\n\n.la.la-circle-thin {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-circle-thin:before {\n  content: \"\\f111\"; }\n\n.la.la-header:before {\n  content: \"\\f1dc\"; }\n\n.la.la-sliders:before {\n  content: \"\\f1de\"; }\n\n.la.la-futbol-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-futbol-o:before {\n  content: \"\\f1e3\"; }\n\n.la.la-soccer-ball-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-soccer-ball-o:before {\n  content: \"\\f1e3\"; }\n\n.la.la-slideshare {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-twitch {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yelp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-newspaper-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-newspaper-o:before {\n  content: \"\\f1ea\"; }\n\n.la.la-paypal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-wallet {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-visa {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-mastercard {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-discover {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-amex {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-paypal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-stripe {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bell-slash-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bell-slash-o:before {\n  content: \"\\f1f6\"; }\n\n.la.la-trash:before {\n  content: \"\\f2ed\"; }\n\n.la.la-copyright {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-eyedropper:before {\n  content: \"\\f1fb\"; }\n\n.la.la-area-chart:before {\n  content: \"\\f1fe\"; }\n\n.la.la-pie-chart:before {\n  content: \"\\f200\"; }\n\n.la.la-line-chart:before {\n  content: \"\\f201\"; }\n\n.la.la-lastfm {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-lastfm-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ioxhost {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-angellist {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-cc:before {\n  content: \"\\f20a\"; }\n\n.la.la-ils:before {\n  content: \"\\f20b\"; }\n\n.la.la-shekel:before {\n  content: \"\\f20b\"; }\n\n.la.la-sheqel:before {\n  content: \"\\f20b\"; }\n\n.la.la-meanpath {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-meanpath:before {\n  content: \"\\f2b4\"; }\n\n.la.la-buysellads {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-connectdevelop {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-dashcube {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-forumbee {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-leanpub {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-sellsy {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-shirtsinbulk {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-simplybuilt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-skyatlas {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-diamond {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-diamond:before {\n  content: \"\\f3a5\"; }\n\n.la.la-intersex:before {\n  content: \"\\f224\"; }\n\n.la.la-facebook-official {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-official:before {\n  content: \"\\f09a\"; }\n\n.la.la-pinterest-p {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-whatsapp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-hotel:before {\n  content: \"\\f236\"; }\n\n.la.la-viacoin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-medium {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc:before {\n  content: \"\\f23b\"; }\n\n.la.la-optin-monster {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-opencart {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-expeditedssl {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-battery-4:before {\n  content: \"\\f240\"; }\n\n.la.la-battery:before {\n  content: \"\\f240\"; }\n\n.la.la-battery-3:before {\n  content: \"\\f241\"; }\n\n.la.la-battery-2:before {\n  content: \"\\f242\"; }\n\n.la.la-battery-1:before {\n  content: \"\\f243\"; }\n\n.la.la-battery-0:before {\n  content: \"\\f244\"; }\n\n.la.la-object-group {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-object-ungroup {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sticky-note-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sticky-note-o:before {\n  content: \"\\f249\"; }\n\n.la.la-cc-jcb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-diners-club {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-clone {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hourglass-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hourglass-o:before {\n  content: \"\\f254\"; }\n\n.la.la-hourglass-1:before {\n  content: \"\\f251\"; }\n\n.la.la-hourglass-2:before {\n  content: \"\\f252\"; }\n\n.la.la-hourglass-3:before {\n  content: \"\\f253\"; }\n\n.la.la-hand-rock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-rock-o:before {\n  content: \"\\f255\"; }\n\n.la.la-hand-grab-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-grab-o:before {\n  content: \"\\f255\"; }\n\n.la.la-hand-paper-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-paper-o:before {\n  content: \"\\f256\"; }\n\n.la.la-hand-stop-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-stop-o:before {\n  content: \"\\f256\"; }\n\n.la.la-hand-scissors-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-scissors-o:before {\n  content: \"\\f257\"; }\n\n.la.la-hand-lizard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-lizard-o:before {\n  content: \"\\f258\"; }\n\n.la.la-hand-spock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-spock-o:before {\n  content: \"\\f259\"; }\n\n.la.la-hand-pointer-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-pointer-o:before {\n  content: \"\\f25a\"; }\n\n.la.la-hand-peace-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-peace-o:before {\n  content: \"\\f25b\"; }\n\n.la.la-registered {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-creative-commons {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gg {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gg-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-tripadvisor {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-odnoklassniki {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-odnoklassniki-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-get-pocket {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wikipedia-w {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-safari {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-chrome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-firefox {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-opera {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-internet-explorer {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-television:before {\n  content: \"\\f26c\"; }\n\n.la.la-contao {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-500px {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-amazon {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-calendar-plus-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-plus-o:before {\n  content: \"\\f271\"; }\n\n.la.la-calendar-minus-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-minus-o:before {\n  content: \"\\f272\"; }\n\n.la.la-calendar-times-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-times-o:before {\n  content: \"\\f273\"; }\n\n.la.la-calendar-check-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-check-o:before {\n  content: \"\\f274\"; }\n\n.la.la-map-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-map-o:before {\n  content: \"\\f279\"; }\n\n.la.la-commenting:before {\n  content: \"\\f4ad\"; }\n\n.la.la-commenting-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-commenting-o:before {\n  content: \"\\f4ad\"; }\n\n.la.la-houzz {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-vimeo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-vimeo:before {\n  content: \"\\f27d\"; }\n\n.la.la-black-tie {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fonticons {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit-alien {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-edge {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-credit-card-alt:before {\n  content: \"\\f09d\"; }\n\n.la.la-codiepie {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-modx {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fort-awesome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-usb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-product-hunt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-mixcloud {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-scribd {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pause-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-pause-circle-o:before {\n  content: \"\\f28b\"; }\n\n.la.la-stop-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-stop-circle-o:before {\n  content: \"\\f28d\"; }\n\n.la.la-bluetooth {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bluetooth-b {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gitlab {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpbeginner {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpforms {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-envira {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wheelchair-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wheelchair-alt:before {\n  content: \"\\f368\"; }\n\n.la.la-question-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-question-circle-o:before {\n  content: \"\\f059\"; }\n\n.la.la-volume-control-phone:before {\n  content: \"\\f2a0\"; }\n\n.la.la-asl-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.la.la-deafness:before {\n  content: \"\\f2a4\"; }\n\n.la.la-hard-of-hearing:before {\n  content: \"\\f2a4\"; }\n\n.la.la-glide {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-glide-g {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-signing:before {\n  content: \"\\f2a7\"; }\n\n.la.la-viadeo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-viadeo-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat-ghost {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-first-order {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yoast {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-themeisle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-official {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-official:before {\n  content: \"\\f2b3\"; }\n\n.la.la-google-plus-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-circle:before {\n  content: \"\\f2b3\"; }\n\n.la.la-font-awesome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fa {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fa:before {\n  content: \"\\f2b4\"; }\n\n.la.la-handshake-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-handshake-o:before {\n  content: \"\\f2b5\"; }\n\n.la.la-envelope-open-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-envelope-open-o:before {\n  content: \"\\f2b6\"; }\n\n.la.la-linode {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-address-book-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-address-book-o:before {\n  content: \"\\f2b9\"; }\n\n.la.la-vcard:before {\n  content: \"\\f2bb\"; }\n\n.la.la-address-card-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-address-card-o:before {\n  content: \"\\f2bb\"; }\n\n.la.la-vcard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-vcard-o:before {\n  content: \"\\f2bb\"; }\n\n.la.la-user-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-user-circle-o:before {\n  content: \"\\f2bd\"; }\n\n.la.la-user-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-user-o:before {\n  content: \"\\f007\"; }\n\n.la.la-id-badge {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-drivers-license:before {\n  content: \"\\f2c2\"; }\n\n.la.la-id-card-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-id-card-o:before {\n  content: \"\\f2c2\"; }\n\n.la.la-drivers-license-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-drivers-license-o:before {\n  content: \"\\f2c2\"; }\n\n.la.la-quora {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-free-code-camp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-telegram {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-thermometer-4:before {\n  content: \"\\f2c7\"; }\n\n.la.la-thermometer:before {\n  content: \"\\f2c7\"; }\n\n.la.la-thermometer-3:before {\n  content: \"\\f2c8\"; }\n\n.la.la-thermometer-2:before {\n  content: \"\\f2c9\"; }\n\n.la.la-thermometer-1:before {\n  content: \"\\f2ca\"; }\n\n.la.la-thermometer-0:before {\n  content: \"\\f2cb\"; }\n\n.la.la-bathtub:before {\n  content: \"\\f2cd\"; }\n\n.la.la-s15:before {\n  content: \"\\f2cd\"; }\n\n.la.la-window-maximize {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-window-restore {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-rectangle:before {\n  content: \"\\f410\"; }\n\n.la.la-window-close-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-window-close-o:before {\n  content: \"\\f410\"; }\n\n.la.la-times-rectangle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-rectangle-o:before {\n  content: \"\\f410\"; }\n\n.la.la-bandcamp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-grav {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-etsy {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-imdb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ravelry {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-eercast {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-eercast:before {\n  content: \"\\f2da\"; }\n\n.la.la-snowflake-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-snowflake-o:before {\n  content: \"\\f2dc\"; }\n\n.la.la-superpowers {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpexplorer {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-spotify {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n","/*\n* Remix Icon v2.5.0\n* https://remixicon.com\n* https://github.com/Remix-Design/RemixIcon\n*\n* Copyright RemixIcon.com\n* Released under the Apache License Version 2.0\n*\n* Date: 2020-05-23\n*/\n@font-face {\n  font-family: \"remixicon\";\n  src: url('../../../fonts/remixicon.eot?t=1590207869815'); /* IE9*/\n  src: url('../../../fonts/remixicon.eot?t=1590207869815#iefix') format('embedded-opentype'), /* IE6-IE8 */\n  url(\"../../../fonts/remixicon.woff2?t=1590207869815\") format(\"woff2\"),\n  url(\"../../../fonts/remixicon.woff?t=1590207869815\") format(\"woff\"),\n  url('../../../fonts/remixicon.ttf?t=1590207869815') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\n  url('../../../fonts/remixicon.svg?t=1590207869815#remixicon') format('svg'); /* iOS 4.1- */\n  font-display: swap;\n}\n\n[class^=\"ri-\"], [class*=\" ri-\"] {\n  font-family: 'remixicon' !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ri-lg { font-size: 1.3333em; line-height: 0.75em; vertical-align: -.0667em; }\n.ri-xl { font-size: 1.5em; line-height: 0.6666em; vertical-align: -.075em; }\n.ri-xxs { font-size: .5em; }\n.ri-xs { font-size: .75em; }\n.ri-sm { font-size: .875em }\n.ri-1x { font-size: 1em; }\n.ri-2x { font-size: 2em; }\n.ri-3x { font-size: 3em; }\n.ri-4x { font-size: 4em; }\n.ri-5x { font-size: 5em; }\n.ri-6x { font-size: 6em; }\n.ri-7x { font-size: 7em; }\n.ri-8x { font-size: 8em; }\n.ri-9x { font-size: 9em; }\n.ri-10x { font-size: 10em; }\n.ri-fw { text-align: center; width: 1.25em; }\n\n.ri-24-hours-fill:before { content: \"\\ea01\"; }\n.ri-24-hours-line:before { content: \"\\ea02\"; }\n.ri-4k-fill:before { content: \"\\ea03\"; }\n.ri-4k-line:before { content: \"\\ea04\"; }\n.ri-a-b:before { content: \"\\ea05\"; }\n.ri-account-box-fill:before { content: \"\\ea06\"; }\n.ri-account-box-line:before { content: \"\\ea07\"; }\n.ri-account-circle-fill:before { content: \"\\ea08\"; }\n.ri-account-circle-line:before { content: \"\\ea09\"; }\n.ri-account-pin-box-fill:before { content: \"\\ea0a\"; }\n.ri-account-pin-box-line:before { content: \"\\ea0b\"; }\n.ri-account-pin-circle-fill:before { content: \"\\ea0c\"; }\n.ri-account-pin-circle-line:before { content: \"\\ea0d\"; }\n.ri-add-box-fill:before { content: \"\\ea0e\"; }\n.ri-add-box-line:before { content: \"\\ea0f\"; }\n.ri-add-circle-fill:before { content: \"\\ea10\"; }\n.ri-add-circle-line:before { content: \"\\ea11\"; }\n.ri-add-fill:before { content: \"\\ea12\"; }\n.ri-add-line:before { content: \"\\ea13\"; }\n.ri-admin-fill:before { content: \"\\ea14\"; }\n.ri-admin-line:before { content: \"\\ea15\"; }\n.ri-advertisement-fill:before { content: \"\\ea16\"; }\n.ri-advertisement-line:before { content: \"\\ea17\"; }\n.ri-airplay-fill:before { content: \"\\ea18\"; }\n.ri-airplay-line:before { content: \"\\ea19\"; }\n.ri-alarm-fill:before { content: \"\\ea1a\"; }\n.ri-alarm-line:before { content: \"\\ea1b\"; }\n.ri-alarm-warning-fill:before { content: \"\\ea1c\"; }\n.ri-alarm-warning-line:before { content: \"\\ea1d\"; }\n.ri-album-fill:before { content: \"\\ea1e\"; }\n.ri-album-line:before { content: \"\\ea1f\"; }\n.ri-alert-fill:before { content: \"\\ea20\"; }\n.ri-alert-line:before { content: \"\\ea21\"; }\n.ri-aliens-fill:before { content: \"\\ea22\"; }\n.ri-aliens-line:before { content: \"\\ea23\"; }\n.ri-align-bottom:before { content: \"\\ea24\"; }\n.ri-align-center:before { content: \"\\ea25\"; }\n.ri-align-justify:before { content: \"\\ea26\"; }\n.ri-align-left:before { content: \"\\ea27\"; }\n.ri-align-right:before { content: \"\\ea28\"; }\n.ri-align-top:before { content: \"\\ea29\"; }\n.ri-align-vertically:before { content: \"\\ea2a\"; }\n.ri-alipay-fill:before { content: \"\\ea2b\"; }\n.ri-alipay-line:before { content: \"\\ea2c\"; }\n.ri-amazon-fill:before { content: \"\\ea2d\"; }\n.ri-amazon-line:before { content: \"\\ea2e\"; }\n.ri-anchor-fill:before { content: \"\\ea2f\"; }\n.ri-anchor-line:before { content: \"\\ea30\"; }\n.ri-ancient-gate-fill:before { content: \"\\ea31\"; }\n.ri-ancient-gate-line:before { content: \"\\ea32\"; }\n.ri-ancient-pavilion-fill:before { content: \"\\ea33\"; }\n.ri-ancient-pavilion-line:before { content: \"\\ea34\"; }\n.ri-android-fill:before { content: \"\\ea35\"; }\n.ri-android-line:before { content: \"\\ea36\"; }\n.ri-angularjs-fill:before { content: \"\\ea37\"; }\n.ri-angularjs-line:before { content: \"\\ea38\"; }\n.ri-anticlockwise-2-fill:before { content: \"\\ea39\"; }\n.ri-anticlockwise-2-line:before { content: \"\\ea3a\"; }\n.ri-anticlockwise-fill:before { content: \"\\ea3b\"; }\n.ri-anticlockwise-line:before { content: \"\\ea3c\"; }\n.ri-app-store-fill:before { content: \"\\ea3d\"; }\n.ri-app-store-line:before { content: \"\\ea3e\"; }\n.ri-apple-fill:before { content: \"\\ea3f\"; }\n.ri-apple-line:before { content: \"\\ea40\"; }\n.ri-apps-2-fill:before { content: \"\\ea41\"; }\n.ri-apps-2-line:before { content: \"\\ea42\"; }\n.ri-apps-fill:before { content: \"\\ea43\"; }\n.ri-apps-line:before { content: \"\\ea44\"; }\n.ri-archive-drawer-fill:before { content: \"\\ea45\"; }\n.ri-archive-drawer-line:before { content: \"\\ea46\"; }\n.ri-archive-fill:before { content: \"\\ea47\"; }\n.ri-archive-line:before { content: \"\\ea48\"; }\n.ri-arrow-down-circle-fill:before { content: \"\\ea49\"; }\n.ri-arrow-down-circle-line:before { content: \"\\ea4a\"; }\n.ri-arrow-down-fill:before { content: \"\\ea4b\"; }\n.ri-arrow-down-line:before { content: \"\\ea4c\"; }\n.ri-arrow-down-s-fill:before { content: \"\\ea4d\"; }\n.ri-arrow-down-s-line:before { content: \"\\ea4e\"; }\n.ri-arrow-drop-down-fill:before { content: \"\\ea4f\"; }\n.ri-arrow-drop-down-line:before { content: \"\\ea50\"; }\n.ri-arrow-drop-left-fill:before { content: \"\\ea51\"; }\n.ri-arrow-drop-left-line:before { content: \"\\ea52\"; }\n.ri-arrow-drop-right-fill:before { content: \"\\ea53\"; }\n.ri-arrow-drop-right-line:before { content: \"\\ea54\"; }\n.ri-arrow-drop-up-fill:before { content: \"\\ea55\"; }\n.ri-arrow-drop-up-line:before { content: \"\\ea56\"; }\n.ri-arrow-go-back-fill:before { content: \"\\ea57\"; }\n.ri-arrow-go-back-line:before { content: \"\\ea58\"; }\n.ri-arrow-go-forward-fill:before { content: \"\\ea59\"; }\n.ri-arrow-go-forward-line:before { content: \"\\ea5a\"; }\n.ri-arrow-left-circle-fill:before { content: \"\\ea5b\"; }\n.ri-arrow-left-circle-line:before { content: \"\\ea5c\"; }\n.ri-arrow-left-down-fill:before { content: \"\\ea5d\"; }\n.ri-arrow-left-down-line:before { content: \"\\ea5e\"; }\n.ri-arrow-left-fill:before { content: \"\\ea5f\"; }\n.ri-arrow-left-line:before { content: \"\\ea60\"; }\n.ri-arrow-left-right-fill:before { content: \"\\ea61\"; }\n.ri-arrow-left-right-line:before { content: \"\\ea62\"; }\n.ri-arrow-left-s-fill:before { content: \"\\ea63\"; }\n.ri-arrow-left-s-line:before { content: \"\\ea64\"; }\n.ri-arrow-left-up-fill:before { content: \"\\ea65\"; }\n.ri-arrow-left-up-line:before { content: \"\\ea66\"; }\n.ri-arrow-right-circle-fill:before { content: \"\\ea67\"; }\n.ri-arrow-right-circle-line:before { content: \"\\ea68\"; }\n.ri-arrow-right-down-fill:before { content: \"\\ea69\"; }\n.ri-arrow-right-down-line:before { content: \"\\ea6a\"; }\n.ri-arrow-right-fill:before { content: \"\\ea6b\"; }\n.ri-arrow-right-line:before { content: \"\\ea6c\"; }\n.ri-arrow-right-s-fill:before { content: \"\\ea6d\"; }\n.ri-arrow-right-s-line:before { content: \"\\ea6e\"; }\n.ri-arrow-right-up-fill:before { content: \"\\ea6f\"; }\n.ri-arrow-right-up-line:before { content: \"\\ea70\"; }\n.ri-arrow-up-circle-fill:before { content: \"\\ea71\"; }\n.ri-arrow-up-circle-line:before { content: \"\\ea72\"; }\n.ri-arrow-up-down-fill:before { content: \"\\ea73\"; }\n.ri-arrow-up-down-line:before { content: \"\\ea74\"; }\n.ri-arrow-up-fill:before { content: \"\\ea75\"; }\n.ri-arrow-up-line:before { content: \"\\ea76\"; }\n.ri-arrow-up-s-fill:before { content: \"\\ea77\"; }\n.ri-arrow-up-s-line:before { content: \"\\ea78\"; }\n.ri-artboard-2-fill:before { content: \"\\ea79\"; }\n.ri-artboard-2-line:before { content: \"\\ea7a\"; }\n.ri-artboard-fill:before { content: \"\\ea7b\"; }\n.ri-artboard-line:before { content: \"\\ea7c\"; }\n.ri-article-fill:before { content: \"\\ea7d\"; }\n.ri-article-line:before { content: \"\\ea7e\"; }\n.ri-aspect-ratio-fill:before { content: \"\\ea7f\"; }\n.ri-aspect-ratio-line:before { content: \"\\ea80\"; }\n.ri-asterisk:before { content: \"\\ea81\"; }\n.ri-at-fill:before { content: \"\\ea82\"; }\n.ri-at-line:before { content: \"\\ea83\"; }\n.ri-attachment-2:before { content: \"\\ea84\"; }\n.ri-attachment-fill:before { content: \"\\ea85\"; }\n.ri-attachment-line:before { content: \"\\ea86\"; }\n.ri-auction-fill:before { content: \"\\ea87\"; }\n.ri-auction-line:before { content: \"\\ea88\"; }\n.ri-award-fill:before { content: \"\\ea89\"; }\n.ri-award-line:before { content: \"\\ea8a\"; }\n.ri-baidu-fill:before { content: \"\\ea8b\"; }\n.ri-baidu-line:before { content: \"\\ea8c\"; }\n.ri-ball-pen-fill:before { content: \"\\ea8d\"; }\n.ri-ball-pen-line:before { content: \"\\ea8e\"; }\n.ri-bank-card-2-fill:before { content: \"\\ea8f\"; }\n.ri-bank-card-2-line:before { content: \"\\ea90\"; }\n.ri-bank-card-fill:before { content: \"\\ea91\"; }\n.ri-bank-card-line:before { content: \"\\ea92\"; }\n.ri-bank-fill:before { content: \"\\ea93\"; }\n.ri-bank-line:before { content: \"\\ea94\"; }\n.ri-bar-chart-2-fill:before { content: \"\\ea95\"; }\n.ri-bar-chart-2-line:before { content: \"\\ea96\"; }\n.ri-bar-chart-box-fill:before { content: \"\\ea97\"; }\n.ri-bar-chart-box-line:before { content: \"\\ea98\"; }\n.ri-bar-chart-fill:before { content: \"\\ea99\"; }\n.ri-bar-chart-grouped-fill:before { content: \"\\ea9a\"; }\n.ri-bar-chart-grouped-line:before { content: \"\\ea9b\"; }\n.ri-bar-chart-horizontal-fill:before { content: \"\\ea9c\"; }\n.ri-bar-chart-horizontal-line:before { content: \"\\ea9d\"; }\n.ri-bar-chart-line:before { content: \"\\ea9e\"; }\n.ri-barcode-box-fill:before { content: \"\\ea9f\"; }\n.ri-barcode-box-line:before { content: \"\\eaa0\"; }\n.ri-barcode-fill:before { content: \"\\eaa1\"; }\n.ri-barcode-line:before { content: \"\\eaa2\"; }\n.ri-barricade-fill:before { content: \"\\eaa3\"; }\n.ri-barricade-line:before { content: \"\\eaa4\"; }\n.ri-base-station-fill:before { content: \"\\eaa5\"; }\n.ri-base-station-line:before { content: \"\\eaa6\"; }\n.ri-basketball-fill:before { content: \"\\eaa7\"; }\n.ri-basketball-line:before { content: \"\\eaa8\"; }\n.ri-battery-2-charge-fill:before { content: \"\\eaa9\"; }\n.ri-battery-2-charge-line:before { content: \"\\eaaa\"; }\n.ri-battery-2-fill:before { content: \"\\eaab\"; }\n.ri-battery-2-line:before { content: \"\\eaac\"; }\n.ri-battery-charge-fill:before { content: \"\\eaad\"; }\n.ri-battery-charge-line:before { content: \"\\eaae\"; }\n.ri-battery-fill:before { content: \"\\eaaf\"; }\n.ri-battery-line:before { content: \"\\eab0\"; }\n.ri-battery-low-fill:before { content: \"\\eab1\"; }\n.ri-battery-low-line:before { content: \"\\eab2\"; }\n.ri-battery-saver-fill:before { content: \"\\eab3\"; }\n.ri-battery-saver-line:before { content: \"\\eab4\"; }\n.ri-battery-share-fill:before { content: \"\\eab5\"; }\n.ri-battery-share-line:before { content: \"\\eab6\"; }\n.ri-bear-smile-fill:before { content: \"\\eab7\"; }\n.ri-bear-smile-line:before { content: \"\\eab8\"; }\n.ri-behance-fill:before { content: \"\\eab9\"; }\n.ri-behance-line:before { content: \"\\eaba\"; }\n.ri-bell-fill:before { content: \"\\eabb\"; }\n.ri-bell-line:before { content: \"\\eabc\"; }\n.ri-bike-fill:before { content: \"\\eabd\"; }\n.ri-bike-line:before { content: \"\\eabe\"; }\n.ri-bilibili-fill:before { content: \"\\eabf\"; }\n.ri-bilibili-line:before { content: \"\\eac0\"; }\n.ri-bill-fill:before { content: \"\\eac1\"; }\n.ri-bill-line:before { content: \"\\eac2\"; }\n.ri-billiards-fill:before { content: \"\\eac3\"; }\n.ri-billiards-line:before { content: \"\\eac4\"; }\n.ri-bit-coin-fill:before { content: \"\\eac5\"; }\n.ri-bit-coin-line:before { content: \"\\eac6\"; }\n.ri-blaze-fill:before { content: \"\\eac7\"; }\n.ri-blaze-line:before { content: \"\\eac8\"; }\n.ri-bluetooth-connect-fill:before { content: \"\\eac9\"; }\n.ri-bluetooth-connect-line:before { content: \"\\eaca\"; }\n.ri-bluetooth-fill:before { content: \"\\eacb\"; }\n.ri-bluetooth-line:before { content: \"\\eacc\"; }\n.ri-blur-off-fill:before { content: \"\\eacd\"; }\n.ri-blur-off-line:before { content: \"\\eace\"; }\n.ri-body-scan-fill:before { content: \"\\eacf\"; }\n.ri-body-scan-line:before { content: \"\\ead0\"; }\n.ri-bold:before { content: \"\\ead1\"; }\n.ri-book-2-fill:before { content: \"\\ead2\"; }\n.ri-book-2-line:before { content: \"\\ead3\"; }\n.ri-book-3-fill:before { content: \"\\ead4\"; }\n.ri-book-3-line:before { content: \"\\ead5\"; }\n.ri-book-fill:before { content: \"\\ead6\"; }\n.ri-book-line:before { content: \"\\ead7\"; }\n.ri-book-mark-fill:before { content: \"\\ead8\"; }\n.ri-book-mark-line:before { content: \"\\ead9\"; }\n.ri-book-open-fill:before { content: \"\\eada\"; }\n.ri-book-open-line:before { content: \"\\eadb\"; }\n.ri-book-read-fill:before { content: \"\\eadc\"; }\n.ri-book-read-line:before { content: \"\\eadd\"; }\n.ri-booklet-fill:before { content: \"\\eade\"; }\n.ri-booklet-line:before { content: \"\\eadf\"; }\n.ri-bookmark-2-fill:before { content: \"\\eae0\"; }\n.ri-bookmark-2-line:before { content: \"\\eae1\"; }\n.ri-bookmark-3-fill:before { content: \"\\eae2\"; }\n.ri-bookmark-3-line:before { content: \"\\eae3\"; }\n.ri-bookmark-fill:before { content: \"\\eae4\"; }\n.ri-bookmark-line:before { content: \"\\eae5\"; }\n.ri-boxing-fill:before { content: \"\\eae6\"; }\n.ri-boxing-line:before { content: \"\\eae7\"; }\n.ri-braces-fill:before { content: \"\\eae8\"; }\n.ri-braces-line:before { content: \"\\eae9\"; }\n.ri-brackets-fill:before { content: \"\\eaea\"; }\n.ri-brackets-line:before { content: \"\\eaeb\"; }\n.ri-briefcase-2-fill:before { content: \"\\eaec\"; }\n.ri-briefcase-2-line:before { content: \"\\eaed\"; }\n.ri-briefcase-3-fill:before { content: \"\\eaee\"; }\n.ri-briefcase-3-line:before { content: \"\\eaef\"; }\n.ri-briefcase-4-fill:before { content: \"\\eaf0\"; }\n.ri-briefcase-4-line:before { content: \"\\eaf1\"; }\n.ri-briefcase-5-fill:before { content: \"\\eaf2\"; }\n.ri-briefcase-5-line:before { content: \"\\eaf3\"; }\n.ri-briefcase-fill:before { content: \"\\eaf4\"; }\n.ri-briefcase-line:before { content: \"\\eaf5\"; }\n.ri-bring-forward:before { content: \"\\eaf6\"; }\n.ri-bring-to-front:before { content: \"\\eaf7\"; }\n.ri-broadcast-fill:before { content: \"\\eaf8\"; }\n.ri-broadcast-line:before { content: \"\\eaf9\"; }\n.ri-brush-2-fill:before { content: \"\\eafa\"; }\n.ri-brush-2-line:before { content: \"\\eafb\"; }\n.ri-brush-3-fill:before { content: \"\\eafc\"; }\n.ri-brush-3-line:before { content: \"\\eafd\"; }\n.ri-brush-4-fill:before { content: \"\\eafe\"; }\n.ri-brush-4-line:before { content: \"\\eaff\"; }\n.ri-brush-fill:before { content: \"\\eb00\"; }\n.ri-brush-line:before { content: \"\\eb01\"; }\n.ri-bubble-chart-fill:before { content: \"\\eb02\"; }\n.ri-bubble-chart-line:before { content: \"\\eb03\"; }\n.ri-bug-2-fill:before { content: \"\\eb04\"; }\n.ri-bug-2-line:before { content: \"\\eb05\"; }\n.ri-bug-fill:before { content: \"\\eb06\"; }\n.ri-bug-line:before { content: \"\\eb07\"; }\n.ri-building-2-fill:before { content: \"\\eb08\"; }\n.ri-building-2-line:before { content: \"\\eb09\"; }\n.ri-building-3-fill:before { content: \"\\eb0a\"; }\n.ri-building-3-line:before { content: \"\\eb0b\"; }\n.ri-building-4-fill:before { content: \"\\eb0c\"; }\n.ri-building-4-line:before { content: \"\\eb0d\"; }\n.ri-building-fill:before { content: \"\\eb0e\"; }\n.ri-building-line:before { content: \"\\eb0f\"; }\n.ri-bus-2-fill:before { content: \"\\eb10\"; }\n.ri-bus-2-line:before { content: \"\\eb11\"; }\n.ri-bus-fill:before { content: \"\\eb12\"; }\n.ri-bus-line:before { content: \"\\eb13\"; }\n.ri-bus-wifi-fill:before { content: \"\\eb14\"; }\n.ri-bus-wifi-line:before { content: \"\\eb15\"; }\n.ri-cactus-fill:before { content: \"\\eb16\"; }\n.ri-cactus-line:before { content: \"\\eb17\"; }\n.ri-cake-2-fill:before { content: \"\\eb18\"; }\n.ri-cake-2-line:before { content: \"\\eb19\"; }\n.ri-cake-3-fill:before { content: \"\\eb1a\"; }\n.ri-cake-3-line:before { content: \"\\eb1b\"; }\n.ri-cake-fill:before { content: \"\\eb1c\"; }\n.ri-cake-line:before { content: \"\\eb1d\"; }\n.ri-calculator-fill:before { content: \"\\eb1e\"; }\n.ri-calculator-line:before { content: \"\\eb1f\"; }\n.ri-calendar-2-fill:before { content: \"\\eb20\"; }\n.ri-calendar-2-line:before { content: \"\\eb21\"; }\n.ri-calendar-check-fill:before { content: \"\\eb22\"; }\n.ri-calendar-check-line:before { content: \"\\eb23\"; }\n.ri-calendar-event-fill:before { content: \"\\eb24\"; }\n.ri-calendar-event-line:before { content: \"\\eb25\"; }\n.ri-calendar-fill:before { content: \"\\eb26\"; }\n.ri-calendar-line:before { content: \"\\eb27\"; }\n.ri-calendar-todo-fill:before { content: \"\\eb28\"; }\n.ri-calendar-todo-line:before { content: \"\\eb29\"; }\n.ri-camera-2-fill:before { content: \"\\eb2a\"; }\n.ri-camera-2-line:before { content: \"\\eb2b\"; }\n.ri-camera-3-fill:before { content: \"\\eb2c\"; }\n.ri-camera-3-line:before { content: \"\\eb2d\"; }\n.ri-camera-fill:before { content: \"\\eb2e\"; }\n.ri-camera-lens-fill:before { content: \"\\eb2f\"; }\n.ri-camera-lens-line:before { content: \"\\eb30\"; }\n.ri-camera-line:before { content: \"\\eb31\"; }\n.ri-camera-off-fill:before { content: \"\\eb32\"; }\n.ri-camera-off-line:before { content: \"\\eb33\"; }\n.ri-camera-switch-fill:before { content: \"\\eb34\"; }\n.ri-camera-switch-line:before { content: \"\\eb35\"; }\n.ri-capsule-fill:before { content: \"\\eb36\"; }\n.ri-capsule-line:before { content: \"\\eb37\"; }\n.ri-car-fill:before { content: \"\\eb38\"; }\n.ri-car-line:before { content: \"\\eb39\"; }\n.ri-car-washing-fill:before { content: \"\\eb3a\"; }\n.ri-car-washing-line:before { content: \"\\eb3b\"; }\n.ri-caravan-fill:before { content: \"\\eb3c\"; }\n.ri-caravan-line:before { content: \"\\eb3d\"; }\n.ri-cast-fill:before { content: \"\\eb3e\"; }\n.ri-cast-line:before { content: \"\\eb3f\"; }\n.ri-cellphone-fill:before { content: \"\\eb40\"; }\n.ri-cellphone-line:before { content: \"\\eb41\"; }\n.ri-celsius-fill:before { content: \"\\eb42\"; }\n.ri-celsius-line:before { content: \"\\eb43\"; }\n.ri-centos-fill:before { content: \"\\eb44\"; }\n.ri-centos-line:before { content: \"\\eb45\"; }\n.ri-character-recognition-fill:before { content: \"\\eb46\"; }\n.ri-character-recognition-line:before { content: \"\\eb47\"; }\n.ri-charging-pile-2-fill:before { content: \"\\eb48\"; }\n.ri-charging-pile-2-line:before { content: \"\\eb49\"; }\n.ri-charging-pile-fill:before { content: \"\\eb4a\"; }\n.ri-charging-pile-line:before { content: \"\\eb4b\"; }\n.ri-chat-1-fill:before { content: \"\\eb4c\"; }\n.ri-chat-1-line:before { content: \"\\eb4d\"; }\n.ri-chat-2-fill:before { content: \"\\eb4e\"; }\n.ri-chat-2-line:before { content: \"\\eb4f\"; }\n.ri-chat-3-fill:before { content: \"\\eb50\"; }\n.ri-chat-3-line:before { content: \"\\eb51\"; }\n.ri-chat-4-fill:before { content: \"\\eb52\"; }\n.ri-chat-4-line:before { content: \"\\eb53\"; }\n.ri-chat-check-fill:before { content: \"\\eb54\"; }\n.ri-chat-check-line:before { content: \"\\eb55\"; }\n.ri-chat-delete-fill:before { content: \"\\eb56\"; }\n.ri-chat-delete-line:before { content: \"\\eb57\"; }\n.ri-chat-download-fill:before { content: \"\\eb58\"; }\n.ri-chat-download-line:before { content: \"\\eb59\"; }\n.ri-chat-follow-up-fill:before { content: \"\\eb5a\"; }\n.ri-chat-follow-up-line:before { content: \"\\eb5b\"; }\n.ri-chat-forward-fill:before { content: \"\\eb5c\"; }\n.ri-chat-forward-line:before { content: \"\\eb5d\"; }\n.ri-chat-heart-fill:before { content: \"\\eb5e\"; }\n.ri-chat-heart-line:before { content: \"\\eb5f\"; }\n.ri-chat-history-fill:before { content: \"\\eb60\"; }\n.ri-chat-history-line:before { content: \"\\eb61\"; }\n.ri-chat-new-fill:before { content: \"\\eb62\"; }\n.ri-chat-new-line:before { content: \"\\eb63\"; }\n.ri-chat-off-fill:before { content: \"\\eb64\"; }\n.ri-chat-off-line:before { content: \"\\eb65\"; }\n.ri-chat-poll-fill:before { content: \"\\eb66\"; }\n.ri-chat-poll-line:before { content: \"\\eb67\"; }\n.ri-chat-private-fill:before { content: \"\\eb68\"; }\n.ri-chat-private-line:before { content: \"\\eb69\"; }\n.ri-chat-quote-fill:before { content: \"\\eb6a\"; }\n.ri-chat-quote-line:before { content: \"\\eb6b\"; }\n.ri-chat-settings-fill:before { content: \"\\eb6c\"; }\n.ri-chat-settings-line:before { content: \"\\eb6d\"; }\n.ri-chat-smile-2-fill:before { content: \"\\eb6e\"; }\n.ri-chat-smile-2-line:before { content: \"\\eb6f\"; }\n.ri-chat-smile-3-fill:before { content: \"\\eb70\"; }\n.ri-chat-smile-3-line:before { content: \"\\eb71\"; }\n.ri-chat-smile-fill:before { content: \"\\eb72\"; }\n.ri-chat-smile-line:before { content: \"\\eb73\"; }\n.ri-chat-upload-fill:before { content: \"\\eb74\"; }\n.ri-chat-upload-line:before { content: \"\\eb75\"; }\n.ri-chat-voice-fill:before { content: \"\\eb76\"; }\n.ri-chat-voice-line:before { content: \"\\eb77\"; }\n.ri-check-double-fill:before { content: \"\\eb78\"; }\n.ri-check-double-line:before { content: \"\\eb79\"; }\n.ri-check-fill:before { content: \"\\eb7a\"; }\n.ri-check-line:before { content: \"\\eb7b\"; }\n.ri-checkbox-blank-circle-fill:before { content: \"\\eb7c\"; }\n.ri-checkbox-blank-circle-line:before { content: \"\\eb7d\"; }\n.ri-checkbox-blank-fill:before { content: \"\\eb7e\"; }\n.ri-checkbox-blank-line:before { content: \"\\eb7f\"; }\n.ri-checkbox-circle-fill:before { content: \"\\eb80\"; }\n.ri-checkbox-circle-line:before { content: \"\\eb81\"; }\n.ri-checkbox-fill:before { content: \"\\eb82\"; }\n.ri-checkbox-indeterminate-fill:before { content: \"\\eb83\"; }\n.ri-checkbox-indeterminate-line:before { content: \"\\eb84\"; }\n.ri-checkbox-line:before { content: \"\\eb85\"; }\n.ri-checkbox-multiple-blank-fill:before { content: \"\\eb86\"; }\n.ri-checkbox-multiple-blank-line:before { content: \"\\eb87\"; }\n.ri-checkbox-multiple-fill:before { content: \"\\eb88\"; }\n.ri-checkbox-multiple-line:before { content: \"\\eb89\"; }\n.ri-china-railway-fill:before { content: \"\\eb8a\"; }\n.ri-china-railway-line:before { content: \"\\eb8b\"; }\n.ri-chrome-fill:before { content: \"\\eb8c\"; }\n.ri-chrome-line:before { content: \"\\eb8d\"; }\n.ri-clapperboard-fill:before { content: \"\\eb8e\"; }\n.ri-clapperboard-line:before { content: \"\\eb8f\"; }\n.ri-clipboard-fill:before { content: \"\\eb90\"; }\n.ri-clipboard-line:before { content: \"\\eb91\"; }\n.ri-clockwise-2-fill:before { content: \"\\eb92\"; }\n.ri-clockwise-2-line:before { content: \"\\eb93\"; }\n.ri-clockwise-fill:before { content: \"\\eb94\"; }\n.ri-clockwise-line:before { content: \"\\eb95\"; }\n.ri-close-circle-fill:before { content: \"\\eb96\"; }\n.ri-close-circle-line:before { content: \"\\eb97\"; }\n.ri-close-fill:before { content: \"\\eb98\"; }\n.ri-close-line:before { content: \"\\eb99\"; }\n.ri-closed-captioning-fill:before { content: \"\\eb9a\"; }\n.ri-closed-captioning-line:before { content: \"\\eb9b\"; }\n.ri-cloud-fill:before { content: \"\\eb9c\"; }\n.ri-cloud-line:before { content: \"\\eb9d\"; }\n.ri-cloud-off-fill:before { content: \"\\eb9e\"; }\n.ri-cloud-off-line:before { content: \"\\eb9f\"; }\n.ri-cloud-windy-fill:before { content: \"\\eba0\"; }\n.ri-cloud-windy-line:before { content: \"\\eba1\"; }\n.ri-cloudy-2-fill:before { content: \"\\eba2\"; }\n.ri-cloudy-2-line:before { content: \"\\eba3\"; }\n.ri-cloudy-fill:before { content: \"\\eba4\"; }\n.ri-cloudy-line:before { content: \"\\eba5\"; }\n.ri-code-box-fill:before { content: \"\\eba6\"; }\n.ri-code-box-line:before { content: \"\\eba7\"; }\n.ri-code-fill:before { content: \"\\eba8\"; }\n.ri-code-line:before { content: \"\\eba9\"; }\n.ri-code-s-fill:before { content: \"\\ebaa\"; }\n.ri-code-s-line:before { content: \"\\ebab\"; }\n.ri-code-s-slash-fill:before { content: \"\\ebac\"; }\n.ri-code-s-slash-line:before { content: \"\\ebad\"; }\n.ri-code-view:before { content: \"\\ebae\"; }\n.ri-codepen-fill:before { content: \"\\ebaf\"; }\n.ri-codepen-line:before { content: \"\\ebb0\"; }\n.ri-coin-fill:before { content: \"\\ebb1\"; }\n.ri-coin-line:before { content: \"\\ebb2\"; }\n.ri-coins-fill:before { content: \"\\ebb3\"; }\n.ri-coins-line:before { content: \"\\ebb4\"; }\n.ri-collage-fill:before { content: \"\\ebb5\"; }\n.ri-collage-line:before { content: \"\\ebb6\"; }\n.ri-command-fill:before { content: \"\\ebb7\"; }\n.ri-command-line:before { content: \"\\ebb8\"; }\n.ri-community-fill:before { content: \"\\ebb9\"; }\n.ri-community-line:before { content: \"\\ebba\"; }\n.ri-compass-2-fill:before { content: \"\\ebbb\"; }\n.ri-compass-2-line:before { content: \"\\ebbc\"; }\n.ri-compass-3-fill:before { content: \"\\ebbd\"; }\n.ri-compass-3-line:before { content: \"\\ebbe\"; }\n.ri-compass-4-fill:before { content: \"\\ebbf\"; }\n.ri-compass-4-line:before { content: \"\\ebc0\"; }\n.ri-compass-discover-fill:before { content: \"\\ebc1\"; }\n.ri-compass-discover-line:before { content: \"\\ebc2\"; }\n.ri-compass-fill:before { content: \"\\ebc3\"; }\n.ri-compass-line:before { content: \"\\ebc4\"; }\n.ri-compasses-2-fill:before { content: \"\\ebc5\"; }\n.ri-compasses-2-line:before { content: \"\\ebc6\"; }\n.ri-compasses-fill:before { content: \"\\ebc7\"; }\n.ri-compasses-line:before { content: \"\\ebc8\"; }\n.ri-computer-fill:before { content: \"\\ebc9\"; }\n.ri-computer-line:before { content: \"\\ebca\"; }\n.ri-contacts-book-2-fill:before { content: \"\\ebcb\"; }\n.ri-contacts-book-2-line:before { content: \"\\ebcc\"; }\n.ri-contacts-book-fill:before { content: \"\\ebcd\"; }\n.ri-contacts-book-line:before { content: \"\\ebce\"; }\n.ri-contacts-book-upload-fill:before { content: \"\\ebcf\"; }\n.ri-contacts-book-upload-line:before { content: \"\\ebd0\"; }\n.ri-contacts-fill:before { content: \"\\ebd1\"; }\n.ri-contacts-line:before { content: \"\\ebd2\"; }\n.ri-contrast-2-fill:before { content: \"\\ebd3\"; }\n.ri-contrast-2-line:before { content: \"\\ebd4\"; }\n.ri-contrast-drop-2-fill:before { content: \"\\ebd5\"; }\n.ri-contrast-drop-2-line:before { content: \"\\ebd6\"; }\n.ri-contrast-drop-fill:before { content: \"\\ebd7\"; }\n.ri-contrast-drop-line:before { content: \"\\ebd8\"; }\n.ri-contrast-fill:before { content: \"\\ebd9\"; }\n.ri-contrast-line:before { content: \"\\ebda\"; }\n.ri-copper-coin-fill:before { content: \"\\ebdb\"; }\n.ri-copper-coin-line:before { content: \"\\ebdc\"; }\n.ri-copper-diamond-fill:before { content: \"\\ebdd\"; }\n.ri-copper-diamond-line:before { content: \"\\ebde\"; }\n.ri-copyleft-fill:before { content: \"\\ebdf\"; }\n.ri-copyleft-line:before { content: \"\\ebe0\"; }\n.ri-copyright-fill:before { content: \"\\ebe1\"; }\n.ri-copyright-line:before { content: \"\\ebe2\"; }\n.ri-coreos-fill:before { content: \"\\ebe3\"; }\n.ri-coreos-line:before { content: \"\\ebe4\"; }\n.ri-coupon-2-fill:before { content: \"\\ebe5\"; }\n.ri-coupon-2-line:before { content: \"\\ebe6\"; }\n.ri-coupon-3-fill:before { content: \"\\ebe7\"; }\n.ri-coupon-3-line:before { content: \"\\ebe8\"; }\n.ri-coupon-4-fill:before { content: \"\\ebe9\"; }\n.ri-coupon-4-line:before { content: \"\\ebea\"; }\n.ri-coupon-5-fill:before { content: \"\\ebeb\"; }\n.ri-coupon-5-line:before { content: \"\\ebec\"; }\n.ri-coupon-fill:before { content: \"\\ebed\"; }\n.ri-coupon-line:before { content: \"\\ebee\"; }\n.ri-cpu-fill:before { content: \"\\ebef\"; }\n.ri-cpu-line:before { content: \"\\ebf0\"; }\n.ri-creative-commons-by-fill:before { content: \"\\ebf1\"; }\n.ri-creative-commons-by-line:before { content: \"\\ebf2\"; }\n.ri-creative-commons-fill:before { content: \"\\ebf3\"; }\n.ri-creative-commons-line:before { content: \"\\ebf4\"; }\n.ri-creative-commons-nc-fill:before { content: \"\\ebf5\"; }\n.ri-creative-commons-nc-line:before { content: \"\\ebf6\"; }\n.ri-creative-commons-nd-fill:before { content: \"\\ebf7\"; }\n.ri-creative-commons-nd-line:before { content: \"\\ebf8\"; }\n.ri-creative-commons-sa-fill:before { content: \"\\ebf9\"; }\n.ri-creative-commons-sa-line:before { content: \"\\ebfa\"; }\n.ri-creative-commons-zero-fill:before { content: \"\\ebfb\"; }\n.ri-creative-commons-zero-line:before { content: \"\\ebfc\"; }\n.ri-criminal-fill:before { content: \"\\ebfd\"; }\n.ri-criminal-line:before { content: \"\\ebfe\"; }\n.ri-crop-2-fill:before { content: \"\\ebff\"; }\n.ri-crop-2-line:before { content: \"\\ec00\"; }\n.ri-crop-fill:before { content: \"\\ec01\"; }\n.ri-crop-line:before { content: \"\\ec02\"; }\n.ri-css3-fill:before { content: \"\\ec03\"; }\n.ri-css3-line:before { content: \"\\ec04\"; }\n.ri-cup-fill:before { content: \"\\ec05\"; }\n.ri-cup-line:before { content: \"\\ec06\"; }\n.ri-currency-fill:before { content: \"\\ec07\"; }\n.ri-currency-line:before { content: \"\\ec08\"; }\n.ri-cursor-fill:before { content: \"\\ec09\"; }\n.ri-cursor-line:before { content: \"\\ec0a\"; }\n.ri-customer-service-2-fill:before { content: \"\\ec0b\"; }\n.ri-customer-service-2-line:before { content: \"\\ec0c\"; }\n.ri-customer-service-fill:before { content: \"\\ec0d\"; }\n.ri-customer-service-line:before { content: \"\\ec0e\"; }\n.ri-dashboard-2-fill:before { content: \"\\ec0f\"; }\n.ri-dashboard-2-line:before { content: \"\\ec10\"; }\n.ri-dashboard-3-fill:before { content: \"\\ec11\"; }\n.ri-dashboard-3-line:before { content: \"\\ec12\"; }\n.ri-dashboard-fill:before { content: \"\\ec13\"; }\n.ri-dashboard-line:before { content: \"\\ec14\"; }\n.ri-database-2-fill:before { content: \"\\ec15\"; }\n.ri-database-2-line:before { content: \"\\ec16\"; }\n.ri-database-fill:before { content: \"\\ec17\"; }\n.ri-database-line:before { content: \"\\ec18\"; }\n.ri-delete-back-2-fill:before { content: \"\\ec19\"; }\n.ri-delete-back-2-line:before { content: \"\\ec1a\"; }\n.ri-delete-back-fill:before { content: \"\\ec1b\"; }\n.ri-delete-back-line:before { content: \"\\ec1c\"; }\n.ri-delete-bin-2-fill:before { content: \"\\ec1d\"; }\n.ri-delete-bin-2-line:before { content: \"\\ec1e\"; }\n.ri-delete-bin-3-fill:before { content: \"\\ec1f\"; }\n.ri-delete-bin-3-line:before { content: \"\\ec20\"; }\n.ri-delete-bin-4-fill:before { content: \"\\ec21\"; }\n.ri-delete-bin-4-line:before { content: \"\\ec22\"; }\n.ri-delete-bin-5-fill:before { content: \"\\ec23\"; }\n.ri-delete-bin-5-line:before { content: \"\\ec24\"; }\n.ri-delete-bin-6-fill:before { content: \"\\ec25\"; }\n.ri-delete-bin-6-line:before { content: \"\\ec26\"; }\n.ri-delete-bin-7-fill:before { content: \"\\ec27\"; }\n.ri-delete-bin-7-line:before { content: \"\\ec28\"; }\n.ri-delete-bin-fill:before { content: \"\\ec29\"; }\n.ri-delete-bin-line:before { content: \"\\ec2a\"; }\n.ri-delete-column:before { content: \"\\ec2b\"; }\n.ri-delete-row:before { content: \"\\ec2c\"; }\n.ri-device-fill:before { content: \"\\ec2d\"; }\n.ri-device-line:before { content: \"\\ec2e\"; }\n.ri-device-recover-fill:before { content: \"\\ec2f\"; }\n.ri-device-recover-line:before { content: \"\\ec30\"; }\n.ri-dingding-fill:before { content: \"\\ec31\"; }\n.ri-dingding-line:before { content: \"\\ec32\"; }\n.ri-direction-fill:before { content: \"\\ec33\"; }\n.ri-direction-line:before { content: \"\\ec34\"; }\n.ri-disc-fill:before { content: \"\\ec35\"; }\n.ri-disc-line:before { content: \"\\ec36\"; }\n.ri-discord-fill:before { content: \"\\ec37\"; }\n.ri-discord-line:before { content: \"\\ec38\"; }\n.ri-discuss-fill:before { content: \"\\ec39\"; }\n.ri-discuss-line:before { content: \"\\ec3a\"; }\n.ri-dislike-fill:before { content: \"\\ec3b\"; }\n.ri-dislike-line:before { content: \"\\ec3c\"; }\n.ri-disqus-fill:before { content: \"\\ec3d\"; }\n.ri-disqus-line:before { content: \"\\ec3e\"; }\n.ri-divide-fill:before { content: \"\\ec3f\"; }\n.ri-divide-line:before { content: \"\\ec40\"; }\n.ri-donut-chart-fill:before { content: \"\\ec41\"; }\n.ri-donut-chart-line:before { content: \"\\ec42\"; }\n.ri-door-closed-fill:before { content: \"\\ec43\"; }\n.ri-door-closed-line:before { content: \"\\ec44\"; }\n.ri-door-fill:before { content: \"\\ec45\"; }\n.ri-door-line:before { content: \"\\ec46\"; }\n.ri-door-lock-box-fill:before { content: \"\\ec47\"; }\n.ri-door-lock-box-line:before { content: \"\\ec48\"; }\n.ri-door-lock-fill:before { content: \"\\ec49\"; }\n.ri-door-lock-line:before { content: \"\\ec4a\"; }\n.ri-door-open-fill:before { content: \"\\ec4b\"; }\n.ri-door-open-line:before { content: \"\\ec4c\"; }\n.ri-dossier-fill:before { content: \"\\ec4d\"; }\n.ri-dossier-line:before { content: \"\\ec4e\"; }\n.ri-douban-fill:before { content: \"\\ec4f\"; }\n.ri-douban-line:before { content: \"\\ec50\"; }\n.ri-double-quotes-l:before { content: \"\\ec51\"; }\n.ri-double-quotes-r:before { content: \"\\ec52\"; }\n.ri-download-2-fill:before { content: \"\\ec53\"; }\n.ri-download-2-line:before { content: \"\\ec54\"; }\n.ri-download-cloud-2-fill:before { content: \"\\ec55\"; }\n.ri-download-cloud-2-line:before { content: \"\\ec56\"; }\n.ri-download-cloud-fill:before { content: \"\\ec57\"; }\n.ri-download-cloud-line:before { content: \"\\ec58\"; }\n.ri-download-fill:before { content: \"\\ec59\"; }\n.ri-download-line:before { content: \"\\ec5a\"; }\n.ri-draft-fill:before { content: \"\\ec5b\"; }\n.ri-draft-line:before { content: \"\\ec5c\"; }\n.ri-drag-drop-fill:before { content: \"\\ec5d\"; }\n.ri-drag-drop-line:before { content: \"\\ec5e\"; }\n.ri-drag-move-2-fill:before { content: \"\\ec5f\"; }\n.ri-drag-move-2-line:before { content: \"\\ec60\"; }\n.ri-drag-move-fill:before { content: \"\\ec61\"; }\n.ri-drag-move-line:before { content: \"\\ec62\"; }\n.ri-dribbble-fill:before { content: \"\\ec63\"; }\n.ri-dribbble-line:before { content: \"\\ec64\"; }\n.ri-drive-fill:before { content: \"\\ec65\"; }\n.ri-drive-line:before { content: \"\\ec66\"; }\n.ri-drizzle-fill:before { content: \"\\ec67\"; }\n.ri-drizzle-line:before { content: \"\\ec68\"; }\n.ri-drop-fill:before { content: \"\\ec69\"; }\n.ri-drop-line:before { content: \"\\ec6a\"; }\n.ri-dropbox-fill:before { content: \"\\ec6b\"; }\n.ri-dropbox-line:before { content: \"\\ec6c\"; }\n.ri-dual-sim-1-fill:before { content: \"\\ec6d\"; }\n.ri-dual-sim-1-line:before { content: \"\\ec6e\"; }\n.ri-dual-sim-2-fill:before { content: \"\\ec6f\"; }\n.ri-dual-sim-2-line:before { content: \"\\ec70\"; }\n.ri-dv-fill:before { content: \"\\ec71\"; }\n.ri-dv-line:before { content: \"\\ec72\"; }\n.ri-dvd-fill:before { content: \"\\ec73\"; }\n.ri-dvd-line:before { content: \"\\ec74\"; }\n.ri-e-bike-2-fill:before { content: \"\\ec75\"; }\n.ri-e-bike-2-line:before { content: \"\\ec76\"; }\n.ri-e-bike-fill:before { content: \"\\ec77\"; }\n.ri-e-bike-line:before { content: \"\\ec78\"; }\n.ri-earth-fill:before { content: \"\\ec79\"; }\n.ri-earth-line:before { content: \"\\ec7a\"; }\n.ri-earthquake-fill:before { content: \"\\ec7b\"; }\n.ri-earthquake-line:before { content: \"\\ec7c\"; }\n.ri-edge-fill:before { content: \"\\ec7d\"; }\n.ri-edge-line:before { content: \"\\ec7e\"; }\n.ri-edit-2-fill:before { content: \"\\ec7f\"; }\n.ri-edit-2-line:before { content: \"\\ec80\"; }\n.ri-edit-box-fill:before { content: \"\\ec81\"; }\n.ri-edit-box-line:before { content: \"\\ec82\"; }\n.ri-edit-circle-fill:before { content: \"\\ec83\"; }\n.ri-edit-circle-line:before { content: \"\\ec84\"; }\n.ri-edit-fill:before { content: \"\\ec85\"; }\n.ri-edit-line:before { content: \"\\ec86\"; }\n.ri-eject-fill:before { content: \"\\ec87\"; }\n.ri-eject-line:before { content: \"\\ec88\"; }\n.ri-emotion-2-fill:before { content: \"\\ec89\"; }\n.ri-emotion-2-line:before { content: \"\\ec8a\"; }\n.ri-emotion-fill:before { content: \"\\ec8b\"; }\n.ri-emotion-happy-fill:before { content: \"\\ec8c\"; }\n.ri-emotion-happy-line:before { content: \"\\ec8d\"; }\n.ri-emotion-laugh-fill:before { content: \"\\ec8e\"; }\n.ri-emotion-laugh-line:before { content: \"\\ec8f\"; }\n.ri-emotion-line:before { content: \"\\ec90\"; }\n.ri-emotion-normal-fill:before { content: \"\\ec91\"; }\n.ri-emotion-normal-line:before { content: \"\\ec92\"; }\n.ri-emotion-sad-fill:before { content: \"\\ec93\"; }\n.ri-emotion-sad-line:before { content: \"\\ec94\"; }\n.ri-emotion-unhappy-fill:before { content: \"\\ec95\"; }\n.ri-emotion-unhappy-line:before { content: \"\\ec96\"; }\n.ri-empathize-fill:before { content: \"\\ec97\"; }\n.ri-empathize-line:before { content: \"\\ec98\"; }\n.ri-emphasis-cn:before { content: \"\\ec99\"; }\n.ri-emphasis:before { content: \"\\ec9a\"; }\n.ri-english-input:before { content: \"\\ec9b\"; }\n.ri-equalizer-fill:before { content: \"\\ec9c\"; }\n.ri-equalizer-line:before { content: \"\\ec9d\"; }\n.ri-eraser-fill:before { content: \"\\ec9e\"; }\n.ri-eraser-line:before { content: \"\\ec9f\"; }\n.ri-error-warning-fill:before { content: \"\\eca0\"; }\n.ri-error-warning-line:before { content: \"\\eca1\"; }\n.ri-evernote-fill:before { content: \"\\eca2\"; }\n.ri-evernote-line:before { content: \"\\eca3\"; }\n.ri-exchange-box-fill:before { content: \"\\eca4\"; }\n.ri-exchange-box-line:before { content: \"\\eca5\"; }\n.ri-exchange-cny-fill:before { content: \"\\eca6\"; }\n.ri-exchange-cny-line:before { content: \"\\eca7\"; }\n.ri-exchange-dollar-fill:before { content: \"\\eca8\"; }\n.ri-exchange-dollar-line:before { content: \"\\eca9\"; }\n.ri-exchange-fill:before { content: \"\\ecaa\"; }\n.ri-exchange-funds-fill:before { content: \"\\ecab\"; }\n.ri-exchange-funds-line:before { content: \"\\ecac\"; }\n.ri-exchange-line:before { content: \"\\ecad\"; }\n.ri-external-link-fill:before { content: \"\\ecae\"; }\n.ri-external-link-line:before { content: \"\\ecaf\"; }\n.ri-eye-2-fill:before { content: \"\\ecb0\"; }\n.ri-eye-2-line:before { content: \"\\ecb1\"; }\n.ri-eye-close-fill:before { content: \"\\ecb2\"; }\n.ri-eye-close-line:before { content: \"\\ecb3\"; }\n.ri-eye-fill:before { content: \"\\ecb4\"; }\n.ri-eye-line:before { content: \"\\ecb5\"; }\n.ri-eye-off-fill:before { content: \"\\ecb6\"; }\n.ri-eye-off-line:before { content: \"\\ecb7\"; }\n.ri-facebook-box-fill:before { content: \"\\ecb8\"; }\n.ri-facebook-box-line:before { content: \"\\ecb9\"; }\n.ri-facebook-circle-fill:before { content: \"\\ecba\"; }\n.ri-facebook-circle-line:before { content: \"\\ecbb\"; }\n.ri-facebook-fill:before { content: \"\\ecbc\"; }\n.ri-facebook-line:before { content: \"\\ecbd\"; }\n.ri-fahrenheit-fill:before { content: \"\\ecbe\"; }\n.ri-fahrenheit-line:before { content: \"\\ecbf\"; }\n.ri-feedback-fill:before { content: \"\\ecc0\"; }\n.ri-feedback-line:before { content: \"\\ecc1\"; }\n.ri-file-2-fill:before { content: \"\\ecc2\"; }\n.ri-file-2-line:before { content: \"\\ecc3\"; }\n.ri-file-3-fill:before { content: \"\\ecc4\"; }\n.ri-file-3-line:before { content: \"\\ecc5\"; }\n.ri-file-4-fill:before { content: \"\\ecc6\"; }\n.ri-file-4-line:before { content: \"\\ecc7\"; }\n.ri-file-add-fill:before { content: \"\\ecc8\"; }\n.ri-file-add-line:before { content: \"\\ecc9\"; }\n.ri-file-chart-2-fill:before { content: \"\\ecca\"; }\n.ri-file-chart-2-line:before { content: \"\\eccb\"; }\n.ri-file-chart-fill:before { content: \"\\eccc\"; }\n.ri-file-chart-line:before { content: \"\\eccd\"; }\n.ri-file-cloud-fill:before { content: \"\\ecce\"; }\n.ri-file-cloud-line:before { content: \"\\eccf\"; }\n.ri-file-code-fill:before { content: \"\\ecd0\"; }\n.ri-file-code-line:before { content: \"\\ecd1\"; }\n.ri-file-copy-2-fill:before { content: \"\\ecd2\"; }\n.ri-file-copy-2-line:before { content: \"\\ecd3\"; }\n.ri-file-copy-fill:before { content: \"\\ecd4\"; }\n.ri-file-copy-line:before { content: \"\\ecd5\"; }\n.ri-file-damage-fill:before { content: \"\\ecd6\"; }\n.ri-file-damage-line:before { content: \"\\ecd7\"; }\n.ri-file-download-fill:before { content: \"\\ecd8\"; }\n.ri-file-download-line:before { content: \"\\ecd9\"; }\n.ri-file-edit-fill:before { content: \"\\ecda\"; }\n.ri-file-edit-line:before { content: \"\\ecdb\"; }\n.ri-file-excel-2-fill:before { content: \"\\ecdc\"; }\n.ri-file-excel-2-line:before { content: \"\\ecdd\"; }\n.ri-file-excel-fill:before { content: \"\\ecde\"; }\n.ri-file-excel-line:before { content: \"\\ecdf\"; }\n.ri-file-fill:before { content: \"\\ece0\"; }\n.ri-file-forbid-fill:before { content: \"\\ece1\"; }\n.ri-file-forbid-line:before { content: \"\\ece2\"; }\n.ri-file-gif-fill:before { content: \"\\ece3\"; }\n.ri-file-gif-line:before { content: \"\\ece4\"; }\n.ri-file-history-fill:before { content: \"\\ece5\"; }\n.ri-file-history-line:before { content: \"\\ece6\"; }\n.ri-file-hwp-fill:before { content: \"\\ece7\"; }\n.ri-file-hwp-line:before { content: \"\\ece8\"; }\n.ri-file-info-fill:before { content: \"\\ece9\"; }\n.ri-file-info-line:before { content: \"\\ecea\"; }\n.ri-file-line:before { content: \"\\eceb\"; }\n.ri-file-list-2-fill:before { content: \"\\ecec\"; }\n.ri-file-list-2-line:before { content: \"\\eced\"; }\n.ri-file-list-3-fill:before { content: \"\\ecee\"; }\n.ri-file-list-3-line:before { content: \"\\ecef\"; }\n.ri-file-list-fill:before { content: \"\\ecf0\"; }\n.ri-file-list-line:before { content: \"\\ecf1\"; }\n.ri-file-lock-fill:before { content: \"\\ecf2\"; }\n.ri-file-lock-line:before { content: \"\\ecf3\"; }\n.ri-file-mark-fill:before { content: \"\\ecf4\"; }\n.ri-file-mark-line:before { content: \"\\ecf5\"; }\n.ri-file-music-fill:before { content: \"\\ecf6\"; }\n.ri-file-music-line:before { content: \"\\ecf7\"; }\n.ri-file-paper-2-fill:before { content: \"\\ecf8\"; }\n.ri-file-paper-2-line:before { content: \"\\ecf9\"; }\n.ri-file-paper-fill:before { content: \"\\ecfa\"; }\n.ri-file-paper-line:before { content: \"\\ecfb\"; }\n.ri-file-pdf-fill:before { content: \"\\ecfc\"; }\n.ri-file-pdf-line:before { content: \"\\ecfd\"; }\n.ri-file-ppt-2-fill:before { content: \"\\ecfe\"; }\n.ri-file-ppt-2-line:before { content: \"\\ecff\"; }\n.ri-file-ppt-fill:before { content: \"\\ed00\"; }\n.ri-file-ppt-line:before { content: \"\\ed01\"; }\n.ri-file-reduce-fill:before { content: \"\\ed02\"; }\n.ri-file-reduce-line:before { content: \"\\ed03\"; }\n.ri-file-search-fill:before { content: \"\\ed04\"; }\n.ri-file-search-line:before { content: \"\\ed05\"; }\n.ri-file-settings-fill:before { content: \"\\ed06\"; }\n.ri-file-settings-line:before { content: \"\\ed07\"; }\n.ri-file-shield-2-fill:before { content: \"\\ed08\"; }\n.ri-file-shield-2-line:before { content: \"\\ed09\"; }\n.ri-file-shield-fill:before { content: \"\\ed0a\"; }\n.ri-file-shield-line:before { content: \"\\ed0b\"; }\n.ri-file-shred-fill:before { content: \"\\ed0c\"; }\n.ri-file-shred-line:before { content: \"\\ed0d\"; }\n.ri-file-text-fill:before { content: \"\\ed0e\"; }\n.ri-file-text-line:before { content: \"\\ed0f\"; }\n.ri-file-transfer-fill:before { content: \"\\ed10\"; }\n.ri-file-transfer-line:before { content: \"\\ed11\"; }\n.ri-file-unknow-fill:before { content: \"\\ed12\"; }\n.ri-file-unknow-line:before { content: \"\\ed13\"; }\n.ri-file-upload-fill:before { content: \"\\ed14\"; }\n.ri-file-upload-line:before { content: \"\\ed15\"; }\n.ri-file-user-fill:before { content: \"\\ed16\"; }\n.ri-file-user-line:before { content: \"\\ed17\"; }\n.ri-file-warning-fill:before { content: \"\\ed18\"; }\n.ri-file-warning-line:before { content: \"\\ed19\"; }\n.ri-file-word-2-fill:before { content: \"\\ed1a\"; }\n.ri-file-word-2-line:before { content: \"\\ed1b\"; }\n.ri-file-word-fill:before { content: \"\\ed1c\"; }\n.ri-file-word-line:before { content: \"\\ed1d\"; }\n.ri-file-zip-fill:before { content: \"\\ed1e\"; }\n.ri-file-zip-line:before { content: \"\\ed1f\"; }\n.ri-film-fill:before { content: \"\\ed20\"; }\n.ri-film-line:before { content: \"\\ed21\"; }\n.ri-filter-2-fill:before { content: \"\\ed22\"; }\n.ri-filter-2-line:before { content: \"\\ed23\"; }\n.ri-filter-3-fill:before { content: \"\\ed24\"; }\n.ri-filter-3-line:before { content: \"\\ed25\"; }\n.ri-filter-fill:before { content: \"\\ed26\"; }\n.ri-filter-line:before { content: \"\\ed27\"; }\n.ri-filter-off-fill:before { content: \"\\ed28\"; }\n.ri-filter-off-line:before { content: \"\\ed29\"; }\n.ri-find-replace-fill:before { content: \"\\ed2a\"; }\n.ri-find-replace-line:before { content: \"\\ed2b\"; }\n.ri-finder-fill:before { content: \"\\ed2c\"; }\n.ri-finder-line:before { content: \"\\ed2d\"; }\n.ri-fingerprint-2-fill:before { content: \"\\ed2e\"; }\n.ri-fingerprint-2-line:before { content: \"\\ed2f\"; }\n.ri-fingerprint-fill:before { content: \"\\ed30\"; }\n.ri-fingerprint-line:before { content: \"\\ed31\"; }\n.ri-fire-fill:before { content: \"\\ed32\"; }\n.ri-fire-line:before { content: \"\\ed33\"; }\n.ri-firefox-fill:before { content: \"\\ed34\"; }\n.ri-firefox-line:before { content: \"\\ed35\"; }\n.ri-first-aid-kit-fill:before { content: \"\\ed36\"; }\n.ri-first-aid-kit-line:before { content: \"\\ed37\"; }\n.ri-flag-2-fill:before { content: \"\\ed38\"; }\n.ri-flag-2-line:before { content: \"\\ed39\"; }\n.ri-flag-fill:before { content: \"\\ed3a\"; }\n.ri-flag-line:before { content: \"\\ed3b\"; }\n.ri-flashlight-fill:before { content: \"\\ed3c\"; }\n.ri-flashlight-line:before { content: \"\\ed3d\"; }\n.ri-flask-fill:before { content: \"\\ed3e\"; }\n.ri-flask-line:before { content: \"\\ed3f\"; }\n.ri-flight-land-fill:before { content: \"\\ed40\"; }\n.ri-flight-land-line:before { content: \"\\ed41\"; }\n.ri-flight-takeoff-fill:before { content: \"\\ed42\"; }\n.ri-flight-takeoff-line:before { content: \"\\ed43\"; }\n.ri-flood-fill:before { content: \"\\ed44\"; }\n.ri-flood-line:before { content: \"\\ed45\"; }\n.ri-flow-chart:before { content: \"\\ed46\"; }\n.ri-flutter-fill:before { content: \"\\ed47\"; }\n.ri-flutter-line:before { content: \"\\ed48\"; }\n.ri-focus-2-fill:before { content: \"\\ed49\"; }\n.ri-focus-2-line:before { content: \"\\ed4a\"; }\n.ri-focus-3-fill:before { content: \"\\ed4b\"; }\n.ri-focus-3-line:before { content: \"\\ed4c\"; }\n.ri-focus-fill:before { content: \"\\ed4d\"; }\n.ri-focus-line:before { content: \"\\ed4e\"; }\n.ri-foggy-fill:before { content: \"\\ed4f\"; }\n.ri-foggy-line:before { content: \"\\ed50\"; }\n.ri-folder-2-fill:before { content: \"\\ed51\"; }\n.ri-folder-2-line:before { content: \"\\ed52\"; }\n.ri-folder-3-fill:before { content: \"\\ed53\"; }\n.ri-folder-3-line:before { content: \"\\ed54\"; }\n.ri-folder-4-fill:before { content: \"\\ed55\"; }\n.ri-folder-4-line:before { content: \"\\ed56\"; }\n.ri-folder-5-fill:before { content: \"\\ed57\"; }\n.ri-folder-5-line:before { content: \"\\ed58\"; }\n.ri-folder-add-fill:before { content: \"\\ed59\"; }\n.ri-folder-add-line:before { content: \"\\ed5a\"; }\n.ri-folder-chart-2-fill:before { content: \"\\ed5b\"; }\n.ri-folder-chart-2-line:before { content: \"\\ed5c\"; }\n.ri-folder-chart-fill:before { content: \"\\ed5d\"; }\n.ri-folder-chart-line:before { content: \"\\ed5e\"; }\n.ri-folder-download-fill:before { content: \"\\ed5f\"; }\n.ri-folder-download-line:before { content: \"\\ed60\"; }\n.ri-folder-fill:before { content: \"\\ed61\"; }\n.ri-folder-forbid-fill:before { content: \"\\ed62\"; }\n.ri-folder-forbid-line:before { content: \"\\ed63\"; }\n.ri-folder-history-fill:before { content: \"\\ed64\"; }\n.ri-folder-history-line:before { content: \"\\ed65\"; }\n.ri-folder-info-fill:before { content: \"\\ed66\"; }\n.ri-folder-info-line:before { content: \"\\ed67\"; }\n.ri-folder-keyhole-fill:before { content: \"\\ed68\"; }\n.ri-folder-keyhole-line:before { content: \"\\ed69\"; }\n.ri-folder-line:before { content: \"\\ed6a\"; }\n.ri-folder-lock-fill:before { content: \"\\ed6b\"; }\n.ri-folder-lock-line:before { content: \"\\ed6c\"; }\n.ri-folder-music-fill:before { content: \"\\ed6d\"; }\n.ri-folder-music-line:before { content: \"\\ed6e\"; }\n.ri-folder-open-fill:before { content: \"\\ed6f\"; }\n.ri-folder-open-line:before { content: \"\\ed70\"; }\n.ri-folder-received-fill:before { content: \"\\ed71\"; }\n.ri-folder-received-line:before { content: \"\\ed72\"; }\n.ri-folder-reduce-fill:before { content: \"\\ed73\"; }\n.ri-folder-reduce-line:before { content: \"\\ed74\"; }\n.ri-folder-settings-fill:before { content: \"\\ed75\"; }\n.ri-folder-settings-line:before { content: \"\\ed76\"; }\n.ri-folder-shared-fill:before { content: \"\\ed77\"; }\n.ri-folder-shared-line:before { content: \"\\ed78\"; }\n.ri-folder-shield-2-fill:before { content: \"\\ed79\"; }\n.ri-folder-shield-2-line:before { content: \"\\ed7a\"; }\n.ri-folder-shield-fill:before { content: \"\\ed7b\"; }\n.ri-folder-shield-line:before { content: \"\\ed7c\"; }\n.ri-folder-transfer-fill:before { content: \"\\ed7d\"; }\n.ri-folder-transfer-line:before { content: \"\\ed7e\"; }\n.ri-folder-unknow-fill:before { content: \"\\ed7f\"; }\n.ri-folder-unknow-line:before { content: \"\\ed80\"; }\n.ri-folder-upload-fill:before { content: \"\\ed81\"; }\n.ri-folder-upload-line:before { content: \"\\ed82\"; }\n.ri-folder-user-fill:before { content: \"\\ed83\"; }\n.ri-folder-user-line:before { content: \"\\ed84\"; }\n.ri-folder-warning-fill:before { content: \"\\ed85\"; }\n.ri-folder-warning-line:before { content: \"\\ed86\"; }\n.ri-folder-zip-fill:before { content: \"\\ed87\"; }\n.ri-folder-zip-line:before { content: \"\\ed88\"; }\n.ri-folders-fill:before { content: \"\\ed89\"; }\n.ri-folders-line:before { content: \"\\ed8a\"; }\n.ri-font-color:before { content: \"\\ed8b\"; }\n.ri-font-size-2:before { content: \"\\ed8c\"; }\n.ri-font-size:before { content: \"\\ed8d\"; }\n.ri-football-fill:before { content: \"\\ed8e\"; }\n.ri-football-line:before { content: \"\\ed8f\"; }\n.ri-footprint-fill:before { content: \"\\ed90\"; }\n.ri-footprint-line:before { content: \"\\ed91\"; }\n.ri-forbid-2-fill:before { content: \"\\ed92\"; }\n.ri-forbid-2-line:before { content: \"\\ed93\"; }\n.ri-forbid-fill:before { content: \"\\ed94\"; }\n.ri-forbid-line:before { content: \"\\ed95\"; }\n.ri-format-clear:before { content: \"\\ed96\"; }\n.ri-fridge-fill:before { content: \"\\ed97\"; }\n.ri-fridge-line:before { content: \"\\ed98\"; }\n.ri-fullscreen-exit-fill:before { content: \"\\ed99\"; }\n.ri-fullscreen-exit-line:before { content: \"\\ed9a\"; }\n.ri-fullscreen-fill:before { content: \"\\ed9b\"; }\n.ri-fullscreen-line:before { content: \"\\ed9c\"; }\n.ri-function-fill:before { content: \"\\ed9d\"; }\n.ri-function-line:before { content: \"\\ed9e\"; }\n.ri-functions:before { content: \"\\ed9f\"; }\n.ri-funds-box-fill:before { content: \"\\eda0\"; }\n.ri-funds-box-line:before { content: \"\\eda1\"; }\n.ri-funds-fill:before { content: \"\\eda2\"; }\n.ri-funds-line:before { content: \"\\eda3\"; }\n.ri-gallery-fill:before { content: \"\\eda4\"; }\n.ri-gallery-line:before { content: \"\\eda5\"; }\n.ri-gallery-upload-fill:before { content: \"\\eda6\"; }\n.ri-gallery-upload-line:before { content: \"\\eda7\"; }\n.ri-game-fill:before { content: \"\\eda8\"; }\n.ri-game-line:before { content: \"\\eda9\"; }\n.ri-gamepad-fill:before { content: \"\\edaa\"; }\n.ri-gamepad-line:before { content: \"\\edab\"; }\n.ri-gas-station-fill:before { content: \"\\edac\"; }\n.ri-gas-station-line:before { content: \"\\edad\"; }\n.ri-gatsby-fill:before { content: \"\\edae\"; }\n.ri-gatsby-line:before { content: \"\\edaf\"; }\n.ri-genderless-fill:before { content: \"\\edb0\"; }\n.ri-genderless-line:before { content: \"\\edb1\"; }\n.ri-ghost-2-fill:before { content: \"\\edb2\"; }\n.ri-ghost-2-line:before { content: \"\\edb3\"; }\n.ri-ghost-fill:before { content: \"\\edb4\"; }\n.ri-ghost-line:before { content: \"\\edb5\"; }\n.ri-ghost-smile-fill:before { content: \"\\edb6\"; }\n.ri-ghost-smile-line:before { content: \"\\edb7\"; }\n.ri-gift-2-fill:before { content: \"\\edb8\"; }\n.ri-gift-2-line:before { content: \"\\edb9\"; }\n.ri-gift-fill:before { content: \"\\edba\"; }\n.ri-gift-line:before { content: \"\\edbb\"; }\n.ri-git-branch-fill:before { content: \"\\edbc\"; }\n.ri-git-branch-line:before { content: \"\\edbd\"; }\n.ri-git-commit-fill:before { content: \"\\edbe\"; }\n.ri-git-commit-line:before { content: \"\\edbf\"; }\n.ri-git-merge-fill:before { content: \"\\edc0\"; }\n.ri-git-merge-line:before { content: \"\\edc1\"; }\n.ri-git-pull-request-fill:before { content: \"\\edc2\"; }\n.ri-git-pull-request-line:before { content: \"\\edc3\"; }\n.ri-git-repository-commits-fill:before { content: \"\\edc4\"; }\n.ri-git-repository-commits-line:before { content: \"\\edc5\"; }\n.ri-git-repository-fill:before { content: \"\\edc6\"; }\n.ri-git-repository-line:before { content: \"\\edc7\"; }\n.ri-git-repository-private-fill:before { content: \"\\edc8\"; }\n.ri-git-repository-private-line:before { content: \"\\edc9\"; }\n.ri-github-fill:before { content: \"\\edca\"; }\n.ri-github-line:before { content: \"\\edcb\"; }\n.ri-gitlab-fill:before { content: \"\\edcc\"; }\n.ri-gitlab-line:before { content: \"\\edcd\"; }\n.ri-global-fill:before { content: \"\\edce\"; }\n.ri-global-line:before { content: \"\\edcf\"; }\n.ri-globe-fill:before { content: \"\\edd0\"; }\n.ri-globe-line:before { content: \"\\edd1\"; }\n.ri-goblet-fill:before { content: \"\\edd2\"; }\n.ri-goblet-line:before { content: \"\\edd3\"; }\n.ri-google-fill:before { content: \"\\edd4\"; }\n.ri-google-line:before { content: \"\\edd5\"; }\n.ri-google-play-fill:before { content: \"\\edd6\"; }\n.ri-google-play-line:before { content: \"\\edd7\"; }\n.ri-government-fill:before { content: \"\\edd8\"; }\n.ri-government-line:before { content: \"\\edd9\"; }\n.ri-gps-fill:before { content: \"\\edda\"; }\n.ri-gps-line:before { content: \"\\eddb\"; }\n.ri-gradienter-fill:before { content: \"\\eddc\"; }\n.ri-gradienter-line:before { content: \"\\eddd\"; }\n.ri-grid-fill:before { content: \"\\edde\"; }\n.ri-grid-line:before { content: \"\\eddf\"; }\n.ri-group-2-fill:before { content: \"\\ede0\"; }\n.ri-group-2-line:before { content: \"\\ede1\"; }\n.ri-group-fill:before { content: \"\\ede2\"; }\n.ri-group-line:before { content: \"\\ede3\"; }\n.ri-guide-fill:before { content: \"\\ede4\"; }\n.ri-guide-line:before { content: \"\\ede5\"; }\n.ri-h-1:before { content: \"\\ede6\"; }\n.ri-h-2:before { content: \"\\ede7\"; }\n.ri-h-3:before { content: \"\\ede8\"; }\n.ri-h-4:before { content: \"\\ede9\"; }\n.ri-h-5:before { content: \"\\edea\"; }\n.ri-h-6:before { content: \"\\edeb\"; }\n.ri-hail-fill:before { content: \"\\edec\"; }\n.ri-hail-line:before { content: \"\\eded\"; }\n.ri-hammer-fill:before { content: \"\\edee\"; }\n.ri-hammer-line:before { content: \"\\edef\"; }\n.ri-hand-coin-fill:before { content: \"\\edf0\"; }\n.ri-hand-coin-line:before { content: \"\\edf1\"; }\n.ri-hand-heart-fill:before { content: \"\\edf2\"; }\n.ri-hand-heart-line:before { content: \"\\edf3\"; }\n.ri-hand-sanitizer-fill:before { content: \"\\edf4\"; }\n.ri-hand-sanitizer-line:before { content: \"\\edf5\"; }\n.ri-handbag-fill:before { content: \"\\edf6\"; }\n.ri-handbag-line:before { content: \"\\edf7\"; }\n.ri-hard-drive-2-fill:before { content: \"\\edf8\"; }\n.ri-hard-drive-2-line:before { content: \"\\edf9\"; }\n.ri-hard-drive-fill:before { content: \"\\edfa\"; }\n.ri-hard-drive-line:before { content: \"\\edfb\"; }\n.ri-hashtag:before { content: \"\\edfc\"; }\n.ri-haze-2-fill:before { content: \"\\edfd\"; }\n.ri-haze-2-line:before { content: \"\\edfe\"; }\n.ri-haze-fill:before { content: \"\\edff\"; }\n.ri-haze-line:before { content: \"\\ee00\"; }\n.ri-hd-fill:before { content: \"\\ee01\"; }\n.ri-hd-line:before { content: \"\\ee02\"; }\n.ri-heading:before { content: \"\\ee03\"; }\n.ri-headphone-fill:before { content: \"\\ee04\"; }\n.ri-headphone-line:before { content: \"\\ee05\"; }\n.ri-health-book-fill:before { content: \"\\ee06\"; }\n.ri-health-book-line:before { content: \"\\ee07\"; }\n.ri-heart-2-fill:before { content: \"\\ee08\"; }\n.ri-heart-2-line:before { content: \"\\ee09\"; }\n.ri-heart-3-fill:before { content: \"\\ee0a\"; }\n.ri-heart-3-line:before { content: \"\\ee0b\"; }\n.ri-heart-add-fill:before { content: \"\\ee0c\"; }\n.ri-heart-add-line:before { content: \"\\ee0d\"; }\n.ri-heart-fill:before { content: \"\\ee0e\"; }\n.ri-heart-line:before { content: \"\\ee0f\"; }\n.ri-heart-pulse-fill:before { content: \"\\ee10\"; }\n.ri-heart-pulse-line:before { content: \"\\ee11\"; }\n.ri-hearts-fill:before { content: \"\\ee12\"; }\n.ri-hearts-line:before { content: \"\\ee13\"; }\n.ri-heavy-showers-fill:before { content: \"\\ee14\"; }\n.ri-heavy-showers-line:before { content: \"\\ee15\"; }\n.ri-history-fill:before { content: \"\\ee16\"; }\n.ri-history-line:before { content: \"\\ee17\"; }\n.ri-home-2-fill:before { content: \"\\ee18\"; }\n.ri-home-2-line:before { content: \"\\ee19\"; }\n.ri-home-3-fill:before { content: \"\\ee1a\"; }\n.ri-home-3-line:before { content: \"\\ee1b\"; }\n.ri-home-4-fill:before { content: \"\\ee1c\"; }\n.ri-home-4-line:before { content: \"\\ee1d\"; }\n.ri-home-5-fill:before { content: \"\\ee1e\"; }\n.ri-home-5-line:before { content: \"\\ee1f\"; }\n.ri-home-6-fill:before { content: \"\\ee20\"; }\n.ri-home-6-line:before { content: \"\\ee21\"; }\n.ri-home-7-fill:before { content: \"\\ee22\"; }\n.ri-home-7-line:before { content: \"\\ee23\"; }\n.ri-home-8-fill:before { content: \"\\ee24\"; }\n.ri-home-8-line:before { content: \"\\ee25\"; }\n.ri-home-fill:before { content: \"\\ee26\"; }\n.ri-home-gear-fill:before { content: \"\\ee27\"; }\n.ri-home-gear-line:before { content: \"\\ee28\"; }\n.ri-home-heart-fill:before { content: \"\\ee29\"; }\n.ri-home-heart-line:before { content: \"\\ee2a\"; }\n.ri-home-line:before { content: \"\\ee2b\"; }\n.ri-home-smile-2-fill:before { content: \"\\ee2c\"; }\n.ri-home-smile-2-line:before { content: \"\\ee2d\"; }\n.ri-home-smile-fill:before { content: \"\\ee2e\"; }\n.ri-home-smile-line:before { content: \"\\ee2f\"; }\n.ri-home-wifi-fill:before { content: \"\\ee30\"; }\n.ri-home-wifi-line:before { content: \"\\ee31\"; }\n.ri-honor-of-kings-fill:before { content: \"\\ee32\"; }\n.ri-honor-of-kings-line:before { content: \"\\ee33\"; }\n.ri-honour-fill:before { content: \"\\ee34\"; }\n.ri-honour-line:before { content: \"\\ee35\"; }\n.ri-hospital-fill:before { content: \"\\ee36\"; }\n.ri-hospital-line:before { content: \"\\ee37\"; }\n.ri-hotel-bed-fill:before { content: \"\\ee38\"; }\n.ri-hotel-bed-line:before { content: \"\\ee39\"; }\n.ri-hotel-fill:before { content: \"\\ee3a\"; }\n.ri-hotel-line:before { content: \"\\ee3b\"; }\n.ri-hotspot-fill:before { content: \"\\ee3c\"; }\n.ri-hotspot-line:before { content: \"\\ee3d\"; }\n.ri-hq-fill:before { content: \"\\ee3e\"; }\n.ri-hq-line:before { content: \"\\ee3f\"; }\n.ri-html5-fill:before { content: \"\\ee40\"; }\n.ri-html5-line:before { content: \"\\ee41\"; }\n.ri-ie-fill:before { content: \"\\ee42\"; }\n.ri-ie-line:before { content: \"\\ee43\"; }\n.ri-image-2-fill:before { content: \"\\ee44\"; }\n.ri-image-2-line:before { content: \"\\ee45\"; }\n.ri-image-add-fill:before { content: \"\\ee46\"; }\n.ri-image-add-line:before { content: \"\\ee47\"; }\n.ri-image-edit-fill:before { content: \"\\ee48\"; }\n.ri-image-edit-line:before { content: \"\\ee49\"; }\n.ri-image-fill:before { content: \"\\ee4a\"; }\n.ri-image-line:before { content: \"\\ee4b\"; }\n.ri-inbox-archive-fill:before { content: \"\\ee4c\"; }\n.ri-inbox-archive-line:before { content: \"\\ee4d\"; }\n.ri-inbox-fill:before { content: \"\\ee4e\"; }\n.ri-inbox-line:before { content: \"\\ee4f\"; }\n.ri-inbox-unarchive-fill:before { content: \"\\ee50\"; }\n.ri-inbox-unarchive-line:before { content: \"\\ee51\"; }\n.ri-increase-decrease-fill:before { content: \"\\ee52\"; }\n.ri-increase-decrease-line:before { content: \"\\ee53\"; }\n.ri-indent-decrease:before { content: \"\\ee54\"; }\n.ri-indent-increase:before { content: \"\\ee55\"; }\n.ri-indeterminate-circle-fill:before { content: \"\\ee56\"; }\n.ri-indeterminate-circle-line:before { content: \"\\ee57\"; }\n.ri-information-fill:before { content: \"\\ee58\"; }\n.ri-information-line:before { content: \"\\ee59\"; }\n.ri-infrared-thermometer-fill:before { content: \"\\ee5a\"; }\n.ri-infrared-thermometer-line:before { content: \"\\ee5b\"; }\n.ri-ink-bottle-fill:before { content: \"\\ee5c\"; }\n.ri-ink-bottle-line:before { content: \"\\ee5d\"; }\n.ri-input-cursor-move:before { content: \"\\ee5e\"; }\n.ri-input-method-fill:before { content: \"\\ee5f\"; }\n.ri-input-method-line:before { content: \"\\ee60\"; }\n.ri-insert-column-left:before { content: \"\\ee61\"; }\n.ri-insert-column-right:before { content: \"\\ee62\"; }\n.ri-insert-row-bottom:before { content: \"\\ee63\"; }\n.ri-insert-row-top:before { content: \"\\ee64\"; }\n.ri-instagram-fill:before { content: \"\\ee65\"; }\n.ri-instagram-line:before { content: \"\\ee66\"; }\n.ri-install-fill:before { content: \"\\ee67\"; }\n.ri-install-line:before { content: \"\\ee68\"; }\n.ri-invision-fill:before { content: \"\\ee69\"; }\n.ri-invision-line:before { content: \"\\ee6a\"; }\n.ri-italic:before { content: \"\\ee6b\"; }\n.ri-kakao-talk-fill:before { content: \"\\ee6c\"; }\n.ri-kakao-talk-line:before { content: \"\\ee6d\"; }\n.ri-key-2-fill:before { content: \"\\ee6e\"; }\n.ri-key-2-line:before { content: \"\\ee6f\"; }\n.ri-key-fill:before { content: \"\\ee70\"; }\n.ri-key-line:before { content: \"\\ee71\"; }\n.ri-keyboard-box-fill:before { content: \"\\ee72\"; }\n.ri-keyboard-box-line:before { content: \"\\ee73\"; }\n.ri-keyboard-fill:before { content: \"\\ee74\"; }\n.ri-keyboard-line:before { content: \"\\ee75\"; }\n.ri-keynote-fill:before { content: \"\\ee76\"; }\n.ri-keynote-line:before { content: \"\\ee77\"; }\n.ri-knife-blood-fill:before { content: \"\\ee78\"; }\n.ri-knife-blood-line:before { content: \"\\ee79\"; }\n.ri-knife-fill:before { content: \"\\ee7a\"; }\n.ri-knife-line:before { content: \"\\ee7b\"; }\n.ri-landscape-fill:before { content: \"\\ee7c\"; }\n.ri-landscape-line:before { content: \"\\ee7d\"; }\n.ri-layout-2-fill:before { content: \"\\ee7e\"; }\n.ri-layout-2-line:before { content: \"\\ee7f\"; }\n.ri-layout-3-fill:before { content: \"\\ee80\"; }\n.ri-layout-3-line:before { content: \"\\ee81\"; }\n.ri-layout-4-fill:before { content: \"\\ee82\"; }\n.ri-layout-4-line:before { content: \"\\ee83\"; }\n.ri-layout-5-fill:before { content: \"\\ee84\"; }\n.ri-layout-5-line:before { content: \"\\ee85\"; }\n.ri-layout-6-fill:before { content: \"\\ee86\"; }\n.ri-layout-6-line:before { content: \"\\ee87\"; }\n.ri-layout-bottom-2-fill:before { content: \"\\ee88\"; }\n.ri-layout-bottom-2-line:before { content: \"\\ee89\"; }\n.ri-layout-bottom-fill:before { content: \"\\ee8a\"; }\n.ri-layout-bottom-line:before { content: \"\\ee8b\"; }\n.ri-layout-column-fill:before { content: \"\\ee8c\"; }\n.ri-layout-column-line:before { content: \"\\ee8d\"; }\n.ri-layout-fill:before { content: \"\\ee8e\"; }\n.ri-layout-grid-fill:before { content: \"\\ee8f\"; }\n.ri-layout-grid-line:before { content: \"\\ee90\"; }\n.ri-layout-left-2-fill:before { content: \"\\ee91\"; }\n.ri-layout-left-2-line:before { content: \"\\ee92\"; }\n.ri-layout-left-fill:before { content: \"\\ee93\"; }\n.ri-layout-left-line:before { content: \"\\ee94\"; }\n.ri-layout-line:before { content: \"\\ee95\"; }\n.ri-layout-masonry-fill:before { content: \"\\ee96\"; }\n.ri-layout-masonry-line:before { content: \"\\ee97\"; }\n.ri-layout-right-2-fill:before { content: \"\\ee98\"; }\n.ri-layout-right-2-line:before { content: \"\\ee99\"; }\n.ri-layout-right-fill:before { content: \"\\ee9a\"; }\n.ri-layout-right-line:before { content: \"\\ee9b\"; }\n.ri-layout-row-fill:before { content: \"\\ee9c\"; }\n.ri-layout-row-line:before { content: \"\\ee9d\"; }\n.ri-layout-top-2-fill:before { content: \"\\ee9e\"; }\n.ri-layout-top-2-line:before { content: \"\\ee9f\"; }\n.ri-layout-top-fill:before { content: \"\\eea0\"; }\n.ri-layout-top-line:before { content: \"\\eea1\"; }\n.ri-leaf-fill:before { content: \"\\eea2\"; }\n.ri-leaf-line:before { content: \"\\eea3\"; }\n.ri-lifebuoy-fill:before { content: \"\\eea4\"; }\n.ri-lifebuoy-line:before { content: \"\\eea5\"; }\n.ri-lightbulb-fill:before { content: \"\\eea6\"; }\n.ri-lightbulb-flash-fill:before { content: \"\\eea7\"; }\n.ri-lightbulb-flash-line:before { content: \"\\eea8\"; }\n.ri-lightbulb-line:before { content: \"\\eea9\"; }\n.ri-line-chart-fill:before { content: \"\\eeaa\"; }\n.ri-line-chart-line:before { content: \"\\eeab\"; }\n.ri-line-fill:before { content: \"\\eeac\"; }\n.ri-line-height:before { content: \"\\eead\"; }\n.ri-line-line:before { content: \"\\eeae\"; }\n.ri-link-m:before { content: \"\\eeaf\"; }\n.ri-link-unlink-m:before { content: \"\\eeb0\"; }\n.ri-link-unlink:before { content: \"\\eeb1\"; }\n.ri-link:before { content: \"\\eeb2\"; }\n.ri-linkedin-box-fill:before { content: \"\\eeb3\"; }\n.ri-linkedin-box-line:before { content: \"\\eeb4\"; }\n.ri-linkedin-fill:before { content: \"\\eeb5\"; }\n.ri-linkedin-line:before { content: \"\\eeb6\"; }\n.ri-links-fill:before { content: \"\\eeb7\"; }\n.ri-links-line:before { content: \"\\eeb8\"; }\n.ri-list-check-2:before { content: \"\\eeb9\"; }\n.ri-list-check:before { content: \"\\eeba\"; }\n.ri-list-ordered:before { content: \"\\eebb\"; }\n.ri-list-settings-fill:before { content: \"\\eebc\"; }\n.ri-list-settings-line:before { content: \"\\eebd\"; }\n.ri-list-unordered:before { content: \"\\eebe\"; }\n.ri-live-fill:before { content: \"\\eebf\"; }\n.ri-live-line:before { content: \"\\eec0\"; }\n.ri-loader-2-fill:before { content: \"\\eec1\"; }\n.ri-loader-2-line:before { content: \"\\eec2\"; }\n.ri-loader-3-fill:before { content: \"\\eec3\"; }\n.ri-loader-3-line:before { content: \"\\eec4\"; }\n.ri-loader-4-fill:before { content: \"\\eec5\"; }\n.ri-loader-4-line:before { content: \"\\eec6\"; }\n.ri-loader-5-fill:before { content: \"\\eec7\"; }\n.ri-loader-5-line:before { content: \"\\eec8\"; }\n.ri-loader-fill:before { content: \"\\eec9\"; }\n.ri-loader-line:before { content: \"\\eeca\"; }\n.ri-lock-2-fill:before { content: \"\\eecb\"; }\n.ri-lock-2-line:before { content: \"\\eecc\"; }\n.ri-lock-fill:before { content: \"\\eecd\"; }\n.ri-lock-line:before { content: \"\\eece\"; }\n.ri-lock-password-fill:before { content: \"\\eecf\"; }\n.ri-lock-password-line:before { content: \"\\eed0\"; }\n.ri-lock-unlock-fill:before { content: \"\\eed1\"; }\n.ri-lock-unlock-line:before { content: \"\\eed2\"; }\n.ri-login-box-fill:before { content: \"\\eed3\"; }\n.ri-login-box-line:before { content: \"\\eed4\"; }\n.ri-login-circle-fill:before { content: \"\\eed5\"; }\n.ri-login-circle-line:before { content: \"\\eed6\"; }\n.ri-logout-box-fill:before { content: \"\\eed7\"; }\n.ri-logout-box-line:before { content: \"\\eed8\"; }\n.ri-logout-box-r-fill:before { content: \"\\eed9\"; }\n.ri-logout-box-r-line:before { content: \"\\eeda\"; }\n.ri-logout-circle-fill:before { content: \"\\eedb\"; }\n.ri-logout-circle-line:before { content: \"\\eedc\"; }\n.ri-logout-circle-r-fill:before { content: \"\\eedd\"; }\n.ri-logout-circle-r-line:before { content: \"\\eede\"; }\n.ri-luggage-cart-fill:before { content: \"\\eedf\"; }\n.ri-luggage-cart-line:before { content: \"\\eee0\"; }\n.ri-luggage-deposit-fill:before { content: \"\\eee1\"; }\n.ri-luggage-deposit-line:before { content: \"\\eee2\"; }\n.ri-lungs-fill:before { content: \"\\eee3\"; }\n.ri-lungs-line:before { content: \"\\eee4\"; }\n.ri-mac-fill:before { content: \"\\eee5\"; }\n.ri-mac-line:before { content: \"\\eee6\"; }\n.ri-macbook-fill:before { content: \"\\eee7\"; }\n.ri-macbook-line:before { content: \"\\eee8\"; }\n.ri-magic-fill:before { content: \"\\eee9\"; }\n.ri-magic-line:before { content: \"\\eeea\"; }\n.ri-mail-add-fill:before { content: \"\\eeeb\"; }\n.ri-mail-add-line:before { content: \"\\eeec\"; }\n.ri-mail-check-fill:before { content: \"\\eeed\"; }\n.ri-mail-check-line:before { content: \"\\eeee\"; }\n.ri-mail-close-fill:before { content: \"\\eeef\"; }\n.ri-mail-close-line:before { content: \"\\eef0\"; }\n.ri-mail-download-fill:before { content: \"\\eef1\"; }\n.ri-mail-download-line:before { content: \"\\eef2\"; }\n.ri-mail-fill:before { content: \"\\eef3\"; }\n.ri-mail-forbid-fill:before { content: \"\\eef4\"; }\n.ri-mail-forbid-line:before { content: \"\\eef5\"; }\n.ri-mail-line:before { content: \"\\eef6\"; }\n.ri-mail-lock-fill:before { content: \"\\eef7\"; }\n.ri-mail-lock-line:before { content: \"\\eef8\"; }\n.ri-mail-open-fill:before { content: \"\\eef9\"; }\n.ri-mail-open-line:before { content: \"\\eefa\"; }\n.ri-mail-send-fill:before { content: \"\\eefb\"; }\n.ri-mail-send-line:before { content: \"\\eefc\"; }\n.ri-mail-settings-fill:before { content: \"\\eefd\"; }\n.ri-mail-settings-line:before { content: \"\\eefe\"; }\n.ri-mail-star-fill:before { content: \"\\eeff\"; }\n.ri-mail-star-line:before { content: \"\\ef00\"; }\n.ri-mail-unread-fill:before { content: \"\\ef01\"; }\n.ri-mail-unread-line:before { content: \"\\ef02\"; }\n.ri-mail-volume-fill:before { content: \"\\ef03\"; }\n.ri-mail-volume-line:before { content: \"\\ef04\"; }\n.ri-map-2-fill:before { content: \"\\ef05\"; }\n.ri-map-2-line:before { content: \"\\ef06\"; }\n.ri-map-fill:before { content: \"\\ef07\"; }\n.ri-map-line:before { content: \"\\ef08\"; }\n.ri-map-pin-2-fill:before { content: \"\\ef09\"; }\n.ri-map-pin-2-line:before { content: \"\\ef0a\"; }\n.ri-map-pin-3-fill:before { content: \"\\ef0b\"; }\n.ri-map-pin-3-line:before { content: \"\\ef0c\"; }\n.ri-map-pin-4-fill:before { content: \"\\ef0d\"; }\n.ri-map-pin-4-line:before { content: \"\\ef0e\"; }\n.ri-map-pin-5-fill:before { content: \"\\ef0f\"; }\n.ri-map-pin-5-line:before { content: \"\\ef10\"; }\n.ri-map-pin-add-fill:before { content: \"\\ef11\"; }\n.ri-map-pin-add-line:before { content: \"\\ef12\"; }\n.ri-map-pin-fill:before { content: \"\\ef13\"; }\n.ri-map-pin-line:before { content: \"\\ef14\"; }\n.ri-map-pin-range-fill:before { content: \"\\ef15\"; }\n.ri-map-pin-range-line:before { content: \"\\ef16\"; }\n.ri-map-pin-time-fill:before { content: \"\\ef17\"; }\n.ri-map-pin-time-line:before { content: \"\\ef18\"; }\n.ri-map-pin-user-fill:before { content: \"\\ef19\"; }\n.ri-map-pin-user-line:before { content: \"\\ef1a\"; }\n.ri-mark-pen-fill:before { content: \"\\ef1b\"; }\n.ri-mark-pen-line:before { content: \"\\ef1c\"; }\n.ri-markdown-fill:before { content: \"\\ef1d\"; }\n.ri-markdown-line:before { content: \"\\ef1e\"; }\n.ri-markup-fill:before { content: \"\\ef1f\"; }\n.ri-markup-line:before { content: \"\\ef20\"; }\n.ri-mastercard-fill:before { content: \"\\ef21\"; }\n.ri-mastercard-line:before { content: \"\\ef22\"; }\n.ri-mastodon-fill:before { content: \"\\ef23\"; }\n.ri-mastodon-line:before { content: \"\\ef24\"; }\n.ri-medal-2-fill:before { content: \"\\ef25\"; }\n.ri-medal-2-line:before { content: \"\\ef26\"; }\n.ri-medal-fill:before { content: \"\\ef27\"; }\n.ri-medal-line:before { content: \"\\ef28\"; }\n.ri-medicine-bottle-fill:before { content: \"\\ef29\"; }\n.ri-medicine-bottle-line:before { content: \"\\ef2a\"; }\n.ri-medium-fill:before { content: \"\\ef2b\"; }\n.ri-medium-line:before { content: \"\\ef2c\"; }\n.ri-men-fill:before { content: \"\\ef2d\"; }\n.ri-men-line:before { content: \"\\ef2e\"; }\n.ri-mental-health-fill:before { content: \"\\ef2f\"; }\n.ri-mental-health-line:before { content: \"\\ef30\"; }\n.ri-menu-2-fill:before { content: \"\\ef31\"; }\n.ri-menu-2-line:before { content: \"\\ef32\"; }\n.ri-menu-3-fill:before { content: \"\\ef33\"; }\n.ri-menu-3-line:before { content: \"\\ef34\"; }\n.ri-menu-4-fill:before { content: \"\\ef35\"; }\n.ri-menu-4-line:before { content: \"\\ef36\"; }\n.ri-menu-5-fill:before { content: \"\\ef37\"; }\n.ri-menu-5-line:before { content: \"\\ef38\"; }\n.ri-menu-add-fill:before { content: \"\\ef39\"; }\n.ri-menu-add-line:before { content: \"\\ef3a\"; }\n.ri-menu-fill:before { content: \"\\ef3b\"; }\n.ri-menu-fold-fill:before { content: \"\\ef3c\"; }\n.ri-menu-fold-line:before { content: \"\\ef3d\"; }\n.ri-menu-line:before { content: \"\\ef3e\"; }\n.ri-menu-unfold-fill:before { content: \"\\ef3f\"; }\n.ri-menu-unfold-line:before { content: \"\\ef40\"; }\n.ri-merge-cells-horizontal:before { content: \"\\ef41\"; }\n.ri-merge-cells-vertical:before { content: \"\\ef42\"; }\n.ri-message-2-fill:before { content: \"\\ef43\"; }\n.ri-message-2-line:before { content: \"\\ef44\"; }\n.ri-message-3-fill:before { content: \"\\ef45\"; }\n.ri-message-3-line:before { content: \"\\ef46\"; }\n.ri-message-fill:before { content: \"\\ef47\"; }\n.ri-message-line:before { content: \"\\ef48\"; }\n.ri-messenger-fill:before { content: \"\\ef49\"; }\n.ri-messenger-line:before { content: \"\\ef4a\"; }\n.ri-meteor-fill:before { content: \"\\ef4b\"; }\n.ri-meteor-line:before { content: \"\\ef4c\"; }\n.ri-mic-2-fill:before { content: \"\\ef4d\"; }\n.ri-mic-2-line:before { content: \"\\ef4e\"; }\n.ri-mic-fill:before { content: \"\\ef4f\"; }\n.ri-mic-line:before { content: \"\\ef50\"; }\n.ri-mic-off-fill:before { content: \"\\ef51\"; }\n.ri-mic-off-line:before { content: \"\\ef52\"; }\n.ri-mickey-fill:before { content: \"\\ef53\"; }\n.ri-mickey-line:before { content: \"\\ef54\"; }\n.ri-microscope-fill:before { content: \"\\ef55\"; }\n.ri-microscope-line:before { content: \"\\ef56\"; }\n.ri-microsoft-fill:before { content: \"\\ef57\"; }\n.ri-microsoft-line:before { content: \"\\ef58\"; }\n.ri-mind-map:before { content: \"\\ef59\"; }\n.ri-mini-program-fill:before { content: \"\\ef5a\"; }\n.ri-mini-program-line:before { content: \"\\ef5b\"; }\n.ri-mist-fill:before { content: \"\\ef5c\"; }\n.ri-mist-line:before { content: \"\\ef5d\"; }\n.ri-money-cny-box-fill:before { content: \"\\ef5e\"; }\n.ri-money-cny-box-line:before { content: \"\\ef5f\"; }\n.ri-money-cny-circle-fill:before { content: \"\\ef60\"; }\n.ri-money-cny-circle-line:before { content: \"\\ef61\"; }\n.ri-money-dollar-box-fill:before { content: \"\\ef62\"; }\n.ri-money-dollar-box-line:before { content: \"\\ef63\"; }\n.ri-money-dollar-circle-fill:before { content: \"\\ef64\"; }\n.ri-money-dollar-circle-line:before { content: \"\\ef65\"; }\n.ri-money-euro-box-fill:before { content: \"\\ef66\"; }\n.ri-money-euro-box-line:before { content: \"\\ef67\"; }\n.ri-money-euro-circle-fill:before { content: \"\\ef68\"; }\n.ri-money-euro-circle-line:before { content: \"\\ef69\"; }\n.ri-money-pound-box-fill:before { content: \"\\ef6a\"; }\n.ri-money-pound-box-line:before { content: \"\\ef6b\"; }\n.ri-money-pound-circle-fill:before { content: \"\\ef6c\"; }\n.ri-money-pound-circle-line:before { content: \"\\ef6d\"; }\n.ri-moon-clear-fill:before { content: \"\\ef6e\"; }\n.ri-moon-clear-line:before { content: \"\\ef6f\"; }\n.ri-moon-cloudy-fill:before { content: \"\\ef70\"; }\n.ri-moon-cloudy-line:before { content: \"\\ef71\"; }\n.ri-moon-fill:before { content: \"\\ef72\"; }\n.ri-moon-foggy-fill:before { content: \"\\ef73\"; }\n.ri-moon-foggy-line:before { content: \"\\ef74\"; }\n.ri-moon-line:before { content: \"\\ef75\"; }\n.ri-more-2-fill:before { content: \"\\ef76\"; }\n.ri-more-2-line:before { content: \"\\ef77\"; }\n.ri-more-fill:before { content: \"\\ef78\"; }\n.ri-more-line:before { content: \"\\ef79\"; }\n.ri-motorbike-fill:before { content: \"\\ef7a\"; }\n.ri-motorbike-line:before { content: \"\\ef7b\"; }\n.ri-mouse-fill:before { content: \"\\ef7c\"; }\n.ri-mouse-line:before { content: \"\\ef7d\"; }\n.ri-movie-2-fill:before { content: \"\\ef7e\"; }\n.ri-movie-2-line:before { content: \"\\ef7f\"; }\n.ri-movie-fill:before { content: \"\\ef80\"; }\n.ri-movie-line:before { content: \"\\ef81\"; }\n.ri-music-2-fill:before { content: \"\\ef82\"; }\n.ri-music-2-line:before { content: \"\\ef83\"; }\n.ri-music-fill:before { content: \"\\ef84\"; }\n.ri-music-line:before { content: \"\\ef85\"; }\n.ri-mv-fill:before { content: \"\\ef86\"; }\n.ri-mv-line:before { content: \"\\ef87\"; }\n.ri-navigation-fill:before { content: \"\\ef88\"; }\n.ri-navigation-line:before { content: \"\\ef89\"; }\n.ri-netease-cloud-music-fill:before { content: \"\\ef8a\"; }\n.ri-netease-cloud-music-line:before { content: \"\\ef8b\"; }\n.ri-netflix-fill:before { content: \"\\ef8c\"; }\n.ri-netflix-line:before { content: \"\\ef8d\"; }\n.ri-newspaper-fill:before { content: \"\\ef8e\"; }\n.ri-newspaper-line:before { content: \"\\ef8f\"; }\n.ri-node-tree:before { content: \"\\ef90\"; }\n.ri-notification-2-fill:before { content: \"\\ef91\"; }\n.ri-notification-2-line:before { content: \"\\ef92\"; }\n.ri-notification-3-fill:before { content: \"\\ef93\"; }\n.ri-notification-3-line:before { content: \"\\ef94\"; }\n.ri-notification-4-fill:before { content: \"\\ef95\"; }\n.ri-notification-4-line:before { content: \"\\ef96\"; }\n.ri-notification-badge-fill:before { content: \"\\ef97\"; }\n.ri-notification-badge-line:before { content: \"\\ef98\"; }\n.ri-notification-fill:before { content: \"\\ef99\"; }\n.ri-notification-line:before { content: \"\\ef9a\"; }\n.ri-notification-off-fill:before { content: \"\\ef9b\"; }\n.ri-notification-off-line:before { content: \"\\ef9c\"; }\n.ri-npmjs-fill:before { content: \"\\ef9d\"; }\n.ri-npmjs-line:before { content: \"\\ef9e\"; }\n.ri-number-0:before { content: \"\\ef9f\"; }\n.ri-number-1:before { content: \"\\efa0\"; }\n.ri-number-2:before { content: \"\\efa1\"; }\n.ri-number-3:before { content: \"\\efa2\"; }\n.ri-number-4:before { content: \"\\efa3\"; }\n.ri-number-5:before { content: \"\\efa4\"; }\n.ri-number-6:before { content: \"\\efa5\"; }\n.ri-number-7:before { content: \"\\efa6\"; }\n.ri-number-8:before { content: \"\\efa7\"; }\n.ri-number-9:before { content: \"\\efa8\"; }\n.ri-numbers-fill:before { content: \"\\efa9\"; }\n.ri-numbers-line:before { content: \"\\efaa\"; }\n.ri-nurse-fill:before { content: \"\\efab\"; }\n.ri-nurse-line:before { content: \"\\efac\"; }\n.ri-oil-fill:before { content: \"\\efad\"; }\n.ri-oil-line:before { content: \"\\efae\"; }\n.ri-omega:before { content: \"\\efaf\"; }\n.ri-open-arm-fill:before { content: \"\\efb0\"; }\n.ri-open-arm-line:before { content: \"\\efb1\"; }\n.ri-open-source-fill:before { content: \"\\efb2\"; }\n.ri-open-source-line:before { content: \"\\efb3\"; }\n.ri-opera-fill:before { content: \"\\efb4\"; }\n.ri-opera-line:before { content: \"\\efb5\"; }\n.ri-order-play-fill:before { content: \"\\efb6\"; }\n.ri-order-play-line:before { content: \"\\efb7\"; }\n.ri-organization-chart:before { content: \"\\efb8\"; }\n.ri-outlet-2-fill:before { content: \"\\efb9\"; }\n.ri-outlet-2-line:before { content: \"\\efba\"; }\n.ri-outlet-fill:before { content: \"\\efbb\"; }\n.ri-outlet-line:before { content: \"\\efbc\"; }\n.ri-page-separator:before { content: \"\\efbd\"; }\n.ri-pages-fill:before { content: \"\\efbe\"; }\n.ri-pages-line:before { content: \"\\efbf\"; }\n.ri-paint-brush-fill:before { content: \"\\efc0\"; }\n.ri-paint-brush-line:before { content: \"\\efc1\"; }\n.ri-paint-fill:before { content: \"\\efc2\"; }\n.ri-paint-line:before { content: \"\\efc3\"; }\n.ri-palette-fill:before { content: \"\\efc4\"; }\n.ri-palette-line:before { content: \"\\efc5\"; }\n.ri-pantone-fill:before { content: \"\\efc6\"; }\n.ri-pantone-line:before { content: \"\\efc7\"; }\n.ri-paragraph:before { content: \"\\efc8\"; }\n.ri-parent-fill:before { content: \"\\efc9\"; }\n.ri-parent-line:before { content: \"\\efca\"; }\n.ri-parentheses-fill:before { content: \"\\efcb\"; }\n.ri-parentheses-line:before { content: \"\\efcc\"; }\n.ri-parking-box-fill:before { content: \"\\efcd\"; }\n.ri-parking-box-line:before { content: \"\\efce\"; }\n.ri-parking-fill:before { content: \"\\efcf\"; }\n.ri-parking-line:before { content: \"\\efd0\"; }\n.ri-passport-fill:before { content: \"\\efd1\"; }\n.ri-passport-line:before { content: \"\\efd2\"; }\n.ri-patreon-fill:before { content: \"\\efd3\"; }\n.ri-patreon-line:before { content: \"\\efd4\"; }\n.ri-pause-circle-fill:before { content: \"\\efd5\"; }\n.ri-pause-circle-line:before { content: \"\\efd6\"; }\n.ri-pause-fill:before { content: \"\\efd7\"; }\n.ri-pause-line:before { content: \"\\efd8\"; }\n.ri-pause-mini-fill:before { content: \"\\efd9\"; }\n.ri-pause-mini-line:before { content: \"\\efda\"; }\n.ri-paypal-fill:before { content: \"\\efdb\"; }\n.ri-paypal-line:before { content: \"\\efdc\"; }\n.ri-pen-nib-fill:before { content: \"\\efdd\"; }\n.ri-pen-nib-line:before { content: \"\\efde\"; }\n.ri-pencil-fill:before { content: \"\\efdf\"; }\n.ri-pencil-line:before { content: \"\\efe0\"; }\n.ri-pencil-ruler-2-fill:before { content: \"\\efe1\"; }\n.ri-pencil-ruler-2-line:before { content: \"\\efe2\"; }\n.ri-pencil-ruler-fill:before { content: \"\\efe3\"; }\n.ri-pencil-ruler-line:before { content: \"\\efe4\"; }\n.ri-percent-fill:before { content: \"\\efe5\"; }\n.ri-percent-line:before { content: \"\\efe6\"; }\n.ri-phone-camera-fill:before { content: \"\\efe7\"; }\n.ri-phone-camera-line:before { content: \"\\efe8\"; }\n.ri-phone-fill:before { content: \"\\efe9\"; }\n.ri-phone-find-fill:before { content: \"\\efea\"; }\n.ri-phone-find-line:before { content: \"\\efeb\"; }\n.ri-phone-line:before { content: \"\\efec\"; }\n.ri-phone-lock-fill:before { content: \"\\efed\"; }\n.ri-phone-lock-line:before { content: \"\\efee\"; }\n.ri-picture-in-picture-2-fill:before { content: \"\\efef\"; }\n.ri-picture-in-picture-2-line:before { content: \"\\eff0\"; }\n.ri-picture-in-picture-exit-fill:before { content: \"\\eff1\"; }\n.ri-picture-in-picture-exit-line:before { content: \"\\eff2\"; }\n.ri-picture-in-picture-fill:before { content: \"\\eff3\"; }\n.ri-picture-in-picture-line:before { content: \"\\eff4\"; }\n.ri-pie-chart-2-fill:before { content: \"\\eff5\"; }\n.ri-pie-chart-2-line:before { content: \"\\eff6\"; }\n.ri-pie-chart-box-fill:before { content: \"\\eff7\"; }\n.ri-pie-chart-box-line:before { content: \"\\eff8\"; }\n.ri-pie-chart-fill:before { content: \"\\eff9\"; }\n.ri-pie-chart-line:before { content: \"\\effa\"; }\n.ri-pin-distance-fill:before { content: \"\\effb\"; }\n.ri-pin-distance-line:before { content: \"\\effc\"; }\n.ri-ping-pong-fill:before { content: \"\\effd\"; }\n.ri-ping-pong-line:before { content: \"\\effe\"; }\n.ri-pinterest-fill:before { content: \"\\efff\"; }\n.ri-pinterest-line:before { content: \"\\f000\"; }\n.ri-pinyin-input:before { content: \"\\f001\"; }\n.ri-pixelfed-fill:before { content: \"\\f002\"; }\n.ri-pixelfed-line:before { content: \"\\f003\"; }\n.ri-plane-fill:before { content: \"\\f004\"; }\n.ri-plane-line:before { content: \"\\f005\"; }\n.ri-plant-fill:before { content: \"\\f006\"; }\n.ri-plant-line:before { content: \"\\f007\"; }\n.ri-play-circle-fill:before { content: \"\\f008\"; }\n.ri-play-circle-line:before { content: \"\\f009\"; }\n.ri-play-fill:before { content: \"\\f00a\"; }\n.ri-play-line:before { content: \"\\f00b\"; }\n.ri-play-list-2-fill:before { content: \"\\f00c\"; }\n.ri-play-list-2-line:before { content: \"\\f00d\"; }\n.ri-play-list-add-fill:before { content: \"\\f00e\"; }\n.ri-play-list-add-line:before { content: \"\\f00f\"; }\n.ri-play-list-fill:before { content: \"\\f010\"; }\n.ri-play-list-line:before { content: \"\\f011\"; }\n.ri-play-mini-fill:before { content: \"\\f012\"; }\n.ri-play-mini-line:before { content: \"\\f013\"; }\n.ri-playstation-fill:before { content: \"\\f014\"; }\n.ri-playstation-line:before { content: \"\\f015\"; }\n.ri-plug-2-fill:before { content: \"\\f016\"; }\n.ri-plug-2-line:before { content: \"\\f017\"; }\n.ri-plug-fill:before { content: \"\\f018\"; }\n.ri-plug-line:before { content: \"\\f019\"; }\n.ri-polaroid-2-fill:before { content: \"\\f01a\"; }\n.ri-polaroid-2-line:before { content: \"\\f01b\"; }\n.ri-polaroid-fill:before { content: \"\\f01c\"; }\n.ri-polaroid-line:before { content: \"\\f01d\"; }\n.ri-police-car-fill:before { content: \"\\f01e\"; }\n.ri-police-car-line:before { content: \"\\f01f\"; }\n.ri-price-tag-2-fill:before { content: \"\\f020\"; }\n.ri-price-tag-2-line:before { content: \"\\f021\"; }\n.ri-price-tag-3-fill:before { content: \"\\f022\"; }\n.ri-price-tag-3-line:before { content: \"\\f023\"; }\n.ri-price-tag-fill:before { content: \"\\f024\"; }\n.ri-price-tag-line:before { content: \"\\f025\"; }\n.ri-printer-cloud-fill:before { content: \"\\f026\"; }\n.ri-printer-cloud-line:before { content: \"\\f027\"; }\n.ri-printer-fill:before { content: \"\\f028\"; }\n.ri-printer-line:before { content: \"\\f029\"; }\n.ri-product-hunt-fill:before { content: \"\\f02a\"; }\n.ri-product-hunt-line:before { content: \"\\f02b\"; }\n.ri-profile-fill:before { content: \"\\f02c\"; }\n.ri-profile-line:before { content: \"\\f02d\"; }\n.ri-projector-2-fill:before { content: \"\\f02e\"; }\n.ri-projector-2-line:before { content: \"\\f02f\"; }\n.ri-projector-fill:before { content: \"\\f030\"; }\n.ri-projector-line:before { content: \"\\f031\"; }\n.ri-psychotherapy-fill:before { content: \"\\f032\"; }\n.ri-psychotherapy-line:before { content: \"\\f033\"; }\n.ri-pulse-fill:before { content: \"\\f034\"; }\n.ri-pulse-line:before { content: \"\\f035\"; }\n.ri-pushpin-2-fill:before { content: \"\\f036\"; }\n.ri-pushpin-2-line:before { content: \"\\f037\"; }\n.ri-pushpin-fill:before { content: \"\\f038\"; }\n.ri-pushpin-line:before { content: \"\\f039\"; }\n.ri-qq-fill:before { content: \"\\f03a\"; }\n.ri-qq-line:before { content: \"\\f03b\"; }\n.ri-qr-code-fill:before { content: \"\\f03c\"; }\n.ri-qr-code-line:before { content: \"\\f03d\"; }\n.ri-qr-scan-2-fill:before { content: \"\\f03e\"; }\n.ri-qr-scan-2-line:before { content: \"\\f03f\"; }\n.ri-qr-scan-fill:before { content: \"\\f040\"; }\n.ri-qr-scan-line:before { content: \"\\f041\"; }\n.ri-question-answer-fill:before { content: \"\\f042\"; }\n.ri-question-answer-line:before { content: \"\\f043\"; }\n.ri-question-fill:before { content: \"\\f044\"; }\n.ri-question-line:before { content: \"\\f045\"; }\n.ri-question-mark:before { content: \"\\f046\"; }\n.ri-questionnaire-fill:before { content: \"\\f047\"; }\n.ri-questionnaire-line:before { content: \"\\f048\"; }\n.ri-quill-pen-fill:before { content: \"\\f049\"; }\n.ri-quill-pen-line:before { content: \"\\f04a\"; }\n.ri-radar-fill:before { content: \"\\f04b\"; }\n.ri-radar-line:before { content: \"\\f04c\"; }\n.ri-radio-2-fill:before { content: \"\\f04d\"; }\n.ri-radio-2-line:before { content: \"\\f04e\"; }\n.ri-radio-button-fill:before { content: \"\\f04f\"; }\n.ri-radio-button-line:before { content: \"\\f050\"; }\n.ri-radio-fill:before { content: \"\\f051\"; }\n.ri-radio-line:before { content: \"\\f052\"; }\n.ri-rainbow-fill:before { content: \"\\f053\"; }\n.ri-rainbow-line:before { content: \"\\f054\"; }\n.ri-rainy-fill:before { content: \"\\f055\"; }\n.ri-rainy-line:before { content: \"\\f056\"; }\n.ri-reactjs-fill:before { content: \"\\f057\"; }\n.ri-reactjs-line:before { content: \"\\f058\"; }\n.ri-record-circle-fill:before { content: \"\\f059\"; }\n.ri-record-circle-line:before { content: \"\\f05a\"; }\n.ri-record-mail-fill:before { content: \"\\f05b\"; }\n.ri-record-mail-line:before { content: \"\\f05c\"; }\n.ri-recycle-fill:before { content: \"\\f05d\"; }\n.ri-recycle-line:before { content: \"\\f05e\"; }\n.ri-red-packet-fill:before { content: \"\\f05f\"; }\n.ri-red-packet-line:before { content: \"\\f060\"; }\n.ri-reddit-fill:before { content: \"\\f061\"; }\n.ri-reddit-line:before { content: \"\\f062\"; }\n.ri-refresh-fill:before { content: \"\\f063\"; }\n.ri-refresh-line:before { content: \"\\f064\"; }\n.ri-refund-2-fill:before { content: \"\\f065\"; }\n.ri-refund-2-line:before { content: \"\\f066\"; }\n.ri-refund-fill:before { content: \"\\f067\"; }\n.ri-refund-line:before { content: \"\\f068\"; }\n.ri-registered-fill:before { content: \"\\f069\"; }\n.ri-registered-line:before { content: \"\\f06a\"; }\n.ri-remixicon-fill:before { content: \"\\f06b\"; }\n.ri-remixicon-line:before { content: \"\\f06c\"; }\n.ri-remote-control-2-fill:before { content: \"\\f06d\"; }\n.ri-remote-control-2-line:before { content: \"\\f06e\"; }\n.ri-remote-control-fill:before { content: \"\\f06f\"; }\n.ri-remote-control-line:before { content: \"\\f070\"; }\n.ri-repeat-2-fill:before { content: \"\\f071\"; }\n.ri-repeat-2-line:before { content: \"\\f072\"; }\n.ri-repeat-fill:before { content: \"\\f073\"; }\n.ri-repeat-line:before { content: \"\\f074\"; }\n.ri-repeat-one-fill:before { content: \"\\f075\"; }\n.ri-repeat-one-line:before { content: \"\\f076\"; }\n.ri-reply-all-fill:before { content: \"\\f077\"; }\n.ri-reply-all-line:before { content: \"\\f078\"; }\n.ri-reply-fill:before { content: \"\\f079\"; }\n.ri-reply-line:before { content: \"\\f07a\"; }\n.ri-reserved-fill:before { content: \"\\f07b\"; }\n.ri-reserved-line:before { content: \"\\f07c\"; }\n.ri-rest-time-fill:before { content: \"\\f07d\"; }\n.ri-rest-time-line:before { content: \"\\f07e\"; }\n.ri-restart-fill:before { content: \"\\f07f\"; }\n.ri-restart-line:before { content: \"\\f080\"; }\n.ri-restaurant-2-fill:before { content: \"\\f081\"; }\n.ri-restaurant-2-line:before { content: \"\\f082\"; }\n.ri-restaurant-fill:before { content: \"\\f083\"; }\n.ri-restaurant-line:before { content: \"\\f084\"; }\n.ri-rewind-fill:before { content: \"\\f085\"; }\n.ri-rewind-line:before { content: \"\\f086\"; }\n.ri-rewind-mini-fill:before { content: \"\\f087\"; }\n.ri-rewind-mini-line:before { content: \"\\f088\"; }\n.ri-rhythm-fill:before { content: \"\\f089\"; }\n.ri-rhythm-line:before { content: \"\\f08a\"; }\n.ri-riding-fill:before { content: \"\\f08b\"; }\n.ri-riding-line:before { content: \"\\f08c\"; }\n.ri-road-map-fill:before { content: \"\\f08d\"; }\n.ri-road-map-line:before { content: \"\\f08e\"; }\n.ri-roadster-fill:before { content: \"\\f08f\"; }\n.ri-roadster-line:before { content: \"\\f090\"; }\n.ri-robot-fill:before { content: \"\\f091\"; }\n.ri-robot-line:before { content: \"\\f092\"; }\n.ri-rocket-2-fill:before { content: \"\\f093\"; }\n.ri-rocket-2-line:before { content: \"\\f094\"; }\n.ri-rocket-fill:before { content: \"\\f095\"; }\n.ri-rocket-line:before { content: \"\\f096\"; }\n.ri-rotate-lock-fill:before { content: \"\\f097\"; }\n.ri-rotate-lock-line:before { content: \"\\f098\"; }\n.ri-rounded-corner:before { content: \"\\f099\"; }\n.ri-route-fill:before { content: \"\\f09a\"; }\n.ri-route-line:before { content: \"\\f09b\"; }\n.ri-router-fill:before { content: \"\\f09c\"; }\n.ri-router-line:before { content: \"\\f09d\"; }\n.ri-rss-fill:before { content: \"\\f09e\"; }\n.ri-rss-line:before { content: \"\\f09f\"; }\n.ri-ruler-2-fill:before { content: \"\\f0a0\"; }\n.ri-ruler-2-line:before { content: \"\\f0a1\"; }\n.ri-ruler-fill:before { content: \"\\f0a2\"; }\n.ri-ruler-line:before { content: \"\\f0a3\"; }\n.ri-run-fill:before { content: \"\\f0a4\"; }\n.ri-run-line:before { content: \"\\f0a5\"; }\n.ri-safari-fill:before { content: \"\\f0a6\"; }\n.ri-safari-line:before { content: \"\\f0a7\"; }\n.ri-safe-2-fill:before { content: \"\\f0a8\"; }\n.ri-safe-2-line:before { content: \"\\f0a9\"; }\n.ri-safe-fill:before { content: \"\\f0aa\"; }\n.ri-safe-line:before { content: \"\\f0ab\"; }\n.ri-sailboat-fill:before { content: \"\\f0ac\"; }\n.ri-sailboat-line:before { content: \"\\f0ad\"; }\n.ri-save-2-fill:before { content: \"\\f0ae\"; }\n.ri-save-2-line:before { content: \"\\f0af\"; }\n.ri-save-3-fill:before { content: \"\\f0b0\"; }\n.ri-save-3-line:before { content: \"\\f0b1\"; }\n.ri-save-fill:before { content: \"\\f0b2\"; }\n.ri-save-line:before { content: \"\\f0b3\"; }\n.ri-scales-2-fill:before { content: \"\\f0b4\"; }\n.ri-scales-2-line:before { content: \"\\f0b5\"; }\n.ri-scales-3-fill:before { content: \"\\f0b6\"; }\n.ri-scales-3-line:before { content: \"\\f0b7\"; }\n.ri-scales-fill:before { content: \"\\f0b8\"; }\n.ri-scales-line:before { content: \"\\f0b9\"; }\n.ri-scan-2-fill:before { content: \"\\f0ba\"; }\n.ri-scan-2-line:before { content: \"\\f0bb\"; }\n.ri-scan-fill:before { content: \"\\f0bc\"; }\n.ri-scan-line:before { content: \"\\f0bd\"; }\n.ri-scissors-2-fill:before { content: \"\\f0be\"; }\n.ri-scissors-2-line:before { content: \"\\f0bf\"; }\n.ri-scissors-cut-fill:before { content: \"\\f0c0\"; }\n.ri-scissors-cut-line:before { content: \"\\f0c1\"; }\n.ri-scissors-fill:before { content: \"\\f0c2\"; }\n.ri-scissors-line:before { content: \"\\f0c3\"; }\n.ri-screenshot-2-fill:before { content: \"\\f0c4\"; }\n.ri-screenshot-2-line:before { content: \"\\f0c5\"; }\n.ri-screenshot-fill:before { content: \"\\f0c6\"; }\n.ri-screenshot-line:before { content: \"\\f0c7\"; }\n.ri-sd-card-fill:before { content: \"\\f0c8\"; }\n.ri-sd-card-line:before { content: \"\\f0c9\"; }\n.ri-sd-card-mini-fill:before { content: \"\\f0ca\"; }\n.ri-sd-card-mini-line:before { content: \"\\f0cb\"; }\n.ri-search-2-fill:before { content: \"\\f0cc\"; }\n.ri-search-2-line:before { content: \"\\f0cd\"; }\n.ri-search-eye-fill:before { content: \"\\f0ce\"; }\n.ri-search-eye-line:before { content: \"\\f0cf\"; }\n.ri-search-fill:before { content: \"\\f0d0\"; }\n.ri-search-line:before { content: \"\\f0d1\"; }\n.ri-secure-payment-fill:before { content: \"\\f0d2\"; }\n.ri-secure-payment-line:before { content: \"\\f0d3\"; }\n.ri-seedling-fill:before { content: \"\\f0d4\"; }\n.ri-seedling-line:before { content: \"\\f0d5\"; }\n.ri-send-backward:before { content: \"\\f0d6\"; }\n.ri-send-plane-2-fill:before { content: \"\\f0d7\"; }\n.ri-send-plane-2-line:before { content: \"\\f0d8\"; }\n.ri-send-plane-fill:before { content: \"\\f0d9\"; }\n.ri-send-plane-line:before { content: \"\\f0da\"; }\n.ri-send-to-back:before { content: \"\\f0db\"; }\n.ri-sensor-fill:before { content: \"\\f0dc\"; }\n.ri-sensor-line:before { content: \"\\f0dd\"; }\n.ri-separator:before { content: \"\\f0de\"; }\n.ri-server-fill:before { content: \"\\f0df\"; }\n.ri-server-line:before { content: \"\\f0e0\"; }\n.ri-service-fill:before { content: \"\\f0e1\"; }\n.ri-service-line:before { content: \"\\f0e2\"; }\n.ri-settings-2-fill:before { content: \"\\f0e3\"; }\n.ri-settings-2-line:before { content: \"\\f0e4\"; }\n.ri-settings-3-fill:before { content: \"\\f0e5\"; }\n.ri-settings-3-line:before { content: \"\\f0e6\"; }\n.ri-settings-4-fill:before { content: \"\\f0e7\"; }\n.ri-settings-4-line:before { content: \"\\f0e8\"; }\n.ri-settings-5-fill:before { content: \"\\f0e9\"; }\n.ri-settings-5-line:before { content: \"\\f0ea\"; }\n.ri-settings-6-fill:before { content: \"\\f0eb\"; }\n.ri-settings-6-line:before { content: \"\\f0ec\"; }\n.ri-settings-fill:before { content: \"\\f0ed\"; }\n.ri-settings-line:before { content: \"\\f0ee\"; }\n.ri-shape-2-fill:before { content: \"\\f0ef\"; }\n.ri-shape-2-line:before { content: \"\\f0f0\"; }\n.ri-shape-fill:before { content: \"\\f0f1\"; }\n.ri-shape-line:before { content: \"\\f0f2\"; }\n.ri-share-box-fill:before { content: \"\\f0f3\"; }\n.ri-share-box-line:before { content: \"\\f0f4\"; }\n.ri-share-circle-fill:before { content: \"\\f0f5\"; }\n.ri-share-circle-line:before { content: \"\\f0f6\"; }\n.ri-share-fill:before { content: \"\\f0f7\"; }\n.ri-share-forward-2-fill:before { content: \"\\f0f8\"; }\n.ri-share-forward-2-line:before { content: \"\\f0f9\"; }\n.ri-share-forward-box-fill:before { content: \"\\f0fa\"; }\n.ri-share-forward-box-line:before { content: \"\\f0fb\"; }\n.ri-share-forward-fill:before { content: \"\\f0fc\"; }\n.ri-share-forward-line:before { content: \"\\f0fd\"; }\n.ri-share-line:before { content: \"\\f0fe\"; }\n.ri-shield-check-fill:before { content: \"\\f0ff\"; }\n.ri-shield-check-line:before { content: \"\\f100\"; }\n.ri-shield-cross-fill:before { content: \"\\f101\"; }\n.ri-shield-cross-line:before { content: \"\\f102\"; }\n.ri-shield-fill:before { content: \"\\f103\"; }\n.ri-shield-flash-fill:before { content: \"\\f104\"; }\n.ri-shield-flash-line:before { content: \"\\f105\"; }\n.ri-shield-keyhole-fill:before { content: \"\\f106\"; }\n.ri-shield-keyhole-line:before { content: \"\\f107\"; }\n.ri-shield-line:before { content: \"\\f108\"; }\n.ri-shield-star-fill:before { content: \"\\f109\"; }\n.ri-shield-star-line:before { content: \"\\f10a\"; }\n.ri-shield-user-fill:before { content: \"\\f10b\"; }\n.ri-shield-user-line:before { content: \"\\f10c\"; }\n.ri-ship-2-fill:before { content: \"\\f10d\"; }\n.ri-ship-2-line:before { content: \"\\f10e\"; }\n.ri-ship-fill:before { content: \"\\f10f\"; }\n.ri-ship-line:before { content: \"\\f110\"; }\n.ri-shirt-fill:before { content: \"\\f111\"; }\n.ri-shirt-line:before { content: \"\\f112\"; }\n.ri-shopping-bag-2-fill:before { content: \"\\f113\"; }\n.ri-shopping-bag-2-line:before { content: \"\\f114\"; }\n.ri-shopping-bag-3-fill:before { content: \"\\f115\"; }\n.ri-shopping-bag-3-line:before { content: \"\\f116\"; }\n.ri-shopping-bag-fill:before { content: \"\\f117\"; }\n.ri-shopping-bag-line:before { content: \"\\f118\"; }\n.ri-shopping-basket-2-fill:before { content: \"\\f119\"; }\n.ri-shopping-basket-2-line:before { content: \"\\f11a\"; }\n.ri-shopping-basket-fill:before { content: \"\\f11b\"; }\n.ri-shopping-basket-line:before { content: \"\\f11c\"; }\n.ri-shopping-cart-2-fill:before { content: \"\\f11d\"; }\n.ri-shopping-cart-2-line:before { content: \"\\f11e\"; }\n.ri-shopping-cart-fill:before { content: \"\\f11f\"; }\n.ri-shopping-cart-line:before { content: \"\\f120\"; }\n.ri-showers-fill:before { content: \"\\f121\"; }\n.ri-showers-line:before { content: \"\\f122\"; }\n.ri-shuffle-fill:before { content: \"\\f123\"; }\n.ri-shuffle-line:before { content: \"\\f124\"; }\n.ri-shut-down-fill:before { content: \"\\f125\"; }\n.ri-shut-down-line:before { content: \"\\f126\"; }\n.ri-side-bar-fill:before { content: \"\\f127\"; }\n.ri-side-bar-line:before { content: \"\\f128\"; }\n.ri-signal-tower-fill:before { content: \"\\f129\"; }\n.ri-signal-tower-line:before { content: \"\\f12a\"; }\n.ri-signal-wifi-1-fill:before { content: \"\\f12b\"; }\n.ri-signal-wifi-1-line:before { content: \"\\f12c\"; }\n.ri-signal-wifi-2-fill:before { content: \"\\f12d\"; }\n.ri-signal-wifi-2-line:before { content: \"\\f12e\"; }\n.ri-signal-wifi-3-fill:before { content: \"\\f12f\"; }\n.ri-signal-wifi-3-line:before { content: \"\\f130\"; }\n.ri-signal-wifi-error-fill:before { content: \"\\f131\"; }\n.ri-signal-wifi-error-line:before { content: \"\\f132\"; }\n.ri-signal-wifi-fill:before { content: \"\\f133\"; }\n.ri-signal-wifi-line:before { content: \"\\f134\"; }\n.ri-signal-wifi-off-fill:before { content: \"\\f135\"; }\n.ri-signal-wifi-off-line:before { content: \"\\f136\"; }\n.ri-sim-card-2-fill:before { content: \"\\f137\"; }\n.ri-sim-card-2-line:before { content: \"\\f138\"; }\n.ri-sim-card-fill:before { content: \"\\f139\"; }\n.ri-sim-card-line:before { content: \"\\f13a\"; }\n.ri-single-quotes-l:before { content: \"\\f13b\"; }\n.ri-single-quotes-r:before { content: \"\\f13c\"; }\n.ri-sip-fill:before { content: \"\\f13d\"; }\n.ri-sip-line:before { content: \"\\f13e\"; }\n.ri-skip-back-fill:before { content: \"\\f13f\"; }\n.ri-skip-back-line:before { content: \"\\f140\"; }\n.ri-skip-back-mini-fill:before { content: \"\\f141\"; }\n.ri-skip-back-mini-line:before { content: \"\\f142\"; }\n.ri-skip-forward-fill:before { content: \"\\f143\"; }\n.ri-skip-forward-line:before { content: \"\\f144\"; }\n.ri-skip-forward-mini-fill:before { content: \"\\f145\"; }\n.ri-skip-forward-mini-line:before { content: \"\\f146\"; }\n.ri-skull-2-fill:before { content: \"\\f147\"; }\n.ri-skull-2-line:before { content: \"\\f148\"; }\n.ri-skull-fill:before { content: \"\\f149\"; }\n.ri-skull-line:before { content: \"\\f14a\"; }\n.ri-skype-fill:before { content: \"\\f14b\"; }\n.ri-skype-line:before { content: \"\\f14c\"; }\n.ri-slack-fill:before { content: \"\\f14d\"; }\n.ri-slack-line:before { content: \"\\f14e\"; }\n.ri-slice-fill:before { content: \"\\f14f\"; }\n.ri-slice-line:before { content: \"\\f150\"; }\n.ri-slideshow-2-fill:before { content: \"\\f151\"; }\n.ri-slideshow-2-line:before { content: \"\\f152\"; }\n.ri-slideshow-3-fill:before { content: \"\\f153\"; }\n.ri-slideshow-3-line:before { content: \"\\f154\"; }\n.ri-slideshow-4-fill:before { content: \"\\f155\"; }\n.ri-slideshow-4-line:before { content: \"\\f156\"; }\n.ri-slideshow-fill:before { content: \"\\f157\"; }\n.ri-slideshow-line:before { content: \"\\f158\"; }\n.ri-smartphone-fill:before { content: \"\\f159\"; }\n.ri-smartphone-line:before { content: \"\\f15a\"; }\n.ri-snapchat-fill:before { content: \"\\f15b\"; }\n.ri-snapchat-line:before { content: \"\\f15c\"; }\n.ri-snowy-fill:before { content: \"\\f15d\"; }\n.ri-snowy-line:before { content: \"\\f15e\"; }\n.ri-sort-asc:before { content: \"\\f15f\"; }\n.ri-sort-desc:before { content: \"\\f160\"; }\n.ri-sound-module-fill:before { content: \"\\f161\"; }\n.ri-sound-module-line:before { content: \"\\f162\"; }\n.ri-soundcloud-fill:before { content: \"\\f163\"; }\n.ri-soundcloud-line:before { content: \"\\f164\"; }\n.ri-space-ship-fill:before { content: \"\\f165\"; }\n.ri-space-ship-line:before { content: \"\\f166\"; }\n.ri-space:before { content: \"\\f167\"; }\n.ri-spam-2-fill:before { content: \"\\f168\"; }\n.ri-spam-2-line:before { content: \"\\f169\"; }\n.ri-spam-3-fill:before { content: \"\\f16a\"; }\n.ri-spam-3-line:before { content: \"\\f16b\"; }\n.ri-spam-fill:before { content: \"\\f16c\"; }\n.ri-spam-line:before { content: \"\\f16d\"; }\n.ri-speaker-2-fill:before { content: \"\\f16e\"; }\n.ri-speaker-2-line:before { content: \"\\f16f\"; }\n.ri-speaker-3-fill:before { content: \"\\f170\"; }\n.ri-speaker-3-line:before { content: \"\\f171\"; }\n.ri-speaker-fill:before { content: \"\\f172\"; }\n.ri-speaker-line:before { content: \"\\f173\"; }\n.ri-spectrum-fill:before { content: \"\\f174\"; }\n.ri-spectrum-line:before { content: \"\\f175\"; }\n.ri-speed-fill:before { content: \"\\f176\"; }\n.ri-speed-line:before { content: \"\\f177\"; }\n.ri-speed-mini-fill:before { content: \"\\f178\"; }\n.ri-speed-mini-line:before { content: \"\\f179\"; }\n.ri-split-cells-horizontal:before { content: \"\\f17a\"; }\n.ri-split-cells-vertical:before { content: \"\\f17b\"; }\n.ri-spotify-fill:before { content: \"\\f17c\"; }\n.ri-spotify-line:before { content: \"\\f17d\"; }\n.ri-spy-fill:before { content: \"\\f17e\"; }\n.ri-spy-line:before { content: \"\\f17f\"; }\n.ri-stack-fill:before { content: \"\\f180\"; }\n.ri-stack-line:before { content: \"\\f181\"; }\n.ri-stack-overflow-fill:before { content: \"\\f182\"; }\n.ri-stack-overflow-line:before { content: \"\\f183\"; }\n.ri-stackshare-fill:before { content: \"\\f184\"; }\n.ri-stackshare-line:before { content: \"\\f185\"; }\n.ri-star-fill:before { content: \"\\f186\"; }\n.ri-star-half-fill:before { content: \"\\f187\"; }\n.ri-star-half-line:before { content: \"\\f188\"; }\n.ri-star-half-s-fill:before { content: \"\\f189\"; }\n.ri-star-half-s-line:before { content: \"\\f18a\"; }\n.ri-star-line:before { content: \"\\f18b\"; }\n.ri-star-s-fill:before { content: \"\\f18c\"; }\n.ri-star-s-line:before { content: \"\\f18d\"; }\n.ri-star-smile-fill:before { content: \"\\f18e\"; }\n.ri-star-smile-line:before { content: \"\\f18f\"; }\n.ri-steam-fill:before { content: \"\\f190\"; }\n.ri-steam-line:before { content: \"\\f191\"; }\n.ri-steering-2-fill:before { content: \"\\f192\"; }\n.ri-steering-2-line:before { content: \"\\f193\"; }\n.ri-steering-fill:before { content: \"\\f194\"; }\n.ri-steering-line:before { content: \"\\f195\"; }\n.ri-stethoscope-fill:before { content: \"\\f196\"; }\n.ri-stethoscope-line:before { content: \"\\f197\"; }\n.ri-sticky-note-2-fill:before { content: \"\\f198\"; }\n.ri-sticky-note-2-line:before { content: \"\\f199\"; }\n.ri-sticky-note-fill:before { content: \"\\f19a\"; }\n.ri-sticky-note-line:before { content: \"\\f19b\"; }\n.ri-stock-fill:before { content: \"\\f19c\"; }\n.ri-stock-line:before { content: \"\\f19d\"; }\n.ri-stop-circle-fill:before { content: \"\\f19e\"; }\n.ri-stop-circle-line:before { content: \"\\f19f\"; }\n.ri-stop-fill:before { content: \"\\f1a0\"; }\n.ri-stop-line:before { content: \"\\f1a1\"; }\n.ri-stop-mini-fill:before { content: \"\\f1a2\"; }\n.ri-stop-mini-line:before { content: \"\\f1a3\"; }\n.ri-store-2-fill:before { content: \"\\f1a4\"; }\n.ri-store-2-line:before { content: \"\\f1a5\"; }\n.ri-store-3-fill:before { content: \"\\f1a6\"; }\n.ri-store-3-line:before { content: \"\\f1a7\"; }\n.ri-store-fill:before { content: \"\\f1a8\"; }\n.ri-store-line:before { content: \"\\f1a9\"; }\n.ri-strikethrough-2:before { content: \"\\f1aa\"; }\n.ri-strikethrough:before { content: \"\\f1ab\"; }\n.ri-subscript-2:before { content: \"\\f1ac\"; }\n.ri-subscript:before { content: \"\\f1ad\"; }\n.ri-subtract-fill:before { content: \"\\f1ae\"; }\n.ri-subtract-line:before { content: \"\\f1af\"; }\n.ri-subway-fill:before { content: \"\\f1b0\"; }\n.ri-subway-line:before { content: \"\\f1b1\"; }\n.ri-subway-wifi-fill:before { content: \"\\f1b2\"; }\n.ri-subway-wifi-line:before { content: \"\\f1b3\"; }\n.ri-suitcase-2-fill:before { content: \"\\f1b4\"; }\n.ri-suitcase-2-line:before { content: \"\\f1b5\"; }\n.ri-suitcase-3-fill:before { content: \"\\f1b6\"; }\n.ri-suitcase-3-line:before { content: \"\\f1b7\"; }\n.ri-suitcase-fill:before { content: \"\\f1b8\"; }\n.ri-suitcase-line:before { content: \"\\f1b9\"; }\n.ri-sun-cloudy-fill:before { content: \"\\f1ba\"; }\n.ri-sun-cloudy-line:before { content: \"\\f1bb\"; }\n.ri-sun-fill:before { content: \"\\f1bc\"; }\n.ri-sun-foggy-fill:before { content: \"\\f1bd\"; }\n.ri-sun-foggy-line:before { content: \"\\f1be\"; }\n.ri-sun-line:before { content: \"\\f1bf\"; }\n.ri-superscript-2:before { content: \"\\f1c0\"; }\n.ri-superscript:before { content: \"\\f1c1\"; }\n.ri-surgical-mask-fill:before { content: \"\\f1c2\"; }\n.ri-surgical-mask-line:before { content: \"\\f1c3\"; }\n.ri-surround-sound-fill:before { content: \"\\f1c4\"; }\n.ri-surround-sound-line:before { content: \"\\f1c5\"; }\n.ri-survey-fill:before { content: \"\\f1c6\"; }\n.ri-survey-line:before { content: \"\\f1c7\"; }\n.ri-swap-box-fill:before { content: \"\\f1c8\"; }\n.ri-swap-box-line:before { content: \"\\f1c9\"; }\n.ri-swap-fill:before { content: \"\\f1ca\"; }\n.ri-swap-line:before { content: \"\\f1cb\"; }\n.ri-switch-fill:before { content: \"\\f1cc\"; }\n.ri-switch-line:before { content: \"\\f1cd\"; }\n.ri-sword-fill:before { content: \"\\f1ce\"; }\n.ri-sword-line:before { content: \"\\f1cf\"; }\n.ri-syringe-fill:before { content: \"\\f1d0\"; }\n.ri-syringe-line:before { content: \"\\f1d1\"; }\n.ri-t-box-fill:before { content: \"\\f1d2\"; }\n.ri-t-box-line:before { content: \"\\f1d3\"; }\n.ri-t-shirt-2-fill:before { content: \"\\f1d4\"; }\n.ri-t-shirt-2-line:before { content: \"\\f1d5\"; }\n.ri-t-shirt-air-fill:before { content: \"\\f1d6\"; }\n.ri-t-shirt-air-line:before { content: \"\\f1d7\"; }\n.ri-t-shirt-fill:before { content: \"\\f1d8\"; }\n.ri-t-shirt-line:before { content: \"\\f1d9\"; }\n.ri-table-2:before { content: \"\\f1da\"; }\n.ri-table-alt-fill:before { content: \"\\f1db\"; }\n.ri-table-alt-line:before { content: \"\\f1dc\"; }\n.ri-table-fill:before { content: \"\\f1dd\"; }\n.ri-table-line:before { content: \"\\f1de\"; }\n.ri-tablet-fill:before { content: \"\\f1df\"; }\n.ri-tablet-line:before { content: \"\\f1e0\"; }\n.ri-takeaway-fill:before { content: \"\\f1e1\"; }\n.ri-takeaway-line:before { content: \"\\f1e2\"; }\n.ri-taobao-fill:before { content: \"\\f1e3\"; }\n.ri-taobao-line:before { content: \"\\f1e4\"; }\n.ri-tape-fill:before { content: \"\\f1e5\"; }\n.ri-tape-line:before { content: \"\\f1e6\"; }\n.ri-task-fill:before { content: \"\\f1e7\"; }\n.ri-task-line:before { content: \"\\f1e8\"; }\n.ri-taxi-fill:before { content: \"\\f1e9\"; }\n.ri-taxi-line:before { content: \"\\f1ea\"; }\n.ri-taxi-wifi-fill:before { content: \"\\f1eb\"; }\n.ri-taxi-wifi-line:before { content: \"\\f1ec\"; }\n.ri-team-fill:before { content: \"\\f1ed\"; }\n.ri-team-line:before { content: \"\\f1ee\"; }\n.ri-telegram-fill:before { content: \"\\f1ef\"; }\n.ri-telegram-line:before { content: \"\\f1f0\"; }\n.ri-temp-cold-fill:before { content: \"\\f1f1\"; }\n.ri-temp-cold-line:before { content: \"\\f1f2\"; }\n.ri-temp-hot-fill:before { content: \"\\f1f3\"; }\n.ri-temp-hot-line:before { content: \"\\f1f4\"; }\n.ri-terminal-box-fill:before { content: \"\\f1f5\"; }\n.ri-terminal-box-line:before { content: \"\\f1f6\"; }\n.ri-terminal-fill:before { content: \"\\f1f7\"; }\n.ri-terminal-line:before { content: \"\\f1f8\"; }\n.ri-terminal-window-fill:before { content: \"\\f1f9\"; }\n.ri-terminal-window-line:before { content: \"\\f1fa\"; }\n.ri-test-tube-fill:before { content: \"\\f1fb\"; }\n.ri-test-tube-line:before { content: \"\\f1fc\"; }\n.ri-text-direction-l:before { content: \"\\f1fd\"; }\n.ri-text-direction-r:before { content: \"\\f1fe\"; }\n.ri-text-spacing:before { content: \"\\f1ff\"; }\n.ri-text-wrap:before { content: \"\\f200\"; }\n.ri-text:before { content: \"\\f201\"; }\n.ri-thermometer-fill:before { content: \"\\f202\"; }\n.ri-thermometer-line:before { content: \"\\f203\"; }\n.ri-thumb-down-fill:before { content: \"\\f204\"; }\n.ri-thumb-down-line:before { content: \"\\f205\"; }\n.ri-thumb-up-fill:before { content: \"\\f206\"; }\n.ri-thumb-up-line:before { content: \"\\f207\"; }\n.ri-thunderstorms-fill:before { content: \"\\f208\"; }\n.ri-thunderstorms-line:before { content: \"\\f209\"; }\n.ri-ticket-2-fill:before { content: \"\\f20a\"; }\n.ri-ticket-2-line:before { content: \"\\f20b\"; }\n.ri-ticket-fill:before { content: \"\\f20c\"; }\n.ri-ticket-line:before { content: \"\\f20d\"; }\n.ri-time-fill:before { content: \"\\f20e\"; }\n.ri-time-line:before { content: \"\\f20f\"; }\n.ri-timer-2-fill:before { content: \"\\f210\"; }\n.ri-timer-2-line:before { content: \"\\f211\"; }\n.ri-timer-fill:before { content: \"\\f212\"; }\n.ri-timer-flash-fill:before { content: \"\\f213\"; }\n.ri-timer-flash-line:before { content: \"\\f214\"; }\n.ri-timer-line:before { content: \"\\f215\"; }\n.ri-todo-fill:before { content: \"\\f216\"; }\n.ri-todo-line:before { content: \"\\f217\"; }\n.ri-toggle-fill:before { content: \"\\f218\"; }\n.ri-toggle-line:before { content: \"\\f219\"; }\n.ri-tools-fill:before { content: \"\\f21a\"; }\n.ri-tools-line:before { content: \"\\f21b\"; }\n.ri-tornado-fill:before { content: \"\\f21c\"; }\n.ri-tornado-line:before { content: \"\\f21d\"; }\n.ri-trademark-fill:before { content: \"\\f21e\"; }\n.ri-trademark-line:before { content: \"\\f21f\"; }\n.ri-traffic-light-fill:before { content: \"\\f220\"; }\n.ri-traffic-light-line:before { content: \"\\f221\"; }\n.ri-train-fill:before { content: \"\\f222\"; }\n.ri-train-line:before { content: \"\\f223\"; }\n.ri-train-wifi-fill:before { content: \"\\f224\"; }\n.ri-train-wifi-line:before { content: \"\\f225\"; }\n.ri-translate-2:before { content: \"\\f226\"; }\n.ri-translate:before { content: \"\\f227\"; }\n.ri-travesti-fill:before { content: \"\\f228\"; }\n.ri-travesti-line:before { content: \"\\f229\"; }\n.ri-treasure-map-fill:before { content: \"\\f22a\"; }\n.ri-treasure-map-line:before { content: \"\\f22b\"; }\n.ri-trello-fill:before { content: \"\\f22c\"; }\n.ri-trello-line:before { content: \"\\f22d\"; }\n.ri-trophy-fill:before { content: \"\\f22e\"; }\n.ri-trophy-line:before { content: \"\\f22f\"; }\n.ri-truck-fill:before { content: \"\\f230\"; }\n.ri-truck-line:before { content: \"\\f231\"; }\n.ri-tumblr-fill:before { content: \"\\f232\"; }\n.ri-tumblr-line:before { content: \"\\f233\"; }\n.ri-tv-2-fill:before { content: \"\\f234\"; }\n.ri-tv-2-line:before { content: \"\\f235\"; }\n.ri-tv-fill:before { content: \"\\f236\"; }\n.ri-tv-line:before { content: \"\\f237\"; }\n.ri-twitch-fill:before { content: \"\\f238\"; }\n.ri-twitch-line:before { content: \"\\f239\"; }\n.ri-twitter-fill:before { content: \"\\f23a\"; }\n.ri-twitter-line:before { content: \"\\f23b\"; }\n.ri-typhoon-fill:before { content: \"\\f23c\"; }\n.ri-typhoon-line:before { content: \"\\f23d\"; }\n.ri-u-disk-fill:before { content: \"\\f23e\"; }\n.ri-u-disk-line:before { content: \"\\f23f\"; }\n.ri-ubuntu-fill:before { content: \"\\f240\"; }\n.ri-ubuntu-line:before { content: \"\\f241\"; }\n.ri-umbrella-fill:before { content: \"\\f242\"; }\n.ri-umbrella-line:before { content: \"\\f243\"; }\n.ri-underline:before { content: \"\\f244\"; }\n.ri-uninstall-fill:before { content: \"\\f245\"; }\n.ri-uninstall-line:before { content: \"\\f246\"; }\n.ri-unsplash-fill:before { content: \"\\f247\"; }\n.ri-unsplash-line:before { content: \"\\f248\"; }\n.ri-upload-2-fill:before { content: \"\\f249\"; }\n.ri-upload-2-line:before { content: \"\\f24a\"; }\n.ri-upload-cloud-2-fill:before { content: \"\\f24b\"; }\n.ri-upload-cloud-2-line:before { content: \"\\f24c\"; }\n.ri-upload-cloud-fill:before { content: \"\\f24d\"; }\n.ri-upload-cloud-line:before { content: \"\\f24e\"; }\n.ri-upload-fill:before { content: \"\\f24f\"; }\n.ri-upload-line:before { content: \"\\f250\"; }\n.ri-usb-fill:before { content: \"\\f251\"; }\n.ri-usb-line:before { content: \"\\f252\"; }\n.ri-user-2-fill:before { content: \"\\f253\"; }\n.ri-user-2-line:before { content: \"\\f254\"; }\n.ri-user-3-fill:before { content: \"\\f255\"; }\n.ri-user-3-line:before { content: \"\\f256\"; }\n.ri-user-4-fill:before { content: \"\\f257\"; }\n.ri-user-4-line:before { content: \"\\f258\"; }\n.ri-user-5-fill:before { content: \"\\f259\"; }\n.ri-user-5-line:before { content: \"\\f25a\"; }\n.ri-user-6-fill:before { content: \"\\f25b\"; }\n.ri-user-6-line:before { content: \"\\f25c\"; }\n.ri-user-add-fill:before { content: \"\\f25d\"; }\n.ri-user-add-line:before { content: \"\\f25e\"; }\n.ri-user-fill:before { content: \"\\f25f\"; }\n.ri-user-follow-fill:before { content: \"\\f260\"; }\n.ri-user-follow-line:before { content: \"\\f261\"; }\n.ri-user-heart-fill:before { content: \"\\f262\"; }\n.ri-user-heart-line:before { content: \"\\f263\"; }\n.ri-user-line:before { content: \"\\f264\"; }\n.ri-user-location-fill:before { content: \"\\f265\"; }\n.ri-user-location-line:before { content: \"\\f266\"; }\n.ri-user-received-2-fill:before { content: \"\\f267\"; }\n.ri-user-received-2-line:before { content: \"\\f268\"; }\n.ri-user-received-fill:before { content: \"\\f269\"; }\n.ri-user-received-line:before { content: \"\\f26a\"; }\n.ri-user-search-fill:before { content: \"\\f26b\"; }\n.ri-user-search-line:before { content: \"\\f26c\"; }\n.ri-user-settings-fill:before { content: \"\\f26d\"; }\n.ri-user-settings-line:before { content: \"\\f26e\"; }\n.ri-user-shared-2-fill:before { content: \"\\f26f\"; }\n.ri-user-shared-2-line:before { content: \"\\f270\"; }\n.ri-user-shared-fill:before { content: \"\\f271\"; }\n.ri-user-shared-line:before { content: \"\\f272\"; }\n.ri-user-smile-fill:before { content: \"\\f273\"; }\n.ri-user-smile-line:before { content: \"\\f274\"; }\n.ri-user-star-fill:before { content: \"\\f275\"; }\n.ri-user-star-line:before { content: \"\\f276\"; }\n.ri-user-unfollow-fill:before { content: \"\\f277\"; }\n.ri-user-unfollow-line:before { content: \"\\f278\"; }\n.ri-user-voice-fill:before { content: \"\\f279\"; }\n.ri-user-voice-line:before { content: \"\\f27a\"; }\n.ri-video-add-fill:before { content: \"\\f27b\"; }\n.ri-video-add-line:before { content: \"\\f27c\"; }\n.ri-video-chat-fill:before { content: \"\\f27d\"; }\n.ri-video-chat-line:before { content: \"\\f27e\"; }\n.ri-video-download-fill:before { content: \"\\f27f\"; }\n.ri-video-download-line:before { content: \"\\f280\"; }\n.ri-video-fill:before { content: \"\\f281\"; }\n.ri-video-line:before { content: \"\\f282\"; }\n.ri-video-upload-fill:before { content: \"\\f283\"; }\n.ri-video-upload-line:before { content: \"\\f284\"; }\n.ri-vidicon-2-fill:before { content: \"\\f285\"; }\n.ri-vidicon-2-line:before { content: \"\\f286\"; }\n.ri-vidicon-fill:before { content: \"\\f287\"; }\n.ri-vidicon-line:before { content: \"\\f288\"; }\n.ri-vimeo-fill:before { content: \"\\f289\"; }\n.ri-vimeo-line:before { content: \"\\f28a\"; }\n.ri-vip-crown-2-fill:before { content: \"\\f28b\"; }\n.ri-vip-crown-2-line:before { content: \"\\f28c\"; }\n.ri-vip-crown-fill:before { content: \"\\f28d\"; }\n.ri-vip-crown-line:before { content: \"\\f28e\"; }\n.ri-vip-diamond-fill:before { content: \"\\f28f\"; }\n.ri-vip-diamond-line:before { content: \"\\f290\"; }\n.ri-vip-fill:before { content: \"\\f291\"; }\n.ri-vip-line:before { content: \"\\f292\"; }\n.ri-virus-fill:before { content: \"\\f293\"; }\n.ri-virus-line:before { content: \"\\f294\"; }\n.ri-visa-fill:before { content: \"\\f295\"; }\n.ri-visa-line:before { content: \"\\f296\"; }\n.ri-voice-recognition-fill:before { content: \"\\f297\"; }\n.ri-voice-recognition-line:before { content: \"\\f298\"; }\n.ri-voiceprint-fill:before { content: \"\\f299\"; }\n.ri-voiceprint-line:before { content: \"\\f29a\"; }\n.ri-volume-down-fill:before { content: \"\\f29b\"; }\n.ri-volume-down-line:before { content: \"\\f29c\"; }\n.ri-volume-mute-fill:before { content: \"\\f29d\"; }\n.ri-volume-mute-line:before { content: \"\\f29e\"; }\n.ri-volume-off-vibrate-fill:before { content: \"\\f29f\"; }\n.ri-volume-off-vibrate-line:before { content: \"\\f2a0\"; }\n.ri-volume-up-fill:before { content: \"\\f2a1\"; }\n.ri-volume-up-line:before { content: \"\\f2a2\"; }\n.ri-volume-vibrate-fill:before { content: \"\\f2a3\"; }\n.ri-volume-vibrate-line:before { content: \"\\f2a4\"; }\n.ri-vuejs-fill:before { content: \"\\f2a5\"; }\n.ri-vuejs-line:before { content: \"\\f2a6\"; }\n.ri-walk-fill:before { content: \"\\f2a7\"; }\n.ri-walk-line:before { content: \"\\f2a8\"; }\n.ri-wallet-2-fill:before { content: \"\\f2a9\"; }\n.ri-wallet-2-line:before { content: \"\\f2aa\"; }\n.ri-wallet-3-fill:before { content: \"\\f2ab\"; }\n.ri-wallet-3-line:before { content: \"\\f2ac\"; }\n.ri-wallet-fill:before { content: \"\\f2ad\"; }\n.ri-wallet-line:before { content: \"\\f2ae\"; }\n.ri-water-flash-fill:before { content: \"\\f2af\"; }\n.ri-water-flash-line:before { content: \"\\f2b0\"; }\n.ri-webcam-fill:before { content: \"\\f2b1\"; }\n.ri-webcam-line:before { content: \"\\f2b2\"; }\n.ri-wechat-2-fill:before { content: \"\\f2b3\"; }\n.ri-wechat-2-line:before { content: \"\\f2b4\"; }\n.ri-wechat-fill:before { content: \"\\f2b5\"; }\n.ri-wechat-line:before { content: \"\\f2b6\"; }\n.ri-wechat-pay-fill:before { content: \"\\f2b7\"; }\n.ri-wechat-pay-line:before { content: \"\\f2b8\"; }\n.ri-weibo-fill:before { content: \"\\f2b9\"; }\n.ri-weibo-line:before { content: \"\\f2ba\"; }\n.ri-whatsapp-fill:before { content: \"\\f2bb\"; }\n.ri-whatsapp-line:before { content: \"\\f2bc\"; }\n.ri-wheelchair-fill:before { content: \"\\f2bd\"; }\n.ri-wheelchair-line:before { content: \"\\f2be\"; }\n.ri-wifi-fill:before { content: \"\\f2bf\"; }\n.ri-wifi-line:before { content: \"\\f2c0\"; }\n.ri-wifi-off-fill:before { content: \"\\f2c1\"; }\n.ri-wifi-off-line:before { content: \"\\f2c2\"; }\n.ri-window-2-fill:before { content: \"\\f2c3\"; }\n.ri-window-2-line:before { content: \"\\f2c4\"; }\n.ri-window-fill:before { content: \"\\f2c5\"; }\n.ri-window-line:before { content: \"\\f2c6\"; }\n.ri-windows-fill:before { content: \"\\f2c7\"; }\n.ri-windows-line:before { content: \"\\f2c8\"; }\n.ri-windy-fill:before { content: \"\\f2c9\"; }\n.ri-windy-line:before { content: \"\\f2ca\"; }\n.ri-wireless-charging-fill:before { content: \"\\f2cb\"; }\n.ri-wireless-charging-line:before { content: \"\\f2cc\"; }\n.ri-women-fill:before { content: \"\\f2cd\"; }\n.ri-women-line:before { content: \"\\f2ce\"; }\n.ri-wubi-input:before { content: \"\\f2cf\"; }\n.ri-xbox-fill:before { content: \"\\f2d0\"; }\n.ri-xbox-line:before { content: \"\\f2d1\"; }\n.ri-xing-fill:before { content: \"\\f2d2\"; }\n.ri-xing-line:before { content: \"\\f2d3\"; }\n.ri-youtube-fill:before { content: \"\\f2d4\"; }\n.ri-youtube-line:before { content: \"\\f2d5\"; }\n.ri-zcool-fill:before { content: \"\\f2d6\"; }\n.ri-zcool-line:before { content: \"\\f2d7\"; }\n.ri-zhihu-fill:before { content: \"\\f2d8\"; }\n.ri-zhihu-line:before { content: \"\\f2d9\"; }\n.ri-zoom-in-fill:before { content: \"\\f2da\"; }\n.ri-zoom-in-line:before { content: \"\\f2db\"; }\n.ri-zoom-out-fill:before { content: \"\\f2dc\"; }\n.ri-zoom-out-line:before { content: \"\\f2dd\"; }\n.ri-zzz-fill:before { content: \"\\f2de\"; }\n.ri-zzz-line:before { content: \"\\f2df\"; }\n\n","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 2.4.0\nWebsite: https://Themesbrand.com/\nContact: Themesbrand@gmail.com\nFile: Custom Bootstrap Css File\n*/\n\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/bootstrap\";","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.2.3 (https://getbootstrap.com/)\n   * Copyright 2011-2022 The Bootstrap Authors\n   * Copyright 2011-2022 Twitter, Inc.\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{$font-family-base};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  --#{$prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-2xl: #{$border-radius-2xl};\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n\n  --#{$prefix}code-color: #{$code-color};\n\n  --#{$prefix}highlight-bg: #{$mark-bg};\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: var(--#{$prefix}link-color);\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: var(--#{$prefix}link-hover-color);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n//\n// custom-variables\n//\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             vz-; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix;\n\n// Font Family\n$font-family-primary:                             'Poppins', sans-serif;\n$font-family-secondary:                           'hkgrotesk', sans-serif;\n\n//\n// Vertical Menu\n//\n$vertical-menu-width:                             250px;\n$vertical-menu-width-md:                          180px;\n$vertical-menu-width-sm:                          70px;\n\n// Light Menu\n$vertical-menu-bg:                                var(--#{$prefix}vertical-menu-bg);\n$vertical-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\n$vertical-menu-border:                            $white;\n$vertical-menu-z-index:                           1002;\n$vertical-menu-item-font-size:                    1rem;\n$vertical-menu-item-font-family:                  $font-family-secondary;\n$vertical-menu-item-color:                        var(--#{$prefix}vertical-menu-item-color);\n$vertical-menu-item-hover-color:                  var(--#{$prefix}vertical-menu-item-hover-color);\n$vertical-menu-item-active-color:                 var(--#{$prefix}vertical-menu-item-active-color);\n$vertical-menu-item-padding-x:                    1.5rem;\n$vertical-menu-item-padding-y:                    0.625rem;\n$vertical-menu-sub-item-font-size:                0.813rem;\n$vertical-menu-sub-item-font-family:              $font-family-primary;\n$vertical-menu-sub-item-color:                    var(--#{$prefix}vertical-menu-sub-item-color);\n$vertical-menu-sub-item-hover-color:              var(--#{$prefix}vertical-menu-sub-item-hover-color);\n$vertical-menu-sub-item-active-color:             var(--#{$prefix}vertical-menu-sub-item-active-color);\n$vertical-menu-sub-item-padding-x:                1.5rem;\n$vertical-menu-sub-item-padding-y:                0.55rem;\n$vertical-menu-dropdown-box-shadow:               0 2px 4px rgba(15,34,58,0.12);\n$vertical-menu-title-color:                       var(--#{$prefix}vertical-menu-title-color);\n$vertical-menu-item-icon-width:                   1.75rem;\n\n// Dark Menu\n$vertical-menu-bg-dark:                         var(--#{$prefix}vertical-menu-bg-dark);\n$vertical-menu-border-dark:                     var(--#{$prefix}vertical-menu-bg-dark);\n$vertical-menu-item-color-dark:                 var(--#{$prefix}vertical-menu-item-color-dark);\n$vertical-menu-item-hover-color-dark:           var(--#{$prefix}vertical-menu-item-hover-color-dark);\n$vertical-menu-item-active-color-dark:          var(--#{$prefix}vertical-menu-item-active-color-dark);\n$vertical-menu-sub-item-color-dark:             var(--#{$prefix}vertical-menu-sub-item-color-dark);\n$vertical-menu-sub-item-hover-color-dark:       var(--#{$prefix}vertical-menu-sub-item-hover-color-dark);\n$vertical-menu-sub-item-active-color-dark:      var(--#{$prefix}vertical-menu-sub-item-active-color-dark);\n$vertical-menu-title-color-dark:                var(--#{$prefix}vertical-menu-title-color-dark);\n\n// vertical gradient Menu\n$vertical-menu-bg-gradient:                         var(--#{$prefix}vertical-menu-bg-gradient);\n$vertical-menu-border-gradient:                     var(--#{$prefix}vertical-menu-border-gradient);\n$vertical-menu-item-color-gradient:                 rgba($white, 0.5);\n$vertical-menu-sub-item-color-gradient:             rgba($white, 0.5);\n$vertical-menu-title-color-gradient:                rgba($white, 0.5);\n\n//\n// Horizontal Menu\n//\n$horizontal-menu-box-shadow:                       0 2px 4px rgba(15,34,58,0.12);\n$horizontal-menu-dropdown-box-shadow:              0 0px 5px rgba(15,34,58,0.15);\n$horizontal-menu-dropdown-min-width:               12rem; \n$horizontal-menu-item-padding-x:                   1.5rem;\n$horizontal-menu-item-padding-y:                   0.75rem;\n\n//\n// Two Column Menu\n//\n$twocolumn-menu-iconview-bg:                       var(--#{$prefix}twocolumn-menu-iconview-bg);\n$twocolumn-menu-bg:                                var(--#{$prefix}twocolumn-menu-bg);\n$twocolumn-menu-iconview-width:                    70px;\n$twocolumn-menu-width:                             220px;\n$twocolumn-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\n$twocolumn-menu-z-index:                           1002;\n// dark\n$twocolumn-menu-iconview-bg-dark:                 var(--#{$prefix}twocolumn-menu-iconview-bg-dark);\n$twocolumn-menu-bg-dark:                          var(--#{$prefix}twocolumn-menu-bg-dark);\n$twocolumn-menu-border-dark:                      var(--#{$prefix}twocolumn-menu-bg-dark);\n$twocolumn-menu-item-color-dark:                  var(--#{$prefix}twocolumn-menu-item-color-dark);\n$twocolumn-menu-item-active-color-dark:           var(--#{$prefix}twocolumn-menu-item-active-color-dark);\n$twocolumn-menu-item-active-bg-dark:              var(--#{$prefix}twocolumn-menu-item-active-bg-dark);\n\n// gradient Menu\n$twocolumn-menu-item-color-gradient:              rgba($white, 0.6);\n\n//semibox\n$semibox-width:                                   110px;\n\n// Topbar - (Default Light)\n$header-height:                                    70px;\n$header-bg:                                       var(--#{$prefix}header-bg);\n$header-item-color:                               var(--#{$prefix}header-item-color);\n\n// Topbar - Dark\n$header-bg-dark:                                 var(--#{$prefix}header-bg-dark);\n$header-item-color-dark:                         var(--#{$prefix}header-item-color-dark); \n\n// Topbar Search\n$topbar-search-bg:                                var(--#{$prefix}topbar-search-bg);\n$page-title-box-shadow:                           0 1px 2px rgba(56,65,74,0.15);\n$page-title-border:                               none;\n\n// Topbar User\n$topbar-user-bg: var(--#{$prefix}topbar-user-bg);\n$topbar-user-bg-dark: var(--#{$prefix}topbar-user-bg-dark);\n\n// Footer\n$footer-height: 60px;\n$footer-bg: var(--#{$prefix}footer-bg);\n$footer-color: var(--#{$prefix}footer-color);\n\n// Horizontal nav\n$topnav-bg:   var(--#{$prefix}topnav-bg);\n$topnav-item-color:   var(--#{$prefix}topnav-item-color);\n$topnav-item-color-active:   var(--#{$prefix}topnav-item-color-active);\n\n// Brand \n$navbar-brand-box-width: 240px;\n\n// Boxed layout width\n$boxed-layout-width:    1300px;\n$boxed-body-bg:         var(--#{$prefix}boxed-body-bg);\n\n// Font Weight\n$font-weight-medium: 500;\n\n// heading\n$heading-color: var(--#{$prefix}heading-color);\n$heading-font-family:         $font-family-primary;\n\n// Chat\n$chat-primary-bg:       var(--#{$prefix}light);\n$chat-secondary-bg:    rgba(var(--#{$prefix}success-rgb), 0.15);\n$chat-secondary-color:  var(--#{$prefix}success);\n\n// Timeline\n$timeline-color:   var(--#{$prefix}card-bg-custom);     \n\n//auth pages\n$auth-bg-cover: linear-gradient(126deg, rgba(8, 143, 125, 1) 0%, rgba(0, 57, 92, 1) 100%);\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff;\n$gray-100: #f3f6f9;\n$gray-200: #eff2f7;\n$gray-300: #e9ebec;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #878a99;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black:    #000;\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:       #3577f1;\n$indigo:     #F26430; // Primary\n$purple:     #F28322; // Primary Light\n$pink:       #f672a7;\n$red:        #f06548;\n$orange:     #208C3B; // Secondary\n$yellow:     #3FBF48; // Secondary Light\n$green:      #0ab39c;\n$teal:       #02a8b5;\n$cyan:       #299cdb;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $indigo;    // #F26430\n$secondary:     $orange;    // #208C3B\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;    // #3FBF48\n$danger:        $red;\n$light:         $gray-100;\n$dark:          $gray-900;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   1.75;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black;\n$color-contrast-light:     $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n);\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n);\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                false;\n$enable-rounded:              true;\n$enable-shadows:              false;\n$enable-gradients:            false;\n$enable-transitions:          true;\n$enable-reduced-motion:       true;\n$enable-smooth-scroll:        true;\n$enable-grid-classes:         true;\n$enable-container-classes:    true;\n$enable-cssgrid:              false;\n$enable-button-pointers:      true;\n$enable-rfs:                  true;\n$enable-validation-icons:     true;\n$enable-negative-margins:     true;\n$enable-deprecation-messages: true;\n$enable-important-utilities:  true;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n);\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   #f3f3f9;\n$body-color:                $gray-900;\n$body-text-align:           null;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              var(--#{$prefix}link-color);\n$link-decoration:                         underline;\n$link-shade-percentage:                   20%;\n$link-hover-color:                        var(--#{$prefix}link-hover-color);\n$link-hover-decoration:                   null;\n\n$stretched-link-pseudo-element:           after;\n$stretched-link-z-index:                  1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           1rem;\n$grid-row-columns:            6;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * 1;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n);\n\n$border-style:                solid;\n$border-color-translucent:    rgba($black, .175);\n$border-color:                var(--#{$prefix}border-color);\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem;\n$border-radius-sm:            .2rem;\n$border-radius-lg:            .3rem;\n$border-radius-xl:            1rem;\n$border-radius-2xl:           2rem;\n$border-radius-pill:          50rem;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 1px 2px rgba(56,65,74,0.15);\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\n$box-shadow-lg:               0 5px 10px rgba(30, 32, 37, 0.12);\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\n$element-shadow:              none;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white;\n$component-active-bg:         $primary;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out;\n$transition-fade:             opacity .15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease;\n$transition-collapse-width:   width .35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      $font-family-primary;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif);\n$font-family-code:            var(--#{$prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null;\n$font-size-base:              0.8125rem; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875;\n$font-size-lg:                $font-size-base * 1.25;\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-semibold:        600;\n$font-weight-bold:            700;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n\n$line-height-base:            1.5;\n$line-height-sm:              1.25;\n$line-height-lg:              2;\n\n$h1-font-size:                $font-size-base * 2.5;\n$h2-font-size:                $font-size-base * 2;\n$h3-font-size:                $font-size-base * 1.75;\n$h4-font-size:                $font-size-base * 1.5;\n$h5-font-size:                $font-size-base * 1.25;\n$h6-font-size:                $font-size-base;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5;\n$headings-font-family:        null;\n$headings-font-style:         null;\n$headings-font-weight:        500;\n$headings-line-height:        1.2;\n$headings-color:              null;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n);\n\n$display-font-family: null;\n$display-font-style:  null;\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             .875em;\n\n$sub-sup-font-size:           .75em;\n\n$text-muted:                  $gray-600;\n\n$initialism-font-size:        $small-font-size;\n\n$blockquote-margin-y:         $spacer;\n$blockquote-font-size:        $font-size-base * 1.1;\n$blockquote-footer-color:     $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y:                 $spacer;\n$hr-color:                    inherit;\n// fusv-disable\n$hr-bg-color:                 null; // Deprecated in v5.2.0\n$hr-height:                   $border-width;\n// fusv-enable\n$hr-border-color:             null; // Allows for inherited colors\n$hr-border-width:             $border-width;\n$hr-opacity:                  .25;\n\n$legend-margin-bottom:        .5rem;\n$legend-font-size:            1.5rem;\n$legend-font-weight:          null;\n\n$mark-padding:                .2em;\n\n$dt-font-weight:              $font-weight-semibold;\n\n$list-inline-padding:         .5rem;\n\n$mark-bg:                     #fcf8e3;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .75rem;\n$table-cell-padding-x:        .6rem;\n$table-cell-padding-y-sm:     .3rem;\n$table-cell-padding-x-sm:     .25rem;\n\n$table-cell-vertical-align:   top;\n\n$table-color:                 var(--#{$prefix}body-color);\n$table-bg:                    transparent;\n$table-accent-bg:             transparent;\n\n$table-th-font-weight:        null;\n\n$table-striped-color:         $table-color;\n$table-striped-bg-factor:     .02;\n$table-striped-bg:            rgba(var(--#{$prefix}dark-rgb), $table-striped-bg-factor);\n\n$table-active-color:          $table-color;\n$table-active-bg-factor:      1;\n$table-active-bg:             rgba(var(--#{$prefix}light-rgb), $table-active-bg-factor);\n\n$table-hover-color:           $table-color;\n$table-hover-bg-factor:       1;\n$table-hover-bg:              rgba(var(--#{$prefix}light-rgb), $table-hover-bg-factor);\n\n$table-border-factor:         .1;\n$table-border-width:          $border-width;\n$table-border-color:          $border-color;\n\n$table-striped-order:         odd;\n$table-striped-columns-order: even;\n\n$table-group-separator-color: $border-color;\n\n$table-caption-color:         $text-muted;\n\n$table-bg-scale:              -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n);\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .5rem;\n$input-btn-padding-x:         .9rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:         0;\n$input-btn-focus-color-opacity: .25;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity);\n$input-btn-focus-blur:          0;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm:      .25rem;\n$input-btn-padding-x-sm:      .5rem;\n$input-btn-font-size-sm:      $font-size-sm;\n\n$input-btn-padding-y-lg:      .7rem;\n$input-btn-padding-x-lg:      1.2rem;\n$input-btn-font-size-lg:      $font-size-lg;\n\n$input-btn-border-width:      $border-width;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\n\n$btn-link-color:              $link-color;\n$btn-link-hover-color:        $link-hover-color;\n$btn-link-disabled-color:     $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius;\n$btn-border-radius-sm:        $border-radius-sm;\n$btn-border-radius-lg:        $border-radius-lg;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$btn-hover-bg-shade-amount:       15%;\n$btn-hover-bg-tint-amount:        15%;\n$btn-hover-border-shade-amount:   20%;\n$btn-hover-border-tint-amount:    10%;\n$btn-active-bg-shade-amount:      20%;\n$btn-active-bg-tint-amount:       20%;\n$btn-active-border-shade-amount:  25%;\n$btn-active-border-tint-amount:   10%;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem;\n$form-text-font-size:                   $small-font-size;\n$form-text-font-style:                  null;\n$form-text-font-weight:                 null;\n$form-text-color:                       $text-muted;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem;\n$form-label-font-size:                  null;\n$form-label-font-style:                 null;\n$form-label-font-weight:                null;\n$form-label-color:                      null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n\n$input-bg:                              var(--#{$prefix}input-bg);\n$input-disabled-color:                  null;\n$input-disabled-bg:                     var(--#{$prefix}input-disabled-bg);\n$input-disabled-border-color:           null;\n\n$input-color:                           var(--#{$prefix}body-color);\n$input-border-color:                    var(--#{$prefix}input-border);\n$input-border-width:                    $input-btn-border-width;\n$input-box-shadow:                      $box-shadow-inset;\n\n$input-border-radius:                   $border-radius;\n$input-border-radius-sm:                $border-radius-sm;\n$input-border-radius-lg:                $border-radius-lg;\n\n$input-focus-bg:                        $input-bg;\n$input-focus-border-color:              var(--#{$prefix}input-focus-border);\n$input-focus-color:                     $input-color;\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow;\n\n$input-placeholder-color:               $gray-600;\n$input-plaintext-color:                 var(--#{$prefix}body-color);\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n$form-color-width:                      3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1.1em;\n$form-check-min-height:                   $font-size-base * $line-height-base;\n$form-check-padding-start:                $form-check-input-width + .5em;\n$form-check-margin-bottom:                .125rem;\n$form-check-label-color:                  null;\n$form-check-label-cursor:                 null;\n$form-check-transition:                   null;\n\n$form-check-input-active-filter:          brightness(90%);\n\n$form-check-input-bg:                     $input-bg;\n$form-check-input-border:                 1px solid var(--#{$prefix}input-check-border);\n$form-check-input-border-radius:          .25em;\n$form-check-radio-border-radius:          50%;\n$form-check-input-focus-border:           $input-focus-border-color;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow;\n\n$form-check-input-checked-color:          $component-active-color;\n$form-check-input-checked-bg-color:       $component-active-bg;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color:          $component-active-color;\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity:        .5;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\n\n$form-check-inline-margin-end:    1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25);\n$form-switch-width:               2em;\n$form-switch-padding-start:       $form-switch-width + .5em;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius:       $form-switch-width;\n$form-switch-transition:          background-position .15s ease-in-out;\n\n$form-switch-focus-color:         tint-color($component-active-bg, 50%);\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color:       $component-active-color;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y;\n$input-group-addon-padding-x:           $input-padding-x;\n$input-group-addon-font-weight:         $input-font-weight;\n$input-group-addon-color:               $input-color;\n$input-group-addon-bg:                  var(--#{$prefix}input-group-addon-bg);\n$input-group-addon-border-color:        $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y;\n$form-select-padding-x:             $input-padding-x;\n$form-select-font-family:           $input-font-family;\n$form-select-font-size:             $input-font-size;\n$form-select-indicator-padding:     $form-select-padding-x * 3; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight;\n$form-select-line-height:           $input-line-height;\n$form-select-color:                 $input-color;\n$form-select-bg:                    $input-bg;\n$form-select-disabled-color:        null;\n$form-select-disabled-bg:           $input-disabled-bg;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position:           right $form-select-padding-x center;\n$form-select-bg-size:               16px 12px; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width:        $input-border-width;\n$form-select-border-color:        $input-border-color;\n$form-select-border-radius:       $border-radius;\n$form-select-box-shadow:          $box-shadow-inset;\n\n$form-select-focus-border-color:  $input-focus-border-color;\n$form-select-focus-width:         $input-focus-width;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color;\n\n$form-select-padding-y-sm:        $input-padding-y-sm;\n$form-select-padding-x-sm:        $input-padding-x-sm;\n$form-select-font-size-sm:        $input-font-size-sm;\n$form-select-border-radius-sm:    $input-border-radius-sm;\n\n$form-select-padding-y-lg:        $input-padding-y-lg;\n$form-select-padding-x-lg:        $input-padding-x-lg;\n$form-select-font-size-lg:        $input-font-size-lg;\n$form-select-border-radius-lg:    $input-border-radius-lg;\n\n$form-select-transition:          $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100%;\n$form-range-track-height:         .5rem;\n$form-range-track-cursor:         pointer;\n$form-range-track-bg:             var(--#{$prefix}gray-300);\n$form-range-track-border-radius:  1rem;\n$form-range-track-box-shadow:     $box-shadow-inset;\n\n$form-range-thumb-width:                   1rem;\n$form-range-thumb-height:                  $form-range-thumb-width;\n$form-range-thumb-bg:                      $component-active-bg;\n$form-range-thumb-border:                  0;\n$form-range-thumb-border-radius:           1rem;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg:             $gray-500;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color;\n$form-file-button-bg:             $input-group-addon-bg;\n$form-file-button-hover-bg:       $input-group-addon-bg;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border);\n$form-floating-line-height:       1.25;\n$form-floating-padding-x:         $input-padding-x;\n$form-floating-padding-y:         1rem;\n$form-floating-input-padding-t:   1.625rem;\n$form-floating-input-padding-b:   .625rem;\n$form-floating-label-opacity:     .65;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $form-text-font-size;\n$form-feedback-font-style:          $form-text-font-style;\n$form-feedback-valid-color:         $success;\n$form-feedback-invalid-color:       $danger;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-offcanvas-backdrop:         1040;\n$zindex-offcanvas:                  1045;\n$zindex-modal-backdrop:             1050;\n$zindex-modal:                      1055;\n$zindex-popover:                    1070;\n$zindex-tooltip:                    1080;\n$zindex-toast:                      1090;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-font-size:                null;\n$nav-link-font-weight:              null;\n$nav-link-color:                    $link-color;\n$nav-link-hover-color:              $link-hover-color;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n$nav-link-disabled-color:           $gray-600;\n\n$nav-tabs-border-color:             var(--#{$prefix}gray-300);\n$nav-tabs-border-width:             $border-width;\n$nav-tabs-border-radius:            $border-radius;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}gray-300) var(--#{$prefix}gray-300) $nav-tabs-border-color;\n$nav-tabs-link-active-color:        $gray-700;\n$nav-tabs-link-active-bg:           var(--#{$prefix}nav-tabs-link-active-bg);\n$nav-tabs-link-active-border-color: var(--#{$prefix}gray-300) var(--#{$prefix}gray-300) $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius:           $border-radius;\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5;\n$navbar-padding-x:                  null;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5;\n$navbar-brand-margin-end:           1rem;\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n$navbar-toggler-focus-width:        $btn-focus-width;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55);\n$navbar-dark-hover-color:           rgba($white, .75);\n$navbar-dark-active-color:          $white;\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color:  rgba($white, .1);\n\n$navbar-light-color:                rgba($black, .55);\n$navbar-light-hover-color:          rgba($black, .7);\n$navbar-light-active-color:         rgba($black, .9);\n$navbar-light-disabled-color:       rgba($black, .3);\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, .1);\n\n$navbar-light-brand-color:                $navbar-light-active-color;\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem;\n$dropdown-padding-x:                0;\n$dropdown-padding-y:                .5rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    var(--#{$prefix}body-color);\n$dropdown-bg:                       $white;\n$dropdown-border-color:             var(--#{$prefix}border-color);\n$dropdown-border-radius:            $border-radius-lg;\n$dropdown-border-width:             0;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\n$dropdown-divider-bg:               $dropdown-border-color;\n$dropdown-divider-margin-y:         $spacer * .5;\n$dropdown-box-shadow:               $box-shadow-lg;\n\n$dropdown-link-color:               $gray-900;\n$dropdown-link-hover-color:         #{shade-color($gray-900, 10%)};\n$dropdown-link-hover-bg:            $gray-100;\n\n$dropdown-link-active-color:        #{shade-color($gray-900, 10%)};\n$dropdown-link-active-bg:           $gray-100;\n\n$dropdown-link-disabled-color:      $gray-500;\n\n$dropdown-item-padding-y:           0.35rem;\n$dropdown-item-padding-x:           1.2rem;\n\n$dropdown-header-color:             $gray-600;\n$dropdown-header-padding-x:         $dropdown-item-padding-x;\n$dropdown-header-padding-y:         $dropdown-padding-y;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x; // Deprecated in v5.2.0\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300;\n$dropdown-dark-bg:                  $gray-800;\n$dropdown-dark-border-color:        $dropdown-border-color;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\n$dropdown-dark-box-shadow:          null;\n$dropdown-dark-link-color:          $dropdown-dark-color;\n$dropdown-dark-link-hover-color:    $white;\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\n$dropdown-dark-link-active-color:   $white;\n$dropdown-dark-link-active-bg:      lighten($dropdown-dark-bg, 5%);\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color:        $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .6rem;\n$pagination-padding-x-lg:           1.2rem;\n\n$pagination-font-size:              $font-size-base;\n$pagination-color:                  $link-color;\n$pagination-bg:                     var(--#{$prefix}card-bg-custom);\n$pagination-border-width:           $border-width;\n$pagination-border-radius:          $border-radius;\n$pagination-margin-start:           -$pagination-border-width;\n$pagination-border-color:           var(--#{$prefix}border-color);\n\n$pagination-focus-color:            $link-hover-color;\n$pagination-focus-bg:               $gray-200;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            $link-hover-color;\n$pagination-hover-bg:               $gray-200;\n$pagination-hover-border-color:     var(--#{$prefix}border-color);\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $pagination-active-bg;\n\n$pagination-disabled-color:         $gray-600;\n$pagination-disabled-bg:            $pagination-bg;\n$pagination-disabled-border-color:  $pagination-border-color;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$pagination-border-radius-sm:       $border-radius-sm;\n$pagination-border-radius-lg:       $border-radius-lg;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5;\n$placeholder-opacity-min:           .2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer;\n$card-spacer-x:                     $spacer;\n$card-title-spacer-y:               $spacer * .5;\n$card-border-width:                 0;\n$card-border-color:                 rgba($black, .125);\n$card-border-radius:                $border-radius;\n$card-box-shadow:                   $box-shadow;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y:                $card-spacer-y;\n$card-cap-padding-x:                $card-spacer-x;\n$card-cap-bg:                       $white;\n$card-cap-color:                    null;\n$card-height:                       null;\n$card-color:                        null;\n$card-bg:                           $white;\n$card-img-overlay-padding:          $spacer;\n$card-group-margin:                 $grid-gutter-width * .5;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem;\n$accordion-padding-x:                     1.25rem;\n$accordion-color:                         var(--#{$prefix}body-color);\n$accordion-bg:                            $white;\n$accordion-border-width:                  $border-width;\n$accordion-border-color:                  var(--#{$prefix}border-color);\n$accordion-border-radius:                 $border-radius;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\n\n$accordion-body-padding-y:                $accordion-padding-y;\n$accordion-body-padding-x:                $accordion-padding-x;\n\n$accordion-button-padding-y:              $accordion-padding-y;\n$accordion-button-padding-x:              $accordion-padding-x;\n$accordion-button-color:                  $accordion-color;\n$accordion-button-bg:                     $accordion-bg;\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\n$accordion-button-active-bg:              rgba($component-active-bg, 0.05);\n$accordion-button-active-color:           shade-color($primary, 10%);\n\n$accordion-button-focus-border-color:     $input-focus-border-color;\n$accordion-button-focus-box-shadow:       inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\n\n$accordion-icon-width:                    0.75rem;\n$accordion-icon-color:                    $accordion-color;\n$accordion-icon-active-color:             $accordion-button-active-color;\n$accordion-icon-transition:               transform .2s ease-in-out;\n$accordion-icon-transform:                rotate(-180deg);\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     $white;\n$tooltip-bg:                        $black;\n$tooltip-border-radius:             $border-radius-sm;\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 $spacer * .4;\n$tooltip-padding-x:                 $spacer * .7;\n$tooltip-margin:                    0;\n\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n$tooltip-arrow-color:               $tooltip-bg;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   null;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-base;\n$popover-bg:                        $white;\n$popover-max-width:                 276px;\n$popover-border-width:              $border-width;\n$popover-border-color:              var(--#{$prefix}border-color);\n$popover-border-radius:             $border-radius;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\n$popover-box-shadow:                $box-shadow-lg;\n\n$popover-header-font-size:          $font-size-base;\n$popover-header-bg:                 var(--#{$prefix}popover-bg);\n$popover-header-color:              $headings-color;\n$popover-header-padding-y:          .7rem;\n$popover-header-padding-x:          $spacer;\n\n$popover-body-color:                var(--#{$prefix}body-color);\n$popover-body-padding-y:            $spacer;\n$popover-body-padding-x:            $spacer;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n$popover-arrow-color:               var(--#{$prefix}popover-bg);\n\n$popover-arrow-outer-color:         var(--#{$prefix}border-color);\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .5rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       null;\n$toast-background-color:            rgba($white, .85);\n$toast-border-width:                1px;\n$toast-border-color:                rgba($black, .1);\n$toast-border-radius:               $border-radius;\n$toast-box-shadow:                  $box-shadow;\n$toast-spacing:                     $container-padding-x;\n\n$toast-header-color:                $gray-600;\n$toast-header-background-color:     rgba($white, .85);\n$toast-header-border-color:         rgba($black, .05);\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em;\n$badge-font-weight:                 $font-weight-semibold;\n$badge-color:                       $white;\n$badge-padding-y:                   .35em;\n$badge-padding-x:                   .65em;\n$badge-border-radius:               $border-radius;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer * 1.25;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem;\n\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  $white;\n$modal-content-border-color:        $border-color;\n$modal-content-border-width:        $border-width;\n$modal-content-border-radius:       $border-radius-lg;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\n$modal-content-box-shadow-xs:       $box-shadow-sm;\n$modal-content-box-shadow-sm-up:    $box-shadow;\n\n$modal-backdrop-bg:                 $black;\n$modal-backdrop-opacity:            .5;\n$modal-header-border-color:         $border-color;\n$modal-footer-border-color:         $modal-header-border-color;\n$modal-header-border-width:         0;\n$modal-footer-border-width:         $modal-header-border-width;\n$modal-header-padding-y:            $modal-inner-padding;\n$modal-header-padding-x:            $modal-inner-padding;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null;\n$modal-sm:                          300px;\n$modal-md:                          500px;\n$modal-lg:                          800px;\n$modal-xl:                          1140px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(1.02);\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer * 0.8;\n$alert-padding-x:               $spacer;\n$alert-margin-bottom:           1rem;\n$alert-border-radius:           $border-radius;\n$alert-link-font-weight:        $font-weight-semibold;\n$alert-border-width:            $border-width;\n$alert-bg-scale:                -85%;\n$alert-border-scale:            -70%;\n$alert-color-scale:             25%;\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   0.625rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       $gray-200;\n$progress-border-radius:            $border-radius;\n$progress-box-shadow:               $box-shadow-inset;\n$progress-bar-color:                $white;\n$progress-bar-bg:                   $primary;\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color);\n$list-group-bg:                     var(--#{$prefix}card-bg-custom);\n$list-group-border-color:           var(--#{$prefix}border-color);\n$list-group-border-width:           $border-width;\n$list-group-border-radius:          $border-radius;\n\n$list-group-item-padding-y:         $spacer * .7;\n$list-group-item-padding-x:         $spacer;\n$list-group-item-bg-scale:          -80%;\n$list-group-item-color-scale:       40%;\n\n$list-group-hover-bg:               var(--#{$prefix}list-group-hover-bg);\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         $gray-600;\n$list-group-disabled-bg:            $list-group-bg;\n\n$list-group-action-color:           var(--#{$prefix}body-color);\n$list-group-action-hover-color:     $list-group-action-color;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color);\n$list-group-action-active-bg:       var(--#{$prefix}list-group-hover-bg);;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      var(--#{$prefix}body-bg);\n$thumbnail-border-width:            $border-width;\n$thumbnail-border-color:            var(--#{$prefix}border-color);\n$thumbnail-border-radius:           $border-radius;\n$thumbnail-box-shadow:              $box-shadow-sm;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size;\n$figure-caption-color:              $gray-600;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null;\n$breadcrumb-padding-y:              0;\n$breadcrumb-padding-x:              0;\n$breadcrumb-item-padding-x:         .5rem;\n$breadcrumb-margin-bottom:          1rem;\n$breadcrumb-bg:                     null;\n$breadcrumb-divider-color:          $gray-600;\n$breadcrumb-active-color:           $gray-600;\n$breadcrumb-divider:                quote(\"\\F0142\");\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\n$breadcrumb-border-radius:          null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white;\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-opacity:         .5;\n$carousel-indicator-active-bg:       $white;\n$carousel-indicator-active-opacity:  1;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             $white;\n$carousel-caption-padding-y:         1.25rem;\n$carousel-caption-spacer:            1.25rem;\n\n$carousel-control-icon-width:        2rem;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black;\n$carousel-dark-caption-color:        $black;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem;\n$spinner-height:          $spinner-width;\n$spinner-vertical-align:  -.125em;\n$spinner-border-width:    .25em;\n$spinner-animation-speed: .75s;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em;\n$btn-close-height:           $btn-close-width;\n$btn-close-padding-x:        .25em;\n$btn-close-padding-y:        $btn-close-padding-x;\n$btn-close-color:            $black;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow;\n$btn-close-opacity:          .5;\n$btn-close-hover-opacity:    .75;\n$btn-close-focus-opacity:    1;\n$btn-close-disabled-opacity: .25;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding;\n$offcanvas-padding-x:               $modal-inner-padding;\n$offcanvas-horizontal-width:        400px;\n$offcanvas-vertical-height:         30vh;\n$offcanvas-transition-duration:     .3s;\n$offcanvas-border-color:            $modal-content-border-color;\n$offcanvas-border-width:            $modal-content-border-width;\n$offcanvas-title-line-height:       $modal-title-line-height;\n$offcanvas-bg-color:                $modal-content-bg;\n$offcanvas-color:                   $modal-content-color;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size;\n$code-color:                        $pink;\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         $white;\n$kbd-bg:                            $gray-900;\n$nested-kbd-font-weight:            $font-weight-bold;; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: var(--#{$prefix}table-color);\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: ($table-border-width * 2) solid $table-group-separator-color;\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-accent-bg: var(--#{$prefix}table-active-bg);\n  color: var(--#{$prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-hover-bg);\n    color: var(--#{$prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$body-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    background: none;\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == ($pagination-border-width * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  --#{$prefix}alert-color: #{$color};\n  --#{$prefix}alert-bg: #{$background};\n  --#{$prefix}alert-border-color: #{$border};\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  padding: var(--#{$prefix}tooltip-arrow-height);\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: 0;\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: 0;\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(transform $offcanvas-transition-duration ease-in-out);\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// stylelint-disable function-name-case\n\n// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value !important; // stylelint-disable-line declaration-no-important\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage)) !important; // stylelint-disable-line declaration-no-important\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 2.4.0\nWebsite: https://themesbrand.com/\nContact: support@themesbrand.com\nFile: Main Css File\n*/\n\n\n//Fonts\n@import \"../../fonts/fonts\";\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/mixins\";\n\n@import \"theme-light\";\n@import \"theme-dark\";\n\n// Structure\n@import \"../../structure/topbar\";\n@import \"../../structure/page-head\";\n@import \"../../structure/footer\";\n@import \"../../structure/vertical\";\n@import \"../../structure/horizontal\";\n@import \"../../structure/two-column\";\n@import \"../../structure/layouts\";\n\n// Components\n@import \"../../components/waves\";\n@import \"../../components/avatar\";\n@import \"../../components/accordion\";\n@import \"../../components/helper\";\n@import \"../../components/preloader\";\n@import \"../../components/forms\";\n@import \"../../components/widgets\";\n@import \"../../components/demos\";\n@import \"../../components/print\";\n@import \"../../components/ribbons\";\n@import \"../../components/toast\";\n@import \"../../components/scrollspy\";\n\n// Bootstrap components\n@import \"../../components/reboot\";\n@import \"../../components/alerts\";\n@import \"../../components/backgrounds\";\n@import \"../../components/badge\";\n@import \"../../components/buttons\";\n@import \"../../components/breadcrumb\";\n@import \"../../components/card\";\n@import \"../../components/dropdown\";\n@import \"../../components/nav\";\n@import \"../../components/table\";\n@import \"../../components/modal\";\n@import \"../../components/pagination\";\n@import \"../../components/progress\";\n@import \"../../components/popover\";\n@import \"../../components/type\";\n@import \"../../components/form-check\";\n@import \"../../components/form-control\";\n@import \"../../components/list-group\";\n\n// Plugins\n@import \"../../plugins/custom-scrollbar\";\n@import \"../../plugins/prismjs\";\n@import \"../../plugins/sweetalert2\";\n@import \"../../plugins/dropzone\";\n@import \"../../plugins/range-slider\";\n@import \"../../plugins/sortablejs\";\n@import \"../../plugins/tour\";\n@import \"../../plugins/swiper\";\n@import \"../../plugins/multijs\";\n@import \"../../plugins/colorpicker\";\n@import \"../../plugins/filepond\";\n@import \"../../plugins/form-input-spin\";\n@import \"../../plugins/ckeditor\";\n@import \"../../plugins/quilljs\";\n@import \"../../plugins/gridjs\";\n@import \"../../plugins/listjs\";\n@import \"../../plugins/apexcharts\";\n@import \"../../plugins/chartjs\";\n@import \"../../plugins/echarts\";\n@import \"../../plugins/google-map\";\n@import \"../../plugins/autocomplete\";\n@import \"../../plugins/vector-maps\";\n@import \"../../plugins/leaflet-maps\";\n@import \"../../plugins/fullcalendar\";\n@import \"../../plugins/emoji-picker\";\n@import \"../../plugins/datatables\";\n@import \"../../plugins/select2\";\n\n// Plugins\n@import \"../../plugins/toastify\";\n@import \"../../plugins/choices\";\n@import \"../../plugins/flatpicker\";\n@import \"../../plugins/flag-input\";\n\n// Pages\n@import \"../../pages/authentication\";\n@import \"../../pages/dashboard\";\n@import \"../../pages/timeline\";\n@import \"../../pages/gallery\";\n@import \"../../pages/errors\";\n@import \"../../pages/profile\";\n@import \"../../pages/sitemap\";\n@import \"../../pages/team\";\n@import \"../../pages/coming-soon\";\n@import \"../../pages/search-results\";\n@import \"../../pages/ecommerce\";\n@import \"../../pages/invoice\";\n@import \"../../pages/chat\";\n@import \"../../pages/email\";\n@import \"../../pages/kanban\";\n@import \"../../pages/landing\";\n@import \"../../pages/nft-landing\";\n@import \"../../pages/file-manager\";\n@import \"../../pages/to-do\";\n@import \"../../pages/jobs\";\n@import \"../../pages/job-landing\";","//\n// Google font - Poppins\n//\n\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\n\n//\n// Premium Font : HKGrotesk\n//\n\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-light.eot\");\n    src: local('hkgrotesk light'), url(\"../../fonts/hkgrotesk-light.woff\") format(\"woff\");\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-regular.eot\");\n    src: local('hkgrotesk regular'), url(\"../../fonts/hkgrotesk-regular.woff\") format(\"woff\");\n    font-weight: 400;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-medium.eot\");\n    src: local('hkgrotesk medium'), url(\"../../fonts/hkgrotesk-medium.woff\") format(\"woff\");\n    font-weight: 500;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-semibold.eot\");\n    src: local('hkgrotesk semibold'), url(\"../../fonts/hkgrotesk-semibold.woff\") format(\"woff\");\n    font-weight: 600;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    // src: url(\"../../fonts/hkgrotesk-bold.eot\");\n    src: local('hkgrotesk bold'), url(\"../../fonts/hkgrotesk-bold.woff\") format(\"woff\");\n    font-weight: 700;\n}","// :root CSS variables\n\n:root{\n\n    //vertical light\n  --#{$prefix}vertical-menu-bg:                      #{$white};\n  --#{$prefix}vertical-menu-item-color:              #{darken($gray-600, 10%)};\n  --#{$prefix}vertical-menu-item-hover-color:        #{$primary};\n  --#{$prefix}vertical-menu-item-active-color:       #{$primary};\n  --#{$prefix}vertical-menu-sub-item-color:          #{darken($gray-600, 4%)};\n  --#{$prefix}vertical-menu-sub-item-hover-color:    #{$primary};\n  --#{$prefix}vertical-menu-sub-item-active-color:   #{$primary};\n  --#{$prefix}vertical-menu-title-color:             #919da9;\n  \n  //vertical dark\n  --#{$prefix}vertical-menu-bg-dark:                 #{$primary};\n  --#{$prefix}vertical-menu-item-color-dark:         #e0dcdc;\n  --#{$prefix}vertical-menu-item-hover-color-dark:   #{$white};\n  --#{$prefix}vertical-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}vertical-menu-sub-item-color-dark:     #e0dcdc;\n  --#{$prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\n  --#{$prefix}vertical-menu-sub-item-active-color-dark: #{$white};\n  --#{$prefix}vertical-menu-title-color-dark:         #c1c6cb;\n\n  // Topbar - (Default Light)\n  --#{$prefix}header-bg:  #{$white};\n  --#{$prefix}header-item-color:  #e9ecef;\n  // Topbar - Dark\n  --#{$prefix}header-bg-dark:  #{$primary};\n  --#{$prefix}header-item-color-dark:  #b0c4d9;\n\n  // Topbar Search\n  --#{$prefix}topbar-search-bg: #f3f3f9;\n  // Topbar User\n  --#{$prefix}topbar-user-bg: #f3f3f9;\n  --#{$prefix}topbar-user-bg-dark: #088F7D;\n\n  //footer\n  --#{$prefix}footer-bg: #{$white};\n  --#{$prefix}footer-color: #98a6ad;\n\n  // Horizontal nav\n  --#{$prefix}topnav-bg: #{$white};\n  --#{$prefix}topnav-item-color: #{darken($gray-600, 10%)};\n  --#{$prefix}topnav-item-color-active: #{$primary};\n\n  // twocolumn menu\n  --#{$prefix}twocolumn-menu-iconview-bg: #{$white};\n  --#{$prefix}twocolumn-menu-bg:  #{$white};\n  // two column dark\n  --#{$prefix}twocolumn-menu-iconview-bg-dark: var(--#{$prefix}vertical-menu-bg-dark);\n  --#{$prefix}twocolumn-menu-bg-dark:  #{lighten($primary, 2%)};\n  --#{$prefix}twocolumn-menu-item-color-dark: var(--#{$prefix}vertical-menu-item-color-dark);\n  --#{$prefix}twocolumn-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\n\n  // boxed \n  --#{$prefix}boxed-body-bg: #{darken($body-bg, 4%)};\n\n  // heading-color\n  --#{$prefix}heading-color: #{$gray-700};\n  \n  // component variable\n  // link\n  --#{$prefix}link-color: #{$primary};\n  --#{$prefix}link-hover-color: #{$primary};\n\n  // Border variable\n  --#{$prefix}border-color:  #{$gray-300};\n\n  // card\n  --#{$prefix}card-bg-custom: #{$white};\n  --#{$prefix}card-logo-dark: block;\n  --#{$prefix}card-logo-light: none;\n\n  // nav tabs\n  .nav-tabs {\n    --#{$prefix}nav-tabs-link-active-bg:           #{$body-bg};\n  }\n\n  //choices \n  .choices, .flatpickr-calendar, .ck, .ql-toolbar, .select2-container, .menu-dropdown{\n    --#{$prefix}choices-bg:                        #{$white};\n    --#{$prefix}choices-link-color:                #{$gray-900};\n    --#{$prefix}choices-link-hover-bg:             #{$gray-100};\n    --#{$prefix}choices-link-active-color:         #{shade-color($gray-900, 10%)};\n  }\n\n  //list\n  --#{$prefix}list-group-hover-bg: #{$gray-100};\n\n  // form\n  --#{$prefix}input-bg: #{$white};\n  --#{$prefix}input-border: #{$gray-400};\n  --#{$prefix}input-focus-border: #{tint-color($component-active-bg, 50%)};\n  --#{$prefix}input-disabled-bg: #{$gray-200};\n\n  // input-group-addon\n  --#{$prefix}input-group-addon-bg: #{$gray-200};\n\n  //check\n  --#{$prefix}input-check-border: var(--#{$prefix}input-border);\n}\n","// :root CSS dark variables\n\n\n[data-layout-mode=\"dark\"]{\n\n  // Color system - Dark Mode only\n  $gray-100: #1a1d21;\n  $gray-200: #212529;\n  $gray-300: #2a2f34;\n  $gray-400: #878a99;\n  $gray-500: #adb5bd;\n  $gray-600: #bfc8e2;\n  $gray-700: #ced4da;\n  $gray-800: #eff2f7;\n  $gray-900: #f3f6f9;\n  \n  $grays: (\n      \"100\": $gray-100,\n      \"200\": $gray-200,\n      \"300\": $gray-300,\n      \"400\": $gray-400,\n      \"500\": $gray-500,\n      \"600\": $gray-600,\n      \"700\": $gray-700,\n      \"800\": $gray-800,\n      \"900\": $gray-900\n  );\n\n  // Prefix for :root CSS variables\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  // body\n  --#{$prefix}body-bg :  #{$gray-100};\n  --#{$prefix}body-bg-rgb :  #{to-rgb($gray-100)};\n  --#{$prefix}body-color: #{$gray-700};\n  --#{$prefix}body-color-rgb: #{to-rgb($gray-700)};\n\n  //vertical light\n  --#{$prefix}vertical-menu-bg:                      #{$gray-200};\n  --#{$prefix}vertical-menu-item-color:              #{darken($gray-400, 16%)};\n  --#{$prefix}vertical-menu-item-hover-color:        #{$primary};\n  --#{$prefix}vertical-menu-item-active-color:       #{$primary};\n  --#{$prefix}vertical-menu-sub-item-color:          #{darken($gray-400, 12%)};\n  --#{$prefix}vertical-menu-sub-item-hover-color:    #{$primary};\n  --#{$prefix}vertical-menu-sub-item-active-color:   #{$primary};\n  --#{$prefix}vertical-menu-title-color:             #{$gray-400};\n\n  //vertical dark\n  --#{$prefix}vertical-menu-bg-dark:                 #{$gray-200};\n  --#{$prefix}vertical-menu-item-color-dark:         #{$gray-400};\n  --#{$prefix}vertical-menu-item-hover-color-dark:   #{$white};\n  --#{$prefix}vertical-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}vertical-menu-sub-item-color-dark:     #{darken($gray-400, 4%)};\n  --#{$prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\n  --#{$prefix}vertical-menu-sub-item-active-color-dark: #{$white};\n  --#{$prefix}vertical-menu-title-color-dark:         #{darken($gray-400, 16%)};\n\n  // Topbar - (Default Light)\n  --#{$prefix}header-bg:  #292e32;\n  --#{$prefix}header-item-color:  #e9ecef;\n  // Topbar - Dark\n  --#{$prefix}header-bg-dark:  #{$primary};\n  --#{$prefix}header-item-color-dark:  #b0c4d9;\n\n  // Topbar Search\n  --#{$prefix}topbar-search-bg: #202328;\n  // Topbar User\n  --#{$prefix}topbar-user-bg: #{lighten($gray-300, 3%)};\n  --#{$prefix}topbar-user-bg-dark: #088f7d;\n  \n  //footer\n  --#{$prefix}footer-bg: #{$gray-200};\n  --#{$prefix}footer-color: #{$gray-400};\n  \n  // Horizontal nav\n  --#{$prefix}topnav-bg: #{lighten($gray-200, 2.5%)};\n  --#{$prefix}topnav-item-color: #{$gray-400};\n  --#{$prefix}topnav-item-color-active: #{$white};\n  \n  // twocolumn menu\n  --#{$prefix}twocolumn-menu-iconview-bg: #{$white};\n  --#{$prefix}twocolumn-menu-bg:  #{$white};\n  \n  // two column dark\n  --#{$prefix}twocolumn-menu-iconview-bg-dark: var(--#{$prefix}vertical-menu-bg-dark);\n  --#{$prefix}twocolumn-menu-bg-dark:  #30363a;\n  --#{$prefix}twocolumn-menu-item-color-dark: var(--#{$prefix}vertical-menu-item-color-dark);\n  --#{$prefix}twocolumn-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\n  \n  // boxed \n  --#{$prefix}boxed-body-bg: #{darken($gray-100, 4%)};\n  \n  // heading-color\n  --#{$prefix}heading-color: #{$gray-700};\n  \n  // component variable\n  --#{$prefix}light: #{$gray-300};\n  --#{$prefix}light-rgb: #{to-rgb($gray-300)};\n  --#{$prefix}dark: #{$gray-800};\n  --#{$prefix}dark-rgb: #{to-rgb($gray-800)};\n  \n  // link\n  --#{$prefix}link-color: #{$gray-700};\n  --#{$prefix}link-hover-color: #{$gray-700};\n  \n  // Border variable\n  --#{$prefix}border-color:  #{lighten($gray-300, 3.5%)};\n  \n  // dropdown\n  .dropdown-menu {\n    --#{$prefix}dropdown-bg:                         #{lighten($gray-200, 3.5%)};\n    --#{$prefix}dropdown-link-color:                 #{$gray-500};\n    --#{$prefix}dropdown-link-hover-color:           #{shade-color($gray-700, 10%)};\n    --#{$prefix}dropdown-link-hover-bg:              #{lighten($gray-300, 2%)};\n    --#{$prefix}dropdown-border-width:               1px;\n    --#{$prefix}dropdown-link-active-color:          #{$gray-500};\n    --#{$prefix}dropdown-link-active-bg:             #{lighten($gray-300, 2%)};\n  }\n\n  //choices \n  .choices, .flatpickr-calendar, .ck, .ql-toolbar, .select2-container, .menu-dropdown {\n    --#{$prefix}choices-bg:                          #{lighten($gray-200, 3.5%)};\n    --#{$prefix}choices-link-color:                  #{$gray-500};\n    --#{$prefix}choices-link-hover-bg:               #{lighten($gray-300, 2%)};\n    --#{$prefix}choices-link-active-color:           #{shade-color($gray-900, 10%)};\n  }\n  \n  //buttons\n  .btn-light {\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\n    --#{$prefix}btn-bg:                              var(--#{$prefix}light);\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}light);\n  }\n\n  .btn-outline-light {\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\n    --#{$prefix}btn-bg:                              transparent;\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}light);\n  }\n  \n  .btn-light, .btn-outline-light {\n    --#{$prefix}btn-hover-color:                     var(--#{$prefix}dark);\n    --#{$prefix}btn-hover-bg:                        rgba(var(--#{$prefix}light-rgb), 0.75);\n    --#{$prefix}btn-hover-border-color:              rgba(var(--#{$prefix}light-rgb), 0.75);\n  }\n\n  .btn-dark {\n    --#{$prefix}btn-color:                           var(--#{$prefix}light);\n    --#{$prefix}btn-bg:                              var(--#{$prefix}dark);\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}dark);\n  }\n\n  .btn-outline-dark {\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\n    --#{$prefix}btn-bg:                              transparent;\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}dark);\n  }\n\n  .btn-dark, .btn-outline-dark {\n    --#{$prefix}btn-hover-color:                     var(--#{$prefix}light);\n    --#{$prefix}btn-hover-bg:                        rgba(var(--#{$prefix}dark-rgb), 0.75);\n    --#{$prefix}btn-hover-border-color:              rgba(var(--#{$prefix}dark-rgb), 0.75);\n  }\n\n  // card\n  .card {\n    --#{$prefix}card-bg:                             #{$gray-200};\n    --#{$prefix}card-cap-bg:                         #{$gray-200};\n  }\n  \n  --#{$prefix}card-bg-custom:                        #{$gray-200};\n  --#{$prefix}card-logo-dark:                        none;\n  --#{$prefix}card-logo-light:                       block;\n  \n  // modal\n  .modal {\n    --#{$prefix}modal-bg:                            #{$gray-200};\n  }\n  \n  // nav tabs\n  .nav-tabs {\n    --#{$prefix}nav-tabs-link-active-color:          #{$gray-900};\n    --#{$prefix}nav-tabs-link-active-bg:             #{$gray-300};\n  }\n\n  // accordion\n  .accordion{\n    --#{$prefix}accordion-button-active-color:       #{$white};\n    --#{$prefix}accordion-bg:                        #{$gray-200};\n    --#{$prefix}accordion-btn-bg:                    #{$gray-200};\n  }\n  \n  //offcanvas\n  :is(.offcanvas, .offcanvas-lg, .offcanvas-md, .offcanvas-sm, .offcanvas-xl, .offcanvas-xxl) {\n    --#{$prefix}offcanvas-bg:                        #{$gray-200};\n      \n  }\n\n  // progress\n  .progress{\n    --#{$prefix}progress-bg:                         #{$gray-300};\n  }\n\n  //table\n  .table {\n    --vz-table-striped-bg:                          #{rgba($white, .03)};\n    --vz-table-active-bg:                          #{rgba($white, .07)};\n    --vz-table-hover-bg:                          #{rgba($white, .07)};\n  }\n\n  .table-light{\n    --vz-table-color:                                #{$white};\n    --vz-table-bg:                                   #{rgba($white, .05)};\n    --vz-table-border-color:                         #{$border-color};\n    --vz-table-striped-bg:                           #{rgba($white, .07)};\n    --vz-table-striped-color:                        #{$white};\n  }\n\n  // toast\n  .toast {\n    --#{$prefix}toast-bg:                            #{rgba($gray-300, .85)};\n    --#{$prefix}toast-header-bg:                     #{rgba($gray-300, .85)};\n    --#{$prefix}toast-border-color:                  #{rgba($white, .1)};\n    --#{$prefix}toast-header-border-color:           #{rgba($white, .05)};\n  }\n\n  //list\n  --#{$prefix}list-group-hover-bg:                   #{lighten($gray-200, 2.5%)};\n\n  // popover\n  .popover{\n    --#{$prefix}popover-bg:                          #{lighten($gray-200, 1%)};\n  }\n\n  // pagination\n  .pagination{\n    --#{$prefix}pagination-hover-bg:                   #{lighten($gray-200, 4%)};\n    --#{$prefix}pagination-focus-bg:                   #{lighten($gray-200, 4%)};\n  }\n\n  //form\n  --#{$prefix}input-bg:                              #{lighten($gray-200, 2%)};\n  --#{$prefix}input-border:                          #{$gray-300};\n  --#{$prefix}input-focus-border:                    #{lighten($gray-300, 4%)};\n  --#{$prefix}input-disabled-bg:                     #{$gray-200};\n\n  // input-group-addon\n  --#{$prefix}input-group-addon-bg:                  #{$gray-300};\n\n  //check\n  --#{$prefix}input-check-border:                    #{lighten($gray-300, 4%)};\n}\n\n//sidebar color\n[data-sidebar=\"gradient\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}primary), var(--#{$prefix}success));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}success);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}success);\n}\n\n[data-sidebar=\"gradient-2\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}secondary));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}secondary);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}secondary);\n}\n\n[data-sidebar=\"gradient-3\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}success));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}success);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}success);\n}\n\n[data-sidebar=\"gradient-4\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, #1a1d21, var(--#{$prefix}primary));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}primary);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}primary);\n}","//\n// _topbar.scss\n//\n\n#page-topbar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1000;\n    background-color: $header-bg;\n    transition: all 0.1s ease-out;\n    border: 1px solid $page-title-border;\n\n    &.topbar-shadow {\n        box-shadow: $box-shadow;\n    }\n\n    @media (min-width: 768px) {\n        left: $vertical-menu-width;\n    }\n}\n\n.navbar-header {\n    display: flex;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto;\n    height: $header-height;\n    padding: 0 $grid-gutter-width 0 calc(#{$grid-gutter-width} / 2)\n    /*rtl: 0 0 0 calc(#{$grid-gutter-width} / 2) */\n    ;\n\n    @media (max-width: 767.98px) {\n        padding: 0 calc(#{$grid-gutter-width} / 2) 0 calc(#{$grid-gutter-width} / 2);\n    }\n\n    .topbar-head-dropdown {\n        .dropdown-menu.show {\n            top: 13px !important;\n        }\n    }\n\n    .btn-topbar {\n        height: 42px;\n        width: 42px;\n\n        @media (max-width: 360px) {\n            height: 36px;\n            width: 36px;\n        }\n    }\n\n    .user-name-text {\n        color: var(--#{$prefix}gray-700);\n    }\n}\n\n/* Search */\n\n.app-search {\n    padding: calc(#{$header-height - 38px} / 2) 0;\n\n    .form-control {\n        border: none;\n        height: 38px;\n        padding-left: 40px;\n        padding-right: 30px;\n        background-color: $topbar-search-bg;\n        box-shadow: none;\n    }\n\n    span.search-widget-icon {\n        position: absolute;\n        z-index: 10;\n        font-size: 18px;\n        line-height: 38px;\n        left: 13px;\n        top: 0;\n        color: $gray-600;\n    }\n\n    .search-widget-icon-close {\n        right: 7px;\n        left: auto !important;\n    }\n\n    @media (max-width: 1023.99px) {\n        padding-left: calc(#{$grid-gutter-width} / 2);\n    }\n}\n\n// Mega menu\n\n.megamenu-list {\n    li {\n        position: relative;\n        padding: 5px 0px;\n\n        a {\n            color: $dropdown-color;\n        }\n    }\n}\n\n@media (max-width: 767.98px) {\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n\n        span.logo-sm {\n            display: inline-block;\n        }\n    }\n}\n\n.header-item {\n    height: $header-height;\n    display: flex;\n    align-items: center;\n}\n\n.header-profile-user {\n    height: 45px;\n    width: 45px;\n    margin-left: 10px;\n}\n\n.topbar-badge-sm {\n    right: 0;\n    top: 7px !important;\n}\n\n.topbar-badge {\n    right: -9px;\n    top: 4px !important;\n}\n\n.topbar-user {\n    @media (min-width: 768px) {\n        background-color: transparent\n    }\n\n    .dropdown-menu {\n        top: 6px !important;\n    }\n}\n\n.notification-item {\n    padding: 0.75rem 1rem;\n    white-space: inherit;\n    position: relative;\n\n    .form-check-input {\n        position: relative;\n        z-index: 2;\n    }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n    display: block;\n    border-radius: 3px;\n    line-height: 34px;\n    text-align: center;\n    padding: 15px 0 9px;\n    border: 1px solid transparent;\n    color: var(--#{$prefix}dropdown-link-color);\n\n    img {\n        height: 24px;\n    }\n\n    span {\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &:hover {\n        background-color: var(--#{$prefix}dropdown-link-hover-bg);\n    }\n}\n\n// Full Screen\n.fullscreen-enable {\n    [data-toggle=\"fullscreen\"] {\n        .bx-fullscreen::before {\n            content: \"\\eacb\";\n        }\n    }\n}\n\n// Dark mode enable\n[data-layout-mode=\"dark\"] {\n    .light-dark-mode {\n        .bx-moon::before {\n            content: \"\\ec34\";\n        }\n    }\n}\n\n[data-topbar=\"dark\"] {\n    #page-topbar {\n        background-color: $header-bg-dark;\n        border-color: $header-bg-dark;\n    }\n\n    .navbar-header {\n        .btn-topbar {\n            color: $header-item-color-dark;\n\n            &:hover,\n            &:focus {\n                background-color: rgba($white, 0.07);\n                color: $white;\n            }\n        }\n    }\n\n    .topbar-user {\n        @media (min-width: 767.99px) {\n            background-color: $topbar-user-bg-dark;\n        }\n\n        .user-name-text {\n            color: rgba($white, 0.85) !important;\n        }\n\n        .user-name-sub-text {\n            color: $header-item-color-dark !important;\n        }\n    }\n\n    .logo-dark {\n        display: none;\n    }\n\n    .logo-light {\n        display: inline-block;\n    }\n\n    .app-search {\n        .form-control {\n            background-color: rgba($white, 0.05);\n            color: $white;\n        }\n\n        span.search-widget-icon,\n        input.form-control::-webkit-input-placeholder {\n            color: rgba($white, 0.5);\n        }\n    }\n\n    .hamburger-icon {\n        span {\n            background-color: $gray-300;\n        }\n    }\n}\n\n@media (max-width: 600px) {\n    .navbar-header {\n        .dropdown {\n            position: static;\n\n            .dropdown-menu {\n                width: 100%;\n            }\n        }\n    }\n}\n\n@media (max-width: 767.98px){\n    #search-dropdown-reponsive{\n        top: 54px !important;\n    }\n}\n\n[data-layout=\"vertical\"] {\n    &[data-layout-style=\"detached\"] {\n        @media (min-width: 1024.1px) {\n            #page-topbar {\n                left: 0 !important;\n                box-shadow: $box-shadow;\n            }\n\n            .horizontal-logo {\n                display: inline-block;\n                padding-left: 0;\n            }\n\n            .topnav-hamburger {\n                visibility: hidden;\n            }\n\n            .layout-width {\n                max-width: 95%;\n                margin: 0 auto;\n            }\n\n            &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n                .navbar-brand-box {\n                    background-color: transparent !important;\n                    position: relative;\n                    width: auto;\n                    text-align: left;\n\n                    .logo-sm {\n                        display: none;\n                    }\n\n                    .logo-lg {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        &[data-topbar=\"dark\"] {\n            .horizontal-logo {\n                .logo-dark {\n                    display: none;\n                }\n\n                .logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    #page-topbar {\n        left: 0;\n        border-bottom: 1px solid var(--#{$prefix}gray-300);\n\n        @media (min-width: 1024.1px) {\n            &.topbar-shadow {\n                box-shadow: none;\n            }\n        }\n    }\n\n    .page-content {\n        @media (min-width: 1024.1px) {\n            margin-top: $header-height;\n        }\n\n        @media (max-width: 1024.1px) {\n            padding: calc(45px + #{$grid-gutter-width} * 1.8) calc(#{$grid-gutter-width} / 2) $footer-height calc(#{$grid-gutter-width} / 2);\n        }\n\n        padding: calc(45px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2) $footer-height calc(#{$grid-gutter-width} / 2);\n    }\n\n    &[data-layout-width=\"boxed\"] {\n        .page-content {\n            @media (min-width: 1024.1px) {\n                min-height: calc(100vh - #{$footer-height + $header-height});\n            }   \n        }\n    }\n}\n\n[data-layout=\"vertical\"] {\n\n    &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n        #page-topbar {\n            @media (min-width: 768px) {\n                left: $vertical-menu-width-sm;\n            }\n        }\n    }\n\n    &[data-sidebar-size=\"md\"] {\n        #page-topbar {\n            @media (min-width: 768px) {\n                left: $vertical-menu-width-md;\n            }\n        }\n    }\n}\n\n[data-layout=\"twocolumn\"] {\n    #page-topbar {\n        @media (min-width: 768px) {\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\n        }\n    }\n\n    .horizontal-logo {\n        display: none;\n    }\n}","// \n// _page-head.scss\n// \n\n.page-title-box {\n    padding: 10px $grid-gutter-width;\n    background-color: var(--#{$prefix}card-bg-custom);\n    box-shadow: $page-title-box-shadow;\n    border-bottom: 1px solid $page-title-border;\n    margin: -23px (-$grid-gutter-width * 1) $grid-gutter-width (-$grid-gutter-width * 1);\n\n    .breadcrumb {\n        background-color: transparent;\n        padding: 0;\n    }\n\n    h4 {\n        font-weight: 700;\n        font-size: 15px!important;\n        text-transform: uppercase;\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    .page-title-box {\n        padding: 1.2rem 0;\n        background-color: transparent !important;\n        border-bottom: none;\n        border-top: none;\n        box-shadow: none;\n        margin: 0;\n\n        @media (min-width: 1024.1px) {\n            margin: -19px 0 0 0;\n        }\n    }\n}\n\n[data-layout=\"vertical\"] {\n    &[data-layout-style=\"detached\"]{\n        .page-title-box {\n            padding: 1.2rem 0;\n            background-color: transparent !important;\n            border-bottom: none;\n            border-top: none;\n            box-shadow: none;\n            margin: 0;\n    \n            @media (min-width: 1024.1px) {\n                margin: -19px 0 0 0;\n            }\n        }\n    }\n}","// \n// _footer.scss\n// \n\n.footer {\n    bottom: 0;\n    padding: 20px calc(#{$grid-gutter-width} * 0.5);\n    position: absolute;\n    right: 0;\n    color: $footer-color;\n    left: $vertical-menu-width;\n    height: $footer-height;\n    background-color: $footer-bg;\n\n    @media (max-width: 991.98px) {\n        left: 0;\n    }\n}\n\n[data-layout=\"vertical\"] {\n\n    &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n        .footer {\n            left: $vertical-menu-width-sm;\n\n            @media (max-width: 767.98px) {\n                left: 0;\n            }\n        }\n    }\n    &[data-sidebar-size=\"md\"] {\n        .footer {\n            left: $vertical-menu-width-md;\n\n            @media (max-width: 991.98px) {\n                left: 0;\n            }\n        }\n    }\n\n}\n\n[data-layout=\"horizontal\"]{\n    .footer {\n        left: 0 !important;\n    } \n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] {\n\n    @media (min-width: 1024.1px) {\n        .footer {\n            left: 0 !important;\n            background-color: transparent;\n        } \n    }\n}\n\n[data-layout=\"twocolumn\"] { \n    .footer {\n        @media (min-width: 768.1px) {\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\n        }\n    }\n}","//\n// _vertical.scss\n//\n\n.app-content {\n margin-left: $vertical-menu-width;\n overflow: hidden;\n\n .content {\n  padding: 0 15px 10px 15px;\n  margin-top: $header-height;\n }\n}\n\n.main-content {\n transition: all 0.1s ease-out;\n\n @media (min-width: 768px) {\n  margin-left: $vertical-menu-width;\n }\n}\n\n.page-content {\n padding: #{$grid-gutter-width} calc(#{$grid-gutter-width}) $footer-height calc(#{$grid-gutter-width});\n}\n\n.navbar-menu {\n width: $vertical-menu-width;\n z-index: $vertical-menu-z-index;\n background: $vertical-menu-bg;\n border-right: 1px solid $vertical-menu-border;\n bottom: 0;\n margin-top: 0;\n position: fixed;\n top: 0;\n box-shadow: $vertical-menu-box-shadow;\n padding: 0 0 calc(#{$header-height} + 25px) 0;\n transition: all 0.1s ease-out;\n\n .navbar-nav {\n  .nav-link {\n   display: flex;\n   align-items: center;\n   padding: $vertical-menu-item-padding-y $vertical-menu-item-padding-x;\n   color: $vertical-menu-item-color;\n   font-size: $vertical-menu-item-font-size;\n   font-family: $vertical-menu-item-font-family;\n\n   &.active {\n    color: $vertical-menu-item-active-color;\n   }\n\n   &:hover {\n    color: $vertical-menu-item-hover-color;\n   }\n\n   i {\n    display: inline-block;\n    min-width: $vertical-menu-item-icon-width;\n    font-size: 18px;\n    line-height: inherit;\n   }\n\n   svg {\n    width: 18px;\n    margin-right: 0.665rem;\n    color: $vertical-menu-item-color;\n   }\n\n   .badge {\n    margin-left: auto;\n    margin-right: -2px;\n    z-index: 1;\n   }\n\n   &:hover {\n    color: $vertical-menu-item-hover-color;\n\n    .icon-dual {\n     color: $vertical-menu-item-hover-color;\n     fill: rgba($primary, 0.16);\n    }\n   }\n\n   &[data-bs-toggle=\"collapse\"] {\n    &:after {\n     display: block;\n     content: \"\\F0142\";\n     font-family: \"Material Design Icons\";\n     margin-left: auto;\n     transition: transform 0.2s;\n     font-size: 1.05rem;\n     position: absolute;\n     right: 18px;\n     color: $vertical-menu-title-color;\n    }\n\n    &[aria-expanded=\"true\"] {\n     color: $vertical-menu-item-active-color;\n\n     .icon-dual {\n      color: $vertical-menu-item-hover-color;\n      fill: rgba($primary, 0.16);\n     }\n\n     &:after {\n      transform: rotate(90deg);\n      color: $vertical-menu-item-active-color;\n     }\n\n     &:before {\n      opacity: 1;\n      background-color: $vertical-menu-item-active-color;\n     }\n    }\n   }\n\n   &.collapsed {\n    &.active {\n     &::after {\n      transform: rotate(90deg);\n     }\n    }\n   }\n  }\n\n  .nav-sm {\n   padding-left: $vertical-menu-item-icon-width;\n\n   .nav-link {\n    padding: $vertical-menu-sub-item-padding-y $vertical-menu-sub-item-padding-x !important;\n    color: $vertical-menu-sub-item-color;\n    white-space: none;\n    position: relative;\n    font-size: $vertical-menu-sub-item-font-size;\n    font-family: $vertical-menu-sub-item-font-family;\n\n    &:before {\n     content: \"\";\n     width: 6px;\n     height: 1.5px;\n     background-color: $vertical-menu-sub-item-color;\n     position: absolute;\n     left: 2px;\n     top: 16.5px;\n     transition: all 0.4s ease-in-out;\n     opacity: 0.5;\n    }\n\n    &:hover {\n     color: $vertical-menu-sub-item-hover-color;\n\n     &:before {\n      background-color: $vertical-menu-sub-item-hover-color !important;\n      opacity: 1;\n     }\n    }\n\n    &.active {\n     color: $vertical-menu-item-active-color;\n\n     &:before {\n      background-color: $vertical-menu-item-active-color;\n     }\n    }\n   }\n\n   .nav-sm {\n    padding-left: 15px;\n\n    .nav-link {\n     &:before {\n      height: 5px;\n      width: 5px;\n      left: 5px;\n      border-radius: 50%;\n      background-color: transparent;\n      border: 1px solid;\n      top: 16px;\n     }\n    }\n   }\n  }\n }\n\n .btn-vertical-sm-hover {\n  color: $text-muted;\n  display: none;\n }\n}\n\n.navbar-brand-box {\n padding: 0 1.3rem;\n text-align: center;\n transition: all 0.1s ease-out;\n\n @media (max-width: 767.98px) {\n  display: none;\n }\n}\n\n.hamburger-icon {\n width: 20px;\n height: 14px;\n position: relative;\n cursor: pointer;\n display: inline-block;\n\n span {\n  background-color: $text-muted;\n  position: absolute;\n  border-radius: 2px;\n  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  width: 100%;\n  height: 2px;\n  display: block;\n  left: 0px;\n\n  &:nth-child(1) {\n   top: 0;\n   width: 80%;\n  }\n\n  &:nth-child(2) {\n   top: 6px;\n  }\n\n  &:nth-child(3) {\n   bottom: 0;\n   width: 60%;\n  }\n }\n\n .vertical-menu-btn:hover &:not(.open) {\n  span {\n   &:nth-child(1) {\n    top: -1px;\n   }\n\n   &:nth-child(3) {\n    bottom: -1px;\n   }\n  }\n }\n\n &.open {\n  transform: rotate(-90deg);\n\n  span {\n   &:nth-child(1) {\n    left: 1px;\n    top: 5px;\n    width: 20px;\n    transform: rotate(90deg);\n    transition-delay: 150ms;\n   }\n\n   &:nth-child(2) {\n    left: 3px;\n    top: 13px;\n    width: 10px;\n    transform: rotate(45deg);\n    transition-delay: 50ms;\n   }\n\n   &:nth-child(3) {\n    left: 9px;\n    top: 13px;\n    width: 10px;\n    transform: rotate(-45deg);\n    transition-delay: 100ms;\n   }\n  }\n }\n}\n\n.logo {\n line-height: $header-height;\n\n .logo-sm {\n  display: none;\n }\n}\n\n.logo-light {\n display: none;\n}\n\n:is([data-layout=\"vertical\"], [data-layout=\"semibox\"]) {\n .app-menu {\n  .row {\n   margin: 0;\n\n   > * {\n    width: 100%;\n    padding: 0;\n   }\n  }\n\n  @media (max-width: 767.98px) {\n   margin-left: -100%;\n   padding: 10px 0 20px 0;\n  }\n }\n\n .navbar-menu {\n  .container-fluid {\n   padding: 0;\n  }\n }\n\n .navbar-brand-box {\n  @media (max-width: 767.98px) {\n   display: none;\n  }\n }\n\n .horizontal-logo {\n  display: none;\n }\n\n &[data-sidebar-size=\"sm-hover\"] {\n  .main-content {\n   margin-left: $vertical-menu-width-sm;\n\n   @media (max-width: 767.98px) {\n    margin-left: 0;\n   }\n  }\n\n  .logo {\n   span.logo-lg {\n    display: none;\n   }\n\n   span.logo-sm {\n    display: inline-block;\n   }\n  }\n\n  .btn-vertical-sm-hover {\n   display: inline-block;\n  }\n\n  @media (min-width: 768px) {\n   .topnav-hamburger {\n    display: none;\n   }\n  }\n\n  // Side menu\n  .navbar-menu {\n   width: $vertical-menu-width-sm;\n\n   .btn-vertical-sm-hover {\n    display: none;\n\n    i {\n     &.ri-record-circle-line:before {\n      content: \"\\EB7D\";\n     }\n    }\n   }\n\n   // Sidebar Menu\n   .navbar-nav {\n    .badge {\n     display: none;\n    }\n\n    .menu-title {\n     text-align: center;\n\n     span {\n      display: none;\n     }\n\n     i {\n      display: block;\n      line-height: 36px;\n      font-size: 1rem;\n     }\n    }\n\n    .nav-link {\n     span {\n      display: none;\n     }\n\n     i {\n      font-size: 22px;\n\n      &.las,\n      &.lar,\n      &.lab {\n       font-size: 24px;\n      }\n     }\n\n     svg {\n      margin-right: 0px;\n     }\n\n     &:after,\n     &:before {\n      display: none;\n     }\n    }\n\n    .menu-dropdown {\n     display: none;\n    }\n   }\n\n   &:hover {\n    width: $vertical-menu-width !important;\n\n    @media (min-width: 1024.99px) {\n     .btn-vertical-sm-hover {\n      display: inline-block;\n     }\n\n     .navbar-brand-box {\n      text-align: left;\n     }\n    }\n\n    .navbar-nav {\n     .menu-dropdown.show {\n      display: block;\n     }\n    }\n\n    .nav-link {\n     i {\n      font-size: 18px;\n\n      &.las,\n      &.lar,\n      &.lab {\n       font-size: 20px;\n      }\n     }\n\n     svg {\n      margin-right: 0.665rem;\n     }\n\n     span,\n     &:after,\n     &:before {\n      display: inline-block;\n     }\n    }\n\n    .logo {\n     span.logo-lg {\n      display: inline-block;\n     }\n\n     span.logo-sm {\n      display: none;\n     }\n    }\n\n    .menu-title {\n     text-align: left;\n\n     span {\n      display: inline-block;\n     }\n\n     i {\n      display: none;\n     }\n    }\n   }\n  }\n }\n\n &:is([data-sidebar-size=\"sm-hover\"], [data-sidebar-size=\"sm-hover-active\"]) {\n  .navbar-header {\n   @media (min-width: 1025px) {\n    padding-left: $grid-gutter-width;\n   }\n   padding-top: calc($grid-gutter-width*0.5);\n  }\n }\n\n &[data-sidebar-size=\"sm-hover-active\"] {\n  .navbar-brand-box {\n   text-align: left;\n  }\n\n  .topnav-hamburger {\n   display: none;\n  }\n\n  .btn-vertical-sm-hover {\n   display: inline-block;\n  }\n }\n\n &[data-sidebar-size=\"sm\"] {\n  @media (min-width: 768px) {\n   min-height: 1400px;\n\n   .main-content {\n    margin-left: $vertical-menu-width-sm;\n   }\n  }\n\n  #page-topbar {\n   /*  z-index: calc(#{$vertical-menu-z-index} + 1); */\n  }\n\n  .navbar-brand-box {\n   position: fixed;\n   padding: 0;\n   width: $vertical-menu-width-sm;\n   z-index: 1;\n   top: 0;\n   background: $vertical-menu-bg;\n  }\n\n  .logo {\n   span.logo-lg {\n    display: none;\n   }\n\n   span.logo-sm {\n    display: inline-block;\n   }\n  }\n\n  // Side menu\n  .navbar-menu {\n   position: absolute;\n   width: $vertical-menu-width-sm !important;\n   padding-top: $header-height;\n\n   .simplebar-mask,\n   .simplebar-content-wrapper {\n    overflow: visible !important;\n   }\n\n   .simplebar-scrollbar,\n   .vertical-menu-btn {\n    display: none !important;\n   }\n\n   .simplebar-offset {\n    bottom: 0 !important;\n   }\n\n   // Sidebar Menu\n   .navbar-nav {\n    .badge {\n     display: none !important;\n    }\n\n    .menu-title {\n     text-align: center;\n     font-size: 1rem;\n\n     span {\n      display: none;\n     }\n\n     i {\n      display: block;\n      line-height: 36px;\n     }\n    }\n\n    .nav-link {\n     span {\n      display: none;\n     }\n\n     i {\n      font-size: 22px;\n     }\n\n     svg {\n      margin-right: 0px;\n     }\n\n     &:after,\n     &:before {\n      display: none;\n     }\n    }\n\n    .menu-dropdown {\n     display: none;\n     height: auto !important;\n    }\n\n    .nav-item {\n     position: relative;\n\n     &:hover {\n      > a.menu-link {\n       position: relative;\n       width: calc(200px + #{$vertical-menu-width-sm});\n       color: $white;\n       background-color: $vertical-menu-bg-dark;\n       transition: none;\n\n       .icon-dual {\n        color: $vertical-menu-item-hover-color-dark;\n        fill: rgba($white, 0.16);\n       }\n\n       span {\n        display: inline-block;\n        padding-left: 25px;\n       }\n\n       &:after {\n        display: block;\n        transform: rotate(90deg);\n        color: $white;\n       }\n      }\n\n      .nav-link {\n       span {\n        display: inline-block;\n       }\n      }\n\n      > .menu-dropdown {\n       display: block;\n       left: $vertical-menu-width-sm;\n       position: absolute;\n       width: 200px;\n       background: $vertical-menu-bg;\n       height: auto !important;\n       padding: 0.5rem 0;\n       border-radius: 0 0 3px 3px;\n       box-shadow: $vertical-menu-dropdown-box-shadow;\n      }\n     }\n    }\n\n    .nav-sm {\n     padding: 0;\n\n     .nav-item {\n      &:hover {\n       > .nav-link {\n        color: $vertical-menu-item-hover-color;\n\n        &:after {\n         color: inherit;\n        }\n       }\n      }\n     }\n\n     .nav-link {\n      &:after {\n       display: block !important;\n       transform: rotate(0deg) !important;\n      }\n     }\n\n     .menu-dropdown {\n      left: 100% !important;\n      top: 0;\n      border-radius: 3px !important;\n     }\n    }\n   }\n  }\n }\n\n &[data-sidebar-size=\"md\"] {\n  @media (min-width: 768px) {\n   .main-content {\n    margin-left: $vertical-menu-width-md;\n   }\n  }\n\n  .navbar-brand-box {\n   width: $vertical-menu-width-md;\n  }\n\n  // Side menu\n  .navbar-menu {\n   width: $vertical-menu-width-md !important;\n\n   // Sidebar Menu\n   .navbar-nav {\n    .nav-link {\n     display: block;\n     text-align: center;\n     padding: $vertical-menu-sub-item-padding-y\n      $vertical-menu-sub-item-padding-x * 0.35;\n\n     i {\n      display: block;\n     }\n\n     svg {\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n     }\n\n     &:before {\n      display: none !important;\n     }\n\n     &[data-bs-toggle=\"collapse\"]:after {\n      position: relative;\n      display: inline-block;\n      right: 0;\n      top: 3px;\n     }\n\n     &.menu-link {\n      &[data-bs-toggle=\"collapse\"]:after {\n       display: none;\n      }\n     }\n    }\n\n    .badge {\n     display: none !important;\n    }\n\n    .nav-sm {\n     padding-left: 0;\n    }\n   }\n\n   .menu-title {\n    text-align: center;\n\n    span {\n     text-decoration: underline;\n    }\n   }\n  }\n }\n\n &[data-sidebar=\"dark\"] {\n  .navbar-menu {\n   background: $vertical-menu-bg-dark;\n   border-right: 1px solid $vertical-menu-border-dark;\n\n   .hamburger-icon {\n    span {\n     background-color: $vertical-menu-item-color-dark;\n    }\n   }\n\n   .btn-vertical-sm-hover {\n    color: $vertical-menu-item-color-dark;\n   }\n  }\n\n  .navbar-nav {\n   .nav-link {\n    color: $vertical-menu-item-color-dark;\n\n    &.active {\n     color: $vertical-menu-item-active-color-dark;\n    }\n\n    &[data-bs-toggle=\"collapse\"] {\n     &:after {\n      color: inherit;\n     }\n\n     &[aria-expanded=\"true\"] {\n      color: $vertical-menu-item-active-color-dark;\n\n      &:after {\n       color: inherit;\n      }\n\n      .icon-dual {\n       color: $vertical-menu-item-active-color-dark;\n       fill: rgba($white, 0.1);\n      }\n     }\n    }\n\n    svg {\n     color: $vertical-menu-item-color-dark;\n     fill: rgba($white, 0.1);\n    }\n\n    &:hover {\n     color: $vertical-menu-item-hover-color-dark;\n\n     .icon-dual {\n      color: $vertical-menu-item-hover-color-dark;\n      fill: rgba($white, 0.16);\n     }\n    }\n   }\n\n   > .nav-item {\n    .nav-link.active {\n     color: $vertical-menu-item-active-color-dark;\n\n     .icon-dual {\n      color: $vertical-menu-item-hover-color-dark;\n      fill: rgba($white, 0.16);\n     }\n    }\n   }\n\n   .nav-sm {\n    .nav-link {\n     color: $vertical-menu-sub-item-color-dark;\n\n     &:before {\n      background-color: $vertical-menu-sub-item-color-dark !important;\n     }\n\n     &:hover {\n      color: $vertical-menu-item-hover-color-dark;\n\n      &:before {\n       background-color: $vertical-menu-item-hover-color-dark !important;\n      }\n     }\n\n     &.active {\n      color: $vertical-menu-item-active-color-dark;\n     }\n    }\n\n    .nav-sm {\n     .nav-link {\n      &:before {\n       background-color: transparent !important;\n      }\n\n      &:hover {\n       &:before {\n        background-color: $vertical-menu-item-hover-color-dark !important;\n       }\n      }\n\n      &.active {\n       color: $vertical-menu-item-active-color-dark;\n\n       &:before {\n        background-color: $vertical-menu-item-active-color-dark !important;\n       }\n      }\n     }\n    }\n   }\n  }\n\n  &[data-sidebar-size=\"sm\"] {\n   .navbar-brand-box {\n    background: $vertical-menu-bg-dark;\n   }\n\n   // Side menu\n   .navbar-menu {\n    .navbar-nav {\n     .nav-item {\n      &:hover {\n       > .menu-dropdown {\n        background: $vertical-menu-bg-dark;\n       }\n      }\n     }\n\n     .nav-sm {\n      padding: 0;\n\n      .nav-link {\n       &:after {\n        display: block !important;\n        transform: rotate(0deg) !important;\n       }\n      }\n\n      .nav-item {\n       &:hover {\n        > .nav-link {\n         color: $vertical-menu-item-active-color-dark;\n\n         &:after {\n          color: inherit;\n         }\n        }\n       }\n      }\n\n      .menu-dropdown {\n       left: 100% !important;\n       top: 0;\n       border-radius: 3px !important;\n      }\n     }\n    }\n   }\n  }\n\n  .menu-title {\n   color: $vertical-menu-title-color-dark;\n  }\n\n  .logo-dark {\n   display: none;\n  }\n\n  .logo-light {\n   display: inline-block;\n  }\n }\n\n &[data-sidebar=\"light\"] {\n  .logo-dark {\n   display: inline-block;\n  }\n\n  .logo-light {\n   display: none;\n  }\n }\n\n &[data-layout-style=\"detached\"] {\n  #layout-wrapper,\n  .main-content {\n   min-height: 100vh;\n  }\n\n  @media (min-width: 1024.1px) {\n   .main-content {\n    position: relative;\n   }\n\n   #layout-wrapper {\n    max-width: 100%;\n    margin: 0 auto;\n    /* padding-left: $grid-gutter-width; */ /* templatletin default ayarını kaldırdım */\n   }\n\n   .navbar-header {\n    padding-left: $grid-gutter-width;\n   }\n\n   .navbar-menu {\n    // top: calc(#{$grid-gutter-width});\n    // bottom: $grid-gutter-width;\n    padding: 0;\n    border-right: $vertical-menu-bg;\n    border-radius:0 38px 38px 0;\n    padding: 10px 0;\n    z-index: 1;\n\n    .navbar-brand-box {\n     display: none;\n    }\n   }\n\n   &:is(\n     [data-sidebar=\"dark\"],\n     [data-sidebar=\"gradient\"],\n     [data-sidebar=\"gradient-2\"],\n     [data-sidebar=\"gradient-3\"],\n     [data-sidebar=\"gradient-4\"]\n    ) {\n    .logo-dark {\n     display: inline-block;\n    }\n\n    .logo-light {\n     display: none;\n    }\n   }\n  }\n\n  .footer {\n   border-top: 1px dashed $border-color;\n  }\n\n  .auth-page-wrapper {\n   .footer {\n    border-top: none;\n   }\n  }\n\n  &[data-sidebar-size=\"sm\"] {\n   @media (min-width: 768px) {\n    #layout-wrapper,\n    .main-content {\n     min-height: 1400px;\n    }\n   }\n  }\n }\n\n &:is(\n   [data-sidebar=\"gradient\"],\n   [data-sidebar=\"gradient-2\"],\n   [data-sidebar=\"gradient-3\"],\n   [data-sidebar=\"gradient-4\"]\n  ) {\n  .logo-dark {\n   display: none;\n  }\n\n  .logo-light {\n   display: inline-block;\n  }\n }\n}\n\n.menu-title {\n letter-spacing: 0.05em;\n cursor: default;\n font-size: 11px;\n text-transform: uppercase;\n color: $vertical-menu-title-color;\n font-weight: $font-weight-semibold;\n\n span {\n  padding: 12px 20px;\n  display: inline-block;\n }\n\n i {\n  display: none;\n }\n}\n\n.vertical-overlay {\n position: fixed;\n top: 0;\n left: 0;\n width: 100vw;\n height: 100vh;\n background-color: rgba($dark, 0.35);\n z-index: 1003;\n display: none;\n}\n\n// Mobile Menu\n.vertical-sidebar-enable {\n .vertical-overlay {\n  display: block;\n }\n\n .app-menu {\n  margin-left: 0 !important;\n  z-index: 1004;\n }\n}\n\n// rtl\n[dir=\"rtl\"] {\n .navbar-menu {\n  .navbar-nav {\n   .nav-link[data-bs-toggle=\"collapse\"] {\n    &:after {\n     transform: rotate(180deg);\n    }\n\n    &[aria-expanded=\"true\"]:after {\n     transform: rotate(270deg);\n    }\n   }\n  }\n }\n}\n\n//gradient sidebar\n:is(\n  [data-sidebar=\"gradient\"],\n  [data-sidebar=\"gradient-2\"],\n  [data-sidebar=\"gradient-3\"],\n  [data-sidebar=\"gradient-4\"]\n ) {\n .navbar-menu {\n  background: $vertical-menu-bg-gradient;\n  border-right: 1px solid $vertical-menu-border-gradient;\n\n  .hamburger-icon {\n   span {\n    background-color: $vertical-menu-item-color-gradient;\n   }\n  }\n\n  .btn-vertical-sm-hover {\n   color: $vertical-menu-item-color-gradient;\n  }\n }\n\n .navbar-nav {\n  .nav-link {\n   color: $vertical-menu-item-color-gradient;\n\n   &.active {\n    color: $vertical-menu-item-active-color-dark;\n   }\n\n   &[data-bs-toggle=\"collapse\"] {\n    &:after {\n     color: inherit;\n    }\n\n    &[aria-expanded=\"true\"] {\n     color: $vertical-menu-item-active-color-dark;\n\n     &:after {\n      color: inherit;\n     }\n\n     .icon-dual {\n      color: $vertical-menu-item-active-color-dark;\n      fill: rgba($white, 0.1);\n     }\n    }\n   }\n\n   svg {\n    color: $vertical-menu-item-color-gradient;\n    fill: rgba($white, 0.1);\n   }\n\n   &:hover {\n    color: $vertical-menu-item-hover-color-dark;\n\n    .icon-dual {\n     color: $vertical-menu-item-hover-color-dark;\n     fill: rgba($white, 0.16);\n    }\n   }\n  }\n\n  > .nav-item {\n   .nav-link.active {\n    color: $vertical-menu-item-active-color-dark;\n\n    .icon-dual {\n     color: $vertical-menu-item-hover-color-dark;\n     fill: rgba($white, 0.16);\n    }\n   }\n  }\n\n  .nav-sm {\n   .nav-link {\n    color: $vertical-menu-sub-item-color-gradient;\n\n    &:before {\n     background-color: $vertical-menu-sub-item-color-gradient !important;\n    }\n\n    &:hover {\n     color: $vertical-menu-item-hover-color-dark;\n\n     &:before {\n      background-color: $vertical-menu-item-hover-color-dark !important;\n     }\n    }\n\n    &.active {\n     color: $vertical-menu-item-active-color-dark;\n    }\n   }\n\n   .nav-sm {\n    .nav-link {\n     &:before {\n      background-color: transparent !important;\n     }\n\n     &:hover {\n      &:before {\n       background-color: $vertical-menu-item-hover-color-dark !important;\n      }\n     }\n\n     &.active {\n      color: $vertical-menu-item-active-color-dark;\n\n      &:before {\n       background-color: $vertical-menu-item-active-color-dark !important;\n      }\n     }\n    }\n   }\n  }\n }\n\n &[data-sidebar-size=\"sm\"] {\n  .navbar-brand-box {\n   background: $vertical-menu-bg-gradient;\n  }\n\n  // Side menu\n  .navbar-menu {\n   .navbar-nav {\n    .nav-item {\n     &:hover {\n      > .menu-dropdown {\n       background: $vertical-menu-bg-dark;\n      }\n     }\n    }\n\n    .nav-sm {\n     padding: 0;\n\n     .nav-link {\n      &:after {\n       display: block !important;\n       transform: rotate(0deg) !important;\n      }\n     }\n\n     .nav-item {\n      &:hover {\n       > .nav-link {\n        color: $vertical-menu-item-active-color-dark;\n\n        &:after {\n         color: inherit;\n        }\n       }\n      }\n     }\n\n     .menu-dropdown {\n      left: 100% !important;\n      top: 0;\n      border-radius: 3px !important;\n     }\n    }\n   }\n  }\n\n  &[data-layout=\"vertical\"] {\n   .navbar-menu {\n    .navbar-nav {\n     .nav-item {\n      &:hover {\n       > a.menu-link {\n        background: $vertical-menu-bg-gradient;\n       }\n      }\n     }\n    }\n   }\n  }\n }\n\n .menu-title {\n  color: $vertical-menu-title-color-gradient;\n }\n}\n\n.bg-vertical-gradient {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}primary),\n  var(--#{$prefix}success)\n );\n}\n\n.bg-vertical-gradient-2 {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}info),\n  var(--#{$prefix}secondary)\n );\n}\n\n.bg-vertical-gradient-3 {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}info),\n  var(--#{$prefix}success)\n );\n}\n\n.bg-vertical-gradient-4 {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}dark),\n  var(--#{$prefix}primary)\n );\n}\n\n//sidebar-images\n.sidebar-background {\n position: absolute;\n z-index: -1;\n height: 100%;\n width: 100%;\n display: block;\n top: 0;\n left: 0;\n background-size: cover;\n background-position: 50%;\n opacity: 0.07;\n}\n\n[data-sidebar-image=\"img-1\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-1.jpg\");\n }\n}\n\n[data-sidebar-image=\"img-2\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-2.jpg\");\n }\n}\n\n[data-sidebar-image=\"img-3\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-3.jpg\");\n }\n}\n\n[data-sidebar-image=\"img-4\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-4.jpg\");\n }\n}\n\n[data-layout=\"semibox\"] {\n .page-title-box {\n  padding: 10px 0;\n  background-color: transparent;\n  box-shadow: none;\n  margin: -15px 0 1.5rem 0;\n }\n\n @media (min-width: 768px) {\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"sm-hover\"] {\n   .main-content {\n    margin-left: $vertical-menu-width-sm;\n   }\n\n   #page-topbar {\n    left: $vertical-menu-width-sm;\n   }\n\n   .footer {\n    left: $vertical-menu-width-sm;\n   }\n  }\n\n  &[data-sidebar-size=\"md\"] {\n   #page-topbar {\n    left: $vertical-menu-width-md;\n   }\n\n   .footer {\n    left: $vertical-menu-width-md;\n   }\n  }\n }\n\n @media (min-width: 1440px) {\n  .page-content {\n   padding: calc(#{$header-height} + #{$grid-gutter-width} * 2)\n    calc(#{$grid-gutter-width} * 0.5) $footer-height\n    calc(#{$grid-gutter-width} * 0.5);\n  }\n\n  .navbar-menu {\n   margin: 25px;\n   border-radius: $border-radius;\n  }\n\n  .main-content {\n   margin-left: calc(#{$vertical-menu-width} + 25px);\n   padding: 0 $semibox-width;\n  }\n\n  .footer {\n   left: calc(\n    #{$vertical-menu-width} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n   );\n   right: calc(#{$semibox-width} + #{$grid-gutter-width});\n  }\n\n  #page-topbar {\n   left: calc(\n    #{$vertical-menu-width} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n   );\n   right: calc(#{$semibox-width} + #{$grid-gutter-width});\n   top: 25px;\n   border-radius: $border-radius;\n   transition: all 0.5s ease;\n\n   &.topbar-shadow {\n    top: 0px;\n   }\n  }\n\n  &[data-sidebar-size=\"md\"] {\n   .main-content {\n    margin-left: calc(#{$vertical-menu-width-md} + 25px);\n   }\n\n   #page-topbar {\n    left: calc(\n     #{$vertical-menu-width-md} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n\n   .footer {\n    left: calc(\n     #{$vertical-menu-width-md} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n  }\n\n  &[data-sidebar-size=\"sm\"] {\n   .main-content {\n    margin-left: calc(#{$vertical-menu-width-sm} + 25px);\n   }\n\n   .navbar-brand-box {\n    top: 25px;\n   }\n\n   #page-topbar {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n\n   .footer {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n  }\n\n  &[data-sidebar-size=\"sm-hover\"] {\n   .main-content {\n    margin-left: calc(#{$vertical-menu-width-sm} + 25px);\n   }\n\n   #page-topbar {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n\n   .footer {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n  }\n }\n\n .mx-n4 {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n\n  &.p-1 {\n   padding-left: 0px !important;\n   padding-right: 0px !important;\n  }\n }\n}\n","//\n// _horizontal.scss\n// \n\n[data-layout=\"horizontal\"] {\n\n    .main-content {\n        margin-left: 0;\n    }\n\n    @media (min-width: 1024.1px) {\n\n        .layout-width,\n        .container-fluid {\n            max-width: 90%;\n            margin: 0 auto;\n        }\n\n        .topnav-hamburger {\n            visibility: hidden;\n        }\n    }\n\n    .horizontal-logo {\n        padding-left: calc(#{$grid-gutter-width} / 2);\n\n        @media (max-width: 1024.98px) {\n            padding-left: $grid-gutter-width;\n        }\n    }\n\n    .navbar-menu {\n        background: $topnav-bg;\n        border-right-color: transparent;\n        padding: 0 calc(#{$grid-gutter-width} / 2);\n        box-shadow: $horizontal-menu-box-shadow;\n        margin-top: $header-height;\n        position: fixed;\n        left: 0;\n        right: 0;\n        z-index: 100;\n        width: 100%;\n        bottom: auto;\n\n        @media (max-width:575.98px) {\n            .container-fluid {\n                padding: 0;\n            }\n        }\n\n        .navbar-nav {\n            flex-direction: row;\n\n            .nav-sm {\n                padding-left: 0;\n\n                .nav-link {\n                    &:before {\n                        opacity: 0 !important;\n                    }\n\n                    &:hover,\n                    &.active {\n                        color: $topnav-item-color-active;\n                    }\n                }\n            }\n\n            .nav-link {\n                color: $topnav-item-color;\n                padding: $horizontal-menu-item-padding-y $horizontal-menu-item-padding-x;\n\n                i {\n                    line-height: 1;\n                }\n\n                &.active {\n                    color: $topnav-item-color-active;\n                    &:after {\n                        color: $topnav-item-color-active;\n                    }\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n                }\n\n                &[data-bs-toggle=collapse][aria-expanded=true] {\n                    color: $topnav-item-color-active;\n\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n\n                    &:after {\n                        color: $topnav-item-color-active;\n                    }\n                }\n\n                &:hover {\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n                }\n            }\n\n            >.nav-item {\n                >.nav-link[data-bs-toggle=collapse]:after {\n                    right: 0px;\n                    transform: rotate(90deg) !important;\n                }\n            }\n\n            >li:nth-of-type(2) {\n                >.nav-link.menu-link {\n                    padding-left: 0;\n                }\n            }\n        }\n\n        .navbar-brand-box {\n            display: none;\n        }\n    }\n\n    .navbar-nav {\n        .nav-item {\n            position: relative;\n\n            .nav-link[data-bs-toggle=collapse]:after {\n                right: 10px;\n                transform: rotate(0deg) !important;\n            }\n\n            >.nav-link {\n                >.badge {\n                    display: none;\n                }\n            }\n\n            &:hover {\n                >.nav-link {\n                    color: $topnav-item-color-active;\n\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n\n                    &:after {\n                        color: $topnav-item-color-active;\n                    }\n                }\n\n                @media (min-width: 1024.1px) {\n                    >.menu-dropdown {\n                        display: block;\n                        height: auto !important;\n                    }\n                }\n            }\n\n            &.active {\n                color: $topnav-item-color-active;\n            }\n        }\n    }\n\n    .menu-dropdown {\n        position: absolute;\n        min-width: $horizontal-menu-dropdown-min-width;\n        padding: $dropdown-padding-y $dropdown-padding-x;\n        box-shadow: $horizontal-menu-dropdown-box-shadow;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n        margin: 0;\n        z-index: $zindex-dropdown;\n        background-color: var(--#{$prefix}choices-bg);\n        background-clip: padding-box;\n        border: $dropdown-border-width solid $dropdown-border-color;\n        border-radius: $dropdown-border-radius;\n        display: none;\n\n        .menu-dropdown {\n            top: 0;\n            left: 100%;\n        }\n    }\n\n    .mega-dropdown-menu {\n        width: 40rem;\n    }\n\n    .menu-title {\n        display: none;\n    }\n\n    .dropdown-custom-right {\n        left: -100% !important;\n        right: 100%;\n    }\n\n    @media (max-width: 1024px) {\n        .navbar-menu {\n            display: none;\n        }\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    .menu {\n        @media (max-width: 1024px) {\n            .navbar-menu {\n                display: block;\n                max-height: 360px;\n                overflow-y: auto;\n                padding-left: 0;\n\n                .navbar-nav {\n                    flex-direction: column;\n\n                    >li:nth-of-type(2)>.nav-link.menu-link {\n                        padding-left: $vertical-menu-item-padding-x;\n                    }\n\n                    .nav-sm .nav-link:before {\n                        opacity: 1 !important;\n                    }\n                }\n            }\n\n            .menu-dropdown {\n                position: relative;\n                min-width: 100%;\n                box-shadow: none;\n                padding-left: 28px;\n                left: 0;\n                animation: none;\n                padding-top: 0;\n\n                &.show {\n                    display: block;\n                }\n            }\n\n            .dropdown-custom-right {\n                left: 0 !important;\n            }\n\n            .nav-item .nav-link[data-bs-toggle=collapse]:after {\n                right: 0px;\n            }\n\n            .mega-dropdown-menu {\n                width: 100%;\n            }\n        }\n    }\n}\n\n// theme dark\n[data-layout-mode=\"dark\"] {\n    &[data-topbar=\"light\"] {\n        .navbar-header {\n            .horizontal-logo {\n                .logo-dark {\n                    display: none;\n                }\n\n                .logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n// rtl\n[dir=\"rtl\"]{\n    &[data-layout=horizontal] {\n        .navbar-menu {\n            .navbar-nav>.nav-item>.nav-link[data-bs-toggle=collapse]{\n                &:after{\n                    transform: rotate(-90deg) !important;\n                }\n            }\n        }\n\n        .navbar-nav{\n            .nav-item {\n                .nav-link[data-bs-toggle=collapse]{\n                    &:after{\n                        transform: rotate(-180deg)!important;\n                    }\n                }\n            }\n        }\n    }\n}","//\n// _two-column.scss\n// \n\n[data-layout=\"twocolumn\"] {\n    .app-menu {\n        padding-bottom: 0;\n        width: $twocolumn-menu-width;\n        left: $twocolumn-menu-iconview-width;\n\n        .menu-link {\n            letter-spacing: .05em;\n            cursor: default;\n            font-size: 11px;\n            text-transform: uppercase;\n            color: $vertical-menu-title-color !important;\n            font-weight: $font-weight-semibold;\n\n            &:after {\n                display: none !important;\n            }\n\n            i {\n                display: none;\n            }\n        }\n\n        .navbar-nav {\n            height: calc(100vh - #{$header-height});\n\n            @media (max-width: 767.98px) {\n                padding-top: 16px;\n            }\n\n            >li:not(.twocolumn-item-show) {\n                display: none;\n            }\n\n            .twocolumn-item-show {\n                >div {\n                    display: block !important;\n                    height: auto !important;\n                }\n            }\n\n            >.nav-item {\n                >.menu-dropdown {\n                    display: block !important;\n                    height: auto !important;\n                }\n            }\n\n            .nav-item {\n                .menu-dropdown {\n                    .row {\n                        margin: 0;\n\n                        .col-lg-4 {\n                            width: 100%;\n                            padding: 0;\n                        }\n                    }\n                }\n            }\n\n            .nav-sm {\n                .nav-link {\n                    color: $vertical-menu-item-color;\n\n                    &.active {\n                        color: $vertical-menu-item-active-color;\n                    }\n                }\n            }\n        }\n\n        .container-fluid {\n            padding: 0;\n        }\n    }\n\n    .main-content {\n        margin-left: calc(#{$twocolumn-menu-width} + #{$twocolumn-menu-iconview-width});\n\n        @media (max-width:767.98px) {\n            margin-left: $twocolumn-menu-iconview-width;\n        }\n    }\n\n    .twocolumn-iconview {\n        width: $twocolumn-menu-iconview-width;\n        background-color: $twocolumn-menu-iconview-bg;\n        height: 100%;\n        left: -$twocolumn-menu-iconview-width;\n        box-shadow: $twocolumn-menu-box-shadow;\n        top: 0;\n        position: absolute;\n        padding: 0;\n        text-align: center;\n\n        li {\n            position: relative;\n            list-style: none;\n\n            .nav-icon {\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    left: 0;\n                }\n            }\n        }\n\n        .nav-icon {\n            width: 42px;\n            height: 42px;\n            line-height: 42px;\n            color: $vertical-menu-item-color;\n            z-index: 1;\n            font-size: 22px;\n            text-align: center;\n            border-radius: 3px;\n            margin: 5px 0;\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n\n            .icon-dual {\n                width: 18px;\n                color: $vertical-menu-item-color;\n            }\n\n            &.active {\n                background-color: rgba($primary, 0.15);\n                color: $primary;\n\n                .icon-dual {\n                    color: $primary;\n                    fill: rgba($primary, 0.10);\n                }\n            }\n        }\n    }\n\n    .menu-title {\n        display: none;\n    }\n\n    @media (max-width: 991.98px) {\n        .logo {\n\n            span.logo-lg {\n                display: block;\n            }\n\n            span.logo-sm {\n                display: none;\n            }\n        }\n    }\n\n    &[data-sidebar=\"light\"] {\n        .app-menu {\n            .navbar-brand-box {\n                .logo-light {\n                    display: none;\n                }\n\n                .logo-dark {\n                    display: block;\n                }\n            }\n        }\n    }\n\n    &[data-sidebar=\"dark\"] {\n        .twocolumn-iconview {\n            background-color: $twocolumn-menu-iconview-bg-dark;\n\n            .nav-icon {\n                color: $twocolumn-menu-item-color-dark;\n\n                &.active {\n                    color: $twocolumn-menu-item-active-color-dark;\n                    background-color: $twocolumn-menu-item-active-bg-dark;\n                }\n            }\n        }\n\n        .app-menu {\n            background-color: $twocolumn-menu-bg-dark;\n            border-right-color: $twocolumn-menu-border-dark;\n\n            .navbar-brand-box {\n                .logo-light {\n                    display: block;\n                }\n\n                .logo-dark {\n                    display: none;\n                }\n            }\n\n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n                        color: $twocolumn-menu-item-color-dark;\n                    }\n                }\n            }\n        }\n\n        .navbar-menu {\n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n\n                        &:hover,\n                        &.active {\n                            color: $twocolumn-menu-item-active-color-dark;\n\n                            &::before {\n                                background-color: $twocolumn-menu-item-active-color-dark !important;\n                            }\n                        }\n                    }\n                }\n\n                .nav-link {\n                    &[data-bs-toggle=collapse][aria-expanded=true] {\n                        color: $twocolumn-menu-item-active-color-dark;\n\n                        &:before {\n                            background-color: $twocolumn-menu-item-active-color-dark;\n                        }\n\n                        &::after {\n                            color: $twocolumn-menu-item-active-color-dark !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    &:is([data-sidebar=\"gradient\"], [data-sidebar=\"gradient-2\"], [data-sidebar=\"gradient-3\"], [data-sidebar=\"gradient-4\"]) {\n        .twocolumn-iconview {\n            background-color: $twocolumn-menu-iconview-bg-dark;\n    \n            .nav-icon {\n                color: $twocolumn-menu-item-color-gradient;\n    \n                &.active {\n                    color: $twocolumn-menu-item-active-color-dark;\n                    background-color: $twocolumn-menu-item-active-bg-dark;\n                }\n            }\n        }\n    \n        .app-menu {\n            background-color: $twocolumn-menu-bg-dark;\n            border-right-color: $twocolumn-menu-border-dark;\n    \n            .navbar-brand-box {\n                .logo-light {\n                    display: block;\n                }\n    \n                .logo-dark {\n                    display: none;\n                }\n            }\n    \n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n                        color: $twocolumn-menu-item-color-gradient;\n                    }\n                }\n            }\n        }\n    \n        .navbar-menu {\n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n    \n                        &:hover,\n                        &.active {\n                            color: $twocolumn-menu-item-active-color-dark;\n    \n                            &::before {\n                                background-color: $twocolumn-menu-item-active-color-dark !important;\n                            }\n                        }\n                    }\n                }\n    \n                .nav-link {\n                    &[data-bs-toggle=collapse][aria-expanded=true] {\n                        color: $twocolumn-menu-item-active-color-dark;\n    \n                        &:before {\n                            background-color: $twocolumn-menu-item-active-color-dark;\n                        }\n    \n                        &::after {\n                            color: $twocolumn-menu-item-active-color-dark !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &[data-layout-mode=\"dark\"] {\n            .app-menu {\n                border-right-color: $gray-700; \n            }\n        }\n    }\n\n    .twocolumn-panel {\n        .app-menu {\n            width: 0;\n            border-right: 0;\n\n            @media (max-width: 575.98px) {\n                display: none;\n            }\n        }\n\n        .navbar-brand-box,\n        .navbar-nav {\n            display: none;\n        }\n\n        .main-content {\n            margin-left: $twocolumn-menu-iconview-width;\n        }\n\n        #page-topbar,\n        .footer {\n            left: $twocolumn-menu-iconview-width;\n        }\n\n        @media (max-width: 575.98px) {\n            .main-content {\n                margin-left: 0;\n            }\n\n            #page-topbar,\n            .footer {\n                left: 0;\n            }\n        }\n\n    }\n\n    #page-topbar,\n    .footer {\n        @media (max-width: 767.98px) {\n            left: $twocolumn-menu-iconview-width;\n        }\n    }\n\n    @media (max-width: 575.98px) {\n        .main-content {\n            margin-left: 0;\n        }\n\n        #page-topbar,\n        .footer {\n            left: 0;\n        }\n    }\n}","//\n// _layouts.scss\n//\n\n[data-layout-width=\"boxed\"] {\n body {\n  background-color: $boxed-body-bg;\n }\n\n #layout-wrapper {\n  max-width: $boxed-layout-width;\n  margin: 0 auto;\n  box-shadow: $box-shadow;\n  background-color: var(--#{$prefix}body-bg);\n }\n\n &[data-layout=\"vertical\"] {\n  #layout-wrapper {\n   min-height: 100vh;\n  }\n }\n\n #page-topbar,\n .footer {\n  max-width: $boxed-layout-width;\n  margin: 0 auto;\n  left: 0 !important;\n }\n\n &[data-sidebar-size=\"sm-hover\"],\n &[data-sidebar-size=\"sm\"] {\n  &[data-layout=\"vertical\"] {\n   @media (min-width: 768px) {\n    #layout-wrapper {\n     min-height: 1400px;\n    }\n   }\n\n   .main-content {\n    @media (max-width: 767.98px) {\n     margin-left: 0;\n    }\n   }\n  }\n\n  #page-topbar,\n  .footer {\n   left: 0 !important;\n   max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-sm});\n\n   @media (min-width: 768px) {\n    left: $vertical-menu-width-sm !important;\n   }\n  }\n }\n\n &[data-sidebar-size=\"sm-hover-active\"],\n &[data-sidebar-size=\"lg\"] {\n  #page-topbar,\n  .footer {\n   max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width});\n\n   @media (min-width: 768px) {\n    left: $vertical-menu-width !important;\n   }\n  }\n }\n\n &[data-sidebar-size=\"md\"] {\n  #page-topbar,\n  .footer {\n   max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-md});\n\n   @media (min-width: 768px) {\n    left: $vertical-menu-width-md !important;\n   }\n  }\n }\n\n // deteched\n\n &[data-layout=\"vertical\"][data-layout-style=\"detached\"] {\n  body {\n   background-color: var(--#{$prefix}body-bg);\n  }\n\n  @media (min-width: 1024.1px) {\n   #layout-wrapper {\n    max-width: 1300px;\n    box-shadow: none;\n   }\n\n   .layout-width {\n    max-width: 1300px;\n   }\n  }\n\n  &[data-sidebar-size=\"sm-hover\"],\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"md\"],\n  &[data-sidebar-size=\"lg\"] {\n   #page-topbar,\n   .footer {\n    max-width: 100%;\n    left: 0 !important;\n   }\n  }\n }\n}\n\n// Horizontal Boxed Layout\n\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] {\n #page-topbar,\n #layout-wrapper,\n .footer {\n  max-width: 100%;\n }\n\n .container-fluid,\n .navbar-header {\n  max-width: $boxed-layout-width;\n }\n\n .navbar-header {\n  padding: 0 calc(#{$grid-gutter-width} / 2) 0 0;\n }\n\n &[data-sidebar-size=\"sm-hover\"],\n &[data-sidebar-size=\"sm\"] &[data-sidebar-size=\"sm-hover-active\"],\n &[data-sidebar-size=\"lg\"] {\n  #page-topbar,\n  .footer {\n   left: 0 !important;\n  }\n }\n}\n\n// Scrollable layout\n\n[data-layout-position=\"scrollable\"] {\n @media (min-width: 992px) {\n  #page-topbar,\n  .navbar-menu {\n   position: absolute;\n  }\n }\n\n &[data-layout=\"horizontal\"] {\n  @media (min-width: 992px) {\n   #page-topbar,\n   .topnav {\n    position: absolute;\n   }\n  }\n }\n}\n\n//Semibox Sidebar Action\n\n[data-layout=\"semibox\"][data-sidebar-visibility=\"hidden\"] {\n @media (min-width: 768px) {\n  .navbar-menu {\n   display: none;\n  }\n\n  .horizontal-logo {\n   display: inline-block;\n   width: auto;\n  }\n\n  .footer {\n   left: 0;\n  }\n\n  #page-topbar {\n   left: 0;\n  }\n\n  .main-content {\n   margin-left: 0px;\n  }\n\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"sm-hover\"] {\n   .navbar-brand-box {\n    position: static;\n    padding: 0 1.3rem;\n   }\n\n   .logo {\n    span.logo-lg {\n     display: inline-block;\n    }\n\n    span.logo-sm {\n     display: none;\n    }\n   }\n  }\n }\n\n &:is(\n   [data-sidebar=\"dark\"],\n   [data-sidebar=\"gradient\"],\n   [data-sidebar=\"gradient-2\"],\n   [data-sidebar=\"gradient-3\"],\n   [data-sidebar=\"gradient-4\"]\n  ) {\n  .logo-dark {\n   display: inline-block;\n  }\n\n  .logo-light {\n   display: none;\n  }\n }\n\n &[data-topbar=\"dark\"]:is(\n   [data-sidebar=\"dark\"],\n   [data-sidebar=\"light\"],\n   [data-sidebar=\"gradient\"],\n   [data-sidebar=\"gradient-2\"],\n   [data-sidebar=\"gradient-3\"],\n   [data-sidebar=\"gradient-4\"]\n  ) {\n  .logo-dark {\n   display: none;\n  }\n\n  .logo-light {\n   display: block;\n  }\n }\n\n @media (min-width: 1440px) {\n  .navbar-menu {\n   display: none;\n  }\n\n  .horizontal-logo {\n   display: inline-block;\n   width: auto;\n  }\n\n  .footer {\n   left: calc(#{$semibox-width} + #{$grid-gutter-width});\n  }\n\n  #page-topbar {\n   left: calc(#{$semibox-width} + #{$grid-gutter-width});\n  }\n\n  .main-content {\n   margin-left: 0px;\n  }\n\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"sm-hover\"] {\n   .navbar-brand-box {\n    position: static;\n    padding: 0 1.3rem;\n   }\n\n   .logo {\n    span.logo-lg {\n     display: inline-block;\n    }\n\n    span.logo-sm {\n     display: none;\n    }\n   }\n  }\n }\n}\n","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}","//\n// avatar.scss\n//\n\n.avatar-xxs {\n    height: 1.5rem;\n    width: 1.5rem;\n}\n\n.avatar-xs {\n    height: 2rem;\n    width: 2rem;\n}\n\n.avatar-sm {\n    height: 3rem;\n    width: 3rem;\n}\n\n.avatar-md {\n    height: 4.5rem;\n    width: 4.5rem;\n}\n\n.avatar-lg {\n    height: 6rem;\n    width: 6rem;\n}\n\n.avatar-xl {\n    height: 7.5rem;\n    width: 7.5rem;\n}\n\n.avatar-title {\n    align-items: center;\n    background-color: $primary;\n    color: $white;\n    display: flex;\n    font-weight: $font-weight-medium;\n    height: 100%;\n    justify-content: center;\n    width: 100%;\n}\n\n// avatar group\n.avatar-group {\n    padding-left: 12px;\n    display: flex;\n    flex-wrap: wrap;\n\n    .avatar-group-item {\n        margin-left: -12px;\n        border: 2px solid var(--#{$prefix}card-bg-custom);\n        border-radius: 50%;\n        transition: all 0.2s;\n\n        &:hover {\n            position: relative;\n            transform: translateY(-2px);\n            z-index: 1;\n        }\n    }\n}","//\n// accordion.scss\n//\n\n.accordion {\n    .accordion-button {\n        font-weight: $font-weight-medium;\n    }\n\n    .accordion-body {\n        color: $text-muted;\n    }\n\n    &.accordion-icon-none {\n        .accordion-button {\n            &::after {\n                content: \"\";\n                background-image: none !important;\n            }\n\n            &:not(.collapsed) {\n                &::after {\n                    content: \"\";\n                }\n            }\n        }\n    }\n}\n\n// Accordion with icon\n\n.custom-accordionwithicon {\n    .accordion-button {\n        &::after {\n            background-image: none !important;\n            font-family: \"Material Design Icons\";\n            content: \"\\F0142\";\n            font-size: 1.1rem;\n            vertical-align: middle;\n            line-height: 0.8;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                background-image: none !important;\n                content: \"\\F0140\";\n                margin-right: -3px;\n            }\n        }\n    }\n}\n\n// Accordion with plus icon\n\n.custom-accordionwithicon-plus {\n    .accordion-button {\n        &::after {\n            background-image: none !important;\n            font-family: \"Material Design Icons\";\n            content: \"\\F0415\";\n            font-size: 1.1rem;\n            vertical-align: middle;\n            line-height: 0.8;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                background-image: none !important;\n                content: \"\\F0374\";\n                margin-right: -3px;\n            }\n        }\n    }\n}\n\n\n// left Icon accordion\n\n.lefticon-accordion {\n    .accordion-button {\n        padding-left: 2.75rem;\n\n        &::after {\n            position: absolute;\n            left: $accordion-button-padding-x;\n            top: 14px;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                top: 20px;\n            }\n        }\n    }\n}\n\n// border accordion\n\n.accordion-border-box {\n    .accordion-item {\n        border-top: $accordion-border-width solid $accordion-border-color;\n        border-radius: $accordion-border-radius;\n\n        &:not(:first-of-type) {\n            margin-top: 8px;\n        }\n\n        .accordion-button {\n            border-radius: $accordion-border-radius;\n\n            &:not(.collapsed) {\n                border-bottom-left-radius: 0;\n                border-bottom-right-radius: 0;\n            }\n        }\n    }\n}\n\n.custom-accordion-border {\n    .accordion-item {\n        border-left: 3px solid $accordion-border-color;\n    }\n}\n\n//accordion Color \n\n@each $color,\n$value in $theme-colors {\n    .accordion-#{$color} {\n        .accordion-item {\n            border-color: rgba($value, 0.6);\n\n            .accordion-button {\n                box-shadow: none;\n\n                &:not(.collapsed) {\n                    color: $value;\n                    background-color: rgba($value, 0.1) !important;\n                }\n\n                &::after {\n                    color: $value;\n                }\n            }\n        }\n    }\n\n    .accordion-fill-#{$color} {\n        .accordion-item {\n            .accordion-button {\n                box-shadow: none;\n\n                &:not(.collapsed) {\n                    color: $white;\n                    background-color: $value !important;\n                }\n            }\n        }\n    }\n}\n\n\n// theme dark\n\n[data-layout-mode=\"dark\"]{\n    .accordion-button {\n        &:not(.collapsed) {\n            color: var(--#{$prefix}accordion-button-active-color);\n            &:after{\n                background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$white}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\n            }\n        }\n\n        &:after{\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$gray-500}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\n        }\n    }\n}\n\n// rtl\n[dir=\"rtl\"]{\n    .custom-accordionwithicon {\n        .accordion-button::after{\n            transform: rotate(180deg);\n        }\n    }\n}","//\n// _helper.scss\n//\n\n$font-size-mixing: 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 36, 48;\n\n@each $font-size-mixing in $font-size-mixing {\n  .fs-#{$font-size-mixing} {\n    font-size: #{$font-size-mixing}px !important;\n  }\n}\n\n// border-color\n.border-dark {\n    border-color: var(--#{$prefix}dark)!important;\n}\n.border-light {\n    border-color: var(--#{$prefix}light)!important;\n}\n\n// Border Style\n$border-style-mixing: double, dashed, groove, outset, ridge, dotted, inset;\n@each $border-style-mixing in $border-style-mixing {\n    .border-#{$border-style-mixing} {\n        border-style: #{$border-style-mixing} !important;\n    }\n    .border-top-#{$border-style-mixing} {\n        border-top-style: #{$border-style-mixing} !important;\n    }\n    .border-bottom-#{$border-style-mixing} {\n        border-bottom-style: #{$border-style-mixing} !important;\n    }\n    .border-end-#{$border-style-mixing} {\n        border-right-style: #{$border-style-mixing} !important;\n    }\n    .border-start-#{$border-style-mixing} {\n        border-left-style: #{$border-style-mixing} !important;\n    }\n    \n    // List Group Flush Style\n    .list-group-flush {\n        &.border-#{$border-style-mixing} { \n            border: none !important;\n            .list-group-item {\n                border-style: #{$border-style-mixing} !important;\n            }\n        }\n    }\n}\n\n//link\n[data-layout-mode=\"dark\"]{\n    .link-dark, .link-light{\n        color: var(--#{$prefix}dark) !important;\n        &:is(:focus, :hover){\n            color: rgba(var(--#{$prefix}dark-rgb), 0.75) !important;\n        }\n    }\n}\n\n\n// Font Family\n\n.ff-base {\n    font-family: $font-family-base;\n}\n\n.ff-secondary {\n    font-family: $font-family-secondary;\n}\n\n// Font weight help class\n\n.fw-medium {\n    font-weight: $font-weight-medium;\n}\n\n// Flex\n\n.flex-1 {\n    flex: 1;\n}\n\n// Social\n\n.social-list-item {\n    height: 2rem;\n    width: 2rem;\n    line-height: calc(2rem - 4px);\n    display: block;\n    border: 2px solid $gray-500;\n    border-radius: 50%;\n    color: $gray-500;\n    text-align: center;\n    transition: all 0.4s;\n\n    &:hover {\n        color: $gray-600;\n        background-color: $gray-200;\n    }\n}\n\n\n// Backgroun pattern\n.bg-pattern {\n    background: url(\"../../images/modal-bg.png\") $modal-content-bg;\n}\n\n// Fixed minimum width\n.w-xs {\n    min-width: 80px;\n}\n\n.w-sm {\n    min-width: 95px;\n}\n\n.w-md {\n    min-width: 110px;\n}\n\n.w-lg {\n    min-width: 140px;\n}\n\n.w-xl {\n    min-width: 160px;\n}\n\n// Icons Sizes\n.icon-xs {\n    height: 16px;\n    width: 16px;\n}\n\n.icon-sm {\n    height: 18px;\n    width: 18px;\n}\n\n.icon-md {\n    height: 22px;\n    width: 22px;\n}\n\n.icon-lg {\n    height: 24px;\n    width: 24px;\n}\n\n.icon-xl {\n    height: 28px;\n    width: 28px;\n}\n\n.icon-xxl {\n    height: 32px;\n    width: 32px;\n}\n\n// Dual Icons\n.icon-dual {\n    color: $gray-500;\n    fill: rgba($gray-500,0.16);\n}\n\n@each $color,\n$value in $theme-colors {\n    .icon-dual-#{$color} {\n        color: $value;\n        fill: rgba($value, 0.16);\n    }\n}\n\n// Search \n.search-box{\n    position: relative;\n    .form-control{\n        padding-left: 40px;\n    }\n    .search-icon{\n        font-size: 14px;\n        position: absolute;\n        left: 13px;\n        top: 0;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        color: $text-muted;\n    }\n}\n\n\n// overlay\n\n.bg-overlay {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    top: 0;\n    opacity: 0.1;\n    background-color: $black;\n}\n\n// Btn Customizer\n\n.customizer-setting {\n    position: fixed;\n    bottom: 40px;\n    right: 20px;\n    z-index: 1000;\n}\n\n// \ncode {\n    user-select: all;\n}\n\n.layout-rightside {\n    width: 280px;\n    margin-right: -#{$grid-gutter-width};\n    margin-top: calc(1px - #{$grid-gutter-width} * 1.1);\n    height: calc(100% + #{$grid-gutter-width} * 1.1);\n}\n\n.layout-rightside-col {\n\n    @media (max-width: 1699.98px) { \n        display: none;\n        position: fixed !important;\n        height: 100vh;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        z-index: 1004;\n        .overlay{\n            position: fixed;\n            top: 0;\n            right: 0px;\n            bottom: 0px;\n            left: 0px;\n            background-color: rgba($dark, 0.2);\n           \n        }\n        .layout-rightside {\n            margin-top: 0px;\n            height: 100%;\n            margin-left: auto;\n        }\n        .card-body {\n            overflow-y: auto;\n            padding-bottom: 1rem !important;\n        }\n    }\n}\n\n[data-layout=\"horizontal\"], [data-layout-style=detached]{\n    @media (min-width: 1700px) {\n        .layout-rightside{\n            margin-top: calc(28px - #{$grid-gutter-width});\n            margin-right: 0;\n            height: calc(100% - calc(#{$grid-gutter-width} / 5));\n        }\n    }\n}\n\n// object fit cover\n.object-cover{\n    object-fit: cover;\n}\n\n// text-truncate-two-lines\n.text-truncate-two-lines{\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    white-space: normal;\n}\n\n// Favourite button \n.favourite-btn{\n    border-color: transparent;\n    .ri-star-fill{\n        color: $text-muted;\n    }\n    &.active{\n        border-color: transparent;\n        .ri-star-fill{\n            color: $warning;\n            \n            &:before{\n                content: \"\\f186\";\n            }\n        }\n    }\n}\n// card\n.card-logo-light{\n    display: var(--#{$prefix}card-logo-light);\n}\n\n.card-logo-dark{\n    display: var(--#{$prefix}card-logo-dark);\n}\n\n[data-layout-mode=\"dark\"]{\n    .btn-close{\n        filter: invert(1) grayscale(100%) brightness(200%);\n    }\n}\n\n\n#back-to-top {\n    position: fixed;\n    bottom: 100px;\n    right: 28px;\n    transition: all 0.5s ease;\n    display: none;\n    z-index: 1000;\n    &:hover {\n        animation: fade-up 1.5s infinite linear;\n    }\n}\n\n@keyframes fade-up {\n  0% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}","// \n// preloader.scss\n//\n\n#preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--#{$prefix}card-bg-custom);\n    z-index: 9999;\n}\n\n[data-preloader=\"disable\"] #preloader {\n    opacity: 0;\n    visibility: hidden;\n}\n\n#status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -20px 0 0 -20px;\n}","//\n// forms.scss\n//\n\n:is([type=\"tel\"], [type=\"url\"], [type=\"email\"], [type=\"number\"]){\n    &::placeholder {\n        text-align: left /*rtl: right*/;\n    }\n}\n","// \n// Widgets.scss\n// \n\n.main-chart {\n    .chart-border-left {\n        border-left: 1.4px solid $border-color;\n        padding: 2px 20px;\n\n        &:last-child {\n            margin-right: 0px;\n        }\n    }\n}\n\n\n\n/* Activity */\n\n.activity-feed {\n    list-style: none;\n\n    .feed-item {\n        position: relative;\n        padding-bottom: 27px;\n        padding-left: 16px;\n        border-left: 2px solid $light;\n\n        &:after {\n            content: \"\";\n            display: block;\n            position: absolute;\n            top: 4px;\n            left: -6px;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            border: 2px solid $primary;\n            background-color: $card-bg;\n        }\n\n        &:last-child {\n            border-color: transparent;\n        }\n    }\n}\n\n// mini-stats-wid\n.mini-stats-wid {\n    position: relative;\n\n    .mini-stat-icon {\n        overflow: hidden;\n        position: relative;\n\n        &:before,\n        &:after {\n            content: \"\";\n            position: absolute;\n            width: 8px;\n            height: 69px;\n            background-color: rgba($success, .1);\n            left: 3px;\n            transform: rotate(32deg);\n            top: -8px;\n            transition: all 0.4s;\n        }\n\n        &::after {\n            left: 27px;\n            width: 8px;\n            transition: all 0.2s;\n        }\n    }\n\n    &:hover {\n        .mini-stat-icon {\n            &::after {\n                left: 60px;\n            }\n\n            &::before {\n                left: 50px;\n            }\n        }\n    }\n}\n\n// credit card widget\n.card-wrapper{\n    .jp-card{\n        .jp-card-back, .jp-card-front{\n            background-color: $success;\n        }\n    }\n}\n\n.notification-elem{\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: var(--#{$prefix}card-bg-custom);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden;\n    opacity: 0;\n}\n\n//ecommerce widgets\n.clothes-size {\n    li {\n        input[type=\"radio\"] {\n            display: none;\n        }\n\n        label {\n            display: inline-block;\n            font-size: 14px;\n            border-radius: 5px;\n            border: 1px solid $border-color;\n            text-transform: none;\n            letter-spacing: 0;\n            color: $primary;\n        }\n\n        input[type=\"radio\"]:checked+label {\n            background-color: $primary;\n            border-color: $primary;\n            color: $white;\n        }\n    }\n}","// \n// _demos.scss\n// \n\n// Buttons demo\n.button-items {\n    margin-left: -8px;\n    margin-bottom: -12px;\n\n    .btn {\n        margin-bottom: 12px;\n        margin-left: 8px;\n    }\n}\n\n// Modals\n.bs-example-modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n}\n\n[dir=\"rtl\"] {\n    .modal-open {\n        padding-left: 0px !important;\n    }\n}\n\n// Icon demo ( Demo only )\n.icon-demo-content {\n    color: var(--#{$prefix}gray-500);\n\n    i {\n        font-size: 24px;\n        margin-right: 10px;\n        color: var(--#{$prefix}gray-600);\n        transition: all 0.4s;\n        vertical-align: middle;\n    }\n\n    svg {\n        margin-right: 10px;\n        transition: all 0.4s;\n        height: 20px;\n    }\n\n    .col-lg-4 {\n        margin-top: 24px;\n\n        &:hover {\n            i, svg {\n                color: $primary;\n                transform: scale(1.5);\n            }\n        }\n    }\n}\n\n// Grid\n\n.grid-structure {\n    .grid-container {\n        background-color: $gray-100;\n        margin-top: 10px;\n        font-size: .8rem;\n        font-weight: $font-weight-medium;\n        padding: 10px 20px;\n    }\n}\n\n// customizer switch\n\n.img-switch{\n    .card-radio{\n        .form-check-input {\n            display: none;\n    \n            &:checked+.form-check-label {\n                &::before{\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    left: 0;\n                    background-color: rgba($primary, 0.5);\n                }\n                &::after{\n                    content: '\\eb80';\n                    font-family: \"remixicon\";\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translateY(-50%) translateX(-50%);\n                    font-size: 18px;\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n[data-bs-target=\"#collapseBgGradient\"]{\n    &.active{\n        border-color: $primary !important;\n        &::before{\n            content: \"\\eb80\";\n            font-family: remixicon;\n            position: absolute;\n            top: 2px;\n            right: 6px;\n            font-size: 16px;\n            color: $primary;\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"]{\n    .colorscheme-cardradio{\n        .form-check-label{\n            background-color: var(--#{$prefix}dark);\n        }\n        .bg-light{\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.1)!important;\n        }\n\n        .bg-soft-light {\n            background-color: rgba(var(--#{$prefix}dark-rgb),.1)!important;\n        }\n\n        .dark{\n            .bg-dark{\n                background-color: var(--#{$prefix}card-bg-custom)!important;\n            }\n        }\n    }\n}","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .vertical-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-header,\n    .app-menu,\n    .footer,\n    #back-to-top {\n        display: none !important;\n    }\n    .card-body,\n    .main-content,\n    .right-bar,\n    .page-content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n\n    .card{\n        border: 0;\n        box-shadow: none !important;\n    }\n\n    .invoice-details{\n        .d-sm-flex{\n            display: flex !important;\n        }\n    }\n    .address{\n        &.col-sm-6 {\n            flex: 0 0 auto !important;\n            width: 50% !important;\n            max-width: 100% !important;\n        }\n    }\n}","// \n// ribbons.scss\n//\n\n.ribbon-box {\n    position: relative;\n\n    .ribbon {\n        padding: 5px 12px;\n        box-shadow: 2px 5px 10px rgba($dark, 0.15);\n        color: $white;\n        font-size: $font-size-base;\n        font-weight: $font-weight-semibold;\n        position: absolute;\n        left: -1px;\n        top: 5px;\n\n        &.round-shape {\n            border-radius: 0 30px 30px 0;\n        }\n\n        &.ribbon-shape {\n            display: inline-block;\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                right: -17px;\n                top: 0;\n                border: 14px solid transparent;\n            }\n\n            &::after {\n                content: \"\";\n                position: absolute;\n                right: -17px;\n                bottom: 0;\n                border: 14px solid transparent;\n            }\n        }\n\n    }\n\n    // ribbon circle\n    &.ribbon-circle {\n        .ribbon {\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            padding: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            left: 20px;\n            top: 20px;\n        }\n    }\n\n    // ribbon fill\n\n    &.ribbon-fill {\n        overflow: hidden;\n            \n        .ribbon {\n            transform: rotate(-45deg);\n            width: 93px;\n            height: 52px;\n            left: -36px;\n            top: -16px;\n            display: flex;\n            justify-content: center;\n            align-items: flex-end;\n        }\n        &.ribbon-sm {\n            .ribbon {\n                padding: 2px 12px;\n                width: 78px;\n                height: 42px;\n                font-size: 12px;\n                box-shadow: none;\n            }\n        }\n    }\n\n    // right\n    &.right {\n        .ribbon {\n            position: absolute;\n            left: auto;\n            right: 0;\n\n            &.round-shape {\n                border-radius: 30px 0 0 30px;\n            }\n\n            &.ribbon-shape {\n                text-align: right;\n\n                &::before,\n                &::after {\n                    right: auto;\n                    left: -17px;\n                    border-left-color: transparent;\n                }\n            }\n        }\n\n        &.ribbon-circle {\n            .ribbon {\n                left: auto;\n                right: 20px;\n            }\n        }\n\n        .icon-ribbon {\n            right: 24px;\n            left: auto;\n        }\n\n        &.ribbon-fill {\n            .ribbon {\n                transform: rotate(45deg);\n                right: -38px;\n                left: auto;\n            }\n        }\n\n        &.ribbon-box {\n            .ribbon-two {\n                left: auto;\n                right: -5px;\n\n                span {\n                    left: auto;\n                    right: -21px;\n                    transform: rotate(45deg);\n                }\n            }\n        }\n\n    }\n\n    .ribbon-content {\n        clear: both;\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-#{$color} {\n            background: ($value);\n\n            &:before {\n                border-color: darken(($value), 10%) transparent transparent;\n            }\n\n            &.ribbon-shape {\n                &::before {\n                    border-left-color: ($value);\n                    border-top-color: ($value);\n                }\n\n                &::after {\n                    border-left-color: ($value);\n                    border-bottom-color: ($value);\n                }\n            }\n        }\n\n        &.right {\n            .ribbon-#{$color} {\n                background: ($value);\n\n                &.ribbon-shape {\n                    &::before {\n                        border-right-color: ($value);\n                        border-top-color: ($value);\n                    }\n\n                    &::after {\n                        border-right-color: ($value);\n                        border-bottom-color: ($value);\n                    }\n                }\n            }\n        }\n    }\n\n\n    // Icon ribbon\n\n    .icon-ribbon {\n        box-shadow: none;\n        left: 24px;\n        top: -12px;\n        font-size: 40px;\n        padding: 0;\n    }\n\n\n    /* Ribbon two */\n    .ribbon-two {\n        position: absolute;\n        left: -5px;\n        top: -5px;\n        z-index: 1;\n        overflow: hidden;\n        width: 75px;\n        height: 75px;\n        text-align: right;\n\n        span {\n            font-size: 13px;\n            color: $white;\n            text-align: center;\n            line-height: 20px;\n            transform: rotate(-45deg);\n            width: 100px;\n            display: block;\n            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n            position: absolute;\n            top: 19px;\n            left: -21px;\n            font-weight: $font-weight-semibold;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                left: 0;\n                top: 100%;\n                z-index: -1;\n                border-right: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n\n            &:after {\n                content: \"\";\n                position: absolute;\n                right: 0;\n                top: 100%;\n                z-index: -1;\n                border-left: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n        }\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-two-#{$color} {\n\n            span {\n                background: ($value);\n\n                &:before {\n                    border-left: 3px solid darken(($value), 15%);\n                    border-top: 3px solid darken(($value), 15%);\n                }\n\n                &:after {\n                    border-right: 3px solid darken(($value), 15%);\n                    border-top: 3px solid darken(($value), 15%);\n                }\n            }\n        }\n    }\n\n}\n\n\n.ribbon-box {\n    &.right {\n        .ribbon-three {\n            position: absolute;\n            top: -6.1px;\n            right: 10px;\n            left: auto;\n        }\n    }\n}\n\n.ribbon-three {\n    position: absolute;\n    top: -6.1px;\n    left: 10px;\n\n    span {\n        position: relative;\n        display: block;\n        text-align: center;\n        color: $white;\n        font-size: 14px;\n        line-height: 1;\n        padding: 12px 8px 10px;\n        border-top-right-radius: 8px;\n        width: 90px;\n\n        &::after,\n        &::before {\n            position: absolute;\n            content: \"\";\n        }\n\n        &::before {\n            height: 6px;\n            width: 6px;\n            left: -6px;\n            top: 0;\n        }\n\n        &::after {\n            height: 6px;\n            width: 8px;\n            left: -8px;\n            top: 0;\n            border-radius: 8px 8px 0 0;\n        }\n    }\n\n    &::after {\n        position: absolute;\n        content: \"\";\n        width: 0;\n        height: 0;\n        border-left: 44px solid transparent;\n        border-right: 44px solid transparent;\n        border-top: 10px solid;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .ribbon-three-#{$color} {\n\n        span {\n            background: ($value);\n\n            &:before {\n                background: ($value);\n            }\n\n            &:after {\n                background: darken($value, 10%);\n            }\n        }\n\n        &::after {\n            border-top-color: ($value);\n        }\n    }\n}\n\n//Ribbon Hover\n.ribbon-box {\n    .trending-ribbon {\n        transform: translateX(-50px);\n        transition: all 0.5s ease;\n\n        .trending-ribbon-text {\n            transition: all 0.5s ease;\n            opacity: 0;\n        }\n    }\n\n    &:hover {\n        .trending-ribbon {\n            transform: translateX(0);\n\n            .trending-ribbon-text {\n                opacity: 1;\n            }\n        }\n    }\n    &.right {\n        .trending-ribbon {\n            transform: translateX(50px);\n            transition: all 0.5s ease;\n    \n            .trending-ribbon-text {\n                transition: all 0.5s ease;\n                opacity: 0;\n            }\n        }\n    \n        &:hover {\n            .trending-ribbon {\n                transform: translateX(0);\n    \n                .trending-ribbon-text {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}","//\n// toast.scss\n//\n\n\n// toast\n.toast { \n    &:not(:last-child) {\n      margin-bottom: $toast-padding-x;\n    }\n}\n\n@mixin toast-border-variant($bg) {\n    .toast-body{\n        color: $bg;\n        border-bottom: 3px solid $bg;\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .toast-border-#{$color} {\n        @include toast-border-variant($value);\n    }\n}","//\n// scrollspy.scss\n//\n\n// Scrollspy\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: .5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 370px;\n  overflow: auto;\n}","// \n// reboot.scss\n//\n\nhtml {\n    position: relative;\n    min-height: 100%;\n}\n\n:is(.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6) {\n    color: $heading-color;\n    font-family: $heading-font-family;\n}\n\na {\n    text-decoration: none !important;\n}\n\nlabel {\n    font-weight: $font-weight-medium;\n    margin-bottom: $form-label-margin-bottom;\n}\nb,\nstrong {\n  font-weight: $font-weight-semibold;\n}\n\n// blockquote\n\n.blockquote {\n    padding: 10px 20px;\n    border-left: 4px solid var(--#{$prefix}gray-300);\n}\n\n.blockquote-reverse {\n    border-left: 0;\n    border-right: 4px solid var(--#{$prefix}gray-300);\n    text-align: right;\n}\n\n// container\n\n:is(.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl) {\n    @media (min-width: 1200px) {\n        max-width: 1140px;\n    }\n}\n\n// row\n.row>*{\n    position: relative;\n}\n\n// mixing\n\n@function set-color-from-background($color) {\n    @if (lightness($color) > 70) {\n        @return $color-contrast-dark;\n    }\n    @else {\n        @return $color-contrast-light;\n    }\n}","//\n// alerts.scss\n//\n\n// alert solid\n\n.alert-solid {\n    .alert-link {\n        color: $white;\n    }\n}\n\n// alert outline\n\n.alert-outline {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border-width: 2px;\n}\n\n// alert borderless\n\n.alert-borderless {\n    border-width: 0;\n}\n\n// alert-label-icon\n\n.alert-label-icon {\n    position: relative;\n    padding-left: 60px;\n    border: 0;\n\n    .label-icon {\n        position: absolute;\n        width: 45px;\n        height: 100%;\n        left: 0;\n        top: 0;\n        background-color: rgba($white, 0.15);\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    // label arrow\n    &.label-arrow {\n        overflow: hidden;\n        .label-icon {\n            &:after {\n                content: \"\";\n                position: absolute;\n                border: 6px solid transparent;\n                border-left-color: $primary;\n                right: -12px;\n            }\n        }\n    }\n}\n\n\n// Alert border left example\n\n.alert-border-left {\n    border-left: 3px solid;\n}\n\n// alert top border example\n\n.alert-top-border {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border-color: $border-color;\n    border-top: 2px solid;\n    color: var(--#{$prefix}body-color);\n}\n\n//alert additional example\n\n.alert-additional { \n    padding: 0;\n\n    .alert-body{\n        padding: $alert-padding-y $alert-padding-x;\n    }\n    .alert-content {\n        padding: $alert-padding-y $alert-padding-x;\n        border-bottom-left-radius: $alert-border-radius;\n        border-bottom-right-radius: $alert-border-radius;\n        margin: 0 (-$alert-border-width) (-$alert-border-width) (-$alert-border-width);\n    }\n}\n\n// rounded label example\n\n.rounded-label {\n    .label-icon {\n        width: 45px;\n        height: 26px;\n        left: 0px;\n        top: 50%;\n        transform: translateY(-50%);\n        border-radius: 0 30px 30px 0;\n    }\n}\n\n// Alert example loop\n\n@each $color, $value in $theme-colors {\n    // alert solid\n    .alert-solid {\n        &.alert-#{$color} {\n            background-color: $value;\n            border-color: $value;\n            color: set-color-from-background($value);\n        }\n    }\n\n    // alert outline\n    .alert-outline {\n        &.alert-#{$color} {\n            color: $value;\n        }\n    }\n\n    // alert border left\n    .alert-border-left {\n        &.alert-#{$color} {\n            border-left-color: $value;\n        }\n    }\n\n    // alert top border\n    .alert-top-border {\n        &.alert-#{$color} {\n            border-top-color: $value;\n        }\n    }\n    \n\n    // rounded label\n\n    .rounded-label {\n        &.alert-#{$color} {\n            .label-icon {\n                background-color: $value;\n                color: set-color-from-background($value);\n            }\n        }\n    }\n\n    // label arrow\n\n    .label-arrow {\n        &.alert-#{$color} {\n            .label-icon {\n                color: set-color-from-background($value);\n                background-color: $value;\n                &:after {\n                    border-left-color: $value !important;\n                }\n            }\n        }\n    }\n\n    .alert{\n        &.alert-#{$color} {\n            .btn-close::after{\n                color: $value;\n            }\n        }\n        \n    }\n\n    //alert additional example\n    .alert-additional {\n        &.alert-#{$color} {\n            .alert-content {\n                background-color: $value;\n                color: set-color-from-background($value);\n            }\n        }\n    }   \n}\n.alert-dismissible {\n    .btn-close {\n        background: transparent !important;\n        &::after {\n            background: transparent !important;\n            content: \"\\F0156\" !important;\n            font-size: 18px;\n            line-height:15px;\n            font-family: \"Material Design Icons\" !important;\n        }\n    }\n}\n\n.alert-outline.alert-dark{\n    color: var(--#{$prefix}dark);\n}\n   ","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.18) !important;\n    }\n}\n\n.bg-soft-dark{\n    background-color: rgba(var(--#{$prefix}dark-rgb),.18)!important;\n}\n\n.bg-soft-light{\n    background-color: rgba(var(--#{$prefix}light-rgb),.18)!important;\n}\n\n","// \n// badge.scss\n//\n\n// Soft badge\n@mixin badge-variant-soft($bg) {\n    color: $bg;\n    background-color: rgba($bg, 0.1);\n}\n\n\n// Outline badge\n@mixin badge-variant-outline($bg) {\n    color: $bg;\n    border: 1px solid $bg;\n    background-color: transparent;\n}\n\n@each $color, $value in $theme-colors {\n    .badge-outline-#{$color} {\n        @include badge-variant-outline($value);\n    }\n}\n\n// badge outline\n\n.badge-outline {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border: 1px solid;\n}\n\n@each $color, $value in $theme-colors {\n    .badge-soft-#{$color} {\n        @include badge-variant-soft($value);\n    }\n\n    .badge-outline {\n        &.badge-#{$color} {\n            @include badge-variant-outline($value);\n        }\n    }\n\n    .badge-label {\n        &.bg-#{$color} {\n            &:before {\n                border-right-color: $value;\n            }\n        }\n    }\n}\n\n// badge-border\n\n.badge-border {\n    border-left: 2px solid;\n}\n\n// badge-label\n\n.badge-label {\n    margin-left: 8px;\n    position: relative;\n    &:before {\n        content: \"\";\n        position: absolute;\n        border: 8px solid transparent;\n        border-right-color: $primary;\n        left: -14px;\n        top: 0;\n    }\n}\n\n// [data-layout-mode=\"dark\"]{\n//     .badge{\n//         &.bg-dark{\n//             background-color: var(--#{$prefix}light) !important;\n//         }\n\n//         &.bg-light{\n//             background-color: var(--#{$prefix}dark) !important;\n//             color: var(--#{$prefix}light) !important;\n//         }\n//     }\n// }\n\n//Badge Gradient Style\n$gradients: ();\n$gradients: map-merge((primary: linear-gradient(135deg, $primary 0%, $success 100%),\n        secondary: linear-gradient(135deg, $secondary 0%, $info 100%),\n        success: linear-gradient(135deg, $success 0%, $warning 100%),\n        danger: linear-gradient(135deg, $danger 0%, $secondary 100%),\n        warning: linear-gradient(135deg, $warning 0%, darken($warning, 15%) 100%),\n        info: linear-gradient(135deg, $info 0%, $success 100%),\n        dark: linear-gradient(135deg, $dark 0%, $primary 100%)),\n    $gradients);\n\n@mixin badge-gradient($parent, $gradient) {\n    #{$parent} {\n        background: $gradient;\n    }\n}\n\n@each $gradient,\n$value in $gradients {\n    @include badge-gradient(\".badge-gradient-#{$gradient}\", $value);\n}","// \n// _buttons.scss\n// \n\nbutton,\na {\n    outline: none !important;\n    position: relative;\n}\n\n.btn {\n    box-shadow: $element-shadow;\n}\n\n:is(.btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active) {\n    border-color: transparent;\n}\n\n// Rounded Buttons\n.btn-rounded {\n    border-radius: 30px;\n}\n\n\n.btn-icon {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    width: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    padding: 0;\n\n    :is(i, svg, img) {\n        vertical-align: middle;\n    }\n\n    &.btn-sm {\n        height: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n        width: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    }\n\n    &.btn-lg {\n        height: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n        width: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    }\n}\n\n//\n// Soft Buttons\n// \n\n@each $color,\n$value in $theme-colors {\n    .btn-soft-#{$color} {\n        --#{$prefix}btn-color: #{$value};\n        --#{$prefix}btn-bg: #{rgba($value, .1)};\n        --#{$prefix}btn-border-color: transparent;\n        --#{$prefix}btn-hover-color: #{$white};\n        --#{$prefix}btn-hover-bg: #{shade-color($value, 10%)};\n        --#{$prefix}btn-hover-border-color: transparent;\n        --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($value)};\n        --#{$prefix}btn-active-color: var(--#{$prefix}btn-hover-color);\n        --#{$prefix}btn-active-bg: #{shade-color($value, 20%)};\n        --#{$prefix}btn-active-border-color: transparent;\n    }\n}\n\n//\n// Ghost Buttons\n// \n\n@each $color,\n$value in $theme-colors {\n    .btn-ghost-#{$color} {\n        --#{$prefix}btn-color: #{$value};\n        --#{$prefix}btn-bg: transparent;\n        --#{$prefix}btn-border-color: transparent;\n        --#{$prefix}btn-hover-color: #{$value};\n        --#{$prefix}btn-hover-bg: #{rgba($value, .1)};\n        --#{$prefix}btn-hover-border-color: transparent;\n        --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($value)};\n        --#{$prefix}btn-active-color: #{$value};\n        --#{$prefix}btn-active-bg: #{rgba($value, .1)};\n        --#{$prefix}btn-active-border-color: transparent;\n    }\n}\n\n.btn-ghost-secondary {\n    color: var(--#{$prefix}gray-700);\n}\n\n//button with icon\n.btn-label {\n    position: relative;\n    padding-left: 44px;\n\n    .label-icon {\n        position: absolute;\n        width: 35.5px;\n        left: -$btn-border-width;\n        top: -$btn-border-width;\n        bottom: -$btn-border-width;\n        background-color: rgba($white, 0.1);\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &.btn-light {\n        .label-icon {\n            background-color: rgba($dark, 0.05);\n        }\n    }\n\n    &.right {\n        padding-left: $btn-padding-x;\n        padding-right: 44px;\n\n        .label-icon {\n            right: -$btn-border-width;\n            left: auto;\n        }\n    }\n}\n\n// Animation Button\n\n.btn-animation {\n    overflow: hidden;\n    transition: border-color 0.3s, background-color 0.3s;\n    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n\n    &::after {\n        content: attr(data-text);\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        transform: translate3d(0, 25%, 0);\n        padding: $btn-padding-y $btn-padding-x;\n        transition: transform 0.3s, opacity 0.3s;\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n    }\n\n    >span {\n        display: block;\n        transition: transform 0.3s, opacity 0.3s;\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n    }\n\n    &:hover {\n        &::after {\n            opacity: 1;\n            transform: translate3d(0, 0, 0);\n        }\n\n        >span {\n            opacity: 0;\n            transform: translate3d(0, -25%, 0);\n        }\n    }\n}\n\n\n@mixin button-variant($bg) {\n    &.btn-animation {\n        background-color: $bg;\n        border-color: $bg !important;\n\n        &:is(:hover, :focus, :active, :focus-visible) {\n            color: $bg;\n            background-color: rgba($bg, 0.1);\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .btn-#{$color} {\n        @include button-variant($value);\n    }\n}\n\n//btn group\n.btn-group-vertical {\n    label {\n        margin-bottom: 0;\n    }\n}\n\n// btn group radio\n.btn-group.radio {\n    .btn {\n        border: none;\n    }\n\n    .btn-check:active+.btn-light,\n    .btn-check:checked+.btn-light,\n    .btn-light.active,\n    .btn-light.dropdown-toggle.show,\n    .btn-light:active {\n        background-color: rgba($info, 0.2);\n        color: $info;\n    }\n}\n\n// theme dark\n[data-layout-mode=\"dark\"] {\n\n    .btn-check:focus+.btn-light,\n    .btn-check:focus+.btn-outline-light,\n    .btn-check:focus+.btn-soft-light,\n    .btn-soft-light:focus {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    }\n\n    .btn-check:active+.btn-light,\n    .btn-check:active+.btn-outline-light,\n    .btn-check:active+.btn-soft-light,\n    .btn-check:checked+.btn-light,\n    .btn-check:checked+.btn-outline-light,\n    .btn-check:checked+.btn-soft-light,\n    .btn-light.active,\n    .btn-light:active,\n    .btn-outline-light.active,\n    .btn-outline-light:active,\n    .btn-soft-light.active,\n    .btn-soft-light:active,\n    .show>.btn-light.dropdown-toggle,\n    .show>.btn-outline-light.dropdown-toggle,\n    .show>.btn-soft-light.dropdown-toggle {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    }\n\n    .btn-check:focus+.btn-dark,\n    .btn-check:focus+.btn-outline-dark,\n    .btn-check:focus+.btn-soft-dark,\n    .btn-soft-dark:focus {\n        color: var(--#{$prefix}light);\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    }\n\n    .btn-check:active+.btn-dark,\n    .btn-check:active+.btn-outline-dark,\n    .btn-check:active+.btn-soft-dark,\n    .btn-check:checked+.btn-dark,\n    .btn-check:checked+.btn-outline-dark,\n    .btn-check:checked+.btn-soft-dark,\n    .btn-dark.active,\n    .btn-dark:active,\n    .btn-outline-dark.active,\n    .btn-outline-dark:active,\n    .btn-soft-dark.active,\n    .btn-soft-dark:active,\n    .show>.btn-dark.dropdown-toggle,\n    .show>.btn-outline-dark.dropdown-toggle,\n    .show>.btn-soft-dark.dropdown-toggle {\n        color: var(--#{$prefix}light);\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    }\n\n    // soft\n\n    .btn-soft-light {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.1);\n\n        &:hover {\n            color: var(--#{$prefix}dark);\n            background-color: var(--#{$prefix}light);\n        }\n    }\n\n    .btn-soft-dark {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n\n        &:hover {\n            color: var(--#{$prefix}light);\n            background-color: var(--#{$prefix}dark);\n        }\n    }\n\n    // ghost\n    .btn-ghost-light {\n        color: var(--#{$prefix}dark);\n\n        &:is(:hover, :focus, :active, :focus-visible) {\n            color: var(--#{$prefix}dark);\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.5);\n        }\n    }\n\n    .btn-ghost-dark {\n        color: var(--#{$prefix}dark);\n\n        &:is(:hover, :focus, :active, :focus-visible) {\n            color: var(--#{$prefix}dark);\n            background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n        }\n    }\n}\n\n.btn-load {\n\n    .spinner-border,\n    .spinner-grow {\n        height: 19px;\n        width: 19px;\n    }\n}\n\n//Border Bottom Buttons Style\n@each $color,\n$value in $theme-colors {\n\n    :is(.btn-#{$color}, .btn-outline-#{$color}, .btn-soft-#{$color}) {\n        &.btn-border {\n            border-bottom: 2px solid darken($value, 8%);\n        }\n    }\n}\n\n//custom toggle\n.custom-toggle {\n    .icon-off {\n        display: none;\n    }\n\n    &.active {\n        .icon-on {\n            display: none;\n        }\n\n        .icon-off {\n            display: block;\n        }\n    }\n}","// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: var(--#{$prefix}gray-700);\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"Material Design Icons\";\n            font-size: 15px;\n            line-height: 20px;\n        }\n    }\n}\n  ","// \n// _card.scss\n// \n\n.card {\n    margin-bottom: $grid-gutter-width;\n    box-shadow: $card-box-shadow;\n}\n\n.card-header {\n    border-bottom: 1px solid $border-color;\n}\n\n//Card Header Dropdown\n.card-header-dropdown {\n    .dropdown-btn {\n        padding: $card-cap-padding-y 0;\n    }\n}\n\n.card-footer {\n    border-top: 1px solid $border-color;\n}\n\n.card-drop {\n    color: $body-color;\n}\n\n.card-title {\n    font-size: 16px;\n    margin: 0 0 7px 0;\n}\n\n.card-title-desc {\n    margin-bottom: 24px;\n}\n\n.card-height-100 {\n    height: calc(100% - #{$grid-gutter-width});\n}\n\n.card-animate{\n    transition: all 0.4s;\n\n    &:hover{\n        transform: translateY(calc(#{-$grid-gutter-width} / 5));\n        box-shadow: $box-shadow-lg;\n    }\n}\n\n\n// card color variant\n\n@mixin card-variant($bg) {\n    color: $white;\n    background-color: $bg;\n}\n\n@each $color,\n$value in $theme-colors {\n    .card-#{$color} {\n        @include card-variant($value);\n\n        .card-header, .card-footer {\n            background-color: rgba($white, 0.1);\n            color: $white;\n            border-color: transparent;\n        }\n\n        .card-title {\n            color: $white;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .card-border-#{$color} {\n        border-color: $value !important;\n        .card-header, .card-footer {\n            border-color: $value;\n        }\n\n    }\n}\n\n.card-light{\n    background-color: var(--#{$prefix}light);\n    .card-header, .card-footer{\n        color: var(--#{$prefix}body-color) !important;\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n    }\n    .card-title, .card-text { \n        color: var(--#{$prefix}body-color) !important;\n    }\n}\n\n.stretched-link {\n    position: static;\n}\n\n\n// Loader\n\n.card-preloader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.6);\n    z-index: 9999;\n}\n\n.card-status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%)!important;\n}\n\n.custom-loader {\n    animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n\tto { transform: rotate(360deg) }\n}\n\n.card-overlay{\n    position: relative;\n    overflow: hidden;\n    &:before {\n        content: \"\";\n        background-color: rgba($primary, 0.20);\n        position: absolute;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n    }\n    :is(.card-header, .card-footer) {\n        border-color: rgba($white, 0.15) !important;\n    }\n}\n\n.card-toolbar-menu {\n    line-height: 0.8;\n    a {\n        font-size: 17px;\n    }\n    .minimize-card {\n        .plus{\n            display: none;\n        }  \n        .minus {\n            display: block;\n        }\n        &.collapsed{\n            .plus{\n                display: block;\n            }  \n            .minus {\n                display: none;\n            }\n        }\n    }\n}","// \n// _dropdown.scss\n// \n\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    font-size: 15px;\n    line-height: 15px;\n    content: \"\\F0140\";\n    font-family: \"Material Design Icons\";\n}\n\n.dropdown-menu {\n    box-shadow: $box-shadow-lg;\n    animation-name: DropDownSlide;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    position: absolute;\n    z-index: 1000;\n\n    &.dropdown-megamenu {\n        padding: 20px;\n        left: 0 !important;\n        right: 0 !important;\n    }\n\n    &[data-popper-placement=\"top-start\"] {\n        animation-name: DropDownSlideDown;\n    }\n}\n\n@keyframes DropDownSlide {\n    100% {\n        margin-top: -1px;\n    }\n\n    0% {\n        margin-top: 8px;\n    }\n}\n\n@keyframes DropDownSlideDown {\n    100% {\n        margin-bottom: 0;\n    }\n\n    0% {\n        margin-bottom: 8px;\n    }\n}\n\n@media (min-width: 600px) {\n    .dropdown-menu-xl {\n        width: 420px;\n    }\n\n    .dropdown-menu-lg {\n        width: 320px;\n    }\n\n    .dropdown-menu-md {\n        width: 240px;\n    }\n}\n\n.dropdown-toggle-split {\n    border-left: none;\n    &::after {\n        margin-left: 0px;\n    }\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        background-color: rgba($white,0.12);\n        top: -$btn-border-width;\n        bottom: -$btn-border-width;\n        right: -$btn-border-width;\n        left: 0;\n        border-radius: 0 $btn-border-radius $btn-border-radius 0;\n    }\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n    position: static !important;\n}\n\n\n\n// Dropdown size\n\n.dropdown-mega-menu-xl {\n    width: 38rem;\n}\n\n.dropdown-mega-menu-lg {\n    width: 26rem;\n}\n\n[dir=\"ltr\"] {\n    .dropdown-menu-start {\n        --bs-position: end;\n    }\n\n    .dropdown-menu-end {\n        --bs-position: start;\n    }\n}\n// Custom Dropdown with Tabs\n.dropdown-head{\n    .nav-tabs-custom{\n        border: 0;\n        .nav-link  {\n            color: rgba($white, 0.6);\n            &.active {\n                background-color: var(--#{$prefix}dropdown-bg);\n            }\n            &:hover {\n                color: $white;\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .dropdownmenu-#{$color} {\n      .dropdown-item{\n        &:is(:focus, :hover, .active){\n          background-color: rgba(($value), 0.07);\n          color: $value;\n        }\n      }\n    }\n}","//\n// _nav.scss\n//\n\n:is(.nav-tabs, .nav-pills) {\n    >li {\n        >a {\n            color: var(--#{$prefix}gray-700);\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n\n.nav-pills {\n    >a {\n        color: var(--#{$prefix}gray-700);\n        font-weight: $font-weight-medium;\n    }\n}\n\n.nav-pills {\n\n    :is(.nav-link.active, .show>.nav-link) {\n        box-shadow: $element-shadow;\n    }\n}\n\n.nav-tabs-custom {\n    border-bottom: 1px solid var(--#{$prefix}gray-300);\n\n    .nav-item {\n        position: relative;\n\n        .nav-link {\n            border: none;\n            font-weight: $font-weight-medium;\n\n            &::after {\n                content: \"\";\n                background: $primary;\n                height: 1px;\n                position: absolute;\n                width: 100%;\n                left: 0;\n                bottom: 0;\n                transition: all 250ms ease 0s;\n                transform: scale(0);\n            }\n\n            &.active {\n                color: $primary;\n\n                &:after {\n                    transform: scale(1);\n                }\n            }\n        }\n    }\n\n    &.card-header-tabs {\n        margin-top: -1rem;\n\n        .nav-link {\n            padding: $card-cap-padding-y $card-cap-padding-x;\n        }\n    }\n}\n\n// vertical nav\n\n.vertical-nav {\n    .nav {\n        .nav-link {\n            padding: 24px 16px;\n            text-align: center;\n            margin-bottom: 8px;\n\n            .nav-icon {\n                font-size: 24px;\n            }\n        }\n    }\n}\n\n//Navtab custom\n.navtab-bg {\n    li {\n        >a {\n            background-color: $gray-300;\n            margin: 0 5px;\n        }\n    }\n}\n\n// arrow-navtabs\n\n.arrow-navtabs {\n    .nav-item {\n        .nav-link {\n            position: relative;\n            text-align: center;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                border: 6px solid transparent;\n                bottom: -12px;\n                left: 50%;\n                transform: translateX(-50%);\n                @include transition($nav-link-transition);\n            }\n\n            &.active {\n                &:before {\n                    border-top-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n// custom hover tab\n.custom-hover-nav-tabs {\n    .nav-item {\n        text-align: center;\n        overflow: hidden;\n\n        .nav-link {\n            width: 120px;\n            height: 45px;\n            position: relative;\n            border-radius: 0px;\n\n            .nav-icon {\n                font-size: 22px;\n            }\n\n            .nav-titl {\n                font-size: 14px;\n            }\n\n            &.active {\n                .nav-tab-position {\n                    color: $white;\n                }\n            }\n\n            .nav-tab-position {\n                position: absolute;\n                left: 0;\n                right: 0;\n                transition: all 0.4s;\n\n                &.nav-icon {\n                    top: 50%;\n                    transform: translateY(-50%);\n                }\n\n                &.nav-titl {\n                    bottom: -20px;\n                }\n            }\n\n            &:hover {\n                .nav-titl {\n                    bottom: 50%;\n                    transform: translateY(50%);\n                }\n\n                .nav-icon {\n                    top: -20px;\n                }\n            }\n        }\n    }\n}\n\n// custom vertical tab\n\n.custom-verti-nav-pills {\n    .nav-link {\n        background-color: var(--#{$prefix}light);\n        margin-top: 7px;\n        position: relative;\n\n        @media (min-width: 992px) {\n            &::before {\n                content: \"\";\n                position: absolute;\n                right: -20px;\n                top: 50%;\n                transform: translateY(-50%);\n                border: 12px solid transparent;\n                border-left-color: transparent;\n                transition: border-left-color 0.04 ease;\n            }\n\n            &.active {\n                &::before {\n                    border-left-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n// animation nav\n.animation-nav {\n    li {\n        position: relative;\n\n        a {\n            color: var(--#{$prefix}body-color);\n            border-radius: 4px;\n            position: relative;\n            overflow: hidden;\n            transition: all 0.4s;\n            z-index: 1;\n\n            span {\n                position: relative;\n            }\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                width: 0;\n                right: 0;\n                height: 100%;\n                transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;\n                background-color: $primary;\n                z-index: -1;\n            }\n\n            &:hover,\n            &.active {\n                color: $white;\n                background-color: transparent !important;\n\n                &::before {\n                    width: 100%;\n                    left: 0;\n                }\n            }\n        }\n    }\n}\n\n.nav-border-top {\n    .nav-link {\n        border-top: 3px solid transparent;\n\n        &.active {\n            border-top-color: $primary;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-border-top-#{$color} {\n        .nav-link {\n            &.active {\n                color: $value;\n                border-top-color: $value;\n            }\n        }\n    }\n}\n\n.nav-custom {\n    background-color: $primary;\n    border-radius: $card-border-radius;\n\n    .nav-item {\n        .nav-link {\n            color: rgba($white, 0.75);\n\n            &.active {\n                color: $white;\n                background-color: rgba($white, 0.1);\n            }\n        }\n    }\n\n    &.nav-custom-light {\n        .nav-item {\n            .nav-link {\n                color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n\n                &.active {\n                    color: $light;\n                    background-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-custom-#{$color} {\n        background-color: $value;\n    }\n}\n\n.nav-custom-light {\n    background-color: var(--#{$prefix}light);\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-#{$color} {\n        .nav-link {\n            &.active {\n                color: $white;\n                background-color: $value;\n            }\n        }\n\n        &.nav-tabs {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    background-color: var(--#{$prefix}card-bg-custom);\n                }\n            }\n        }\n\n        &.nav-tabs-custom {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    background-color: var(--#{$prefix}card-bg-custom);\n\n                    &::after {\n                        background-color: $value;\n                    }\n                }\n            }\n        }\n\n        &.arrow-navtabs {\n            .nav-link {\n                &.active {\n                    &::before {\n                        border-top-color: $value;\n                    }\n                }\n            }\n        }\n\n        &.custom-verti-nav-pills {\n            .nav-link {\n                &.active {\n                    &::before {\n                        border-left-color: $value;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// progress nav\n.progress-nav {\n    position: relative;\n    margin-right: 1rem;\n    margin-left: 1rem;\n\n    .progress {\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 100%;\n    }\n\n    .nav {\n        margin-right: -1rem;\n        margin-left: -1rem;\n        justify-content: space-between;\n\n        .nav-link {\n            width: 2rem;\n            height: 2rem;\n            background-color: var(--#{$prefix}light);\n            padding: 0;\n            color: var(--#{$prefix}dark);\n            font-weight: $font-weight-medium;\n\n            &.active,\n            &.done {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n// Step arrow nav\n.step-arrow-nav {\n    .nav {\n        background-color: var(--#{$prefix}light);\n\n        .nav-link {\n            border-radius: 0;\n            position: relative;\n            font-weight: $font-weight-medium;\n            color: var(--#{$prefix}dark);\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                border: 7px solid transparent;\n                right: -14px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n\n            &.done {\n                background-color: rgba($primary, 0.05);\n                color: $primary;\n\n                &::before {\n                    border-left-color: transparent;\n                }\n            }\n\n            &.active {\n                background-color: rgba($primary, 0.1);\n                color: $primary;\n                box-shadow: none;\n\n                &::before {\n                    border-left-color: rgba($primary, 0.1);\n                }\n            }\n        }\n\n        .nav-item {\n            &:last-child {\n                .nav-link {\n                    &:before {\n                        display: none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// vertical nav step\n.vertical-navs-step {\n    .nav {\n        gap: 16px;\n\n        .nav-link {\n            text-align: left;\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.4);\n            border: 1px solid var(--#{$prefix}border-color);\n            color: var(--#{$prefix}dark);\n\n            .step-title {\n                font-weight: $font-weight-semibold;\n            }\n\n            .step-icon {\n                color: $danger;\n                vertical-align: middle;\n                font-weight: $font-weight-medium;\n                float: left;\n            }\n\n            &.active,\n            &.done {\n                .step-icon {\n                    color: $success;\n\n                    &:before {\n                        content: \"\\eb80\";\n                    }\n                }\n            }\n\n            &.active {\n                border-color: $primary;\n            }\n\n            &.done {\n                border-color: $success;\n            }\n        }\n    }\n}\n\n//Outline Border Nav\n.nav-custom-outline {\n    &.nav {\n        .nav-link {\n            border: 1px solid transparent;\n            border-bottom: 2px solid transparent;\n\n            &.active {\n                border-color: $primary;\n                background-color: transparent;\n                color: $primary;\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-#{$color} {\n        &.nav-custom-outline {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n//customs nav\n.nav-customs {\n    &.nav {\n        padding-left: 34px;\n        overflow: hidden;\n\n        .nav-link {\n            position: relative;\n            display: block;\n            float: right;\n            background-color: var(--#{$prefix}body-bg);\n            margin-right: 46px;\n            transition: all 0.5s ease;\n\n            &::before,\n            &::after {\n                display: block;\n                content: \" \";\n                position: absolute;\n                top: -1px;\n                bottom: -1px;\n                width: 37px;\n                background-color: var(--#{$prefix}body-bg);\n                transition: all 0.5s ease;\n            }\n\n            &::before {\n                border-radius: 0 8px 0 0;\n                right: -24px;\n                transform: skew(30deg, 0deg);\n            }\n\n            &::after {\n                border-radius: 8px 0 0 0;\n                left: -24px;\n                transform: skew(-30deg, 0deg);\n            }\n\n            &.active,\n            &.active:before,\n            &.active:after {\n                background-color: $primary;\n                color: $white;\n            }\n\n            &.active {\n                z-index: 1;\n            }\n        }\n    }\n}","// \n// _table.scss\n// \n\n.table {\n    th {\n        font-weight: $font-weight-semibold;\n    }\n\n    >thead {\n        border-color: $table-border-color;\n    }\n    >:not(:first-child) {\n        border-top-width: $table-border-width;\n    }\n}\n\n\n.table-nowrap {\n\n    th,\n    td {\n        white-space: nowrap;\n    }\n}\n\n// card table\n\n.table-card{\n    margin: (-$card-spacer-y) (-$card-spacer-x);\n\n    th,\n    td {\n\n        &:first-child{\n            padding-left: 16px;\n        }\n\n        &:last-child{\n            padding-right: 16px;\n        }\n    }\n\n    .table > :not(:first-child) {\n        border-top-width: $table-border-width;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .border-#{$color} {\n        &.table {\n            > thead {\n                border-color: $value !important;\n            }\n        }\n    }\n    .table-#{$color} {\n        &.table {\n            > thead {\n                border-bottom-color:lighten($value, 10%) !important;\n            }\n        }\n    }\n}\n\n.table {\n    .form-check {\n        padding-left: 0px;\n        margin-bottom: 0px;\n        .form-check-input {\n            margin-left: 0px;\n            margin-top: 0px;\n            float: none;\n            vertical-align: middle;\n        }\n    }\n    .sort {\n        position: relative;\n        &::before {\n            content: \"\\f035d\";\n            position: absolute;\n            right: 0.5rem;\n            top: 18px;\n            font-size: 0.8rem;\n            font-family: \"Material Design Icons\";\n        }\n        &::after {\n            position:absolute;\n            right: 0.5rem;\n            content: \"\\f0360\";\n            font-family: \"Material Design Icons\";\n            font-size: 0.8rem;\n            top: 12px;\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"] {\n    .table-light {\n        background-color: var(--#{$variable-prefix}light);\n        color: var(--#{$variable-prefix}body-color);\n        th,td {\n            background-color: var(--#{$variable-prefix}light);\n        }\n    }\n}\n\n.rdt_Table {\n    &.eSTlnH {\n        background-color: var(--#{$variable-prefix}card-bg) !important;\n        color: var(--#{$variable-prefix}body-color);\n    }\n\n    .gZWIKX,\n    .jVeafb {\n        color: var(--#{$variable-prefix}body-color);\n        background-color: var(--#{$variable-prefix}card-bg);\n    }\n\n    .jVeafb:not(:last-of-type),\n    .gZWIKX {\n        border-bottom-color: var(--#{$variable-prefix}border-color);\n    }\n}\n\n.rdt_Pagination {\n    &.jxflYm {\n        background-color: var(--#{$variable-prefix}card-bg);\n        color: var(--#{$variable-prefix}body-color);\n        border-top-color: var(--#{$variable-prefix}border-color);\n    }\n\n    .bvxQGL {\n        fill: var(--#{$variable-prefix}dark);\n    }\n\n    .bvxQGL:disabled {\n        fill: rgba(var(--#{$variable-prefix}dark-rgb), 0.25);\n    }\n}","//\n// _modal.scss\n//\n\n.modal-title {\n    font-weight: $font-weight-semibold;\n}\n\n.modal-dialog:not(.modal-dialog-scrollable) {\n    .modal-header {\n        padding-bottom: 0;\n    \n        .btn-close {\n            margin-top: -$modal-header-padding;\n        }\n    }\n    \n    .modal-footer {\n        padding-top: 0;\n    }\n}\n\n.modal {\n\t&.fadeInRight {\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: translateX(20%);\n\t\t\ttransition: all .3s ease-in-out;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: translateX(0);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.fadeInLeft {\n\t\t.modal-dialog {\n\t\t\tanimation: fadeInLeft 0.3s ease-in-out;\n\t\t\ttransform: translate(-50%, 0);\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.fadeInUp {\n\t\t.modal-dialog {\n\t\t\tanimation: fadeInUp 0.3s ease-in-out;\n\t\t\ttransform: translate(0, 30%);\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.flip {\n\t\tperspective: 1300px;\n\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: rotateY(-70deg);\n\t\t\ttransition: all .3s;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: rotateY(0deg);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.zoomIn {\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: scale(.7);\n\t\t\ttransition: all .3s ease;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: scale(1)\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.modal-dialog-right {\n\tmargin-right: $modal-dialog-margin-y-sm-up;\n}\n\n// modal-dialog-bottom\n.modal-dialog-bottom {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\n\n\t@media (min-width: 576px) {\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\n\t}\n}\n\n.modal-dialog-bottom-right {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\n\tmargin-right: $modal-dialog-margin-y-sm-up;\n\n\t@media (min-width: 576px) {\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\n\t}\n}\n\n@keyframes fadeInLeft {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translate3d(-30%, 0, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateZ(0);\n\t}\n}\n\n\n@keyframes fadeInUp {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translate3d(0, 30%, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateZ(0);\n\t}\n}\n\n@keyframes zoomIn {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: scale3d(.3, .3, .3);\n\t}\n\n\t50% {\n\t\topacity: 1\n\t}\n}\n\n.login-modal {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1016%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(64%2c 81%2c 137%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704' fill='%2333416e'%3e%3c/path%3e%3cpath d='M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672' fill='%234d61a4'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1016'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e\");\n\tbackground-size: cover;\n\tbackground-position: center;\n}","// \n// _pagination.scss\n// \n\n// Pagination Separated\n.pagination-separated {\n    .page-item {\n        .page-link {\n            margin-left: 0.35rem;\n            border-radius: $border-radius;\n        }\n    }\n}\n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px !important;\n        border: none;\n        min-width: 32px;\n        min-height: 32px;\n        text-align: center;\n    }\n\n    &.pagination-sm {\n        .page-link {\n            min-width: 25px;\n            min-height: 25px;\n        }\n    }\n}\n\n.page-item.active {\n    .page-link{\n        box-shadow: $element-shadow;\n    }\n}","// \n// _progress.scss\n// \n\n// Progress height small\n.progress-sm {\n    height: 5px;\n}\n\n// Progress height large\n.progress-lg {\n    height: 12px;\n}\n\n// Progress height Extra large\n.progress-xl {\n    height: 16px;\n}\n\n.custom-progess {\n    position: relative;\n\n    .progress-icon {\n        position: absolute;\n        top: -12px;\n\n        .avatar-title {\n            background: var(--#{$prefix}card-bg-custom);\n        }\n    }\n}\n\n// animated-progress\n\n.animated-progress {\n    position: relative;\n\n    .progress-bar {\n        position: relative;\n        border-radius: 6px;\n        animation: animate-positive 2s;\n    }\n}\n\n@keyframes animate-positive {\n    0% {\n        width: 0;\n    }\n}\n\n// custom-progress\n\n.custom-progress {\n    height: 15px;\n    padding: 4px;\n    border-radius: 30px;\n\n    .progress-bar {\n        position: relative;\n        border-radius: 30px;\n\n        &::before {\n            content: \"\";\n            position: absolute;\n            width: 4px;\n            height: 4px;\n            background-color: $white;\n            border-radius: 7px;\n            right: 2px;\n            top: 50%;\n            transform: translateY(-50%);\n\n        }\n    }\n}\n\n// progress withlabel\n.progress-label {\n    overflow: visible;\n\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n\n        .label {\n            position: absolute;\n            top: -25px;\n            right: -9px;\n            background-color: $primary;\n            color: $white;\n            display: inline-block;\n            line-height: 18px;\n            padding: 0 4px;\n            border-radius: 4px;\n\n            &:after {\n                content: \"\";\n                position: absolute;\n                border: 4px solid transparent;\n                border-top-color: $primary;\n                bottom: -7px;\n                left: 50%;\n                transform: translateX(-50%);\n            }\n        }\n    }\n}\n\n\n.progress-step-arrow {\n    height: 3.25rem;\n\n    .progress-bar {\n        position: relative;\n        overflow: initial;\n        font-size: .875rem;\n        color: $white;\n        &::after {\n            content: \"\";\n            position: absolute;\n            border: 10px solid transparent;\n            bottom: 15px;\n            right: -20px;\n            z-index: 1;\n        }\n    }\n}\n\n\n@mixin progress-variant($bg) {\n    .progress-bar {\n        background-color: $bg;\n        &::after { \n            border-left-color: $bg;\n        }\n        &:nth-child(2) {\n            background-color: rgba($bg, 0.1) !important;\n            color: $bg !important;\n            &::after { \n                border-left-color: rgba($bg, 0.1);\n            }\n        }\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .progress-#{$color} {\n        @include progress-variant($value);\n    }\n}\n\n","// \n// _popover.scss\n// \n\n.popover {\n    box-shadow: $popover-box-shadow;\n}","// \n// type.scss\n//\n\n// Text colors\n.text-white-75 {\n    color: rgba($white, 0.75) !important;\n}\n\n// Blockquote\n.custom-blockquote {\n    &.blockquote {\n        padding: 16px;\n        border-left: 3px solid;\n        \n        &.blockquote-outline{\n            background-color: var(--#{$prefix}card-bg-custom) !important;\n            border: 1px solid;\n            border-left: 3px solid;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .custom-blockquote {\n        &.blockquote {\n            &.blockquote-#{$color} {\n                color: #{$value};\n                border-color: #{$value};\n                background-color: rgba($value, 0.15);\n\n                .blockquote-footer {\n                    color: #{$value};\n                }\n            }\n\n            &.blockquote-outline{\n                &.blockquote-#{$color} {\n                    border-color: #{$value};\n\n                    .blockquote-footer {\n                        color: #{$value};\n                    }\n                }\n            }\n        }\n    }\n}\n\n.custom-blockquote{\n    &.blockquote{\n        &.blockquote-dark{\n            color: var(--#{$prefix}dark);\n            border-color: var(--#{$prefix}dark);\n            background-color: rgba(var(--#{$prefix}dark-rgb), 0.15);\n            .blockquote-footer {\n                color: var(--#{$prefix}dark);\n            }\n        }\n        &.blockquote-outline{\n            &.blockquote-dark{\n                border-color: var(--#{$prefix}dark);\n                .blockquote-footer {\n                    color: var(--#{$prefix}dark);\n                }\n            }\n        }\n    }\n}","//\n// _form-check.scss\n//\n\n.form-check {\n    position: relative;\n    text-align: left\n        /*rtl: right*/;\n\n    .form-check-input {\n        cursor: pointer;\n    }\n\n    label {\n        cursor: pointer;\n    }\n}\n\n\n// checkbox color\n\n@each $color,\n$value in $theme-colors {\n    .form-check-#{$color} {\n        .form-check-input {\n            &:checked {\n                background-color: $value;\n                border-color: $value;\n            }\n        }\n    }\n\n    .form-radio-#{$color} {\n        .form-check-input {\n            &:checked {\n                border-color: $value;\n                background-color: $value;\n\n                &:after {\n                    background-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-check-label {\n    cursor: pointer;\n    margin-bottom: 0;\n}\n\n// checkbox input right\n.form-check-right {\n    padding-left: 0;\n    display: inline-block;\n\n    .form-check-input {\n        float: right;\n        margin-left: 0;\n        margin-right: $form-check-padding-start * -1;\n    }\n\n    .form-check-label {\n        display: block;\n    }\n\n    &.form-switch {\n        .form-check-input {\n            margin-right: $form-check-padding-start * -1.6;\n        }\n    }\n}\n\n\n// Checkbox outline\n\n@each $color,\n$value in $theme-colors {\n    .form-check-outline {\n        &.form-check-#{$color} {\n            .form-check-input {\n                &:checked[type=checkbox] {\n                    color: $value;\n                    background-color: transparent;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-check-outline {\n    .form-check-input {\n        position: relative;\n\n        &:checked[type=checkbox] {\n            background-image: none;\n\n            &::before {\n                content: \"\\F012C\";\n                font-family: \"Material Design Icons\";\n                top: -2px;\n                position: absolute;\n                font-weight: 700;\n                font-size: 11px;\n                left: 1px;\n            }\n        }\n\n    }\n}\n\n// Radio\n\n@each $color,\n$value in $theme-colors {\n    .form-radio-outline {\n        &.form-radio-#{$color} {\n            .form-check-input {\n                &:checked[type=radio] {\n                    color: $value;\n                    background-color: transparent;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-radio-outline {\n    .form-check-input {\n        position: relative;\n\n        &:checked[type=radio] {\n            background-image: none;\n\n            &::before {\n                content: \"\\F0765\";\n                font-family: \"Material Design Icons\";\n                top: 0px;\n                position: absolute;\n                font-size: 8px;\n                left: 2.2px;\n            }\n        }\n\n    }\n}\n\n// Switch sizes\n\n.form-switch-md {\n    padding-left: 2.5rem;\n    min-height: 22px;\n    line-height: 22px;\n\n    .form-check-input {\n        width: 40px;\n        height: 20px;\n        left: -0.5rem;\n        position: relative;\n    }\n\n    .form-check-label {\n        vertical-align: middle;\n    }\n}\n\n.form-switch-lg {\n    padding-left: 2.75rem;\n    min-height: 28px;\n    line-height: 28px;\n\n    .form-check-input {\n        width: 48px;\n        height: 24px;\n        left: -0.75rem;\n        position: relative;\n    }\n}\n\n.input-group-text {\n    margin-bottom: 0px;\n}\n\n\n@each $color,\n$value in $theme-colors {\n    .form-switch-#{$color} {\n        .form-check-input {\n\n            &:checked {\n                background-color: $value;\n                border-color: $value;\n            }\n        }\n    }\n\n    .form-switch-custom {\n        &.form-switch-#{$color} {\n            .form-check-input {\n                &:checked {\n                    &::before {\n                        color: $value;\n                    }\n\n                }\n            }\n        }\n    }\n}\n\n// Custom Switch style\n\n.form-switch-custom {\n    .form-check-input {\n        position: relative;\n        background-image: none;\n\n        &::before {\n            content: \"\\F0765\";\n            font-family: \"Material Design Icons\";\n            top: -9px;\n            position: absolute;\n            font-size: 20px;\n            left: -3px;\n            color: $text-muted;\n            @include transition($form-switch-transition);\n        }\n\n        &:checked {\n            background-image: none;\n            background-color: $form-check-input-bg;\n            @include transition($form-switch-transition);\n\n            &::before {\n                right: -3px;\n                left: auto;\n            }\n        }\n\n        &:focus {\n            background-image: none;\n        }\n    }\n}\n\n// Switch - Right\n\n.form-switch-right {\n    display: inline-block;\n    padding-right: $form-check-padding-start * .5;\n    margin-bottom: 0;\n    padding-left: 0 !important;\n\n    .form-check-input {\n        float: right;\n        margin-left: 0;\n        margin-right: $form-check-padding-start * -1;\n        margin-top: .1em !important;\n    }\n\n    label {\n        margin-bottom: 0;\n        margin-right: 1rem;\n    }\n}\n\n// card radio\n.card-radio {\n    padding: 0;\n\n    .form-check-label {\n        background-color: var(--#{$prefix}card-bg-custom);\n        border: 1px solid var(--#{$prefix}input-check-border);\n        border-radius: $border-radius;\n        padding: 1rem;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        display: block;\n        position: relative;\n        padding-right: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .form-check-input {\n        display: none;\n\n        &:checked+.form-check-label {\n            border-color: $primary !important;\n\n            &:before {\n                content: '\\eb80';\n                font-family: \"remixicon\";\n                position: absolute;\n                top: 2px;\n                right: 6px;\n                font-size: 16px;\n                color: $primary;\n            }\n        }\n    }\n\n    &.dark {\n        .form-check-input {\n            &:checked+.form-check-label {\n                &:before {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"]{\n    .form-switch{\n        .form-check-input, .form-check-input:focus{\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$gray-400}'/></svg>\"));\n        }\n    }\n}","//\n// _form-control.scss\n//\n\n\n.form-icon{\n    position: relative;\n    .form-control-icon {\n        padding-left: $input-padding-x*3;\n        position: relative;\n    }\n    i {\n        position: absolute;\n        top: 0px;\n        bottom: 0px;\n        left: 18px;\n        display: flex;\n        align-items: center;\n    }\n    &.right{\n        .form-control-icon {\n            padding-right: $input-padding-x*3;\n            padding-left: $input-padding-x;\n            position: relative;\n        }\n        i {\n            left: auto;\n            right: 18px;\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"]{\n    .form-select {\n        background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$gray-400}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\"));\n        background-color: var(--#{$prefix}gray-200) !important;\n        border-color: var(--#{$prefix}border-color) !important;\n    }\n\n    .form-control {\n        background-color: var(--#{$prefix}gray-200) !important;\n        border-color: var(--#{$prefix}border-color) !important;\n    }\n  }","//\n// _list-group.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .list-group-fill-#{$color} {\n        .list-group-item {\n            &.active {\n                background-color: $value !important;\n                border-color: $value;\n            }\n        }\n    }\n}\n\n.list-group-fill-light {\n    color: $dark !important;\n}\n\n.list-group-item {\n    margin-bottom: 0px;\n    .list-text {\n        color: $text-muted;\n    }\n    &.active {\n        box-shadow: $element-shadow;\n        .list-title {\n            color: $white;\n        }\n        .list-text {\n            color: rgba($white, 0.50);\n        }\n    }\n}","//\n// _custom-scrollbar.scss\n//\n\n[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 6px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}\n\n@each $color, $value in $theme-colors {\n  [data-simplebar-track=\"#{$color}\"]{\n    .simplebar-scrollbar:before{\n      background: $value;\n    }\n  }\n}","/**\n * prism.js default theme for JavaScript, CSS and HTML\n * Based on dabblet (http://dabblet.com)\n * @author Lea Verou\n */\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: black;\n    background: none;\n    text-shadow: 0 1px white;\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n    font-size: 1em;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    word-wrap: normal;\n    line-height: 1.5;\n\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n}\n\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n    text-shadow: none;\n    background: #b3d4fc;\n}\n\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n    text-shadow: none;\n    background: #b3d4fc;\n}\n\n@media print {\n    code[class*=\"language-\"],\n    pre[class*=\"language-\"] {\n        text-shadow: none;\n    }\n}\n\n/* Code blocks */\npre[class*=\"language-\"] {\n    padding: 1em;\n    margin: 0;\n    overflow: auto;\n}\n\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    background: var(--#{$prefix}light) !important;\n}\n\n/* Inline code */\n:not(pre) > code[class*=\"language-\"] {\n    padding: 0.1em;\n    border-radius: 0.3em;\n    white-space: normal;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n    color: slategray;\n}\n\n.token.punctuation {\n    color: #999;\n}\n\n.token.namespace {\n    opacity: 0.7;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n    color: $danger;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n    color: #690;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n    color: #9a6e3a;\n    /* This background color was intended by the author of this theme. */\n    background: hsla(0, 0%, 100%, 0.5);\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n    color: #07a;\n}\n\n.token.function,\n.token.class-name {\n    color: #dd4a68;\n}\n\n.token.regex,\n.token.important,\n.token.variable {\n    color: #e90;\n}\n\n.token.important,\n.token.bold {\n    font-weight: bold;\n}\n.token.italic {\n    font-style: italic;\n}\n\n.token.entity {\n    cursor: help;\n}\n\n/* Prism editor */\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    background: $gray-200;\n}\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: $gray-600;\n    text-shadow: none;\n}\n\n\n\n// Scrollbar\n\n.language-markup {\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 10px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .1);\n        border-radius: 10px;\n        border: 2px solid var(--#{$prefix}light)\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: var(--#{$prefix}light)\n    }\n}\n\n\n// Scroll-top\n\n#scroll-top {\n    width: 30px;\n    height: 30px;\n    position: fixed;\n    bottom: 65px;\n    right: 30px;\n    background: #343a40;\n    border-color: transparent;\n    border-radius: 3px;\n    color: #ffffff;\n    transition: all 0.5s ease;\n}\n\n// Toolbar (Copy button)\n\n.btn-clipboard {\n    position: absolute !important;\n    right: 15px !important;\n    z-index: 1 !important;\n}\n\ndiv.code-toolbar > .toolbar {\n    opacity: 1 !important;\n    button {\n        display: inline-block !important;\n        margin: 0.375rem 0.5rem !important;\n        padding: 0.25rem 0.75rem !important;\n        transition: $btn-transition !important;\n        border-radius: $border-radius-sm !important;\n        border: $border-width solid rgba($primary, 0.35) !important;\n        background-color: transparent;\n        color: $primary !important;\n        box-shadow: none !important;\n        &:focus {\n            outline: none !important;\n            box-shadow: none !important;\n        }\n        &:hover {\n            background-color: $primary !important;\n            color: $white !important;\n        }\n    }\n}\n","\n//\n//  _sweetalert2.scss\n//\n\n.swal2-container {\n  .swal2-title{\n    padding: 24px 24px 0;\n    font-size: 20px;\n    font-weight: $font-weight-medium;\n  }  \n}\n\n.swal2-popup{\n  padding-bottom: 24px;\n  border-radius: $modal-content-border-radius;\n  background-color: var(--#{$prefix}card-bg-custom);\n  color: var(--#{$prefix}body-color);\n\n  .swal2-title{\n    color: var(--#{$prefix}heading-color);\n  }\n\n  .swal2-html-container{\n    color: var(--#{$prefix}body-color);\n  }\n}\n\n.swal2-footer{\n  border-top: 1px solid var(--#{$prefix}border-color);\n  color: var(--#{$prefix}body-color);\n}\n\n.swal2-html-container{\n  font-size: 16px;\n}\n\n.swal2-icon{\n  &.swal2-question{\n    border-color: $info;\n    color: $info;\n  }\n  &.swal2-success {\n    [class^=swal2-success-line]{\n      background-color: $success;\n    }\n\n    .swal2-success-ring{\n      border-color: rgba($success, 0.3);\n    }\n  }\n  &.swal2-warning{\n    border-color: $warning;\n    color: $warning;\n  }\n}\n\n.swal2-styled{\n  &:focus{\n    box-shadow: none;\n  }\n}\n\n.swal2-loader{\n  border-color: $primary transparent $primary transparent;\n}\n\n.swal2-timer-progress-bar{\n  background-color: rgba($success, 0.4);\n}\n\n.swal2-progress-steps {\n  .swal2-progress-step{\n    background: $primary;\n    &.swal2-active-progress-step{\n      background: $primary;\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\n        background: rgba($primary, 0.3);\n      }\n    }\n  }\n  .swal2-progress-step-line{\n    background: $primary;\n  }\n}\n\n.swal2-actions.swal2-loading{\n  .swal2-styled.swal2-confirm{\n    border-left-color: $primary !important;\n    border-right-color: $primary !important;\n  }\n}\n\n.swal2-file, .swal2-input, .swal2-textarea{\n  border: 1px solid $input-border-color;\n  &:focus{\n    box-shadow: none;\n    border-color: $input-focus-border-color;\n  }\n}\n\n.swal2-input{\n  height: auto;\n  display: block;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n}\n\n.swal2-close{\n  font-family: $font-family-base;\n  font-weight: $font-weight-light;\n  font-size: 28px;\n  &:focus{\n    box-shadow: none;\n  }\n\n  &:hover{\n    color: $primary;\n  }\n}\n\n.swal2-validation-message{\n  background-color: transparent;\n}","//\n// Dropzone\n//\n\n\n.dropzone {\n  min-height: 230px;\n  border: 2px dashed var(--#{$prefix}border-color);\n  background: var(--#{$prefix}card-bg-custom);\n  border-radius: 6px;\n\n  .dz-message {\n    font-size: 24px;\n    width: 100%;\n    margin: 1em 0;\n  }\n}\n","\n//\n// _range-slider.scss\n//\n\n.noUi-connect{\n  background: $success;\n}\n\n.noUi-handle{\n  background: $success;\n  border: 2px solid var(--#{$prefix}card-bg);\n  box-shadow: none;\n}\n\n.noUi-horizontal{\n  height: 4px;\n  .noUi-handle{\n    height: 16px;\n    width: 16px;\n    border-radius: 50%;\n    right: -10px !important;\n    top: -7px;\n\n    &::before, &::after{\n      display: none;\n    }\n    &:focus{\n      outline: 0;\n    }\n  }\n}\n\n.noUi-pips-horizontal{\n  height: 50px;\n}\n\n// tooltip\n\n.noUi-tooltip{\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  border-color: $border-color;\n  border-radius: $tooltip-border-radius;\n  background-color: var(--#{$prefix}card-bg-custom);\n  color: var(--#{$prefix}body-color);\n}\n\n// Vertical Slider\n\n.noUi-vertical{\n  width: 4px;\n  .noUi-handle{\n    height: 16px;\n    width: 16px;\n    right: -8px;\n    top: -12px;\n    left: auto;\n    border-radius: 50%;\n    &::before, &::after{\n      display: none;\n    }\n    &:focus{\n      outline: 0;\n    }\n  }\n\n  .noUi-origin{\n    top: 0;\n  }\n}\n\n.noUi-value{\n  font-size: 12px;\n}\n\n.noUi-marker-horizontal{\n  &.noUi-marker-large{\n    height: 12px;\n  }\n}\n\n.noUi-value-horizontal{\n  padding-top: 4px;\n}\n\n.noUi-target{\n  box-shadow: none;\n  background-color: var(--#{$prefix}light);\n  border-color: var(--#{$prefix}light);\n}\n\n.noUi-touch-area{\n  &:focus{\n    outline: 0;\n  }\n}\n\n// Colorpicker\n\n#red, #green, #blue {\n\tmargin: 10px;\n\tdisplay: inline-block;\n\theight: 200px;\n}\n\n#colorpicker {\n\theight: 240px;\n\twidth: 310px;\n\tmargin: 0 auto;\n\tpadding: 10px;\n\tborder: 1px solid $border-color;\n}\n\n#result {\n\tmargin: 60px 26px;\n\theight: 100px;\n\twidth: 100px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tborder: 1px solid $border-color;\n    box-shadow: 0 0 3px;\n    border-radius: 7px;\n}\n\n#red {\n    .noUi-connect {\n        background: $danger;\n    }\n}\n\n#green {\n    .noUi-connect {\n        background: $success;\n    }\n}\n\n#blue {\n    .noUi-connect {\n        background: $primary;\n    }\n}\n\n// Adding keyboard support\n\n.form-control{\n    &.keyboard{\n        max-width: 340px !important;\n    }\n}\n\n\n// Non linear slider\n\n.example-val{\n    font-size: 12px;\n    color: $text-muted;\n    display: block;\n    margin: 15px 0;\n    &:before{\n        content: \"Value: \";\n        font-size: 12px;\n        font-weight: 600;\n    }\n}\n\n// showing tooltips\n\n.noUi-tooltip {\n    display: none;\n}\n.noUi-active .noUi-tooltip {\n    display: block;\n}\n\n// Colored Connect Elements\n\n.c-1-color { background: $danger; }\n.c-2-color { background: $warning; }\n.c-3-color { background: $success; }\n.c-4-color { background: $primary; }\n.c-5-color { background: $purple; }\n\n//  slider togle\n\n#slider-toggle {\n    height: 50px;\n    &.off{\n        .noUi-handle{\n            border-color: $danger;\n        }\n    }\n}\n\n// rangeslider color\n\n@each $color, $value in $theme-colors {\n  [data-slider-color=\"#{$color}\"] {\n    .noUi-connect{\n      background: $value;\n    }\n\n    .noUi-handle{\n      background: $value;\n    }\n\n    &[data-slider-style=\"border\"], &[data-slider-style=\"square\"]{\n      .noUi-handle{\n        border-color: $value;\n      }\n    }\n  }\n}\n\n// rangeslider sizes\n\n[data-slider-size=\"lg\"]{\n  &.noUi-horizontal{\n    height: 12px;\n\n    .noUi-handle{\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n[data-slider-size=\"md\"]{\n  &.noUi-horizontal{\n    height: 8px;\n\n    .noUi-handle{\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n[data-slider-size=\"sm\"]{\n  &.noUi-horizontal{\n    height: 4px;\n\n    .noUi-handle{\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n\n// rangeslider style\n\n[data-slider-style=\"line\"]{\n  &.noUi-horizontal .noUi-handle{\n    width: 8px;\n    border-radius: 4px;\n    right: -8px;\n  }\n  &.noUi-vertical .noUi-handle{\n    height: 8px;\n    border-radius: 4px;\n    top: -3px;\n  }\n}\n\n[data-slider-style=\"border\"]{\n  .noUi-handle{\n    border-color: $success;\n    background-color: $card-bg;\n  }\n}\n\n[data-slider-style=\"square\"]{\n  .noUi-handle{\n    border-radius: 0px;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 10px;\n    top: -4px;\n    border-color: $success;\n    background-color: $card-bg;\n  }\n}\n\n","// \n// _sortablejs.scss\n// \n\n\n.nested-list{\n    .list-group-item{\n        background-color: rgba($primary, 0.05);\n        border-color: rgba($primary, 0.05);\n    }\n}\n\n.nested-list, .nested-1, .nested-2, .nested-3{\n    margin-top: 5px;\n}\n\n\n.nested-sortable-handle{\n    .handle{\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 42px;\n        height: 42px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: grab;\n    }\n    .list-group-item{\n        padding-left: 42px;\n    }\n}","// \n// tour.scss\n// \n\n.shepherd-element{\n    background: var(--#{$prefix}card-bg-custom);\n    box-shadow: $box-shadow;\n}\n\n.shepherd-has-title{\n    .shepherd-content{\n        .shepherd-header{\n            background-color: var(--#{$prefix}light);\n            padding: $toast-padding-y $toast-padding-x;\n        }\n\n        .shepherd-cancel-icon{\n            color: rgba(var(--#{$prefix}dark-rgb), .75);\n            &:hover{\n                color: rgba(var(--#{$prefix}dark-rgb), .75);\n            }\n        }\n    }\n}\n\n.shepherd-element.shepherd-has-title[data-popper-placement^=bottom]>.shepherd-arrow:before{\n    background-color: var(--#{$prefix}light);\n}\n\n.shepherd-title{\n    font-size: 15px;\n    font-weight: $font-weight-medium;\n    color: var(--#{$prefix}body-color);\n}\n\n.shepherd-text{\n    padding: $toast-padding-x;\n    font-size: $font-size-base;\n    color: var(--#{$prefix}body-color);\n}\n\n.shepherd-button{\n    &.btn-success:not(:disabled):hover{\n        background: darken($success, 2.5%);\n        color: $white;\n    }\n\n    &.btn-light:not(:disabled):hover{\n        background: rgba(var(--#{$prefix}light-rgb), .75);\n        color: var(--#{$prefix}dark);\n    }\n\n    &.btn-primary:not(:disabled):hover{\n        background: darken($primary, 2.5%);\n        color: $white;\n    }\n}\n\n.shepherd-footer{\n    padding: 0 $toast-padding-x $toast-padding-x;\n}\n.shepherd-arrow,\n.shepherd-arrow:before{\n    content: \"\\ea75\";\n    font-family: 'remixicon';\n    font-size: 24px;\n    z-index: 1;\n    background-color: transparent !important;\n    transform: rotate(0deg);\n    color: $primary;\n}\n\n.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow{\n    top: -18px;\n}\n\n.shepherd-button{\n    margin-right: 0.5rem;\n}","//\n// _swiper.scss\n//\n\n.swiper-button-next, .swiper-button-prev {\n    height: 32px !important;\n    width: 32px !important;\n    background-color: rgba($primary, 0.2);\n    backdrop-filter: blur(2px);\n    border-radius: 8px;\n    &::after {\n        font-family: remixicon !important;\n        font-size: 28px !important;\n        color: rgba($primary, 1);\n        transition: all 0.3s ease;\n    }\n}\n\n.swiper-button-prev {\n    &::after {\n        content: \"\\ea64\" !important;\n    }\n}\n.swiper-button-next {\n    &::after {\n        content: \"\\ea6e\" !important;\n    }\n}\n\n.swiper-pagination-bullet{\n    width: 22px !important;\n    height: 5px !important;\n    background-color: $white !important;\n    border-radius: 50px !important;\n    box-shadow: $element-shadow;\n    .swiper-pagination-bullet-active{\n        opacity: 1;\n    }\n}\n\n.dynamic-pagination{\n    .swiper-pagination-bullet {\n        width: 8px;\n        height: 8px;\n        background-color: $white;\n        opacity: 0.5;\n        transition: all 0.5s ease;\n        &.swiper-pagination-bullet-active{\n            opacity: 1;\n            width: 20px;\n        }\n    }\n}\n\n.swiper-pagination-fraction {\n    color: $white;\n    font-size: 16px;\n    background-color: rgba($black, 0.3);\n    backdrop-filter: blur(2px);\n}\n\n\n.pagination-custom{\n    .swiper-pagination-bullet {\n        height: 25px !important;\n        width: 25px !important;\n        line-height: 25px !important;\n        border-radius: 8px !important;\n        background-color: $white !important;\n        opacity: 0.5 !important;\n        transition: all 0.5s ease;\n        &.swiper-pagination-bullet-active{\n            color: $secondary !important;\n            opacity: 1 !important;\n        }\n    }\n}\n\n.swiper-pagination-progressbar{\n    height: 6px !important;\n    background-color: rgba($success, 0.25) !important;\n    .swiper-pagination-progressbar-fill {\n        background-color: $success !important;\n    }\n}\n\n\n.swiper-scrollbar {\n    background-color: rgba($white, 0.35);\n    backdrop-filter: blur(2px);\n    padding: 1.2px;\n    height: 6px !important;\n    .swiper-scrollbar-drag {\n        background-color: $white;\n    }\n}\n\n.swiper-pagination-dark {\n    .swiper-pagination-bullet {\n        background-color: $secondary !important;\n    }\n    .dynamic-pagination{\n        .swiper-pagination-bullet { \n            background-color: $secondary !important;\n        }\n    }\n    &.pagination-custom{\n        .swiper-pagination-bullet { \n            color: $white;\n            &.swiper-pagination-bullet-active{\n                opacity: 1;\n            }\n        }\n    }\n    &.swiper-scrollbar { \n        background-color: rgba($dark, 0.35); \n    }\n}","\n//\n// _multijs.scss\n//\n\n.multi-wrapper{\n  border: none;\n  position: relative;\n\n  &::before{\n    content: \"\\ea61\";\n    position: absolute;\n    font-family: \"remixicon\";\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 86px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    border-radius: 50%;\n    color: $text-muted;\n    background-color: var(--#{$prefix}light);\n    z-index: 1;\n  }\n  \n  .non-selected-wrapper{\n    border: 1px solid $input-border-color;\n    background-color: $input-bg;\n    border-top-left-radius: $border-radius;\n    border-bottom-left-radius: $border-radius;\n  }\n\n  .selected-wrapper, .non-selected-wrapper{\n    &::-webkit-scrollbar {\n      -webkit-appearance: none;\n    }\n  \n    &::-webkit-scrollbar:vertical {\n      width: 10px;\n    }\n  \n    &::-webkit-scrollbar:horizontal {\n      height: 9px;\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(var(--#{$prefix}dark-rgb), .2);\n      border-radius: 10px;\n      border: 2px solid $input-bg;\n    }\n  \n    &::-webkit-scrollbar-track {\n      border-radius: 10px;  \n      background-color: $input-bg; \n    }\n}\n\n  .item-group .group-label{\n    font-size: 12px;\n  }\n\n  .item{\n    color: $input-color;\n    &:hover{\n      background-color: rgba($primary, 0.1);\n    }\n  }\n\n  .selected-wrapper{\n    border: 1px solid $input-border-color;\n    background: $input-bg;\n    border-top-right-radius: $border-radius;\n    border-bottom-right-radius: $border-radius;\n  }\n\n  .search-input{\n    flex: 0 0 auto;\n    padding: $input-padding-y $input-padding-x;\n    font-family: $input-font-family;\n    font-size: $input-font-size;\n    color: $input-color;\n    background-color: $input-bg;\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n    margin-bottom: 16px;\n    &::placeholder{\n      color: $input-placeholder-color;\n    }\n  }\n\n  .header{\n    font-weight: $font-weight-semibold;\n    color: var(--#{$prefix}gray-600);\n  }\n}","//\n// _colorpicker.scss\n//\n\n.pcr-app{\n  background: var(--#{$prefix}card-bg-custom);\n  box-shadow: $box-shadow-lg;\n  border-radius: 4px;\n  border: 1px solid $border-color;\n}\n\n.pickr{\n  .pcr-button{\n    border: 4px solid var(--#{$prefix}card-bg-custom);\n    box-shadow: 0px 0px 0 2px $border-color;\n    border-radius: 50%;\n    box-shadow: $element-shadow;\n    &::after, &::before{\n      border-radius: 50%;\n    }\n  }\n}\n\n.pcr-app{\n  &[data-theme=classic]{\n    .pcr-selection {\n      .pcr-color-preview{\n        margin-right: .75em;\n        margin-left: 0;\n      }\n  \n      .pcr-color-chooser, .pcr-color-opacity{\n        margin-left: .75em;\n        margin-right: 0;\n      }\n    }\n  }\n\n  &[data-theme=\"monolith\"]{\n    .pcr-result{\n      min-width: 100%;\n    }\n  }\n\n  .pcr-interaction{\n    .pcr-type.active{\n      background: $primary;\n    }\n\n    .pcr-result{\n      background-color: $input-bg;\n      color: $input-color;\n      border: 1px solid $input-border-color;\n      border-radius: $input-border-radius;\n    }\n\n    input{\n      border-radius: $input-border-radius !important;\n      &:focus{\n        box-shadow: none;\n        background-color: $input-focus-bg;\n        border-color: $input-focus-border-color;\n      }\n    }\n\n    .pcr-save{\n      background: $success !important;\n    }\n\n    .pcr-clear, .pcr-cancel{\n      background: $danger !important;\n    }\n  }\n}","//\n// filepond\n//\n\n.filepond--root{\n  margin-bottom: 0;\n\n  &[data-style-panel-layout~=circle]{\n    .filepond--drop-label label{\n      font-size: 14px;\n    }\n  }\n}\n\n.filepond--panel-root{\n  border: 2px dashed var(--#{$prefix}border-color);\n  background: var(--#{$prefix}card-bg-custom);\n}\n\n.filepond--drop-label {\n  color: var(--#{$prefix}body-color);\n  label{\n    font-weight: $font-weight-medium;\n  }\n}\n\n.filepond--credits {\n  display: none;\n}\n\n.filepond--item-panel {\n  background-color: $primary !important;\n}","//\n// _form-input-spin.scss\n//\n\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    height: auto;\n}\n\n.input-step {\n    border: 1px solid $input-border-color;\n    display: inline-flex;\n    overflow: visible;\n    height: 37.5px;\n    @include border-radius($input-border-radius, 0);\n    background: $input-bg;\n    padding: 4px;\n\n    input {\n        width: 4em;\n        height: 100%;\n        text-align: center;\n        border: 0;\n        background: transparent;\n        color: $input-color;\n        border-radius: $input-border-radius;\n\n        &:focus-visible {\n            outline: 0;\n        }\n    }\n\n    button {\n        width: 1.4em;\n        font-weight: 300;\n        height: 100%;\n        line-height: 0.1em;\n        font-size: 1.4em;\n        padding: 0.2em !important;\n        background: var(--#{$prefix}light);\n        color: var(--#{$prefix}body-color);\n        border: none;\n        border-radius: $btn-border-radius;\n    }\n\n    &.light {\n        background: var(--#{$prefix}light);\n\n        button {\n            background-color: $input-bg;\n        }\n    }\n\n    &.light-input {\n        background: var(--#{$prefix}light);\n\n        input {\n            background-color: $input-bg;\n        }\n    }\n\n    &.full-width {\n        display: flex;\n        width: 100%;\n\n        button {\n            flex-shrink: 0;\n        }\n\n        input {\n            flex-grow: 1;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .input-step {\n        &.step-#{$color} {\n            button {\n                background-color: $value;\n                color: $white;\n            }\n        }\n    }\n}","//\n// _ckeditor.scss\n//\n\n.ck {\n    font-family: $font-family-base !important;\n\n    &.ck-reset_all, &.ck-reset_all *{\n        color: var(--#{$prefix}body-color) !important;\n    }\n    &.ck-toolbar{\n        background: #{rgba(var(--#{$prefix}light-rgb), .75)} !important;\n    }\n\n    p {\n        margin-bottom: 0;\n    }\n\n    &.ck-toolbar {\n        border: 1px solid $input-border-color !important;\n\n        &.ck-toolbar_grouping>.ck-toolbar__items {\n            flex-wrap: wrap !important;\n        }\n\n        .ck.ck-toolbar__separator {\n            background: transparent !important;\n        }\n    }\n\n    &.ck-editor__main>.ck-editor__editable {\n        border-top: 0 !important;\n        background-color: var(--#{$prefix}card-bg-custom) !important;\n        border-color: $input-border-color !important;\n        box-shadow: none !important;\n    }\n\n    &.ck-dropdown__panel{\n        background: var(--#{$prefix}choices-bg) !important;\n        box-shadow: $box-shadow-lg;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n        border-radius: $dropdown-border-radius;\n    }\n\n    &.ck-list {\n        background: var(--#{$prefix}choices-bg) !important;\n    }\n\n    &.ck-dropdown {\n        .ck-dropdown__panel {\n            &.ck-dropdown__panel_ne,\n            &.ck-dropdown__panel_se {\n                left: 0;\n                right: auto !important;\n            }\n        }\n    }\n\n    &.ck-editor__editable_inline {\n        &[dir=ltr] {\n            text-align: left !important;\n        }\n    }\n\n    &.ck-dropdown__panel {\n        box-shadow: $dropdown-box-shadow !important;\n        border-radius: $dropdown-border-radius !important;\n        border: 1px solid $dropdown-border-color !important;\n    }\n}\n\n.ck.ck-button, \na.ck.ck-button{\n\n    &:focus, &:active{\n        box-shadow: none !important;\n        border: 1px solid var(--#{$prefix}light) !important;\n    }\n\n    &:not(.ck-disabled){\n        &:hover{\n            background: var(--#{$prefix}light) !important;\n        }\n    }\n\n    &.ck-on{\n        background: var(--#{$prefix}light) !important;\n    }\n}\n\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.ck-editor__editable {\n    min-height: 245px !important;\n}\n\n.ck[class*=ck-heading_heading] {\n    font-weight: $font-weight-medium !important;\n}\n\n.ck,\na.ck {\n    &.ck-button {\n        &.ck-on:not(.ck-disabled) {\n            &:hover,\n            &:active {\n                box-shadow: none !important;\n            }\n        }\n    }\n}\n\n.ck{\n    &.ck-tooltip{\n        .ck-tooltip__text {\n            background: $dark !important;\n            color: $light !important;\n        }\n    }\n\n    &.ck-input-text{\n        background: $input-bg !important;\n        border: 1px solid $input-border-color !important;\n        &:focus{\n            border: 1px solid $input-focus-border-color !important;\n            box-shadow: none !important;\n        }\n    }\n\n    &.ck-balloon-panel{\n        background: $dropdown-bg !important;\n        border: 1px solid $dropdown-border-color !important;\n\n        &[class*=arrow_n]{\n            &:after{\n                border-bottom-color: $dropdown-bg !important;\n            }\n\n            &::before{\n                border-bottom-color: $dropdown-border-color !important;\n            }\n        }\n    }\n}\n\n\n\n.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{\n    background: $dropdown-bg !important;\n}\n\n// ck-editor-reverse\n\n.ck-editor-reverse{\n    .ck-editor{\n      display: flex;\n      flex-direction: column-reverse;\n    }\n  \n    .ck{\n      &.ck-editor__main>.ck-editor__editable{\n        border: 1px solid $input-border-color !important;\n        border-bottom: 0 !important;\n      }\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n    .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-bottom-left-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-top-left-radius: 0 !important;\n      border-top-right-radius: 0 !important;\n    }\n}\n\n[dir=\"rtl\"] {\n    .ck.ck-toolbar>.ck-toolbar__items {\n        flex-direction: row-reverse;\n    }\n}","//\n// _quilljs.scss\n//\n\n.ql-editor {\n    text-align: left;\n\n    ol,\n    ul {\n        padding-left: 1.5em;\n        padding-right: 0;\n    }\n\n    li:not(.ql-direction-rtl)::before {\n        margin-left: -1.5em;\n        margin-right: 0.3em;\n        text-align: right;\n    }\n}\n\n.ql-container {\n    font-family: $font-family-base;\n\n    &.ql-snow {\n        border-color: $input-border-color;\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n}\n\n.ql-bubble {\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n}\n\n.ql-toolbar {\n    font-family: $font-family-base !important;\n\n    span {\n        outline: none !important;\n        color: var(--#{$prefix}choices-link-color);\n\n        &:hover {\n            color: $primary !important;\n        }\n    }\n\n    &.ql-snow {\n        border-top-left-radius: 4px;\n        border-top-right-radius: 4px;\n        border-color: $input-border-color;\n\n        .ql-picker.ql-expanded {\n            .ql-picker-label {\n                border-color: transparent;\n            }\n        }\n\n        .ql-picker-options {\n            box-shadow: $dropdown-box-shadow;\n            border-radius: $dropdown-border-radius;\n        }\n    }\n}\n\n.ql-snow {\n\n    .ql-stroke,\n    .ql-script,\n    .ql-strike svg {\n        stroke: var(--#{$prefix}choices-link-color);\n    }\n\n    .ql-fill {\n        fill: var(--#{$prefix}choices-link-color);\n    }\n\n    .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) {\n        svg {\n            right: 0;\n            left: auto;\n        }\n    }\n\n    .ql-picker {\n        &.ql-expanded .ql-picker-label {\n            color: var(--#{$prefix}choices-link-color);\n        }\n    }\n}\n\n.ql-snow {\n    .ql-picker-options {\n        background-color: var(--#{$prefix}choices-bg);\n        border-color: $dropdown-border-color !important;\n    }\n}","// \n// _gridjs.scss\n// \n\n.gridjs-container {\n    color: $table-color;\n    padding: 0;\n    display: block;\n}\n\n.gridjs-wrapper {\n    box-shadow: none;\n    border: 1px solid $table-border-color;\n    border-radius: 0px;\n\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 12px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 12px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 10px;\n        border: 2px solid var(--#{$prefix}card-bg-custom);\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: var(--#{$prefix}card-bg-custom);\n    }\n}\n\n.gridjs-footer {\n    border: none !important;\n    padding: 12px 0 0;\n}\n\n.gridjs-table {\n    width: 100%;\n}\n\n.gridjs-tbody, td.gridjs-td{\n    background-color: $table-bg;\n}\n\nth.gridjs-th,\ntd.gridjs-td {\n    border: 1px solid $table-border-color;\n    padding: $table-cell-padding-y $table-cell-padding-x;\n}\n\nth {\n    &.gridjs-th {\n        border-top: 0;\n        color: $table-color;\n        background-color: rgba(var(--#{$prefix}light-rgb), .75);\n\n    }\n\n    &.gridjs-th-sort {\n\n        &:focus,\n        &:hover {\n            background-color: rgba(var(--#{$prefix}light-rgb), .85);\n        }\n    }\n}\n\n.gridjs-head{\n    padding-top: 0;\n}\n\n.gridjs-footer {\n    box-shadow: none;\n    border: 1px solid $table-border-color;\n    border-top: 0;\n    background-color: $table-bg;\n}\n\n.gridjs-summary {\n    color: $text-muted;\n    margin-top: 8px !important;\n}\n\n.gridjs-pagination {\n\n    .gridjs-pages button {\n        margin-left: 0.3rem;\n        border-radius: $border-radius !important;\n        border: 1px solid $pagination-border-color;\n        background-color: $pagination-bg;\n        color: $pagination-color;\n\n        &:last-child{\n            border-right: 1px solid $pagination-border-color;\n        }\n\n        &:disabled,\n        &:hover:disabled,\n        &[disabled] {\n            color: $pagination-disabled-color;\n            background-color: $pagination-bg;\n        }\n\n        &:hover {\n            background-color: $pagination-hover-bg;\n            color: $pagination-hover-color;\n        }\n\n        &:focus {\n            box-shadow: none;\n        }\n\n        &:last-child,\n        &:first-child {\n            &:hover {\n                background-color: transparent;\n            }\n        }\n\n        &.gridjs-currentPage {\n            background-color: $pagination-active-bg;\n            color: $pagination-active-color;\n            border-color: $pagination-active-border-color;\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n\n.gridjs-search {\n    position: relative;\n    float: left;\n\n    &::before {\n        content: \"\\f0d1\";\n        font-family: \"remixicon\";\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 10px;\n        font-size: 14px;\n        color: $text-muted;\n    }\n}\n\ninput.gridjs-input {\n    border-color: $input-border-color;\n    background-color: $input-bg;\n    color: $input-color;\n    line-height: $input-line-height;\n    padding: $input-padding-y $input-padding-x $input-padding-y $input-padding-x*2.25;\n    border-radius: $input-border-radius;\n    @include font-size($input-font-size);\n\n    &:focus {\n        box-shadow: none;\n        border-color: $input-focus-border-color;\n        background-color: $input-focus-bg;\n    }\n\n    &::placeholder{\n        color: $input-placeholder-color;\n    }\n}\n\nth.gridjs-th {\n    .gridjs-th-content {\n        float: none;\n        display: inline-block;\n        vertical-align: middle;\n        font-weight: $font-weight-semibold;\n    }\n}\n\nbutton.gridjs-sort {\n    float: none;\n    display: inline-block;\n    vertical-align: middle;\n    width: 10px;\n    height: 20px;\n}\n\nth.gridjs-th-sort .gridjs-th-content {\n    width: calc(100% - 10px);\n}\n\nbutton{\n    &.gridjs-sort-asc, &.gridjs-sort-desc{\n        background-size: 7px;\n    }\n}\n\n\n// card table\n\n.table-card{\n\n    .gridjs-head{\n        padding: 16px 16px 5px;\n    }\n\n    .gridjs-wrapper{\n        border-top: 0;\n        border-radius: 0;\n        border-width: 1px 0;\n    }\n\n    .gridjs-footer{\n        padding: 8px 16px;\n    }\n}\n\n// gridjs selection\n.gridjs-tr-selected {\n    td{\n        background-color: $table-active-bg;\n    }\n    .gridjs-td .gridjs-checkbox[type=checkbox]{\n        background-color: $form-check-input-checked-bg-color;\n        border-color: $form-check-input-checked-border-color;\n        @if $enable-gradients {\n            background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n          } @else {\n            background-image: escape-svg($form-check-input-checked-bg-image);\n          }\n    }\n}\n.gridjs-td{\n    .gridjs-checkbox{\n        width: $form-check-input-width;\n        height: $form-check-input-width;\n        vertical-align: top;\n        background-color: $form-check-input-bg;\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: contain;\n        border: $form-check-input-border;\n        appearance: none;\n        print-color-adjust: exact; // Keep themed appearance for print\n        @include transition($form-check-transition);\n        &[type=\"checkbox\"] {\n          @include border-radius($form-check-input-border-radius);\n        }\n    }\n}\n\n.gridjs-border-none{\n    td.gridjs-td, th.gridjs-th{\n        border-right-width: 0;\n        border-left-width: 0;\n    }\n}\n\n.gridjs-loading-bar {\n    background-color: var(--#{$prefix}card-bg-custom);\n}\n\n[data-layout-mode=\"dark\"]{\n    button{\n        &.gridjs-sort-neutral, &.gridjs-sort-asc, &.gridjs-sort-desc{\n            filter: $btn-close-white-filter;\n        }\n    }\n}","// \n// _listjs.scss\n// \n\n.listjs-pagination{\n    margin-bottom: 0;\n    justify-content: flex-end;\n    gap: 8px;\n    li{\n        .page{\n            display: block;\n            padding: $pagination-padding-y $pagination-padding-x;\n            color: $pagination-color;\n            background-color: $pagination-bg;\n            border: $pagination-border-width solid $pagination-border-color;\n            border-radius: $border-radius;\n        }\n\n        &.active{\n            .page{\n                color: $pagination-active-color;\n                @include gradient-bg($pagination-active-bg);\n                border-color: $pagination-active-border-color;\n            }\n        }\n    }\n}\n\n.pagination-wrap {\n    user-select: none;\n    display: flex;\n    align-items: center;\n    a {\n        text-decoration: none;\n        display: inline-block;\n    }\n}\n\n.pagination-next,\n.pagination-prev {\n    color: $primary;\n    font-weight: $font-weight-medium;\n    padding: $pagination-padding-y $pagination-padding-x;\n    background-color: $pagination-bg;\n    border: $pagination-border-width solid $pagination-border-color;\n    border-radius: $border-radius; \n    &:hover {\n        color: lighten($primary, 20%);\n    }\n\n    &.disabled {\n        color: $text-muted;\n        cursor: default;\n\n        &:hover {\n            color: $text-muted;\n        }\n    }\n}","//\n// apexcharts.scss\n//\n\n.apex-charts {\n    min-height: 10px !important;\n    text {\n        font-family: $font-family-base !important;\n    }\n    .apexcharts-canvas {\n        margin: 0 auto;\n    }\n}\n\n.apexcharts-tooltip-title,\n.apexcharts-tooltip-text {\n    font-family: $font-family-base !important;  \n}\n\n.apexcharts-tooltip{\n    border: 1px solid $border-color !important;\n    background-color: var(--#{$prefix}card-bg-custom) !important;\n    box-shadow: $box-shadow !important;\n    * {\n        font-family: $font-family-base !important;\n        color: $gray-600 !important;\n    }\n\n    .apexcharts-tooltip-title{\n        background-color: rgba(var(--#{$prefix}light-rgb), .75) !important;\n        border-bottom: 1px solid $border-color !important;\n    }\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark{\n    * {\n        color: $white !important;\n    }\n}\n\n.apexcharts-legend-series {\n    font-weight: $font-weight-medium;\n}\n\n.apexcharts-gridline {\n    pointer-events: none;\n    stroke: rgba(var(--#{$prefix}light-rgb), .75);\n}\n\n.apexcharts-legend-text {\n    color: $gray-600 !important;\n    font-family: $font-family-base !important;\n    font-size: 13px !important;\n}\n\n.apexcharts-pie-label {\n    fill: $white !important;\n}\n\n.apexcharts-title-text, .apexcharts-subtitle-text{\n    fill: $gray-500;\n}\n\n.apexcharts-yaxis,\n.apexcharts-xaxis {\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-500;\n    }\n}\n\n.apexcharts-yaxis-title {\n    font-weight: 500;\n}\n\n// column dynamic loaded chart\n\n#dynamicloadedchart-wrap {\n    margin: 0px auto;\n    max-width: 800px;\n    position: relative;\n}\n\n.chart-box {\n    padding-left: 0;\n}\n\n#chart-year,\n#chart-quarter {\n    width: 96%;\n    max-width: 48%;\n    box-shadow: none;\n    padding-left: 0;\n    padding-top: 20px;\n    background: var(--#{$prefix}card-bg-custom);\n    border: 1px solid $border-color;\n}\n\n#chart-year {\n    float: left;\n    position: relative;\n    transition: 1s ease transform;\n    z-index: 3;\n    &.chart-quarter-activated {\n        transform: translateX(0);\n        transition: 1s ease transform;\n    }\n}\n\n#chart-quarter {\n    float: left;\n    position: relative;\n    z-index: -2;\n    transition: 1s ease transform;\n    &.active {\n        transition: 1.1s ease-in-out transform;\n        transform: translateX(0);\n        z-index: 1;\n    }\n}\n\n@media screen and (min-width: 480px) {\n    #chart-year {\n        transform: translateX(50%);\n    }\n    #chart-quarter {\n        transform: translateX(-50%);\n    }\n}\n\n// radar chart\n\n.apexcharts-radar-series{\n    polygon, line{\n        stroke: $border-color;\n    }\n}\n\n.apexcharts-pie{\n    circle ,line{\n        stroke: $border-color;\n    }\n    text{\n        fill: var(--#{$prefix}body-color);\n    }\n}\n\n.apex-charts {\n\n    .apexcharts-xaxis,\n    .apexcharts-yaxis {\n        line {\n            stroke: var(--#{$prefix}border-color);\n        }\n    }\n\n    .apexcharts-xaxis-tick {\n        stroke: var(--#{$prefix}border-color);\n    }\n\n    .apexcharts-pie-series,\n    .apexcharts-bar-series {\n        path {\n            stroke: var(--#{$prefix}card-bg-custom);\n        }\n    }\n\n    .apexcharts-radialbar-track {\n        path {\n            stroke: var(--#{$prefix}light);\n        }\n    }\n\n    .apexcharts-marker {\n        stroke: var(--#{$prefix}card-bg-custom);\n    }\n\n    .apexcharts-boxPlot-series {\n        path {\n            stroke: var(--#{$prefix}border-color);\n        }\n    }\n\n    .apexcharts-treemap,\n    .apexcharts-heatmap-series {\n        rect {\n            stroke: var(--#{$prefix}card-bg-custom);\n        }\n    }\n}","\n//\n// _chartjs.scss\n//\n\n.chartjs-chart{\n  max-height: 320px;\n}\n  ","//\n// echarts.scss\n//\n\n.e-charts{\n    height: 350px;\n}\n\n.e-charts-height{\n    height: 300px;\n}","\n//\n// _google-map.scss\n//\n\n.gmaps, .gmaps-panaroma {\n  height: 300px;\n  background: $gray-100;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: $white;\n  font-size: 16px;\n  line-height: 40px;\n  background: $primary;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n  &.above {\n    bottom: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-top: 16px solid $primary;\n  }\n  &.below {\n    top: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-bottom: 16px solid $primary;\n  }\n  \n}","//\n// _autocomplete.scss\n//\n\n.autoComplete_wrapper {\n    display: block;\n\n    >input {\n        display: block;\n        width: 100%;\n        height: auto;\n        padding: $input-padding-y $input-padding-x;\n        font-family: $input-font-family;\n        font-size: $input-font-size;\n        font-weight: $input-font-weight;\n        line-height: $input-line-height;\n        color: $input-color;\n        background-color: $input-bg;\n        background-clip: padding-box;\n        border: $input-border-width solid $input-border-color;\n        border-radius: $input-border-radius;\n        background-image: none;\n\n        &::placeholder {\n            padding: 0 !important;\n            color: $input-placeholder-color !important;\n            font-size: $input-font-size !important;\n        }\n\n        &:focus {\n            border: $input-border-width solid $input-focus-border-color;\n            color: $input-focus-color;\n        }\n\n        &:hover {\n            color: $input-color;\n        }\n    }\n\n    >ul {\n        border-radius: $border-radius;\n        border-color: $dropdown-border-color;\n        background-color: $dropdown-bg;\n        box-shadow: $dropdown-box-shadow;\n        padding: 0;\n        overflow: auto;\n        max-height: 160px;\n        margin: 0;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n\n        > li {\n            font-size: $dropdown-font-size;\n            margin: 0;\n            padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n            border-radius: 0;\n            background-color: $dropdown-bg;\n            color: $dropdown-color;\n\n            mark {\n                color: $danger;\n                font-weight: $font-weight-semibold;\n                padding: 1px;\n            }\n\n            &[aria-selected=true],\n            &:hover {\n                color: $dropdown-link-hover-color;\n                @include gradient-bg($dropdown-link-hover-bg);\n            }\n        }\n\n        .no_result {\n            padding: $dropdown-item-padding-y *2 $dropdown-item-padding-x;\n            font-style: italic;\n            font-weight: $font-weight-medium;\n        }\n    }\n}","//\n// vector-maps.scss\n//\n\n.jvm-tooltip {\n    border-radius: 3px;\n    background-color: $primary;\n    font-family: $font-family-base;\n    box-shadow: $box-shadow-lg;\n    padding: 5px 9px;\n}\n\n.jvm-container {\n    text {\n        font-family: $font-family-base;\n        font-size: $font-size-base;\n        fill: var(--#{$prefix}gray-700);\n    }\n}\n\n.jvm-zoom-btn {\n    background-color: $primary;\n}","//\n// _leaflet-maps.scss\n//\n\n.leaflet-map {\n    height: 300px;\n    &.leaflet-container{\n        z-index: 0;\n        font-family: $font-family-primary;\n    }\n}","// \n// _fullcalendar.scss\n// \n\n\n.fc td,\n.fc th {\n    border: $table-border-width solid $table-border-color;\n}\n\n.fc {\n    .fc-toolbar {\n        h2 {\n            font-size: 16px;\n            line-height: 30px;\n            text-transform: uppercase;\n        }\n\n        @media (max-width: 767.98px) {\n\n            .fc-left,\n            .fc-right,\n            .fc-center {\n                float: none;\n                display: block;\n                text-align: center;\n                clear: both;\n                margin: 10px 0;\n            }\n\n            >*>* {\n                float: none;\n            }\n\n            .fc-today-button {\n                display: none;\n            }\n        }\n\n        .btn {\n            text-transform: capitalize;\n        }\n    }\n\n    .fc-col-header-cell {\n        background-color: var(--#{$prefix}light);\n    }\n\n    .fc-col-header-cell-cushion {\n        display: block;\n        padding: 8px 4px;\n    }\n\n    .fc-daygrid-day-number {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n        font-weight: $font-weight-medium;\n        margin: 2px;\n    }\n\n    .fc-daygrid-day {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n    \n            .fc-daygrid-day-number {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n\n    .fc-daygrid-day {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n        }\n    }\n    \n    .fc-timegrid-col {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n        }\n    }\n\n    .fc-list-event:hover td {\n        background: transparent;\n    }\n\n    .fc-list-event-title {\n        a {\n            color: $white !important;\n        }\n    }\n\n    .fc-col-header,\n    .fc-daygrid-body,\n    .fc-scrollgrid-sync-table {\n        width: 100% !important;\n    }\n\n    .fc-scrollgrid-section>*{\n        border-left: $table-border-width solid $table-border-color;\n        border-top: $table-border-width solid $table-border-color;\n    }\n\n    .fc-scrollgrid-section-liquid>td{\n        border-top: 0;\n    }\n}\n\n.fc-theme-bootstrap a:not([href]) {\n    color: var(--#{$prefix}body-color);\n}\n\n.fc-event {\n    color: $white;\n}\n\n.fc {\n    th.fc-widget-header {\n        background: $gray-300;\n        line-height: 20px;\n        padding: 10px 0;\n        text-transform: uppercase;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.fc-unthemed {\n\n    .fc-content,\n    .fc-divider,\n    .fc-list-heading td,\n    .fc-list-view,\n    .fc-popover,\n    .fc-row,\n    tbody,\n    td,\n    th,\n    thead {\n        border-color: $gray-300;\n    }\n\n    td.fc-today {\n        background: lighten($gray-200, 2%);\n    }\n}\n\n.fc-button {\n    background: var(--#{$prefix}card-bg-custom);\n    border-color: $border-color;\n    color: $gray-700;\n    text-transform: capitalize;\n    box-shadow: none;\n    padding: 6px 12px !important;\n    height: auto !important;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n    background-color: $primary;\n    color: $white;\n    text-shadow: none;\n}\n\n.fc-event {\n    border-radius: 2px;\n    border: none;\n    cursor: move;\n    font-size: 0.8125rem;\n    margin: 5px 7px;\n    padding: 5px 5px;\n    text-align: center;\n}\n\n.fc-event,\n.fc-event-dot {\n    background-color: $primary;\n}\n\n.fc-daygrid-dot-event.fc-event-mirror,\n.fc-daygrid-dot-event:hover {\n    background-color: $primary;\n}\n\n// .fc-daygrid-dot-event {\n//     color: $white !important;\n// }\n\n.fc-event-title,\n.fc-sticky {\n    font-weight: $font-weight-semibold !important;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.fc-daygrid-event-dot {\n    border-color: $white !important;\n    display: none;\n}\n\n.fc-event-time {\n    display: none;\n}\n\n.fc-event .fc-content {\n    color: $white;\n}\n\n#external-events {\n    .external-event {\n        text-align: left;\n        padding: 8px 16px;\n        margin: 6px 0;\n    }\n}\n\n\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\n    .fc-content {\n        color: $light;\n    }\n}\n\n.fc-prev-button,\n.fc-next-button {\n    position: relative;\n    height: 37.5px;\n    width: 37.5px;\n\n    &::before {\n        position: absolute;\n        font-family: remixicon !important;\n        font-size: 20px;\n        top: 0;\n        bottom: 0px;\n        left: 0;\n        right: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.fc-prev-button {\n    &::before {\n        content: \"\\ea64\";\n    }\n}\n\n.fc-next-button {\n    &::before {\n        content: \"\\ea6e\";\n    }\n}\n\n.fc-toolbar-chunk {\n    .btn-group {\n        box-shadow: $element-shadow;\n        .btn {\n            color: $secondary;\n            background-color: rgba($secondary, 0.15);\n            border: none;\n            box-shadow: none;\n\n            &:hover,\n            &.active {\n                color: $white;\n                background-color: $secondary;\n            }\n        }\n    }\n\n    .fc-today-button {\n        background-color: $secondary !important;\n        border: $secondary;\n    }\n}\n\n.fc-toolbar {\n    @media (max-width: 575.98px) {\n        flex-direction: column;\n        gap: 16px;\n    }\n}\n\n#upcoming-event-list {\n    .card {\n        &:last-child {\n            margin-bottom: 6px !important;\n        }\n    }\n}\n\n#event-modal {\n    .event-details {\n        display: none;\n    }\n\n    .view-event {\n        .event-form {\n            display: none;\n        }\n\n        #event-category-tag {\n            display: none;\n        }\n\n        .event-details {\n            display: block;\n        }\n    }\n}\n\n.fc-daygrid-event-harness {\n    .fc-daygrid-event {\n        backdrop-filter: blur(4px);\n    }\n}\n\n.fc-timegrid-event-harness {\n    .fc-timegrid-event {\n        backdrop-filter: blur(4px);\n    }\n}\n\n\n.fc-timegrid-slots {\n    table {\n        tr {\n            border-color: $border-color !important;\n        }\n    }\n}\n\n.fc-list-table {\n    border-color: $border-color;\n}\n\n@each $color,\n$value in $theme-colors {\n    .fc-daygrid-event-harness {\n        .fc-daygrid-event {\n            &.bg-soft-#{$color} {\n\n                .fc-event-title,\n                .fc-event-main {\n                    color: $value !important;\n                }\n            }\n        }\n    }\n\n    .fc-timegrid-event-harness {\n        .fc-timegrid-event {\n            &.bg-soft-#{$color} {\n                .fc-event-title {\n                    color: $value !important;\n                }\n            }\n        }\n    }\n\n    .fc-list-table {\n        .fc-list-event {\n            &.bg-soft-#{$color} {\n                color: $value !important;\n\n                .fc-list-event-title {\n                    >a {\n                        color: $value !important;\n                    }\n                }\n\n                .fc-list-event-dot {\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark{\n    .fc-event-main, .fc-event-title {\n        color:  var(--#{$prefix}dark) !important;\n    }\n}\n\n.fc-direction-ltr{\n    direction: ltr;\n    .fc-toolbar>*>:not(:first-child){\n        margin-left: 0.75em;\n    }\n}","//\n// emoji-picker.scss\n//\n\n.fg-emoji-picker{\n    width: 250px !important;\n    box-shadow: $box-shadow !important;\n    top: auto !important;\n    bottom: 130px;\n\n    *{\n        font-family: $font-family-base !important;\n        color: var(--#{$prefix}body-color) !important;\n    }\n    @media (max-width:991.98px) {\n        left: 14px !important;\n        top: auto !important;\n        bottom: 118px;\n    }\n\n    .fg-emoji-picker-container-title{\n        color: $dark !important;\n    }\n\n    .fg-emoji-picker-search{\n        height: 40px !important;\n        input{\n            background-color: $input-bg !important;\n            color: $input-color !important;\n            padding: $input-btn-padding-y $input-btn-padding-x !important;\n            font-size: $font-size-base !important;\n            &::placeholder{\n                color: $input-placeholder-color !important;\n            }\n        }\n\n        svg{\n            fill: var(--#{$prefix}body-color) !important;\n            right: 11px;\n            top: 12px;\n        }\n    }\n\n    .fg-emoji-picker-categories{\n        background-color: $light !important;\n        li.active{\n            background-color: rgba(var(--bs-primary-rgb), 0.2);\n        }\n        a{\n            &:hover{\n                background-color: rgba(var(--bs-primary-rgb), 0.2);\n            }\n        }\n        \n    }\n}\n\n.fg-emoji-picker-grid > li:hover{\n    background-color: rgba(var(--bs-primary-rgb), 0.2) !important;\n}\n\na.fg-emoji-picker-close-button{\n    background-color: darken($light, 4%) !important;\n}","//\n// _datatables.scss\n//\n\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n    text-align: center;\n    padding: 50px;\n    font-weight: $font-weight-semibold;\n    --vz-table-accent-bg: var(--#{$prefix}card-bg-custom);\n}\n\ntable.dataTable>thead .sorting:before,\ntable.dataTable>thead .sorting_asc:before,\ntable.dataTable>thead .sorting_desc:before,\ntable.dataTable>thead .sorting_asc_disabled:before,\ntable.dataTable>thead .sorting_desc_disabled:before {\n    content:\"\\f0360\";\n    position: absolute;\n    right: 0.5rem;\n    top: 12px;\n    font-size: .8rem;\n    font-family: \"Material Design Icons\";\n}\n\ntable.dataTable>thead .sorting:after,\ntable.dataTable>thead .sorting_asc:after,\ntable.dataTable>thead .sorting_desc:after,\ntable.dataTable>thead .sorting_asc_disabled:after,\ntable.dataTable>thead .sorting_desc_disabled:after {\n    content: \"\\f035d\";\n    position: absolute;\n    right: 0.5rem;\n    top: 18px;\n    font-size: .8rem;\n    font-family: \"Material Design Icons\";\n}\n\ntable.dataTable>tbody>tr.child span.dtr-title {\n    font-weight: $font-weight-semibold;\n    min-width: 150px;\n}\n\n\n//responsive \ntable {\n    &.dataTable {\n        &.dtr-inline {\n            &.collapsed {\n                >tbody {\n                    >tr {\n\n                        >th,\n                        >td {\n                            &.dtr-control {\n                                &::before {\n                                    background-color: $primary;\n                                    border-color: var(--#{$prefix}card-bg-custom);\n                                }\n                            }\n                        }\n\n                        &.parent {\n                            &.parent {\n                                >th {\n                                    &.dtr-control {\n                                        &::before {\n                                            background-color: $danger;\n                                        }\n                                    }\n                                }\n                            }\n\n                            >td {\n                                &.dtr-control {\n                                    &::before {\n                                        background-color: $danger;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        >tbody {\n            >tr {\n                &.child {\n                    span {\n                        &.dtr-title {\n                            min-width: 135px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n.table-card {\n\n    .dataTables_length,\n    .dataTables_filter {\n        padding: $card-cap-padding-y $card-cap-padding-x;\n        padding-bottom: 0px;\n    }\n\n    .dataTables_info,\n    .dataTables_paginate {\n        padding: $card-cap-padding-y $card-cap-padding-x;\n    }\n\n    div.dataTables_wrapper {\n        .col-md-6 {\n            width: 100%;\n        }\n\n        div {\n            &.dataTables_filter {\n                input {\n                    width: calc(100% - 52px);\n                }\n\n                label {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n\ndiv{\n    &.dtr-modal {\n        div {\n            &.dtr-modal-display {\n                background-color: $modal-content-bg;\n                border-color: $border-color;\n                box-shadow: none;\n                height: 70%;\n            }\n            &.dtr-modal-content {\n                padding: $modal-inner-padding;\n                h2 {\n                    font-size: $font-size-lg;\n                    font-weight: $font-weight-semibold;\n                    margin-bottom: 15px;\n                }\n                .dtr-details{\n                    tr {\n                        td {\n                            padding: $table-cell-padding-y $table-cell-padding-x;\n                        }\n                    }\n                }\n            }\n            &.dtr-modal-close {\n                font-size: 24px;\n                top: 9px;\n                right: 11px;\n                width: 30px;\n                height: 30px;\n                line-height: 30px;\n                background-color: var(--#{$prefix}card-bg-custom);\n                border-color: $border-color;\n                &:hover {\n                    background-color: var(--#{$prefix}light);\n                }\n            }\n        }\n    }\n}\n\n.dt-buttons {\n    button.dt-button,\n    div.dt-button,\n    a.dt-button,\n    input.dt-button {\n        border-color: $border-color;\n        background: var(--#{$prefix}light);\n        color: var(--#{$prefix}gray-800);\n    }\n}\n\n.rdt_Table{\n\t.rdt_TableBody{\n        .rdt_TableRow{\n        background-color :$table-bg;\n        color: $table-color;\n        border-bottom-color :$table-border-color;\n        outline-color :$table-border-color;\n        }\n  }\n}","//\n// Select 2\n//\n\n.select2.select2-container{\n    width: 100% !important;\n}\n.select2-container {\n    .select2-selection--single {\n        border: $input-border-width solid $input-border-color;\n        height: $input-height;\n        background-color: $input-bg;\n        outline: none;\n        .select2-selection__rendered {\n            line-height: 36px;\n            padding-left: 12px;\n            color: $input-color;\n        }\n        .select2-selection__arrow {\n            height: 34px;\n            width: 34px;\n            /*rtl:ignore*/\n            right: 3px;\n            b {\n                border-color: $input-border-color transparent transparent transparent;\n                border-width: 6px 6px 0 6px;\n            }\n        }\n    }\n}\n\n.select2-container--open {\n    .select2-selection--single {\n        .select2-selection__arrow {\n            b {\n                border-color: transparent transparent $input-border-color transparent !important;\n                border-width: 0 6px 6px 6px !important;\n            }\n        }\n    }\n}\n\n.select2-results__option {\n    padding: 6px 12px;\n}\n\n.select2-dropdown {\n    border: $dropdown-border-width solid $dropdown-border-color;\n    box-shadow: $box-shadow;\n    background-color: var(--#{$prefix}choices-bg);\n    z-index: $zindex-modal + 1;\n}\n\n.select2-container--default {\n    .select2-results__option--selected {\n        background-color: $input-disabled-bg;\n    }\n    .select2-search--dropdown {\n        padding: 10px;\n        background-color: var(--#{$prefix}choices-bg);\n        .select2-search__field {\n            outline: none;\n            border: 1px solid $input-border-color;\n            background-color: $input-bg;\n            color: $input-color;\n            border-radius: $input-border-radius;\n        }\n    }\n    .select2-results__option--highlighted[aria-selected] {\n        background-color: $primary;\n    }\n    .select2-results__option[aria-selected=true] {\n        background-color: var(--#{$prefix}choices-bg);\n        color: var(--#{$prefix}choices-link-active-color);\n        &:hover {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n    .select2-selection--multiple {\n        .select2-selection__choice__display {\n            padding-left: 36px;\n            padding-right: 5px;\n        }\n    }\n    .select2-selection--single {\n        .select2-selection__arrow {\n            /*rtl:ignore*/\n            right: 1px;\n            /*rtl:ignore*/\n            left: auto;\n        }\n    }\n    \n}\n\n.select2-container {\n    .select2-selection--multiple {\n        min-height: $input-height;\n        border: $input-border-width solid $input-border-color !important;\n        background-color: $input-bg;\n\n        .select2-selection__rendered {\n            padding: 1px 4px;\n        }\n        .select2-search__field {\n            border: 0;\n            color: $input-color;\n        }\n        .select2-selection__choice {\n            background-color: $primary;\n            border: none;\n            color: $white;\n            border-radius: 3px;\n            padding: 3px;\n            margin-top: 6px;\n        }\n        .select2-selection__choice__remove {\n            color: $white;\n            margin-right: 7px;\n            border-color: tint-color($primary, 10%);\n            padding: 0 8px;\n            top: 3px;\n            &:hover {\n                color: $white;\n                background-color: $primary;\n            }\n        }\n    }\n    .select2-search--inline {\n        .select2-search__field {\n            margin-top: 7px;\n            font-family: $font-family-base;\n        }\n    }\n    .select2-search {\n        textarea {\n            &::placeholder {\n                color: $input-placeholder-color;\n            }\n        }\n    }\n}\n\n.select2-container--default{\n    &.select2-container--disabled {\n        .select2-selection--single, .select2-selection--multiple {\n            background-color: $input-disabled-bg;\n            cursor: default;\n        }\n    }\n}\n","// \n// toastify.scss\n// \n\n\n.toastify {\n    padding: 12px 16px;\n    color: $white;\n    display: inline-block;\n    box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);\n    background: $success;\n    position: fixed;\n    opacity: 0;\n    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n    border-radius: 2px;\n    cursor: pointer;\n    text-decoration: none;\n    max-width: calc(50% - 20px);\n    z-index: 2147483647;\n    &.on {\n        opacity: 1;\n    }\n}\n\n\n.toast-close {\n    opacity: 0.4;\n    padding: 0 5px;\n    position: relative;\n    left: 4px;\n    margin-left: 4px;\n    border: none;\n    background: none;\n}\n\n.toastify-right {\n    right: 15px;\n}\n\n.toastify-left {\n    left: 15px;\n    .toast-close {\n        left: -4px;\n        margin-left: 0;\n        margin-right: 4px;\n    }\n}\n\n.toastify-top {\n    top: -150px;\n}\n\n.toastify-bottom {\n    bottom: -150px;\n}\n\n.toastify-rounded {\n    border-radius: 25px;\n}\n\n.toastify-avatar {\n    width: 1.5em;\n    height: 1.5em;\n    margin: -7px 5px;\n    border-radius: 2px;\n}\n\n.toastify-center {\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    max-width: fit-content;\n    max-width: -moz-fit-content;\n}\n\n@media only screen and (max-width: 360px) {\n    .toastify-right, .toastify-left {\n        margin-left: auto;\n        margin-right: auto;\n        left: 0;\n        right: 0;\n        max-width: fit-content;\n    }\n}","//\n// _choices.scss\n//\n\n.choices {\n    position: relative;\n    margin-bottom: 24px;\n    font-size: 16px;\n\n    &:focus {\n        outline: none;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    &.is-disabled{\n        .choices__inner,\n        .choices__input {\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n            cursor: not-allowed;\n            user-select: none;\n        }\n\n        .choices__item {\n            cursor: not-allowed;\n        }\n    }\n\n    [hidden] {\n        display: none !important;\n    }\n    \n    // data-type = select-one\n    &[data-type*='select-one'] {\n        cursor: pointer;\n        .choices__inner{\n            padding-bottom: 0.25rem;\n        }\n\n        .choices__input{\n            display: block;\n            width: 100%;\n            padding: $input-padding-y $input-padding-x;\n            background-color: $input-bg;\n            border: 1px solid $input-border-color;\n            font-size: $input-font-size;\n            border-radius: $input-border-radius;\n            color: $input-color;\n            margin-bottom: 10px;\n        }\n\n        .choices__button{\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n            padding: 0;\n            background-size: 8px;\n            position: absolute;\n            top: 50%;\n            right: 0;\n            left: auto;\n            margin-top: -10px;\n            margin-right: 25px;\n            margin-left: 0;\n            height: 20px;\n            width: 20px;\n            border-radius: 10em;\n            opacity: 0.5;\n\n            &:hover, &:focus {\n                opacity: 1;\n            }\n\n            &:focus {\n                box-shadow: 0px 0px 0px 2px #00bcd4;\n            }\n        }\n\n        .choices__item[data-value=''] .choices__button {\n            display: none;\n        }\n\n        &:after {\n            content: \"\\F0140\";\n            position: absolute;\n            border: 0;\n            border-color: $dark transparent transparent;\n            right: 11.5px;\n            left: auto;\n            font-family: 'Material Design Icons';\n            width: auto;\n            height: auto;\n            margin-top: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            pointer-events: none;\n        }\n\n        &.is-open:after {\n            margin-top: 0;\n            transform: translateY(-50%) rotate(-180deg);\n        }\n\n    }\n\n\n    // data-type = select- multiple & text\n\n    &[data-type*='select-multiple'],\n    &[data-type*='text'] {\n        .choices__inner {\n            cursor: text;\n            padding-right: $form-select-padding-x;\n        }\n\n        .choices__button {\n            position: relative;\n            display: inline-block;\n            margin-top: 0;\n            margin-right: -4px;\n            margin-bottom: 0;\n            margin-left: 8px;\n            padding-left: 16px;\n            border-left: 1px solid rgba($white, 0.5);\n            border-right: 0;\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n            background-size: 8px;\n            width: 8px;\n            line-height: 1;\n            opacity: 0.75;\n            border-radius: 0;\n            &:hover, &:focus {\n                opacity: 1;\n            }\n        }\n        .choices__list--dropdown{\n            padding-bottom: 10px;\n            .choices__list{\n                margin-bottom: 0;\n            }\n        }\n    }\n\n    &[data-type*=select-multiple] {\n        .choices__input {\n            padding-top: 3px;\n        }\n    }\n}\n\n//Select Light\n.input-light {\n    .choices__inner { \n        background-color: var(--#{$prefix}light);\n        border: none;\n    }\n}\n  \n.choices__inner {\n    display: inline-block;\n    vertical-align: middle;\n    width: 100%;\n    background-color: $form-select-bg;\n    padding: 0.25rem ($form-select-padding-x + $form-select-indicator-padding) 0.1rem 0.5rem;\n    border: $form-select-border-width solid $form-select-border-color;\n    border-radius: $form-select-border-radius !important;\n    font-size: $input-font-size;\n    min-height: 37.5px;\n    overflow: hidden;\n}\n\n  \n.is-focused,\n.is-open {\n    .choices__inner {\n        border-color: $input-focus-border-color;\n    }\n}\n  \n.choices__list {\n    margin: 0;\n    padding-left: 0;\n    list-style: none;\n}\n  \n.choices__list--single {\n    display: inline-block;\n    padding: 4px 16px 4px 4px;\n    width: 100%;\n\n    .choices__item {\n        width: 100%;\n    }\n}\n\n.choices__list--multiple {\n    display: inline;\n    .choices__item {\n        display: inline-block;\n        vertical-align: initial;\n        border-radius: 7px;\n        padding: 2px 7px;\n        font-size: 11px;\n        font-weight: $font-weight-normal;\n        margin-right: 3.75px;\n        margin-bottom: 3.75px;\n        margin-top: 2px;\n        background-color: $primary;\n        border: 1px solid $primary;\n        word-break: break-all;\n        box-sizing: border-box;\n        color: $white;\n        box-shadow: $element-shadow;\n        &[data-deletable] {\n            padding-right: 5px;\n        }\n\n        &.is-highlighted {\n            background-color: $primary;\n            border: 1px solid $primary;\n        }\n    }\n}\n\n  \n.is-disabled {\n    .choices__list--multiple {\n        .choices__item {\n            background-color: $secondary;\n            border: 1px solid $secondary\n        }\n    }\n}\n  \n.choices__list--dropdown {\n    visibility: hidden;\n    z-index: 1;\n    position: absolute;\n    width: 100%;\n    background-color: var(--#{$prefix}choices-bg);\n    border: 1px solid var(--#{$prefix}border-color);\n    box-shadow: $dropdown-box-shadow;\n    top: 100%;\n    margin-top: 0;\n    padding: 10px 10px 20px 10px;\n    border-bottom-left-radius: 2.5px;\n    border-bottom-right-radius: 2.5px;\n    overflow: hidden;\n    word-break: break-all;\n    will-change: visibility;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    transform: translateY(1px);\n    &.is-active {\n        visibility: visible;\n        animation-name: DropDownSlide;\n    }\n\n    .choices__item--selectable.is-highlighted {\n        background-color: var(--#{$prefix}choices-link-hover-bg);\n    }\n\n    .choices__list {\n        margin: 0 -16px -16px;\n    }\n\n    .has-no-results {\n        font-style: italic;\n        font-weight: $font-weight-medium;\n    }\n\n    .choices__item--selectable:after{\n        display: none;\n    }\n}\n  \n.is-open{\n    .choices__list--dropdown {\n        border-color: $dropdown-border-color;\n    }\n}\n  \n.is-flipped{\n    .choices__list--dropdown {\n        top: auto;\n        bottom: 100%;\n        margin-top: 0;\n        margin-bottom: -1px;\n        border-radius: 0.25rem 0.25rem 0 0;\n        &.is-active {\n            animation-name: DropDownSlideDown;\n            transform: translateY(-1px);\n        }\n    }\n}\n  \n.choices__list--dropdown{\n    .choices__list {\n        position: relative;\n        max-height: 300px;\n        overflow: auto;\n        -webkit-overflow-scrolling: touch;\n        will-change: scroll-position;\n    }\n\n    .choices__item {\n        position: relative;\n        font-size: $dropdown-font-size;\n        padding: $dropdown-item-padding-y $dropdown-item-padding-x $dropdown-item-padding-y 16px;\n    }\n}\n  \n\n  \n@media (min-width: 640px) {\n    .choices__list--dropdown {\n        .choices__item--selectable {\n\n            &:after {\n                content: attr(data-select-text);\n                font-size: 12px;\n                opacity: 0;\n                position: absolute;\n                right: 10px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n\n            &.is-highlighted {\n                &:after {\n                    opacity: 0.5;\n                }\n            }\n        }\n    }\n    \n\n}\n  \n.choices__item {\n    cursor: default;\n}\n  \n.choices__item--selectable {\n    cursor: pointer;\n}\n  \n.choices__item--disabled {\n    cursor: not-allowed;\n    user-select: none;\n    opacity: 0.5;\n}\n  \n.choices__heading {\n    font-weight: $font-weight-semibold;\n    font-size: 12px;\n    padding: 10px 16px;\n    border-bottom: 1px solid $border-color;\n    color: $text-muted;\n}\n  \n.choices__button {\n    text-indent: -9999px;\n    appearance: none;\n    border: 0;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: center;\n    cursor: pointer;\n    &:focus {\n        outline: none;\n    }\n}\n  \n.choices__input {\n    display: inline-block;\n    vertical-align: baseline;\n    background-color: $input-bg;\n    color: $input-color;\n    font-size: $input-font-size;\n    margin-bottom: 0;\n    border: 0;\n    border-radius: 0;\n    max-width: 100%;\n    padding: 2px 0 2px 2px;\n    &:focus {\n        outline: 0;\n    }\n    &::placeholder {\n        color: $input-placeholder-color;\n    }\n}\n  \n.choices__placeholder {\n    color: $input-placeholder-color;\n    opacity: 1;\n}\n\n\n[data-layout-mode=\"dark\"]{\n    .choices[data-type*=select-one]{\n        .choices__button{\n            filter: $btn-close-white-filter;\n        }\n    }\n}","//\n// _flatpicker.scss\n//\n\n.flatpickr-calendar {\n    background: transparent;\n    opacity: 0;\n    display: none;\n    text-align: center;\n    visibility: hidden;\n    padding: 0;\n    animation: none;\n    direction: ltr;\n    border: 0;\n    font-size: 14px;\n    line-height: 24px;\n    border-radius: 5px;\n    position: absolute;\n    width: 307.875px;\n    box-sizing: border-box;\n    touch-action: manipulation;\n    background: var(--#{$prefix}choices-bg);\n    box-shadow: 1px 0 0 $border-color, -1px 0 0 $border-color, 0 1px 0 $border-color, 0 -1px 0 $border-color, 0 3px 13px rgba(0, 0, 0, 0.08);\n\n    &.open,\n    &.inline {\n        opacity: 1;\n        max-height: 640px;\n        visibility: visible;\n    }\n\n    &.open {\n        display: inline-block;\n        z-index: 1056;\n    }\n\n    &.animate.open {\n            animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n    }\n\n    &.inline {\n        display: block;\n        position: relative;\n        top: 2px;\n        width: 100%;\n        box-shadow: none;\n\n        .flatpickr-rContainer {\n            display: block;\n            width: 100%;\n\n            .flatpickr-days {\n                width: 100%;\n                border: $input-border-width solid $input-border-color;\n                border-top: none;\n                border-radius: 0 0 5px 5px;\n\n\n                .dayContainer {\n                    width: 100%;\n                    min-width: 100%;\n                    max-width: 100%;\n\n                    .flatpickr-day {\n                        max-width: 100%;\n                        border-radius: 4px;\n                    }\n                }\n            }\n        }\n\n        .flatpickr-time {\n            border: $input-border-width solid $input-border-color !important;\n            border-radius: $input-border-radius;\n        }\n    }\n\n    &.static {\n        position: absolute;\n        top: calc(100% + 2px);\n        &.open {\n            z-index: 999;\n            display: block;\n        }\n    }\n\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\n        box-shadow: none !important;\n    }\n\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n        box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n    }\n\n    .hasWeeks .dayContainer,\n    .hasTime .dayContainer {\n        border-bottom: 0;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .hasWeeks .dayContainer {\n        border-left: 0;\n    }\n\n    &.hasTime .flatpickr-time {\n        height: 40px;\n        border-top: 1px solid $border-color;\n    }\n\n    &.noCalendar.hasTime .flatpickr-time {\n        height: auto;\n    }\n\n    &::before,\n    &::after {\n        position: absolute;\n        display: block;\n        pointer-events: none;\n        border: solid transparent;\n        content: '';\n        height: 0;\n        width: 0;\n        left: 22px;\n    }\n\n    &.rightMost::before,\n    &.arrowRight::before,\n    &.rightMost::after,\n    &.arrowRight::after {\n      left: auto;\n      right: 22px;\n    }\n\n    &.arrowCenter::before,\n    &.arrowCenter::after {\n      left: 50%;\n      right: 50%;\n    }\n\n    &::before {\n        border-width: 5px;\n        margin: 0 -5px;\n    }\n    &::after {\n        border-width: 4px;\n        margin: 0 -4px;\n    }\n\n    &.arrowTop::before,\n    &.arrowTop::after {\n        bottom: 100%;\n    }\n    &.arrowTop::before {\n        border-bottom-color: $primary;\n    }\n    &.arrowTop::after {\n        border-bottom-color: $primary;\n    }\n\n    &.arrowBottom::before,\n    &.arrowBottom::after {\n        top: 100%;\n    }\n    &.arrowBottom::before {\n        border-top-color: $primary;\n    }\n    &.arrowBottom::after {\n        border-top-color: $primary;\n    }\n    &:focus {\n        outline: 0;\n    }\n}\n\n.flatpickr-wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.flatpickr-months {\n    display: flex;\n    background-color: $primary;\n    border-radius: 5px 5px 0px 0px;\n\n    .flatpickr-month {\n        background: transparent;\n        color: rgba($white, 0.9);\n        fill: rgba($white, 0.9);\n        height: 34px;\n        line-height: 1;\n        text-align: center;\n        position: relative;\n        user-select: none;\n        overflow: hidden;\n        flex: 1;\n    }\n\n    .flatpickr-prev-month,\n    .flatpickr-next-month {\n        text-decoration: none;\n        cursor: pointer;\n        position: absolute;\n        top: 0;\n        height: 34px;\n        padding: 10px;\n        z-index: 3;\n        color: rgba($white, 0.9);\n        fill: rgba($white, 0.9);\n\n        &.flatpickr-disabled{\n          display: none;\n        }\n\n        i {\n            position: relative;\n        }\n\n        &.flatpickr-prev-month {\n            /*\n                  /*rtl:begin:ignore*/\n            /*\n                  */\n              left: 0;\n            /*\n                  /*rtl:end:ignore*/\n            /*\n                  */\n        }\n          /*\n        /*rtl:begin:ignore*/\n        /*\n        /*rtl:end:ignore*/\n\n        &.flatpickr-next-month {\n            /*\n                  /*rtl:begin:ignore*/\n            /*\n                  */\n              right: 0;\n            /*\n                  /*rtl:end:ignore*/\n            /*\n                  */\n        }\n          /*\n        /*rtl:begin:ignore*/\n        /*\n        /*rtl:end:ignore*/\n\n        &:hover {\n            color: #959ea9;\n\n            svg {\n                fill: rgba($white, 0.9);\n            }\n        }\n\n        svg {\n            width: 14px;\n            height: 14px;\n\n            path {\n                transition: fill 0.1s;\n                fill: inherit;\n            }\n        }\n    }\n}\n\n.numInputWrapper {\n    position: relative;\n    height: auto;\n\n    input,\n    span {\n        display: inline-block;\n    }\n\n    input {\n        width: 100%;\n\n        &::-ms-clear {\n            display: none;\n        }\n\n        &::-webkit-outer-spin-button,\n        &::-webkit-inner-spin-button {\n            margin: 0;\n            -webkit-appearance: none;\n        }\n    }\n\n    span {\n        position: absolute;\n        right: 0;\n        width: 14px;\n        padding: 0 4px 0 2px;\n        height: 50%;\n        line-height: 50%;\n        opacity: 0;\n        cursor: pointer;\n        border: 1px solid rgba(var(--#{$prefix}dark-rgb),0.15);\n        box-sizing: border-box;\n\n        &:hover {\n            background: rgba(0,0,0,0.1);\n        }\n\n        &:active {\n            background: rgba(0,0,0,0.2);\n        }\n\n        &:after {\n            display: block;\n            content: \"\";\n            position: absolute;\n        }\n\n        &.arrowUp {\n            top: 0;\n            border-bottom: 0;\n\n            &:after {\n                border-left: 4px solid transparent;\n                border-right: 4px solid transparent;\n                border-bottom: 4px solid rgba(57,57,57,0.6);\n                top: 26%;\n            }\n        }\n\n        &.arrowDown {\n            top: 50%;\n\n            &:after {\n                border-left: 4px solid transparent;\n                border-right: 4px solid transparent;\n                border-top: 4px solid rgba(57,57,57,0.6);\n                top: 40%;\n            }\n        }\n\n        svg {\n            width: inherit;\n            height: auto;\n\n            path {\n                fill: rgba(0,0,0,0.5);\n            }\n        }\n    }\n\n\n    &:hover {\n        background: rgba(0,0,0,0.05);\n        span {\n            opacity: 1;\n        }\n    }\n}\n\n.flatpickr-current-month {\n    font-size: 100%;\n    line-height: inherit;\n    font-weight: 300;\n    color: inherit;\n    position: absolute;\n    width: 75%;\n    left: 12.5%;\n    padding: 7.48px 0 0 0;\n    line-height: 1;\n    height: 34px;\n    display: inline-block;\n    text-align: center;\n    transform: translate3d(0px, 0px, 0px);\n\n    span.cur-month {\n        font-family: inherit;\n        font-weight: 700;\n        color: inherit;\n        display: inline-block;\n        margin-left: 0.5ch;\n        padding: 0;\n\n        &:hover {\n            background: rgba(0,0,0,0.05);\n        }\n    }\n\n    .numInputWrapper {\n        width: 6ch;\n        width: 7ch\\0;\n        display: inline-block;\n    }\n\n    span{\n        &.arrowUp::after {\n            border-bottom-color: rgba(0,0,0,0.9);\n        }\n        &.arrowDown:after {\n            border-top-color: rgba(0,0,0,0.9);\n        }\n    }\n\n    input.cur-year {\n        background: transparent;\n        box-sizing: border-box;\n        color: inherit;\n        cursor: text;\n        padding: 0 0 0 0.5ch;\n        margin: 0;\n        display: inline-block;\n        font-size: inherit;\n        font-family: inherit;\n        font-weight: $font-weight-semibold;\n        line-height: inherit;\n        height: auto;\n        border: 0;\n        border-radius: 0;\n        vertical-align: initial;\n        appearance: textfield;\n\n        &:focus {\n            outline: 0;\n        }\n\n        &[disabled],\n        &[disabled]:hover {\n            font-size: 100%;\n            color: rgba($white, 0.9);\n            background: transparent;\n            pointer-events: none;\n        }\n    }\n\n    .flatpickr-monthDropdown-months {\n        appearance: menulist;\n        background: transparent;\n        border: none;\n        border-radius: 0;\n        box-sizing: border-box;\n        color: inherit;\n        cursor: pointer;\n        font-size: inherit;\n        font-family: inherit;\n        font-weight: $font-weight-semibold;\n        height: auto;\n        line-height: inherit;\n        margin: -1px 0 0 0;\n        outline: none;\n        padding: 0 0 0 0.5ch;\n        position: relative;\n        vertical-align: initial;\n        width: auto;\n\n        &:focus,\n        &:active {\n            outline: none;\n        }\n\n        &:hover {\n            background-color: transparent;\n        }\n\n        .flatpickr-monthDropdown-month {\n            background-color: transparent;\n            outline: none;\n            padding: 0;\n            color: rgba($black, 0.8);\n        }\n    }\n}\n\n\n.flatpickr-weekdays {\n    background-color: $primary;\n    text-align: center;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    height: 36px;\n    border-bottom: 1px solid $border-color;\n    .flatpickr-weekdaycontainer {\n        display: flex;\n        flex: 1;\n    }\n}\n\nspan.flatpickr-weekday {\n    cursor: default;\n    font-size: 90%;\n    background: $primary;\n    color: $white;\n    line-height: 1;\n    margin: 0;\n    text-align: center;\n    display: block;\n    flex: 1;\n    font-weight: $font-weight-medium;\n}\n\n.dayContainer,\n.flatpickr-weeks {\n    padding: 1px 0 0 0;\n}\n.flatpickr-days {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: flex-start;\n    width: 307.875px;\n    &:focus {\n        outline: 0;\n    }\n}\n\n.dayContainer {\n    padding: 0;\n    outline: 0;\n    text-align: left;\n    width: 307.875px;\n    min-width: 307.875px;\n    max-width: 307.875px;\n    box-sizing: border-box;\n    display: inline-block;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    transform: translate3d(0px, 0px, 0px);\n    opacity: 1;\n    + .dayContainer {\n        box-shadow: -1px 0 0 #e6e6e6;\n    }\n}\n\n.flatpickr-day {\n    background: none;\n    border: 1px solid transparent;\n    border-radius: 150px;\n    box-sizing: border-box;\n    color: var(--#{$prefix}body-color);\n    cursor: pointer;\n    font-weight: 400;\n    width: 14.2857143%;\n    flex-basis: 14.2857143%;\n    max-width: 39px;\n    height: 39px;\n    line-height: 39px;\n    margin: 0;\n    display: inline-block;\n    position: relative;\n    justify-content: center;\n    text-align: center;\n\n    &:hover,\n    &:focus {\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.7);\n    }\n\n    &.inRange,\n    &.prevMonthDay.inRange,\n    &.nextMonthDay.inRange,\n    &.today.inRange,\n    &.prevMonthDay.today.inRange,\n    &.nextMonthDay.today.inRange,\n    &:hover,\n    &.prevMonthDay:hover,\n    &.nextMonthDay:hover,\n    &:focus,\n    &.prevMonthDay:focus,\n    &.nextMonthDay:focus {\n        cursor: pointer;\n        outline: 0;\n        background-color: var(--#{$prefix}light);\n        border-color: var(--#{$prefix}light);\n    }\n\n    &.today {\n        border-color: $primary;\n        background-color: rgba($primary, 0.1);\n        box-shadow: $element-shadow;\n\n        &:hover,\n        &:focus {\n            border-color: $primary;\n            background-color: rgba($primary, 0.15);\n            color: var(--#{$prefix}dark);\n        }\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange,\n    &.selected.inRange,\n    &.startRange.inRange,\n    &.endRange.inRange,\n    &.selected:focus,\n    &.startRange:focus,\n    &.endRange:focus,\n    &.selected:hover,\n    &.startRange:hover,\n    &.endRange:hover,\n    &.selected.prevMonthDay,\n    &.startRange.prevMonthDay,\n    &.endRange.prevMonthDay,\n    &.selected.nextMonthDay,\n    &.startRange.nextMonthDay,\n    &.endRange.nextMonthDay {\n        background: $primary;\n        box-shadow: $element-shadow;\n        color: $white;\n        border-color: $primary;\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange{\n        &.startRange {\n            border-radius: 50px 0 0 50px;\n            + .endRange:not(:nth-child(7n+1)) {\n                box-shadow: -10px 0 0 $primary;\n            }\n\n            .endRange{\n                border-radius: 50px;\n            }\n        }\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange{\n        &.endRange {\n            border-radius: 0 50px 50px 0;\n        }\n    }\n\n    &.inRange {\n        border-radius: 0;\n        box-shadow: -5px 0 0 var(--#{$prefix}light), 5px 0 0 var(--#{$prefix}light);\n    }\n\n    &.flatpickr-disabled,\n    &.flatpickr-disabled:hover,\n    &.prevMonthDay,\n    &.nextMonthDay,\n    &.notAllowed,\n    &.notAllowed.prevMonthDay,\n    &.notAllowed.nextMonthDay {\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\n        background: transparent;\n        border-color: transparent;\n        cursor: default;\n    }\n\n    &.flatpickr-disabled,\n    &.flatpickr-disabled:hover {\n        cursor: not-allowed;\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\n    }\n\n    &.week.selected {\n        border-radius: 0;\n        box-shadow: -5px 0 0 $primary, 5px 0 0 $primary;\n    }\n\n    &.hidden {\n        visibility: hidden;\n    }\n}\n\n.rangeMode .flatpickr-day {\n    margin-top: 1px;\n}\n\n.flatpickr-weekwrapper {\n    float: left;\n    .flatpickr-weeks {\n        padding: 0 12px;\n        box-shadow: 1px 0 0 #e6e6e6;\n    }\n\n    .flatpickr-weekday {\n        float: none;\n        width: 100%;\n        line-height: 35px;\n    }\n\n    span{\n        &.flatpickr-day,\n        &.flatpickr-day:hover {\n            display: block;\n            width: 100%;\n            max-width: none;\n            color: rgba(var(--#{$prefix}dark-rgb),0.3);\n            background: transparent;\n            cursor: default;\n            border: none;\n        }\n    }\n}\n\n\n.flatpickr-innerContainer {\n    display: block;\n    display: flex;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n\n.flatpickr-rContainer {\n    display: inline-block;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.flatpickr-time {\n    text-align: center;\n    outline: 0;\n    display: block;\n    height: 0;\n    line-height: 40px;\n    max-height: 40px;\n    box-sizing: border-box;\n    overflow: hidden;\n    display: flex;\n\n    &:after {\n        content: \"\";\n        display: table;\n        clear: both;\n    }\n    .numInputWrapper {\n        flex: 1;\n        width: 40%;\n        height: 40px;\n        float: left;\n        span{\n            &.arrowUp, &.arrowDown{\n                &:after {\n                    border-bottom-color: $border-color;\n                }\n            }\n        }\n    }\n\n    &.hasSeconds .numInputWrapper {\n        width: 26%;\n    }\n\n    &.time24hr .numInputWrapper {\n        width: 49%;\n    }\n\n\n    input {\n        background: transparent;\n        box-shadow: none;\n        border: 0;\n        border-radius: 0;\n        text-align: center;\n        margin: 0;\n        padding: 0;\n        height: inherit;\n        line-height: inherit;\n        color: var(--#{$prefix}body-color);\n        font-size: 14px;\n        position: relative;\n        box-sizing: border-box;\n        appearance: textfield;\n\n        &.flatpickr-hour {\n            font-weight: bold;\n        }\n\n        &.flatpickr-minute,\n        &.flatpickr-second {\n          font-weight: 400;\n        }\n\n        &:focus {\n            outline: 0;\n            border: 0;\n        }\n    }\n\n\n    .flatpickr-time-separator,\n    .flatpickr-am-pm {\n        height: inherit;\n        float: left;\n        line-height: inherit;\n        color: var(--#{$prefix}body-color);\n        font-weight: bold;\n        width: 2%;\n        user-select: none;\n        align-self: center;\n    }\n\n    .flatpickr-am-pm {\n        outline: 0;\n        width: 18%;\n        cursor: pointer;\n        text-align: center;\n        font-weight: 400;\n    }\n\n    input, .flatpickr-am-pm{\n        &:hover, &:focus{\n            background: rgba($primary, 0.04);\n        }\n    }\n}\n\n.flatpickr-am-pm,\n.numInput,\n.numInputWrapper {\n    &:focus,\n    &:hover {\n        background-color: transparent;\n    }\n}\n\n.flatpickr-input[readonly] {\n    cursor: pointer;\n    background-color: $input-bg;\n}\n\n[data-inline-date=\"true\"],[data-time-inline] {\n    display: none;\n}\n\n@keyframes fpFadeInDown {\n    from {\n        opacity: 0;\n        transform: translate3d(0, -20px, 0);\n    }\n    to {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n    }\n}\n  \n[datepicker-inline],\n[timepicker-inline] {\n    display: none;\n}","// flag input\n\n[data-input-flag] {\n    position: relative;\n\n    .dropdown-menu {\n        .dropdown-menu-list {\n            max-height: 158px;\n            overflow-y: auto;\n\n            &::-webkit-scrollbar {\n                -webkit-appearance: none;\n            }\n\n            &::-webkit-scrollbar:vertical {\n                width: 8px;\n            }\n\n            &::-webkit-scrollbar:horizontal {\n                height: 10px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n                border-radius: 8px;\n            }\n\n            &::-webkit-scrollbar-track {\n                border-radius: 8px;\n            }\n        }\n    }\n}\n\n[data-option-flag-img-name] {\n    .flag-input {\n        padding-left: 45px;\n        background-image: url(\"../../images/flags/us.svg\");\n        background-repeat: no-repeat;\n        background-position: 14px 8px;\n        background-size: 18px;\n    }\n}\n\n[data-option-flag-name],\n[data-option-flag-img-name] {\n    &::before {\n        content: \"\\f0140\";\n        font-family: \"Material Design Icons\";\n        position: absolute;\n        right: $input-padding-x;\n        top: $input-padding-y;\n        font-size: 16px;\n    }\n}\n\n[data-option-countrycode=\"false\"] {\n    .country-codeno {\n        display: none;\n    }\n}\n\n[data-search-input=\"false\"] {\n    .searchlist-input {\n        display: none;\n    }\n}","//\n// _authentication.scss\n//\n\n\n.auth-page-wrapper{\n    .auth-page-content{\n        padding-bottom: $footer-height;\n        position: relative;\n        z-index: 2;\n        width: 100%;\n    }\n    .footer{\n        left: 0;\n        background-color: transparent;\n        color: var(--#{$prefix}body-color);\n    }\n}\n\n.auth-one-bg-position{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 580px;\n    \n    @media (max-width: 575.98px) {\n        height: 280px;\n    }\n}\n\n.auth-one-bg{\n    background-image: url(\"../../images/kuzelogo.jpeg\");\n    background-size: cover;\n\n    .bg-overlay{\n        background: linear-gradient(to right, darken($primary, 6%), $primary);\n        opacity: 0.1;\n    }\n}\n\n.shape{\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 1;\n    pointer-events: none;\n    >svg {\n        width: 100%;\n        height: auto;\n        fill: var(--#{$prefix}body-bg);\n    }\n}\n\n// auth-pass-inputgroup\n\n.auth-pass-inputgroup{\n    input[type=\"text\"] + .btn .ri-eye-fill{\n        &:before{\n            content: \"\\ecb6\";\n        }\n    }\n}\n\n.particles-js-canvas-el{\n    position: relative;\n}\n\n// signin card title\n\n.signin-other-title{\n    position: relative;\n    &:after{\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 1px;\n        left: 0;\n        right: 0;\n        border-top: 1px dashed var(--#{$prefix}border-color);\n        top: 10px;\n    }\n\n    .title{\n        display: inline-block;\n        position: relative;\n        z-index: 9;\n        background-color: var(--#{$prefix}card-bg-custom);\n        padding: 2px 16px;\n    }\n}\n\n// Auth cover\n\n.auth-bg-cover{\n    background: $auth-bg-cover;\n\n    > .bg-overlay{\n        background-image: url(\"../../images/cover-pattern.png\");\n        background-position: center;\n        background-size: cover;\n        opacity: 1;\n        background-color: transparent;\n    }\n\n    .footer{\n        color: rgba($white, .5);\n    }\n}\n\n//passowrd validations \n#password-contain {\n    display: none;\n\n    p {\n        padding-left: 13px;\n\n        &.valid {\n            color: $success;\n\n            &::before {\n                position: relative;\n                left: -8px;\n                content: \"✔\";\n            }\n        }\n\n        &.invalid {\n            color: $danger;\n\n            &::before {\n                position: relative;\n                left: -8px;\n                content: \"✖\";\n            }\n        }\n    }\n}","//\n// _dashboard.scss\n//\n\n.dash-filter-picker {\n  min-width: 210px !important;\n}\n\n// Flatpickr Calendar\n\n.upcoming-scheduled {\n  position: relative;\n  @media (max-width: 575.98px) {\n    top: 35px !important;\n  }\n  .flatpickr-months {\n    position: absolute !important;\n    top: -45px !important;\n    left: auto !important;\n    right: 0px !important;\n    width: 200px;\n    background-color: transparent;\n\n    .flatpickr-month {\n      color: $gray-600 !important;\n      fill: $gray-600 !important;\n    }\n    .flatpickr-prev-month,\n    .flatpickr-next-month {\n      display: none;\n    }\n  }\n  .flatpickr-calendar {\n    box-shadow: none !important;\n    .flatpickr-current-month {\n      font-size: 13px;\n      width: 100%;\n      left: 0;\n    }\n    .flatpickr-monthDropdown-months {\n      border: 1px solid $border-color;\n      border-radius: 4px;\n      height: 26px;\n    }\n    .flatpickr-weekdays {\n      background-color: var(--#{$prefix}light);\n      border: none;\n      span.flatpickr-weekday {\n        color: var(--#{$prefix}dark);\n        background-color: var(--#{$prefix}light);\n      }\n    }\n    .flatpickr-day {\n      &.today {\n        color: $white !important;\n        background-color: $success;\n        border-color: $success !important;\n        &:hover {\n          color: $success !important;\n          background-color: rgba($success, 0.2) !important;\n        }\n      }\n      &.selected {\n        background-color: $success !important;\n        border-color: $success !important;\n        color: $white;\n      }\n    }\n    .numInputWrapper {\n      width: 7.5ch;\n      margin-left: 10px;\n    }\n  }\n\n  .flatpickr-days {\n    border: none !important;\n  }\n}\n\n.crm-widget {\n  .col {\n    border-right: 1px solid $border-color;\n    &:last-child {\n      border: 0px;\n    }\n    @media (min-width: 768px) and (max-width: 1399.98px) {\n      &:nth-child(3) {\n        border-right: 0px;\n      }\n      &:last-child {\n        border-right: 1px solid $border-color;\n      }\n    }\n    @media (max-width: 767.98px) {\n      border-right: 0px;\n      border-bottom: 1px solid $border-color;\n    }\n  }\n}\n\n@media (min-width: 1400px) and (max-width: 1599.98px) {\n  .project-wrapper {\n    > .col-xxl-8,\n    .col-xxl-4 {\n      width: 100%;\n    }\n  }\n}\n\n.crypto-widget {\n  max-width: 130px !important;\n}\n\n//nft dashboard\n\n.bg-marketplace {\n  background-image: url(../../images/nft/marketplace.png);\n  background-size: cover;\n}\n\n.dash-countdown {\n  .countdownlist {\n    .count-num {\n      background-color: var(--#{$prefix}card-bg-custom);\n      padding: 16px 8px;\n      font-size: 22px;\n\n      @media (max-width: 575.98px) {\n        font-size: 16px;\n        padding: 8px 6px;\n      }\n    }\n\n    .count-title {\n      @media (max-width: 575.98px) {\n        font-size: 10px;\n      }\n    }\n  }\n}\n\n.marketplace-icon {\n  position: absolute;\n  float: right;\n  top: 30px;\n  left: 30px;\n}\n\n.marketplace-swiper {\n  .swiper-button-next,\n  .swiper-button-prev {\n    top: 34px;\n    width: 28px;\n    height: 28px;\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n    border-radius: 0.3rem;\n    right: 16px !important;\n  }\n  .swiper-button-prev {\n    right: 58px !important;\n    left: auto !important;\n  }\n}\n\n.dash-collection {\n  .content {\n    background-color: rgba($white, 0.25);\n    backdrop-filter: blur(5px);\n  }\n}\n\n.dash-nft {\n  @media (max-width: 1441.98px) {\n    .col-xxl-9,\n    .col-xxl-3 {\n      width: 100% !important;\n      max-width: 100% !important;\n    }\n  }\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  vertical-align: middle;\n}\n","//\n// _timeline.scss\n//\n\n.timeline {\n  position: relative;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    width: 2px;\n    background: $timeline-color;\n    top: 57px;\n    bottom: 166px;\n    left: 50%;\n    margin-left: -1.5px;\n  }\n}\n\n.timeline-item {\n  padding: 30px 60px;\n  position: relative;\n  background: inherit;\n  width: 50%;\n\n  .icon {\n    position: absolute;\n    display: inline-flex;\n    width: 60px;\n    height: 60px;\n    align-items: center;\n    justify-content: center;\n    font-size: 25px;\n    top: 30px;\n    right: -30px;\n    padding: 9px 0;\n    background: var(--#{$prefix}card-bg-custom);\n    border: 1px solid $border-color;\n    border-radius: 50px;\n    color: $success;\n    z-index: 1;\n  }\n\n  .date {\n    position: absolute;\n    display: inline-block;\n    width: calc(100% - 48px);\n    top: 50px;\n    font-size: 14px;\n    font-weight: 500;\n    font-style: italic;\n  }\n\n  .content {\n    padding: 20px;\n    background: var(--#{$prefix}card-bg-custom);\n    position: relative;\n    border: 1px solid $border-color;\n    border-radius: $border-radius;\n    box-shadow: $box-shadow-sm;\n  }\n\n  &.left {\n    left: 0;\n\n    .date {\n      left: calc(100% + 48px);\n      text-align: start;\n    }\n  }\n\n  &.right {\n    left: 50%;\n\n    .icon {\n      left: -30px;\n    }\n\n    .date {\n      right: calc(100% + 48px);\n      text-align: end;\n    }\n\n    &::before {\n      left: 28px;\n      border-color: transparent transparent transparent $white;\n    }\n  }\n}\n\n@media (max-width: 991.98px) {\n  .timeline {\n    &::after {\n      left: 24px;\n      bottom: 180px;\n    }\n  }\n\n  .timeline-item {\n    width: 100%;\n    padding-left: 48px;\n    padding-right: 0px;\n\n    &.right,\n    &.left {\n      left: 0%;\n\n      .icon {\n        width: 45px;\n        height: 45px;\n        top: 0;\n        font-size: 18px;\n        left: 0;\n      }\n\n      &::before {\n        left: 110px;\n        border-color: transparent transparent transparent $border-color;\n      }\n\n      .date {\n        right: auto;\n        left: 48px;\n        width: 79px;\n        top: 8px;\n        text-align: left;\n      }\n    }\n  }\n}\n\n.timeline-2 {\n  position: relative;\n\n  &::after {\n    position: absolute;\n    content: \"\";\n    width: 2px;\n    height: 83%;\n    top: 50px;\n    left: 40px;\n    margin-left: -1px;\n    background: $timeline-color;\n  }\n\n  .timeline-year {\n    position: relative;\n    width: 100%;\n    text-align: left;\n    z-index: 1;\n\n    p {\n      display: inline-flex;\n      width: 80px;\n      height: 80px;\n      margin: 0;\n      padding: 23px 10px;\n      background: $timeline-color;\n      border-radius: 50px;\n      text-transform: uppercase;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      span {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .timeline-date {\n    font-size: 14px;\n    font-weight: $font-weight-medium;\n    margin: 24px 0 0 0;\n    margin-left: 55px;\n\n    &::after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 14px;\n      height: 14px;\n      top: 26px;\n      left: 45px;\n      align-items: left;\n      background: $success;\n      border: 3px solid $timeline-color;\n      border-radius: 50px;\n      z-index: 1;\n    }\n  }\n\n  .timeline-box {\n    position: relative;\n    display: inline-block;\n    margin: 23px 62px;\n    padding: 20px;\n    border: 1px solid $border-color;\n    border-radius: 6px;\n    background: var(--#{$prefix}card-bg-custom);\n    max-width: 695px;\n    @media (max-width: 991.98px) {\n      margin-right: 0;\n    }\n\n    &::after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      top: 26px;\n      right: 100%;\n      border-color: transparent var(--#{$prefix}card-bg-custom) transparent\n        transparent;\n      border-width: 10px;\n    }\n\n    &::before {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      right: 100%;\n      top: 24px;\n      border-color: transparent $border-color transparent transparent;\n      border-width: 12px;\n    }\n\n    .timeline-text {\n      position: relative;\n      float: left;\n    }\n  }\n\n  .timeline-launch {\n    position: relative;\n    display: inline-block;\n    border: 1px solid $border-color;\n    border-radius: 6px;\n    background: $white;\n    width: 100%;\n    margin-top: 15px;\n    padding: 0;\n    border: none;\n    text-align: left;\n    background: transparent;\n\n    .timeline-box {\n      margin-left: 0;\n\n      &::after {\n        left: 30px;\n        margin-left: 0px;\n        top: -20px;\n        border-color: transparent transparent $border-color transparent;\n      }\n\n      &::before {\n        left: 30px;\n        margin-left: 0px;\n        top: -19px;\n        border-color: transparent transparent var(--#{$prefix}card-bg-custom)\n          transparent;\n        border-width: 10px;\n        z-index: 1;\n      }\n    }\n  }\n}\n\n// Horizontal Timeline\n.horizontal-timeline {\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    top: 174px;\n    left: 0;\n    height: 2px;\n    background-color: $timeline-color;\n  }\n\n  .swiper-slide {\n    .item-box {\n      margin: 227px 0px 0px;\n      background-color: transparent;\n      box-shadow: none;\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        left: 0px;\n        right: 0px;\n        margin: 0px auto;\n        background: $primary;\n        width: 13px;\n        height: 13px;\n        top: -59px;\n        border-radius: 50px;\n        border: 3px solid $timeline-color;\n      }\n    }\n\n    .timeline-content {\n      min-height: 110px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      background-color: $timeline-color;\n\n      &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        left: 0px;\n        top: -23px;\n        border-color: transparent transparent $timeline-color transparent;\n        border-width: 12px;\n        right: 0;\n        margin: 0 auto;\n      }\n    }\n\n    .time {\n      position: absolute;\n      top: -86px;\n      right: 0px;\n      left: 0px;\n      margin: 0px auto;\n    }\n\n    &:nth-child(even) {\n      margin-top: 5px;\n      transform: rotate(-180deg);\n\n      .timeline-content {\n        transform: rotate(180deg);\n\n        &::before {\n          bottom: -23px;\n          top: auto;\n          border-color: $timeline-color transparent transparent transparent;\n        }\n      }\n\n      .time {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .swiper-button-next,\n  .swiper-button-prev {\n    height: 40px;\n    width: 40px;\n    line-height: 40px;\n    border-radius: 50%;\n    background-color: lighten($primary, 2.5%);\n\n    &::after {\n      font-size: 24px;\n      color: $white;\n    }\n    &.swiper-button-disabled {\n      background-color: rgba($primary, 0.5);\n      opacity: 1;\n      cursor: auto;\n      backdrop-filter: blur(25px);\n      pointer-events: none;\n    }\n  }\n\n  .swiper-button-next {\n    right: 0;\n\n    &::after {\n      content: \"\\EA6E\";\n      font-family: remixicon;\n    }\n  }\n\n  .swiper-button-prev {\n    left: 0;\n\n    &::after {\n      content: \"\\EA64\";\n      font-family: remixicon;\n    }\n  }\n}\n\n//activity-timeline\n\n.acitivity-timeline {\n  position: relative;\n  overflow: hidden;\n\n  .acitivity-item {\n    position: relative;\n\n    .flex-shrink-0 {\n      z-index: 2;\n    }\n\n    .acitivity-avatar {\n      background-color: var(--#{$prefix}card-bg-custom);\n      border: 3px solid var(--#{$prefix}card-bg-custom);\n      height: 32px;\n      width: 32px;\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      border-left: 1px dashed $border-color;\n      left: 16px;\n      height: 100%;\n      top: 5px;\n      z-index: 0;\n    }\n    &:last-child {\n      &::before {\n        border-color: transparent;\n      }\n    }\n  }\n}\n","    //\n// _gallery.scss\n//\n\n.categories-filter {\n    .list-inline-item {\n        position: relative;\n        margin-right: 0;\n\n        a {\n            display: block;\n            color: var(--#{$prefix}body-color);\n            font-weight: $font-weight-semibold;\n            padding: 8px 15px;\n            margin: 5px;\n            cursor: pointer;\n        }\n    }\n}\n\n.gallery-box {\n    position: relative;\n    overflow: hidden;\n    border: 1px solid transparent;\n    margin-bottom: 10px;\n    box-shadow: none;\n    background-color: transparent;\n    padding: 8px;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n        height: 0;\n        background-color: var(--#{$prefix}card-bg-custom);\n        transition: all 0.4s;\n    }\n\n    .gallery-container {\n        position: relative;\n        overflow: hidden;\n        border-radius: 4px;\n\n        a {\n            display: block;\n        }\n\n        .gallery-overlay {\n            position: absolute;\n            top: 0px;\n            left: 0px;\n            bottom: 0px;\n            right: 0px;\n            opacity: 0;\n            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, .5) 100%);\n            visibility: hidden;\n            overflow: hidden;\n            transition: all 0.4s ease-in-out 0s;\n            display: flex;\n            width: 100%;\n            align-items: flex-end;\n            padding: 16px;\n\n            .overlay-caption {\n                color: $white;\n                margin: 0;\n                font-size: 16px;\n            }\n        }\n    }\n\n    .gallery-img {\n        transition: all 0.2s ease-in-out;\n    }\n\n    .box-content {\n        position: relative;\n\n        .title {\n            font-size: 14px;\n            margin-bottom: 4px;\n            display: none;\n        }\n\n        .post {\n            margin: 0;\n            transition: all 0.2s;\n            color: $text-muted;\n        }\n    }\n\n    &:hover {\n        &::before {\n            height: 100%;\n        }\n\n        .box-content {\n            bottom: 0;\n\n            .post {\n                opacity: 1;\n            }\n        }\n\n        .gallery-overlay {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n\n.gallery-light {\n    .gallery-box {\n        &::before {\n            background-color: var(--#{$prefix}light);\n        }\n    }\n}","//\n// _errors.scss\n//\n\n.error-basic-img{\n    max-width: 450px;\n}\n\n.error-500 {\n    .title {\n        font-size: 250px;\n    }\n\n    .error-500-img {\n        position: absolute;\n        top: 57px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n\n    @media (min-width: 768px) and (max-width: 991.98px) {\n        .title {\n            font-size: 150px;\n        }\n\n        .error-500-img {\n            width: 20% !important;\n            top: 43px;\n        }\n    }\n\n    @media (max-width: 767.98px) {\n        .title {\n            font-size: 68px;\n            margin-top: 35px;\n        }\n\n        .error-500-img {\n            position: relative;\n            top: 0px;\n        }\n    }\n}\n\n\n@keyframes errorAnimation {\n    0% {\n        transform: translateX(0%);\n    }\n\n    15% {\n        transform: translateX(-25%) rotate(-5deg);\n    }\n\n    30% {\n        transform: translateX(20%) rotate(3deg);\n    }\n\n    45% {\n        transform: translateX(-15%) rotate(-3deg);\n    }\n\n    60% {\n        transform: translateX(10%) rotate(2deg);\n    }\n\n    75% {\n        transform: translateX(-5%) rotate(-1deg);\n    }\n\n    100% {\n        transform: translateX(0%);\n    }\n}\n\n.error-img {\n    animation: errorAnimation 20s infinite;\n}","//\n// _profile.scss\n//\n\n.error-text {\n    text-shadow: 4px 4px rgba($success, 0.4);\n\n    @media (min-width: 1200px) {\n        font-size: 10rem;\n    }\n}\n\n\n// profile\n\n.profile-wid-bg {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 320px;\n    @media (max-width: 575.98px) {\n        height: 445px;\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        opacity: 0.9;\n        background: $primary;\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\n\n    }\n\n    .profile-wid-img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n}\n\n.profile-nav {\n    &.nav-pills {\n        .nav-link {\n            color: rgba($white, 0.8);\n\n            &::before {\n                background-color: rgba($white, 0.1);\n            }\n        }\n    }\n}\n\n.profile-project-card {\n    border: 1px solid $border-color;\n    border-left: 3px solid $border-color;\n}\n\n@each $color,\n$value in $theme-colors {\n    .profile-project-card {\n        &.profile-project-#{$color} {\n            border-left-color: $value;\n        }\n    }\n}\n\n.user-profile-img {\n    position: relative;\n\n    .profile-img {\n        width: 100%;\n        height: 250px;\n        object-fit: cover;\n\n        @media (max-width:991px) {\n            height: 160px;\n        }\n    }\n\n    .profile-foreground-img-file-input {\n        display: none;\n    }\n\n    .profile-photo-edit {\n        cursor: pointer;\n    }\n}\n\n.profile-user {\n    position: relative;\n    display: inline-block;\n\n    .profile-photo-edit {\n        position: absolute;\n        right: 0;\n        left: auto;\n        bottom: 0;\n        cursor: pointer;\n    }\n\n    .user-profile-image {\n        object-fit: cover;\n    }\n\n    .profile-img-file-input {\n        display: none;\n    }\n}\n\n.profile-timeline {\n    .accordion-item {\n        position: relative;\n\n        .accordion-button {\n            background-color: transparent;\n\n            &::after {\n                background: none;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            border-left: 2px dashed $border-color;\n            position: absolute;\n            height: 100%;\n            left: 23px;\n        }\n\n        &:first-child {\n            &::before {\n                top: 8px;\n            }\n        }\n\n        &:last-child {\n            &::before {\n                height: 20px;\n                top: 3px;\n            }\n        }\n    }\n}\n\n.profile-setting-img {\n    position: relative;\n    height: 260px;\n\n    .overlay-content {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0;\n    }\n\n    .profile-img {\n        width: 100%;\n        height: 250px;\n        object-fit: cover;\n\n        @media (max-width:991.98px) {\n            height: 160px;\n        }\n    }\n\n    .profile-foreground-img-file-input {\n        display: none;\n    }\n\n    .profile-photo-edit {\n        cursor: pointer;\n    }\n}\n\n@media (max-width:575.98px) {\n\n    [data-layout=\"horizontal\"]{\n        .profile-foreground{\n            margin-top: 0 !important;\n        }\n    }\n}\n\n[data-layout=\"semibox\"] {\n    .profile-wrapper {\n        padding: 0 $card-spacer-x;\n    }\n}","//\n// _sitemap.scss\n//\n\n.sitemap-content {\n    width: 100%;\n    max-width: 1142px;\n    margin: 0 auto;\n    padding: 0 20px;\n\n    * {\n        position: relative;\n    }\n}\n\n.sitemap-horizontal {\n    position: relative;\n\n    ul {\n        padding: 0;\n        margin: 0;\n        list-style: none;\n\n        a {\n            display: block;\n            background: var(--#{$prefix}light);\n            border: 2px solid var(--#{$prefix}card-bg-custom);\n            box-shadow: $box-shadow;\n            font-size: $font-size-base;\n            height: 60px;\n            padding: 8px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            span {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n        }\n    }\n}\n\n.administration {\n    .director {\n        >li {\n            >a {\n                width: 50%;\n                margin: 0 auto 0px auto;\n                border-radius: 4px;\n            }\n        }\n    }\n\n    .subdirector {\n        position: absolute;\n        width: 100%;\n\n        &::after {\n            content: \"\";\n            display: block;\n            width: 0;\n            height: 130px;\n            border-left: 2px dashed $border-color;\n            left: 45.45%;\n            position: relative;\n        }\n\n        >li {\n            &:first-child {\n                width: 18.59%;\n                height: 64px;\n                margin: 0 auto 92px auto;\n                padding-top: 25px;\n                border-bottom: 2px dashed $border-color;\n                z-index: 1;\n                float: right;\n                right: 27.2%;\n                border-left: 2px dashed $border-color;\n\n                a {\n                    width: 100%;\n                    left: 25px;\n                }\n            }\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        .subdirector {\n            >li {\n                &:first-child {\n                    width: 40%;\n                    right: 10%;\n                    margin-right: 2px;\n                }\n            }\n\n            &::after {\n                left: 49.8%;\n            }\n        }\n    }\n}\n\n.departments {\n    width: 100%;\n\n    >li {\n        &:first-child {\n            width: 18.59%;\n            height: 64px;\n            margin: 0 auto 92px auto;\n            padding-top: 25px;\n            border-bottom: 2px dashed $border-color;\n            z-index: 1;\n            float: left;\n            left: 27%;\n\n            a {\n                width: 100%;\n                right: 25px;\n            }\n        }\n\n        &:nth-child(2) {\n            margin-left: 0;\n            clear: left;\n\n            &.department {\n                &:before {\n                    border: none;\n                }\n            }\n        }\n    }\n\n    &::after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 81.1%;\n        height: 22px;\n        border-top: 2px dashed $border-color;\n        border-right: 2px dashed $border-color;\n        border-left: 2px dashed $border-color;\n        margin: 0 auto;\n        top: 130px;\n        left: 9.1%\n    }\n\n    @media screen and (max-width: 767px) {\n        >li {\n            &:first-child {\n                width: 40%;\n                left: 10%;\n                margin-left: 2px;\n            }\n        }\n\n        &::after {\n            border-right: none;\n            left: 0;\n            width: 50%;\n        }\n    }\n}\n\n.department {\n    border-left: 2px dashed $border-color;\n    float: left;\n    margin-left: 1.75%;\n    margin-bottom: 60px;\n    width: 18.25%;\n\n    &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 0;\n        height: 22px;\n        border-left: 2px dashed $border-color;\n        z-index: 1;\n        top: -22px;\n        left: 50%;\n        margin-left: -4px;\n    }\n\n    >a {\n        margin: 0 0 -26px -4px;\n        z-index: 1;\n    }\n\n    ul {\n        margin-top: 0px;\n        margin-bottom: 0px;\n\n        li {\n            padding-left: 25px;\n            border-bottom: 2px dashed $border-color;\n            height: 80px;\n\n            a {\n                background: var(--#{$prefix}card-bg-custom);\n                margin-top: 48px;\n                position: absolute;\n                z-index: 1;\n                width: 90%;\n                height: 60px;\n                vertical-align: middle;\n                right: -1px;\n                text-align: center;\n            }\n        }\n    }\n\n    &:first-child {\n        margin-left: 0;\n        clear: left;\n    }\n\n    @media screen and (min-width: 768px) {\n        &:last-child:before {\n            border: none;\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        float: none;\n        width: 100%;\n        margin-left: 0;\n\n        &::before {\n            content: \"\";\n            display: block;\n            position: absolute;\n            width: 0;\n            height: 60px;\n            border-left: 2px dashed $white;\n            z-index: 1;\n            top: -60px;\n            left: 0%;\n            margin-left: -4px;\n        }\n\n        &:nth-child(2) {\n            &::before {\n                display: none;\n            }\n        }\n    }\n}\n\n\n\n// sitemap\n\n.hori-sitemap {\n    ul {\n        padding: 0;\n        padding-top: 10px;\n        text-align: center;\n        li {\n            position: relative;\n        }\n        @media (max-width: 575.98px) {\n            text-align: left;\n            .parent-title {\n                a {\n                    padding-left: 0;\n                    &:after {\n                        display: none;\n                    }\n                }\n\n                &:before {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    @media (max-width: 575.98px) {\n        >ul {\n            position: relative;\n            li {\n                padding-top: 10px;\n                .second-list,\n                .sub-list {\n                    position: relative;\n\n                    &:before {\n                        content: \"\";\n                        height: calc(100% - 14px);\n                        border-right: 2px dashed $border-color;\n                        position: absolute;\n                        top: 0px;\n                        left: 0px;\n                    }\n                }\n                .sub-list {\n                    &:before {\n                        height: 38%;\n                    }\n                }\n                a {\n                    position: relative;\n                    padding: 4px 16px 4px 36px;\n\n                    &:after {\n                        content: \"\";\n                        width: 24px;\n                        border-top: 2px dashed $border-color;\n                        position: absolute;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        left: 0;\n                    }\n                }\n\n                ul {\n                    margin-left: 36px;\n                }\n            }\n        }\n    }\n    @media (min-width: 576px) {\n        ul {\n            padding-top: 20px;\n            li {\n                padding-top: 30px;\n\n                &:before {\n                    content: \"\";\n                    height: 24px;\n                    width: 0;\n                    border-right: 2px dashed $border-color;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    margin: 0px auto;\n                }\n\n                &:after {\n                    content: \"\";\n                    width: 100%;\n                    border-top: 2px dashed $border-color;\n                    position: absolute;\n                    top: 0;\n                    left: 50%;\n                }\n\n                &:last-of-type {\n                    &:after {\n                        display: none;\n                    }\n                }\n\n                &.parent-title {\n                    &::before {\n                        content: \"\";\n                        height: 23px;\n                        border-right: 2px dashed $border-color;\n                        position: absolute;\n                        top: 28px;\n                        left: 0;\n                    }\n                    &::after {\n                        border: none;\n                    }\n                }\n\n                .sub-title {\n                    position: relative;\n\n                    &::before {\n                        content: \"\";\n                        height: 21px;\n                        border-right: 2px dashed $border-color;\n                        position: absolute;\n                        top: 27px;\n                        left: 49%;\n                        margin: 0 auto;\n                    }\n                }\n            }\n        }\n    }\n\n    a {\n        color: var(--#{$prefix}body-color);\n        padding: 4px 0px;\n        display: block;\n\n    }\n}\n\n\n// vertical sitemap\n.verti-sitemap { \n    a {\n        color: var(--#{$prefix}body-color);\n        display: block;\n    }\n    .parent-title {\n        a {\n            padding-left: 0;\n\n            &:before {\n                display: none;\n            }\n        }\n\n        &:before {\n            display: none;\n        }\n    }\n    .first-list {\n        position: relative;\n        padding-top: 10px;\n        &:before {\n            content: \"\";\n            border-left: 2px dashed $border-color;\n            position: absolute;\n            top: 0;\n            height: 100%;\n            bottom: 0;\n            left: 0;\n        }\n        .list-wrap, li {\n            a {\n                position: relative;\n                padding: 10px 16px 4px 36px;\n                &::before {\n                    content: \"\";\n                    width: 24px;\n                    border-top: 2px dashed $border-color;\n                    position: absolute;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    left: 0;\n                }\n            }\n        }\n        .second-list, .third-list {\n            margin-left: 42px;\n            \n        }\n\n        .third-list, .second-list {\n            position: relative;\n            li {\n                position: relative;\n                &:before {\n                    content: \"\";\n                    height: 100%;\n                    border-left: 2px dashed $border-color;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    margin: 0px auto;\n                }\n                &:last-child {\n                    &::before {\n                        height: 13px;\n                    }\n                }\n            }\n        }\n        \n        &:last-child {\n            &::before {\n                height: 25px;\n            }\n        }\n    }\n}\n\n","//\n// _team.scss\n//\n\n.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover{\n    display: none;\n    position: relative;\n    margin-bottom: -140px;\n\n    img {\n        height: 140px;\n        width: 100%;\n        object-fit: cover;\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\n        opacity: 0.6;\n    }\n}\n\n.team-list {\n    &.grid-view-filter {\n        flex-flow: row wrap;\n\n        .col {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n\n        .team-box {\n            overflow: hidden;\n\n            .team-row {\n                align-items: start;\n\n                .col {\n                    width: 100%;\n                }\n            }\n\n            .team-cover {\n                display: block;\n            }\n\n            .team-settings {\n                .col {\n                    width: 50% !important;\n                    flex: 0 0 auto;\n                }\n\n                .btn-star {\n                    color: $white;\n                }\n\n                .dropdown {\n                    >a {\n                        color: $white;\n                    }\n                }\n            }\n\n            .team-profile-img {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                margin-bottom: 25px;\n                margin-top: 36px;\n\n                .avatar-lg {\n                    font-size: 22px;\n                }\n\n                .team-content {\n                    margin-left: 0px;\n                    margin-top: 25px;\n                    text-align: center;\n                }\n            }\n\n            .view-btn {\n                width: 100%;\n                margin-top: 25px;\n            }\n        }\n\n        @media (min-width: 1200px) and (max-width: 1399.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 33.33%;\n            }\n        }\n\n        @media (max-width: 1199.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 50%;\n            }\n        }\n\n        @media (max-width: 767.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 100%;\n            }\n        }\n    }\n\n    &.list-view-filter {\n        flex-direction: column;\n\n        .team-box {\n            margin-bottom: 10px;\n\n            .team-row {\n                align-items: center;\n                justify-content: space-between;\n            }\n\n            .team-profile-img {\n                display: flex;\n                align-items: center;\n\n                .avatar-lg {\n                    height: 4rem;\n                    width: 4rem;\n                    font-size: 16px;\n                }\n\n                .team-content {\n                    margin-left: 15px;\n                }\n            }\n\n            .team-settings {\n                width: auto;\n                flex: 0 0 auto;\n                -webkit-box-ordinal-group: 7;\n                order: 6;\n            }\n\n            .btn-star {\n                color: $primary;\n            }\n        }\n\n        @media (max-width: 767.98px) {\n            flex-direction: row;\n            .col {\n                -webkit-box-flex: 0;\n                -ms-flex: 0 0 auto;\n                flex: 0 0 auto;\n                width: 100%;\n            }\n            .team-box {\n\n                .team-settings {\n                    width: 100%;\n                    flex: 0 0 auto;\n                    order: -1;\n                    margin-bottom: 10px;\n\n                    .col {\n                        width: 50%;\n                    }\n                }\n\n                .team-profile-img {\n                    margin-bottom: 25px;\n                }\n\n                .view-btn {\n                    width: 100%;\n                    margin-top: 25px;\n                }\n            }\n        }\n    }\n}\n\n.modal-team-cover{\n    display: block;\n}\n\n.list-grid-nav {\n    .nav-link {\n        &.active {\n            background-color: $info;\n            color: $white;\n        }\n    }\n}\n\n.profile-offcanvas  {\n    .team-cover {\n        margin-bottom: -132px;\n        display: block;\n        z-index: -1;\n    }\n    .btn-star {\n        color: $white;\n    }\n\n    .dropdown {\n        >a {\n            color: $white;\n        }\n    }\n}","// \n// _coming-soon.scss\n//\n\n// countdownlist\n\n.countdownlist {\n    text-align: center;\n    display: flex;\n    gap: 24px;\n\n\n    .countdownlist-item{\n        width: 25%;\n        &:last-of-type{\n            .count-num{\n                &::after{\n                    display: none;\n                }\n            }\n        }\n    }\n    .count-title{\n        font-size: 13px;\n        font-weight: $font-weight-medium;\n        display: block;\n        margin-bottom: 8px;\n        color: rgba(var(--#{$prefix}dark-rgb), 0.5);\n        text-transform: uppercase;\n    }\n\n    .count-num{\n        background-color: var(--#{$prefix}card-bg-custom);\n        padding: 16px 8px;\n        position: relative;\n        border-radius: $card-border-radius;\n        box-shadow: $box-shadow;\n        font-weight: $font-weight-semibold;\n        font-size: 32px;\n        @media (max-width: 575.98px) {\n            font-size: 18px;\n        }\n    \n        &::after{\n            content: \":\";\n            font-size: 20px;\n            position: absolute;\n            right: -16px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: var(--#{$prefix}dark);\n        }\n    }\n}\n// coming soon \n\n.move-animation{\n    animation: mover 1s infinite  alternate;\n}\n\n@keyframes mover {\n    0% { transform: translateY(0); }\n    100% { transform: translateY(-16px); }\n}\n\n.coming-soon-text{\n    font-weight: $font-weight-semibold;\n    text-transform: uppercase;\n    color: $white;\n    text-shadow: 3px 4px $success;\n}\n\n.countdown-input-group{\n    max-width: 400px;\n}\n","//\n// _search-results.scss\n//\n\n.search-more-results {\n    position: relative;\n    overflow: hidden;\n\n    .nav-icon {\n        font-size: 14px;\n        color: $white;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        text-align: center;\n        left: 0;\n        right: 0;\n\n        i {\n            font-size: 20px;\n        }\n\n        @media (max-width: 767.98px) {\n            font-size: 14px;\n\n            i {\n                font-size: 18px;\n            }\n        }\n    }\n}\n\n.video-list {\n    .list-element {\n        display: none;\n        &:nth-child(1) {\n            display: block;\n        }\n        &:nth-child(2) {\n            display: block;\n        }\n        &:nth-child(3) {\n            display: block;\n        }\n    }\n}\n\n.search-voice {\n    height: 120px;\n    width: 120px;\n    line-height: 120px;\n    margin: 0px auto;\n    text-align: center;\n    border-radius: 50%;\n    z-index: 1;\n    position: relative;\n\n    i {\n        line-height: 56px;\n        font-size: 30px;\n    }\n\n    .voice-wave {\n        position: absolute;\n        width: 120px;\n        height: 120px;\n        z-index: -1;\n        left: 0px;\n        right: 0px;\n        margin: 0px auto;\n        opacity: 0;\n        border-radius: 100px;\n        animation: voice-wave 1.8s infinite;\n        background-color: var(--#{$prefix}light);\n\n        &:nth-child(2) {\n            animation-delay: 0.3s;\n        }\n\n        &:nth-child(3) {\n            animation-delay: 0.6s;\n        }\n    }\n}\n\n@keyframes voice-wave {\n    0% {\n        opacity: 1;\n        transform: scale(0);\n    }\n\n    100% {\n        opacity: 0;\n        transform: scale(1);\n    }\n}\n\n.images-menu {\n    .swiper-slide {\n        width: auto;\n        display: inline-block;\n    }\n}","//\n// _ecommerce.scss\n//\n\n// product list\n\n#selection-element { \n    display: none;\n}\n\n.filter-choices-input{\n    .choices__inner{\n        padding: 0;\n        border: none;\n        background-color: var(--#{$prefix}card-bg-custom);\n    }\n\n    .choices__input{\n        background-color: var(--#{$prefix}card-bg-custom);\n    }\n}\n\n//  product detail\n\n.sticky-side-div{\n    @media (min-width: 992px){\n        position: sticky;\n        top: calc(#{$header-height} + #{$grid-gutter-width});\n    }\n}\n\n.product-img-slider{\n    .product-nav-slider{\n        .nav-slide-item{\n            border: 1px solid $border-color;\n            border-radius: $border-radius;\n            padding: 0.5rem;\n            cursor: pointer;\n        }\n\n        .swiper-slide-thumb-active{\n            .nav-slide-item{\n                background-color: var(--#{$prefix}light);\n            }\n        }\n    }\n}\n\n.filter-list{\n    a {\n        &.active {\n            .listname {\n                color: $success;\n            }\n        }   \n    }\n}","//\n// _invoice.scss\n//\n\n.invoice-table {\n    tbody {\n        &:last-child {\n            border: none;\n        }\n    }\n}\n\n.currency-select {\n    .choices__inner {\n        padding:0px;\n        padding-right: 15px;\n        min-height: 0px;\n    }\n    .choices__list--single {\n        padding: 0px 16px 0 4px;\n    }\n    .choices[data-type*=select-one]{\n        bottom: 0px;\n        :after { \n            top: 4px;\n        }\n        .choices__inner {\n            padding-bottom: 0px;\n        }\n    }\n}","//\n// _chat.scss\n//\n\n.chat-wrapper {\n  position: relative;\n  overflow-x: hidden;\n}\n\n// chat left sidebar\n\n.chat-leftsidebar {\n  height: calc(100vh - 137px);\n  position: relative;\n  background-color: var(--#{$prefix}card-bg-custom);\n\n  @media (min-width: 992px) {\n    min-width: 300px;\n    max-width: 300px;\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n  }\n}\n\n.chat-list {\n  margin: 0;\n\n  > li {\n    &.active {\n      a {\n        background-color: $chat-secondary-bg;\n        color: $chat-secondary-color;\n\n        .badge {\n          background-color: rgba(var(--#{$prefix}success-rgb), 0.15) !important;\n          color: $success !important;\n        }\n      }\n    }\n\n    a {\n      display: block;\n      padding: 7px 24px;\n      color: var(--#{$prefix}body-color);\n      transition: all 0.4s;\n      font-family: $font-family-secondary;\n      font-weight: $font-weight-medium;\n      font-size: $font-size-base;\n    }\n\n    .chat-user-message {\n      font-size: 14px;\n    }\n\n    .unread-msg-user {\n      font-weight: $font-weight-semibold;\n    }\n\n    .unread-message {\n      position: absolute;\n      display: inline-block;\n      right: 24px /*rtl:auto*/;\n      left: auto /*rtl:0*/;\n      top: 33px;\n\n      .badge {\n        line-height: 16px;\n        font-weight: $font-weight-semibold;\n        font-size: 10px;\n      }\n    }\n  }\n}\n\n.chat-user-img {\n  position: relative;\n\n  .user-status {\n    width: 10px;\n    height: 10px;\n    background-color: $gray-500;\n    border-radius: 50%;\n    border: 2px solid var(--#{$prefix}card-bg-custom);\n    position: absolute;\n    right: 0;\n    left: auto;\n    bottom: 0;\n  }\n\n  &.online {\n    .user-status {\n      background-color: $success;\n    }\n  }\n\n  &.away {\n    .user-status {\n      background-color: $warning;\n    }\n  }\n}\n\n.chat-room-list {\n  max-height: calc(100vh - 296px);\n\n  @media (max-width: 991.98px) {\n    height: calc(100vh - 296px);\n  }\n}\n\n// contact list\n\n.contact-list {\n  li {\n    cursor: pointer;\n    padding: 8px 24px;\n    transition: all 0.4s;\n    color: var(--#{$prefix}body-color);\n    font-family: $font-family-secondary;\n    font-weight: $font-weight-medium;\n    font-size: $font-size-base;\n  }\n}\n\n.contact-list-title {\n  padding: 6px 24px;\n  color: $primary;\n  font-weight: $font-weight-medium;\n  position: relative;\n  font-size: 12px;\n  &:after {\n    content: \"\";\n    height: 1px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 50px;\n    right: 0;\n    background-color: var(--#{$prefix}light);\n  }\n}\n\n// user chat\n\n.user-chat {\n  background: url(\"../../images/chat-bg-pattern.png\");\n  transition: all 0.4s;\n  position: relative;\n  background-color: var(--#{$prefix}body-bg);\n\n  @media (max-width: 991.98px) {\n    position: absolute;\n    left: 0;\n    top: 3px;\n    width: 100%;\n    height: calc(100% - 3px);\n    visibility: hidden;\n    transform: translateX(100%);\n    z-index: 99;\n    padding-top: 70px;\n\n    &.user-chat-show {\n      visibility: visible;\n      transform: translateX(0);\n    }\n  }\n\n  .chat-content {\n    position: relative;\n  }\n\n  &.user-chat-show {\n    .chat-welcome-section {\n      display: none;\n    }\n    .chat-content {\n      @media (min-width: 992px) {\n        display: flex !important;\n      }\n    }\n  }\n}\n\n.user-chat-topbar {\n  border-bottom: 1px solid transparent;\n  background-color: var(--#{$prefix}card-bg-custom);\n  @media (max-width: 991.98px) {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 1;\n  }\n}\n\n.user-chat-nav {\n  .nav-btn {\n    height: 40px;\n    width: 40px;\n    line-height: 40px;\n    box-shadow: none;\n    padding: 0;\n    font-size: 20px;\n    color: $gray-800;\n  }\n  @media (max-width: 575.98px) {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.chat-conversation {\n  height: calc(100vh - 299px) !important;\n  @media (max-width: 991.98px) {\n    height: calc(100vh - 275px) !important;\n  }\n\n  .simplebar-content-wrapper {\n    display: flex;\n    flex-direction: column;\n\n    .simplebar-content {\n      margin-top: auto;\n    }\n  }\n\n  .chat-conversation-list {\n    padding-top: 10px;\n    margin-bottom: 0;\n    > li {\n      display: flex;\n    }\n  }\n\n  li {\n    &:last-of-type {\n      .conversation-list {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .chat-list {\n    &.left {\n      .check-message-icon {\n        display: none;\n      }\n    }\n    .message-box-drop {\n      visibility: hidden;\n    }\n\n    &:hover {\n      .message-box-drop {\n        visibility: visible;\n      }\n    }\n  }\n\n  .chat-avatar {\n    margin: 0 16px 0 0 /*rtl:0 0 0 16px*/;\n\n    img {\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n    }\n  }\n\n  .chat-day-title {\n    position: relative;\n    text-align: center;\n    margin-bottom: 24px;\n    margin-top: 12px;\n    width: 100%;\n\n    .title {\n      background-color: $white;\n      position: relative;\n      font-size: 13px;\n      z-index: 1;\n      padding: 6px 12px;\n      border-radius: 5px;\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 1px;\n      left: 0;\n      right: 0;\n      background-color: rgba($primary, 0.2);\n      top: 10px;\n    }\n\n    .badge {\n      font-size: 12px;\n    }\n  }\n\n  .conversation-list {\n    margin-bottom: 24px;\n    display: inline-flex;\n    position: relative;\n    align-items: flex-end;\n    max-width: 80%;\n\n    @media (max-width: 575.98px) {\n      max-width: 90%;\n    }\n\n    .ctext-wrap {\n      display: flex;\n      margin-bottom: 10px;\n    }\n\n    .ctext-content {\n      word-wrap: break-word;\n      word-break: break-word;\n    }\n\n    .ctext-wrap-content {\n      padding: 12px 20px;\n      background-color: $chat-primary-bg;\n      position: relative;\n      border-radius: 3px;\n      box-shadow: $box-shadow-lg;\n\n      .attached-file {\n        @media (max-width: 575.98px) {\n          .attached-file-avatar {\n            display: none;\n          }\n\n          .dropdown .dropdown-toggle {\n            display: block;\n          }\n        }\n      }\n    }\n\n    .conversation-name {\n      font-weight: $font-weight-medium;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .dropdown {\n      .dropdown-toggle {\n        font-size: 18px;\n        padding: 4px;\n        color: $gray-600;\n        &::after {\n          display: none;\n        }\n\n        @media (max-width: 575.98px) {\n          display: none;\n        }\n      }\n    }\n\n    .chat-time {\n      font-size: 12px;\n      margin-top: 4px;\n      text-align: right;\n    }\n\n    .message-img {\n      border-radius: 0.2rem;\n      position: relative;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n\n      .message-img-list {\n        position: relative;\n      }\n\n      img {\n        max-width: 150px;\n      }\n\n      .message-img-link {\n        position: absolute;\n        right: 10px /*rtl:auto*/;\n        left: auto /*rtl:0*/;\n        bottom: 10px;\n\n        li {\n          > a {\n            font-size: 18px;\n            color: $white;\n            display: inline-block;\n            line-height: 20px;\n            width: 26px;\n            height: 24px;\n            border-radius: 3px;\n            background-color: rgba($dark, 0.7);\n            text-align: center;\n          }\n        }\n      }\n    }\n  }\n\n  .right {\n    justify-content: flex-end;\n\n    .chat-avatar {\n      order: 3;\n      margin-right: 0px;\n      margin-left: 16px;\n    }\n\n    .chat-time {\n      text-align: left;\n      color: $gray-600;\n    }\n\n    .conversation-list {\n      text-align: right;\n\n      .ctext-wrap {\n        justify-content: flex-end;\n\n        .ctext-wrap-content {\n          order: 2;\n          background-color: $chat-secondary-bg;\n          color: $chat-secondary-color;\n          text-align: right;\n          box-shadow: $element-shadow;\n\n          .replymessage-block {\n            background-color: rgba($white, 0.5);\n            border-color: rgba(var(--vz-success-rgb), 1);\n            color: $body-color;\n\n            .conversation-name {\n              color: rgba(var(--vz-success-rgb), 1);\n            }\n          }\n        }\n      }\n\n      .conversation-name {\n        justify-content: flex-end;\n\n        .check-message-icon {\n          order: 1;\n        }\n\n        .time {\n          order: 2;\n        }\n\n        .name {\n          order: 3;\n        }\n      }\n\n      .dropdown {\n        order: 1;\n      }\n    }\n\n    .dot {\n      background-color: $dark;\n    }\n  }\n}\n\n.chat-input-section {\n  border-top: 1px solid transparent;\n  background-color: var(--#{$prefix}card-bg-custom);\n  position: relative;\n  z-index: 1;\n\n  .chat-input-feedback {\n    display: none;\n    position: absolute;\n    top: -20px;\n    left: 4px;\n    font-size: 12px;\n    color: $danger;\n  }\n  .show {\n    display: block;\n  }\n}\n\n.chat-input-links {\n  display: flex;\n  .links-list-item {\n    > .btn {\n      box-shadow: none;\n      padding: 0;\n      font-size: 20px;\n      width: 37.5px;\n      height: 37.5px;\n      &.btn-link {\n        color: $gray-600;\n      }\n    }\n  }\n}\n\n//Copy Message Alert\n.copyclipboard-alert {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: none;\n}\n\n.replyCard {\n  position: absolute;\n  left: 0;\n  right: 0;\n  border-top: 1px solid $border-color;\n  overflow: hidden;\n  opacity: 0;\n  bottom: 0;\n  border-radius: 0;\n  transition: all 0.4s;\n\n  @media (max-width: 991.98px) {\n    bottom: -12px;\n  }\n\n  &.show {\n    transform: translateY(-88px);\n    opacity: 1;\n\n    @media (max-width: 991.98px) {\n      transform: translateY(-83px);\n    }\n  }\n}\n\n.replymessage-block {\n  padding: 12px 20px;\n  margin-bottom: 8px;\n  text-align: left;\n  border-radius: 4px;\n  background-color: rgba(var(--vz-success-rgb), 0.1);\n  border-left: 2px solid rgba(var(--vz-success-rgb), 1);\n\n  .conversation-name {\n    color: rgba(var(--vz-success-rgb), 1);\n    font-size: 14px;\n  }\n}\n\n// Chat Small\n.chat-sm {\n  .ctext-wrap-content {\n    box-shadow: none !important;\n  }\n\n  .message-img {\n    img {\n      max-width: 90px !important;\n    }\n  }\n\n  .message-img-link {\n    bottom: 0 !important;\n    right: 5px !important;\n  }\n}\n\n// for horizontal layout\n[data-layout=\"horizontal\"] {\n  .chat-wrapper {\n    @media (min-width: 1025px) {\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n    }\n    @media (max-width: 991.98px) {\n      margin-top: 0 !important;\n    }\n  }\n\n  .chat-leftsidebar {\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\n    @media (max-width: 991.98px) {\n      height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n    }\n  }\n\n  .chat-room-list {\n    height: calc(100vh - 352px);\n    @media (max-width: 991.98px) {\n      height: calc(100vh - 265px);\n    }\n  }\n\n  .chat-conversation {\n    height: calc(100vh - 343px) !important;\n    @media (max-width: 991.98px) {\n      height: calc(100vh - 275px) !important;\n    }\n  }\n}\n","//\n// _email.scss\n//\n\n.email-wrapper {\n  position: relative;\n  overflow-x: hidden;\n}\n\n// chat left sidebar\n\n.email-menu-sidebar {\n  height: calc(100vh - 137px);\n  position: relative;\n  background-color: var(--#{$prefix}card-bg-custom);\n  transition: all 0.2s;\n\n  @media (min-width: 992px) {\n    min-width: 250px;\n    max-width: 250px;\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n  }\n\n  @media (max-width: 991.98px) {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 200px;\n    max-width: 100%;\n    z-index: 1003;\n    box-shadow: $box-shadow-lg;\n    transform: translateX(-100%);\n    visibility: hidden;\n    height: 100vh;\n\n    &.menubar-show {\n      visibility: visible;\n      transform: none;\n    }\n  }\n\n  .email-menu-sidebar-scroll {\n    height: calc(100vh - 295px);\n\n    @media (max-width: 991.98px) {\n      height: calc(100vh - 150px);\n    }\n  }\n}\n\n.mail-list {\n  a {\n    display: flex;\n    align-items: center;\n    color: $gray-600;\n    padding: 5px 0;\n    font-weight: $font-weight-medium;\n\n    &:hover {\n      color: $primary;\n    }\n\n    i {\n      font-size: 14px;\n    }\n\n    &.active {\n      color: $success;\n      font-weight: $font-weight-semibold;\n\n      i {\n        color: $success;\n      }\n    }\n  }\n}\n\n.email-chat-list {\n  a {\n    padding: 6px 24px;\n    &.active {\n      background-color: rgba(var(--#{$prefix}light-rgb), 0.7);\n    }\n  }\n}\n.email-topbar-link {\n  .btn-ghost-secondary {\n    color: $text-muted;\n\n    &:hover {\n      color: $secondary;\n    }\n  }\n}\n\n.email-content {\n  width: 100%;\n  background-color: var(--#{$prefix}card-bg-custom);\n  transition: all 0.2s;\n}\n\n.unreadConversations-alert {\n  position: fixed;\n  bottom: $footer-height;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1;\n}\n\n.email-detail-content {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  left: 68%;\n  width: 32%;\n  background-color: var(--#{$prefix}card-bg-custom);\n  transform: translateX(200%);\n  transition: all 0.2s;\n  visibility: hidden;\n  border-left: 2px solid var(--#{$prefix}body-bg);\n}\n\n.email-detail-show {\n  .email-detail-content {\n    transform: none;\n    visibility: visible;\n  }\n\n  .email-content {\n    margin-right: 32%;\n\n    @media (max-width: 1349.98px) {\n      margin-right: 0;\n    }\n  }\n}\n\n.email-detail-content-scroll {\n  height: calc(100vh - 390px);\n\n  @media (max-width: 1349.98px) {\n    height: calc(100vh - 252px);\n  }\n}\n\n.message-list-content {\n  height: calc(100vh - 242px);\n\n  @media (max-width: 575.98px) {\n    height: calc(100vh - 230px);\n  }\n}\n\n.message-list {\n  display: block;\n  padding-left: 0;\n  margin: 0;\n\n  li {\n    position: relative;\n    display: block;\n    height: 50px;\n    line-height: 50px;\n    cursor: default;\n    transition-duration: 0.3s;\n    clear: both;\n\n    a {\n      color: var(--#{$prefix}gray-700);\n    }\n\n    &:hover {\n      background: var(--#{$prefix}light);\n      transition-duration: 0.05s;\n    }\n\n    .col-mail {\n      float: left;\n      position: relative;\n    }\n\n    .col-mail-1 {\n      width: 280px;\n\n      .star-toggle,\n      .checkbox-wrapper-mail,\n      .dot {\n        display: block;\n        float: left;\n      }\n\n      .dot {\n        border: 4px solid transparent;\n        border-radius: 100px;\n        margin: 22px 26px 0;\n        height: 0;\n        width: 0;\n        line-height: 0;\n        font-size: 0;\n      }\n\n      .checkbox-wrapper-mail {\n        margin: 15px 0 0 20px;\n        line-height: normal;\n      }\n\n      .star-toggle {\n        margin-top: 18px;\n        margin-left: 5px;\n      }\n\n      .title {\n        position: absolute;\n        top: 0;\n        left: 95px;\n        right: 0;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        margin-bottom: 0;\n\n        @media (max-width: 575.98px) {\n          left: 95px;\n        }\n      }\n    }\n\n    .col-mail-2 {\n      position: absolute;\n      top: 0;\n      left: 280px;\n      right: 0;\n      bottom: 0;\n\n      .subject,\n      .date {\n        position: absolute;\n        top: 0;\n      }\n\n      .subject {\n        left: 0;\n        right: 110px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n\n        .teaser {\n          color: var(--#{$prefix}gray-600);\n        }\n      }\n\n      .date {\n        right: 0;\n        width: 100px;\n        padding-left: 20px;\n      }\n    }\n\n    &.active,\n    &.active:hover {\n      box-shadow: inset 3px 0 0 $primary;\n      background-color: var(--#{$prefix}light);\n    }\n\n    &.unread {\n      color: var(--#{$prefix}gray-800);\n\n      a {\n        color: var(--#{$prefix}gray-800);\n        font-weight: $font-weight-semibold;\n      }\n    }\n  }\n}\n\n#unreadConversations,\n#email-topbar-actions {\n  display: none;\n}\n\n#elmLoader {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.email-compose-input {\n  padding-right: 80px;\n}\n\n@media (max-width: 1349.98px) {\n  .email-detail-content {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: auto;\n    right: 0;\n    width: 400px;\n    max-width: 100%;\n    z-index: 1003;\n    box-shadow: $box-shadow-lg;\n    transform: translateX(100%);\n  }\n\n  .email-detail-show {\n    .email-detail-content {\n      transform: none;\n    }\n  }\n}\n\n@media (max-width: 575.98px) {\n  .message-list li .col-mail-1 {\n    width: 180px;\n  }\n}\n\n.email-editor {\n  .ck-editor__editable_inline {\n    min-height: 200px !important;\n  }\n}\n\n.email-chat-detail {\n  width: 350px;\n  position: fixed;\n  max-width: 100%;\n  bottom: $footer-height;\n  right: $footer-height;\n  z-index: 9;\n  display: none;\n  .card {\n    box-shadow: $box-shadow-lg;\n  }\n\n  @media (max-width: 515.98px) {\n    left: 16px;\n    right: 16px;\n  }\n}\n\n// for horizontal layout\n[data-layout=\"horizontal\"] {\n  .email-wrapper {\n    @media (min-width: 1025px) {\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n    }\n    @media (max-width: 991.98px) {\n      margin-top: 0 !important;\n    }\n  }\n\n  .email-menu-sidebar {\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\n    @media (max-width: 991.98px) {\n      height: 100vh;\n    }\n    .email-menu-sidebar-scroll {\n      height: calc(100vh - 330px);\n      @media (max-width: 991.98px) {\n        height: calc(100vh - 150px);\n      }\n    }\n  }\n\n  .message-list-content {\n    height: calc(100vh - 289px);\n  }\n\n  .email-detail-content-scroll {\n    height: calc(100vh - 435px);\n    @media (max-width: 1349.98px) {\n      height: calc(100vh - 252px);\n    }\n  }\n}\n\n.email-chat-element {\n  .chat-conversation1 {\n    height: 250px !important;\n  }\n}\n","//\n// _kanban.scss\n//\n\n.tasks-board {\n    display: flex;\n    overflow-x: auto;\n    align-items: stretch;\n\n    .tasks-list {\n        min-width: 300px;\n        margin-right: 24px;\n    }\n\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 10px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 8px;\n    }\n}\n\n.tasks-box {\n    .progress {\n        border-radius: 0px 0px $card-border-radius $card-border-radius;\n    }\n\n    .tasks-img {\n        height: 135px;\n        width: 100%;\n        object-fit: cover;\n        object-position: center;\n        margin: 12px 0px;\n    }\n\n    &:last-child {\n        margin-bottom: 0px;\n    }\n}\n\n.tasks-wrapper {\n    max-height: calc(100vh - 418px);\n}\n\n\n.tasks {\n    min-height: 180px;\n    position: relative;\n\n    &.noTask{\n        &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        height: 180px;\n        width: 270px;\n        margin: 0 auto;\n        background-image: url('../../images/file.png');\n        background-size: cover;\n        background-position: center;\n    }\n    }\n}\n\n#tasksList {\n    tr {\n        .tasks-list-menu {\n            opacity: 0;\n        }\n\n        &:hover {\n            .tasks-list-menu {\n                opacity: 1;\n            }\n        }\n    }\n}","//\n// _landing.scss\n//\n\n.layout-wrapper {\n    &.landing {\n        background-color: var(--#{$prefix}card-bg-custom);\n        font-size: 15px;\n    }\n}\n\n// helper\n\n.section {\n    padding: 90px 0;\n    position: relative;\n\n    @media (max-width:767.98px) {\n        padding: 50px 0;\n    }\n}\n\n.icon-effect {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 24px;\n        height: 24px;\n        background-color: rgba($success, 0.2);\n        border-radius: 50%;\n        bottom: 0;\n        left: 0;\n    }\n}\n\n// navbar\n\n.navbar-landing {\n    padding: 10px 0px;\n    transition: all 0.5s ease;\n    @media (max-width: 991.98px) {\n        background-color: var(--#{$prefix}card-bg-custom);\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n        padding: 10px 8px;\n    }\n\n    .navbar-nav {\n        .nav-item {\n            .nav-link {\n                font-size: 16px;\n                font-weight: $font-weight-medium;\n                transition: all 0.4s;\n                font-family: $font-family-secondary;\n                color: var(--#{$prefix}dark);\n                padding: 14px;\n\n                @media (max-width: 991.98px) {\n                    padding: 8px 0px;\n                }\n\n                &:hover,\n                &.active,\n                &:focus {\n                    color: $success !important;\n                }\n            }\n            &.active {\n                .nav-link {\n                    color: $success !important;\n                }\n            }\n        }\n    }\n\n    &.is-sticky {\n        background-color: var(--#{$prefix}card-bg-custom);\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n    }\n}\n\n//navbar-light\n.navbar-light{\n    .navbar-brand {\n        .card-logo-dark {\n            display: none;\n        }\n    \n        .card-logo-light {\n            display: block;\n        }\n    }\n    .navbar-nav {\n        .nav-item {\n            .nav-link {\n                color: rgba(var(--#{$prefix}white-rgb), 0.75);\n            }\n        }\n    }\n    &.is-sticky {\n        .navbar-nav {\n            .nav-item {\n                .nav-link {\n                    color: var(--#{$prefix}dark);\n                }\n            }\n        }\n        .navbar-brand {\n            .card-logo-dark {\n                display: block;\n            }\n        \n            .card-logo-light {\n                display: none;\n            }\n        }\n    }\n}\n\n// hero section\n\n.hero-section {\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.5);\n\n    .hero-shape-svg {\n        svg {\n            path {\n                fill: var(--#{$prefix}card-bg-custom);\n            }\n        }\n    }\n}\n\n.bg-overlay-pattern {\n    background-image: url(\"../../images/landing/bg-pattern.png\");\n    background-color: transparent;\n    background-position: center;\n    background-size: cover;\n    opacity: 0.2;\n}\n\n.demo-carousel {\n    position: relative;\n    z-index: 1;\n\n    .carousel-item {\n        .demo-item {\n            background-color: var(--#{$prefix}card-bg-custom);\n            padding: 8px;\n            border-radius: 7px;\n        }\n    }\n\n    .demo-img-patten-top {\n        position: absolute;\n        right: -50px;\n        top: -16px;\n        max-width: 230px;\n    }\n\n    .demo-img-patten-bottom {\n        position: absolute;\n        left: -70px;\n        bottom: -50px;\n        max-width: 230px;\n    }\n}\n\n// client images\n.client-images img {\n    max-height: 45px;\n    width: auto;\n    margin: 12px auto;\n    transition: all .4s;\n}\n\n// plan\n\n.plan-box {\n    max-width: 356px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n// work process\n.process-card {\n    position: relative;\n\n    .process-arrow-img {\n        position: absolute;\n        left: 75%;\n        top: 7%;\n        width: 50%;\n        opacity: .1;\n    }\n}\n\n.custom-footer {\n    color: #9ba7b3;\n}\n\n.footer-list {\n    li {\n        a {\n            color: #9ba7b3;\n            padding: 7px 0;\n            display: block;\n            transition: all 0.3s ease-in-out;\n\n            &:hover {\n                color: rgba($white, 0.9);\n            }\n        }\n    }\n}\n\n.footer-social-link {\n    .avatar-title {\n        color: #778089;\n        background-color: rgba($white, 0.05);\n        transition: all 0.3s ease;\n\n        &:hover {\n            color: $white;\n            background-color: $primary;\n        }\n    }\n}\n\n#back-to-top {\n    &.landing-back-top {\n        bottom: 35px;\n    }\n}\n\n// dark\n\n[data-layout-mode=\"dark\"] {\n    .layout-wrapper.landing {\n\n        .demo-img-patten-top,\n        .demo-img-patten-bottom {\n            opacity: .2;\n        }\n\n        footer.bg-dark {\n            background-color: var(--#{$prefix}card-bg-custom) !important;\n        }\n    }\n\n    //navbar-light\n    .navbar-light{\n        &.is-sticky { \n            .navbar-brand {\n                .card-logo-dark {\n                    display: none;\n                }\n        \n                .card-logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}","//\n// _nft-landing.scss\n//\n\n.bookmark-icon {\n    .btn {\n        color: $text-muted;\n        background-color: var(--#{$prefix}light);\n        box-shadow: $box-shadow;\n        font-size: $font-size-base;\n        &:hover,\n        &.active {\n            border-color: transparent;\n            color: $danger;\n        }\n    }\n}\n\n.explore-box {\n    border-radius: 9px;\n    overflow: hidden;\n    .explore-img {\n        height: 280px;\n        object-fit: cover;\n    }\n    .explore-place-bid-img {\n        position: relative;\n        overflow: hidden;\n        z-index: 0;\n        .bg-overlay {\n            position: absolute;\n            right: 0;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            background-color: rgba($dark, 0.4);\n            opacity: 0;\n            transition: all 0.5s ease;\n        }\n    \n        .place-bid-btn {\n            top: 50%;\n            position: absolute;\n            left: 50%;\n            transform: translate(-50%, -50%);\n    \n            .btn {\n                opacity: 0;\n                bottom: -25px;\n                transition: 0.5s ease;\n            }\n        }\n    }\n    \n    &:hover {\n        .explore-place-bid-img {\n            .place-bid-btn {\n                .btn {\n                    opacity: 1;\n                    bottom: 0;\n                }\n            }\n    \n            .bg-overlay {\n                opacity: 1;\n            }\n        }\n    }\n    .discount-time {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        text-align: center;\n        background-color: rgba($white, 0.4);\n        backdrop-filter: blur(5px);\n        padding: 8px;\n    }\n}\n\n//\n.nft-hero {\n    // background-image: url('../../images/nft/bg-home.jpg');\n    background-size: cover;\n    background-position: bottom;\n    padding: 222px 0 150px 0;\n    .bg-overlay {\n        background-color: #05175f;\n        opacity: 0.85;\n    }\n}\n\n#explorecard-list {\n    .list-element {\n        display: none;\n\n        &:nth-child(-n+10) {\n            display: block;\n        }\n    }\n}","//\n// _file-manager.scss\n//\n\n.file-manager-menu {\n    max-height: calc(100vh - 296px);\n\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 296px);\n    }\n\n    li {\n        padding: 5px 0px;\n\n        a {\n            color: var(--#{$prefix}dark);\n            font-weight: $font-weight-medium;\n            transition: all 0.5s ease;\n\n            &.active,\n            &:hover,\n            &[aria-expanded=\"true\"]{\n                color: $success;\n            }\n        }\n\n        .sub-menu {\n            li {\n                padding-left: 25px;\n                position: relative;\n\n                &::before {\n                    content: \"\\f0374\";\n                    position: absolute;\n                    left: 0px;\n                    font-family: Material Design Icons;\n                    color: rgba(var(--#{$prefix}dark-rgb), 0.4);\n                }\n            }\n        }\n    }\n}\n\n.file-manager-sidebar {\n    position: relative;\n    background-color: var(--#{$prefix}card-bg-custom);\n\n    @media (min-width: 992px) {\n        min-width: 300px;\n        max-width: 300px;\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n    }\n\n    @media (max-width: 991.98px) {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        width: 200px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(-100%);\n        visibility: hidden;\n        height: 100vh;\n\n        &.menubar-show {\n            visibility: visible;\n            transform: none;\n        }\n    }\n}\n\n.file-menu-sidebar-scroll{\n    height: calc(100vh - 375px);\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 190px);\n    }\n}\n\n.file-manager-content {\n    background-color: var(--#{$prefix}card-bg-custom);\n}\n\n.file-manager-content-scroll{\n    height: calc(100vh - 185px);\n    overflow-y: auto;\n\n        &::-webkit-scrollbar {\n            -webkit-appearance: none;\n        }\n    \n        &::-webkit-scrollbar:vertical {\n            width: 12px;\n        }\n    \n        &::-webkit-scrollbar:horizontal {\n            height: 12px;\n        }\n    \n        &::-webkit-scrollbar-thumb {\n            background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n            border-radius: 10px;\n            border: 2px solid var(--#{$prefix}card-bg-custom);\n        }\n    \n        &::-webkit-scrollbar-track {\n            border-radius: 10px;\n            background-color: var(--#{$prefix}card-bg-custom);\n        }\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 144px);\n    }\n\n    .simplebar-content{\n        height: 100%;\n    }\n}\n\n.file-detail-content-scroll{\n    height: calc(100vh - 180px);\n    @media (max-width: 991.98px) {\n        height: 100vh;\n    }\n\n    .simplebar-content{\n        height: 100%;\n    }\n}\n\n.file-manager-detail-content {\n    width: 32%;\n    max-width: 100%;\n    background-color: var(--#{$prefix}card-bg-custom);\n    display: none;\n}\n\n.file-detail-show{\n    .file-manager-detail-content{\n        display: block;\n    }\n}\n\n#file-overview{\n    display: none;\n}\n\n@media (max-width: 1399.98px) {\n    .file-manager-detail-content {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: auto;\n        right: 0;\n        width: 400px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(100%);\n    }\n\n    .file-detail-show {\n        .file-manager-detail-content {\n            transform: none;\n        }\n    }\n}\n\n.file-details-box {\n    height: 195px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}","//\n// _to-do.scss\n//\n\n.to-do-menu {\n    li {\n        .nav-link {\n            color: var(--#{$prefix}body-color);\n            padding-left: 0;\n            font-weight: $font-weight-medium;\n            background-color: var(--#{$prefix}light);\n            padding: 10px 12px;\n            border-radius: 4px;\n            display: block;\n            margin-bottom: 8px;\n            &:hover, &.active {\n                color: $success;\n            }\n        }\n    }\n}\n\n.todo-content {\n    height: calc(100vh - 362px);\n    overflow-y: auto;\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 8px;\n    }\n}\n\n.todo-task {\n    table{\n        .form-check{\n            .form-check-input {\n                &:checked+.form-check-label {\n                    text-decoration: line-through;\n                }\n            }\n        }\n    }\n}\n\n.task-handle{\n    cursor: move;\n}\n\n#task-error-msg{\n    display: none;\n}","//\n// _invoice.scss\n//\n\n.bg-job {\n    background-image: url(../../images/new.png);\n    background-size: cover;\n    background-position: center;\n}\n\n.job-list-view-card{\n    .background {\n        height: 130px;\n    }\n}\n\n.job-list-row {\n    &.row {\n        .col-xxl-3 {\n            @media (min-width: 1400px) and (max-width: 1499.98px) {\n                width: 33%; \n            }\n        }\n    }\n}",".custom-container {\n    width: 90%;\n}\n\n//********** Navbar **********//\n.job-navbar {\n    .dropdown-menu {\n        .dropdown-item {\n            .avatar-sm {\n                height: 2.5rem;\n                width: 2.5rem;\n            }\n        }\n    }\n\n    @media (max-width: 991.98px) {\n        background-color: var(--#{$prefix}card-bg-custom);\n        padding: 16px 0;\n    }\n}\n\n//********** Home **********//\n.job-hero-section {\n    position: relative;\n    padding: 165px 0;\n    overflow-x: hidden;\n}\n\n.job-panel-filter {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border-radius: $border-radius;\n    overflow: hidden;\n\n    .form-control {\n        height: 45px;\n        border: none;\n        border-radius: 0;\n        background-color: transparent;\n    }\n\n    .btn {\n        border-radius: 0;\n    }\n\n    input.form-control {\n        border-right: 1px solid $border-color;\n    }\n\n    @media (max-width: 767.98px) {\n        background-color: transparent;\n\n        .form-control {\n            background-color: $white;\n            border-radius: $input-border-radius;\n        }\n\n        input.form-control {\n            border: 0;\n        }\n\n        .btn {\n            border-radius: $btn-border-radius;\n        }\n    }\n}\n\n.circle-effect {\n    position: absolute;\n    top: 0;\n    z-index: 0;\n    right: -55px;\n    margin: 0 auto;\n\n    .circle {\n        border: 1px solid $border-color;\n        height: 240px;\n        width: 240px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle2 {\n        position: absolute;\n        top: -20px;\n        right: -20px;\n        border: 1px solid $border-color;\n        height: 280px;\n        width: 280px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle3 {\n        position: absolute;\n        top: -40px;\n        right: -40px;\n        border: 1px solid $border-color;\n        height: 320px;\n        width: 320px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle4 {\n        position: absolute;\n        top: -60px;\n        right: -60px;\n        border: 1px solid $border-color;\n        height: 360px;\n        width: 360px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    @media (max-width: 991.98px) {\n        display: none;\n    }\n}\n\n.home-img {\n    .user-img {\n        position: relative;\n        z-index: 1;\n    }\n}\n\n//********** About **********//\n.application-box,\n.feedback-box,\n.inquiry-box {\n    max-width: 240px;\n    position: absolute;\n    z-index: 2;\n    transition: all 0.5s ease;\n\n    &:hover {\n        transform: translateY(-5px);\n    }\n}\n\n.inquiry-box {\n    left: -134px;\n    top: 90px;\n\n    @media (max-width: 991.98px) {\n        left: 0;\n    }\n}\n\n.application-box {\n    bottom: 50px;\n    right: -160px;\n\n    @media (max-width: 991.98px) {\n        right: 0;\n    }\n}\n\n.feedback-box {\n    right: -50px;\n    bottom: -54px;\n\n    @media (max-width: 576.98px) {\n        right: 0;\n        bottom: 0;\n    }\n}\n\n.job-icon-effect {\n    height: 30px;\n    width: 30px;\n    position: absolute;\n    top: 0px;\n    left: -2%;\n    border-radius: 50%;\n    background: repeating-linear-gradient(-55deg, rgba($white, 0) 0.8px, $success 1.6px, $success 2px, rgba($white, 0) 3.8px, rgba($white, 0) 5px);\n    z-index: 0;\n    opacity: 0.20;\n\n    span {\n        position: relative;\n        z-index: 1;\n    }\n}\n\n.about-img-section {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 20px;\n        right: -20px;\n        top: -20px;\n        bottom: 20px;\n        border: 1px solid $info;\n        z-index: 0;\n        border-radius: $border-radius;\n\n        @media (max-width: 576.98px) {\n            right: 20px;\n            top: 20px;\n        }\n    }\n\n}\n\n.features-company-widgets {\n    position: absolute;\n    bottom: -18px;\n    right: -35px;\n}","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nWebsite: https://themesbrand.com/\nContact: support@themesbrand.com\nFile: Custom Css File\n*/\n\n.css-b62m3t-container {\n  .css-13cymwt-control {\n    background-color: #fff; /* input bg */\n    border-color: var(--#{$prefix}border-color);\n    &:hover {\n      border-color: var(--#{$prefix}border-color);\n    }\n  }\n  .css-t3ipsp-control {\n    background-color: var(--#{$prefix}gray-200);\n    border-color: var(--#{$prefix}border-color);\n    box-shadow: none;\n    &:hover {\n      border-color: var(--#{$prefix}border-color) !important;\n    }\n  }\n  .css-1nmdiq5-menu {\n    background-color: var(--#{$prefix}gray-200);\n    .css-10wo9uf-option {\n      cursor: pointer;\n      background-color: var(--#{$prefix}gray-200);\n      &:active {\n        background-color: var(--#{$prefix}gray-200);\n      }\n    }\n    .css-d7l1ni-option {\n      cursor: pointer;\n      background-color: var(--#{$prefix}gray-100);\n    }\n  }\n  .css-1p3m7a8-multiValue {\n    background-color: var(--#{$variable-prefix}light);\n  }\n  .css-wsp0cs-MultiValueGeneric {\n    color: $heading-color;\n  }\n  .css-12jo7m5 {\n    color: $heading-color;\n  }\n  .css-6j8wv5-Input,\n  .css-qc6sy-singleValue {\n    color: $heading-color;\n  }\n\n  .css-1dimb5e-singleValue {\n    color: var(--vz-body-color);\n  }\n}\n\n.marketplace-swiper .swiper-button-next,\n.marketplace-swiper .swiper-button-prev {\n  top: 24px;\n}\n\n.marquee {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  height: 22px;\n  line-height: 2;\n}\n\n.marquee div {\n  display: block;\n  width: 200%;\n  height: 30px;\n  position: absolute;\n  overflow: hidden;\n  animation: marquee 35s linear infinite;\n}\n\n.marquee span {\n  float: left;\n  width: 50%;\n}\n\n@keyframes marquee {\n  0% {\n    left: 0;\n  }\n\n  100% {\n    left: -100%;\n  }\n}\n\n// Data Table\n\n.kVrXuC,\n.dwPlXY,\n.gKbhqU,\n.iSAVrt {\n  background-color: $table-bg !important;\n  color: $table-color !important;\n}\n\n.fyrdjl {\n  color: rgba(var(--#{$prefix}body-color-rgb), 0.54) !important;\n  fill: rgba(var(--#{$prefix}body-color-rgb), 0.54) !important;\n}\n\n.fyrdjl:disabled {\n  color: rgba(var(--#{$prefix}body-color-rgb), 0.18) !important;\n  fill: rgba(var(--#{$prefix}body-color-rgb), 0.18) !important;\n}\n\n.iSAVrt {\n  background-color: var(--#{$prefix}card-bg-custom) !important;\n  border-bottom-color: $table-border-color !important;\n}\n\n.dwPlXY:not(:last-of-type) {\n  border-bottom-color: $table-border-color !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
